import { ambitoActual, nombrePrivado, exigirMismaCuenta } from "../lib/privacidad-local.js";
/** Runtime y bibliotecas preservadas del despliegue; componentes extraídos en ../components. */
import { SesionRequerida } from "../components/compartidos/SesionRequerida.jsx";
import { PermisoRequerido } from "../components/compartidos/PermisoRequerido.jsx";
import { RedireccionInicio } from "../components/compartidos/RedireccionInicio.jsx";
import { SinSecciones } from "../components/compartidos/SinSecciones.jsx";
import { AccesoDenegado } from "../components/compartidos/AccesoDenegado.jsx";
import { Modal } from "../components/compartidos/Modal.jsx";
import { ProveedorDialogos } from "../components/compartidos/ProveedorDialogos.jsx";
import { DialogoConfirmacion } from "../components/compartidos/DialogoConfirmacion.jsx";
import { Componente_is_105_115 } from "../components/compartidos/Componente_is_105_115.jsx";
import { ProveedorAvisos } from "../components/compartidos/ProveedorAvisos.jsx";
import { LogoMarca } from "../components/compartidos/LogoMarca.jsx";
import { MarcaCarga } from "../components/compartidos/MarcaCarga.jsx";
import { TransicionMarca } from "../components/compartidos/TransicionMarca.jsx";
import { IconoMicrosoft } from "../components/compartidos/IconoMicrosoft.jsx";
import { Login } from "../components/auth/Login.jsx";
import { CambiarContrasena } from "../components/auth/CambiarContrasena.jsx";
import { EstadoError } from "../components/auth/EstadoError.jsx";
import { AccionAsync } from "../components/auth/AccionAsync.jsx";
import { BuscadorPersona } from "../components/auth/BuscadorPersona.jsx";
import { AvatarPersona } from "../components/auth/AvatarPersona.jsx";
import { SelectorMultiple } from "../components/auth/SelectorMultiple.jsx";
import { CalendarioFecha } from "../components/compartidos/CalendarioFecha.jsx";
import { Componente_TS_84_83 } from "../components/compartidos/Componente_TS_84_83.jsx";
import { SelectorFecha } from "../components/compartidos/SelectorFecha.jsx";
import { EditorMenciones } from "../components/compartidos/EditorMenciones.jsx";
import { ListaAdjuntos } from "../components/compartidos/ListaAdjuntos.jsx";
import { DetalleTarea } from "../components/tareas/DetalleTarea.jsx";
import { Componente_LS_76_83 } from "../components/tareas/Componente_LS_76_83.jsx";
import { Componente_zS_122_83 } from "../components/tareas/Componente_zS_122_83.jsx";
import { Componente_BS_66_83 } from "../components/tareas/Componente_BS_66_83.jsx";
import { ResumenTarea } from "../components/tareas/ResumenTarea.jsx";
import { Componente_HS_72_83 } from "../components/tareas/Componente_HS_72_83.jsx";
import { Componente_GS_71_83 } from "../components/tareas/Componente_GS_71_83.jsx";
import { ConfirmarFechaTerminada } from "../components/tareas/ConfirmarFechaTerminada.jsx";
import { AccionesEstadoTarea } from "../components/tareas/AccionesEstadoTarea.jsx";
import { TarjetaTarea } from "../components/tareas/TarjetaTarea.jsx";
import { MenuCrear } from "../components/navegacion/MenuCrear.jsx";
import { BusquedaGlobal } from "../components/navegacion/BusquedaGlobal.jsx";
import { CambiosPendientes } from "../components/navegacion/CambiosPendientes.jsx";
import { PanelNotificaciones } from "../components/navegacion/PanelNotificaciones.jsx";
import { Componente_xC_120_67 } from "../components/navegacion/Componente_xC_120_67.jsx";
import { EstructuraPrincipal } from "../components/navegacion/EstructuraPrincipal.jsx";
import { Componente_IC_73_67 } from "../components/navegacion/Componente_IC_73_67.jsx";
import { Componente_LC_76_67 } from "../components/navegacion/Componente_LC_76_67.jsx";
import { Componente_RC_82_67 } from "../components/navegacion/Componente_RC_82_67.jsx";
import { Componente_zC_122_67 } from "../components/navegacion/Componente_zC_122_67.jsx";
import { Componente_BC_66_67 } from "../components/navegacion/Componente_BC_66_67.jsx";
import { Cargando } from "../components/navegacion/Cargando.jsx";
import { Paginacion } from "../components/navegacion/Paginacion.jsx";
import { MisTareas } from "../components/planner/MisTareas.jsx";
import { Aprobaciones } from "../components/planner/Aprobaciones.jsx";
import { Proyectos } from "../components/planner/Proyectos.jsx";
import { NuevoProyecto } from "../components/proyectos/NuevoProyecto.jsx";
import { TableroTareas } from "../components/proyectos/TableroTareas.jsx";
import { Componente_MD_77_68 } from "../components/proyectos/Componente_MD_77_68.jsx";
import { Componente_PD_80_68 } from "../components/proyectos/Componente_PD_80_68.jsx";
import { TarjetaKanban } from "../components/proyectos/TarjetaKanban.jsx";
import { Componente_ID_73_68 } from "../components/proyectos/Componente_ID_73_68.jsx";
import { Componente_LD_76_68 } from "../components/proyectos/Componente_LD_76_68.jsx";
import { MetasProyecto } from "../components/proyectos/MetasProyecto.jsx";
import { NuevaMeta } from "../components/proyectos/NuevaMeta.jsx";
import { SelectorFechaHora } from "../components/proyectos/SelectorFechaHora.jsx";
import { Componente_KD_75_68 } from "../components/proyectos/Componente_KD_75_68.jsx";
import { Componente_qD_113_68 } from "../components/proyectos/Componente_qD_113_68.jsx";
import { ReunionesProyecto } from "../components/proyectos/ReunionesProyecto.jsx";
import { NuevaReunion } from "../components/proyectos/NuevaReunion.jsx";
import { DetalleReunion } from "../components/proyectos/DetalleReunion.jsx";
import { DiscusionesProyecto } from "../components/proyectos/DiscusionesProyecto.jsx";
import { NuevoHilo } from "../components/proyectos/NuevoHilo.jsx";
import { DetalleHilo } from "../components/proyectos/DetalleHilo.jsx";
import { EquipoProyecto } from "../components/proyectos/EquipoProyecto.jsx";
import { ActividadProyecto } from "../components/proyectos/ActividadProyecto.jsx";
import { AuditoriaProyecto } from "../components/proyectos/AuditoriaProyecto.jsx";
import { Componente_aO_97_79 } from "../components/proyectos/Componente_aO_97_79.jsx";
import { ConfiguracionProyecto } from "../components/proyectos/ConfiguracionProyecto.jsx";
import { NuevaEtiqueta } from "../components/proyectos/NuevaEtiqueta.jsx";
import { NuevaLista } from "../components/proyectos/NuevaLista.jsx";
import { DetalleProyecto } from "../components/proyectos/DetalleProyecto.jsx";
import { CerrarProyecto } from "../components/proyectos/CerrarProyecto.jsx";
import { Calendario } from "../components/calendario/Calendario.jsx";
import { CeldaCalendario } from "../components/calendario/CeldaCalendario.jsx";
import { AgendarEnArea } from "../components/calendario/AgendarEnArea.jsx";
import { Componente_DO_68_79 } from "../components/calendario/Componente_DO_68_79.jsx";
import { ConectarCalendario } from "../components/calendario/ConectarCalendario.jsx";
import { Notificaciones } from "../components/notificaciones/Notificaciones.jsx";
import { EstrategiasUnidad } from "../components/organizacion/EstrategiasUnidad.jsx";
import { DetalleEstrategia } from "../components/organizacion/DetalleEstrategia.jsx";
import { Componente_zO_122_79 } from "../components/organizacion/Componente_zO_122_79.jsx";
import { FormularioEstrategia } from "../components/organizacion/FormularioEstrategia.jsx";
import { Organizacion } from "../components/organizacion/Organizacion.jsx";
import { ArbolOrganizacion } from "../components/organizacion/ArbolOrganizacion.jsx";
import { TarjetaUnidad } from "../components/organizacion/TarjetaUnidad.jsx";
import { DetalleUnidad } from "../components/organizacion/DetalleUnidad.jsx";
import { EquipoUnidad } from "../components/organizacion/EquipoUnidad.jsx";
import { Componente_ZO_90_79 } from "../components/organizacion/Componente_ZO_90_79.jsx";
import { TareasUnidad } from "../components/organizacion/TareasUnidad.jsx";
import { Componente_DolarO_36_79 } from "../components/organizacion/Componente_DolarO_36_79.jsx";
import { Componente_ek_101_107 } from "../components/organizacion/Componente_ek_101_107.jsx";
import { Componente_nk_110_107 } from "../components/organizacion/Componente_nk_110_107.jsx";
import { Componente_rk_114_107 } from "../components/organizacion/Componente_rk_114_107.jsx";
import { Componente_ik_105_107 } from "../components/organizacion/Componente_ik_105_107.jsx";
import { Componente_ak_97_107 } from "../components/organizacion/Componente_ak_97_107.jsx";
import { Componente_ok_111_107 } from "../components/organizacion/Componente_ok_111_107.jsx";
import { Componente_ck_99_107 } from "../components/organizacion/Componente_ck_99_107.jsx";
import { Componente_lk_108_107 } from "../components/organizacion/Componente_lk_108_107.jsx";
import { Componente_uk_117_107 } from "../components/organizacion/Componente_uk_117_107.jsx";
import { Componente_dk_100_107 } from "../components/organizacion/Componente_dk_100_107.jsx";
import { FormularioUnidad } from "../components/organizacion/FormularioUnidad.jsx";
import { AnaliticaUso } from "../components/administracion/AnaliticaUso.jsx";
import { Componente_kk_107_107 } from "../components/administracion/Componente_kk_107_107.jsx";
import { ResumenAdmin } from "../components/administracion/ResumenAdmin.jsx";
import { Componente_Mk_77_107 } from "../components/administracion/Componente_Mk_77_107.jsx";
import { Maestros } from "../components/administracion/Maestros.jsx";
import { Fundos } from "../components/administracion/Fundos.jsx";
import { FormularioFundo } from "../components/administracion/FormularioFundo.jsx";
import { Roles } from "../components/administracion/Roles.jsx";
import { FormularioRol } from "../components/administracion/FormularioRol.jsx";
import { Usuarios } from "../components/administracion/Usuarios.jsx";
import { SesionesUsuario } from "../components/administracion/SesionesUsuario.jsx";
import { Componente_Gk_71_107 } from "../components/administracion/Componente_Gk_71_107.jsx";
import { FormularioUsuario } from "../components/administracion/FormularioUsuario.jsx";
import { SedesUsuario } from "../components/administracion/SedesUsuario.jsx";
import { Componente_Zk_90_107 } from "../components/administracion/Componente_Zk_90_107.jsx";
import { Componente_Qk_81_107 } from "../components/administracion/Componente_Qk_81_107.jsx";
import { Apariencia } from "../components/administracion/Apariencia.jsx";
import { Componente_nA_110_65 } from "../components/administracion/Componente_nA_110_65.jsx";
import { NombreMarca } from "../components/administracion/NombreMarca.jsx";
import { ColoresMarca } from "../components/administracion/ColoresMarca.jsx";
import { Componente_oA_111_65 } from "../components/administracion/Componente_oA_111_65.jsx";
import { TipografiaMarca } from "../components/administracion/TipografiaMarca.jsx";
import { ImagenesMarca } from "../components/administracion/ImagenesMarca.jsx";
import { ImagenMarca } from "../components/administracion/ImagenMarca.jsx";
import { Personal } from "../components/administracion/Personal.jsx";
import { Componente_hA_104_65 } from "../components/administracion/Componente_hA_104_65.jsx";
import { DesempenoPersonal } from "../components/administracion/DesempenoPersonal.jsx";
import { Componente__A_95_65 } from "../components/administracion/Componente__A_95_65.jsx";
import { Componente_vA_118_65 } from "../components/administracion/Componente_vA_118_65.jsx";
import { TransferirTrabajo } from "../components/administracion/TransferirTrabajo.jsx";
import { ErroresSistema } from "../components/administracion/ErroresSistema.jsx";
import { Componente_TA_84_65 } from "../components/administracion/Componente_TA_84_65.jsx";
import { MovilidadAdmin } from "../components/movilidad/MovilidadAdmin.jsx";
import { PedidosMovilidadAdmin } from "../components/movilidad/PedidosMovilidadAdmin.jsx";
import { AccesosMovilidad } from "../components/movilidad/AccesosMovilidad.jsx";
import { NuevoAccesoMovilidad } from "../components/movilidad/NuevoAccesoMovilidad.jsx";
import { CatalogosMovilidad } from "../components/movilidad/CatalogosMovilidad.jsx";
import { HorarioMovilidad } from "../components/movilidad/HorarioMovilidad.jsx";
import { SolicitantesMovilidad } from "../components/movilidad/SolicitantesMovilidad.jsx";
import { FormularioSolicitante } from "../components/movilidad/FormularioSolicitante.jsx";
import { Componente__Z_95_90 } from "../components/movilidad/Componente__Z_95_90.jsx";
import { FormularioCatalogoMovilidad } from "../components/movilidad/FormularioCatalogoMovilidad.jsx";
import { Componente_yZ_121_90 } from "../components/movilidad/Componente_yZ_121_90.jsx";
import { Componente_bZ_98_90 } from "../components/movilidad/Componente_bZ_98_90.jsx";
import { Componente_xZ_120_90 } from "../components/movilidad/Componente_xZ_120_90.jsx";
import { BotsWhatsApp } from "../components/bots/BotsWhatsApp.jsx";
import { EstadoBots } from "../components/bots/EstadoBots.jsx";
import { TarjetaBot } from "../components/bots/TarjetaBot.jsx";
import { VincularBot } from "../components/bots/VincularBot.jsx";
import { VincularPorTelefono } from "../components/bots/VincularPorTelefono.jsx";
import { CodigoVinculacion } from "../components/bots/CodigoVinculacion.jsx";
import { QrVinculacion } from "../components/bots/QrVinculacion.jsx";
import { GestorWhatsApp } from "../components/gestor/GestorWhatsApp.jsx";
import { VincularMiNumero } from "../components/gestor/VincularMiNumero.jsx";
import { CandadoGestor } from "../components/gestor/CandadoGestor.jsx";
import { ConversacionesGestor } from "../components/gestor/ConversacionesGestor.jsx";
import { ChatGestor } from "../components/gestor/ChatGestor.jsx";
import { MensajeGestor } from "../components/gestor/MensajeGestor.jsx";
import { Componente_SQ_83_81 } from "../components/gestor/Componente_SQ_83_81.jsx";
import { ContenidoMensaje } from "../components/gestor/ContenidoMensaje.jsx";
import { DocumentoMensaje } from "../components/gestor/DocumentoMensaje.jsx";
import { BuscarConversacion } from "../components/gestor/BuscarConversacion.jsx";
import { Transporte } from "../components/transporte/Transporte.jsx";
import { Componente_FQ_70_81 } from "../components/transporte/Componente_FQ_70_81.jsx";
import { PedidosTransporte } from "../components/transporte/PedidosTransporte.jsx";
import { ArmarOrden } from "../components/transporte/ArmarOrden.jsx";
import { OrdenesTransporte } from "../components/transporte/OrdenesTransporte.jsx";
import { EstadoOrden } from "../components/transporte/EstadoOrden.jsx";
import { Componente_VQ_86_81 } from "../components/transporte/Componente_VQ_86_81.jsx";
import { RepartoPorArea } from "../components/transporte/RepartoPorArea.jsx";
import { Componente_qQ_113_81 } from "../components/transporte/Componente_qQ_113_81.jsx";
import { Componente_JQ_74_81 } from "../components/transporte/Componente_JQ_74_81.jsx";
import { CerrarOrden } from "../components/transporte/CerrarOrden.jsx";
import { ReportesTransporte } from "../components/transporte/ReportesTransporte.jsx";
import { Componente_rDolar_114_36 } from "../components/transporte/Componente_rDolar_114_36.jsx";
import { ResumenCostos } from "../components/transporte/ResumenCostos.jsx";
import { AnaliticaTransporte } from "../components/transporte/AnaliticaTransporte.jsx";
import { Componente_sDolar_115_36 } from "../components/transporte/Componente_sDolar_115_36.jsx";
import { RutasTransporte } from "../components/transporte/RutasTransporte.jsx";
import { FormularioRuta } from "../components/transporte/FormularioRuta.jsx";
import { Flota } from "../components/transporte/Flota.jsx";
import { TablaFlota } from "../components/transporte/TablaFlota.jsx";
import { FormularioProveedor } from "../components/transporte/FormularioProveedor.jsx";
import { FormularioVehiculo } from "../components/transporte/FormularioVehiculo.jsx";
import { Componente_gDolar_103_36 } from "../components/transporte/Componente_gDolar_103_36.jsx";
import { Componente__Dolar_95_36 } from "../components/transporte/Componente__Dolar_95_36.jsx";
import { Componente_vDolar_118_36 } from "../components/transporte/Componente_vDolar_118_36.jsx";
import { DetalleIncidencia } from "../components/incidencias/DetalleIncidencia.jsx";
import { Componente_jDolar_106_36 } from "../components/incidencias/Componente_jDolar_106_36.jsx";
import { Componente_MDolar_77_36 } from "../components/incidencias/Componente_MDolar_77_36.jsx";
import { Componente_NDolar_78_36 } from "../components/incidencias/Componente_NDolar_78_36.jsx";
import { FotoIncidencia } from "../components/incidencias/FotoIncidencia.jsx";
import { Componente_LDolar_76_36 } from "../components/incidencias/Componente_LDolar_76_36.jsx";
import { Componente_RDolar_82_36 } from "../components/incidencias/Componente_RDolar_82_36.jsx";
import { Incidencias } from "../components/incidencias/Incidencias.jsx";
import { SeleccionTipoIncidencia } from "../components/incidencias/SeleccionTipoIncidencia.jsx";
import { Componente_XDolar_88_36 } from "../components/incidencias/Componente_XDolar_88_36.jsx";
import { IncidenciaEnviada } from "../components/incidencias/IncidenciaEnviada.jsx";
import { ListaIncidencias } from "../components/incidencias/ListaIncidencias.jsx";
import { Componente_t1_116_49 } from "../components/incidencias/Componente_t1_116_49.jsx";
import { AvanceIncidencia } from "../components/incidencias/AvanceIncidencia.jsx";
import { ReportarIncidencia } from "../components/incidencias/ReportarIncidencia.jsx";
import { PreguntaIncidencia } from "../components/incidencias/PreguntaIncidencia.jsx";
import { RespuestaIncidencia } from "../components/incidencias/RespuestaIncidencia.jsx";
import { SelectorHora } from "../components/inspecciones/SelectorHora.jsx";
import { CapturarFirma } from "../components/inspecciones/CapturarFirma.jsx";
import { ResolverObservacion } from "../components/inspecciones/ResolverObservacion.jsx";
import { SeguimientoObservaciones } from "../components/inspecciones/SeguimientoObservaciones.jsx";
import { Inspecciones } from "../components/inspecciones/Inspecciones.jsx";
import { ControlLabores } from "../components/labores/ControlLabores.jsx";
import { ListaInspecciones } from "../components/inspecciones/ListaInspecciones.jsx";
import { AnaliticaInspecciones } from "../components/inspecciones/AnaliticaInspecciones.jsx";
import { Componente_U1_85_49 } from "../components/inspecciones/Componente_U1_85_49.jsx";
import { Componente_W1_87_49 } from "../components/inspecciones/Componente_W1_87_49.jsx";
import { Componente_G1_71_49 } from "../components/inspecciones/Componente_G1_71_49.jsx";
import { IniciarInspeccion } from "../components/inspecciones/IniciarInspeccion.jsx";
import { FormularioActa } from "../components/inspecciones/FormularioActa.jsx";
import { PreguntaActa } from "../components/inspecciones/PreguntaActa.jsx";
import { CapturarFoto } from "../components/inspecciones/CapturarFoto.jsx";
import { Componente_Q1_81_49 } from "../components/inspecciones/Componente_Q1_81_49.jsx";
import { ImagenActa } from "../components/inspecciones/ImagenActa.jsx";
import { FotosActa } from "../components/inspecciones/FotosActa.jsx";
import { RespuestaActa } from "../components/inspecciones/RespuestaActa.jsx";
import { DetalleActa } from "../components/inspecciones/DetalleActa.jsx";
import { Observaciones } from "../components/observaciones/Observaciones.jsx";
import { PendientesPorLevantar } from "../components/observaciones/PendientesPorLevantar.jsx";
import { Componente_f0_102_48 } from "../components/observaciones/Componente_f0_102_48.jsx";
import { Componente_p0_112_48 } from "../components/observaciones/Componente_p0_112_48.jsx";
import { TablaOrganigrama } from "../components/organigrama/TablaOrganigrama.jsx";
import { CeldaEditable } from "../components/organigrama/CeldaEditable.jsx";
import { Componente_A0_65_48 } from "../components/organigrama/Componente_A0_65_48.jsx";
import { FiltroColumna } from "../components/organigrama/FiltroColumna.jsx";
import { FiltrosOrganigrama } from "../components/organigrama/FiltrosOrganigrama.jsx";
import { Componente_r4_114_52 } from "../components/organigrama/Componente_r4_114_52.jsx";
import { Componente_i4_105_52 } from "../components/organigrama/Componente_i4_105_52.jsx";
import { Componente_a4_97_52 } from "../components/organigrama/Componente_a4_97_52.jsx";
import { EscaleraOrganigrama } from "../components/organigrama/EscaleraOrganigrama.jsx";
import { PuestoOrganigrama } from "../components/organigrama/PuestoOrganigrama.jsx";
import { BuscarPersonaOrganigrama } from "../components/organigrama/BuscarPersonaOrganigrama.jsx";
import { LienzoOrganigrama } from "../components/organigrama/LienzoOrganigrama.jsx";
import { Organigrama } from "../components/organigrama/Organigrama.jsx";
import { GestionOrganigrama } from "../components/organigrama/GestionOrganigrama.jsx";
import { Componente_r3_114_51 } from "../components/organigrama/Componente_r3_114_51.jsx";
import { Componente_i3_105_51 } from "../components/organigrama/Componente_i3_105_51.jsx";
import { ImportacionNisira } from "../components/organigrama/ImportacionNisira.jsx";
import { Componente_o3_111_51 } from "../components/organigrama/Componente_o3_111_51.jsx";
import { Componente_s3_115_51 } from "../components/organigrama/Componente_s3_115_51.jsx";
import { Componente_c3_99_51 } from "../components/organigrama/Componente_c3_99_51.jsx";
import { FotoPuesto } from "../components/organigrama/FotoPuesto.jsx";
import { FormularioPuesto } from "../components/organigrama/FormularioPuesto.jsx";
import { NivelesJerarquicos } from "../components/administracion/NivelesJerarquicos.jsx";
import { GestionNiveles } from "../components/administracion/GestionNiveles.jsx";
import { EditarNivel } from "../components/administracion/EditarNivel.jsx";
import { AreasPorSector } from "../components/administracion/AreasPorSector.jsx";
import { AsignacionesPorArea } from "../components/administracion/AsignacionesPorArea.jsx";
import { InstalacionYConexion } from "../components/pwa/InstalacionYConexion.jsx";
import { PantallaActualizando } from "../components/pwa/PantallaActualizando.jsx";
import { AvisoActualizacion } from "../components/pwa/AvisoActualizacion.jsx";
import { PaginaNoEncontrada } from "../components/navegacion/PaginaNoEncontrada.jsx";
import { RutaConPermiso } from "../components/navegacion/RutaConPermiso.jsx";
import { RutasAplicacion } from "../components/navegacion/RutasAplicacion.jsx";
import { ConstruirRuta } from "../components/navegacion/ConstruirRuta.jsx";
import { App } from "../components/navegacion/App.jsx";
const __vite__mapDeps = () => [];
import { i as e, n as t, t as n } from "./rolldown-runtime-Dd_uD5pT.js";
(function () {
  let e = document.createElement(`link`).relList;
  if (e && e.supports && e.supports(`modulepreload`)) return;
  for (let e of document.querySelectorAll(`link[rel="modulepreload"]`)) n(e);
  new MutationObserver(e => {
    for (let t of e) if (t.type === `childList`) for (let e of t.addedNodes) e.tagName === `LINK` && e.rel === `modulepreload` && n(e);
  }).observe(document, {
    childList: !0,
    subtree: !0
  });
  function t(e) {
    let t = {};
    return e.integrity && (t.integrity = e.integrity), e.referrerPolicy && (t.referrerPolicy = e.referrerPolicy), t.credentials = e.crossOrigin === `use-credentials` ? `include` : e.crossOrigin === `anonymous` ? `omit` : `same-origin`, t;
  }
  function n(e) {
    if (e.ep) return;
    e.ep = !0;
    let n = t(e);
    fetch(e.href, n);
  }
})();
var r = n(e => {
    var t = Symbol.for(`react.transitional.element`),
      n = Symbol.for(`react.portal`),
      r = Symbol.for(`react.fragment`),
      i = Symbol.for(`react.strict_mode`),
      a = Symbol.for(`react.profiler`),
      o = Symbol.for(`react.consumer`),
      s = Symbol.for(`react.context`),
      c = Symbol.for(`react.forward_ref`),
      l = Symbol.for(`react.suspense`),
      u = Symbol.for(`react.memo`),
      d = Symbol.for(`react.lazy`),
      f = Symbol.for(`react.activity`),
      p = Symbol.iterator;
    function m(e) {
      return typeof e != `object` || !e ? null : (e = p && e[p] || e[`@@iterator`], typeof e == `function` ? e : null);
    }
    var h = {
        isMounted: function () {
          return !1;
        },
        enqueueForceUpdate: function () {},
        enqueueReplaceState: function () {},
        enqueueSetState: function () {}
      },
      g = Object.assign,
      _ = {};
    function v(e, t, n) {
      this.props = e, this.context = t, this.refs = _, this.updater = n || h;
    }
    v.prototype.isReactComponent = {}, v.prototype.setState = function (e, t) {
      if (typeof e != `object` && typeof e != `function` && e != null) throw Error(`takes an object of state variables to update or a function which returns an object of state variables.`);
      this.updater.enqueueSetState(this, e, t, `setState`);
    }, v.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, `forceUpdate`);
    };
    function y() {}
    y.prototype = v.prototype;
    function b(e, t, n) {
      this.props = e, this.context = t, this.refs = _, this.updater = n || h;
    }
    var x = b.prototype = new y();
    x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
    var S = Array.isArray;
    function C() {}
    var w = {
        H: null,
        A: null,
        T: null,
        S: null
      },
      T = Object.prototype.hasOwnProperty;
    function E(e, n, r) {
      var i = r.ref;
      return {
        $$typeof: t,
        type: e,
        key: n,
        ref: i === void 0 ? null : i,
        props: r
      };
    }
    function D(e, t) {
      return E(e.type, t, e.props);
    }
    function O(e) {
      return typeof e == `object` && !!e && e.$$typeof === t;
    }
    function k(e) {
      var t = {
        "=": `=0`,
        ":": `=2`
      };
      return `$` + e.replace(/[=:]/g, function (e) {
        return t[e];
      });
    }
    var A = /\/+/g;
    function j(e, t) {
      return typeof e == `object` && e && e.key != null ? k(`` + e.key) : t.toString(36);
    }
    function M(e) {
      switch (e.status) {
        case `fulfilled`:
          return e.value;
        case `rejected`:
          throw e.reason;
        default:
          switch (typeof e.status == `string` ? e.then(C, C) : (e.status = `pending`, e.then(function (t) {
            e.status === `pending` && (e.status = `fulfilled`, e.value = t);
          }, function (t) {
            e.status === `pending` && (e.status = `rejected`, e.reason = t);
          })), e.status) {
            case `fulfilled`:
              return e.value;
            case `rejected`:
              throw e.reason;
          }
      }
      throw e;
    }
    function N(e, r, i, a, o) {
      var s = typeof e;
      (s === `undefined` || s === `boolean`) && (e = null);
      var c = !1;
      if (e === null) c = !0;else switch (s) {
        case `bigint`:
        case `string`:
        case `number`:
          c = !0;
          break;
        case `object`:
          switch (e.$$typeof) {
            case t:
            case n:
              c = !0;
              break;
            case d:
              return c = e._init, N(c(e._payload), r, i, a, o);
          }
      }
      if (c) return o = o(e), c = a === `` ? `.` + j(e, 0) : a, S(o) ? (i = ``, c != null && (i = c.replace(A, `$&/`) + `/`), N(o, r, i, ``, function (e) {
        return e;
      })) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? `` : (`` + o.key).replace(A, `$&/`) + `/`) + c)), r.push(o)), 1;
      c = 0;
      var l = a === `` ? `.` : a + `:`;
      if (S(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + j(a, u), c += N(a, r, i, s, o);else if (u = m(e), typeof u == `function`) for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + j(a, u++), c += N(a, r, i, s, o);else if (s === `object`) {
        if (typeof e.then == `function`) return N(M(e), r, i, a, o);
        throw r = String(e), Error(`Objects are not valid as a React child (found: ` + (r === `[object Object]` ? `object with keys {` + Object.keys(e).join(`, `) + `}` : r) + `). If you meant to render a collection of children, use an array instead.`);
      }
      return c;
    }
    function P(e, t, n) {
      if (e == null) return e;
      var r = [],
        i = 0;
      return N(e, r, ``, ``, function (e) {
        return t.call(n, e, i++);
      }), r;
    }
    function F(e) {
      if (e._status === -1) {
        var t = e._result;
        t = t(), t.then(function (t) {
          (e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
        }, function (t) {
          (e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
        }), e._status === -1 && (e._status = 0, e._result = t);
      }
      if (e._status === 1) return e._result.default;
      throw e._result;
    }
    var I = typeof reportError == `function` ? reportError : function (e) {
        if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
          var t = new window.ErrorEvent(`error`, {
            bubbles: !0,
            cancelable: !0,
            message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
            error: e
          });
          if (!window.dispatchEvent(t)) return;
        } else if (typeof process == `object` && typeof process.emit == `function`) {
          process.emit(`uncaughtException`, e);
          return;
        }
        console.error(e);
      },
      L = {
        map: P,
        forEach: function (e, t, n) {
          P(e, function () {
            t.apply(this, arguments);
          }, n);
        },
        count: function (e) {
          var t = 0;
          return P(e, function () {
            t++;
          }), t;
        },
        toArray: function (e) {
          return P(e, function (e) {
            return e;
          }) || [];
        },
        only: function (e) {
          if (!O(e)) throw Error(`React.Children.only expected to receive a single React element child.`);
          return e;
        }
      };
    e.Activity = f, e.Children = L, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
      __proto__: null,
      c: function (e) {
        return w.H.useMemoCache(e);
      }
    }, e.cache = function (e) {
      return function () {
        return e.apply(null, arguments);
      };
    }, e.cacheSignal = function () {
      return null;
    }, e.cloneElement = function (e, t, n) {
      if (e == null) throw Error(`The argument must be a React element, but you passed ` + e + `.`);
      var r = g({}, e.props),
        i = e.key;
      if (t != null) for (a in t.key !== void 0 && (i = `` + t.key), t) !T.call(t, a) || a === `key` || a === `__self` || a === `__source` || a === `ref` && t.ref === void 0 || (r[a] = t[a]);
      var a = arguments.length - 2;
      if (a === 1) r.children = n;else if (1 < a) {
        for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
        r.children = o;
      }
      return E(e.type, i, r);
    }, e.createContext = function (e) {
      return e = {
        $$typeof: s,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }, e.Provider = e, e.Consumer = {
        $$typeof: o,
        _context: e
      }, e;
    }, e.createElement = function (e, t, n) {
      var r,
        i = {},
        a = null;
      if (t != null) for (r in t.key !== void 0 && (a = `` + t.key), t) T.call(t, r) && r !== `key` && r !== `__self` && r !== `__source` && (i[r] = t[r]);
      var o = arguments.length - 2;
      if (o === 1) i.children = n;else if (1 < o) {
        for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
        i.children = s;
      }
      if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
      return E(e, a, i);
    }, e.createRef = function () {
      return {
        current: null
      };
    }, e.forwardRef = function (e) {
      return {
        $$typeof: c,
        render: e
      };
    }, e.isValidElement = O, e.lazy = function (e) {
      return {
        $$typeof: d,
        _payload: {
          _status: -1,
          _result: e
        },
        _init: F
      };
    }, e.memo = function (e, t) {
      return {
        $$typeof: u,
        type: e,
        compare: t === void 0 ? null : t
      };
    }, e.startTransition = function (e) {
      var t = w.T,
        n = {};
      w.T = n;
      try {
        var r = e(),
          i = w.S;
        i !== null && i(n, r), typeof r == `object` && r && typeof r.then == `function` && r.then(C, I);
      } catch (e) {
        I(e);
      } finally {
        t !== null && n.types !== null && (t.types = n.types), w.T = t;
      }
    }, e.unstable_useCacheRefresh = function () {
      return w.H.useCacheRefresh();
    }, e.use = function (e) {
      return w.H.use(e);
    }, e.useActionState = function (e, t, n) {
      return w.H.useActionState(e, t, n);
    }, e.useCallback = function (e, t) {
      return w.H.useCallback(e, t);
    }, e.useContext = function (e) {
      return w.H.useContext(e);
    }, e.useDebugValue = function () {}, e.useDeferredValue = function (e, t) {
      return w.H.useDeferredValue(e, t);
    }, e.useEffect = function (e, t) {
      return w.H.useEffect(e, t);
    }, e.useEffectEvent = function (e) {
      return w.H.useEffectEvent(e);
    }, e.useId = function () {
      return w.H.useId();
    }, e.useImperativeHandle = function (e, t, n) {
      return w.H.useImperativeHandle(e, t, n);
    }, e.useInsertionEffect = function (e, t) {
      return w.H.useInsertionEffect(e, t);
    }, e.useLayoutEffect = function (e, t) {
      return w.H.useLayoutEffect(e, t);
    }, e.useMemo = function (e, t) {
      return w.H.useMemo(e, t);
    }, e.useOptimistic = function (e, t) {
      return w.H.useOptimistic(e, t);
    }, e.useReducer = function (e, t, n) {
      return w.H.useReducer(e, t, n);
    }, e.useRef = function (e) {
      return w.H.useRef(e);
    }, e.useState = function (e) {
      return w.H.useState(e);
    }, e.useSyncExternalStore = function (e, t, n) {
      return w.H.useSyncExternalStore(e, t, n);
    }, e.useTransition = function () {
      return w.H.useTransition();
    }, e.version = `19.2.8`;
  }),
  i = n((e, t) => {
    t.exports = r();
  }),
  a = n(e => {
    function t(e, t) {
      var n = e.length;
      e.push(t);
      a: for (; 0 < n;) {
        var r = n - 1 >>> 1,
          a = e[r];
        if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;else break a;
      }
    }
    function n(e) {
      return e.length === 0 ? null : e[0];
    }
    function r(e) {
      if (e.length === 0) return null;
      var t = e[0],
        n = e.pop();
      if (n !== t) {
        e[0] = n;
        a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
          var s = 2 * (r + 1) - 1,
            c = e[s],
            l = s + 1,
            u = e[l];
          if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;else break a;
        }
      }
      return t;
    }
    function i(e, t) {
      var n = e.sortIndex - t.sortIndex;
      return n === 0 ? e.id - t.id : n;
    }
    if (e.unstable_now = void 0, typeof performance == `object` && typeof performance.now == `function`) {
      var a = performance;
      e.unstable_now = function () {
        return a.now();
      };
    } else {
      var o = Date,
        s = o.now();
      e.unstable_now = function () {
        return o.now() - s;
      };
    }
    var c = [],
      l = [],
      u = 1,
      d = null,
      f = 3,
      p = !1,
      m = !1,
      h = !1,
      g = !1,
      _ = typeof setTimeout == `function` ? setTimeout : null,
      v = typeof clearTimeout == `function` ? clearTimeout : null,
      y = typeof setImmediate < `u` ? setImmediate : null;
    function b(e) {
      for (var i = n(l); i !== null;) {
        if (i.callback === null) r(l);else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);else break;
        i = n(l);
      }
    }
    function x(e) {
      if (h = !1, b(e), !m) {
        if (n(c) !== null) m = !0, S || (S = !0, O());else {
          var t = n(l);
          t !== null && j(x, t.startTime - e);
        }
      }
    }
    var S = !1,
      C = -1,
      w = 5,
      T = -1;
    function E() {
      return g ? !0 : !(e.unstable_now() - T < w);
    }
    function D() {
      if (g = !1, S) {
        var t = e.unstable_now();
        T = t;
        var i = !0;
        try {
          a: {
            m = !1, h && (h = !1, v(C), C = -1), p = !0;
            var a = f;
            try {
              b: {
                for (b(t), d = n(c); d !== null && !(d.expirationTime > t && E());) {
                  var o = d.callback;
                  if (typeof o == `function`) {
                    d.callback = null, f = d.priorityLevel;
                    var s = o(d.expirationTime <= t);
                    if (t = e.unstable_now(), typeof s == `function`) {
                      d.callback = s, b(t), i = !0;
                      break b;
                    }
                    d === n(c) && r(c), b(t);
                  } else r(c);
                  d = n(c);
                }
                if (d !== null) i = !0;else {
                  var u = n(l);
                  u !== null && j(x, u.startTime - t), i = !1;
                }
              }
              break a;
            } finally {
              d = null, f = a, p = !1;
            }
            i = void 0;
          }
        } finally {
          i ? O() : S = !1;
        }
      }
    }
    var O;
    if (typeof y == `function`) O = function () {
      y(D);
    };else if (typeof MessageChannel < `u`) {
      var k = new MessageChannel(),
        A = k.port2;
      k.port1.onmessage = D, O = function () {
        A.postMessage(null);
      };
    } else O = function () {
      _(D, 0);
    };
    function j(t, n) {
      C = _(function () {
        t(e.unstable_now());
      }, n);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (e) {
      e.callback = null;
    }, e.unstable_forceFrameRate = function (e) {
      0 > e || 125 < e ? console.error(`forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported`) : w = 0 < e ? Math.floor(1e3 / e) : 5;
    }, e.unstable_getCurrentPriorityLevel = function () {
      return f;
    }, e.unstable_next = function (e) {
      switch (f) {
        case 1:
        case 2:
        case 3:
          var t = 3;
          break;
        default:
          t = f;
      }
      var n = f;
      f = t;
      try {
        return e();
      } finally {
        f = n;
      }
    }, e.unstable_requestPaint = function () {
      g = !0;
    }, e.unstable_runWithPriority = function (e, t) {
      switch (e) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          e = 3;
      }
      var n = f;
      f = e;
      try {
        return t();
      } finally {
        f = n;
      }
    }, e.unstable_scheduleCallback = function (r, i, a) {
      var o = e.unstable_now();
      switch (typeof a == `object` && a ? (a = a.delay, a = typeof a == `number` && 0 < a ? o + a : o) : a = o, r) {
        case 1:
          var s = -1;
          break;
        case 2:
          s = 250;
          break;
        case 5:
          s = 1073741823;
          break;
        case 4:
          s = 1e4;
          break;
        default:
          s = 5e3;
      }
      return s = a + s, r = {
        id: u++,
        callback: i,
        priorityLevel: r,
        startTime: a,
        expirationTime: s,
        sortIndex: -1
      }, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, j(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, O()))), r;
    }, e.unstable_shouldYield = E, e.unstable_wrapCallback = function (e) {
      var t = f;
      return function () {
        var n = f;
        f = t;
        try {
          return e.apply(this, arguments);
        } finally {
          f = n;
        }
      };
    };
  }),
  o = n((e, t) => {
    t.exports = a();
  }),
  s = n(e => {
    var t = i();
    function n(e) {
      var t = `https://react.dev/errors/` + e;
      if (1 < arguments.length) {
        t += `?args[]=` + encodeURIComponent(arguments[1]);
        for (var n = 2; n < arguments.length; n++) t += `&args[]=` + encodeURIComponent(arguments[n]);
      }
      return `Minified React error #` + e + `; visit ` + t + ` for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`;
    }
    function r() {}
    var a = {
        d: {
          f: r,
          r: function () {
            throw Error(n(522));
          },
          D: r,
          C: r,
          L: r,
          m: r,
          X: r,
          S: r,
          M: r
        },
        p: 0,
        findDOMNode: null
      },
      o = Symbol.for(`react.portal`);
    function s(e, t, n) {
      var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return {
        $$typeof: o,
        key: r == null ? null : `` + r,
        children: e,
        containerInfo: t,
        implementation: n
      };
    }
    var c = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    function l(e, t) {
      if (e === `font`) return ``;
      if (typeof t == `string`) return t === `use-credentials` ? t : ``;
    }
    e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = a, e.createPortal = function (e, t) {
      var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
      return s(e, t, null, r);
    }, e.flushSync = function (e) {
      var t = c.T,
        n = a.p;
      try {
        if (c.T = null, a.p = 2, e) return e();
      } finally {
        c.T = t, a.p = n, a.d.f();
      }
    }, e.preconnect = function (e, t) {
      typeof e == `string` && (t ? (t = t.crossOrigin, t = typeof t == `string` ? t === `use-credentials` ? t : `` : void 0) : t = null, a.d.C(e, t));
    }, e.prefetchDNS = function (e) {
      typeof e == `string` && a.d.D(e);
    }, e.preinit = function (e, t) {
      if (typeof e == `string` && t && typeof t.as == `string`) {
        var n = t.as,
          r = l(n, t.crossOrigin),
          i = typeof t.integrity == `string` ? t.integrity : void 0,
          o = typeof t.fetchPriority == `string` ? t.fetchPriority : void 0;
        n === `style` ? a.d.S(e, typeof t.precedence == `string` ? t.precedence : void 0, {
          crossOrigin: r,
          integrity: i,
          fetchPriority: o
        }) : n === `script` && a.d.X(e, {
          crossOrigin: r,
          integrity: i,
          fetchPriority: o,
          nonce: typeof t.nonce == `string` ? t.nonce : void 0
        });
      }
    }, e.preinitModule = function (e, t) {
      if (typeof e == `string`) {
        if (typeof t == `object` && t) {
          if (t.as == null || t.as === `script`) {
            var n = l(t.as, t.crossOrigin);
            a.d.M(e, {
              crossOrigin: n,
              integrity: typeof t.integrity == `string` ? t.integrity : void 0,
              nonce: typeof t.nonce == `string` ? t.nonce : void 0
            });
          }
        } else t ?? a.d.M(e);
      }
    }, e.preload = function (e, t) {
      if (typeof e == `string` && typeof t == `object` && t && typeof t.as == `string`) {
        var n = t.as,
          r = l(n, t.crossOrigin);
        a.d.L(e, n, {
          crossOrigin: r,
          integrity: typeof t.integrity == `string` ? t.integrity : void 0,
          nonce: typeof t.nonce == `string` ? t.nonce : void 0,
          type: typeof t.type == `string` ? t.type : void 0,
          fetchPriority: typeof t.fetchPriority == `string` ? t.fetchPriority : void 0,
          referrerPolicy: typeof t.referrerPolicy == `string` ? t.referrerPolicy : void 0,
          imageSrcSet: typeof t.imageSrcSet == `string` ? t.imageSrcSet : void 0,
          imageSizes: typeof t.imageSizes == `string` ? t.imageSizes : void 0,
          media: typeof t.media == `string` ? t.media : void 0
        });
      }
    }, e.preloadModule = function (e, t) {
      if (typeof e == `string`) {
        if (t) {
          var n = l(t.as, t.crossOrigin);
          a.d.m(e, {
            as: typeof t.as == `string` && t.as !== `script` ? t.as : void 0,
            crossOrigin: n,
            integrity: typeof t.integrity == `string` ? t.integrity : void 0
          });
        } else a.d.m(e);
      }
    }, e.requestFormReset = function (e) {
      a.d.r(e);
    }, e.unstable_batchedUpdates = function (e, t) {
      return e(t);
    }, e.useFormState = function (e, t, n) {
      return c.H.useFormState(e, t, n);
    }, e.useFormStatus = function () {
      return c.H.useHostTransitionStatus();
    }, e.version = `19.2.8`;
  }),
  c = n((e, t) => {
    function n() {
      if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > `u` || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != `function`)) try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (e) {
        console.error(e);
      }
    }
    n(), t.exports = s();
  }),
  l = n(e => {
    var t = o(),
      n = i(),
      r = c();
    function a(e) {
      var t = `https://react.dev/errors/` + e;
      if (1 < arguments.length) {
        t += `?args[]=` + encodeURIComponent(arguments[1]);
        for (var n = 2; n < arguments.length; n++) t += `&args[]=` + encodeURIComponent(arguments[n]);
      }
      return `Minified React error #` + e + `; visit ` + t + ` for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`;
    }
    function s(e) {
      return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
    }
    function l(e) {
      var t = e,
        n = e;
      if (e.alternate) for (; t.return;) t = t.return;else {
        e = t;
        do t = e, t.flags & 4098 && (n = t.return), e = t.return; while (e);
      }
      return t.tag === 3 ? n : null;
    }
    function u(e) {
      if (e.tag === 13) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
      }
      return null;
    }
    function d(e) {
      if (e.tag === 31) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
      }
      return null;
    }
    function f(e) {
      if (l(e) !== e) throw Error(a(188));
    }
    function p(e) {
      var t = e.alternate;
      if (!t) {
        if (t = l(e), t === null) throw Error(a(188));
        return t === e ? e : null;
      }
      for (var n = e, r = t;;) {
        var i = n.return;
        if (i === null) break;
        var o = i.alternate;
        if (o === null) {
          if (r = i.return, r !== null) {
            n = r;
            continue;
          }
          break;
        }
        if (i.child === o.child) {
          for (o = i.child; o;) {
            if (o === n) return f(i), e;
            if (o === r) return f(i), t;
            o = o.sibling;
          }
          throw Error(a(188));
        }
        if (n.return !== r.return) n = i, r = o;else {
          for (var s = !1, c = i.child; c;) {
            if (c === n) {
              s = !0, n = i, r = o;
              break;
            }
            if (c === r) {
              s = !0, r = i, n = o;
              break;
            }
            c = c.sibling;
          }
          if (!s) {
            for (c = o.child; c;) {
              if (c === n) {
                s = !0, n = o, r = i;
                break;
              }
              if (c === r) {
                s = !0, r = o, n = i;
                break;
              }
              c = c.sibling;
            }
            if (!s) throw Error(a(189));
          }
        }
        if (n.alternate !== r) throw Error(a(190));
      }
      if (n.tag !== 3) throw Error(a(188));
      return n.stateNode.current === n ? e : t;
    }
    function m(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6) return e;
      for (e = e.child; e !== null;) {
        if (t = m(e), t !== null) return t;
        e = e.sibling;
      }
      return null;
    }
    var h = Object.assign,
      g = Symbol.for(`react.element`),
      _ = Symbol.for(`react.transitional.element`),
      v = Symbol.for(`react.portal`),
      y = Symbol.for(`react.fragment`),
      b = Symbol.for(`react.strict_mode`),
      x = Symbol.for(`react.profiler`),
      S = Symbol.for(`react.consumer`),
      C = Symbol.for(`react.context`),
      w = Symbol.for(`react.forward_ref`),
      T = Symbol.for(`react.suspense`),
      E = Symbol.for(`react.suspense_list`),
      D = Symbol.for(`react.memo`),
      O = Symbol.for(`react.lazy`),
      k = Symbol.for(`react.activity`),
      A = Symbol.for(`react.memo_cache_sentinel`),
      j = Symbol.iterator;
    function M(e) {
      return typeof e != `object` || !e ? null : (e = j && e[j] || e[`@@iterator`], typeof e == `function` ? e : null);
    }
    var N = Symbol.for(`react.client.reference`);
    function P(e) {
      if (e == null) return null;
      if (typeof e == `function`) return e.$$typeof === N ? null : e.displayName || e.name || null;
      if (typeof e == `string`) return e;
      switch (e) {
        case y:
          return `Fragment`;
        case x:
          return `Profiler`;
        case b:
          return `StrictMode`;
        case T:
          return `Suspense`;
        case E:
          return `SuspenseList`;
        case k:
          return `Activity`;
      }
      if (typeof e == `object`) switch (e.$$typeof) {
        case v:
          return `Portal`;
        case C:
          return e.displayName || `Context`;
        case S:
          return (e._context.displayName || `Context`) + `.Consumer`;
        case w:
          var t = e.render;
          return e = e.displayName, e ||= (e = t.displayName || t.name || ``, e === `` ? `ForwardRef` : `ForwardRef(` + e + `)`), e;
        case D:
          return t = e.displayName || null, t === null ? P(e.type) || `Memo` : t;
        case O:
          t = e._payload, e = e._init;
          try {
            return P(e(t));
          } catch {}
      }
      return null;
    }
    var F = Array.isArray,
      I = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
      L = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
      R = {
        pending: !1,
        data: null,
        method: null,
        action: null
      },
      z = [],
      ee = -1;
    function te(e) {
      return {
        current: e
      };
    }
    function B(e) {
      0 > ee || (e.current = z[ee], z[ee] = null, ee--);
    }
    function V(e, t) {
      ee++, z[ee] = e.current, e.current = t;
    }
    var H = te(null),
      ne = te(null),
      re = te(null),
      ie = te(null);
    function U(e, t) {
      switch (V(re, t), V(ne, e), V(H, null), t.nodeType) {
        case 9:
        case 11:
          e = (e = t.documentElement) && (e = e.namespaceURI) ? Kd(e) : 0;
          break;
        default:
          if (e = t.tagName, t = t.namespaceURI) t = Kd(t), e = qd(t, e);else switch (e) {
            case `svg`:
              e = 1;
              break;
            case `math`:
              e = 2;
              break;
            default:
              e = 0;
          }
      }
      B(H), V(H, e);
    }
    function ae() {
      B(H), B(ne), B(re);
    }
    function oe(e) {
      e.memoizedState !== null && V(ie, e);
      var t = H.current,
        n = qd(t, e.type);
      t !== n && (V(ne, e), V(H, n));
    }
    function se(e) {
      ne.current === e && (B(H), B(ne)), ie.current === e && (B(ie), rp._currentValue = R);
    }
    var ce, le;
    function ue(e) {
      if (ce === void 0) try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        ce = t && t[1] || ``, le = -1 < e.stack.indexOf(`
    at`) ? ` (<anonymous>)` : -1 < e.stack.indexOf(`@`) ? `@unknown:0:0` : ``;
      }
      return `
` + ce + e + le;
    }
    var de = !1;
    function fe(e, t) {
      if (!e || de) return ``;
      de = !0;
      var n = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        var r = {
          DetermineComponentFrameRoot: function () {
            try {
              if (t) {
                var n = function () {
                  throw Error();
                };
                if (Object.defineProperty(n.prototype, "props", {
                  set: function () {
                    throw Error();
                  }
                }), typeof Reflect == `object` && Reflect.construct) {
                  try {
                    Reflect.construct(n, []);
                  } catch (e) {
                    var r = e;
                  }
                  Reflect.construct(e, [], n);
                } else {
                  try {
                    n.call();
                  } catch (e) {
                    r = e;
                  }
                  e.call(n.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (e) {
                  r = e;
                }
                (n = e()) && typeof n.catch == `function` && n.catch(function () {});
              }
            } catch (e) {
              if (e && r && typeof e.stack == `string`) return [e.stack, r.stack];
            }
            return [null, null];
          }
        };
        r.DetermineComponentFrameRoot.displayName = `DetermineComponentFrameRoot`;
        var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, `name`);
        i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
          value: `DetermineComponentFrameRoot`
        });
        var a = r.DetermineComponentFrameRoot(),
          o = a[0],
          s = a[1];
        if (o && s) {
          var c = o.split(`
`),
            l = s.split(`
`);
          for (i = r = 0; r < c.length && !c[r].includes(`DetermineComponentFrameRoot`);) r++;
          for (; i < l.length && !l[i].includes(`DetermineComponentFrameRoot`);) i++;
          if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
          for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
            if (r !== 1 || i !== 1) do if (r--, i--, 0 > i || c[r] !== l[i]) {
              var u = `
` + c[r].replace(` at new `, ` at `);
              return e.displayName && u.includes(`<anonymous>`) && (u = u.replace(`<anonymous>`, e.displayName)), u;
            } while (1 <= r && 0 <= i);
            break;
          }
        }
      } finally {
        de = !1, Error.prepareStackTrace = n;
      }
      return (n = e ? e.displayName || e.name : ``) ? ue(n) : ``;
    }
    function pe(e, t) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return ue(e.type);
        case 16:
          return ue(`Lazy`);
        case 13:
          return e.child !== t && t !== null ? ue(`Suspense Fallback`) : ue(`Suspense`);
        case 19:
          return ue(`SuspenseList`);
        case 0:
        case 15:
          return fe(e.type, !1);
        case 11:
          return fe(e.type.render, !1);
        case 1:
          return fe(e.type, !0);
        case 31:
          return ue(`Activity`);
        default:
          return ``;
      }
    }
    function me(e) {
      try {
        var t = ``,
          n = null;
        do t += pe(e, n), n = e, e = e.return; while (e);
        return t;
      } catch (e) {
        return `
Error generating stack: ` + e.message + `
` + e.stack;
      }
    }
    var he = Object.prototype.hasOwnProperty,
      ge = t.unstable_scheduleCallback,
      _e = t.unstable_cancelCallback,
      ve = t.unstable_shouldYield,
      ye = t.unstable_requestPaint,
      be = t.unstable_now,
      xe = t.unstable_getCurrentPriorityLevel,
      Se = t.unstable_ImmediatePriority,
      Ce = t.unstable_UserBlockingPriority,
      we = t.unstable_NormalPriority,
      Te = t.unstable_LowPriority,
      Ee = t.unstable_IdlePriority,
      De = t.log,
      Oe = t.unstable_setDisableYieldValue,
      ke = null,
      Ae = null;
    function je(e) {
      if (typeof De == `function` && Oe(e), Ae && typeof Ae.setStrictMode == `function`) try {
        Ae.setStrictMode(ke, e);
      } catch {}
    }
    var Me = Math.clz32 ? Math.clz32 : Fe,
      Ne = Math.log,
      Pe = Math.LN2;
    function Fe(e) {
      return e >>>= 0, e === 0 ? 32 : 31 - (Ne(e) / Pe | 0) | 0;
    }
    var Ie = 256,
      Le = 262144,
      Re = 4194304;
    function ze(e) {
      var t = e & 42;
      if (t !== 0) return t;
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return e & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return e & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return e & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return e;
      }
    }
    function Be(e, t, n) {
      var r = e.pendingLanes;
      if (r === 0) return 0;
      var i = 0,
        a = e.suspendedLanes,
        o = e.pingedLanes;
      e = e.warmLanes;
      var s = r & 134217727;
      return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = ze(n))) : i = ze(o) : i = ze(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = ze(n))) : i = ze(o)) : i = ze(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
    }
    function Ve(e, t) {
      return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
    }
    function He(e, t) {
      switch (e) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return t + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return t + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function Ue() {
      var e = Re;
      return Re <<= 1, !(Re & 62914560) && (Re = 4194304), e;
    }
    function We(e) {
      for (var t = [], n = 0; 31 > n; n++) t.push(e);
      return t;
    }
    function Ge(e, t) {
      e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function Ke(e, t, n, r, i, a) {
      var o = e.pendingLanes;
      e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
      var s = e.entanglements,
        c = e.expirationTimes,
        l = e.hiddenUpdates;
      for (n = o & ~n; 0 < n;) {
        var u = 31 - Me(n),
          d = 1 << u;
        s[u] = 0, c[u] = -1;
        var f = l[u];
        if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
          var p = f[u];
          p !== null && (p.lane &= -536870913);
        }
        n &= ~d;
      }
      r !== 0 && qe(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
    }
    function qe(e, t, n) {
      e.pendingLanes |= t, e.suspendedLanes &= ~t;
      var r = 31 - Me(t);
      e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
    }
    function Je(e, t) {
      var n = e.entangledLanes |= t;
      for (e = e.entanglements; n;) {
        var r = 31 - Me(n),
          i = 1 << r;
        i & t | e[r] & t && (e[r] |= t), n &= ~i;
      }
    }
    function Ye(e, t) {
      var n = t & -t;
      return n = n & 42 ? 1 : Xe(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
    }
    function Xe(e) {
      switch (e) {
        case 2:
          e = 1;
          break;
        case 8:
          e = 4;
          break;
        case 32:
          e = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          e = 128;
          break;
        case 268435456:
          e = 134217728;
          break;
        default:
          e = 0;
      }
      return e;
    }
    function Ze(e) {
      return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
    }
    function Qe() {
      var e = L.p;
      return e === 0 ? (e = window.event, e === void 0 ? 32 : yp(e.type)) : e;
    }
    function $e(e, t) {
      var n = L.p;
      try {
        return L.p = e, t();
      } finally {
        L.p = n;
      }
    }
    var et = Math.random().toString(36).slice(2),
      tt = `__reactFiber$` + et,
      nt = `__reactProps$` + et,
      rt = `__reactContainer$` + et,
      it = `__reactEvents$` + et,
      at = `__reactListeners$` + et,
      ot = `__reactHandles$` + et,
      st = `__reactResources$` + et,
      ct = `__reactMarker$` + et;
    function lt(e) {
      delete e[tt], delete e[nt], delete e[it], delete e[at], delete e[ot];
    }
    function ut(e) {
      var t = e[tt];
      if (t) return t;
      for (var n = e.parentNode; n;) {
        if (t = n[rt] || n[tt]) {
          if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = gf(e); e !== null;) {
            if (n = e[tt]) return n;
            e = gf(e);
          }
          return t;
        }
        e = n, n = e.parentNode;
      }
      return null;
    }
    function dt(e) {
      if (e = e[tt] || e[rt]) {
        var t = e.tag;
        if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
      }
      return null;
    }
    function ft(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
      throw Error(a(33));
    }
    function pt(e) {
      var t = e[st];
      return t ||= e[st] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
      }, t;
    }
    function mt(e) {
      e[ct] = !0;
    }
    var ht = new Set(),
      gt = {};
    function _t(e, t) {
      vt(e, t), vt(e + `Capture`, t);
    }
    function vt(e, t) {
      for (gt[e] = t, e = 0; e < t.length; e++) ht.add(t[e]);
    }
    var yt = RegExp(`^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$`),
      bt = {},
      xt = {};
    function St(e) {
      return he.call(xt, e) ? !0 : he.call(bt, e) ? !1 : yt.test(e) ? xt[e] = !0 : (bt[e] = !0, !1);
    }
    function Ct(e, t, n) {
      if (St(t)) {
        if (n === null) e.removeAttribute(t);else {
          switch (typeof n) {
            case `undefined`:
            case `function`:
            case `symbol`:
              e.removeAttribute(t);
              return;
            case `boolean`:
              var r = t.toLowerCase().slice(0, 5);
              if (r !== `data-` && r !== `aria-`) {
                e.removeAttribute(t);
                return;
              }
          }
          e.setAttribute(t, `` + n);
        }
      }
    }
    function wt(e, t, n) {
      if (n === null) e.removeAttribute(t);else {
        switch (typeof n) {
          case `undefined`:
          case `function`:
          case `symbol`:
          case `boolean`:
            e.removeAttribute(t);
            return;
        }
        e.setAttribute(t, `` + n);
      }
    }
    function Tt(e, t, n, r) {
      if (r === null) e.removeAttribute(n);else {
        switch (typeof r) {
          case `undefined`:
          case `function`:
          case `symbol`:
          case `boolean`:
            e.removeAttribute(n);
            return;
        }
        e.setAttributeNS(t, n, `` + r);
      }
    }
    function Et(e) {
      switch (typeof e) {
        case `bigint`:
        case `boolean`:
        case `number`:
        case `string`:
        case `undefined`:
          return e;
        case `object`:
          return e;
        default:
          return ``;
      }
    }
    function Dt(e) {
      var t = e.type;
      return (e = e.nodeName) && e.toLowerCase() === `input` && (t === `checkbox` || t === `radio`);
    }
    function Ot(e, t, n) {
      var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == `function` && typeof r.set == `function`) {
        var i = r.get,
          a = r.set;
        return Object.defineProperty(e, t, {
          configurable: !0,
          get: function () {
            return i.call(this);
          },
          set: function (e) {
            n = `` + e, a.call(this, e);
          }
        }), Object.defineProperty(e, t, {
          enumerable: r.enumerable
        }), {
          getValue: function () {
            return n;
          },
          setValue: function (e) {
            n = `` + e;
          },
          stopTracking: function () {
            e._valueTracker = null, delete e[t];
          }
        };
      }
    }
    function kt(e) {
      if (!e._valueTracker) {
        var t = Dt(e) ? `checked` : `value`;
        e._valueTracker = Ot(e, t, `` + e[t]);
      }
    }
    function At(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var n = t.getValue(),
        r = ``;
      return e && (r = Dt(e) ? e.checked ? `true` : `false` : e.value), e = r, e !== n && (t.setValue(e), !0);
    }
    function jt(e) {
      if (e ||= typeof document < `u` ? document : void 0, e === void 0) return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var Mt = /[\n"\\]/g;
    function Nt(e) {
      return e.replace(Mt, function (e) {
        return `\\` + e.charCodeAt(0).toString(16) + ` `;
      });
    }
    function Pt(e, t, n, r, i, a, o, s) {
      e.name = ``, o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean` ? e.type = o : e.removeAttribute(`type`), t == null ? o !== `submit` && o !== `reset` || e.removeAttribute(`value`) : o === `number` ? (t === 0 && e.value === `` || e.value != t) && (e.value = `` + Et(t)) : e.value !== `` + Et(t) && (e.value = `` + Et(t)), t == null ? n == null ? r != null && e.removeAttribute(`value`) : It(e, o, Et(n)) : It(e, o, Et(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != `function` && typeof i != `symbol`), s != null && typeof s != `function` && typeof s != `symbol` && typeof s != `boolean` ? e.name = `` + Et(s) : e.removeAttribute(`name`);
    }
    function Ft(e, t, n, r, i, a, o, s) {
      if (a != null && typeof a != `function` && typeof a != `symbol` && typeof a != `boolean` && (e.type = a), t != null || n != null) {
        if (!(a !== `submit` && a !== `reset` || t != null)) {
          kt(e);
          return;
        }
        n = n == null ? `` : `` + Et(n), t = t == null ? n : `` + Et(t), s || t === e.value || (e.value = t), e.defaultValue = t;
      }
      r ??= i, r = typeof r != `function` && typeof r != `symbol` && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean` && (e.name = o), kt(e);
    }
    function It(e, t, n) {
      t === `number` && jt(e.ownerDocument) === e || e.defaultValue === `` + n || (e.defaultValue = `` + n);
    }
    function Lt(e, t, n, r) {
      if (e = e.options, t) {
        t = {};
        for (var i = 0; i < n.length; i++) t[`$` + n[i]] = !0;
        for (n = 0; n < e.length; n++) i = t.hasOwnProperty(`$` + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
      } else {
        for (n = `` + Et(n), t = null, i = 0; i < e.length; i++) {
          if (e[i].value === n) {
            e[i].selected = !0, r && (e[i].defaultSelected = !0);
            return;
          }
          t !== null || e[i].disabled || (t = e[i]);
        }
        t !== null && (t.selected = !0);
      }
    }
    function Rt(e, t, n) {
      if (t != null && (t = `` + Et(t), t !== e.value && (e.value = t), n == null)) {
        e.defaultValue !== t && (e.defaultValue = t);
        return;
      }
      e.defaultValue = n == null ? `` : `` + Et(n);
    }
    function zt(e, t, n, r) {
      if (t == null) {
        if (r != null) {
          if (n != null) throw Error(a(92));
          if (F(r)) {
            if (1 < r.length) throw Error(a(93));
            r = r[0];
          }
          n = r;
        }
        n ??= ``, t = n;
      }
      n = Et(t), e.defaultValue = n, r = e.textContent, r === n && r !== `` && r !== null && (e.value = r), kt(e);
    }
    function Bt(e, t) {
      if (t) {
        var n = e.firstChild;
        if (n && n === e.lastChild && n.nodeType === 3) {
          n.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }
    var Vt = new Set(`animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp`.split(` `));
    function Ht(e, t, n) {
      var r = t.indexOf(`--`) === 0;
      n == null || typeof n == `boolean` || n === `` ? r ? e.setProperty(t, ``) : t === `float` ? e.cssFloat = `` : e[t] = `` : r ? e.setProperty(t, n) : typeof n != `number` || n === 0 || Vt.has(t) ? t === `float` ? e.cssFloat = n : e[t] = (`` + n).trim() : e[t] = n + `px`;
    }
    function Ut(e, t, n) {
      if (t != null && typeof t != `object`) throw Error(a(62));
      if (e = e.style, n != null) {
        for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf(`--`) === 0 ? e.setProperty(r, ``) : r === `float` ? e.cssFloat = `` : e[r] = ``);
        for (var i in t) r = t[i], t.hasOwnProperty(i) && n[i] !== r && Ht(e, i, r);
      } else for (var o in t) t.hasOwnProperty(o) && Ht(e, o, t[o]);
    }
    function Wt(e) {
      if (e.indexOf(`-`) === -1) return !1;
      switch (e) {
        case `annotation-xml`:
        case `color-profile`:
        case `font-face`:
        case `font-face-src`:
        case `font-face-uri`:
        case `font-face-format`:
        case `font-face-name`:
        case `missing-glyph`:
          return !1;
        default:
          return !0;
      }
    }
    var Gt = new Map([[`acceptCharset`, `accept-charset`], [`htmlFor`, `for`], [`httpEquiv`, `http-equiv`], [`crossOrigin`, `crossorigin`], [`accentHeight`, `accent-height`], [`alignmentBaseline`, `alignment-baseline`], [`arabicForm`, `arabic-form`], [`baselineShift`, `baseline-shift`], [`capHeight`, `cap-height`], [`clipPath`, `clip-path`], [`clipRule`, `clip-rule`], [`colorInterpolation`, `color-interpolation`], [`colorInterpolationFilters`, `color-interpolation-filters`], [`colorProfile`, `color-profile`], [`colorRendering`, `color-rendering`], [`dominantBaseline`, `dominant-baseline`], [`enableBackground`, `enable-background`], [`fillOpacity`, `fill-opacity`], [`fillRule`, `fill-rule`], [`floodColor`, `flood-color`], [`floodOpacity`, `flood-opacity`], [`fontFamily`, `font-family`], [`fontSize`, `font-size`], [`fontSizeAdjust`, `font-size-adjust`], [`fontStretch`, `font-stretch`], [`fontStyle`, `font-style`], [`fontVariant`, `font-variant`], [`fontWeight`, `font-weight`], [`glyphName`, `glyph-name`], [`glyphOrientationHorizontal`, `glyph-orientation-horizontal`], [`glyphOrientationVertical`, `glyph-orientation-vertical`], [`horizAdvX`, `horiz-adv-x`], [`horizOriginX`, `horiz-origin-x`], [`imageRendering`, `image-rendering`], [`letterSpacing`, `letter-spacing`], [`lightingColor`, `lighting-color`], [`markerEnd`, `marker-end`], [`markerMid`, `marker-mid`], [`markerStart`, `marker-start`], [`overlinePosition`, `overline-position`], [`overlineThickness`, `overline-thickness`], [`paintOrder`, `paint-order`], [`panose-1`, `panose-1`], [`pointerEvents`, `pointer-events`], [`renderingIntent`, `rendering-intent`], [`shapeRendering`, `shape-rendering`], [`stopColor`, `stop-color`], [`stopOpacity`, `stop-opacity`], [`strikethroughPosition`, `strikethrough-position`], [`strikethroughThickness`, `strikethrough-thickness`], [`strokeDasharray`, `stroke-dasharray`], [`strokeDashoffset`, `stroke-dashoffset`], [`strokeLinecap`, `stroke-linecap`], [`strokeLinejoin`, `stroke-linejoin`], [`strokeMiterlimit`, `stroke-miterlimit`], [`strokeOpacity`, `stroke-opacity`], [`strokeWidth`, `stroke-width`], [`textAnchor`, `text-anchor`], [`textDecoration`, `text-decoration`], [`textRendering`, `text-rendering`], [`transformOrigin`, `transform-origin`], [`underlinePosition`, `underline-position`], [`underlineThickness`, `underline-thickness`], [`unicodeBidi`, `unicode-bidi`], [`unicodeRange`, `unicode-range`], [`unitsPerEm`, `units-per-em`], [`vAlphabetic`, `v-alphabetic`], [`vHanging`, `v-hanging`], [`vIdeographic`, `v-ideographic`], [`vMathematical`, `v-mathematical`], [`vectorEffect`, `vector-effect`], [`vertAdvY`, `vert-adv-y`], [`vertOriginX`, `vert-origin-x`], [`vertOriginY`, `vert-origin-y`], [`wordSpacing`, `word-spacing`], [`writingMode`, `writing-mode`], [`xmlnsXlink`, `xmlns:xlink`], [`xHeight`, `x-height`]]),
      Kt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
    function qt(e) {
      return Kt.test(`` + e) ? `javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')` : e;
    }
    function Jt() {}
    var Yt = null;
    function Xt(e) {
      return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
    }
    var Zt = null,
      Qt = null;
    function $t(e) {
      var t = dt(e);
      if (t && (e = t.stateNode)) {
        var n = e[nt] || null;
        a: switch (e = t.stateNode, t.type) {
          case `input`:
            if (Pt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === `radio` && t != null) {
              for (n = e; n.parentNode;) n = n.parentNode;
              for (n = n.querySelectorAll(`input[name="` + Nt(`` + t) + `"][type="radio"]`), t = 0; t < n.length; t++) {
                var r = n[t];
                if (r !== e && r.form === e.form) {
                  var i = r[nt] || null;
                  if (!i) throw Error(a(90));
                  Pt(r, i.value, i.defaultValue, i.defaultValue, i.checked, i.defaultChecked, i.type, i.name);
                }
              }
              for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && At(r);
            }
            break a;
          case `textarea`:
            Rt(e, n.value, n.defaultValue);
            break a;
          case `select`:
            t = n.value, t != null && Lt(e, !!n.multiple, t, !1);
        }
      }
    }
    var en = !1;
    function tn(e, t, n) {
      if (en) return e(t, n);
      en = !0;
      try {
        return e(t);
      } finally {
        if (en = !1, (Zt !== null || Qt !== null) && (Cu(), Zt && (t = Zt, e = Qt, Qt = Zt = null, $t(t), e))) for (t = 0; t < e.length; t++) $t(e[t]);
      }
    }
    function nn(e, t) {
      var n = e.stateNode;
      if (n === null) return null;
      var r = n[nt] || null;
      if (r === null) return null;
      n = r[t];
      a: switch (t) {
        case `onClick`:
        case `onClickCapture`:
        case `onDoubleClick`:
        case `onDoubleClickCapture`:
        case `onMouseDown`:
        case `onMouseDownCapture`:
        case `onMouseMove`:
        case `onMouseMoveCapture`:
        case `onMouseUp`:
        case `onMouseUpCapture`:
        case `onMouseEnter`:
          (r = !r.disabled) || (e = e.type, r = e !== `button` && e !== `input` && e !== `select` && e !== `textarea`), e = !r;
          break a;
        default:
          e = !1;
      }
      if (e) return null;
      if (n && typeof n != `function`) throw Error(a(231, t, typeof n));
      return n;
    }
    var rn = !(typeof window > `u` || window.document === void 0 || window.document.createElement === void 0),
      an = !1;
    if (rn) try {
      var on = {};
      Object.defineProperty(on, "passive", {
        get: function () {
          an = !0;
        }
      }), window.addEventListener(`test`, on, on), window.removeEventListener(`test`, on, on);
    } catch {
      an = !1;
    }
    var sn = null,
      cn = null,
      ln = null;
    function un() {
      if (ln) return ln;
      var e,
        t = cn,
        n = t.length,
        r,
        i = `value` in sn ? sn.value : sn.textContent,
        a = i.length;
      for (e = 0; e < n && t[e] === i[e]; e++);
      var o = n - e;
      for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
      return ln = i.slice(e, 1 < r ? 1 - r : void 0);
    }
    function dn(e) {
      var t = e.keyCode;
      return `charCode` in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
    }
    function fn() {
      return !0;
    }
    function pn() {
      return !1;
    }
    function mn(e) {
      function t(t, n, r, i, a) {
        for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
        return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? fn : pn, this.isPropagationStopped = pn, this;
      }
      return h(t.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var e = this.nativeEvent;
          e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != `unknown` && (e.returnValue = !1), this.isDefaultPrevented = fn);
        },
        stopPropagation: function () {
          var e = this.nativeEvent;
          e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != `unknown` && (e.cancelBubble = !0), this.isPropagationStopped = fn);
        },
        persist: function () {},
        isPersistent: fn
      }), t;
    }
    var hn = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (e) {
          return e.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      },
      gn = mn(hn),
      _n = h({}, hn, {
        view: 0,
        detail: 0
      }),
      vn = mn(_n),
      yn,
      bn,
      xn,
      Sn = h({}, _n, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: Nn,
        button: 0,
        buttons: 0,
        relatedTarget: function (e) {
          return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
        },
        movementX: function (e) {
          return `movementX` in e ? e.movementX : (e !== xn && (xn && e.type === `mousemove` ? (yn = e.screenX - xn.screenX, bn = e.screenY - xn.screenY) : bn = yn = 0, xn = e), yn);
        },
        movementY: function (e) {
          return `movementY` in e ? e.movementY : bn;
        }
      }),
      Cn = mn(Sn),
      wn = mn(h({}, Sn, {
        dataTransfer: 0
      })),
      Tn = mn(h({}, _n, {
        relatedTarget: 0
      })),
      En = mn(h({}, hn, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      })),
      Dn = mn(h({}, hn, {
        clipboardData: function (e) {
          return `clipboardData` in e ? e.clipboardData : window.clipboardData;
        }
      })),
      On = mn(h({}, hn, {
        data: 0
      })),
      kn = {
        Esc: `Escape`,
        Spacebar: ` `,
        Left: `ArrowLeft`,
        Up: `ArrowUp`,
        Right: `ArrowRight`,
        Down: `ArrowDown`,
        Del: `Delete`,
        Win: `OS`,
        Menu: `ContextMenu`,
        Apps: `ContextMenu`,
        Scroll: `ScrollLock`,
        MozPrintableKey: `Unidentified`
      },
      An = {
        8: `Backspace`,
        9: `Tab`,
        12: `Clear`,
        13: `Enter`,
        16: `Shift`,
        17: `Control`,
        18: `Alt`,
        19: `Pause`,
        20: `CapsLock`,
        27: `Escape`,
        32: ` `,
        33: `PageUp`,
        34: `PageDown`,
        35: `End`,
        36: `Home`,
        37: `ArrowLeft`,
        38: `ArrowUp`,
        39: `ArrowRight`,
        40: `ArrowDown`,
        45: `Insert`,
        46: `Delete`,
        112: `F1`,
        113: `F2`,
        114: `F3`,
        115: `F4`,
        116: `F5`,
        117: `F6`,
        118: `F7`,
        119: `F8`,
        120: `F9`,
        121: `F10`,
        122: `F11`,
        123: `F12`,
        144: `NumLock`,
        145: `ScrollLock`,
        224: `Meta`
      },
      jn = {
        Alt: `altKey`,
        Control: `ctrlKey`,
        Meta: `metaKey`,
        Shift: `shiftKey`
      };
    function Mn(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : (e = jn[e]) ? !!t[e] : !1;
    }
    function Nn() {
      return Mn;
    }
    var Pn = mn(h({}, _n, {
        key: function (e) {
          if (e.key) {
            var t = kn[e.key] || e.key;
            if (t !== `Unidentified`) return t;
          }
          return e.type === `keypress` ? (e = dn(e), e === 13 ? `Enter` : String.fromCharCode(e)) : e.type === `keydown` || e.type === `keyup` ? An[e.keyCode] || `Unidentified` : ``;
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: Nn,
        charCode: function (e) {
          return e.type === `keypress` ? dn(e) : 0;
        },
        keyCode: function (e) {
          return e.type === `keydown` || e.type === `keyup` ? e.keyCode : 0;
        },
        which: function (e) {
          return e.type === `keypress` ? dn(e) : e.type === `keydown` || e.type === `keyup` ? e.keyCode : 0;
        }
      })),
      Fn = mn(h({}, Sn, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      })),
      In = mn(h({}, _n, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: Nn
      })),
      Ln = mn(h({}, hn, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      })),
      Rn = mn(h({}, Sn, {
        deltaX: function (e) {
          return `deltaX` in e ? e.deltaX : `wheelDeltaX` in e ? -e.wheelDeltaX : 0;
        },
        deltaY: function (e) {
          return `deltaY` in e ? e.deltaY : `wheelDeltaY` in e ? -e.wheelDeltaY : `wheelDelta` in e ? -e.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
      })),
      zn = mn(h({}, hn, {
        newState: 0,
        oldState: 0
      })),
      Bn = [9, 13, 27, 32],
      Vn = rn && `CompositionEvent` in window,
      Hn = null;
    rn && `documentMode` in document && (Hn = document.documentMode);
    var Un = rn && `TextEvent` in window && !Hn,
      Wn = rn && (!Vn || Hn && 8 < Hn && 11 >= Hn),
      Gn = ` `,
      Kn = !1;
    function qn(e, t) {
      switch (e) {
        case `keyup`:
          return Bn.indexOf(t.keyCode) !== -1;
        case `keydown`:
          return t.keyCode !== 229;
        case `keypress`:
        case `mousedown`:
        case `focusout`:
          return !0;
        default:
          return !1;
      }
    }
    function Jn(e) {
      return e = e.detail, typeof e == `object` && `data` in e ? e.data : null;
    }
    var Yn = !1;
    function Xn(e, t) {
      switch (e) {
        case `compositionend`:
          return Jn(t);
        case `keypress`:
          return t.which === 32 ? (Kn = !0, Gn) : null;
        case `textInput`:
          return e = t.data, e === Gn && Kn ? null : e;
        default:
          return null;
      }
    }
    function Zn(e, t) {
      if (Yn) return e === `compositionend` || !Vn && qn(e, t) ? (e = un(), ln = cn = sn = null, Yn = !1, e) : null;
      switch (e) {
        case `paste`:
          return null;
        case `keypress`:
          if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
            if (t.char && 1 < t.char.length) return t.char;
            if (t.which) return String.fromCharCode(t.which);
          }
          return null;
        case `compositionend`:
          return Wn && t.locale !== `ko` ? null : t.data;
        default:
          return null;
      }
    }
    var Qn = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function $n(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === `input` ? !!Qn[e.type] : t === `textarea`;
    }
    function er(e, t, n, r) {
      Zt ? Qt ? Qt.push(r) : Qt = [r] : Zt = r, t = jd(t, `onChange`), 0 < t.length && (n = new gn(`onChange`, `change`, null, n, r), e.push({
        event: n,
        listeners: t
      }));
    }
    var tr = null,
      nr = null;
    function rr(e) {
      Cd(e, 0);
    }
    function W(e) {
      if (At(ft(e))) return e;
    }
    function ir(e, t) {
      if (e === `change`) return t;
    }
    var ar = !1;
    if (rn) {
      var or;
      if (rn) {
        var sr = `oninput` in document;
        if (!sr) {
          var cr = document.createElement(`div`);
          cr.setAttribute(`oninput`, `return;`), sr = typeof cr.oninput == `function`;
        }
        or = sr;
      } else or = !1;
      ar = or && (!document.documentMode || 9 < document.documentMode);
    }
    function lr() {
      tr && (tr.detachEvent(`onpropertychange`, ur), nr = tr = null);
    }
    function ur(e) {
      if (e.propertyName === `value` && W(nr)) {
        var t = [];
        er(t, nr, e, Xt(e)), tn(rr, t);
      }
    }
    function dr(e, t, n) {
      e === `focusin` ? (lr(), tr = t, nr = n, tr.attachEvent(`onpropertychange`, ur)) : e === `focusout` && lr();
    }
    function fr(e) {
      if (e === `selectionchange` || e === `keyup` || e === `keydown`) return W(nr);
    }
    function pr(e, t) {
      if (e === `click`) return W(t);
    }
    function G(e, t) {
      if (e === `input` || e === `change`) return W(t);
    }
    function mr(e, t) {
      return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
    }
    var hr = typeof Object.is == `function` ? Object.is : mr;
    function gr(e, t) {
      if (hr(e, t)) return !0;
      if (typeof e != `object` || !e || typeof t != `object` || !t) return !1;
      var n = Object.keys(e),
        r = Object.keys(t);
      if (n.length !== r.length) return !1;
      for (r = 0; r < n.length; r++) {
        var i = n[r];
        if (!he.call(t, i) || !hr(e[i], t[i])) return !1;
      }
      return !0;
    }
    function _r(e) {
      for (; e && e.firstChild;) e = e.firstChild;
      return e;
    }
    function vr(e, t) {
      var n = _r(e);
      e = 0;
      for (var r; n;) {
        if (n.nodeType === 3) {
          if (r = e + n.textContent.length, e <= t && r >= t) return {
            node: n,
            offset: t - e
          };
          e = r;
        }
        a: {
          for (; n;) {
            if (n.nextSibling) {
              n = n.nextSibling;
              break a;
            }
            n = n.parentNode;
          }
          n = void 0;
        }
        n = _r(n);
      }
    }
    function yr(e, t) {
      return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? yr(e, t.parentNode) : `contains` in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
    }
    function br(e) {
      e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
      for (var t = jt(e.document); t instanceof e.HTMLIFrameElement;) {
        try {
          var n = typeof t.contentWindow.location.href == `string`;
        } catch {
          n = !1;
        }
        if (n) e = t.contentWindow;else break;
        t = jt(e.document);
      }
      return t;
    }
    function xr(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === `input` && (e.type === `text` || e.type === `search` || e.type === `tel` || e.type === `url` || e.type === `password`) || t === `textarea` || e.contentEditable === `true`);
    }
    var Sr = rn && `documentMode` in document && 11 >= document.documentMode,
      Cr = null,
      wr = null,
      Tr = null,
      Er = !1;
    function Dr(e, t, n) {
      var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
      Er || Cr == null || Cr !== jt(r) || (r = Cr, `selectionStart` in r && xr(r) ? r = {
        start: r.selectionStart,
        end: r.selectionEnd
      } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
        anchorNode: r.anchorNode,
        anchorOffset: r.anchorOffset,
        focusNode: r.focusNode,
        focusOffset: r.focusOffset
      }), Tr && gr(Tr, r) || (Tr = r, r = jd(wr, `onSelect`), 0 < r.length && (t = new gn(`onSelect`, `select`, null, t, n), e.push({
        event: t,
        listeners: r
      }), t.target = Cr)));
    }
    function Or(e, t) {
      var n = {};
      return n[e.toLowerCase()] = t.toLowerCase(), n[`Webkit` + e] = `webkit` + t, n[`Moz` + e] = `moz` + t, n;
    }
    var kr = {
        animationend: Or(`Animation`, `AnimationEnd`),
        animationiteration: Or(`Animation`, `AnimationIteration`),
        animationstart: Or(`Animation`, `AnimationStart`),
        transitionrun: Or(`Transition`, `TransitionRun`),
        transitionstart: Or(`Transition`, `TransitionStart`),
        transitioncancel: Or(`Transition`, `TransitionCancel`),
        transitionend: Or(`Transition`, `TransitionEnd`)
      },
      Ar = {},
      jr = {};
    rn && (jr = document.createElement(`div`).style, `AnimationEvent` in window || (delete kr.animationend.animation, delete kr.animationiteration.animation, delete kr.animationstart.animation), `TransitionEvent` in window || delete kr.transitionend.transition);
    function Mr(e) {
      if (Ar[e]) return Ar[e];
      if (!kr[e]) return e;
      var t = kr[e],
        n;
      for (n in t) if (t.hasOwnProperty(n) && n in jr) return Ar[e] = t[n];
      return e;
    }
    var Nr = Mr(`animationend`),
      Pr = Mr(`animationiteration`),
      Fr = Mr(`animationstart`),
      Ir = Mr(`transitionrun`),
      Lr = Mr(`transitionstart`),
      Rr = Mr(`transitioncancel`),
      zr = Mr(`transitionend`),
      Br = new Map(),
      Vr = `abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel`.split(` `);
    Vr.push(`scrollEnd`);
    function Hr(e, t) {
      Br.set(e, t), _t(t, [e]);
    }
    var Ur = typeof reportError == `function` ? reportError : function (e) {
        if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
          var t = new window.ErrorEvent(`error`, {
            bubbles: !0,
            cancelable: !0,
            message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
            error: e
          });
          if (!window.dispatchEvent(t)) return;
        } else if (typeof process == `object` && typeof process.emit == `function`) {
          process.emit(`uncaughtException`, e);
          return;
        }
        console.error(e);
      },
      Wr = [],
      Gr = 0,
      Kr = 0;
    function qr() {
      for (var e = Gr, t = Kr = Gr = 0; t < e;) {
        var n = Wr[t];
        Wr[t++] = null;
        var r = Wr[t];
        Wr[t++] = null;
        var i = Wr[t];
        Wr[t++] = null;
        var a = Wr[t];
        if (Wr[t++] = null, r !== null && i !== null) {
          var o = r.pending;
          o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
        }
        a !== 0 && Zr(n, i, a);
      }
    }
    function Jr(e, t, n, r) {
      Wr[Gr++] = e, Wr[Gr++] = t, Wr[Gr++] = n, Wr[Gr++] = r, Kr |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
    }
    function Yr(e, t, n, r) {
      return Jr(e, t, n, r), Qr(e);
    }
    function Xr(e, t) {
      return Jr(e, null, null, t), Qr(e);
    }
    function Zr(e, t, n) {
      e.lanes |= n;
      var r = e.alternate;
      r !== null && (r.lanes |= n);
      for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
      return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Me(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
    }
    function Qr(e) {
      if (50 < mu) throw mu = 0, hu = null, Error(a(185));
      for (var t = e.return; t !== null;) e = t, t = e.return;
      return e.tag === 3 ? e.stateNode : null;
    }
    var $r = {};
    function ei(e, t, n, r) {
      this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function ti(e, t, n, r) {
      return new ei(e, t, n, r);
    }
    function ni(e) {
      return e = e.prototype, !(!e || !e.isReactComponent);
    }
    function ri(e, t) {
      var n = e.alternate;
      return n === null ? (n = ti(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext
      }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
    }
    function ii(e, t) {
      e.flags &= 65011714;
      var n = e.alternate;
      return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext
      }), e;
    }
    function ai(e, t, n, r, i, o) {
      var s = 0;
      if (r = e, typeof e == `function`) ni(e) && (s = 1);else if (typeof e == `string`) s = Jf(e, n, H.current) ? 26 : e === `html` || e === `head` || e === `body` ? 27 : 5;else a: switch (e) {
        case k:
          return e = ti(31, n, t, i), e.elementType = k, e.lanes = o, e;
        case y:
          return oi(n.children, i, o, t);
        case b:
          s = 8, i |= 24;
          break;
        case x:
          return e = ti(12, n, t, i | 2), e.elementType = x, e.lanes = o, e;
        case T:
          return e = ti(13, n, t, i), e.elementType = T, e.lanes = o, e;
        case E:
          return e = ti(19, n, t, i), e.elementType = E, e.lanes = o, e;
        default:
          if (typeof e == `object` && e) switch (e.$$typeof) {
            case C:
              s = 10;
              break a;
            case S:
              s = 9;
              break a;
            case w:
              s = 11;
              break a;
            case D:
              s = 14;
              break a;
            case O:
              s = 16, r = null;
              break a;
          }
          s = 29, n = Error(a(130, e === null ? `null` : typeof e, ``)), r = null;
      }
      return t = ti(s, n, t, i), t.elementType = e, t.type = r, t.lanes = o, t;
    }
    function oi(e, t, n, r) {
      return e = ti(7, e, r, t), e.lanes = n, e;
    }
    function si(e, t, n) {
      return e = ti(6, e, null, t), e.lanes = n, e;
    }
    function ci(e) {
      var t = ti(18, null, null, 0);
      return t.stateNode = e, t;
    }
    function li(e, t, n) {
      return t = ti(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }
    var ui = new WeakMap();
    function di(e, t) {
      if (typeof e == `object` && e) {
        var n = ui.get(e);
        return n === void 0 ? (t = {
          value: e,
          source: t,
          stack: me(t)
        }, ui.set(e, t), t) : n;
      }
      return {
        value: e,
        source: t,
        stack: me(t)
      };
    }
    var fi = [],
      pi = 0,
      mi = null,
      hi = 0,
      gi = [],
      _i = 0,
      vi = null,
      yi = 1,
      bi = ``;
    function xi(e, t) {
      fi[pi++] = hi, fi[pi++] = mi, mi = e, hi = t;
    }
    function Si(e, t, n) {
      gi[_i++] = yi, gi[_i++] = bi, gi[_i++] = vi, vi = e;
      var r = yi;
      e = bi;
      var i = 32 - Me(r) - 1;
      r &= ~(1 << i), n += 1;
      var a = 32 - Me(t) + i;
      if (30 < a) {
        var o = i - i % 5;
        a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, yi = 1 << 32 - Me(t) + i | n << i | r, bi = a + e;
      } else yi = 1 << a | n << i | r, bi = e;
    }
    function Ci(e) {
      e.return !== null && (xi(e, 1), Si(e, 1, 0));
    }
    function wi(e) {
      for (; e === mi;) mi = fi[--pi], fi[pi] = null, hi = fi[--pi], fi[pi] = null;
      for (; e === vi;) vi = gi[--_i], gi[_i] = null, bi = gi[--_i], gi[_i] = null, yi = gi[--_i], gi[_i] = null;
    }
    function Ti(e, t) {
      gi[_i++] = yi, gi[_i++] = bi, gi[_i++] = vi, yi = t.id, bi = t.overflow, vi = e;
    }
    var Ei = null,
      Di = null,
      Oi = !1,
      ki = null,
      Ai = !1,
      ji = Error(a(519));
    function Mi(e) {
      throw Ri(di(Error(a(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? `text` : `HTML`, ``)), e)), ji;
    }
    function Ni(e) {
      var t = e.stateNode,
        n = e.type,
        r = e.memoizedProps;
      switch (t[tt] = e, t[nt] = r, n) {
        case `dialog`:
          wd(`cancel`, t), wd(`close`, t);
          break;
        case `iframe`:
        case `object`:
        case `embed`:
          wd(`load`, t);
          break;
        case `video`:
        case `audio`:
          for (n = 0; n < xd.length; n++) wd(xd[n], t);
          break;
        case `source`:
          wd(`error`, t);
          break;
        case `img`:
        case `image`:
        case `link`:
          wd(`error`, t), wd(`load`, t);
          break;
        case `details`:
          wd(`toggle`, t);
          break;
        case `input`:
          wd(`invalid`, t), Ft(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
          break;
        case `select`:
          wd(`invalid`, t);
          break;
        case `textarea`:
          wd(`invalid`, t), zt(t, r.value, r.defaultValue, r.children);
      }
      n = r.children, typeof n != `string` && typeof n != `number` && typeof n != `bigint` || t.textContent === `` + n || !0 === r.suppressHydrationWarning || Id(t.textContent, n) ? (r.popover != null && (wd(`beforetoggle`, t), wd(`toggle`, t)), r.onScroll != null && wd(`scroll`, t), r.onScrollEnd != null && wd(`scrollend`, t), r.onClick != null && (t.onclick = Jt), t = !0) : t = !1, t || Mi(e, !0);
    }
    function Pi(e) {
      for (Ei = e.return; Ei;) switch (Ei.tag) {
        case 5:
        case 31:
        case 13:
          Ai = !1;
          return;
        case 27:
        case 3:
          Ai = !0;
          return;
        default:
          Ei = Ei.return;
      }
    }
    function Fi(e) {
      if (e !== Ei) return !1;
      if (!Oi) return Pi(e), Oi = !0, !1;
      var t = e.tag,
        n;
      if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = n === `form` || n === `button` || Jd(e.type, e.memoizedProps)), n = !n), n && Di && Mi(e), Pi(e), t === 13) {
        if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(a(317));
        Di = hf(e);
      } else if (t === 31) {
        if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(a(317));
        Di = hf(e);
      } else t === 27 ? (t = Di, nf(e.type) ? (e = mf, mf = null, Di = e) : Di = t) : Di = Ei ? pf(e.stateNode.nextSibling) : null;
      return !0;
    }
    function Ii() {
      Di = Ei = null, Oi = !1;
    }
    function Li() {
      var e = ki;
      return e !== null && (eu === null ? eu = e : eu.push.apply(eu, e), ki = null), e;
    }
    function Ri(e) {
      ki === null ? ki = [e] : ki.push(e);
    }
    var zi = te(null),
      Bi = null,
      Vi = null;
    function Hi(e, t, n) {
      V(zi, t._currentValue), t._currentValue = n;
    }
    function Ui(e) {
      e._currentValue = zi.current, B(zi);
    }
    function Wi(e, t, n) {
      for (; e !== null;) {
        var r = e.alternate;
        if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
        e = e.return;
      }
    }
    function Gi(e, t, n, r) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null;) {
        var o = i.dependencies;
        if (o !== null) {
          var s = i.child;
          o = o.firstContext;
          a: for (; o !== null;) {
            var c = o;
            o = i;
            for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
              o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Wi(o.return, n, e), r || (s = null);
              break a;
            }
            o = c.next;
          }
        } else if (i.tag === 18) {
          if (s = i.return, s === null) throw Error(a(341));
          s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Wi(s, n, e), s = null;
        } else s = i.child;
        if (s !== null) s.return = i;else for (s = i; s !== null;) {
          if (s === e) {
            s = null;
            break;
          }
          if (i = s.sibling, i !== null) {
            i.return = s.return, s = i;
            break;
          }
          s = s.return;
        }
        i = s;
      }
    }
    function Ki(e, t, n, r) {
      e = null;
      for (var i = t, o = !1; i !== null;) {
        if (!o) {
          if (i.flags & 524288) o = !0;else if (i.flags & 262144) break;
        }
        if (i.tag === 10) {
          var s = i.alternate;
          if (s === null) throw Error(a(387));
          if (s = s.memoizedProps, s !== null) {
            var c = i.type;
            hr(i.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
          }
        } else if (i === ie.current) {
          if (s = i.alternate, s === null) throw Error(a(387));
          s.memoizedState.memoizedState !== i.memoizedState.memoizedState && (e === null ? e = [rp] : e.push(rp));
        }
        i = i.return;
      }
      e !== null && Gi(t, e, n, r), t.flags |= 262144;
    }
    function qi(e) {
      for (e = e.firstContext; e !== null;) {
        if (!hr(e.context._currentValue, e.memoizedValue)) return !0;
        e = e.next;
      }
      return !1;
    }
    function Ji(e) {
      Bi = e, Vi = null, e = e.dependencies, e !== null && (e.firstContext = null);
    }
    function Yi(e) {
      return Zi(Bi, e);
    }
    function Xi(e, t) {
      return Bi === null && Ji(e), Zi(e, t);
    }
    function Zi(e, t) {
      var n = t._currentValue;
      if (t = {
        context: t,
        memoizedValue: n,
        next: null
      }, Vi === null) {
        if (e === null) throw Error(a(308));
        Vi = t, e.dependencies = {
          lanes: 0,
          firstContext: t
        }, e.flags |= 524288;
      } else Vi = Vi.next = t;
      return n;
    }
    var Qi = typeof AbortController < `u` ? AbortController : function () {
        var e = [],
          t = this.signal = {
            aborted: !1,
            addEventListener: function (t, n) {
              e.push(n);
            }
          };
        this.abort = function () {
          t.aborted = !0, e.forEach(function (e) {
            return e();
          });
        };
      },
      $i = t.unstable_scheduleCallback,
      ea = t.unstable_NormalPriority,
      ta = {
        $$typeof: C,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0
      };
    function na() {
      return {
        controller: new Qi(),
        data: new Map(),
        refCount: 0
      };
    }
    function ra(e) {
      e.refCount--, e.refCount === 0 && $i(ea, function () {
        e.controller.abort();
      });
    }
    var ia = null,
      aa = 0,
      oa = 0,
      sa = null;
    function ca(e, t) {
      if (ia === null) {
        var n = ia = [];
        aa = 0, oa = hd(), sa = {
          status: `pending`,
          value: void 0,
          then: function (e) {
            n.push(e);
          }
        };
      }
      return aa++, t.then(la, la), t;
    }
    function la() {
      if (--aa === 0 && ia !== null) {
        sa !== null && (sa.status = `fulfilled`);
        var e = ia;
        ia = null, oa = 0, sa = null;
        for (var t = 0; t < e.length; t++) (0, e[t])();
      }
    }
    function ua(e, t) {
      var n = [],
        r = {
          status: `pending`,
          value: null,
          reason: null,
          then: function (e) {
            n.push(e);
          }
        };
      return e.then(function () {
        r.status = `fulfilled`, r.value = t;
        for (var e = 0; e < n.length; e++) (0, n[e])(t);
      }, function (e) {
        for (r.status = `rejected`, r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
      }), r;
    }
    var da = I.S;
    I.S = function (e, t) {
      ru = be(), typeof t == `object` && t && typeof t.then == `function` && ca(e, t), da !== null && da(e, t);
    };
    var fa = te(null);
    function pa() {
      var e = fa.current;
      return e === null ? Rl.pooledCache : e;
    }
    function ma(e, t) {
      t === null ? V(fa, fa.current) : V(fa, t.pool);
    }
    function ha() {
      var e = pa();
      return e === null ? null : {
        parent: ta._currentValue,
        pool: e
      };
    }
    var ga = Error(a(460)),
      _a = Error(a(474)),
      va = Error(a(542)),
      ya = {
        then: function () {}
      };
    function ba(e) {
      return e = e.status, e === `fulfilled` || e === `rejected`;
    }
    function xa(e, t, n) {
      switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(Jt, Jt), t = n), t.status) {
        case `fulfilled`:
          return t.value;
        case `rejected`:
          throw e = t.reason, Ta(e), e;
        default:
          if (typeof t.status == `string`) t.then(Jt, Jt);else {
            if (e = Rl, e !== null && 100 < e.shellSuspendCounter) throw Error(a(482));
            e = t, e.status = `pending`, e.then(function (e) {
              if (t.status === `pending`) {
                var n = t;
                n.status = `fulfilled`, n.value = e;
              }
            }, function (e) {
              if (t.status === `pending`) {
                var n = t;
                n.status = `rejected`, n.reason = e;
              }
            });
          }
          switch (t.status) {
            case `fulfilled`:
              return t.value;
            case `rejected`:
              throw e = t.reason, Ta(e), e;
          }
          throw Ca = t, ga;
      }
    }
    function Sa(e) {
      try {
        var t = e._init;
        return t(e._payload);
      } catch (e) {
        throw typeof e == `object` && e && typeof e.then == `function` ? (Ca = e, ga) : e;
      }
    }
    var Ca = null;
    function wa() {
      if (Ca === null) throw Error(a(459));
      var e = Ca;
      return Ca = null, e;
    }
    function Ta(e) {
      if (e === ga || e === va) throw Error(a(483));
    }
    var Ea = null,
      Da = 0;
    function Oa(e) {
      var t = Da;
      return Da += 1, Ea === null && (Ea = []), xa(Ea, e, t);
    }
    function ka(e, t) {
      t = t.props.ref, e.ref = t === void 0 ? null : t;
    }
    function Aa(e, t) {
      throw t.$$typeof === g ? Error(a(525)) : (e = Object.prototype.toString.call(t), Error(a(31, e === `[object Object]` ? `object with keys {` + Object.keys(t).join(`, `) + `}` : e)));
    }
    function ja(e) {
      function t(t, n) {
        if (e) {
          var r = t.deletions;
          r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
        }
      }
      function n(n, r) {
        if (!e) return null;
        for (; r !== null;) t(n, r), r = r.sibling;
        return null;
      }
      function r(e) {
        for (var t = new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
        return t;
      }
      function i(e, t) {
        return e = ri(e, t), e.index = 0, e.sibling = null, e;
      }
      function o(t, n, r) {
        return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
      }
      function s(t) {
        return e && t.alternate === null && (t.flags |= 67108866), t;
      }
      function c(e, t, n, r) {
        return t === null || t.tag !== 6 ? (t = si(n, e.mode, r), t.return = e, t) : (t = i(t, n), t.return = e, t);
      }
      function l(e, t, n, r) {
        var a = n.type;
        return a === y ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === a || typeof a == `object` && a && a.$$typeof === O && Sa(a) === t.type) ? (t = i(t, n.props), ka(t, n), t.return = e, t) : (t = ai(n.type, n.key, n.props, null, e.mode, r), ka(t, n), t.return = e, t);
      }
      function u(e, t, n, r) {
        return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = li(n, e.mode, r), t.return = e, t) : (t = i(t, n.children || []), t.return = e, t);
      }
      function d(e, t, n, r, a) {
        return t === null || t.tag !== 7 ? (t = oi(n, e.mode, r, a), t.return = e, t) : (t = i(t, n), t.return = e, t);
      }
      function f(e, t, n) {
        if (typeof t == `string` && t !== `` || typeof t == `number` || typeof t == `bigint`) return t = si(`` + t, e.mode, n), t.return = e, t;
        if (typeof t == `object` && t) {
          switch (t.$$typeof) {
            case _:
              return n = ai(t.type, t.key, t.props, null, e.mode, n), ka(n, t), n.return = e, n;
            case v:
              return t = li(t, e.mode, n), t.return = e, t;
            case O:
              return t = Sa(t), f(e, t, n);
          }
          if (F(t) || M(t)) return t = oi(t, e.mode, n, null), t.return = e, t;
          if (typeof t.then == `function`) return f(e, Oa(t), n);
          if (t.$$typeof === C) return f(e, Xi(e, t), n);
          Aa(e, t);
        }
        return null;
      }
      function p(e, t, n, r) {
        var i = t === null ? null : t.key;
        if (typeof n == `string` && n !== `` || typeof n == `number` || typeof n == `bigint`) return i === null ? c(e, t, `` + n, r) : null;
        if (typeof n == `object` && n) {
          switch (n.$$typeof) {
            case _:
              return n.key === i ? l(e, t, n, r) : null;
            case v:
              return n.key === i ? u(e, t, n, r) : null;
            case O:
              return n = Sa(n), p(e, t, n, r);
          }
          if (F(n) || M(n)) return i === null ? d(e, t, n, r, null) : null;
          if (typeof n.then == `function`) return p(e, t, Oa(n), r);
          if (n.$$typeof === C) return p(e, t, Xi(e, n), r);
          Aa(e, n);
        }
        return null;
      }
      function m(e, t, n, r, i) {
        if (typeof r == `string` && r !== `` || typeof r == `number` || typeof r == `bigint`) return e = e.get(n) || null, c(t, e, `` + r, i);
        if (typeof r == `object` && r) {
          switch (r.$$typeof) {
            case _:
              return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
            case v:
              return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
            case O:
              return r = Sa(r), m(e, t, n, r, i);
          }
          if (F(r) || M(r)) return e = e.get(n) || null, d(t, e, r, i, null);
          if (typeof r.then == `function`) return m(e, t, n, Oa(r), i);
          if (r.$$typeof === C) return m(e, t, n, Xi(t, r), i);
          Aa(t, r);
        }
        return null;
      }
      function h(i, a, s, c) {
        for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
          d.index > h ? (g = d, d = null) : g = d.sibling;
          var _ = p(i, d, s[h], c);
          if (_ === null) {
            d === null && (d = g);
            break;
          }
          e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
        }
        if (h === s.length) return n(i, d), Oi && xi(i, h), l;
        if (d === null) {
          for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
          return Oi && xi(i, h), l;
        }
        for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
        return e && d.forEach(function (e) {
          return t(i, e);
        }), Oi && xi(i, h), l;
      }
      function g(i, s, c, l) {
        if (c == null) throw Error(a(151));
        for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
          h.index > g ? (_ = h, h = null) : _ = h.sibling;
          var y = p(i, h, v.value, l);
          if (y === null) {
            h === null && (h = _);
            break;
          }
          e && h && y.alternate === null && t(i, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
        }
        if (v.done) return n(i, h), Oi && xi(i, g), u;
        if (h === null) {
          for (; !v.done; g++, v = c.next()) v = f(i, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
          return Oi && xi(i, g), u;
        }
        for (h = r(h); !v.done; g++, v = c.next()) v = m(h, i, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
        return e && h.forEach(function (e) {
          return t(i, e);
        }), Oi && xi(i, g), u;
      }
      function b(e, r, o, c) {
        if (typeof o == `object` && o && o.type === y && o.key === null && (o = o.props.children), typeof o == `object` && o) {
          switch (o.$$typeof) {
            case _:
              a: {
                for (var l = o.key; r !== null;) {
                  if (r.key === l) {
                    if (l = o.type, l === y) {
                      if (r.tag === 7) {
                        n(e, r.sibling), c = i(r, o.props.children), c.return = e, e = c;
                        break a;
                      }
                    } else if (r.elementType === l || typeof l == `object` && l && l.$$typeof === O && Sa(l) === r.type) {
                      n(e, r.sibling), c = i(r, o.props), ka(c, o), c.return = e, e = c;
                      break a;
                    }
                    n(e, r);
                    break;
                  }
                  t(e, r), r = r.sibling;
                }
                o.type === y ? (c = oi(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = ai(o.type, o.key, o.props, null, e.mode, c), ka(c, o), c.return = e, e = c);
              }
              return s(e);
            case v:
              a: {
                for (l = o.key; r !== null;) {
                  if (r.key === l) {
                    if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
                      n(e, r.sibling), c = i(r, o.children || []), c.return = e, e = c;
                      break a;
                    }
                    n(e, r);
                    break;
                  }
                  t(e, r), r = r.sibling;
                }
                c = li(o, e.mode, c), c.return = e, e = c;
              }
              return s(e);
            case O:
              return o = Sa(o), b(e, r, o, c);
          }
          if (F(o)) return h(e, r, o, c);
          if (M(o)) {
            if (l = M(o), typeof l != `function`) throw Error(a(150));
            return o = l.call(o), g(e, r, o, c);
          }
          if (typeof o.then == `function`) return b(e, r, Oa(o), c);
          if (o.$$typeof === C) return b(e, r, Xi(e, o), c);
          Aa(e, o);
        }
        return typeof o == `string` && o !== `` || typeof o == `number` || typeof o == `bigint` ? (o = `` + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = i(r, o), c.return = e, e = c) : (n(e, r), c = si(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
      }
      return function (e, t, n, r) {
        try {
          Da = 0;
          var i = b(e, t, n, r);
          return Ea = null, i;
        } catch (t) {
          if (t === ga || t === va) throw t;
          var a = ti(29, t, null, e.mode);
          return a.lanes = r, a.return = e, a;
        }
      };
    }
    var Ma = ja(!0),
      Na = ja(!1),
      Pa = !1;
    function Fa(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          lanes: 0,
          hiddenCallbacks: null
        },
        callbacks: null
      };
    }
    function Ia(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        callbacks: null
      });
    }
    function La(e) {
      return {
        lane: e,
        tag: 0,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Ra(e, t, n) {
      var r = e.updateQueue;
      if (r === null) return null;
      if (r = r.shared, Ll & 2) {
        var i = r.pending;
        return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Qr(e), Zr(e, null, n), t;
      }
      return Jr(e, r, t, n), Qr(e);
    }
    function za(e, t, n) {
      if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
        var r = t.lanes;
        r &= e.pendingLanes, n |= r, t.lanes = n, Je(e, n);
      }
    }
    function Ba(e, t) {
      var n = e.updateQueue,
        r = e.alternate;
      if (r !== null && (r = r.updateQueue, n === r)) {
        var i = null,
          a = null;
        if (n = n.firstBaseUpdate, n !== null) {
          do {
            var o = {
              lane: n.lane,
              tag: n.tag,
              payload: n.payload,
              callback: null,
              next: null
            };
            a === null ? i = a = o : a = a.next = o, n = n.next;
          } while (n !== null);
          a === null ? i = a = t : a = a.next = t;
        } else i = a = t;
        n = {
          baseState: r.baseState,
          firstBaseUpdate: i,
          lastBaseUpdate: a,
          shared: r.shared,
          callbacks: r.callbacks
        }, e.updateQueue = n;
        return;
      }
      e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
    }
    var Va = !1;
    function Ha() {
      if (Va) {
        var e = sa;
        if (e !== null) throw e;
      }
    }
    function Ua(e, t, n, r) {
      Va = !1;
      var i = e.updateQueue;
      Pa = !1;
      var a = i.firstBaseUpdate,
        o = i.lastBaseUpdate,
        s = i.shared.pending;
      if (s !== null) {
        i.shared.pending = null;
        var c = s,
          l = c.next;
        c.next = null, o === null ? a = l : o.next = l, o = c;
        var u = e.alternate;
        u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
      }
      if (a !== null) {
        var d = i.baseState;
        o = 0, u = l = c = null, s = a;
        do {
          var f = s.lane & -536870913,
            p = f !== s.lane;
          if (p ? (Bl & f) === f : (r & f) === f) {
            f !== 0 && f === oa && (Va = !0), u !== null && (u = u.next = {
              lane: 0,
              tag: s.tag,
              payload: s.payload,
              callback: null,
              next: null
            });
            a: {
              var m = e,
                g = s;
              f = t;
              var _ = n;
              switch (g.tag) {
                case 1:
                  if (m = g.payload, typeof m == `function`) {
                    d = m.call(_, d, f);
                    break a;
                  }
                  d = m;
                  break a;
                case 3:
                  m.flags = m.flags & -65537 | 128;
                case 0:
                  if (m = g.payload, f = typeof m == `function` ? m.call(_, d, f) : m, f == null) break a;
                  d = h({}, d, f);
                  break a;
                case 2:
                  Pa = !0;
              }
            }
            f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f));
          } else p = {
            lane: f,
            tag: s.tag,
            payload: s.payload,
            callback: s.callback,
            next: null
          }, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
          if (s = s.next, s === null) {
            if (s = i.shared.pending, s === null) break;
            p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
          }
        } while (1);
        u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Jl |= o, e.lanes = o, e.memoizedState = d;
      }
    }
    function K(e, t) {
      if (typeof e != `function`) throw Error(a(191, e));
      e.call(t);
    }
    function Wa(e, t) {
      var n = e.callbacks;
      if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) K(n[e], t);
    }
    var Ga = te(null),
      Ka = te(0);
    function qa(e, t) {
      e = Kl, V(Ka, e), V(Ga, t), Kl = e | t.baseLanes;
    }
    function Ja() {
      V(Ka, Kl), V(Ga, Ga.current);
    }
    function Ya() {
      Kl = Ka.current, B(Ga), B(Ka);
    }
    var Xa = te(null),
      Za = null;
    function Qa(e) {
      var t = e.alternate;
      V(ro, ro.current & 1), V(Xa, e), Za === null && (t === null || Ga.current !== null || t.memoizedState !== null) && (Za = e);
    }
    function $a(e) {
      V(ro, ro.current), V(Xa, e), Za === null && (Za = e);
    }
    function eo(e) {
      e.tag === 22 ? (V(ro, ro.current), V(Xa, e), Za === null && (Za = e)) : to(e);
    }
    function to() {
      V(ro, ro.current), V(Xa, Xa.current);
    }
    function no(e) {
      B(Xa), Za === e && (Za = null), B(ro);
    }
    var ro = te(0);
    function io(e) {
      for (var t = e; t !== null;) {
        if (t.tag === 13) {
          var n = t.memoizedState;
          if (n !== null && (n = n.dehydrated, n === null || uf(n) || df(n))) return t;
        } else if (t.tag === 19 && (t.memoizedProps.revealOrder === `forwards` || t.memoizedProps.revealOrder === `backwards` || t.memoizedProps.revealOrder === `unstable_legacy-backwards` || t.memoizedProps.revealOrder === `together`)) {
          if (t.flags & 128) return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;
        for (; t.sibling === null;) {
          if (t.return === null || t.return === e) return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var ao = 0,
      oo = null,
      so = null,
      co = null,
      lo = !1,
      uo = !1,
      fo = !1,
      po = 0,
      mo = 0,
      ho = null,
      go = 0;
    function _o() {
      throw Error(a(321));
    }
    function vo(e, t) {
      if (t === null) return !1;
      for (var n = 0; n < t.length && n < e.length; n++) if (!hr(e[n], t[n])) return !1;
      return !0;
    }
    function yo(e, t, n, r, i, a) {
      return ao = a, oo = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, I.H = e === null || e.memoizedState === null ? Is : Ls, fo = !1, a = n(r, i), fo = !1, uo && (a = xo(t, n, r, i)), bo(e), a;
    }
    function bo(e) {
      I.H = Fs;
      var t = so !== null && so.next !== null;
      if (ao = 0, co = so = oo = null, lo = !1, mo = 0, ho = null, t) throw Error(a(300));
      e === null || ec || (e = e.dependencies, e !== null && qi(e) && (ec = !0));
    }
    function xo(e, t, n, r) {
      oo = e;
      var i = 0;
      do {
        if (uo && (ho = null), mo = 0, uo = !1, 25 <= i) throw Error(a(301));
        if (i += 1, co = so = null, e.updateQueue != null) {
          var o = e.updateQueue;
          o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
        }
        I.H = Rs, o = t(n, r);
      } while (uo);
      return o;
    }
    function So() {
      var e = I.H,
        t = e.useState()[0];
      return t = typeof t.then == `function` ? ko(t) : t, e = e.useState()[0], (so === null ? null : so.memoizedState) !== e && (oo.flags |= 1024), t;
    }
    function Co() {
      var e = po !== 0;
      return po = 0, e;
    }
    function wo(e, t, n) {
      t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
    }
    function To(e) {
      if (lo) {
        for (e = e.memoizedState; e !== null;) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        lo = !1;
      }
      ao = 0, co = so = oo = null, uo = !1, mo = po = 0, ho = null;
    }
    function Eo() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return co === null ? oo.memoizedState = co = e : co = co.next = e, co;
    }
    function Do() {
      if (so === null) {
        var e = oo.alternate;
        e = e === null ? null : e.memoizedState;
      } else e = so.next;
      var t = co === null ? oo.memoizedState : co.next;
      if (t !== null) co = t, so = e;else {
        if (e === null) throw oo.alternate === null ? Error(a(467)) : Error(a(310));
        so = e, e = {
          memoizedState: so.memoizedState,
          baseState: so.baseState,
          baseQueue: so.baseQueue,
          queue: so.queue,
          next: null
        }, co === null ? oo.memoizedState = co = e : co = co.next = e;
      }
      return co;
    }
    function Oo() {
      return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
      };
    }
    function ko(e) {
      var t = mo;
      return mo += 1, ho === null && (ho = []), e = xa(ho, e, t), t = oo, (co === null ? t.memoizedState : co.next) === null && (t = t.alternate, I.H = t === null || t.memoizedState === null ? Is : Ls), e;
    }
    function Ao(e) {
      if (typeof e == `object` && e) {
        if (typeof e.then == `function`) return ko(e);
        if (e.$$typeof === C) return Yi(e);
      }
      throw Error(a(438, String(e)));
    }
    function jo(e) {
      var t = null,
        n = oo.updateQueue;
      if (n !== null && (t = n.memoCache), t == null) {
        var r = oo.alternate;
        r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
          data: r.data.map(function (e) {
            return e.slice();
          }),
          index: 0
        })));
      }
      if (t ??= {
        data: [],
        index: 0
      }, n === null && (n = Oo(), oo.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = A;
      return t.index++, n;
    }
    function Mo(e, t) {
      return typeof t == `function` ? t(e) : t;
    }
    function No(e) {
      return Po(Do(), so, e);
    }
    function Po(e, t, n) {
      var r = e.queue;
      if (r === null) throw Error(a(311));
      r.lastRenderedReducer = n;
      var i = e.baseQueue,
        o = r.pending;
      if (o !== null) {
        if (i !== null) {
          var s = i.next;
          i.next = o.next, o.next = s;
        }
        t.baseQueue = i = o, r.pending = null;
      }
      if (o = e.baseState, i === null) e.memoizedState = o;else {
        t = i.next;
        var c = s = null,
          l = null,
          u = t,
          d = !1;
        do {
          var f = u.lane & -536870913;
          if (f === u.lane ? (ao & f) === f : (Bl & f) === f) {
            var p = u.revertLane;
            if (p === 0) l !== null && (l = l.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: u.action,
              hasEagerState: u.hasEagerState,
              eagerState: u.eagerState,
              next: null
            }), f === oa && (d = !0);else if ((ao & p) === p) {
              u = u.next, p === oa && (d = !0);
              continue;
            } else f = {
              lane: 0,
              revertLane: u.revertLane,
              gesture: null,
              action: u.action,
              hasEagerState: u.hasEagerState,
              eagerState: u.eagerState,
              next: null
            }, l === null ? (c = l = f, s = o) : l = l.next = f, oo.lanes |= p, Jl |= p;
            f = u.action, fo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
          } else p = {
            lane: f,
            revertLane: u.revertLane,
            gesture: u.gesture,
            action: u.action,
            hasEagerState: u.hasEagerState,
            eagerState: u.eagerState,
            next: null
          }, l === null ? (c = l = p, s = o) : l = l.next = p, oo.lanes |= f, Jl |= f;
          u = u.next;
        } while (u !== null && u !== t);
        if (l === null ? s = o : l.next = c, !hr(o, e.memoizedState) && (ec = !0, d && (n = sa, n !== null))) throw n;
        e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
      }
      return i === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
    }
    function Fo(e) {
      var t = Do(),
        n = t.queue;
      if (n === null) throw Error(a(311));
      n.lastRenderedReducer = e;
      var r = n.dispatch,
        i = n.pending,
        o = t.memoizedState;
      if (i !== null) {
        n.pending = null;
        var s = i = i.next;
        do o = e(o, s.action), s = s.next; while (s !== i);
        hr(o, t.memoizedState) || (ec = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
      }
      return [o, r];
    }
    function Io(e, t, n) {
      var r = oo,
        i = Do(),
        o = Oi;
      if (o) {
        if (n === void 0) throw Error(a(407));
        n = n();
      } else n = t();
      var s = !hr((so || i).memoizedState, n);
      if (s && (i.memoizedState = n, ec = !0), i = i.queue, ss(zo.bind(null, r, i, e), [e]), i.getSnapshot !== t || s || co !== null && co.memoizedState.tag & 1) {
        if (r.flags |= 2048, ns(9, {
          destroy: void 0
        }, Ro.bind(null, r, i, n, t), null), Rl === null) throw Error(a(349));
        o || ao & 127 || Lo(r, t, n);
      }
      return n;
    }
    function Lo(e, t, n) {
      e.flags |= 16384, e = {
        getSnapshot: t,
        value: n
      }, t = oo.updateQueue, t === null ? (t = Oo(), oo.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
    }
    function Ro(e, t, n, r) {
      t.value = n, t.getSnapshot = r, Bo(t) && Vo(e);
    }
    function zo(e, t, n) {
      return n(function () {
        Bo(t) && Vo(e);
      });
    }
    function Bo(e) {
      var t = e.getSnapshot;
      e = e.value;
      try {
        var n = t();
        return !hr(e, n);
      } catch {
        return !0;
      }
    }
    function Vo(e) {
      var t = Xr(e, 2);
      t !== null && vu(t, e, 2);
    }
    function Ho(e) {
      var t = Eo();
      if (typeof e == `function`) {
        var n = e;
        if (e = n(), fo) {
          je(!0);
          try {
            n();
          } finally {
            je(!1);
          }
        }
      }
      return t.memoizedState = t.baseState = e, t.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Mo,
        lastRenderedState: e
      }, t;
    }
    function Uo(e, t, n, r) {
      return e.baseState = n, Po(e, so, typeof r == `function` ? r : Mo);
    }
    function Wo(e, t, n, r, i) {
      if (Ms(e)) throw Error(a(485));
      if (e = t.action, e !== null) {
        var o = {
          payload: i,
          action: e,
          next: null,
          isTransition: !0,
          status: `pending`,
          value: null,
          reason: null,
          listeners: [],
          then: function (e) {
            o.listeners.push(e);
          }
        };
        I.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Go(t, o)) : (o.next = n.next, t.pending = n.next = o);
      }
    }
    function Go(e, t) {
      var n = t.action,
        r = t.payload,
        i = e.state;
      if (t.isTransition) {
        var a = I.T,
          o = {};
        I.T = o;
        try {
          var s = n(i, r),
            c = I.S;
          c !== null && c(o, s), Ko(e, t, s);
        } catch (n) {
          Jo(e, t, n);
        } finally {
          a !== null && o.types !== null && (a.types = o.types), I.T = a;
        }
      } else try {
        a = n(i, r), Ko(e, t, a);
      } catch (n) {
        Jo(e, t, n);
      }
    }
    function Ko(e, t, n) {
      typeof n == `object` && n && typeof n.then == `function` ? n.then(function (n) {
        qo(e, t, n);
      }, function (n) {
        return Jo(e, t, n);
      }) : qo(e, t, n);
    }
    function qo(e, t, n) {
      t.status = `fulfilled`, t.value = n, Yo(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Go(e, n)));
    }
    function Jo(e, t, n) {
      var r = e.pending;
      if (e.pending = null, r !== null) {
        r = r.next;
        do t.status = `rejected`, t.reason = n, Yo(t), t = t.next; while (t !== r);
      }
      e.action = null;
    }
    function Yo(e) {
      e = e.listeners;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
    function Xo(e, t) {
      return t;
    }
    function Zo(e, t) {
      if (Oi) {
        var n = Rl.formState;
        if (n !== null) {
          a: {
            var r = oo;
            if (Oi) {
              if (Di) {
                b: {
                  for (var i = Di, a = Ai; i.nodeType !== 8;) {
                    if (!a) {
                      i = null;
                      break b;
                    }
                    if (i = pf(i.nextSibling), i === null) {
                      i = null;
                      break b;
                    }
                  }
                  a = i.data, i = a === `F!` || a === `F` ? i : null;
                }
                if (i) {
                  Di = pf(i.nextSibling), r = i.data === `F!`;
                  break a;
                }
              }
              Mi(r);
            }
            r = !1;
          }
          r && (t = n[0]);
        }
      }
      return n = Eo(), n.memoizedState = n.baseState = t, r = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Xo,
        lastRenderedState: t
      }, n.queue = r, n = ks.bind(null, oo, r), r.dispatch = n, r = Ho(!1), a = js.bind(null, oo, !1, r.queue), r = Eo(), i = {
        state: t,
        dispatch: null,
        action: e,
        pending: null
      }, r.queue = i, n = Wo.bind(null, oo, i, a, n), i.dispatch = n, r.memoizedState = e, [t, n, !1];
    }
    function Qo(e) {
      return $o(Do(), so, e);
    }
    function $o(e, t, n) {
      if (t = Po(e, t, Xo)[0], e = No(Mo)[0], typeof t == `object` && t && typeof t.then == `function`) try {
        var r = ko(t);
      } catch (e) {
        throw e === ga ? va : e;
      } else r = t;
      t = Do();
      var i = t.queue,
        a = i.dispatch;
      return n !== t.memoizedState && (oo.flags |= 2048, ns(9, {
        destroy: void 0
      }, es.bind(null, i, n), null)), [r, a, e];
    }
    function es(e, t) {
      e.action = t;
    }
    function ts(e) {
      var t = Do(),
        n = so;
      if (n !== null) return $o(t, n, e);
      Do(), t = t.memoizedState, n = Do();
      var r = n.queue.dispatch;
      return n.memoizedState = e, [t, r, !1];
    }
    function ns(e, t, n, r) {
      return e = {
        tag: e,
        create: n,
        deps: r,
        inst: t,
        next: null
      }, t = oo.updateQueue, t === null && (t = Oo(), oo.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
    }
    function rs() {
      return Do().memoizedState;
    }
    function is(e, t, n, r) {
      var i = Eo();
      oo.flags |= e, i.memoizedState = ns(1 | t, {
        destroy: void 0
      }, n, r === void 0 ? null : r);
    }
    function as(e, t, n, r) {
      var i = Do();
      r = r === void 0 ? null : r;
      var a = i.memoizedState.inst;
      so !== null && r !== null && vo(r, so.memoizedState.deps) ? i.memoizedState = ns(t, a, n, r) : (oo.flags |= e, i.memoizedState = ns(1 | t, a, n, r));
    }
    function os(e, t) {
      is(8390656, 8, e, t);
    }
    function ss(e, t) {
      as(2048, 8, e, t);
    }
    function cs(e) {
      oo.flags |= 4;
      var t = oo.updateQueue;
      if (t === null) t = Oo(), oo.updateQueue = t, t.events = [e];else {
        var n = t.events;
        n === null ? t.events = [e] : n.push(e);
      }
    }
    function ls(e) {
      var t = Do().memoizedState;
      return cs({
        ref: t,
        nextImpl: e
      }), function () {
        if (Ll & 2) throw Error(a(440));
        return t.impl.apply(void 0, arguments);
      };
    }
    function us(e, t) {
      return as(4, 2, e, t);
    }
    function ds(e, t) {
      return as(4, 4, e, t);
    }
    function fs(e, t) {
      if (typeof t == `function`) {
        e = e();
        var n = t(e);
        return function () {
          typeof n == `function` ? n() : t(null);
        };
      }
      if (t != null) return e = e(), t.current = e, function () {
        t.current = null;
      };
    }
    function ps(e, t, n) {
      n = n == null ? null : n.concat([e]), as(4, 4, fs.bind(null, t, e), n);
    }
    function ms() {}
    function hs(e, t) {
      var n = Do();
      t = t === void 0 ? null : t;
      var r = n.memoizedState;
      return t !== null && vo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
    }
    function gs(e, t) {
      var n = Do();
      t = t === void 0 ? null : t;
      var r = n.memoizedState;
      if (t !== null && vo(t, r[1])) return r[0];
      if (r = e(), fo) {
        je(!0);
        try {
          e();
        } finally {
          je(!1);
        }
      }
      return n.memoizedState = [r, t], r;
    }
    function _s(e, t, n) {
      return n === void 0 || ao & 1073741824 && !(Bl & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = _u(), oo.lanes |= e, Jl |= e, n);
    }
    function vs(e, t, n, r) {
      return hr(n, t) ? n : Ga.current === null ? !(ao & 42) || ao & 1073741824 && !(Bl & 261930) ? (ec = !0, e.memoizedState = n) : (e = _u(), oo.lanes |= e, Jl |= e, t) : (e = _s(e, n, r), hr(e, t) || (ec = !0), e);
    }
    function ys(e, t, n, r, i) {
      var a = L.p;
      L.p = a !== 0 && 8 > a ? a : 8;
      var o = I.T,
        s = {};
      I.T = s, js(e, !1, t, n);
      try {
        var c = i(),
          l = I.S;
        l !== null && l(s, c), typeof c == `object` && c && typeof c.then == `function` ? As(e, t, ua(c, r), gu(e)) : As(e, t, r, gu(e));
      } catch (n) {
        As(e, t, {
          then: function () {},
          status: `rejected`,
          reason: n
        }, gu());
      } finally {
        L.p = a, o !== null && s.types !== null && (o.types = s.types), I.T = o;
      }
    }
    function bs() {}
    function xs(e, t, n, r) {
      if (e.tag !== 5) throw Error(a(476));
      var i = Ss(e).queue;
      ys(e, i, t, R, n === null ? bs : function () {
        return Cs(e), n(r);
      });
    }
    function Ss(e) {
      var t = e.memoizedState;
      if (t !== null) return t;
      t = {
        memoizedState: R,
        baseState: R,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Mo,
          lastRenderedState: R
        },
        next: null
      };
      var n = {};
      return t.next = {
        memoizedState: n,
        baseState: n,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Mo,
          lastRenderedState: n
        },
        next: null
      }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
    }
    function Cs(e) {
      var t = Ss(e);
      t.next === null && (t = e.alternate.memoizedState), As(e, t.next.queue, {}, gu());
    }
    function ws() {
      return Yi(rp);
    }
    function Ts() {
      return Do().memoizedState;
    }
    function Es() {
      return Do().memoizedState;
    }
    function Ds(e) {
      for (var t = e.return; t !== null;) {
        switch (t.tag) {
          case 24:
          case 3:
            var n = gu();
            e = La(n);
            var r = Ra(t, e, n);
            r !== null && (vu(r, t, n), za(r, t, n)), t = {
              cache: na()
            }, e.payload = t;
            return;
        }
        t = t.return;
      }
    }
    function Os(e, t, n) {
      var r = gu();
      n = {
        lane: r,
        revertLane: 0,
        gesture: null,
        action: n,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Ms(e) ? Ns(t, n) : (n = Yr(e, t, n, r), n !== null && (vu(n, e, r), Ps(n, t, r)));
    }
    function ks(e, t, n) {
      As(e, t, n, gu());
    }
    function As(e, t, n, r) {
      var i = {
        lane: r,
        revertLane: 0,
        gesture: null,
        action: n,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Ms(e)) Ns(t, i);else {
        var a = e.alternate;
        if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
          var o = t.lastRenderedState,
            s = a(o, n);
          if (i.hasEagerState = !0, i.eagerState = s, hr(s, o)) return Jr(e, t, i, 0), Rl === null && qr(), !1;
        } catch {}
        if (n = Yr(e, t, i, r), n !== null) return vu(n, e, r), Ps(n, t, r), !0;
      }
      return !1;
    }
    function js(e, t, n, r) {
      if (r = {
        lane: 2,
        revertLane: hd(),
        gesture: null,
        action: r,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Ms(e)) {
        if (t) throw Error(a(479));
      } else t = Yr(e, n, r, 2), t !== null && vu(t, e, 2);
    }
    function Ms(e) {
      var t = e.alternate;
      return e === oo || t !== null && t === oo;
    }
    function Ns(e, t) {
      uo = lo = !0;
      var n = e.pending;
      n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
    }
    function Ps(e, t, n) {
      if (n & 4194048) {
        var r = t.lanes;
        r &= e.pendingLanes, n |= r, t.lanes = n, Je(e, n);
      }
    }
    var Fs = {
      readContext: Yi,
      use: Ao,
      useCallback: _o,
      useContext: _o,
      useEffect: _o,
      useImperativeHandle: _o,
      useLayoutEffect: _o,
      useInsertionEffect: _o,
      useMemo: _o,
      useReducer: _o,
      useRef: _o,
      useState: _o,
      useDebugValue: _o,
      useDeferredValue: _o,
      useTransition: _o,
      useSyncExternalStore: _o,
      useId: _o,
      useHostTransitionStatus: _o,
      useFormState: _o,
      useActionState: _o,
      useOptimistic: _o,
      useMemoCache: _o,
      useCacheRefresh: _o
    };
    Fs.useEffectEvent = _o;
    var Is = {
        readContext: Yi,
        use: Ao,
        useCallback: function (e, t) {
          return Eo().memoizedState = [e, t === void 0 ? null : t], e;
        },
        useContext: Yi,
        useEffect: os,
        useImperativeHandle: function (e, t, n) {
          n = n == null ? null : n.concat([e]), is(4194308, 4, fs.bind(null, t, e), n);
        },
        useLayoutEffect: function (e, t) {
          return is(4194308, 4, e, t);
        },
        useInsertionEffect: function (e, t) {
          is(4, 2, e, t);
        },
        useMemo: function (e, t) {
          var n = Eo();
          t = t === void 0 ? null : t;
          var r = e();
          if (fo) {
            je(!0);
            try {
              e();
            } finally {
              je(!1);
            }
          }
          return n.memoizedState = [r, t], r;
        },
        useReducer: function (e, t, n) {
          var r = Eo();
          if (n !== void 0) {
            var i = n(t);
            if (fo) {
              je(!0);
              try {
                n(t);
              } finally {
                je(!1);
              }
            }
          } else i = t;
          return r.memoizedState = r.baseState = i, e = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: e,
            lastRenderedState: i
          }, r.queue = e, e = e.dispatch = Os.bind(null, oo, e), [r.memoizedState, e];
        },
        useRef: function (e) {
          var t = Eo();
          return e = {
            current: e
          }, t.memoizedState = e;
        },
        useState: function (e) {
          e = Ho(e);
          var t = e.queue,
            n = ks.bind(null, oo, t);
          return t.dispatch = n, [e.memoizedState, n];
        },
        useDebugValue: ms,
        useDeferredValue: function (e, t) {
          return _s(Eo(), e, t);
        },
        useTransition: function () {
          var e = Ho(!1);
          return e = ys.bind(null, oo, e.queue, !0, !1), Eo().memoizedState = e, [!1, e];
        },
        useSyncExternalStore: function (e, t, n) {
          var r = oo,
            i = Eo();
          if (Oi) {
            if (n === void 0) throw Error(a(407));
            n = n();
          } else {
            if (n = t(), Rl === null) throw Error(a(349));
            Bl & 127 || Lo(r, t, n);
          }
          i.memoizedState = n;
          var o = {
            value: n,
            getSnapshot: t
          };
          return i.queue = o, os(zo.bind(null, r, o, e), [e]), r.flags |= 2048, ns(9, {
            destroy: void 0
          }, Ro.bind(null, r, o, n, t), null), n;
        },
        useId: function () {
          var e = Eo(),
            t = Rl.identifierPrefix;
          if (Oi) {
            var n = bi,
              r = yi;
            n = (r & ~(1 << 32 - Me(r) - 1)).toString(32) + n, t = `_` + t + `R_` + n, n = po++, 0 < n && (t += `H` + n.toString(32)), t += `_`;
          } else n = go++, t = `_` + t + `r_` + n.toString(32) + `_`;
          return e.memoizedState = t;
        },
        useHostTransitionStatus: ws,
        useFormState: Zo,
        useActionState: Zo,
        useOptimistic: function (e) {
          var t = Eo();
          t.memoizedState = t.baseState = e;
          var n = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
          };
          return t.queue = n, t = js.bind(null, oo, !0, n), n.dispatch = t, [e, t];
        },
        useMemoCache: jo,
        useCacheRefresh: function () {
          return Eo().memoizedState = Ds.bind(null, oo);
        },
        useEffectEvent: function (e) {
          var t = Eo(),
            n = {
              impl: e
            };
          return t.memoizedState = n, function () {
            if (Ll & 2) throw Error(a(440));
            return n.impl.apply(void 0, arguments);
          };
        }
      },
      Ls = {
        readContext: Yi,
        use: Ao,
        useCallback: hs,
        useContext: Yi,
        useEffect: ss,
        useImperativeHandle: ps,
        useInsertionEffect: us,
        useLayoutEffect: ds,
        useMemo: gs,
        useReducer: No,
        useRef: rs,
        useState: function () {
          return No(Mo);
        },
        useDebugValue: ms,
        useDeferredValue: function (e, t) {
          return vs(Do(), so.memoizedState, e, t);
        },
        useTransition: function () {
          var e = No(Mo)[0],
            t = Do().memoizedState;
          return [typeof e == `boolean` ? e : ko(e), t];
        },
        useSyncExternalStore: Io,
        useId: Ts,
        useHostTransitionStatus: ws,
        useFormState: Qo,
        useActionState: Qo,
        useOptimistic: function (e, t) {
          return Uo(Do(), so, e, t);
        },
        useMemoCache: jo,
        useCacheRefresh: Es
      };
    Ls.useEffectEvent = ls;
    var Rs = {
      readContext: Yi,
      use: Ao,
      useCallback: hs,
      useContext: Yi,
      useEffect: ss,
      useImperativeHandle: ps,
      useInsertionEffect: us,
      useLayoutEffect: ds,
      useMemo: gs,
      useReducer: Fo,
      useRef: rs,
      useState: function () {
        return Fo(Mo);
      },
      useDebugValue: ms,
      useDeferredValue: function (e, t) {
        var n = Do();
        return so === null ? _s(n, e, t) : vs(n, so.memoizedState, e, t);
      },
      useTransition: function () {
        var e = Fo(Mo)[0],
          t = Do().memoizedState;
        return [typeof e == `boolean` ? e : ko(e), t];
      },
      useSyncExternalStore: Io,
      useId: Ts,
      useHostTransitionStatus: ws,
      useFormState: ts,
      useActionState: ts,
      useOptimistic: function (e, t) {
        var n = Do();
        return so === null ? (n.baseState = e, [e, n.queue.dispatch]) : Uo(n, so, e, t);
      },
      useMemoCache: jo,
      useCacheRefresh: Es
    };
    Rs.useEffectEvent = ls;
    function zs(e, t, n, r) {
      t = e.memoizedState, n = n(r, t), n = n == null ? t : h({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
    }
    var Bs = {
      enqueueSetState: function (e, t, n) {
        e = e._reactInternals;
        var r = gu(),
          i = La(r);
        i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (vu(t, e, r), za(t, e, r));
      },
      enqueueReplaceState: function (e, t, n) {
        e = e._reactInternals;
        var r = gu(),
          i = La(r);
        i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (vu(t, e, r), za(t, e, r));
      },
      enqueueForceUpdate: function (e, t) {
        e = e._reactInternals;
        var n = gu(),
          r = La(n);
        r.tag = 2, t != null && (r.callback = t), t = Ra(e, r, n), t !== null && (vu(t, e, n), za(t, e, n));
      }
    };
    function Vs(e, t, n, r, i, a, o) {
      return e = e.stateNode, typeof e.shouldComponentUpdate == `function` ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !gr(n, r) || !gr(i, a) : !0;
    }
    function Hs(e, t, n, r) {
      e = t.state, typeof t.componentWillReceiveProps == `function` && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == `function` && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Bs.enqueueReplaceState(t, t.state, null);
    }
    function Us(e, t) {
      var n = t;
      if (`ref` in t) for (var r in n = {}, t) r !== `ref` && (n[r] = t[r]);
      if (e = e.defaultProps) for (var i in n === t && (n = h({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
      return n;
    }
    function Ws(e) {
      Ur(e);
    }
    function Gs(e) {
      console.error(e);
    }
    function Ks(e) {
      Ur(e);
    }
    function qs(e, t) {
      try {
        var n = e.onUncaughtError;
        n(t.value, {
          componentStack: t.stack
        });
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }
    function Js(e, t, n) {
      try {
        var r = e.onCaughtError;
        r(n.value, {
          componentStack: n.stack,
          errorBoundary: t.tag === 1 ? t.stateNode : null
        });
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }
    function Ys(e, t, n) {
      return n = La(n), n.tag = 3, n.payload = {
        element: null
      }, n.callback = function () {
        qs(e, t);
      }, n;
    }
    function Xs(e) {
      return e = La(e), e.tag = 3, e;
    }
    function Zs(e, t, n, r) {
      var i = n.type.getDerivedStateFromError;
      if (typeof i == `function`) {
        var a = r.value;
        e.payload = function () {
          return i(a);
        }, e.callback = function () {
          Js(t, n, r);
        };
      }
      var o = n.stateNode;
      o !== null && typeof o.componentDidCatch == `function` && (e.callback = function () {
        Js(t, n, r), typeof i != `function` && (ou === null ? ou = new Set([this]) : ou.add(this));
        var e = r.stack;
        this.componentDidCatch(r.value, {
          componentStack: e === null ? `` : e
        });
      });
    }
    function Qs(e, t, n, r, i) {
      if (n.flags |= 32768, typeof r == `object` && r && typeof r.then == `function`) {
        if (t = n.alternate, t !== null && Ki(t, n, i, !0), n = Xa.current, n !== null) {
          switch (n.tag) {
            case 31:
            case 13:
              return Za === null ? Au() : n.alternate === null && ql === 0 && (ql = 3), n.flags &= -257, n.flags |= 65536, n.lanes = i, r === ya ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Yu(e, r, i)), !1;
            case 22:
              return n.flags |= 65536, r === ya ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
                transitions: null,
                markerInstances: null,
                retryQueue: new Set([r])
              }, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Yu(e, r, i)), !1;
          }
          throw Error(a(435, n.tag));
        }
        return Yu(e, r, i), Au(), !1;
      }
      if (Oi) return t = Xa.current, t === null ? (r !== ji && (t = Error(a(423), {
        cause: r
      }), Ri(di(t, n))), e = e.current.alternate, e.flags |= 65536, i &= -i, e.lanes |= i, r = di(r, n), i = Ys(e.stateNode, r, i), Ba(e, i), ql !== 4 && (ql = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = i, r !== ji && (e = Error(a(422), {
        cause: r
      }), Ri(di(e, n)))), !1;
      var o = Error(a(520), {
        cause: r
      });
      if (o = di(o, n), $l === null ? $l = [o] : $l.push(o), ql !== 4 && (ql = 2), t === null) return !0;
      r = di(r, n), n = t;
      do {
        switch (n.tag) {
          case 3:
            return n.flags |= 65536, e = i & -i, n.lanes |= e, e = Ys(n.stateNode, r, e), Ba(n, e), !1;
          case 1:
            if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == `function` || o !== null && typeof o.componentDidCatch == `function` && (ou === null || !ou.has(o)))) return n.flags |= 65536, i &= -i, n.lanes |= i, i = Xs(i), Zs(i, e, n, r), Ba(n, i), !1;
        }
        n = n.return;
      } while (n !== null);
      return !1;
    }
    var $s = Error(a(461)),
      ec = !1;
    function tc(e, t, n, r) {
      t.child = e === null ? Na(t, null, n, r) : Ma(t, e.child, n, r);
    }
    function nc(e, t, n, r, i) {
      n = n.render;
      var a = t.ref;
      if (`ref` in r) {
        var o = {};
        for (var s in r) s !== `ref` && (o[s] = r[s]);
      } else o = r;
      return Ji(t), r = yo(e, t, n, o, a, i), s = Co(), e !== null && !ec ? (wo(e, t, i), Ec(e, t, i)) : (Oi && s && Ci(t), t.flags |= 1, tc(e, t, r, i), t.child);
    }
    function rc(e, t, n, r, i) {
      if (e === null) {
        var a = n.type;
        return typeof a == `function` && !ni(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, ic(e, t, a, r, i)) : (e = ai(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
      }
      if (a = e.child, !Dc(e, i)) {
        var o = a.memoizedProps;
        if (n = n.compare, n = n === null ? gr : n, n(o, r) && e.ref === t.ref) return Ec(e, t, i);
      }
      return t.flags |= 1, e = ri(a, r), e.ref = t.ref, e.return = t, t.child = e;
    }
    function ic(e, t, n, r, i) {
      if (e !== null) {
        var a = e.memoizedProps;
        if (gr(a, r) && e.ref === t.ref) {
          if (ec = !1, t.pendingProps = r = a, Dc(e, i)) e.flags & 131072 && (ec = !0);else return t.lanes = e.lanes, Ec(e, t, i);
        }
      }
      return fc(e, t, n, r, i);
    }
    function ac(e, t, n, r) {
      var i = r.children,
        a = e === null ? null : e.memoizedState;
      if (e === null && t.stateNode === null && (t.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), r.mode === `hidden`) {
        if (t.flags & 128) {
          if (a = a === null ? n : a.baseLanes | n, e !== null) {
            for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
            r = i & ~a;
          } else r = 0, t.child = null;
          return sc(e, t, a, n, r);
        }
        if (n & 536870912) t.memoizedState = {
          baseLanes: 0,
          cachePool: null
        }, e !== null && ma(t, a === null ? null : a.cachePool), a === null ? Ja() : qa(t, a), eo(t);else return r = t.lanes = 536870912, sc(e, t, a === null ? n : a.baseLanes | n, n, r);
      } else a === null ? (e !== null && ma(t, null), Ja(), to(t)) : (ma(t, a.cachePool), qa(t, a), to(t), t.memoizedState = null);
      return tc(e, t, i, n), t.child;
    }
    function oc(e, t) {
      return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), t.sibling;
    }
    function sc(e, t, n, r, i) {
      var a = pa();
      return a = a === null ? null : {
        parent: ta._currentValue,
        pool: a
      }, t.memoizedState = {
        baseLanes: n,
        cachePool: a
      }, e !== null && ma(t, null), Ja(), eo(t), e !== null && Ki(e, t, r, !0), t.childLanes = i, null;
    }
    function cc(e, t) {
      return t = xc({
        mode: t.mode,
        children: t.children
      }, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
    }
    function lc(e, t, n) {
      return Ma(t, e.child, null, n), e = cc(t, t.pendingProps), e.flags |= 2, no(t), t.memoizedState = null, e;
    }
    function uc(e, t, n) {
      var r = t.pendingProps,
        i = !!(t.flags & 128);
      if (t.flags &= -129, e === null) {
        if (Oi) {
          if (r.mode === `hidden`) return e = cc(t, r), t.lanes = 536870912, oc(null, e);
          if ($a(t), (e = Di) ? (e = lf(e, Ai), e = e !== null && e.data === `&` ? e : null, e !== null && (t.memoizedState = {
            dehydrated: e,
            treeContext: vi === null ? null : {
              id: yi,
              overflow: bi
            },
            retryLane: 536870912,
            hydrationErrors: null
          }, n = ci(e), n.return = t, t.child = n, Ei = t, Di = null)) : e = null, e === null) throw Mi(t);
          return t.lanes = 536870912, null;
        }
        return cc(t, r);
      }
      var o = e.memoizedState;
      if (o !== null) {
        var s = o.dehydrated;
        if ($a(t), i) {
          if (t.flags & 256) t.flags &= -257, t = lc(e, t, n);else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;else throw Error(a(558));
        } else if (ec || Ki(e, t, n, !1), i = (n & e.childLanes) !== 0, ec || i) {
          if (r = Rl, r !== null && (s = Ye(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, Xr(e, s), vu(r, e, s), $s;
          Au(), t = lc(e, t, n);
        } else e = o.treeContext, Di = pf(s.nextSibling), Ei = t, Oi = !0, ki = null, Ai = !1, e !== null && Ti(t, e), t = cc(t, r), t.flags |= 4096;
        return t;
      }
      return e = ri(e.child, {
        mode: r.mode,
        children: r.children
      }), e.ref = t.ref, t.child = e, e.return = t, e;
    }
    function dc(e, t) {
      var n = t.ref;
      if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);else {
        if (typeof n != `function` && typeof n != `object`) throw Error(a(284));
        (e === null || e.ref !== n) && (t.flags |= 4194816);
      }
    }
    function fc(e, t, n, r, i) {
      return Ji(t), n = yo(e, t, n, r, void 0, i), r = Co(), e !== null && !ec ? (wo(e, t, i), Ec(e, t, i)) : (Oi && r && Ci(t), t.flags |= 1, tc(e, t, n, i), t.child);
    }
    function pc(e, t, n, r, i, a) {
      return Ji(t), t.updateQueue = null, n = xo(t, r, n, i), bo(e), r = Co(), e !== null && !ec ? (wo(e, t, a), Ec(e, t, a)) : (Oi && r && Ci(t), t.flags |= 1, tc(e, t, n, a), t.child);
    }
    function mc(e, t, n, r, i) {
      if (Ji(t), t.stateNode === null) {
        var a = $r,
          o = n.contextType;
        typeof o == `object` && o && (a = Yi(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Bs, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Fa(t), o = n.contextType, a.context = typeof o == `object` && o ? Yi(o) : $r, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == `function` && (zs(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == `function` || typeof a.getSnapshotBeforeUpdate == `function` || typeof a.UNSAFE_componentWillMount != `function` && typeof a.componentWillMount != `function` || (o = a.state, typeof a.componentWillMount == `function` && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == `function` && a.UNSAFE_componentWillMount(), o !== a.state && Bs.enqueueReplaceState(a, a.state, null), Ua(t, r, a, i), Ha(), a.state = t.memoizedState), typeof a.componentDidMount == `function` && (t.flags |= 4194308), r = !0;
      } else if (e === null) {
        a = t.stateNode;
        var s = t.memoizedProps,
          c = Us(n, s);
        a.props = c;
        var l = a.context,
          u = n.contextType;
        o = $r, typeof u == `object` && u && (o = Yi(u));
        var d = n.getDerivedStateFromProps;
        u = typeof d == `function` || typeof a.getSnapshotBeforeUpdate == `function`, s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != `function` && typeof a.componentWillReceiveProps != `function` || (s || l !== o) && Hs(t, a, r, o), Pa = !1;
        var f = t.memoizedState;
        a.state = f, Ua(t, r, a, i), Ha(), l = t.memoizedState, s || f !== l || Pa ? (typeof d == `function` && (zs(t, n, d, r), l = t.memoizedState), (c = Pa || Vs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != `function` && typeof a.componentWillMount != `function` || (typeof a.componentWillMount == `function` && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == `function` && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == `function` && (t.flags |= 4194308)) : (typeof a.componentDidMount == `function` && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == `function` && (t.flags |= 4194308), r = !1);
      } else {
        a = t.stateNode, Ia(e, t), o = t.memoizedProps, u = Us(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = $r, typeof l == `object` && l && (c = Yi(l)), s = n.getDerivedStateFromProps, (l = typeof s == `function` || typeof a.getSnapshotBeforeUpdate == `function`) || typeof a.UNSAFE_componentWillReceiveProps != `function` && typeof a.componentWillReceiveProps != `function` || (o !== d || f !== c) && Hs(t, a, r, c), Pa = !1, f = t.memoizedState, a.state = f, Ua(t, r, a, i), Ha();
        var p = t.memoizedState;
        o !== d || f !== p || Pa || e !== null && e.dependencies !== null && qi(e.dependencies) ? (typeof s == `function` && (zs(t, n, s, r), p = t.memoizedState), (u = Pa || Vs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && qi(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != `function` && typeof a.componentWillUpdate != `function` || (typeof a.componentWillUpdate == `function` && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == `function` && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == `function` && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == `function` && (t.flags |= 1024)) : (typeof a.componentDidUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
      }
      return a = r, dc(e, t), r = !!(t.flags & 128), a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != `function` ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ma(t, e.child, null, i), t.child = Ma(t, null, n, i)) : tc(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Ec(e, t, i), e;
    }
    function hc(e, t, n, r) {
      return Ii(), t.flags |= 256, tc(e, t, n, r), t.child;
    }
    var gc = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    };
    function _c(e) {
      return {
        baseLanes: e,
        cachePool: ha()
      };
    }
    function vc(e, t, n) {
      return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Zl), e;
    }
    function yc(e, t, n) {
      var r = t.pendingProps,
        i = !1,
        o = !!(t.flags & 128),
        s;
      if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : !!(ro.current & 2)), s && (i = !0, t.flags &= -129), s = !!(t.flags & 32), t.flags &= -33, e === null) {
        if (Oi) {
          if (i ? Qa(t) : to(t), (e = Di) ? (e = lf(e, Ai), e = e !== null && e.data !== `&` ? e : null, e !== null && (t.memoizedState = {
            dehydrated: e,
            treeContext: vi === null ? null : {
              id: yi,
              overflow: bi
            },
            retryLane: 536870912,
            hydrationErrors: null
          }, n = ci(e), n.return = t, t.child = n, Ei = t, Di = null)) : e = null, e === null) throw Mi(t);
          return df(e) ? t.lanes = 32 : t.lanes = 536870912, null;
        }
        var c = r.children;
        return r = r.fallback, i ? (to(t), i = t.mode, c = xc({
          mode: `hidden`,
          children: c
        }, i), r = oi(r, i, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = _c(n), r.childLanes = vc(e, s, n), t.memoizedState = gc, oc(null, r)) : (Qa(t), bc(t, c));
      }
      var l = e.memoizedState;
      if (l !== null && (c = l.dehydrated, c !== null)) {
        if (o) t.flags & 256 ? (Qa(t), t.flags &= -257, t = Sc(e, t, n)) : t.memoizedState === null ? (to(t), c = r.fallback, i = t.mode, r = xc({
          mode: `visible`,
          children: r.children
        }, i), c = oi(c, i, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ma(t, e.child, null, n), r = t.child, r.memoizedState = _c(n), r.childLanes = vc(e, s, n), t.memoizedState = gc, t = oc(null, r)) : (to(t), t.child = e.child, t.flags |= 128, t = null);else if (Qa(t), df(c)) {
          if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
          s = u, r = Error(a(419)), r.stack = ``, r.digest = s, Ri({
            value: r,
            source: null,
            stack: null
          }), t = Sc(e, t, n);
        } else if (ec || Ki(e, t, n, !1), s = (n & e.childLanes) !== 0, ec || s) {
          if (s = Rl, s !== null && (r = Ye(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, Xr(e, r), vu(s, e, r), $s;
          uf(c) || Au(), t = Sc(e, t, n);
        } else uf(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, Di = pf(c.nextSibling), Ei = t, Oi = !0, ki = null, Ai = !1, e !== null && Ti(t, e), t = bc(t, r.children), t.flags |= 4096);
        return t;
      }
      return i ? (to(t), c = r.fallback, i = t.mode, l = e.child, u = l.sibling, r = ri(l, {
        mode: `hidden`,
        children: r.children
      }), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = oi(c, i, n, null), c.flags |= 2) : c = ri(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, oc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = _c(n) : (i = c.cachePool, i === null ? i = ha() : (l = ta._currentValue, i = i.parent === l ? i : {
        parent: l,
        pool: l
      }), c = {
        baseLanes: c.baseLanes | n,
        cachePool: i
      }), r.memoizedState = c, r.childLanes = vc(e, s, n), t.memoizedState = gc, oc(e.child, r)) : (Qa(t), n = e.child, e = n.sibling, n = ri(n, {
        mode: `visible`,
        children: r.children
      }), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
    }
    function bc(e, t) {
      return t = xc({
        mode: `visible`,
        children: t
      }, e.mode), t.return = e, e.child = t;
    }
    function xc(e, t) {
      return e = ti(22, e, null, t), e.lanes = 0, e;
    }
    function Sc(e, t, n) {
      return Ma(t, e.child, null, n), e = bc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
    }
    function Cc(e, t, n) {
      e.lanes |= t;
      var r = e.alternate;
      r !== null && (r.lanes |= t), Wi(e.return, t, n);
    }
    function wc(e, t, n, r, i, a) {
      var o = e.memoizedState;
      o === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: n,
        tailMode: i,
        treeForkCount: a
      } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
    }
    function Tc(e, t, n) {
      var r = t.pendingProps,
        i = r.revealOrder,
        a = r.tail;
      r = r.children;
      var o = ro.current,
        s = !!(o & 2);
      if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, V(ro, o), tc(e, t, r, n), r = Oi ? hi : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
        if (e.tag === 13) e.memoizedState !== null && Cc(e, n, t);else if (e.tag === 19) Cc(e, n, t);else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break a;
        for (; e.sibling === null;) {
          if (e.return === null || e.return === t) break a;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
      switch (i) {
        case `forwards`:
          for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && io(e) === null && (i = n), n = n.sibling;
          n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), wc(t, !1, i, n, a, r);
          break;
        case `backwards`:
        case `unstable_legacy-backwards`:
          for (n = null, i = t.child, t.child = null; i !== null;) {
            if (e = i.alternate, e !== null && io(e) === null) {
              t.child = i;
              break;
            }
            e = i.sibling, i.sibling = n, n = i, i = e;
          }
          wc(t, !0, n, null, a, r);
          break;
        case `together`:
          wc(t, !1, null, null, void 0, r);
          break;
        default:
          t.memoizedState = null;
      }
      return t.child;
    }
    function Ec(e, t, n) {
      if (e !== null && (t.dependencies = e.dependencies), Jl |= t.lanes, (n & t.childLanes) === 0) {
        if (e !== null) {
          if (Ki(e, t, n, !1), (n & t.childLanes) === 0) return null;
        } else return null;
      }
      if (e !== null && t.child !== e.child) throw Error(a(153));
      if (t.child !== null) {
        for (e = t.child, n = ri(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = ri(e, e.pendingProps), n.return = t;
        n.sibling = null;
      }
      return t.child;
    }
    function Dc(e, t) {
      return (e.lanes & t) !== 0 || (e = e.dependencies, !!(e !== null && qi(e)));
    }
    function Oc(e, t, n) {
      switch (t.tag) {
        case 3:
          U(t, t.stateNode.containerInfo), Hi(t, ta, e.memoizedState.cache), Ii();
          break;
        case 27:
        case 5:
          oe(t);
          break;
        case 4:
          U(t, t.stateNode.containerInfo);
          break;
        case 10:
          Hi(t, t.type, t.memoizedProps.value);
          break;
        case 31:
          if (t.memoizedState !== null) return t.flags |= 128, $a(t), null;
          break;
        case 13:
          var r = t.memoizedState;
          if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (Qa(t), e = Ec(e, t, n), e === null ? null : e.sibling) : yc(e, t, n) : (Qa(t), t.flags |= 128, null);
          Qa(t);
          break;
        case 19:
          var i = !!(e.flags & 128);
          if (r = (n & t.childLanes) !== 0, r ||= (Ki(e, t, n, !1), (n & t.childLanes) !== 0), i) {
            if (r) return Tc(e, t, n);
            t.flags |= 128;
          }
          if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), V(ro, ro.current), r) break;
          return null;
        case 22:
          return t.lanes = 0, ac(e, t, n, t.pendingProps);
        case 24:
          Hi(t, ta, e.memoizedState.cache);
      }
      return Ec(e, t, n);
    }
    function kc(e, t, n) {
      if (e !== null) {
        if (e.memoizedProps !== t.pendingProps) ec = !0;else {
          if (!Dc(e, n) && !(t.flags & 128)) return ec = !1, Oc(e, t, n);
          ec = !!(e.flags & 131072);
        }
      } else ec = !1, Oi && t.flags & 1048576 && Si(t, hi, t.index);
      switch (t.lanes = 0, t.tag) {
        case 16:
          a: {
            var r = t.pendingProps;
            if (e = Sa(t.elementType), t.type = e, typeof e == `function`) ni(e) ? (r = Us(e, r), t.tag = 1, t = mc(null, t, e, r, n)) : (t.tag = 0, t = fc(null, t, e, r, n));else {
              if (e != null) {
                var i = e.$$typeof;
                if (i === w) {
                  t.tag = 11, t = nc(null, t, e, r, n);
                  break a;
                }
                if (i === D) {
                  t.tag = 14, t = rc(null, t, e, r, n);
                  break a;
                }
              }
              throw t = P(e) || e, Error(a(306, t, ``));
            }
          }
          return t;
        case 0:
          return fc(e, t, t.type, t.pendingProps, n);
        case 1:
          return r = t.type, i = Us(r, t.pendingProps), mc(e, t, r, i, n);
        case 3:
          a: {
            if (U(t, t.stateNode.containerInfo), e === null) throw Error(a(387));
            r = t.pendingProps;
            var o = t.memoizedState;
            i = o.element, Ia(e, t), Ua(t, r, null, n);
            var s = t.memoizedState;
            if (r = s.cache, Hi(t, ta, r), r !== o.cache && Gi(t, [ta], n, !0), Ha(), r = s.element, o.isDehydrated) {
              if (o = {
                element: r,
                isDehydrated: !1,
                cache: s.cache
              }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
                t = hc(e, t, r, n);
                break a;
              }
              if (r !== i) {
                i = di(Error(a(424)), t), Ri(i), t = hc(e, t, r, n);
                break a;
              }
              switch (e = t.stateNode.containerInfo, e.nodeType) {
                case 9:
                  e = e.body;
                  break;
                default:
                  e = e.nodeName === `HTML` ? e.ownerDocument.body : e;
              }
              for (Di = pf(e.firstChild), Ei = t, Oi = !0, ki = null, Ai = !0, n = Na(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
            } else {
              if (Ii(), r === i) {
                t = Ec(e, t, n);
                break a;
              }
              tc(e, t, r, n);
            }
            t = t.child;
          }
          return t;
        case 26:
          return dc(e, t), e === null ? (n = Pf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : Oi || (n = t.type, e = t.pendingProps, r = Gd(re.current).createElement(n), r[tt] = t, r[nt] = e, zd(r, n, e), mt(r), t.stateNode = r) : t.memoizedState = Pf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
        case 27:
          return oe(t), e === null && Oi && (r = t.stateNode = _f(t.type, t.pendingProps, re.current), Ei = t, Ai = !0, i = Di, nf(t.type) ? (mf = i, Di = pf(r.firstChild)) : Di = i), tc(e, t, t.pendingProps.children, n), dc(e, t), e === null && (t.flags |= 4194304), t.child;
        case 5:
          return e === null && Oi && ((i = r = Di) && (r = sf(r, t.type, t.pendingProps, Ai), r === null ? i = !1 : (t.stateNode = r, Ei = t, Di = pf(r.firstChild), Ai = !1, i = !0)), i || Mi(t)), oe(t), i = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Jd(i, o) ? r = null : s !== null && Jd(i, s) && (t.flags |= 32), t.memoizedState !== null && (i = yo(e, t, So, null, null, n), rp._currentValue = i), dc(e, t), tc(e, t, r, n), t.child;
        case 6:
          return e === null && Oi && ((e = n = Di) && (n = cf(n, t.pendingProps, Ai), n === null ? e = !1 : (t.stateNode = n, Ei = t, Di = null, e = !0)), e || Mi(t)), null;
        case 13:
          return yc(e, t, n);
        case 4:
          return U(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ma(t, null, r, n) : tc(e, t, r, n), t.child;
        case 11:
          return nc(e, t, t.type, t.pendingProps, n);
        case 7:
          return tc(e, t, t.pendingProps, n), t.child;
        case 8:
          return tc(e, t, t.pendingProps.children, n), t.child;
        case 12:
          return tc(e, t, t.pendingProps.children, n), t.child;
        case 10:
          return r = t.pendingProps, Hi(t, t.type, r.value), tc(e, t, r.children, n), t.child;
        case 9:
          return i = t.type._context, r = t.pendingProps.children, Ji(t), i = Yi(i), r = r(i), t.flags |= 1, tc(e, t, r, n), t.child;
        case 14:
          return rc(e, t, t.type, t.pendingProps, n);
        case 15:
          return ic(e, t, t.type, t.pendingProps, n);
        case 19:
          return Tc(e, t, n);
        case 31:
          return uc(e, t, n);
        case 22:
          return ac(e, t, n, t.pendingProps);
        case 24:
          return Ji(t), r = Yi(ta), e === null ? (i = pa(), i === null && (i = Rl, o = na(), i.pooledCache = o, o.refCount++, o !== null && (i.pooledCacheLanes |= n), i = o), t.memoizedState = {
            parent: r,
            cache: i
          }, Fa(t), Hi(t, ta, i)) : ((e.lanes & n) !== 0 && (Ia(e, t), Ua(t, null, null, n), Ha()), i = e.memoizedState, o = t.memoizedState, i.parent === r ? (r = o.cache, Hi(t, ta, r), r !== i.cache && Gi(t, [ta], n, !0)) : (i = {
            parent: r,
            cache: r
          }, t.memoizedState = i, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = i), Hi(t, ta, r))), tc(e, t, t.pendingProps.children, n), t.child;
        case 29:
          throw t.pendingProps;
      }
      throw Error(a(156, t.tag));
    }
    function Ac(e) {
      e.flags |= 4;
    }
    function jc(e, t, n, r, i) {
      if ((t = !!(e.mode & 32)) && (t = !1), t) {
        if (e.flags |= 16777216, (i & 335544128) === i) {
          if (e.stateNode.complete) e.flags |= 8192;else if (Du()) e.flags |= 8192;else throw Ca = ya, _a;
        }
      } else e.flags &= -16777217;
    }
    function Mc(e, t) {
      if (t.type !== `stylesheet` || t.state.loading & 4) e.flags &= -16777217;else if (e.flags |= 16777216, !Yf(t)) {
        if (Du()) e.flags |= 8192;else throw Ca = ya, _a;
      }
    }
    function Nc(e, t) {
      t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : Ue(), e.lanes |= t, Ql |= t);
    }
    function Pc(e, t) {
      if (!Oi) switch (e.tailMode) {
        case `hidden`:
          t = e.tail;
          for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
          n === null ? e.tail = null : n.sibling = null;
          break;
        case `collapsed`:
          n = e.tail;
          for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
          r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
      }
    }
    function Fc(e) {
      var t = e.alternate !== null && e.alternate.child === e.child,
        n = 0,
        r = 0;
      if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
      return e.subtreeFlags |= r, e.childLanes = n, t;
    }
    function Ic(e, t, n) {
      var r = t.pendingProps;
      switch (wi(t), t.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Fc(t), null;
        case 1:
          return Fc(t), null;
        case 3:
          return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Ui(ta), ae(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Fi(t) ? Ac(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Li())), Fc(t), null;
        case 26:
          var i = t.type,
            o = t.memoizedState;
          return e === null ? (Ac(t), o === null ? (Fc(t), jc(t, i, null, r, n)) : (Fc(t), Mc(t, o))) : o ? o === e.memoizedState ? (Fc(t), t.flags &= -16777217) : (Ac(t), Fc(t), Mc(t, o)) : (e = e.memoizedProps, e !== r && Ac(t), Fc(t), jc(t, i, e, r, n)), null;
        case 27:
          if (se(t), n = re.current, i = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Ac(t);else {
            if (!r) {
              if (t.stateNode === null) throw Error(a(166));
              return Fc(t), null;
            }
            e = H.current, Fi(t) ? Ni(t, e) : (e = _f(i, r, n), t.stateNode = e, Ac(t));
          }
          return Fc(t), null;
        case 5:
          if (se(t), i = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Ac(t);else {
            if (!r) {
              if (t.stateNode === null) throw Error(a(166));
              return Fc(t), null;
            }
            if (o = H.current, Fi(t)) Ni(t, o);else {
              var s = Gd(re.current);
              switch (o) {
                case 1:
                  o = s.createElementNS(`http://www.w3.org/2000/svg`, i);
                  break;
                case 2:
                  o = s.createElementNS(`http://www.w3.org/1998/Math/MathML`, i);
                  break;
                default:
                  switch (i) {
                    case `svg`:
                      o = s.createElementNS(`http://www.w3.org/2000/svg`, i);
                      break;
                    case `math`:
                      o = s.createElementNS(`http://www.w3.org/1998/Math/MathML`, i);
                      break;
                    case `script`:
                      o = s.createElement(`div`), o.innerHTML = `<script><\/script>`, o = o.removeChild(o.firstChild);
                      break;
                    case `select`:
                      o = typeof r.is == `string` ? s.createElement(`select`, {
                        is: r.is
                      }) : s.createElement(`select`), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
                      break;
                    default:
                      o = typeof r.is == `string` ? s.createElement(i, {
                        is: r.is
                      }) : s.createElement(i);
                  }
              }
              o[tt] = t, o[nt] = r;
              a: for (s = t.child; s !== null;) {
                if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
                  s.child.return = s, s = s.child;
                  continue;
                }
                if (s === t) break a;
                for (; s.sibling === null;) {
                  if (s.return === null || s.return === t) break a;
                  s = s.return;
                }
                s.sibling.return = s.return, s = s.sibling;
              }
              t.stateNode = o;
              a: switch (zd(o, i, r), i) {
                case `button`:
                case `input`:
                case `select`:
                case `textarea`:
                  r = !!r.autoFocus;
                  break a;
                case `img`:
                  r = !0;
                  break a;
                default:
                  r = !1;
              }
              r && Ac(t);
            }
          }
          return Fc(t), jc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
        case 6:
          if (e && t.stateNode != null) e.memoizedProps !== r && Ac(t);else {
            if (typeof r != `string` && t.stateNode === null) throw Error(a(166));
            if (e = re.current, Fi(t)) {
              if (e = t.stateNode, n = t.memoizedProps, r = null, i = Ei, i !== null) switch (i.tag) {
                case 27:
                case 5:
                  r = i.memoizedProps;
              }
              e[tt] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Id(e.nodeValue, n)), e || Mi(t, !0);
            } else e = Gd(e).createTextNode(r), e[tt] = t, t.stateNode = e;
          }
          return Fc(t), null;
        case 31:
          if (n = t.memoizedState, e === null || e.memoizedState !== null) {
            if (r = Fi(t), n !== null) {
              if (e === null) {
                if (!r) throw Error(a(318));
                if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(a(557));
                e[tt] = t;
              } else Ii(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
              Fc(t), e = !1;
            } else n = Li(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
            if (!e) return t.flags & 256 ? (no(t), t) : (no(t), null);
            if (t.flags & 128) throw Error(a(558));
          }
          return Fc(t), null;
        case 13:
          if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            if (i = Fi(t), r !== null && r.dehydrated !== null) {
              if (e === null) {
                if (!i) throw Error(a(318));
                if (i = t.memoizedState, i = i === null ? null : i.dehydrated, !i) throw Error(a(317));
                i[tt] = t;
              } else Ii(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
              Fc(t), i = !1;
            } else i = Li(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = i), i = !0;
            if (!i) return t.flags & 256 ? (no(t), t) : (no(t), null);
          }
          return no(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, i = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (i = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== i && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Nc(t, t.updateQueue), Fc(t), null);
        case 4:
          return ae(), e === null && Dd(t.stateNode.containerInfo), Fc(t), null;
        case 10:
          return Ui(t.type), Fc(t), null;
        case 19:
          if (B(ro), r = t.memoizedState, r === null) return Fc(t), null;
          if (i = !!(t.flags & 128), o = r.rendering, o === null) {
            if (i) Pc(r, !1);else {
              if (ql !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
                if (o = io(e), o !== null) {
                  for (t.flags |= 128, Pc(r, !1), e = o.updateQueue, t.updateQueue = e, Nc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) ii(n, e), n = n.sibling;
                  return V(ro, ro.current & 1 | 2), Oi && xi(t, r.treeForkCount), t.child;
                }
                e = e.sibling;
              }
              r.tail !== null && be() > iu && (t.flags |= 128, i = !0, Pc(r, !1), t.lanes = 4194304);
            }
          } else {
            if (!i) {
              if (e = io(o), e !== null) {
                if (t.flags |= 128, i = !0, e = e.updateQueue, t.updateQueue = e, Nc(t, e), Pc(r, !0), r.tail === null && r.tailMode === `hidden` && !o.alternate && !Oi) return Fc(t), null;
              } else 2 * be() - r.renderingStartTime > iu && n !== 536870912 && (t.flags |= 128, i = !0, Pc(r, !1), t.lanes = 4194304);
            }
            r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
          }
          return r.tail === null ? (Fc(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = be(), e.sibling = null, n = ro.current, V(ro, i ? n & 1 | 2 : n & 1), Oi && xi(t, r.treeForkCount), e);
        case 22:
        case 23:
          return no(t), Ya(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (Fc(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Fc(t), n = t.updateQueue, n !== null && Nc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && B(fa), null;
        case 24:
          return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Ui(ta), Fc(t), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(a(156, t.tag));
    }
    function Lc(e, t) {
      switch (wi(t), t.tag) {
        case 1:
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
        case 3:
          return Ui(ta), ae(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
        case 26:
        case 27:
        case 5:
          return se(t), null;
        case 31:
          if (t.memoizedState !== null) {
            if (no(t), t.alternate === null) throw Error(a(340));
            Ii();
          }
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
        case 13:
          if (no(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
            if (t.alternate === null) throw Error(a(340));
            Ii();
          }
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
        case 19:
          return B(ro), null;
        case 4:
          return ae(), null;
        case 10:
          return Ui(t.type), null;
        case 22:
        case 23:
          return no(t), Ya(), e !== null && B(fa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
        case 24:
          return Ui(ta), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function Rc(e, t) {
      switch (wi(t), t.tag) {
        case 3:
          Ui(ta), ae();
          break;
        case 26:
        case 27:
        case 5:
          se(t);
          break;
        case 4:
          ae();
          break;
        case 31:
          t.memoizedState !== null && no(t);
          break;
        case 13:
          no(t);
          break;
        case 19:
          B(ro);
          break;
        case 10:
          Ui(t.type);
          break;
        case 22:
        case 23:
          no(t), Ya(), e !== null && B(fa);
          break;
        case 24:
          Ui(ta);
      }
    }
    function zc(e, t) {
      try {
        var n = t.updateQueue,
          r = n === null ? null : n.lastEffect;
        if (r !== null) {
          var i = r.next;
          n = i;
          do {
            if ((n.tag & e) === e) {
              r = void 0;
              var a = n.create,
                o = n.inst;
              r = a(), o.destroy = r;
            }
            n = n.next;
          } while (n !== i);
        }
      } catch (e) {
        Ju(t, t.return, e);
      }
    }
    function Bc(e, t, n) {
      try {
        var r = t.updateQueue,
          i = r === null ? null : r.lastEffect;
        if (i !== null) {
          var a = i.next;
          r = a;
          do {
            if ((r.tag & e) === e) {
              var o = r.inst,
                s = o.destroy;
              if (s !== void 0) {
                o.destroy = void 0, i = t;
                var c = n,
                  l = s;
                try {
                  l();
                } catch (e) {
                  Ju(i, c, e);
                }
              }
            }
            r = r.next;
          } while (r !== a);
        }
      } catch (e) {
        Ju(t, t.return, e);
      }
    }
    function Vc(e) {
      var t = e.updateQueue;
      if (t !== null) {
        var n = e.stateNode;
        try {
          Wa(t, n);
        } catch (t) {
          Ju(e, e.return, t);
        }
      }
    }
    function Hc(e, t, n) {
      n.props = Us(e.type, e.memoizedProps), n.state = e.memoizedState;
      try {
        n.componentWillUnmount();
      } catch (n) {
        Ju(e, t, n);
      }
    }
    function Uc(e, t) {
      try {
        var n = e.ref;
        if (n !== null) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              var r = e.stateNode;
              break;
            case 30:
              r = e.stateNode;
              break;
            default:
              r = e.stateNode;
          }
          typeof n == `function` ? e.refCleanup = n(r) : n.current = r;
        }
      } catch (n) {
        Ju(e, t, n);
      }
    }
    function Wc(e, t) {
      var n = e.ref,
        r = e.refCleanup;
      if (n !== null) {
        if (typeof r == `function`) try {
          r();
        } catch (n) {
          Ju(e, t, n);
        } finally {
          e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
        } else if (typeof n == `function`) try {
          n(null);
        } catch (n) {
          Ju(e, t, n);
        } else n.current = null;
      }
    }
    function Gc(e) {
      var t = e.type,
        n = e.memoizedProps,
        r = e.stateNode;
      try {
        a: switch (t) {
          case `button`:
          case `input`:
          case `select`:
          case `textarea`:
            n.autoFocus && r.focus();
            break a;
          case `img`:
            n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
        }
      } catch (t) {
        Ju(e, e.return, t);
      }
    }
    function Kc(e, t, n) {
      try {
        var r = e.stateNode;
        Bd(r, e.type, n, t), r[nt] = t;
      } catch (t) {
        Ju(e, e.return, t);
      }
    }
    function qc(e) {
      return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && nf(e.type) || e.tag === 4;
    }
    function Jc(e) {
      a: for (;;) {
        for (; e.sibling === null;) {
          if (e.return === null || qc(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
          if (e.tag === 27 && nf(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
          e.child.return = e, e = e.child;
        }
        if (!(e.flags & 2)) return e.stateNode;
      }
    }
    function Yc(e, t, n) {
      var r = e.tag;
      if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Jt));else if (r !== 4 && (r === 27 && nf(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Yc(e, t, n), e = e.sibling; e !== null;) Yc(e, t, n), e = e.sibling;
    }
    function Xc(e, t, n) {
      var r = e.tag;
      if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);else if (r !== 4 && (r === 27 && nf(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (Xc(e, t, n), e = e.sibling; e !== null;) Xc(e, t, n), e = e.sibling;
    }
    function Zc(e) {
      var t = e.stateNode,
        n = e.memoizedProps;
      try {
        for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
        zd(t, r, n), t[tt] = e, t[nt] = n;
      } catch (t) {
        Ju(e, e.return, t);
      }
    }
    var Qc = !1,
      $c = !1,
      el = !1,
      tl = typeof WeakSet == `function` ? WeakSet : Set,
      nl = null;
    function rl(e, t) {
      if (e = e.containerInfo, Ud = fp, e = br(e), xr(e)) {
        if (`selectionStart` in e) var n = {
          start: e.selectionStart,
          end: e.selectionEnd
        };else a: {
          n = (n = e.ownerDocument) && n.defaultView || window;
          var r = n.getSelection && n.getSelection();
          if (r && r.rangeCount !== 0) {
            n = r.anchorNode;
            var i = r.anchorOffset,
              o = r.focusNode;
            r = r.focusOffset;
            try {
              n.nodeType, o.nodeType;
            } catch {
              n = null;
              break a;
            }
            var s = 0,
              c = -1,
              l = -1,
              u = 0,
              d = 0,
              f = e,
              p = null;
            b: for (;;) {
              for (var m; f !== n || i !== 0 && f.nodeType !== 3 || (c = s + i), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
              for (;;) {
                if (f === e) break b;
                if (p === n && ++u === i && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
                f = p, p = f.parentNode;
              }
              f = m;
            }
            n = c === -1 || l === -1 ? null : {
              start: c,
              end: l
            };
          } else n = null;
        }
        n ||= {
          start: 0,
          end: 0
        };
      } else n = null;
      for (Wd = {
        focusedElem: e,
        selectionRange: n
      }, fp = !1, nl = t; nl !== null;) if (t = nl, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, nl = e;else for (; nl !== null;) {
        switch (t = nl, o = t.alternate, e = t.flags, t.tag) {
          case 0:
            if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) i = e[n], i.ref.impl = i.nextImpl;
            break;
          case 11:
          case 15:
            break;
          case 1:
            if (e & 1024 && o !== null) {
              e = void 0, n = t, i = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
              try {
                var h = Us(n.type, i);
                e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
              } catch (e) {
                Ju(n, n.return, e);
              }
            }
            break;
          case 3:
            if (e & 1024) {
              if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) of(e);else if (n === 1) switch (e.nodeName) {
                case `HEAD`:
                case `HTML`:
                case `BODY`:
                  of(e);
                  break;
                default:
                  e.textContent = ``;
              }
            }
            break;
          case 5:
          case 26:
          case 27:
          case 6:
          case 4:
          case 17:
            break;
          default:
            if (e & 1024) throw Error(a(163));
        }
        if (e = t.sibling, e !== null) {
          e.return = t.return, nl = e;
          break;
        }
        nl = t.return;
      }
    }
    function il(e, t, n) {
      var r = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          yl(e, n), r & 4 && zc(5, n);
          break;
        case 1:
          if (yl(e, n), r & 4) {
            if (e = n.stateNode, t === null) try {
              e.componentDidMount();
            } catch (e) {
              Ju(n, n.return, e);
            } else {
              var i = Us(n.type, t.memoizedProps);
              t = t.memoizedState;
              try {
                e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
              } catch (e) {
                Ju(n, n.return, e);
              }
            }
          }
          r & 64 && Vc(n), r & 512 && Uc(n, n.return);
          break;
        case 3:
          if (yl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
            if (t = null, n.child !== null) switch (n.child.tag) {
              case 27:
              case 5:
                t = n.child.stateNode;
                break;
              case 1:
                t = n.child.stateNode;
            }
            try {
              Wa(e, t);
            } catch (e) {
              Ju(n, n.return, e);
            }
          }
          break;
        case 27:
          t === null && r & 4 && Zc(n);
        case 26:
        case 5:
          yl(e, n), t === null && r & 4 && Gc(n), r & 512 && Uc(n, n.return);
          break;
        case 12:
          yl(e, n);
          break;
        case 31:
          yl(e, n), r & 4 && ul(e, n);
          break;
        case 13:
          yl(e, n), r & 4 && dl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Qu.bind(null, n), ff(e, n))));
          break;
        case 22:
          if (r = n.memoizedState !== null || Qc, !r) {
            t = t !== null && t.memoizedState !== null || $c, i = Qc;
            var a = $c;
            Qc = r, ($c = t) && !a ? xl(e, n, !!(n.subtreeFlags & 8772)) : yl(e, n), Qc = i, $c = a;
          }
          break;
        case 30:
          break;
        default:
          yl(e, n);
      }
    }
    function al(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, al(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && lt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    var ol = null,
      sl = !1;
    function cl(e, t, n) {
      for (n = n.child; n !== null;) ll(e, t, n), n = n.sibling;
    }
    function ll(e, t, n) {
      if (Ae && typeof Ae.onCommitFiberUnmount == `function`) try {
        Ae.onCommitFiberUnmount(ke, n);
      } catch {}
      switch (n.tag) {
        case 26:
          $c || Wc(n, t), cl(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
          break;
        case 27:
          $c || Wc(n, t);
          var r = ol,
            i = sl;
          nf(n.type) && (ol = n.stateNode, sl = !1), cl(e, t, n), vf(n.stateNode), ol = r, sl = i;
          break;
        case 5:
          $c || Wc(n, t);
        case 6:
          if (r = ol, i = sl, ol = null, cl(e, t, n), ol = r, sl = i, ol !== null) {
            if (sl) try {
              (ol.nodeType === 9 ? ol.body : ol.nodeName === `HTML` ? ol.ownerDocument.body : ol).removeChild(n.stateNode);
            } catch (e) {
              Ju(n, t, e);
            } else try {
              ol.removeChild(n.stateNode);
            } catch (e) {
              Ju(n, t, e);
            }
          }
          break;
        case 18:
          ol !== null && (sl ? (e = ol, rf(e.nodeType === 9 ? e.body : e.nodeName === `HTML` ? e.ownerDocument.body : e, n.stateNode), Rp(e)) : rf(ol, n.stateNode));
          break;
        case 4:
          r = ol, i = sl, ol = n.stateNode.containerInfo, sl = !0, cl(e, t, n), ol = r, sl = i;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          Bc(2, n, t), $c || Bc(4, n, t), cl(e, t, n);
          break;
        case 1:
          $c || (Wc(n, t), r = n.stateNode, typeof r.componentWillUnmount == `function` && Hc(n, t, r)), cl(e, t, n);
          break;
        case 21:
          cl(e, t, n);
          break;
        case 22:
          $c = (r = $c) || n.memoizedState !== null, cl(e, t, n), $c = r;
          break;
        default:
          cl(e, t, n);
      }
    }
    function ul(e, t) {
      if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
        e = e.dehydrated;
        try {
          Rp(e);
        } catch (e) {
          Ju(t, t.return, e);
        }
      }
    }
    function dl(e, t) {
      if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
        Rp(e);
      } catch (e) {
        Ju(t, t.return, e);
      }
    }
    function fl(e) {
      switch (e.tag) {
        case 31:
        case 13:
        case 19:
          var t = e.stateNode;
          return t === null && (t = e.stateNode = new tl()), t;
        case 22:
          return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new tl()), t;
        default:
          throw Error(a(435, e.tag));
      }
    }
    function pl(e, t) {
      var n = fl(e);
      t.forEach(function (t) {
        if (!n.has(t)) {
          n.add(t);
          var r = $u.bind(null, e, t);
          t.then(r, r);
        }
      });
    }
    function ml(e, t) {
      var n = t.deletions;
      if (n !== null) for (var r = 0; r < n.length; r++) {
        var i = n[r],
          o = e,
          s = t,
          c = s;
        a: for (; c !== null;) {
          switch (c.tag) {
            case 27:
              if (nf(c.type)) {
                ol = c.stateNode, sl = !1;
                break a;
              }
              break;
            case 5:
              ol = c.stateNode, sl = !1;
              break a;
            case 3:
            case 4:
              ol = c.stateNode.containerInfo, sl = !0;
              break a;
          }
          c = c.return;
        }
        if (ol === null) throw Error(a(160));
        ll(o, s, i), ol = null, sl = !1, o = i.alternate, o !== null && (o.return = null), i.return = null;
      }
      if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) gl(t, e), t = t.sibling;
    }
    var hl = null;
    function gl(e, t) {
      var n = e.alternate,
        r = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ml(t, e), _l(e), r & 4 && (Bc(3, e, e.return), zc(3, e), Bc(5, e, e.return));
          break;
        case 1:
          ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), r & 64 && Qc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
          break;
        case 26:
          var i = hl;
          if (ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), r & 4) {
            var o = n === null ? null : n.memoizedState;
            if (r = e.memoizedState, n === null) {
              if (r === null) {
                if (e.stateNode === null) {
                  a: {
                    r = e.type, n = e.memoizedProps, i = i.ownerDocument || i;
                    b: switch (r) {
                      case `title`:
                        o = i.getElementsByTagName(`title`)[0], (!o || o[ct] || o[tt] || o.namespaceURI === `http://www.w3.org/2000/svg` || o.hasAttribute(`itemprop`)) && (o = i.createElement(r), i.head.insertBefore(o, i.querySelector(`head > title`))), zd(o, r, n), o[tt] = e, mt(o), r = o;
                        break a;
                      case `link`:
                        var s = Kf(`link`, `href`, i).get(r + (n.href || ``));
                        if (s) {
                          for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute(`href`) === (n.href == null || n.href === `` ? null : n.href) && o.getAttribute(`rel`) === (n.rel == null ? null : n.rel) && o.getAttribute(`title`) === (n.title == null ? null : n.title) && o.getAttribute(`crossorigin`) === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            s.splice(c, 1);
                            break b;
                          }
                        }
                        o = i.createElement(r), zd(o, r, n), i.head.appendChild(o);
                        break;
                      case `meta`:
                        if (s = Kf(`meta`, `content`, i).get(r + (n.content || ``))) {
                          for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute(`content`) === (n.content == null ? null : `` + n.content) && o.getAttribute(`name`) === (n.name == null ? null : n.name) && o.getAttribute(`property`) === (n.property == null ? null : n.property) && o.getAttribute(`http-equiv`) === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute(`charset`) === (n.charSet == null ? null : n.charSet)) {
                            s.splice(c, 1);
                            break b;
                          }
                        }
                        o = i.createElement(r), zd(o, r, n), i.head.appendChild(o);
                        break;
                      default:
                        throw Error(a(468, r));
                    }
                    o[tt] = e, mt(o), r = o;
                  }
                  e.stateNode = r;
                } else qf(i, e.type, e.stateNode);
              } else e.stateNode = Vf(i, r, e.memoizedProps);
            } else o === r ? r === null && e.stateNode !== null && Kc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? qf(i, e.type, e.stateNode) : Vf(i, r, e.memoizedProps));
          }
          break;
        case 27:
          ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), n !== null && r & 4 && Kc(e, e.memoizedProps, n.memoizedProps);
          break;
        case 5:
          if (ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), e.flags & 32) {
            i = e.stateNode;
            try {
              Bt(i, ``);
            } catch (t) {
              Ju(e, e.return, t);
            }
          }
          r & 4 && e.stateNode != null && (i = e.memoizedProps, Kc(e, i, n === null ? i : n.memoizedProps)), r & 1024 && (el = !0);
          break;
        case 6:
          if (ml(t, e), _l(e), r & 4) {
            if (e.stateNode === null) throw Error(a(162));
            r = e.memoizedProps, n = e.stateNode;
            try {
              n.nodeValue = r;
            } catch (t) {
              Ju(e, e.return, t);
            }
          }
          break;
        case 3:
          if (Gf = null, i = hl, hl = xf(t.containerInfo), ml(t, e), hl = i, _l(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
            Rp(t.containerInfo);
          } catch (t) {
            Ju(e, e.return, t);
          }
          el && (el = !1, vl(e));
          break;
        case 4:
          r = hl, hl = xf(e.stateNode.containerInfo), ml(t, e), _l(e), hl = r;
          break;
        case 12:
          ml(t, e), _l(e);
          break;
        case 31:
          ml(t, e), _l(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
          break;
        case 13:
          ml(t, e), _l(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (nu = be()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
          break;
        case 22:
          i = e.memoizedState !== null;
          var l = n !== null && n.memoizedState !== null,
            u = Qc,
            d = $c;
          if (Qc = u || i, $c = d || l, ml(t, e), $c = d, Qc = u, _l(e), r & 8192) a: for (t = e.stateNode, t._visibility = i ? t._visibility & -2 : t._visibility | 1, i && (n === null || l || Qc || $c || bl(e)), n = null, t = e;;) {
            if (t.tag === 5 || t.tag === 26) {
              if (n === null) {
                l = n = t;
                try {
                  if (o = l.stateNode, i) s = o.style, typeof s.setProperty == `function` ? s.setProperty(`display`, `none`, `important`) : s.display = `none`;else {
                    c = l.stateNode;
                    var f = l.memoizedProps.style,
                      p = f != null && f.hasOwnProperty(`display`) ? f.display : null;
                    c.style.display = p == null || typeof p == `boolean` ? `` : (`` + p).trim();
                  }
                } catch (e) {
                  Ju(l, l.return, e);
                }
              }
            } else if (t.tag === 6) {
              if (n === null) {
                l = t;
                try {
                  l.stateNode.nodeValue = i ? `` : l.memoizedProps;
                } catch (e) {
                  Ju(l, l.return, e);
                }
              }
            } else if (t.tag === 18) {
              if (n === null) {
                l = t;
                try {
                  var m = l.stateNode;
                  i ? af(m, !0) : af(l.stateNode, !1);
                } catch (e) {
                  Ju(l, l.return, e);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === e) break a;
            for (; t.sibling === null;) {
              if (t.return === null || t.return === e) break a;
              n === t && (n = null), t = t.return;
            }
            n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
          }
          r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, pl(e, n))));
          break;
        case 19:
          ml(t, e), _l(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          ml(t, e), _l(e);
      }
    }
    function _l(e) {
      var t = e.flags;
      if (t & 2) {
        try {
          for (var n, r = e.return; r !== null;) {
            if (qc(r)) {
              n = r;
              break;
            }
            r = r.return;
          }
          if (n == null) throw Error(a(160));
          switch (n.tag) {
            case 27:
              var i = n.stateNode;
              Xc(e, Jc(e), i);
              break;
            case 5:
              var o = n.stateNode;
              n.flags & 32 && (Bt(o, ``), n.flags &= -33), Xc(e, Jc(e), o);
              break;
            case 3:
            case 4:
              var s = n.stateNode.containerInfo;
              Yc(e, Jc(e), s);
              break;
            default:
              throw Error(a(161));
          }
        } catch (t) {
          Ju(e, e.return, t);
        }
        e.flags &= -3;
      }
      t & 4096 && (e.flags &= -4097);
    }
    function vl(e) {
      if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
        var t = e;
        vl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
      }
    }
    function yl(e, t) {
      if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) il(e, t.alternate, t), t = t.sibling;
    }
    function bl(e) {
      for (e = e.child; e !== null;) {
        var t = e;
        switch (t.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            Bc(4, t, t.return), bl(t);
            break;
          case 1:
            Wc(t, t.return);
            var n = t.stateNode;
            typeof n.componentWillUnmount == `function` && Hc(t, t.return, n), bl(t);
            break;
          case 27:
            vf(t.stateNode);
          case 26:
          case 5:
            Wc(t, t.return), bl(t);
            break;
          case 22:
            t.memoizedState === null && bl(t);
            break;
          case 30:
            bl(t);
            break;
          default:
            bl(t);
        }
        e = e.sibling;
      }
    }
    function xl(e, t, n) {
      for (n &&= !!(t.subtreeFlags & 8772), t = t.child; t !== null;) {
        var r = t.alternate,
          i = e,
          a = t,
          o = a.flags;
        switch (a.tag) {
          case 0:
          case 11:
          case 15:
            xl(i, a, n), zc(4, a);
            break;
          case 1:
            if (xl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == `function`) try {
              i.componentDidMount();
            } catch (e) {
              Ju(r, r.return, e);
            }
            if (r = a, i = r.updateQueue, i !== null) {
              var s = r.stateNode;
              try {
                var c = i.shared.hiddenCallbacks;
                if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) K(c[i], s);
              } catch (e) {
                Ju(r, r.return, e);
              }
            }
            n && o & 64 && Vc(a), Uc(a, a.return);
            break;
          case 27:
            Zc(a);
          case 26:
          case 5:
            xl(i, a, n), n && r === null && o & 4 && Gc(a), Uc(a, a.return);
            break;
          case 12:
            xl(i, a, n);
            break;
          case 31:
            xl(i, a, n), n && o & 4 && ul(i, a);
            break;
          case 13:
            xl(i, a, n), n && o & 4 && dl(i, a);
            break;
          case 22:
            a.memoizedState === null && xl(i, a, n), Uc(a, a.return);
            break;
          case 30:
            break;
          default:
            xl(i, a, n);
        }
        t = t.sibling;
      }
    }
    function Sl(e, t) {
      var n = null;
      e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && ra(n));
    }
    function Cl(e, t) {
      e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ra(e));
    }
    function wl(e, t, n, r) {
      if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) q(e, t, n, r), t = t.sibling;
    }
    function q(e, t, n, r) {
      var i = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          wl(e, t, n, r), i & 2048 && zc(9, t);
          break;
        case 1:
          wl(e, t, n, r);
          break;
        case 3:
          wl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ra(e)));
          break;
        case 12:
          if (i & 2048) {
            wl(e, t, n, r), e = t.stateNode;
            try {
              var a = t.memoizedProps,
                o = a.id,
                s = a.onPostCommit;
              typeof s == `function` && s(o, t.alternate === null ? `mount` : `update`, e.passiveEffectDuration, -0);
            } catch (e) {
              Ju(t, t.return, e);
            }
          } else wl(e, t, n, r);
          break;
        case 31:
          wl(e, t, n, r);
          break;
        case 13:
          wl(e, t, n, r);
          break;
        case 23:
          break;
        case 22:
          a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? wl(e, t, n, r) : (a._visibility |= 2, Tl(e, t, n, r, !!(t.subtreeFlags & 10256) || !1)) : a._visibility & 2 ? wl(e, t, n, r) : El(e, t), i & 2048 && Sl(o, t);
          break;
        case 24:
          wl(e, t, n, r), i & 2048 && Cl(t.alternate, t);
          break;
        default:
          wl(e, t, n, r);
      }
    }
    function Tl(e, t, n, r, i) {
      for (i &&= !!(t.subtreeFlags & 10256) || !1, t = t.child; t !== null;) {
        var a = e,
          o = t,
          s = n,
          c = r,
          l = o.flags;
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            Tl(a, o, s, c, i), zc(8, o);
            break;
          case 23:
            break;
          case 22:
            var u = o.stateNode;
            o.memoizedState === null ? (u._visibility |= 2, Tl(a, o, s, c, i)) : u._visibility & 2 ? Tl(a, o, s, c, i) : El(a, o), i && l & 2048 && Sl(o.alternate, o);
            break;
          case 24:
            Tl(a, o, s, c, i), i && l & 2048 && Cl(o.alternate, o);
            break;
          default:
            Tl(a, o, s, c, i);
        }
        t = t.sibling;
      }
    }
    function El(e, t) {
      if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
        var n = e,
          r = t,
          i = r.flags;
        switch (r.tag) {
          case 22:
            El(n, r), i & 2048 && Sl(r.alternate, r);
            break;
          case 24:
            El(n, r), i & 2048 && Cl(r.alternate, r);
            break;
          default:
            El(n, r);
        }
        t = t.sibling;
      }
    }
    var Dl = 8192;
    function Ol(e, t, n) {
      if (e.subtreeFlags & Dl) for (e = e.child; e !== null;) kl(e, t, n), e = e.sibling;
    }
    function kl(e, t, n) {
      switch (e.tag) {
        case 26:
          Ol(e, t, n), e.flags & Dl && e.memoizedState !== null && Xf(n, hl, e.memoizedState, e.memoizedProps);
          break;
        case 5:
          Ol(e, t, n);
          break;
        case 3:
        case 4:
          var r = hl;
          hl = xf(e.stateNode.containerInfo), Ol(e, t, n), hl = r;
          break;
        case 22:
          e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Dl, Dl = 16777216, Ol(e, t, n), Dl = r) : Ol(e, t, n));
          break;
        default:
          Ol(e, t, n);
      }
    }
    function Al(e) {
      var t = e.alternate;
      if (t !== null && (e = t.child, e !== null)) {
        t.child = null;
        do t = e.sibling, e.sibling = null, e = t; while (e !== null);
      }
    }
    function jl(e) {
      var t = e.deletions;
      if (e.flags & 16) {
        if (t !== null) for (var n = 0; n < t.length; n++) {
          var r = t[n];
          nl = r, Pl(r, e);
        }
        Al(e);
      }
      if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Ml(e), e = e.sibling;
    }
    function Ml(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          jl(e), e.flags & 2048 && Bc(9, e, e.return);
          break;
        case 3:
          jl(e);
          break;
        case 12:
          jl(e);
          break;
        case 22:
          var t = e.stateNode;
          e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Nl(e)) : jl(e);
          break;
        default:
          jl(e);
      }
    }
    function Nl(e) {
      var t = e.deletions;
      if (e.flags & 16) {
        if (t !== null) for (var n = 0; n < t.length; n++) {
          var r = t[n];
          nl = r, Pl(r, e);
        }
        Al(e);
      }
      for (e = e.child; e !== null;) {
        switch (t = e, t.tag) {
          case 0:
          case 11:
          case 15:
            Bc(8, t, t.return), Nl(t);
            break;
          case 22:
            n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Nl(t));
            break;
          default:
            Nl(t);
        }
        e = e.sibling;
      }
    }
    function Pl(e, t) {
      for (; nl !== null;) {
        var n = nl;
        switch (n.tag) {
          case 0:
          case 11:
          case 15:
            Bc(8, n, t);
            break;
          case 23:
          case 22:
            if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
              var r = n.memoizedState.cachePool.pool;
              r != null && r.refCount++;
            }
            break;
          case 24:
            ra(n.memoizedState.cache);
        }
        if (r = n.child, r !== null) r.return = n, nl = r;else a: for (n = e; nl !== null;) {
          r = nl;
          var i = r.sibling,
            a = r.return;
          if (al(r), r === n) {
            nl = null;
            break a;
          }
          if (i !== null) {
            i.return = a, nl = i;
            break a;
          }
          nl = a;
        }
      }
    }
    var Fl = {
        getCacheForType: function (e) {
          var t = Yi(ta),
            n = t.data.get(e);
          return n === void 0 && (n = e(), t.data.set(e, n)), n;
        },
        cacheSignal: function () {
          return Yi(ta).controller.signal;
        }
      },
      Il = typeof WeakMap == `function` ? WeakMap : Map,
      Ll = 0,
      Rl = null,
      zl = null,
      Bl = 0,
      Vl = 0,
      Hl = null,
      Ul = !1,
      Wl = !1,
      Gl = !1,
      Kl = 0,
      ql = 0,
      Jl = 0,
      Yl = 0,
      Xl = 0,
      Zl = 0,
      Ql = 0,
      $l = null,
      eu = null,
      tu = !1,
      nu = 0,
      ru = 0,
      iu = 1 / 0,
      au = null,
      ou = null,
      su = 0,
      cu = null,
      lu = null,
      uu = 0,
      du = 0,
      fu = null,
      pu = null,
      mu = 0,
      hu = null;
    function gu() {
      return Ll & 2 && Bl !== 0 ? Bl & -Bl : I.T === null ? Qe() : hd();
    }
    function _u() {
      if (Zl === 0) {
        if (!(Bl & 536870912) || Oi) {
          var e = Le;
          Le <<= 1, !(Le & 3932160) && (Le = 262144), Zl = e;
        } else Zl = 536870912;
      }
      return e = Xa.current, e !== null && (e.flags |= 32), Zl;
    }
    function vu(e, t, n) {
      (e === Rl && (Vl === 2 || Vl === 9) || e.cancelPendingCommit !== null) && (Tu(e, 0), Su(e, Bl, Zl, !1)), Ge(e, n), (!(Ll & 2) || e !== Rl) && (e === Rl && (!(Ll & 2) && (Yl |= n), ql === 4 && Su(e, Bl, Zl, !1)), sd(e));
    }
    function yu(e, t, n) {
      if (Ll & 6) throw Error(a(327));
      var r = !n && !(t & 127) && (t & e.expiredLanes) === 0 || Ve(e, t),
        i = r ? Nu(e, t) : ju(e, t, !0),
        o = r;
      do {
        if (i === 0) {
          Wl && !r && Su(e, t, 0, !1);
          break;
        }
        if (n = e.current.alternate, o && !xu(n)) {
          i = ju(e, t, !1), o = !1;
          continue;
        }
        if (i === 2) {
          if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
          if (s !== 0) {
            t = s;
            a: {
              var c = e;
              i = $l;
              var l = c.current.memoizedState.isDehydrated;
              if (l && (Tu(c, s).flags |= 256), s = ju(c, s, !1), s !== 2) {
                if (Gl && !l) {
                  c.errorRecoveryDisabledLanes |= o, Yl |= o, i = 4;
                  break a;
                }
                o = eu, eu = i, o !== null && (eu === null ? eu = o : eu.push.apply(eu, o));
              }
              i = s;
            }
            if (o = !1, i !== 2) continue;
          }
        }
        if (i === 1) {
          Tu(e, 0), Su(e, t, 0, !0);
          break;
        }
        a: {
          switch (r = e, o = i, o) {
            case 0:
            case 1:
              throw Error(a(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              Su(r, t, Zl, !Ul);
              break a;
            case 2:
              eu = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(a(329));
          }
          if ((t & 62914560) === t && (i = nu + 300 - be(), 10 < i)) {
            if (Su(r, t, Zl, !Ul), Be(r, 0, !0) !== 0) break a;
            uu = t, r.timeoutHandle = Zd(bu.bind(null, r, n, eu, au, tu, t, Zl, Yl, Ql, Ul, o, `Throttled`, -0, 0), i);
            break a;
          }
          bu(r, n, eu, au, tu, t, Zl, Yl, Ql, Ul, o, null, -0, 0);
        }
        break;
      } while (1);
      sd(e);
    }
    function bu(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
      if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
        d = {
          stylesheets: null,
          count: 0,
          imgCount: 0,
          imgBytes: 0,
          suspenseyImages: [],
          waitingForImages: !0,
          waitingForViewTransition: !1,
          unsuspend: Jt
        }, kl(t, a, d);
        var m = (a & 62914560) === a ? nu - be() : (a & 4194048) === a ? ru - be() : 0;
        if (m = Qf(d, m), m !== null) {
          uu = a, e.cancelPendingCommit = m(Bu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), Su(e, a, o, !l);
          return;
        }
      }
      Bu(e, t, a, n, r, i, o, s, c);
    }
    function xu(e) {
      for (var t = e;;) {
        var n = t.tag;
        if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
          var i = n[r],
            a = i.getSnapshot;
          i = i.value;
          try {
            if (!hr(a(), i)) return !1;
          } catch {
            return !1;
          }
        }
        if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;else {
          if (t === e) break;
          for (; t.sibling === null;) {
            if (t.return === null || t.return === e) return !0;
            t = t.return;
          }
          t.sibling.return = t.return, t = t.sibling;
        }
      }
      return !0;
    }
    function Su(e, t, n, r) {
      t &= ~Xl, t &= ~Yl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
      for (var i = t; 0 < i;) {
        var a = 31 - Me(i),
          o = 1 << a;
        r[a] = -1, i &= ~o;
      }
      n !== 0 && qe(e, n, t);
    }
    function Cu() {
      return Ll & 6 ? !0 : (cd(0, !1), !1);
    }
    function wu() {
      if (zl !== null) {
        if (Vl === 0) var e = zl.return;else e = zl, Vi = Bi = null, To(e), Ea = null, Da = 0, e = zl;
        for (; e !== null;) Rc(e.alternate, e), e = e.return;
        zl = null;
      }
    }
    function Tu(e, t) {
      var n = e.timeoutHandle;
      n !== -1 && (e.timeoutHandle = -1, Qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), uu = 0, wu(), Rl = e, zl = n = ri(e.current, null), Bl = t, Vl = 0, Hl = null, Ul = !1, Wl = Ve(e, t), Gl = !1, Ql = Zl = Xl = Yl = Jl = ql = 0, eu = $l = null, tu = !1, t & 8 && (t |= t & 32);
      var r = e.entangledLanes;
      if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
        var i = 31 - Me(r),
          a = 1 << i;
        t |= e[i], r &= ~a;
      }
      return Kl = t, qr(), n;
    }
    function Eu(e, t) {
      oo = null, I.H = Fs, t === ga || t === va ? (t = wa(), Vl = 3) : t === _a ? (t = wa(), Vl = 4) : Vl = t === $s ? 8 : typeof t == `object` && t && typeof t.then == `function` ? 6 : 1, Hl = t, zl === null && (ql = 1, qs(e, di(t, e.current)));
    }
    function Du() {
      var e = Xa.current;
      return e === null ? !0 : (Bl & 4194048) === Bl ? Za === null : (Bl & 62914560) === Bl || Bl & 536870912 ? e === Za : !1;
    }
    function Ou() {
      var e = I.H;
      return I.H = Fs, e === null ? Fs : e;
    }
    function ku() {
      var e = I.A;
      return I.A = Fl, e;
    }
    function Au() {
      ql = 4, Ul || (Bl & 4194048) !== Bl && Xa.current !== null || (Wl = !0), !(Jl & 134217727) && !(Yl & 134217727) || Rl === null || Su(Rl, Bl, Zl, !1);
    }
    function ju(e, t, n) {
      var r = Ll;
      Ll |= 2;
      var i = Ou(),
        a = ku();
      (Rl !== e || Bl !== t) && (au = null, Tu(e, t)), t = !1;
      var o = ql;
      a: do try {
        if (Vl !== 0 && zl !== null) {
          var s = zl,
            c = Hl;
          switch (Vl) {
            case 8:
              wu(), o = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              Xa.current === null && (t = !0);
              var l = Vl;
              if (Vl = 0, Hl = null, Lu(e, s, c, l), n && Wl) {
                o = 0;
                break a;
              }
              break;
            default:
              l = Vl, Vl = 0, Hl = null, Lu(e, s, c, l);
          }
        }
        Mu(), o = ql;
        break;
      } catch (t) {
        Eu(e, t);
      } while (1);
      return t && e.shellSuspendCounter++, Vi = Bi = null, Ll = r, I.H = i, I.A = a, zl === null && (Rl = null, Bl = 0, qr()), o;
    }
    function Mu() {
      for (; zl !== null;) Fu(zl);
    }
    function Nu(e, t) {
      var n = Ll;
      Ll |= 2;
      var r = Ou(),
        i = ku();
      Rl !== e || Bl !== t ? (au = null, iu = be() + 500, Tu(e, t)) : Wl = Ve(e, t);
      a: do try {
        if (Vl !== 0 && zl !== null) {
          t = zl;
          var o = Hl;
          b: switch (Vl) {
            case 1:
              Vl = 0, Hl = null, Lu(e, t, o, 1);
              break;
            case 2:
            case 9:
              if (ba(o)) {
                Vl = 0, Hl = null, Iu(t);
                break;
              }
              t = function () {
                Vl !== 2 && Vl !== 9 || Rl !== e || (Vl = 7), sd(e);
              }, o.then(t, t);
              break a;
            case 3:
              Vl = 7;
              break a;
            case 4:
              Vl = 5;
              break a;
            case 7:
              ba(o) ? (Vl = 0, Hl = null, Iu(t)) : (Vl = 0, Hl = null, Lu(e, t, o, 7));
              break;
            case 5:
              var s = null;
              switch (zl.tag) {
                case 26:
                  s = zl.memoizedState;
                case 5:
                case 27:
                  var c = zl;
                  if (s ? Yf(s) : c.stateNode.complete) {
                    Vl = 0, Hl = null;
                    var l = c.sibling;
                    if (l !== null) zl = l;else {
                      var u = c.return;
                      u === null ? zl = null : (zl = u, Ru(u));
                    }
                    break b;
                  }
              }
              Vl = 0, Hl = null, Lu(e, t, o, 5);
              break;
            case 6:
              Vl = 0, Hl = null, Lu(e, t, o, 6);
              break;
            case 8:
              wu(), ql = 6;
              break a;
            default:
              throw Error(a(462));
          }
        }
        Pu();
        break;
      } catch (t) {
        Eu(e, t);
      } while (1);
      return Vi = Bi = null, I.H = r, I.A = i, Ll = n, zl === null ? (Rl = null, Bl = 0, qr(), ql) : 0;
    }
    function Pu() {
      for (; zl !== null && !ve();) Fu(zl);
    }
    function Fu(e) {
      var t = kc(e.alternate, e, Kl);
      e.memoizedProps = e.pendingProps, t === null ? Ru(e) : zl = t;
    }
    function Iu(e) {
      var t = e,
        n = t.alternate;
      switch (t.tag) {
        case 15:
        case 0:
          t = pc(n, t, t.pendingProps, t.type, void 0, Bl);
          break;
        case 11:
          t = pc(n, t, t.pendingProps, t.type.render, t.ref, Bl);
          break;
        case 5:
          To(t);
        default:
          Rc(n, t), t = zl = ii(t, Kl), t = kc(n, t, Kl);
      }
      e.memoizedProps = e.pendingProps, t === null ? Ru(e) : zl = t;
    }
    function Lu(e, t, n, r) {
      Vi = Bi = null, To(t), Ea = null, Da = 0;
      var i = t.return;
      try {
        if (Qs(e, i, t, n, Bl)) {
          ql = 1, qs(e, di(n, e.current)), zl = null;
          return;
        }
      } catch (t) {
        if (i !== null) throw zl = i, t;
        ql = 1, qs(e, di(n, e.current)), zl = null;
        return;
      }
      t.flags & 32768 ? (Oi || r === 1 ? e = !0 : Wl || Bl & 536870912 ? e = !1 : (Ul = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Xa.current, r !== null && r.tag === 13 && (r.flags |= 16384))), zu(t, e)) : Ru(t);
    }
    function Ru(e) {
      var t = e;
      do {
        if (t.flags & 32768) {
          zu(t, Ul);
          return;
        }
        e = t.return;
        var n = Ic(t.alternate, t, Kl);
        if (n !== null) {
          zl = n;
          return;
        }
        if (t = t.sibling, t !== null) {
          zl = t;
          return;
        }
        zl = t = e;
      } while (t !== null);
      ql === 0 && (ql = 5);
    }
    function zu(e, t) {
      do {
        var n = Lc(e.alternate, e);
        if (n !== null) {
          n.flags &= 32767, zl = n;
          return;
        }
        if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
          zl = e;
          return;
        }
        zl = e = n;
      } while (e !== null);
      ql = 6, zl = null;
    }
    function Bu(e, t, n, r, i, o, s, c, l) {
      e.cancelPendingCommit = null;
      do Gu(); while (su !== 0);
      if (Ll & 6) throw Error(a(327));
      if (t !== null) {
        if (t === e.current) throw Error(a(177));
        if (o = t.lanes | t.childLanes, o |= Kr, Ke(e, n, o, s, c, l), e === Rl && (zl = Rl = null, Bl = 0), lu = t, cu = e, uu = n, du = o, fu = i, pu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, ed(we, function () {
          return Ku(), null;
        })) : (e.callbackNode = null, e.callbackPriority = 0), r = !!(t.flags & 13878), t.subtreeFlags & 13878 || r) {
          r = I.T, I.T = null, i = L.p, L.p = 2, s = Ll, Ll |= 4;
          try {
            rl(e, t, n);
          } finally {
            Ll = s, L.p = i, I.T = r;
          }
        }
        su = 1, Vu(), Hu(), Uu();
      }
    }
    function Vu() {
      if (su === 1) {
        su = 0;
        var e = cu,
          t = lu,
          n = !!(t.flags & 13878);
        if (t.subtreeFlags & 13878 || n) {
          n = I.T, I.T = null;
          var r = L.p;
          L.p = 2;
          var i = Ll;
          Ll |= 4;
          try {
            gl(t, e);
            var a = Wd,
              o = br(e.containerInfo),
              s = a.focusedElem,
              c = a.selectionRange;
            if (o !== s && s && s.ownerDocument && yr(s.ownerDocument.documentElement, s)) {
              if (c !== null && xr(s)) {
                var l = c.start,
                  u = c.end;
                if (u === void 0 && (u = l), `selectionStart` in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);else {
                  var d = s.ownerDocument || document,
                    f = d && d.defaultView || window;
                  if (f.getSelection) {
                    var p = f.getSelection(),
                      m = s.textContent.length,
                      h = Math.min(c.start, m),
                      g = c.end === void 0 ? h : Math.min(c.end, m);
                    !p.extend && h > g && (o = g, g = h, h = o);
                    var _ = vr(s, h),
                      v = vr(s, g);
                    if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
                      var y = d.createRange();
                      y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
                    }
                  }
                }
              }
              for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
                element: p,
                left: p.scrollLeft,
                top: p.scrollTop
              });
              for (typeof s.focus == `function` && s.focus(), s = 0; s < d.length; s++) {
                var b = d[s];
                b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
              }
            }
            fp = !!Ud, Wd = Ud = null;
          } finally {
            Ll = i, L.p = r, I.T = n;
          }
        }
        e.current = t, su = 2;
      }
    }
    function Hu() {
      if (su === 2) {
        su = 0;
        var e = cu,
          t = lu,
          n = !!(t.flags & 8772);
        if (t.subtreeFlags & 8772 || n) {
          n = I.T, I.T = null;
          var r = L.p;
          L.p = 2;
          var i = Ll;
          Ll |= 4;
          try {
            il(e, t.alternate, t);
          } finally {
            Ll = i, L.p = r, I.T = n;
          }
        }
        su = 3;
      }
    }
    function Uu() {
      if (su === 4 || su === 3) {
        su = 0, ye();
        var e = cu,
          t = lu,
          n = uu,
          r = pu;
        t.subtreeFlags & 10256 || t.flags & 10256 ? su = 5 : (su = 0, lu = cu = null, Wu(e, e.pendingLanes));
        var i = e.pendingLanes;
        if (i === 0 && (ou = null), Ze(n), t = t.stateNode, Ae && typeof Ae.onCommitFiberRoot == `function`) try {
          Ae.onCommitFiberRoot(ke, t, void 0, (t.current.flags & 128) == 128);
        } catch {}
        if (r !== null) {
          t = I.T, i = L.p, L.p = 2, I.T = null;
          try {
            for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
              var s = r[o];
              a(s.value, {
                componentStack: s.stack
              });
            }
          } finally {
            I.T = t, L.p = i;
          }
        }
        uu & 3 && Gu(), sd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === hu ? mu++ : (mu = 0, hu = e) : mu = 0, cd(0, !1);
      }
    }
    function Wu(e, t) {
      (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, ra(t)));
    }
    function Gu() {
      return Vu(), Hu(), Uu(), Ku();
    }
    function Ku() {
      if (su !== 5) return !1;
      var e = cu,
        t = du;
      du = 0;
      var n = Ze(uu),
        r = I.T,
        i = L.p;
      try {
        L.p = 32 > n ? 32 : n, I.T = null, n = fu, fu = null;
        var o = cu,
          s = uu;
        if (su = 0, lu = cu = null, uu = 0, Ll & 6) throw Error(a(331));
        var c = Ll;
        if (Ll |= 4, Ml(o.current), q(o, o.current, s, n), Ll = c, cd(0, !1), Ae && typeof Ae.onPostCommitFiberRoot == `function`) try {
          Ae.onPostCommitFiberRoot(ke, o);
        } catch {}
        return !0;
      } finally {
        L.p = i, I.T = r, Wu(e, t);
      }
    }
    function qu(e, t, n) {
      t = di(n, t), t = Ys(e.stateNode, t, 2), e = Ra(e, t, 2), e !== null && (Ge(e, 2), sd(e));
    }
    function Ju(e, t, n) {
      if (e.tag === 3) qu(e, e, n);else for (; t !== null;) {
        if (t.tag === 3) {
          qu(t, e, n);
          break;
        }
        if (t.tag === 1) {
          var r = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == `function` || typeof r.componentDidCatch == `function` && (ou === null || !ou.has(r))) {
            e = di(n, e), n = Xs(2), r = Ra(t, n, 2), r !== null && (Zs(n, r, t, e), Ge(r, 2), sd(r));
            break;
          }
        }
        t = t.return;
      }
    }
    function Yu(e, t, n) {
      var r = e.pingCache;
      if (r === null) {
        r = e.pingCache = new Il();
        var i = new Set();
        r.set(t, i);
      } else i = r.get(t), i === void 0 && (i = new Set(), r.set(t, i));
      i.has(n) || (Gl = !0, i.add(n), e = Xu.bind(null, e, t, n), t.then(e, e));
    }
    function Xu(e, t, n) {
      var r = e.pingCache;
      r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Rl === e && (Bl & n) === n && (ql === 4 || ql === 3 && (Bl & 62914560) === Bl && 300 > be() - nu ? !(Ll & 2) && Tu(e, 0) : Xl |= n, Ql === Bl && (Ql = 0)), sd(e);
    }
    function Zu(e, t) {
      t === 0 && (t = Ue()), e = Xr(e, t), e !== null && (Ge(e, t), sd(e));
    }
    function Qu(e) {
      var t = e.memoizedState,
        n = 0;
      t !== null && (n = t.retryLane), Zu(e, n);
    }
    function $u(e, t) {
      var n = 0;
      switch (e.tag) {
        case 31:
        case 13:
          var r = e.stateNode,
            i = e.memoizedState;
          i !== null && (n = i.retryLane);
          break;
        case 19:
          r = e.stateNode;
          break;
        case 22:
          r = e.stateNode._retryCache;
          break;
        default:
          throw Error(a(314));
      }
      r !== null && r.delete(t), Zu(e, n);
    }
    function ed(e, t) {
      return ge(e, t);
    }
    var td = null,
      nd = null,
      rd = !1,
      id = !1,
      ad = !1,
      od = 0;
    function sd(e) {
      e !== nd && e.next === null && (nd === null ? td = nd = e : nd = nd.next = e), id = !0, rd || (rd = !0, md());
    }
    function cd(e, t) {
      if (!ad && id) {
        ad = !0;
        do for (var n = !1, r = td; r !== null;) {
          if (!t) {
            if (e !== 0) {
              var i = r.pendingLanes;
              if (i === 0) var a = 0;else {
                var o = r.suspendedLanes,
                  s = r.pingedLanes;
                a = (1 << 31 - Me(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
              }
              a !== 0 && (n = !0, pd(r, a));
            } else a = Bl, a = Be(r, r === Rl ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || Ve(r, a) || (n = !0, pd(r, a));
          }
          r = r.next;
        } while (n);
        ad = !1;
      }
    }
    function ld() {
      ud();
    }
    function ud() {
      id = rd = !1;
      var e = 0;
      od !== 0 && Xd() && (e = od);
      for (var t = be(), n = null, r = td; r !== null;) {
        var i = r.next,
          a = dd(r, t);
        a === 0 ? (r.next = null, n === null ? td = i : n.next = i, i === null && (nd = n)) : (n = r, (e !== 0 || a & 3) && (id = !0)), r = i;
      }
      su !== 0 && su !== 5 || cd(e, !1), od !== 0 && (od = 0);
    }
    function dd(e, t) {
      for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
        var o = 31 - Me(a),
          s = 1 << o,
          c = i[o];
        c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = He(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
      }
      if (t = Rl, n = Bl, n = Be(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Vl === 2 || Vl === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && _e(r), e.callbackNode = null, e.callbackPriority = 0;
      if (!(n & 3) || Ve(e, n)) {
        if (t = n & -n, t === e.callbackPriority) return t;
        switch (r !== null && _e(r), Ze(n)) {
          case 2:
          case 8:
            n = Ce;
            break;
          case 32:
            n = we;
            break;
          case 268435456:
            n = Ee;
            break;
          default:
            n = we;
        }
        return r = fd.bind(null, e), n = ge(n, r), e.callbackPriority = t, e.callbackNode = n, t;
      }
      return r !== null && r !== null && _e(r), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function fd(e, t) {
      if (su !== 0 && su !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
      var n = e.callbackNode;
      if (Gu() && e.callbackNode !== n) return null;
      var r = Bl;
      return r = Be(e, e === Rl ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (yu(e, r, t), dd(e, be()), e.callbackNode != null && e.callbackNode === n ? fd.bind(null, e) : null);
    }
    function pd(e, t) {
      if (Gu()) return null;
      yu(e, t, !0);
    }
    function md() {
      ef(function () {
        Ll & 6 ? ge(Se, ld) : ud();
      });
    }
    function hd() {
      if (od === 0) {
        var e = oa;
        e === 0 && (e = Ie, Ie <<= 1, !(Ie & 261888) && (Ie = 256)), od = e;
      }
      return od;
    }
    function gd(e) {
      return e == null || typeof e == `symbol` || typeof e == `boolean` ? null : typeof e == `function` ? e : qt(`` + e);
    }
    function _d(e, t) {
      var n = t.ownerDocument.createElement(`input`);
      return n.name = t.name, n.value = t.value, e.id && n.setAttribute(`form`, e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
    }
    function vd(e, t, n, r, i) {
      if (t === `submit` && n && n.stateNode === i) {
        var a = gd((i[nt] || null).action),
          o = r.submitter;
        o && (t = (t = o[nt] || null) ? gd(t.formAction) : o.getAttribute(`formAction`), t !== null && (a = t, o = null));
        var s = new gn(`action`, `action`, null, r, i);
        e.push({
          event: s,
          listeners: [{
            instance: null,
            listener: function () {
              if (r.defaultPrevented) {
                if (od !== 0) {
                  var e = o ? _d(i, o) : new FormData(i);
                  xs(n, {
                    pending: !0,
                    data: e,
                    method: i.method,
                    action: a
                  }, null, e);
                }
              } else typeof a == `function` && (s.preventDefault(), e = o ? _d(i, o) : new FormData(i), xs(n, {
                pending: !0,
                data: e,
                method: i.method,
                action: a
              }, a, e));
            },
            currentTarget: i
          }]
        });
      }
    }
    for (var yd = 0; yd < Vr.length; yd++) {
      var bd = Vr[yd];
      Hr(bd.toLowerCase(), `on` + (bd[0].toUpperCase() + bd.slice(1)));
    }
    Hr(Nr, `onAnimationEnd`), Hr(Pr, `onAnimationIteration`), Hr(Fr, `onAnimationStart`), Hr(`dblclick`, `onDoubleClick`), Hr(`focusin`, `onFocus`), Hr(`focusout`, `onBlur`), Hr(Ir, `onTransitionRun`), Hr(Lr, `onTransitionStart`), Hr(Rr, `onTransitionCancel`), Hr(zr, `onTransitionEnd`), vt(`onMouseEnter`, [`mouseout`, `mouseover`]), vt(`onMouseLeave`, [`mouseout`, `mouseover`]), vt(`onPointerEnter`, [`pointerout`, `pointerover`]), vt(`onPointerLeave`, [`pointerout`, `pointerover`]), _t(`onChange`, `change click focusin focusout input keydown keyup selectionchange`.split(` `)), _t(`onSelect`, `focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange`.split(` `)), _t(`onBeforeInput`, [`compositionend`, `keypress`, `textInput`, `paste`]), _t(`onCompositionEnd`, `compositionend focusout keydown keypress keyup mousedown`.split(` `)), _t(`onCompositionStart`, `compositionstart focusout keydown keypress keyup mousedown`.split(` `)), _t(`onCompositionUpdate`, `compositionupdate focusout keydown keypress keyup mousedown`.split(` `));
    var xd = `abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting`.split(` `),
      Sd = new Set(`beforetoggle cancel close invalid load scroll scrollend toggle`.split(` `).concat(xd));
    function Cd(e, t) {
      t = !!(t & 4);
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
          i = r.event;
        r = r.listeners;
        a: {
          var a = void 0;
          if (t) for (var o = r.length - 1; 0 <= o; o--) {
            var s = r[o],
              c = s.instance,
              l = s.currentTarget;
            if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
            a = s, i.currentTarget = l;
            try {
              a(i);
            } catch (e) {
              Ur(e);
            }
            i.currentTarget = null, a = c;
          } else for (o = 0; o < r.length; o++) {
            if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
            a = s, i.currentTarget = l;
            try {
              a(i);
            } catch (e) {
              Ur(e);
            }
            i.currentTarget = null, a = c;
          }
        }
      }
    }
    function wd(e, t) {
      var n = t[it];
      n === void 0 && (n = t[it] = new Set());
      var r = e + `__bubble`;
      n.has(r) || (Od(t, e, 2, !1), n.add(r));
    }
    function Td(e, t, n) {
      var r = 0;
      t && (r |= 4), Od(n, e, r, t);
    }
    var Ed = `_reactListening` + Math.random().toString(36).slice(2);
    function Dd(e) {
      if (!e[Ed]) {
        e[Ed] = !0, ht.forEach(function (t) {
          t !== `selectionchange` && (Sd.has(t) || Td(t, !1, e), Td(t, !0, e));
        });
        var t = e.nodeType === 9 ? e : e.ownerDocument;
        t === null || t[Ed] || (t[Ed] = !0, Td(`selectionchange`, !1, t));
      }
    }
    function Od(e, t, n, r) {
      switch (yp(t)) {
        case 2:
          var i = pp;
          break;
        case 8:
          i = mp;
          break;
        default:
          i = hp;
      }
      n = i.bind(null, t, n, e), i = void 0, !an || t !== `touchstart` && t !== `touchmove` && t !== `wheel` || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
        capture: !0,
        passive: i
      }) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, {
        passive: i
      });
    }
    function kd(e, t, n, r, i) {
      var a = r;
      if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
        if (r === null) return;
        var o = r.tag;
        if (o === 3 || o === 4) {
          var s = r.stateNode.containerInfo;
          if (s === i) break;
          if (o === 4) for (o = r.return; o !== null;) {
            var c = o.tag;
            if ((c === 3 || c === 4) && o.stateNode.containerInfo === i) return;
            o = o.return;
          }
          for (; s !== null;) {
            if (o = ut(s), o === null) return;
            if (c = o.tag, c === 5 || c === 6 || c === 26 || c === 27) {
              r = a = o;
              continue a;
            }
            s = s.parentNode;
          }
        }
        r = r.return;
      }
      tn(function () {
        var r = a,
          i = Xt(n),
          o = [];
        a: {
          var s = Br.get(e);
          if (s !== void 0) {
            var c = gn,
              u = e;
            switch (e) {
              case `keypress`:
                if (dn(n) === 0) break a;
              case `keydown`:
              case `keyup`:
                c = Pn;
                break;
              case `focusin`:
                u = `focus`, c = Tn;
                break;
              case `focusout`:
                u = `blur`, c = Tn;
                break;
              case `beforeblur`:
              case `afterblur`:
                c = Tn;
                break;
              case `click`:
                if (n.button === 2) break a;
              case `auxclick`:
              case `dblclick`:
              case `mousedown`:
              case `mousemove`:
              case `mouseup`:
              case `mouseout`:
              case `mouseover`:
              case `contextmenu`:
                c = Cn;
                break;
              case `drag`:
              case `dragend`:
              case `dragenter`:
              case `dragexit`:
              case `dragleave`:
              case `dragover`:
              case `dragstart`:
              case `drop`:
                c = wn;
                break;
              case `touchcancel`:
              case `touchend`:
              case `touchmove`:
              case `touchstart`:
                c = In;
                break;
              case Nr:
              case Pr:
              case Fr:
                c = En;
                break;
              case zr:
                c = Ln;
                break;
              case `scroll`:
              case `scrollend`:
                c = vn;
                break;
              case `wheel`:
                c = Rn;
                break;
              case `copy`:
              case `cut`:
              case `paste`:
                c = Dn;
                break;
              case `gotpointercapture`:
              case `lostpointercapture`:
              case `pointercancel`:
              case `pointerdown`:
              case `pointermove`:
              case `pointerout`:
              case `pointerover`:
              case `pointerup`:
                c = Fn;
                break;
              case `toggle`:
              case `beforetoggle`:
                c = zn;
            }
            var d = !!(t & 4),
              f = !d && (e === `scroll` || e === `scrollend`),
              p = d ? s === null ? null : s + `Capture` : s;
            d = [];
            for (var m = r, h; m !== null;) {
              var g = m;
              if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = nn(m, p), g != null && d.push(Ad(m, g, h))), f) break;
              m = m.return;
            }
            0 < d.length && (s = new c(s, u, null, n, i), o.push({
              event: s,
              listeners: d
            }));
          }
        }
        if (!(t & 7)) {
          a: {
            if (s = e === `mouseover` || e === `pointerover`, c = e === `mouseout` || e === `pointerout`, s && n !== Yt && (u = n.relatedTarget || n.fromElement) && (ut(u) || u[rt])) break a;
            if ((c || s) && (s = i.window === i ? i : (s = i.ownerDocument) ? s.defaultView || s.parentWindow : window, c ? (u = n.relatedTarget || n.toElement, c = r, u = u ? ut(u) : null, u !== null && (f = l(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (c = null, u = r), c !== u)) {
              if (d = Cn, g = `onMouseLeave`, p = `onMouseEnter`, m = `mouse`, (e === `pointerout` || e === `pointerover`) && (d = Fn, g = `onPointerLeave`, p = `onPointerEnter`, m = `pointer`), f = c == null ? s : ft(c), h = u == null ? s : ft(u), s = new d(g, m + `leave`, c, n, i), s.target = f, s.relatedTarget = h, g = null, ut(i) === r && (d = new d(p, m + `enter`, u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, c && u) b: {
                for (d = Md, p = c, m = u, h = 0, g = p; g; g = d(g)) h++;
                g = 0;
                for (var _ = m; _; _ = d(_)) g++;
                for (; 0 < h - g;) p = d(p), h--;
                for (; 0 < g - h;) m = d(m), g--;
                for (; h--;) {
                  if (p === m || m !== null && p === m.alternate) {
                    d = p;
                    break b;
                  }
                  p = d(p), m = d(m);
                }
                d = null;
              } else d = null;
              c !== null && Nd(o, s, c, d, !1), u !== null && f !== null && Nd(o, f, u, d, !0);
            }
          }
          a: {
            if (s = r ? ft(r) : window, c = s.nodeName && s.nodeName.toLowerCase(), c === `select` || c === `input` && s.type === `file`) var v = ir;else if ($n(s)) {
              if (ar) v = G;else {
                v = fr;
                var y = dr;
              }
            } else c = s.nodeName, !c || c.toLowerCase() !== `input` || s.type !== `checkbox` && s.type !== `radio` ? r && Wt(r.elementType) && (v = ir) : v = pr;
            if (v &&= v(e, r)) {
              er(o, v, n, i);
              break a;
            }
            y && y(e, s, r), e === `focusout` && r && s.type === `number` && r.memoizedProps.value != null && It(s, `number`, s.value);
          }
          switch (y = r ? ft(r) : window, e) {
            case `focusin`:
              ($n(y) || y.contentEditable === `true`) && (Cr = y, wr = r, Tr = null);
              break;
            case `focusout`:
              Tr = wr = Cr = null;
              break;
            case `mousedown`:
              Er = !0;
              break;
            case `contextmenu`:
            case `mouseup`:
            case `dragend`:
              Er = !1, Dr(o, n, i);
              break;
            case `selectionchange`:
              if (Sr) break;
            case `keydown`:
            case `keyup`:
              Dr(o, n, i);
          }
          var b;
          if (Vn) b: {
            switch (e) {
              case `compositionstart`:
                var x = `onCompositionStart`;
                break b;
              case `compositionend`:
                x = `onCompositionEnd`;
                break b;
              case `compositionupdate`:
                x = `onCompositionUpdate`;
                break b;
            }
            x = void 0;
          } else Yn ? qn(e, n) && (x = `onCompositionEnd`) : e === `keydown` && n.keyCode === 229 && (x = `onCompositionStart`);
          x && (Wn && n.locale !== `ko` && (Yn || x !== `onCompositionStart` ? x === `onCompositionEnd` && Yn && (b = un()) : (sn = i, cn = `value` in sn ? sn.value : sn.textContent, Yn = !0)), y = jd(r, x), 0 < y.length && (x = new On(x, e, null, n, i), o.push({
            event: x,
            listeners: y
          }), b ? x.data = b : (b = Jn(n), b !== null && (x.data = b)))), (b = Un ? Xn(e, n) : Zn(e, n)) && (x = jd(r, `onBeforeInput`), 0 < x.length && (y = new On(`onBeforeInput`, `beforeinput`, null, n, i), o.push({
            event: y,
            listeners: x
          }), y.data = b)), vd(o, e, r, n, i);
        }
        Cd(o, t);
      });
    }
    function Ad(e, t, n) {
      return {
        instance: e,
        listener: t,
        currentTarget: n
      };
    }
    function jd(e, t) {
      for (var n = t + `Capture`, r = []; e !== null;) {
        var i = e,
          a = i.stateNode;
        if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = nn(e, n), i != null && r.unshift(Ad(e, i, a)), i = nn(e, t), i != null && r.push(Ad(e, i, a))), e.tag === 3) return r;
        e = e.return;
      }
      return [];
    }
    function Md(e) {
      if (e === null) return null;
      do e = e.return; while (e && e.tag !== 5 && e.tag !== 27);
      return e || null;
    }
    function Nd(e, t, n, r, i) {
      for (var a = t._reactName, o = []; n !== null && n !== r;) {
        var s = n,
          c = s.alternate,
          l = s.stateNode;
        if (s = s.tag, c !== null && c === r) break;
        s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = nn(n, a), l != null && o.unshift(Ad(n, l, c))) : i || (l = nn(n, a), l != null && o.push(Ad(n, l, c)))), n = n.return;
      }
      o.length !== 0 && e.push({
        event: t,
        listeners: o
      });
    }
    var Pd = /\r\n?/g,
      Fd = /\u0000|\uFFFD/g;
    function J(e) {
      return (typeof e == `string` ? e : `` + e).replace(Pd, `
`).replace(Fd, ``);
    }
    function Id(e, t) {
      return t = J(t), J(e) === t;
    }
    function Ld(e, t, n, r, i, o) {
      switch (n) {
        case `children`:
          typeof r == `string` ? t === `body` || t === `textarea` && r === `` || Bt(e, r) : (typeof r == `number` || typeof r == `bigint`) && t !== `body` && Bt(e, `` + r);
          break;
        case `className`:
          wt(e, `class`, r);
          break;
        case `tabIndex`:
          wt(e, `tabindex`, r);
          break;
        case `dir`:
        case `role`:
        case `viewBox`:
        case `width`:
        case `height`:
          wt(e, n, r);
          break;
        case `style`:
          Ut(e, r, o);
          break;
        case `data`:
          if (t !== `object`) {
            wt(e, `data`, r);
            break;
          }
        case `src`:
        case `href`:
          if (r === `` && (t !== `a` || n !== `href`)) {
            e.removeAttribute(n);
            break;
          }
          if (r == null || typeof r == `function` || typeof r == `symbol` || typeof r == `boolean`) {
            e.removeAttribute(n);
            break;
          }
          r = qt(`` + r), e.setAttribute(n, r);
          break;
        case `action`:
        case `formAction`:
          if (typeof r == `function`) {
            e.setAttribute(n, `javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')`);
            break;
          }
          if (typeof o == `function` && (n === `formAction` ? (t !== `input` && Ld(e, t, `name`, i.name, i, null), Ld(e, t, `formEncType`, i.formEncType, i, null), Ld(e, t, `formMethod`, i.formMethod, i, null), Ld(e, t, `formTarget`, i.formTarget, i, null)) : (Ld(e, t, `encType`, i.encType, i, null), Ld(e, t, `method`, i.method, i, null), Ld(e, t, `target`, i.target, i, null))), r == null || typeof r == `symbol` || typeof r == `boolean`) {
            e.removeAttribute(n);
            break;
          }
          r = qt(`` + r), e.setAttribute(n, r);
          break;
        case `onClick`:
          r != null && (e.onclick = Jt);
          break;
        case `onScroll`:
          r != null && wd(`scroll`, e);
          break;
        case `onScrollEnd`:
          r != null && wd(`scrollend`, e);
          break;
        case `dangerouslySetInnerHTML`:
          if (r != null) {
            if (typeof r != `object` || !(`__html` in r)) throw Error(a(61));
            if (n = r.__html, n != null) {
              if (i.children != null) throw Error(a(60));
              e.innerHTML = n;
            }
          }
          break;
        case `multiple`:
          e.multiple = r && typeof r != `function` && typeof r != `symbol`;
          break;
        case `muted`:
          e.muted = r && typeof r != `function` && typeof r != `symbol`;
          break;
        case `suppressContentEditableWarning`:
        case `suppressHydrationWarning`:
        case `defaultValue`:
        case `defaultChecked`:
        case `innerHTML`:
        case `ref`:
          break;
        case `autoFocus`:
          break;
        case `xlinkHref`:
          if (r == null || typeof r == `function` || typeof r == `boolean` || typeof r == `symbol`) {
            e.removeAttribute(`xlink:href`);
            break;
          }
          n = qt(`` + r), e.setAttributeNS(`http://www.w3.org/1999/xlink`, `xlink:href`, n);
          break;
        case `contentEditable`:
        case `spellCheck`:
        case `draggable`:
        case `value`:
        case `autoReverse`:
        case `externalResourcesRequired`:
        case `focusable`:
        case `preserveAlpha`:
          r != null && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, `` + r) : e.removeAttribute(n);
          break;
        case `inert`:
        case `allowFullScreen`:
        case `async`:
        case `autoPlay`:
        case `controls`:
        case `default`:
        case `defer`:
        case `disabled`:
        case `disablePictureInPicture`:
        case `disableRemotePlayback`:
        case `formNoValidate`:
        case `hidden`:
        case `loop`:
        case `noModule`:
        case `noValidate`:
        case `open`:
        case `playsInline`:
        case `readOnly`:
        case `required`:
        case `reversed`:
        case `scoped`:
        case `seamless`:
        case `itemScope`:
          r && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, ``) : e.removeAttribute(n);
          break;
        case `capture`:
        case `download`:
          !0 === r ? e.setAttribute(n, ``) : !1 !== r && r != null && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, r) : e.removeAttribute(n);
          break;
        case `cols`:
        case `rows`:
        case `size`:
        case `span`:
          r != null && typeof r != `function` && typeof r != `symbol` && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
          break;
        case `rowSpan`:
        case `start`:
          r == null || typeof r == `function` || typeof r == `symbol` || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
          break;
        case `popover`:
          wd(`beforetoggle`, e), wd(`toggle`, e), Ct(e, `popover`, r);
          break;
        case `xlinkActuate`:
          Tt(e, `http://www.w3.org/1999/xlink`, `xlink:actuate`, r);
          break;
        case `xlinkArcrole`:
          Tt(e, `http://www.w3.org/1999/xlink`, `xlink:arcrole`, r);
          break;
        case `xlinkRole`:
          Tt(e, `http://www.w3.org/1999/xlink`, `xlink:role`, r);
          break;
        case `xlinkShow`:
          Tt(e, `http://www.w3.org/1999/xlink`, `xlink:show`, r);
          break;
        case `xlinkTitle`:
          Tt(e, `http://www.w3.org/1999/xlink`, `xlink:title`, r);
          break;
        case `xlinkType`:
          Tt(e, `http://www.w3.org/1999/xlink`, `xlink:type`, r);
          break;
        case `xmlBase`:
          Tt(e, `http://www.w3.org/XML/1998/namespace`, `xml:base`, r);
          break;
        case `xmlLang`:
          Tt(e, `http://www.w3.org/XML/1998/namespace`, `xml:lang`, r);
          break;
        case `xmlSpace`:
          Tt(e, `http://www.w3.org/XML/1998/namespace`, `xml:space`, r);
          break;
        case `is`:
          Ct(e, `is`, r);
          break;
        case `innerText`:
        case `textContent`:
          break;
        default:
          (!(2 < n.length) || n[0] !== `o` && n[0] !== `O` || n[1] !== `n` && n[1] !== `N`) && (n = Gt.get(n) || n, Ct(e, n, r));
      }
    }
    function Rd(e, t, n, r, i, o) {
      switch (n) {
        case `style`:
          Ut(e, r, o);
          break;
        case `dangerouslySetInnerHTML`:
          if (r != null) {
            if (typeof r != `object` || !(`__html` in r)) throw Error(a(61));
            if (n = r.__html, n != null) {
              if (i.children != null) throw Error(a(60));
              e.innerHTML = n;
            }
          }
          break;
        case `children`:
          typeof r == `string` ? Bt(e, r) : (typeof r == `number` || typeof r == `bigint`) && Bt(e, `` + r);
          break;
        case `onScroll`:
          r != null && wd(`scroll`, e);
          break;
        case `onScrollEnd`:
          r != null && wd(`scrollend`, e);
          break;
        case `onClick`:
          r != null && (e.onclick = Jt);
          break;
        case `suppressContentEditableWarning`:
        case `suppressHydrationWarning`:
        case `innerHTML`:
        case `ref`:
          break;
        case `innerText`:
        case `textContent`:
          break;
        default:
          if (!gt.hasOwnProperty(n)) a: {
            if (n[0] === `o` && n[1] === `n` && (i = n.endsWith(`Capture`), t = n.slice(2, i ? n.length - 7 : void 0), o = e[nt] || null, o = o == null ? null : o[n], typeof o == `function` && e.removeEventListener(t, o, i), typeof r == `function`)) {
              typeof o != `function` && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, i);
              break a;
            }
            n in e ? e[n] = r : !0 === r ? e.setAttribute(n, ``) : Ct(e, n, r);
          }
      }
    }
    function zd(e, t, n) {
      switch (t) {
        case `div`:
        case `span`:
        case `svg`:
        case `path`:
        case `a`:
        case `g`:
        case `p`:
        case `li`:
          break;
        case `img`:
          wd(`error`, e), wd(`load`, e);
          var r = !1,
            i = !1,
            o;
          for (o in n) if (n.hasOwnProperty(o)) {
            var s = n[o];
            if (s != null) switch (o) {
              case `src`:
                r = !0;
                break;
              case `srcSet`:
                i = !0;
                break;
              case `children`:
              case `dangerouslySetInnerHTML`:
                throw Error(a(137, t));
              default:
                Ld(e, t, o, s, n, null);
            }
          }
          i && Ld(e, t, `srcSet`, n.srcSet, n, null), r && Ld(e, t, `src`, n.src, n, null);
          return;
        case `input`:
          wd(`invalid`, e);
          var c = o = s = i = null,
            l = null,
            u = null;
          for (r in n) if (n.hasOwnProperty(r)) {
            var d = n[r];
            if (d != null) switch (r) {
              case `name`:
                i = d;
                break;
              case `type`:
                s = d;
                break;
              case `checked`:
                l = d;
                break;
              case `defaultChecked`:
                u = d;
                break;
              case `value`:
                o = d;
                break;
              case `defaultValue`:
                c = d;
                break;
              case `children`:
              case `dangerouslySetInnerHTML`:
                if (d != null) throw Error(a(137, t));
                break;
              default:
                Ld(e, t, r, d, n, null);
            }
          }
          Ft(e, o, c, l, u, s, i, !1);
          return;
        case `select`:
          for (i in wd(`invalid`, e), r = s = o = null, n) if (n.hasOwnProperty(i) && (c = n[i], c != null)) switch (i) {
            case `value`:
              o = c;
              break;
            case `defaultValue`:
              s = c;
              break;
            case `multiple`:
              r = c;
            default:
              Ld(e, t, i, c, n, null);
          }
          t = o, n = s, e.multiple = !!r, t == null ? n != null && Lt(e, !!r, n, !0) : Lt(e, !!r, t, !1);
          return;
        case `textarea`:
          for (s in wd(`invalid`, e), o = i = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
            case `value`:
              r = c;
              break;
            case `defaultValue`:
              i = c;
              break;
            case `children`:
              o = c;
              break;
            case `dangerouslySetInnerHTML`:
              if (c != null) throw Error(a(91));
              break;
            default:
              Ld(e, t, s, c, n, null);
          }
          zt(e, r, i, o);
          return;
        case `option`:
          for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
            case `selected`:
              e.selected = r && typeof r != `function` && typeof r != `symbol`;
              break;
            default:
              Ld(e, t, l, r, n, null);
          }
          return;
        case `dialog`:
          wd(`beforetoggle`, e), wd(`toggle`, e), wd(`cancel`, e), wd(`close`, e);
          break;
        case `iframe`:
        case `object`:
          wd(`load`, e);
          break;
        case `video`:
        case `audio`:
          for (r = 0; r < xd.length; r++) wd(xd[r], e);
          break;
        case `image`:
          wd(`error`, e), wd(`load`, e);
          break;
        case `details`:
          wd(`toggle`, e);
          break;
        case `embed`:
        case `source`:
        case `link`:
          wd(`error`, e), wd(`load`, e);
        case `area`:
        case `base`:
        case `br`:
        case `col`:
        case `hr`:
        case `keygen`:
        case `meta`:
        case `param`:
        case `track`:
        case `wbr`:
        case `menuitem`:
          for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
            case `children`:
            case `dangerouslySetInnerHTML`:
              throw Error(a(137, t));
            default:
              Ld(e, t, u, r, n, null);
          }
          return;
        default:
          if (Wt(t)) {
            for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Rd(e, t, d, r, n, void 0));
            return;
          }
      }
      for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && Ld(e, t, c, r, n, null));
    }
    function Bd(e, t, n, r) {
      switch (t) {
        case `div`:
        case `span`:
        case `svg`:
        case `path`:
        case `a`:
        case `g`:
        case `p`:
        case `li`:
          break;
        case `input`:
          var i = null,
            o = null,
            s = null,
            c = null,
            l = null,
            u = null,
            d = null;
          for (m in n) {
            var f = n[m];
            if (n.hasOwnProperty(m) && f != null) switch (m) {
              case `checked`:
                break;
              case `value`:
                break;
              case `defaultValue`:
                l = f;
              default:
                r.hasOwnProperty(m) || Ld(e, t, m, null, r, f);
            }
          }
          for (var p in r) {
            var m = r[p];
            if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
              case `type`:
                o = m;
                break;
              case `name`:
                i = m;
                break;
              case `checked`:
                u = m;
                break;
              case `defaultChecked`:
                d = m;
                break;
              case `value`:
                s = m;
                break;
              case `defaultValue`:
                c = m;
                break;
              case `children`:
              case `dangerouslySetInnerHTML`:
                if (m != null) throw Error(a(137, t));
                break;
              default:
                m !== f && Ld(e, t, p, m, r, f);
            }
          }
          Pt(e, s, c, l, u, d, o, i);
          return;
        case `select`:
          for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
            case `value`:
              break;
            case `multiple`:
              m = l;
            default:
              r.hasOwnProperty(o) || Ld(e, t, o, null, r, l);
          }
          for (i in r) if (o = r[i], l = n[i], r.hasOwnProperty(i) && (o != null || l != null)) switch (i) {
            case `value`:
              p = o;
              break;
            case `defaultValue`:
              c = o;
              break;
            case `multiple`:
              s = o;
            default:
              o !== l && Ld(e, t, i, o, r, l);
          }
          t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Lt(e, !!n, n ? [] : ``, !1) : Lt(e, !!n, t, !0)) : Lt(e, !!n, p, !1);
          return;
        case `textarea`:
          for (c in m = p = null, n) if (i = n[c], n.hasOwnProperty(c) && i != null && !r.hasOwnProperty(c)) switch (c) {
            case `value`:
              break;
            case `children`:
              break;
            default:
              Ld(e, t, c, null, r, i);
          }
          for (s in r) if (i = r[s], o = n[s], r.hasOwnProperty(s) && (i != null || o != null)) switch (s) {
            case `value`:
              p = i;
              break;
            case `defaultValue`:
              m = i;
              break;
            case `children`:
              break;
            case `dangerouslySetInnerHTML`:
              if (i != null) throw Error(a(91));
              break;
            default:
              i !== o && Ld(e, t, s, i, r, o);
          }
          Rt(e, p, m);
          return;
        case `option`:
          for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
            case `selected`:
              e.selected = !1;
              break;
            default:
              Ld(e, t, h, null, r, p);
          }
          for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
            case `selected`:
              e.selected = p && typeof p != `function` && typeof p != `symbol`;
              break;
            default:
              Ld(e, t, l, p, r, m);
          }
          return;
        case `img`:
        case `link`:
        case `area`:
        case `base`:
        case `br`:
        case `col`:
        case `embed`:
        case `hr`:
        case `keygen`:
        case `meta`:
        case `param`:
        case `source`:
        case `track`:
        case `wbr`:
        case `menuitem`:
          for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && Ld(e, t, g, null, r, p);
          for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
            case `children`:
            case `dangerouslySetInnerHTML`:
              if (p != null) throw Error(a(137, t));
              break;
            default:
              Ld(e, t, u, p, r, m);
          }
          return;
        default:
          if (Wt(t)) {
            for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Rd(e, t, _, void 0, r, p);
            for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Rd(e, t, d, p, r, m);
            return;
          }
      }
      for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && Ld(e, t, v, null, r, p);
      for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || Ld(e, t, f, p, r, m);
    }
    function Vd(e) {
      switch (e) {
        case `css`:
        case `script`:
        case `font`:
        case `img`:
        case `image`:
        case `input`:
        case `link`:
          return !0;
        default:
          return !1;
      }
    }
    function Hd() {
      if (typeof performance.getEntriesByType == `function`) {
        for (var e = 0, t = 0, n = performance.getEntriesByType(`resource`), r = 0; r < n.length; r++) {
          var i = n[r],
            a = i.transferSize,
            o = i.initiatorType,
            s = i.duration;
          if (a && s && Vd(o)) {
            for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
              var c = n[r],
                l = c.startTime;
              if (l > s) break;
              var u = c.transferSize,
                d = c.initiatorType;
              u && Vd(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
            }
            if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
          }
        }
        if (0 < e) return t / e / 1e6;
      }
      return navigator.connection && (e = navigator.connection.downlink, typeof e == `number`) ? e : 5;
    }
    var Ud = null,
      Wd = null;
    function Gd(e) {
      return e.nodeType === 9 ? e : e.ownerDocument;
    }
    function Kd(e) {
      switch (e) {
        case `http://www.w3.org/2000/svg`:
          return 1;
        case `http://www.w3.org/1998/Math/MathML`:
          return 2;
        default:
          return 0;
      }
    }
    function qd(e, t) {
      if (e === 0) switch (t) {
        case `svg`:
          return 1;
        case `math`:
          return 2;
        default:
          return 0;
      }
      return e === 1 && t === `foreignObject` ? 0 : e;
    }
    function Jd(e, t) {
      return e === `textarea` || e === `noscript` || typeof t.children == `string` || typeof t.children == `number` || typeof t.children == `bigint` || typeof t.dangerouslySetInnerHTML == `object` && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    var Yd = null;
    function Xd() {
      var e = window.event;
      return e && e.type === `popstate` ? e !== Yd && (Yd = e, !0) : (Yd = null, !1);
    }
    var Zd = typeof setTimeout == `function` ? setTimeout : void 0,
      Qd = typeof clearTimeout == `function` ? clearTimeout : void 0,
      $d = typeof Promise == `function` ? Promise : void 0,
      ef = typeof queueMicrotask == `function` ? queueMicrotask : $d === void 0 ? Zd : function (e) {
        return $d.resolve(null).then(e).catch(tf);
      };
    function tf(e) {
      setTimeout(function () {
        throw e;
      });
    }
    function nf(e) {
      return e === `head`;
    }
    function rf(e, t) {
      var n = t,
        r = 0;
      do {
        var i = n.nextSibling;
        if (e.removeChild(n), i && i.nodeType === 8) {
          if (n = i.data, n === `/$` || n === `/&`) {
            if (r === 0) {
              e.removeChild(i), Rp(t);
              return;
            }
            r--;
          } else if (n === `$` || n === `$?` || n === `$~` || n === `$!` || n === `&`) r++;else if (n === `html`) vf(e.ownerDocument.documentElement);else if (n === `head`) {
            n = e.ownerDocument.head, vf(n);
            for (var a = n.firstChild; a;) {
              var o = a.nextSibling,
                s = a.nodeName;
              a[ct] || s === `SCRIPT` || s === `STYLE` || s === `LINK` && a.rel.toLowerCase() === `stylesheet` || n.removeChild(a), a = o;
            }
          } else n === `body` && vf(e.ownerDocument.body);
        }
        n = i;
      } while (n);
      Rp(t);
    }
    function af(e, t) {
      var n = e;
      e = 0;
      do {
        var r = n.nextSibling;
        if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = `none`) : (n.style.display = n._stashedDisplay || ``, n.getAttribute(`style`) === `` && n.removeAttribute(`style`)) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = ``) : n.nodeValue = n._stashedText || ``), r && r.nodeType === 8) {
          if (n = r.data, n === `/$`) {
            if (e === 0) break;
            e--;
          } else n !== `$` && n !== `$?` && n !== `$~` && n !== `$!` || e++;
        }
        n = r;
      } while (n);
    }
    function of(e) {
      var t = e.firstChild;
      for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
        var n = t;
        switch (t = t.nextSibling, n.nodeName) {
          case `HTML`:
          case `HEAD`:
          case `BODY`:
            of(n), lt(n);
            continue;
          case `SCRIPT`:
          case `STYLE`:
            continue;
          case `LINK`:
            if (n.rel.toLowerCase() === `stylesheet`) continue;
        }
        e.removeChild(n);
      }
    }
    function sf(e, t, n, r) {
      for (; e.nodeType === 1;) {
        var i = n;
        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
          if (!r && (e.nodeName !== `INPUT` || e.type !== `hidden`)) break;
        } else if (!r) {
          if (t === `input` && e.type === `hidden`) {
            var a = i.name == null ? null : `` + i.name;
            if (i.type === `hidden` && e.getAttribute(`name`) === a) return e;
          } else return e;
        } else if (!e[ct]) switch (t) {
          case `meta`:
            if (!e.hasAttribute(`itemprop`)) break;
            return e;
          case `link`:
            if (a = e.getAttribute(`rel`), a === `stylesheet` && e.hasAttribute(`data-precedence`) || a !== i.rel || e.getAttribute(`href`) !== (i.href == null || i.href === `` ? null : i.href) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute(`title`) !== (i.title == null ? null : i.title)) break;
            return e;
          case `style`:
            if (e.hasAttribute(`data-precedence`)) break;
            return e;
          case `script`:
            if (a = e.getAttribute(`src`), (a !== (i.src == null ? null : i.src) || e.getAttribute(`type`) !== (i.type == null ? null : i.type) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute(`async`) && !e.hasAttribute(`itemprop`)) break;
            return e;
          default:
            return e;
        }
        if (e = pf(e.nextSibling), e === null) break;
      }
      return null;
    }
    function cf(e, t, n) {
      if (t === ``) return null;
      for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !n || (e = pf(e.nextSibling), e === null)) return null;
      return e;
    }
    function lf(e, t) {
      for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !t || (e = pf(e.nextSibling), e === null)) return null;
      return e;
    }
    function uf(e) {
      return e.data === `$?` || e.data === `$~`;
    }
    function df(e) {
      return e.data === `$!` || e.data === `$?` && e.ownerDocument.readyState !== `loading`;
    }
    function ff(e, t) {
      var n = e.ownerDocument;
      if (e.data === `$~`) e._reactRetry = t;else if (e.data !== `$?` || n.readyState !== `loading`) t();else {
        var r = function () {
          t(), n.removeEventListener(`DOMContentLoaded`, r);
        };
        n.addEventListener(`DOMContentLoaded`, r), e._reactRetry = r;
      }
    }
    function pf(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === 1 || t === 3) break;
        if (t === 8) {
          if (t = e.data, t === `$` || t === `$!` || t === `$?` || t === `$~` || t === `&` || t === `F!` || t === `F`) break;
          if (t === `/$` || t === `/&`) return null;
        }
      }
      return e;
    }
    var mf = null;
    function hf(e) {
      e = e.nextSibling;
      for (var t = 0; e;) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === `/$` || n === `/&`) {
            if (t === 0) return pf(e.nextSibling);
            t--;
          } else n !== `$` && n !== `$!` && n !== `$?` && n !== `$~` && n !== `&` || t++;
        }
        e = e.nextSibling;
      }
      return null;
    }
    function gf(e) {
      e = e.previousSibling;
      for (var t = 0; e;) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === `$` || n === `$!` || n === `$?` || n === `$~` || n === `&`) {
            if (t === 0) return e;
            t--;
          } else n !== `/$` && n !== `/&` || t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    function _f(e, t, n) {
      switch (t = Gd(n), e) {
        case `html`:
          if (e = t.documentElement, !e) throw Error(a(452));
          return e;
        case `head`:
          if (e = t.head, !e) throw Error(a(453));
          return e;
        case `body`:
          if (e = t.body, !e) throw Error(a(454));
          return e;
        default:
          throw Error(a(451));
      }
    }
    function vf(e) {
      for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
      lt(e);
    }
    var yf = new Map(),
      bf = new Set();
    function xf(e) {
      return typeof e.getRootNode == `function` ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
    }
    var Sf = L.d;
    L.d = {
      f: Cf,
      r: wf,
      D: Df,
      C: Of,
      L: kf,
      m: Af,
      X: Mf,
      S: jf,
      M: Nf
    };
    function Cf() {
      var e = Sf.f(),
        t = Cu();
      return e || t;
    }
    function wf(e) {
      var t = dt(e);
      t !== null && t.tag === 5 && t.type === `form` ? Cs(t) : Sf.r(e);
    }
    var Tf = typeof document > `u` ? null : document;
    function Ef(e, t, n) {
      var r = Tf;
      if (r && typeof t == `string` && t) {
        var i = Nt(t);
        i = `link[rel="` + e + `"][href="` + i + `"]`, typeof n == `string` && (i += `[crossorigin="` + n + `"]`), bf.has(i) || (bf.add(i), e = {
          rel: e,
          crossOrigin: n,
          href: t
        }, r.querySelector(i) === null && (t = r.createElement(`link`), zd(t, `link`, e), mt(t), r.head.appendChild(t)));
      }
    }
    function Df(e) {
      Sf.D(e), Ef(`dns-prefetch`, e, null);
    }
    function Of(e, t) {
      Sf.C(e, t), Ef(`preconnect`, e, t);
    }
    function kf(e, t, n) {
      Sf.L(e, t, n);
      var r = Tf;
      if (r && e && t) {
        var i = `link[rel="preload"][as="` + Nt(t) + `"]`;
        t === `image` && n && n.imageSrcSet ? (i += `[imagesrcset="` + Nt(n.imageSrcSet) + `"]`, typeof n.imageSizes == `string` && (i += `[imagesizes="` + Nt(n.imageSizes) + `"]`)) : i += `[href="` + Nt(e) + `"]`;
        var a = i;
        switch (t) {
          case `style`:
            a = Ff(e);
            break;
          case `script`:
            a = zf(e);
        }
        yf.has(a) || (e = h({
          rel: `preload`,
          href: t === `image` && n && n.imageSrcSet ? void 0 : e,
          as: t
        }, n), yf.set(a, e), r.querySelector(i) !== null || t === `style` && r.querySelector(If(a)) || t === `script` && r.querySelector(Bf(a)) || (t = r.createElement(`link`), zd(t, `link`, e), mt(t), r.head.appendChild(t)));
      }
    }
    function Af(e, t) {
      Sf.m(e, t);
      var n = Tf;
      if (n && e) {
        var r = t && typeof t.as == `string` ? t.as : `script`,
          i = `link[rel="modulepreload"][as="` + Nt(r) + `"][href="` + Nt(e) + `"]`,
          a = i;
        switch (r) {
          case `audioworklet`:
          case `paintworklet`:
          case `serviceworker`:
          case `sharedworker`:
          case `worker`:
          case `script`:
            a = zf(e);
        }
        if (!yf.has(a) && (e = h({
          rel: `modulepreload`,
          href: e
        }, t), yf.set(a, e), n.querySelector(i) === null)) {
          switch (r) {
            case `audioworklet`:
            case `paintworklet`:
            case `serviceworker`:
            case `sharedworker`:
            case `worker`:
            case `script`:
              if (n.querySelector(Bf(a))) return;
          }
          r = n.createElement(`link`), zd(r, `link`, e), mt(r), n.head.appendChild(r);
        }
      }
    }
    function jf(e, t, n) {
      Sf.S(e, t, n);
      var r = Tf;
      if (r && e) {
        var i = pt(r).hoistableStyles,
          a = Ff(e);
        t ||= `default`;
        var o = i.get(a);
        if (!o) {
          var s = {
            loading: 0,
            preload: null
          };
          if (o = r.querySelector(If(a))) s.loading = 5;else {
            e = h({
              rel: `stylesheet`,
              href: e,
              "data-precedence": t
            }, n), (n = yf.get(a)) && Uf(e, n);
            var c = o = r.createElement(`link`);
            mt(c), zd(c, `link`, e), c._p = new Promise(function (e, t) {
              c.onload = e, c.onerror = t;
            }), c.addEventListener(`load`, function () {
              s.loading |= 1;
            }), c.addEventListener(`error`, function () {
              s.loading |= 2;
            }), s.loading |= 4, Hf(o, t, r);
          }
          o = {
            type: `stylesheet`,
            instance: o,
            count: 1,
            state: s
          }, i.set(a, o);
        }
      }
    }
    function Mf(e, t) {
      Sf.X(e, t);
      var n = Tf;
      if (n && e) {
        var r = pt(n).hoistableScripts,
          i = zf(e),
          a = r.get(i);
        a || (a = n.querySelector(Bf(i)), a || (e = h({
          src: e,
          async: !0
        }, t), (t = yf.get(i)) && Wf(e, t), a = n.createElement(`script`), mt(a), zd(a, `link`, e), n.head.appendChild(a)), a = {
          type: `script`,
          instance: a,
          count: 1,
          state: null
        }, r.set(i, a));
      }
    }
    function Nf(e, t) {
      Sf.M(e, t);
      var n = Tf;
      if (n && e) {
        var r = pt(n).hoistableScripts,
          i = zf(e),
          a = r.get(i);
        a || (a = n.querySelector(Bf(i)), a || (e = h({
          src: e,
          async: !0,
          type: `module`
        }, t), (t = yf.get(i)) && Wf(e, t), a = n.createElement(`script`), mt(a), zd(a, `link`, e), n.head.appendChild(a)), a = {
          type: `script`,
          instance: a,
          count: 1,
          state: null
        }, r.set(i, a));
      }
    }
    function Pf(e, t, n, r) {
      var i = (i = re.current) ? xf(i) : null;
      if (!i) throw Error(a(446));
      switch (e) {
        case `meta`:
        case `title`:
          return null;
        case `style`:
          return typeof n.precedence == `string` && typeof n.href == `string` ? (t = Ff(n.href), n = pt(i).hoistableStyles, r = n.get(t), r || (r = {
            type: `style`,
            instance: null,
            count: 0,
            state: null
          }, n.set(t, r)), r) : {
            type: `void`,
            instance: null,
            count: 0,
            state: null
          };
        case `link`:
          if (n.rel === `stylesheet` && typeof n.href == `string` && typeof n.precedence == `string`) {
            e = Ff(n.href);
            var o = pt(i).hoistableStyles,
              s = o.get(e);
            if (s || (i = i.ownerDocument || i, s = {
              type: `stylesheet`,
              instance: null,
              count: 0,
              state: {
                loading: 0,
                preload: null
              }
            }, o.set(e, s), (o = i.querySelector(If(e))) && !o._p && (s.instance = o, s.state.loading = 5), yf.has(e) || (n = {
              rel: `preload`,
              as: `style`,
              href: n.href,
              crossOrigin: n.crossOrigin,
              integrity: n.integrity,
              media: n.media,
              hrefLang: n.hrefLang,
              referrerPolicy: n.referrerPolicy
            }, yf.set(e, n), o || Rf(i, e, n, s.state))), t && r === null) throw Error(a(528, ``));
            return s;
          }
          if (t && r !== null) throw Error(a(529, ``));
          return null;
        case `script`:
          return t = n.async, n = n.src, typeof n == `string` && t && typeof t != `function` && typeof t != `symbol` ? (t = zf(n), n = pt(i).hoistableScripts, r = n.get(t), r || (r = {
            type: `script`,
            instance: null,
            count: 0,
            state: null
          }, n.set(t, r)), r) : {
            type: `void`,
            instance: null,
            count: 0,
            state: null
          };
        default:
          throw Error(a(444, e));
      }
    }
    function Ff(e) {
      return `href="` + Nt(e) + `"`;
    }
    function If(e) {
      return `link[rel="stylesheet"][` + e + `]`;
    }
    function Lf(e) {
      return h({}, e, {
        "data-precedence": e.precedence,
        precedence: null
      });
    }
    function Rf(e, t, n, r) {
      e.querySelector(`link[rel="preload"][as="style"][` + t + `]`) ? r.loading = 1 : (t = e.createElement(`link`), r.preload = t, t.addEventListener(`load`, function () {
        return r.loading |= 1;
      }), t.addEventListener(`error`, function () {
        return r.loading |= 2;
      }), zd(t, `link`, n), mt(t), e.head.appendChild(t));
    }
    function zf(e) {
      return `[src="` + Nt(e) + `"]`;
    }
    function Bf(e) {
      return `script[async]` + e;
    }
    function Vf(e, t, n) {
      if (t.count++, t.instance === null) switch (t.type) {
        case `style`:
          var r = e.querySelector(`style[data-href~="` + Nt(n.href) + `"]`);
          if (r) return t.instance = r, mt(r), r;
          var i = h({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return r = (e.ownerDocument || e).createElement(`style`), mt(r), zd(r, `style`, i), Hf(r, n.precedence, e), t.instance = r;
        case `stylesheet`:
          i = Ff(n.href);
          var o = e.querySelector(If(i));
          if (o) return t.state.loading |= 4, t.instance = o, mt(o), o;
          r = Lf(n), (i = yf.get(i)) && Uf(r, i), o = (e.ownerDocument || e).createElement(`link`), mt(o);
          var s = o;
          return s._p = new Promise(function (e, t) {
            s.onload = e, s.onerror = t;
          }), zd(o, `link`, r), t.state.loading |= 4, Hf(o, n.precedence, e), t.instance = o;
        case `script`:
          return o = zf(n.src), (i = e.querySelector(Bf(o))) ? (t.instance = i, mt(i), i) : (r = n, (i = yf.get(o)) && (r = h({}, n), Wf(r, i)), e = e.ownerDocument || e, i = e.createElement(`script`), mt(i), zd(i, `link`, r), e.head.appendChild(i), t.instance = i);
        case `void`:
          return null;
        default:
          throw Error(a(443, t.type));
      } else t.type === `stylesheet` && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Hf(r, n.precedence, e));
      return t.instance;
    }
    function Hf(e, t, n) {
      for (var r = n.querySelectorAll(`link[rel="stylesheet"][data-precedence],style[data-precedence]`), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
        var s = r[o];
        if (s.dataset.precedence === t) a = s;else if (a !== i) break;
      }
      a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
    }
    function Uf(e, t) {
      e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
    }
    function Wf(e, t) {
      e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
    }
    var Gf = null;
    function Kf(e, t, n) {
      if (Gf === null) {
        var r = new Map(),
          i = Gf = new Map();
        i.set(n, r);
      } else i = Gf, r = i.get(n), r || (r = new Map(), i.set(n, r));
      if (r.has(e)) return r;
      for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
        var a = n[i];
        if (!(a[ct] || a[tt] || e === `link` && a.getAttribute(`rel`) === `stylesheet`) && a.namespaceURI !== `http://www.w3.org/2000/svg`) {
          var o = a.getAttribute(t) || ``;
          o = e + o;
          var s = r.get(o);
          s ? s.push(a) : r.set(o, [a]);
        }
      }
      return r;
    }
    function qf(e, t, n) {
      e = e.ownerDocument || e, e.head.insertBefore(n, t === `title` ? e.querySelector(`head > title`) : null);
    }
    function Jf(e, t, n) {
      if (n === 1 || t.itemProp != null) return !1;
      switch (e) {
        case `meta`:
        case `title`:
          return !0;
        case `style`:
          if (typeof t.precedence != `string` || typeof t.href != `string` || t.href === ``) break;
          return !0;
        case `link`:
          if (typeof t.rel != `string` || typeof t.href != `string` || t.href === `` || t.onLoad || t.onError) break;
          switch (t.rel) {
            case `stylesheet`:
              return e = t.disabled, typeof t.precedence == `string` && e == null;
            default:
              return !0;
          }
        case `script`:
          if (t.async && typeof t.async != `function` && typeof t.async != `symbol` && !t.onLoad && !t.onError && t.src && typeof t.src == `string`) return !0;
      }
      return !1;
    }
    function Yf(e) {
      return !(e.type === `stylesheet` && !(e.state.loading & 3));
    }
    function Xf(e, t, n, r) {
      if (n.type === `stylesheet` && (typeof r.media != `string` || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
        if (n.instance === null) {
          var i = Ff(r.href),
            a = t.querySelector(If(i));
          if (a) {
            t = a._p, typeof t == `object` && t && typeof t.then == `function` && (e.count++, e = $f.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, mt(a);
            return;
          }
          a = t.ownerDocument || t, r = Lf(r), (i = yf.get(i)) && Uf(r, i), a = a.createElement(`link`), mt(a);
          var o = a;
          o._p = new Promise(function (e, t) {
            o.onload = e, o.onerror = t;
          }), zd(a, `link`, r), n.instance = a;
        }
        e.stylesheets === null && (e.stylesheets = new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = $f.bind(e), t.addEventListener(`load`, n), t.addEventListener(`error`, n));
      }
    }
    var Zf = 0;
    function Qf(e, t) {
      return e.stylesheets && e.count === 0 && tp(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function (n) {
        var r = setTimeout(function () {
          if (e.stylesheets && tp(e, e.stylesheets), e.unsuspend) {
            var t = e.unsuspend;
            e.unsuspend = null, t();
          }
        }, 6e4 + t);
        0 < e.imgBytes && Zf === 0 && (Zf = 62500 * Hd());
        var i = setTimeout(function () {
          if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && tp(e, e.stylesheets), e.unsuspend)) {
            var t = e.unsuspend;
            e.unsuspend = null, t();
          }
        }, (e.imgBytes > Zf ? 50 : 800) + t);
        return e.unsuspend = n, function () {
          e.unsuspend = null, clearTimeout(r), clearTimeout(i);
        };
      } : null;
    }
    function $f() {
      if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
        if (this.stylesheets) tp(this, this.stylesheets);else if (this.unsuspend) {
          var e = this.unsuspend;
          this.unsuspend = null, e();
        }
      }
    }
    var ep = null;
    function tp(e, t) {
      e.stylesheets = null, e.unsuspend !== null && (e.count++, ep = new Map(), t.forEach(np, e), ep = null, $f.call(e));
    }
    function np(e, t) {
      if (!(t.state.loading & 4)) {
        var n = ep.get(e);
        if (n) var r = n.get(null);else {
          n = new Map(), ep.set(e, n);
          for (var i = e.querySelectorAll(`link[data-precedence],style[data-precedence]`), a = 0; a < i.length; a++) {
            var o = i[a];
            (o.nodeName === `LINK` || o.getAttribute(`media`) !== `not all`) && (n.set(o.dataset.precedence, o), r = o);
          }
          r && n.set(null, r);
        }
        i = t.instance, o = i.getAttribute(`data-precedence`), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = $f.bind(this), i.addEventListener(`load`, r), i.addEventListener(`error`, r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
      }
    }
    var rp = {
      $$typeof: C,
      Provider: null,
      Consumer: null,
      _currentValue: R,
      _currentValue2: R,
      _threadCount: 0
    };
    function ip(e, t, n, r, i, a, o, s, c) {
      this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = We(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = We(0), this.hiddenUpdates = We(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = new Map();
    }
    function ap(e, t, n, r, i, a, o, s, c, l, u, d) {
      return e = new ip(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = ti(3, null, null, t), e.current = a, a.stateNode = e, t = na(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
        element: r,
        isDehydrated: n,
        cache: t
      }, Fa(a), e;
    }
    function op(e) {
      return e ? (e = $r, e) : $r;
    }
    function sp(e, t, n, r, i, a) {
      i = op(i), r.context === null ? r.context = i : r.pendingContext = i, r = La(t), r.payload = {
        element: n
      }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ra(e, r, t), n !== null && (vu(n, e, t), za(n, e, t));
    }
    function cp(e, t) {
      if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
        var n = e.retryLane;
        e.retryLane = n !== 0 && n < t ? n : t;
      }
    }
    function lp(e, t) {
      cp(e, t), (e = e.alternate) && cp(e, t);
    }
    function up(e) {
      if (e.tag === 13 || e.tag === 31) {
        var t = Xr(e, 67108864);
        t !== null && vu(t, e, 67108864), lp(e, 67108864);
      }
    }
    function dp(e) {
      if (e.tag === 13 || e.tag === 31) {
        var t = gu();
        t = Xe(t);
        var n = Xr(e, t);
        n !== null && vu(n, e, t), lp(e, t);
      }
    }
    var fp = !0;
    function pp(e, t, n, r) {
      var i = I.T;
      I.T = null;
      var a = L.p;
      try {
        L.p = 2, hp(e, t, n, r);
      } finally {
        L.p = a, I.T = i;
      }
    }
    function mp(e, t, n, r) {
      var i = I.T;
      I.T = null;
      var a = L.p;
      try {
        L.p = 8, hp(e, t, n, r);
      } finally {
        L.p = a, I.T = i;
      }
    }
    function hp(e, t, n, r) {
      if (fp) {
        var i = gp(r);
        if (i === null) kd(e, t, r, _p, n), Op(e, r);else if (Ap(i, e, t, n, r)) r.stopPropagation();else if (Op(e, r), t & 4 && -1 < Dp.indexOf(e)) {
          for (; i !== null;) {
            var a = dt(i);
            if (a !== null) switch (a.tag) {
              case 3:
                if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
                  var o = ze(a.pendingLanes);
                  if (o !== 0) {
                    var s = a;
                    for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
                      var c = 1 << 31 - Me(o);
                      s.entanglements[1] |= c, o &= ~c;
                    }
                    sd(a), !(Ll & 6) && (iu = be() + 500, cd(0, !1));
                  }
                }
                break;
              case 31:
              case 13:
                s = Xr(a, 2), s !== null && vu(s, a, 2), Cu(), lp(a, 2);
            }
            if (a = gp(r), a === null && kd(e, t, r, _p, n), a === i) break;
            i = a;
          }
          i !== null && r.stopPropagation();
        } else kd(e, t, r, null, n);
      }
    }
    function gp(e) {
      return e = Xt(e), vp(e);
    }
    var _p = null;
    function vp(e) {
      if (_p = null, e = ut(e), e !== null) {
        var t = l(e);
        if (t === null) e = null;else {
          var n = t.tag;
          if (n === 13) {
            if (e = u(t), e !== null) return e;
            e = null;
          } else if (n === 31) {
            if (e = d(t), e !== null) return e;
            e = null;
          } else if (n === 3) {
            if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
            e = null;
          } else t !== e && (e = null);
        }
      }
      return _p = e, null;
    }
    function yp(e) {
      switch (e) {
        case `beforetoggle`:
        case `cancel`:
        case `click`:
        case `close`:
        case `contextmenu`:
        case `copy`:
        case `cut`:
        case `auxclick`:
        case `dblclick`:
        case `dragend`:
        case `dragstart`:
        case `drop`:
        case `focusin`:
        case `focusout`:
        case `input`:
        case `invalid`:
        case `keydown`:
        case `keypress`:
        case `keyup`:
        case `mousedown`:
        case `mouseup`:
        case `paste`:
        case `pause`:
        case `play`:
        case `pointercancel`:
        case `pointerdown`:
        case `pointerup`:
        case `ratechange`:
        case `reset`:
        case `resize`:
        case `seeked`:
        case `submit`:
        case `toggle`:
        case `touchcancel`:
        case `touchend`:
        case `touchstart`:
        case `volumechange`:
        case `change`:
        case `selectionchange`:
        case `textInput`:
        case `compositionstart`:
        case `compositionend`:
        case `compositionupdate`:
        case `beforeblur`:
        case `afterblur`:
        case `beforeinput`:
        case `blur`:
        case `fullscreenchange`:
        case `focus`:
        case `hashchange`:
        case `popstate`:
        case `select`:
        case `selectstart`:
          return 2;
        case `drag`:
        case `dragenter`:
        case `dragexit`:
        case `dragleave`:
        case `dragover`:
        case `mousemove`:
        case `mouseout`:
        case `mouseover`:
        case `pointermove`:
        case `pointerout`:
        case `pointerover`:
        case `scroll`:
        case `touchmove`:
        case `wheel`:
        case `mouseenter`:
        case `mouseleave`:
        case `pointerenter`:
        case `pointerleave`:
          return 8;
        case `message`:
          switch (xe()) {
            case Se:
              return 2;
            case Ce:
              return 8;
            case we:
            case Te:
              return 32;
            case Ee:
              return 268435456;
            default:
              return 32;
          }
        default:
          return 32;
      }
    }
    var bp = !1,
      xp = null,
      Sp = null,
      Cp = null,
      wp = new Map(),
      Tp = new Map(),
      Ep = [],
      Dp = `mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset`.split(` `);
    function Op(e, t) {
      switch (e) {
        case `focusin`:
        case `focusout`:
          xp = null;
          break;
        case `dragenter`:
        case `dragleave`:
          Sp = null;
          break;
        case `mouseover`:
        case `mouseout`:
          Cp = null;
          break;
        case `pointerover`:
        case `pointerout`:
          wp.delete(t.pointerId);
          break;
        case `gotpointercapture`:
        case `lostpointercapture`:
          Tp.delete(t.pointerId);
      }
    }
    function kp(e, t, n, r, i, a) {
      return e === null || e.nativeEvent !== a ? (e = {
        blockedOn: t,
        domEventName: n,
        eventSystemFlags: r,
        nativeEvent: a,
        targetContainers: [i]
      }, t !== null && (t = dt(t), t !== null && up(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
    }
    function Ap(e, t, n, r, i) {
      switch (t) {
        case `focusin`:
          return xp = kp(xp, e, t, n, r, i), !0;
        case `dragenter`:
          return Sp = kp(Sp, e, t, n, r, i), !0;
        case `mouseover`:
          return Cp = kp(Cp, e, t, n, r, i), !0;
        case `pointerover`:
          var a = i.pointerId;
          return wp.set(a, kp(wp.get(a) || null, e, t, n, r, i)), !0;
        case `gotpointercapture`:
          return a = i.pointerId, Tp.set(a, kp(Tp.get(a) || null, e, t, n, r, i)), !0;
      }
      return !1;
    }
    function jp(e) {
      var t = ut(e.target);
      if (t !== null) {
        var n = l(t);
        if (n !== null) {
          if (t = n.tag, t === 13) {
            if (t = u(n), t !== null) {
              e.blockedOn = t, $e(e.priority, function () {
                dp(n);
              });
              return;
            }
          } else if (t === 31) {
            if (t = d(n), t !== null) {
              e.blockedOn = t, $e(e.priority, function () {
                dp(n);
              });
              return;
            }
          } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
            e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
            return;
          }
        }
      }
      e.blockedOn = null;
    }
    function Mp(e) {
      if (e.blockedOn !== null) return !1;
      for (var t = e.targetContainers; 0 < t.length;) {
        var n = gp(e.nativeEvent);
        if (n === null) {
          n = e.nativeEvent;
          var r = new n.constructor(n.type, n);
          Yt = r, n.target.dispatchEvent(r), Yt = null;
        } else return t = dt(n), t !== null && up(t), e.blockedOn = n, !1;
        t.shift();
      }
      return !0;
    }
    function Np(e, t, n) {
      Mp(e) && n.delete(t);
    }
    function Pp() {
      bp = !1, xp !== null && Mp(xp) && (xp = null), Sp !== null && Mp(Sp) && (Sp = null), Cp !== null && Mp(Cp) && (Cp = null), wp.forEach(Np), Tp.forEach(Np);
    }
    function Fp(e, n) {
      e.blockedOn === n && (e.blockedOn = null, bp || (bp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Pp)));
    }
    var Ip = null;
    function Lp(e) {
      Ip !== e && (Ip = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function () {
        Ip === e && (Ip = null);
        for (var t = 0; t < e.length; t += 3) {
          var n = e[t],
            r = e[t + 1],
            i = e[t + 2];
          if (typeof r != `function`) {
            if (vp(r || n) === null) continue;
            break;
          }
          var a = dt(n);
          a !== null && (e.splice(t, 3), t -= 3, xs(a, {
            pending: !0,
            data: i,
            method: n.method,
            action: r
          }, r, i));
        }
      }));
    }
    function Rp(e) {
      function t(t) {
        return Fp(t, e);
      }
      xp !== null && Fp(xp, e), Sp !== null && Fp(Sp, e), Cp !== null && Fp(Cp, e), wp.forEach(t), Tp.forEach(t);
      for (var n = 0; n < Ep.length; n++) {
        var r = Ep[n];
        r.blockedOn === e && (r.blockedOn = null);
      }
      for (; 0 < Ep.length && (n = Ep[0], n.blockedOn === null);) jp(n), n.blockedOn === null && Ep.shift();
      if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
        var i = n[r],
          a = n[r + 1],
          o = i[nt] || null;
        if (typeof a == `function`) o || Lp(n);else if (o) {
          var s = null;
          if (a && a.hasAttribute(`formAction`)) {
            if (i = a, o = a[nt] || null) s = o.formAction;else if (vp(i) !== null) continue;
          } else s = o.action;
          typeof s == `function` ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Lp(n);
        }
      }
    }
    function zp() {
      function e(e) {
        e.canIntercept && e.info === `react-transition` && e.intercept({
          handler: function () {
            return new Promise(function (e) {
              return i = e;
            });
          },
          focusReset: `manual`,
          scroll: `manual`
        });
      }
      function t() {
        i !== null && (i(), i = null), r || setTimeout(n, 20);
      }
      function n() {
        if (!r && !navigation.transition) {
          var e = navigation.currentEntry;
          e && e.url != null && navigation.navigate(e.url, {
            state: e.getState(),
            info: `react-transition`,
            history: `replace`
          });
        }
      }
      if (typeof navigation == `object`) {
        var r = !1,
          i = null;
        return navigation.addEventListener(`navigate`, e), navigation.addEventListener(`navigatesuccess`, t), navigation.addEventListener(`navigateerror`, t), setTimeout(n, 100), function () {
          r = !0, navigation.removeEventListener(`navigate`, e), navigation.removeEventListener(`navigatesuccess`, t), navigation.removeEventListener(`navigateerror`, t), i !== null && (i(), i = null);
        };
      }
    }
    function Bp(e) {
      this._internalRoot = e;
    }
    Vp.prototype.render = Bp.prototype.render = function (e) {
      var t = this._internalRoot;
      if (t === null) throw Error(a(409));
      var n = t.current;
      sp(n, gu(), e, t, null, null);
    }, Vp.prototype.unmount = Bp.prototype.unmount = function () {
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        sp(e.current, 2, null, e, null, null), Cu(), t[rt] = null;
      }
    };
    function Vp(e) {
      this._internalRoot = e;
    }
    Vp.prototype.unstable_scheduleHydration = function (e) {
      if (e) {
        var t = Qe();
        e = {
          blockedOn: null,
          target: e,
          priority: t
        };
        for (var n = 0; n < Ep.length && t !== 0 && t < Ep[n].priority; n++);
        Ep.splice(n, 0, e), n === 0 && jp(e);
      }
    };
    var Hp = n.version;
    if (Hp !== `19.2.8`) throw Error(a(527, Hp, `19.2.8`));
    L.findDOMNode = function (e) {
      var t = e._reactInternals;
      if (t === void 0) throw typeof e.render == `function` ? Error(a(188)) : (e = Object.keys(e).join(`,`), Error(a(268, e)));
      return e = p(t), e = e === null ? null : m(e), e = e === null ? null : e.stateNode, e;
    };
    var Up = {
      bundleType: 0,
      version: `19.2.8`,
      rendererPackageName: `react-dom`,
      currentDispatcherRef: I,
      reconcilerVersion: `19.2.8`
    };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < `u`) {
      var Wp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!Wp.isDisabled && Wp.supportsFiber) try {
        ke = Wp.inject(Up), Ae = Wp;
      } catch {}
    }
    e.createRoot = function (e, t) {
      if (!s(e)) throw Error(a(299));
      var n = !1,
        r = ``,
        i = Ws,
        o = Gs,
        c = Ks;
      return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (i = t.onUncaughtError), t.onCaughtError !== void 0 && (o = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ap(e, 1, !1, null, null, n, r, null, i, o, c, zp), e[rt] = t.current, Dd(e), new Bp(t);
    };
  }),
  u = n((e, t) => {
    function n() {
      if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > `u` || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != `function`)) try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (e) {
        console.error(e);
      }
    }
    n(), t.exports = l();
  }),
  React = e(i(), 1),
  f = u(),
  p = n(e => {
    var t = i().__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    e.c = function (e) {
      return t.H.useMemoCache(e);
    };
  }),
  m = n((e, t) => {
    t.exports = p();
  }),
  h = e(c(), 1),
  ReactCompiler = m(),
  _ = `modulepreload`,
  v = function (e) {
    return `/` + e;
  },
  y = {},
  b = function (e, t, n) {
    let r = Promise.resolve();
    if (t && t.length > 0) {
      let e = document.getElementsByTagName(`link`),
        i = document.querySelector(`meta[property=csp-nonce]`),
        a = i?.nonce || i?.getAttribute(`nonce`);
      function o(e) {
        return Promise.all(e.map(e => Promise.resolve(e).then(e => ({
          status: `fulfilled`,
          value: e
        }), e => ({
          status: `rejected`,
          reason: e
        }))));
      }
      function s(e) {
        return import.meta.resolve ? import.meta.resolve(e) : new URL(e, import.meta.url).href;
      }
      r = o(t.map(t => {
        if (t = v(t, n), t = s(t), t in y) return;
        y[t] = !0;
        let r = t.endsWith(`.css`);
        for (let n = e.length - 1; n >= 0; n--) {
          let i = e[n];
          if (i.href === t && (!r || i.rel === `stylesheet`)) return;
        }
        let i = document.createElement(`link`);
        if (i.rel = r ? `stylesheet` : _, r || (i.as = `script`), i.crossOrigin = ``, i.href = t, a && i.setAttribute(`nonce`, a), document.head.appendChild(i), r) return new Promise((e, n) => {
          i.addEventListener(`load`, e), i.addEventListener(`error`, () => n(Error(`Unable to preload CSS for ${t}`)));
        });
      }));
    }
    function i(e) {
      let t = new Event(`vite:preloadError`, {
        cancelable: !0
      });
      if (t.payload = e, window.dispatchEvent(t), !t.defaultPrevented) throw e;
    }
    return r.then(t => {
      for (let e of t || []) e.status === `rejected` && i(e.reason);
      return e().catch(i);
    });
  },
  x = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i,
  S = /^[\\/]{2}/;
function C(e, t) {
  return t + e.replace(/\\/g, `/`);
}
var w = `popstate`;
function T(e) {
  return typeof e == `object` && !!e && `pathname` in e && `search` in e && `hash` in e && `state` in e && `key` in e;
}
function E(e = {}) {
  function t(e, t) {
    let n = t.state?.masked,
      {
        pathname: r,
        search: i,
        hash: a
      } = n || e.location;
    return j(``, {
      pathname: r,
      search: i,
      hash: a
    }, t.state && t.state.usr || null, t.state && t.state.key || `default`, n ? {
      pathname: e.location.pathname,
      search: e.location.search,
      hash: e.location.hash
    } : void 0);
  }
  function n(e, t) {
    return typeof t == `string` ? t : M(t);
  }
  return P(t, n, null, e);
}
function D(e, t) {
  if (e === !1 || e == null) throw Error(t);
}
function O(e, t) {
  if (!e) {
    typeof console < `u` && console.warn(t);
    try {
      throw Error(t);
    } catch {}
  }
}
function k() {
  return Math.random().toString(36).substring(2, 10);
}
function A(e, t) {
  return {
    usr: e.state,
    key: e.key,
    idx: t,
    masked: e.mask ? {
      pathname: e.pathname,
      search: e.search,
      hash: e.hash
    } : void 0
  };
}
function j(e, t, n = null, r, i) {
  return {
    pathname: typeof e == `string` ? e : e.pathname,
    search: ``,
    hash: ``,
    ...(typeof t == `string` ? N(t) : t),
    state: n,
    key: t && t.key || r || k(),
    mask: i
  };
}
function M({
  pathname: e = `/`,
  search: t = ``,
  hash: n = ``
}) {
  return t && t !== `?` && (e += t.charAt(0) === `?` ? t : `?` + t), n && n !== `#` && (e += n.charAt(0) === `#` ? n : `#` + n), e;
}
function N(e) {
  let t = {};
  if (e) {
    let n = e.indexOf(`#`);
    n >= 0 && (t.hash = e.substring(n), e = e.substring(0, n));
    let r = e.indexOf(`?`);
    r >= 0 && (t.search = e.substring(r), e = e.substring(0, r)), e && (t.pathname = e);
  }
  return t;
}
function P(e, t, n, r = {}) {
  let {
      window: i = document.defaultView,
      v5Compat: a = !1
    } = r,
    o = i.history,
    s = `POP`,
    c = null,
    l = u();
  l ?? (l = 0, o.replaceState({
    ...o.state,
    idx: l
  }, ``));
  function u() {
    return (o.state || {
      idx: null
    }).idx;
  }
  function d() {
    s = `POP`;
    let e = u(),
      t = e == null ? null : e - l;
    l = e, c && c({
      action: s,
      location: h.location,
      delta: t
    });
  }
  function f(e, t) {
    s = `PUSH`;
    let r = T(e) ? e : j(h.location, e, t);
    n && n(r, e), l = u() + 1;
    let d = A(r, l),
      f = h.createHref(r.mask || r);
    try {
      o.pushState(d, ``, f);
    } catch (e) {
      if (e instanceof DOMException && e.name === `DataCloneError`) throw e;
      i.location.assign(f);
    }
    a && c && c({
      action: s,
      location: h.location,
      delta: 1
    });
  }
  function p(e, t) {
    s = `REPLACE`;
    let r = T(e) ? e : j(h.location, e, t);
    n && n(r, e), l = u();
    let i = A(r, l),
      d = h.createHref(r.mask || r);
    o.replaceState(i, ``, d), a && c && c({
      action: s,
      location: h.location,
      delta: 0
    });
  }
  function m(e) {
    return F(i, e);
  }
  let h = {
    get action() {
      return s;
    },
    get location() {
      return e(i, o);
    },
    listen(e) {
      if (c) throw Error(`A history only accepts one active listener`);
      return i.addEventListener(w, d), c = e, () => {
        i.removeEventListener(w, d), c = null;
      };
    },
    createHref(e) {
      return t(i, e);
    },
    createURL: m,
    encodeLocation(e) {
      let t = m(e);
      return {
        pathname: t.pathname,
        search: t.search,
        hash: t.hash
      };
    },
    push: f,
    replace: p,
    go(e) {
      return o.go(e);
    }
  };
  return h;
}
function F(e, t, n = !1) {
  let r = `http://localhost`;
  e && (r = e.location.origin === `null` ? e.location.href : e.location.origin), D(r, `No window.location.(origin|href) available to create URL`);
  let i = typeof t == `string` ? t : M(t);
  return i = i.replace(/ $/, `%20`), !n && S.test(i) && (i = r + i), new URL(i, r);
}
function I(e, t, n = `/`) {
  return L(e, t, n, !1);
}
function L(e, t, n, r, i) {
  let a = fe((typeof t == `string` ? N(t) : t).pathname || `/`, n);
  if (a == null) return null;
  let o = i ?? R(e),
    s = null,
    c = de(a);
  for (let e = 0; s == null && e < o.length; ++e) s = se(o[e], c, r);
  return s;
}
function R(e) {
  let t = z(e);
  return te(t), t;
}
function z(e, t = [], n = [], r = ``, i = !1) {
  let a = (e, a, o = i, s) => {
    let c = {
      relativePath: s === void 0 ? e.path || `` : s,
      caseSensitive: e.caseSensitive === !0,
      childrenIndex: a,
      route: e
    };
    if (c.relativePath.startsWith(`/`)) {
      if (!c.relativePath.startsWith(r) && o) return;
      D(c.relativePath.startsWith(r), `Absolute route path "${c.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`), c.relativePath = c.relativePath.slice(r.length);
    }
    let l = be([r, c.relativePath]),
      u = n.concat(c);
    e.children && e.children.length > 0 && (D(e.index !== !0, `Index routes must not have child routes. Please remove all child routes from route path "${l}".`), z(e.children, t, u, l, o)), (e.path != null || e.index) && t.push({
      path: l,
      score: ae(l, e.index),
      routesMeta: u.map((e, t) => {
        let [n, r] = ue(e.relativePath, e.caseSensitive, t === u.length - 1);
        return {
          ...e,
          matcher: n,
          compiledParams: r
        };
      })
    });
  };
  return e.forEach((e, t) => {
    if (e.path === `` || !e.path?.includes(`?`)) a(e, t);else for (let n of ee(e.path)) a(e, t, !0, n);
  }), t;
}
function ee(e) {
  let t = e.split(`/`);
  if (t.length === 0) return [];
  let [n, ...r] = t,
    i = n.endsWith(`?`),
    a = n.replace(/\?$/, ``);
  if (r.length === 0) return i ? [a, ``] : [a];
  let o = ee(r.join(`/`)),
    s = [];
  return s.push(...o.map(e => e === `` ? a : [a, e].join(`/`))), i && s.push(...o), s.map(t => e.startsWith(`/`) && t === `` ? `/` : t);
}
function te(e) {
  e.sort((e, t) => e.score === t.score ? oe(e.routesMeta.map(e => e.childrenIndex), t.routesMeta.map(e => e.childrenIndex)) : t.score - e.score);
}
var B = /^:[\w-]+$/,
  V = 3,
  H = 2,
  ne = 1,
  re = 10,
  ie = -2,
  U = e => e === `*`;
function ae(e, t) {
  let n = e.split(`/`),
    r = n.length;
  return n.some(U) && (r += ie), t && (r += H), n.filter(e => !U(e)).reduce((e, t) => e + (B.test(t) ? V : t === `` ? ne : re), r);
}
function oe(e, t) {
  return e.length === t.length && e.slice(0, -1).every((e, n) => e === t[n]) ? e[e.length - 1] - t[t.length - 1] : 0;
}
function se(e, t, n = !1) {
  let {
      routesMeta: r
    } = e,
    i = {},
    a = `/`,
    o = [];
  for (let e = 0; e < r.length; ++e) {
    let s = r[e],
      c = e === r.length - 1,
      l = a === `/` ? t : t.slice(a.length) || `/`,
      u = {
        path: s.relativePath,
        caseSensitive: s.caseSensitive,
        end: c
      },
      d = s.matcher && s.compiledParams ? le(u, l, s.matcher, s.compiledParams) : ce(u, l),
      f = s.route;
    if (!d && c && n && !r[r.length - 1].route.index && (d = ce({
      path: s.relativePath,
      caseSensitive: s.caseSensitive,
      end: !1
    }, l)), !d) return null;
    Object.assign(i, d.params), o.push({
      params: i,
      pathname: be([a, d.pathname]),
      pathnameBase: Se(be([a, d.pathnameBase])),
      route: f
    }), d.pathnameBase !== `/` && (a = be([a, d.pathnameBase]));
  }
  return o;
}
function ce(e, t) {
  typeof e == `string` && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, r] = ue(e.path, e.caseSensitive, e.end);
  return le(e, t, n, r);
}
function le(e, t, n, r) {
  let i = t.match(n);
  if (!i) return null;
  let a = i[0],
    o = xe(a, 1),
    s = i.slice(1);
  return {
    params: r.reduce((e, {
      paramName: t,
      isOptional: n
    }, r) => {
      if (t === `*`) {
        let e = s[r] || ``;
        o = xe(a.slice(0, a.length - e.length), 1);
      }
      let i = s[r];
      return e[t] = n && !i ? void 0 : (i || ``).replace(/%2F/g, `/`), e;
    }, {}),
    pathname: a,
    pathnameBase: o,
    pattern: e
  };
}
function ue(e, t = !1, n = !0) {
  O(e === `*` || !e.endsWith(`*`) || e.endsWith(`/*`), `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, `/*`)}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, `/*`)}".`);
  let r = [],
    i = `^` + e.replace(/\/*\*?$/, ``).replace(/^\/*/, `/`).replace(/[\\.*+^${}|()[\]]/g, `\\$&`).replace(/\/:([\w-]+)(\?)?/g, (e, t, n, i, a) => {
      if (r.push({
        paramName: t,
        isOptional: n != null
      }), n) {
        let t = a.charAt(i + e.length);
        return t && t !== `/` ? `/([^\\/]*)` : `(?:/([^\\/]*))?`;
      }
      return `/([^\\/]+)`;
    }).replace(/\/([\w-]+)\?(\/|$)/g, `(/$1)?$2`);
  return e.endsWith(`*`) ? (r.push({
    paramName: `*`
  }), i += e === `*` || e === `/*` ? `(.*)$` : `(?:\\/(.+)|\\/*)$`) : n ? i += `\\/*$` : e !== `` && e !== `/` && (i += `(?:(?=\\/|$))`), [new RegExp(i, t ? void 0 : `i`), r];
}
function de(e) {
  try {
    return e.split(`/`).map(e => decodeURIComponent(e).replace(/\//g, `%2F`)).join(`/`);
  } catch (t) {
    return O(!1, `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`), e;
  }
}
function fe(e, t) {
  if (t === `/`) return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
  let n = t.endsWith(`/`) ? t.length - 1 : t.length,
    r = e.charAt(n);
  return r && r !== `/` ? null : e.slice(n) || `/`;
}
function pe(e, t = `/`) {
  let {
      pathname: n,
      search: r = ``,
      hash: i = ``
    } = typeof e == `string` ? N(e) : e,
    a;
  return n ? (n = ye(n), a = n.startsWith(`/`) || n.startsWith(`\\`) ? me(n.substring(1), `/`) : me(n, t)) : a = t, {
    pathname: a,
    search: Ce(r),
    hash: we(i)
  };
}
function me(e, t) {
  let n = xe(t).split(`/`);
  return e.split(`/`).forEach(e => {
    e === `..` ? n.length > 1 && n.pop() : e !== `.` && n.push(e);
  }), n.length > 1 ? n.join(`/`) : `/`;
}
function he(e, t, n, r) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(r)}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function ge(e) {
  return e.filter((e, t) => t === 0 || e.route.path && e.route.path.length > 0);
}
function _e(e) {
  let t = ge(e);
  return t.map((e, n) => n === t.length - 1 ? e.pathname : e.pathnameBase);
}
function ve(e, t, n, r = !1) {
  let i;
  typeof e == `string` ? i = N(e) : (i = {
    ...e
  }, D(!i.pathname || !i.pathname.includes(`?`), he(`?`, `pathname`, `search`, i)), D(!i.pathname || !i.pathname.includes(`#`), he(`#`, `pathname`, `hash`, i)), D(!i.search || !i.search.includes(`#`), he(`#`, `search`, `hash`, i)));
  let a = e === `` || i.pathname === ``,
    o = a ? `/` : i.pathname,
    s;
  if (o == null) s = n;else {
    let e = t.length - 1;
    if (!r && o.startsWith(`..`)) {
      let t = o.split(`/`);
      for (; t[0] === `..`;) t.shift(), --e;
      i.pathname = t.join(`/`);
    }
    s = e >= 0 ? t[e] : `/`;
  }
  let c = pe(i, s),
    l = o && o !== `/` && o.endsWith(`/`),
    u = (a || o === `.`) && n.endsWith(`/`);
  return !c.pathname.endsWith(`/`) && (l || u) && (c.pathname += `/`), c;
}
var ye = e => e.replace(/[\\/]{2,}/g, `/`),
  be = e => ye(e.join(`/`));
function xe(e, t = 0) {
  let n = e.length;
  for (; n > t && e.charCodeAt(n - 1) === 47;) n--;
  return n === e.length ? e : e.slice(0, n);
}
var Se = e => xe(e).replace(/^\/*/, `/`),
  Ce = e => !e || e === `?` ? `` : e.startsWith(`?`) ? e : `?` + e,
  we = e => !e || e === `#` ? `` : e.startsWith(`#`) ? e : `#` + e,
  Te = class {
    constructor(e, t, n, r = !1) {
      this.status = e, this.statusText = t || ``, this.internal = r, n instanceof Error ? (this.data = n.toString(), this.error = n) : this.data = n;
    }
  };
function Ee(e) {
  return e != null && typeof e.status == `number` && typeof e.statusText == `string` && typeof e.internal == `boolean` && `data` in e;
}
function De(e) {
  return be(e.map(e => e.route.path).filter(Boolean)) || `/`;
}
var Oe = typeof window < `u` && window.document !== void 0 && window.document.createElement !== void 0;
function ke(e, t) {
  let n = e;
  if (typeof n != `string` || !x.test(n)) return {
    absoluteURL: void 0,
    isExternal: !1,
    to: n
  };
  let r = n,
    i = !1;
  if (Oe) try {
    let e = new URL(window.location.href),
      r = S.test(n) ? new URL(C(n, e.protocol)) : new URL(n),
      a = fe(r.pathname, t);
    r.origin === e.origin && a != null ? n = a + r.search + r.hash : i = !0;
  } catch {
    O(!1, `<Link to="${n}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
  }
  return {
    absoluteURL: r,
    isExternal: i,
    to: n
  };
}
Object.getOwnPropertyNames(Object.prototype).sort().join(`\0`);
var Ae = new URL(`http://localhost`);
function je(e) {
  if (e.createURL) return e.createURL(`/`);
  try {
    return new URL(e.createHref(`/`), Ae);
  } catch {
    return Ae;
  }
}
function Me(e, t) {
  return e.origin === t.origin && (e.origin !== `null` || e.protocol === t.protocol && e.host === t.host);
}
function Ne(e, t) {
  if (e.startsWith(`//`)) return !0;
  let n = t.protocol.toLowerCase();
  return e.toLowerCase().startsWith(n) ? t.host === `` || e.slice(n.length).startsWith(`//`) : !1;
}
function Pe(e, t, n, r) {
  let i = null;
  try {
    i = e == null ? null : new URL(e, n);
  } catch {}
  let a = new URL(t, n),
    o = i != null && !Me(i, n),
    s = !Me(a, n);
  if (r === `reject`) {
    if (o || s) throw Error(`External navigation is not allowed`);
  } else if (s && (i == null || !Ne(e, i) || !Me(i, a))) throw Error(`External navigation is not allowed`);
}
var Fe = [`POST`, `PUT`, `PATCH`, `DELETE`];
new Set(Fe);
var Ie = [`GET`, ...Fe];
new Set(Ie);
var Le = [`about:`, `blob:`, `chrome:`, `chrome-untrusted:`, `content:`, `data:`, `devtools:`, `file:`, `filesystem:`, `javascript:`];
function Re(e) {
  try {
    return Le.includes(new URL(e).protocol);
  } catch {
    return !1;
  }
}
var ze = React.createContext(null);
ze.displayName = `DataRouter`;
var Be = React.createContext(null);
Be.displayName = `DataRouterState`;
var Ve = React.createContext(!1);
function He() {
  return React.useContext(Ve);
}
var Ue = React.createContext({
  isTransitioning: !1
});
Ue.displayName = `ViewTransition`;
var We = React.createContext(new Map());
We.displayName = `Fetchers`;
var Ge = React.createContext(null);
Ge.displayName = `Await`;
var Ke = React.createContext(null);
Ke.displayName = `Navigation`;
var qe = React.createContext(null);
qe.displayName = `Location`;
var Je = React.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
Je.displayName = `Route`;
var Ye = React.createContext(null);
Ye.displayName = `RouteError`;
var Xe = `REACT_ROUTER_ERROR`,
  Ze = `REDIRECT`,
  Qe = `ROUTE_ERROR_RESPONSE`;
function $e(e) {
  if (e.startsWith(`${Xe}:${Ze}:{`)) try {
    let t = JSON.parse(e.slice(28));
    if (typeof t == `object` && t && typeof t.status == `number` && typeof t.statusText == `string` && typeof t.location == `string` && typeof t.reloadDocument == `boolean` && typeof t.replace == `boolean`) return t;
  } catch {}
}
function et(e) {
  if (e.startsWith(`${Xe}:${Qe}:{`)) try {
    let t = JSON.parse(e.slice(40));
    if (typeof t == `object` && t && typeof t.status == `number` && typeof t.statusText == `string`) return new Te(t.status, t.statusText, t.data);
  } catch {}
}
function tt(e, {
  relative: t
} = {}) {
  D(nt(), `useHref() may be used only in the context of a <Router> component.`);
  let {
      basename: n,
      navigator: r
    } = React.useContext(Ke),
    {
      hash: i,
      pathname: a,
      search: o
    } = ut(e, {
      relative: t
    }),
    s = a;
  return n !== `/` && (s = a === `/` ? n : be([n, a])), r.createHref({
    pathname: s,
    search: o,
    hash: i
  });
}
function nt() {
  return React.useContext(qe) != null;
}
function rt() {
  return D(nt(), `useLocation() may be used only in the context of a <Router> component.`), React.useContext(qe).location;
}
function it() {
  return React.useContext(qe).navigationType;
}
var at = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function ot(e) {
  React.useContext(Ke).static || React.useLayoutEffect(e);
}
function st() {
  let {
    isDataRoute: e
  } = React.useContext(Je);
  return e ? Dt() : ct();
}
function ct() {
  D(nt(), `useNavigate() may be used only in the context of a <Router> component.`);
  let e = React.useContext(ze),
    {
      basename: t,
      navigator: n
    } = React.useContext(Ke),
    {
      matches: r
    } = React.useContext(Je),
    {
      pathname: i
    } = rt(),
    a = JSON.stringify(_e(r)),
    o = React.useRef(!1);
  return ot(() => {
    o.current = !0;
  }), React.useCallback((r, s = {}) => {
    if (O(o.current, at), !o.current) return;
    if (typeof r == `number`) {
      n.go(r);
      return;
    }
    let c = ve(r, JSON.parse(a), i, s.relative === `path`);
    e == null && t !== `/` && (c.pathname = c.pathname === `/` ? t : be([t, c.pathname])), Pe(typeof r == `string` ? r : M(r), n.createHref(c), je(n), `reject`), (s.replace ? n.replace : n.push)(c, s.state, s);
  }, [t, n, a, i, e]);
}
React.createContext(null);
function lt() {
  let {
    matches: e
  } = React.useContext(Je);
  return e[e.length - 1]?.params ?? {};
}
function ut(e, {
  relative: t
} = {}) {
  let {
      matches: n
    } = React.useContext(Je),
    {
      pathname: r
    } = rt(),
    i = JSON.stringify(_e(n));
  return React.useMemo(() => ve(e, JSON.parse(i), r, t === `path`), [e, i, r, t]);
}
function dt(e, t) {
  return ft(e, t);
}
function ft(e, t, n) {
  D(nt(), `useRoutes() may be used only in the context of a <Router> component.`);
  let {
      navigator: r
    } = React.useContext(Ke),
    {
      matches: i
    } = React.useContext(Je),
    a = i[i.length - 1],
    o = a ? a.params : {},
    s = a ? a.pathname : `/`,
    c = a ? a.pathnameBase : `/`,
    l = a && a.route;
  {
    let e = l && l.path || ``;
    kt(s, !l || e.endsWith(`*`) || e.endsWith(`*?`), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${s}" (under <Route path="${e}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${e}"> to <Route path="${e === `/` ? `*` : `${e}/*`}">.`);
  }
  let u = rt(),
    f;
  if (t) {
    let e = typeof t == `string` ? N(t) : t;
    D(c === `/` || e.pathname?.startsWith(c), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${c}" but pathname "${e.pathname}" was given in the \`location\` prop.`), f = e;
  } else f = u;
  let p = f.pathname || `/`,
    m = p;
  if (c !== `/`) {
    let e = c.replace(/^\//, ``).split(`/`);
    m = `/` + p.replace(/^\//, ``).split(`/`).slice(e.length).join(`/`);
  }
  let h = n && n.state.matches.length ? n.state.matches.map(e => Object.assign(e, {
    route: n.manifest[e.route.id] || e.route
  })) : I(e, {
    pathname: m
  });
  O(l || h != null, `No routes matched location "${f.pathname}${f.search}${f.hash}" `), O(h == null || h[h.length - 1].route.element !== void 0 || h[h.length - 1].route.Component !== void 0 || h[h.length - 1].route.lazy !== void 0, `Matched leaf route at location "${f.pathname}${f.search}${f.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
  let g = yt(h && h.map(e => Object.assign({}, e, {
    params: Object.assign({}, o, e.params),
    pathname: be([c, r.encodeLocation ? r.encodeLocation(e.pathname.replace(/%/g, `%25`).replace(/\?/g, `%3F`).replace(/#/g, `%23`)).pathname : e.pathname]),
    pathnameBase: e.pathnameBase === `/` ? c : be([c, r.encodeLocation ? r.encodeLocation(e.pathnameBase.replace(/%/g, `%25`).replace(/\?/g, `%3F`).replace(/#/g, `%23`)).pathname : e.pathnameBase])
  })), i, n);
  return t && g ? React.createElement(qe.Provider, {
    value: {
      location: {
        pathname: `/`,
        search: ``,
        hash: ``,
        state: null,
        key: `default`,
        mask: void 0,
        ...f
      },
      navigationType: `POP`
    }
  }, g) : g;
}
function pt() {
  let e = Et(),
    t = Ee(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e),
    n = e instanceof Error ? e.stack : null,
    r = `rgba(200,200,200, 0.5)`,
    i = {
      padding: `0.5rem`,
      backgroundColor: r
    },
    a = {
      padding: `2px 4px`,
      backgroundColor: r
    },
    o = null;
  return console.error(`Error handled by React Router default ErrorBoundary:`, e), o = React.createElement(React.Fragment, null, React.createElement(`p`, null, `💿 Hey developer 👋`), React.createElement(`p`, null, `You can provide a way better UX than this when your app throws errors by providing your own `, React.createElement(`code`, {
    style: a
  }, `ErrorBoundary`), ` or`, ` `, React.createElement(`code`, {
    style: a
  }, `errorElement`), ` prop on your route.`)), React.createElement(React.Fragment, null, React.createElement(`h2`, null, `Unexpected Application Error!`), React.createElement(`h3`, {
    style: {
      fontStyle: `italic`
    }
  }, t), n ? React.createElement(`pre`, {
    style: i
  }, n) : null, o);
}
var mt = React.createElement(pt, null),
  ht = class extends React.Component {
    constructor(e) {
      super(e), this.state = {
        location: e.location,
        revalidation: e.revalidation,
        error: e.error
      };
    }
    static getDerivedStateFromError(e) {
      return {
        error: e
      };
    }
    static getDerivedStateFromProps(e, t) {
      return t.location !== e.location || t.revalidation !== `idle` && e.revalidation === `idle` ? {
        error: e.error,
        location: e.location,
        revalidation: e.revalidation
      } : {
        error: e.error === void 0 ? t.error : e.error,
        location: t.location,
        revalidation: e.revalidation || t.revalidation
      };
    }
    componentDidCatch(e, t) {
      this.props.onError ? this.props.onError(e, t) : console.error(`React Router caught the following error during render`, e);
    }
    render() {
      let e = this.state.error;
      if (this.context && typeof e == `object` && e && `digest` in e && typeof e.digest == `string`) {
        let t = et(e.digest);
        t && (e = t);
      }
      let t = e === void 0 ? this.props.children : React.createElement(Je.Provider, {
        value: this.props.routeContext
      }, React.createElement(Ye.Provider, {
        value: e,
        children: this.props.component
      }));
      return this.context ? React.createElement(_t, {
        error: e
      }, t) : t;
    }
  };
ht.contextType = Ve;
var gt = new WeakMap();
function _t({
  children: e,
  error: t
}) {
  let {
    basename: n,
    navigator: r
  } = React.useContext(Ke);
  if (typeof t == `object` && t && `digest` in t && typeof t.digest == `string`) {
    let e = $e(t.digest);
    if (e) {
      let i = gt.get(t);
      if (i) throw i;
      let a = ke(e.location, n),
        o = a.absoluteURL || a.to;
      if (Pe(e.location, o, je(r), `allow-explicit`), Re(o)) throw Error(`Invalid redirect location`);
      if (Oe && !gt.get(t)) {
        if (a.isExternal || e.reloadDocument) window.location.href = o;else {
          let n = Promise.resolve().then(() => window.__reactRouterDataRouter.navigate(a.to, {
            replace: e.replace
          }));
          throw gt.set(t, n), n;
        }
      }
      return React.createElement(`meta`, {
        httpEquiv: `refresh`,
        content: `0;url=${o}`
      });
    }
  }
  return e;
}
function vt({
  routeContext: e,
  match: t,
  children: n
}) {
  let r = React.useContext(ze);
  return r && r.static && r.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (r.staticContext._deepestRenderedBoundaryId = t.route.id), React.createElement(Je.Provider, {
    value: e
  }, n);
}
function yt(e, t = [], n) {
  let r = n?.state;
  if (e == null) {
    if (!r) return null;
    if (r.errors) e = r.matches;else if (t.length === 0 && !r.initialized && r.matches.length > 0) e = r.matches;else return null;
  }
  let i = e,
    a = r?.errors;
  if (a != null) {
    let e = i.findIndex(e => e.route.id && a?.[e.route.id] !== void 0);
    D(e >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(a).join(`,`)}`), i = i.slice(0, Math.min(i.length, e + 1));
  }
  let o = !1,
    s = -1;
  if (n && r) {
    o = r.renderFallback;
    for (let e = 0; e < i.length; e++) {
      let t = i[e];
      if ((t.route.HydrateFallback || t.route.hydrateFallbackElement) && (s = e), t.route.id) {
        let {
            loaderData: e,
            errors: a
          } = r,
          c = t.route.loader && !e.hasOwnProperty(t.route.id) && (!a || a[t.route.id] === void 0);
        if (t.route.lazy || c) {
          n.isStatic && (o = !0), i = s >= 0 ? i.slice(0, s + 1) : [i[0]];
          break;
        }
      }
    }
  }
  let c = n?.onError,
    l = r && c ? (e, t) => {
      c(e, {
        location: r.location,
        params: r.matches?.[0]?.params ?? {},
        pattern: De(r.matches),
        errorInfo: t
      });
    } : void 0;
  return i.reduceRight((e, n, c) => {
    let u,
      f = !1,
      p = null,
      m = null;
    r && (u = a && n.route.id ? a[n.route.id] : void 0, p = n.route.errorElement || mt, o && (s < 0 && c === 0 ? (kt(`route-fallback`, !1, "No `HydrateFallback` element provided to render during initial hydration"), f = !0, m = null) : s === c && (f = !0, m = n.route.hydrateFallbackElement || null)));
    let h = t.concat(i.slice(0, c + 1)),
      g = () => {
        let t;
        return t = u ? p : f ? m : n.route.Component ? React.createElement(n.route.Component, null) : n.route.element ? n.route.element : e, React.createElement(vt, {
          match: n,
          routeContext: {
            outlet: e,
            matches: h,
            isDataRoute: r != null
          },
          children: t
        });
      };
    return r && (n.route.ErrorBoundary || n.route.errorElement || c === 0) ? React.createElement(ht, {
      location: r.location,
      revalidation: r.revalidation,
      component: p,
      error: u,
      children: g(),
      routeContext: {
        outlet: null,
        matches: h,
        isDataRoute: !0
      },
      onError: l
    }) : g();
  }, null);
}
function bt(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function xt(e) {
  let t = React.useContext(ze);
  return D(t, bt(e)), t;
}
function St(e) {
  let t = React.useContext(Be);
  return D(t, bt(e)), t;
}
function Ct(e) {
  let t = React.useContext(Je);
  return D(t, bt(e)), t;
}
function wt(e) {
  let t = Ct(e),
    n = t.matches[t.matches.length - 1];
  return D(n.route.id, `${e} can only be used on routes that contain a unique "id"`), n.route.id;
}
function Tt() {
  return wt(`useRouteId`);
}
function Et() {
  let e = React.useContext(Ye),
    t = St(`useRouteError`),
    n = wt(`useRouteError`);
  return e === void 0 ? t.errors?.[n] : e;
}
function Dt() {
  let {
      router: e
    } = xt(`useNavigate`),
    t = wt(`useNavigate`),
    n = React.useRef(!1);
  return ot(() => {
    n.current = !0;
  }), React.useCallback(async (r, i = {}) => {
    O(n.current, at), n.current && (typeof r == `number` ? await e.navigate(r) : await e.navigate(r, {
      fromRouteId: t,
      ...i
    }));
  }, [e, t]);
}
var Ot = {};
function kt(e, t, n) {
  !t && !Ot[e] && (Ot[e] = !0, O(!1, n));
}
React.memo(At);
function At({
  routes: e,
  manifest: t,
  future: n,
  state: r,
  isStatic: i,
  onError: a
}) {
  return ft(e, void 0, {
    manifest: t,
    state: r,
    isStatic: i,
    onError: a,
    future: n
  });
}
function jt({
  to: e,
  replace: t,
  state: n,
  relative: r
}) {
  D(nt(), `<Navigate> may be used only in the context of a <Router> component.`);
  let {
    static: i,
    navigator: a
  } = React.useContext(Ke);
  O(!i, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
  let {
      matches: o
    } = React.useContext(Je),
    {
      pathname: s
    } = rt(),
    c = st(),
    l = ve(e, _e(o), s, r === `path`);
  Pe(typeof e == `string` ? e : M(e), a.createHref(l), je(a), `reject`);
  let u = JSON.stringify(l);
  return React.useEffect(() => {
    c(JSON.parse(u), {
      replace: t,
      state: n,
      relative: r
    });
  }, [c, u, r, t, n]), null;
}
function Mt(e) {
  D(!1, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function Nt({
  basename: e = `/`,
  children: t = null,
  location: n,
  navigationType: r = `POP`,
  navigator: i,
  static: a = !1,
  useTransitions: o
}) {
  D(!nt(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
  let s = e.replace(/^\/*/, `/`),
    c = React.useMemo(() => ({
      basename: s,
      navigator: i,
      static: a,
      useTransitions: o,
      future: {}
    }), [s, i, a, o]);
  typeof n == `string` && (n = N(n));
  let {
      pathname: l = `/`,
      search: u = ``,
      hash: f = ``,
      state: p = null,
      key: m = `default`,
      mask: h
    } = n,
    g = React.useMemo(() => {
      let e = fe(l, s);
      return e == null ? null : {
        location: {
          pathname: e,
          search: u,
          hash: f,
          state: p,
          key: m,
          mask: h
        },
        navigationType: r
      };
    }, [s, l, u, f, p, m, r, h]);
  return O(g != null, `<Router basename="${s}"> is not able to match the URL "${l}${u}${f}" because it does not start with the basename, so the <Router> won't render anything.`), g == null ? null : React.createElement(Ke.Provider, {
    value: c
  }, React.createElement(qe.Provider, {
    children: t,
    value: g
  }));
}
function Pt({
  children: e,
  location: t
}) {
  return dt(Ft(e), t);
}
React.Component;
function Ft(e, t = []) {
  let n = [];
  return React.Children.forEach(e, (e, r) => {
    if (!React.isValidElement(e)) return;
    let i = [...t, r];
    if (e.type === React.Fragment) {
      n.push.apply(n, Ft(e.props.children, i));
      return;
    }
    D(e.type === Mt, `[${typeof e.type == `string` ? e.type : e.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`), D(!e.props.index || !e.props.children, `An index route cannot have child routes.`);
    let a = {
      id: e.props.id || i.join(`-`),
      caseSensitive: e.props.caseSensitive,
      element: e.props.element,
      Component: e.props.Component,
      index: e.props.index,
      path: e.props.path,
      middleware: e.props.middleware,
      loader: e.props.loader,
      action: e.props.action,
      hydrateFallbackElement: e.props.hydrateFallbackElement,
      HydrateFallback: e.props.HydrateFallback,
      errorElement: e.props.errorElement,
      ErrorBoundary: e.props.ErrorBoundary,
      hasErrorBoundary: e.props.hasErrorBoundary === !0 || e.props.ErrorBoundary != null || e.props.errorElement != null,
      shouldRevalidate: e.props.shouldRevalidate,
      handle: e.props.handle,
      lazy: e.props.lazy
    };
    e.props.children && (a.children = Ft(e.props.children, i)), n.push(a);
  }), n;
}
var It = `get`,
  Lt = `application/x-www-form-urlencoded`;
function Rt(e) {
  return typeof HTMLElement < `u` && e instanceof HTMLElement;
}
function zt(e) {
  return Rt(e) && e.tagName.toLowerCase() === `button`;
}
function Bt(e) {
  return Rt(e) && e.tagName.toLowerCase() === `form`;
}
function Vt(e) {
  return Rt(e) && e.tagName.toLowerCase() === `input`;
}
function Ht(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Ut(e, t) {
  return e.button === 0 && (!t || t === `_self`) && !Ht(e);
}
function Wt(e = ``) {
  return new URLSearchParams(typeof e == `string` || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce((t, n) => {
    let r = e[n];
    return t.concat(Array.isArray(r) ? r.map(e => [n, e]) : [[n, r]]);
  }, []));
}
function Gt(e, t) {
  let n = Wt(e);
  return t && t.forEach((e, r) => {
    n.has(r) || t.getAll(r).forEach(e => {
      n.append(r, e);
    });
  }), n;
}
var Kt = null;
function qt() {
  if (Kt === null) try {
    new FormData(document.createElement(`form`), 0), Kt = !1;
  } catch {
    Kt = !0;
  }
  return Kt;
}
var Jt = new Set([`application/x-www-form-urlencoded`, `multipart/form-data`, `text/plain`]);
function Yt(e) {
  return e != null && !Jt.has(e) ? (O(!1, `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${Lt}"`), null) : e;
}
function Xt(e, t) {
  let n, r, i, a, o;
  if (Bt(e)) {
    let o = e.getAttribute(`action`);
    r = o ? fe(o, t) : null, n = e.getAttribute(`method`) || It, i = Yt(e.getAttribute(`enctype`)) || Lt, a = new FormData(e);
  } else if (zt(e) || Vt(e) && (e.type === `submit` || e.type === `image`)) {
    let o = e.form;
    if (o == null) throw Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
    let s = e.getAttribute(`formaction`) || o.getAttribute(`action`);
    if (r = s ? fe(s, t) : null, n = e.getAttribute(`formmethod`) || o.getAttribute(`method`) || It, i = Yt(e.getAttribute(`formenctype`)) || Yt(o.getAttribute(`enctype`)) || Lt, a = new FormData(o, e), !qt()) {
      let {
        name: t,
        type: n,
        value: r
      } = e;
      if (n === `image`) {
        let e = t ? `${t}.` : ``;
        a.append(`${e}x`, `0`), a.append(`${e}y`, `0`);
      } else t && a.append(t, r);
    }
  } else if (Rt(e)) throw Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);else n = It, r = null, i = Lt, o = e;
  return a && i === `text/plain` && (o = a, a = void 0), {
    action: r,
    method: n.toLowerCase(),
    encType: i,
    formData: a,
    body: o
  };
}
Object.getOwnPropertyNames(Object.prototype).sort().join(`\0`);
function Zt(e, t) {
  if (e === !1 || e == null) throw Error(t);
}
function Qt(e, t, n, r) {
  let i = typeof e == `string` ? new URL(e, typeof window > `u` ? `server://singlefetch/` : window.location.origin) : e;
  return i.pathname = n ? i.pathname.endsWith(`/`) ? `${i.pathname}_.${r}` : `${i.pathname}.${r}` : i.pathname === `/` ? `_root.${r}` : t && fe(i.pathname, t) === `/` ? `${xe(t)}/_root.${r}` : `${xe(i.pathname)}.${r}`, i;
}
async function $t(e, t) {
  if (e.id in t) return t[e.id];
  try {
    let n = await b(() => import(e.module), []);
    return t[e.id] = n, n;
  } catch (t) {
    return console.error(`Error loading route module \`${e.module}\`, reloading page...`), console.error(t), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {});
  }
}
function en(e) {
  return e != null && typeof e.page == `string`;
}
function tn(e) {
  return e == null ? !1 : e.href == null ? e.rel === `preload` && typeof e.imageSrcSet == `string` && typeof e.imageSizes == `string` : typeof e.rel == `string` && typeof e.href == `string`;
}
async function nn(e, t, n) {
  return cn((await Promise.all(e.map(async e => {
    let r = t.routes[e.route.id];
    if (r) {
      let e = await $t(r, n);
      return e.links ? e.links() : [];
    }
    return [];
  }))).flat(1).filter(tn).filter(e => e.rel === `stylesheet` || e.rel === `preload`).map(e => e.rel === `stylesheet` ? {
    ...e,
    rel: `prefetch`,
    as: `style`
  } : {
    ...e,
    rel: `prefetch`
  }));
}
function rn(e, t, n, r, i, a) {
  let o = (e, t) => !n[t] || e.route.id !== n[t].route.id,
    s = (e, t) => n[t].pathname !== e.pathname || n[t].route.path?.endsWith(`*`) && n[t].params[`*`] !== e.params[`*`];
  return a === `assets` ? t.filter((e, t) => o(e, t) || s(e, t)) : a === `data` ? t.filter((t, a) => {
    let c = r.routes[t.route.id];
    if (!c || !c.hasLoader) return !1;
    if (o(t, a) || s(t, a)) return !0;
    if (t.route.shouldRevalidate) {
      let r = t.route.shouldRevalidate({
        currentUrl: new URL(i.pathname + i.search + i.hash, window.origin),
        currentParams: n[0]?.params || {},
        nextUrl: new URL(e, window.origin),
        nextParams: t.params,
        defaultShouldRevalidate: !0
      });
      if (typeof r == `boolean`) return r;
    }
    return !0;
  }) : [];
}
function an(e, t, {
  includeHydrateFallback: n
} = {}) {
  return on(e.map(e => {
    let r = t.routes[e.route.id];
    if (!r) return [];
    let i = [r.module];
    return r.clientActionModule && (i = i.concat(r.clientActionModule)), r.clientLoaderModule && (i = i.concat(r.clientLoaderModule)), n && r.hydrateFallbackModule && (i = i.concat(r.hydrateFallbackModule)), r.imports && (i = i.concat(r.imports)), i;
  }).flat(1));
}
function on(e) {
  return [...new Set(e)];
}
function sn(e) {
  let t = {},
    n = Object.keys(e).sort();
  for (let r of n) t[r] = e[r];
  return t;
}
function cn(e, t) {
  let n = new Set(),
    r = new Set(t);
  return e.reduce((e, i) => {
    if (t && !en(i) && i.as === `script` && i.href && r.has(i.href)) return e;
    let a = JSON.stringify(sn(i));
    return n.has(a) || (n.add(a), e.push({
      key: a,
      link: i
    })), e;
  }, []);
}
function ln() {
  let e = React.useContext(ze);
  return Zt(e, `You must render this element inside a <DataRouterContext.Provider> element`), e;
}
function un() {
  let e = React.useContext(Be);
  return Zt(e, `You must render this element inside a <DataRouterStateContext.Provider> element`), e;
}
var dn = React.createContext(void 0);
dn.displayName = `FrameworkContext`;
function fn() {
  let e = React.useContext(dn);
  return Zt(e, `You must render this element inside a <HydratedRouter> element`), e;
}
function pn(e, t) {
  let n = React.useContext(dn),
    [r, i] = React.useState(!1),
    [a, o] = React.useState(!1),
    {
      onFocus: s,
      onBlur: c,
      onMouseEnter: l,
      onMouseLeave: u,
      onTouchStart: f
    } = t,
    p = React.useRef(null);
  React.useEffect(() => {
    if (e === `render` && o(!0), e === `viewport`) {
      let e = new IntersectionObserver(e => {
        e.forEach(e => {
          o(e.isIntersecting);
        });
      }, {
        threshold: .5
      });
      return p.current && e.observe(p.current), () => {
        e.disconnect();
      };
    }
  }, [e]), React.useEffect(() => {
    if (r) {
      let e = setTimeout(() => {
        o(!0);
      }, 100);
      return () => {
        clearTimeout(e);
      };
    }
  }, [r]);
  let m = () => {
      i(!0);
    },
    h = () => {
      i(!1), o(!1);
    };
  return n ? e === `intent` ? [a, p, {
    onFocus: mn(s, m),
    onBlur: mn(c, h),
    onMouseEnter: mn(l, m),
    onMouseLeave: mn(u, h),
    onTouchStart: mn(f, m)
  }] : [a, p, {}] : [!1, p, {}];
}
function mn(e, t) {
  return n => {
    e && e(n), n.defaultPrevented || t(n);
  };
}
function hn({
  page: e,
  ...t
}) {
  let n = He(),
    {
      nonce: r
    } = fn(),
    {
      router: i
    } = ln(),
    a = React.useMemo(() => I(i.routes, e, i.basename), [i.routes, e, i.basename]);
  return a ? (t.nonce == null && r && (t = {
    ...t,
    nonce: r
  }), n ? React.createElement(_n, {
    page: e,
    matches: a,
    ...t
  }) : React.createElement(vn, {
    page: e,
    matches: a,
    ...t
  })) : null;
}
function gn(e) {
  let {
      manifest: t,
      routeModules: n
    } = fn(),
    [r, i] = React.useState([]);
  return React.useEffect(() => {
    let r = !1;
    return nn(e, t, n).then(e => {
      r || i(e);
    }), () => {
      r = !0;
    };
  }, [e, t, n]), r;
}
function _n({
  page: e,
  matches: t,
  ...n
}) {
  let r = rt(),
    {
      future: i
    } = fn(),
    {
      basename: a
    } = ln(),
    o = React.useMemo(() => {
      if (e === r.pathname + r.search + r.hash) return [];
      let n = Qt(e, a, i.v8_trailingSlashAwareDataRequests, `rsc`),
        o = !1,
        s = [];
      for (let e of t) typeof e.route.shouldRevalidate == `function` ? o = !0 : s.push(e.route.id);
      return o && s.length > 0 && n.searchParams.set(`_routes`, s.join(`,`)), [n.pathname + n.search];
    }, [a, i.v8_trailingSlashAwareDataRequests, e, r, t]);
  return React.createElement(React.Fragment, null, o.map(e => React.createElement(`link`, {
    key: e,
    rel: `prefetch`,
    as: `fetch`,
    href: e,
    ...n
  })));
}
function vn({
  page: e,
  matches: t,
  ...n
}) {
  let r = rt(),
    {
      future: i,
      manifest: a,
      routeModules: o
    } = fn(),
    {
      basename: s
    } = ln(),
    {
      loaderData: c,
      matches: l
    } = un(),
    u = React.useMemo(() => rn(e, t, l, a, r, `data`), [e, t, l, a, r]),
    f = React.useMemo(() => rn(e, t, l, a, r, `assets`), [e, t, l, a, r]),
    p = React.useMemo(() => {
      if (e === r.pathname + r.search + r.hash) return [];
      let n = new Set(),
        l = !1;
      if (t.forEach(e => {
        let t = a.routes[e.route.id];
        t && t.hasLoader && (!u.some(t => t.route.id === e.route.id) && e.route.id in c && o[e.route.id]?.shouldRevalidate || t.hasClientLoader ? l = !0 : n.add(e.route.id));
      }), n.size === 0) return [];
      let d = Qt(e, s, i.v8_trailingSlashAwareDataRequests, `data`);
      return l && n.size > 0 && d.searchParams.set(`_routes`, t.filter(e => n.has(e.route.id)).map(e => e.route.id).join(`,`)), [d.pathname + d.search];
    }, [s, i.v8_trailingSlashAwareDataRequests, c, r, a, u, t, e, o]),
    m = React.useMemo(() => an(f, a), [f, a]),
    h = gn(f);
  return React.createElement(React.Fragment, null, p.map(e => React.createElement(`link`, {
    key: e,
    rel: `prefetch`,
    as: `fetch`,
    href: e,
    ...n
  })), m.map(e => React.createElement(`link`, {
    key: e,
    rel: `modulepreload`,
    href: e,
    ...n
  })), h.map(({
    key: e,
    link: t
  }) => React.createElement(`link`, {
    key: e,
    nonce: n.nonce,
    ...t,
    crossOrigin: t.crossOrigin ?? n.crossOrigin
  })));
}
function yn(...e) {
  return t => {
    e.forEach(e => {
      typeof e == `function` ? e(t) : e != null && (e.current = t);
    });
  };
}
React.Component;
var bn = typeof window < `u` && window.document !== void 0 && window.document.createElement !== void 0;
try {
  bn && (window.__reactRouterVersion = `7.18.3`);
} catch {}
function xn({
  basename: e,
  children: t,
  useTransitions: n,
  window: r
}) {
  let i = React.useRef();
  i.current ??= E({
    window: r,
    v5Compat: !0
  });
  let a = i.current,
    [o, s] = React.useState({
      action: a.action,
      location: a.location
    }),
    c = React.useCallback(e => {
      n === !1 ? s(e) : React.startTransition(() => s(e));
    }, [n]);
  return React.useLayoutEffect(() => a.listen(c), [a, c]), React.createElement(Nt, {
    basename: e,
    children: t,
    location: o.location,
    navigationType: o.action,
    navigator: a,
    useTransitions: n
  });
}
var Sn = React.forwardRef(function ({
  onClick: e,
  discover: t = `render`,
  prefetch: n = `none`,
  relative: r,
  reloadDocument: i,
  replace: a,
  mask: o,
  state: s,
  target: c,
  to: l,
  preventScrollReset: u,
  viewTransition: f,
  defaultShouldRevalidate: p,
  ...m
}, h) {
  let {
      basename: g,
      navigator: _,
      useTransitions: v
    } = React.useContext(Ke),
    y = typeof l == `string` && x.test(l),
    b = ke(l, g);
  l = b.to;
  let S = tt(l, {
      relative: r
    }),
    C = rt(),
    w = null;
  if (o) {
    let e = ve(o, [], C.mask ? C.mask.pathname : `/`, !0);
    g !== `/` && (e.pathname = e.pathname === `/` ? g : be([g, e.pathname])), w = _.createHref(e);
  }
  let [T, E, D] = pn(n, m),
    O = Dn(l, {
      replace: a,
      mask: o,
      state: s,
      target: c,
      preventScrollReset: u,
      relative: r,
      viewTransition: f,
      defaultShouldRevalidate: p,
      useTransitions: v
    });
  function k(t) {
    e && e(t), t.defaultPrevented || O(t);
  }
  let A = !(b.isExternal || i),
    j = React.createElement(`a`, {
      ...m,
      ...D,
      href: (A ? w : void 0) || b.absoluteURL || S,
      onClick: A ? k : e,
      ref: yn(h, E),
      target: c,
      "data-discover": !y && t === `render` ? `true` : void 0
    });
  return T && !y ? React.createElement(React.Fragment, null, j, React.createElement(hn, {
    page: S
  })) : j;
});
Sn.displayName = `Link`;
var Cn = React.forwardRef(function ({
  "aria-current": e = `page`,
  caseSensitive: t = !1,
  className: n = ``,
  end: r = !1,
  style: i,
  to: a,
  viewTransition: o,
  children: s,
  ...c
}, l) {
  let u = ut(a, {
      relative: c.relative
    }),
    f = rt(),
    p = React.useContext(Be),
    {
      navigator: m,
      basename: h
    } = React.useContext(Ke),
    g = p != null && Nn(u) && o === !0,
    _ = m.encodeLocation ? m.encodeLocation(u).pathname : u.pathname,
    v = f.pathname,
    y = p && p.navigation && p.navigation.location ? p.navigation.location.pathname : null;
  t || (v = v.toLowerCase(), y = y ? y.toLowerCase() : null, _ = _.toLowerCase()), y && h && (y = fe(y, h) || y);
  let b = _ !== `/` && _.endsWith(`/`) ? _.length - 1 : _.length,
    x = v === _ || !r && v.startsWith(_) && v.charAt(b) === `/`,
    S = y != null && (y === _ || !r && y.startsWith(_) && y.charAt(_.length) === `/`),
    C = {
      isActive: x,
      isPending: S,
      isTransitioning: g
    },
    w = x ? e : void 0,
    T;
  T = typeof n == `function` ? n(C) : [n, x ? `active` : null, S ? `pending` : null, g ? `transitioning` : null].filter(Boolean).join(` `);
  let E = typeof i == `function` ? i(C) : i;
  return React.createElement(Sn, {
    ...c,
    "aria-current": w,
    className: T,
    ref: l,
    style: E,
    to: a,
    viewTransition: o
  }, typeof s == `function` ? s(C) : s);
});
Cn.displayName = `NavLink`;
var wn = React.forwardRef(({
  discover: e = `render`,
  fetcherKey: t,
  navigate: n,
  reloadDocument: r,
  replace: i,
  state: a,
  method: o = It,
  action: s,
  onSubmit: c,
  relative: l,
  preventScrollReset: u,
  viewTransition: f,
  defaultShouldRevalidate: p,
  ...m
}, h) => {
  let {
      useTransitions: g
    } = React.useContext(Ke),
    _ = jn(),
    v = Mn(s, {
      relative: l
    }),
    y = o.toLowerCase() === `get` ? `get` : `post`,
    b = typeof s == `string` && x.test(s);
  return React.createElement(`form`, {
    ref: h,
    method: y,
    action: v,
    onSubmit: r ? c : e => {
      if (c && c(e), e.defaultPrevented) return;
      e.preventDefault();
      let r = e.nativeEvent.submitter,
        s = r?.getAttribute(`formmethod`) || o,
        m = () => _(r || e.currentTarget, {
          fetcherKey: t,
          method: s,
          navigate: n,
          replace: i,
          state: a,
          relative: l,
          preventScrollReset: u,
          viewTransition: f,
          defaultShouldRevalidate: p
        });
      g && n !== !1 ? React.startTransition(() => m()) : m();
    },
    ...m,
    "data-discover": !b && e === `render` ? `true` : void 0
  });
});
wn.displayName = `Form`;
function Tn(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function En(e) {
  let t = React.useContext(ze);
  return D(t, Tn(e)), t;
}
function Dn(e, {
  target: t,
  replace: n,
  mask: r,
  state: i,
  preventScrollReset: a,
  relative: o,
  viewTransition: s,
  defaultShouldRevalidate: c,
  useTransitions: l
} = {}) {
  let u = st(),
    f = rt(),
    p = ut(e, {
      relative: o
    });
  return React.useCallback(m => {
    if (Ut(m, t)) {
      m.preventDefault();
      let t = n === void 0 ? M(f) === M(p) : n,
        h = () => u(e, {
          replace: t,
          mask: r,
          state: i,
          preventScrollReset: a,
          relative: o,
          viewTransition: s,
          defaultShouldRevalidate: c
        });
      l ? React.startTransition(() => h()) : h();
    }
  }, [f, u, p, n, r, i, t, e, a, o, s, c, l]);
}
function On(e) {
  O(typeof URLSearchParams < `u`, "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
  let t = React.useRef(Wt(e)),
    n = React.useRef(!1),
    r = rt(),
    i = React.useMemo(() => Gt(r.search, n.current ? null : t.current), [r.search]),
    a = st();
  return [i, React.useCallback((e, t) => {
    let r = Wt(typeof e == `function` ? e(new URLSearchParams(i)) : e);
    n.current = !0, a(`?` + r, t);
  }, [a, i])];
}
var kn = 0,
  An = () => `__${String(++kn)}__`;
function jn() {
  let {
      router: e
    } = En(`useSubmit`),
    {
      basename: t
    } = React.useContext(Ke),
    n = Tt(),
    r = e.fetch,
    i = e.navigate;
  return React.useCallback(async (e, a = {}) => {
    let {
      action: o,
      method: s,
      encType: c,
      formData: l,
      body: u
    } = Xt(e, t);
    if (a.navigate === !1) {
      let e = a.fetcherKey || An();
      await r(e, n, a.action || o, {
        defaultShouldRevalidate: a.defaultShouldRevalidate,
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: u,
        formMethod: a.method || s,
        formEncType: a.encType || c,
        flushSync: a.flushSync
      });
    } else await i(a.action || o, {
      defaultShouldRevalidate: a.defaultShouldRevalidate,
      preventScrollReset: a.preventScrollReset,
      formData: l,
      body: u,
      formMethod: a.method || s,
      formEncType: a.encType || c,
      replace: a.replace,
      state: a.state,
      fromRouteId: n,
      flushSync: a.flushSync,
      viewTransition: a.viewTransition
    });
  }, [r, i, t, n]);
}
function Mn(e, {
  relative: t
} = {}) {
  let {
      basename: n
    } = React.useContext(Ke),
    r = React.useContext(Je);
  D(r, `useFormAction must be used inside a RouteContext`);
  let [i] = r.matches.slice(-1),
    a = {
      ...ut(e || `.`, {
        relative: t
      })
    },
    o = rt();
  if (e == null) {
    a.search = o.search;
    let e = new URLSearchParams(a.search),
      t = e.getAll(`index`);
    if (t.some(e => e === ``)) {
      e.delete(`index`), t.filter(e => e).forEach(t => e.append(`index`, t));
      let n = e.toString();
      a.search = n ? `?${n}` : ``;
    }
  }
  return (!e || e === `.`) && i.route.index && (a.search = a.search ? a.search.replace(/^\?/, `?index&`) : `?index`), n !== `/` && (a.pathname = a.pathname === `/` ? n : be([n, a.pathname])), M(a);
}
function Nn(e, {
  relative: t
} = {}) {
  let n = React.useContext(Ue);
  D(n != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
  let {
      basename: r
    } = En(`useViewTransitionState`),
    i = ut(e, {
      relative: t
    });
  if (!n.isTransitioning) return !1;
  let a = fe(n.currentLocation.pathname, r) || n.currentLocation.pathname,
    o = fe(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return ce(i.pathname, o) != null || ce(i.pathname, a) != null;
}
var Pn = `gth_auth_token`,
  Fn = `gth_auth_usuario`,
  In = `gth_auth_dispositivo`;
function guardarSesion(e, t) {
  e && localStorage.setItem(Pn, e), t && localStorage.setItem(Fn, JSON.stringify(t));
}
function obtenerToken() {
  return localStorage.getItem(Pn);
}
function obtenerUsuario() {
  let e = localStorage.getItem(Fn);
  return e ? JSON.parse(e) : null;
}
function Bn() {
  return localStorage.getItem(In);
}
function Vn(e) {
  e && localStorage.setItem(In, e);
}
function borrarSesion() {
  localStorage.removeItem(Pn), localStorage.removeItem(Fn);
  try {
    navigator.clearAppBadge?.();
  } catch {}
}
function cabeceraSesion() {
  let e = obtenerToken();
  return e ? {
    Authorization: `Bearer ${e}`
  } : {};
}
var Wn = [`admin`, `administrador`, `superadmin`];
function leerClaims() {
  let e = obtenerToken();
  if (!e) return null;
  try {
    return JSON.parse(atob(e.split(`.`)[1].replace(/-/g, `+`).replace(/_/g, `/`)));
  } catch {
    return null;
  }
}
function rolesSesion() {
  let e = leerClaims()?.groups;
  return Array.isArray(e) ? e : e ? [e] : [];
}
function usuarioIdSesion() {
  let e = leerClaims()?.sub,
    t = e == null ? NaN : Number(e);
  return Number.isFinite(t) ? t : null;
}
function Jn() {
  let e = leerClaims()?.exp;
  return typeof e == `number` ? e * 1e3 - Date.now() : null;
}
// Permisos por acción (2026-10-07): se leen de /permisos/mios al abrir la
// app y al volver a la pestaña; mientras no llegan, valen las marcas del token.
// El backend vuelve a verificar todo: esto sólo decide qué se muestra.
var permisosVivos = null,
  permisosPidiendo = null;
function refrescarPermisos() {
  if (!obtenerToken()) return (permisosVivos = null, Promise.resolve(null));
  return permisosPidiendo ??= api(`/permisos/mios`).then(p => {
    permisosVivos = p;
    window.dispatchEvent(new Event(`gth-permisos`));
    return p;
  }).catch(() => null).finally(() => {
    permisosPidiendo = null;
  });
}
function permisosSesion() {
  return permisosVivos;
}
/** ¿Tiene el permiso (en ese ámbito, o en alguno si no se indica)? */
function puedeAccion(codigo, ambitoId) {
  let p = permisosVivos;
  if (!p) return esAdministrador();
  if (p.superadmin) return !0;
  if (p.globales.includes(codigo)) return !0;
  let ids = p.porAmbito[codigo];
  return !!ids && (ambitoId == null ? ids.length > 0 : ids.includes(Number(ambitoId)));
}
/** ¿Tiene algún permiso cuyo código empieza así? null = todavía no se sabe. */
function tienePermisoCon(prefijo) {
  let p = permisosVivos;
  if (!p) return null;
  return p.superadmin || p.globales.some(c => c.startsWith(prefijo)) || Object.keys(p.porAmbito).some(c => c.startsWith(prefijo));
}
function esAdministrador() {
  if (permisosVivos) return permisosVivos.superadmin === !0;
  return rolesSesion().some(e => Wn.includes(e));
}
function puedeMovilidad() {
  return tienePermisoCon(`transporte.`) ?? (leerClaims()?.movilidad === !0 || esAdministrador());
}
function puedeIncidencias() {
  return tienePermisoCon(`incidencias.`) ?? (leerClaims()?.incidencias === !0 || esAdministrador());
}
/** Control de Labores SSCC (2026-10-09). */
// Los cinco permisos de Control de Labores (los mismos que exige verPanel() en
// LaboresResource). Al crear uno nuevo del módulo, agregarlo aquí y allá.
const PERMISOS_CONTROL_LABORES = [`labores.control.ver`, `labores.asignaciones.gestionar`, `labores.maestros.gestionar`, `labores.reporte.ver`, `labores.planificacion.gestionar`];
function puedeLabores() {
  return PERMISOS_CONTROL_LABORES.some((p) => puedeAccion(p));
}
function puedeInspecciones() {
  return tienePermisoCon(`inspecciones.`) ?? (leerClaims()?.inspecciones === !0 || esAdministrador());
}
function puedeOrganigrama() {
  return tienePermisoCon(`organigrama.`) ?? leerClaims()?.organigrama === !0;
}
function puedePlanner() {
  return tienePermisoCon(`planner.`) ?? (leerClaims()?.planner !== !1 || esAdministrador());
}
/**
 * ¿Puede esta acción en el proyecto? El backend manda `misAcciones` en el
 * detalle del proyecto; sin ese dato (listas), se cae al rol del proyecto.
 */
function accionProyecto(p, codigo) {
  if (!p) return !1;
  if (permisosVivos?.superadmin) return !0;
  if (Array.isArray(p.misAcciones)) return p.misAcciones.includes(codigo);
  return p.miRol === `ADMIN` || p.miRol === `COLABORADOR` && !/eliminar|archivar|cerrar|reabrir|miembros|gestionar/.test(codigo);
}
/** Páginas de Configuración: cada una con los permisos que la abren. */
var PERMISOS_ADMIN = {
  "/admin": [`sistema.resumen.ver`],
  "/admin/maestros": [`sistema.usuarios.ver`, `sistema.usuarios.permisos`, `sistema.maestros.sedes`, `sistema.maestros.fundos`, `sistema.maestros.concesionarias`],
  "/admin/marca": [`sistema.apariencia`],
  "/admin/personal": [`personal.ver`],
  "/admin/errores": [`sistema.fallas.ver`],
  "/admin/movilidad": [`transporte.numeros.gestionar`, `transporte.enlaces.gestionar`, `transporte.sedes.gestionar`, `transporte.horarios.gestionar`],
  "/admin/bots": [`sistema.bots.ver`, `transporte.bot.ver`, `labores.bot.ver`],
  "/admin/niveles": [`sistema.niveles`, `organigrama.niveles`],
  "/admin/areas-por-sector": [`inspecciones.configurar`, `incidencias.configurar`]
};
function puedeRutaAdmin(ruta) {
  if (!permisosVivos) return esAdministrador();
  return (PERMISOS_ADMIN[ruta] ?? []).some(c => puedeAccion(c));
}
/** Páginas del planner: cada una con su permiso de «ver». */
function puedePagina(ruta) {
  if (!permisosVivos) return puedePlanner();
  switch (ruta) {
    case `/`: return puedeAccion(`planner.mis_tareas.ver`);
    case `/aprobaciones`: return puedeAccion(`planner.aprobaciones.ver`);
    case `/proyectos`: return puedeAccion(`planner.proyectos.ver`) || puedeAccion(`planner.personal.usar`);
    case `/calendario`: return puedeAccion(`planner.calendario.ver`);
    case `/organizacion`: return puedeAccion(`planner.unidad.ver`);
    default: return puedePlanner();
  }
}
function sesionVencida() {
  let e = Jn();
  return e != null && e <= 0;
}
var nr = n(e => {
    var t = Symbol.for(`react.transitional.element`),
      n = Symbol.for(`react.fragment`);
    function r(e, n, r) {
      var i = null;
      if (r !== void 0 && (i = `` + r), n.key !== void 0 && (i = `` + n.key), `key` in n) for (var a in r = {}, n) a !== `key` && (r[a] = n[a]);else r = n;
      return n = r.ref, {
        $$typeof: t,
        type: e,
        key: i,
        ref: n === void 0 ? null : n,
        props: r
      };
    }
    e.Fragment = n, e.jsx = r, e.jsxs = r;
  }),
  rr = n((e, t) => {
    t.exports = nr();
  }),
  JSXRuntime = rr();
var ar = (...e) => e.filter((e, t, n) => !!e && e.trim() !== `` && n.indexOf(e) === t).join(` `).trim(),
  or = e => e.replace(/([a-z0-9])([A-Z])/g, `$1-$2`).toLowerCase(),
  sr = e => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()),
  cr = e => {
    let t = sr(e);
    return t.charAt(0).toUpperCase() + t.slice(1);
  },
  lr = {
    xmlns: `http://www.w3.org/2000/svg`,
    width: 24,
    height: 24,
    viewBox: `0 0 24 24`,
    fill: `none`,
    stroke: `currentColor`,
    strokeWidth: 2,
    strokeLinecap: `round`,
    strokeLinejoin: `round`
  },
  ur = e => {
    for (let t in e) if (t.startsWith(`aria-`) || t === `role` || t === `title`) return !0;
    return !1;
  },
  dr = (0, React.createContext)({}),
  fr = () => (0, React.useContext)(dr),
  pr = (0, React.forwardRef)(({
    color: e,
    size: t,
    strokeWidth: n,
    absoluteStrokeWidth: r,
    className: i = ``,
    children: a,
    iconNode: o,
    ...s
  }, c) => {
    let {
        size: l = 24,
        strokeWidth: u = 2,
        absoluteStrokeWidth: f = !1,
        color: p = `currentColor`,
        className: m = ``
      } = fr() ?? {},
      h = r ?? f ? Number(n ?? u) * 24 / Number(t ?? l) : n ?? u;
    return (0, React.createElement)(`svg`, {
      ref: c,
      ...lr,
      width: t ?? l ?? lr.width,
      height: t ?? l ?? lr.height,
      stroke: e ?? p,
      strokeWidth: h,
      className: ar(`lucide`, m, i),
      ...(!a && !ur(s) && {
        "aria-hidden": `true`
      }),
      ...s
    }, [...o.map(([e, t]) => (0, React.createElement)(e, t)), ...(Array.isArray(a) ? a : [a])]);
  }),
  G = (e, t) => {
    let n = (0, React.forwardRef)(({
      className: n,
      ...r
    }, i) => (0, React.createElement)(pr, {
      ref: i,
      iconNode: t,
      className: ar(`lucide-${or(cr(e))}`, `lucide-${e}`, n),
      ...r
    }));
    return n.displayName = cr(e), n;
  },
  mr = G(`activity`, [[`path`, {
    d: `M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2`,
    key: `169zse`
  }]]),
  hr = G(`arrow-down-a-z`, [[`path`, {
    d: `m3 16 4 4 4-4`,
    key: `1co6wj`
  }], [`path`, {
    d: `M7 20V4`,
    key: `1yoxec`
  }], [`path`, {
    d: `M20 8h-5`,
    key: `1vsyxs`
  }], [`path`, {
    d: `M15 10V6.5a2.5 2.5 0 0 1 5 0V10`,
    key: `ag13bf`
  }], [`path`, {
    d: `M15 14h5l-5 6h5`,
    key: `ur5jdg`
  }]]),
  gr = G(`arrow-left`, [[`path`, {
    d: `m12 19-7-7 7-7`,
    key: `1l729n`
  }], [`path`, {
    d: `M19 12H5`,
    key: `x3x0zl`
  }]]),
  _r = G(`arrow-right`, [[`path`, {
    d: `M5 12h14`,
    key: `1ays0h`
  }], [`path`, {
    d: `m12 5 7 7-7 7`,
    key: `xquz4c`
  }]]),
  vr = G(`arrow-up-a-z`, [[`path`, {
    d: `m3 8 4-4 4 4`,
    key: `11wl7u`
  }], [`path`, {
    d: `M7 4v16`,
    key: `1glfcx`
  }], [`path`, {
    d: `M20 8h-5`,
    key: `1vsyxs`
  }], [`path`, {
    d: `M15 10V6.5a2.5 2.5 0 0 1 5 0V10`,
    key: `ag13bf`
  }], [`path`, {
    d: `M15 14h5l-5 6h5`,
    key: `ur5jdg`
  }]]),
  yr = G(`ban`, [[`circle`, {
    cx: `12`,
    cy: `12`,
    r: `10`,
    key: `1mglay`
  }], [`path`, {
    d: `M4.929 4.929 19.07 19.071`,
    key: `196cmz`
  }]]),
  br = G(`bell-ring`, [[`path`, {
    d: `M10.268 21a2 2 0 0 0 3.464 0`,
    key: `vwvbt9`
  }], [`path`, {
    d: `M22 8c0-2.3-.8-4.3-2-6`,
    key: `5bb3ad`
  }], [`path`, {
    d: `M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326`,
    key: `11g9vi`
  }], [`path`, {
    d: `M4 2C2.8 3.7 2 5.7 2 8`,
    key: `tap9e0`
  }]]),
  xr = G(`bell`, [[`path`, {
    d: `M10.268 21a2 2 0 0 0 3.464 0`,
    key: `vwvbt9`
  }], [`path`, {
    d: `M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326`,
    key: `11g9vi`
  }]]),
  Sr = G(`building-2`, [[`path`, {
    d: `M10 12h4`,
    key: `a56b0p`
  }], [`path`, {
    d: `M10 8h4`,
    key: `1sr2af`
  }], [`path`, {
    d: `M14 21v-3a2 2 0 0 0-4 0v3`,
    key: `1rgiei`
  }], [`path`, {
    d: `M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2`,
    key: `secmi2`
  }], [`path`, {
    d: `M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16`,
    key: `16ra0t`
  }]]),
  Cr = G(`bus`, [[`path`, {
    d: `M8 6v6`,
    key: `18i7km`
  }], [`path`, {
    d: `M15 6v6`,
    key: `1sg6z9`
  }], [`path`, {
    d: `M2 12h19.6`,
    key: `de5uta`
  }], [`path`, {
    d: `M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3`,
    key: `1wwztk`
  }], [`circle`, {
    cx: `7`,
    cy: `18`,
    r: `2`,
    key: `19iecd`
  }], [`path`, {
    d: `M9 18h5`,
    key: `lrx6i`
  }], [`circle`, {
    cx: `16`,
    cy: `18`,
    r: `2`,
    key: `1v4tcr`
  }]]),
  wr = G(`calendar-clock`, [[`path`, {
    d: `M16 14v2.2l1.6 1`,
    key: `fo4ql5`
  }], [`path`, {
    d: `M16 2v3`,
    key: `otl347`
  }], [`path`, {
    d: `M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338`,
    key: `7hb8p4`
  }], [`path`, {
    d: `M3 9h5.859`,
    key: `numkqi`
  }], [`path`, {
    d: `M8 2v3`,
    key: `1ioesn`
  }], [`circle`, {
    cx: `16`,
    cy: `16`,
    r: `6`,
    key: `qoo3c4`
  }]]),
  Tr = G(`calendar-days`, [[`path`, {
    d: `M8 2v3`,
    key: `1ioesn`
  }], [`path`, {
    d: `M16 2v3`,
    key: `otl347`
  }], [`rect`, {
    x: `3`,
    y: `3`,
    width: `18`,
    height: `18`,
    rx: `2`,
    key: `h1oib`
  }], [`path`, {
    d: `M3 9h18`,
    key: `1pudct`
  }], [`path`, {
    d: `M8 13h.01`,
    key: `1sbv64`
  }], [`path`, {
    d: `M12 13h.01`,
    key: `y0uutt`
  }], [`path`, {
    d: `M16 13h.01`,
    key: `wip0gl`
  }], [`path`, {
    d: `M8 17h.01`,
    key: `p3bg7i`
  }], [`path`, {
    d: `M12 17h.01`,
    key: `p32p05`
  }], [`path`, {
    d: `M16 17h.01`,
    key: `ql8jdd`
  }]]),
  Er = G(`calendar-plus`, [[`path`, {
    d: `M16 18h6`,
    key: `987eiv`
  }], [`path`, {
    d: `M16 2v3`,
    key: `otl347`
  }], [`path`, {
    d: `M19 15v6`,
    key: `10aioa`
  }], [`path`, {
    d: `M21 11.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8.3`,
    key: `jgwkxf`
  }], [`path`, {
    d: `M3 9h18`,
    key: `1pudct`
  }], [`path`, {
    d: `M8 2v3`,
    key: `1ioesn`
  }]]),
  Dr = G(`camera`, [[`path`, {
    d: `M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z`,
    key: `18u6gg`
  }], [`circle`, {
    cx: `12`,
    cy: `13`,
    r: `3`,
    key: `1vg3eu`
  }]]),
  Or = G(`chart-column`, [[`path`, {
    d: `M3 3v16a2 2 0 0 0 2 2h16`,
    key: `c24i48`
  }], [`path`, {
    d: `M18 17V9`,
    key: `2bz60n`
  }], [`path`, {
    d: `M13 17V5`,
    key: `1frdt8`
  }], [`path`, {
    d: `M8 17v-3`,
    key: `17ska0`
  }]]),
  kr = G(`check`, [[`path`, {
    d: `M20 6 9 17l-5-5`,
    key: `1gmf2c`
  }]]),
  Ar = G(`chevron-down`, [[`path`, {
    d: `m6 9 6 6 6-6`,
    key: `qrunsl`
  }]]),
  jr = G(`chevron-left`, [[`path`, {
    d: `m15 18-6-6 6-6`,
    key: `1wnfg3`
  }]]),
  Mr = G(`chevron-right`, [[`path`, {
    d: `m9 18 6-6-6-6`,
    key: `mthhwq`
  }]]),
  Nr = G(`circle-check`, [[`circle`, {
    cx: `12`,
    cy: `12`,
    r: `10`,
    key: `1mglay`
  }], [`path`, {
    d: `m16 9-5.5 5.5L8 12`,
    key: `xofnsj`
  }]]),
  Pr = G(`clipboard-check`, [[`rect`, {
    width: `8`,
    height: `4`,
    x: `8`,
    y: `2`,
    rx: `1`,
    ry: `1`,
    key: `tgr4d6`
  }], [`path`, {
    d: `M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2`,
    key: `116196`
  }], [`path`, {
    d: `m9 14 2 2 4-4`,
    key: `df797q`
  }]]),
  Fr = G(`clock`, [[`circle`, {
    cx: `12`,
    cy: `12`,
    r: `10`,
    key: `1mglay`
  }], [`path`, {
    d: `M12 6v6l4 2`,
    key: `mmk7yg`
  }]]),
  Ir = G(`cloud-upload`, [[`path`, {
    d: `M12 13v8`,
    key: `1l5pq0`
  }], [`path`, {
    d: `M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242`,
    key: `1pljnt`
  }], [`path`, {
    d: `m8 17 4-4 4 4`,
    key: `1quai1`
  }]]),
  Lr = G(`copy`, [[`rect`, {
    width: `14`,
    height: `14`,
    x: `8`,
    y: `8`,
    rx: `2`,
    ry: `2`,
    key: `17jyea`
  }], [`path`, {
    d: `M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2`,
    key: `zix9uf`
  }]]),
  Rr = G(`download`, [[`path`, {
    d: `M12 15V3`,
    key: `m9g1x1`
  }], [`path`, {
    d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
    key: `ih7n3h`
  }], [`path`, {
    d: `m7 10 5 5 5-5`,
    key: `brsn70`
  }]]),
  zr = G(`eraser`, [[`path`, {
    d: `M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21`,
    key: `g5wo59`
  }], [`path`, {
    d: `m5.082 11.09 8.828 8.828`,
    key: `1wx5vj`
  }]]),
  Br = G(`external-link`, [[`path`, {
    d: `M15 3h6v6`,
    key: `1q9fwt`
  }], [`path`, {
    d: `M10 14 21 3`,
    key: `gplh6r`
  }], [`path`, {
    d: `M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6`,
    key: `a6xqqp`
  }]]),
  Vr = G(`eye-off`, [[`path`, {
    d: `M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49`,
    key: `ct8e1f`
  }], [`path`, {
    d: `M14.084 14.158a3 3 0 0 1-4.242-4.242`,
    key: `151rxh`
  }], [`path`, {
    d: `M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143`,
    key: `13bj9a`
  }], [`path`, {
    d: `m2 2 20 20`,
    key: `1ooewy`
  }]]),
  Hr = G(`eye`, [[`path`, {
    d: `M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0`,
    key: `1nclc0`
  }], [`circle`, {
    cx: `12`,
    cy: `12`,
    r: `3`,
    key: `1v7zrd`
  }]]),
  Ur = G(`file-spreadsheet`, [[`path`, {
    d: `M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z`,
    key: `1oefj6`
  }], [`path`, {
    d: `M14 2v5a1 1 0 0 0 1 1h5`,
    key: `wfsgrz`
  }], [`path`, {
    d: `M8 13h2`,
    key: `yr2amv`
  }], [`path`, {
    d: `M14 13h2`,
    key: `un5t4a`
  }], [`path`, {
    d: `M8 17h2`,
    key: `2yhykz`
  }], [`path`, {
    d: `M14 17h2`,
    key: `10kma7`
  }]]),
  Wr = G(`file-text`, [[`path`, {
    d: `M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z`,
    key: `1oefj6`
  }], [`path`, {
    d: `M14 2v5a1 1 0 0 0 1 1h5`,
    key: `wfsgrz`
  }], [`path`, {
    d: `M10 9H8`,
    key: `b1mrlr`
  }], [`path`, {
    d: `M16 13H8`,
    key: `t4e002`
  }], [`path`, {
    d: `M16 17H8`,
    key: `z1uh3a`
  }]]),
  Gr = G(`folder-kanban`, [[`path`, {
    d: `M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z`,
    key: `1fr9dc`
  }], [`path`, {
    d: `M8 10v4`,
    key: `tgpxqk`
  }], [`path`, {
    d: `M12 10v2`,
    key: `hh53o1`
  }], [`path`, {
    d: `M16 10v6`,
    key: `1d6xys`
  }]]),
  Kr = G(`folder-tree`, [[`path`, {
    d: `M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z`,
    key: `hod4my`
  }], [`path`, {
    d: `M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z`,
    key: `w4yl2u`
  }], [`path`, {
    d: `M3 5a2 2 0 0 0 2 2h3`,
    key: `f2jnh7`
  }], [`path`, {
    d: `M3 3v13a2 2 0 0 0 2 2h3`,
    key: `k8epm1`
  }]]),
  qr = G(`funnel`, [[`path`, {
    d: `M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z`,
    key: `sc7q7i`
  }]]),
  Jr = G(`image-down`, [[`path`, {
    d: `M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21`,
    key: `9csbqa`
  }], [`path`, {
    d: `m14 19 3 3v-5.5`,
    key: `9ldu5r`
  }], [`path`, {
    d: `m17 22 3-3`,
    key: `1nkfve`
  }], [`circle`, {
    cx: `9`,
    cy: `9`,
    r: `2`,
    key: `af1f0g`
  }]]),
  Yr = G(`image`, [[`rect`, {
    width: `18`,
    height: `18`,
    x: `3`,
    y: `3`,
    rx: `2`,
    ry: `2`,
    key: `1m3agn`
  }], [`circle`, {
    cx: `9`,
    cy: `9`,
    r: `2`,
    key: `af1f0g`
  }], [`path`, {
    d: `m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21`,
    key: `1xmnt7`
  }]]),
  Xr = G(`info`, [[`circle`, {
    cx: `12`,
    cy: `12`,
    r: `10`,
    key: `1mglay`
  }], [`path`, {
    d: `M12 16v-4`,
    key: `1dtifu`
  }], [`path`, {
    d: `M12 8h.01`,
    key: `e9boi3`
  }]]),
  Zr = G(`layers`, [[`path`, {
    d: `M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z`,
    key: `zw3jo`
  }], [`path`, {
    d: `M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12`,
    key: `1wduqc`
  }], [`path`, {
    d: `M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17`,
    key: `kqbvx6`
  }]]),
  Qr = G(`layout-grid`, [[`rect`, {
    width: `7`,
    height: `7`,
    x: `3`,
    y: `3`,
    rx: `1`,
    key: `1g98yp`
  }], [`rect`, {
    width: `7`,
    height: `7`,
    x: `14`,
    y: `3`,
    rx: `1`,
    key: `6d4xhi`
  }], [`rect`, {
    width: `7`,
    height: `7`,
    x: `14`,
    y: `14`,
    rx: `1`,
    key: `nxv5o0`
  }], [`rect`, {
    width: `7`,
    height: `7`,
    x: `3`,
    y: `14`,
    rx: `1`,
    key: `1bb6yr`
  }]]),
  $r = G(`link-2`, [[`path`, {
    d: `M9 17H7A5 5 0 0 1 7 7h2`,
    key: `8i5ue5`
  }], [`path`, {
    d: `M15 7h2a5 5 0 1 1 0 10h-2`,
    key: `1b9ql8`
  }], [`line`, {
    x1: `8`,
    x2: `16`,
    y1: `12`,
    y2: `12`,
    key: `1jonct`
  }]]),
  ei = G(`list-checks`, [[`path`, {
    d: `M13 5h8`,
    key: `a7qcls`
  }], [`path`, {
    d: `M13 12h8`,
    key: `h98zly`
  }], [`path`, {
    d: `M13 19h8`,
    key: `c3s6r1`
  }], [`path`, {
    d: `m3 17 2 2 4-4`,
    key: `1jhpwq`
  }], [`path`, {
    d: `m3 7 2 2 4-4`,
    key: `1obspn`
  }]]),
  ti = G(`list-todo`, [[`path`, {
    d: `M13 5h8`,
    key: `a7qcls`
  }], [`path`, {
    d: `M13 12h8`,
    key: `h98zly`
  }], [`path`, {
    d: `M13 19h8`,
    key: `c3s6r1`
  }], [`path`, {
    d: `m3 17 2 2 4-4`,
    key: `1jhpwq`
  }], [`rect`, {
    x: `3`,
    y: `4`,
    width: `6`,
    height: `6`,
    rx: `1`,
    key: `cif1o7`
  }]]),
  ni = G(`list-tree`, [[`path`, {
    d: `M8 5h13`,
    key: `1pao27`
  }], [`path`, {
    d: `M13 12h8`,
    key: `h98zly`
  }], [`path`, {
    d: `M13 19h8`,
    key: `c3s6r1`
  }], [`path`, {
    d: `M3 10a2 2 0 0 0 2 2h3`,
    key: `1npucw`
  }], [`path`, {
    d: `M3 5v12a2 2 0 0 0 2 2h3`,
    key: `x1gjn2`
  }]]),
  ri = G(`list`, [[`path`, {
    d: `M3 5h.01`,
    key: `18ugdj`
  }], [`path`, {
    d: `M3 12h.01`,
    key: `nlz23k`
  }], [`path`, {
    d: `M3 19h.01`,
    key: `noohij`
  }], [`path`, {
    d: `M8 5h13`,
    key: `1pao27`
  }], [`path`, {
    d: `M8 12h13`,
    key: `1za7za`
  }], [`path`, {
    d: `M8 19h13`,
    key: `m83p4d`
  }]]),
  ii = G(`loader-circle`, [[`path`, {
    d: `M21 12a9 9 0 1 1-6.219-8.56`,
    key: `13zald`
  }]]),
  ai = G(`lock-keyhole`, [[`circle`, {
    cx: `12`,
    cy: `16`,
    r: `1`,
    key: `1au0dj`
  }], [`rect`, {
    x: `3`,
    y: `10`,
    width: `18`,
    height: `12`,
    rx: `2`,
    key: `6s8ecr`
  }], [`path`, {
    d: `M7 10V7a5 5 0 0 1 10 0v3`,
    key: `1pqi11`
  }]]),
  oi = G(`lock`, [[`rect`, {
    width: `18`,
    height: `11`,
    x: `3`,
    y: `11`,
    rx: `2`,
    ry: `2`,
    key: `1w4ew1`
  }], [`path`, {
    d: `M7 11V7a5 5 0 0 1 10 0v4`,
    key: `fwvmzm`
  }]]),
  si = G(`log-out`, [[`path`, {
    d: `m16 17 5-5-5-5`,
    key: `1bji2h`
  }], [`path`, {
    d: `M21 12H9`,
    key: `dn1m92`
  }], [`path`, {
    d: `M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4`,
    key: `1uf3rs`
  }]]),
  ci = G(`mail`, [[`path`, {
    d: `m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7`,
    key: `132q7q`
  }], [`rect`, {
    x: `2`,
    y: `4`,
    width: `20`,
    height: `16`,
    rx: `2`,
    key: `izxlao`
  }]]),
  li = G(`map-pin-off`, [[`path`, {
    d: `M12.75 7.09a3 3 0 0 1 2.16 2.16`,
    key: `1d4wjd`
  }], [`path`, {
    d: `M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568`,
    key: `12yil7`
  }], [`path`, {
    d: `m2 2 20 20`,
    key: `1ooewy`
  }], [`path`, {
    d: `M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533`,
    key: `lhrkcz`
  }], [`path`, {
    d: `M9.13 9.13a3 3 0 0 0 3.74 3.74`,
    key: `13wojd`
  }]]),
  ui = G(`map-pin`, [[`path`, {
    d: `M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0`,
    key: `1r0f0z`
  }], [`circle`, {
    cx: `12`,
    cy: `10`,
    r: `3`,
    key: `ilqhr7`
  }]]),
  di = G(`maximize-2`, [[`path`, {
    d: `M15 3h6v6`,
    key: `1q9fwt`
  }], [`path`, {
    d: `m21 3-7 7`,
    key: `1l2asr`
  }], [`path`, {
    d: `m3 21 7-7`,
    key: `tjx5ai`
  }], [`path`, {
    d: `M9 21H3v-6`,
    key: `wtvkvv`
  }]]),
  fi = G(`menu`, [[`path`, {
    d: `M4 5h16`,
    key: `1tepv9`
  }], [`path`, {
    d: `M4 12h16`,
    key: `1lakjw`
  }], [`path`, {
    d: `M4 19h16`,
    key: `1djgab`
  }]]),
  pi = G(`message-circle`, [[`path`, {
    d: `M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719`,
    key: `1sd12s`
  }]]),
  mi = G(`messages-square`, [[`path`, {
    d: `M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z`,
    key: `1n2ejm`
  }], [`path`, {
    d: `M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1`,
    key: `1qfcsi`
  }]]),
  hi = G(`minimize-2`, [[`path`, {
    d: `m14 10 7-7`,
    key: `oa77jy`
  }], [`path`, {
    d: `M20 10h-6V4`,
    key: `mjg0md`
  }], [`path`, {
    d: `m3 21 7-7`,
    key: `tjx5ai`
  }], [`path`, {
    d: `M4 14h6v6`,
    key: `rmj7iw`
  }]]),
  gi = G(`minus`, [[`path`, {
    d: `M5 12h14`,
    key: `1ays0h`
  }]]),
  _i = G(`monitor-smartphone`, [[`path`, {
    d: `M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8`,
    key: `10dyio`
  }], [`path`, {
    d: `M10 19v-3.96 3.15`,
    key: `1irgej`
  }], [`path`, {
    d: `M7 19h5`,
    key: `qswx4l`
  }], [`rect`, {
    width: `6`,
    height: `10`,
    x: `16`,
    y: `12`,
    rx: `2`,
    key: `1egngj`
  }]]),
  vi = G(`moon`, [[`path`, {
    d: `M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401`,
    key: `kfwtm`
  }]]),
  yi = G(`network`, [[`rect`, {
    x: `16`,
    y: `16`,
    width: `6`,
    height: `6`,
    rx: `1`,
    key: `4q2zg0`
  }], [`rect`, {
    x: `2`,
    y: `16`,
    width: `6`,
    height: `6`,
    rx: `1`,
    key: `8cvhb9`
  }], [`rect`, {
    x: `9`,
    y: `2`,
    width: `6`,
    height: `6`,
    rx: `1`,
    key: `1egb70`
  }], [`path`, {
    d: `M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3`,
    key: `1jsf9p`
  }], [`path`, {
    d: `M12 12V8`,
    key: `2874zd`
  }]]),
  bi = G(`palette`, [[`path`, {
    d: `M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z`,
    key: `e79jfc`
  }], [`circle`, {
    cx: `13.5`,
    cy: `6.5`,
    r: `.5`,
    fill: `currentColor`,
    key: `1okk4w`
  }], [`circle`, {
    cx: `17.5`,
    cy: `10.5`,
    r: `.5`,
    fill: `currentColor`,
    key: `f64h9f`
  }], [`circle`, {
    cx: `6.5`,
    cy: `12.5`,
    r: `.5`,
    fill: `currentColor`,
    key: `qy21gx`
  }], [`circle`, {
    cx: `8.5`,
    cy: `7.5`,
    r: `.5`,
    fill: `currentColor`,
    key: `fotxhn`
  }]]),
  xi = G(`panel-left-close`, [[`rect`, {
    width: `18`,
    height: `18`,
    x: `3`,
    y: `3`,
    rx: `2`,
    key: `afitv7`
  }], [`path`, {
    d: `M9 3v18`,
    key: `fh3hqa`
  }], [`path`, {
    d: `m16 15-3-3 3-3`,
    key: `14y99z`
  }]]),
  Si = G(`panel-left-open`, [[`rect`, {
    width: `18`,
    height: `18`,
    x: `3`,
    y: `3`,
    rx: `2`,
    key: `afitv7`
  }], [`path`, {
    d: `M9 3v18`,
    key: `fh3hqa`
  }], [`path`, {
    d: `m14 9 3 3-3 3`,
    key: `8010ee`
  }]]),
  Ci = G(`paperclip`, [[`path`, {
    d: `m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551`,
    key: `1miecu`
  }]]),
  wi = G(`pencil`, [[`path`, {
    d: `M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z`,
    key: `1a8usu`
  }], [`path`, {
    d: `m15 5 4 4`,
    key: `1mk7zo`
  }]]),
  Ti = G(`plus`, [[`path`, {
    d: `M5 12h14`,
    key: `1ays0h`
  }], [`path`, {
    d: `M12 5v14`,
    key: `s699le`
  }]]),
  Ei = G(`power-off`, [[`path`, {
    d: `M18.36 6.64A9 9 0 0 1 20.77 15`,
    key: `dxknvb`
  }], [`path`, {
    d: `M6.16 6.16a9 9 0 1 0 12.68 12.68`,
    key: `1x7qb5`
  }], [`path`, {
    d: `M12 2v4`,
    key: `3427ic`
  }], [`path`, {
    d: `m2 2 20 20`,
    key: `1ooewy`
  }]]),
  Di = G(`power`, [[`path`, {
    d: `M12 2v10`,
    key: `mnfbl`
  }], [`path`, {
    d: `M18.4 6.6a9 9 0 1 1-12.77.04`,
    key: `obofu9`
  }]]),
  Oi = G(`refresh-cw`, [[`path`, {
    d: `M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8`,
    key: `v9h5vc`
  }], [`path`, {
    d: `M21 3v5h-5`,
    key: `1q7to0`
  }], [`path`, {
    d: `M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16`,
    key: `3uifl3`
  }], [`path`, {
    d: `M8 16H3v5`,
    key: `1cv678`
  }]]),
  ki = G(`repeat`, [[`path`, {
    d: `m17 2 4 4-4 4`,
    key: `nntrym`
  }], [`path`, {
    d: `M3 11v-1a4 4 0 0 1 4-4h14`,
    key: `84bu3i`
  }], [`path`, {
    d: `m7 22-4-4 4-4`,
    key: `1wqhfi`
  }], [`path`, {
    d: `M21 13v1a4 4 0 0 1-4 4H3`,
    key: `1rx37r`
  }]]),
  Ai = G(`rotate-ccw-clock`, [[`path`, {
    d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
    key: `1357e3`
  }], [`path`, {
    d: `M3 3v5h5`,
    key: `1xhq8a`
  }], [`path`, {
    d: `M12 7v5l4 2`,
    key: `1fdv2h`
  }]]),
  ji = G(`rotate-ccw`, [[`path`, {
    d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
    key: `1357e3`
  }], [`path`, {
    d: `M3 3v5h5`,
    key: `1xhq8a`
  }]]),
  Mi = G(`rows-3`, [[`rect`, {
    width: `18`,
    height: `18`,
    x: `3`,
    y: `3`,
    rx: `2`,
    key: `afitv7`
  }], [`path`, {
    d: `M21 9H3`,
    key: `1338ky`
  }], [`path`, {
    d: `M21 15H3`,
    key: `9uk58r`
  }]]),
  Ni = G(`scan`, [[`path`, {
    d: `M3 7V5a2 2 0 0 1 2-2h2`,
    key: `aa7l1z`
  }], [`path`, {
    d: `M17 3h2a2 2 0 0 1 2 2v2`,
    key: `4qcy5o`
  }], [`path`, {
    d: `M21 17v2a2 2 0 0 1-2 2h-2`,
    key: `6vwrx8`
  }], [`path`, {
    d: `M7 21H5a2 2 0 0 1-2-2v-2`,
    key: `ioqczr`
  }]]),
  Pi = G(`search`, [[`path`, {
    d: `m21 21-4.34-4.34`,
    key: `14j7rj`
  }], [`circle`, {
    cx: `11`,
    cy: `11`,
    r: `8`,
    key: `4ej97u`
  }]]),
  Fi = G(`send`, [[`path`, {
    d: `M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z`,
    key: `1ffxy3`
  }], [`path`, {
    d: `m21.854 2.147-10.94 10.939`,
    key: `12cjpa`
  }]]),
  Ii = G(`settings-2`, [[`path`, {
    d: `M14 17H5`,
    key: `gfn3mx`
  }], [`path`, {
    d: `M19 7h-9`,
    key: `6i9tg`
  }], [`circle`, {
    cx: `17`,
    cy: `17`,
    r: `3`,
    key: `18b49y`
  }], [`circle`, {
    cx: `7`,
    cy: `7`,
    r: `3`,
    key: `dfmy0x`
  }]]),
  Li = G(`settings`, [[`path`, {
    d: `M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915`,
    key: `1i5ecw`
  }], [`circle`, {
    cx: `12`,
    cy: `12`,
    r: `3`,
    key: `1v7zrd`
  }]]),
  Ri = G(`share`, [[`path`, {
    d: `M12 2v13`,
    key: `1km8f5`
  }], [`path`, {
    d: `m16 6-4-4-4 4`,
    key: `13yo43`
  }], [`path`, {
    d: `M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8`,
    key: `1b2hhj`
  }]]),
  zi = G(`sheet`, [[`rect`, {
    width: `18`,
    height: `18`,
    x: `3`,
    y: `3`,
    rx: `2`,
    ry: `2`,
    key: `1m3agn`
  }], [`line`, {
    x1: `3`,
    x2: `21`,
    y1: `9`,
    y2: `9`,
    key: `1vqk6q`
  }], [`line`, {
    x1: `3`,
    x2: `21`,
    y1: `15`,
    y2: `15`,
    key: `o2sbyz`
  }], [`line`, {
    x1: `9`,
    x2: `9`,
    y1: `9`,
    y2: `21`,
    key: `1ib60c`
  }], [`line`, {
    x1: `15`,
    x2: `15`,
    y1: `9`,
    y2: `21`,
    key: `1n26ft`
  }]]),
  Bi = G(`shield-check`, [[`path`, {
    d: `M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z`,
    key: `oel41y`
  }], [`path`, {
    d: `m9 12 2 2 4-4`,
    key: `dzmm74`
  }]]),
  Vi = G(`siren`, [[`path`, {
    d: `M7 18v-6a5 5 0 1 1 10 0v6`,
    key: `pcx96s`
  }], [`path`, {
    d: `M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z`,
    key: `1b4s83`
  }], [`path`, {
    d: `M21 12h1`,
    key: `jtio3y`
  }], [`path`, {
    d: `M18.5 4.5 18 5`,
    key: `g5sp9y`
  }], [`path`, {
    d: `M2 12h1`,
    key: `1uaihz`
  }], [`path`, {
    d: `M12 2v1`,
    key: `11qlp1`
  }], [`path`, {
    d: `m4.929 4.929.707.707`,
    key: `1i51kw`
  }], [`path`, {
    d: `M12 12v6`,
    key: `3ahymv`
  }]]),
  Hi = G(`smartphone`, [[`rect`, {
    width: `14`,
    height: `20`,
    x: `5`,
    y: `2`,
    rx: `2`,
    ry: `2`,
    key: `1yt0o3`
  }], [`path`, {
    d: `M12 18h.01`,
    key: `mhygvu`
  }]]),
  Ui = G(`sun`, [[`circle`, {
    cx: `12`,
    cy: `12`,
    r: `4`,
    key: `4exip2`
  }], [`path`, {
    d: `M12 2v2`,
    key: `tus03m`
  }], [`path`, {
    d: `M12 20v2`,
    key: `1lh1kg`
  }], [`path`, {
    d: `m4.93 4.93 1.41 1.41`,
    key: `149t6j`
  }], [`path`, {
    d: `m17.66 17.66 1.41 1.41`,
    key: `ptbguv`
  }], [`path`, {
    d: `M2 12h2`,
    key: `1t8f8n`
  }], [`path`, {
    d: `M20 12h2`,
    key: `1q8mjw`
  }], [`path`, {
    d: `m6.34 17.66-1.41 1.41`,
    key: `1m8zz5`
  }], [`path`, {
    d: `m19.07 4.93-1.41 1.41`,
    key: `1shlcs`
  }]]),
  Wi = G(`tag`, [[`path`, {
    d: `M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z`,
    key: `vktsd0`
  }], [`circle`, {
    cx: `7.5`,
    cy: `7.5`,
    r: `.5`,
    fill: `currentColor`,
    key: `kqv944`
  }]]),
  Gi = G(`target`, [[`circle`, {
    cx: `12`,
    cy: `12`,
    r: `10`,
    key: `1mglay`
  }], [`circle`, {
    cx: `12`,
    cy: `12`,
    r: `6`,
    key: `1vlfrh`
  }], [`circle`, {
    cx: `12`,
    cy: `12`,
    r: `2`,
    key: `1c9p78`
  }]]),
  Ki = G(`trash-2`, [[`path`, {
    d: `M10 11v6`,
    key: `nco0om`
  }], [`path`, {
    d: `M14 11v6`,
    key: `outv1u`
  }], [`path`, {
    d: `M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6`,
    key: `miytrc`
  }], [`path`, {
    d: `M3 6h18`,
    key: `d0wm0j`
  }], [`path`, {
    d: `M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2`,
    key: `e791ji`
  }]]),
  qi = G(`triangle-alert`, [[`path`, {
    d: `m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3`,
    key: `wmoenq`
  }], [`path`, {
    d: `M12 9v4`,
    key: `juzpu7`
  }], [`path`, {
    d: `M12 17h.01`,
    key: `p32p05`
  }]]),
  IconoLabores = G(`sparkles`, [[`path`, {
    d: `M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z`,
    key: `4pj2yx`
  }], [`path`, {
    d: `M20 3v4`,
    key: `1olli1`
  }], [`path`, {
    d: `M22 5h-4`,
    key: `1gvqau`
  }]]),
  Ji = G(`truck`, [[`path`, {
    d: `M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2`,
    key: `wrbu53`
  }], [`path`, {
    d: `M15 18H9`,
    key: `1lyqi6`
  }], [`path`, {
    d: `M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14`,
    key: `lysw3i`
  }], [`circle`, {
    cx: `17`,
    cy: `18`,
    r: `2`,
    key: `332jqn`
  }], [`circle`, {
    cx: `7`,
    cy: `18`,
    r: `2`,
    key: `19iecd`
  }]]),
  Yi = G(`undo-2`, [[`path`, {
    d: `M9 14 4 9l5-5`,
    key: `102s5s`
  }], [`path`, {
    d: `M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11`,
    key: `f3b9sd`
  }]]),
  Xi = G(`upload`, [[`path`, {
    d: `M12 3v12`,
    key: `1x0j5s`
  }], [`path`, {
    d: `m17 8-5-5-5 5`,
    key: `7q97r8`
  }], [`path`, {
    d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
    key: `ih7n3h`
  }]]),
  Zi = G(`user-minus`, [[`path`, {
    d: `M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2`,
    key: `1yyitq`
  }], [`circle`, {
    cx: `9`,
    cy: `7`,
    r: `4`,
    key: `nufk8`
  }], [`line`, {
    x1: `22`,
    x2: `16`,
    y1: `11`,
    y2: `11`,
    key: `1shjgl`
  }]]),
  Qi = G(`user-round`, [[`circle`, {
    cx: `12`,
    cy: `8`,
    r: `5`,
    key: `1hypcn`
  }], [`path`, {
    d: `M20 21a8 8 0 0 0-16 0`,
    key: `rfgkzh`
  }]]),
  $i = G(`users`, [[`path`, {
    d: `M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2`,
    key: `1yyitq`
  }], [`path`, {
    d: `M16 3.128a4 4 0 0 1 0 7.744`,
    key: `16gr8j`
  }], [`path`, {
    d: `M22 21v-2a4 4 0 0 0-3-3.87`,
    key: `kshegd`
  }], [`circle`, {
    cx: `9`,
    cy: `7`,
    r: `4`,
    key: `nufk8`
  }]]),
  ea = G(`volume-2`, [[`path`, {
    d: `M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z`,
    key: `uqj9uw`
  }], [`path`, {
    d: `M16 9a5 5 0 0 1 0 6`,
    key: `1q6k2b`
  }], [`path`, {
    d: `M19.364 18.364a9 9 0 0 0 0-12.728`,
    key: `ijwkga`
  }]]),
  ta = G(`volume-x`, [[`path`, {
    d: `M11 4.702a.7.7 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.7.7 0 0 0 11 19.298z`,
    key: `1p7khw`
  }], [`path`, {
    d: `m16.5 14.5 5-5`,
    key: `cul3yw`
  }], [`path`, {
    d: `m16.5 9.5 5 5`,
    key: `1akey5`
  }]]),
  na = G(`wifi-off`, [[`path`, {
    d: `M12 20h.01`,
    key: `zekei9`
  }], [`path`, {
    d: `M8.5 16.429a5 5 0 0 1 7 0`,
    key: `1bycff`
  }], [`path`, {
    d: `M5 12.859a10 10 0 0 1 5.17-2.69`,
    key: `1dl1wf`
  }], [`path`, {
    d: `M19 12.859a10 10 0 0 0-2.007-1.523`,
    key: `4k23kn`
  }], [`path`, {
    d: `M2 8.82a15 15 0 0 1 4.177-2.643`,
    key: `1grhjp`
  }], [`path`, {
    d: `M22 8.82a15 15 0 0 0-11.288-3.764`,
    key: `z3jwby`
  }], [`path`, {
    d: `m2 2 20 20`,
    key: `1ooewy`
  }]]),
  ra = G(`x`, [[`path`, {
    d: `M18 6 6 18`,
    key: `1bl5f8`
  }], [`path`, {
    d: `m6 6 12 12`,
    key: `d8bk6v`
  }]]);
var sa = `planner-pendientes`,
  ca = `cola`,
  la = 1,
  ua = [{
    metodo: `POST`,
    patron: /^\/tareas$/
  }, {
    metodo: `PUT`,
    patron: /^\/tareas\/\d+$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/mover$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/conforme$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/devolver$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/cancelar$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/comentarios$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/comprobantes$/
  }, {
    metodo: `PUT`,
    patron: /^\/tareas\/\d+\/checklist\/\d+$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/solicitudes-fecha$/
  }, {
    metodo: `POST`,
    patron: /^\/tareas\/\d+\/solicitudes-cancelacion$/
  }, {
    metodo: `POST`,
    patron: /^\/incidencias$/
  }];
function da(e, t = `GET`) {
  let n = e.split(`?`)[0];
  return ua.some(e => e.metodo === t.toUpperCase() && e.patron.test(n));
}
function fa() {
  return new Promise((e, t) => {
    let n = indexedDB.open(nombrePrivado(sa), la);
    n.onupgradeneeded = () => {
      let e = n.result;
      e.objectStoreNames.contains(ca) || e.createObjectStore(ca, {
        keyPath: `clave`
      });
    }, n.onsuccess = () => e(n.result), n.onerror = () => t(n.error);
  });
}
async function pa(e, t) {
  let n = await fa();
  try {
    return await new Promise((r, i) => {
      let a = n.transaction(ca, e),
        o = a.objectStore(ca),
        s,
        c = t(o);
      c && c.onsuccess !== void 0 && (c.onsuccess = () => {
        s = c.result;
      }), a.oncomplete = () => r(s), a.onerror = () => i(a.error), a.onabort = () => i(a.error);
    });
  } finally {
    n.close();
  }
}
function ma() {
  return crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
async function ha({
  ruta: e,
  metodo: t,
  cuerpo: n,
  partes: r,
  descripcion: i,
  clave: a
}) {
  let o = {
    clave: a || ma(),
    ruta: e,
    metodo: t,
    cuerpo: n,
    ...(r ? {
      partes: r
    } : {}),
    descripcion: i || e,
    creadoEn: Date.now(),
    error: null
  };
  return await pa(`readwrite`, e => e.put(o)), ba(), o;
}
async function ga() {
  return ((await pa(`readonly`, e => e.getAll())) ?? []).sort((e, t) => e.creadoEn - t.creadoEn);
}
async function _a(e) {
  await pa(`readwrite`, t => t.delete(e)), ba();
}
async function va(e, t) {
  let n = (await ga()).find(t => t.clave === e);
  n && (await pa(`readwrite`, e => e.put({
    ...n,
    error: t
  })), ba());
}
async function ya(e) {
  let t = (await ga()).find(t => t.clave === e);
  t && (await pa(`readwrite`, e => e.put({
    ...t,
    error: null
  })), ba());
}
function ba() {
  window.dispatchEvent(new Event(`pendientes-cambiaron`));
}
var xa = new Map();
function Sa(e, t) {
  if (!e) return t();
  let n = (xa.get(e) ?? Promise.resolve()).catch(() => {}).then(t);
  return xa.set(e, n), n.catch(() => {}).finally(() => {
    xa.get(e) === n && xa.delete(e);
  }), n;
}
function Ca(e) {
  if (!e) return null;
  let t = e.split(`?`)[0],
    n = t.match(/^\/([a-z-]+)\/(\d+)/i);
  if (n) return `${n[1]}/${n[2]}`;
  let r = t.match(/^\/([a-z-]+)$/i);
  return r ? r[1] : null;
}
var API_BASE = (import.meta.env.VITE_API_BASE || "/api").replace(/\/$/, "");
function Ta(e) {
  return `${API_BASE}${e}`;
}
function Ea(e) {
  return Ta(e);
}
var Da = new Set();
function Oa(e) {
  obtenerToken() && !Da.has(e) && (Da.add(e), setTimeout(() => Da.delete(e), 3e4), api(e).catch(() => {}));
}
var ka = class extends Error {
    constructor(e, t) {
      super(e), this.status = t;
    }
  },
  Aa = 15e3;
async function ja(e, t) {
  let n = new AbortController(),
    r = setTimeout(() => n.abort(), t?.topeMs ?? Aa),
    i = Date.now();
  try {
    let {
      topeMs: r,
      ...i
    } = t ?? {};
    return await fetch(Ta(e), {
      credentials: `include`,
      signal: n.signal,
      ...i
    });
  } catch (r) {
    let a = n.signal.aborted;
    throw uo({
      tipo: a ? `ApiSinRespuesta` : `ApiSinConexion`,
      mensaje: `${t?.method ?? `GET`} ${e} — ${a ? `se agotó la espera` : `la red falló`} tras ${Date.now() - i} ms`,
      traza: r?.message ?? null
    }), new ka(`No se pudo conectar con el servidor. Verifica tu conexion e intenta de nuevo.`, 0);
  } finally {
    clearTimeout(r);
  }
}
function Ma() {
  try {
    return crypto.randomUUID();
  } catch {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
}
var Na = `planner-datos-v1`;
async function Pa(e, t) {
  if (!(typeof caches > `u`)) try {
    await (await caches.open(nombrePrivado("planner-datos"))).put(new Request(Ta(e)), new Response(JSON.stringify({
      datos: t,
      en: Date.now()
    }), {
      headers: {
        "Content-Type": `application/json`
      }
    }));
  } catch {}
}
async function Fa(e) {
  const cuenta = ambitoActual();
  if (typeof caches > `u`) return null;
  try {
    let t = await (await caches.open(nombrePrivado("planner-datos"))).match(new Request(Ta(e)));
    const datos = t ? await t.json() : null;
    return ambitoActual() === cuenta ? datos : null;
  } catch {
    return null;
  }
}
var Ia = [15e3, 6e4, 3e5],
  La = null,
  Ra = 0;
function za() {
  if (La) return;
  let e = Ia[Math.min(Ra, Ia.length - 1)];
  La = setTimeout(async () => {
    La = null;
    try {
      await Va(), (await ga()).filter(e => !e.error).length > 0 ? (Ra++, za()) : Ra = 0;
    } catch {
      Ra++, za();
    }
  }, e);
}
function Ba(e) {
  return e >= 500 || e === 408 || e === 425 || e === 429;
}
async function Va() {
  const cuenta = ambitoActual();
  if (!navigator.onLine || !obtenerToken()) return {
    enviados: 0,
    fallidos: 0
  };
  let e = (await ga()).filter(e => !e.error),
    t = 0,
    n = 0,
    r = !1;
  for (let i of e) try {
    exigirMismaCuenta(cuenta);
    let e = Array.isArray(i.partes),
      a = await fetch(Ta(i.ruta), {
        method: i.metodo,
        credentials: `include`,
        headers: {
          ...(e ? {} : {
            "Content-Type": `application/json`
          }),
          "X-Idempotencia": i.clave,
          ...cabeceraSesion()
        },
        body: e ? Xa(i.partes) : i.cuerpo ?? void 0
      });
    exigirMismaCuenta(cuenta);
    if (a.ok) await _a(i.clave), t++;else if (a.status === 401) break;else if (Ba(a.status)) {
      r = !0;
      break;
    } else {
      let e = null;
      try {
        e = await a.json();
      } catch {}
      let t = Ha(a.status, e);
      await va(i.clave, t), n++;
    }
  } catch {
    r = !0;
    break;
  }
  return (t > 0 || n > 0) && window.dispatchEvent(new CustomEvent(`pendientes-sincronizados`, {
    detail: {
      enviados: t,
      fallidos: n
    }
  })), r && za(), {
    enviados: t,
    fallidos: n
  };
}
function Ha(e, t) {
  let n = typeof t?.error == `string` && t.error.trim() ? t.error : null;
  return n && e !== 502 && e !== 503 && e !== 504 ? n : e === 401 ? `Tu sesión terminó. Vuelve a iniciar sesión.` : e === 403 ? `No tienes permiso para hacer esto.` : e === 404 ? `No se encontró lo que buscas: puede que lo hayan quitado.` : e === 408 || e === 504 ? `El servidor tardó demasiado en responder. Prueba de nuevo.` : e === 409 ? `Alguien más lo cambió recién. Recarga y prueba de nuevo.` : e === 413 ? `El archivo es demasiado grande.` : e === 429 ? `Demasiados intentos seguidos. Espera un minuto y prueba de nuevo.` : e === 502 || e === 503 ? `El sistema se está actualizando. Prueba de nuevo en unos segundos.` : e >= 500 ? `Algo falló de nuestro lado. Ya quedó registrado; prueba de nuevo en un momento.` : n ?? `No se pudo completar. Revisa los datos y prueba de nuevo.`;
}
function Ua(e) {
  e && window.dispatchEvent(new Event(`sesion-expirada`));
}
async function api(e, t = {}) {
  let n = (t.method || `GET`).toUpperCase();
  return n === `GET` ? Ga(e, t, n) : Sa(t.clave ?? Ca(e), () => Ga(e, t, n));
}
var Wa = 864e5;
async function Ga(e, t, n) {
  const cuenta = ambitoActual();
  if (n === `GET` && !t.sinCache && typeof t.alRefrescar == `function`) {
    let r = await Fa(e);
    exigirMismaCuenta(cuenta);
    if (r && Date.now() - r.en < Wa) {
      let {
        alRefrescar: i,
        ...a
      } = t;
      return Ga(e, a, n).then(e => { exigirMismaCuenta(cuenta); i(e); }).catch(() => {
        window.dispatchEvent(new CustomEvent(`datos-desactualizados`, {
          detail: {
            en: r.en
          }
        }));
      }), r.datos;
    }
  }
  return qa(e, t, n);
}
function Ka(e) {
  return e == null || typeof e == `string` || typeof FormData < `u` && e instanceof FormData || typeof Blob < `u` && e instanceof Blob || typeof URLSearchParams < `u` && e instanceof URLSearchParams || typeof ArrayBuffer < `u` && (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) ? e : JSON.stringify(e);
}
async function qa(e, t, n) {
  const cuenta = ambitoActual();
  let {
      redirigirEn401: r = !0,
      clave: i,
      alRefrescar: a,
      sinCache: o = !1,
      ...s
    } = t,
    c = `body` in s ? {
      ...s,
      body: Ka(s.body)
    } : s,
    l = !!obtenerToken(),
    u = n === `GET` ? null : t.idempotencia ?? Ma();
  if (n !== `GET` && !navigator.onLine && da(e, n)) return await ha({
    ruta: e,
    metodo: n,
    cuerpo: c.body ?? null,
    descripcion: t.descripcion,
    clave: u
  }), {
    guardadoSinConexion: !0
  };
  let d;
  try {
    d = await ja(e, {
      ...c,
      headers: {
        "Content-Type": `application/json`,
        ...cabeceraSesion(),
        ...(u ? {
          "X-Idempotencia": u
        } : {}),
        ...(c.headers || {})
      }
    });
  } catch (r) {
    exigirMismaCuenta(cuenta);
    if (n === `GET` && !o) {
      let t = await Fa(e);
      if (t) return window.dispatchEvent(new CustomEvent(`datos-desactualizados`, {
        detail: {
          en: t.en
        }
      })), t.datos;
    }
    if (n !== `GET` && da(e, n)) return await ha({
      ruta: e,
      metodo: n,
      cuerpo: c.body ?? null,
      descripcion: t.descripcion,
      clave: u
    }), za(), {
      guardadoSinConexion: !0
    };
    throw r;
  }
  exigirMismaCuenta(cuenta);
  if (d.status === 204) return null;
  let f = null;
  try {
    f = await d.json();
  } catch {}
  if (!d.ok) throw d.status === 401 && r && Ua(l), new ka(Ha(d.status, f), d.status);
  exigirMismaCuenta(cuenta);
  return n === `GET` && !o && Pa(e, f), f;
}
var Ja = 6e4;
function Ya(e) {
  return [...e.entries()].map(([e, t]) => typeof Blob < `u` && t instanceof Blob ? {
    nombre: e,
    archivo: t,
    nombreArchivo: t.name ?? `archivo`
  } : {
    nombre: e,
    valor: String(t)
  });
}
function Xa(e) {
  let t = new FormData();
  for (let n of e) n.archivo ? t.append(n.nombre, n.archivo, n.nombreArchivo) : t.append(n.nombre, n.valor);
  return t;
}
async function Za(e, t, {
  topeMs: n = Ja,
  descripcion: r
} = {}) {
  const cuenta = ambitoActual();
  let i = Ma(),
    a = da(e, `POST`),
    o = async () => (exigirMismaCuenta(cuenta), await ha({
      ruta: e,
      metodo: `POST`,
      cuerpo: null,
      partes: Ya(t),
      descripcion: r,
      clave: i
    }), {
      guardadoSinConexion: !0
    });
  if (a && typeof navigator < `u` && navigator.onLine === !1) return o();
  let s;
  try {
    s = await ja(e, {
      method: `POST`,
      headers: {
        ...cabeceraSesion(),
        "X-Idempotencia": i
      },
      body: t,
      topeMs: n
    });
  } catch (e) {
    if (!a) throw e;
    let t = await o();
    return za(), t;
  }
  exigirMismaCuenta(cuenta);
  if (s.status === 204) return null;
  let c = null;
  try {
    c = await s.json();
  } catch {}
  if (!s.ok) throw s.status === 401 && Ua(!!obtenerToken()), new ka(Ha(s.status, c), s.status);
  return c;
}
async function Qa(e, t = {}) {
  const cuenta = ambitoActual();
  let n = await ja(e, {
    headers: {
      ...cabeceraSesion(),
      ...t
    }
  });
  if (!n.ok) throw n.status === 401 && Ua(!!obtenerToken()), new ka(Ha(n.status, null), n.status);
  const blob = await n.blob();
  exigirMismaCuenta(cuenta);
  return URL.createObjectURL(blob);
}
var $a = 3e5,
  eo = 18e5,
  to = 0,
  no = null,
  ro = !1;
async function io() {
  if (obtenerToken() && !(Date.now() - to < 6e4)) {
    to = Date.now();
    try {
      let e = await api(`/auth/refresh`, {
        method: `POST`,
        redirigirEn401: !1
      });
      e?.token && (guardarSesion(e.token, e.usuario ?? void 0), window.dispatchEvent(new Event(`sesion-actualizada`)));
    } catch (e) {
      e.status === 401 && window.dispatchEvent(new Event(`sesion-expirada`));
    } finally {
      ao();
    }
  }
}
function ao() {
  if (!ro) return;
  no && clearTimeout(no);
  let e = Jn(),
    t = e == null ? eo : Math.min(Math.max(e - $a, 6e4), eo);
  no = setTimeout(io, t);
}
function oo() {
  if (document.visibilityState === `hidden` || !obtenerToken()) return;
  let e = Jn();
  e == null || e < $a * 2 ? io() : ao();
}
function so() {
  ro || (ro = !0, ao(), window.addEventListener(`focus`, oo), document.addEventListener(`visibilitychange`, oo));
}
function co() {
  ro = !1, no && clearTimeout(no), no = null, window.removeEventListener(`focus`, oo), document.removeEventListener(`visibilitychange`, oo);
}
var lo = new Set();
function uo({
  tipo: e,
  mensaje: t,
  traza: n
}) {
  try {
    if (!t || !obtenerToken()) return;
    let r = `${e}|${t}`.slice(0, 300);
    if (lo.has(r)) return;
    lo.add(r);
    let i = JSON.stringify({
      tipo: e || `ErrorEnPantalla`,
      mensaje: String(t).slice(0, 1e3),
      ruta: window.location.pathname,
      traza: n ? String(n).slice(0, 8e3) : null
    });
    fetch(Ea(`/errores/cliente`), {
      method: `POST`,
      credentials: `include`,
      keepalive: !0,
      headers: {
        "Content-Type": `application/json`,
        ...fo()
      },
      body: i
    }).catch(() => {});
  } catch {}
}
function fo() {
  let e = obtenerToken();
  return e ? {
    Authorization: `Bearer ${e}`
  } : {};
}
function po() {
  window.addEventListener(`error`, e => {
    uo({
      tipo: e.error?.name || `ErrorDeScript`,
      mensaje: e.message,
      traza: e.error?.stack || `${e.filename}:${e.lineno}:${e.colno}`
    });
  }), window.addEventListener(`unhandledrejection`, e => {
    let t = e.reason;
    uo({
      tipo: t?.name || `PromesaSinAtender`,
      mensaje: t?.message || String(t),
      traza: t?.stack
    });
  });
}
var mo = () => !0,
  ho = () => puedePlanner(),
  go = () => esAdministrador(),
  rutaPlanner = e => () => puedePagina(e),
  _o = () => puedeMovilidad(),
  vo = () => puedeIncidencias(),
  yo = () => puedeInspecciones(),
  bo = [{
    path: `/`,
    puede: rutaPlanner(`/`)
  }, {
    path: `/aprobaciones`,
    puede: rutaPlanner(`/aprobaciones`)
  }, {
    path: `/proyectos`,
    puede: rutaPlanner(`/proyectos`)
  }, {
    path: `/proyectos/:id`,
    puede: rutaPlanner(`/proyectos`)
  }, {
    path: `/calendario`,
    puede: rutaPlanner(`/calendario`)
  }, {
    path: `/calendario/conectar/:proveedor`,
    puede: mo
  }, {
    path: `/notificaciones`,
    puede: mo
  }, {
    path: `/organizacion`,
    puede: rutaPlanner(`/organizacion`)
  }, {
    path: `/organizacion/:id`,
    puede: rutaPlanner(`/organizacion`)
  }, {
    path: `/admin`,
    puede: () => puedeRutaAdmin(`/admin`)
  }, {
    path: `/admin/maestros`,
    puede: () => puedeRutaAdmin(`/admin/maestros`)
  }, {
    path: `/admin/marca`,
    puede: () => puedeRutaAdmin(`/admin/marca`)
  }, {
    path: `/admin/personal`,
    puede: () => puedeRutaAdmin(`/admin/personal`)
  }, {
    path: `/admin/errores`,
    puede: () => puedeRutaAdmin(`/admin/errores`)
  }, {
    path: `/admin/movilidad`,
    puede: () => puedeRutaAdmin(`/admin/movilidad`)
  }, {
    path: `/admin/bots`,
    puede: () => puedeRutaAdmin(`/admin/bots`)
  }, {
    path: `/admin/niveles`,
    puede: () => puedeRutaAdmin(`/admin/niveles`)
  }, {
    path: `/admin/areas-por-sector`,
    puede: () => puedeRutaAdmin(`/admin/areas-por-sector`)
  }, {
    path: `/transporte`,
    puede: _o
  }, {
    path: `/incidencias`,
    puede: vo
  }, {
    path: `/inspecciones`,
    puede: yo
  }, {
    path: `/labores`,
    puede: () => puedeLabores()
  }, {
    path: `/observaciones`,
    puede: () => vo() || yo()
  }, {
    path: `/organigrama`,
    puede: () => puedeOrganigrama()
  }, {
    path: `/gestor`,
    puede: mo
  }],
  xo = [`/`, `/transporte`, `/incidencias`, `/inspecciones`, `/organigrama`];
function So(e) {
  return bo.find(t => ce({
    path: t.path,
    end: !0
  }, e)) ?? null;
}
function Co(e) {
  let t = So(e);
  return !t || t.puede();
}
function wo() {
  return xo.find(e => Co(e)) ?? null;
}
function To(e) {
  if (typeof e == `string` && /^\/(?![/\\])/.test(e) && !e.startsWith(`/login`)) {
    let t = e.split(/[?#]/)[0];
    if (Co(t)) return e;
  }
  return wo();
}
var Do = class extends React.Component {
    state = {
      error: null
    };
    static getDerivedStateFromError(e) {
      return {
        error: e
      };
    }
    componentDidUpdate(e) {
      this.state.error && e.reiniciarCon !== this.props.reiniciarCon && this.setState({
        error: null
      });
    }
    componentDidCatch(e, t) {
      console.error(`ErrorBoundary:`, e, t), uo({
        tipo: e?.name || `PantallaRota`,
        mensaje: e?.message || String(e),
        traza: `${e?.stack || ``}\n${t?.componentStack || ``}`
      });
    }
    render() {
      return this.state.error ? (0, JSXRuntime.jsx)(PermisoRequerido, {
        icono: qi,
        titulo: `Esta pantalla no se pudo mostrar`,
        mensaje: `Ya quedó registrado. Recarga la página; si vuelve a pasar, avisa al equipo.`,
        acciones: [{
          texto: `Recargar`,
          principal: !0,
          alHacer: () => window.location.reload()
        }, {
          texto: `Ir al inicio`,
          alHacer: () => window.location.assign(obtenerToken() ? wo() ?? `/` : `/login`)
        }]
      }) : this.props.children;
    }
  },
  Oo = {
    clave: ``,
    en: 0
  };
function ko(e, t, n = null) {
  try {
    if (!obtenerToken()) return;
    let r = `${e}:${t}:${n}`;
    if (Oo.clave === r && Date.now() - Oo.en < 1e3) return;
    Oo = {
      clave: r,
      en: Date.now()
    }, fetch(Ea(`/analitica/eventos`), {
      method: `POST`,
      headers: {
        ...cabeceraSesion(),
        "Content-Type": `application/json`
      },
      body: JSON.stringify({
        evento: e,
        vista: t,
        proyectoId: n
      }),
      keepalive: !0
    }).catch(() => {});
  } catch {}
}
var Ao = {
  "/": `INICIO`,
  proyectos: `PROYECTOS`,
  calendario: `CALENDARIO`,
  organizacion: `ORGANIZACION`,
  objetivos: `OBJETIVOS`,
  notificaciones: `NOTIFICACIONES`,
  admin: `ADMIN`
};
function jo() {
  let e = (0, ReactCompiler.c)(3),
    {
      pathname: t
    } = rt(),
    n,
    r;
  return e[0] === t ? (n = e[1], r = e[2]) : (n = () => {
    let e = t.split(`/`).filter(Boolean),
      n = e[0] === `proyectos` && /^\d+$/.test(e[1] || ``) ? Number(e[1]) : null,
      r = n ? `PROYECTO` : Ao[e[0] || `/`];
    r && ko(`NAVEGACION`, r, n);
  }, r = [t], e[0] = t, e[1] = n, e[2] = r), (0, React.useEffect)(n, r), null;
}
function No(e) {
  return e.stopPropagation();
}
var Po = (0, React.createContext)(null);
function Fo() {
  let e = (0, React.useContext)(Po);
  if (!e) throw Error(`useDialogos necesita <ProveedorDialogos> arriba en el árbol`);
  return e;
}
var Io = `transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100`,
  Lo = `w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`,
  Ro = `rounded-full bg-(--accent) px-4 py-2 text-sm font-medium text-(--accent-fg) hover:opacity-90 ${Io}`,
  zo = `rounded-full border border-(--border) px-4 py-2 text-sm text-(--text-h) hover:bg-(--accent-bg) ${Io}`,
  Bo = `rounded-2xl border border-(--border) bg-(--bg) p-4`,
  Vo = Io;
var Wo = (0, React.createContext)(null);
function Go() {
  let e = (0, React.useContext)(Wo);
  if (!e) throw Error(`useAvisos necesita <ProveedorAvisos>`);
  return e;
}
var Ko = `gth_sonido`,
  qo = .35,
  Jo = {
    exito: `/sonido/exito.mp3`,
    error: `/sonido/error.mp3`,
    carro: `/sonido/carro.mp3`
  },
  Yo = {};
function Xo() {
  try {
    return localStorage.getItem(Ko) !== `0`;
  } catch {
    return !0;
  }
}
function Zo(e) {
  try {
    localStorage.setItem(Ko, e ? `1` : `0`);
  } catch {}
}
var Qo = null;
function $o() {
  let e = typeof window < `u` ? window.AudioContext || window.webkitAudioContext : null;
  if (!e) return;
  Qo ??= new e(), Qo.state === `suspended` && Qo.resume?.().catch?.(() => {});
  let t = Qo.currentTime;
  [[880, 0], [1320, .14]].forEach(([e, n]) => {
    let r = Qo.createOscillator(),
      i = Qo.createGain();
    r.type = `sine`, r.frequency.value = e, i.gain.setValueAtTime(1e-4, t + n), i.gain.exponentialRampToValueAtTime(qo, t + n + .02), i.gain.exponentialRampToValueAtTime(1e-4, t + n + .35), r.connect(i).connect(Qo.destination), r.start(t + n), r.stop(t + n + .4);
  });
}
function es(e) {
  if (!Xo()) return;
  if (e === `aviso`) {
    try {
      $o();
    } catch {}
    return;
  }
  let t = Jo[e];
  if (t) try {
    let n = Yo[e];
    n || (n = new Audio(t), n.preload = `auto`, n.volume = qo, Yo[e] = n), n.currentTime = 0;
    let r = n.play();
    r && typeof r.catch == `function` && r.catch(() => {});
  } catch {}
}
var ts = {
  toque: 10,
  exito: [12, 45, 18],
  error: [28, 60, 28]
};
function ns() {
  if (typeof navigator > `u` || typeof navigator.vibrate != `function` || !Xo()) return !1;
  try {
    return !window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
  } catch {
    return !0;
  }
}
function rs(e = `toque`) {
  if (ns()) try {
    navigator.vibrate(ts[e] ?? ts.toque);
  } catch {}
}
var as = {
    ok: Nr,
    error: qi,
    info: Xr
  },
  os = {
    ok: `border-(--success-border) bg-(--success-bg)`,
    error: `border-(--error-border) bg-(--error-bg)`,
    info: `border-(--accent-border) bg-(--accent-bg)`
  },
  ss = {
    ok: `text-(--success)`,
    error: `text-(--error)`,
    info: `text-(--accent)`
  };
var ls = `gth_marca`,
  us = null;
function ds() {
  try {
    let e = localStorage.getItem(ls);
    return e ? JSON.parse(e) : null;
  } catch {
    return null;
  }
}
function fs(e) {
  try {
    localStorage.setItem(ls, JSON.stringify(e));
  } catch {}
}
function ps(e) {
  return typeof e == `string` && e.startsWith(`--`);
}
var ms = `marca-fuentes`;
function hs(e) {
  if (!e || typeof e != `string` || !e.startsWith(`https://fonts.googleapis.com/`)) return;
  let t = document.getElementById(ms);
  if (t?.getAttribute(`href`) === e) return;
  let n = t ?? document.createElement(`link`);
  n.id = ms, n.rel = `stylesheet`, n.setAttribute(`href`, e), t || document.head.appendChild(n);
}
function gs(e = us) {
  if (!e?.tokens) return;
  let t = document.documentElement,
    n = t.classList.contains(`dark`),
    r = n ? {
      ...e.tokens,
      ...(e.tokensOscuro ?? {})
    } : e.tokens,
    i = new Set(n ? e.omitirEnOscuro ?? [] : []);
  Object.entries(r).forEach(([e, n]) => {
    ps(e) && (i.has(e) ? t.style.removeProperty(e) : t.style.setProperty(e, n));
  }), e.fuentes?.tokens && Object.entries(e.fuentes.tokens).forEach(([e, n]) => {
    ps(e) && n && t.style.setProperty(e, n);
  }), hs(e.fuentes?.urlGoogle), e.nombreApp && (document.title = e.nombreApp), us = e;
}
function _s() {
  gs(us);
}
function vs() {
  return us;
}
function ys() {
  return us?.nombreApp || `Planner`;
}
function bs() {
  return us?.nombreEmpresa || ys();
}
function xs(e, t) {
  return us?.archivos?.[e] || t;
}
async function Ss() {
  let e = ds();
  e && gs(e);
  try {
    let e = await fetch(Ea(`/config/marca`), {
      credentials: `include`
    });
    if (!e.ok) return us;
    let t = await e.json();
    if (!t?.tokens) return us;
    gs(t), fs(t);
  } catch {}
  return us;
}
function Cs() {
  let e = ds();
  e && gs(e);
}
var ws = new URL(`/assets/logo-espanol-BGM1XAJb.svg`, `` + import.meta.url).href,
  Ts = new URL(`/assets/banner-auth-BcGZN49H.jpg`, `` + import.meta.url).href;
function Es(e) {
  return e.trim().split(/\s+/).length <= 2;
}
var ks = new URL(`/assets/logo-espanol-BGM1XAJb.svg`, `` + import.meta.url).href,
  As = 700,
  js = 700;
var Ns = `client_id`,
  Ps = `redirect_uri`,
  Fs = `response_type`,
  Is = `response_mode`,
  Ls = `grant_type`,
  Rs = `claims`,
  zs = `scope`,
  Bs = `refresh_token`,
  Vs = `state`,
  Hs = `nonce`,
  Us = `prompt`,
  Ws = `code`,
  Gs = `code_challenge`,
  Ks = `code_challenge_method`,
  qs = `code_verifier`,
  Js = `client-request-id`,
  Ys = `x-client-SKU`,
  Xs = `x-client-VER`,
  Zs = `x-client-OS`,
  Qs = `x-client-CPU`,
  $s = `x-client-current-telemetry`,
  ec = `x-client-last-telemetry`,
  tc = `x-ms-lib-capability`,
  nc = `x-app-name`,
  rc = `x-app-ver`,
  ic = `post_logout_redirect_uri`,
  ac = `id_token_hint`,
  oc = `client_secret`,
  sc = `client_assertion`,
  cc = `client_assertion_type`,
  lc = `token_type`,
  uc = `req_cnf`,
  dc = `dpop_jkt`,
  fc = `return_spa_code`,
  pc = `nativebroker`,
  mc = `logout_hint`,
  hc = `login_hint`,
  gc = `domain_hint`,
  _c = `x-client-xtra-sku`,
  vc = `brk_client_id`,
  yc = `brk_redirect_uri`,
  bc = `instance_aware`,
  xc = `ear_jwk`,
  Sc = `ear_jwe_crypto`,
  Cc = `resource`,
  wc = `clidata`,
  Tc = `attribute_tokens`,
  Ec = `msal.js.common`,
  Dc = `https://login.microsoftonline.com/common/`,
  Oc = `login.microsoftonline.com`,
  kc = `common`,
  Ac = `adfs`,
  jc = `${Dc}discovery/instance?api-version=1.1&authorization_endpoint=`,
  Mc = `.ciamlogin.com`,
  Nc = `.onmicrosoft.com`,
  Pc = `openid`,
  Fc = `profile`,
  Ic = `offline_access`,
  Lc = `email`,
  Rc = `S256`,
  zc = `application/x-www-form-urlencoded;charset=utf-8`,
  Bc = `http://169.254.169.254/metadata/instance/compute`,
  Vc = `2021-02-01`,
  Hc = 2e3,
  Uc = `login.microsoft.com`,
  Wc = [`login.microsoftonline.com`, `login.windows.net`, `login.microsoft.com`, `sts.windows.net`],
  Gc = {
    GET: `GET`,
    POST: `POST`
  },
  Kc = [Pc, Fc, Ic],
  qc = [...Kc, Lc],
  Jc = {
    CONTENT_TYPE: `Content-Type`,
    CONTENT_LENGTH: `Content-Length`,
    DPOP: `DPoP`,
    RETRY_AFTER: `Retry-After`,
    CCS_HEADER: `X-AnchorMailbox`,
    WWWAuthenticate: `WWW-Authenticate`,
    AuthenticationInfo: `Authentication-Info`,
    X_MS_REQUEST_ID: `x-ms-request-id`,
    X_MS_HTTP_VERSION: `x-ms-httpver`
  },
  Yc = {
    ACTIVE_ACCOUNT_FILTERS: `active-account-filters`
  },
  Xc = {
    COMMON: `common`,
    ORGANIZATIONS: `organizations`,
    CONSUMERS: `consumers`
  },
  Zc = {
    ACCESS_TOKEN: `access_token`,
    XMS_CC: `xms_cc`,
    ID_TOKEN: `id_token`,
    SIGNIN_STATE: `signin_state`,
    LOGIN_HINT: `login_hint`,
    TENANT_REGION_SUB_SCOPE: `tenant_region_sub_scope`
  },
  Qc = {
    LOGIN: `login`,
    SELECT_ACCOUNT: `select_account`,
    CONSENT: `consent`,
    NONE: `none`,
    CREATE: `create`,
    NO_SESSION: `no_session`
  },
  $c = {
    CODE: `code`,
    IDTOKEN_TOKEN: `id_token token`,
    IDTOKEN_TOKEN_REFRESHTOKEN: `id_token token refresh_token`
  },
  el = {
    QUERY: `query`,
    FRAGMENT: `fragment`,
    FORM_POST: `form_post`
  },
  tl = {
    IMPLICIT_GRANT: `implicit`,
    AUTHORIZATION_CODE_GRANT: `authorization_code`,
    CLIENT_CREDENTIALS_GRANT: `client_credentials`,
    RESOURCE_OWNER_PASSWORD_GRANT: `password`,
    REFRESH_TOKEN_GRANT: `refresh_token`,
    DEVICE_CODE_GRANT: `device_code`,
    JWT_BEARER: `urn:ietf:params:oauth:grant-type:jwt-bearer`,
    USER_FIC: `user_fic`
  },
  nl = `MSSTS`,
  rl = `ADFS`,
  il = `Generic`,
  al = {
    ID_TOKEN: `IdToken`,
    ACCESS_TOKEN: `AccessToken`,
    ACCESS_TOKEN_WITH_AUTH_SCHEME: `AccessToken_With_AuthScheme`,
    REFRESH_TOKEN: `RefreshToken`
  },
  ol = `appmetadata`,
  sl = `client_info`,
  cl = `authority-metadata`,
  ll = 86400,
  ul = {
    CONFIG: `config`,
    CACHE: `cache`,
    NETWORK: `network`,
    HARDCODED_VALUES: `hardcoded_values`
  },
  dl = `server-telemetry`,
  fl = `unknown_error`,
  pl = {
    BEARER: `Bearer`,
    POP: `pop`,
    DPOP: `DPoP`,
    SSH: `ssh-cert`
  },
  ml = 3600,
  hl = `throttling`,
  gl = `retry-after, h429`,
  _l = {
    FAILED_AUTO_DETECTION: `1`,
    INTERNAL_CACHE: `2`,
    ENVIRONMENT_VARIABLE: `3`,
    IMDS: `4`
  },
  vl = {
    CONFIGURED_MATCHES_DETECTED: `1`,
    CONFIGURED_NO_AUTO_DETECTION: `2`,
    CONFIGURED_NOT_DETECTED: `3`,
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: `4`,
    AUTO_DETECTION_REQUESTED_FAILED: `5`
  },
  yl = {
    NOT_APPLICABLE: `0`,
    FORCE_REFRESH_OR_CLAIMS: `1`,
    NO_CACHED_ACCESS_TOKEN: `2`,
    CACHED_ACCESS_TOKEN_EXPIRED: `3`,
    PROACTIVELY_REFRESHED: `4`
  },
  bl = {
    Jwt: `JWT`,
    Jwk: `JWK`,
    Pop: `pop`,
    Dpop: `dpop+jwt`
  };
function xl(e) {
  return `See https://aka.ms/msal.js.errors#${e} for details`;
}
var Sl = class e extends Error {
  constructor(t, n, r, i) {
    let a = r || (t ? xl(t) : ``),
      o = a ? `${t}: ${a}` : t;
    super(o), Object.setPrototypeOf(this, e.prototype), this.errorCode = t || ``, this.errorMessage = a || ``, this.subError = i || ``, this.correlationId = n, this.name = `AuthError`;
  }
};
function Cl(e, t, n) {
  return new Sl(e, t, n || xl(e));
}
var wl = class e extends Sl {
  constructor(t, n, r) {
    super(t, n, r), this.name = `ClientAuthError`, Object.setPrototypeOf(this, e.prototype);
  }
};
function q(e, t, n) {
  return new wl(e, t, n);
}
var Tl = `client_info_decoding_error`,
  El = `client_info_empty_error`,
  Dl = `token_parsing_error`,
  Ol = `null_or_empty_token`,
  kl = `endpoints_resolution_error`,
  Al = `network_error`,
  jl = `openid_config_error`,
  Ml = `hash_not_deserialized`,
  Nl = `invalid_state`,
  Pl = `state_mismatch`,
  Fl = `state_not_found`,
  Il = `nonce_mismatch`,
  Ll = `multiple_matching_appMetadata`,
  Rl = `request_cannot_be_made`,
  zl = `cannot_remove_empty_scope`,
  Bl = `cannot_append_scopeset`,
  Vl = `empty_input_scopeset`,
  Hl = `no_account_in_silent_request`,
  Ul = `invalid_cache_record`,
  Wl = `invalid_cache_environment`,
  Gl = `no_account_found`,
  Kl = `no_crypto_object`,
  ql = `dpop_token_type_mismatch`,
  Jl = `token_refresh_required`,
  Yl = `token_claims_cnf_required_for_signedjwt`,
  Xl = `authorization_code_missing_from_server_response`,
  Zl = `binding_key_not_removed`,
  Ql = `end_session_endpoint_not_supported`,
  $l = `key_id_missing`,
  eu = `method_not_implemented`,
  tu = `resource_parameter_required`,
  nu = `misplaced_resource_parameter`;
function ru(e, t) {
  if (!e) throw q(El, ``);
  try {
    let n = t(e);
    return JSON.parse(n);
  } catch {
    throw q(Tl, ``);
  }
}
function iu(e) {
  if (!e) throw q(Tl, ``);
  let t = e.split(`.`, 2);
  return {
    uid: t[0],
    utid: t.length < 2 ? `` : t[1]
  };
}
function au(e, t, n) {
  let r = su(e, n);
  try {
    let e = t(r);
    return JSON.parse(e);
  } catch {
    throw q(Dl, n);
  }
}
function ou(e) {
  if (!e.signin_state) return !1;
  let t = [`kmsi`, `dvc_dmjd`];
  return e.signin_state.some(e => t.includes(e.trim().toLowerCase()));
}
function su(e, t) {
  if (!e) throw q(Ol, t);
  let n = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/.exec(e);
  if (!n || n.length < 4) throw q(Dl, t);
  return n[2];
}
function cu(e, t) {
  return !!e && !!t && e === t.split(`.`)[1];
}
function lu(e, t, n, r, i) {
  if (i) {
    let {
        oid: t,
        sub: n,
        tid: a,
        name: o,
        tfp: s,
        acr: c,
        preferred_username: l,
        upn: u,
        login_hint: d
      } = i,
      f = a || s || c || ``;
    return {
      tenantId: f,
      localAccountId: t || n || ``,
      name: o,
      username: l || u || ``,
      loginHint: d,
      isHomeTenant: cu(f, e),
      upn: u,
      ...(r && {
        nativeAccountId: r
      })
    };
  }
  return {
    tenantId: n,
    localAccountId: t,
    username: ``,
    isHomeTenant: cu(n, e),
    ...(r && {
      nativeAccountId: r
    })
  };
}
function uu(e, t, n, r) {
  let i = e;
  if (t) {
    let {
      isHomeTenant: n,
      ...r
    } = t;
    i = {
      ...e,
      ...r
    };
  }
  if (n) {
    let {
      isHomeTenant: t,
      ...a
    } = lu(e.homeAccountId, e.localAccountId, e.tenantId, i.nativeAccountId, n);
    return i = {
      ...i,
      ...a,
      idTokenClaims: n,
      idToken: r,
      kmsi: ou(n)
    }, i;
  }
  return i;
}
var du = {
  Default: 0,
  Adfs: 1,
  Ciam: 3
};
function fu(e) {
  return e && (e.tid || e.tfp || e.acr) || null;
}
var pu = {
  AAD: `AAD`,
  OIDC: `OIDC`,
  EAR: `EAR`
};
function mu(e) {
  let t = e.tenantProfiles || [];
  t.length === 0 && e.realm && e.localAccountId && t.push(lu(e.homeAccountId, e.localAccountId, e.realm, e.nativeAccountId));
  let n = t.find(t => t.tenantId === e.realm)?.nativeAccountId || e.nativeAccountId;
  return {
    homeAccountId: e.homeAccountId,
    environment: e.environment,
    tenantId: e.realm,
    username: e.username,
    localAccountId: e.localAccountId,
    loginHint: e.loginHint,
    name: e.name,
    nativeAccountId: n,
    authorityType: e.authorityType,
    tenantProfiles: new Map(t.map(e => [e.tenantId, e])),
    dataBoundary: e.dataBoundary
  };
}
function hu(e, t, n, r) {
  let i;
  i = t.authorityType === du.Adfs ? rl : t.protocolMode === pu.OIDC ? il : nl;
  let a, o;
  e.clientInfo && r && (a = ru(e.clientInfo, r), a.xms_tdbr && (o = a.xms_tdbr === `EU` ? `EU` : `None`));
  let s = e.environment || t && t.getPreferredCache();
  if (!s) throw q(Wl, n);
  let c = e.idTokenClaims?.preferred_username || e.idTokenClaims?.upn,
    l = e.idTokenClaims?.emails ? e.idTokenClaims.emails[0] : null,
    u = c || l || ``,
    d = e.idTokenClaims?.login_hint,
    f = a?.utid || fu(e.idTokenClaims) || ``,
    p = a?.uid || e.idTokenClaims?.oid || e.idTokenClaims?.sub || ``,
    m;
  return m = e.tenantProfiles ? e.tenantProfiles : [lu(e.homeAccountId, p, f, e.nativeAccountId, e.idTokenClaims)], {
    homeAccountId: e.homeAccountId,
    environment: s,
    realm: f,
    localAccountId: p,
    username: u,
    authorityType: i,
    loginHint: d,
    clientInfo: e.clientInfo,
    name: e.idTokenClaims?.name || ``,
    lastModificationTime: void 0,
    lastModificationApp: void 0,
    cloudGraphHostName: e.cloudGraphHostName,
    msGraphHost: e.msGraphHost,
    nativeAccountId: e.nativeAccountId,
    tenantProfiles: m,
    dataBoundary: o
  };
}
function gu(e, t, n) {
  let r = Array.from(e.tenantProfiles?.values() || []);
  if (r.length === 0 && e.tenantId && e.localAccountId) r.push(lu(e.homeAccountId, e.localAccountId, e.tenantId, e.nativeAccountId, e.idTokenClaims));else if (e.nativeAccountId) {
    let t = r.find(t => t.tenantId === e.tenantId);
    t && !t.nativeAccountId && (t.nativeAccountId = e.nativeAccountId);
  }
  return {
    authorityType: e.authorityType || `Generic`,
    homeAccountId: e.homeAccountId,
    localAccountId: e.localAccountId,
    nativeAccountId: e.nativeAccountId,
    realm: e.tenantId,
    environment: e.environment,
    username: e.username,
    loginHint: e.loginHint,
    name: e.name,
    cloudGraphHostName: t,
    msGraphHost: n,
    tenantProfiles: r,
    dataBoundary: e.dataBoundary
  };
}
function _u(e, t, n, r, i, a) {
  if (t !== du.Adfs) {
    if (e) try {
      let t = ru(e, r.base64Decode);
      if (t.uid && t.utid) return `${t.uid}.${t.utid}`;
    } catch {}
    n.warning(`1ub6wv`, i);
  }
  return a?.sub || ``;
}
function vu(e) {
  return e ? e.hasOwnProperty(`homeAccountId`) && e.hasOwnProperty(`environment`) && e.hasOwnProperty(`realm`) && e.hasOwnProperty(`localAccountId`) && e.hasOwnProperty(`username`) && e.hasOwnProperty(`authorityType`) : !1;
}
var yu = `unexpected_error`,
  bu = class e extends Sl {
    constructor(t, n) {
      super(t, n), this.name = `ClientConfigurationError`, Object.setPrototypeOf(this, e.prototype);
    }
  };
function xu(e, t) {
  return new bu(e, t);
}
var Su = `redirect_uri_empty`,
  Cu = `authority_uri_insecure`,
  wu = `url_parse_error`,
  Tu = `empty_url_error`,
  Eu = `empty_input_scopes_error`,
  Du = `invalid_claims`,
  Ou = `token_request_empty`,
  ku = `logout_request_empty`,
  Au = `pkce_params_missing`,
  ju = `invalid_cloud_discovery_metadata`,
  Mu = `invalid_authority_metadata`,
  Nu = `untrusted_authority`,
  Pu = `missing_ssh_jwk`,
  Fu = `missing_ssh_kid`,
  Iu = `unsupported_authentication_scheme`,
  Lu = `cannot_set_OIDCOptions`,
  Ru = `cannot_allow_platform_broker`,
  zu = `authority_mismatch`,
  Bu = `invalid_request_method_for_EAR`,
  Vu = `invalid_platform_broker_configuration`,
  Hu = `issuer_validation_failed`,
  Uu = `invalid_dpop_htm`,
  Wu = `invalid_dpop_htu`,
  Gu = `invalid_dpop_nonce`,
  Ku = `dpop_missing_resource_context`;
function qu(e) {
  return e.hasOwnProperty(`authorization_endpoint`) && e.hasOwnProperty(`token_endpoint`) && e.hasOwnProperty(`issuer`) && e.hasOwnProperty(`jwks_uri`);
}
var Ju = class {
    static isEmptyObj(e) {
      if (e) try {
        let t = JSON.parse(e);
        return Object.keys(t).length === 0;
      } catch {}
      return !0;
    }
    static startsWith(e, t) {
      return e.indexOf(t) === 0;
    }
    static endsWith(e, t) {
      return e.length >= t.length && e.lastIndexOf(t) === e.length - t.length;
    }
    static queryStringToObject(e) {
      let t = {},
        n = e.split(`&`),
        r = e => decodeURIComponent(e.replace(/\+/g, ` `));
      return n.forEach(e => {
        if (e.trim()) {
          let [n, i] = e.split(/=(.+)/g, 2);
          n && i && (t[r(n)] = r(i));
        }
      }), t;
    }
    static trimArrayEntries(e) {
      return e.map(e => e.trim());
    }
    static removeEmptyStringsFromArray(e) {
      return e.filter(e => !!e);
    }
    static jsonParseHelper(e) {
      try {
        return JSON.parse(e);
      } catch {
        return null;
      }
    }
  },
  Yu = class e {
    get urlString() {
      return this._urlString;
    }
    constructor(t, n) {
      if (this._urlString = t, this.correlationId = n, !this._urlString) throw xu(Tu, n);
      t.includes(`#`) || (this._urlString = e.canonicalizeUri(t));
    }
    static canonicalizeUri(e) {
      if (e) {
        let t = e.toLowerCase();
        return Ju.endsWith(t, `?`) ? t = t.slice(0, -1) : Ju.endsWith(t, `?/`) && (t = t.slice(0, -2)), Ju.endsWith(t, `/`) || (t += `/`), t;
      }
      return e;
    }
    validateAsUri() {
      let e;
      try {
        e = this.getUrlComponents();
      } catch {
        throw xu(wu, this.correlationId);
      }
      if (!e.HostNameAndPort || !e.PathSegments) throw xu(wu, this.correlationId);
      if (!e.Protocol || e.Protocol.toLowerCase() !== `https:`) throw xu(Cu, this.correlationId);
    }
    static appendQueryString(e, t) {
      return t ? e.indexOf(`?`) < 0 ? `${e}?${t}` : `${e}&${t}` : e;
    }
    static removeHashFromUrl(t) {
      return e.canonicalizeUri(t.split(`#`)[0]);
    }
    replaceTenantPath(t) {
      let n = this.getUrlComponents(),
        r = n.PathSegments;
      return t && r.length !== 0 && (r[0] === Xc.COMMON || r[0] === Xc.ORGANIZATIONS) && (r[0] = t), e.constructAuthorityUriFromObject(n, this.correlationId);
    }
    getUrlComponents() {
      let e = RegExp(`^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?`),
        t = this.urlString.match(e);
      if (!t) throw xu(wu, this.correlationId);
      let n = {
          Protocol: t[1],
          HostNameAndPort: t[4],
          AbsolutePath: t[5],
          QueryString: t[7]
        },
        r = n.AbsolutePath.split(`/`);
      return r = r.filter(e => e && e.length > 0), n.PathSegments = r, n.QueryString && n.QueryString.endsWith(`/`) && (n.QueryString = n.QueryString.substring(0, n.QueryString.length - 1)), n;
    }
    static getDomainFromUrl(e, t) {
      let n = RegExp(`^([^:/?#]+://)?([^/?#]*)`),
        r = e.match(n);
      if (!r) throw xu(wu, t);
      return r[2];
    }
    static getAbsoluteUrl(t, n, r) {
      if (t[0] === `/`) {
        let i = new e(n, r).getUrlComponents();
        return i.Protocol + `//` + i.HostNameAndPort + t;
      }
      return t;
    }
    static constructAuthorityUriFromObject(t, n) {
      return new e(t.Protocol + `//` + t.HostNameAndPort + `/` + t.PathSegments.join(`/`), n);
    }
  },
  Xu = [{
    host: `login.microsoftonline.com`
  }, {
    host: `login.partner.microsoftonline.cn`
  }, {
    host: `login.microsoftonline.us`
  }, {
    host: `login.sovcloud-identity.fr`
  }, {
    host: `login.sovcloud-identity.de`
  }, {
    host: `login.sovcloud-identity.sg`
  }];
function Zu(e, t) {
  return {
    token_endpoint: `https://${e}/{tenantid}/oauth2/v2.0/token`,
    jwks_uri: `https://${e}/{tenantid}/discovery/v2.0/keys`,
    issuer: `https://${t}/{tenantid}/v2.0`,
    authorization_endpoint: `https://${e}/{tenantid}/oauth2/v2.0/authorize`,
    end_session_endpoint: `https://${e}/{tenantid}/oauth2/v2.0/logout`
  };
}
var Qu = {
    endpointMetadata: Xu.reduce((e, {
      host: t,
      issuerHost: n
    }) => (e[t] = Zu(t, n || t), e), {}),
    instanceDiscoveryMetadata: {
      metadata: [{
        preferred_network: `login.microsoftonline.com`,
        preferred_cache: `login.windows.net`,
        aliases: [`login.microsoftonline.com`, `login.windows.net`, `login.microsoft.com`, `sts.windows.net`]
      }, {
        preferred_network: `login.partner.microsoftonline.cn`,
        preferred_cache: `login.partner.microsoftonline.cn`,
        aliases: [`login.partner.microsoftonline.cn`, `login.chinacloudapi.cn`]
      }, {
        preferred_network: `login.microsoftonline.de`,
        preferred_cache: `login.microsoftonline.de`,
        aliases: [`login.microsoftonline.de`]
      }, {
        preferred_network: `login.microsoftonline.us`,
        preferred_cache: `login.microsoftonline.us`,
        aliases: [`login.microsoftonline.us`, `login.usgovcloudapi.net`]
      }, {
        preferred_network: `login-us.microsoftonline.com`,
        preferred_cache: `login-us.microsoftonline.com`,
        aliases: [`login-us.microsoftonline.com`]
      }, {
        preferred_network: `login.sovcloud-identity.fr`,
        preferred_cache: `login.sovcloud-identity.fr`,
        aliases: [`login.sovcloud-identity.fr`]
      }, {
        preferred_network: `login.sovcloud-identity.de`,
        preferred_cache: `login.sovcloud-identity.de`,
        aliases: [`login.sovcloud-identity.de`]
      }, {
        preferred_network: `login.sovcloud-identity.sg`,
        preferred_cache: `login.sovcloud-identity.sg`,
        aliases: [`login.sovcloud-identity.sg`]
      }]
    }
  },
  $u = Qu.endpointMetadata,
  ed = Qu.instanceDiscoveryMetadata,
  td = new Set();
ed.metadata.forEach(e => {
  e.aliases.forEach(e => {
    td.add(e);
  });
});
function nd(e, t, n) {
  let r,
    i = e.canonicalAuthority;
  if (i) {
    let a = new Yu(i, n).getUrlComponents().HostNameAndPort;
    r = rd(t, n, a, e.cloudDiscoveryMetadata?.metadata, ul.CONFIG) || rd(t, n, a, ed.metadata, ul.HARDCODED_VALUES) || e.knownAuthorities;
  }
  return r || [];
}
function rd(e, t, n, r, i) {
  if (e.trace(`1bmquz ${i}`, t), n && r) {
    let a = ad(r, n);
    if (a) return e.trace(`1fotbt ${i}`, t), a.aliases;
    e.trace(`14avvj ${i}`, t);
  }
  return null;
}
function id(e) {
  return ad(ed.metadata, e);
}
function ad(e, t) {
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    if (r.aliases.includes(t)) return r;
  }
  return null;
}
var od = {
  None: `none`,
  AzurePublic: `https://login.microsoftonline.com`,
  AzureChina: `https://login.chinacloudapi.cn`,
  AzureGermany: `https://login.microsoftonline.de`,
  AzureUsGovernment: `https://login.microsoftonline.us`
};
function sd(e) {
  return e.hasOwnProperty(`tenant_discovery_endpoint`) && e.hasOwnProperty(`metadata`);
}
function cd(e) {
  return e.hasOwnProperty(`error`) && e.hasOwnProperty(`error_description`);
}
var ld = `networkClientSendPostRequestAsync`,
  ud = `refreshTokenClientExecutePostToTokenEndpoint`,
  dd = `authorizationCodeClientExecutePostToTokenEndpoint`,
  fd = `refreshTokenClientExecuteTokenRequest`,
  pd = `refreshTokenClientAcquireToken`,
  md = `refreshTokenClientAcquireTokenWithCachedRefreshToken`,
  hd = `refreshTokenClientCreateTokenRequestBody`,
  gd = `silentFlowClientGenerateResultFromCacheRecord`,
  _d = `getAuthCodeUrl`,
  vd = `handleCodeResponseFromServer`,
  yd = `authClientExecuteTokenRequest`,
  bd = `authClientCreateTokenRequestBody`,
  xd = `updateTokenEndpointAuthority`,
  Sd = `popTokenGenerateCnf`,
  Cd = `handleServerTokenResponse`,
  wd = `authorityResolveEndpointsAsync`,
  Td = `authorityGetCloudDiscoveryMetadataFromNetwork`,
  Ed = `authorityUpdateCloudDiscoveryMetadata`,
  Dd = `authorityGetEndpointMetadataFromNetwork`,
  Od = `authorityUpdateEndpointMetadata`,
  kd = `authorityUpdateMetadataWithRegionalInformation`,
  Ad = `regionDiscoveryDetectRegion`,
  jd = `regionDiscoveryGetRegionFromIMDS`,
  Md = `regionDiscoveryGetCurrentVersion`,
  Nd = `cacheManagerGetRefreshToken`,
  Pd = `setUserData`,
  Fd = (e, t, n, r, i) => (...a) => {
    n.trace(`1plfzx ${t}`, i);
    let o = r.startMeasurement(t, i);
    i && r.incrementFields({
      [`ext.${t}CallCount`]: 1
    }, i);
    try {
      let r = e(...a);
      return o.end({
        success: !0
      }), n.trace(`1g8n6a ${t}`, i), r;
    } catch (e) {
      n.trace(`0cfd8i ${t}`, i);
      try {
        n.trace(JSON.stringify(e), i);
      } catch {
        n.trace(`00dty7`, i);
      }
      throw o.end({
        success: !1
      }, e), e;
    }
  },
  J = (e, t, n, r, i) => (...a) => {
    n.trace(`1plfzx ${t}`, i);
    let o = r.startMeasurement(t, i);
    return i && r.incrementFields({
      [`ext.${t}CallCount`]: 1
    }, i), e(...a).then(e => (n.trace(`1g8n6a ${t}`, i), o.end({
      success: !0
    }), e)).catch(e => {
      n.trace(`0cfd8i ${t}`, i);
      try {
        n.trace(JSON.stringify(e), i);
      } catch {
        n.trace(`00dty7`, i);
      }
      throw o.end({
        success: !1
      }, e), e;
    });
  },
  Id = class e {
    constructor(e, t, n, r) {
      this.networkInterface = e, this.logger = t, this.performanceClient = n, this.correlationId = r;
    }
    async detectRegion(t, n) {
      let r = t;
      if (r) n.region_source = _l.ENVIRONMENT_VARIABLE;else {
        let t = e.IMDS_OPTIONS;
        try {
          let e = await J(this.getRegionFromIMDS.bind(this), jd, this.logger, this.performanceClient, this.correlationId)(Vc, t);
          if (e.status === 200 && (r = e.body?.location, r && (n.region_source = _l.IMDS)), e.status === 400) {
            let e = await J(this.getCurrentVersion.bind(this), Md, this.logger, this.performanceClient, this.correlationId)(t);
            if (!e) return n.region_source = _l.FAILED_AUTO_DETECTION, null;
            let i = await J(this.getRegionFromIMDS.bind(this), jd, this.logger, this.performanceClient, this.correlationId)(e, t);
            i.status === 200 && (r = i.body?.location, r && (n.region_source = _l.IMDS));
          }
        } catch {
          return n.region_source = _l.FAILED_AUTO_DETECTION, null;
        }
      }
      return r || (n.region_source = _l.FAILED_AUTO_DETECTION), r || null;
    }
    async getRegionFromIMDS(e, t) {
      return this.networkInterface.sendGetRequestAsync(`${Bc}?api-version=${e}`, t, Hc);
    }
    async getCurrentVersion(e) {
      try {
        let t = await this.networkInterface.sendGetRequestAsync(`${Bc}?format=json`, e);
        return t.status === 400 && t.body && t.body[`newest-versions`] && t.body[`newest-versions`].length > 0 ? t.body[`newest-versions`][0] : null;
      } catch {
        return null;
      }
    }
  };
Id.IMDS_OPTIONS = {
  headers: {
    Metadata: `true`
  }
};
function Ld() {
  return Math.round(new Date().getTime() / 1e3);
}
function Rd(e) {
  return e.getTime() / 1e3;
}
function zd(e) {
  return e ? new Date(Number(e) * 1e3) : new Date();
}
function Bd(e, t) {
  let n = Number(e) || 0;
  return Ld() + t > n;
}
function Vd(e, t) {
  let n = Number(e) + t * 24 * 60 * 60 * 1e3;
  return Date.now() > n;
}
function Hd(e) {
  return Number(e) > Ld();
}
function Ud(e, t, n, r, i) {
  return {
    credentialType: al.ID_TOKEN,
    homeAccountId: e,
    environment: t,
    clientId: r,
    secret: n,
    realm: i,
    lastUpdatedAt: Date.now().toString()
  };
}
function Wd(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m) {
  let h = {
    homeAccountId: e,
    credentialType: al.ACCESS_TOKEN,
    secret: n,
    cachedAt: Ld().toString(),
    expiresOn: o.toString(),
    extendedExpiresOn: s.toString(),
    environment: t,
    clientId: r,
    realm: i,
    target: a,
    tokenType: d || pl.BEARER,
    lastUpdatedAt: Date.now().toString()
  };
  f && (h.userAssertionHash = f), u && (h.refreshOn = u.toString());
  let g = h.tokenType?.toLowerCase();
  if (h.tokenType?.toLowerCase() !== pl.BEARER.toLowerCase()) switch (h.credentialType = al.ACCESS_TOKEN_WITH_AUTH_SCHEME, g) {
    case pl.POP:
      let e = au(n, c, l);
      if (!e?.cnf?.kid) throw q(Yl, l);
      h.keyId = e.cnf.kid;
      break;
    case `dpop`:
      if (!p) throw q($l, l);
      h.keyId = p;
      break;
    case pl.SSH:
      h.keyId = p;
  }
  return m && Object.keys(m).length > 0 && (h.additionalCacheKeyComponents = m), h;
}
function Gd(e, t, n, r, i, a, o) {
  let s = {
    credentialType: al.REFRESH_TOKEN,
    homeAccountId: e,
    environment: t,
    clientId: r,
    secret: n,
    lastUpdatedAt: Date.now().toString()
  };
  return a && (s.userAssertionHash = a), i && (s.familyId = i), o && (s.expiresOn = o.toString()), s;
}
function Kd(e) {
  return e.hasOwnProperty(`homeAccountId`) && e.hasOwnProperty(`environment`) && e.hasOwnProperty(`credentialType`) && e.hasOwnProperty(`clientId`) && e.hasOwnProperty(`secret`);
}
function qd(e) {
  return e ? Kd(e) && e.hasOwnProperty(`realm`) && e.hasOwnProperty(`target`) && (e.credentialType === al.ACCESS_TOKEN || e.credentialType === al.ACCESS_TOKEN_WITH_AUTH_SCHEME) : !1;
}
function Jd(e) {
  return e ? Kd(e) && e.hasOwnProperty(`realm`) && e.credentialType === al.ID_TOKEN : !1;
}
function Yd(e) {
  return e ? Kd(e) && e.credentialType === al.REFRESH_TOKEN : !1;
}
function Xd(e, t) {
  let n = e.indexOf(dl) === 0,
    r = !0;
  return t && (r = t.hasOwnProperty(`failedRequests`) && t.hasOwnProperty(`errors`) && t.hasOwnProperty(`cacheHits`)), n && r;
}
function Zd(e, t) {
  let n = !1;
  e && (n = e.indexOf(hl) === 0);
  let r = !0;
  return t && (r = t.hasOwnProperty(`throttleTime`)), n && r;
}
function Qd({
  environment: e,
  clientId: t
}) {
  return [ol, e, t].join(`-`).toLowerCase();
}
function $d(e, t) {
  return t ? e.indexOf(`appmetadata`) === 0 && t.hasOwnProperty(`clientId`) && t.hasOwnProperty(`environment`) : !1;
}
function ef(e, t) {
  return t ? e.indexOf(`authority-metadata`) === 0 && t.hasOwnProperty(`aliases`) && t.hasOwnProperty(`preferred_cache`) && t.hasOwnProperty(`preferred_network`) && t.hasOwnProperty(`canonical_authority`) && t.hasOwnProperty(`authorization_endpoint`) && t.hasOwnProperty(`token_endpoint`) && t.hasOwnProperty(`issuer`) && t.hasOwnProperty(`aliasesFromNetwork`) && t.hasOwnProperty(`endpointsFromNetwork`) && t.hasOwnProperty(`expiresAt`) && t.hasOwnProperty(`jwks_uri`) : !1;
}
function tf() {
  return Ld() + ll;
}
function nf(e, t, n) {
  e.authorization_endpoint = t.authorization_endpoint, e.token_endpoint = t.token_endpoint, e.end_session_endpoint = t.end_session_endpoint, e.issuer = t.issuer, e.endpointsFromNetwork = n, e.jwks_uri = t.jwks_uri;
}
function rf(e, t, n) {
  e.aliases = t.aliases, e.preferred_cache = t.preferred_cache, e.preferred_network = t.preferred_network, e.aliasesFromNetwork = n;
}
function af(e) {
  return e.expiresAt <= Ld();
}
function of(e) {
  if (e && e.length !== 0) return [...e].sort().join(` `);
}
var sf = class e {
  constructor(e, t, n, r, i, a, o, s) {
    this.canonicalAuthority = e, this._canonicalAuthority.validateAsUri(), this.networkInterface = t, this.cacheManager = n, this.authorityOptions = r, this.regionDiscoveryMetadata = {
      region_used: void 0,
      region_source: void 0,
      region_outcome: void 0
    }, this.logger = i, this.performanceClient = o, this.correlationId = a, this.managedIdentity = s || !1, this.regionDiscovery = new Id(t, this.logger, this.performanceClient, this.correlationId);
  }
  getAuthorityType(e) {
    if (e.HostNameAndPort.endsWith(`.ciamlogin.com`)) return du.Ciam;
    let t = e.PathSegments;
    if (t.length) switch (t[0].toLowerCase()) {
      case Ac:
        return du.Adfs;
    }
    return du.Default;
  }
  get authorityType() {
    return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
  }
  get protocolMode() {
    return this.authorityOptions.protocolMode;
  }
  get options() {
    return this.authorityOptions;
  }
  get canonicalAuthority() {
    return this._canonicalAuthority.urlString;
  }
  set canonicalAuthority(e) {
    this._canonicalAuthority = new Yu(e, this.correlationId), this._canonicalAuthority.validateAsUri(), this._canonicalAuthorityUrlComponents = null;
  }
  get canonicalAuthorityUrlComponents() {
    return this._canonicalAuthorityUrlComponents ||= this._canonicalAuthority.getUrlComponents(), this._canonicalAuthorityUrlComponents;
  }
  get hostnameAndPort() {
    return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
  }
  get tenant() {
    return this.canonicalAuthorityUrlComponents.PathSegments[0];
  }
  get authorizationEndpoint() {
    if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
    throw q(kl, this.correlationId);
  }
  get tokenEndpoint() {
    if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
    throw q(kl, this.correlationId);
  }
  get deviceCodeEndpoint() {
    if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace(`/token`, `/devicecode`));
    throw q(kl, this.correlationId);
  }
  get endSessionEndpoint() {
    if (this.discoveryComplete()) {
      if (!this.metadata.end_session_endpoint) throw q(Ql, this.correlationId);
      return this.replacePath(this.metadata.end_session_endpoint);
    }
    throw q(kl, this.correlationId);
  }
  get selfSignedJwtAudience() {
    if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
    throw q(kl, this.correlationId);
  }
  get jwksUri() {
    if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
    throw q(kl, this.correlationId);
  }
  canReplaceTenant(t) {
    return t.PathSegments.length === 1 && !e.reservedTenantDomains.has(t.PathSegments[0]) && this.getAuthorityType(t) === du.Default && this.protocolMode !== pu.OIDC;
  }
  replaceTenant(e) {
    return e.replace(/{tenant}|{tenantid}/g, this.tenant);
  }
  replacePath(e) {
    let t = e,
      n = new Yu(this.metadata.canonical_authority, this.correlationId).getUrlComponents(),
      r = n.PathSegments;
    return this.canonicalAuthorityUrlComponents.PathSegments.forEach((e, i) => {
      let a = r[i];
      if (i === 0 && this.canReplaceTenant(n)) {
        let e = new Yu(this.metadata.authorization_endpoint, this.correlationId).getUrlComponents().PathSegments[0];
        a !== e && (this.logger.verbose(`1q3g2x ${a} ${e}`, this.correlationId), a = e);
      }
      e !== a && (t = t.replace(`/${a}/`, `/${e}/`));
    }), this.replaceTenant(t);
  }
  get defaultOpenIdConfigurationEndpoint() {
    let e = this.hostnameAndPort;
    return this.canonicalAuthority.endsWith(`v2.0/`) || this.authorityType === du.Adfs || this.protocolMode === pu.OIDC && !this.isAliasOfKnownMicrosoftAuthority(e) ? `${this.canonicalAuthority}.well-known/openid-configuration` : `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
  }
  discoveryComplete() {
    return !!this.metadata;
  }
  async resolveEndpointsAsync() {
    let e = this.getCurrentMetadataEntity(),
      t = await J(this.updateCloudDiscoveryMetadata.bind(this), Ed, this.logger, this.performanceClient, this.correlationId)(e);
    this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, e.preferred_network);
    let n = await J(this.updateEndpointMetadata.bind(this), Od, this.logger, this.performanceClient, this.correlationId)(e);
    this.updateCachedMetadata(e, t, {
      source: n
    }), this.performanceClient?.addFields({
      cloudDiscoverySource: t,
      authorityEndpointSource: n
    }, this.correlationId);
  }
  getCurrentMetadataEntity() {
    let e = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort, this.correlationId);
    return e ||= {
      aliases: [],
      preferred_cache: this.hostnameAndPort,
      preferred_network: this.hostnameAndPort,
      canonical_authority: this.canonicalAuthority,
      authorization_endpoint: ``,
      token_endpoint: ``,
      end_session_endpoint: ``,
      issuer: ``,
      aliasesFromNetwork: !1,
      endpointsFromNetwork: !1,
      expiresAt: tf(),
      jwks_uri: ``
    }, e;
  }
  updateCachedMetadata(e, t, n) {
    t !== ul.CACHE && n?.source !== ul.CACHE && (e.expiresAt = tf(), e.canonical_authority = this.canonicalAuthority);
    let r = this.cacheManager.generateAuthorityMetadataCacheKey(e.preferred_cache, this.correlationId);
    this.cacheManager.setAuthorityMetadata(r, e, this.correlationId), this.metadata = e;
  }
  async updateEndpointMetadata(e) {
    let t = this.updateEndpointMetadataFromLocalSources(e);
    if (t) return t.source === ul.HARDCODED_VALUES && this.authorityOptions.azureRegionConfiguration?.azureRegion && t.metadata && (nf(e, await J(this.updateMetadataWithRegionalInformation.bind(this), kd, this.logger, this.performanceClient, this.correlationId)(t.metadata), !1), e.canonical_authority = this.canonicalAuthority), t.source;
    let n = await J(this.getEndpointMetadataFromNetwork.bind(this), Dd, this.logger, this.performanceClient, this.correlationId)();
    if (n) return this.validateIssuer(n.issuer), this.authorityOptions.azureRegionConfiguration?.azureRegion && (n = await J(this.updateMetadataWithRegionalInformation.bind(this), kd, this.logger, this.performanceClient, this.correlationId)(n)), nf(e, n, !0), ul.NETWORK;
    throw q(jl, this.defaultOpenIdConfigurationEndpoint, this.correlationId);
  }
  updateEndpointMetadataFromLocalSources(e) {
    this.logger.verbose(`1fi0kc`, this.correlationId);
    let t = this.getEndpointMetadataFromConfig();
    if (t) return this.logger.verbose(`06t0uj`, this.correlationId), nf(e, t, !1), {
      source: ul.CONFIG
    };
    this.logger.verbose(`151k0p`, this.correlationId);
    let n = this.getEndpointMetadataFromHardcodedValues();
    if (n) return nf(e, n, !1), {
      source: ul.HARDCODED_VALUES,
      metadata: n
    };
    this.logger.verbose(`1imop5`, this.correlationId);
    let r = af(e);
    return this.isAuthoritySameType(e) && e.endpointsFromNetwork && !r ? (this.logger.verbose(`16uq31`, ``), {
      source: ul.CACHE
    }) : (r && this.logger.verbose(`0uoibc`, ``), null);
  }
  isAuthoritySameType(e) {
    return new Yu(e.canonical_authority, this.correlationId).getUrlComponents().PathSegments.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
  }
  getEndpointMetadataFromConfig() {
    if (this.authorityOptions.authorityMetadata) try {
      return JSON.parse(this.authorityOptions.authorityMetadata);
    } catch {
      throw xu(Mu, this.correlationId);
    }
    return null;
  }
  async getEndpointMetadataFromNetwork() {
    let e = {},
      t = this.defaultOpenIdConfigurationEndpoint;
    this.logger.verbose(`1y65x6 ${t}`, this.correlationId);
    try {
      let n = await this.networkInterface.sendGetRequestAsync(t, e);
      return qu(n.body) ? n.body : (this.logger.verbose(`1koyv8`, this.correlationId), null);
    } catch (e) {
      return this.logger.verbose(`0a9wik ${e}`, this.correlationId), null;
    }
  }
  getEndpointMetadataFromHardcodedValues() {
    return this.hostnameAndPort in $u ? $u[this.hostnameAndPort] : null;
  }
  async updateMetadataWithRegionalInformation(t) {
    let n = this.authorityOptions.azureRegionConfiguration?.azureRegion;
    if (n) {
      if (n !== `TryAutoDetect`) return this.regionDiscoveryMetadata.region_outcome = vl.CONFIGURED_NO_AUTO_DETECTION, this.regionDiscoveryMetadata.region_used = n, e.replaceWithRegionalInformation(t, n, this.correlationId);
      let r = await J(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), Ad, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
      if (r) return this.regionDiscoveryMetadata.region_outcome = vl.AUTO_DETECTION_REQUESTED_SUCCESSFUL, this.regionDiscoveryMetadata.region_used = r, e.replaceWithRegionalInformation(t, r, this.correlationId);
      this.regionDiscoveryMetadata.region_outcome = vl.AUTO_DETECTION_REQUESTED_FAILED;
    }
    return t;
  }
  async updateCloudDiscoveryMetadata(e) {
    let t = this.updateCloudDiscoveryMetadataFromLocalSources(e);
    if (t) return t;
    let n = await J(this.getCloudDiscoveryMetadataFromNetwork.bind(this), Td, this.logger, this.performanceClient, this.correlationId)();
    if (n) return rf(e, n, !0), ul.NETWORK;
    throw xu(Nu, this.correlationId);
  }
  updateCloudDiscoveryMetadataFromLocalSources(e) {
    this.logger.verbose(`1tpqlr`, this.correlationId), this.logger.verbosePii(`1fy7uz ${this.authorityOptions.knownAuthorities || `N/A`}`, this.correlationId), this.logger.verbosePii(`08zabj ${this.authorityOptions.authorityMetadata || `N/A`}`, this.correlationId), this.logger.verbosePii(`1o1kv3 ${e.canonical_authority || `N/A`}`, this.correlationId);
    let t = this.getCloudDiscoveryMetadataFromConfig();
    if (t) return this.logger.verbose(`1nakio`, this.correlationId), rf(e, t, !1), ul.CONFIG;
    this.logger.verbose(`1x74aj`, this.correlationId);
    let n = id(this.hostnameAndPort);
    if (n) return this.logger.verbose(`0by47c`, this.correlationId), rf(e, n, !1), ul.HARDCODED_VALUES;
    this.logger.verbose(`0r2fzy`, this.correlationId);
    let r = af(e);
    return this.isAuthoritySameType(e) && e.aliasesFromNetwork && !r ? (this.logger.verbose(`1uffgh`, ``), ul.CACHE) : (r && this.logger.verbose(`0uoibc`, ``), null);
  }
  getCloudDiscoveryMetadataFromConfig() {
    if (this.authorityType === du.Ciam) return this.logger.verbose(`04y84h`, this.correlationId), e.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
    if (this.authorityOptions.cloudDiscoveryMetadata) {
      this.logger.verbose(`0gszr3`, this.correlationId);
      try {
        this.logger.verbose(`1iifkx`, this.correlationId);
        let e = ad(JSON.parse(this.authorityOptions.cloudDiscoveryMetadata).metadata, this.hostnameAndPort);
        if (this.logger.verbose(`0q67e3`, ``), e) return this.logger.verbose(`0hzfao`, this.correlationId), e;
        this.logger.verbose(`1ajz3u`, this.correlationId);
      } catch {
        throw this.logger.verbose(`1wq5tu`, this.correlationId), xu(ju, this.correlationId);
      }
    }
    return this.isInKnownAuthorities(this.hostnameAndPort) ? (this.logger.verbose(`0mt9al`, this.correlationId), e.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort)) : null;
  }
  async getCloudDiscoveryMetadataFromNetwork() {
    let t = `${jc}${this.canonicalAuthority}oauth2/v2.0/authorize`,
      n = {},
      r = null;
    try {
      let e = await this.networkInterface.sendGetRequestAsync(t, n),
        i,
        a;
      if (sd(e.body)) i = e.body, a = i.metadata, this.logger.verbosePii(`1vglyt ${i.tenant_discovery_endpoint}`, this.correlationId);else if (cd(e.body)) {
        if (this.logger.warning(`062uto ${e.status}`, this.correlationId), i = e.body, i.error === `invalid_instance`) return this.logger.error(`1x90tm`, this.correlationId), null;
        this.logger.warning(`0wchdm ${i.error}`, this.correlationId), this.logger.warning(`1s5mpv ${i.error_description}`, this.correlationId), this.logger.warning(`1yhqpw`, this.correlationId), a = [];
      } else return this.logger.error(`0768g0`, this.correlationId), null;
      this.logger.verbose(`1lrobr`, this.correlationId), r = ad(a, this.hostnameAndPort);
    } catch (e) {
      if (e instanceof Sl) this.logger.error(`0vwhc7 ${e.errorCode} ${e.errorMessage}`, this.correlationId);else {
        let t = e;
        this.logger.error(`0s2z41 ${t.name} ${t.message}`, this.correlationId);
      }
      return null;
    }
    return r ||= (this.logger.warning(`0jp28q`, this.correlationId), this.logger.verbose(`130sd8`, this.correlationId), e.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort)), r;
  }
  isInKnownAuthorities(e) {
    let t = e.toLowerCase();
    return this.authorityOptions.knownAuthorities.filter(e => e && Yu.getDomainFromUrl(e, this.correlationId).toLowerCase() === t).length > 0;
  }
  static generateAuthority(e, t) {
    let n;
    if (t && t.azureCloudInstance !== od.None) {
      let e = t.tenant ? t.tenant : kc;
      n = `${t.azureCloudInstance}/${e}/`;
    }
    return n || e;
  }
  static createCloudDiscoveryMetadataFromHost(e) {
    return {
      preferred_network: e,
      preferred_cache: e,
      aliases: [e]
    };
  }
  getPreferredCache() {
    if (this.managedIdentity) return Oc;
    if (this.discoveryComplete()) return this.metadata.preferred_cache;
    throw q(kl, this.correlationId);
  }
  isAlias(e) {
    return this.metadata.aliases.indexOf(e) > -1;
  }
  isAliasOfKnownMicrosoftAuthority(e) {
    return td.has(e);
  }
  validateIssuer(e) {
    if (!e) throw xu(Hu, this.correlationId);
    let t;
    try {
      t = new URL(e);
    } catch {
      throw xu(Hu, this.correlationId);
    }
    let n = t.protocol,
      r = t.host,
      i = (this.canonicalAuthorityUrlComponents.Protocol || ``).toLowerCase(),
      a = (this.canonicalAuthorityUrlComponents.HostNameAndPort || ``).toLowerCase(),
      o = this.matchesAuthorityOrigin(n, r, i, a),
      s = n === `https:` && this.isAliasOfKnownMicrosoftAuthority(r),
      c = n === `https:` && this.matchesRegionalMicrosoftHost(r),
      l = this.matchesCiamTenantPattern(t, a, this.canonicalAuthorityUrlComponents.PathSegments),
      u = n === `https:` && this.isInKnownAuthorities(r);
    if (!(o || s || c || l || u)) throw xu(Hu, this.correlationId);
  }
  matchesAuthorityOrigin(e, t, n, r) {
    return e === n && t === r;
  }
  matchesRegionalMicrosoftHost(e) {
    let t = e.indexOf(`.`);
    if (t > 0 && t < e.length - 1) {
      let n = e.substring(t + 1);
      return this.isAliasOfKnownMicrosoftAuthority(n);
    }
    return !1;
  }
  matchesCiamTenantPattern(e, t, n) {
    let r = n[0],
      i = r ? r.endsWith(`.onmicrosoft.com`) ? r.slice(0, -Nc.length) : r : t.split(`.`)[0];
    if (!i) return !1;
    let a = `https://${i}${Mc}`,
      o = [a, `${a}/${i}`, `${a}/${i}/v2.0`, `${a}/${i}${Nc}`, `${a}/${i}${Nc}/v2.0`],
      s = e.pathname.replace(/\/+$/, ``),
      c = `${e.protocol}//${e.host}${s}`;
    return o.some(e => e === c);
  }
  static isPublicCloudAuthority(e) {
    return Wc.indexOf(e) >= 0;
  }
  static buildRegionalAuthorityString(e, t, n, r) {
    let i = new Yu(e, n);
    i.validateAsUri();
    let a = i.getUrlComponents(),
      o = `${t}.${a.HostNameAndPort}`;
    this.isPublicCloudAuthority(a.HostNameAndPort) && (o = `${t}.${Uc}`);
    let s = Yu.constructAuthorityUriFromObject({
      ...i.getUrlComponents(),
      HostNameAndPort: o
    }, n).urlString;
    return r ? `${s}?${r}` : s;
  }
  static replaceWithRegionalInformation(t, n, r) {
    let i = {
      ...t
    };
    return i.authorization_endpoint = e.buildRegionalAuthorityString(i.authorization_endpoint, n, r), i.token_endpoint = e.buildRegionalAuthorityString(i.token_endpoint, n, r), i.end_session_endpoint &&= e.buildRegionalAuthorityString(i.end_session_endpoint, n, r), i;
  }
  static transformCIAMAuthority(e, t) {
    let n = e,
      r = new Yu(e, t).getUrlComponents();
    if (r.PathSegments.length === 0 && r.HostNameAndPort.endsWith(`.ciamlogin.com`)) {
      let e = r.HostNameAndPort.split(`.`)[0];
      n = `${n}${e}${Nc}`;
    }
    return n;
  }
};
sf.reservedTenantDomains = new Set([`{tenant}`, `{tenantid}`, Xc.COMMON, Xc.CONSUMERS, Xc.ORGANIZATIONS]);
function cf(e, t) {
  let n = new Yu(e, t).getUrlComponents().PathSegments.slice(-1)[0]?.toLowerCase();
  switch (n) {
    case Xc.COMMON:
    case Xc.ORGANIZATIONS:
    case Xc.CONSUMERS:
      return;
    default:
      return n;
  }
}
function lf(e) {
  return e.endsWith(`/`) ? e : `${e}/`;
}
function uf(e) {
  let t = e.cloudDiscoveryMetadata,
    n;
  if (t) try {
    n = JSON.parse(t);
  } catch {
    throw xu(ju, ``);
  }
  return {
    canonicalAuthority: e.authority ? lf(e.authority) : void 0,
    knownAuthorities: e.knownAuthorities,
    cloudDiscoveryMetadata: n
  };
}
async function df(e, t, n, r, i, a, o) {
  let s = new sf(sf.transformCIAMAuthority(lf(e), a), t, n, r, i, a, o);
  try {
    return await J(s.resolveEndpointsAsync.bind(s), wd, i, o, a)(), s;
  } catch {
    throw q(kl, a);
  }
}
var ff = class e {
  constructor(e, t) {
    this.correlationId = t;
    let n = e ? Ju.trimArrayEntries([...e]) : [],
      r = n ? Ju.removeEmptyStringsFromArray(n) : [];
    if (!r || !r.length) throw xu(Eu, t);
    this.scopes = new Set(), r.forEach(e => this.scopes.add(e));
  }
  static fromString(t, n) {
    let r = (t || ``).split(` `);
    return new e(r, n);
  }
  static createSearchScopes(t, n) {
    let r = t && t.length > 0 ? t : [...Kc],
      i = new e(r, n);
    return i.containsOnlyOIDCScopes() ? i.removeScope(Ic) : i.removeOIDCScopes(), i;
  }
  containsScope(t) {
    let n = this.printScopesLowerCase().split(` `),
      r = new e(n, this.correlationId);
    return t ? r.scopes.has(t.toLowerCase()) : !1;
  }
  containsScopeSet(e) {
    return !e || e.scopes.size <= 0 ? !1 : this.scopes.size >= e.scopes.size && e.asArray().every(e => this.containsScope(e));
  }
  containsOnlyOIDCScopes() {
    let e = 0;
    return qc.forEach(t => {
      this.containsScope(t) && (e += 1);
    }), this.scopes.size === e;
  }
  appendScope(e) {
    e && this.scopes.add(e.trim());
  }
  appendScopes(e) {
    try {
      e.forEach(e => this.appendScope(e));
    } catch {
      throw q(Bl, this.correlationId);
    }
  }
  removeScope(e) {
    if (!e) throw q(zl, this.correlationId);
    this.scopes.delete(e.trim());
  }
  removeOIDCScopes() {
    qc.forEach(e => {
      this.scopes.delete(e);
    });
  }
  unionScopeSets(e) {
    if (!e) throw q(Vl, this.correlationId);
    let t = new Set();
    return e.scopes.forEach(e => t.add(e.toLowerCase())), this.scopes.forEach(e => t.add(e.toLowerCase())), t;
  }
  intersectingScopeSets(e) {
    if (!e) throw q(Vl, this.correlationId);
    e.containsOnlyOIDCScopes() || e.removeOIDCScopes();
    let t = this.unionScopeSets(e),
      n = e.getScopeCount(),
      r = this.getScopeCount();
    return t.size < r + n;
  }
  getScopeCount() {
    return this.scopes.size;
  }
  asArray() {
    let e = [];
    return this.scopes.forEach(t => e.push(t)), e;
  }
  printScopes() {
    return this.scopes ? this.asArray().join(` `) : ``;
  }
  printScopesLowerCase() {
    return this.printScopes().toLowerCase();
  }
};
function pf(e, t, n) {
  if (!t) return;
  let r = e.get(Ns);
  r && e.has(`brk_client_id`) && n?.addFields({
    embeddedClientId: r,
    embeddedRedirectUri: e.get(Ps)
  }, t);
}
function mf(e, t) {
  e.set(Fs, t);
}
function hf(e, t) {
  e.set(Is, t || el.QUERY);
}
function gf(e) {
  e.set(pc, `1`);
}
function _f(e, t, n, r = !0, i = Kc) {
  r && !i.includes(`openid`) && !t.includes(`openid`) && i.push(`openid`);
  let a = new ff(r ? [...(t || []), ...i] : t || [], n);
  e.set(zs, a.printScopes());
}
function vf(e, t) {
  e.set(Ns, t);
}
function yf(e, t) {
  e.set(Ps, t);
}
function bf(e, t) {
  e.set(ic, t);
}
function xf(e, t) {
  e.set(ac, t);
}
function Sf(e, t) {
  e.set(gc, t);
}
function Cf(e, t) {
  e.set(hc, t);
}
function wf(e, t) {
  e.set(Jc.CCS_HEADER, `UPN:${t}`);
}
function Tf(e, t) {
  e.set(Jc.CCS_HEADER, `Oid:${t.uid}@${t.utid}`);
}
function Ef(e, t) {
  e.set(`sid`, t);
}
function Df(e, t, n, r, i, a) {
  let o = Xf(n, i && e.has(`brk_client_id`) ? void 0 : r, t, a);
  e.set(Rs, o);
}
function Of(e, t) {
  e.set(Js, t);
}
function kf(e, t) {
  e.set(Ys, t.sku), e.set(Xs, t.version), t.os && e.set(Zs, t.os), t.cpu && e.set(Qs, t.cpu);
}
function Af(e, t) {
  t?.appName && e.set(nc, t.appName), t?.appVersion && e.set(rc, t.appVersion);
}
function jf(e, t) {
  e.set(Us, t);
}
function Mf(e, t) {
  t && e.set(Vs, t);
}
function Nf(e, t) {
  e.set(Hs, t);
}
function Pf(e, t, n) {
  if (t && n) e.set(Gs, t), e.set(Ks, n);else throw xu(Au, ``);
}
function Ff(e, t) {
  e.set(Ws, t);
}
function If(e, t) {
  e.set(Bs, t);
}
function Lf(e, t) {
  e.set(qs, t);
}
function Rf(e, t) {
  e.set(oc, t);
}
function zf(e, t) {
  t && e.set(sc, t);
}
function Bf(e, t) {
  t && e.set(cc, t);
}
function Vf(e, t) {
  e.set(Ls, t);
}
function Hf(e) {
  e.set(sl, `1`);
}
function Uf(e) {
  e.set(wc, `1`);
}
function Wf(e) {
  e.has(`instance_aware`) || e.set(bc, `true`);
}
function Gf(e, t) {
  Object.entries(t).forEach(([t, n]) => {
    !e.has(t) && n && e.set(t, n);
  });
}
var Kf = {
  [Zc.SIGNIN_STATE]: {
    essential: !1
  },
  [Zc.LOGIN_HINT]: {
    essential: !1
  },
  [Zc.TENANT_REGION_SUB_SCOPE]: {
    essential: !1
  }
};
function qf(e, t = ``) {
  let n;
  try {
    n = JSON.parse(e);
  } catch {
    throw xu(Du, t);
  }
  if (!Jf(n)) throw xu(Du, t);
  return n;
}
function Jf(e) {
  return typeof e == `object` && !!e && !Array.isArray(e);
}
function Yf(e, t) {
  let n = {
    ...e
  };
  for (let [e, r] of Object.entries(t)) {
    let t = n[e];
    n[e] = Jf(t) && Jf(r) ? Yf(t, r) : r;
  }
  return n;
}
function Xf(e, t, n = ``, r) {
  let i = e ? qf(e, n) : {};
  r?.trim() && (i = Yf(i, qf(r, n))), Object.prototype.hasOwnProperty.call(i, Zc.ID_TOKEN) || (i[Zc.ID_TOKEN] = {});
  let a = i[Zc.ID_TOKEN];
  for (let [e, t] of Object.entries(Kf)) e in a || (a[e] = t);
  return t && t.length > 0 && (Object.prototype.hasOwnProperty.call(i, Zc.ACCESS_TOKEN) || (i[Zc.ACCESS_TOKEN] = {}), i[Zc.ACCESS_TOKEN][Zc.XMS_CC] = {
    values: t
  }), JSON.stringify(i);
}
function Zf(e, t) {
  t && (e.set(lc, pl.POP), e.set(uc, t));
}
function Qf(e, t) {
  t && (e.set(lc, pl.SSH), e.set(uc, t));
}
function $f(e, t) {
  e.set($s, t.generateCurrentRequestHeaderValue()), e.set(ec, t.generateLastRequestHeaderValue());
}
function ep(e) {
  e.set(tc, gl);
}
function tp(e, t) {
  e.set(mc, t);
}
function np(e, t, n) {
  e.has(`brk_client_id`) || e.set(vc, t), e.has(`brk_redirect_uri`) || e.set(yc, n);
}
function rp(e, t) {
  e.set(xc, encodeURIComponent(t)), e.set(Sc, `eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0`);
}
function ip(e, t) {
  t && e.set(Cc, t);
}
function ap(e, t) {
  let n = of(t);
  n ? e.set(Tc, n) : e.delete(Tc);
}
function op(e) {
  return e.startsWith(`#/`) ? e.substring(2) : e.startsWith(`#`) || e.startsWith(`?`) ? e.substring(1) : e;
}
function sp(e) {
  if (!e || e.indexOf(`=`) < 0) return null;
  try {
    let t = op(e),
      n = Object.fromEntries(new URLSearchParams(t));
    if (n.code || n.ear_jwe || n.error || n.error_description || n.state) return n;
  } catch {
    throw q(Ml, ``);
  }
  return null;
}
function cp(e) {
  let t = [];
  return e.forEach((e, n) => {
    t.push(`${n}=${encodeURIComponent(e)}`);
  }), t.join(`&`);
}
function lp(e, t, n) {
  if (!e) return e;
  let r = e.split(`#`)[0];
  if (!r) return r;
  try {
    let e = new URL(r);
    e.search ||= ``;
    let t;
    try {
      t = decodeURIComponent(e.pathname);
    } catch {
      t = e.pathname;
    }
    return t.endsWith(`/`) || (t += `/`), e.pathname = t, e.href;
  } catch (e) {
    throw t?.error(`15apdm ${e}`, n || ``), xu(wu, n || ``);
  }
}
function up(e, t, n) {
  try {
    new URL(e);
  } catch (e) {
    throw t?.error(`1lrjz7 ${e}`, n || ``), xu(wu, n || ``);
  }
}
var dp = {
    ES256: `ES256`,
    RS256: `RS256`
  },
  fp = {
    createNewGuid: () => {
      throw q(eu, ``);
    },
    base64Decode: () => {
      throw q(eu, ``);
    },
    base64Encode: () => {
      throw q(eu, ``);
    },
    base64UrlEncode: () => {
      throw q(eu, ``);
    },
    encodeKid: () => {
      throw q(eu, ``);
    },
    async removeTokenBindingKey(e, t) {
      throw q(eu, t);
    },
    async clearKeystore(e) {
      throw q(eu, e);
    },
    async signTokenBindingJwt(e, t, n, r) {
      throw q(eu, r);
    },
    async hashString() {
      throw q(eu, ``);
    }
  },
  pp = {
    async provisionTokenBindingKey(e) {
      throw q(eu, e.correlationId);
    },
    async removeTokenBindingKey(e, t) {
      throw q(eu, t);
    },
    async getTokenBindingPublicKeyJwk(e, t) {
      throw q(eu, t);
    }
  },
  mp;
(function (e) {
  e[e.Error = 0] = `Error`, e[e.Warning = 1] = `Warning`, e[e.Info = 2] = `Info`, e[e.Verbose = 3] = `Verbose`, e[e.Trace = 4] = `Trace`;
})(mp ||= {});
var hp = 50,
  gp = 500,
  _p = new Map();
function vp(e, t) {
  _p.delete(e), _p.set(e, t);
}
function yp(e, t) {
  let n = Date.now(),
    r = _p.get(e);
  if (r) vp(e, r);else if (r = {
    logs: [],
    firstEventTime: n
  }, _p.set(e, r), _p.size > hp) {
    let e = _p.keys().next().value;
    e !== void 0 && _p.delete(e);
  }
  r.logs.push({
    ...t,
    milliseconds: n - r.firstEventTime
  }), r.logs.length > gp && r.logs.shift();
}
function bp(e) {
  if (e.length < 6 || e.length > 6 && e[6] !== ` `) return null;
  for (let t = 0; t < 6; t++) {
    let n = e[t];
    if (!(n >= `a` && n <= `z` || n >= `A` && n <= `Z` || n >= `0` && n <= `9`)) return null;
  }
  return e.substring(0, 6);
}
var xp = class e {
    constructor(t, n, r) {
      this.level = mp.Info;
      let i = () => {},
        a = t || e.createDefaultLoggerOptions();
      this.localCallback = a.loggerCallback || i, this.piiLoggingEnabled = a.piiLoggingEnabled || !1, this.level = typeof a.logLevel == `number` ? a.logLevel : mp.Info, this.packageName = n || ``, this.packageVersion = r || ``;
    }
    static createDefaultLoggerOptions() {
      return {
        loggerCallback: () => {},
        piiLoggingEnabled: !1,
        logLevel: mp.Info
      };
    }
    clone(t, n) {
      return new e({
        loggerCallback: this.localCallback,
        piiLoggingEnabled: this.piiLoggingEnabled,
        logLevel: this.level
      }, t, n);
    }
    logMessage(e, t) {
      let n = t.correlationId,
        r = bp(e);
      if (r && yp(n, {
        hash: r,
        level: t.logLevel,
        containsPii: t.containsPii || !1,
        milliseconds: 0
      }), t.logLevel > this.level || !this.piiLoggingEnabled && t.containsPii) return;
      let i = `${`[${new Date().toUTCString()}] : [${n}]`} : ${this.packageName}@${this.packageVersion} : ${mp[t.logLevel]} - ${e}`;
      this.executeCallback(t.logLevel, i, t.containsPii || !1);
    }
    executeCallback(e, t, n) {
      this.localCallback && this.localCallback(e, t, n);
    }
    error(e, t) {
      this.logMessage(e, {
        logLevel: mp.Error,
        containsPii: !1,
        correlationId: t
      });
    }
    errorPii(e, t) {
      this.logMessage(e, {
        logLevel: mp.Error,
        containsPii: !0,
        correlationId: t
      });
    }
    warning(e, t) {
      this.logMessage(e, {
        logLevel: mp.Warning,
        containsPii: !1,
        correlationId: t
      });
    }
    warningPii(e, t) {
      this.logMessage(e, {
        logLevel: mp.Warning,
        containsPii: !0,
        correlationId: t
      });
    }
    info(e, t) {
      this.logMessage(e, {
        logLevel: mp.Info,
        containsPii: !1,
        correlationId: t
      });
    }
    infoPii(e, t) {
      this.logMessage(e, {
        logLevel: mp.Info,
        containsPii: !0,
        correlationId: t
      });
    }
    verbose(e, t) {
      this.logMessage(e, {
        logLevel: mp.Verbose,
        containsPii: !1,
        correlationId: t
      });
    }
    verbosePii(e, t) {
      this.logMessage(e, {
        logLevel: mp.Verbose,
        containsPii: !0,
        correlationId: t
      });
    }
    trace(e, t) {
      this.logMessage(e, {
        logLevel: mp.Trace,
        containsPii: !1,
        correlationId: t
      });
    }
    tracePii(e, t) {
      this.logMessage(e, {
        logLevel: mp.Trace,
        containsPii: !0,
        correlationId: t
      });
    }
    isPiiLoggingEnabled() {
      return this.piiLoggingEnabled || !1;
    }
  },
  Sp = `@azure/msal-common`,
  Cp = `16.14.0`,
  wp = `cache_quota_exceeded`,
  Tp = `cache_error_unknown`,
  Ep = class e extends Error {
    constructor(t, n) {
      let r = n || xl(t);
      super(r), Object.setPrototypeOf(this, e.prototype), this.name = `CacheError`, this.errorCode = t, this.errorMessage = r;
    }
  };
function Dp(e) {
  return e instanceof Error ? e.name === `QuotaExceededError` || e.name === `NS_ERROR_DOM_QUOTA_REACHED` || e.message.includes(`exceeded the quota`) ? new Ep(wp) : new Ep(e.name, e.message) : new Ep(Tp);
}
var Op = class {
    constructor(e, t, n, r, i, a) {
      this.clientId = e, this.cryptoImpl = t, this.tokenBindingKeyManager = a, this.commonLogger = n.clone(Sp, Cp), this.staticAuthorityOptions = i, this.performanceClient = r;
    }
    getAllAccounts(e = {}, t) {
      return this.buildTenantProfiles(this.getAccountsFilteredBy(e, t), t, e);
    }
    getAccountInfoFilteredBy(e, t) {
      if (Object.keys(e).length === 0 || Object.values(e).every(e => e == null || e === ``)) return this.commonLogger.warning(`1skb02`, t), null;
      let n = this.getAllAccounts(e, t);
      return n.length > 1 ? n.sort((e, t) => {
        let n = +!!e.idTokenClaims;
        return +!!t.idTokenClaims - n;
      })[0] : n.length === 1 ? n[0] : null;
    }
    getBaseAccountInfo(e, t) {
      let n = this.getAccountsFilteredBy(e, t);
      return n.length > 0 ? mu(n[0]) : null;
    }
    buildTenantProfiles(e, t, n) {
      return e.flatMap(e => this.getTenantProfilesFromAccountEntity(e, t, n?.tenantId, n));
    }
    getTenantedAccountInfoByFilter(e, t, n, r, i) {
      let a = null,
        o;
      if (i && !this.tenantProfileMatchesFilter(n, i)) return null;
      let s = this.getIdToken(e, r, t, n.tenantId);
      return s && (o = au(s.secret, this.cryptoImpl.base64Decode, r), !this.idTokenClaimsMatchTenantProfileFilter(o, i)) ? null : (a = uu(e, n, o, s?.secret), a);
    }
    getTenantProfilesFromAccountEntity(e, t, n, r) {
      let i = mu(e),
        a = i.tenantProfiles || new Map(),
        o = this.getTokenKeys();
      if (n) {
        let e = a.get(n);
        if (e) a = new Map([[n, e]]);else return [];
      }
      let s = [];
      return a.forEach(e => {
        let n = this.getTenantedAccountInfoByFilter(i, o, e, t, r);
        n && s.push(n);
      }), s;
    }
    tenantProfileMatchesFilter(e, t) {
      return !(t.localAccountId && !this.matchLocalAccountIdFromTenantProfile(e, t.localAccountId) || t.name && e.name !== t.name || t.isHomeTenant !== void 0 && e.isHomeTenant !== t.isHomeTenant || t.username && !this.matchUsername(e.username, t.username) && !this.matchUsername(e.upn, t.username) || t.loginHint && !this.matchLoginHintWithTenantProfile(e, t.loginHint) || t.upn && e.upn !== t.upn || t.nativeAccountId && e.nativeAccountId !== t.nativeAccountId);
    }
    idTokenClaimsMatchTenantProfileFilter(e, t) {
      return !(t && (t.localAccountId && !this.matchLocalAccountIdFromTokenClaims(e, t.localAccountId) || t.loginHint && !this.matchLoginHintFromTokenClaims(e, t.loginHint) || t.username && !this.matchUsername(e.preferred_username, t.username) && !this.matchUsername(e.upn, t.username) || t.name && !this.matchName(e, t.name) || t.sid && !this.matchSid(e, t.sid)));
    }
    async saveCacheRecord(e, t, n, r, i) {
      if (!e) throw q(Ul, t);
      try {
        e.account && (await this.setAccount(e.account, t, n, r)), e.idToken && i?.idToken !== !1 && (await this.setIdTokenCredential(e.idToken, t, n)), e.accessToken && i?.accessToken !== !1 && (await this.saveAccessToken(e.accessToken, t, n)), e.refreshToken && i?.refreshToken !== !1 && (await this.setRefreshTokenCredential(e.refreshToken, t, n)), e.appMetadata && this.setAppMetadata(e.appMetadata, t);
      } catch (e) {
        throw this.commonLogger?.error(`0j476p`, t), e instanceof Sl ? e : Dp(e);
      }
    }
    async saveAccessToken(e, t, n) {
      let r;
      e.additionalCacheKeyComponents && Object.keys(e.additionalCacheKeyComponents).length > 0 && (r = await this.cryptoImpl.hashString(JSON.stringify(e.additionalCacheKeyComponents)));
      let i = {
          clientId: e.clientId,
          credentialType: e.credentialType,
          environment: e.environment,
          homeAccountId: e.homeAccountId,
          realm: e.realm,
          tokenType: e.tokenType
        },
        a = this.getTokenKeys(),
        o = ff.fromString(e.target, t);
      a.accessToken.forEach(e => {
        if (!this.accessTokenKeyMatchesFilter(e, i, !1)) return;
        let n = this.getAccessTokenCredential(e, t);
        n && this.credentialMatchesFilter(n, i, t) && ff.fromString(n.target, t).intersectingScopeSets(o) && this.removeAccessToken(e, t);
      }), await this.setAccessTokenCredential(e, t, n, r);
    }
    getAccountsFilteredBy(e, t) {
      let n = this.getAccountKeys(),
        r = [];
      return n.forEach(n => {
        let i = this.getAccount(n, t);
        if (!i || e.homeAccountId && !this.matchHomeAccountId(i, e.homeAccountId) || e.environment && !this.matchEnvironment(i, e.environment, t) || e.realm && !this.matchRealm(i, e.realm) || e.authorityType && !this.matchAuthorityType(i, e.authorityType)) return;
        let a = {
            localAccountId: e?.localAccountId,
            name: e?.name,
            username: e?.username,
            loginHint: e?.loginHint,
            upn: e?.upn,
            nativeAccountId: e?.nativeAccountId
          },
          o = i.tenantProfiles?.filter(e => this.tenantProfileMatchesFilter(e, a));
        o && o.length === 0 || r.push(i);
      }), r;
    }
    credentialMatchesFilter(e, t, n) {
      if (t.clientId && !this.matchClientId(e, t.clientId) || t.userAssertionHash && !this.matchUserAssertionHash(e, t.userAssertionHash) || typeof t.homeAccountId == `string` && !this.matchHomeAccountId(e, t.homeAccountId) || t.environment && !this.matchEnvironment(e, t.environment, n) || t.realm && !this.matchRealm(e, t.realm) || t.credentialType && !this.matchCredentialType(e, t.credentialType) || t.familyId && !this.matchFamilyId(e, t.familyId) || t.target && !this.matchTarget(e, t.target, n) || e.credentialType === al.ACCESS_TOKEN_WITH_AUTH_SCHEME && !this.matchAccessTokenWithAuthScheme(e, t)) return !1;
      let r = e.additionalCacheKeyComponents,
        i = t.additionalCacheKeyComponents,
        a = !!r && Object.keys(r).length > 0,
        o = !!i && Object.keys(i).length > 0;
      if (a !== o) return !1;
      if (a && o) {
        let e = Object.keys(r).sort(),
          t = Object.keys(i).sort();
        if (e.length !== t.length) return !1;
        for (let n = 0; n < e.length; n++) if (e[n] !== t[n] || r[e[n]] !== i[t[n]]) return !1;
      }
      return !0;
    }
    getAppMetadataFilteredBy(e, t) {
      let n = this.getKeys(),
        r = {};
      return n.forEach(n => {
        if (!this.isAppMetadata(n)) return;
        let i = this.getAppMetadata(n, t);
        i && (!e.environment || this.matchEnvironment(i, e.environment, t)) && (!e.clientId || this.matchClientId(i, e.clientId)) && (r[n] = i);
      }), r;
    }
    getAuthorityMetadataByAlias(e, t) {
      let n = this.getAuthorityMetadataKeys(),
        r = null;
      return n.forEach(n => {
        if (!this.isAuthorityMetadata(n) || n.indexOf(this.clientId) === -1) return;
        let i = this.getAuthorityMetadata(n, t);
        i && i.aliases.indexOf(e) !== -1 && (r = i);
      }), r;
    }
    removeAllAccounts(e) {
      this.getAllAccounts({}, e).forEach(t => {
        this.removeAccount(t, e);
      });
    }
    removeAccount(e, t) {
      this.removeAccountContext(e, t), this.getAccountKeys().filter(t => t.includes(e.homeAccountId) && t.includes(e.environment)).forEach(e => {
        this.removeItem(e, t), this.performanceClient.incrementFields({
          accountsRemoved: 1
        }, t);
      });
    }
    removeAccountContext(e, t) {
      let n = this.getTokenKeys(),
        r = t => t.includes(e.homeAccountId) && t.includes(e.environment);
      n.idToken.filter(r).forEach(e => {
        this.removeIdToken(e, t);
      }), n.accessToken.filter(r).forEach(e => {
        this.removeAccessToken(e, t);
      }), n.refreshToken.filter(r).forEach(e => {
        this.removeRefreshToken(e, t);
      });
    }
    removeAccessToken(e, t) {
      let n = this.getAccessTokenCredential(e, t);
      if (n && (this.removeItem(e, t), this.performanceClient.incrementFields({
        accessTokensRemoved: 1
      }, t), n.credentialType.toLowerCase() === al.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase())) switch (n.tokenType?.toLowerCase()) {
        case pl.POP:
        case pl.DPOP.toLowerCase():
          {
            let e = n.keyId;
            e && this.tokenBindingKeyManager.removeTokenBindingKey(e, t).catch(() => {
              this.commonLogger.error(`0id34f`, t), this.performanceClient?.incrementFields({
                removeTokenBindingKeyFailure: 1
              }, t);
            });
            break;
          }
      }
    }
    removeAppMetadata(e) {
      return this.getKeys().forEach(t => {
        this.isAppMetadata(t) && this.removeItem(t, e);
      }), !0;
    }
    getIdToken(e, t, n, r) {
      this.commonLogger.trace(`1drz22`, t);
      let i = {
          homeAccountId: e.homeAccountId,
          environment: e.environment,
          credentialType: al.ID_TOKEN,
          clientId: this.clientId,
          realm: r
        },
        a = this.getIdTokensByFilter(i, t, n),
        o = a.size;
      if (o < 1) return this.commonLogger.info(`1atvtd`, t), null;
      if (o > 1) {
        let n = a;
        if (!r) {
          let r = new Map();
          a.forEach((t, n) => {
            t.realm === e.tenantId && r.set(n, t);
          });
          let i = r.size;
          if (i < 1) return this.commonLogger.info(`0ooalx`, t), a.values().next().value ?? null;
          if (i === 1) return this.commonLogger.info(`1eq2vc`, t), r.values().next().value ?? null;
          n = r;
        }
        return this.commonLogger.info(`1ws328`, t), n.forEach((e, n) => {
          this.removeIdToken(n, t);
        }), this.performanceClient.addFields({
          multiMatchedID: a.size
        }, t), null;
      }
      return this.commonLogger.info(`1sm769`, t), a.values().next().value ?? null;
    }
    getIdTokensByFilter(e, t, n) {
      let r = n && n.idToken || this.getTokenKeys().idToken,
        i = new Map();
      return r.forEach(n => {
        if (!this.idTokenKeyMatchesFilter(n, {
          clientId: this.clientId,
          ...e
        })) return;
        let r = this.getIdTokenCredential(n, t);
        r && this.credentialMatchesFilter(r, e, t) && i.set(n, r);
      }), i;
    }
    idTokenKeyMatchesFilter(e, t) {
      let n = e.toLowerCase();
      return !(t.clientId && n.indexOf(t.clientId.toLowerCase()) === -1 || t.homeAccountId && n.indexOf(t.homeAccountId.toLowerCase()) === -1);
    }
    removeIdToken(e, t) {
      this.removeItem(e, t);
    }
    removeRefreshToken(e, t) {
      this.removeItem(e, t);
    }
    getAccessToken(e, t, n, r) {
      let i = t.correlationId;
      this.commonLogger.trace(`1t7hz1`, i);
      let a = ff.createSearchScopes(t.scopes, i),
        o = t.authenticationScheme || pl.BEARER,
        s = o && o.toLowerCase() !== pl.BEARER.toLowerCase() ? al.ACCESS_TOKEN_WITH_AUTH_SCHEME : al.ACCESS_TOKEN,
        c = of(t.attributeTokens),
        l = c ? {
          attribute_tokens: c
        } : void 0,
        u = {
          homeAccountId: e.homeAccountId,
          environment: e.environment,
          credentialType: s,
          clientId: this.clientId,
          realm: r || e.tenantId,
          target: a,
          tokenType: o,
          keyId: o === pl.SSH ? t.sshKid : void 0,
          additionalCacheKeyComponents: l
        },
        d = n && n.accessToken || this.getTokenKeys().accessToken,
        f = [],
        p = [];
      return d.forEach(e => {
        if (this.accessTokenKeyMatchesFilter(e, u, !0)) {
          let t = this.getAccessTokenCredential(e, i);
          t && this.credentialMatchesFilter(t, u, i) && (f.push(t), p.push(e));
        }
      }), f.length < 1 ? (this.commonLogger.info(`1nckna`, i), null) : f.length > 1 ? (this.commonLogger.info(`1wkfwp`, i), p.forEach(e => {
        this.removeAccessToken(e, i);
      }), this.performanceClient.addFields({
        multiMatchedAT: f.length
      }, i), null) : (this.commonLogger.info(`06yt98`, i), f[0]);
    }
    accessTokenKeyMatchesFilter(e, t, n) {
      let r = e.toLowerCase();
      if (t.clientId && r.indexOf(t.clientId.toLowerCase()) === -1 || t.homeAccountId && r.indexOf(t.homeAccountId.toLowerCase()) === -1 || t.realm && r.indexOf(t.realm.toLowerCase()) === -1) return !1;
      if (t.target) {
        let e = t.target.asArray();
        for (let t = 0; t < e.length; t++) if (n && !r.includes(e[t].toLowerCase())) return !1;else if (!n && r.includes(e[t].toLowerCase())) return !0;
      }
      return !0;
    }
    getAccessTokensByFilter(e, t) {
      let n = this.getTokenKeys(),
        r = [];
      return n.accessToken.forEach(n => {
        if (!this.accessTokenKeyMatchesFilter(n, e, !0)) return;
        let i = this.getAccessTokenCredential(n, t);
        i && this.credentialMatchesFilter(i, e, t) && r.push(i);
      }), r;
    }
    getRefreshToken(e, t, n, r) {
      this.commonLogger.trace(`0x53vi`, n);
      let i = t ? `1` : void 0,
        a = {
          homeAccountId: e.homeAccountId,
          environment: e.environment,
          credentialType: al.REFRESH_TOKEN,
          clientId: this.clientId,
          familyId: i
        },
        o = r && r.refreshToken || this.getTokenKeys().refreshToken,
        s = [];
      o.forEach(e => {
        if (this.refreshTokenKeyMatchesFilter(e, a)) {
          let t = this.getRefreshTokenCredential(e, n);
          t && this.credentialMatchesFilter(t, a, n) && s.push(t);
        }
      });
      let c = s.length;
      return c < 1 ? (this.commonLogger.info(`0dlw11`, n), null) : (c > 1 && this.performanceClient.addFields({
        multiMatchedRT: c
      }, n), this.commonLogger.info(`0wcnep`, n), s[0]);
    }
    refreshTokenKeyMatchesFilter(e, t) {
      let n = e.toLowerCase();
      return !(t.familyId && n.indexOf(t.familyId.toLowerCase()) === -1 || !t.familyId && t.clientId && n.indexOf(t.clientId.toLowerCase()) === -1 || t.homeAccountId && n.indexOf(t.homeAccountId.toLowerCase()) === -1);
    }
    readAppMetadataFromCache(e, t) {
      let n = {
          environment: e,
          clientId: this.clientId
        },
        r = this.getAppMetadataFilteredBy(n, t),
        i = Object.keys(r).map(e => r[e]),
        a = i.length;
      if (a < 1) return null;
      if (a > 1) throw q(Ll, t);
      return i[0];
    }
    isAppMetadataFOCI(e, t) {
      let n = this.readAppMetadataFromCache(e, t);
      return !!(n && n.familyId === `1`);
    }
    matchHomeAccountId(e, t) {
      return typeof e.homeAccountId == `string` && t === e.homeAccountId;
    }
    matchLocalAccountIdFromTokenClaims(e, t) {
      return t === (e.oid || e.sub);
    }
    matchLocalAccountIdFromTenantProfile(e, t) {
      return e.localAccountId === t;
    }
    matchName(e, t) {
      return t.toLowerCase() === e.name?.toLowerCase();
    }
    matchUsername(e, t) {
      return !!(e && typeof e == `string` && t?.toLowerCase() === e.toLowerCase());
    }
    matchLoginHintWithTenantProfile(e, t) {
      return e.loginHint === t || e.username === t || e.upn === t;
    }
    matchUserAssertionHash(e, t) {
      return !!(e.userAssertionHash && t === e.userAssertionHash);
    }
    matchEnvironment(e, t, n) {
      if (this.staticAuthorityOptions) {
        let r = nd(this.staticAuthorityOptions, this.commonLogger, n);
        if (r.includes(t) && r.includes(e.environment)) return !0;
      }
      let r = this.getAuthorityMetadataByAlias(t, n);
      return !!(r && r.aliases.indexOf(e.environment) > -1);
    }
    matchCredentialType(e, t) {
      return e.credentialType && t.toLowerCase() === e.credentialType.toLowerCase();
    }
    matchClientId(e, t) {
      return !!(e.clientId && t === e.clientId);
    }
    matchFamilyId(e, t) {
      return !!(e.familyId && t === e.familyId);
    }
    matchRealm(e, t) {
      return e.realm?.toLowerCase() === t.toLowerCase();
    }
    matchLoginHintFromTokenClaims(e, t) {
      return !!(e.login_hint === t || e.preferred_username === t || e.upn === t || e.emails && e.emails.includes(t));
    }
    matchSid(e, t) {
      return e.sid === t;
    }
    matchAuthorityType(e, t) {
      return !!(e.authorityType && t.toLowerCase() === e.authorityType.toLowerCase());
    }
    matchTarget(e, t, n) {
      return e.credentialType !== al.ACCESS_TOKEN && e.credentialType !== al.ACCESS_TOKEN_WITH_AUTH_SCHEME || !e.target ? !1 : ff.fromString(e.target, n).containsScopeSet(t);
    }
    matchTokenType(e, t) {
      return !!(e.tokenType && e.tokenType.toLowerCase() === t.toLowerCase());
    }
    matchAccessTokenWithAuthScheme(e, t) {
      let n = t.tokenType?.toLowerCase();
      if (t.tokenType && !this.matchTokenType(e, t.tokenType)) return !1;
      switch (n) {
        case `dpop`:
        case pl.SSH:
          return this.matchKeyBoundAccessToken(e, t);
        default:
          return !0;
      }
    }
    matchKeyBoundAccessToken(e, t) {
      return !t.keyId || this.matchKeyId(e, t.keyId);
    }
    matchKeyId(e, t) {
      return !!(e.keyId && e.keyId === t);
    }
    isAppMetadata(e) {
      return e.indexOf(ol) !== -1;
    }
    isAuthorityMetadata(e) {
      return e.indexOf(cl) !== -1;
    }
    generateAuthorityMetadataCacheKey(e) {
      return `${cl}-${this.clientId}-${e}`;
    }
    static toObject(e, t) {
      for (let n in t) e[n] = t[n];
      return e;
    }
  },
  kp = class extends Op {
    async setAccount() {
      throw q(eu, ``);
    }
    getAccount() {
      throw q(eu, ``);
    }
    async setIdTokenCredential() {
      throw q(eu, ``);
    }
    getIdTokenCredential() {
      throw q(eu, ``);
    }
    async setAccessTokenCredential() {
      throw q(eu, ``);
    }
    getAccessTokenCredential() {
      throw q(eu, ``);
    }
    async setRefreshTokenCredential() {
      throw q(eu, ``);
    }
    getRefreshTokenCredential() {
      throw q(eu, ``);
    }
    setAppMetadata() {
      throw q(eu, ``);
    }
    getAppMetadata() {
      throw q(eu, ``);
    }
    setServerTelemetry() {
      throw q(eu, ``);
    }
    getServerTelemetry() {
      throw q(eu, ``);
    }
    setAuthorityMetadata() {
      throw q(eu, ``);
    }
    getAuthorityMetadata() {
      throw q(eu, ``);
    }
    getAuthorityMetadataKeys() {
      throw q(eu, ``);
    }
    setThrottlingCache() {
      throw q(eu, ``);
    }
    getThrottlingCache() {
      throw q(eu, ``);
    }
    removeItem() {
      throw q(eu, ``);
    }
    getKeys() {
      throw q(eu, ``);
    }
    getAccountKeys() {
      throw q(eu, ``);
    }
    getTokenKeys() {
      throw q(eu, ``);
    }
    generateCredentialKey(e, t) {
      throw q(eu, ``);
    }
    generateAccountKey() {
      throw q(eu, ``);
    }
  },
  Ap = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
  },
  jp = class {
    generateId() {
      return `callback-id`;
    }
    startMeasurement(e, t) {
      return {
        end: () => null,
        discard: () => {},
        add: () => {},
        increment: () => {},
        event: {
          eventId: this.generateId(),
          status: Ap.InProgress,
          authority: ``,
          libraryName: ``,
          libraryVersion: ``,
          clientId: ``,
          name: e,
          startTimeMs: Date.now(),
          correlationId: t || ``
        }
      };
    }
    endMeasurement() {
      return null;
    }
    discardMeasurements() {}
    removePerformanceCallback() {
      return !0;
    }
    addPerformanceCallback() {
      return ``;
    }
    emitEvents() {}
    addFields() {}
    addGlobalFields() {}
    incrementFields() {}
    cacheEventByCorrelationId() {}
  },
  Mp = {
    tokenRenewalOffsetSeconds: 300,
    preventCorsPreflight: !1
  },
  Np = {
    loggerCallback: () => {},
    piiLoggingEnabled: !1,
    logLevel: mp.Info,
    correlationId: ``
  },
  Pp = {
    async sendGetRequestAsync() {
      throw q(eu, ``);
    },
    async sendPostRequestAsync() {
      throw q(eu, ``);
    }
  },
  Fp = {
    sku: Ec,
    version: Cp,
    cpu: ``,
    os: ``
  },
  Ip = {
    clientSecret: ``,
    clientAssertion: void 0
  },
  Lp = {
    azureCloudInstance: od.None,
    tenant: `${kc}`
  },
  Rp = {
    application: {
      appName: ``,
      appVersion: ``
    }
  };
function zp({
  authOptions: e,
  systemOptions: t,
  loggerOptions: n,
  storageInterface: r,
  networkInterface: i,
  cryptoInterface: a,
  tokenBindingKeyManager: o,
  clientCredentials: s,
  libraryInfo: c,
  telemetry: l,
  serverTelemetryManager: u,
  persistencePlugin: d,
  serializableCache: f
}) {
  let p = {
      ...Np,
      ...n
    },
    m = o || pp;
  return {
    authOptions: Bp(e),
    systemOptions: {
      ...Mp,
      ...t
    },
    loggerOptions: p,
    storageInterface: r || new kp(e.clientId, fp, new xp(p, `@azure/msal-common`, `16.14.0`), new jp(), void 0, m),
    networkInterface: i || Pp,
    cryptoInterface: a || fp,
    tokenBindingKeyManager: m,
    clientCredentials: s || Ip,
    libraryInfo: {
      ...Fp,
      ...c
    },
    telemetry: {
      ...Rp,
      ...l
    },
    serverTelemetryManager: u || null,
    persistencePlugin: d || null,
    serializableCache: f || null
  };
}
function Bp(e) {
  return {
    clientCapabilities: [],
    azureCloudOptions: Lp,
    instanceAware: !1,
    isMcp: !1,
    ...e
  };
}
function Vp(e) {
  return e.authOptions.authority.options.protocolMode === pu.OIDC;
}
var Hp = class {
    constructor(e, t) {
      this.cache = e, this.hasChanged = t;
    }
    get cacheHasChanged() {
      return this.hasChanged;
    }
    get tokenCache() {
      return this.cache;
    }
  },
  Up = class e extends Sl {
    constructor(t, n, r) {
      super(t, n, r), this.name = `JoseHeaderError`, Object.setPrototypeOf(this, e.prototype);
    }
  };
function Wp(e, t) {
  return new Up(e, t);
}
function Gp(e) {
  if (typeof e != `object` || !e || Object.prototype.toString.call(e) !== `[object Object]`) return !1;
  if (Object.getPrototypeOf(e) === null) return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null;) t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
var Kp = `missing_kid_error`,
  qp = `missing_alg_error`,
  Jp = `missing_jwk_error`,
  Yp = `invalid_jwk_error`,
  Xp = class e {
    constructor(e, t) {
      if (typeof e.alg != `string` || !e.alg) throw Wp(qp, t);
      this.typ = e.typ, this.alg = e.alg, this.kid = e.kid, this.jwk = e.jwk;
    }
    static getShrHeader(t, n) {
      if (!t.kid) throw Wp(Kp, n);
      if (!t.alg) throw Wp(qp, n);
      return new e({
        typ: t.typ || bl.Pop,
        kid: t.kid,
        alg: t.alg
      }, n);
    }
    static getDpopHeader(t, n) {
      if (!Gp(t.jwk)) throw Wp(Jp, n);
      if (!t.alg) throw Wp(qp, n);
      if (Object.keys(t.jwk).length === 0) throw Wp(Yp, n);
      return new e({
        typ: bl.Dpop,
        alg: t.alg,
        jwk: t.jwk
      }, n);
    }
  },
  Zp = {
    SW: `sw`
  },
  Qp = `shr`,
  $p = dp.RS256,
  em = class {
    constructor(e, t, n) {
      this.cryptoUtils = e, this.tokenBindingKeyManager = t, this.performanceClient = n;
    }
    async generateCnf(e, t) {
      let n = await J(this.generateKid.bind(this), Sd, t, this.performanceClient, e.correlationId)(e),
        r = this.cryptoUtils.base64UrlEncode(JSON.stringify(n));
      return {
        kid: n.kid,
        reqCnfString: r
      };
    }
    async generateKid(e) {
      return {
        kid: await this.tokenBindingKeyManager.provisionTokenBindingKey({
          correlationId: e.correlationId,
          tokenBindingKeyType: Qp,
          tokenBindingKeyAlgorithm: $p
        }),
        xms_ksl: Zp.SW
      };
    }
    async signPopToken(e, t, n) {
      return this.signPayload(e, t, n);
    }
    async signPayload(e, t, n, r) {
      let {
          resourceRequestMethod: i,
          resourceRequestUri: a,
          shrClaims: o,
          shrNonce: s,
          shrOptions: c
        } = n,
        l = (a ? new Yu(a, n.correlationId) : void 0)?.getUrlComponents(),
        u = await this.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(t, n.correlationId),
        d = this.cryptoUtils.base64UrlEncode(JSON.stringify({
          kid: t
        })),
        f = c?.header?.alg || u.alg || $p,
        p = Xp.getShrHeader({
          ...c?.header,
          alg: f,
          kid: d
        }, n.correlationId),
        m = {
          at: e,
          ts: Ld(),
          m: i?.toUpperCase(),
          u: l?.HostNameAndPort,
          nonce: s || this.cryptoUtils.createNewGuid(),
          p: l?.AbsolutePath,
          q: l?.QueryString ? [[], l.QueryString] : void 0,
          client_claims: o || void 0,
          ...r,
          cnf: {
            jwk: u
          }
        };
      return this.cryptoUtils.signTokenBindingJwt(p, m, t, n.correlationId);
    }
  },
  tm = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/,
  nm = `dpop`,
  rm = dp.ES256;
function im(e, t) {
  return Xp.getDpopHeader({
    alg: rm,
    jwk: e
  }, t);
}
function am(e, t) {
  if (typeof e != `string` || !tm.test(e)) throw xu(Uu, t);
  return e.toUpperCase();
}
function om(e, t) {
  let n;
  try {
    n = new URL(e);
  } catch {
    throw xu(wu, t);
  }
  if (!/^https:\/\//i.test(e) || n.protocol !== `https:` || n.username || n.password) throw xu(Wu, t);
  return n.search = ``, n.hash = ``, n.href;
}
function sm(e, t) {
  if (e !== void 0 && e.trim().length === 0) throw xu(Gu, t);
}
var cm = class {
    constructor(e, t) {
      this.cryptoUtils = e, this.tokenBindingKeyManager = t;
    }
    async generateJkt(e = ``) {
      return this.tokenBindingKeyManager.provisionTokenBindingKey({
        tokenBindingKeyType: nm,
        tokenBindingKeyAlgorithm: rm,
        correlationId: e
      });
    }
    buildTokenProofClaims(e, t = ``) {
      sm(e.nonce, t);
      let n = {
        jti: this.cryptoUtils.createNewGuid(),
        htm: `POST`,
        htu: om(e.tokenEndpoint, t),
        iat: Ld()
      };
      return e.nonce !== void 0 && (n.nonce = e.nonce), n;
    }
    async generateTokenProof(e, t, n = ``) {
      return this.generateProof(this.buildTokenProofClaims(e, n), t, n);
    }
    buildResourceProofClaims(e, t = ``) {
      sm(e.nonce, t);
      let n = {
        jti: this.cryptoUtils.createNewGuid(),
        htm: am(e.htm, t),
        htu: om(e.htu, t),
        ath: e.ath,
        iat: Ld()
      };
      return e.nonce !== void 0 && (n.nonce = e.nonce), n;
    }
    async generateResourceProof(e, t, n = ``) {
      let {
        htu: r,
        htm: i,
        nonce: a
      } = e;
      if (!r || !i) throw xu(Ku, n);
      let o = await this.cryptoUtils.hashString(e.accessToken);
      return this.generateProof(this.buildResourceProofClaims({
        htu: r,
        htm: i,
        ath: o,
        nonce: a
      }, n), t, n);
    }
    async generateProof(e, t, n) {
      let r = await this.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(t, n);
      return this.cryptoUtils.signTokenBindingJwt(im(r, n), e, t, n);
    }
  },
  lm = `no_tokens_found`,
  um = `native_account_unavailable`,
  dm = `refresh_token_expired`,
  fm = `ui_not_allowed`,
  pm = [`interaction_required`, `consent_required`, `login_required`, `bad_token`, fm, `interrupted_user`],
  mm = [`message_only`, `additional_action`, `basic_action`, `user_password_expired`, `consent_required`, `bad_token`, `ui_not_allowed`, `interrupted_user`],
  hm = class e extends Sl {
    constructor(t, n, r, i, a, o, s, c) {
      super(t, n, r, i), Object.setPrototypeOf(this, e.prototype), this.timestamp = a || ``, this.traceId = o || ``, this.claims = s || ``, this.name = `InteractionRequiredAuthError`, this.errorNo = c;
    }
  };
function gm(e, t, n) {
  let r = !!e && pm.indexOf(e) > -1,
    i = !!n && mm.indexOf(n) > -1,
    a = !!t && pm.some(e => t.indexOf(e) > -1);
  return r || a || i;
}
function _m(e, t, n) {
  return new hm(e, t, n);
}
var vm = class e extends Sl {
  constructor(t, n, r, i, a, o) {
    super(t, n, r, i), this.name = `ServerError`, this.errorNo = a, this.status = o, Object.setPrototypeOf(this, e.prototype);
  }
};
function ym(e, t, n, r) {
  let i = bm(e, r, n);
  return t ? `${i}|${t}` : i;
}
function bm(e, t, n) {
  if (!e) throw q(Kl, t);
  let r = {
    id: e.createNewGuid()
  };
  n && (r.meta = n);
  let i = JSON.stringify(r);
  return e.base64Encode(i);
}
function xm(e, t, n) {
  if (!e) throw q(Kl, n);
  if (!t) throw q(Nl, n);
  try {
    let n = t.split(`|`),
      r = n[0],
      i = n.length > 1 ? n.slice(1).join(`|`) : ``,
      a = e(r),
      o = JSON.parse(a);
    return {
      userRequestState: i || ``,
      libraryState: o
    };
  } catch {
    throw q(Nl, n);
  }
}
var Sm = class e {
  constructor(e, t, n, r, i, a, o, s = pp) {
    this.clientId = e, this.cacheStorage = t, this.cryptoObj = n, this.tokenBindingKeyManager = s, this.logger = r, this.performanceClient = i, this.serializableCache = a, this.persistencePlugin = o;
  }
  validateTokenResponse(e, t, n) {
    if (e.error || e.error_description || e.suberror) {
      let r = `Error(s): ${e.error_codes || `Not Available`} - Timestamp: ${e.timestamp || `Not Available`} - Description: ${e.error_description || `Not Available`} - Correlation ID: ${e.correlation_id || `Not Available`} - Trace ID: ${e.trace_id || `Not Available`}`,
        i = e.error_codes?.length ? e.error_codes[0] : void 0,
        a = new vm(e.error || ``, e.correlation_id || ``, r, e.suberror, i, e.status);
      if (n && e.status && e.status >= 500 && e.status <= 599) {
        this.logger.warning(`16ks7j ${a}`, t);
        return;
      }
      if (n && e.status && e.status >= 400 && e.status <= 499) {
        this.logger.warning(`0g61x3 ${a}`, t);
        return;
      }
      throw gm(e.error, e.error_description, e.suberror) ? new hm(e.error || ``, e.correlation_id || ``, e.error_description, e.suberror, e.timestamp || ``, e.trace_id || ``, e.claims || ``, i) : a;
    }
  }
  async handleServerTokenResponse(t, n, r, i, a, o, s, c, l, u, d) {
    let f;
    if (t.id_token && (f = au(t.id_token || ``, this.cryptoObj.base64Decode, i.correlationId), o && o.nonce && f.nonce !== o.nonce)) throw q(Il, i.correlationId);
    this.homeAccountIdentifier = _u(t.client_info || ``, n.authorityType, this.logger, this.cryptoObj, i.correlationId, f);
    let p;
    if (o && o.state && (p = xm(this.cryptoObj.base64Decode, o.state, i.correlationId)), t.key_id = t.key_id || i.dpopJkt || i.sshKid || void 0, i.authenticationScheme === pl.DPOP) {
      if (t.token_type?.toLowerCase() !== pl.DPOP.toLowerCase()) throw this.performanceClient?.addFields({
        dpopTokenTypeMismatch: t.token_type
      }, i.correlationId), q(ql, i.correlationId);
      t.token_type = pl.DPOP;
    }
    let m = of(i.attributeTokens),
      h = d ?? (m ? {
        attribute_tokens: m
      } : void 0),
      g = this.generateCacheRecord(t, n, r, i, f, s, o, h),
      _;
    try {
      if (this.persistencePlugin && this.serializableCache && (this.logger.verbose(`0jbz5k`, i.correlationId), _ = new Hp(this.serializableCache, !0), await this.persistencePlugin.beforeCacheAccess(_)), c && !l && g.account && this.cacheStorage.getAllAccounts({
        homeAccountId: g.account.homeAccountId,
        environment: g.account.environment
      }, i.correlationId).length < 1) return this.logger.warning(`1gmt66`, i.correlationId), this.performanceClient?.addFields({
        acntLoggedOut: !0
      }, i.correlationId), await e.generateAuthenticationResult(this.cryptoObj, n, g, !1, i, this.performanceClient, {
        idTokenClaims: f,
        requestState: p,
        requestId: u,
        tokenBindingKeyManager: this.tokenBindingKeyManager
      });
      await this.cacheStorage.saveCacheRecord(g, i.correlationId, ou(f || {}), a, i.storeInCache);
    } finally {
      this.persistencePlugin && this.serializableCache && _ && (this.logger.verbose(`1bh17u`, i.correlationId), await this.persistencePlugin.afterCacheAccess(_));
    }
    return e.generateAuthenticationResult(this.cryptoObj, n, g, !1, i, this.performanceClient, {
      idTokenClaims: f,
      requestState: p,
      serverTokenResponse: t,
      requestId: u,
      tokenBindingKeyManager: this.tokenBindingKeyManager
    });
  }
  generateCacheRecord(e, t, n, r, i, a, o, s) {
    let c = t.getPreferredCache();
    if (!c) throw q(Wl, r.correlationId);
    let l = fu(i),
      u,
      d;
    e.id_token && i && (u = Ud(this.homeAccountIdentifier, c, e.id_token, this.clientId, l || ``), d = Cm(this.cacheStorage, t, this.homeAccountIdentifier, this.cryptoObj.base64Decode, r.correlationId, i, e.client_info, c, l, o, void 0, this.logger, this.performanceClient));
    let f = null;
    if (e.access_token) {
      let i = e.scope ? ff.fromString(e.scope, r.correlationId) : new ff(r.scopes || [], r.correlationId),
        o = (typeof e.expires_in == `string` ? parseInt(e.expires_in, 10) : e.expires_in) || 0,
        u = (typeof e.ext_expires_in == `string` ? parseInt(e.ext_expires_in, 10) : e.ext_expires_in) || 0,
        d = (typeof e.refresh_in == `string` ? parseInt(e.refresh_in, 10) : e.refresh_in) || void 0,
        p = n + o,
        m = p + u,
        h = d && d > 0 ? n + d : void 0;
      f = Wd(this.homeAccountIdentifier, c, e.access_token, this.clientId, l || t.tenant || ``, i.printScopes(), p, m, this.cryptoObj.base64Decode, r.correlationId, h, e.token_type, a, e.key_id, s);
      let g = r.resource || null;
      g && (f.resource = g);
    }
    let p = null;
    if (e.refresh_token) {
      let t;
      e.refresh_token_expires_in && (t = n + (typeof e.refresh_token_expires_in == `string` ? parseInt(e.refresh_token_expires_in, 10) : e.refresh_token_expires_in), this.performanceClient?.addFields({
        ntwkRtExpiresOnSeconds: t
      }, r.correlationId)), p = Gd(this.homeAccountIdentifier, c, e.refresh_token, this.clientId, e.foci, a, t);
    }
    let m = null;
    return e.foci && (m = {
      clientId: this.clientId,
      environment: c,
      familyId: e.foci
    }), {
      account: d,
      idToken: u,
      accessToken: f,
      refreshToken: p,
      appMetadata: m
    };
  }
  static async generateAuthenticationResult(e, t, n, r, i, a, o = {}) {
    let {
        idTokenClaims: s,
        requestState: c,
        serverTokenResponse: l,
        requestId: u,
        tokenBindingKeyManager: d = pp
      } = o,
      f = ``,
      p = [],
      m = null,
      h,
      g,
      _ = ``,
      v;
    if (n.accessToken) {
      let t = n.accessToken.tokenType?.toLowerCase();
      if (n.accessToken.tokenType === pl.POP && !i.popKid) {
        let t = new em(e, d, a),
          {
            secret: r,
            keyId: o
          } = n.accessToken;
        if (!o) throw q($l, i.correlationId);
        f = await t.signPopToken(r, o, i);
      } else f = n.accessToken.secret;
      if (t === pl.DPOP.toLowerCase()) {
        if (!n.accessToken.keyId) throw q($l, i.correlationId);
        v = await new cm(e, d).generateResourceProof({
          htu: i.resourceRequestUri,
          htm: i.resourceRequestMethod,
          accessToken: n.accessToken.secret
        }, n.accessToken.keyId, i.correlationId);
      }
      p = ff.fromString(n.accessToken.target, i.correlationId).asArray(), m = zd(n.accessToken.expiresOn), h = zd(n.accessToken.extendedExpiresOn), n.accessToken.refreshOn && (g = zd(n.accessToken.refreshOn));
    }
    n.appMetadata && (_ = n.appMetadata.familyId === `1` ? `1` : ``);
    let y = s?.oid || s?.sub || ``,
      b = s?.tid || ``,
      x = s?.tenant_region_sub_scope;
    if (typeof x == `string` && a?.addFields({
      regionSubScope: x
    }, i.correlationId), l?.spa_accountid && n.account) {
      n.account.nativeAccountId = l?.spa_accountid;
      let e = b || n.account.realm;
      if (n.account.tenantProfiles) {
        let t = n.account.tenantProfiles.find(t => t.tenantId === e);
        t && (t.nativeAccountId = l.spa_accountid);
      }
    }
    let S = n.account ? uu(mu(n.account), void 0, s, n.idToken?.secret) : null;
    return {
      authority: t.canonicalAuthority,
      uniqueId: y,
      tenantId: b,
      scopes: p,
      account: S,
      idToken: n?.idToken?.secret || ``,
      idTokenClaims: s || {},
      accessToken: f,
      dpopProof: v,
      fromCache: r,
      expiresOn: m,
      extExpiresOn: h,
      refreshOn: g,
      correlationId: i.correlationId,
      requestId: u || ``,
      familyId: _,
      tokenType: n.accessToken?.tokenType?.toLowerCase() === pl.DPOP.toLowerCase() ? pl.DPOP : n.accessToken?.tokenType || ``,
      state: c ? c.userRequestState : ``,
      cloudGraphHostName: n.account?.cloudGraphHostName || ``,
      msGraphHost: n.account?.msGraphHost || ``,
      code: l?.spa_code,
      fromPlatformBroker: !1
    };
  }
};
function Cm(e, t, n, r, i, a, o, s, c, l, u, d, f) {
  d?.verbose(`09jz0t`, i);
  let p = s || t.getPreferredCache(),
    m = e.getAccountsFilteredBy({
      homeAccountId: n,
      environment: p
    }, i);
  f?.addFields({
    cacheMatchedAccounts: m.length
  }, i), m.length > 1 && d?.warning(`0x7ad1`, i);
  let h = (m.length === 1 ? m[0] : null) || hu({
      homeAccountId: n,
      idTokenClaims: a,
      clientInfo: o,
      environment: s,
      cloudGraphHostName: l?.cloud_graph_host_name,
      msGraphHost: l?.msgraph_host,
      nativeAccountId: u
    }, t, i, r),
    g = h.tenantProfiles || [],
    _ = c || h.realm;
  if (_ && !g.find(e => e.tenantId === _)) {
    let e = lu(n, h.localAccountId, _, u, a);
    g.push(e);
  }
  return h.tenantProfiles = g, h;
}
var wm = {
  HOME_ACCOUNT_ID: `home_account_id`,
  UPN: `UPN`
};
async function Tm(e, t, n, r) {
  return typeof e == `string` ? e : e({
    clientId: t,
    tokenEndpoint: n,
    fmiPath: r
  });
}
function Em(e, t, n) {
  return {
    clientId: e,
    authority: t.authority,
    scopes: t.scopes,
    homeAccountIdentifier: n,
    claims: t.claims,
    authenticationScheme: t.authenticationScheme,
    resourceRequestMethod: t.resourceRequestMethod,
    resourceRequestUri: t.resourceRequestUri,
    shrClaims: t.shrClaims,
    sshKid: t.sshKid,
    embeddedClientId: t.embeddedClientId || t.extraParameters?.clientId,
    resource: t.resource,
    attributeTokens: of(t.attributeTokens)
  };
}
var Dm = class e {
    static generateThrottlingStorageKey(e) {
      return `${hl}.${JSON.stringify(e)}`;
    }
    static preProcess(t, n, r) {
      let i = e.generateThrottlingStorageKey(n),
        a = t.getThrottlingCache(i, r);
      if (a) {
        if (a.throttleTime < Date.now()) {
          t.removeItem(i, r);
          return;
        }
        throw new vm(a.errorCodes?.join(` `) || ``, r, a.errorMessage, a.subError);
      }
    }
    static postProcess(t, n, r, i) {
      if (e.checkResponseStatus(r) || e.checkResponseForRetryAfter(r)) {
        let a = {
          throttleTime: e.calculateThrottleTime(parseInt(r.headers[Jc.RETRY_AFTER])),
          error: r.body.error,
          errorCodes: r.body.error_codes,
          errorMessage: r.body.error_description,
          subError: r.body.suberror
        };
        t.setThrottlingCache(e.generateThrottlingStorageKey(n), a, i);
      }
    }
    static checkResponseStatus(e) {
      return e.status === 429 || e.status >= 500 && e.status < 600;
    }
    static checkResponseForRetryAfter(e) {
      return e.headers ? e.headers.hasOwnProperty(Jc.RETRY_AFTER) && (e.status < 200 || e.status >= 300) : !1;
    }
    static calculateThrottleTime(e) {
      let t = e <= 0 ? 0 : e,
        n = Date.now() / 1e3;
      return Math.floor(Math.min(n + (t || 60), n + ml) * 1e3);
    }
    static removeThrottle(e, t, n, r) {
      let i = Em(t, n, r),
        a = this.generateThrottlingStorageKey(i);
      e.removeItem(a, n.correlationId);
    }
  },
  Om = class e extends Sl {
    constructor(t, n, r) {
      super(t.errorCode, t.correlationId, t.errorMessage, t.subError), Object.setPrototypeOf(this, e.prototype), this.name = `NetworkError`, this.error = t, this.httpStatus = n, this.responseHeaders = r;
    }
  };
function km(e, t, n, r) {
  return e.errorMessage = `${e.errorMessage}, additionalErrorInfo: error.name:${r?.name}, error.message:${r?.message}`, new Om(e, t, n);
}
function Am(e, t, n) {
  let r = {};
  if (r[Jc.CONTENT_TYPE] = zc, !t && n) switch (n.type) {
    case wm.HOME_ACCOUNT_ID:
      try {
        let e = iu(n.credential);
        r[Jc.CCS_HEADER] = `Oid:${e.uid}@${e.utid}`;
      } catch (t) {
        e.verbose(`1qhtee ${t}`, ``);
      }
      break;
    case wm.UPN:
      r[Jc.CCS_HEADER] = `UPN: ${n.credential}`;
  }
  return r;
}
async function jm(e, t, n, r, i) {
  if (t.authenticationScheme !== pl.DPOP) return;
  let a = new cm(r, i),
    o = t.dpopJkt;
  if (!o?.trim()) throw q($l, t.correlationId);
  e[Jc.DPOP] = await a.generateTokenProof({
    tokenEndpoint: n
  }, o, t.correlationId);
}
function Mm(e, t, n, r) {
  let i = new Map();
  return e.embeddedClientId && np(i, t, n), e.extraQueryParameters && Gf(i, e.extraQueryParameters), Of(i, e.correlationId), pf(i, e.correlationId, r), cp(i);
}
async function Nm(e, t, n, r, i, a, o, s, c, l) {
  let u = await Pm(r, e, {
    body: t,
    headers: n
  }, i, a, o, s, c);
  return l && u.status < 500 && u.status !== 429 && l.clearTelemetryCache(), u;
}
async function Pm(e, t, n, r, i, a, o, s) {
  Dm.preProcess(i, e, r);
  let c;
  try {
    c = await J(a.sendPostRequestAsync.bind(a), ld, o, s, r)(t, {
      ...n,
      correlationId: r,
      performanceClient: s
    });
    let e = c.headers || {};
    s?.addFields({
      refreshTokenSize: c.body.refresh_token?.length || 0,
      httpVerToken: e[Jc.X_MS_HTTP_VERSION] || ``,
      requestId: e[Jc.X_MS_REQUEST_ID] || ``
    }, r);
  } catch (e) {
    if (e instanceof Om) {
      let t = e.responseHeaders;
      throw t && s?.addFields({
        httpVerToken: t[Jc.X_MS_HTTP_VERSION] || ``,
        requestId: t[Jc.X_MS_REQUEST_ID] || ``,
        contentTypeHeader: t[Jc.CONTENT_TYPE] || void 0,
        contentLengthHeader: t[Jc.CONTENT_LENGTH] || void 0,
        httpStatus: e.httpStatus
      }, r), e.error;
    }
    throw e instanceof Sl ? e : q(Al, r);
  }
  return Dm.postProcess(i, e, c, r), c;
}
var Fm = class {
  constructor(e, t) {
    this.includeRedirectUri = !0, this.config = zp(e), this.logger = new xp(this.config.loggerOptions, Sp, Cp), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = t, this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
  }
  async acquireToken(e, t, n) {
    if (!e.code) throw q(Rl, e.correlationId);
    n && n.cloud_instance_host_name && (await J(this.updateTokenEndpointAuthority.bind(this), xd, this.logger, this.performanceClient, e.correlationId)(n.cloud_instance_host_name, e.correlationId));
    let r = Ld(),
      i = await J(this.executeTokenRequest.bind(this), yd, this.logger, this.performanceClient, e.correlationId)(this.authority, e, this.serverTelemetryManager),
      a = i.headers?.[Jc.X_MS_REQUEST_ID],
      o = new Sm(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin, this.config.tokenBindingKeyManager);
    return o.validateTokenResponse(i.body, e.correlationId), J(o.handleServerTokenResponse.bind(o), Cd, this.logger, this.performanceClient, e.correlationId)(i.body, this.authority, r, e, t, n, void 0, void 0, void 0, a);
  }
  getLogoutUri(e) {
    if (!e) throw xu(ku, ``);
    let t = this.createLogoutUrlQueryString(e);
    return Yu.appendQueryString(this.authority.endSessionEndpoint, t);
  }
  async executeTokenRequest(e, t, n) {
    let r = Mm(t, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient),
      i = Yu.appendQueryString(e.tokenEndpoint, r),
      a = await J(this.createTokenRequestBody.bind(this), bd, this.logger, this.performanceClient, t.correlationId)(t),
      o;
    if (t.clientInfo) try {
      let e = ru(t.clientInfo, this.cryptoUtils.base64Decode);
      o = {
        credential: `${e.uid}.${e.utid}`,
        type: wm.HOME_ACCOUNT_ID
      };
    } catch (e) {
      this.logger.verbose(`0wznt3 ${e}`, t.correlationId);
    }
    let s = Am(this.logger, this.config.systemOptions.preventCorsPreflight, o || t.ccsCredential);
    await jm(s, t, i, this.cryptoUtils, this.config.tokenBindingKeyManager);
    let c = Em(this.config.authOptions.clientId, t);
    return J(Nm, dd, this.logger, this.performanceClient, t.correlationId)(i, a, s, c, t.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, n);
  }
  async createTokenRequestBody(e) {
    let t = new Map();
    if (vf(t, e.embeddedClientId || e.extraParameters?.client_id || this.config.authOptions.clientId), this.includeRedirectUri) yf(t, e.redirectUri);else if (!e.redirectUri) throw xu(Su, e.correlationId);
    if (_f(t, e.scopes, e.correlationId, !0, this.oidcDefaultScopes), ip(t, e.resource), e.attributeTokens && ap(t, e.attributeTokens), this.performanceClient?.addFields({
      hasAttributeTokens: !!e.attributeTokens?.length
    }, e.correlationId), Ff(t, e.code), kf(t, this.config.libraryInfo), Af(t, this.config.telemetry.application), ep(t), this.serverTelemetryManager && !Vp(this.config) && $f(t, this.serverTelemetryManager), e.codeVerifier && Lf(t, e.codeVerifier), this.config.clientCredentials.clientSecret && Rf(t, this.config.clientCredentials.clientSecret), this.config.clientCredentials.clientAssertion) {
      let n = this.config.clientCredentials.clientAssertion;
      zf(t, await Tm(n.assertion, this.config.authOptions.clientId, e.resourceRequestUri)), Bf(t, n.assertionType);
    }
    if (Vf(t, tl.AUTHORIZATION_CODE_GRANT), Hf(t), e.authenticationScheme === pl.POP) {
      let n = new em(this.cryptoUtils, this.config.tokenBindingKeyManager, this.performanceClient),
        r;
      r = e.popKid ? this.cryptoUtils.encodeKid(e.popKid) : (await J(n.generateCnf.bind(n), Sd, this.logger, this.performanceClient, e.correlationId)(e, this.logger)).reqCnfString, Zf(t, r);
    } else if (e.authenticationScheme === pl.SSH) {
      if (e.sshJwk) Qf(t, e.sshJwk);else throw xu(Pu, e.correlationId);
    }
    let n;
    if (e.clientInfo) try {
      let t = ru(e.clientInfo, this.cryptoUtils.base64Decode);
      n = {
        credential: `${t.uid}.${t.utid}`,
        type: wm.HOME_ACCOUNT_ID
      };
    } catch (t) {
      this.logger.verbose(`0wznt3 ${t}`, e.correlationId);
    } else n = e.ccsCredential;
    if (this.config.systemOptions.preventCorsPreflight && n) switch (n.type) {
      case wm.HOME_ACCOUNT_ID:
        try {
          Tf(t, iu(n.credential));
        } catch (t) {
          this.logger.verbose(`1qhtee ${t}`, e.correlationId);
        }
        break;
      case wm.UPN:
        wf(t, n.credential);
    }
    return e.embeddedClientId && np(t, this.config.authOptions.clientId, this.config.authOptions.redirectUri), e.extraParameters && Gf(t, e.extraParameters), e.enableSpaAuthorizationCode && (!e.extraParameters || !e.extraParameters.return_spa_code) && Gf(t, {
      [fc]: `1`
    }), pf(t, e.correlationId, this.performanceClient), Df(t, e.correlationId, e.claims, this.config.authOptions.clientCapabilities, e.skipBrokerClaims), cp(t);
  }
  createLogoutUrlQueryString(e) {
    let t = new Map();
    return e.postLogoutRedirectUri && bf(t, e.postLogoutRedirectUri), e.correlationId && Of(t, e.correlationId), e.idTokenHint && xf(t, e.idTokenHint), e.state && Mf(t, e.state), e.logoutHint && tp(t, e.logoutHint), e.extraQueryParameters && Gf(t, e.extraQueryParameters), this.config.authOptions.instanceAware && Wf(t), cp(t);
  }
  async updateTokenEndpointAuthority(e, t) {
    let n = await df(`https://${e}/${this.authority.tenant}/`, this.networkClient, this.cacheManager, this.authority.options, this.logger, t, this.performanceClient);
    this.authority = n;
  }
};
function Im(e, t, n, r) {
  let i = t.correlationId,
    a = new Map();
  if (vf(a, t.embeddedClientId || t.extraQueryParameters?.client_id || e.clientId), _f(a, [...(t.scopes || []), ...(t.extraScopesToConsent || [])], t.correlationId, !0, e.authority.options.OIDCOptions?.defaultScopes), ip(a, t.resource), yf(a, t.redirectUri), Of(a, i), hf(a, t.responseMode), Hf(a), Uf(a), t.prompt && (jf(a, t.prompt), r?.addFields({
    prompt: t.prompt
  }, i)), t.domainHint && (Sf(a, t.domainHint), r?.addFields({
    domainHintFromRequest: !0
  }, i)), t.prompt !== Qc.SELECT_ACCOUNT) {
    if (t.sid && t.prompt === Qc.NONE) n.verbose(`1tvqyx`, t.correlationId), Ef(a, t.sid), r?.addFields({
      sidFromRequest: !0
    }, i);else if (t.account) {
      let e = Vm(t.account),
        o = Hm(t.account);
      if (o && t.domainHint && (n.warning(`0wkg3v`, t.correlationId), o = null), o) {
        n.verbose(`1eyfsw`, t.correlationId), Cf(a, o), r?.addFields({
          loginHintFromClaim: !0
        }, i);
        try {
          Tf(a, iu(t.account.homeAccountId));
        } catch {
          n.verbose(`12ugck`, t.correlationId);
        }
      } else if (e && t.prompt === Qc.NONE) {
        n.verbose(`1rmd8s`, t.correlationId), Ef(a, e), r?.addFields({
          sidFromClaim: !0
        }, i);
        try {
          Tf(a, iu(t.account.homeAccountId));
        } catch {
          n.verbose(`12ugck`, t.correlationId);
        }
      } else if (t.loginHint) n.verbose(`0y3007`, t.correlationId), Cf(a, t.loginHint), wf(a, t.loginHint), r?.addFields({
        loginHintFromRequest: !0
      }, i);else if (t.account.username) {
        n.verbose(`02f507`, t.correlationId), Cf(a, t.account.username), r?.addFields({
          loginHintFromUpn: !0
        }, i);
        try {
          Tf(a, iu(t.account.homeAccountId));
        } catch {
          n.verbose(`12ugck`, t.correlationId);
        }
      }
    } else t.loginHint && (n.verbose(`0g01ey`, t.correlationId), Cf(a, t.loginHint), wf(a, t.loginHint), r?.addFields({
      loginHintFromRequest: !0
    }, i));
  } else n.verbose(`169k9v`, t.correlationId);
  return t.nonce && Nf(a, t.nonce), t.state && Mf(a, t.state), t.embeddedClientId && np(a, e.clientId, e.redirectUri), Df(a, t.correlationId, t.claims, e.clientCapabilities, t.skipBrokerClaims), e.instanceAware && (!t.extraQueryParameters || !Object.keys(t.extraQueryParameters).includes(`instance_aware`)) && Wf(a), a;
}
function Lm(e, t) {
  let n = cp(t);
  return Yu.appendQueryString(e.authorizationEndpoint, n);
}
function Rm(e, t, n) {
  if (zm(e, t, n), !e.code) throw q(Xl, n);
  return e;
}
function zm(e, t, n) {
  if (!e.state || !t) throw e.state ? q(Fl, n, `Cached State`) : q(Fl, n, `Server State`);
  let r, i;
  try {
    r = decodeURIComponent(e.state);
  } catch {
    throw q(Nl, n, e.state);
  }
  try {
    i = decodeURIComponent(t);
  } catch {
    throw q(Nl, n, e.state);
  }
  if (r !== i) throw q(Pl, n);
  if (e.error || e.error_description || e.suberror) {
    let t = Bm(e);
    throw gm(e.error, e.error_description, e.suberror) ? new hm(e.error || ``, e.correlation_id || n, e.error_description, e.suberror, e.timestamp || ``, e.trace_id || ``, e.claims || ``, t) : new vm(e.error || ``, e.correlation_id || n, e.error_description, e.suberror, t);
  }
}
function Bm(e) {
  let t = e.error_uri?.lastIndexOf(`code=`);
  return t && t >= 0 ? e.error_uri?.substring(t + 5) : void 0;
}
function Vm(e) {
  return e.idTokenClaims?.sid || null;
}
function Hm(e) {
  return e.loginHint || e.idTokenClaims?.login_hint || null;
}
var Um = 300,
  Wm = class {
    constructor(e, t) {
      this.config = zp(e), this.logger = new xp(this.config.loggerOptions, Sp, Cp), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = t;
    }
    async acquireToken(e, t) {
      let n = Ld(),
        r = await J(this.executeTokenRequest.bind(this), fd, this.logger, this.performanceClient, e.correlationId)(e, this.authority),
        i = r.headers?.[Jc.X_MS_REQUEST_ID],
        a = new Sm(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin, this.config.tokenBindingKeyManager);
      return a.validateTokenResponse(r.body, e.correlationId), J(a.handleServerTokenResponse.bind(a), Cd, this.logger, this.performanceClient, e.correlationId)(r.body, this.authority, n, e, t, void 0, void 0, !0, e.forceCache, i);
    }
    async acquireTokenByRefreshToken(e, t) {
      if (!e) throw xu(Ou, ``);
      if (!e.account) throw q(Hl, e.correlationId);
      if (this.cacheManager.isAppMetadataFOCI(e.account.environment, e.correlationId)) try {
        return await J(this.acquireTokenWithCachedRefreshToken.bind(this), md, this.logger, this.performanceClient, e.correlationId)(e, !0, t);
      } catch (n) {
        let r = n instanceof hm && n.errorCode === `no_tokens_found`,
          i = n instanceof vm && n.errorCode === `invalid_grant` && n.subError === `client_mismatch`;
        if (r || i) return J(this.acquireTokenWithCachedRefreshToken.bind(this), md, this.logger, this.performanceClient, e.correlationId)(e, !1, t);
        throw n;
      }
      return J(this.acquireTokenWithCachedRefreshToken.bind(this), md, this.logger, this.performanceClient, e.correlationId)(e, !1, t);
    }
    async acquireTokenWithCachedRefreshToken(e, t, n) {
      let r = Fd(this.cacheManager.getRefreshToken.bind(this.cacheManager), Nd, this.logger, this.performanceClient, e.correlationId)(e.account, t, e.correlationId, void 0);
      if (!r) throw _m(lm, e.correlationId);
      if (r.expiresOn) {
        let t = e.refreshTokenExpirationOffsetSeconds || Um;
        if (this.performanceClient?.addFields({
          cacheRtExpiresOnSeconds: Number(r.expiresOn),
          rtOffsetSeconds: t
        }, e.correlationId), Bd(r.expiresOn, t)) throw _m(dm, e.correlationId);
      }
      let i = {
        ...e,
        refreshToken: r.secret,
        authenticationScheme: e.authenticationScheme || pl.BEARER,
        ccsCredential: {
          credential: e.account.homeAccountId,
          type: wm.HOME_ACCOUNT_ID
        }
      };
      i.authenticationScheme === pl.DPOP && !i.dpopJkt && (i.dpopJkt = await new cm(this.cryptoUtils, this.config.tokenBindingKeyManager).generateJkt(e.correlationId));
      try {
        return await J(this.acquireToken.bind(this), pd, this.logger, this.performanceClient, e.correlationId)(i, n);
      } catch (t) {
        if (t instanceof hm && t.subError === `bad_token`) {
          this.logger.verbose(`1pg3ap`, e.correlationId);
          let t = this.cacheManager.generateCredentialKey(r);
          this.cacheManager.removeRefreshToken(t, e.correlationId);
        }
        throw t;
      }
    }
    async executeTokenRequest(e, t) {
      let n = Mm(e, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient),
        r = Yu.appendQueryString(t.tokenEndpoint, n),
        i = await J(this.createTokenRequestBody.bind(this), hd, this.logger, this.performanceClient, e.correlationId)(e),
        a = Am(this.logger, this.config.systemOptions.preventCorsPreflight, e.ccsCredential);
      await jm(a, e, r, this.cryptoUtils, this.config.tokenBindingKeyManager);
      let o = Em(this.config.authOptions.clientId, e);
      return J(Nm, ud, this.logger, this.performanceClient, e.correlationId)(r, i, a, o, e.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, this.serverTelemetryManager);
    }
    async createTokenRequestBody(e) {
      let t = new Map();
      if (vf(t, e.embeddedClientId || e.extraParameters?.client_id || this.config.authOptions.clientId), e.redirectUri && yf(t, e.redirectUri), _f(t, e.scopes, e.correlationId, !0, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes), Vf(t, tl.REFRESH_TOKEN_GRANT), Hf(t), kf(t, this.config.libraryInfo), Af(t, this.config.telemetry.application), ep(t), this.serverTelemetryManager && !Vp(this.config) && $f(t, this.serverTelemetryManager), If(t, e.refreshToken), e.attributeTokens && ap(t, e.attributeTokens), this.performanceClient?.addFields({
        hasAttributeTokens: !!e.attributeTokens?.length
      }, e.correlationId), this.config.clientCredentials.clientSecret && Rf(t, this.config.clientCredentials.clientSecret), this.config.clientCredentials.clientAssertion) {
        let n = this.config.clientCredentials.clientAssertion;
        zf(t, await Tm(n.assertion, this.config.authOptions.clientId, e.resourceRequestUri)), Bf(t, n.assertionType);
      }
      if (e.authenticationScheme === pl.POP) {
        let n = new em(this.cryptoUtils, this.config.tokenBindingKeyManager, this.performanceClient),
          r;
        r = e.popKid ? this.cryptoUtils.encodeKid(e.popKid) : (await J(n.generateCnf.bind(n), Sd, this.logger, this.performanceClient, e.correlationId)(e, this.logger)).reqCnfString, Zf(t, r);
      } else if (e.authenticationScheme === pl.SSH) {
        if (e.sshJwk) Qf(t, e.sshJwk);else throw xu(Pu, e.correlationId);
      }
      if (this.config.systemOptions.preventCorsPreflight && e.ccsCredential) switch (e.ccsCredential.type) {
        case wm.HOME_ACCOUNT_ID:
          try {
            Tf(t, iu(e.ccsCredential.credential));
          } catch (t) {
            this.logger.verbose(`1qhtee ${t}`, e.correlationId);
          }
          break;
        case wm.UPN:
          wf(t, e.ccsCredential.credential);
      }
      return e.embeddedClientId && np(t, this.config.authOptions.clientId, this.config.authOptions.redirectUri), e.extraParameters && Gf(t, {
        ...e.extraParameters
      }), pf(t, e.correlationId, this.performanceClient), Df(t, e.correlationId, e.claims, this.config.authOptions.clientCapabilities, e.skipBrokerClaims), cp(t);
    }
  },
  Gm = `,`,
  Km = `|`;
function qm(e) {
  let {
      skus: t,
      libraryName: n,
      libraryVersion: r,
      extensionName: i,
      extensionVersion: a
    } = e,
    o = new Map([[0, [n, r]], [2, [i, a]]]),
    s = [];
  if (t?.length) {
    if (s = t.split(Gm), s.length < 4) return t;
  } else s = Array.from({
    length: 4
  }, () => Km);
  return o.forEach((e, t) => {
    e.length === 2 && e[0]?.length && e[1]?.length && Jm({
      skuArr: s,
      index: t,
      skuName: e[0],
      skuVersion: e[1]
    });
  }), s.join(Gm);
}
function Jm(e) {
  let {
    skuArr: t,
    index: n,
    skuName: r,
    skuVersion: i
  } = e;
  n >= t.length || (t[n] = [r, i].join(Km));
}
var Ym = class e {
    constructor(e, t) {
      this.cacheOutcome = yl.NOT_APPLICABLE, this.cacheManager = t, this.apiId = e.apiId, this.correlationId = e.correlationId, this.wrapperSKU = e.wrapperSKU || ``, this.wrapperVer = e.wrapperVer || ``, this.telemetryCacheKey = dl + `-` + e.clientId;
    }
    generateCurrentRequestHeaderValue() {
      let e = `${this.apiId},${this.cacheOutcome}`,
        t = [this.wrapperSKU, this.wrapperVer],
        n = this.getNativeBrokerErrorCode();
      n?.length && t.push(`broker_error=${n}`);
      let r = t.join(`,`);
      return [5, [e, this.getRegionDiscoveryFields()].join(`,`), r].join(`|`);
    }
    generateLastRequestHeaderValue() {
      let t = this.getLastRequests(),
        n = e.maxErrorsToSend(t),
        r = t.failedRequests.slice(0, 2 * n).join(`,`),
        i = t.errors.slice(0, n).join(`,`),
        a = t.errors.length,
        o = [a, n < a ? `1` : `0`].join(`,`);
      return [5, t.cacheHits, r, i, o].join(`|`);
    }
    cacheFailedRequest(e) {
      try {
        let t = this.getLastRequests();
        t.errors.length >= 50 && (t.failedRequests.shift(), t.failedRequests.shift(), t.errors.shift()), t.failedRequests.push(this.apiId, this.correlationId), e instanceof Error && e && e.toString() ? e instanceof Sl ? e.subError ? t.errors.push(e.subError) : e.errorCode ? t.errors.push(e.errorCode) : t.errors.push(e.toString()) : t.errors.push(e.toString()) : t.errors.push(fl), this.cacheManager.setServerTelemetry(this.telemetryCacheKey, t, this.correlationId);
      } catch {}
    }
    incrementCacheHits() {
      let e = this.getLastRequests();
      return e.cacheHits += 1, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e, this.correlationId), e.cacheHits;
    }
    getLastRequests() {
      return this.cacheManager.getServerTelemetry(this.telemetryCacheKey, this.correlationId) || {
        failedRequests: [],
        errors: [],
        cacheHits: 0
      };
    }
    clearTelemetryCache() {
      let t = this.getLastRequests(),
        n = e.maxErrorsToSend(t);
      if (n === t.errors.length) this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);else {
        let e = {
          failedRequests: t.failedRequests.slice(n * 2),
          errors: t.errors.slice(n),
          cacheHits: 0
        };
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e, this.correlationId);
      }
    }
    static maxErrorsToSend(e) {
      let t,
        n = 0,
        r = 0,
        i = e.errors.length;
      for (t = 0; t < i; t++) {
        let i = e.failedRequests[2 * t] || ``,
          a = e.failedRequests[2 * t + 1] || ``,
          o = e.errors[t] || ``;
        if (r += i.toString().length + a.toString().length + o.length + 3, r < 330) n += 1;else break;
      }
      return n;
    }
    getRegionDiscoveryFields() {
      let e = [];
      return e.push(this.regionUsed || ``), e.push(this.regionSource || ``), e.push(this.regionOutcome || ``), e.join(`,`);
    }
    updateRegionDiscoveryMetadata(e) {
      this.regionUsed = e.region_used, this.regionSource = e.region_source, this.regionOutcome = e.region_outcome;
    }
    setCacheOutcome(e) {
      this.cacheOutcome = e;
    }
    setNativeBrokerErrorCode(e) {
      let t = this.getLastRequests();
      t.nativeBrokerErrorCode = e, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, t, this.correlationId);
    }
    getNativeBrokerErrorCode() {
      return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
      let e = this.getLastRequests();
      delete e.nativeBrokerErrorCode, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e, this.correlationId);
    }
    static makeExtraSkuString(e) {
      return qm(e);
    }
  },
  Xm = class extends Ym {
    constructor() {
      super({
        clientId: ``,
        apiId: 0,
        correlationId: ``,
        forceRefresh: !1
      }, {});
    }
    generateCurrentRequestHeaderValue() {
      return ``;
    }
    generateLastRequestHeaderValue() {
      return ``;
    }
    cacheFailedRequest() {}
    incrementCacheHits() {
      return 0;
    }
    clearTelemetryCache() {}
    getRegionDiscoveryFields() {
      return ``;
    }
    updateRegionDiscoveryMetadata() {}
    setCacheOutcome() {}
    setNativeBrokerErrorCode() {}
    getNativeBrokerErrorCode() {}
    clearNativeBrokerErrorCode() {}
  },
  Zm = class {
    constructor(e, t) {
      this.config = zp(e), this.logger = new xp(this.config.loggerOptions, Sp, Cp), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = t;
    }
    async acquireCachedToken(e) {
      let t = yl.NOT_APPLICABLE;
      if (e.forceRefresh || !Ju.isEmptyObj(e.claims)) throw this.setCacheOutcome(yl.FORCE_REFRESH_OR_CLAIMS, e.correlationId), q(Jl, e.correlationId);
      if (!e.account) throw q(Hl, e.correlationId);
      let n = e.account.tenantId || cf(e.authority, e.correlationId),
        r = this.cacheManager.getTokenKeys(),
        i = this.cacheManager.getAccessToken(e.account, e, r, n);
      if (!i) throw this.setCacheOutcome(yl.NO_CACHED_ACCESS_TOKEN, e.correlationId), q(Jl, e.correlationId);
      if (Hd(i.cachedAt) || Bd(i.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) throw this.setCacheOutcome(yl.CACHED_ACCESS_TOKEN_EXPIRED, e.correlationId), q(Jl, e.correlationId);
      if (e.resource) {
        if (i.resource !== e.resource) throw this.setCacheOutcome(yl.NO_CACHED_ACCESS_TOKEN, e.correlationId), q(Jl, e.correlationId);
      } else i.refreshOn && Bd(i.refreshOn, 0) && (t = yl.PROACTIVELY_REFRESHED);
      if (i.tokenType?.toLowerCase() === pl.DPOP.toLowerCase()) {
        if (!i.keyId) throw this.logger.info(`1enswf`, e.correlationId), this.setCacheOutcome(yl.NO_CACHED_ACCESS_TOKEN, e.correlationId), q(Jl, e.correlationId);
        try {
          await this.config.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(i.keyId, e.correlationId);
        } catch {
          throw this.logger.info(`14djth`, e.correlationId), this.setCacheOutcome(yl.NO_CACHED_ACCESS_TOKEN, e.correlationId), q(Jl, e.correlationId);
        }
      }
      let a = e.authority || this.authority.getPreferredCache(),
        o = {
          account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(e.account), e.correlationId),
          accessToken: i,
          idToken: this.cacheManager.getIdToken(e.account, e.correlationId, r, n),
          refreshToken: null,
          appMetadata: this.cacheManager.readAppMetadataFromCache(a, e.correlationId)
        };
      return this.setCacheOutcome(t, e.correlationId), this.config.serverTelemetryManager && this.config.serverTelemetryManager.incrementCacheHits(), [await J(this.generateResultFromCacheRecord.bind(this), gd, this.logger, this.performanceClient, e.correlationId)(o, e), t];
    }
    setCacheOutcome(e, t) {
      this.serverTelemetryManager?.setCacheOutcome(e), this.performanceClient?.addFields({
        cacheOutcome: e
      }, t), e !== yl.NOT_APPLICABLE && this.logger.info(`09ingz ${e}`, t);
    }
    async generateResultFromCacheRecord(e, t) {
      let n;
      return e.idToken && (n = au(e.idToken.secret, this.config.cryptoInterface.base64Decode, t.correlationId)), Sm.generateAuthenticationResult(this.cryptoUtils, this.authority, e, !0, t, this.performanceClient, {
        idTokenClaims: n,
        tokenBindingKeyManager: this.config.tokenBindingKeyManager
      });
    }
  },
  Qm = {
    sendGetRequestAsync: () => Promise.reject(q(eu, ``)),
    sendPostRequestAsync: () => Promise.reject(q(eu, ``))
  };
function $m(e, t) {
  if (e) {
    if (t.resource && (eh(t.extraParameters) || eh(t.extraQueryParameters))) throw q(nu, t.correlationId || ``);
    if (!t.resource) throw q(tu, t.correlationId || ``);
  }
}
function eh(e) {
  return e ? Object.prototype.hasOwnProperty.call(e, `resource`) : !1;
}
var th = `acquireTokenFromCache`,
  nh = `acquireTokenByRefreshToken`,
  rh = `acquireTokenSilentAsync`,
  ih = `cryptoOptsGetPublicKeyThumbprint`,
  ah = `cryptoOptsSignJwt`,
  oh = `silentCacheClientAcquireToken`,
  sh = `silentIframeClientAcquireToken`,
  ch = `awaitConcurrentIframe`,
  lh = `silentRefreshClientAcquireToken`,
  uh = `standardInteractionClientGetDiscoveredAuthority`,
  dh = `nativeInteractionClientAcquireToken`,
  fh = `nativeInteractionClientAcquireToken`,
  ph = `refreshTokenClientAcquireTokenByRefreshToken`,
  mh = `acquireTokenBySilentIframe`,
  hh = `initializeBaseRequest`,
  gh = `initializeSilentRequest`,
  _h = `initializeCache`,
  vh = `silentIframeClientTokenHelper`,
  yh = `silentHandlerInitiateAuthRequest`,
  bh = `silentHandlerMonitorIframeForHash`,
  xh = `standardInteractionClientCreateAuthCodeClient`,
  Sh = `standardInteractionClientGetClientConfiguration`,
  Ch = `standardInteractionClientInitializeAuthorizationRequest`,
  wh = `silentFlowClientAcquireCachedToken`,
  Th = `getStandardParams`,
  Eh = `handleCodeResponse`,
  Dh = `handleResponseEar`,
  Oh = `handleResponsePlatformBroker`,
  kh = `handleResponseCode`,
  Ah = `authClientAcquireToken`,
  jh = `deserializeResponse`,
  Mh = `authorityFactoryCreateDiscoveredInstance`,
  Nh = `acquireTokenByCodeAsync`,
  Ph = `handleRedirectPromise`,
  Fh = `handleNativeRedirectPromise`,
  Ih = `nativeMessageHandlerHandshake`,
  Lh = `removeHiddenIframe`,
  Rh = `importExistingCache`,
  zh = `generatePkceCodes`,
  Bh = `generateCodeVerifier`,
  Vh = `generateCodeChallengeFromVerifier`,
  Hh = `sha256Digest`,
  Uh = `getRandomValues`,
  Wh = `generateHKDF`,
  Gh = `generateBaseKey`,
  Kh = `base64Decode`,
  qh = `urlEncodeArr`,
  Jh = `encrypt`,
  Yh = `decrypt`,
  Xh = `generateEarKey`,
  Zh = `decryptEarResponse`,
  Qh = `waitForBridgeLateResponse`;
function $h(e) {
  return `See https://aka.ms/msal.js.errors#${e} for details`;
}
var eg = class e extends Sl {
  constructor(t, n, r) {
    super(t, n, $h(t), r), Object.setPrototypeOf(this, e.prototype), this.name = `BrowserAuthError`;
  }
};
function Y(e, t, n) {
  return new eg(e, t, n);
}
var tg = `pkce_not_created`,
  ng = `ear_jwk_empty`,
  rg = `ear_jwe_empty`,
  ig = `crypto_nonexistent`,
  ag = `empty_navigate_uri`,
  og = `hash_empty_error`,
  sg = `no_state_in_hash`,
  cg = `hash_does_not_contain_known_properties`,
  lg = `unable_to_parse_state`,
  ug = `state_interaction_type_mismatch`,
  dg = `interaction_in_progress`,
  fg = `interaction_in_progress_cancelled`,
  pg = `popup_window_error`,
  mg = `empty_window_error`,
  hg = `user_cancelled`,
  gg = `redirect_bridge_empty_response`,
  _g = `redirect_in_iframe`,
  vg = `block_iframe_reload`,
  yg = `block_nested_popups`,
  bg = `popup_relay_unsupported_flow`,
  xg = `silent_logout_unsupported`,
  Sg = `no_account_error`,
  Cg = `no_token_request_cache_error`,
  wg = `unable_to_parse_token_request_cache_error`,
  Tg = `non_browser_environment`,
  Eg = `database_not_open`,
  Dg = `no_network_connectivity`,
  Og = `post_request_failed`,
  kg = `get_request_failed`,
  Ag = `failed_to_parse_response`,
  jg = `crypto_key_not_found`,
  Mg = `invalid_public_jwk`,
  Ng = `auth_code_required`,
  Pg = `auth_code_or_nativeAccountId_required`,
  Fg = `spa_code_and_nativeAccountId_present`,
  Ig = `database_unavailable`,
  Lg = `unable_to_acquire_token_from_native_platform`,
  Rg = `native_handshake_timeout`,
  zg = `native_extension_not_installed`,
  Bg = `native_connection_not_established`,
  Vg = `uninitialized_public_client_application`,
  Hg = `native_prompt_not_supported`,
  Ug = `invalid_base64_string`,
  Wg = `invalid_pop_token_request`,
  Gg = `unsupported_token_binding_algorithm`,
  Kg = `token_binding_key_algorithm_mismatch`,
  qg = `token_binding_key_jwk_thumbprint_mismatch`,
  Jg = `failed_to_build_headers`,
  Yg = `failed_to_parse_headers`,
  Xg = `failed_to_decrypt_ear_response`,
  Zg = `timed_out`,
  Qg = `empty_response`;
function $g(e) {
  return new TextDecoder().decode(e_(e));
}
function e_(e) {
  let t = e.replace(/-/g, `+`).replace(/_/g, `/`);
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += `==`;
      break;
    case 3:
      t += `=`;
      break;
    default:
      throw Y(Ug, ``);
  }
  let n = atob(t);
  return Uint8Array.from(n, e => e.codePointAt(0) || 0);
}
var t_ = {
    INVALID_GRANT_ERROR: `invalid_grant`,
    POPUP_WIDTH: 483,
    POPUP_HEIGHT: 600,
    POPUP_NAME_PREFIX: `msal`,
    MSAL_SKU: `msal.js.browser`
  },
  n_ = {
    CHANNEL_ID: `53ee284d-920a-4b59-9d30-a60315b26836`,
    PREFERRED_EXTENSION_ID: `ppnbnpeolgkicgegkbkbjmhlideopiji`,
    MATS_TELEMETRY: `MATS`,
    MICROSOFT_ENTRA_BROKERID: `MicrosoftEntra`,
    DOM_API_NAME: `DOM API`,
    PLATFORM_DOM_APIS: `get-token-and-sign-out`,
    PLATFORM_DOM_PROVIDER: `PlatformAuthDOMHandler`,
    PLATFORM_EXTENSION_PROVIDER: `PlatformAuthExtensionHandler`
  },
  r_ = {
    HandshakeRequest: `Handshake`,
    HandshakeResponse: `HandshakeResponse`,
    GetToken: `GetToken`,
    Response: `Response`
  },
  i_ = {
    LocalStorage: `localStorage`,
    SessionStorage: `sessionStorage`,
    MemoryStorage: `memoryStorage`
  },
  a_ = {
    GET: `GET`,
    POST: `POST`
  },
  o_ = {
    SIGNIN: `signin`,
    SIGNOUT: `signout`
  },
  s_ = {
    ORIGIN_URI: `request.origin`,
    URL_HASH: `urlHash`,
    REQUEST_PARAMS: `request.params`,
    VERIFIER: `code.verifier`,
    INTERACTION_STATUS_KEY: `interaction.status`,
    NATIVE_REQUEST: `request.native`
  },
  c_ = {
    WRAPPER_SKU: `wrapper.sku`,
    WRAPPER_VER: `wrapper.version`
  },
  l_ = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962,
    hydrateCache: 963,
    loadExternalTokens: 964
  },
  u_ = {
    861: `acquireTokenRedirect`,
    862: `acquireTokenPopup`,
    863: `ssoSilent`,
    864: `acquireTokenSilent_authCode`,
    865: `handleRedirectPromise`,
    866: `acquireTokenByCode`,
    61: `acquireTokenSilent_silentFlow`,
    961: `logout`,
    962: `logoutPopup`,
    963: `hydrateCache`,
    964: `loadExternalTokens`
  },
  d_ = e => typeof e == `number` && e in u_ ? u_[e] : `unknown`,
  f_;
(function (e) {
  e.Redirect = `redirect`, e.Popup = `popup`, e.Silent = `silent`, e.None = `none`;
})(f_ ||= {});
var p_ = {
    scopes: Kc
  },
  m_ = `msal.db`,
  h_ = `${m_}.keys`,
  g_ = {
    Default: 0,
    AccessToken: 1,
    AccessTokenAndRefreshToken: 2,
    RefreshToken: 3,
    RefreshTokenAndNetwork: 4,
    Skip: 5
  },
  __ = [g_.Default, g_.Skip, g_.RefreshTokenAndNetwork];
function v_(e) {
  return encodeURIComponent(b_(e).replace(/=/g, ``).replace(/\+/g, `-`).replace(/\//g, `_`));
}
function y_(e) {
  return x_(e).replace(/=/g, ``).replace(/\+/g, `-`).replace(/\//g, `_`);
}
function b_(e) {
  return x_(new TextEncoder().encode(e));
}
function x_(e) {
  let t = Array.from(e, e => String.fromCodePoint(e)).join(``);
  return btoa(t);
}
var S_ = `RSASSA-PKCS1-v1_5`,
  C_ = `AES-GCM`,
  w_ = `HKDF`,
  T_ = `SHA-256`,
  E_ = `P-256`,
  D_ = `EC`,
  O_ = `RSA`,
  k_ = `missing_jwk_kty`,
  A_ = `unsupported_jwk_kty`,
  j_ = `missing_jwk_member`,
  M_ = `empty_jwk_member`,
  N_ = 2048,
  P_ = new Uint8Array([1, 0, 1]),
  F_ = `0123456789abcdef`,
  I_ = new Uint32Array(1),
  L_ = `raw`,
  R_ = `encrypt`,
  z_ = `decrypt`,
  B_ = `deriveKey`,
  V_ = `crypto_subtle_undefined`,
  H_ = {
    name: S_,
    hash: T_,
    modulusLength: N_,
    publicExponent: P_
  },
  U_ = {
    name: S_
  },
  W_ = {
    name: `ECDSA`,
    namedCurve: E_
  },
  G_ = {
    name: `ECDSA`,
    hash: {
      name: T_
    }
  };
function K_(e) {
  if (!window) throw Y(Tg, ``);
  if (!window.crypto) throw Y(ig, ``);
  if (!e && !window.crypto.subtle) throw Y(ig, ``, V_);
}
async function q_(e) {
  let t = new TextEncoder().encode(e);
  return window.crypto.subtle.digest(T_, t);
}
function J_(e) {
  return window.crypto.getRandomValues(e);
}
function Y_() {
  return window.crypto.getRandomValues(I_), I_[0];
}
function X_() {
  let e = Date.now(),
    t = Y_() * 1024 + (Y_() & 1023),
    n = new Uint8Array(16),
    r = Math.trunc(t / 2 ** 30),
    i = t & 2 ** 30 - 1,
    a = Y_();
  n[0] = e / 2 ** 40, n[1] = e / 2 ** 32, n[2] = e / 2 ** 24, n[3] = e / 2 ** 16, n[4] = e / 256, n[5] = e, n[6] = 112 | r >>> 8, n[7] = r, n[8] = 128 | i >>> 24, n[9] = i >>> 16, n[10] = i >>> 8, n[11] = i, n[12] = a >>> 24, n[13] = a >>> 16, n[14] = a >>> 8, n[15] = a;
  let o = ``;
  for (let e = 0; e < n.length; e++) o += F_.charAt(n[e] >>> 4), o += F_.charAt(n[e] & 15), (e === 3 || e === 5 || e === 7 || e === 9) && (o += `-`);
  return o;
}
async function Z_(e, t, n) {
  return window.crypto.subtle.generateKey(n, e, t);
}
async function Q_(e) {
  return window.crypto.subtle.exportKey(`jwk`, e);
}
async function $_(e, t, n) {
  return window.crypto.subtle.sign(n, e, t);
}
async function ev() {
  let e = await rv(),
    t = {
      alg: `dir`,
      kty: `oct`,
      k: y_(new Uint8Array(e))
    };
  return b_(JSON.stringify(t));
}
async function tv(e) {
  let t = $g(e),
    n = JSON.parse(t).k,
    r = e_(n);
  return window.crypto.subtle.importKey(L_, r, C_, !1, [z_]);
}
async function nv(e, t) {
  let n = t.split(`.`);
  if (n.length !== 5) throw Y(Xg, ``, `jwe_length`);
  let r = await tv(e).catch(() => {
    throw Y(Xg, ``, `import_key`);
  });
  try {
    let e = new TextEncoder().encode(n[0]),
      t = e_(n[2]),
      i = e_(n[3]),
      a = e_(n[4]),
      o = a.byteLength * 8,
      s = new Uint8Array(i.length + a.length);
    s.set(i), s.set(a, i.length);
    let c = await window.crypto.subtle.decrypt({
      name: C_,
      iv: t,
      tagLength: o,
      additionalData: e
    }, r, s);
    return new TextDecoder().decode(c);
  } catch {
    throw Y(Xg, ``, `decrypt`);
  }
}
async function rv() {
  let e = await window.crypto.subtle.generateKey({
    name: C_,
    length: 256
  }, !0, [R_, z_]);
  return window.crypto.subtle.exportKey(L_, e);
}
async function iv(e) {
  return window.crypto.subtle.importKey(L_, e, w_, !1, [B_]);
}
async function av(e, t, n) {
  return window.crypto.subtle.deriveKey({
    name: w_,
    salt: t,
    hash: T_,
    info: new TextEncoder().encode(n)
  }, e, {
    name: C_,
    length: 256
  }, !1, [R_, z_]);
}
async function ov(e, t, n) {
  let r = new TextEncoder().encode(t),
    i = window.crypto.getRandomValues(new Uint8Array(16)),
    a = await av(e, i, n),
    o = await window.crypto.subtle.encrypt({
      name: C_,
      iv: new Uint8Array(12)
    }, a, r);
  return {
    data: y_(new Uint8Array(o)),
    nonce: y_(i)
  };
}
async function sv(e, t, n, r) {
  let i = e_(r),
    a = await av(e, e_(t), n),
    o = await window.crypto.subtle.decrypt({
      name: C_,
      iv: new Uint8Array(12)
    }, a, i);
  return new TextDecoder().decode(o);
}
async function cv(e) {
  let t = await q_(e);
  return y_(new Uint8Array(t));
}
var lv = {
  [D_]: [`crv`, `kty`, `x`, `y`],
  [O_]: [`e`, `kty`, `n`]
};
function uv(e, t) {
  let n = e.kty;
  if (typeof n != `string` || n.length === 0) throw Y(Mg, t, k_);
  let r = lv[n];
  if (!r) throw Y(Mg, t, A_);
  return r.reduce((n, r) => {
    let i = e[r];
    if (typeof i != `string`) throw Y(Mg, t, j_);
    if (i.length === 0) throw Y(Mg, t, M_);
    return n[r] = i, n;
  }, {});
}
async function dv(e, t) {
  let n = uv(e, t);
  return cv(JSON.stringify(n, Object.keys(n).sort()));
}
var fv = class e extends Sl {
  constructor(t, n, r) {
    super(t, n, r), this.name = `BrowserConfigurationAuthError`, Object.setPrototypeOf(this, e.prototype);
  }
};
function pv(e, t) {
  return new fv(e, t, $h(e));
}
var mv = `storage_not_supported`,
  hv = `in_mem_redirect_unavailable`;
function gv() {
  let e = window.location.hash,
    t = window.location.search,
    n = !1,
    r = !1,
    i = ``,
    a;
  if (e && e.length > 1) {
    let t = e.charAt(0) === `#` ? e.substring(1) : e,
      r = new URLSearchParams(t);
    r.has(`state`) && (n = !0, i = t, a = r);
  }
  if (t && t.length > 1) {
    let e = t.charAt(0) === `?` ? t.substring(1) : t,
      n = new URLSearchParams(e);
    n.has(`state`) && (r = !0, i = e, a = n);
  }
  if (n && r && (i = `${t.charAt(0) === `?` ? t.substring(1) : t}${e.charAt(0) === `#` ? e.substring(1) : e}`, a = new URLSearchParams(i)), !i || !a) throw Y(Qg, ``);
  let o = a.get(`state`);
  if (!o) throw Y(sg, ``);
  let {
      libraryState: s
    } = xm($g, o, ``),
    {
      id: c,
      meta: l
    } = s;
  if (!c || !l) throw Y(lg, ``, `missing_library_state`);
  return {
    params: a,
    payload: i,
    urlHash: e,
    urlQuery: t,
    hasResponseInHash: n,
    hasResponseInQuery: r,
    libraryState: {
      id: c,
      meta: l
    }
  };
}
function _v(e) {
  e.location.hash = ``, typeof e.history.replaceState == `function` && e.history.replaceState(null, ``, `${e.location.origin}${e.location.pathname}${e.location.search}`);
}
function vv(e) {
  let t = e.split(`#`);
  t.shift(), window.location.hash = t.length > 0 ? t.join(`#`) : ``;
}
function yv() {
  return window.parent !== window;
}
function bv() {
  if (yv()) return !1;
  try {
    let {
        libraryState: e
      } = gv(),
      {
        meta: t
      } = e;
    return t.interactionType === f_.Popup;
  } catch {
    return !1;
  }
}
var xv = null;
function Sv(e, t) {
  xv &&= (e.verbose(`18y01k`, t), clearTimeout(xv.timeoutId), xv.channel.close(), xv.reject(Y(fg, ``)), null);
}
async function Cv(e, t, n, r, i) {
  return new Promise((a, o) => {
    t.verbose(`1rf6em`, n.correlationId);
    let s = n.correlationId;
    r.addFields({
      redirectBridgeTimeoutMs: e,
      lateResponseExperimentEnabled: i?.iframeTimeoutTelemetry || !1
    }, s);
    let {
        libraryState: c
      } = xm($g, n.state || ``, n.correlationId),
      l = new BroadcastChannel(c.id),
      u,
      d = !1,
      f,
      p,
      m = window.setTimeout(() => {
        xv = null, i?.iframeTimeoutTelemetry ? (p = r.startMeasurement(Qh, s), d = !0, f = window.setTimeout(() => {
          p?.end({
            success: !1
          }), clearTimeout(f), l.close();
        }, 6e4)) : l.close(), o(Y(Zg, ``, `redirect_bridge_timeout`));
      }, e);
    xv = {
      timeoutId: m,
      channel: l,
      reject: o
    }, l.onmessage = e => {
      u = e.data.payload;
      let t = e?.data && typeof e.data.v == `number` ? e.data.v : void 0;
      if (d) {
        p?.end({
          success: !!u
        }), clearTimeout(f), l.close();
        return;
      }
      r.addFields({
        redirectBridgeMessageVersion: t
      }, s), xv = null, clearTimeout(m), l.close(), u ? a(u) : o(Y(gg, s));
    };
  });
}
function wv() {
  return typeof window < `u` && window.location ? window.location.href.split(`?`)[0].split(`#`)[0] : ``;
}
function Tv(e) {
  let t = new Yu(window.location.href, e || ``).getUrlComponents();
  return `${t.Protocol}//${t.HostNameAndPort}/`;
}
function Ev() {
  if (sp(window.location.hash) && yv()) throw Y(vg, ``);
}
function Dv(e) {
  if (yv() && !e) throw Y(_g, ``);
}
function Ov() {
  if (bv()) throw Y(yg, ``);
}
function kv() {
  if (typeof window > `u`) throw Y(Tg, ``);
}
function Av(e) {
  if (!e) throw Y(Vg, ``);
}
function jv(e) {
  kv(), Ev(), Ov(), Av(e);
}
function Mv(e, t) {
  if (jv(e), Dv(t.system.allowRedirectInIframe), t.cache.cacheLocation === i_.MemoryStorage) throw pv(hv, ``);
}
function Nv(e) {
  let t = document.createElement(`link`);
  t.rel = `preconnect`, t.href = new URL(e).origin, t.crossOrigin = `anonymous`, document.head.appendChild(t), window.setTimeout(() => {
    try {
      document.head.removeChild(t);
    } catch {}
  }, 1e4);
}
function Pv() {
  return X_();
}
var Fv = class {
    constructor() {
      this.dbName = m_, this.version = 1, this.tableName = h_, this.dbOpen = !1;
    }
    async open() {
      return new Promise((e, t) => {
        let n = window.indexedDB.open(this.dbName, this.version);
        n.addEventListener(`upgradeneeded`, e => {
          e.target.result.createObjectStore(this.tableName);
        }), n.addEventListener(`success`, t => {
          let n = t;
          this.db = n.target.result, this.dbOpen = !0, e();
        }), n.addEventListener(`error`, () => t(Y(Ig, ``)));
      });
    }
    closeConnection() {
      let e = this.db;
      e && this.dbOpen && (e.close(), this.dbOpen = !1);
    }
    async validateDbIsOpen() {
      if (!this.dbOpen) return this.open();
    }
    async getItem(e) {
      return await this.validateDbIsOpen(), new Promise((t, n) => {
        if (!this.db) return n(Y(Eg, ``));
        let r = this.db.transaction([this.tableName], `readonly`).objectStore(this.tableName).get(e);
        r.addEventListener(`success`, e => {
          let n = e;
          this.closeConnection(), t(n.target.result);
        }), r.addEventListener(`error`, e => {
          this.closeConnection(), n(e);
        });
      });
    }
    async setItem(e, t) {
      return await this.validateDbIsOpen(), new Promise((n, r) => {
        if (!this.db) return r(Y(Eg, ``));
        let i = this.db.transaction([this.tableName], `readwrite`).objectStore(this.tableName).put(t, e);
        i.addEventListener(`success`, () => {
          this.closeConnection(), n();
        }), i.addEventListener(`error`, e => {
          this.closeConnection(), r(e);
        });
      });
    }
    async removeItem(e) {
      return await this.validateDbIsOpen(), new Promise((t, n) => {
        if (!this.db) return n(Y(Eg, ``));
        let r = this.db.transaction([this.tableName], `readwrite`).objectStore(this.tableName).delete(e);
        r.addEventListener(`success`, () => {
          this.closeConnection(), t();
        }), r.addEventListener(`error`, e => {
          this.closeConnection(), n(e);
        });
      });
    }
    async getKeys() {
      return await this.validateDbIsOpen(), new Promise((e, t) => {
        if (!this.db) return t(Y(Eg, ``));
        let n = this.db.transaction([this.tableName], `readonly`).objectStore(this.tableName).getAllKeys();
        n.addEventListener(`success`, t => {
          let n = t;
          this.closeConnection(), e(n.target.result);
        }), n.addEventListener(`error`, e => {
          this.closeConnection(), t(e);
        });
      });
    }
    async containsKey(e) {
      return await this.validateDbIsOpen(), new Promise((t, n) => {
        if (!this.db) return n(Y(Eg, ``));
        let r = this.db.transaction([this.tableName], `readonly`).objectStore(this.tableName).count(e);
        r.addEventListener(`success`, e => {
          let n = e;
          this.closeConnection(), t(n.target.result === 1);
        }), r.addEventListener(`error`, e => {
          this.closeConnection(), n(e);
        });
      });
    }
    async deleteDatabase() {
      return this.db && this.dbOpen && this.closeConnection(), new Promise((e, t) => {
        let n = window.indexedDB.deleteDatabase(m_),
          r = setTimeout(() => t(!1), 200);
        n.addEventListener(`success`, () => (clearTimeout(r), e(!0))), n.addEventListener(`blocked`, () => (clearTimeout(r), e(!0))), n.addEventListener(`error`, () => (clearTimeout(r), t(!1)));
      });
    }
  },
  Iv = class {
    constructor() {
      this.cache = new Map();
    }
    async initialize() {}
    getItem(e) {
      return this.cache.get(e) || null;
    }
    getUserData(e) {
      return this.getItem(e);
    }
    setItem(e, t) {
      this.cache.set(e, t);
    }
    async setUserData(e, t) {
      this.setItem(e, t);
    }
    removeItem(e) {
      this.cache.delete(e);
    }
    getKeys() {
      let e = [];
      return this.cache.forEach((t, n) => {
        e.push(n);
      }), e;
    }
    containsKey(e) {
      return this.cache.has(e);
    }
    clear() {
      this.cache.clear();
    }
    decryptData() {
      return Promise.resolve(null);
    }
  },
  Lv = class {
    constructor(e) {
      this.inMemoryCache = new Iv(), this.indexedDBCache = new Fv(), this.logger = e;
    }
    handleDatabaseAccessError(e, t) {
      if (e instanceof eg && e.errorCode === `database_unavailable`) this.logger.error(`1wx7zz`, t);else throw e;
    }
    async getItem(e, t) {
      let n = this.inMemoryCache.getItem(e);
      if (!n) try {
        return this.logger.verbose(`0naxpl`, t), await this.indexedDBCache.getItem(e);
      } catch (e) {
        this.handleDatabaseAccessError(e, t);
      }
      return n;
    }
    async setItem(e, t, n) {
      this.inMemoryCache.setItem(e, t);
      try {
        await this.indexedDBCache.setItem(e, t);
      } catch (e) {
        this.handleDatabaseAccessError(e, n);
      }
    }
    async removeItem(e, t) {
      this.inMemoryCache.removeItem(e);
      try {
        await this.indexedDBCache.removeItem(e);
      } catch (e) {
        this.handleDatabaseAccessError(e, t);
      }
    }
    async getKeys(e) {
      let t = this.inMemoryCache.getKeys();
      try {
        let e = await this.indexedDBCache.getKeys();
        return Array.from(new Set([...t, ...e]));
      } catch (n) {
        return this.handleDatabaseAccessError(n, e), t;
      }
    }
    async containsKey(e, t) {
      let n = this.inMemoryCache.containsKey(e);
      if (!n) try {
        return this.logger.verbose(`03zl2j`, t), await this.indexedDBCache.containsKey(e);
      } catch (e) {
        this.handleDatabaseAccessError(e, t);
      }
      return n;
    }
    clearInMemory(e) {
      this.logger.verbose(`03r21p`, e), this.inMemoryCache.clear(), this.logger.verbose(`0uksk1`, e);
    }
    async clearPersistent(e) {
      try {
        this.logger.verbose(`0rdqut`, e);
        let t = await this.indexedDBCache.deleteDatabase();
        return t && this.logger.verbose(`149ouc`, e), t;
      } catch (t) {
        return this.handleDatabaseAccessError(t, e), !1;
      }
    }
  },
  Rv = class e {
    constructor(t, n) {
      this.logger = t, this.cache = e.getTokenBindingKeyStorage(this.logger), this.performanceClient = n;
    }
    static getTokenBindingKeyStorage(t) {
      return e.tokenBindingKeyStorage ||= new Lv(t), e.tokenBindingKeyStorage;
    }
    async provisionTokenBindingKey(e) {
      let t = this.performanceClient?.startMeasurement(ih, e.correlationId);
      try {
        let n = await this.createTokenBindingKey(e);
        return t?.end({
          success: !0,
          ...this.getTokenBindingKeyTelemetry(n)
        }), n.keyId;
      } catch (n) {
        throw t?.end({
          success: !1,
          tokenBindingKeyType: e.tokenBindingKeyType,
          tokenBindingKeyAlgorithm: e.tokenBindingKeyAlgorithm
        }), n;
      }
    }
    async removeTokenBindingKey(e, t) {
      if (await this.cache.removeItem(e, t), await this.cache.containsKey(e, t)) throw q(Zl, t);
    }
    async clearKeystore(e) {
      this.cache.clearInMemory(e);
      try {
        return await this.cache.clearPersistent(e), !0;
      } catch (t) {
        return t instanceof Error ? this.logger.error(`1owpn8 ${t.message}`, e) : this.logger.error(`0yrmwo`, e), !1;
      }
    }
    async getTokenBindingPublicKeyJwk(e, t) {
      return Q_((await this.getTokenBindingKeyPair(e, t)).publicKey);
    }
    async createTokenBindingKey(t) {
      let n = this.getTokenBindingKeyGenAlgorithmOptions(t.tokenBindingKeyAlgorithm, t.correlationId),
        r = await this.generateKeyPairAndThumbprint(e.TOKEN_BINDING_KEY_USAGES, n, t.correlationId);
      return await this.cache.setItem(r.keyId, {
        ...r,
        tokenBindingKeyType: t.tokenBindingKeyType,
        tokenBindingKeyAlgorithm: t.tokenBindingKeyAlgorithm
      }, t.correlationId), {
        ...r,
        tokenBindingKeyType: t.tokenBindingKeyType,
        tokenBindingKeyAlgorithm: t.tokenBindingKeyAlgorithm
      };
    }
    async generateKeyPairAndThumbprint(e, t, n) {
      let r = await Z_(!1, e, t),
        i = await dv(await Q_(r.publicKey), n);
      return {
        publicKey: r.publicKey,
        privateKey: r.privateKey,
        keyId: i
      };
    }
    async getTokenBindingKeyPair(e, t) {
      let n = await this.cache.getItem(e, t);
      if (!n) throw Y(jg, t);
      return n;
    }
    getTokenBindingKeyTelemetry(e, t) {
      return {
        ...(e.tokenBindingKeyType && {
          tokenBindingKeyType: e.tokenBindingKeyType
        }),
        ...(e.tokenBindingKeyAlgorithm || t ? {
          tokenBindingKeyAlgorithm: e.tokenBindingKeyAlgorithm || t
        } : {})
      };
    }
    getTokenBindingKeyGenAlgorithmOptions(e, t) {
      if (e === dp.RS256) return H_;
      if (e === dp.ES256) return W_;
      throw Y(Gg, t);
    }
  };
Rv.TOKEN_BINDING_KEY_USAGES = [`sign`, `verify`];
var zv = class {
    constructor(e, t, n) {
      this.logger = e, K_(n ?? !1), this.performanceClient = t, this.tokenBindingKeyManager = new Rv(this.logger, this.performanceClient);
    }
    createNewGuid() {
      return X_();
    }
    base64Encode(e) {
      return b_(e);
    }
    base64Decode(e) {
      return $g(e);
    }
    base64UrlEncode(e) {
      return v_(e);
    }
    encodeKid(e) {
      return this.base64UrlEncode(JSON.stringify({
        kid: e
      }));
    }
    async removeTokenBindingKey(e, t) {
      await this.tokenBindingKeyManager.removeTokenBindingKey(e, t);
    }
    async clearKeystore(e) {
      return this.tokenBindingKeyManager.clearKeystore(e);
    }
    async signTokenBindingJwt(e, t, n, r) {
      let i = {},
        a = this.performanceClient?.startMeasurement(ah, r);
      try {
        let o = await this.tokenBindingKeyManager.getTokenBindingKeyPair(n, r);
        await this.validateTokenBindingJwtHeaderKey(e, n, r), i = this.tokenBindingKeyManager.getTokenBindingKeyTelemetry(o, e.alg);
        let s = this.getTokenBindingKeySigningAlgorithm(o, e.alg, r),
          c = `${v_(JSON.stringify(e))}.${v_(JSON.stringify(t))}`,
          l = await this.signInput(o, c, s);
        return a?.end({
          success: !0,
          ...i
        }), `${c}.${l}`;
      } catch (e) {
        throw a?.end({
          success: !1,
          ...i
        }), e;
      }
    }
    async hashString(e) {
      return cv(e);
    }
    async signInput(e, t, n) {
      let r = new TextEncoder(),
        i = await $_(e.privateKey, r.encode(t), n);
      return y_(new Uint8Array(i));
    }
    getTokenBindingKeySigningAlgorithm(e, t, n) {
      let r = e.privateKey.algorithm;
      if (t === dp.RS256 && r.name === U_.name) return U_;
      if (t === dp.ES256 && r.name === G_.name && r.namedCurve === W_.namedCurve) return G_;
      throw t === dp.RS256 || t === dp.ES256 ? Y(Gg, n, Kg) : Y(Gg, n);
    }
    async validateTokenBindingJwtHeaderKey(e, t, n) {
      if (e.jwk && (await dv(e.jwk, n)) !== t) throw Y(Mg, n, qg);
    }
  },
  Bv = `acquireTokenSilent`,
  Vv = `acquireTokenByCode`,
  Hv = `acquireTokenPopup`,
  Uv = `acquireTokenPreRedirect`,
  Wv = `acquireTokenRedirect`,
  Gv = `ssoSilent`,
  Kv = `initializeClientApplication`,
  qv = `localStorageUpdated`,
  Jv = `ssoCapable`,
  Yv = `msal`,
  Xv = `browser`,
  Zv = `${Yv}.${Xv}.log.level`,
  Qv = `${Yv}.${Xv}.log.pii`;
`${Yv}${Xv}`;
var $v = `${Yv}.version`,
  ey = `account.keys`,
  ty = `token.keys`,
  ny = `${Yv}.${Xv}.sso.capable`;
function ry(e = 3) {
  return e < 1 ? `${Yv}.${ey}` : `${Yv}.${e}.${ey}`;
}
function iy(e, t = 3) {
  return t < 1 ? `${Yv}.${ty}.${e}` : `${Yv}.${t}.${ty}.${e}`;
}
var ay = 864e5,
  oy = {
    Lax: `Lax`,
    None: `None`
  },
  sy = class {
    initialize() {
      return Promise.resolve();
    }
    getItem(e) {
      let t = encodeURIComponent(e),
        n = document.cookie.split(`;`);
      for (let e = 0; e < n.length; e++) {
        let r = n[e].trim(),
          i = r.indexOf(`=`);
        if ((i === -1 ? r : r.substring(0, i)) === t) {
          let e = i === -1 ? `` : r.substring(i + 1);
          try {
            return decodeURIComponent(e);
          } catch {
            return e;
          }
        }
      }
      return ``;
    }
    getUserData() {
      throw q(eu, ``);
    }
    setItem(e, t, n, r = !0, i = oy.Lax) {
      let a = `${encodeURIComponent(e)}=${encodeURIComponent(t)};path=/;SameSite=${i};`;
      if (n) {
        let e = cy(n);
        a += `expires=${e};`;
      }
      (r || i === oy.None) && (a += `Secure;`), document.cookie = a;
    }
    async setUserData(e, t, n) {
      return Promise.reject(q(eu, n));
    }
    removeItem(e) {
      this.setItem(e, ``, -1);
    }
    getKeys() {
      let e = document.cookie.split(`;`),
        t = [];
      return e.forEach(e => {
        let n = e.trim(),
          r = n.indexOf(`=`),
          i = r === -1 ? n : n.substring(0, r);
        try {
          t.push(decodeURIComponent(i));
        } catch {}
      }), t;
    }
    containsKey(e) {
      return this.getKeys().includes(e);
    }
    decryptData() {
      return Promise.resolve(null);
    }
  };
function cy(e) {
  return new Date(new Date().getTime() + e * ay).toUTCString();
}
function ly(e, t) {
  let n = e.getItem(ry(t));
  return n ? JSON.parse(n) : [];
}
function uy(e, t, n) {
  let r = t.getItem(iy(e, n));
  if (r) {
    let e = JSON.parse(r);
    if (e && e.hasOwnProperty(`idToken`) && e.hasOwnProperty(`accessToken`) && e.hasOwnProperty(`refreshToken`)) return e;
  }
  return {
    idToken: [],
    accessToken: [],
    refreshToken: []
  };
}
function dy(e) {
  return e.hasOwnProperty(`id`) && e.hasOwnProperty(`nonce`) && e.hasOwnProperty(`data`);
}
var fy = `msal.cache.encryption`,
  py = `msal.broadcast.cache`,
  my = class {
    constructor(e, t, n) {
      if (!window.localStorage) throw pv(mv, ``);
      this.memoryStorage = new Iv(), this.initialized = !1, this.clientId = e, this.logger = t, this.performanceClient = n, this.broadcast = new BroadcastChannel(py);
    }
    async initialize(e) {
      let t = new sy(),
        n = t.getItem(fy),
        r = {
          key: ``,
          id: ``
        };
      if (n) try {
        r = JSON.parse(n);
      } catch {}
      if (r.key && r.id) {
        let t = Fd(e_, Kh, this.logger, this.performanceClient, e)(r.key);
        this.encryptionCookie = {
          id: r.id,
          key: await J(iv, Wh, this.logger, this.performanceClient, e)(t)
        };
      } else {
        let n = X_(),
          r = await J(rv, Gh, this.logger, this.performanceClient, e)(),
          i = Fd(y_, qh, this.logger, this.performanceClient, e)(new Uint8Array(r));
        this.encryptionCookie = {
          id: n,
          key: await J(iv, Wh, this.logger, this.performanceClient, e)(r)
        };
        let a = {
          id: n,
          key: i
        };
        t.setItem(fy, JSON.stringify(a), 0, !0, oy.None);
      }
      await J(this.importExistingCache.bind(this), Rh, this.logger, this.performanceClient, e)(e), this.broadcast.addEventListener(`message`, t => {
        this.updateCache(t, e);
      }), this.initialized = !0;
    }
    getItem(e) {
      return window.localStorage.getItem(e);
    }
    getUserData(e) {
      if (!this.initialized) throw Y(Vg, ``);
      return this.memoryStorage.getItem(e);
    }
    async decryptData(e, t, n) {
      if (!this.initialized || !this.encryptionCookie) throw Y(Vg, ``);
      if (t.id !== this.encryptionCookie.id) return this.performanceClient.incrementFields({
        encryptedCacheExpiredCount: 1
      }, n), null;
      let r = await J(sv, Yh, this.logger, this.performanceClient, n)(this.encryptionCookie.key, t.nonce, this.getContext(e), t.data);
      if (!r) return null;
      try {
        return {
          ...JSON.parse(r),
          lastUpdatedAt: t.lastUpdatedAt
        };
      } catch {
        return this.performanceClient.incrementFields({
          encryptedCacheCorruptionCount: 1
        }, n), null;
      }
    }
    setItem(e, t) {
      window.localStorage.setItem(e, t);
    }
    async setUserData(e, t, n, r, i) {
      if (!this.initialized || !this.encryptionCookie) throw Y(Vg, ``);
      if (i) this.setItem(e, t);else {
        let {
            data: i,
            nonce: a
          } = await J(ov, Jh, this.logger, this.performanceClient, n)(this.encryptionCookie.key, t, this.getContext(e)),
          o = {
            id: this.encryptionCookie.id,
            nonce: a,
            data: i,
            lastUpdatedAt: r
          };
        this.setItem(e, JSON.stringify(o));
      }
      this.memoryStorage.setItem(e, t), this.broadcast.postMessage({
        key: e,
        value: t,
        context: this.getContext(e)
      });
    }
    removeItem(e) {
      this.memoryStorage.containsKey(e) && (this.memoryStorage.removeItem(e), this.broadcast.postMessage({
        key: e,
        value: null,
        context: this.getContext(e)
      })), window.localStorage.removeItem(e);
    }
    getKeys() {
      return Object.keys(window.localStorage);
    }
    containsKey(e) {
      return window.localStorage.hasOwnProperty(e);
    }
    clear() {
      this.memoryStorage.clear(), ly(this).forEach(e => this.removeItem(e));
      let e = uy(this.clientId, this);
      e.idToken.forEach(e => this.removeItem(e)), e.accessToken.forEach(e => this.removeItem(e)), e.refreshToken.forEach(e => this.removeItem(e)), this.getKeys().forEach(e => {
        (e.startsWith(`msal`) || e.indexOf(this.clientId) !== -1) && this.removeItem(e);
      });
    }
    async importExistingCache(e) {
      if (!this.encryptionCookie) return;
      let t = ly(this);
      t = await this.importArray(t, e), t.length ? this.setItem(ry(), JSON.stringify(t)) : this.removeItem(ry());
      let n = uy(this.clientId, this);
      n.idToken = await this.importArray(n.idToken, e), n.accessToken = await this.importArray(n.accessToken, e), n.refreshToken = await this.importArray(n.refreshToken, e), n.idToken.length || n.accessToken.length || n.refreshToken.length ? this.setItem(iy(this.clientId), JSON.stringify(n)) : this.removeItem(iy(this.clientId));
    }
    async getItemFromEncryptedCache(e, t) {
      if (!this.encryptionCookie) return null;
      let n = this.getItem(e);
      if (!n) return null;
      let r;
      try {
        r = JSON.parse(n);
      } catch {
        return null;
      }
      return dy(r) ? r.id === this.encryptionCookie.id ? (this.performanceClient.incrementFields({
        encryptedCacheCount: 1
      }, t), J(sv, Yh, this.logger, this.performanceClient, t)(this.encryptionCookie.key, r.nonce, this.getContext(e), r.data)) : (this.performanceClient.incrementFields({
        encryptedCacheExpiredCount: 1
      }, t), null) : (this.performanceClient.incrementFields({
        unencryptedCacheCount: 1
      }, t), n);
    }
    async importArray(e, t) {
      let n = [],
        r = [];
      return e.forEach(e => {
        let i = this.getItemFromEncryptedCache(e, t).then(t => {
          t ? (this.memoryStorage.setItem(e, t), n.push(e)) : this.removeItem(e);
        });
        r.push(i);
      }), await Promise.all(r), n;
    }
    getContext(e) {
      let t = ``;
      return e.includes(this.clientId) && (t = this.clientId), t;
    }
    updateCache(e, t) {
      this.logger.trace(`17cxcm`, t);
      let n = this.performanceClient.startMeasurement(qv);
      n.add({
        isBackground: !0
      });
      let {
        key: r,
        value: i,
        context: a
      } = e.data;
      if (!r) {
        this.logger.error(`0e10qr`, t), n.end({
          success: !1,
          errorCode: `noKey`
        });
        return;
      }
      if (a && a !== this.clientId) {
        this.logger.trace(`04rtdy ${a}`, t), n.discard();
        return;
      }
      i ? (this.memoryStorage.setItem(r, i), this.logger.verbose(`1vzsgt`, t)) : (this.memoryStorage.removeItem(r), this.logger.verbose(`04ypih`, t)), n.end({
        success: !0
      });
    }
  },
  hy = class {
    constructor() {
      if (!window.sessionStorage) throw pv(mv, ``);
    }
    async initialize() {}
    getItem(e) {
      return window.sessionStorage.getItem(e);
    }
    getUserData(e) {
      return this.getItem(e);
    }
    setItem(e, t) {
      window.sessionStorage.setItem(e, t);
    }
    async setUserData(e, t) {
      this.setItem(e, t);
    }
    removeItem(e) {
      window.sessionStorage.removeItem(e);
    }
    getKeys() {
      return Object.keys(window.sessionStorage);
    }
    containsKey(e) {
      return window.sessionStorage.hasOwnProperty(e);
    }
    decryptData() {
      return Promise.resolve(null);
    }
  },
  gy = {
    INITIALIZE_START: `msal:initializeStart`,
    INITIALIZE_END: `msal:initializeEnd`,
    ACTIVE_ACCOUNT_CHANGED: `msal:activeAccountChanged`,
    LOGIN_SUCCESS: `msal:loginSuccess`,
    ACQUIRE_TOKEN_START: `msal:acquireTokenStart`,
    BROKERED_REQUEST_START: `msal:brokeredRequestStart`,
    ACQUIRE_TOKEN_SUCCESS: `msal:acquireTokenSuccess`,
    BROKERED_REQUEST_SUCCESS: `msal:brokeredRequestSuccess`,
    ACQUIRE_TOKEN_FAILURE: `msal:acquireTokenFailure`,
    BROKERED_REQUEST_FAILURE: `msal:brokeredRequestFailure`,
    ACQUIRE_TOKEN_NETWORK_START: `msal:acquireTokenFromNetworkStart`,
    HANDLE_REDIRECT_START: `msal:handleRedirectStart`,
    HANDLE_REDIRECT_END: `msal:handleRedirectEnd`,
    POPUP_OPENED: `msal:popupOpened`,
    LOGOUT_START: `msal:logoutStart`,
    LOGOUT_SUCCESS: `msal:logoutSuccess`,
    LOGOUT_FAILURE: `msal:logoutFailure`,
    LOGOUT_END: `msal:logoutEnd`,
    RESTORE_FROM_BFCACHE: `msal:restoreFromBFCache`,
    BROKER_CONNECTION_ESTABLISHED: `msal:brokerConnectionEstablished`
  },
  _y = `@azure/msal-browser`,
  vy = `5.20.0`;
function yy(e, t) {
  let n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
var by = {
    Invalid: `invalid`,
    TtlExpired: `ttlExpired`,
    DecryptFailed: `decryptFailed`,
    Expired: `expired`
  },
  xy = class extends Op {
    constructor(e, t, n, r, i, a, o, s = pp) {
      super(e, n, r, i, o, s), this.cacheConfig = t, this.logger = r, this.internalStorage = new Iv(), this.browserStorage = Sy(e, t.cacheLocation, r, i), this.temporaryCacheStorage = Sy(e, i_.SessionStorage, r, i), this.cookieStorage = new sy(), this.eventHandler = a;
    }
    async initialize(e) {
      this.performanceClient.addFields({
        cacheLocation: this.cacheConfig.cacheLocation,
        cacheRetentionDays: this.cacheConfig.cacheRetentionDays
      }, e), await this.browserStorage.initialize(e), await this.migrateExistingCache(e), this.trackVersionChanges(e);
    }
    async migrateExistingCache(e) {
      let t = ly(this.browserStorage),
        n = uy(this.clientId, this.browserStorage);
      this.performanceClient.addFields({
        preMigrateAcntCount: t.length,
        preMigrateATCount: n.accessToken.length,
        preMigrateITCount: n.idToken.length,
        preMigrateRTCount: n.refreshToken.length
      }, e);
      for (let t = 0; t < 3; t++) {
        let n = t;
        await this.removeStaleAccounts(t, n, e);
      }
      for (let t = 0; t < 3; t++) {
        let n = t;
        await this.migrateIdTokens(t, n, e);
      }
      let r = this.getKMSIValues();
      for (let t = 0; t < 3; t++) await this.migrateAccessTokens(t, r, e), await this.migrateRefreshTokens(t, r, e);
      t = ly(this.browserStorage), n = uy(this.clientId, this.browserStorage), this.performanceClient.addFields({
        postMigrateAcntCount: t.length,
        postMigrateATCount: n.accessToken.length,
        postMigrateITCount: n.idToken.length,
        postMigrateRTCount: n.refreshToken.length
      }, e);
    }
    async updateOldEntry(e, t) {
      let n = this.browserStorage.getItem(e),
        r = this.validateAndParseJson(n || ``);
      if (!r) return this.browserStorage.removeItem(e), {
        entry: null,
        removalReason: by.Invalid
      };
      if (!r.lastUpdatedAt) r.lastUpdatedAt = Date.now().toString(), this.setItem(e, JSON.stringify(r), t);else if (Vd(r.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) return this.browserStorage.removeItem(e), {
        entry: null,
        removalReason: by.TtlExpired
      };
      let i = dy(r),
        a = i ? await this.browserStorage.decryptData(e, r, t) : r;
      return a ? Kd(a) ? (qd(a) || Yd(a)) && a.expiresOn && Bd(a.expiresOn, 300) ? (this.browserStorage.removeItem(e), {
        entry: null,
        removalReason: by.Expired
      }) : {
        entry: a
      } : (this.browserStorage.removeItem(e), {
        entry: null,
        removalReason: by.Invalid
      }) : (this.browserStorage.removeItem(e), {
        entry: null,
        removalReason: i ? by.DecryptFailed : by.Invalid
      });
    }
    async removeStaleAccounts(e, t, n) {
      let r = ly(this.browserStorage, e);
      if (r.length !== 0) {
        for (let e of [...r]) {
          this.performanceClient.incrementFields({
            oldAcntCount: 1
          }, n);
          let i = this.browserStorage.getItem(e),
            a = this.validateAndParseJson(i || ``);
          if (!a) {
            this.browserStorage.removeItem(e), this.performanceClient.incrementFields({
              invalidAcntCount: 1
            }, n), yy(r, e);
            continue;
          }
          if (a.lastUpdatedAt) Vd(a.lastUpdatedAt, this.cacheConfig.cacheRetentionDays) ? (await this.removeAccountOldSchema(e, a, t, n), this.performanceClient.incrementFields({
            ttlExpiredAcntCount: 1
          }, n), yy(r, e)) : dy(a) && ((await this.browserStorage.decryptData(e, a, n)) || (this.browserStorage.removeItem(e), this.performanceClient.incrementFields({
            decryptFailedAcntCount: 1
          }, n), yy(r, e)));else {
            a.lastUpdatedAt = Date.now().toString(), this.setItem(e, JSON.stringify(a), n);
            continue;
          }
        }
        this.setAccountKeys(r, n, e);
      }
    }
    async removeAccountOldSchema(e, t, n, r) {
      let i = (dy(t) ? await this.browserStorage.decryptData(e, t, r) : t)?.homeAccountId;
      if (i) {
        let e = this.getTokenKeys(n);
        [...e.idToken].filter(e => e.includes(i)).forEach(t => {
          this.browserStorage.removeItem(t), yy(e.idToken, t);
        }), [...e.accessToken].filter(e => e.includes(i)).forEach(t => {
          this.browserStorage.removeItem(t), yy(e.accessToken, t);
        }), [...e.refreshToken].filter(e => e.includes(i)).forEach(t => {
          this.browserStorage.removeItem(t), yy(e.refreshToken, t);
        }), this.setTokenKeys(e, r, n);
      }
      this.browserStorage.removeItem(e);
    }
    getKMSIValues() {
      let e = {},
        t = this.getTokenKeys().idToken;
      for (let n of t) {
        let t = this.browserStorage.getUserData(n);
        if (t) {
          let n = JSON.parse(t),
            r = au(n.secret, $g, ``);
          r && (e[n.homeAccountId] = ou(r));
        }
      }
      return e;
    }
    async migrateIdTokens(e, t, n) {
      let r = uy(this.clientId, this.browserStorage, e);
      if (r.idToken.length === 0) return;
      let i = uy(this.clientId, this.browserStorage, 3),
        a = ly(this.browserStorage),
        o = ly(this.browserStorage, t);
      for (let e of [...r.idToken]) {
        this.performanceClient.incrementFields({
          oldITCount: 1
        }, n);
        let t = await this.updateOldEntry(e, n),
          s = t.entry;
        if (!s) {
          switch (t.removalReason) {
            case by.TtlExpired:
              this.performanceClient.incrementFields({
                ttlExpiredITCount: 1
              }, n);
              break;
            case by.DecryptFailed:
              this.performanceClient.incrementFields({
                decryptFailedITCount: 1
              }, n);
              break;
            case by.Invalid:
              this.performanceClient.incrementFields({
                invalidITCount: 1
              }, n);
          }
          yy(r.idToken, e);
          continue;
        }
        let c = a.find(e => e.includes(s.homeAccountId)),
          l = o.find(e => e.includes(s.homeAccountId)),
          u = null;
        if (c) u = this.getAccount(c, n);else if (l) {
          let e = this.browserStorage.getItem(l),
            t = this.validateAndParseJson(e || ``);
          u = t && dy(t) ? await this.browserStorage.decryptData(l, t, n) : t;
        }
        if (!u) {
          this.performanceClient.incrementFields({
            skipITMigrateCount: 1
          }, n);
          continue;
        }
        let d = au(s.secret, $g, n),
          f = this.generateCredentialKey(s),
          p = this.getIdTokenCredential(f, n),
          m = Object.keys(d).includes(`signin_state`),
          h = p && Object.keys(au(p.secret, $g, n) || {}).includes(`signin_state`);
        if (!p || s.lastUpdatedAt > p.lastUpdatedAt && (m || !h)) {
          let e = u.tenantProfiles || [],
            t = fu(d) || u.realm;
          if (t && !e.find(e => e.tenantId === t)) {
            let n = lu(u.homeAccountId, u.localAccountId, t, u.nativeAccountId, d);
            e.push(n);
          }
          u.tenantProfiles = e;
          let r = this.generateAccountKey(mu(u)),
            o = ou(d);
          await this.setUserData(r, JSON.stringify(u), n, u.lastUpdatedAt, o), a.includes(r) || a.push(r), await this.setUserData(f, JSON.stringify(s), n, s.lastUpdatedAt, o), this.performanceClient.incrementFields({
            migratedITCount: 1
          }, n), i.idToken.includes(f) || i.idToken.push(f);
        }
      }
      this.setTokenKeys(r, n, e), this.setTokenKeys(i, n), this.setAccountKeys(a, n);
    }
    async migrateAccessTokens(e, t, n) {
      let r = uy(this.clientId, this.browserStorage, e);
      if (r.accessToken.length === 0) return;
      let i = uy(this.clientId, this.browserStorage, 3);
      for (let e of [...r.accessToken]) {
        this.performanceClient.incrementFields({
          oldATCount: 1
        }, n);
        let a = await this.updateOldEntry(e, n),
          o = a.entry;
        if (!o) {
          switch (a.removalReason) {
            case by.TtlExpired:
              this.performanceClient.incrementFields({
                ttlExpiredATCount: 1
              }, n);
              break;
            case by.DecryptFailed:
              this.performanceClient.incrementFields({
                decryptFailedATCount: 1
              }, n);
              break;
            case by.Expired:
              this.performanceClient.incrementFields({
                expiredATCount: 1
              }, n);
              break;
            case by.Invalid:
              this.performanceClient.incrementFields({
                invalidATCount: 1
              }, n);
          }
          yy(r.accessToken, e);
          continue;
        }
        if (!(o.homeAccountId in t)) {
          this.performanceClient.incrementFields({
            skipATMigrateCount: 1
          }, n);
          continue;
        }
        let s = this.generateCredentialKey(o),
          c = t[o.homeAccountId];
        if (!i.accessToken.includes(s)) await this.setUserData(s, JSON.stringify(o), n, o.lastUpdatedAt, c), this.performanceClient.incrementFields({
          migratedATCount: 1
        }, n), i.accessToken.push(s);else {
          let e = this.getAccessTokenCredential(s, n);
          (!e || o.lastUpdatedAt > e.lastUpdatedAt) && (await this.setUserData(s, JSON.stringify(o), n, o.lastUpdatedAt, c), this.performanceClient.incrementFields({
            migratedATCount: 1
          }, n));
        }
      }
      this.setTokenKeys(r, n, e), this.setTokenKeys(i, n);
    }
    async migrateRefreshTokens(e, t, n) {
      let r = uy(this.clientId, this.browserStorage, e);
      if (r.refreshToken.length === 0) return;
      let i = uy(this.clientId, this.browserStorage, 3);
      for (let e of [...r.refreshToken]) {
        this.performanceClient.incrementFields({
          oldRTCount: 1
        }, n);
        let a = await this.updateOldEntry(e, n),
          o = a.entry;
        if (!o) {
          switch (a.removalReason) {
            case by.TtlExpired:
              this.performanceClient.incrementFields({
                ttlExpiredRTCount: 1
              }, n);
              break;
            case by.DecryptFailed:
              this.performanceClient.incrementFields({
                decryptFailedRTCount: 1
              }, n);
              break;
            case by.Expired:
              this.performanceClient.incrementFields({
                expiredRTCount: 1
              }, n);
              break;
            case by.Invalid:
              this.performanceClient.incrementFields({
                invalidRTCount: 1
              }, n);
          }
          yy(r.refreshToken, e);
          continue;
        }
        if (!(o.homeAccountId in t)) {
          this.performanceClient.incrementFields({
            skipRTMigrateCount: 1
          }, n);
          continue;
        }
        let s = this.generateCredentialKey(o),
          c = t[o.homeAccountId];
        if (!i.refreshToken.includes(s)) await this.setUserData(s, JSON.stringify(o), n, o.lastUpdatedAt, c), this.performanceClient.incrementFields({
          migratedRTCount: 1
        }, n), i.refreshToken.push(s);else {
          let e = this.getRefreshTokenCredential(s, n);
          (!e || o.lastUpdatedAt > e.lastUpdatedAt) && (await this.setUserData(s, JSON.stringify(o), n, o.lastUpdatedAt, c), this.performanceClient.incrementFields({
            migratedRTCount: 1
          }, n));
        }
      }
      this.setTokenKeys(r, n, e), this.setTokenKeys(i, n);
    }
    trackVersionChanges(e) {
      let t = this.browserStorage.getItem($v);
      t && (this.logger.info(`1wuc87 ${t}`, e), this.performanceClient.addGlobalFields({
        previousLibraryVersion: t
      })), t !== `5.20.0` && this.setItem($v, vy, e);
    }
    validateAndParseJson(e) {
      if (!e) return null;
      try {
        let t = JSON.parse(e);
        return t && typeof t == `object` ? t : null;
      } catch {
        return null;
      }
    }
    setItem(e, t, n) {
      let r = [,,,,].fill(0),
        i = [];
      for (let a = 0; a <= 20; a++) try {
        if (this.browserStorage.setItem(e, t), a > 0) for (let e = 0; e <= 3; e++) {
          let t = r.slice(0, e).reduce((e, t) => e + t, 0);
          if (t >= a) break;
          let o = a > t + r[e] ? t + r[e] : a;
          a > t && r[e] > 0 && this.removeAccessTokenKeys(i.slice(t, o), n, e);
        }
        break;
      } catch (o) {
        let s = Dp(o);
        if (s.errorCode === `cache_quota_exceeded` && a < 20) {
          if (!i.length) for (let n = 0; n <= 3; n++) if (e === iy(this.clientId, n)) {
            let e = JSON.parse(t).accessToken;
            i.push(...e), r[n] = e.length;
          } else {
            let e = this.getTokenKeys(n).accessToken;
            i.push(...e), r[n] = e.length;
          }
          if (i.length <= a) throw s;
          this.removeAccessToken(i[a], n, !1);
        } else throw s;
      }
    }
    async setUserData(e, t, n, r, i) {
      let a = [,,,,].fill(0),
        o = [];
      for (let s = 0; s <= 20; s++) try {
        if (await J(this.browserStorage.setUserData.bind(this.browserStorage), Pd, this.logger, this.performanceClient, n)(e, t, n, r, i), s > 0) for (let e = 0; e <= 3; e++) {
          let t = a.slice(0, e).reduce((e, t) => e + t, 0);
          if (t >= s) break;
          let r = s > t + a[e] ? t + a[e] : s;
          s > t && a[e] > 0 && this.removeAccessTokenKeys(o.slice(t, r), n, e);
        }
        break;
      } catch (e) {
        let t = Dp(e);
        if (t.errorCode === `cache_quota_exceeded` && s < 20) {
          if (!o.length) for (let e = 0; e <= 3; e++) {
            let t = this.getTokenKeys(e).accessToken;
            o.push(...t), a[e] = t.length;
          }
          if (o.length <= s) throw t;
          this.removeAccessToken(o[s], n, !1);
        } else throw t;
      }
    }
    getAccount(e, t) {
      this.logger.trace(`1lfvm6`, t);
      let n = this.browserStorage.getUserData(e);
      if (!n) return this.removeAccountKeyFromMap(e, t), null;
      let r = this.validateAndParseJson(n);
      if (!r || !vu(r)) return null;
      let i = Op.toObject({}, r);
      return this.performanceClient.addFields({
        accountCachedBy: d_(i.cachedByApiId)
      }, t), i;
    }
    async setAccount(e, t, n, r) {
      this.logger.trace(`1bz3wr`, t);
      let i = this.generateAccountKey(mu(e)),
        a = Date.now().toString();
      e.lastUpdatedAt = a, e.cachedByApiId = r, await this.setUserData(i, JSON.stringify(e), t, a, n), this.addAccountKeyToMap(i, t), this.performanceClient.addFields({
        kmsi: n
      }, t);
    }
    setAccountKeys(e, t, n = 3) {
      e.length === 0 ? this.removeItem(ry(n)) : this.setItem(ry(n), JSON.stringify(e), t);
    }
    getAccountKeys() {
      return ly(this.browserStorage);
    }
    addAccountKeyToMap(e, t) {
      this.logger.trace(`0rb85k`, t), this.logger.tracePii(`1l9bdo ${e}`, t);
      let n = this.getAccountKeys();
      return n.indexOf(e) === -1 ? (n.push(e), this.setItem(ry(), JSON.stringify(n), t), this.logger.verbose(`0xia39`, t), !0) : (this.logger.verbose(`0161kk`, t), !1);
    }
    removeAccountKeyFromMap(e, t) {
      this.logger.trace(`1jpigu`, t), this.logger.tracePii(`1xzspl ${e}`, t);
      let n = this.getAccountKeys(),
        r = n.indexOf(e);
      r > -1 ? (n.splice(r, 1), this.setAccountKeys(n, t)) : this.logger.trace(`1dytu2`, t);
    }
    removeAccount(e, t) {
      let n = this.getActiveAccount(t);
      n?.homeAccountId === e.homeAccountId && n?.environment === e.environment && this.setActiveAccount(null, t), super.removeAccount(e, t), this.removeAccountKeyFromMap(this.generateAccountKey(e), t), this.browserStorage.getKeys().forEach(t => {
        t.includes(e.homeAccountId) && t.includes(e.environment) && this.browserStorage.removeItem(t);
      });
    }
    removeIdToken(e, t) {
      super.removeIdToken(e, t);
      let n = this.getTokenKeys(),
        r = n.idToken.indexOf(e);
      r > -1 && (this.logger.info(`05udv9`, t), n.idToken.splice(r, 1), this.setTokenKeys(n, t));
    }
    removeAccessToken(e, t, n = !0) {
      super.removeAccessToken(e, t), n && this.removeAccessTokenKeys([e], t);
    }
    removeAccessTokenKeys(e, t, n = 3) {
      this.logger.trace(`17o18n`, t);
      let r = this.getTokenKeys(n),
        i = 0;
      if (e.forEach(e => {
        let t = r.accessToken.indexOf(e);
        t > -1 && (r.accessToken.splice(t, 1), i++);
      }), i > 0) {
        this.logger.info(`15i5d5 ${i}`, t), this.setTokenKeys(r, t, n);
        return;
      }
    }
    removeRefreshToken(e, t) {
      super.removeRefreshToken(e, t);
      let n = this.getTokenKeys(),
        r = n.refreshToken.indexOf(e);
      r > -1 && (this.logger.info(`1f4fq3`, t), n.refreshToken.splice(r, 1), this.setTokenKeys(n, t));
    }
    getTokenKeys(e = 3) {
      return uy(this.clientId, this.browserStorage, e);
    }
    setTokenKeys(e, t, n = 3) {
      if (e.idToken.length === 0 && e.accessToken.length === 0 && e.refreshToken.length === 0) {
        this.removeItem(iy(this.clientId, n));
        return;
      }
      this.setItem(iy(this.clientId, n), JSON.stringify(e), t);
    }
    getIdTokenCredential(e, t) {
      let n = this.browserStorage.getUserData(e);
      if (!n) return this.logger.trace(`1jukz6`, t), this.removeIdToken(e, t), null;
      let r = this.validateAndParseJson(n);
      return !r || !Jd(r) ? (this.logger.trace(`1jukz6`, t), null) : (this.logger.trace(`01ju66`, t), r);
    }
    async setIdTokenCredential(e, t, n) {
      this.logger.trace(`13hjll`, t);
      let r = this.generateCredentialKey(e),
        i = Date.now().toString();
      e.lastUpdatedAt = i, await this.setUserData(r, JSON.stringify(e), t, i, n);
      let a = this.getTokenKeys();
      a.idToken.indexOf(r) === -1 && (this.logger.info(`07jy92`, t), a.idToken.push(r), this.setTokenKeys(a, t));
    }
    getAccessTokenCredential(e, t) {
      let n = this.browserStorage.getUserData(e);
      if (!n) return this.logger.trace(`0bqvx8`, t), this.removeAccessTokenKeys([e], t), null;
      let r = this.validateAndParseJson(n);
      return !r || !qd(r) ? (this.logger.trace(`0bqvx8`, t), null) : (this.logger.trace(`1o81rl`, t), r);
    }
    async setAccessTokenCredential(e, t, n, r) {
      this.logger.trace(`1pondb`, t);
      let i = this.generateCredentialKey(e, r),
        a = Date.now().toString();
      e.lastUpdatedAt = a, await this.setUserData(i, JSON.stringify(e), t, a, n);
      let o = this.getTokenKeys(),
        s = o.accessToken.indexOf(i);
      s !== -1 && o.accessToken.splice(s, 1), this.logger.trace(`1onhey ${s === -1 ? `added to` : `updated in`}`, t), o.accessToken.push(i), this.setTokenKeys(o, t);
    }
    getRefreshTokenCredential(e, t) {
      let n = this.browserStorage.getUserData(e);
      if (!n) return this.logger.trace(`0jlizt`, t), this.removeRefreshToken(e, t), null;
      let r = this.validateAndParseJson(n);
      return !r || !Yd(r) ? (this.logger.trace(`0jlizt`, t), null) : (this.logger.trace(`0nokxi`, t), r);
    }
    async setRefreshTokenCredential(e, t, n) {
      this.logger.trace(`0tcg8d`, t);
      let r = this.generateCredentialKey(e),
        i = Date.now().toString();
      e.lastUpdatedAt = i, await this.setUserData(r, JSON.stringify(e), t, i, n);
      let a = this.getTokenKeys();
      a.refreshToken.indexOf(r) === -1 && (this.logger.info(`0eckjs`, t), a.refreshToken.push(r), this.setTokenKeys(a, t));
    }
    getAppMetadata(e, t) {
      let n = this.browserStorage.getItem(e);
      if (!n) return this.logger.trace(`1q101h`, t), null;
      let r = this.validateAndParseJson(n);
      return !r || !$d(e, r) ? (this.logger.trace(`1q101h`, t), null) : (this.logger.trace(`19pvg2`, t), r);
    }
    setAppMetadata(e, t) {
      this.logger.trace(`0cyma6`, t);
      let n = Qd(e);
      this.setItem(n, JSON.stringify(e), t);
    }
    getServerTelemetry(e, t) {
      let n = this.browserStorage.getItem(e);
      if (!n) return this.logger.trace(`0jk19c`, t), null;
      let r = this.validateAndParseJson(n);
      return !r || !Xd(e, r) ? (this.logger.trace(`0jk19c`, t), null) : (this.logger.trace(`12jguk`, t), r);
    }
    setServerTelemetry(e, t, n) {
      this.logger.trace(`1poh61`, n), this.setItem(e, JSON.stringify(t), n);
    }
    getAuthorityMetadata(e, t) {
      let n = this.internalStorage.getItem(e);
      if (!n) return this.logger.trace(`1r39oe`, t), null;
      let r = this.validateAndParseJson(n);
      return r && ef(e, r) ? (this.logger.trace(`1ohvk3`, t), r) : null;
    }
    getAuthorityMetadataKeys() {
      return this.internalStorage.getKeys().filter(e => this.isAuthorityMetadata(e));
    }
    setWrapperMetadata(e, t) {
      this.internalStorage.setItem(c_.WRAPPER_SKU, e), this.internalStorage.setItem(c_.WRAPPER_VER, t);
    }
    getWrapperMetadata() {
      return [this.internalStorage.getItem(c_.WRAPPER_SKU) || ``, this.internalStorage.getItem(c_.WRAPPER_VER) || ``];
    }
    setAuthorityMetadata(e, t, n) {
      this.logger.trace(`07w8n2`, n), this.internalStorage.setItem(e, JSON.stringify(t));
    }
    getActiveAccount(e) {
      let t = this.generateCacheKey(Yc.ACTIVE_ACCOUNT_FILTERS),
        n = this.browserStorage.getItem(t);
      if (!n) return this.logger.trace(`08gw0e`, e), null;
      let r = this.validateAndParseJson(n);
      return r ? (this.logger.trace(`1t3ch7`, e), this.getAccountInfoFilteredBy({
        homeAccountId: r.homeAccountId,
        localAccountId: r.localAccountId,
        tenantId: r.tenantId
      }, e)) : (this.logger.trace(`0me1up`, e), null);
    }
    setActiveAccount(e, t) {
      let n = this.generateCacheKey(Yc.ACTIVE_ACCOUNT_FILTERS);
      if (e) {
        this.logger.verbose(`0rsj80`, t);
        let r = {
          homeAccountId: e.homeAccountId,
          localAccountId: e.localAccountId,
          tenantId: e.tenantId
        };
        this.setItem(n, JSON.stringify(r), t);
      } else this.logger.verbose(`1bp5z5`, t), this.browserStorage.removeItem(n);
      this.eventHandler.emitEvent(gy.ACTIVE_ACCOUNT_CHANGED, t);
    }
    getThrottlingCache(e, t) {
      let n = this.browserStorage.getItem(e);
      if (!n) return this.logger.trace(`1h4wa6`, t), null;
      let r = this.validateAndParseJson(n);
      return !r || !Zd(e, r) ? (this.logger.trace(`1h4wa6`, t), null) : (this.logger.trace(`0of6n8`, t), r);
    }
    setThrottlingCache(e, t, n) {
      this.logger.trace(`0wfgh6`, n), this.setItem(e, JSON.stringify(t), n);
    }
    getTemporaryCache(e, t, n) {
      this.logger.trace(`1ordf8`, t);
      let r = n ? this.generateCacheKey(e) : e;
      return this.temporaryCacheStorage.getItem(r);
    }
    setTemporaryCache(e, t, n) {
      let r = n ? this.generateCacheKey(e) : e;
      this.temporaryCacheStorage.setItem(r, t);
    }
    removeItem(e) {
      this.browserStorage.removeItem(e);
    }
    removeTemporaryItem(e) {
      this.temporaryCacheStorage.removeItem(e);
    }
    getKeys() {
      return this.browserStorage.getKeys();
    }
    clear(e) {
      this.removeAllAccounts(e), this.removeAppMetadata(e), this.temporaryCacheStorage.getKeys().forEach(e => {
        (e.indexOf(`msal`) !== -1 || e.indexOf(this.clientId) !== -1) && this.removeTemporaryItem(e);
      }), this.browserStorage.getKeys().forEach(e => {
        (e.indexOf(`msal`) !== -1 || e.indexOf(this.clientId) !== -1) && this.browserStorage.removeItem(e);
      }), this.internalStorage.clear();
    }
    generateCacheKey(e) {
      return Ju.startsWith(e, `msal`) ? e : `${Yv}.${this.clientId}.${e}`;
    }
    generateCredentialKey(e, t) {
      let n = e.credentialType === al.REFRESH_TOKEN && e.familyId || e.clientId,
        r = e.tokenType && e.tokenType.toLowerCase() !== pl.BEARER.toLowerCase() ? e.tokenType.toLowerCase() : ``,
        i = [`${Yv}.3`, e.homeAccountId, e.environment, e.credentialType, n, e.realm || ``, e.target || ``, r];
      return e.additionalCacheKeyComponents && Object.keys(e.additionalCacheKeyComponents).length > 0 && t && i.push(t), i.join(`|`).toLowerCase();
    }
    generateAccountKey(e) {
      let t = e.homeAccountId.split(`.`)[1];
      return [`${Yv}.3`, e.homeAccountId, e.environment, t || e.tenantId || ``].join(`|`).toLowerCase();
    }
    resetRequestCache(e) {
      this.logger.trace(`0h0ynu`, e), this.removeTemporaryItem(this.generateCacheKey(s_.REQUEST_PARAMS)), this.removeTemporaryItem(this.generateCacheKey(s_.VERIFIER)), this.removeTemporaryItem(this.generateCacheKey(s_.ORIGIN_URI)), this.removeTemporaryItem(this.generateCacheKey(s_.URL_HASH)), this.removeTemporaryItem(this.generateCacheKey(s_.NATIVE_REQUEST)), this.setInteractionInProgress(!1, void 0);
    }
    cacheAuthorizeRequest(e, t, n) {
      this.logger.trace(`1tzef5`, t);
      let r = b_(JSON.stringify(e));
      if (this.setTemporaryCache(s_.REQUEST_PARAMS, r, !0), n) {
        let e = b_(n);
        this.setTemporaryCache(s_.VERIFIER, e, !0);
      }
    }
    getCachedRequest(e) {
      this.logger.trace(`0uen20`, e);
      let t = this.getTemporaryCache(s_.REQUEST_PARAMS, e, !0);
      if (!t) throw Y(Cg, ``);
      let n = this.getTemporaryCache(s_.VERIFIER, e, !0),
        r,
        i = ``;
      try {
        r = JSON.parse($g(t)), n && (i = $g(n));
      } catch (n) {
        throw this.logger.errorPii(`0ewsey ${t}`, e), this.logger.error(`0tvdic ${n}`, e), Y(wg, ``);
      }
      return [r, i];
    }
    getCachedNativeRequest() {
      this.logger.trace(`1yxcdm`, ``);
      let e = this.getTemporaryCache(s_.NATIVE_REQUEST, ``, !0);
      return e ? this.validateAndParseJson(e) || (this.logger.error(`0rrkip`, ``), null) : (this.logger.trace(`0mnxd4`, ``), null);
    }
    isInteractionInProgress(e) {
      let t = this.getInteractionInProgress()?.clientId;
      return e ? t === this.clientId : !!t;
    }
    getInteractionInProgress() {
      let e = `${Yv}.${s_.INTERACTION_STATUS_KEY}`,
        t = this.getTemporaryCache(e, ``, !1);
      try {
        return t ? JSON.parse(t) : null;
      } catch {
        return this.logger.error(`0jjyys`, ``), this.removeTemporaryItem(e), this.resetRequestCache(``), _v(window), null;
      }
    }
    setInteractionInProgress(e, t = o_.SIGNIN, n = !1, r = ``) {
      let i = `${Yv}.${s_.INTERACTION_STATUS_KEY}`;
      if (e) {
        let e = this.getInteractionInProgress();
        if (e) {
          if (n) this.logger.warning(`1pmscr ${e.clientId} ${e.type}`, r), Sv(this.logger, r), this.removeTemporaryItem(i);else throw Y(dg, ``);
        }
        this.setTemporaryCache(i, JSON.stringify({
          clientId: this.clientId,
          type: t
        }), !1);
      } else !e && this.getInteractionInProgress()?.clientId === this.clientId && this.removeTemporaryItem(i);
    }
    async hydrateCache(e, t) {
      let n = Ud(e.account.homeAccountId, e.account.environment, e.idToken, this.clientId, e.tenantId),
        r = Wd(e.account.homeAccountId, e.account.environment, e.accessToken, this.clientId, e.tenantId, e.scopes.join(` `), e.expiresOn ? Rd(e.expiresOn) : 0, e.extExpiresOn ? Rd(e.extExpiresOn) : 0, $g, t.correlationId || ``, void 0, e.tokenType, void 0, t.sshKid);
      t.resource && (r.resource = t.resource);
      let i = {
        idToken: n,
        accessToken: r
      };
      return this.saveCacheRecord(i, e.correlationId, ou(au(e.idToken, $g, e.correlationId)), l_.hydrateCache);
    }
    async saveCacheRecord(e, t, n, r, i) {
      try {
        await super.saveCacheRecord(e, t, n, r, i);
      } catch (e) {
        if (e instanceof Ep && this.performanceClient && t) try {
          let e = this.getTokenKeys();
          this.performanceClient.addFields({
            cacheRtCount: e.refreshToken.length,
            cacheIdCount: e.idToken.length,
            cacheAtCount: e.accessToken.length
          }, t);
        } catch {}
        throw e;
      }
    }
  };
function Sy(e, t, n, r) {
  try {
    switch (t) {
      case i_.LocalStorage:
        return new my(e, n, r);
      case i_.SessionStorage:
        return new hy();
      case i_.MemoryStorage:
    }
  } catch (e) {
    n.error(e, ``);
  }
  return new Iv();
}
var Cy = (e, t, n, r, i, a = pp) => new xy(e, {
  cacheLocation: i_.MemoryStorage,
  cacheRetentionDays: 5
}, fp, t, n, r, i, a);
function wy(e, t, n, r, i) {
  return e.verbose(`1yd030`, r), n ? t.getAllAccounts(i, r) : [];
}
function Ty(e, t, n, r) {
  t.trace(`0u7b90`, r);
  let i = n.getAccountInfoFilteredBy(e, r);
  return i ? (t.verbose(`0btgll`, r), i) : (t.verbose(`0ltaj5`, r), null);
}
function Ey(e, t, n) {
  t.setActiveAccount(e, n);
}
function Dy(e, t) {
  return e.getActiveAccount(t);
}
var Oy = `msal.broadcast.event`,
  ky = class {
    constructor(e) {
      this.eventCallbacks = new Map(), this.logger = e || new xp({}, `@azure/msal-browser`, `5.20.0`), typeof BroadcastChannel < `u` && (this.broadcastChannel = new BroadcastChannel(Oy)), this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    addEventCallback(e, t, n) {
      if (typeof window < `u`) {
        let r = n || Pv();
        return this.eventCallbacks.has(r) ? (this.logger.error(`1578i0 ${r}`, ``), null) : (this.eventCallbacks.set(r, [e, t || []]), this.logger.verbose(`1cnec4 ${r}`, ``), r);
      }
      return null;
    }
    removeEventCallback(e) {
      this.eventCallbacks.delete(e), this.logger.verbose(`12zotd ${e}`, ``);
    }
    emitEvent(e, t, n, r, i) {
      let a = {
        eventType: e,
        interactionType: n || null,
        payload: r || null,
        error: i || null,
        correlationId: t,
        timestamp: Date.now()
      };
      switch (e) {
        case gy.LOGIN_SUCCESS:
        case gy.LOGOUT_SUCCESS:
        case gy.ACTIVE_ACCOUNT_CHANGED:
          this.broadcastChannel?.postMessage(a);
      }
      this.invokeCallbacks(a);
    }
    invokeCallbacks(e) {
      this.eventCallbacks.forEach(([t, n], r) => {
        (n.length === 0 || n.includes(e.eventType)) && (this.logger.verbose(`15jpwk ${r} ${e.eventType}`, ``), t.apply(null, [e]));
      });
    }
    invokeCrossTabCallbacks(e) {
      let t = e.data;
      this.invokeCallbacks(t);
    }
    subscribeCrossTab() {
      this.broadcastChannel?.addEventListener(`message`, this.invokeCrossTabCallbacks);
    }
    unsubscribeCrossTab() {
      this.broadcastChannel?.removeEventListener(`message`, this.invokeCrossTabCallbacks);
    }
  },
  Ay = class {
    constructor(e, t, n, r, i, a, o, s, c, l) {
      this.config = e, this.browserStorage = t, this.browserCrypto = n, this.networkClient = this.config.system.networkClient, this.eventHandler = i, this.navigationClient = a, this.platformAuthProvider = c, this.correlationId = s, this.logger = r.clone(_y, vy), this.performanceClient = o, this.tokenBindingKeyManager = l || new Rv(this.logger, this.performanceClient);
    }
  };
function jy(e, t, n, r) {
  n.verbose(`0bd1la`, r);
  let i = e || t || ``;
  return Yu.getAbsoluteUrl(i, wv(), r);
}
function My(e, t, n, r, i, a, o = !0) {
  return i.verbose(`1p12tq`, n), o ? new Ym({
    clientId: t,
    correlationId: n,
    apiId: e,
    forceRefresh: a || !1,
    wrapperSKU: r.getWrapperMetadata()[0],
    wrapperVer: r.getWrapperMetadata()[1]
  }, r) : (i.verbose(`0tajnr`, n), new Xm());
}
async function Ny(e, t, n, r, i, a, o, s, c) {
  let l = s && s.hasOwnProperty(`instance_aware`) ? s.instance_aware : void 0,
    u = {
      protocolMode: e.system.protocolMode,
      OIDCOptions: e.auth.OIDCOptions,
      knownAuthorities: e.auth.knownAuthorities,
      cloudDiscoveryMetadata: e.auth.cloudDiscoveryMetadata,
      authorityMetadata: e.auth.authorityMetadata
    },
    d = a || e.auth.authority,
    f = l?.length ? l === `true` : e.auth.instanceAware,
    p = c && f ? e.auth.authority.replace(Yu.getDomainFromUrl(d, t), c.environment) : d,
    m = sf.generateAuthority(p, o || e.auth.azureCloudOptions),
    h = await J(df, Mh, i, n, t)(m, e.system.networkClient, r, u, i, t, n);
  if (c && !h.isAlias(c.environment)) throw xu(zu, t);
  return h;
}
async function Py(e, t, n, r, i) {
  if (i) try {
    e.removeAccount(i, r), n.verbose(`0s4z6h`, r);
  } catch {
    n.error(`0mgg1d`, r);
  } else try {
    n.verbose(`0zj631`, r), e.clear(r), await t.clearKeystore(r);
  } catch {
    n.error(`12ih0c`, r);
  }
}
var Fy = new Set([pl.BEARER, pl.POP, pl.DPOP, pl.SSH]);
function Iy(e, t) {
  if (!e.sshJwk) throw xu(Pu, t);
  if (!e.sshKid) throw xu(Fu, t);
}
function Ly(e, t) {
  if (!e.resourceRequestMethod?.trim() || !e.resourceRequestUri?.trim()) throw xu(Ku, t);
}
async function Ry(e, t, n, r) {
  switch (e.authenticationScheme) {
    case pl.DPOP:
      return e.platformBroker ? {} : e.dpopJkt ? {
        dpopJkt: e.dpopJkt
      } : {
        dpopJkt: await t.provisionTokenBindingKey({
          tokenBindingKeyType: pl.DPOP.toLowerCase(),
          tokenBindingKeyAlgorithm: dp.ES256,
          correlationId: e.correlationId
        })
      };
    case pl.POP:
      if (!e.platformBroker) return {};
      let i = new zv(n, r);
      if (e.popKid) return {
        reqCnf: i.encodeKid(e.popKid)
      };
      let a = new em(i, t, r);
      return {
        reqCnf: (await J(a.generateCnf.bind(a), Sd, n, r, e.correlationId)(e, n)).reqCnfString
      };
    default:
      return {};
  }
}
async function zy(e, t, n, r, i) {
  let a = e.authority || t.auth.authority,
    o = [...(e && e.scopes || [])],
    s = {
      ...e,
      correlationId: e.correlationId,
      authority: a,
      scopes: o
    };
  if (!s.authenticationScheme) s.authenticationScheme = pl.BEARER, r.verbose(`1l4fwv`, i);else {
    if (!Fy.has(s.authenticationScheme)) throw xu(Iu, i);
    switch (s.authenticationScheme) {
      case pl.SSH:
        Iy(e, i);
        break;
      case pl.DPOP:
        Ly(e, i);
    }
    r.verbose(`1ecmns ${s.authenticationScheme}`, i);
  }
  return s;
}
async function By(e, t, n, r, i) {
  let a = await J(zy, hh, i, r, e.correlationId)(e, n, r, i, e.correlationId);
  return {
    ...e,
    ...a,
    account: t,
    forceRefresh: e.forceRefresh || !1
  };
}
function Vy(e, t) {
  let n,
    r = e.httpMethod;
  if (t === pu.EAR) {
    if (r && r !== Gc.POST) throw xu(Bu, ``);
    n = Gc.POST;
  } else n = r || Gc.GET;
  return n;
}
var Hy = class extends Ay {
  initializeLogoutRequest(e) {
    this.logger.verbose(`0546u4`, this.correlationId);
    let t = {
      correlationId: this.correlationId,
      ...e
    };
    if (e) {
      if (e.logoutHint) this.logger.verbose(`12k4l4`, this.correlationId);else if (e.account) {
        let n = e.account.loginHint || this.getLogoutHintFromIdTokenClaims(e.account);
        n && (this.logger.verbose(`0d7s8p`, this.correlationId), t.logoutHint = n);
      } else this.logger.verbose(`0pdtc3`, this.correlationId);
    } else this.logger.verbose(`07ndze`, this.correlationId);
    return !e || e.postLogoutRedirectUri !== null ? e && e.postLogoutRedirectUri ? (this.logger.verbose(`1vamm6`, t.correlationId), t.postLogoutRedirectUri = Yu.getAbsoluteUrl(e.postLogoutRedirectUri, wv(), t.correlationId)) : this.config.auth.postLogoutRedirectUri === null ? this.logger.verbose(`15m5g7`, t.correlationId) : this.config.auth.postLogoutRedirectUri ? (this.logger.verbose(`1f4xlz`, t.correlationId), t.postLogoutRedirectUri = Yu.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, wv(), t.correlationId)) : (this.logger.verbose(`17s5rf`, t.correlationId), t.postLogoutRedirectUri = Yu.getAbsoluteUrl(wv(), wv(), t.correlationId)) : this.logger.verbose(`0ljv63`, t.correlationId), t;
  }
  getLogoutHintFromIdTokenClaims(e) {
    let t = e.idTokenClaims;
    if (t) {
      if (t.login_hint) return this.logger.verbose(`0u5bmc`, this.correlationId), t.login_hint;
      this.logger.verbose(`0mvp54`, this.correlationId);
    } else this.logger.verbose(`1e7bdp`, this.correlationId);
    return null;
  }
  async createAuthCodeClient(e) {
    return new Fm(await J(this.getClientConfiguration.bind(this), Sh, this.logger, this.performanceClient, this.correlationId)(e), this.performanceClient);
  }
  async getClientConfiguration(e) {
    let {
        serverTelemetryManager: t,
        requestAuthority: n,
        requestAzureCloudOptions: r,
        requestExtraQueryParameters: i,
        account: a
      } = e,
      o = e.authority || (await J(Ny, `standardInteractionClientGetDiscoveredAuthority`, this.logger, this.performanceClient, this.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, n, r, i, a)),
      s = this.config.system.loggerOptions;
    return {
      authOptions: {
        clientId: this.config.auth.clientId,
        authority: o,
        clientCapabilities: this.config.auth.clientCapabilities,
        redirectUri: this.config.auth.redirectUri,
        isMcp: this.config.auth.isMcp
      },
      systemOptions: {
        tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
        preventCorsPreflight: !0
      },
      loggerOptions: {
        loggerCallback: s.loggerCallback,
        piiLoggingEnabled: s.piiLoggingEnabled,
        logLevel: s.logLevel,
        correlationId: this.correlationId
      },
      cryptoInterface: this.browserCrypto,
      tokenBindingKeyManager: this.tokenBindingKeyManager,
      networkInterface: this.networkClient,
      storageInterface: this.browserStorage,
      serverTelemetryManager: t,
      libraryInfo: {
        sku: t_.MSAL_SKU,
        version: vy,
        cpu: ``,
        os: ``
      },
      telemetry: this.config.telemetry
    };
  }
};
async function Uy(e, t, n, r, i, a, o, s) {
  let c = jy(e.redirectUri, n.auth.redirectUri, a, s);
  new URL(c).origin !== new URL(window.location.href).origin && (a.warning(`08qbvw`, s), o.addFields({
    isRedirectUriCrossOrigin: !0
  }, s));
  let l = {
      interactionType: t
    },
    u = ym(r, e && e.state || ``, l, s),
    d = {
      ...(await J(zy, hh, a, o, s)({
        ...e,
        correlationId: s
      }, n, o, a, s)),
      redirectUri: c,
      state: u,
      nonce: e.nonce || X_(),
      responseMode: n.auth.OIDCOptions.responseMode
    },
    f = {
      ...d,
      httpMethod: Vy(d, n.system.protocolMode)
    };
  if (e.loginHint || e.sid) return f;
  let p = e.account || i.getActiveAccount(s);
  return p && (a.verbose(`1eqlb3`, s), a.verbosePii(`0tf99t ${p.homeAccountId}`, s), f.account = p), f;
}
function Wy(e, t, n, r) {
  let i = {
      id: t,
      ...n
    },
    a = new URL(e, window.location.origin);
  if (a.origin !== window.location.origin) throw Y(bg, r, `popup_relay_cross_origin`);
  let o = new URLSearchParams();
  return o.set(`req`, JSON.stringify(i)), a.hash = o.toString(), a.toString();
}
async function Gy(e, t, n, r, i) {
  return new Promise((a, o) => {
    let s = n.correlationId;
    t.verbose(`1d05g9`, s), i.addFields({
      redirectBridgeTimeoutMs: e
    }, s);
    let {
        libraryState: c
      } = xm($g, n.state || ``, s),
      l = c.id,
      u = window.location.origin,
      d = !1,
      f = () => {
        window.removeEventListener(`message`, p), clearTimeout(m), clearInterval(h);
      },
      p = e => {
        if (e.origin !== u || e.source !== r) return;
        let t = e.data;
        t && t.type === `msal:popup-relay-response:v1` && t.id === l && (d || (d = !0, f(), t.error ? o(Y(t.error, s)) : t.payload ? a(t.payload) : o(Y(gg, s))));
      };
    window.addEventListener(`message`, p);
    let m = window.setTimeout(() => {
        d || (d = !0, f(), o(Y(Zg, s, `popup_relay_timeout`)));
      }, e),
      h = window.setInterval(() => {
        r.closed && !d && (d = !0, f(), o(Y(hg, s)));
      }, 500);
  });
}
function Ky(e, t, n) {
  if (!t) return null;
  try {
    return xm(e.base64Decode, t, n).libraryState.meta;
  } catch {
    throw q(Nl, n);
  }
}
function qy(e, t, n, r) {
  let i = sp(e);
  if (!i) throw op(e) ? (n.error(`13pl0s ${t} ${t}`, r), n.errorPii(`1097vx ${t} ${e}`, r), Y(cg, r)) : (n.error(`18h0l1 ${t} ${t}`, r), Y(og, r));
  return i;
}
function Jy(e, t, n, r) {
  if (!e.state) throw Y(sg, r);
  let i = Ky(t, e.state, r);
  if (!i) throw Y(lg, r);
  if (i.interactionType !== n) throw Y(ug, r);
}
var Yy = class {
    constructor(e, t, n, r, i) {
      this.authModule = e, this.browserStorage = t, this.authCodeRequest = n, this.logger = r, this.performanceClient = i;
    }
    async handleCodeResponse(e, t, n) {
      let r;
      try {
        r = Rm(e, t.state, t.correlationId);
      } catch (e) {
        throw e instanceof vm && e.subError === `user_cancelled` ? Y(hg, t.correlationId) : e;
      }
      return J(this.handleCodeResponseFromServer.bind(this), vd, this.logger, this.performanceClient, t.correlationId)(r, t, n);
    }
    async handleCodeResponseFromServer(e, t, n, r = !0) {
      if (this.logger.trace(`0mf2hb`, t.correlationId), this.authCodeRequest.code = e.code, r && (e.nonce = t.nonce || void 0), e.state = t.state, e.client_info) this.authCodeRequest.clientInfo = e.client_info;else {
        let e = this.createCcsCredentials(t);
        e && (this.authCodeRequest.ccsCredential = e);
      }
      return await J(this.authModule.acquireToken.bind(this.authModule), Ah, this.logger, this.performanceClient, t.correlationId)(this.authCodeRequest, n, e);
    }
    createCcsCredentials(e) {
      return e.account ? {
        credential: e.account.homeAccountId,
        type: wm.HOME_ACCOUNT_ID
      } : e.loginHint ? {
        credential: e.loginHint,
        type: wm.UPN
      } : null;
    }
  },
  Xy = `ContentError`,
  Zy = `PageException`,
  Qy = `user_switch`,
  $y = `USER_INTERACTION_REQUIRED`,
  eb = `USER_CANCEL`,
  tb = `NO_NETWORK`,
  nb = `ACCOUNT_UNAVAILABLE`,
  rb = `UI_NOT_ALLOWED`,
  ib = -2147186943,
  ab = class e extends Sl {
    constructor(t, n, r, i) {
      super(t, n, r || $h(t)), Object.setPrototypeOf(this, e.prototype), this.name = `NativeAuthError`, this.ext = i;
    }
  };
function ob(e) {
  if (e.ext && e.ext.status && e.ext.status === `DISABLED` || e.ext && e.ext.error && e.ext.error === ib) return !0;
  switch (e.errorCode) {
    case Xy:
    case Zy:
      return !0;
    default:
      return !1;
  }
}
function sb(e, t, n, r) {
  let i;
  if (r && r.status) {
    switch (r.status) {
      case nb:
        i = _m(um, t, $h(e));
        break;
      case $y:
        i = new hm(e, t, n);
        break;
      case eb:
        i = Y(hg, t);
        break;
      case tb:
        i = Y(Dg, t);
        break;
      case rb:
        i = _m(fm, t);
        break;
      default:
        i = new ab(e, t, n, r);
    }
    return i;
  }
  return i = new ab(e, t, n, r), i;
}
var cb = class extends Hy {
    async acquireToken(e) {
      let t = My(l_.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
        n = new Zm(await J(this.getClientConfiguration.bind(this), Sh, this.logger, this.performanceClient, this.correlationId)({
          serverTelemetryManager: t,
          requestAuthority: e.authority,
          requestAzureCloudOptions: e.azureCloudOptions,
          account: e.account
        }), this.performanceClient);
      this.logger.verbose(`0wa871`, this.correlationId);
      try {
        let t = (await J(n.acquireCachedToken.bind(n), wh, this.logger, this.performanceClient, e.correlationId)(e))[0];
        return this.performanceClient.addFields({
          fromCache: !0
        }, e.correlationId), t;
      } catch (e) {
        throw e instanceof eg && e.errorCode === `crypto_key_not_found` && this.logger.verbose(`06wena`, this.correlationId), e;
      }
    }
    logout(e) {
      this.logger.verbose(`1rkurh`, this.correlationId);
      let t = this.initializeLogoutRequest(e);
      return Py(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, t.account);
    }
  },
  lb = class extends Ay {
    constructor(e, t, n, r, i, a, o, s, c, l, u, d, f) {
      super(e, t, n, r, i, a, s, d, c, f), this.apiId = o, this.accountId = l, this.platformAuthProvider = c, this.nativeStorageManager = u, this.silentCacheClient = new cb(e, this.nativeStorageManager, n, r, i, a, s, d, c, this.tokenBindingKeyManager);
      let p = this.platformAuthProvider.getExtensionName();
      this.skus = Ym.makeExtraSkuString({
        libraryName: t_.MSAL_SKU,
        libraryVersion: vy,
        extensionName: p,
        extensionVersion: this.platformAuthProvider.getExtensionVersion()
      });
    }
    addRequestSKUs(e) {
      e.extraParameters = {
        ...e.extraParameters,
        [_c]: this.skus
      };
    }
    async acquireToken(e, t) {
      this.logger.trace(`03qeos`, this.correlationId);
      let n = this.performanceClient.startMeasurement(dh, this.correlationId),
        r = Ld(),
        i = My(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
        a;
      try {
        a = await this.initializePlatformRequest(e);
      } catch (e) {
        throw n.add({
          isNativeBroker: !1
        }), n.end({
          success: !1
        }, e), e;
      }
      try {
        let e = await this.acquireTokensFromCache(this.accountId, a);
        return n.add({
          isNativeBroker: !1
        }), n.end({
          success: !0,
          fromCache: !0
        }), e;
      } catch (e) {
        if (t === g_.AccessToken) throw this.logger.info(`0eitbc`, this.correlationId), n.add({
          isNativeBroker: !1
        }), n.end({
          success: !1
        }), e;
        this.logger.info(`0957j1`, this.correlationId);
      }
      try {
        let t = await this.platformAuthProvider.sendMessage(a),
          o = await this.handleNativeResponse(t, a, r, e.storeInCache);
        return n.end({
          success: !0,
          requestId: o.requestId
        }), i.clearNativeBrokerErrorCode(), o;
      } catch (e) {
        throw e instanceof ab && i.setNativeBrokerErrorCode(e.errorCode), n.end({
          success: !1
        }, e), this.setBrokerErrorTelemetry(e), e;
      }
    }
    setBrokerErrorTelemetry(e) {
      e instanceof Sl && this.performanceClient.addFields({
        isNativeBroker: !0,
        brokerErrorName: e.name,
        brokerErrorCode: e.errorCode
      }, this.correlationId);
    }
    createSilentCacheRequest(e, t) {
      let n = {
        authority: e.authority,
        correlationId: this.correlationId,
        scopes: ff.fromString(e.scope, this.correlationId).asArray(),
        account: t,
        forceRefresh: !1
      };
      return e.attributeTokens && (n.attributeTokens = e.attributeTokens.split(` `)), n;
    }
    async acquireTokensFromCache(e, t) {
      if (!e) throw this.logger.warning(`1ndf3e`, this.correlationId), q(Gl, this.correlationId);
      let n = this.browserStorage.getBaseAccountInfo({
        nativeAccountId: e
      }, this.correlationId);
      if (!n) throw q(Gl, this.correlationId);
      try {
        let e = this.createSilentCacheRequest(t, n),
          r = await this.silentCacheClient.acquireToken(e),
          i = this.browserStorage.getIdToken(n, this.correlationId, this.browserStorage.getTokenKeys(), n.tenantId),
          a = au(i?.secret || ``, $g, this.correlationId),
          o = uu(n, void 0, a, i?.secret);
        return {
          ...r,
          idToken: i?.secret || ``,
          idTokenClaims: a,
          account: o
        };
      } catch (e) {
        throw e;
      }
    }
    async acquireTokenRedirect(e, t, n) {
      this.logger.trace(`0luikq`, this.correlationId);
      let r = await this.initializePlatformRequest(e),
        i = n?.navigateToLoginRequestUrl ?? !0;
      try {
        await this.platformAuthProvider.sendMessage(r);
      } catch (e) {
        if (e instanceof ab && (My(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled).setNativeBrokerErrorCode(e.errorCode), ob(e))) throw this.setBrokerErrorTelemetry(e), e;
      }
      this.browserStorage.setTemporaryCache(s_.NATIVE_REQUEST, JSON.stringify({
        ...r,
        storeInCache: e.storeInCache
      }), !0);
      let a = {
          apiId: l_.acquireTokenRedirect,
          timeout: this.config.system.redirectNavigationTimeout,
          noHistory: !1
        },
        o = i ? Yu.getAbsoluteUrl(e.redirectStartPage || window.location.href, wv(), this.correlationId) : jy(e.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
      t.end({
        success: !0
      }), await this.navigationClient.navigateExternal(o, a);
    }
    async handleRedirectPromise() {
      if (this.logger.trace(`1c5lhw`, this.correlationId), !this.browserStorage.isInteractionInProgress(!0)) return this.logger.info(`0le6uv`, this.correlationId), null;
      let e = this.browserStorage.getCachedNativeRequest();
      if (!e) return this.logger.verbose(`0a6zjb`, this.correlationId), this.performanceClient?.addFields({
        errorCode: `no_cached_request`
      }, this.correlationId), null;
      let {
        prompt: t,
        storeInCache: n,
        ...r
      } = e;
      t && this.logger.verbose(`0ac34v`, this.correlationId), this.browserStorage.removeItem(this.browserStorage.generateCacheKey(s_.NATIVE_REQUEST));
      let i = Ld();
      try {
        this.logger.verbose(`003x5a`, this.correlationId);
        let e = await this.platformAuthProvider.sendMessage(r),
          t = await this.handleNativeResponse(e, r, i, n);
        return My(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled).clearNativeBrokerErrorCode(), t;
      } catch (e) {
        throw this.setBrokerErrorTelemetry(e), e;
      }
    }
    logout() {
      return this.logger.trace(`0u2sjm`, this.correlationId), Promise.reject(`Logout not implemented yet`);
    }
    async handleNativeResponse(e, t, n, r) {
      this.logger.trace(`1bojln`, this.correlationId);
      let i = au(e.id_token, $g, this.correlationId),
        a = this.createHomeAccountIdentifier(e, i),
        o = this.browserStorage.getAccountInfoFilteredBy({
          nativeAccountId: t.accountId
        }, this.correlationId)?.homeAccountId;
      if (t.extraParameters?.child_client_id && e.account.id !== t.accountId) this.logger.info(`1ub1in`, this.correlationId);else if (a !== o && e.account.id !== t.accountId) throw sb(Qy, this.correlationId);
      let s = await Ny(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, t.authority),
        c = Cm(this.browserStorage, s, a, $g, this.correlationId, i, e.client_info, s.getPreferredCache(), i.tid, void 0, e.account.id, this.logger, this.performanceClient);
      e.expires_in = Number(e.expires_in);
      let l = await this.generateAuthenticationResult(e, t, i, c, s.canonicalAuthority, n);
      return await this.cacheAccount(c, ou(i)), await this.cacheNativeTokens(e, t, a, i, l.tenantId, n, s.getPreferredCache(), r), l;
    }
    createHomeAccountIdentifier(e, t) {
      return _u(e.client_info || ``, du.Default, this.logger, this.browserCrypto, this.correlationId, t);
    }
    generateScopes(e, t) {
      return t ? ff.fromString(t, this.correlationId) : ff.fromString(e, this.correlationId);
    }
    async generatePopAccessToken(e, t) {
      if (t.tokenType === pl.POP && t.signPopToken) {
        if (e.shr) return this.logger.trace(`0coqhu`, this.correlationId), e.shr;
        let n = new em(this.browserCrypto, this.tokenBindingKeyManager, this.performanceClient),
          r = {
            resourceRequestMethod: t.resourceRequestMethod,
            resourceRequestUri: t.resourceRequestUri,
            shrClaims: t.shrClaims,
            shrNonce: t.shrNonce,
            correlationId: this.correlationId
          };
        if (!t.keyId) throw q($l, this.correlationId);
        return n.signPopToken(e.access_token, t.keyId, r);
      }
      return e.access_token;
    }
    async generateAuthenticationResult(e, t, n, r, i, a) {
      let o = this.addTelemetryFromNativeResponse(e.properties.MATS),
        s = this.generateScopes(t.scope, e.scope),
        c = e.account.properties || {},
        l = c.UID || n.oid || n.sub || ``,
        u = c.TenantId || n.tid || ``,
        d = uu(mu(r), void 0, n, e.id_token);
      if (d.nativeAccountId !== e.account.id) {
        d.nativeAccountId = e.account.id;
        let t = u || d.tenantId,
          n = d.tenantProfiles?.get(t);
        n && (n.nativeAccountId = e.account.id);
      }
      let f = await this.generatePopAccessToken(e, t),
        p = t.tokenType === pl.POP ? pl.POP : pl.BEARER;
      return {
        authority: i,
        uniqueId: l,
        tenantId: u,
        scopes: s.asArray(),
        account: d,
        idToken: e.id_token,
        idTokenClaims: n,
        accessToken: f,
        fromCache: o ? this.isResponseFromCache(o) : !1,
        expiresOn: zd(a + e.expires_in),
        tokenType: p,
        correlationId: this.correlationId,
        state: e.state,
        fromPlatformBroker: !0,
        ...(t.extraParameters?.resource && {
          resource: t.extraParameters.resource
        })
      };
    }
    async cacheAccount(e, t) {
      await this.browserStorage.setAccount(e, this.correlationId, t, this.apiId), this.browserStorage.removeAccountContext(mu(e), this.correlationId);
    }
    async cacheNativeTokens(e, t, n, r, i, a, o, s) {
      let c = Ud(n, o, e.id_token || ``, t.clientId, r.tid || ``),
        l = a + (t.tokenType === pl.POP ? 240 : (typeof e.expires_in == `string` ? parseInt(e.expires_in, 10) : e.expires_in) || 0),
        u = this.generateScopes(e.scope, t.scope),
        d = t.attributeTokens ? {
          attribute_tokens: t.attributeTokens
        } : void 0,
        f = Wd(n, o, e.access_token, t.clientId, r.tid || i, u.printScopes(), l, 0, $g, t.correlationId, void 0, t.tokenType, void 0, t.keyId, d);
      c && s?.idToken !== !1 && (await this.browserStorage.setIdTokenCredential(c, this.correlationId, ou(r)));
      let p = {
        accessToken: f
      };
      return this.nativeStorageManager.saveCacheRecord(p, this.correlationId, ou(r), this.apiId, s);
    }
    getExpiresInValue(e, t) {
      return e === pl.POP ? 240 : (typeof t == `string` ? parseInt(t, 10) : t) || 0;
    }
    addTelemetryFromNativeResponse(e) {
      let t = this.getMATSFromResponse(e);
      return t ? (this.performanceClient.addFields({
        extensionId: this.platformAuthProvider.getExtensionId(),
        extensionVersion: this.platformAuthProvider.getExtensionVersion(),
        matsBrokerVersion: t.broker_version,
        matsAccountJoinOnStart: t.account_join_on_start,
        matsAccountJoinOnEnd: t.account_join_on_end,
        matsDeviceJoin: t.device_join,
        matsPromptBehavior: t.prompt_behavior,
        matsApiErrorCode: t.api_error_code,
        matsUiVisible: t.ui_visible,
        matsSilentCode: t.silent_code,
        matsSilentBiSubCode: t.silent_bi_sub_code,
        matsSilentMessage: t.silent_message,
        matsSilentStatus: t.silent_status,
        matsHttpStatus: t.http_status,
        matsHttpEventCount: t.http_event_count
      }, this.correlationId), t) : null;
    }
    getMATSFromResponse(e) {
      if (e) try {
        return JSON.parse(e);
      } catch {
        this.logger.error(`0b3l57`, this.correlationId);
      }
      return null;
    }
    isResponseFromCache(e) {
      return e.is_cached === void 0 ? (this.logger.verbose(`1okqev`, this.correlationId), !1) : !!e.is_cached;
    }
    async initializePlatformRequest(e) {
      this.logger.trace(`1xdm2a`, this.correlationId);
      let t = await this.getCanonicalAuthority(e),
        n = e.skipBrokerClaims && e.embeddedClientId ? void 0 : this.config.auth.clientCapabilities,
        {
          scopes: r,
          claims: i
        } = e,
        a = new ff(r || [], this.correlationId);
      a.appendScopes(Kc);
      let o = Xf(i, n?.length ? n : void 0),
        s = !!e.attributeTokens?.length;
      this.performanceClient?.addFields({
        hasAttributeTokens: s
      }, this.correlationId);
      let c = {
        claims: o,
        accountId: this.accountId,
        clientId: this.config.auth.clientId,
        authority: t.urlString,
        scope: a.printScopes(),
        redirectUri: jy(e.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId),
        prompt: this.getPrompt(e.prompt),
        correlationId: this.correlationId,
        isSts: !1,
        tokenType: e.authenticationScheme,
        windowTitleSubstring: document.title,
        nonce: e.nonce,
        state: e.state,
        loginHint: e.loginHint,
        extraParameters: {
          ...e.extraParameters,
          ...(e.resource && {
            resource: e.resource
          })
        },
        extendedExpiryToken: !1,
        keyId: e.popKid,
        resourceRequestMethod: e.resourceRequestMethod,
        resourceRequestUri: e.resourceRequestUri,
        shrClaims: e.shrClaims,
        shrNonce: e.shrNonce
      };
      if (s && (c.attributeTokens = of(e.attributeTokens)), c.signPopToken && e.popKid) throw Y(Wg, this.correlationId);
      if (this.handleExtraBrokerParams(c, e.embeddedClientId), c.extraParameters = c.extraParameters || {}, c.extraParameters.telemetry = n_.MATS_TELEMETRY, e.authenticationScheme === pl.POP) {
        let t = {
            resourceRequestUri: e.resourceRequestUri,
            resourceRequestMethod: e.resourceRequestMethod,
            shrClaims: e.shrClaims,
            shrNonce: e.shrNonce,
            correlationId: this.correlationId
          },
          n = new em(this.browserCrypto, this.tokenBindingKeyManager, this.performanceClient),
          r;
        if (c.keyId) r = this.browserCrypto.base64UrlEncode(JSON.stringify({
          kid: c.keyId
        })), c.signPopToken = !1;else {
          let e = await J(n.generateCnf.bind(n), Sd, this.logger, this.performanceClient, this.correlationId)(t, this.logger);
          r = e.reqCnfString, c.keyId = e.kid, c.signPopToken = !0;
        }
        c.reqCnf = r;
      }
      return this.addRequestSKUs(c), c;
    }
    async getCanonicalAuthority(e) {
      let t = e.authority || this.config.auth.authority,
        {
          azureCloudOptions: n,
          account: r
        } = e;
      r && (await Ny(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, t, n, void 0, r));
      let i = new Yu(t, this.correlationId);
      return i.validateAsUri(), i;
    }
    getPrompt(e) {
      switch (this.apiId) {
        case l_.ssoSilent:
        case l_.acquireTokenSilent_silentFlow:
          return this.logger.trace(`12n1y2`, this.correlationId), Qc.NONE;
      }
      if (!e) {
        this.logger.trace(`0uid1p`, this.correlationId);
        return;
      }
      switch (e) {
        case Qc.NONE:
        case Qc.CONSENT:
        case Qc.LOGIN:
          return this.logger.trace(`0i0hco`, this.correlationId), e;
        default:
          throw this.logger.trace(`0w3tpw ${e}`, this.correlationId), Y(Hg, this.correlationId);
      }
    }
    handleExtraBrokerParams(e, t) {
      let n = e.extraParameters && e.extraParameters.hasOwnProperty(`brk_client_id`) && e.extraParameters.hasOwnProperty(`brk_redirect_uri`) && e.extraParameters.hasOwnProperty(`client_id`);
      if (!t && !n) return;
      let r = ``,
        i = e.redirectUri;
      t ? (e.redirectUri = this.config.auth.redirectUri, r = t) : e.extraParameters && (e.redirectUri = e.extraParameters[yc], r = e.extraParameters[Ns]);
      let {
        [vc]: a,
        [yc]: o,
        [Ns]: s,
        ...c
      } = e.extraParameters || {};
      e.extraParameters = {
        ...c,
        child_client_id: r,
        child_redirect_uri: i
      }, this.performanceClient?.addFields({
        embeddedClientId: r,
        embeddedRedirectUri: i
      }, this.correlationId);
    }
  },
  ub = new Map([[`e`, `AAD`], [`m`, `MSA`]]);
function db(e) {
  if (!e) return null;
  try {
    let t = (/%(?:[0-9A-Fa-f]{2})/.test(e) ? decodeURIComponent(e) : e).split(`|`);
    return t.length < 5 ? null : {
      accountType: ub.get(t[0]?.trim() || ``) || ``,
      error: t[1]?.trim() || ``,
      subError: t[2]?.trim() || ``,
      cloudInstance: t[3]?.trim() || ``,
      callerDataBoundary: t[4]?.trim() || ``
    };
  } catch {
    return null;
  }
}
function fb(e, t, n) {
  let r = db(e.clientdata);
  r?.accountType && n.addFields({
    accountType: r.accountType
  }, t), r?.error && n.addFields({
    serverErrorNo: r.error
  }, t), r?.subError && n.addFields({
    serverSubErrorNo: r.subError
  }, t);
}
async function pb(e, t, n, r, i) {
  let a = Im({
    ...e.auth,
    authority: t
  }, n, r, i);
  return kf(a, {
    sku: t_.MSAL_SKU,
    version: vy,
    os: ``,
    cpu: ``
  }), e.system.protocolMode !== pu.OIDC && Af(a, e.telemetry.application), n.platformBroker && (gf(a), i.addFields({
    isPlatformAuthorizeRequest: !0
  }, n.correlationId), n.authenticationScheme === pl.POP && n.reqCnf && Zf(a, n.reqCnf)), n.authenticationScheme === pl.DPOP && n.dpopJkt && a.set(dc, n.dpopJkt), pf(a, n.correlationId, i), a;
}
async function mb(e, t, n, r, i) {
  if (!n.codeChallenge) throw xu(Au, n.correlationId);
  let a = await J(pb, Th, r, i, n.correlationId)(e, t, n, r, i);
  return mf(a, $c.CODE), Pf(a, n.codeChallenge, Rc), Gf(a, {
    ...n.extraQueryParameters,
    ...n.extraParameters
  }), Lm(t, a);
}
async function hb(e, t, n, r, i) {
  if (!n.earJwk) throw Y(ng, n.correlationId);
  let a = await pb(e, t, n, r, i);
  mf(a, $c.IDTOKEN_TOKEN_REFRESHTOKEN), rp(a, n.earJwk), Pf(a, n.codeChallenge, Rc), Gf(a, {
    ...n.extraParameters
  });
  let o = new Map();
  return Gf(o, n.extraQueryParameters || {}), Of(o, n.correlationId), {
    action: Lm(t, o),
    fields: Object.fromEntries(a)
  };
}
async function gb(e, t, n, r, i, a) {
  let {
    action: o,
    fields: s
  } = await hb(t, n, r, i, a);
  return yb(e, o, s);
}
async function _b(e, t, n, r, i) {
  let a = await pb(e, t, n, r, i);
  mf(a, $c.CODE), Pf(a, n.codeChallenge, n.codeChallengeMethod || `S256`), Gf(a, {
    ...n.extraParameters
  });
  let o = new Map();
  return Gf(o, n.extraQueryParameters || {}), Of(o, n.correlationId), {
    action: Lm(t, o),
    fields: Object.fromEntries(a)
  };
}
async function vb(e, t, n, r, i, a) {
  let {
    action: o,
    fields: s
  } = await _b(t, n, r, i, a);
  return yb(e, o, s);
}
function yb(e, t, n) {
  let r = e.createElement(`form`);
  return r.method = `post`, r.action = t, Object.keys(n).forEach(t => {
    let i = e.createElement(`input`);
    i.hidden = !0, i.name = t, i.value = n[t], r.appendChild(i);
  }), e.body.appendChild(r), r;
}
async function bb(e, t, n, r, i, a, o, s, c, l) {
  if (s.verbose(`11qcow`, e.correlationId), !l) throw Y(Bg, e.correlationId);
  let u = new zv(s, c),
    d = new lb(r, i, u, s, o, r.system.navigationClient, n, c, l, t, a, e.correlationId),
    {
      userRequestState: f
    } = xm(u.base64Decode, e.state, e.correlationId);
  return J(d.acquireToken.bind(d), dh, s, c, e.correlationId)({
    ...e,
    state: f,
    prompt: void 0
  });
}
async function xb(e, t, n, r, i, a, o, s, c, l, u, d) {
  if (Dm.removeThrottle(o, i.auth.clientId, e), fb(t, e.correlationId, u), t.accountId) return J(bb, Oh, l, u, e.correlationId)(e, t.accountId, r, i, o, s, c, l, u, d);
  let f = new Yy(a, o, {
    ...e,
    code: t.code || ``,
    codeVerifier: n
  }, l, u);
  return await J(f.handleCodeResponse.bind(f), Eh, l, u, e.correlationId)(t, e, r);
}
async function Sb(e, t, n, r, i, a, o, s, c, l, u) {
  if (Dm.removeThrottle(a, r.auth.clientId, e), fb(t, e.correlationId, l), zm(t, e.state, e.correlationId), !t.ear_jwe) throw Y(rg, e.correlationId);
  if (!e.earJwk) throw Y(ng, e.correlationId);
  let d = JSON.parse(await J(nv, Zh, c, l, e.correlationId)(e.earJwk, t.ear_jwe));
  if (d.accountId) return J(bb, Oh, c, l, e.correlationId)(e, d.accountId, n, r, a, o, s, c, l, u);
  let f = new Sm(r.auth.clientId, a, new zv(c, l), c, l, null, null, new Rv(c, l));
  f.validateTokenResponse(d, e.correlationId);
  let p = {
    code: ``,
    state: e.state,
    nonce: e.nonce,
    client_info: d.client_info,
    cloud_graph_host_name: d.cloud_graph_host_name,
    cloud_instance_host_name: d.cloud_instance_host_name,
    cloud_instance_name: d.cloud_instance_name,
    msgraph_host: d.msgraph_host
  };
  return await J(f.handleServerTokenResponse.bind(f), Cd, c, l, e.correlationId)(d, i, Ld(), e, n, p, void 0, void 0, void 0, void 0);
}
var Cb = 32;
async function wb(e, t, n) {
  let r = Fd(Tb, Bh, t, e, n)(e, t, n);
  return {
    verifier: r,
    challenge: await J(Eb, Vh, t, e, n)(r, e, t, n)
  };
}
function Tb(e, t, n) {
  try {
    let r = new Uint8Array(Cb);
    return Fd(J_, Uh, t, e, n)(r), y_(r);
  } catch {
    throw Y(tg, n);
  }
}
async function Eb(e, t, n, r) {
  try {
    let i = await J(q_, Hh, n, t, r)(e);
    return y_(new Uint8Array(i));
  } catch {
    throw Y(tg, r);
  }
}
var Db = class e {
    navigateInternal(t, n) {
      return e.defaultNavigateWindow(t, n);
    }
    navigateExternal(t, n) {
      return e.defaultNavigateWindow(t, n);
    }
    static defaultNavigateWindow(e, t) {
      return t.noHistory ? window.location.replace(e) : window.location.assign(e), new Promise((e, n) => {
        setTimeout(() => {
          n(Y(Zg, ``, `failed_to_redirect`));
        }, t.timeout);
      });
    }
  },
  Ob = 1,
  kb = 100,
  Ab = class {
    async sendGetRequestAsync(e, t) {
      let n,
        r = {},
        i = 0,
        a = Mb(t);
      try {
        n = await fetch(e, {
          method: a_.GET,
          headers: a
        });
      } catch (e) {
        throw km(Y(window.navigator.onLine ? kg : Dg, ``), void 0, void 0, e);
      }
      r = Nb(n.headers);
      try {
        return i = n.status, {
          headers: r,
          body: await n.json(),
          status: i
        };
      } catch (e) {
        throw km(Y(Ag, ``), i, r, e);
      }
    }
    async sendPostRequestAsync(e, t) {
      let n = t && t.body || ``,
        r = Mb(t),
        i = t?.correlationId,
        a = t?.performanceClient,
        o,
        s;
      for (let t = 1; t <= 2; t++) try {
        o = await fetch(e, {
          method: a_.POST,
          headers: r,
          body: n
        });
        break;
      } catch (e) {
        if (s = e, !jb(s, t)) throw km(Y(window.navigator.onLine === !1 ? Dg : Og, i || ``), void 0, void 0, s);
        await new Promise(e => setTimeout(e, kb)), i && a?.incrementFields({
          fetchRetryCount: 1
        }, i);
      }
      if (!o) throw km(Y(window.navigator.onLine === !1 ? Dg : Og, i || ``), void 0, void 0, s);
      let c = 0,
        l = {};
      l = Nb(o.headers);
      try {
        return c = o.status, {
          headers: l,
          body: await o.json(),
          status: c
        };
      } catch (e) {
        throw km(Y(Ag, i || ``), c, l, e);
      }
    }
  };
function jb(e, t) {
  return t <= Ob && window.navigator.onLine !== !1 && e.name !== `AbortError`;
}
function Mb(e) {
  try {
    let t = new Headers();
    if (!(e && e.headers)) return t;
    let n = e.headers;
    return Object.entries(n).forEach(([e, n]) => {
      t.append(e, n);
    }), t;
  } catch (e) {
    throw km(Y(Jg, ``), void 0, void 0, e);
  }
}
function Nb(e) {
  try {
    let t = {};
    return e.forEach((e, n) => {
      t[n] = e;
    }), t;
  } catch {
    throw Y(Yg, ``);
  }
}
var Pb = 3e4;
function Fb({
  auth: e,
  cache: t,
  system: n,
  experimental: r,
  telemetry: i
}, a) {
  let o = {
      clientId: ``,
      authority: `${Dc}`,
      knownAuthorities: [],
      cloudDiscoveryMetadata: ``,
      authorityMetadata: ``,
      redirectUri: typeof window < `u` && window.location ? window.location.href.split(`?`)[0].split(`#`)[0] : ``,
      postLogoutRedirectUri: ``,
      popupRelayUri: ``,
      clientCapabilities: [],
      OIDCOptions: {
        responseMode: el.FRAGMENT,
        defaultScopes: [Pc, Fc, Ic]
      },
      azureCloudOptions: {
        azureCloudInstance: od.None,
        tenant: ``
      },
      instanceAware: !1,
      isMcp: !1,
      verifySSO: !1
    },
    s = {
      cacheLocation: i_.SessionStorage,
      cacheRetentionDays: 5
    },
    c = {
      loggerCallback: () => {},
      logLevel: mp.Info,
      piiLoggingEnabled: !1
    },
    l = {
      ...Mp,
      loggerOptions: c,
      networkClient: a ? new Ab() : Qm,
      navigationClient: new Db(),
      popupBridgeTimeout: n?.popupBridgeTimeout || 6e4,
      iframeBridgeTimeout: n?.iframeBridgeTimeout || 1e4,
      redirectNavigationTimeout: Pb,
      allowRedirectInIframe: !1,
      navigatePopups: !0,
      allowPlatformBroker: !1,
      nativeBrokerHandshakeTimeout: n?.nativeBrokerHandshakeTimeout || 2e3,
      protocolMode: pu.AAD,
      serverTelemetryEnabled: !1,
      ...n,
      loggerOptions: n?.loggerOptions || c
    },
    u = {
      application: {
        appName: ``,
        appVersion: ``
      },
      client: new jp()
    },
    d = {
      iframeTimeoutTelemetry: !1,
      allowPlatformBrokerWithDOM: !1
    };
  if (n?.protocolMode !== pu.OIDC && e?.OIDCOptions && new xp(l.loggerOptions, _y, vy).warning(JSON.stringify(xu(Lu, ``)), ``), n?.protocolMode && n.protocolMode === pu.OIDC && l?.allowPlatformBroker) throw xu(Ru, ``);
  return {
    auth: {
      ...o,
      ...e,
      OIDCOptions: {
        ...o.OIDCOptions,
        ...e?.OIDCOptions
      }
    },
    cache: {
      ...s,
      ...t
    },
    system: l,
    experimental: {
      ...d,
      ...r
    },
    telemetry: {
      ...u,
      ...i
    }
  };
}
var Ib = class e {
    constructor(e, t, n, r) {
      this.logger = e, this.handshakeTimeoutMs = t, this.extensionId = r, this.resolvers = new Map(), this.handshakeResolvers = new Map(), this.messageChannel = new MessageChannel(), this.windowListener = this.onWindowMessage.bind(this), this.performanceClient = n, this.handshakeEvent = this.performanceClient.startMeasurement(Ih), this.platformAuthType = n_.PLATFORM_EXTENSION_PROVIDER;
    }
    async sendMessage(e) {
      this.logger.trace(`0on4p2 ${this.platformAuthType}`, e.correlationId);
      let t = {
          method: r_.GetToken,
          request: e
        },
        n = {
          channel: n_.CHANNEL_ID,
          extensionId: this.extensionId,
          responseId: X_(),
          body: t
        };
      this.logger.trace(`1qadfi ${this.platformAuthType}`, e.correlationId), this.logger.tracePii(`1xm533 ${this.platformAuthType} ${JSON.stringify(n)}`, e.correlationId), this.messageChannel.port1.postMessage(n);
      let r = await new Promise((e, t) => {
        this.resolvers.set(n.responseId, {
          resolve: e,
          reject: t
        });
      });
      return this.validatePlatformBrokerResponse(r);
    }
    static async createProvider(t, n, r, i) {
      t.trace(`15zfnw`, i);
      try {
        let a = new e(t, n, r, n_.PREFERRED_EXTENSION_ID);
        return await a.sendHandshakeRequest(i), a;
      } catch {
        let a = new e(t, n, r);
        return await a.sendHandshakeRequest(i), a;
      }
    }
    async sendHandshakeRequest(e) {
      this.logger.trace(`1dpg9o ${this.platformAuthType}`, e), window.addEventListener(`message`, this.windowListener, !1);
      let t = {
        channel: n_.CHANNEL_ID,
        extensionId: this.extensionId,
        responseId: X_(),
        body: {
          method: r_.HandshakeRequest
        }
      };
      return this.handshakeEvent.add({
        extensionId: this.extensionId,
        extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
      }), this.messageChannel.port1.onmessage = e => {
        this.onChannelMessage(e);
      }, window.postMessage(t, window.origin, [this.messageChannel.port2]), new Promise((e, n) => {
        this.handshakeResolvers.set(t.responseId, {
          resolve: e,
          reject: n
        }), this.timeoutId = window.setTimeout(() => {
          window.removeEventListener(`message`, this.windowListener, !1), this.messageChannel.port1.close(), this.messageChannel.port2.close(), this.handshakeEvent.end({
            extensionHandshakeTimedOut: !0,
            success: !1
          }), n(Y(Rg, ``)), this.handshakeResolvers.delete(t.responseId);
        }, this.handshakeTimeoutMs);
      });
    }
    onWindowMessage(e) {
      let t = Pv();
      if (this.logger.trace(`0jpn5u ${this.platformAuthType}`, t), e.source !== window) return;
      let n = e.data;
      if (n.channel && n.channel === n_.CHANNEL_ID && !(n.extensionId && n.extensionId !== this.extensionId) && n.body.method === r_.HandshakeRequest) {
        let e = this.handshakeResolvers.get(n.responseId);
        if (!e) {
          this.logger.trace(`07buhm ${this.platformAuthType} ${n.responseId}`, t);
          return;
        }
        this.logger.verbose(n.extensionId ? `0xrkug ${n.extensionId}` : `No extension installed`, t), clearTimeout(this.timeoutId), this.messageChannel.port1.close(), this.messageChannel.port2.close(), window.removeEventListener(`message`, this.windowListener, !1), this.handshakeEvent.end({
          success: !1,
          extensionInstalled: !1
        }), e.reject(Y(zg, ``));
      }
    }
    onChannelMessage(e) {
      let t = Pv();
      this.logger.trace(`1py8yf ${this.platformAuthType}`, t);
      let n = e.data,
        r = this.resolvers.get(n.responseId),
        i = this.handshakeResolvers.get(n.responseId);
      try {
        let e = n.body.method;
        if (e === r_.Response) {
          if (!r) return;
          let e = n.body.response;
          if (this.logger.trace(`19hpgm ${this.platformAuthType}`, t), this.logger.tracePii(`179a24 ${this.platformAuthType} ${JSON.stringify(e)}`, t), e.status !== `Success`) r.reject(sb(e.code, t, e.description, e.ext));else if (e.result) e.result.code && e.result.description ? r.reject(sb(e.result.code, t, e.result.description, e.result.ext)) : r.resolve(e.result);else throw Cl(yu, t, `Event does not contain result.`);
          this.resolvers.delete(n.responseId);
        } else if (e === r_.HandshakeResponse) {
          if (!i) {
            this.logger.trace(`082qnt ${this.platformAuthType} ${n.responseId}`, t);
            return;
          }
          clearTimeout(this.timeoutId), window.removeEventListener(`message`, this.windowListener, !1), this.extensionId = n.extensionId, this.extensionVersion = n.body.version, this.logger.verbose(`0yf5ib ${this.platformAuthType} ${this.extensionId}`, t), this.handshakeEvent.end({
            extensionInstalled: !0,
            success: !0
          }), i.resolve(), this.handshakeResolvers.delete(n.responseId);
        }
      } catch (n) {
        this.logger.error(`0xf978`, t), this.logger.errorPii(`04i99o ${n}`, t), this.logger.errorPii(`0xdvsy ${e}`, t), r ? r.reject(n) : i && i.reject(n);
      }
    }
    validatePlatformBrokerResponse(e) {
      if (e.hasOwnProperty(`access_token`) && e.hasOwnProperty(`id_token`) && e.hasOwnProperty(`client_info`) && e.hasOwnProperty(`account`) && e.hasOwnProperty(`scope`) && e.hasOwnProperty(`expires_in`)) return e;
      throw Cl(yu, ``, `Response missing expected properties.`);
    }
    getExtensionId() {
      return this.extensionId;
    }
    getExtensionVersion() {
      return this.extensionVersion;
    }
    getExtensionName() {
      return this.getExtensionId() === n_.PREFERRED_EXTENSION_ID ? `chrome` : this.getExtensionId()?.length ? `unknown` : void 0;
    }
  },
  Lb = class e {
    constructor(e, t, n) {
      this.logger = e, this.performanceClient = t, this.correlationId = n, this.platformAuthType = n_.PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(t, n, r) {
      if (t.trace(`12mj4a`, r), window.navigator?.platformAuthentication && (await window.navigator.platformAuthentication.getSupportedContracts(n_.MICROSOFT_ENTRA_BROKERID))?.includes(n_.PLATFORM_DOM_APIS)) return t.trace(`1h5q1r`, r), new e(t, n, r);
    }
    getExtensionId() {
      return n_.MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
      return ``;
    }
    getExtensionName() {
      return n_.DOM_API_NAME;
    }
    async sendMessage(e) {
      this.logger.trace(`02bcil ${this.platformAuthType}`, e.correlationId);
      try {
        let t = this.initializePlatformDOMRequest(e),
          n = await window.navigator.platformAuthentication.executeGetToken(t);
        return this.validatePlatformBrokerResponse(n, e.correlationId);
      } catch (t) {
        throw this.logger.error(`11im7g ${this.platformAuthType}`, e.correlationId), t;
      }
    }
    initializePlatformDOMRequest(e) {
      this.logger.trace(`15d6yv ${this.platformAuthType}`, e.correlationId);
      let {
          accountId: t,
          clientId: n,
          authority: r,
          scope: i,
          redirectUri: a,
          correlationId: o,
          state: s,
          extraParameters: c,
          ...l
        } = e,
        u = this.getDOMExtraParams(l, o);
      return {
        accountId: t,
        brokerId: this.getExtensionId(),
        authority: r,
        clientId: n,
        correlationId: o || this.correlationId,
        extraParameters: {
          ...c,
          ...u
        },
        isSecurityTokenService: !1,
        redirectUri: a,
        scope: i,
        state: s
      };
    }
    validatePlatformBrokerResponse(e, t) {
      if (e.hasOwnProperty(`isSuccess`)) {
        if (e.hasOwnProperty(`accessToken`) && e.hasOwnProperty(`idToken`) && e.hasOwnProperty(`clientInfo`) && e.hasOwnProperty(`account`) && e.hasOwnProperty(`scopes`) && e.hasOwnProperty(`expiresIn`)) return this.logger.trace(`0h4vei ${this.platformAuthType}`, t), this.convertToPlatformBrokerResponse(e, t);
        if (e.hasOwnProperty(`error`)) {
          let n = e;
          if (n.isSuccess === !1 && n.error && n.error.code) throw this.logger.trace(`0g92vm ${this.platformAuthType}`, t), sb(n.error.code, t, n.error.description, {
            error: parseInt(n.error.errorCode),
            protocol_error: n.error.protocolError,
            status: n.error.status,
            properties: n.error.properties
          });
        }
      }
      throw Cl(yu, t, `Response missing expected properties.`);
    }
    convertToPlatformBrokerResponse(e, t) {
      return this.logger.trace(`14913t ${this.platformAuthType}`, t), {
        access_token: e.accessToken,
        id_token: e.idToken,
        client_info: e.clientInfo,
        account: e.account,
        expires_in: e.expiresIn,
        scope: e.scopes,
        state: e.state || ``,
        properties: e.properties || {},
        extendedLifetimeToken: e.extendedLifetimeToken ?? !1,
        shr: e.proofOfPossessionPayload
      };
    }
    getDOMExtraParams(e, t) {
      try {
        let t = {};
        for (let [n, r] of Object.entries(e)) r && (t[n] = typeof r == `object` ? JSON.stringify(r) : String(r));
        return t;
      } catch (e) {
        return this.logger.error(`0eu9o3 ${this.platformAuthType}`, t), this.logger.errorPii(`17rpl5 ${this.platformAuthType} ${e}`, t), {};
      }
    }
  };
async function Rb(e, t, n, r, i) {
  e.trace(`134j0v`, n), e.trace(`04c81g ${i}`, n);
  let a;
  try {
    i && (a = await Lb.createProvider(e, t, n)), a ||= (e.trace(`0l3na8`, n), await Ib.createProvider(e, r || 2e3, t, n));
  } catch (t) {
    e.trace(`0icbd7`, t);
  }
  return a;
}
function zb(e, t, n, r, i) {
  if (t.trace(`0uko3r`, n), !e.system.allowPlatformBroker && e.experimental.allowPlatformBrokerWithDOM) throw xu(Vu, ``);
  if (!e.system.allowPlatformBroker) return t.trace(`04hozs`, n), !1;
  if (!r) return t.trace(`0kvv1r`, n), !1;
  if (i) switch (i) {
    case pl.BEARER:
    case pl.POP:
      return t.trace(`18tev1`, n), !0;
    default:
      return t.trace(`1dd2nh`, n), !1;
  }
  return !0;
}
var Bb = class extends Hy {
  constructor(e, t, n, r, i, a, o, s, c, l, u, d) {
    super(e, t, n, r, i, a, o, c, l, d), this.nativeStorage = s, this.eventHandler = i, this.waitForPopupResponseHook = u;
  }
  acquireToken(e, t) {
    let n;
    try {
      if (n = {
        popupName: this.generatePopupName(e.scopes || Kc, e.authority || this.config.auth.authority),
        popupWindowAttributes: e.popupWindowAttributes || {},
        popupWindowParent: e.popupWindowParent ?? window
      }, this.performanceClient.addFields({
        isAsyncPopup: !this.config.system.navigatePopups
      }, this.correlationId), this.config.system.navigatePopups) {
        let r = {
          ...e,
          httpMethod: Vy(e, this.config.system.protocolMode)
        };
        return this.logger.verbose(`1f9ok3`, this.correlationId), n.popup = this.openSizedPopup(`about:blank`, n), this.acquireTokenPopupAsync(r, n, t);
      }
      return this.logger.verbose(`162h4u`, this.correlationId), this.acquireTokenPopupAsync(e, n, t);
    } catch (e) {
      return Promise.reject(e);
    }
  }
  logout(e) {
    try {
      this.logger.verbose(`068rup`, this.correlationId);
      let t = this.initializeLogoutRequest(e),
        n = {
          popupName: this.generateLogoutPopupName(t),
          popupWindowAttributes: e?.popupWindowAttributes || {},
          popupWindowParent: e?.popupWindowParent ?? window
        },
        r = e && e.authority,
        i = e && e.mainWindowRedirectUri;
      return this.config.system.navigatePopups ? (this.logger.verbose(`1a28da`, this.correlationId), n.popup = this.openSizedPopup(`about:blank`, n), this.logoutPopupAsync(t, n, r, i)) : (this.logger.verbose(`1phd8u`, this.correlationId), this.logoutPopupAsync(t, n, r, i));
    } catch (e) {
      return Promise.reject(e);
    }
  }
  async acquireTokenPopupAsync(e, t, n) {
    this.logger.verbose(`1g77pg`, this.correlationId);
    let r = await J(Uy, Ch, this.logger, this.performanceClient, this.correlationId)(e, f_.Popup, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
    return t.popup && Nv(r.authority), r.platformBroker = zb(this.config, this.logger, this.correlationId, this.platformAuthProvider, e.authenticationScheme), this.config.system.protocolMode === pu.EAR ? this.executeEarFlow(r, t, n) : this.executeCodeFlow(r, t, n);
  }
  async executeCodeFlow(e, t, n) {
    let r = e.correlationId,
      i = My(l_.acquireTokenPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
      a = n || (await J(wb, `generatePkceCodes`, this.logger, this.performanceClient, r)(this.performanceClient, this.logger, r)),
      o = await Ry(e, this.tokenBindingKeyManager, this.logger, this.performanceClient),
      s = {
        ...e,
        codeChallenge: a.challenge,
        ...o
      };
    try {
      let n = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, r)({
        serverTelemetryManager: i,
        requestAuthority: s.authority,
        requestAzureCloudOptions: s.azureCloudOptions,
        requestExtraQueryParameters: s.extraQueryParameters,
        account: s.account
      });
      if (s.httpMethod === Gc.POST) return await this.executeCodeFlowWithPost(s, t, n, a.verifier);
      {
        let i = await J(mb, _d, this.logger, this.performanceClient, r)(this.config, n.authority, s, this.logger, this.performanceClient),
          o = this.config.auth.popupRelayUri,
          c = o ? Wy(o, this.getRelayStateId(e.state, r), {
            method: `GET`,
            url: i
          }, r) : i,
          l = this.initiateAuthRequest(c, t);
        this.eventHandler.emitEvent(gy.POPUP_OPENED, r, f_.Popup, {
          popupWindow: l
        }, null);
        let u = await this.waitForPopupResponse(e, l, t.popupWindowParent),
          d = Fd(qy, jh, this.logger, this.performanceClient, this.correlationId)(u, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        return await J(xb, kh, this.logger, this.performanceClient, r)(s, d, a.verifier, l_.acquireTokenPopup, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
      }
    } catch (e) {
      throw t.popup?.close(), e instanceof Sl && (e.correlationId = this.correlationId, i.cacheFailedRequest(e)), e;
    }
  }
  async executeEarFlow(e, t, n) {
    let {
        correlationId: r,
        authority: i,
        azureCloudOptions: a,
        extraQueryParameters: o,
        account: s
      } = e,
      c = await J(Ny, uh, this.logger, this.performanceClient, r)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, i, a, o, s),
      l = await J(ev, Xh, this.logger, this.performanceClient, r)(),
      u = n || (await J(wb, `generatePkceCodes`, this.logger, this.performanceClient, r)(this.performanceClient, this.logger, r)),
      d = await Ry(e, this.tokenBindingKeyManager, this.logger, this.performanceClient),
      f = {
        ...e,
        earJwk: l,
        codeChallenge: u.challenge,
        ...d
      },
      p = await this.openPostFormPopup(f, c, t, r, !0),
      m = await J(this.waitForPopupResponse.bind(this), bh, this.logger, this.performanceClient, r)(f, p, t.popupWindowParent),
      h = Fd(qy, jh, this.logger, this.performanceClient, this.correlationId)(m, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
    if (!h.ear_jwe && h.code) {
      let t = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, r)({
        serverTelemetryManager: My(l_.acquireTokenPopup, this.config.auth.clientId, r, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
        requestAuthority: e.authority,
        requestAzureCloudOptions: e.azureCloudOptions,
        requestExtraQueryParameters: e.extraQueryParameters,
        account: e.account,
        authority: c
      });
      return J(xb, kh, this.logger, this.performanceClient, r)(f, h, u.verifier, l_.acquireTokenPopup, this.config, t, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    return J(Sb, Dh, this.logger, this.performanceClient, r)(f, h, l_.acquireTokenPopup, this.config, c, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
  }
  async executeCodeFlowWithPost(e, t, n, r) {
    let i = e.correlationId,
      a = await J(Ny, uh, this.logger, this.performanceClient, i)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger),
      o = await this.openPostFormPopup(e, a, t, i, !1),
      s = await J(this.waitForPopupResponse.bind(this), bh, this.logger, this.performanceClient, i)(e, o, t.popupWindowParent),
      c = Fd(qy, jh, this.logger, this.performanceClient, this.correlationId)(s, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
    return J(xb, kh, this.logger, this.performanceClient, i)(e, c, r, l_.acquireTokenPopup, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
  }
  async logoutPopupAsync(e, t, n, r) {
    this.logger.verbose(`0b7yrk`, this.correlationId), this.eventHandler.emitEvent(gy.LOGOUT_START, this.correlationId, f_.Popup, e);
    let i = My(l_.logoutPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled);
    try {
      await Py(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, e.account);
      let a = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, this.correlationId)({
        serverTelemetryManager: i,
        requestAuthority: n,
        account: e.account || void 0
      });
      try {
        a.authority.endSessionEndpoint;
      } catch {
        if (e.account?.homeAccountId && e.postLogoutRedirectUri && a.authority.protocolMode === pu.OIDC) {
          if (this.eventHandler.emitEvent(gy.LOGOUT_SUCCESS, e.correlationId, f_.Popup, e), r) {
            let e = {
                apiId: l_.logoutPopup,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: !1
              },
              t = Yu.getAbsoluteUrl(r, wv(), this.correlationId);
            await this.navigationClient.navigateInternal(t, e);
          }
          t.popup?.close();
          return;
        }
      }
      e.state = ym(this.browserCrypto, e.state || ``, {
        interactionType: f_.Popup
      }, e.correlationId);
      let o = a.getLogoutUri(e);
      this.eventHandler.emitEvent(gy.LOGOUT_SUCCESS, e.correlationId, f_.Popup, e);
      let s = this.config.auth.popupRelayUri,
        c = s ? Wy(s, this.getRelayStateId(e.state || ``, this.correlationId), {
          method: `GET`,
          url: o
        }, this.correlationId) : o,
        l = this.openPopup(c, t);
      if (this.eventHandler.emitEvent(gy.POPUP_OPENED, e.correlationId, f_.Popup, {
        popupWindow: l
      }, null), await this.waitForPopupResponse(e, l, t.popupWindowParent).catch(() => {}), r) {
        let e = {
            apiId: l_.logoutPopup,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: !1
          },
          t = Yu.getAbsoluteUrl(r, wv(), this.correlationId);
        this.logger.verbose(`0qcur2`, this.correlationId), this.logger.verbosePii(`0oj7lk ${t}`, this.correlationId), await this.navigationClient.navigateInternal(t, e);
      } else this.logger.verbose(`03zgcf`, this.correlationId);
    } catch (e) {
      throw t.popup?.close(), e instanceof Sl && (e.correlationId = this.correlationId, i.cacheFailedRequest(e)), this.eventHandler.emitEvent(gy.LOGOUT_FAILURE, this.correlationId, f_.Popup, null, e), this.eventHandler.emitEvent(gy.LOGOUT_END, this.correlationId, f_.Popup), e;
    }
    this.eventHandler.emitEvent(gy.LOGOUT_END, this.correlationId, f_.Popup);
  }
  initiateAuthRequest(e, t) {
    if (e) return this.logger.infoPii(`1kcr9k ${e}`, this.correlationId), this.openPopup(e, t);
    throw this.logger.error(`1l7hyp`, this.correlationId), Y(ag, this.correlationId);
  }
  openPopup(e, t) {
    try {
      let n;
      if (t.popup ? (n = t.popup, this.logger.verbosePii(`0cgeo7 ${e}`, this.correlationId), n.location.assign(e)) : t.popup === void 0 && (this.logger.verbosePii(`0c2awd ${e}`, this.correlationId), n = this.openSizedPopup(e, t)), !n) throw Y(mg, this.correlationId);
      try {
        n.document.title = `Microsoft Authentication`;
      } catch (e) {
        typeof DOMException < `u` && e instanceof DOMException && e.name === `SecurityError` || this.logger.verbose(`1s1yfs`, this.correlationId);
      }
      return n.focus && n.focus(), this.currentWindow = n, n;
    } catch (e) {
      throw this.logger.error(`0dxfb9 ${e.message}`, this.correlationId), Y(pg, this.correlationId);
    }
  }
  openSizedPopup(e, {
    popupName: t,
    popupWindowAttributes: n,
    popupWindowParent: r
  }) {
    let i = r.screenLeft ? r.screenLeft : r.screenX,
      a = r.screenTop ? r.screenTop : r.screenY,
      o = r.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      s = r.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      c = n.popupSize?.width,
      l = n.popupSize?.height,
      u = n.popupPosition?.top,
      d = n.popupPosition?.left;
    return (!c || c < 0 || c > o) && (this.logger.verbose(`08vfmo`, this.correlationId), c = t_.POPUP_WIDTH), (!l || l < 0 || l > s) && (this.logger.verbose(`09cxa0`, this.correlationId), l = t_.POPUP_HEIGHT), (!u || u < 0 || u > s) && (this.logger.verbose(`1qh4wo`, this.correlationId), u = Math.max(0, s / 2 - t_.POPUP_HEIGHT / 2 + a)), (!d || d < 0 || d > o) && (this.logger.verbose(`1sz3en`, this.correlationId), d = Math.max(0, o / 2 - t_.POPUP_WIDTH / 2 + i)), r.open(e, t, `width=${c}, height=${l}, top=${u}, left=${d}, scrollbars=yes`);
  }
  generatePopupName(e, t) {
    return `${t_.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${e.join(`-`)}.${t}.${this.correlationId}`;
  }
  generateLogoutPopupName(e) {
    let t = e.account && e.account.homeAccountId;
    return `${t_.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${t}.${this.correlationId}`;
  }
  getRelayStateId(e, t) {
    return xm($g, e, t).libraryState.id;
  }
  async openPostFormPopup(e, t, n, r, i) {
    let a = this.config.auth.popupRelayUri;
    if (a) {
      let o = await (i ? hb : _b)(this.config, t, e, this.logger, this.performanceClient),
        s = Wy(a, this.getRelayStateId(e.state, r), {
          method: `POST`,
          action: o.action,
          fields: o.fields
        }, r);
      return this.initiateAuthRequest(s, n);
    }
    let o = n.popup || this.openPopup(`about:blank`, n);
    return (await (i ? gb : vb)(o.document, this.config, t, e, this.logger, this.performanceClient)).submit(), o;
  }
  async waitForPopupResponse(e, t, n) {
    return this.config.auth.popupRelayUri ? Gy(this.config.system.popupBridgeTimeout, this.logger, e, t, this.performanceClient) : this.waitForPopupResponseHook ? this.waitForPopupResponseHook(e, t, n) : Cv(this.config.system.popupBridgeTimeout, this.logger, e, this.performanceClient);
  }
};
function Vb() {
  if (typeof window > `u` || window.performance === void 0 || typeof window.performance.getEntriesByType != `function`) return;
  let e = window.performance.getEntriesByType(`navigation`);
  return (e.length ? e[0] : void 0)?.type;
}
var Hb = class extends Hy {
  constructor(e, t, n, r, i, a, o, s, c, l, u) {
    super(e, t, n, r, i, a, o, c, l, u), this.nativeStorage = s;
  }
  async acquireToken(e) {
    let t = await J(Uy, Ch, this.logger, this.performanceClient, this.correlationId)(e, f_.Redirect, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
    t.platformBroker = zb(this.config, this.logger, this.correlationId, this.platformAuthProvider, e.authenticationScheme);
    let n = e => {
        e.persisted && (this.logger.verbose(`0udvtt`, this.correlationId), this.browserStorage.resetRequestCache(this.correlationId), this.eventHandler.emitEvent(gy.RESTORE_FROM_BFCACHE, this.correlationId, f_.Redirect));
      },
      r = this.getRedirectStartPage(e.redirectStartPage);
    this.logger.verbosePii(`0zao0a ${r}`, this.correlationId), this.browserStorage.setTemporaryCache(s_.ORIGIN_URI, r, !0), window.addEventListener(`pageshow`, n);
    try {
      this.config.system.protocolMode === pu.EAR ? await this.executeEarFlow(t) : await this.executeCodeFlow(t);
    } catch (e) {
      throw e instanceof Sl && (e.correlationId = this.correlationId), window.removeEventListener(`pageshow`, n), e;
    }
  }
  async executeCodeFlow(e) {
    let t = e.correlationId,
      n = My(l_.acquireTokenRedirect, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
      r = await J(wb, zh, this.logger, this.performanceClient, t)(this.performanceClient, this.logger, t),
      i = await Ry(e, this.tokenBindingKeyManager, this.logger, this.performanceClient),
      a = {
        ...e,
        codeChallenge: r.challenge,
        ...i
      };
    this.browserStorage.cacheAuthorizeRequest(a, this.correlationId, r.verifier);
    try {
      if (a.httpMethod === Gc.POST) return await this.executeCodeFlowWithPost(a);
      {
        let t = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: n,
            requestAuthority: a.authority,
            requestAzureCloudOptions: a.azureCloudOptions,
            requestExtraQueryParameters: a.extraQueryParameters,
            account: a.account
          }),
          r = await J(mb, _d, this.logger, this.performanceClient, e.correlationId)(this.config, t.authority, a, this.logger, this.performanceClient);
        return await this.initiateAuthRequest(r);
      }
    } catch (e) {
      throw e instanceof Sl && (e.correlationId = this.correlationId, n.cacheFailedRequest(e)), e;
    }
  }
  async executeEarFlow(e) {
    let {
        correlationId: t,
        authority: n,
        azureCloudOptions: r,
        extraQueryParameters: i,
        account: a
      } = e,
      o = await J(Ny, uh, this.logger, this.performanceClient, t)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, n, r, i, a),
      s = await J(ev, Xh, this.logger, this.performanceClient, t)(),
      c = await J(wb, zh, this.logger, this.performanceClient, t)(this.performanceClient, this.logger, t),
      l = await Ry(e, this.tokenBindingKeyManager, this.logger, this.performanceClient),
      u = {
        ...e,
        earJwk: s,
        codeChallenge: c.challenge,
        ...l
      };
    return this.browserStorage.cacheAuthorizeRequest(u, this.correlationId, c.verifier), (await gb(document, this.config, o, u, this.logger, this.performanceClient)).submit(), new Promise((e, t) => {
      setTimeout(() => {
        t(Y(Zg, ``, `failed_to_redirect`));
      }, this.config.system.redirectNavigationTimeout);
    });
  }
  async executeCodeFlowWithPost(e) {
    let t = e.correlationId,
      n = await J(Ny, uh, this.logger, this.performanceClient, t)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
    return this.browserStorage.cacheAuthorizeRequest(e, this.correlationId), (await vb(document, this.config, n, e, this.logger, this.performanceClient)).submit(), new Promise((e, t) => {
      setTimeout(() => {
        t(Y(Zg, ``, `failed_to_redirect`));
      }, this.config.system.redirectNavigationTimeout);
    });
  }
  async handleRedirectPromise(e, t, n, r) {
    let i = document.title;
    document.title = `Microsoft Authentication`;
    let a = My(l_.handleRedirectPromise, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
      o = r?.navigateToLoginRequestUrl ?? !0;
    try {
      let [i, s] = this.getRedirectResponse(r?.hash || ``);
      if (!i) return this.logger.info(`1qmv0q`, this.correlationId), this.browserStorage.resetRequestCache(this.correlationId), Vb() === `back_forward` ? this.logger.verbose(`1eqegq`, this.correlationId) : n.event.errorCode = `no_server_response`, null;
      let c = this.browserStorage.getTemporaryCache(s_.ORIGIN_URI, this.correlationId, !0) || ``;
      if (lp(c, this.logger, this.correlationId) === lp(window.location.href, this.logger, this.correlationId) && o) return this.logger.verbose(`11yred`, this.correlationId), c.indexOf(`#`) > -1 && vv(c), await this.handleResponse(i, e, t, a);
      if (!o) return this.logger.verbose(`0v4sdv`, this.correlationId), await this.handleResponse(i, e, t, a);
      if (!yv() || this.config.system.allowRedirectInIframe) {
        this.browserStorage.setTemporaryCache(s_.URL_HASH, s, !0);
        let n = {
            apiId: l_.handleRedirectPromise,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: !0
          },
          r = !0;
        if (c) this.logger.verbose(`08jpy1 ${c}`, this.correlationId), r = await this.navigationClient.navigateInternal(c, n);else {
          let e = Tv(this.correlationId);
          this.browserStorage.setTemporaryCache(s_.ORIGIN_URI, e, !0), this.logger.warning(`1dutq1`, this.correlationId), r = await this.navigationClient.navigateInternal(e, n);
        }
        if (!r) return await this.handleResponse(i, e, t, a);
      }
      return null;
    } catch (e) {
      throw e instanceof Sl && (e.correlationId = this.correlationId, a.cacheFailedRequest(e)), e;
    } finally {
      document.title = i;
    }
  }
  getRedirectResponse(e) {
    this.logger.verbose(`1c5i8m`, this.correlationId);
    let t = e;
    t ||= this.config.auth.OIDCOptions.responseMode === el.QUERY ? window.location.search : window.location.hash;
    let n = sp(t);
    if (n) {
      try {
        Jy(n, this.browserCrypto, f_.Redirect, this.correlationId);
      } catch (e) {
        return e instanceof Sl && this.logger.error(`0bkq6p ${e.errorCode} ${e.errorMessage}`, this.correlationId), [null, ``];
      }
      return _v(window), this.logger.verbose(`00uvho`, this.correlationId), [n, t];
    }
    let r = this.browserStorage.getTemporaryCache(s_.URL_HASH, this.correlationId, !0);
    return this.browserStorage.removeItem(this.browserStorage.generateCacheKey(s_.URL_HASH)), r && (n = sp(r), n) ? (this.logger.verbose(`001671`, this.correlationId), [n, r]) : [null, ``];
  }
  async handleResponse(e, t, n, r) {
    if (!e.state) throw Y(sg, t.correlationId);
    let {
      authority: i,
      azureCloudOptions: a,
      extraQueryParameters: o,
      account: s
    } = t;
    if (e.ear_jwe) {
      let n = await J(Ny, uh, this.logger, this.performanceClient, t.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, i, a, o, s);
      return J(Sb, Dh, this.logger, this.performanceClient, t.correlationId)(t, e, l_.acquireTokenRedirect, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    let c = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, this.correlationId)({
      serverTelemetryManager: r,
      requestAuthority: t.authority
    });
    return J(xb, kh, this.logger, this.performanceClient, t.correlationId)(t, e, n, l_.acquireTokenRedirect, this.config, c, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
  }
  async initiateAuthRequest(e) {
    if (this.logger.verbose(`0yaw2e`, this.correlationId), e) {
      this.logger.infoPii(`1luf83 ${e}`, this.correlationId);
      let t = {
          apiId: l_.acquireTokenRedirect,
          timeout: this.config.system.redirectNavigationTimeout,
          noHistory: !1
        },
        n = this.config.auth.onRedirectNavigate;
      if (typeof n == `function`) {
        if (this.logger.verbose(`1nehvl`, this.correlationId), n(e) !== !1) {
          this.logger.verbose(`1a0jxh`, this.correlationId), await this.navigationClient.navigateExternal(e, t);
          return;
        }
        this.logger.verbose(`09k5h5`, this.correlationId);
        return;
      }
      this.logger.verbose(`0klwf7`, this.correlationId), await this.navigationClient.navigateExternal(e, t);
      return;
    }
    throw this.logger.info(`0rlh4e`, this.correlationId), Y(ag, this.correlationId);
  }
  async logout(e) {
    this.logger.verbose(`1rkurh`, this.correlationId);
    let t = this.initializeLogoutRequest(e),
      n = My(l_.logout, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled);
    try {
      this.eventHandler.emitEvent(gy.LOGOUT_START, this.correlationId, f_.Redirect, e), await Py(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, t.account);
      let r = {
          apiId: l_.logout,
          timeout: this.config.system.redirectNavigationTimeout,
          noHistory: !1
        },
        i = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, this.correlationId)({
          serverTelemetryManager: n,
          requestAuthority: e && e.authority,
          requestExtraQueryParameters: e?.extraQueryParameters,
          account: e && e.account || void 0
        });
      if (i.authority.protocolMode === pu.OIDC) try {
        i.authority.endSessionEndpoint;
      } catch {
        if (t.account?.homeAccountId) {
          this.eventHandler.emitEvent(gy.LOGOUT_SUCCESS, this.correlationId, f_.Redirect, t);
          return;
        }
      }
      t.state = ym(this.browserCrypto, t.state || ``, {
        interactionType: f_.Redirect
      }, t.correlationId);
      let a = i.getLogoutUri(t);
      t.account?.homeAccountId && this.eventHandler.emitEvent(gy.LOGOUT_SUCCESS, this.correlationId, f_.Redirect, t);
      let o = this.config.auth.onRedirectNavigate;
      if (typeof o == `function`) {
        if (o(a) !== !1) {
          this.logger.verbose(`06v57e`, this.correlationId), this.browserStorage.getInteractionInProgress() || this.browserStorage.setInteractionInProgress(!0, o_.SIGNOUT), await this.navigationClient.navigateExternal(a, r);
          return;
        }
        this.browserStorage.setInteractionInProgress(!1), this.logger.verbose(`0xqes1`, this.correlationId);
      } else {
        this.browserStorage.getInteractionInProgress() || this.browserStorage.setInteractionInProgress(!0, o_.SIGNOUT), await this.navigationClient.navigateExternal(a, r);
        return;
      }
    } catch (e) {
      throw e instanceof Sl && (e.correlationId = this.correlationId, n.cacheFailedRequest(e)), this.eventHandler.emitEvent(gy.LOGOUT_FAILURE, this.correlationId, f_.Redirect, null, e), this.eventHandler.emitEvent(gy.LOGOUT_END, this.correlationId, f_.Redirect), e;
    }
    this.eventHandler.emitEvent(gy.LOGOUT_END, this.correlationId, f_.Redirect);
  }
  getRedirectStartPage(e) {
    let t = e || window.location.href,
      n = Yu.getAbsoluteUrl(t, wv(), this.correlationId);
    return up(n, this.logger, this.correlationId), n;
  }
};
async function Ub(e, t, n, r) {
  if (!t) throw n.info(`1l7hyp`, r), Y(ag, r);
  return e.src = t, e;
}
async function Wb(e, t, n, r, i, a) {
  if (!e.contentDocument) throw `No document associated with iframe!`;
  return (await vb(e.contentDocument, t, n, r, i, a)).submit(), e;
}
async function Gb(e, t, n, r, i, a) {
  if (!e.contentDocument) throw `No document associated with iframe!`;
  return (await gb(e.contentDocument, t, n, r, i, a)).submit(), e;
}
function Kb() {
  let e = document.createElement(`iframe`);
  return e.className = `msalSilentIframe`, e.title = `Microsoft Authentication`, e.style.visibility = `hidden`, e.style.position = `absolute`, e.style.width = e.style.height = `0`, e.style.border = `0`, e.setAttribute(`sandbox`, `allow-scripts allow-same-origin allow-forms`), e.setAttribute(`allow`, `local-network-access *`), document.body.appendChild(e), e;
}
function qb(e) {
  document.body === e.parentNode && document.body.removeChild(e);
}
var Jb = class extends Hy {
    constructor(e, t, n, r, i, a, o, s, c, l, u, d, f) {
      super(e, t, n, r, i, a, s, l, u, f), this.apiId = o, this.nativeStorage = c, this.waitForIframeResponseHook = d;
    }
    async acquireToken(e) {
      !e.loginHint && !e.sid && (!e.account || !e.account.username) && this.logger.warning(`1kl318`, this.correlationId);
      let t = {
        ...e
      };
      t.prompt ? t.prompt !== Qc.NONE && t.prompt !== Qc.NO_SESSION && (this.logger.warning(`0bmctg ${t.prompt} ${Qc.NONE}`, this.correlationId), t.prompt = Qc.NONE) : t.prompt = Qc.NONE;
      let n = await J(Uy, Ch, this.logger, this.performanceClient, this.correlationId)(t, f_.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
      return n.platformBroker = zb(this.config, this.logger, this.correlationId, this.platformAuthProvider, n.authenticationScheme), Nv(n.authority), this.config.system.protocolMode === pu.EAR ? this.executeEarFlow(n) : this.executeCodeFlow(n);
    }
    async executeCodeFlow(e) {
      let t,
        n = My(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled);
      try {
        return t = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, e.correlationId)({
          serverTelemetryManager: n,
          requestAuthority: e.authority,
          requestAzureCloudOptions: e.azureCloudOptions,
          requestExtraQueryParameters: e.extraQueryParameters,
          account: e.account
        }), await J(this.silentTokenHelper.bind(this), vh, this.logger, this.performanceClient, e.correlationId)(t, e);
      } catch (r) {
        if (r instanceof Sl && (r.correlationId = this.correlationId, n.cacheFailedRequest(r)), !t || !(r instanceof Sl) || r.errorCode !== t_.INVALID_GRANT_ERROR) throw r;
        return this.performanceClient.addFields({
          retryError: r.errorCode
        }, this.correlationId), await J(this.silentTokenHelper.bind(this), vh, this.logger, this.performanceClient, this.correlationId)(t, e);
      }
    }
    async executeEarFlow(e) {
      let {
          correlationId: t,
          authority: n,
          azureCloudOptions: r,
          extraQueryParameters: i,
          account: a
        } = e,
        o = await J(Ny, uh, this.logger, this.performanceClient, t)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, n, r, i, a),
        s = await J(ev, Xh, this.logger, this.performanceClient, t)(),
        c = await J(wb, zh, this.logger, this.performanceClient, t)(this.performanceClient, this.logger, t),
        l = {
          ...e,
          earJwk: s,
          codeChallenge: c.challenge
        },
        u = Kb(),
        d = this.config.auth.OIDCOptions.responseMode,
        f;
      try {
        let n = J(this.waitForIframeResponse.bind(this), bh, this.logger, this.performanceClient, t)(u, e);
        n.catch(() => {}), await J(Gb, yh, this.logger, this.performanceClient, t)(u, this.config, o, l, this.logger, this.performanceClient), f = await n;
      } finally {
        Fd(qb, Lh, this.logger, this.performanceClient, t)(u);
      }
      let p = Fd(qy, jh, this.logger, this.performanceClient, t)(f, d, this.logger, this.correlationId);
      if (!p.ear_jwe && p.code) {
        let n = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, t)({
          serverTelemetryManager: My(this.apiId, this.config.auth.clientId, t, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
          requestAuthority: e.authority,
          requestAzureCloudOptions: e.azureCloudOptions,
          requestExtraQueryParameters: e.extraQueryParameters,
          account: e.account,
          authority: o
        });
        return J(xb, kh, this.logger, this.performanceClient, t)(l, p, c.verifier, this.apiId, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
      }
      return J(Sb, Dh, this.logger, this.performanceClient, t)(l, p, this.apiId, this.config, o, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async verifySso(e) {
      let t = {
        ...e
      };
      t.prompt ||= Qc.NONE;
      let n = await J(Uy, Ch, this.logger, this.performanceClient, this.correlationId)(t, f_.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId),
        r = await J(this.createAuthCodeClient.bind(this), xh, this.logger, this.performanceClient, this.correlationId)({
          serverTelemetryManager: My(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
          requestAuthority: n.authority,
          requestAzureCloudOptions: n.azureCloudOptions,
          requestExtraQueryParameters: n.extraQueryParameters,
          account: n.account
        }),
        {
          serverParams: i
        } = await this.silentAuthorizeHelper(r, n),
        a = n.correlationId;
      return zm(i, n.state, a), i.code ? (this.logger.verbose(`0kkkcj`, a), !0) : (this.logger.warning(`0y34ti`, a), !1);
    }
    logout() {
      return Promise.reject(Y(xg, ``));
    }
    async silentTokenHelper(e, t) {
      let {
        serverParams: n,
        pkceCodes: r,
        silentRequest: i
      } = await this.silentAuthorizeHelper(e, t);
      return J(xb, kh, this.logger, this.performanceClient, t.correlationId)(i, n, r.verifier, this.apiId, this.config, e, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async silentAuthorizeHelper(e, t) {
      let n = t.correlationId,
        r = await J(wb, zh, this.logger, this.performanceClient, n)(this.performanceClient, this.logger, n),
        i = await Ry(t, this.tokenBindingKeyManager, this.logger, this.performanceClient),
        a = {
          ...t,
          codeChallenge: r.challenge,
          ...i
        },
        o = Kb(),
        s = this.config.auth.OIDCOptions.responseMode,
        c;
      try {
        let r = J(this.waitForIframeResponse.bind(this), bh, this.logger, this.performanceClient, n)(o, t);
        if (r.catch(() => {}), t.httpMethod === Gc.POST) await J(Wb, yh, this.logger, this.performanceClient, n)(o, this.config, e.authority, a, this.logger, this.performanceClient);else {
          let t = await J(mb, _d, this.logger, this.performanceClient, n)(this.config, e.authority, a, this.logger, this.performanceClient);
          await J(Ub, yh, this.logger, this.performanceClient, n)(o, t, this.logger, n);
        }
        c = await r;
      } finally {
        Fd(qb, Lh, this.logger, this.performanceClient, n)(o);
      }
      return {
        serverParams: Fd(qy, jh, this.logger, this.performanceClient, n)(c, s, this.logger, this.correlationId),
        pkceCodes: r,
        silentRequest: a
      };
    }
    async waitForIframeResponse(e, t) {
      return this.waitForIframeResponseHook ? this.waitForIframeResponseHook(e, t) : Cv(this.config.system.iframeBridgeTimeout, this.logger, t, this.performanceClient, this.config.experimental);
    }
  },
  Yb = class extends Hy {
    async acquireToken(e) {
      let t = await J(zy, hh, this.logger, this.performanceClient, e.correlationId)(e, this.config, this.performanceClient, this.logger, this.correlationId),
        n = await Ry(t, this.tokenBindingKeyManager, this.logger, this.performanceClient),
        r = {
          ...e,
          ...t,
          ...n
        };
      e.redirectUri && (r.redirectUri = jy(e.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId));
      let i = My(l_.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled),
        a = await this.createRefreshTokenClient({
          serverTelemetryManager: i,
          authorityUrl: r.authority,
          azureCloudOptions: r.azureCloudOptions,
          account: r.account
        });
      return J(a.acquireTokenByRefreshToken.bind(a), ph, this.logger, this.performanceClient, e.correlationId)(r, l_.acquireTokenSilent_silentFlow).catch(e => {
        throw e.correlationId = this.correlationId, i.cacheFailedRequest(e), e;
      });
    }
    logout() {
      return Promise.reject(Y(xg, ``));
    }
    async createRefreshTokenClient(e) {
      return new Wm(await J(this.getClientConfiguration.bind(this), Sh, this.logger, this.performanceClient, this.correlationId)({
        serverTelemetryManager: e.serverTelemetryManager,
        requestAuthority: e.authorityUrl,
        requestAzureCloudOptions: e.azureCloudOptions,
        requestExtraQueryParameters: e.extraQueryParameters,
        account: e.account
      }), this.performanceClient);
    }
  },
  Xb = class extends Fm {
    constructor(e, t) {
      super(e, t), this.includeRedirectUri = !1;
    }
  },
  Zb = class extends Hy {
    constructor(e, t, n, r, i, a, o, s, c, l, u) {
      super(e, t, n, r, i, a, s, c, l, u), this.apiId = o;
    }
    async acquireToken(e) {
      if (!e.code) throw Y(Ng, this.correlationId);
      let t = await J(Uy, Ch, this.logger, this.performanceClient, this.correlationId)(e, f_.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId),
        n = My(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, void 0, this.config.system.serverTelemetryEnabled);
      try {
        let r = await Ry(t, this.tokenBindingKeyManager, this.logger, this.performanceClient),
          i = {
            ...t,
            code: e.code,
            ...r
          },
          a = new Xb(await J(this.getClientConfiguration.bind(this), Sh, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: n,
            requestAuthority: t.authority,
            requestAzureCloudOptions: t.azureCloudOptions,
            requestExtraQueryParameters: t.extraQueryParameters,
            account: t.account
          }), this.performanceClient);
        this.logger.verbose(`1uic5e`, this.correlationId);
        let o = new Yy(a, this.browserStorage, i, this.logger, this.performanceClient);
        return await J(o.handleCodeResponseFromServer.bind(o), vd, this.logger, this.performanceClient, this.correlationId)({
          code: e.code,
          msgraph_host: e.msGraphHost,
          cloud_graph_host_name: e.cloudGraphHostName,
          cloud_instance_host_name: e.cloudInstanceHostName
        }, t, this.apiId, !1);
      } catch (e) {
        throw e instanceof Sl && (e.correlationId = this.correlationId, n.cacheFailedRequest(e)), e;
      }
    }
    logout() {
      return Promise.reject(Y(xg, ``));
    }
  };
function Qb(e, t, n, r) {
  let i = window.msal?.clientIds || [],
    a = i.length,
    o = i.filter(t => t === e).length;
  o > 1 && n.warning(`1e88vg`, r), t.add({
    msalInstanceCount: a,
    sameClientIdInstanceCount: o
  });
}
function $b(e, t, n, r) {
  try {
    jv(e), $m(n.auth.isMcp, r);
  } catch (e) {
    throw t.end({
      success: !1
    }, e, r.account), e;
  }
}
var ex = class e {
  constructor(e) {
    this.operatingContext = e, this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment(), this.config = e.getConfig(), this.initialized = !1, this.logger = this.operatingContext.getLogger(), this.networkClient = this.config.system.networkClient, this.navigationClient = this.config.system.navigationClient, this.redirectResponse = new Map(), this.hybridAuthCodeResponses = new Map(), this.performanceClient = this.config.telemetry.client, this.isBrowserEnvironment ? (this.browserCrypto = new zv(this.logger, this.performanceClient), this.tokenBindingKeyManager = new Rv(this.logger, this.performanceClient)) : (this.browserCrypto = fp, this.tokenBindingKeyManager = pp), this.eventHandler = new ky(this.logger), this.browserStorage = this.isBrowserEnvironment ? new xy(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, uf(this.config.auth), this.tokenBindingKeyManager) : Cy(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler, void 0, this.tokenBindingKeyManager);
    let t = {
      cacheLocation: i_.MemoryStorage,
      cacheRetentionDays: 5
    };
    this.nativeInternalStorage = new xy(this.config.auth.clientId, t, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, void 0, this.tokenBindingKeyManager), this.activeSilentTokenRequests = new Map(), this.trackStateChange = this.trackStateChange.bind(this), this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
  }
  static async createController(t, n) {
    let r = new e(t);
    return await r.initialize(n), r;
  }
  trackStateChange(e, t) {
    e && (t.type === `visibilitychange` ? (this.logger.info(`16v6hv`, e), this.performanceClient.incrementFields({
      visibilityChangeCount: 1
    }, e)) : t.type === `online` ? (this.logger.info(`0zirfd`, e), this.performanceClient.incrementFields({
      onlineStatusChangeCount: 1
    }, e)) : t.type === `offline` && (this.logger.info(`1xk9ef`, e), this.performanceClient.incrementFields({
      onlineStatusChangeCount: 1
    }, e)));
  }
  async initialize(e) {
    let t = this.getRequestCorrelationId(e);
    if (this.logger.trace(`1f7joy`, t), this.initialized) {
      this.logger.info(`061m5x`, t);
      return;
    }
    if (!this.isBrowserEnvironment) {
      this.logger.info(`19fvpi`, t), this.initialized = !0, this.eventHandler.emitEvent(gy.INITIALIZE_END, t);
      return;
    }
    let n = this.config.system.allowPlatformBroker,
      r = this.performanceClient.startMeasurement(Kv, t);
    if (this.eventHandler.emitEvent(gy.INITIALIZE_START, t), this.logMultipleInstances(r, t), r.add({
      isMcp: this.config.auth.isMcp
    }), await J(this.browserStorage.initialize.bind(this.browserStorage), _h, this.logger, this.performanceClient, t)(t), n) try {
      this.platformAuthProvider = await Rb(this.logger, this.performanceClient, t, this.config.system.nativeBrokerHandshakeTimeout, this.config.experimental.allowPlatformBrokerWithDOM);
    } catch (e) {
      this.logger.verbose(e, t);
    }
    this.config.cache.cacheLocation === i_.LocalStorage && this.eventHandler.subscribeCrossTab(), !this.config.system.navigatePopups && (await this.preGeneratePkceCodes(t)), this.initialized = !0, this.eventHandler.emitEvent(gy.INITIALIZE_END, t), r.end({
      allowPlatformBroker: n,
      success: !0
    });
  }
  async handleRedirectPromise(e) {
    if (this.logger.verbose(`02l8bm`, ``), Av(this.initialized), this.isBrowserEnvironment) {
      let t = e?.hash || ``,
        n = this.redirectResponse.get(t);
      return n === void 0 ? (n = this.handleRedirectPromiseInternal(e), this.redirectResponse.set(t, n), this.logger.verbose(`1wn9kp`, ``)) : this.logger.verbose(`0w0gm3`, ``), n;
    }
    return this.logger.verbose(`12xi63`, ``), null;
  }
  async handleRedirectPromiseInternal(e) {
    if (!this.browserStorage.isInteractionInProgress(!0)) return this.logger.info(`0le6uv`, ``), null;
    if (this.browserStorage.getInteractionInProgress()?.type === o_.SIGNOUT) return this.logger.verbose(`1ywcv2`, ``), this.browserStorage.setInteractionInProgress(!1), Promise.resolve(null);
    let t = this.getAllAccounts(),
      n = this.browserStorage.getCachedNativeRequest(),
      r = n && !e?.hash,
      i,
      a,
      o;
    try {
      if (r && this.platformAuthProvider) {
        let e = n?.correlationId || ``;
        this.eventHandler.emitEvent(gy.HANDLE_REDIRECT_START, e, f_.Redirect), i = this.performanceClient.startMeasurement(Wv, e), this.logger.trace(`12v7is`, e), i.add({
          isPlatformBrokerRequest: !0
        });
        let t = new lb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, l_.handleRedirectPromise, this.performanceClient, this.platformAuthProvider, n.accountId, this.nativeInternalStorage, n.correlationId, this.tokenBindingKeyManager);
        a = J(t.handleRedirectPromise.bind(t), Fh, this.logger, this.performanceClient, i.event.correlationId)();
      } else {
        let [t, n] = this.browserStorage.getCachedRequest(``);
        o = t;
        let r = t.correlationId;
        this.eventHandler.emitEvent(gy.HANDLE_REDIRECT_START, r, f_.Redirect), i = this.performanceClient.startMeasurement(Wv, r), this.logger.trace(`0znzs5`, r);
        let s = this.createRedirectClient(r);
        a = J(s.handleRedirectPromise.bind(s), Ph, this.logger, this.performanceClient, i.event.correlationId)(t, n, i, e);
      }
    } catch (e) {
      throw this.browserStorage.resetRequestCache(``), e;
    }
    return a.then(e => (e ? (this.browserStorage.resetRequestCache(e.correlationId), this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_SUCCESS, e.correlationId, f_.Redirect, e), this.logger.verbose(`0ui8f5`, e.correlationId), t.length < this.getAllAccounts().length && (this.eventHandler.emitEvent(gy.LOGIN_SUCCESS, e.correlationId, f_.Redirect, e.account), this.logger.verbose(`16im3l`, e.correlationId)), i.end({
      success: !0,
      isNativeBroker: e.fromPlatformBroker ?? !1
    }, void 0, e.account), this.verifySsoCapability(o, f_.Redirect)) : i.event.errorCode ? i.end({
      success: !1
    }) : i.discard(), this.eventHandler.emitEvent(gy.HANDLE_REDIRECT_END, i.event.correlationId, f_.Redirect), e)).catch(e => {
      this.browserStorage.resetRequestCache(i.event.correlationId);
      let t = e;
      throw this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, i.event.correlationId, f_.Redirect, null, t), this.eventHandler.emitEvent(gy.HANDLE_REDIRECT_END, i.event.correlationId, f_.Redirect), i.end({
        success: !1
      }, t), e;
    });
  }
  async acquireTokenRedirect(e) {
    let t = this.getRequestCorrelationId(e);
    this.logger.verbose(`0os66p`, t), Mv(this.initialized, this.config), this.browserStorage.setInteractionInProgress(!0, o_.SIGNIN);
    let n = this.performanceClient.startMeasurement(Uv, t);
    n.add({
      scenarioId: e.scenarioId
    });
    let r = this.config.auth.onRedirectNavigate;
    this.config.auth.onRedirectNavigate = t => {
      let i = typeof r == `function` ? r(t) : void 0;
      return n.add({
        navigateCallbackResult: i !== !1
      }), n.event = n.end({
        success: !0
      }, void 0, e.account) || n.event, i;
    };
    try {
      $m(this.config.auth.isMcp, e), this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_START, t, f_.Redirect, e);
      let r;
      if (this.platformAuthProvider && this.canUsePlatformBroker(e)) {
        let i = new lb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, l_.acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(e), this.nativeInternalStorage, t, this.tokenBindingKeyManager);
        r = J(i.acquireTokenRedirect.bind(i), fh, this.logger, this.performanceClient, t)(e, n).catch(n => {
          if (n instanceof ab && ob(n)) return this.platformAuthProvider = void 0, this.createRedirectClient(t).acquireToken(e);
          if (n instanceof hm) return this.logger.verbose(`1ipyz4`, t), this.createRedirectClient(t).acquireToken(e);
          throw n;
        });
      } else r = this.createRedirectClient(t).acquireToken(e);
      return await r;
    } catch (r) {
      throw this.browserStorage.resetRequestCache(t), n.event.status === 2 ? this.performanceClient.startMeasurement(Wv, t).end({
        success: !1
      }, r, e.account) : n.end({
        success: !1
      }, r, e.account), this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, t, f_.Redirect, null, r), r;
    }
  }
  acquireTokenPopup(e) {
    let t = this.getRequestCorrelationId(e),
      n = this.performanceClient.startMeasurement(Hv, t);
    n.add({
      scenarioId: e.scenarioId
    });
    try {
      this.logger.verbose(`0ch87b`, t), $b(this.initialized, n, this.config, e), this.browserStorage.setInteractionInProgress(!0, o_.SIGNIN, e.overrideInteractionInProgress, t);
    } catch (e) {
      return Promise.reject(e);
    }
    let r = this.getAllAccounts();
    this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_START, t, f_.Popup, e);
    let i,
      a = this.getPreGeneratedPkceCodes(t);
    return this.canUsePlatformBroker(e) ? (n.add({
      isPlatformBrokerRequest: !0
    }), i = this.acquireTokenNative({
      ...e,
      correlationId: t
    }, l_.acquireTokenPopup).then(e => (n.end({
      success: !0,
      isNativeBroker: e.fromPlatformBroker ?? !1
    }, void 0, e.account), e)).catch(n => {
      if (n instanceof ab && ob(n)) return this.platformAuthProvider = void 0, this.createPopupClient(t).acquireToken(e, a);
      if (n instanceof hm) return this.logger.verbose(`0yy5fw`, t), this.createPopupClient(t).acquireToken(e, a);
      throw n;
    })) : i = this.createPopupClient(t).acquireToken(e, a), i.then(i => {
      let a = r.length < this.getAllAccounts().length;
      return this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_SUCCESS, t, f_.Popup, i), a && this.eventHandler.emitEvent(gy.LOGIN_SUCCESS, t, f_.Popup, i.account), n.end({
        success: !0,
        isNativeBroker: i.fromPlatformBroker ?? !1,
        accessTokenSize: i.accessToken.length,
        idTokenSize: i.idToken.length
      }, void 0, i.account), this.verifySsoCapability(e, f_.Popup), i;
    }).catch(r => (this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, t, f_.Popup, null, r), n.end({
      success: !1
    }, r, e.account), Promise.reject(r))).finally(async () => {
      this.browserStorage.setInteractionInProgress(!1), this.config.system.navigatePopups || (await this.preGeneratePkceCodes(t));
    });
  }
  trackStateChangeWithMeasurement(e) {
    let t = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
    t && (e.type === `visibilitychange` ? (this.logger.info(`0yzimq ${t.event.name}`, t.event.correlationId), t.increment({
      visibilityChangeCount: 1
    })) : e.type === `online` ? (this.logger.info(`1caf53 ${t.event.name}`, t.event.correlationId), t.increment({
      onlineStatusChangeCount: 1
    })) : e.type === `offline` && (this.logger.info(`0fdyk7 ${t.event.name}`, t.event.correlationId), t.increment({
      onlineStatusChangeCount: 1
    })));
  }
  addStateChangeListeners(e) {
    document.addEventListener(`visibilitychange`, e), window.addEventListener(`online`, e), window.addEventListener(`offline`, e);
  }
  removeStateChangeListeners(e) {
    document.removeEventListener(`visibilitychange`, e), window.removeEventListener(`online`, e), window.removeEventListener(`offline`, e);
  }
  getCachedSsoCapable() {
    try {
      let e = window.localStorage.getItem(ny);
      if (e) {
        let t = JSON.parse(e);
        if (t && typeof t.ssoCapable == `boolean` && t.expiresOn && Date.now() < t.expiresOn) return t.ssoCapable;
      }
    } catch {}
  }
  verifySsoCapability(e, t) {
    if (!this.config.auth.verifySSO) return;
    let n = ny;
    if (this.getCachedSsoCapable() !== void 0) {
      this.logger.verbose(`13poou ${t}`, ``);
      return;
    }
    let r = X_(),
      i = this.performanceClient.startMeasurement(Jv, r);
    i.add({
      "ext.interactionType": t
    }), this.logger.verbose(`0pbr0i ${t}`, r), setTimeout(() => {
      let a = {
        ...e,
        correlationId: r
      };
      this.createSilentIframeClient(r).verifySso(a).then(e => {
        this.logger.verbose(`1gd1iv ${t} ${e}`, r);
        try {
          let t = JSON.stringify({
            ssoCapable: e,
            expiresOn: Date.now() + 864e5
          });
          window.localStorage.setItem(n, t);
        } catch {
          this.logger.warning(`18lmoj ${t}`, r);
        }
        i.end({
          fromCache: !1,
          success: e
        }, void 0);
      }).catch(e => {
        this.logger.warning(`05g83w ${t} ${e.message}`, r);
        try {
          window.localStorage.removeItem(n);
        } catch {
          this.logger.warning(`0nlf9q ${t}`, r);
        }
        i.end({
          fromCache: !1,
          success: !1
        }, e);
      });
    }, 0);
  }
  async ssoSilent(e) {
    let t = this.getRequestCorrelationId(e),
      n = {
        ...e,
        correlationId: t
      };
    this.ssoSilentMeasurement = this.performanceClient.startMeasurement(Gv, t), this.ssoSilentMeasurement?.add({
      scenarioId: e.scenarioId,
      ssoCapable: this.getCachedSsoCapable()
    }), $b(this.initialized, this.ssoSilentMeasurement, this.config, n), this.ssoSilentMeasurement?.increment({
      visibilityChangeCount: 0,
      onlineStatusChangeCount: 0
    }), this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
    let r = this.getAllAccounts();
    this.logger.verbose(`0w1b45`, t), this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_START, t, f_.Silent, n);
    let i;
    return this.canUsePlatformBroker(n) ? (this.ssoSilentMeasurement?.add({
      isPlatformBrokerRequest: !0
    }), i = this.acquireTokenNative(n, l_.ssoSilent).catch(e => {
      if (e instanceof ab && ob(e)) return this.platformAuthProvider = void 0, this.createSilentIframeClient(n.correlationId).acquireToken(n);
      throw e;
    })) : i = this.createSilentIframeClient(n.correlationId).acquireToken(n), i.then(e => {
      let n = r.length < this.getAllAccounts().length;
      return this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_SUCCESS, t, f_.Silent, e), n && this.eventHandler.emitEvent(gy.LOGIN_SUCCESS, t, f_.Silent, e.account), this.ssoSilentMeasurement?.end({
        success: !0,
        isNativeBroker: e.fromPlatformBroker ?? !1,
        accessTokenSize: e.accessToken.length,
        idTokenSize: e.idToken.length
      }, void 0, e.account), e;
    }).catch(n => {
      throw this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, t, f_.Silent, null, n), this.ssoSilentMeasurement?.end({
        success: !1
      }, n, e.account), n;
    }).finally(() => {
      this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
    });
  }
  async acquireTokenByCode(e) {
    let t = this.getRequestCorrelationId(e);
    this.logger.trace(`0ch6ga`, t);
    let n = this.performanceClient.startMeasurement(Vv, t);
    $b(this.initialized, n, this.config, e), this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_START, t, f_.Silent, e), n.add({
      scenarioId: e.scenarioId
    });
    try {
      if (e.code && e.nativeAccountId) throw Y(Fg, t);
      if (e.code) {
        let r = e.code,
          i = this.hybridAuthCodeResponses.get(r);
        return i ? (this.logger.verbose(`0qgp28`, t), n.discard()) : (this.logger.verbose(`06eh73`, t), i = this.acquireTokenByCodeAsync({
          ...e,
          correlationId: t
        }).then(e => (this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_SUCCESS, t, f_.Silent, e), this.hybridAuthCodeResponses.delete(r), n.end({
          success: !0,
          isNativeBroker: !1,
          accessTokenSize: e.accessToken.length,
          idTokenSize: e.idToken.length
        }, void 0, e.account), e)).catch(e => {
          throw this.hybridAuthCodeResponses.delete(r), this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, t, f_.Silent, null, e), n.end({
            success: !1
          }, e), e;
        }), this.hybridAuthCodeResponses.set(r, i)), await i;
      }
      if (e.nativeAccountId) {
        if (this.canUsePlatformBroker(e, e.nativeAccountId)) {
          n.add({
            isPlatformBrokerRequest: !0
          });
          let r = await this.acquireTokenNative({
            ...e,
            correlationId: t
          }, l_.acquireTokenByCode, e.nativeAccountId).catch(e => {
            throw e instanceof ab && ob(e) && (this.platformAuthProvider = void 0), e;
          });
          return n.end({
            success: !0,
            isNativeBroker: r.fromPlatformBroker ?? !1
          }, void 0, r.account), r;
        }
        throw Y(Lg, t);
      }
      throw Y(Pg, t);
    } catch (e) {
      throw this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, t, f_.Silent, null, e), n.end({
        success: !1
      }, e), e;
    }
  }
  async acquireTokenByCodeAsync(e) {
    let t = this.getRequestCorrelationId(e);
    return this.logger.trace(`10d9hy`, t), this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement(Nh, t), this.acquireTokenByCodeAsyncMeasurement?.increment({
      visibilityChangeCount: 0,
      onlineStatusChangeCount: 0
    }), this.addStateChangeListeners(this.trackStateChangeWithMeasurement), await this.createSilentAuthCodeClient(t).acquireToken(e).then(e => (this.acquireTokenByCodeAsyncMeasurement?.end({
      success: !0,
      isNativeBroker: !1,
      fromCache: e.fromCache
    }), e)).catch(e => {
      throw this.acquireTokenByCodeAsyncMeasurement?.end({
        success: !1
      }, e), e;
    }).finally(() => {
      this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
    });
  }
  async acquireTokenFromCache(e, t) {
    switch (t) {
      case g_.Default:
      case g_.AccessToken:
      case g_.AccessTokenAndRefreshToken:
        let t = this.createSilentCacheClient(e.correlationId);
        return J(t.acquireToken.bind(t), oh, this.logger, this.performanceClient, e.correlationId)(e);
      default:
        throw q(Jl, e.correlationId);
    }
  }
  async acquireTokenByRefreshToken(e, t) {
    switch (t) {
      case g_.Default:
      case g_.AccessTokenAndRefreshToken:
      case g_.RefreshToken:
      case g_.RefreshTokenAndNetwork:
        let t = this.createSilentRefreshClient(e.correlationId);
        return J(t.acquireToken.bind(t), lh, this.logger, this.performanceClient, e.correlationId)(e);
      default:
        throw q(Jl, e.correlationId);
    }
  }
  async acquireTokenBySilentIframe(e) {
    let t = this.createSilentIframeClient(e.correlationId);
    return J(t.acquireToken.bind(t), sh, this.logger, this.performanceClient, e.correlationId)(e);
  }
  async logoutRedirect(e) {
    let t = this.getRequestCorrelationId(e);
    return Mv(this.initialized, this.config), this.browserStorage.setInteractionInProgress(!0, o_.SIGNOUT), this.createRedirectClient(t).logout(e);
  }
  logoutPopup(e) {
    try {
      let t = this.getRequestCorrelationId(e);
      return jv(this.initialized), this.browserStorage.setInteractionInProgress(!0, o_.SIGNOUT), this.createPopupClient(t).logout(e).finally(() => {
        this.browserStorage.setInteractionInProgress(!1);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }
  async clearCache(e) {
    if (!this.isBrowserEnvironment) return;
    let t = this.getRequestCorrelationId(e);
    return this.createSilentCacheClient(t).logout(e);
  }
  getAllAccounts(e) {
    return wy(this.logger, this.browserStorage, this.isBrowserEnvironment, this.getRequestCorrelationId(), e);
  }
  getAccount(e) {
    return Ty(e, this.logger, this.browserStorage, this.getRequestCorrelationId());
  }
  setActiveAccount(e) {
    Ey(e, this.browserStorage, this.getRequestCorrelationId());
  }
  getActiveAccount() {
    return Dy(this.browserStorage, this.getRequestCorrelationId());
  }
  async hydrateCache(e, t) {
    this.logger.verbose(`16jycr`, e.correlationId);
    let n = gu(e.account, e.cloudGraphHostName, e.msGraphHost);
    if (await this.browserStorage.setAccount(n, e.correlationId, ou(e.idTokenClaims), l_.hydrateCache), e.fromPlatformBroker) {
      this.logger.verbose(`1i5atf`, e.correlationId);
      let n = Ud(e.account.homeAccountId, e.account.environment, e.idToken, this.config.auth.clientId, e.tenantId),
        r = of(t.attributeTokens),
        i = r ? {
          attribute_tokens: r
        } : void 0,
        a = Wd(e.account.homeAccountId, e.account.environment, e.accessToken, this.config.auth.clientId, e.tenantId, e.scopes.join(` `), e.expiresOn ? Rd(e.expiresOn) : 0, e.extExpiresOn ? Rd(e.extExpiresOn) : 0, $g, t.correlationId || ``, void 0, e.tokenType, void 0, t.sshKid, i);
      t.resource && (a.resource = t.resource);
      let o = i,
        s = o ? await this.browserCrypto.hashString(JSON.stringify(o)) : void 0,
        c = ou(e.idTokenClaims);
      await this.browserStorage.setIdTokenCredential(n, e.correlationId, c), await this.nativeInternalStorage.setAccessTokenCredential(a, e.correlationId, c, s);
    } else return this.browserStorage.hydrateCache(e, t);
  }
  async acquireTokenNative(e, t, n, r) {
    let i = this.getRequestCorrelationId(e);
    if (this.logger.trace(`0b9y3p`, i), !this.platformAuthProvider) throw Y(Bg, i);
    let a = new lb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, t, this.performanceClient, this.platformAuthProvider, n || this.getNativeAccountId(e), this.nativeInternalStorage, i, this.tokenBindingKeyManager);
    return J(a.acquireToken.bind(a), dh, this.logger, this.performanceClient, i)(e, r);
  }
  canUsePlatformBroker(e, t) {
    let n = this.getRequestCorrelationId(e);
    if (this.logger.trace(`1n9lbl`, n), !this.platformAuthProvider) return this.logger.trace(`0vnu11`, n), !1;
    if (!zb(this.config, this.logger, n, this.platformAuthProvider, e.authenticationScheme)) return this.logger.trace(`0yoy1g`, n), !1;
    if (e.prompt) switch (e.prompt) {
      case Qc.NONE:
      case Qc.CONSENT:
      case Qc.LOGIN:
        this.logger.trace(`0vdv8e`, n);
        break;
      default:
        return this.logger.trace(`0pdzw6 ${e.prompt}`, n), !1;
    }
    return !t && !this.getNativeAccountId(e) ? (this.logger.trace(`16lbtk`, n), !1) : !0;
  }
  getNativeAccountId(e) {
    let t = e.account || this.getAccount({
      loginHint: e.loginHint,
      sid: e.sid
    }) || (!e.loginHint && !e.sid ? this.getActiveAccount() : null);
    return t && t.nativeAccountId || ``;
  }
  createPopupClient(e) {
    return new Bb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, e, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForPopupResponse, this.tokenBindingKeyManager);
  }
  createRedirectClient(e) {
    return new Hb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, e, this.platformAuthProvider, this.tokenBindingKeyManager);
  }
  createSilentIframeClient(e) {
    return new Jb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, l_.ssoSilent, this.performanceClient, this.nativeInternalStorage, e, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForIframeResponse, this.tokenBindingKeyManager);
  }
  createSilentCacheClient(e) {
    return new cb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, e, this.platformAuthProvider, this.tokenBindingKeyManager);
  }
  createSilentRefreshClient(e) {
    return new Yb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, e, this.platformAuthProvider, this.tokenBindingKeyManager);
  }
  createSilentAuthCodeClient(e) {
    return new Zb(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, l_.acquireTokenByCode, this.performanceClient, e, this.platformAuthProvider, this.tokenBindingKeyManager);
  }
  addEventCallback(e, t) {
    return this.eventHandler.addEventCallback(e, t);
  }
  removeEventCallback(e) {
    this.eventHandler.removeEventCallback(e);
  }
  addPerformanceCallback(e) {
    return kv(), this.performanceClient.addPerformanceCallback(e);
  }
  removePerformanceCallback(e) {
    return this.performanceClient.removePerformanceCallback(e);
  }
  getLogger() {
    return this.logger;
  }
  setLogger(e) {
    this.logger = e;
  }
  initializeWrapperLibrary(e, t) {
    this.browserStorage.setWrapperMetadata(e, t);
  }
  setNavigationClient(e) {
    this.navigationClient = e;
  }
  getConfiguration() {
    return this.config;
  }
  getPerformanceClient() {
    return this.performanceClient;
  }
  isBrowserEnv() {
    return this.isBrowserEnvironment;
  }
  getRequestCorrelationId(e) {
    return e?.correlationId ? e.correlationId : this.isBrowserEnvironment ? X_() : ``;
  }
  async loginRedirect(e) {
    let t = this.getRequestCorrelationId(e);
    return this.logger.verbose(`0lz9hf`, t), this.acquireTokenRedirect({
      correlationId: t,
      ...(e || p_)
    });
  }
  loginPopup(e) {
    let t = this.getRequestCorrelationId(e);
    return this.logger.verbose(`0qw7v5`, t), this.acquireTokenPopup({
      correlationId: t,
      ...(e || p_)
    });
  }
  async acquireTokenSilent(e) {
    let t = this.getRequestCorrelationId(e),
      n = this.performanceClient.startMeasurement(Bv, t);
    n.add({
      cacheLookupPolicy: e.cacheLookupPolicy,
      scenarioId: e.scenarioId,
      ssoCapable: this.getCachedSsoCapable()
    }), $b(this.initialized, n, this.config, e), this.logger.verbose(`0x1c4s`, t);
    let r = e.account || this.getActiveAccount();
    if (!r) throw Y(Sg, t);
    return this.acquireTokenSilentDeduped(e, r, t).then(r => (n.end({
      success: !0,
      isNativeBroker: r.fromPlatformBroker ?? !1,
      fromCache: r.fromCache,
      accessTokenSize: r.accessToken.length,
      idTokenSize: r.idToken.length
    }, void 0, r.account), {
      ...r,
      state: e.state,
      correlationId: t
    })).catch(e => {
      throw e instanceof Sl && (e.correlationId = t), n.end({
        success: !1
      }, e, r), e;
    });
  }
  async acquireTokenSilentDeduped(e, t, n) {
    let r = Em(this.config.auth.clientId, {
        ...e,
        authority: e.authority || this.config.auth.authority,
        correlationId: n
      }, t.homeAccountId),
      i = JSON.stringify(r),
      a = this.activeSilentTokenRequests.get(i);
    if (a === void 0) {
      this.logger.verbose(`0fcjbk`, n), this.performanceClient.addFields({
        deduped: !1
      }, n);
      let r = J(this.acquireTokenSilentAsync.bind(this), rh, this.logger, this.performanceClient, n)({
        ...e,
        correlationId: n
      }, t);
      return this.activeSilentTokenRequests.set(i, r), r.finally(() => {
        this.activeSilentTokenRequests.delete(i);
      });
    }
    return this.logger.verbose(`1yq7nb`, n), this.performanceClient.addFields({
      deduped: !0
    }, n), a;
  }
  async acquireTokenSilentAsync(e, t) {
    let n = t => this.trackStateChange(e.correlationId, t);
    this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_START, e.correlationId, f_.Silent, e), e.correlationId && this.performanceClient.incrementFields({
      visibilityChangeCount: 0,
      onlineStatusChangeCount: 0
    }, e.correlationId), this.addStateChangeListeners(n);
    let r = await J(By, gh, this.logger, this.performanceClient, e.correlationId)(e, t, this.config, this.performanceClient, this.logger),
      i = e.cacheLookupPolicy || g_.Default;
    return this.acquireTokenSilentNoIframe(r, i).catch(async t => {
      if (tx(t, i)) {
        let n = `${t.errorCode}${t.subError ? `|${t.subError}` : ``}`;
        if (this.performanceClient.addFields({
          silentRefreshReason: n
        }, e.correlationId), !this.activeIframeRequest) {
          let e;
          return this.activeIframeRequest = [new Promise(t => {
            e = t;
          }), r.correlationId], this.logger.verbose(`0rh08z`, r.correlationId), J(this.acquireTokenBySilentIframe.bind(this), mh, this.logger, this.performanceClient, r.correlationId)(r).then(t => (e(!0), t)).catch(t => {
            throw e(!1), t;
          }).finally(() => {
            this.activeIframeRequest = void 0;
          });
        }
        if (i !== g_.Skip) {
          let [e, n] = this.activeIframeRequest;
          this.logger.verbose(`1w8fso ${n}`, r.correlationId);
          let a = this.performanceClient.startMeasurement(ch, r.correlationId);
          a.add({
            awaitIframeCorrelationId: n
          });
          let o = await e;
          if (a.end({
            success: o
          }), o) return this.logger.verbose(`0ywzzi ${n}`, r.correlationId), this.acquireTokenSilentNoIframe(r, i);
          throw this.logger.info(`17y14q ${n}`, r.correlationId), t;
        }
        return this.logger.warning(`1bd4p8`, r.correlationId), J(this.acquireTokenBySilentIframe.bind(this), mh, this.logger, this.performanceClient, r.correlationId)(r);
      }
      throw t;
    }).then(t => (this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_SUCCESS, e.correlationId, f_.Silent, t), e.correlationId && this.performanceClient.addFields({
      fromCache: t.fromCache,
      isNativeBroker: t.fromPlatformBroker ?? !1
    }, e.correlationId), t)).catch(t => {
      throw this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_FAILURE, e.correlationId, f_.Silent, null, t), t;
    }).finally(() => {
      this.removeStateChangeListeners(n);
    });
  }
  async acquireTokenSilentNoIframe(e, t) {
    return zb(this.config, this.logger, e.correlationId, this.platformAuthProvider, e.authenticationScheme) && e.account.nativeAccountId ? (this.logger.verbose(`0sczo4`, e.correlationId), this.performanceClient.addFields({
      isPlatformBrokerRequest: !0
    }, e.correlationId), this.acquireTokenNative(e, l_.acquireTokenSilent_silentFlow, e.account.nativeAccountId, t).catch(async t => {
      throw t instanceof ab && ob(t) ? (this.logger.verbose(`07rkmb`, e.correlationId), this.platformAuthProvider = void 0, q(Jl, e.correlationId)) : t;
    })) : (this.logger.verbose(`0ox81t`, e.correlationId), t === g_.AccessToken && this.logger.verbose(`0fvwxe`, e.correlationId), J(this.acquireTokenFromCache.bind(this), th, this.logger, this.performanceClient, e.correlationId)(e, t).catch(n => {
      if (t === g_.AccessToken) throw n;
      return this.eventHandler.emitEvent(gy.ACQUIRE_TOKEN_NETWORK_START, e.correlationId, f_.Silent, e), J(this.acquireTokenByRefreshToken.bind(this), nh, this.logger, this.performanceClient, e.correlationId)(e, t);
    }));
  }
  async preGeneratePkceCodes(e) {
    return this.logger.verbose(`1x6uj6`, e), this.pkceCode = await J(wb, zh, this.logger, this.performanceClient, e)(this.performanceClient, this.logger, e), Promise.resolve();
  }
  getPreGeneratedPkceCodes(e) {
    let t = this.pkceCode ? {
      ...this.pkceCode
    } : void 0;
    return this.pkceCode = void 0, t ? this.logger.verbose(`12js1o`, e) : this.logger.verbose(`1oe9ci`, e), this.performanceClient.addFields({
      usePreGeneratedPkce: !!t
    }, e), t;
  }
  logMultipleInstances(e, t) {
    let n = this.config.auth.clientId;
    window && (window.msal = window.msal || {}, window.msal.clientIds = window.msal.clientIds || [], window.msal.clientIds.length > 0 && this.logger.verbose(`1qtz3l`, t), window.msal.clientIds.push(n), Qb(n, e, this.logger, t));
  }
};
function tx(e, t) {
  let n = !(e instanceof hm && e.subError !== `bad_token`),
    r = e.errorCode === t_.INVALID_GRANT_ERROR || e.errorCode === `token_refresh_required`,
    i = n && r || e.errorCode === `no_tokens_found` || e.errorCode === `refresh_token_expired`,
    a = __.includes(t);
  return i && a;
}
var nx = class e {
    static loggerCallback(e, t) {
      switch (e) {
        case mp.Error:
          console.error(t);
          return;
        case mp.Info:
          console.info(t);
          return;
        case mp.Verbose:
          console.debug(t);
          return;
        case mp.Warning:
          console.warn(t);
          return;
        default:
          console.log(t);
          return;
      }
    }
    constructor(t, n) {
      this.browserEnvironment = typeof window < `u`, this.config = Fb(t, this.browserEnvironment), this.responseHandlers = n;
      let r;
      try {
        r = window[i_.SessionStorage];
      } catch {}
      let i = r?.getItem(Zv),
        a = r?.getItem(Qv)?.toLowerCase(),
        o = a === `true` || a !== `false` && void 0,
        s = {
          ...this.config.system.loggerOptions
        },
        c = i && Object.keys(mp).includes(i) ? mp[i] : void 0;
      c && (s.loggerCallback = e.loggerCallback, s.logLevel = c), o !== void 0 && (s.piiLoggingEnabled = o), this.logger = new xp(s, _y, vy), this.available = !1;
    }
    getConfig() {
      return this.config;
    }
    getResponseHandlers() {
      return this.responseHandlers;
    }
    getLogger() {
      return this.logger;
    }
    isAvailable() {
      return this.available;
    }
    isBrowserEnvironment() {
      return this.browserEnvironment;
    }
  },
  rx = class e extends nx {
    getModuleName() {
      return e.MODULE_NAME;
    }
    getId() {
      return e.ID;
    }
    async initialize(e) {
      return this.available = typeof window < `u`, this.available;
    }
  };
rx.MODULE_NAME = ``, rx.ID = `StandardOperatingContext`;
var ix = new class {
    constructor(e, t) {
      this.controller = t || new ex(new rx(e, {
        waitForPopupResponse: this.waitForPopupResponse.bind(this),
        waitForIframeResponse: this.waitForIframeResponse.bind(this)
      }));
    }
    async waitForPopupResponse(e, t, n) {
      let r = this.controller;
      return Cv(r.getConfiguration().system.popupBridgeTimeout, r.getLogger(), e, r.getPerformanceClient());
    }
    async waitForIframeResponse(e, t) {
      let n = this.controller,
        r = n.getConfiguration();
      return Cv(r.system.iframeBridgeTimeout, n.getLogger(), t, n.getPerformanceClient(), r.experimental);
    }
    async initialize(e) {
      return this.controller.initialize(e);
    }
    async acquireTokenPopup(e) {
      return this.controller.acquireTokenPopup(e);
    }
    acquireTokenRedirect(e) {
      return this.controller.acquireTokenRedirect(e);
    }
    acquireTokenSilent(e) {
      return this.controller.acquireTokenSilent(e);
    }
    acquireTokenByCode(e) {
      return this.controller.acquireTokenByCode(e);
    }
    addEventCallback(e, t) {
      return this.controller.addEventCallback(e, t);
    }
    removeEventCallback(e) {
      return this.controller.removeEventCallback(e);
    }
    addPerformanceCallback(e) {
      return this.controller.addPerformanceCallback(e);
    }
    removePerformanceCallback(e) {
      return this.controller.removePerformanceCallback(e);
    }
    getAccount(e) {
      return this.controller.getAccount(e);
    }
    getAllAccounts(e) {
      return this.controller.getAllAccounts(e);
    }
    handleRedirectPromise(e) {
      return this.controller.handleRedirectPromise(e);
    }
    loginPopup(e) {
      return this.controller.loginPopup(e);
    }
    loginRedirect(e) {
      return this.controller.loginRedirect(e);
    }
    logoutRedirect(e) {
      return this.controller.logoutRedirect(e);
    }
    logoutPopup(e) {
      return this.controller.logoutPopup(e);
    }
    ssoSilent(e) {
      return this.controller.ssoSilent(e);
    }
    getLogger() {
      return this.controller.getLogger();
    }
    setLogger(e) {
      this.controller.setLogger(e);
    }
    setActiveAccount(e) {
      this.controller.setActiveAccount(e);
    }
    getActiveAccount() {
      return this.controller.getActiveAccount();
    }
    initializeWrapperLibrary(e, t) {
      return this.controller.initializeWrapperLibrary(e, t);
    }
    setNavigationClient(e) {
      this.controller.setNavigationClient(e);
    }
    getConfiguration() {
      return this.controller.getConfiguration();
    }
    async hydrateCache(e, t) {
      return this.controller.hydrateCache(e, t);
    }
    clearCache(e) {
      return this.controller.clearCache(e);
    }
  }({
    auth: {
      clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || "be2b7655-fe3d-4245-a1d7-1e8e804547df",
      authority: import.meta.env.VITE_MICROSOFT_AUTHORITY || "https://login.microsoftonline.com/04e05ea3-3981-4a7b-9be2-17535cf34b8f",
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: !1
    },
    cache: {
      cacheLocation: `sessionStorage`
    }
  }),
  ax = null;
function ox() {
  return ax ||= ix.initialize(), ax;
}
async function sx() {
  await ox(), await ix.loginRedirect({
    scopes: [`User.Read`],
    prompt: `select_account`
  });
}
var cx = `w-full rounded-2xl border border-(--border) bg-(--bg) py-3 pl-11 pr-3 text-sm text-(--text-h) placeholder-(--text)/60 outline-none transition focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`;
var fx = `gth_theme`;
function px() {
  return localStorage.getItem(fx) === `dark` ? `dark` : `light`;
}
function mx(e) {
  document.documentElement.classList.toggle(`dark`, e === `dark`), localStorage.setItem(fx, e), _s();
}
function hx() {
  let e = px() === `dark` ? `light` : `dark`;
  return mx(e), e;
}
var gx = `X-Gestor-Llave`;
async function _x() {
  try {
    return typeof (await api(`/gestor`, {
      sinCache: !0,
      redirigirEn401: !1
    }))?.pinConfigurado == `boolean`;
  } catch {
    return !1;
  }
}
function vx(e) {
  let t = {
    [gx]: e
  };
  return {
    chats: () => api(`/gestor/chats`, {
      sinCache: !0,
      headers: t
    }),
    mensajes: e => api(`/gestor/chats/${e}/mensajes?limite=80`, {
      sinCache: !0,
      headers: t
    }),
    enviar: (e, n) => api(`/gestor/chats/${e}/mensajes`, {
      method: `POST`,
      body: {
        texto: n
      },
      headers: t,
      clave: `gestor-${e}`
    }),
    presencia: e => api(`/gestor/presencia`, {
      method: `POST`,
      body: {
        enLinea: e
      },
      headers: t,
      clave: `gestor-presencia`
    }),
    accesos: () => api(`/gestor/accesos`, {
      sinCache: !0,
      headers: t
    }),
    archivo: e => Qa(`/gestor/archivos/${e}`, t),
    cerrar: () => api(`/gestor/cerrar`, {
      method: `POST`,
      headers: t,
      clave: `gestor-cerrar`
    })
  };
}
function yx(e) {
  return e?.status === 403;
}
function bx(e, t = new Date()) {
  if (!e) return ``;
  let n = new Date(e),
    r = (e, t) => e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
  if (r(n, t)) return n.toLocaleTimeString(`es-PE`, {
    hour: `2-digit`,
    minute: `2-digit`
  });
  let i = new Date(t);
  return i.setDate(t.getDate() - 1), r(n, i) ? `ayer` : n.toLocaleDateString(`es-PE`, {
    day: `numeric`,
    month: `short`
  });
}
function xx(e, {
  conGrupos: t = !1,
  buscar: n = ``
} = {}) {
  let r = n.trim().toLowerCase();
  return (e ?? []).filter(e => (t || !e.esGrupo) && (!r || `${e.nombre ?? ``} ${e.vistaPrevia ?? ``}`.toLowerCase().includes(r)));
}
var Cx = `inline-flex items-center justify-center gap-1.5 rounded-full text-sm font-medium transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100`,
  wx = {
    primario: `bg-(--accent) px-4 py-2 text-(--accent-fg) hover:opacity-90`,
    secundario: `border border-(--border) px-4 py-2 text-(--text-h) hover:bg-(--accent-bg)`,
    peligro: `border border-(--error-border) px-4 py-2 text-(--error) hover:bg-(--error-bg)`,
    texto: `px-2 py-1 text-(--text-h) hover:text-(--accent)`,
    chico: `border border-(--border) px-3 py-1.5 text-xs text-(--text-h) hover:bg-(--accent-bg)`
  };
function Ox(e) {
  return !!(e instanceof Element && e.closest(`[data-flotante]`));
}
function kx(e, t, n) {
  let r = (0, ReactCompiler.c)(5),
    i,
    a;
  r[0] !== e || r[1] !== n || r[2] !== t ? (i = () => {
    if (!e) return;
    let r = e => {
        t.current && !t.current.contains(e.target) && !Ox(e.target) && n();
      },
      i = e => e.key === `Escape` && n();
    return document.addEventListener(`mousedown`, r), document.addEventListener(`keydown`, i), () => {
      document.removeEventListener(`mousedown`, r), document.removeEventListener(`keydown`, i);
    };
  }, a = [e, t, n], r[0] = e, r[1] = n, r[2] = t, r[3] = i, r[4] = a) : (i = r[3], a = r[4]), (0, React.useEffect)(i, a);
}
function jx(e) {
  return !e;
}
var Mx = [{
    codigo: `POR_HACER`,
    label: `Por hacer`
  }, {
    codigo: `EN_PROGRESO`,
    label: `En progreso`
  }, {
    codigo: `EN_REVISION`,
    label: `En revision`
  }, {
    codigo: `COMPLETADA`,
    label: `Completada`
  }, {
    codigo: `CANCELADA`,
    label: `Cancelada`
  }],
  Nx = Mx.filter(e => e.codigo !== `EN_REVISION` && e.codigo !== `CANCELADA`),
  Px = [`POR_HACER`, `EN_PROGRESO`, `EN_REVISION`, `COMPLETADA`],
  Fx = [{
    codigo: `BAJA`,
    label: `Baja`
  }, {
    codigo: `MEDIA`,
    label: `Media`
  }, {
    codigo: `ALTA`,
    label: `Alta`
  }, {
    codigo: `URGENTE`,
    label: `Urgente`
  }],
  Ix = [{
    codigo: `NINGUNA`,
    label: `No se repite`
  }, {
    codigo: `SEMANAL`,
    label: `Cada semana`
  }, {
    codigo: `QUINCENAL`,
    label: `Cada 2 semanas`
  }, {
    codigo: `MENSUAL`,
    label: `Cada mes`
  }],
  Lx = [{
    codigo: `NINGUNA`,
    label: `En blanco`
  }, {
    codigo: `ONBOARDING`,
    label: `Onboarding de un nuevo colaborador`
  }, {
    codigo: `RECLUTAMIENTO`,
    label: `Proceso de reclutamiento`
  }, {
    codigo: `EVENTO_INTERNO`,
    label: `Evento interno`
  }],
  Rx = [{
    codigo: `ADMIN`,
    label: `Administrador`
  }, {
    codigo: `COLABORADOR`,
    label: `Colaborador`
  }, {
    codigo: `OBSERVADOR`,
    label: `Observador`
  }];
function zx(e) {
  if (e == null) return ``;
  if (e < 24) return `${e} h`;
  let t = Math.floor(e / 24),
    n = e % 24;
  return `${t} ${t === 1 ? `día` : `días`}${n ? ` y ${n} h` : ``}`;
}
var Bx = [{
    value: `TARDANZA`,
    label: `No llegó a tiempo (queda el atraso)`
  }, {
    value: `REPROGRAMACION`,
    label: `Se replanificó (sin atraso)`
  }],
  Vx = null,
  Hx = [{
    codigo: `CORPORATIVA`,
    orden: 10,
    label: `Gerencia corporativa`,
    plural: `Gerencias corporativas`,
    cargo: `Gerente corporativo`,
    cargoPlural: `Gerentes corporativos`
  }, {
    codigo: `LINEAL`,
    orden: 20,
    label: `Gerencia`,
    plural: `Gerencias`,
    cargo: `Gerente`,
    cargoPlural: `Gerentes`
  }, {
    codigo: `SUBGERENCIA`,
    orden: 30,
    label: `Subgerencia`,
    plural: `Subgerencias`,
    cargo: `Subgerente`,
    cargoPlural: `Subgerentes`
  }, {
    codigo: `AREA`,
    orden: 40,
    label: `Área`,
    plural: `Áreas`,
    cargo: `Jefe de área`,
    cargoPlural: `Jefes de área`
  }, {
    codigo: `GRUPO`,
    orden: 50,
    label: `Grupo de trabajo`,
    plural: `Grupos de trabajo`,
    cargo: `Coordinador`,
    cargoPlural: `Coordinadores`
  }];
function Ux() {
  return Vx ?? Hx;
}
function Wx(e) {
  Array.isArray(e) && e.length !== 0 && (Vx = e.map(e => ({
    ...e,
    label: e.nombre ?? e.label
  })).sort((e, t) => e.orden - t.orden));
}
function Gx(e) {
  return Ux().find(t => t.codigo === e);
}
function Kx(e, t = !1) {
  let n = Gx(e);
  return n ? t ? n.cargoPlural ?? n.cargo : n.cargo : `Responsable`;
}
function qx(e) {
  return `${e === `GRUPO` ? `Nuevo` : `Nueva`} ${(Jx[e] || e).toLowerCase()}`;
}
var Jx = Object.fromEntries([...Mx, ...Fx, ...Rx, ...Ix, ...Hx].map(e => [e.codigo, e.label]));
function Yx(e) {
  return Jx[e] ?? e;
}
function Xx(e) {
  let t = e?.asignados ?? [];
  if (t.length === 0) return e?.asignadoNombre ? e.asignadoNombre.split(` `)[0] : null;
  let n = (t[0].nombre || `Usuario ${t[0].usuarioId}`).split(` `)[0];
  return t.length > 1 ? `${n} +${t.length - 1}` : n;
}
function Zx(e) {
  switch (e) {
    case `URGENTE`:
      return `border border-(--error-border) bg-transparent text-(--error-texto)`;
    case `ALTA`:
      return `border border-(--warning-border) bg-transparent text-(--warning-texto)`;
    case `BAJA`:
      return `border border-(--border) bg-transparent text-(--text)`;
    default:
      return `border border-(--accent-border) bg-transparent text-(--accent-texto)`;
  }
}
function Qx(e) {
  switch (e) {
    case `COMPLETADA`:
    case `LOGRADA`:
      return `border border-(--success-border) bg-transparent text-(--success-texto)`;
    case `CANCELADA`:
      return `border border-(--border) bg-transparent text-(--text) line-through`;
    case `EN_RIESGO`:
      return `border border-(--warning-border) bg-transparent text-(--warning-texto)`;
    default:
      return `border border-(--accent-border) bg-transparent text-(--accent-texto)`;
  }
}
function $x() {
  return vs()?.paleta ?? eS;
}
var eS = [{
    fondo: `#558ba5`,
    texto: `#ffffff`
  }, {
    fondo: `#54904c`,
    texto: `#ffffff`
  }, {
    fondo: `#db9647`,
    texto: `#1f2430`
  }, {
    fondo: `#d7594e`,
    texto: `#ffffff`
  }, {
    fondo: `#9f4f64`,
    texto: `#ffffff`
  }, {
    fondo: `#30586b`,
    texto: `#ffffff`
  }, {
    fondo: `#95ba21`,
    texto: `#1f2430`
  }, {
    fondo: `#f2cf68`,
    texto: `#1f2430`
  }],
  tS = eS.map(e => e.fondo);
function nS(e) {
  return e || vs()?.colorAcento || tS[0];
}
function rS(e) {
  let t = nS(e?.color);
  return {
    background: t,
    color: e?.colorTexto || $x().find(e => e.fondo?.toLowerCase() === t.toLowerCase())?.texto || `#1f2430`
  };
}
function iS(e, t) {
  let n = new Date(`${e}Z`);
  if (Number.isNaN(n.getTime())) return null;
  if (!t) return n;
  try {
    let e = new Intl.DateTimeFormat(`en-US`, {
        timeZone: t,
        hour12: !1,
        year: `numeric`,
        month: `2-digit`,
        day: `2-digit`,
        hour: `2-digit`,
        minute: `2-digit`,
        second: `2-digit`
      }),
      r = {};
    for (let {
      type: t,
      value: i
    } of e.formatToParts(n)) r[t] = i;
    let i = r.hour === `24` ? 0 : Number(r.hour),
      a = Date.UTC(Number(r.year), Number(r.month) - 1, Number(r.day), i, Number(r.minute), Number(r.second)) - n.getTime();
    return new Date(n.getTime() - a);
  } catch {
    return n;
  }
}
function aS(e, t = vs()?.zonaHoraria) {
  if (!e?.fechaHora) return null;
  let n = iS(e.fechaHora.length <= 16 ? `${e.fechaHora}:00` : e.fechaHora.slice(0, 19), t);
  if (!n || Number.isNaN(n.getTime())) return null;
  let r = new Date(n.getTime() + (Number(e.duracionMin) || 60) * 6e4),
    i = (e.participantes ?? []).map(e => e.usuarioCorreo).filter(Boolean).join(`,`),
    a = [e.agenda, e.lugarOEnlace && `Lugar / enlace: ${e.lugarOEnlace}`].filter(Boolean).join(`

`),
    o = new URLSearchParams({
      subject: e.titulo || `Reunión`,
      startTime: n.toISOString(),
      endTime: r.toISOString()
    });
  return a && o.set(`content`, a), i && o.set(`attendees`, i), `https://teams.microsoft.com/l/meeting/new?${o.toString()}`;
}
var oS = {
  TAREA_ASIGNADA: `Tarea asignada`,
  TAREA_COMENTADA: `Comentario en tarea`,
  MENCION: `Te mencionaron`,
  PROYECTO_INVITACION: `Nuevo proyecto`,
  REUNION_PROXIMA: `Reunion proxima`,
  DISCUSION_COMENTADA: `Respuesta en hilo`,
  META_EN_RIESGO: `Meta en riesgo`,
  TAREA_EN_REVISION: `Espera tu conforme`,
  TAREA_CONFORME: `Te dieron el conforme`,
  TAREA_DEVUELTA: `Te devolvieron una tarea`,
  SOLICITUD_FECHA: `Piden cambiar una fecha`,
  SOLICITUD_FECHA_RESUELTA: `Cambio de fecha resuelto`,
  INCIDENCIA_NUEVA: `Incidencia por levantar`,
  INCIDENCIA_ACTUALIZADA: `Tu reporte`,
  OBSERVACION_NUEVA: `Observación por levantar`,
  INSPECCION_POR_VENCER: `Acta sin terminar`
};
function sS(e) {
  return oS[e] ?? e;
}
var cS = {
  REABIERTA: `Reabrió la tarea`,
  CHECKLIST: `Actualizó el checklist`,
  ELIMINADA: `Eliminó la tarea`,
  CREADA: `Creó la tarea`,
  ASIGNADA: `Cambió el asignado`,
  ESTADO: `Cambió el estado`,
  CAMPO: `Editó un campo`,
  COMPROBANTE: `Agregó un comprobante`,
  SOLICITUD_FECHA: `Pidió cambiar la fecha`,
  SOLICITUD_RESUELTA: `Resolvió la solicitud de fecha`,
  CONFORME: `Dio el conforme`,
  DEVUELTA: `Devolvió la tarea`,
  CANCELADA: `Canceló la tarea`
};
function lS(e) {
  return cS[e] ?? e;
}
function uS(e) {
  if (!e) return ``;
  let t = new Date(e),
    n = Math.round((Date.now() - t.getTime()) / 1e3);
  return n < 60 ? `hace un momento` : n < 3600 ? `hace ${Math.floor(n / 60)} min` : n < 86400 ? `hace ${Math.floor(n / 3600)} h` : n < 604800 ? `hace ${Math.floor(n / 86400)} d` : t.toLocaleDateString(`es-PE`, {
    day: `2-digit`,
    month: `short`
  });
}
function dS(e) {
  return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, `0`)}-${String(e.getDate()).padStart(2, `0`)}`;
}
function fS(e) {
  return e ? new Date(e.length <= 10 ? e + `T00:00:00` : e).toLocaleDateString(`es-PE`, {
    day: `2-digit`,
    month: `short`
  }) : null;
}
function pS(e) {
  return e ? new Date(e).toLocaleString(`es-PE`, {
    day: `2-digit`,
    month: `short`,
    hour: `2-digit`,
    minute: `2-digit`
  }) : null;
}
function mS(e) {
  return e?.proyectoId ? `/proyectos/${e.proyectoId}` : e?.unidadId ? `/organizacion/${e.unidadId}` : `/`;
}
function hS(e) {
  return e?.proyectoNombre || e?.unidadNombre || null;
}
function gS(e) {
  if (!e) return null;
  let [t, n, r] = e.split(`-`).map(Number);
  return !t || !n || !r ? null : new Date(t, n - 1, r);
}
function _S(e) {
  let t = gS(e);
  return t ? t.toLocaleDateString(`es-PE`, {
    day: `2-digit`,
    month: `short`,
    year: `numeric`
  }) : ``;
}
function vS(e) {
  let t = new Date(e);
  return t.setDate(t.getDate() - (t.getDay() + 6) % 7), t;
}
function yS(e) {
  let t = e => {
      let t = new Date(e.getFullYear(), e.getMonth(), e.getDate());
      return t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7), t;
    },
    n = t(e),
    r = t(new Date(n.getFullYear(), 0, 4));
  return 1 + Math.round((n - r) / 6048e5);
}
function bS(e) {
  let t = gS(e);
  if (!t) return !1;
  let n = vS(new Date());
  return n.setHours(0, 0, 0, 0), t >= n;
}
function xS(e) {
  let t = vS(new Date(e.getFullYear(), e.getMonth(), 1));
  return Array.from({
    length: 6
  }, (e, n) => Array.from({
    length: 7
  }, (e, r) => {
    let i = new Date(t);
    return i.setDate(t.getDate() + n * 7 + r), i;
  }));
}
var SS = [`L`, `M`, `M`, `J`, `V`, `S`, `D`],
  CS = [`enero`, `febrero`, `marzo`, `abril`, `mayo`, `junio`, `julio`, `agosto`, `septiembre`, `octubre`, `noviembre`, `diciembre`];
function OS(e) {
  return e.usuarioNombre;
}
function kS(e) {
  return e.usuarioId;
}
function AS(e) {
  return e.usuarioId;
}
function jS(e) {
  return e ? e < 1024 ? `${e} B` : e < 1048576 ? `${(e / 1024).toFixed(0)} KB` : `${(e / 1024 / 1024).toFixed(1)} MB` : ``;
}
var NS = dS(new Date(Date.now() - 6048e5)),
  PS = dS(new Date(Date.now() + 6048e5)),
  FS = (e, t) => ({
    proyectoId: e?.id ?? null,
    unidadId: e?.id ? null : e?.unidadId ?? null,
    titulo: ``,
    descripcion: ``,
    estado: `POR_HACER`,
    prioridad: `MEDIA`,
    fechaInicio: ``,
    fechaVencimiento: t?.fechaVencimiento ?? PS,
    metaId: ``,
    listaId: ``,
    recurrencia: `NINGUNA`,
    etiquetaIds: [],
    asignados: t?.asignadoUsuarioId ? [{
      usuarioId: t.asignadoUsuarioId,
      nombre: t.asignadoNombre ?? ``,
      correo: t.asignadoCorreo ?? ``
    }] : [],
    dependeDe: [],
    reunionOrigenId: t?.reunionOrigenId ?? null,
    reunionOrigenTitulo: t?.reunionOrigenTitulo ?? null,
    discusionOrigenId: t?.discusionOrigenId ?? null,
    discusionOrigenTitulo: t?.discusionOrigenTitulo ?? null
  });
function RS(e) {
  return !e;
}
function US(e) {
  return e.nombre;
}
function WS(e) {
  return e.hecho;
}
function JS(e) {
  return {
    proyectoId: e.proyectoId,
    version: e.version,
    titulo: e.titulo,
    descripcion: e.descripcion || ``,
    estado: e.estado,
    prioridad: e.prioridad,
    fechaInicio: e.fechaInicio || ``,
    fechaVencimiento: e.fechaVencimiento || ``,
    metaId: e.metaId || ``,
    listaId: e.listaId || ``,
    recurrencia: e.recurrencia || `NINGUNA`,
    etiquetaIds: (e.etiquetas || []).map(e => e.id),
    asignados: (e.asignados ?? []).map(e => ({
      usuarioId: e.usuarioId,
      nombre: e.nombre ?? ``,
      correo: e.correo ?? ``
    })),
    dependeDe: e.dependeDe || [],
    checklist: e.checklist || [],
    reunionOrigenId: e.reunionOrigenId || null,
    reunionOrigenTitulo: e.reunionOrigenTitulo || null,
    discusionOrigenId: e.discusionOrigenId || null,
    discusionOrigenTitulo: e.discusionOrigenTitulo || null
  };
}
function XS() {
  return [];
}
function ZS() {
  return [];
}
function QS() {
  return [];
}
function $S(e) {
  let t = (0, ReactCompiler.c)(7),
    n;
  t[0] === Symbol.for(`react.memo_cache_sentinel`) ? (n = [], t[0] = n) : n = t[0];
  let [r, i] = (0, React.useState)(n),
    [a, o] = (0, React.useState)(!1),
    s,
    c;
  t[1] === e ? (s = t[2], c = t[3]) : (s = () => {
    let t = e.trim();
    if (t.length < 2) {
      i([]), o(!1);
      return;
    }
    o(!0);
    let n = setTimeout(() => {
      api(`/busqueda?q=${encodeURIComponent(t)}`).then(i).catch(() => i([])).finally(() => o(!1));
    }, 250);
    return () => clearTimeout(n);
  }, c = [e], t[1] = e, t[2] = s, t[3] = c), (0, React.useEffect)(s, c);
  let l;
  return t[4] !== a || t[5] !== r ? (l = {
    resultados: r,
    buscando: a
  }, t[4] = a, t[5] = r, t[6] = l) : l = t[6], l;
}
var eC = {
  PROYECTO: `Proyecto`,
  TAREA: `Tarea`,
  REUNION: `Reunión`,
  DISCUSION: `Discusión`
};
function iC(e, {
  onMensaje: t,
  onEstado: n
} = {}) {
  let r = Ea(e),
    i = !1,
    a = null,
    o = 1e3;
  async function s() {
    if (!i) {
      a = new AbortController();
      try {
        let e = await fetch(r, {
          headers: {
            ...cabeceraSesion(),
            Accept: `text/event-stream`
          },
          signal: a.signal,
          cache: `no-store`
        });
        if (!e.ok || !e.body) throw Error(`SSE ${e.status}`);
        n?.(`conectado`), o = 1e3;
        let s = e.body.getReader(),
          c = new TextDecoder(),
          l = ``;
        for (; !i;) {
          let {
            value: e,
            done: n
          } = await s.read();
          if (n) break;
          l += c.decode(e, {
            stream: !0
          });
          let r;
          for (; (r = l.indexOf(`

`)) >= 0;) {
            let e = l.slice(0, r);
            l = l.slice(r + 2);
            let n = e.split(`
`).filter(e => e.startsWith(`data:`)).map(e => e.slice(5).trimStart()).join(`
`);
            if (n) try {
              t?.(JSON.parse(n));
            } catch {}
          }
        }
      } catch (e) {
        if (i || e.name === `AbortError`) return;
        n?.(`caido`);
      }
      i || (await new Promise(e => setTimeout(e, o)), o = Math.min(o * 2, 3e4), s());
    }
  }
  return s(), {
    cerrar() {
      i = !0, a?.abort();
    }
  };
}
var aC = null,
  oC = null,
  sC = new Set(),
  cC = 5e3;
function lC() {
  oC &&= (clearTimeout(oC), null), !aC && obtenerToken() && (aC = iC(`/notificaciones/stream`, {
    onMensaje: e => {
      if (e) for (let t of sC) try {
        t(e);
      } catch {}
    }
  }));
}
function uC() {
  sC.size > 0 || !aC || oC || (oC = setTimeout(() => {
    oC = null, sC.size === 0 && aC && (aC.cerrar(), aC = null);
  }, cC));
}
function dC(e) {
  return sC.add(e), lC(), () => {
    sC.delete(e), uC();
  };
}
function fC(e, {
  proyectoId: t = null,
  entidad: n = null,
  esperaMs: r = 400
} = {}) {
  let i = null,
    a = null;
  return dC(o => {
    o.tipo === `CAMBIO` && o.cambio && (n == null || o.cambio.entidad === n) && (t == null || String(o.cambio.proyectoId) === String(t)) && (o.cambio.actorUsuarioId == null || o.cambio.actorUsuarioId !== usuarioIdSesion()) && (a = o.cambio, i && clearTimeout(i), i = setTimeout(() => {
      i = null, e(a);
    }, r));
  });
}
function pC(e) {
  let t = (e + `=`.repeat((4 - e.length % 4) % 4)).replace(/-/g, `+`).replace(/_/g, `/`),
    n = atob(t),
    r = new Uint8Array(n.length);
  for (let e = 0; e < n.length; e++) r[e] = n.charCodeAt(e);
  return r;
}
function mC() {
  return `serviceWorker` in navigator && `PushManager` in window && `Notification` in window;
}
async function hC() {
  // iPhone / iPad: los avisos web sólo existen en la app instalada (iOS 16.4+).
  if (!mC()) return /iphone|ipad|ipod/i.test(navigator.userAgent) && window.navigator.standalone !== !0 ? `requiere-instalar` : `no-soportado`;
  if (Notification.permission === `denied`) return `bloqueado`;
  try {
    let e = await navigator.serviceWorker.getRegistration();
    return e && (await e.pushManager.getSubscription()) ? `activo` : `inactivo`;
  } catch {
    return `inactivo`;
  }
}
async function gC() {
  if (!mC()) throw Error(`Este navegador no soporta notificaciones push.`);
  if ((await Notification.requestPermission()) !== `granted`) throw Error(`Diste "no" al permiso de notificaciones. Cambialo en el candado de la barra de dirección.`);
  let {
    clave: e,
    activo: t
  } = await api(`/push/clave-publica`);
  if (!t || !e) throw Error(`El servidor todavía no tiene el push web configurado (falta la clave VAPID).`);
  let n = await navigator.serviceWorker.ready,
    r = await n.pushManager.getSubscription();
  r ||= await n.pushManager.subscribe({
    userVisibleOnly: !0,
    applicationServerKey: pC(e)
  });
  let i = r.toJSON();
  await api(`/push/suscribir`, {
    method: `POST`,
    body: JSON.stringify({
      endpoint: i.endpoint,
      keys: i.keys
    })
  });
}
async function _C() {
  try {
    let e = await navigator.serviceWorker.getRegistration(),
      t = e && (await e.pushManager.getSubscription());
    t && (await api(`/push/desuscribir`, {
      method: `POST`,
      body: JSON.stringify({
        endpoint: t.endpoint
      })
    }).catch(() => {}), await t.unsubscribe().catch(() => {}));
  } catch {}
}
async function vC(e) {
  if (!(`Notification` in window) || Notification.permission !== `granted`) return;
  let t = {
    body: e.cuerpo || ``,
    icon: `/icon/icon-192.png`,
    badge: `/icon/icon-192.png`,
    tag: e.enlace || `notif-${e.id}`,
    data: {
      enlace: e.enlace || `/`
    }
  };
  try {
    let n = await navigator.serviceWorker.getRegistration();
    n ? await n.showNotification(e.titulo, t) : new Notification(e.titulo, t);
  } catch {}
}
var bC = `gth_celular_despues`;
var SC = new URL(`/assets/logo-espanol-BGM1XAJb.svg`, `` + import.meta.url).href,
  CC = [{
    to: `/`,
    label: `Mis tareas`,
    icon: ei,
    end: !0
  }, {
    to: `/aprobaciones`,
    label: `Aprobaciones`,
    icon: Nr
  }, {
    to: `/organizacion`,
    label: `Organización`,
    icon: yi
  }, {
    to: `/calendario`,
    label: `Calendario`,
    icon: Tr
  }],
  wC = [{
    to: `/admin`,
    label: `Resumen general`,
    icon: Bi,
    end: !0
  }, {
    to: `/admin/maestros`,
    label: `Usuarios y permisos`,
    icon: $i
  }, {
    to: `/admin/personal`,
    label: `Personal`,
    icon: Or
  }, {
    to: `/admin/marca`,
    label: `Apariencia`,
    icon: bi
  }, {
    to: `/admin/errores`,
    label: `Registro de fallas`,
    icon: qi
  }, {
    to: `/admin/movilidad`,
    label: `Movilidad`,
    icon: Cr
  }, {
    to: `/admin/bots`,
    label: `Bots de WhatsApp`,
    icon: pi
  }, {
    to: `/admin/niveles`,
    label: `Niveles jerárquicos`,
    icon: Zr
  }, {
    to: `/admin/areas-por-sector`,
    label: `Actas e incidencias por área`,
    icon: Pr
  }],
  TC = {
    to: `/transporte`,
    label: `Transporte`,
    icon: Ji
  },
  EC = [{
    to: `/incidencias`,
    label: `Incidencias`,
    icon: Vi,
    visible: puedeIncidencias
  }, {
    to: `/inspecciones`,
    label: `Inspecciones`,
    icon: Pr,
    visible: puedeInspecciones
  }, {
    to: `/labores`,
    label: `Control de Labores`,
    icon: IconoLabores,
    visible: puedeLabores
  }, {
    to: `/organigrama`,
    label: `Organigrama`,
    icon: Kr,
    visible: puedeOrganigrama
  }],
  DC = {
    to: `/observaciones`,
    label: `Por levantar`,
    icon: ti
  },
  OC = {
    to: `/gestor`,
    label: `WhatsApp`,
    icon: pi
  },
  kC = null;
function AC() {
  return kC ??= _x(), kC;
}
var jC = `gth_menu_oculto`,
  MC = 3,
  NC = ({
    isActive: e
  }) => `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition ${e ? `bg-(--sidebar-activo) text-(--sidebar-fg)` : `text-(--sidebar-fg-tenue) hover:bg-(--sidebar-hover) hover:text-(--sidebar-fg)`}`;
var FC = `animate-pulse rounded-xl bg-(--border)/60`;
function UC() {
  let e = new Date().getHours();
  return e < 12 ? `Buenos días` : e < 19 ? `Buenas tardes` : `Buenas noches`;
}
var WC = () => (obtenerUsuario()?.nombre ?? ``).split(` `)[0];
function GC(e, t) {
  if (t === 0) return `Hoy no tenés nada asignado.`;
  let n = dS(new Date()),
    r = e.filter(e => e.fechaVencimiento === n).length,
    i = e.filter(e => e.atrasada).length,
    a = [];
  return r > 0 && a.push(`${r} ${r === 1 ? `vence` : `vencen`} hoy`), i > 0 && a.push(`${i} ${i === 1 ? `está atrasada` : `están atrasadas`}`), a.length === 0 ? `Tenés ${t} ${t === 1 ? `tarea` : `tareas`}, ninguna vence hoy.` : `De tus ${t}, ${a.join(` y `)}.`;
}
var qC = 25;
var YC = [`#3f7fb0`, `#c77b2e`, `#4e9a63`, `#a8547c`, `#7b6cc4`, `#b8543f`, `#2f9199`, `#8a8330`];
function XC(e) {
  if (e == null || e === ``) return null;
  let t = Math.abs(Number(e));
  return Number.isFinite(t) ? YC[t % YC.length] : null;
}
function ZC(e, t) {
  return t?.sedeNombre ? `${e} · ${t.sedeNombre}` : e;
}
var QC = `__sin__`;
function tw(e, t) {
  try {
    return localStorage.getItem(`gth_pref_${e}`) ?? t;
  } catch {
    return t;
  }
}
function nw(e, t) {
  try {
    localStorage.setItem(`gth_pref_${e}`, t);
  } catch {}
}
function rw() {
  var e = [...arguments];
  return (0, React.useMemo)(() => t => {
    e.forEach(e => e(t));
  }, e);
}
var iw = typeof window < `u` && window.document !== void 0 && window.document.createElement !== void 0;
function aw(e) {
  let t = Object.prototype.toString.call(e);
  return t === `[object Window]` || t === `[object global]`;
}
function ow(e) {
  return `nodeType` in e;
}
function sw(e) {
  return e ? aw(e) ? e : ow(e) ? e.ownerDocument?.defaultView ?? window : window : window;
}
function cw(e) {
  let {
    Document: t
  } = sw(e);
  return e instanceof t;
}
function lw(e) {
  return !aw(e) && e instanceof sw(e).HTMLElement;
}
function uw(e) {
  return e instanceof sw(e).SVGElement;
}
function dw(e) {
  return e ? aw(e) ? e.document : ow(e) ? cw(e) ? e : lw(e) || uw(e) ? e.ownerDocument : document : document : document;
}
var fw = iw ? React.useLayoutEffect : React.useEffect;
function pw(e) {
  let t = (0, React.useRef)(e);
  return fw(() => {
    t.current = e;
  }), (0, React.useCallback)(function () {
    var e = [...arguments];
    return t.current == null ? void 0 : t.current(...e);
  }, []);
}
function mw() {
  let e = (0, React.useRef)(null);
  return [(0, React.useCallback)((t, n) => {
    e.current = setInterval(t, n);
  }, []), (0, React.useCallback)(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, [])];
}
function hw(e, t) {
  t === void 0 && (t = [e]);
  let n = (0, React.useRef)(e);
  return fw(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function gw(e, t) {
  let n = (0, React.useRef)();
  return (0, React.useMemo)(() => {
    let t = e(n.current);
    return n.current = t, t;
  }, [...t]);
}
function _w(e) {
  let t = pw(e),
    n = (0, React.useRef)(null);
  return [n, (0, React.useCallback)(e => {
    e !== n.current && t?.(e, n.current), n.current = e;
  }, [])];
}
function vw(e) {
  let t = (0, React.useRef)();
  return (0, React.useEffect)(() => {
    t.current = e;
  }, [e]), t.current;
}
var yw = {};
function bw(e, t) {
  return (0, React.useMemo)(() => {
    if (t) return t;
    let n = yw[e] == null ? 0 : yw[e] + 1;
    return yw[e] = n, e + `-` + n;
  }, [e, t]);
}
function xw(e) {
  return function (t) {
    return [...arguments].slice(1).reduce((t, n) => {
      let r = Object.entries(n);
      for (let [n, i] of r) {
        let r = t[n];
        r != null && (t[n] = r + e * i);
      }
      return t;
    }, {
      ...t
    });
  };
}
var Sw = xw(1),
  Cw = xw(-1);
function ww(e) {
  return `clientX` in e && `clientY` in e;
}
function Tw(e) {
  if (!e) return !1;
  let {
    KeyboardEvent: t
  } = sw(e.target);
  return t && e instanceof t;
}
function Ew(e) {
  if (!e) return !1;
  let {
    TouchEvent: t
  } = sw(e.target);
  return t && e instanceof t;
}
function Dw(e) {
  if (Ew(e)) {
    if (e.touches && e.touches.length) {
      let {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    }
    if (e.changedTouches && e.changedTouches.length) {
      let {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return ww(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
var Ow = Object.freeze({
    Translate: {
      toString(e) {
        if (!e) return;
        let {
          x: t,
          y: n
        } = e;
        return `translate3d(` + (t ? Math.round(t) : 0) + `px, ` + (n ? Math.round(n) : 0) + `px, 0)`;
      }
    },
    Scale: {
      toString(e) {
        if (!e) return;
        let {
          scaleX: t,
          scaleY: n
        } = e;
        return `scaleX(` + t + `) scaleY(` + n + `)`;
      }
    },
    Transform: {
      toString(e) {
        if (e) return [Ow.Translate.toString(e), Ow.Scale.toString(e)].join(` `);
      }
    },
    Transition: {
      toString(e) {
        let {
          property: t,
          duration: n,
          easing: r
        } = e;
        return t + ` ` + n + `ms ` + r;
      }
    }
  }),
  kw = `a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]`;
function Aw(e) {
  return e.matches(kw) ? e : e.querySelector(kw);
}
var jw = {
  display: `none`
};
function Mw(e) {
  let {
    id: t,
    value: n
  } = e;
  return React.createElement(`div`, {
    id: t,
    style: jw
  }, n);
}
function Nw(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = `assertive`
  } = e;
  return React.createElement(`div`, {
    id: t,
    style: {
      position: `fixed`,
      top: 0,
      left: 0,
      width: 1,
      height: 1,
      margin: -1,
      border: 0,
      padding: 0,
      overflow: `hidden`,
      clip: `rect(0 0 0 0)`,
      clipPath: `inset(100%)`,
      whiteSpace: `nowrap`
    },
    role: `status`,
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function Pw() {
  let [e, t] = (0, React.useState)(``);
  return {
    announce: (0, React.useCallback)(e => {
      e != null && t(e);
    }, []),
    announcement: e
  };
}
var Fw = (0, React.createContext)(null);
function Iw(e) {
  let t = (0, React.useContext)(Fw);
  (0, React.useEffect)(() => {
    if (!t) throw Error(`useDndMonitor must be used within a children of <DndContext>`);
    return t(e);
  }, [e, t]);
}
function Lw() {
  let [e] = (0, React.useState)(() => new Set()),
    t = (0, React.useCallback)(t => (e.add(t), () => e.delete(t)), [e]);
  return [(0, React.useCallback)(t => {
    let {
      type: n,
      event: r
    } = t;
    e.forEach(e => e[n]?.call(e, r));
  }, [e]), t];
}
var Rw = {
    draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
  },
  zw = {
    onDragStart(e) {
      let {
        active: t
      } = e;
      return `Picked up draggable item ` + t.id + `.`;
    },
    onDragOver(e) {
      let {
        active: t,
        over: n
      } = e;
      return n ? `Draggable item ` + t.id + ` was moved over droppable area ` + n.id + `.` : `Draggable item ` + t.id + ` is no longer over a droppable area.`;
    },
    onDragEnd(e) {
      let {
        active: t,
        over: n
      } = e;
      return n ? `Draggable item ` + t.id + ` was dropped over droppable area ` + n.id : `Draggable item ` + t.id + ` was dropped.`;
    },
    onDragCancel(e) {
      let {
        active: t
      } = e;
      return `Dragging was cancelled. Draggable item ` + t.id + ` was dropped.`;
    }
  };
function Bw(e) {
  let {
      announcements: t = zw,
      container: n,
      hiddenTextDescribedById: r,
      screenReaderInstructions: i = Rw
    } = e,
    {
      announce: a,
      announcement: o
    } = Pw(),
    s = bw(`DndLiveRegion`),
    [c, l] = (0, React.useState)(!1);
  if ((0, React.useEffect)(() => {
    l(!0);
  }, []), Iw((0, React.useMemo)(() => ({
    onDragStart(e) {
      let {
        active: n
      } = e;
      a(t.onDragStart({
        active: n
      }));
    },
    onDragMove(e) {
      let {
        active: n,
        over: r
      } = e;
      t.onDragMove && a(t.onDragMove({
        active: n,
        over: r
      }));
    },
    onDragOver(e) {
      let {
        active: n,
        over: r
      } = e;
      a(t.onDragOver({
        active: n,
        over: r
      }));
    },
    onDragEnd(e) {
      let {
        active: n,
        over: r
      } = e;
      a(t.onDragEnd({
        active: n,
        over: r
      }));
    },
    onDragCancel(e) {
      let {
        active: n,
        over: r
      } = e;
      a(t.onDragCancel({
        active: n,
        over: r
      }));
    }
  }), [a, t])), !c) return null;
  let u = React.createElement(React.Fragment, null, React.createElement(Mw, {
    id: r,
    value: i.draggable
  }), React.createElement(Nw, {
    id: s,
    announcement: o
  }));
  return n ? (0, h.createPortal)(u, n) : u;
}
var Vw;
(function (e) {
  e.DragStart = `dragStart`, e.DragMove = `dragMove`, e.DragEnd = `dragEnd`, e.DragCancel = `dragCancel`, e.DragOver = `dragOver`, e.RegisterDroppable = `registerDroppable`, e.SetDroppableDisabled = `setDroppableDisabled`, e.UnregisterDroppable = `unregisterDroppable`;
})(Vw ||= {});
function Hw() {}
function Uw(e, t) {
  return (0, React.useMemo)(() => ({
    sensor: e,
    options: t ?? {}
  }), [e, t]);
}
function Ww() {
  var e = [...arguments];
  return (0, React.useMemo)(() => [...e].filter(e => e != null), [...e]);
}
var Gw = Object.freeze({
  x: 0,
  y: 0
});
function Kw(e, t) {
  return Math.sqrt((e.x - t.x) ** 2 + (e.y - t.y) ** 2);
}
function qw(e, t) {
  let n = Dw(e);
  if (!n) return `0 0`;
  let r = {
    x: (n.x - t.left) / t.width * 100,
    y: (n.y - t.top) / t.height * 100
  };
  return r.x + `% ` + r.y + `%`;
}
function Jw(e, t) {
  let {
      data: {
        value: n
      }
    } = e,
    {
      data: {
        value: r
      }
    } = t;
  return n - r;
}
function Yw(e, t) {
  let {
      data: {
        value: n
      }
    } = e,
    {
      data: {
        value: r
      }
    } = t;
  return r - n;
}
function Xw(e) {
  let {
    left: t,
    top: n,
    height: r,
    width: i
  } = e;
  return [{
    x: t,
    y: n
  }, {
    x: t + i,
    y: n
  }, {
    x: t,
    y: n + r
  }, {
    x: t + i,
    y: n + r
  }];
}
function Zw(e, t) {
  if (!e || e.length === 0) return null;
  let [n] = e;
  return t ? n[t] : n;
}
var Qw = e => {
  let {
      collisionRect: t,
      droppableRects: n,
      droppableContainers: r
    } = e,
    i = Xw(t),
    a = [];
  for (let e of r) {
    let {
        id: t
      } = e,
      r = n.get(t);
    if (r) {
      let n = Xw(r),
        o = i.reduce((e, t, r) => e + Kw(n[r], t), 0),
        s = Number((o / 4).toFixed(4));
      a.push({
        id: t,
        data: {
          droppableContainer: e,
          value: s
        }
      });
    }
  }
  return a.sort(Jw);
};
function $w(e, t) {
  let n = Math.max(t.top, e.top),
    r = Math.max(t.left, e.left),
    i = Math.min(t.left + t.width, e.left + e.width),
    a = Math.min(t.top + t.height, e.top + e.height),
    o = i - r,
    s = a - n;
  if (r < i && n < a) {
    let n = t.width * t.height,
      r = e.width * e.height,
      i = o * s,
      a = i / (n + r - i);
    return Number(a.toFixed(4));
  }
  return 0;
}
var eT = e => {
  let {
      collisionRect: t,
      droppableRects: n,
      droppableContainers: r
    } = e,
    i = [];
  for (let e of r) {
    let {
        id: r
      } = e,
      a = n.get(r);
    if (a) {
      let n = $w(a, t);
      n > 0 && i.push({
        id: r,
        data: {
          droppableContainer: e,
          value: n
        }
      });
    }
  }
  return i.sort(Yw);
};
function tT(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function nT(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Gw;
}
function rT(e) {
  return function (t) {
    return [...arguments].slice(1).reduce((t, n) => ({
      ...t,
      top: t.top + e * n.y,
      bottom: t.bottom + e * n.y,
      left: t.left + e * n.x,
      right: t.right + e * n.x
    }), {
      ...t
    });
  };
}
var iT = rT(1);
function aT(e) {
  if (e.startsWith(`matrix3d(`)) {
    let t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  }
  if (e.startsWith(`matrix(`)) {
    let t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function oT(e, t, n) {
  let r = aT(t);
  if (!r) return e;
  let {
      scaleX: i,
      scaleY: a,
      x: o,
      y: s
    } = r,
    c = e.left - o - (1 - i) * parseFloat(n),
    l = e.top - s - (1 - a) * parseFloat(n.slice(n.indexOf(` `) + 1)),
    u = i ? e.width / i : e.width,
    d = a ? e.height / a : e.height;
  return {
    width: u,
    height: d,
    top: l,
    right: c + u,
    bottom: l + d,
    left: c
  };
}
var sT = {
  ignoreTransform: !1
};
function cT(e, t) {
  t === void 0 && (t = sT);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    let {
      transform: t,
      transformOrigin: r
    } = sw(e).getComputedStyle(e);
    t && (n = oT(n, t, r));
  }
  let {
    top: r,
    left: i,
    width: a,
    height: o,
    bottom: s,
    right: c
  } = n;
  return {
    top: r,
    left: i,
    width: a,
    height: o,
    bottom: s,
    right: c
  };
}
function lT(e) {
  return cT(e, {
    ignoreTransform: !0
  });
}
function uT(e) {
  let t = e.innerWidth,
    n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function dT(e, t) {
  return t === void 0 && (t = sw(e).getComputedStyle(e)), t.position === `fixed`;
}
function fT(e, t) {
  t === void 0 && (t = sw(e).getComputedStyle(e));
  let n = /(auto|scroll|overlay)/;
  return [`overflow`, `overflowX`, `overflowY`].some(e => {
    let r = t[e];
    return typeof r == `string` && n.test(r);
  });
}
function pT(e, t) {
  let n = [];
  function r(i) {
    if (t != null && n.length >= t || !i) return n;
    if (cw(i) && i.scrollingElement != null && !n.includes(i.scrollingElement)) return n.push(i.scrollingElement), n;
    if (!lw(i) || uw(i) || n.includes(i)) return n;
    let a = sw(e).getComputedStyle(i);
    return i !== e && fT(i, a) && n.push(i), dT(i, a) ? n : r(i.parentNode);
  }
  return e ? r(e) : n;
}
function mT(e) {
  let [t] = pT(e, 1);
  return t ?? null;
}
function hT(e) {
  return !iw || !e ? null : aw(e) ? e : ow(e) ? cw(e) || e === dw(e).scrollingElement ? window : lw(e) ? e : null : null;
}
function gT(e) {
  return aw(e) ? e.scrollX : e.scrollLeft;
}
function _T(e) {
  return aw(e) ? e.scrollY : e.scrollTop;
}
function vT(e) {
  return {
    x: gT(e),
    y: _T(e)
  };
}
var yT;
(function (e) {
  e[e.Forward = 1] = `Forward`, e[e.Backward = -1] = `Backward`;
})(yT ||= {});
function bT(e) {
  return !iw || !e ? !1 : e === document.scrollingElement;
}
function xT(e) {
  let t = {
      x: 0,
      y: 0
    },
    n = bT(e) ? {
      height: window.innerHeight,
      width: window.innerWidth
    } : {
      height: e.clientHeight,
      width: e.clientWidth
    },
    r = {
      x: e.scrollWidth - n.width,
      y: e.scrollHeight - n.height
    };
  return {
    isTop: e.scrollTop <= t.y,
    isLeft: e.scrollLeft <= t.x,
    isBottom: e.scrollTop >= r.y,
    isRight: e.scrollLeft >= r.x,
    maxScroll: r,
    minScroll: t
  };
}
var ST = {
  x: .2,
  y: .2
};
function CT(e, t, n, r, i) {
  let {
    top: a,
    left: o,
    right: s,
    bottom: c
  } = n;
  r === void 0 && (r = 10), i === void 0 && (i = ST);
  let {
      isTop: l,
      isBottom: u,
      isLeft: d,
      isRight: f
    } = xT(e),
    p = {
      x: 0,
      y: 0
    },
    m = {
      x: 0,
      y: 0
    },
    h = {
      height: t.height * i.y,
      width: t.width * i.x
    };
  return !l && a <= t.top + h.height ? (p.y = yT.Backward, m.y = r * Math.abs((t.top + h.height - a) / h.height)) : !u && c >= t.bottom - h.height && (p.y = yT.Forward, m.y = r * Math.abs((t.bottom - h.height - c) / h.height)), !f && s >= t.right - h.width ? (p.x = yT.Forward, m.x = r * Math.abs((t.right - h.width - s) / h.width)) : !d && o <= t.left + h.width && (p.x = yT.Backward, m.x = r * Math.abs((t.left + h.width - o) / h.width)), {
    direction: p,
    speed: m
  };
}
function wT(e) {
  if (e === document.scrollingElement) {
    let {
      innerWidth: e,
      innerHeight: t
    } = window;
    return {
      top: 0,
      left: 0,
      right: e,
      bottom: t,
      width: e,
      height: t
    };
  }
  let {
    top: t,
    left: n,
    right: r,
    bottom: i
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: i,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function TT(e) {
  return e.reduce((e, t) => Sw(e, vT(t)), Gw);
}
function ET(e) {
  return e.reduce((e, t) => e + gT(t), 0);
}
function DT(e) {
  return e.reduce((e, t) => e + _T(t), 0);
}
function OT(e, t) {
  if (t === void 0 && (t = cT), !e) return;
  let {
    top: n,
    left: r,
    bottom: i,
    right: a
  } = t(e);
  mT(e) && (i <= 0 || a <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
    block: `center`,
    inline: `center`
  });
}
var kT = [[`x`, [`left`, `right`], ET], [`y`, [`top`, `bottom`], DT]],
  AT = class {
    constructor(e, t) {
      this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
      let n = pT(t),
        r = TT(n);
      this.rect = {
        ...e
      }, this.width = e.width, this.height = e.height;
      for (let [e, t, i] of kT) for (let a of t) Object.defineProperty(this, a, {
        get: () => {
          let t = i(n),
            o = r[e] - t;
          return this.rect[a] + o;
        },
        enumerable: !0
      });
      Object.defineProperty(this, "rect", {
        enumerable: !1
      });
    }
  },
  jT = class {
    constructor(e) {
      this.target = void 0, this.listeners = [], this.removeAll = () => {
        this.listeners.forEach(e => this.target?.removeEventListener(...e));
      }, this.target = e;
    }
    add(e, t, n) {
      var r;
      (r = this.target) == null || r.addEventListener(e, t, n), this.listeners.push([e, t, n]);
    }
  };
function MT(e) {
  let {
    EventTarget: t
  } = sw(e);
  return e instanceof t ? e : dw(e);
}
function NT(e, t) {
  let n = Math.abs(e.x),
    r = Math.abs(e.y);
  return typeof t == `number` ? Math.sqrt(n ** 2 + r ** 2) > t : `x` in t && `y` in t ? n > t.x && r > t.y : `x` in t ? n > t.x : `y` in t && r > t.y;
}
var PT;
(function (e) {
  e.Click = `click`, e.DragStart = `dragstart`, e.Keydown = `keydown`, e.ContextMenu = `contextmenu`, e.Resize = `resize`, e.SelectionChange = `selectionchange`, e.VisibilityChange = `visibilitychange`;
})(PT ||= {});
function FT(e) {
  e.preventDefault();
}
function IT(e) {
  e.stopPropagation();
}
var LT;
(function (e) {
  e.Space = `Space`, e.Down = `ArrowDown`, e.Right = `ArrowRight`, e.Left = `ArrowLeft`, e.Up = `ArrowUp`, e.Esc = `Escape`, e.Enter = `Enter`, e.Tab = `Tab`;
})(LT ||= {});
var RT = {
    start: [LT.Space, LT.Enter],
    cancel: [LT.Esc],
    end: [LT.Space, LT.Enter, LT.Tab]
  },
  zT = (e, t) => {
    let {
      currentCoordinates: n
    } = t;
    switch (e.code) {
      case LT.Right:
        return {
          ...n,
          x: n.x + 25
        };
      case LT.Left:
        return {
          ...n,
          x: n.x - 25
        };
      case LT.Down:
        return {
          ...n,
          y: n.y + 25
        };
      case LT.Up:
        return {
          ...n,
          y: n.y - 25
        };
    }
  },
  BT = class {
    constructor(e) {
      this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = e;
      let {
        event: {
          target: t
        }
      } = e;
      this.props = e, this.listeners = new jT(dw(t)), this.windowListeners = new jT(sw(t)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
    }
    attach() {
      this.handleStart(), this.windowListeners.add(PT.Resize, this.handleCancel), this.windowListeners.add(PT.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(PT.Keydown, this.handleKeyDown));
    }
    handleStart() {
      let {
          activeNode: e,
          onStart: t
        } = this.props,
        n = e.node.current;
      n && OT(n), t(Gw);
    }
    handleKeyDown(e) {
      if (Tw(e)) {
        let {
            active: t,
            context: n,
            options: r
          } = this.props,
          {
            keyboardCodes: i = RT,
            coordinateGetter: a = zT,
            scrollBehavior: o = `smooth`
          } = r,
          {
            code: s
          } = e;
        if (i.end.includes(s)) {
          this.handleEnd(e);
          return;
        }
        if (i.cancel.includes(s)) {
          this.handleCancel(e);
          return;
        }
        let {
            collisionRect: c
          } = n.current,
          l = c ? {
            x: c.left,
            y: c.top
          } : Gw;
        this.referenceCoordinates ||= l;
        let u = a(e, {
          active: t,
          context: n.current,
          currentCoordinates: l
        });
        if (u) {
          let t = Cw(u, l),
            r = {
              x: 0,
              y: 0
            },
            {
              scrollableAncestors: i
            } = n.current;
          for (let n of i) {
            let i = e.code,
              {
                isTop: a,
                isRight: s,
                isLeft: c,
                isBottom: l,
                maxScroll: d,
                minScroll: f
              } = xT(n),
              p = wT(n),
              m = {
                x: Math.min(i === LT.Right ? p.right - p.width / 2 : p.right, Math.max(i === LT.Right ? p.left : p.left + p.width / 2, u.x)),
                y: Math.min(i === LT.Down ? p.bottom - p.height / 2 : p.bottom, Math.max(i === LT.Down ? p.top : p.top + p.height / 2, u.y))
              },
              h = i === LT.Right && !s || i === LT.Left && !c,
              g = i === LT.Down && !l || i === LT.Up && !a;
            if (h && m.x !== u.x) {
              let e = n.scrollLeft + t.x,
                a = i === LT.Right && e <= d.x || i === LT.Left && e >= f.x;
              if (a && !t.y) {
                n.scrollTo({
                  left: e,
                  behavior: o
                });
                return;
              }
              r.x = a ? n.scrollLeft - e : i === LT.Right ? n.scrollLeft - d.x : n.scrollLeft - f.x, r.x && n.scrollBy({
                left: -r.x,
                behavior: o
              });
              break;
            }
            if (g && m.y !== u.y) {
              let e = n.scrollTop + t.y,
                a = i === LT.Down && e <= d.y || i === LT.Up && e >= f.y;
              if (a && !t.x) {
                n.scrollTo({
                  top: e,
                  behavior: o
                });
                return;
              }
              r.y = a ? n.scrollTop - e : i === LT.Down ? n.scrollTop - d.y : n.scrollTop - f.y, r.y && n.scrollBy({
                top: -r.y,
                behavior: o
              });
              break;
            }
          }
          this.handleMove(e, Sw(Cw(u, this.referenceCoordinates), r));
        }
      }
    }
    handleMove(e, t) {
      let {
        onMove: n
      } = this.props;
      e.preventDefault(), n(t);
    }
    handleEnd(e) {
      let {
        onEnd: t
      } = this.props;
      e.preventDefault(), this.detach(), t();
    }
    handleCancel(e) {
      let {
        onCancel: t
      } = this.props;
      e.preventDefault(), this.detach(), t();
    }
    detach() {
      this.listeners.removeAll(), this.windowListeners.removeAll();
    }
  };
BT.activators = [{
  eventName: `onKeyDown`,
  handler: (e, t, n) => {
    let {
        keyboardCodes: r = RT,
        onActivation: i
      } = t,
      {
        active: a
      } = n,
      {
        code: o
      } = e.nativeEvent;
    if (r.start.includes(o)) {
      let t = a.activatorNode.current;
      return t && e.target !== t ? !1 : (e.preventDefault(), i?.({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function VT(e) {
  return !!(e && `distance` in e);
}
function HT(e) {
  return !!(e && `delay` in e);
}
var UT = class {
    constructor(e, t, n) {
      n === void 0 && (n = MT(e.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = e, this.events = t;
      let {
          event: r
        } = e,
        {
          target: i
        } = r;
      this.props = e, this.events = t, this.document = dw(i), this.documentListeners = new jT(this.document), this.listeners = new jT(n), this.windowListeners = new jT(sw(i)), this.initialCoordinates = Dw(r) ?? Gw, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
    }
    attach() {
      let {
        events: e,
        props: {
          options: {
            activationConstraint: t,
            bypassActivationConstraint: n
          }
        }
      } = this;
      if (this.listeners.add(e.move.name, this.handleMove, {
        passive: !1
      }), this.listeners.add(e.end.name, this.handleEnd), e.cancel && this.listeners.add(e.cancel.name, this.handleCancel), this.windowListeners.add(PT.Resize, this.handleCancel), this.windowListeners.add(PT.DragStart, FT), this.windowListeners.add(PT.VisibilityChange, this.handleCancel), this.windowListeners.add(PT.ContextMenu, FT), this.documentListeners.add(PT.Keydown, this.handleKeydown), t) {
        if (n != null && n({
          event: this.props.event,
          activeNode: this.props.activeNode,
          options: this.props.options
        })) return this.handleStart();
        if (HT(t)) {
          this.timeoutId = setTimeout(this.handleStart, t.delay), this.handlePending(t);
          return;
        }
        if (VT(t)) {
          this.handlePending(t);
          return;
        }
      }
      this.handleStart();
    }
    detach() {
      this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
    }
    handlePending(e, t) {
      let {
        active: n,
        onPending: r
      } = this.props;
      r(n, e, this.initialCoordinates, t);
    }
    handleStart() {
      let {
          initialCoordinates: e
        } = this,
        {
          onStart: t
        } = this.props;
      e && (this.activated = !0, this.documentListeners.add(PT.Click, IT, {
        capture: !0
      }), this.removeTextSelection(), this.documentListeners.add(PT.SelectionChange, this.removeTextSelection), t(e));
    }
    handleMove(e) {
      let {
          activated: t,
          initialCoordinates: n,
          props: r
        } = this,
        {
          onMove: i,
          options: {
            activationConstraint: a
          }
        } = r;
      if (!n) return;
      let o = Dw(e) ?? Gw,
        s = Cw(n, o);
      if (!t && a) {
        if (VT(a)) {
          if (a.tolerance != null && NT(s, a.tolerance)) return this.handleCancel();
          if (NT(s, a.distance)) return this.handleStart();
        }
        if (HT(a) && NT(s, a.tolerance)) return this.handleCancel();
        this.handlePending(a, s);
        return;
      }
      e.cancelable && e.preventDefault(), i(o);
    }
    handleEnd() {
      let {
        onAbort: e,
        onEnd: t
      } = this.props;
      this.detach(), this.activated || e(this.props.active), t();
    }
    handleCancel() {
      let {
        onAbort: e,
        onCancel: t
      } = this.props;
      this.detach(), this.activated || e(this.props.active), t();
    }
    handleKeydown(e) {
      e.code === LT.Esc && this.handleCancel();
    }
    removeTextSelection() {
      var e;
      (e = this.document.getSelection()) == null || e.removeAllRanges();
    }
  },
  WT = {
    cancel: {
      name: `pointercancel`
    },
    move: {
      name: `pointermove`
    },
    end: {
      name: `pointerup`
    }
  },
  GT = class extends UT {
    constructor(e) {
      let {
          event: t
        } = e,
        n = dw(t.target);
      super(e, WT, n);
    }
  };
GT.activators = [{
  eventName: `onPointerDown`,
  handler: (e, t) => {
    let {
        nativeEvent: n
      } = e,
      {
        onActivation: r
      } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
var KT = {
    move: {
      name: `mousemove`
    },
    end: {
      name: `mouseup`
    }
  },
  qT;
(function (e) {
  e[e.RightClick = 2] = `RightClick`;
})(qT ||= {});
var JT = class extends UT {
  constructor(e) {
    super(e, KT, dw(e.event.target));
  }
};
JT.activators = [{
  eventName: `onMouseDown`,
  handler: (e, t) => {
    let {
        nativeEvent: n
      } = e,
      {
        onActivation: r
      } = t;
    return n.button !== qT.RightClick && (r?.({
      event: n
    }), !0);
  }
}];
var YT = {
    cancel: {
      name: `touchcancel`
    },
    move: {
      name: `touchmove`
    },
    end: {
      name: `touchend`
    }
  },
  XT = class extends UT {
    constructor(e) {
      super(e, YT);
    }
    static setup() {
      return window.addEventListener(YT.move.name, e, {
        capture: !1,
        passive: !1
      }), function () {
        window.removeEventListener(YT.move.name, e);
      };
      function e() {}
    }
  };
XT.activators = [{
  eventName: `onTouchStart`,
  handler: (e, t) => {
    let {
        nativeEvent: n
      } = e,
      {
        onActivation: r
      } = t,
      {
        touches: i
      } = n;
    return i.length > 1 ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
var ZT;
(function (e) {
  e[e.Pointer = 0] = `Pointer`, e[e.DraggableRect = 1] = `DraggableRect`;
})(ZT ||= {});
var QT;
(function (e) {
  e[e.TreeOrder = 0] = `TreeOrder`, e[e.ReversedTreeOrder = 1] = `ReversedTreeOrder`;
})(QT ||= {});
function $T(e) {
  let {
      acceleration: t,
      activator: n = ZT.Pointer,
      canScroll: r,
      draggingRect: i,
      enabled: a,
      interval: o = 5,
      order: s = QT.TreeOrder,
      pointerCoordinates: c,
      scrollableAncestors: l,
      scrollableAncestorRects: u,
      delta: f,
      threshold: p
    } = e,
    m = tE({
      delta: f,
      disabled: !a
    }),
    [h, g] = mw(),
    _ = (0, React.useRef)({
      x: 0,
      y: 0
    }),
    v = (0, React.useRef)({
      x: 0,
      y: 0
    }),
    y = (0, React.useMemo)(() => {
      switch (n) {
        case ZT.Pointer:
          return c ? {
            top: c.y,
            bottom: c.y,
            left: c.x,
            right: c.x
          } : null;
        case ZT.DraggableRect:
          return i;
      }
    }, [n, i, c]),
    b = (0, React.useRef)(null),
    x = (0, React.useCallback)(() => {
      let e = b.current;
      if (!e) return;
      let t = _.current.x * v.current.x,
        n = _.current.y * v.current.y;
      e.scrollBy(t, n);
    }, []),
    S = (0, React.useMemo)(() => s === QT.TreeOrder ? [...l].reverse() : l, [s, l]);
  (0, React.useEffect)(() => {
    if (!a || !l.length || !y) {
      g();
      return;
    }
    for (let e of S) {
      if (r?.(e) === !1) continue;
      let n = l.indexOf(e),
        i = u[n];
      if (!i) continue;
      let {
        direction: a,
        speed: s
      } = CT(e, i, y, t, p);
      for (let e of [`x`, `y`]) m[e][a[e]] || (s[e] = 0, a[e] = 0);
      if (s.x > 0 || s.y > 0) {
        g(), b.current = e, h(x, o), _.current = s, v.current = a;
        return;
      }
    }
    _.current = {
      x: 0,
      y: 0
    }, v.current = {
      x: 0,
      y: 0
    }, g();
  }, [t, x, r, g, a, o, JSON.stringify(y), JSON.stringify(m), h, l, S, u, JSON.stringify(p)]);
}
var eE = {
  x: {
    [yT.Backward]: !1,
    [yT.Forward]: !1
  },
  y: {
    [yT.Backward]: !1,
    [yT.Forward]: !1
  }
};
function tE(e) {
  let {
      delta: t,
      disabled: n
    } = e,
    r = vw(t);
  return gw(e => {
    if (n || !r || !e) return eE;
    let i = {
      x: Math.sign(t.x - r.x),
      y: Math.sign(t.y - r.y)
    };
    return {
      x: {
        [yT.Backward]: e.x[yT.Backward] || i.x === -1,
        [yT.Forward]: e.x[yT.Forward] || i.x === 1
      },
      y: {
        [yT.Backward]: e.y[yT.Backward] || i.y === -1,
        [yT.Forward]: e.y[yT.Forward] || i.y === 1
      }
    };
  }, [n, t, r]);
}
function nE(e, t) {
  let n = t == null ? void 0 : e.get(t),
    r = n ? n.node.current : null;
  return gw(e => t == null ? null : r ?? e ?? null, [r, t]);
}
function rE(e, t) {
  return (0, React.useMemo)(() => e.reduce((e, n) => {
    let {
        sensor: r
      } = n,
      i = r.activators.map(e => ({
        eventName: e.eventName,
        handler: t(e.handler, n)
      }));
    return [...e, ...i];
  }, []), [e, t]);
}
var iE;
(function (e) {
  e[e.Always = 0] = `Always`, e[e.BeforeDragging = 1] = `BeforeDragging`, e[e.WhileDragging = 2] = `WhileDragging`;
})(iE ||= {});
var aE;
(function (e) {
  e.Optimized = `optimized`;
})(aE ||= {});
var oE = new Map();
function sE(e, t) {
  let {
      dragging: n,
      dependencies: r,
      config: i
    } = t,
    [a, o] = (0, React.useState)(null),
    {
      frequency: s,
      measure: c,
      strategy: l
    } = i,
    u = (0, React.useRef)(e),
    f = _(),
    p = hw(f),
    m = (0, React.useCallback)(function (e) {
      e === void 0 && (e = []), !p.current && o(t => t === null ? e : t.concat(e.filter(e => !t.includes(e))));
    }, [p]),
    h = (0, React.useRef)(null),
    g = gw(t => {
      if (f && !n) return oE;
      if (!t || t === oE || u.current !== e || a != null) {
        let t = new Map();
        for (let n of e) {
          if (!n) continue;
          if (a && a.length > 0 && !a.includes(n.id) && n.rect.current) {
            t.set(n.id, n.rect.current);
            continue;
          }
          let e = n.node.current,
            r = e ? new AT(c(e), e) : null;
          n.rect.current = r, r && t.set(n.id, r);
        }
        return t;
      }
      return t;
    }, [e, a, n, f, c]);
  return (0, React.useEffect)(() => {
    u.current = e;
  }, [e]), (0, React.useEffect)(() => {
    f || m();
  }, [n, f]), (0, React.useEffect)(() => {
    a && a.length > 0 && o(null);
  }, [JSON.stringify(a)]), (0, React.useEffect)(() => {
    f || typeof s != `number` || h.current !== null || (h.current = setTimeout(() => {
      m(), h.current = null;
    }, s));
  }, [s, f, m, ...r]), {
    droppableRects: g,
    measureDroppableContainers: m,
    measuringScheduled: a != null
  };
  function _() {
    switch (l) {
      case iE.Always:
        return !1;
      case iE.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function cE(e, t) {
  return gw(n => e ? n || (typeof t == `function` ? t(e) : e) : null, [t, e]);
}
function lE(e, t) {
  return cE(e, t);
}
function uE(e) {
  let {
      callback: t,
      disabled: n
    } = e,
    r = pw(t),
    i = (0, React.useMemo)(() => {
      if (n || typeof window > `u` || window.MutationObserver === void 0) return;
      let {
        MutationObserver: e
      } = window;
      return new e(r);
    }, [r, n]);
  return (0, React.useEffect)(() => () => i?.disconnect(), [i]), i;
}
function dE(e) {
  let {
      callback: t,
      disabled: n
    } = e,
    r = pw(t),
    i = (0, React.useMemo)(() => {
      if (n || typeof window > `u` || window.ResizeObserver === void 0) return;
      let {
        ResizeObserver: e
      } = window;
      return new e(r);
    }, [n]);
  return (0, React.useEffect)(() => () => i?.disconnect(), [i]), i;
}
function fE(e) {
  return new AT(cT(e), e);
}
function pE(e, t, n) {
  t === void 0 && (t = fE);
  let [r, i] = (0, React.useState)(null);
  function a() {
    i(r => {
      if (!e) return null;
      if (e.isConnected === !1) return r ?? n ?? null;
      let i = t(e);
      return JSON.stringify(r) === JSON.stringify(i) ? r : i;
    });
  }
  let o = uE({
      callback(t) {
        if (e) for (let n of t) {
          let {
            type: t,
            target: r
          } = n;
          if (t === `childList` && r instanceof HTMLElement && r.contains(e)) {
            a();
            break;
          }
        }
      }
    }),
    s = dE({
      callback: a
    });
  return fw(() => {
    a(), e ? (s?.observe(e), o?.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (s?.disconnect(), o?.disconnect());
  }, [e]), r;
}
function mE(e) {
  return nT(e, cE(e));
}
var hE = [];
function gE(e) {
  let t = (0, React.useRef)(e),
    n = gw(n => e ? n && n !== hE && e && t.current && e.parentNode === t.current.parentNode ? n : pT(e) : hE, [e]);
  return (0, React.useEffect)(() => {
    t.current = e;
  }, [e]), n;
}
function _E(e) {
  let [t, n] = (0, React.useState)(null),
    r = (0, React.useRef)(e),
    i = (0, React.useCallback)(e => {
      let t = hT(e.target);
      t && n(e => e ? (e.set(t, vT(t)), new Map(e)) : null);
    }, []);
  return (0, React.useEffect)(() => {
    let t = r.current;
    if (e !== t) {
      a(t);
      let o = e.map(e => {
        let t = hT(e);
        return t ? (t.addEventListener(`scroll`, i, {
          passive: !0
        }), [t, vT(t)]) : null;
      }).filter(e => e != null);
      n(o.length ? new Map(o) : null), r.current = e;
    }
    return () => {
      a(e), a(t);
    };
    function a(e) {
      e.forEach(e => {
        hT(e)?.removeEventListener(`scroll`, i);
      });
    }
  }, [i, e]), (0, React.useMemo)(() => e.length ? t ? Array.from(t.values()).reduce((e, t) => Sw(e, t), Gw) : TT(e) : Gw, [e, t]);
}
function vE(e, t) {
  t === void 0 && (t = []);
  let n = (0, React.useRef)(null);
  return (0, React.useEffect)(() => {
    n.current = null;
  }, t), (0, React.useEffect)(() => {
    let t = e !== Gw;
    t && !n.current && (n.current = e), !t && n.current && (n.current = null);
  }, [e]), n.current ? Cw(e, n.current) : Gw;
}
function yE(e) {
  (0, React.useEffect)(() => {
    if (!iw) return;
    let t = e.map(e => {
      let {
        sensor: t
      } = e;
      return t.setup == null ? void 0 : t.setup();
    });
    return () => {
      for (let e of t) e?.();
    };
  }, e.map(e => {
    let {
      sensor: t
    } = e;
    return t;
  }));
}
function bE(e, t) {
  return (0, React.useMemo)(() => e.reduce((e, n) => {
    let {
      eventName: r,
      handler: i
    } = n;
    return e[r] = e => {
      i(e, t);
    }, e;
  }, {}), [e, t]);
}
function xE(e) {
  return (0, React.useMemo)(() => e ? uT(e) : null, [e]);
}
var SE = [];
function CE(e, t) {
  t === void 0 && (t = cT);
  let [n] = e,
    r = xE(n ? sw(n) : null),
    [i, a] = (0, React.useState)(SE);
  function o() {
    a(() => e.length ? e.map(e => bT(e) ? r : new AT(t(e), e)) : SE);
  }
  let s = dE({
    callback: o
  });
  return fw(() => {
    s?.disconnect(), o(), e.forEach(e => s?.observe(e));
  }, [e]), i;
}
function wE(e) {
  if (!e) return null;
  if (e.children.length > 1) return e;
  let t = e.children[0];
  return lw(t) ? t : e;
}
function TE(e) {
  let {
      measure: t
    } = e,
    [n, r] = (0, React.useState)(null),
    i = dE({
      callback: (0, React.useCallback)(e => {
        for (let {
          target: n
        } of e) if (lw(n)) {
          r(e => {
            let r = t(n);
            return e ? {
              ...e,
              width: r.width,
              height: r.height
            } : r;
          });
          break;
        }
      }, [t])
    }),
    [a, o] = _w((0, React.useCallback)(e => {
      let n = wE(e);
      i?.disconnect(), n && i?.observe(n), r(n ? t(n) : null);
    }, [t, i]));
  return (0, React.useMemo)(() => ({
    nodeRef: a,
    rect: n,
    setRef: o
  }), [n, a, o]);
}
var EE = [{
    sensor: GT,
    options: {}
  }, {
    sensor: BT,
    options: {}
  }],
  DE = {
    current: {}
  },
  OE = {
    draggable: {
      measure: lT
    },
    droppable: {
      measure: lT,
      strategy: iE.WhileDragging,
      frequency: aE.Optimized
    },
    dragOverlay: {
      measure: cT
    }
  },
  kE = class extends Map {
    get(e) {
      return e == null ? void 0 : super.get(e) ?? void 0;
    }
    toArray() {
      return Array.from(this.values());
    }
    getEnabled() {
      return this.toArray().filter(e => {
        let {
          disabled: t
        } = e;
        return !t;
      });
    }
    getNodeFor(e) {
      return this.get(e)?.node.current ?? void 0;
    }
  },
  AE = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: new Map(),
    droppableRects: new Map(),
    droppableContainers: new kE(),
    over: null,
    dragOverlay: {
      nodeRef: {
        current: null
      },
      rect: null,
      setRef: Hw
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: OE,
    measureDroppableContainers: Hw,
    windowRect: null,
    measuringScheduled: !1
  },
  jE = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
      draggable: ``
    },
    dispatch: Hw,
    draggableNodes: new Map(),
    over: null,
    measureDroppableContainers: Hw
  },
  ME = (0, React.createContext)(jE),
  NE = (0, React.createContext)(AE);
function PE() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new kE()
    }
  };
}
function FE(e, t) {
  switch (t.type) {
    case Vw.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case Vw.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case Vw.DragEnd:
    case Vw.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Vw.RegisterDroppable:
      {
        let {
            element: n
          } = t,
          {
            id: r
          } = n,
          i = new kE(e.droppable.containers);
        return i.set(r, n), {
          ...e,
          droppable: {
            ...e.droppable,
            containers: i
          }
        };
      }
    case Vw.SetDroppableDisabled:
      {
        let {
            id: n,
            key: r,
            disabled: i
          } = t,
          a = e.droppable.containers.get(n);
        if (!a || r !== a.key) return e;
        let o = new kE(e.droppable.containers);
        return o.set(n, {
          ...a,
          disabled: i
        }), {
          ...e,
          droppable: {
            ...e.droppable,
            containers: o
          }
        };
      }
    case Vw.UnregisterDroppable:
      {
        let {
            id: n,
            key: r
          } = t,
          i = e.droppable.containers.get(n);
        if (!i || r !== i.key) return e;
        let a = new kE(e.droppable.containers);
        return a.delete(n), {
          ...e,
          droppable: {
            ...e.droppable,
            containers: a
          }
        };
      }
    default:
      return e;
  }
}
function IE(e) {
  let {
      disabled: t
    } = e,
    {
      active: n,
      activatorEvent: r,
      draggableNodes: i
    } = (0, React.useContext)(ME),
    a = vw(r),
    o = vw(n?.id);
  return (0, React.useEffect)(() => {
    if (!t && !r && a && o != null) {
      if (!Tw(a) || document.activeElement === a.target) return;
      let e = i.get(o);
      if (!e) return;
      let {
        activatorNode: t,
        node: n
      } = e;
      if (!t.current && !n.current) return;
      requestAnimationFrame(() => {
        for (let e of [t.current, n.current]) {
          if (!e) continue;
          let t = Aw(e);
          if (t) {
            t.focus();
            break;
          }
        }
      });
    }
  }, [r, t, i, o, a]), null;
}
function LE(e, t) {
  let {
    transform: n,
    ...r
  } = t;
  return e != null && e.length ? e.reduce((e, t) => t({
    transform: e,
    ...r
  }), n) : n;
}
function RE(e) {
  return (0, React.useMemo)(() => ({
    draggable: {
      ...OE.draggable,
      ...e?.draggable
    },
    droppable: {
      ...OE.droppable,
      ...e?.droppable
    },
    dragOverlay: {
      ...OE.dragOverlay,
      ...e?.dragOverlay
    }
  }), [e?.draggable, e?.droppable, e?.dragOverlay]);
}
function zE(e) {
  let {
      activeNode: t,
      measure: n,
      initialRect: r,
      config: i = !0
    } = e,
    a = (0, React.useRef)(!1),
    {
      x: o,
      y: s
    } = typeof i == `boolean` ? {
      x: i,
      y: i
    } : i;
  fw(() => {
    if (!o && !s || !t) {
      a.current = !1;
      return;
    }
    if (a.current || !r) return;
    let e = t?.node.current;
    if (!e || e.isConnected === !1) return;
    let i = nT(n(e), r);
    if (o || (i.x = 0), s || (i.y = 0), a.current = !0, Math.abs(i.x) > 0 || Math.abs(i.y) > 0) {
      let t = mT(e);
      t && t.scrollBy({
        top: i.y,
        left: i.x
      });
    }
  }, [t, o, s, r, n]);
}
var BE = (0, React.createContext)({
    ...Gw,
    scaleX: 1,
    scaleY: 1
  }),
  VE;
(function (e) {
  e[e.Uninitialized = 0] = `Uninitialized`, e[e.Initializing = 1] = `Initializing`, e[e.Initialized = 2] = `Initialized`;
})(VE ||= {});
var HE = (0, React.memo)(function (e) {
    let {
        id: t,
        accessibility: n,
        autoScroll: r = !0,
        children: i,
        sensors: a = EE,
        collisionDetection: o = eT,
        measuring: s,
        modifiers: c,
        ...l
      } = e,
      [u, f] = (0, React.useReducer)(FE, void 0, PE),
      [p, m] = Lw(),
      [g, _] = (0, React.useState)(VE.Uninitialized),
      v = g === VE.Initialized,
      {
        draggable: {
          active: y,
          nodes: b,
          translate: x
        },
        droppable: {
          containers: S
        }
      } = u,
      C = y == null ? null : b.get(y),
      w = (0, React.useRef)({
        initial: null,
        translated: null
      }),
      T = (0, React.useMemo)(() => y == null ? null : {
        id: y,
        data: C?.data ?? DE,
        rect: w
      }, [y, C]),
      E = (0, React.useRef)(null),
      [D, O] = (0, React.useState)(null),
      [k, A] = (0, React.useState)(null),
      j = hw(l, Object.values(l)),
      M = bw(`DndDescribedBy`, t),
      N = (0, React.useMemo)(() => S.getEnabled(), [S]),
      P = RE(s),
      {
        droppableRects: F,
        measureDroppableContainers: I,
        measuringScheduled: L
      } = sE(N, {
        dragging: v,
        dependencies: [x.x, x.y],
        config: P.droppable
      }),
      R = nE(b, y),
      z = (0, React.useMemo)(() => k ? Dw(k) : null, [k]),
      ee = De(),
      te = lE(R, P.draggable.measure);
    zE({
      activeNode: y == null ? null : b.get(y),
      config: ee.layoutShiftCompensation,
      initialRect: te,
      measure: P.draggable.measure
    });
    let B = pE(R, P.draggable.measure, te),
      V = pE(R ? R.parentElement : null),
      H = (0, React.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: R,
        collisionRect: null,
        collisions: null,
        droppableRects: F,
        draggableNodes: b,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: S,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
      }),
      ne = S.getNodeFor(H.current.over?.id),
      re = TE({
        measure: P.dragOverlay.measure
      }),
      ie = re.nodeRef.current ?? R,
      U = v ? re.rect ?? B : null,
      ae = !!(re.nodeRef.current && re.rect),
      oe = mE(ae ? null : B),
      se = xE(ie ? sw(ie) : null),
      ce = gE(v ? ne ?? R : null),
      le = CE(ce),
      ue = LE(c, {
        transform: {
          x: x.x - oe.x,
          y: x.y - oe.y,
          scaleX: 1,
          scaleY: 1
        },
        activatorEvent: k,
        active: T,
        activeNodeRect: B,
        containerNodeRect: V,
        draggingNodeRect: U,
        over: H.current.over,
        overlayNodeRect: re.rect,
        scrollableAncestors: ce,
        scrollableAncestorRects: le,
        windowRect: se
      }),
      de = z ? Sw(z, x) : null,
      fe = _E(ce),
      pe = vE(fe),
      me = vE(fe, [B]),
      he = Sw(ue, pe),
      ge = U ? iT(U, ue) : null,
      _e = T && ge ? o({
        active: T,
        collisionRect: ge,
        droppableRects: F,
        droppableContainers: N,
        pointerCoordinates: de
      }) : null,
      ve = Zw(_e, `id`),
      [ye, be] = (0, React.useState)(null),
      xe = tT(ae ? ue : Sw(ue, me), ye?.rect ?? null, B),
      Se = (0, React.useRef)(null),
      Ce = (0, React.useCallback)((e, t) => {
        let {
          sensor: n,
          options: r
        } = t;
        if (E.current == null) return;
        let i = b.get(E.current);
        if (!i) return;
        let a = e.nativeEvent,
          o = new n({
            active: E.current,
            activeNode: i,
            event: a,
            options: r,
            context: H,
            onAbort(e) {
              if (!b.get(e)) return;
              let {
                  onDragAbort: t
                } = j.current,
                n = {
                  id: e
                };
              t?.(n), p({
                type: `onDragAbort`,
                event: n
              });
            },
            onPending(e, t, n, r) {
              if (!b.get(e)) return;
              let {
                  onDragPending: i
                } = j.current,
                a = {
                  id: e,
                  constraint: t,
                  initialCoordinates: n,
                  offset: r
                };
              i?.(a), p({
                type: `onDragPending`,
                event: a
              });
            },
            onStart(e) {
              let t = E.current;
              if (t == null) return;
              let n = b.get(t);
              if (!n) return;
              let {
                  onDragStart: r
                } = j.current,
                i = {
                  activatorEvent: a,
                  active: {
                    id: t,
                    data: n.data,
                    rect: w
                  }
                };
              (0, h.unstable_batchedUpdates)(() => {
                r?.(i), _(VE.Initializing), f({
                  type: Vw.DragStart,
                  initialCoordinates: e,
                  active: t
                }), p({
                  type: `onDragStart`,
                  event: i
                }), O(Se.current), A(a);
              });
            },
            onMove(e) {
              f({
                type: Vw.DragMove,
                coordinates: e
              });
            },
            onEnd: s(Vw.DragEnd),
            onCancel: s(Vw.DragCancel)
          });
        Se.current = o;
        function s(e) {
          return async function () {
            let {
                active: t,
                collisions: n,
                over: r,
                scrollAdjustedTranslate: i
              } = H.current,
              o = null;
            if (t && i) {
              let {
                cancelDrop: s
              } = j.current;
              o = {
                activatorEvent: a,
                active: t,
                collisions: n,
                delta: i,
                over: r
              }, e === Vw.DragEnd && typeof s == `function` && (await Promise.resolve(s(o))) && (e = Vw.DragCancel);
            }
            E.current = null, (0, h.unstable_batchedUpdates)(() => {
              f({
                type: e
              }), _(VE.Uninitialized), be(null), O(null), A(null), Se.current = null;
              let t = e === Vw.DragEnd ? `onDragEnd` : `onDragCancel`;
              if (o) {
                let e = j.current[t];
                e?.(o), p({
                  type: t,
                  event: o
                });
              }
            });
          };
        }
      }, [b]),
      we = rE(a, (0, React.useCallback)((e, t) => (n, r) => {
        let i = n.nativeEvent,
          a = b.get(r);
        if (E.current !== null || !a || i.dndKit || i.defaultPrevented) return;
        let o = {
          active: a
        };
        e(n, t.options, o) === !0 && (i.dndKit = {
          capturedBy: t.sensor
        }, E.current = r, Ce(n, t));
      }, [b, Ce]));
    yE(a), fw(() => {
      B && g === VE.Initializing && _(VE.Initialized);
    }, [B, g]), (0, React.useEffect)(() => {
      let {
          onDragMove: e
        } = j.current,
        {
          active: t,
          activatorEvent: n,
          collisions: r,
          over: i
        } = H.current;
      if (!t || !n) return;
      let a = {
        active: t,
        activatorEvent: n,
        collisions: r,
        delta: {
          x: he.x,
          y: he.y
        },
        over: i
      };
      (0, h.unstable_batchedUpdates)(() => {
        e?.(a), p({
          type: `onDragMove`,
          event: a
        });
      });
    }, [he.x, he.y]), (0, React.useEffect)(() => {
      let {
        active: e,
        activatorEvent: t,
        collisions: n,
        droppableContainers: r,
        scrollAdjustedTranslate: i
      } = H.current;
      if (!e || E.current == null || !t || !i) return;
      let {
          onDragOver: a
        } = j.current,
        o = r.get(ve),
        s = o && o.rect.current ? {
          id: o.id,
          rect: o.rect.current,
          data: o.data,
          disabled: o.disabled
        } : null,
        c = {
          active: e,
          activatorEvent: t,
          collisions: n,
          delta: {
            x: i.x,
            y: i.y
          },
          over: s
        };
      (0, h.unstable_batchedUpdates)(() => {
        be(s), a?.(c), p({
          type: `onDragOver`,
          event: c
        });
      });
    }, [ve]), fw(() => {
      H.current = {
        activatorEvent: k,
        active: T,
        activeNode: R,
        collisionRect: ge,
        collisions: _e,
        droppableRects: F,
        draggableNodes: b,
        draggingNode: ie,
        draggingNodeRect: U,
        droppableContainers: S,
        over: ye,
        scrollableAncestors: ce,
        scrollAdjustedTranslate: he
      }, w.current = {
        initial: U,
        translated: ge
      };
    }, [T, R, _e, ge, b, ie, U, F, S, ye, ce, he]), $T({
      ...ee,
      delta: x,
      draggingRect: ge,
      pointerCoordinates: de,
      scrollableAncestors: ce,
      scrollableAncestorRects: le
    });
    let Te = (0, React.useMemo)(() => ({
        active: T,
        activeNode: R,
        activeNodeRect: B,
        activatorEvent: k,
        collisions: _e,
        containerNodeRect: V,
        dragOverlay: re,
        draggableNodes: b,
        droppableContainers: S,
        droppableRects: F,
        over: ye,
        measureDroppableContainers: I,
        scrollableAncestors: ce,
        scrollableAncestorRects: le,
        measuringConfiguration: P,
        measuringScheduled: L,
        windowRect: se
      }), [T, R, B, k, _e, V, re, b, S, F, ye, I, ce, le, P, L, se]),
      Ee = (0, React.useMemo)(() => ({
        activatorEvent: k,
        activators: we,
        active: T,
        activeNodeRect: B,
        ariaDescribedById: {
          draggable: M
        },
        dispatch: f,
        draggableNodes: b,
        over: ye,
        measureDroppableContainers: I
      }), [k, we, T, B, f, M, b, ye, I]);
    return React.createElement(Fw.Provider, {
      value: m
    }, React.createElement(ME.Provider, {
      value: Ee
    }, React.createElement(NE.Provider, {
      value: Te
    }, React.createElement(BE.Provider, {
      value: xe
    }, i)), React.createElement(IE, {
      disabled: n?.restoreFocus === !1
    })), React.createElement(Bw, {
      ...n,
      hiddenTextDescribedById: M
    }));
    function De() {
      let e = D?.autoScrollEnabled === !1,
        t = typeof r == `object` ? r.enabled === !1 : r === !1,
        n = v && !e && !t;
      return typeof r == `object` ? {
        ...r,
        enabled: n
      } : {
        enabled: n
      };
    }
  }),
  UE = (0, React.createContext)(null),
  WE = `button`,
  GE = `Draggable`;
function KE(e) {
  let {
      id: t,
      data: n,
      disabled: r = !1,
      attributes: i
    } = e,
    a = bw(GE),
    {
      activators: o,
      activatorEvent: s,
      active: c,
      activeNodeRect: l,
      ariaDescribedById: u,
      draggableNodes: f,
      over: p
    } = (0, React.useContext)(ME),
    {
      role: m = WE,
      roleDescription: h = `draggable`,
      tabIndex: g = 0
    } = i ?? {},
    _ = c?.id === t,
    v = (0, React.useContext)(_ ? BE : UE),
    [y, b] = _w(),
    [x, S] = _w(),
    C = bE(o, t),
    w = hw(n);
  return fw(() => (f.set(t, {
    id: t,
    key: a,
    node: y,
    activatorNode: x,
    data: w
  }), () => {
    let e = f.get(t);
    e && e.key === a && f.delete(t);
  }), [f, t]), {
    active: c,
    activatorEvent: s,
    activeNodeRect: l,
    attributes: (0, React.useMemo)(() => ({
      role: m,
      tabIndex: g,
      "aria-disabled": r,
      "aria-pressed": _ && m === WE ? !0 : void 0,
      "aria-roledescription": h,
      "aria-describedby": u.draggable
    }), [r, m, g, _, h, u.draggable]),
    isDragging: _,
    listeners: r ? void 0 : C,
    node: y,
    over: p,
    setNodeRef: b,
    setActivatorNodeRef: S,
    transform: v
  };
}
function qE() {
  return (0, React.useContext)(NE);
}
var JE = `Droppable`,
  YE = {
    timeout: 25
  };
function XE(e) {
  let {
      data: t,
      disabled: n = !1,
      id: r,
      resizeObserverConfig: i
    } = e,
    a = bw(JE),
    {
      active: o,
      dispatch: s,
      over: c,
      measureDroppableContainers: l
    } = (0, React.useContext)(ME),
    u = (0, React.useRef)({
      disabled: n
    }),
    f = (0, React.useRef)(!1),
    p = (0, React.useRef)(null),
    m = (0, React.useRef)(null),
    {
      disabled: h,
      updateMeasurementsFor: g,
      timeout: _
    } = {
      ...YE,
      ...i
    },
    v = hw(g ?? r),
    y = dE({
      callback: (0, React.useCallback)(() => {
        if (!f.current) {
          f.current = !0;
          return;
        }
        m.current != null && clearTimeout(m.current), m.current = setTimeout(() => {
          l(Array.isArray(v.current) ? v.current : [v.current]), m.current = null;
        }, _);
      }, [_]),
      disabled: h || !o
    }),
    [b, x] = _w((0, React.useCallback)((e, t) => {
      y && (t && (y.unobserve(t), f.current = !1), e && y.observe(e));
    }, [y])),
    S = hw(t);
  return (0, React.useEffect)(() => {
    y && b.current && (y.disconnect(), f.current = !1, y.observe(b.current));
  }, [b, y]), (0, React.useEffect)(() => (s({
    type: Vw.RegisterDroppable,
    element: {
      id: r,
      key: a,
      disabled: n,
      node: b,
      rect: p,
      data: S
    }
  }), () => s({
    type: Vw.UnregisterDroppable,
    key: a,
    id: r
  })), [r]), (0, React.useEffect)(() => {
    n !== u.current.disabled && (s({
      type: Vw.SetDroppableDisabled,
      id: r,
      key: a,
      disabled: n
    }), u.current.disabled = n);
  }, [r, a, n, s]), {
    active: o,
    rect: p,
    isOver: c?.id === r,
    node: b,
    over: c,
    setNodeRef: x
  };
}
function ZE(e) {
  let {
      animation: t,
      children: n
    } = e,
    [r, i] = (0, React.useState)(null),
    [a, o] = (0, React.useState)(null),
    s = vw(n);
  return !n && !r && s && i(s), fw(() => {
    if (!a) return;
    let e = r?.key,
      n = r?.props.id;
    if (e == null || n == null) {
      i(null);
      return;
    }
    Promise.resolve(t(n, a)).then(() => {
      i(null);
    });
  }, [t, r, a]), React.createElement(React.Fragment, null, n, r ? (0, React.cloneElement)(r, {
    ref: o
  }) : null);
}
var QE = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function $E(e) {
  let {
    children: t
  } = e;
  return React.createElement(ME.Provider, {
    value: jE
  }, React.createElement(BE.Provider, {
    value: QE
  }, t));
}
var eD = {
    position: `fixed`,
    touchAction: `none`
  },
  tD = e => Tw(e) ? `transform 250ms ease` : void 0,
  nD = (0, React.forwardRef)((e, t) => {
    let {
      as: n,
      activatorEvent: r,
      adjustScale: i,
      children: a,
      className: o,
      rect: s,
      style: c,
      transform: l,
      transition: u = tD
    } = e;
    if (!s) return null;
    let f = i ? l : {
        ...l,
        scaleX: 1,
        scaleY: 1
      },
      p = {
        ...eD,
        width: s.width,
        height: s.height,
        top: s.top,
        left: s.left,
        transform: Ow.Transform.toString(f),
        transformOrigin: i && r ? qw(r, s) : void 0,
        transition: typeof u == `function` ? u(r) : u,
        ...c
      };
    return React.createElement(n, {
      className: o,
      style: p,
      ref: t
    }, a);
  }),
  rD = {
    duration: 250,
    easing: `ease`,
    keyframes: e => {
      let {
        transform: {
          initial: t,
          final: n
        }
      } = e;
      return [{
        transform: Ow.Transform.toString(t)
      }, {
        transform: Ow.Transform.toString(n)
      }];
    },
    sideEffects: (e => t => {
      let {
          active: n,
          dragOverlay: r
        } = t,
        i = {},
        {
          styles: a,
          className: o
        } = e;
      if (a != null && a.active) for (let [e, t] of Object.entries(a.active)) t !== void 0 && (i[e] = n.node.style.getPropertyValue(e), n.node.style.setProperty(e, t));
      if (a != null && a.dragOverlay) for (let [e, t] of Object.entries(a.dragOverlay)) t !== void 0 && r.node.style.setProperty(e, t);
      return o != null && o.active && n.node.classList.add(o.active), o != null && o.dragOverlay && r.node.classList.add(o.dragOverlay), function () {
        for (let [e, t] of Object.entries(i)) n.node.style.setProperty(e, t);
        o != null && o.active && n.node.classList.remove(o.active);
      };
    })({
      styles: {
        active: {
          opacity: `0`
        }
      }
    })
  };
function iD(e) {
  let {
    config: t,
    draggableNodes: n,
    droppableContainers: r,
    measuringConfiguration: i
  } = e;
  return pw((e, a) => {
    if (t === null) return;
    let o = n.get(e);
    if (!o) return;
    let s = o.node.current;
    if (!s) return;
    let c = wE(a);
    if (!c) return;
    let {
        transform: l
      } = sw(a).getComputedStyle(a),
      u = aT(l);
    if (!u) return;
    let d = typeof t == `function` ? t : aD(t);
    return OT(s, i.draggable.measure), d({
      active: {
        id: e,
        data: o.data,
        node: s,
        rect: i.draggable.measure(s)
      },
      draggableNodes: n,
      dragOverlay: {
        node: a,
        rect: i.dragOverlay.measure(c)
      },
      droppableContainers: r,
      measuringConfiguration: i,
      transform: u
    });
  });
}
function aD(e) {
  let {
    duration: t,
    easing: n,
    sideEffects: r,
    keyframes: i
  } = {
    ...rD,
    ...e
  };
  return e => {
    let {
      active: a,
      dragOverlay: o,
      transform: s,
      ...c
    } = e;
    if (!t) return;
    let l = {
        x: o.rect.left - a.rect.left,
        y: o.rect.top - a.rect.top
      },
      u = {
        scaleX: s.scaleX === 1 ? 1 : a.rect.width * s.scaleX / o.rect.width,
        scaleY: s.scaleY === 1 ? 1 : a.rect.height * s.scaleY / o.rect.height
      },
      d = {
        x: s.x - l.x,
        y: s.y - l.y,
        ...u
      },
      f = i({
        ...c,
        active: a,
        dragOverlay: o,
        transform: {
          initial: s,
          final: d
        }
      }),
      [p] = f,
      m = f[f.length - 1];
    if (JSON.stringify(p) === JSON.stringify(m)) return;
    let h = r?.({
        active: a,
        dragOverlay: o,
        ...c
      }),
      g = o.node.animate(f, {
        duration: t,
        easing: n,
        fill: `forwards`
      });
    return new Promise(e => {
      g.onfinish = () => {
        h?.(), e();
      };
    });
  };
}
var oD = 0;
function sD(e) {
  return (0, React.useMemo)(() => {
    if (e != null) return oD++, oD;
  }, [e]);
}
var cD = React.memo(e => {
  let {
      adjustScale: t = !1,
      children: n,
      dropAnimation: r,
      style: i,
      transition: a,
      modifiers: o,
      wrapperElement: s = `div`,
      className: c,
      zIndex: l = 999
    } = e,
    {
      activatorEvent: u,
      active: f,
      activeNodeRect: p,
      containerNodeRect: m,
      draggableNodes: h,
      droppableContainers: g,
      dragOverlay: _,
      over: v,
      measuringConfiguration: y,
      scrollableAncestors: b,
      scrollableAncestorRects: x,
      windowRect: S
    } = qE(),
    C = (0, React.useContext)(BE),
    w = sD(f?.id),
    T = LE(o, {
      activatorEvent: u,
      active: f,
      activeNodeRect: p,
      containerNodeRect: m,
      draggingNodeRect: _.rect,
      over: v,
      overlayNodeRect: _.rect,
      scrollableAncestors: b,
      scrollableAncestorRects: x,
      transform: C,
      windowRect: S
    }),
    E = cE(p),
    D = iD({
      config: r,
      draggableNodes: h,
      droppableContainers: g,
      measuringConfiguration: y
    }),
    O = E ? _.setRef : void 0;
  return React.createElement($E, null, React.createElement(ZE, {
    animation: D
  }, f && w ? React.createElement(nD, {
    key: w,
    id: f.id,
    ref: O,
    as: s,
    activatorEvent: u,
    adjustScale: t,
    className: c,
    transition: a,
    rect: E,
    style: {
      zIndex: l,
      ...i
    },
    transform: T
  }, n) : null));
});
function lD(e, t, n) {
  let r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function uD(e, t) {
  return e.reduce((e, n, r) => {
    let i = t.get(n);
    return i && (e[r] = i), e;
  }, Array(e.length));
}
function dD(e) {
  return e !== null && e >= 0;
}
function fD(e, t) {
  if (e === t) return !0;
  if (e.length !== t.length) return !1;
  for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
  return !0;
}
function pD(e) {
  return typeof e == `boolean` ? {
    draggable: e,
    droppable: e
  } : e;
}
var mD = e => {
    let {
        rects: t,
        activeIndex: n,
        overIndex: r,
        index: i
      } = e,
      a = lD(t, r, n),
      o = t[i],
      s = a[i];
    return !s || !o ? null : {
      x: s.left - o.left,
      y: s.top - o.top,
      scaleX: s.width / o.width,
      scaleY: s.height / o.height
    };
  },
  hD = {
    scaleX: 1,
    scaleY: 1
  },
  gD = e => {
    let {
        activeIndex: t,
        activeNodeRect: n,
        index: r,
        rects: i,
        overIndex: a
      } = e,
      o = i[t] ?? n;
    if (!o) return null;
    if (r === t) {
      let e = i[a];
      return e ? {
        x: 0,
        y: t < a ? e.top + e.height - (o.top + o.height) : e.top - o.top,
        ...hD
      } : null;
    }
    let s = _D(i, r, t);
    return r > t && r <= a ? {
      x: 0,
      y: -o.height - s,
      ...hD
    } : r < t && r >= a ? {
      x: 0,
      y: o.height + s,
      ...hD
    } : {
      x: 0,
      y: 0,
      ...hD
    };
  };
function _D(e, t, n) {
  let r = e[t],
    i = e[t - 1],
    a = e[t + 1];
  return r ? n < t ? i ? r.top - (i.top + i.height) : a ? a.top - (r.top + r.height) : 0 : a ? a.top - (r.top + r.height) : i ? r.top - (i.top + i.height) : 0 : 0;
}
var vD = `Sortable`,
  yD = React.createContext({
    activeIndex: -1,
    containerId: vD,
    disableTransforms: !1,
    items: [],
    overIndex: -1,
    useDragOverlay: !1,
    sortedRects: [],
    strategy: mD,
    disabled: {
      draggable: !1,
      droppable: !1
    }
  });
function bD(e) {
  let {
      children: t,
      id: n,
      items: r,
      strategy: i = mD,
      disabled: a = !1
    } = e,
    {
      active: o,
      dragOverlay: s,
      droppableRects: c,
      over: l,
      measureDroppableContainers: u
    } = qE(),
    f = bw(vD, n),
    p = s.rect !== null,
    m = (0, React.useMemo)(() => r.map(e => typeof e == `object` && `id` in e ? e.id : e), [r]),
    h = o != null,
    g = o ? m.indexOf(o.id) : -1,
    _ = l ? m.indexOf(l.id) : -1,
    v = (0, React.useRef)(m),
    y = !fD(m, v.current),
    b = _ !== -1 && g === -1 || y,
    x = pD(a);
  fw(() => {
    y && h && u(m);
  }, [y, m, h, u]), (0, React.useEffect)(() => {
    v.current = m;
  }, [m]);
  let S = (0, React.useMemo)(() => ({
    activeIndex: g,
    containerId: f,
    disabled: x,
    disableTransforms: b,
    items: m,
    overIndex: _,
    useDragOverlay: p,
    sortedRects: uD(m, c),
    strategy: i
  }), [g, f, x.draggable, x.droppable, b, m, _, c, p, i]);
  return React.createElement(yD.Provider, {
    value: S
  }, t);
}
var xD = e => {
    let {
      id: t,
      items: n,
      activeIndex: r,
      overIndex: i
    } = e;
    return lD(n, r, i).indexOf(t);
  },
  SD = e => {
    let {
      containerId: t,
      isSorting: n,
      wasDragging: r,
      index: i,
      items: a,
      newIndex: o,
      previousItems: s,
      previousContainerId: c,
      transition: l
    } = e;
    return !l || !r || s !== a && i === o ? !1 : n ? !0 : o !== i && t === c;
  },
  CD = {
    duration: 200,
    easing: `ease`
  },
  wD = `transform`,
  TD = Ow.Transition.toString({
    property: wD,
    duration: 0,
    easing: `linear`
  }),
  ED = {
    roleDescription: `sortable`
  };
function DD(e) {
  let {
      disabled: t,
      index: n,
      node: r,
      rect: i
    } = e,
    [a, o] = (0, React.useState)(null),
    s = (0, React.useRef)(n);
  return fw(() => {
    if (!t && n !== s.current && r.current) {
      let e = i.current;
      if (e) {
        let t = cT(r.current, {
            ignoreTransform: !0
          }),
          n = {
            x: e.left - t.left,
            y: e.top - t.top,
            scaleX: e.width / t.width,
            scaleY: e.height / t.height
          };
        (n.x || n.y) && o(n);
      }
    }
    n !== s.current && (s.current = n);
  }, [t, n, r, i]), (0, React.useEffect)(() => {
    a && o(null);
  }, [a]), a;
}
function OD(e) {
  let {
      animateLayoutChanges: t = SD,
      attributes: n,
      disabled: r,
      data: i,
      getNewIndex: a = xD,
      id: o,
      strategy: s,
      resizeObserverConfig: c,
      transition: l = CD
    } = e,
    {
      items: u,
      containerId: f,
      activeIndex: p,
      disabled: m,
      disableTransforms: h,
      sortedRects: g,
      overIndex: _,
      useDragOverlay: v,
      strategy: y
    } = (0, React.useContext)(yD),
    b = kD(r, m),
    x = u.indexOf(o),
    S = (0, React.useMemo)(() => ({
      sortable: {
        containerId: f,
        index: x,
        items: u
      },
      ...i
    }), [f, i, x, u]),
    C = (0, React.useMemo)(() => u.slice(u.indexOf(o)), [u, o]),
    {
      rect: w,
      node: T,
      isOver: E,
      setNodeRef: D
    } = XE({
      id: o,
      data: S,
      disabled: b.droppable,
      resizeObserverConfig: {
        updateMeasurementsFor: C,
        ...c
      }
    }),
    {
      active: O,
      activatorEvent: k,
      activeNodeRect: A,
      attributes: j,
      setNodeRef: M,
      listeners: N,
      isDragging: P,
      over: F,
      setActivatorNodeRef: I,
      transform: L
    } = KE({
      id: o,
      data: S,
      attributes: {
        ...ED,
        ...n
      },
      disabled: b.draggable
    }),
    R = rw(D, M),
    z = !!O,
    ee = z && !h && dD(p) && dD(_),
    te = !v && P,
    B = ee ? (te && ee ? L : null) ?? (s ?? y)({
      rects: g,
      activeNodeRect: A,
      activeIndex: p,
      overIndex: _,
      index: x
    }) : null,
    V = dD(p) && dD(_) ? a({
      id: o,
      items: u,
      activeIndex: p,
      overIndex: _
    }) : x,
    H = O?.id,
    ne = (0, React.useRef)({
      activeId: H,
      items: u,
      newIndex: V,
      containerId: f
    }),
    re = u !== ne.current.items,
    ie = t({
      active: O,
      containerId: f,
      isDragging: P,
      isSorting: z,
      id: o,
      index: x,
      items: u,
      newIndex: ne.current.newIndex,
      previousItems: ne.current.items,
      previousContainerId: ne.current.containerId,
      transition: l,
      wasDragging: ne.current.activeId != null
    }),
    U = DD({
      disabled: !ie,
      index: x,
      node: T,
      rect: w
    });
  return (0, React.useEffect)(() => {
    z && ne.current.newIndex !== V && (ne.current.newIndex = V), f !== ne.current.containerId && (ne.current.containerId = f), u !== ne.current.items && (ne.current.items = u);
  }, [z, V, f, u]), (0, React.useEffect)(() => {
    if (H === ne.current.activeId) return;
    if (H != null && ne.current.activeId == null) {
      ne.current.activeId = H;
      return;
    }
    let e = setTimeout(() => {
      ne.current.activeId = H;
    }, 50);
    return () => clearTimeout(e);
  }, [H]), {
    active: O,
    activeIndex: p,
    attributes: j,
    data: S,
    rect: w,
    index: x,
    newIndex: V,
    items: u,
    isOver: E,
    isSorting: z,
    isDragging: P,
    listeners: N,
    node: T,
    overIndex: _,
    over: F,
    setNodeRef: R,
    setActivatorNodeRef: I,
    setDroppableNodeRef: D,
    setDraggableNodeRef: M,
    transform: U ?? B,
    transition: ae()
  };
  function ae() {
    if (U || re && ne.current.newIndex === x) return TD;
    if (!(te && !Tw(k) || !l) && (z || ie)) return Ow.Transition.toString({
      ...l,
      property: wD
    });
  }
}
function kD(e, t) {
  return typeof e == `boolean` ? {
    draggable: e,
    droppable: !1
  } : {
    draggable: e?.draggable ?? t.draggable,
    droppable: e?.droppable ?? t.droppable
  };
}
LT.Down, LT.Right, LT.Up, LT.Left;
var AD = `__sin__`;
function ND(e) {
  return e.id;
}
function RD(e) {
  let [, t] = e;
  return t.length > 0;
}
var VD = `09:00`,
  HD = 5;
function UD(e) {
  let [t = ``, n = ``] = (e || ``).split(`T`),
    [r = ``, i = ``] = n.split(`:`);
  return {
    fecha: t,
    hora: r,
    minuto: i
  };
}
var WD = e => String(e).padStart(2, `0`);
var JD = 10;
var tO = e => (e.usuarioNombre || `Esa persona`).split(` `)[0];
function cO() {
  return $x()[0].fondo;
}
var uO = (0, React.lazy)(() => b(() => import(`./Gantt-C36TTBkL.js`), __vite__mapDeps([0, 1, 2]))),
  dO = (0, React.lazy)(() => b(() => import(`./Reportes-QfIcfC7m.js`), __vite__mapDeps([3, 1]))),
  fO = [{
    id: `tablero`,
    label: `Tablero`,
    C: TableroTareas
  }, {
    id: `metas`,
    label: `Metas`,
    C: MetasProyecto
  }, {
    id: `gantt`,
    label: `Gantt`,
    C: uO
  }, {
    id: `reuniones`,
    label: `Reuniones`,
    C: ReunionesProyecto
  }, {
    id: `discusiones`,
    label: `Discusiones`,
    C: DiscusionesProyecto
  }, {
    id: `reportes`,
    label: `Reportes`,
    C: dO
  }, {
    id: `actividad`,
    label: `Actividad`,
    C: ActividadProyecto,
    gestion: !0
  }, {
    id: `auditoria`,
    label: `Auditoría`,
    C: AuditoriaProyecto,
    gestion: !0
  }, {
    id: `miembros`,
    label: `Miembros`,
    C: EquipoProyecto,
    gestion: !0
  }, {
    id: `organizar`,
    label: `Etiquetas y listas`,
    C: ConfiguracionProyecto,
    gestion: !0
  }];
var hO = dS,
  gO = [`Lun`, `Mar`, `Mié`, `Jue`, `Vie`, `Sáb`, `Dom`],
  _O = 3,
  vO = `grid-cols-[2.25rem_repeat(7,1fr)]`,
  yO = [{
    value: `calendario`,
    label: `Calendario`
  }, {
    value: `agenda`,
    label: `Por fechas`
  }, {
    value: `semanas`,
    label: `Por semanas`
  }],
  bO = [{
    value: `pendientes`,
    label: `Lo que falta`,
    estados: [`POR_HACER`, `EN_PROGRESO`, `EN_REVISION`]
  }, {
    value: `todas`,
    label: `Todo`,
    estados: null
  }, {
    value: `POR_HACER`,
    label: `Por hacer`,
    estados: [`POR_HACER`]
  }, {
    value: `EN_PROGRESO`,
    label: `En progreso`,
    estados: [`EN_PROGRESO`]
  }, {
    value: `EN_REVISION`,
    label: `En revisión`,
    estados: [`EN_REVISION`]
  }, {
    value: `COMPLETADA`,
    label: `Completadas`,
    estados: [`COMPLETADA`]
  }],
  xO = {
    POR_HACER: `var(--text)`,
    EN_PROGRESO: `var(--accent)`,
    EN_REVISION: `var(--warning)`,
    COMPLETADA: `var(--success)`,
    CANCELADA: `var(--error)`
  };
function SO(e) {
  return e.tipo === `TAREA` && e.estado ? xO[e.estado] ?? `var(--accent)` : e.color || `var(--accent)`;
}
function EO(e) {
  return {
    value: String(e.id),
    label: ZC(e.nombre, e)
  };
}
function OO(e) {
  return e.titulo;
}
function kO(e) {
  return e.eventos.length > 0;
}
var MO = null;
function NO() {
  return MO ||= api(`/niveles`).then(e => (Wx(e), e)).catch(() => (MO = null, null)), MO;
}
var PO = [{
    value: `EN_CURSO`,
    label: `En curso`,
    clase: `bg-(--accent-bg) text-(--accent-texto)`
  }, {
    value: `PAUSADA`,
    label: `Pausada`,
    clase: `bg-(--warning-bg) text-(--warning-texto)`
  }, {
    value: `CUMPLIDA`,
    label: `Cumplida`,
    clase: `bg-(--success-bg) text-(--success-texto)`
  }, {
    value: `CANCELADA`,
    label: `Cancelada`,
    clase: `bg-(--panel) text-(--text)`
  }],
  FO = e => PO.find(t => t.value === e) ?? PO[0],
  IO = (e, t, n) => e === 1 ? `1 ${t}` : `${e} ${n}`;
var VO = `__sin__`,
  HO = `rounded-full border border-(--border) px-3 py-1.5 text-xs text-(--text-h) transition hover:bg-(--accent-bg)`,
  UO = [{
    value: `ABIERTAS`,
    label: `Sin terminar`,
    estados: [`POR_HACER`, `EN_PROGRESO`, `EN_REVISION`]
  }, {
    value: `TODAS`,
    label: `Todas`,
    estados: null
  }, {
    value: `COMPLETADAS`,
    label: `Terminadas`,
    estados: [`COMPLETADA`]
  }, {
    value: `CANCELADAS`,
    label: `Canceladas`,
    estados: [`CANCELADA`]
  }];
function KO(e, t, n) {
  let r = 0,
    i = (n.get(e.id) ?? []).length;
  for (let a of t.get(e.id) ?? []) {
    let e = KO(a, t, n);
    r += 1 + e.unidades, i += e.proyectos;
  }
  return {
    unidades: r,
    proyectos: i
  };
}
function qO(e) {
  let t = e?.unidades ?? [],
    n = e?.proyectos ?? [],
    r = new Set(t.map(e => e.id)),
    i = new Map(),
    a = [];
  for (let e of t) e.padreId && r.has(e.padreId) ? (i.has(e.padreId) || i.set(e.padreId, []), i.get(e.padreId).push(e)) : a.push(e);
  let o = new Map();
  for (let e of n) {
    let t = e.unidadId ?? VO;
    o.has(t) || o.set(t, []), o.get(t).push(e);
  }
  return {
    raices: a,
    hijosDe: i,
    proyectosDe: o
  };
}
function tk(e) {
  return [String(e.id), e];
}
function sk(e) {
  let t = [],
    n = e.totalProyectos;
  return n > 0 && t.push(n === 1 ? `1 proyecto` : `${n} proyectos`), t.push(e.totalTareas === 0 ? `sin tareas todavía` : `${e.completadas} de ${e.totalTareas} tareas terminadas`), t.join(` · `);
}
function fk(e) {
  return [{
    value: `RESPONSABLE`,
    label: Kx(e)
  }, {
    value: `SUPERVISOR`,
    label: `Supervisor`
  }, {
    value: `AUXILIAR`,
    label: `Auxiliar`
  }];
}
function pk(e) {
  let t = (e.responsables ?? []).filter(e => (e.posicion || `RESPONSABLE`) === `RESPONSABLE`);
  if (t.length === 0) return `Sin responsable`;
  let n = t.map(e => e.nombre).filter(Boolean).join(`, `);
  return `${Kx(e.tipo, t.length > 1)}: ${n}`;
}
function hk(e) {
  return e.id;
}
function gk(e) {
  return {
    value: e.codigo,
    label: e.nombre
  };
}
function _k(e) {
  return {
    usuarioId: e.id,
    nombre: e.nombre,
    correo: e.correo,
    posicion: e.posicion || `AUXILIAR`
  };
}
function vk() {}
function yk(e) {
  return {
    sedeId: e.sedeId,
    nombre: e.nombre
  };
}
function bk(e) {
  return {
    id: e.usuarioId,
    nombre: e.nombre,
    correo: e.correo,
    posicion: e.posicion || `RESPONSABLE`
  };
}
var xk = {
  NAVEGACION: `Navegación`,
  ABRIR_GANTT: `Abrir Gantt`,
  CREAR_TAREA: `Crear tarea`,
  USAR_FILTRO: `Usar filtros`,
  EXPORTAR: `Exportaciones`,
  INICIO: `Inicio`,
  PROYECTOS: `Proyectos`,
  PROYECTO: `Proyecto`,
  CALENDARIO: `Calendario`,
  ORGANIZACION: `Organización`,
  OBJETIVOS: `Objetivos`,
  NOTIFICACIONES: `Notificaciones`,
  ADMIN: `Administración`,
  GANTT: `Gantt`,
  TABLERO: `Tablero`,
  REPORTES: `Reportes`
};
function Ck(e) {
  return `Usuario ${e}`;
}
function wk(e) {
  return xk[e] || e;
}
function Tk(e) {
  return xk[e] || e;
}
function Ek(e) {
  return {
    value: String(e.id),
    label: ZC(e.nombre, e)
  };
}
function Dk() {
  return dS(new Date());
}
function Ok() {
  let e = new Date();
  return e.setDate(e.getDate() - 29), dS(e);
}
var Ak = `rounded-2xl border border-(--border) bg-(--bg) p-4`;
function Nk(e) {
  let t = [];
  return e?.traidos && t.push(`${e.traidos} ${e.traidos === 1 ? `traído` : `traídos`}`), e?.enviados && t.push(`${e.enviados} ${e.enviados === 1 ? `enviado` : `enviados`} a Transporte`), e?.desactivados && t.push(`${e.desactivados} ${e.desactivados === 1 ? `desactivado` : `desactivados`} allá`), t.length === 0 ? `Ya estaban iguales` : t.join(` · `);
}
var Pk = [{
    id: `usuarios`,
    label: `Usuarios`
  }, {
    id: `roles`,
    label: `Roles`
  }, {
    id: `sedes`,
    label: `Sedes`
  }, {
    id: `fundos`,
    label: `Fundos`
  }, {
    id: `concesionarias`,
    label: `Concesionarias`
  }],
  Fk = [{
    value: `LECTURA`,
    label: `Solo lectura`
  }, {
    value: `ESCRITURA`,
    label: `Escritura`
  }];
var Lk = {
    roles: `rol`,
    sedes: `sede`
  },
  Rk = {
    roles: `Nuevo rol`,
    sedes: `Nueva sede`
  };
var Kk = {
  RESPONSABLE: `a cargo`,
  SUPERVISOR: `supervisor`,
  AUXILIAR: `auxiliar`
};
function qk(e) {
  return e ? [e.esPlanner && `el planner`, e.esInspecciones && `Inspecciones`, e.esIncidencias && `Incidencias`, e.esTransporte && `Movilidad`, e.esOrganigrama && `el Organigrama`].filter(Boolean) : [];
}
var Yk = e => e.sedeNombre ? `${e.nombre} · ${e.sedeNombre}` : e.nombre;
var $k = [{
  id: `PRINCIPAL`,
  label: `Logo del inicio de sesión`,
  ayuda: `SVG o PNG. Se muestra en blanco sobre la foto.`
}, {
  id: `SIDEBAR`,
  label: `Logo del menú`,
  ayuda: `Si no lo cargás, se usa el del inicio de sesión.`
}, {
  id: `BANNER`,
  label: `Foto del inicio de sesión`,
  ayuda: `JPG o WebP, apaisada.`
}, {
  id: `ICONO_192`,
  label: `Icono de la aplicación`,
  ayuda: `PNG de 192×192. Es el que se ve en el teléfono y en los correos.`
}, {
  id: `ICONO_512`,
  label: `Icono grande`,
  ayuda: `PNG de 512×512.`
}, {
  id: `ICONO_APPLE`,
  label: `Icono de iPhone`,
  ayuda: `PNG de 180×180.`
}, {
  id: `TRANSICION`,
  label: `Logo de la animación`,
  ayuda: `El que aparece al entrar y salir.`
}];
function tA(e) {
  return {
    nombreApp: e.nombreApp ?? ``,
    nombreEmpresa: e.nombreEmpresa ?? ``,
    colorAcento: e.colorAcento,
    colorTitulo: e.colorTitulo,
    colorSidebar: e.colorSidebar,
    fuenteCuerpo: e.fuentes?.cuerpo ?? `POPPINS`,
    fuenteTitulos: e.fuentes?.titulos ?? `NINGUNA`
  };
}
var iA = [{
  campo: `colorAcento`,
  label: `Color principal`,
  ayuda: `Botones, enlaces y lo que hay que mirar.`
}, {
  campo: `colorTitulo`,
  label: `Color de los títulos`,
  ayuda: `También la barra del sistema en el teléfono.`
}, {
  campo: `colorSidebar`,
  label: `Color del menú`,
  ayuda: `El fondo de la barra lateral.`
}];
function cA(e) {
  return {
    value: e.codigo,
    label: e.etiqueta
  };
}
function lA(e) {
  return {
    value: e.codigo,
    label: e.etiqueta
  };
}
function uA(e, t) {
  return e?.find(e => e.codigo === t)?.nota;
}
function pA(e) {
  let t = new Date(e.getFullYear(), e.getMonth(), 1),
    n = new Date(e.getFullYear(), e.getMonth() + 1, 0);
  return {
    desde: dS(t),
    hasta: dS(n)
  };
}
var yA = (e, t, n) => `${e} ${e === 1 ? t : n}`;
function bA(e) {
  return [...(e?.cargos ?? []).map(e => `${e.cargo} en ${e.unidad.split(` > `).at(-1)}`), e?.abiertas > 0 && yA(e.abiertas, `tarea`, `tareas`), e?.encargos > 0 && yA(e.encargos, `encargo`, `encargos`), e?.proyectos > 0 && yA(e.proyectos, `proyecto`, `proyectos`)].filter(Boolean).join(` · `);
}
var SA = [{
    value: `pendientes`,
    label: `Sin resolver`
  }, {
    value: `resueltos`,
    label: `Resueltos`
  }, {
    value: `todos`,
    label: `Todos`
  }],
  CA = {
    API: `Servidor`,
    WEB: `Navegador`,
    TAREA_FONDO: `Proceso automático`
  };
var EA = t({
    CFB: () => SM,
    SSF: () => gM,
    parse_xlscfb: () => wJ,
    parse_zip: () => tX,
    read: () => mX,
    readFile: () => hX,
    readFileSync: () => hX,
    set_cptable: () => UA,
    set_fs: () => wM,
    stream: () => tZ,
    utils: () => YX,
    version: () => nZ,
    write: () => TX,
    writeFile: () => DX,
    writeFileAsync: () => kX,
    writeFileSync: () => DX,
    writeFileXLSX: () => OX,
    writeXLSX: () => wX
  }),
  DA = {};
DA.version = `0.18.5`;
var OA = 1200,
  kA = 1252,
  AA = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4],
  jA = {
    0: 1252,
    1: 65001,
    2: 65001,
    77: 1e4,
    128: 932,
    129: 949,
    130: 1361,
    134: 936,
    136: 950,
    161: 1253,
    162: 1254,
    163: 1258,
    177: 1255,
    178: 1256,
    186: 1257,
    204: 1251,
    222: 874,
    238: 1250,
    255: 1252,
    69: 6969
  },
  MA = function (e) {
    AA.indexOf(e) != -1 && (kA = jA[0] = e);
  };
function NA() {
  MA(1252);
}
var PA = function (e) {
  OA = e, MA(e);
};
function FA() {
  PA(1200), NA();
}
function IA(e) {
  for (var t = [], n = 0, r = e.length; n < r; ++n) t[n] = e.charCodeAt(n);
  return t;
}
function LA(e) {
  for (var t = [], n = 0; n < e.length >> 1; ++n) t[n] = String.fromCharCode(e.charCodeAt(2 * n) + (e.charCodeAt(2 * n + 1) << 8));
  return t.join(``);
}
function RA(e) {
  for (var t = [], n = 0; n < e.length >> 1; ++n) t[n] = String.fromCharCode(e.charCodeAt(2 * n + 1) + (e.charCodeAt(2 * n) << 8));
  return t.join(``);
}
var zA = function (e) {
    var t = e.charCodeAt(0),
      n = e.charCodeAt(1);
    return t == 255 && n == 254 ? LA(e.slice(2)) : t == 254 && n == 255 ? RA(e.slice(2)) : t == 65279 ? e.slice(1) : e;
  },
  BA = function (e) {
    return String.fromCharCode(e);
  },
  VA = function (e) {
    return String.fromCharCode(e);
  },
  HA;
function UA(e) {
  HA = e, PA = function (e) {
    OA = e, MA(e);
  }, zA = function (e) {
    return e.charCodeAt(0) === 255 && e.charCodeAt(1) === 254 ? HA.utils.decode(1200, IA(e.slice(2))) : e;
  }, BA = function (e) {
    return OA === 1200 ? String.fromCharCode(e) : HA.utils.decode(OA, [e & 255, e >> 8])[0];
  }, VA = function (e) {
    return HA.utils.decode(kA, [e])[0];
  }, SP();
}
var WA = null,
  GA = !0,
  KA = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=`;
function qA(e) {
  for (var t = ``, n = 0, r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = 0; l < e.length;) n = e.charCodeAt(l++), a = n >> 2, r = e.charCodeAt(l++), o = (n & 3) << 4 | r >> 4, i = e.charCodeAt(l++), s = (r & 15) << 2 | i >> 6, c = i & 63, isNaN(r) ? s = c = 64 : isNaN(i) && (c = 64), t += KA.charAt(a) + KA.charAt(o) + KA.charAt(s) + KA.charAt(c);
  return t;
}
function JA(e) {
  var t = ``,
    n = 0,
    r = 0,
    i = 0,
    a = 0,
    o = 0,
    s = 0,
    c = 0;
  e = e.replace(/[^\w\+\/\=]/g, ``);
  for (var l = 0; l < e.length;) a = KA.indexOf(e.charAt(l++)), o = KA.indexOf(e.charAt(l++)), n = a << 2 | o >> 4, t += String.fromCharCode(n), s = KA.indexOf(e.charAt(l++)), r = (o & 15) << 4 | s >> 2, s !== 64 && (t += String.fromCharCode(r)), c = KA.indexOf(e.charAt(l++)), i = (s & 3) << 6 | c, c !== 64 && (t += String.fromCharCode(i));
  return t;
}
var YA = function () {
    return typeof Buffer < `u` && typeof process < `u` && process.versions !== void 0 && !!process.versions.node;
  }(),
  XA = function () {
    if (typeof Buffer < `u`) {
      var e = !Buffer.from;
      if (!e) try {
        Buffer.from(`foo`, `utf8`);
      } catch {
        e = !0;
      }
      return e ? function (e, t) {
        return t ? new Buffer(e, t) : new Buffer(e);
      } : Buffer.from.bind(Buffer);
    }
    return function () {};
  }();
function ZA(e) {
  return YA ? Buffer.alloc ? Buffer.alloc(e) : new Buffer(e) : typeof Uint8Array < `u` ? new Uint8Array(e) : Array(e);
}
function QA(e) {
  return YA ? Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : new Buffer(e) : typeof Uint8Array < `u` ? new Uint8Array(e) : Array(e);
}
var $A = function (e) {
  return YA ? XA(e, `binary`) : e.split(``).map(function (e) {
    return e.charCodeAt(0) & 255;
  });
};
function ej(e) {
  if (typeof ArrayBuffer > `u`) return $A(e);
  for (var t = new ArrayBuffer(e.length), n = new Uint8Array(t), r = 0; r != e.length; ++r) n[r] = e.charCodeAt(r) & 255;
  return t;
}
function tj(e) {
  if (Array.isArray(e)) return e.map(function (e) {
    return String.fromCharCode(e);
  }).join(``);
  for (var t = [], n = 0; n < e.length; ++n) t[n] = String.fromCharCode(e[n]);
  return t.join(``);
}
function nj(e) {
  if (typeof Uint8Array > `u`) throw Error(`Unsupported`);
  return new Uint8Array(e);
}
function rj(e) {
  if (typeof ArrayBuffer > `u`) throw Error(`Unsupported`);
  if (e instanceof ArrayBuffer) return rj(new Uint8Array(e));
  for (var t = Array(e.length), n = 0; n < e.length; ++n) t[n] = e[n];
  return t;
}
var ij = YA ? function (e) {
  return Buffer.concat(e.map(function (e) {
    return Buffer.isBuffer(e) ? e : XA(e);
  }));
} : function (e) {
  if (typeof Uint8Array < `u`) {
    var t = 0,
      n = 0;
    for (t = 0; t < e.length; ++t) n += e[t].length;
    var r = new Uint8Array(n),
      i = 0;
    for (t = 0, n = 0; t < e.length; n += i, ++t) if (i = e[t].length, e[t] instanceof Uint8Array) r.set(e[t], n);else if (typeof e[t] == `string`) throw `wtf`;else r.set(new Uint8Array(e[t]), n);
    return r;
  }
  return [].concat.apply([], e.map(function (e) {
    return Array.isArray(e) ? e : [].slice.call(e);
  }));
};
function aj(e) {
  for (var t = [], n = 0, r = e.length + 250, i = ZA(e.length + 255), a = 0; a < e.length; ++a) {
    var o = e.charCodeAt(a);
    if (o < 128) i[n++] = o;else if (o < 2048) i[n++] = 192 | o >> 6 & 31, i[n++] = 128 | o & 63;else if (o >= 55296 && o < 57344) {
      o = (o & 1023) + 64;
      var s = e.charCodeAt(++a) & 1023;
      i[n++] = 240 | o >> 8 & 7, i[n++] = 128 | o >> 2 & 63, i[n++] = 128 | s >> 6 & 15 | (o & 3) << 4, i[n++] = 128 | s & 63;
    } else i[n++] = 224 | o >> 12 & 15, i[n++] = 128 | o >> 6 & 63, i[n++] = 128 | o & 63;
    n > r && (t.push(i.slice(0, n)), n = 0, i = ZA(65535), r = 65530);
  }
  return t.push(i.slice(0, n)), ij(t);
}
var oj = /\u0000/g,
  sj = /[\u0001-\u0006]/g;
function cj(e) {
  for (var t = ``, n = e.length - 1; n >= 0;) t += e.charAt(n--);
  return t;
}
function lj(e, t) {
  var n = `` + e;
  return n.length >= t ? n : KM(`0`, t - n.length) + n;
}
function uj(e, t) {
  var n = `` + e;
  return n.length >= t ? n : KM(` `, t - n.length) + n;
}
function dj(e, t) {
  var n = `` + e;
  return n.length >= t ? n : n + KM(` `, t - n.length);
}
function fj(e, t) {
  var n = `` + Math.round(e);
  return n.length >= t ? n : KM(`0`, t - n.length) + n;
}
function pj(e, t) {
  var n = `` + e;
  return n.length >= t ? n : KM(`0`, t - n.length) + n;
}
var mj = 2 ** 32;
function hj(e, t) {
  return e > mj || e < -mj ? fj(e, t) : pj(Math.round(e), t);
}
function gj(e, t) {
  return t ||= 0, e.length >= 7 + t && (e.charCodeAt(t) | 32) == 103 && (e.charCodeAt(t + 1) | 32) == 101 && (e.charCodeAt(t + 2) | 32) == 110 && (e.charCodeAt(t + 3) | 32) == 101 && (e.charCodeAt(t + 4) | 32) == 114 && (e.charCodeAt(t + 5) | 32) == 97 && (e.charCodeAt(t + 6) | 32) == 108;
}
var _j = [[`Sun`, `Sunday`], [`Mon`, `Monday`], [`Tue`, `Tuesday`], [`Wed`, `Wednesday`], [`Thu`, `Thursday`], [`Fri`, `Friday`], [`Sat`, `Saturday`]],
  vj = [[`J`, `Jan`, `January`], [`F`, `Feb`, `February`], [`M`, `Mar`, `March`], [`A`, `Apr`, `April`], [`M`, `May`, `May`], [`J`, `Jun`, `June`], [`J`, `Jul`, `July`], [`A`, `Aug`, `August`], [`S`, `Sep`, `September`], [`O`, `Oct`, `October`], [`N`, `Nov`, `November`], [`D`, `Dec`, `December`]];
function yj(e) {
  return e ||= {}, e[0] = `General`, e[1] = `0`, e[2] = `0.00`, e[3] = `#,##0`, e[4] = `#,##0.00`, e[9] = `0%`, e[10] = `0.00%`, e[11] = `0.00E+00`, e[12] = `# ?/?`, e[13] = `# ??/??`, e[14] = `m/d/yy`, e[15] = `d-mmm-yy`, e[16] = `d-mmm`, e[17] = `mmm-yy`, e[18] = `h:mm AM/PM`, e[19] = `h:mm:ss AM/PM`, e[20] = `h:mm`, e[21] = `h:mm:ss`, e[22] = `m/d/yy h:mm`, e[37] = `#,##0 ;(#,##0)`, e[38] = `#,##0 ;[Red](#,##0)`, e[39] = `#,##0.00;(#,##0.00)`, e[40] = `#,##0.00;[Red](#,##0.00)`, e[45] = `mm:ss`, e[46] = `[h]:mm:ss`, e[47] = `mmss.0`, e[48] = `##0.0E+0`, e[49] = `@`, e[56] = `"上午/下午 "hh"時"mm"分"ss"秒 "`, e;
}
var bj = {
    0: `General`,
    1: `0`,
    2: `0.00`,
    3: `#,##0`,
    4: `#,##0.00`,
    9: `0%`,
    10: `0.00%`,
    11: `0.00E+00`,
    12: `# ?/?`,
    13: `# ??/??`,
    14: `m/d/yy`,
    15: `d-mmm-yy`,
    16: `d-mmm`,
    17: `mmm-yy`,
    18: `h:mm AM/PM`,
    19: `h:mm:ss AM/PM`,
    20: `h:mm`,
    21: `h:mm:ss`,
    22: `m/d/yy h:mm`,
    37: `#,##0 ;(#,##0)`,
    38: `#,##0 ;[Red](#,##0)`,
    39: `#,##0.00;(#,##0.00)`,
    40: `#,##0.00;[Red](#,##0.00)`,
    45: `mm:ss`,
    46: `[h]:mm:ss`,
    47: `mmss.0`,
    48: `##0.0E+0`,
    49: `@`,
    56: `"上午/下午 "hh"時"mm"分"ss"秒 "`
  },
  xj = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0
  },
  Sj = {
    5: `"$"#,##0_);\\("$"#,##0\\)`,
    63: `"$"#,##0_);\\("$"#,##0\\)`,
    6: `"$"#,##0_);[Red]\\("$"#,##0\\)`,
    64: `"$"#,##0_);[Red]\\("$"#,##0\\)`,
    7: `"$"#,##0.00_);\\("$"#,##0.00\\)`,
    65: `"$"#,##0.00_);\\("$"#,##0.00\\)`,
    8: `"$"#,##0.00_);[Red]\\("$"#,##0.00\\)`,
    66: `"$"#,##0.00_);[Red]\\("$"#,##0.00\\)`,
    41: `_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)`,
    42: `_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)`,
    43: `_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)`,
    44: `_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)`
  };
function Cj(e, t, n) {
  for (var r = e < 0 ? -1 : 1, i = e * r, a = 0, o = 1, s = 0, c = 1, l = 0, u = 0, d = Math.floor(i); l < t && (d = Math.floor(i), s = d * o + a, u = d * l + c, !(i - d < 5e-8));) i = 1 / (i - d), a = o, o = s, c = l, l = u;
  if (u > t && (l > t ? (u = c, s = a) : (u = l, s = o)), !n) return [0, r * s, u];
  var f = Math.floor(r * s / u);
  return [f, r * s - f * u, u];
}
function wj(e, t, n) {
  if (e > 2958465 || e < 0) return null;
  var r = e | 0,
    i = Math.floor(86400 * (e - r)),
    a = 0,
    o = [],
    s = {
      D: r,
      T: i,
      u: 86400 * (e - r) - i,
      y: 0,
      m: 0,
      d: 0,
      H: 0,
      M: 0,
      S: 0,
      q: 0
    };
  if (Math.abs(s.u) < 1e-6 && (s.u = 0), t && t.date1904 && (r += 1462), s.u > .9999 && (s.u = 0, ++i == 86400 && (s.T = i = 0, ++r, ++s.D)), r === 60) o = n ? [1317, 10, 29] : [1900, 2, 29], a = 3;else if (r === 0) o = n ? [1317, 8, 29] : [1900, 1, 0], a = 6;else {
    r > 60 && --r;
    var c = new Date(1900, 0, 1);
    c.setDate(c.getDate() + r - 1), o = [c.getFullYear(), c.getMonth() + 1, c.getDate()], a = c.getDay(), r < 60 && (a = (a + 6) % 7), n && (a = Fj(c, o));
  }
  return s.y = o[0], s.m = o[1], s.d = o[2], s.S = i % 60, i = Math.floor(i / 60), s.M = i % 60, i = Math.floor(i / 60), s.H = i, s.q = a, s;
}
var Tj = new Date(1899, 11, 31, 0, 0, 0),
  Ej = Tj.getTime(),
  Dj = new Date(1900, 2, 1, 0, 0, 0);
function Oj(e, t) {
  var n = e.getTime();
  return t ? n -= 1262304e5 : e >= Dj && (n += 864e5), (n - (Ej + (e.getTimezoneOffset() - Tj.getTimezoneOffset()) * 6e4)) / 864e5;
}
function kj(e) {
  return e.indexOf(`.`) == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, `$1`);
}
function Aj(e) {
  return e.indexOf(`E`) == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, `$1E`).replace(/(E[+-])(\d)$/, `$10$2`);
}
function jj(e) {
  var t = e < 0 ? 12 : 11,
    n = kj(e.toFixed(12));
  return n.length <= t || (n = e.toPrecision(10), n.length <= t) ? n : e.toExponential(5);
}
function Mj(e) {
  var t = kj(e.toFixed(11));
  return t.length > (e < 0 ? 12 : 11) || t === `0` || t === `-0` ? e.toPrecision(6) : t;
}
function Nj(e) {
  var t = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E);
  return kj(Aj((t >= -4 && t <= -1 ? e.toPrecision(10 + t) : Math.abs(t) <= 9 ? jj(e) : t === 10 ? e.toFixed(10).substr(0, 12) : Mj(e)).toUpperCase()));
}
function Pj(e, t) {
  switch (typeof e) {
    case `string`:
      return e;
    case `boolean`:
      return e ? `TRUE` : `FALSE`;
    case `number`:
      return (e | 0) === e ? e.toString(10) : Nj(e);
    case `undefined`:
      return ``;
    case `object`:
      if (e == null) return ``;
      if (e instanceof Date) return fM(14, Oj(e, t && t.date1904), t);
  }
  throw Error(`unsupported value in General format: ` + e);
}
function Fj(e, t) {
  t[0] -= 581;
  var n = e.getDay();
  return e < 60 && (n = (n + 6) % 7), n;
}
function Ij(e, t, n, r) {
  var i = ``,
    a = 0,
    o = 0,
    s = n.y,
    c,
    l = 0;
  switch (e) {
    case 98:
      s = n.y + 543;
    case 121:
      switch (t.length) {
        case 1:
        case 2:
          c = s % 100, l = 2;
          break;
        default:
          c = s % 1e4, l = 4;
      }
      break;
    case 109:
      switch (t.length) {
        case 1:
        case 2:
          c = n.m, l = t.length;
          break;
        case 3:
          return vj[n.m - 1][1];
        case 5:
          return vj[n.m - 1][0];
        default:
          return vj[n.m - 1][2];
      }
      break;
    case 100:
      switch (t.length) {
        case 1:
        case 2:
          c = n.d, l = t.length;
          break;
        case 3:
          return _j[n.q][0];
        default:
          return _j[n.q][1];
      }
      break;
    case 104:
      switch (t.length) {
        case 1:
        case 2:
          c = 1 + (n.H + 11) % 12, l = t.length;
          break;
        default:
          throw `bad hour format: ` + t;
      }
      break;
    case 72:
      switch (t.length) {
        case 1:
        case 2:
          c = n.H, l = t.length;
          break;
        default:
          throw `bad hour format: ` + t;
      }
      break;
    case 77:
      switch (t.length) {
        case 1:
        case 2:
          c = n.M, l = t.length;
          break;
        default:
          throw `bad minute format: ` + t;
      }
      break;
    case 115:
      if (t != `s` && t != `ss` && t != `.0` && t != `.00` && t != `.000`) throw `bad second format: ` + t;
      return n.u === 0 && (t == `s` || t == `ss`) ? lj(n.S, t.length) : (o = r >= 2 ? r === 3 ? 1e3 : 100 : r === 1 ? 10 : 1, a = Math.round(o * (n.S + n.u)), a >= 60 * o && (a = 0), t === `s` ? a === 0 ? `0` : `` + a / o : (i = lj(a, 2 + r), t === `ss` ? i.substr(0, 2) : `.` + i.substr(2, t.length - 1)));
    case 90:
      switch (t) {
        case `[h]`:
        case `[hh]`:
          c = n.D * 24 + n.H;
          break;
        case `[m]`:
        case `[mm]`:
          c = (n.D * 24 + n.H) * 60 + n.M;
          break;
        case `[s]`:
        case `[ss]`:
          c = ((n.D * 24 + n.H) * 60 + n.M) * 60 + Math.round(n.S + n.u);
          break;
        default:
          throw `bad abstime format: ` + t;
      }
      l = t.length === 3 ? 1 : 2;
      break;
    case 101:
      c = s, l = 1;
  }
  return l > 0 ? lj(c, l) : ``;
}
function Lj(e) {
  var t = 3;
  if (e.length <= t) return e;
  for (var n = e.length % t, r = e.substr(0, n); n != e.length; n += t) r += (r.length > 0 ? `,` : ``) + e.substr(n, t);
  return r;
}
var Rj = /%/g;
function zj(e, t, n) {
  var r = t.replace(Rj, ``),
    i = t.length - r.length;
  return iM(e, r, n * 10 ** (2 * i)) + KM(`%`, i);
}
function Bj(e, t, n) {
  for (var r = t.length - 1; t.charCodeAt(r - 1) === 44;) --r;
  return iM(e, t.substr(0, r), n / 10 ** (3 * (t.length - r)));
}
function Vj(e, t) {
  var n,
    r = e.indexOf(`E`) - e.indexOf(`.`) - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return `0.0E+0`;
    if (t < 0) return `-` + Vj(e, -t);
    var i = e.indexOf(`.`);
    i === -1 && (i = e.indexOf(`E`));
    var a = Math.floor(Math.log(t) * Math.LOG10E) % i;
    if (a < 0 && (a += i), n = (t / 10 ** a).toPrecision(r + 1 + (i + a) % i), n.indexOf(`e`) === -1) {
      var o = Math.floor(Math.log(t) * Math.LOG10E);
      for (n.indexOf(`.`) === -1 ? n = n.charAt(0) + `.` + n.substr(1) + `E+` + (o - n.length + a) : n += `E+` + (o - a); n.substr(0, 2) === `0.`;) n = n.charAt(0) + n.substr(2, i) + `.` + n.substr(2 + i), n = n.replace(/^0+([1-9])/, `$1`).replace(/^0+\./, `0.`);
      n = n.replace(/\+-/, `-`);
    }
    n = n.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, t, n, r) {
      return t + n + r.substr(0, (i + a) % i) + `.` + r.substr(a) + `E`;
    });
  } else n = t.toExponential(r);
  return e.match(/E\+00$/) && n.match(/e[+-]\d$/) && (n = n.substr(0, n.length - 1) + `0` + n.charAt(n.length - 1)), e.match(/E\-/) && n.match(/e\+/) && (n = n.replace(/e\+/, `e`)), n.replace(`e`, `E`);
}
var Hj = /# (\?+)( ?)\/( ?)(\d+)/;
function Uj(e, t, n) {
  var r = parseInt(e[4], 10),
    i = Math.round(t * r),
    a = Math.floor(i / r),
    o = i - a * r,
    s = r;
  return n + (a === 0 ? `` : `` + a) + ` ` + (o === 0 ? KM(` `, e[1].length + 1 + e[4].length) : uj(o, e[1].length) + e[2] + `/` + e[3] + lj(s, e[4].length));
}
function Wj(e, t, n) {
  return n + (t === 0 ? `` : `` + t) + KM(` `, e[1].length + 2 + e[4].length);
}
var Gj = /^#*0*\.([0#]+)/,
  Kj = /\).*[0#]/,
  qj = /\(###\) ###\\?-####/;
function Jj(e) {
  for (var t = ``, n, r = 0; r != e.length; ++r) switch (n = e.charCodeAt(r)) {
    case 35:
      break;
    case 63:
      t += ` `;
      break;
    case 48:
      t += `0`;
      break;
    default:
      t += String.fromCharCode(n);
  }
  return t;
}
function Yj(e, t) {
  var n = 10 ** t;
  return `` + Math.round(e * n) / n;
}
function Xj(e, t) {
  var n = e - Math.floor(e),
    r = 10 ** t;
  return t < (`` + Math.round(n * r)).length ? 0 : Math.round(n * r);
}
function Zj(e, t) {
  return +(t < (`` + Math.round((e - Math.floor(e)) * 10 ** t)).length);
}
function Qj(e) {
  return e < 2147483647 && e > -2147483648 ? `` + (e >= 0 ? e | 0 : e - 1 | 0) : `` + Math.floor(e);
}
function $j(e, t, n) {
  if (e.charCodeAt(0) === 40 && !t.match(Kj)) {
    var r = t.replace(/\( */, ``).replace(/ \)/, ``).replace(/\)/, ``);
    return n >= 0 ? $j(`n`, r, n) : `(` + $j(`n`, r, -n) + `)`;
  }
  if (t.charCodeAt(t.length - 1) === 44) return Bj(e, t, n);
  if (t.indexOf(`%`) !== -1) return zj(e, t, n);
  if (t.indexOf(`E`) !== -1) return Vj(t, n);
  if (t.charCodeAt(0) === 36) return `$` + $j(e, t.substr(t.charAt(1) == ` ` ? 2 : 1), n);
  var i,
    a,
    o,
    s,
    c = Math.abs(n),
    l = n < 0 ? `-` : ``;
  if (t.match(/^00+$/)) return l + hj(c, t.length);
  if (t.match(/^[#?]+$/)) return i = hj(n, 0), i === `0` && (i = ``), i.length > t.length ? i : Jj(t.substr(0, t.length - i.length)) + i;
  if (a = t.match(Hj)) return Uj(a, c, l);
  if (t.match(/^#+0+$/)) return l + hj(c, t.length - t.indexOf(`0`));
  if (a = t.match(Gj)) return i = Yj(n, a[1].length).replace(/^([^\.]+)$/, `$1.` + Jj(a[1])).replace(/\.$/, `.` + Jj(a[1])).replace(/\.(\d*)$/, function (e, t) {
    return `.` + t + KM(`0`, Jj(a[1]).length - t.length);
  }), t.indexOf(`0.`) === -1 ? i.replace(/^0\./, `.`) : i;
  if (t = t.replace(/^#+([0.])/, `$1`), a = t.match(/^(0*)\.(#*)$/)) return l + Yj(c, a[2].length).replace(/\.(\d*[1-9])0*$/, `.$1`).replace(/^(-?\d*)$/, `$1.`).replace(/^0\./, a[1].length ? `0.` : `.`);
  if (a = t.match(/^#{1,3},##0(\.?)$/)) return l + Lj(hj(c, 0));
  if (a = t.match(/^#,##0\.([#0]*0)$/)) return n < 0 ? `-` + $j(e, t, -n) : Lj(`` + (Math.floor(n) + Zj(n, a[1].length))) + `.` + lj(Xj(n, a[1].length), a[1].length);
  if (a = t.match(/^#,#*,#0/)) return $j(e, t.replace(/^#,#*,/, ``), n);
  if (a = t.match(/^([0#]+)(\\?-([0#]+))+$/)) return i = cj($j(e, t.replace(/[\\-]/g, ``), n)), o = 0, cj(cj(t.replace(/\\/g, ``)).replace(/[0#]/g, function (e) {
    return o < i.length ? i.charAt(o++) : e === `0` ? `0` : ``;
  }));
  if (t.match(qj)) return i = $j(e, `##########`, n), `(` + i.substr(0, 3) + `) ` + i.substr(3, 3) + `-` + i.substr(6);
  var u = ``;
  if (a = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) return o = Math.min(a[4].length, 7), s = Cj(c, 10 ** o - 1, !1), i = `` + l, u = iM(`n`, a[1], s[1]), u.charAt(u.length - 1) == ` ` && (u = u.substr(0, u.length - 1) + `0`), i += u + a[2] + `/` + a[3], u = dj(s[2], o), u.length < a[4].length && (u = Jj(a[4].substr(a[4].length - u.length)) + u), i += u, i;
  if (a = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) return o = Math.min(Math.max(a[1].length, a[4].length), 7), s = Cj(c, 10 ** o - 1, !0), l + (s[0] || (s[1] ? `` : `0`)) + ` ` + (s[1] ? uj(s[1], o) + a[2] + `/` + a[3] + dj(s[2], o) : KM(` `, 2 * o + 1 + a[2].length + a[3].length));
  if (a = t.match(/^[#0?]+$/)) return i = hj(n, 0), t.length <= i.length ? i : Jj(t.substr(0, t.length - i.length)) + i;
  if (a = t.match(/^([#0?]+)\.([#0]+)$/)) {
    i = `` + n.toFixed(Math.min(a[2].length, 10)).replace(/([^0])0+$/, `$1`), o = i.indexOf(`.`);
    var d = t.indexOf(`.`) - o,
      f = t.length - i.length - d;
    return Jj(t.substr(0, d) + i + t.substr(t.length - f));
  }
  if (a = t.match(/^00,000\.([#0]*0)$/)) return o = Xj(n, a[1].length), n < 0 ? `-` + $j(e, t, -n) : Lj(Qj(n)).replace(/^\d,\d{3}$/, `0$&`).replace(/^\d*$/, function (e) {
    return `00,` + (e.length < 3 ? lj(0, 3 - e.length) : ``) + e;
  }) + `.` + lj(o, a[1].length);
  switch (t) {
    case `###,##0.00`:
      return $j(e, `#,##0.00`, n);
    case `###,###`:
    case `##,###`:
    case `#,###`:
      var p = Lj(hj(c, 0));
      return p === `0` ? `` : l + p;
    case `###,###.00`:
      return $j(e, `###,##0.00`, n).replace(/^0\./, `.`);
    case `#,###.00`:
      return $j(e, `#,##0.00`, n).replace(/^0\./, `.`);
  }
  throw Error(`unsupported format |` + t + `|`);
}
function eM(e, t, n) {
  for (var r = t.length - 1; t.charCodeAt(r - 1) === 44;) --r;
  return iM(e, t.substr(0, r), n / 10 ** (3 * (t.length - r)));
}
function tM(e, t, n) {
  var r = t.replace(Rj, ``),
    i = t.length - r.length;
  return iM(e, r, n * 10 ** (2 * i)) + KM(`%`, i);
}
function nM(e, t) {
  var n,
    r = e.indexOf(`E`) - e.indexOf(`.`) - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return `0.0E+0`;
    if (t < 0) return `-` + nM(e, -t);
    var i = e.indexOf(`.`);
    i === -1 && (i = e.indexOf(`E`));
    var a = Math.floor(Math.log(t) * Math.LOG10E) % i;
    if (a < 0 && (a += i), n = (t / 10 ** a).toPrecision(r + 1 + (i + a) % i), !n.match(/[Ee]/)) {
      var o = Math.floor(Math.log(t) * Math.LOG10E);
      n.indexOf(`.`) === -1 ? n = n.charAt(0) + `.` + n.substr(1) + `E+` + (o - n.length + a) : n += `E+` + (o - a), n = n.replace(/\+-/, `-`);
    }
    n = n.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, t, n, r) {
      return t + n + r.substr(0, (i + a) % i) + `.` + r.substr(a) + `E`;
    });
  } else n = t.toExponential(r);
  return e.match(/E\+00$/) && n.match(/e[+-]\d$/) && (n = n.substr(0, n.length - 1) + `0` + n.charAt(n.length - 1)), e.match(/E\-/) && n.match(/e\+/) && (n = n.replace(/e\+/, `e`)), n.replace(`e`, `E`);
}
function rM(e, t, n) {
  if (e.charCodeAt(0) === 40 && !t.match(Kj)) {
    var r = t.replace(/\( */, ``).replace(/ \)/, ``).replace(/\)/, ``);
    return n >= 0 ? rM(`n`, r, n) : `(` + rM(`n`, r, -n) + `)`;
  }
  if (t.charCodeAt(t.length - 1) === 44) return eM(e, t, n);
  if (t.indexOf(`%`) !== -1) return tM(e, t, n);
  if (t.indexOf(`E`) !== -1) return nM(t, n);
  if (t.charCodeAt(0) === 36) return `$` + rM(e, t.substr(t.charAt(1) == ` ` ? 2 : 1), n);
  var i,
    a,
    o,
    s,
    c = Math.abs(n),
    l = n < 0 ? `-` : ``;
  if (t.match(/^00+$/)) return l + lj(c, t.length);
  if (t.match(/^[#?]+$/)) return i = `` + n, n === 0 && (i = ``), i.length > t.length ? i : Jj(t.substr(0, t.length - i.length)) + i;
  if (a = t.match(Hj)) return Wj(a, c, l);
  if (t.match(/^#+0+$/)) return l + lj(c, t.length - t.indexOf(`0`));
  if (a = t.match(Gj)) return i = (`` + n).replace(/^([^\.]+)$/, `$1.` + Jj(a[1])).replace(/\.$/, `.` + Jj(a[1])), i = i.replace(/\.(\d*)$/, function (e, t) {
    return `.` + t + KM(`0`, Jj(a[1]).length - t.length);
  }), t.indexOf(`0.`) === -1 ? i.replace(/^0\./, `.`) : i;
  if (t = t.replace(/^#+([0.])/, `$1`), a = t.match(/^(0*)\.(#*)$/)) return l + (`` + c).replace(/\.(\d*[1-9])0*$/, `.$1`).replace(/^(-?\d*)$/, `$1.`).replace(/^0\./, a[1].length ? `0.` : `.`);
  if (a = t.match(/^#{1,3},##0(\.?)$/)) return l + Lj(`` + c);
  if (a = t.match(/^#,##0\.([#0]*0)$/)) return n < 0 ? `-` + rM(e, t, -n) : Lj(`` + n) + `.` + KM(`0`, a[1].length);
  if (a = t.match(/^#,#*,#0/)) return rM(e, t.replace(/^#,#*,/, ``), n);
  if (a = t.match(/^([0#]+)(\\?-([0#]+))+$/)) return i = cj(rM(e, t.replace(/[\\-]/g, ``), n)), o = 0, cj(cj(t.replace(/\\/g, ``)).replace(/[0#]/g, function (e) {
    return o < i.length ? i.charAt(o++) : e === `0` ? `0` : ``;
  }));
  if (t.match(qj)) return i = rM(e, `##########`, n), `(` + i.substr(0, 3) + `) ` + i.substr(3, 3) + `-` + i.substr(6);
  var u = ``;
  if (a = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) return o = Math.min(a[4].length, 7), s = Cj(c, 10 ** o - 1, !1), i = `` + l, u = iM(`n`, a[1], s[1]), u.charAt(u.length - 1) == ` ` && (u = u.substr(0, u.length - 1) + `0`), i += u + a[2] + `/` + a[3], u = dj(s[2], o), u.length < a[4].length && (u = Jj(a[4].substr(a[4].length - u.length)) + u), i += u, i;
  if (a = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) return o = Math.min(Math.max(a[1].length, a[4].length), 7), s = Cj(c, 10 ** o - 1, !0), l + (s[0] || (s[1] ? `` : `0`)) + ` ` + (s[1] ? uj(s[1], o) + a[2] + `/` + a[3] + dj(s[2], o) : KM(` `, 2 * o + 1 + a[2].length + a[3].length));
  if (a = t.match(/^[#0?]+$/)) return i = `` + n, t.length <= i.length ? i : Jj(t.substr(0, t.length - i.length)) + i;
  if (a = t.match(/^([#0]+)\.([#0]+)$/)) {
    i = `` + n.toFixed(Math.min(a[2].length, 10)).replace(/([^0])0+$/, `$1`), o = i.indexOf(`.`);
    var d = t.indexOf(`.`) - o,
      f = t.length - i.length - d;
    return Jj(t.substr(0, d) + i + t.substr(t.length - f));
  }
  if (a = t.match(/^00,000\.([#0]*0)$/)) return n < 0 ? `-` + rM(e, t, -n) : Lj(`` + n).replace(/^\d,\d{3}$/, `0$&`).replace(/^\d*$/, function (e) {
    return `00,` + (e.length < 3 ? lj(0, 3 - e.length) : ``) + e;
  }) + `.` + lj(0, a[1].length);
  switch (t) {
    case `###,###`:
    case `##,###`:
    case `#,###`:
      var p = Lj(`` + c);
      return p === `0` ? `` : l + p;
    default:
      if (t.match(/\.[0#?]*$/)) return rM(e, t.slice(0, t.lastIndexOf(`.`)), n) + Jj(t.slice(t.lastIndexOf(`.`)));
  }
  throw Error(`unsupported format |` + t + `|`);
}
function iM(e, t, n) {
  return (n | 0) === n ? rM(e, t, n) : $j(e, t, n);
}
function aM(e) {
  for (var t = [], n = !1, r = 0, i = 0; r < e.length; ++r) switch (e.charCodeAt(r)) {
    case 34:
      n = !n;
      break;
    case 95:
    case 42:
    case 92:
      ++r;
      break;
    case 59:
      t[t.length] = e.substr(i, r - i), i = r + 1;
  }
  if (t[t.length] = e.substr(i), n === !0) throw Error(`Format |` + e + `| unterminated string `);
  return t;
}
var oM = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function sM(e) {
  for (var t = 0, n = ``, r = ``; t < e.length;) switch (n = e.charAt(t)) {
    case `G`:
      gj(e, t) && (t += 6), t++;
      break;
    case `"`:
      for (; e.charCodeAt(++t) !== 34 && t < e.length;);
      ++t;
      break;
    case `\\`:
      t += 2;
      break;
    case `_`:
      t += 2;
      break;
    case `@`:
      ++t;
      break;
    case `B`:
    case `b`:
      if (e.charAt(t + 1) === `1` || e.charAt(t + 1) === `2`) return !0;
    case `M`:
    case `D`:
    case `Y`:
    case `H`:
    case `S`:
    case `E`:
    case `m`:
    case `d`:
    case `y`:
    case `h`:
    case `s`:
    case `e`:
    case `g`:
      return !0;
    case `A`:
    case `a`:
    case `上`:
      if (e.substr(t, 3).toUpperCase() === `A/P` || e.substr(t, 5).toUpperCase() === `AM/PM` || e.substr(t, 5).toUpperCase() === `上午/下午`) return !0;
      ++t;
      break;
    case `[`:
      for (r = n; e.charAt(t++) !== `]` && t < e.length;) r += e.charAt(t);
      if (r.match(oM)) return !0;
      break;
    case `.`:
    case `0`:
    case `#`:
      for (; t < e.length && (`0#?.,E+-%`.indexOf(n = e.charAt(++t)) > -1 || n == `\\` && e.charAt(t + 1) == `-` && `0#`.indexOf(e.charAt(t + 2)) > -1););
      break;
    case `?`:
      for (; e.charAt(++t) === n;);
      break;
    case `*`:
      ++t, (e.charAt(t) == ` ` || e.charAt(t) == `*`) && ++t;
      break;
    case `(`:
    case `)`:
      ++t;
      break;
    case `1`:
    case `2`:
    case `3`:
    case `4`:
    case `5`:
    case `6`:
    case `7`:
    case `8`:
    case `9`:
      for (; t < e.length && `0123456789`.indexOf(e.charAt(++t)) > -1;);
      break;
    case ` `:
      ++t;
      break;
    default:
      ++t;
  }
  return !1;
}
function cM(e, t, n, r) {
  for (var i = [], a = ``, o = 0, s = ``, c = `t`, l, u, d, f = `H`; o < e.length;) switch (s = e.charAt(o)) {
    case `G`:
      if (!gj(e, o)) throw Error(`unrecognized character ` + s + ` in ` + e);
      i[i.length] = {
        t: `G`,
        v: `General`
      }, o += 7;
      break;
    case `"`:
      for (a = ``; (d = e.charCodeAt(++o)) !== 34 && o < e.length;) a += String.fromCharCode(d);
      i[i.length] = {
        t: `t`,
        v: a
      }, ++o;
      break;
    case `\\`:
      var p = e.charAt(++o),
        m = p === `(` || p === `)` ? p : `t`;
      i[i.length] = {
        t: m,
        v: p
      }, ++o;
      break;
    case `_`:
      i[i.length] = {
        t: `t`,
        v: ` `
      }, o += 2;
      break;
    case `@`:
      i[i.length] = {
        t: `T`,
        v: t
      }, ++o;
      break;
    case `B`:
    case `b`:
      if (e.charAt(o + 1) === `1` || e.charAt(o + 1) === `2`) {
        if (l == null && (l = wj(t, n, e.charAt(o + 1) === `2`), l == null)) return ``;
        i[i.length] = {
          t: `X`,
          v: e.substr(o, 2)
        }, c = s, o += 2;
        break;
      }
    case `M`:
    case `D`:
    case `Y`:
    case `H`:
    case `S`:
    case `E`:
      s = s.toLowerCase();
    case `m`:
    case `d`:
    case `y`:
    case `h`:
    case `s`:
    case `e`:
    case `g`:
      if (t < 0 || l == null && (l = wj(t, n), l == null)) return ``;
      for (a = s; ++o < e.length && e.charAt(o).toLowerCase() === s;) a += s;
      s === `m` && c.toLowerCase() === `h` && (s = `M`), s === `h` && (s = f), i[i.length] = {
        t: s,
        v: a
      }, c = s;
      break;
    case `A`:
    case `a`:
    case `上`:
      var h = {
        t: s,
        v: s
      };
      if (l ??= wj(t, n), e.substr(o, 3).toUpperCase() === `A/P` ? (l != null && (h.v = l.H >= 12 ? `P` : `A`), h.t = `T`, f = `h`, o += 3) : e.substr(o, 5).toUpperCase() === `AM/PM` ? (l != null && (h.v = l.H >= 12 ? `PM` : `AM`), h.t = `T`, o += 5, f = `h`) : e.substr(o, 5).toUpperCase() === `上午/下午` ? (l != null && (h.v = l.H >= 12 ? `下午` : `上午`), h.t = `T`, o += 5, f = `h`) : (h.t = `t`, ++o), l == null && h.t === `T`) return ``;
      i[i.length] = h, c = s;
      break;
    case `[`:
      for (a = s; e.charAt(o++) !== `]` && o < e.length;) a += e.charAt(o);
      if (a.slice(-1) !== `]`) throw `unterminated "[" block: |` + a + `|`;
      if (a.match(oM)) {
        if (l == null && (l = wj(t, n), l == null)) return ``;
        i[i.length] = {
          t: `Z`,
          v: a.toLowerCase()
        }, c = a.charAt(1);
      } else a.indexOf(`$`) > -1 && (a = (a.match(/\$([^-\[\]]*)/) || [])[1] || `$`, sM(e) || (i[i.length] = {
        t: `t`,
        v: a
      }));
      break;
    case `.`:
      if (l != null) {
        for (a = s; ++o < e.length && (s = e.charAt(o)) === `0`;) a += s;
        i[i.length] = {
          t: `s`,
          v: a
        };
        break;
      }
    case `0`:
    case `#`:
      for (a = s; ++o < e.length && `0#?.,E+-%`.indexOf(s = e.charAt(o)) > -1;) a += s;
      i[i.length] = {
        t: `n`,
        v: a
      };
      break;
    case `?`:
      for (a = s; e.charAt(++o) === s;) a += s;
      i[i.length] = {
        t: s,
        v: a
      }, c = s;
      break;
    case `*`:
      ++o, (e.charAt(o) == ` ` || e.charAt(o) == `*`) && ++o;
      break;
    case `(`:
    case `)`:
      i[i.length] = {
        t: r === 1 ? `t` : s,
        v: s
      }, ++o;
      break;
    case `1`:
    case `2`:
    case `3`:
    case `4`:
    case `5`:
    case `6`:
    case `7`:
    case `8`:
    case `9`:
      for (a = s; o < e.length && `0123456789`.indexOf(e.charAt(++o)) > -1;) a += e.charAt(o);
      i[i.length] = {
        t: `D`,
        v: a
      };
      break;
    case ` `:
      i[i.length] = {
        t: s,
        v: s
      }, ++o;
      break;
    case `$`:
      i[i.length] = {
        t: `t`,
        v: `$`
      }, ++o;
      break;
    default:
      if (`,$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP`.indexOf(s) === -1) throw Error(`unrecognized character ` + s + ` in ` + e);
      i[i.length] = {
        t: `t`,
        v: s
      }, ++o;
  }
  var g = 0,
    _ = 0,
    v;
  for (o = i.length - 1, c = `t`; o >= 0; --o) switch (i[o].t) {
    case `h`:
    case `H`:
      i[o].t = f, c = `h`, g < 1 && (g = 1);
      break;
    case `s`:
      (v = i[o].v.match(/\.0+$/)) && (_ = Math.max(_, v[0].length - 1)), g < 3 && (g = 3);
    case `d`:
    case `y`:
    case `M`:
    case `e`:
      c = i[o].t;
      break;
    case `m`:
      c === `s` && (i[o].t = `M`, g < 2 && (g = 2));
      break;
    case `X`:
      break;
    case `Z`:
      g < 1 && i[o].v.match(/[Hh]/) && (g = 1), g < 2 && i[o].v.match(/[Mm]/) && (g = 2), g < 3 && i[o].v.match(/[Ss]/) && (g = 3);
  }
  switch (g) {
    case 0:
      break;
    case 1:
      l.u >= .5 && (l.u = 0, ++l.S), l.S >= 60 && (l.S = 0, ++l.M), l.M >= 60 && (l.M = 0, ++l.H);
      break;
    case 2:
      l.u >= .5 && (l.u = 0, ++l.S), l.S >= 60 && (l.S = 0, ++l.M);
  }
  var y = ``,
    b;
  for (o = 0; o < i.length; ++o) switch (i[o].t) {
    case `t`:
    case `T`:
    case ` `:
    case `D`:
      break;
    case `X`:
      i[o].v = ``, i[o].t = `;`;
      break;
    case `d`:
    case `m`:
    case `y`:
    case `h`:
    case `H`:
    case `M`:
    case `s`:
    case `e`:
    case `b`:
    case `Z`:
      i[o].v = Ij(i[o].t.charCodeAt(0), i[o].v, l, _), i[o].t = `t`;
      break;
    case `n`:
    case `?`:
      for (b = o + 1; i[b] != null && ((s = i[b].t) === `?` || s === `D` || (s === ` ` || s === `t`) && i[b + 1] != null && (i[b + 1].t === `?` || i[b + 1].t === `t` && i[b + 1].v === `/`) || i[o].t === `(` && (s === ` ` || s === `n` || s === `)`) || s === `t` && (i[b].v === `/` || i[b].v === ` ` && i[b + 1] != null && i[b + 1].t == `?`));) i[o].v += i[b].v, i[b] = {
        v: ``,
        t: `;`
      }, ++b;
      y += i[o].v, o = b - 1;
      break;
    case `G`:
      i[o].t = `t`, i[o].v = Pj(t, n);
  }
  var x = ``,
    S,
    C;
  if (y.length > 0) {
    y.charCodeAt(0) == 40 ? (S = t < 0 && y.charCodeAt(0) === 45 ? -t : t, C = iM(`n`, y, S)) : (S = t < 0 && r > 1 ? -t : t, C = iM(`n`, y, S), S < 0 && i[0] && i[0].t == `t` && (C = C.substr(1), i[0].v = `-` + i[0].v)), b = C.length - 1;
    var w = i.length;
    for (o = 0; o < i.length; ++o) if (i[o] != null && i[o].t != `t` && i[o].v.indexOf(`.`) > -1) {
      w = o;
      break;
    }
    var T = i.length;
    if (w === i.length && C.indexOf(`E`) === -1) {
      for (o = i.length - 1; o >= 0; --o) i[o] != null && `n?`.indexOf(i[o].t) !== -1 && (b >= i[o].v.length - 1 ? (b -= i[o].v.length, i[o].v = C.substr(b + 1, i[o].v.length)) : b < 0 ? i[o].v = `` : (i[o].v = C.substr(0, b + 1), b = -1), i[o].t = `t`, T = o);
      b >= 0 && T < i.length && (i[T].v = C.substr(0, b + 1) + i[T].v);
    } else if (w !== i.length && C.indexOf(`E`) === -1) {
      for (b = C.indexOf(`.`) - 1, o = w; o >= 0; --o) if (i[o] != null && `n?`.indexOf(i[o].t) !== -1) {
        for (u = i[o].v.indexOf(`.`) > -1 && o === w ? i[o].v.indexOf(`.`) - 1 : i[o].v.length - 1, x = i[o].v.substr(u + 1); u >= 0; --u) b >= 0 && (i[o].v.charAt(u) === `0` || i[o].v.charAt(u) === `#`) && (x = C.charAt(b--) + x);
        i[o].v = x, i[o].t = `t`, T = o;
      }
      for (b >= 0 && T < i.length && (i[T].v = C.substr(0, b + 1) + i[T].v), b = C.indexOf(`.`) + 1, o = w; o < i.length; ++o) if (!(i[o] == null || `n?(`.indexOf(i[o].t) === -1 && o !== w)) {
        for (u = i[o].v.indexOf(`.`) > -1 && o === w ? i[o].v.indexOf(`.`) + 1 : 0, x = i[o].v.substr(0, u); u < i[o].v.length; ++u) b < C.length && (x += C.charAt(b++));
        i[o].v = x, i[o].t = `t`, T = o;
      }
    }
  }
  for (o = 0; o < i.length; ++o) i[o] != null && `n?`.indexOf(i[o].t) > -1 && (S = r > 1 && t < 0 && o > 0 && i[o - 1].v === `-` ? -t : t, i[o].v = iM(i[o].t, i[o].v, S), i[o].t = `t`);
  var E = ``;
  for (o = 0; o !== i.length; ++o) i[o] != null && (E += i[o].v);
  return E;
}
var lM = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function uM(e, t) {
  if (t == null) return !1;
  var n = parseFloat(t[2]);
  switch (t[1]) {
    case `=`:
      if (e == n) return !0;
      break;
    case `>`:
      if (e > n) return !0;
      break;
    case `<`:
      if (e < n) return !0;
      break;
    case `<>`:
      if (e != n) return !0;
      break;
    case `>=`:
      if (e >= n) return !0;
      break;
    case `<=`:
      if (e <= n) return !0;
  }
  return !1;
}
function dM(e, t) {
  var n = aM(e),
    r = n.length,
    i = n[r - 1].indexOf(`@`);
  if (r < 4 && i > -1 && --r, n.length > 4) throw Error(`cannot find right format for |` + n.join(`|`) + `|`);
  if (typeof t != `number`) return [4, n.length === 4 || i > -1 ? n[n.length - 1] : `@`];
  switch (n.length) {
    case 1:
      n = i > -1 ? [`General`, `General`, `General`, n[0]] : [n[0], n[0], n[0], `@`];
      break;
    case 2:
      n = i > -1 ? [n[0], n[0], n[0], n[1]] : [n[0], n[1], n[0], `@`];
      break;
    case 3:
      n = i > -1 ? [n[0], n[1], n[0], n[2]] : [n[0], n[1], n[2], `@`];
  }
  var a = t > 0 ? n[0] : t < 0 ? n[1] : n[2];
  if (n[0].indexOf(`[`) === -1 && n[1].indexOf(`[`) === -1) return [r, a];
  if (n[0].match(/\[[=<>]/) != null || n[1].match(/\[[=<>]/) != null) {
    var o = n[0].match(lM),
      s = n[1].match(lM);
    return uM(t, o) ? [r, n[0]] : uM(t, s) ? [r, n[1]] : [r, n[o != null && s != null ? 2 : 1]];
  }
  return [r, a];
}
function fM(e, t, n) {
  n ??= {};
  var r = ``;
  switch (typeof e) {
    case `string`:
      r = e == `m/d/yy` && n.dateNF ? n.dateNF : e;
      break;
    case `number`:
      r = e == 14 && n.dateNF ? n.dateNF : (n.table == null ? bj : n.table)[e], r ??= n.table && n.table[xj[e]] || bj[xj[e]], r ??= Sj[e] || `General`;
  }
  if (gj(r, 0)) return Pj(t, n);
  t instanceof Date && (t = Oj(t, n.date1904));
  var i = dM(r, t);
  if (gj(i[1])) return Pj(t, n);
  if (t === !0) t = `TRUE`;else if (t === !1) t = `FALSE`;else if (t === `` || t == null) return ``;
  return cM(i[1], t, n, i[0]);
}
function pM(e, t) {
  if (typeof t != `number`) {
    t = +t || -1;
    for (var n = 0; n < 392; ++n) {
      if (bj[n] == null) {
        t < 0 && (t = n);
        continue;
      }
      if (bj[n] == e) {
        t = n;
        break;
      }
    }
    t < 0 && (t = 391);
  }
  return bj[t] = e, t;
}
function mM(e) {
  for (var t = 0; t != 392; ++t) e[t] !== void 0 && pM(e[t], t);
}
function hM() {
  bj = yj();
}
var gM = {
    format: fM,
    load: pM,
    _table: bj,
    load_table: mM,
    parse_date_code: wj,
    is_date: sM,
    get_table: function () {
      return gM._table = bj;
    }
  },
  _M = {
    5: `"$"#,##0_);\\("$"#,##0\\)`,
    6: `"$"#,##0_);[Red]\\("$"#,##0\\)`,
    7: `"$"#,##0.00_);\\("$"#,##0.00\\)`,
    8: `"$"#,##0.00_);[Red]\\("$"#,##0.00\\)`,
    23: `General`,
    24: `General`,
    25: `General`,
    26: `General`,
    27: `m/d/yy`,
    28: `m/d/yy`,
    29: `m/d/yy`,
    30: `m/d/yy`,
    31: `m/d/yy`,
    32: `h:mm:ss`,
    33: `h:mm:ss`,
    34: `h:mm:ss`,
    35: `h:mm:ss`,
    36: `m/d/yy`,
    41: `_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)`,
    42: `_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)`,
    43: `_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)`,
    44: `_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)`,
    50: `m/d/yy`,
    51: `m/d/yy`,
    52: `m/d/yy`,
    53: `m/d/yy`,
    54: `m/d/yy`,
    55: `m/d/yy`,
    56: `m/d/yy`,
    57: `m/d/yy`,
    58: `m/d/yy`,
    59: `0`,
    60: `0.00`,
    61: `#,##0`,
    62: `#,##0.00`,
    63: `"$"#,##0_);\\("$"#,##0\\)`,
    64: `"$"#,##0_);[Red]\\("$"#,##0\\)`,
    65: `"$"#,##0.00_);\\("$"#,##0.00\\)`,
    66: `"$"#,##0.00_);[Red]\\("$"#,##0.00\\)`,
    67: `0%`,
    68: `0.00%`,
    69: `# ?/?`,
    70: `# ??/??`,
    71: `m/d/yy`,
    72: `m/d/yy`,
    73: `d-mmm-yy`,
    74: `d-mmm`,
    75: `mmm-yy`,
    76: `h:mm`,
    77: `h:mm:ss`,
    78: `m/d/yy h:mm`,
    79: `mm:ss`,
    80: `[h]:mm:ss`,
    81: `mmss.0`
  },
  vM = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function yM(e) {
  var t = typeof e == `number` ? bj[e] : e;
  return t = t.replace(vM, `(\\d+)`), RegExp(`^` + t + `$`);
}
function bM(e, t, n) {
  var r = -1,
    i = -1,
    a = -1,
    o = -1,
    s = -1,
    c = -1;
  (t.match(vM) || []).forEach(function (e, t) {
    var l = parseInt(n[t + 1], 10);
    switch (e.toLowerCase().charAt(0)) {
      case `y`:
        r = l;
        break;
      case `d`:
        a = l;
        break;
      case `h`:
        o = l;
        break;
      case `s`:
        c = l;
        break;
      case `m`:
        o >= 0 ? s = l : i = l;
    }
  }), c >= 0 && s == -1 && i >= 0 && (s = i, i = -1);
  var l = (`` + (r >= 0 ? r : new Date().getFullYear())).slice(-4) + `-` + (`00` + (i >= 1 ? i : 1)).slice(-2) + `-` + (`00` + (a >= 1 ? a : 1)).slice(-2);
  l.length == 7 && (l = `0` + l), l.length == 8 && (l = `20` + l);
  var u = (`00` + (o >= 0 ? o : 0)).slice(-2) + `:` + (`00` + (s >= 0 ? s : 0)).slice(-2) + `:` + (`00` + (c >= 0 ? c : 0)).slice(-2);
  return o == -1 && s == -1 && c == -1 ? l : r == -1 && i == -1 && a == -1 ? u : l + `T` + u;
}
var xM = function () {
    var e = {};
    e.version = `1.2.0`;
    function t() {
      for (var e = 0, t = Array(256), n = 0; n != 256; ++n) e = n, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, e = e & 1 ? -306674912 ^ e >>> 1 : e >>> 1, t[n] = e;
      return typeof Int32Array < `u` ? new Int32Array(t) : t;
    }
    var n = t();
    function r(e) {
      var t = 0,
        n = 0,
        r = 0,
        i = typeof Int32Array < `u` ? new Int32Array(4096) : Array(4096);
      for (r = 0; r != 256; ++r) i[r] = e[r];
      for (r = 0; r != 256; ++r) for (n = e[r], t = 256 + r; t < 4096; t += 256) n = i[t] = n >>> 8 ^ e[n & 255];
      var a = [];
      for (r = 1; r != 16; ++r) a[r - 1] = typeof Int32Array < `u` ? i.subarray(r * 256, r * 256 + 256) : i.slice(r * 256, r * 256 + 256);
      return a;
    }
    var i = r(n),
      a = i[0],
      o = i[1],
      s = i[2],
      c = i[3],
      l = i[4],
      u = i[5],
      d = i[6],
      f = i[7],
      p = i[8],
      m = i[9],
      h = i[10],
      g = i[11],
      _ = i[12],
      v = i[13],
      y = i[14];
    function b(e, t) {
      for (var r = t ^ -1, i = 0, a = e.length; i < a;) r = r >>> 8 ^ n[(r ^ e.charCodeAt(i++)) & 255];
      return ~r;
    }
    function x(e, t) {
      for (var r = t ^ -1, i = e.length - 15, b = 0; b < i;) r = y[e[b++] ^ r & 255] ^ v[e[b++] ^ r >> 8 & 255] ^ _[e[b++] ^ r >> 16 & 255] ^ g[e[b++] ^ r >>> 24] ^ h[e[b++]] ^ m[e[b++]] ^ p[e[b++]] ^ f[e[b++]] ^ d[e[b++]] ^ u[e[b++]] ^ l[e[b++]] ^ c[e[b++]] ^ s[e[b++]] ^ o[e[b++]] ^ a[e[b++]] ^ n[e[b++]];
      for (i += 15; b < i;) r = r >>> 8 ^ n[(r ^ e[b++]) & 255];
      return ~r;
    }
    function S(e, t) {
      for (var r = t ^ -1, i = 0, a = e.length, o = 0, s = 0; i < a;) o = e.charCodeAt(i++), o < 128 ? r = r >>> 8 ^ n[(r ^ o) & 255] : o < 2048 ? (r = r >>> 8 ^ n[(r ^ (192 | o >> 6 & 31)) & 255], r = r >>> 8 ^ n[(r ^ (128 | o & 63)) & 255]) : o >= 55296 && o < 57344 ? (o = (o & 1023) + 64, s = e.charCodeAt(i++) & 1023, r = r >>> 8 ^ n[(r ^ (240 | o >> 8 & 7)) & 255], r = r >>> 8 ^ n[(r ^ (128 | o >> 2 & 63)) & 255], r = r >>> 8 ^ n[(r ^ (128 | s >> 6 & 15 | (o & 3) << 4)) & 255], r = r >>> 8 ^ n[(r ^ (128 | s & 63)) & 255]) : (r = r >>> 8 ^ n[(r ^ (224 | o >> 12 & 15)) & 255], r = r >>> 8 ^ n[(r ^ (128 | o >> 6 & 63)) & 255], r = r >>> 8 ^ n[(r ^ (128 | o & 63)) & 255]);
      return ~r;
    }
    return e.table = n, e.bstr = b, e.buf = x, e.str = S, e;
  }(),
  SM = function () {
    var e = {};
    e.version = `1.2.1`;
    function t(e, t) {
      for (var n = e.split(`/`), r = t.split(`/`), i = 0, a = 0, o = Math.min(n.length, r.length); i < o; ++i) {
        if (a = n[i].length - r[i].length) return a;
        if (n[i] != r[i]) return n[i] < r[i] ? -1 : 1;
      }
      return n.length - r.length;
    }
    function n(e) {
      if (e.charAt(e.length - 1) == `/`) return e.slice(0, -1).indexOf(`/`) === -1 ? e : n(e.slice(0, -1));
      var t = e.lastIndexOf(`/`);
      return t === -1 ? e : e.slice(0, t + 1);
    }
    function r(e) {
      if (e.charAt(e.length - 1) == `/`) return r(e.slice(0, -1));
      var t = e.lastIndexOf(`/`);
      return t === -1 ? e : e.slice(t + 1);
    }
    function i(e, t) {
      typeof t == `string` && (t = new Date(t));
      var n = t.getHours();
      n = n << 6 | t.getMinutes(), n = n << 5 | t.getSeconds() >>> 1, e.write_shift(2, n);
      var r = t.getFullYear() - 1980;
      r = r << 4 | t.getMonth() + 1, r = r << 5 | t.getDate(), e.write_shift(2, r);
    }
    function a(e) {
      var t = e.read_shift(2) & 65535,
        n = e.read_shift(2) & 65535,
        r = new Date(),
        i = n & 31;
      n >>>= 5;
      var a = n & 15;
      n >>>= 4, r.setMilliseconds(0), r.setFullYear(n + 1980), r.setMonth(a - 1), r.setDate(i);
      var o = t & 31;
      t >>>= 5;
      var s = t & 63;
      return t >>>= 6, r.setHours(t), r.setMinutes(s), r.setSeconds(o << 1), r;
    }
    function o(e) {
      FP(e, 0);
      for (var t = {}, n = 0; e.l <= e.length - 4;) {
        var r = e.read_shift(2),
          i = e.read_shift(2),
          a = e.l + i,
          o = {};
        r === 21589 && (n = e.read_shift(1), n & 1 && (o.mtime = e.read_shift(4)), i > 5 && (n & 2 && (o.atime = e.read_shift(4)), n & 4 && (o.ctime = e.read_shift(4))), o.mtime && (o.mt = new Date(o.mtime * 1e3))), e.l = a, t[r] = o;
      }
      return t;
    }
    var s;
    function c() {
      return s ||= {};
    }
    function l(e, t) {
      if (e[0] == 80 && e[1] == 75) return je(e, t);
      if ((e[0] | 32) == 109 && (e[1] | 32) == 105) return Be(e, t);
      if (e.length < 512) throw Error(`CFB file size ` + e.length + ` < 512`);
      var n = 3,
        r = 512,
        i = 0,
        a = 0,
        o = 0,
        s = 0,
        c = 0,
        l = [],
        m = e.slice(0, 512);
      FP(m, 0);
      var g = u(m);
      switch (n = g[0], n) {
        case 3:
          r = 512;
          break;
        case 4:
          r = 4096;
          break;
        case 0:
          if (g[1] == 0) return je(e, t);
        default:
          throw Error(`Major Version: Expected 3 or 4 saw ` + n);
      }
      r !== 512 && (m = e.slice(0, r), FP(m, 28));
      var y = e.slice(0, r);
      d(m, n);
      var b = m.read_shift(4, `i`);
      if (n === 3 && b !== 0) throw Error(`# Directory Sectors: Expected 0 saw ` + b);
      m.l += 4, o = m.read_shift(4, `i`), m.l += 4, m.chk(`00100000`, `Mini Stream Cutoff Size: `), s = m.read_shift(4, `i`), i = m.read_shift(4, `i`), c = m.read_shift(4, `i`), a = m.read_shift(4, `i`);
      for (var x = -1, S = 0; S < 109 && (x = m.read_shift(4, `i`), !(x < 0)); ++S) l[S] = x;
      var C = f(e, r);
      h(c, a, C, r, l);
      var w = _(C, o, l, r);
      w[o].name = `!Directory`, i > 0 && s !== O && (w[s].name = `!MiniFAT`), w[l[0]].name = `!FAT`, w.fat_addrs = l, w.ssz = r;
      var T = {},
        E = [],
        D = [],
        k = [];
      v(o, w, C, E, i, T, D, s), p(D, k, E), E.shift();
      var A = {
        FileIndex: D,
        FullPaths: k
      };
      return t && t.raw && (A.raw = {
        header: y,
        sectors: C
      }), A;
    }
    function u(e) {
      if (e[e.l] == 80 && e[e.l + 1] == 75) return [0, 0];
      e.chk(k, `Header Signature: `), e.l += 16;
      var t = e.read_shift(2, `u`);
      return [e.read_shift(2, `u`), t];
    }
    function d(e, t) {
      var n = 9;
      switch (e.l += 2, n = e.read_shift(2)) {
        case 9:
          if (t != 3) throw Error(`Sector Shift: Expected 9 saw ` + n);
          break;
        case 12:
          if (t != 4) throw Error(`Sector Shift: Expected 12 saw ` + n);
          break;
        default:
          throw Error(`Sector Shift: Expected 9 or 12 saw ` + n);
      }
      e.chk(`0600`, `Mini Sector Shift: `), e.chk(`000000000000`, `Reserved: `);
    }
    function f(e, t) {
      for (var n = Math.ceil(e.length / t) - 1, r = [], i = 1; i < n; ++i) r[i - 1] = e.slice(i * t, (i + 1) * t);
      return r[n - 1] = e.slice(n * t), r;
    }
    function p(e, t, n) {
      for (var r = 0, i = 0, a = 0, o = 0, s = 0, c = n.length, l = [], u = []; r < c; ++r) l[r] = u[r] = r, t[r] = n[r];
      for (; s < u.length; ++s) r = u[s], i = e[r].L, a = e[r].R, o = e[r].C, l[r] === r && (i !== -1 && l[i] !== i && (l[r] = l[i]), a !== -1 && l[a] !== a && (l[r] = l[a])), o !== -1 && (l[o] = r), i !== -1 && r != l[r] && (l[i] = l[r], u.lastIndexOf(i) < s && u.push(i)), a !== -1 && r != l[r] && (l[a] = l[r], u.lastIndexOf(a) < s && u.push(a));
      for (r = 1; r < c; ++r) l[r] === r && (a !== -1 && l[a] !== a ? l[r] = l[a] : i !== -1 && l[i] !== i && (l[r] = l[i]));
      for (r = 1; r < c; ++r) if (e[r].type !== 0) {
        if (s = r, s != l[s]) do s = l[s], t[r] = t[s] + `/` + t[r]; while (s !== 0 && l[s] !== -1 && s != l[s]);
        l[r] = -1;
      }
      for (t[0] += `/`, r = 1; r < c; ++r) e[r].type !== 2 && (t[r] += `/`);
    }
    function m(e, t, n) {
      for (var r = e.start, i = e.size, a = [], o = r; n && i > 0 && o >= 0;) a.push(t.slice(o * D, o * D + D)), i -= D, o = DP(n, o * 4);
      return a.length === 0 ? Z(0) : ij(a).slice(0, e.size);
    }
    function h(e, t, n, r, i) {
      var a = O;
      if (e === O) {
        if (t !== 0) throw Error(`DIFAT chain shorter than expected`);
      } else if (e !== -1) {
        var o = n[e],
          s = (r >>> 2) - 1;
        if (!o) return;
        for (var c = 0; c < s && (a = DP(o, c * 4)) !== O; ++c) i.push(a);
        h(DP(o, r - 4), t - 1, n, r, i);
      }
    }
    function g(e, t, n, r, i) {
      var a = [],
        o = [];
      i ||= [];
      var s = r - 1,
        c = 0,
        l = 0;
      for (c = t; c >= 0;) {
        i[c] = !0, a[a.length] = c, o.push(e[c]);
        var u = n[Math.floor(c * 4 / r)];
        if (l = c * 4 & s, r < 4 + l) throw Error(`FAT boundary crossed: ` + c + ` 4 ` + r);
        if (!e[u]) break;
        c = DP(e[u], l);
      }
      return {
        nodes: a,
        data: nP([o])
      };
    }
    function _(e, t, n, r) {
      var i = e.length,
        a = [],
        o = [],
        s = [],
        c = [],
        l = r - 1,
        u = 0,
        d = 0,
        f = 0,
        p = 0;
      for (u = 0; u < i; ++u) if (s = [], f = u + t, f >= i && (f -= i), !o[f]) {
        c = [];
        var m = [];
        for (d = f; d >= 0;) {
          m[d] = !0, o[d] = !0, s[s.length] = d, c.push(e[d]);
          var h = n[Math.floor(d * 4 / r)];
          if (p = d * 4 & l, r < 4 + p) throw Error(`FAT boundary crossed: ` + d + ` 4 ` + r);
          if (!e[h] || (d = DP(e[h], p), m[d])) break;
        }
        a[f] = {
          nodes: s,
          data: nP([c])
        };
      }
      return a;
    }
    function v(e, t, n, r, i, a, o, s) {
      for (var c = 0, l = r.length ? 2 : 0, u = t[e].data, d = 0, f = 0, p; d < u.length; d += 128) {
        var h = u.slice(d, d + 128);
        FP(h, 64), f = h.read_shift(2), p = iP(h, 0, f - l), r.push(p);
        var _ = {
          name: p,
          type: h.read_shift(1),
          color: h.read_shift(1),
          L: h.read_shift(4, `i`),
          R: h.read_shift(4, `i`),
          C: h.read_shift(4, `i`),
          clsid: h.read_shift(16),
          state: h.read_shift(4, `i`),
          start: 0,
          size: 0
        };
        h.read_shift(2) + h.read_shift(2) + h.read_shift(2) + h.read_shift(2) !== 0 && (_.ct = y(h, h.l - 8)), h.read_shift(2) + h.read_shift(2) + h.read_shift(2) + h.read_shift(2) !== 0 && (_.mt = y(h, h.l - 8)), _.start = h.read_shift(4, `i`), _.size = h.read_shift(4, `i`), _.size < 0 && _.start < 0 && (_.size = _.type = 0, _.start = O, _.name = ``), _.type === 5 ? (c = _.start, i > 0 && c !== O && (t[c].name = `!StreamData`)) : _.size >= 4096 ? (_.storage = `fat`, t[_.start] === void 0 && (t[_.start] = g(n, _.start, t.fat_addrs, t.ssz)), t[_.start].name = _.name, _.content = t[_.start].data.slice(0, _.size)) : (_.storage = `minifat`, _.size < 0 ? _.size = 0 : c !== O && _.start !== O && t[c] && (_.content = m(_, t[c].data, (t[s] || {}).data))), _.content && FP(_.content, 0), a[p] = _, o.push(_);
      }
    }
    function y(e, t) {
      return new Date((EP(e, t + 4) / 1e7 * 2 ** 32 + EP(e, t) / 1e7 - 11644473600) * 1e3);
    }
    function b(e, t) {
      return c(), l(s.readFileSync(e), t);
    }
    function x(e, t) {
      var n = t && t.type;
      switch (n || YA && Buffer.isBuffer(e) && (n = `buffer`), n || `base64`) {
        case `file`:
          return b(e, t);
        case `base64`:
          return l($A(JA(e)), t);
        case `binary`:
          return l($A(e), t);
      }
      return l(e, t);
    }
    function S(e, t) {
      var n = t || {},
        r = n.root || `Root Entry`;
      if (e.FullPaths ||= [], e.FileIndex ||= [], e.FullPaths.length !== e.FileIndex.length) throw Error(`inconsistent CFB structure`);
      e.FullPaths.length === 0 && (e.FullPaths[0] = r + `/`, e.FileIndex[0] = {
        name: r,
        type: 5
      }), n.CLSID && (e.FileIndex[0].clsid = n.CLSID), C(e);
    }
    function C(e) {
      var t = `Sh33tJ5`;
      if (!SM.find(e, `/` + t)) {
        var n = Z(4);
        n[0] = 55, n[1] = n[3] = 50, n[2] = 54, e.FileIndex.push({
          name: t,
          type: 2,
          content: n,
          size: 4,
          L: 69,
          R: 69,
          C: 69
        }), e.FullPaths.push(e.FullPaths[0] + t), w(e);
      }
    }
    function w(e, i) {
      S(e);
      for (var a = !1, o = !1, s = e.FullPaths.length - 1; s >= 0; --s) {
        var c = e.FileIndex[s];
        switch (c.type) {
          case 0:
            o ? a = !0 : (e.FileIndex.pop(), e.FullPaths.pop());
            break;
          case 1:
          case 2:
          case 5:
            o = !0, isNaN(c.R * c.L * c.C) && (a = !0), c.R > -1 && c.L > -1 && c.R == c.L && (a = !0);
            break;
          default:
            a = !0;
        }
      }
      if (a || i) {
        var l = new Date(1987, 1, 19),
          u = 0,
          d = Object.create ? Object.create(null) : {},
          f = [];
        for (s = 0; s < e.FullPaths.length; ++s) d[e.FullPaths[s]] = !0, e.FileIndex[s].type !== 0 && f.push([e.FullPaths[s], e.FileIndex[s]]);
        for (s = 0; s < f.length; ++s) {
          var p = n(f[s][0]);
          o = d[p], o || (f.push([p, {
            name: r(p).replace(`/`, ``),
            type: 1,
            clsid: j,
            ct: l,
            mt: l,
            content: null
          }]), d[p] = !0);
        }
        for (f.sort(function (e, n) {
          return t(e[0], n[0]);
        }), e.FullPaths = [], e.FileIndex = [], s = 0; s < f.length; ++s) e.FullPaths[s] = f[s][0], e.FileIndex[s] = f[s][1];
        for (s = 0; s < f.length; ++s) {
          var m = e.FileIndex[s],
            h = e.FullPaths[s];
          if (m.name = r(h).replace(`/`, ``), m.L = m.R = m.C = -(m.color = 1), m.size = m.content ? m.content.length : 0, m.start = 0, m.clsid = m.clsid || j, s === 0) m.C = f.length > 1 ? 1 : -1, m.size = 0, m.type = 5;else if (h.slice(-1) == `/`) {
            for (u = s + 1; u < f.length && n(e.FullPaths[u]) != h; ++u);
            for (m.C = u >= f.length ? -1 : u, u = s + 1; u < f.length && n(e.FullPaths[u]) != n(h); ++u);
            m.R = u >= f.length ? -1 : u, m.type = 1;
          } else n(e.FullPaths[s + 1] || ``) == n(h) && (m.R = s + 1), m.type = 2;
        }
      }
    }
    function T(e, t) {
      var n = t || {};
      if (n.fileType == `mad`) return Ve(e, n);
      if (w(e), n.fileType === `zip`) return Ne(e, n);
      var r = function (e) {
          for (var t = 0, n = 0, r = 0; r < e.FileIndex.length; ++r) {
            var i = e.FileIndex[r];
            if (i.content) {
              var a = i.content.length;
              a > 0 && (a < 4096 ? t += a + 63 >> 6 : n += a + 511 >> 9);
            }
          }
          for (var o = e.FullPaths.length + 3 >> 2, s = t + 7 >> 3, c = t + 127 >> 7, l = s + n + o + c, u = l + 127 >> 7, d = u <= 109 ? 0 : Math.ceil((u - 109) / 127); l + u + d + 127 >> 7 > u;) d = ++u <= 109 ? 0 : Math.ceil((u - 109) / 127);
          var f = [1, d, u, c, o, n, t, 0];
          return e.FileIndex[0].size = t << 6, f[7] = (e.FileIndex[0].start = f[0] + f[1] + f[2] + f[3] + f[4] + f[5]) + (f[6] + 7 >> 3), f;
        }(e),
        i = Z(r[7] << 9),
        a = 0,
        o = 0;
      for (a = 0; a < 8; ++a) i.write_shift(1, A[a]);
      for (a = 0; a < 8; ++a) i.write_shift(2, 0);
      for (i.write_shift(2, 62), i.write_shift(2, 3), i.write_shift(2, 65534), i.write_shift(2, 9), i.write_shift(2, 6), a = 0; a < 3; ++a) i.write_shift(2, 0);
      for (i.write_shift(4, 0), i.write_shift(4, r[2]), i.write_shift(4, r[0] + r[1] + r[2] + r[3] - 1), i.write_shift(4, 0), i.write_shift(4, 4096), i.write_shift(4, r[3] ? r[0] + r[1] + r[2] - 1 : O), i.write_shift(4, r[3]), i.write_shift(-4, r[1] ? r[0] - 1 : O), i.write_shift(4, r[1]), a = 0; a < 109; ++a) i.write_shift(-4, a < r[2] ? r[1] + a : -1);
      if (r[1]) for (o = 0; o < r[1]; ++o) {
        for (; a < 236 + o * 127; ++a) i.write_shift(-4, a < r[2] ? r[1] + a : -1);
        i.write_shift(-4, o === r[1] - 1 ? O : o + 1);
      }
      var s = function (e) {
        for (o += e; a < o - 1; ++a) i.write_shift(-4, a + 1);
        e && (++a, i.write_shift(-4, O));
      };
      for (o = a = 0, o += r[1]; a < o; ++a) i.write_shift(-4, M.DIFSECT);
      for (o += r[2]; a < o; ++a) i.write_shift(-4, M.FATSECT);
      s(r[3]), s(r[4]);
      for (var c = 0, l = 0, u = e.FileIndex[0]; c < e.FileIndex.length; ++c) u = e.FileIndex[c], u.content && (l = u.content.length, !(l < 4096) && (u.start = o, s(l + 511 >> 9)));
      for (s(r[6] + 7 >> 3); i.l & 511;) i.write_shift(-4, M.ENDOFCHAIN);
      for (o = a = 0, c = 0; c < e.FileIndex.length; ++c) u = e.FileIndex[c], u.content && (l = u.content.length, !(!l || l >= 4096) && (u.start = o, s(l + 63 >> 6)));
      for (; i.l & 511;) i.write_shift(-4, M.ENDOFCHAIN);
      for (a = 0; a < r[4] << 2; ++a) {
        var d = e.FullPaths[a];
        if (!d || d.length === 0) {
          for (c = 0; c < 17; ++c) i.write_shift(4, 0);
          for (c = 0; c < 3; ++c) i.write_shift(4, -1);
          for (c = 0; c < 12; ++c) i.write_shift(4, 0);
          continue;
        }
        u = e.FileIndex[a], a === 0 && (u.start = u.size ? u.start - 1 : O);
        var f = a === 0 && n.root || u.name;
        if (l = 2 * (f.length + 1), i.write_shift(64, f, `utf16le`), i.write_shift(2, l), i.write_shift(1, u.type), i.write_shift(1, u.color), i.write_shift(-4, u.L), i.write_shift(-4, u.R), i.write_shift(-4, u.C), u.clsid) i.write_shift(16, u.clsid, `hex`);else for (c = 0; c < 4; ++c) i.write_shift(4, 0);
        i.write_shift(4, u.state || 0), i.write_shift(4, 0), i.write_shift(4, 0), i.write_shift(4, 0), i.write_shift(4, 0), i.write_shift(4, u.start), i.write_shift(4, u.size), i.write_shift(4, 0);
      }
      for (a = 1; a < e.FileIndex.length; ++a) if (u = e.FileIndex[a], u.size >= 4096) {
        if (i.l = u.start + 1 << 9, YA && Buffer.isBuffer(u.content)) u.content.copy(i, i.l, 0, u.size), i.l += u.size + 511 & -512;else {
          for (c = 0; c < u.size; ++c) i.write_shift(1, u.content[c]);
          for (; c & 511; ++c) i.write_shift(1, 0);
        }
      }
      for (a = 1; a < e.FileIndex.length; ++a) if (u = e.FileIndex[a], u.size > 0 && u.size < 4096) {
        if (YA && Buffer.isBuffer(u.content)) u.content.copy(i, i.l, 0, u.size), i.l += u.size + 63 & -64;else {
          for (c = 0; c < u.size; ++c) i.write_shift(1, u.content[c]);
          for (; c & 63; ++c) i.write_shift(1, 0);
        }
      }
      if (YA) i.l = i.length;else for (; i.l < i.length;) i.write_shift(1, 0);
      return i;
    }
    function E(e, t) {
      var n = e.FullPaths.map(function (e) {
          return e.toUpperCase();
        }),
        r = n.map(function (e) {
          var t = e.split(`/`);
          return t[t.length - (e.slice(-1) == `/` ? 2 : 1)];
        }),
        i = !1;
      t.charCodeAt(0) === 47 ? (i = !0, t = n[0].slice(0, -1) + t) : i = t.indexOf(`/`) !== -1;
      var a = t.toUpperCase(),
        o = i === !0 ? n.indexOf(a) : r.indexOf(a);
      if (o !== -1) return e.FileIndex[o];
      var s = !a.match(sj);
      for (a = a.replace(oj, ``), s && (a = a.replace(sj, `!`)), o = 0; o < n.length; ++o) if ((s ? n[o].replace(sj, `!`) : n[o]).replace(oj, ``) == a || (s ? r[o].replace(sj, `!`) : r[o]).replace(oj, ``) == a) return e.FileIndex[o];
      return null;
    }
    var D = 64,
      O = -2,
      k = `d0cf11e0a1b11ae1`,
      A = [208, 207, 17, 224, 161, 177, 26, 225],
      j = `00000000000000000000000000000000`,
      M = {
        MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: O,
        FREESECT: -1,
        HEADER_SIGNATURE: k,
        HEADER_MINOR_VERSION: `3e00`,
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: j,
        EntryTypes: [`unknown`, `storage`, `stream`, `lockbytes`, `property`, `root`]
      };
    function N(e, t, n) {
      c();
      var r = T(e, n);
      s.writeFileSync(t, r);
    }
    function P(e) {
      for (var t = Array(e.length), n = 0; n < e.length; ++n) t[n] = String.fromCharCode(e[n]);
      return t.join(``);
    }
    function F(e, t) {
      var n = T(e, t);
      switch (t && t.type || `buffer`) {
        case `file`:
          return c(), s.writeFileSync(t.filename, n), n;
        case `binary`:
          return typeof n == `string` ? n : P(n);
        case `base64`:
          return qA(typeof n == `string` ? n : P(n));
        case `buffer`:
          if (YA) return Buffer.isBuffer(n) ? n : XA(n);
        case `array`:
          return typeof n == `string` ? $A(n) : n;
      }
      return n;
    }
    var I;
    function L(e) {
      try {
        var t = e.InflateRaw,
          n = new t();
        if (n._processChunk(new Uint8Array([3, 0]), n._finishFlushFlag), n.bytesRead) I = e;else throw Error(`zlib does not expose bytesRead`);
      } catch (e) {
        console.error(`cannot use native zlib: ` + (e.message || e));
      }
    }
    function R(e, t) {
      if (!I) return ke(e, t);
      var n = I.InflateRaw,
        r = new n(),
        i = r._processChunk(e.slice(e.l), r._finishFlushFlag);
      return e.l += r.bytesRead, i;
    }
    function z(e) {
      return I ? I.deflateRawSync(e) : xe(e);
    }
    var ee = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
      te = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258],
      B = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
    function V(e) {
      var t = (e << 1 | e << 11) & 139536 | (e << 5 | e << 15) & 558144;
      return (t >> 16 | t >> 8 | t) & 255;
    }
    for (var H = typeof Uint8Array < `u`, ne = H ? new Uint8Array(256) : [], re = 0; re < 256; ++re) ne[re] = V(re);
    function ie(e, t) {
      var n = ne[e & 255];
      return t <= 8 ? n >>> 8 - t : (n = n << 8 | ne[e >> 8 & 255], t <= 16 ? n >>> 16 - t : (n = n << 8 | ne[e >> 16 & 255], n >>> 24 - t));
    }
    function U(e, t) {
      var n = t & 7,
        r = t >>> 3;
      return (e[r] | (n <= 6 ? 0 : e[r + 1] << 8)) >>> n & 3;
    }
    function ae(e, t) {
      var n = t & 7,
        r = t >>> 3;
      return (e[r] | (n <= 5 ? 0 : e[r + 1] << 8)) >>> n & 7;
    }
    function oe(e, t) {
      var n = t & 7,
        r = t >>> 3;
      return (e[r] | (n <= 4 ? 0 : e[r + 1] << 8)) >>> n & 15;
    }
    function se(e, t) {
      var n = t & 7,
        r = t >>> 3;
      return (e[r] | (n <= 3 ? 0 : e[r + 1] << 8)) >>> n & 31;
    }
    function ce(e, t) {
      var n = t & 7,
        r = t >>> 3;
      return (e[r] | (n <= 1 ? 0 : e[r + 1] << 8)) >>> n & 127;
    }
    function le(e, t, n) {
      var r = t & 7,
        i = t >>> 3,
        a = (1 << n) - 1,
        o = e[i] >>> r;
      return n < 8 - r || (o |= e[i + 1] << 8 - r, n < 16 - r) || (o |= e[i + 2] << 16 - r, n < 24 - r) || (o |= e[i + 3] << 24 - r), o & a;
    }
    function ue(e, t, n) {
      var r = t & 7,
        i = t >>> 3;
      return r <= 5 ? e[i] |= (n & 7) << r : (e[i] |= n << r & 255, e[i + 1] = (n & 7) >> 8 - r), t + 3;
    }
    function de(e, t, n) {
      var r = t & 7,
        i = t >>> 3;
      return n = (n & 1) << r, e[i] |= n, t + 1;
    }
    function fe(e, t, n) {
      var r = t & 7,
        i = t >>> 3;
      return n <<= r, e[i] |= n & 255, n >>>= 8, e[i + 1] = n, t + 8;
    }
    function pe(e, t, n) {
      var r = t & 7,
        i = t >>> 3;
      return n <<= r, e[i] |= n & 255, n >>>= 8, e[i + 1] = n & 255, e[i + 2] = n >>> 8, t + 16;
    }
    function me(e, t) {
      var n = e.length,
        r = 2 * n > t ? 2 * n : t + 5,
        i = 0;
      if (n >= t) return e;
      if (YA) {
        var a = QA(r);
        if (e.copy) e.copy(a);else for (; i < e.length; ++i) a[i] = e[i];
        return a;
      }
      if (H) {
        var o = new Uint8Array(r);
        if (o.set) o.set(e);else for (; i < n; ++i) o[i] = e[i];
        return o;
      }
      return e.length = r, e;
    }
    function he(e) {
      for (var t = Array(e), n = 0; n < e; ++n) t[n] = 0;
      return t;
    }
    function ge(e, t, n) {
      var r = 1,
        i = 0,
        a = 0,
        o = 0,
        s = 0,
        c = e.length,
        l = H ? new Uint16Array(32) : he(32);
      for (a = 0; a < 32; ++a) l[a] = 0;
      for (a = c; a < n; ++a) e[a] = 0;
      c = e.length;
      var u = H ? new Uint16Array(c) : he(c);
      for (a = 0; a < c; ++a) l[i = e[a]]++, r < i && (r = i), u[a] = 0;
      for (l[0] = 0, a = 1; a <= r; ++a) l[a + 16] = s = s + l[a - 1] << 1;
      for (a = 0; a < c; ++a) s = e[a], s != 0 && (u[a] = l[s + 16]++);
      var d = 0;
      for (a = 0; a < c; ++a) if (d = e[a], d != 0) for (s = ie(u[a], r) >> r - d, o = (1 << r + 4 - d) - 1; o >= 0; --o) t[s | o << d] = d & 15 | a << 4;
      return r;
    }
    var _e = H ? new Uint16Array(512) : he(512),
      ve = H ? new Uint16Array(32) : he(32);
    if (!H) {
      for (var ye = 0; ye < 512; ++ye) _e[ye] = 0;
      for (ye = 0; ye < 32; ++ye) ve[ye] = 0;
    }
    (function () {
      for (var e = [], t = 0; t < 32; t++) e.push(5);
      ge(e, ve, 32);
      var n = [];
      for (t = 0; t <= 143; t++) n.push(8);
      for (; t <= 255; t++) n.push(9);
      for (; t <= 279; t++) n.push(7);
      for (; t <= 287; t++) n.push(8);
      ge(n, _e, 288);
    })();
    var be = function () {
      for (var e = H ? new Uint8Array(32768) : [], t = 0, n = 0; t < B.length - 1; ++t) for (; n < B[t + 1]; ++n) e[n] = t;
      for (; n < 32768; ++n) e[n] = 29;
      var r = H ? new Uint8Array(259) : [];
      for (t = 0, n = 0; t < te.length - 1; ++t) for (; n < te[t + 1]; ++n) r[n] = t;
      function i(e, t) {
        for (var n = 0; n < e.length;) {
          var r = Math.min(65535, e.length - n),
            i = n + r == e.length;
          for (t.write_shift(1, +i), t.write_shift(2, r), t.write_shift(2, ~r & 65535); r-- > 0;) t[t.l++] = e[n++];
        }
        return t.l;
      }
      function a(t, n) {
        for (var i = 0, a = 0, o = H ? new Uint16Array(32768) : []; a < t.length;) {
          var s = Math.min(65535, t.length - a);
          if (s < 10) {
            for (i = ue(n, i, +(a + s == t.length)), i & 7 && (i += 8 - (i & 7)), n.l = i / 8 | 0, n.write_shift(2, s), n.write_shift(2, ~s & 65535); s-- > 0;) n[n.l++] = t[a++];
            i = n.l * 8;
            continue;
          }
          i = ue(n, i, +(a + s == t.length) + 2);
          for (var c = 0; s-- > 0;) {
            var l = t[a];
            c = (c << 5 ^ l) & 32767;
            var u = -1,
              d = 0;
            if ((u = o[c]) && (u |= a & -32768, u > a && (u -= 32768), u < a)) for (; t[u + d] == t[a + d] && d < 250;) ++d;
            if (d > 2) {
              l = r[d], l <= 22 ? i = fe(n, i, ne[l + 1] >> 1) - 1 : (fe(n, i, 3), i += 5, fe(n, i, ne[l - 23] >> 5), i += 3);
              var f = l < 8 ? 0 : l - 4 >> 2;
              f > 0 && (pe(n, i, d - te[l]), i += f), l = e[a - u], i = fe(n, i, ne[l] >> 3), i -= 3;
              var p = l < 4 ? 0 : l - 2 >> 1;
              p > 0 && (pe(n, i, a - u - B[l]), i += p);
              for (var m = 0; m < d; ++m) o[c] = a & 32767, c = (c << 5 ^ t[a]) & 32767, ++a;
              s -= d - 1;
            } else l <= 143 ? l += 48 : i = de(n, i, 1), i = fe(n, i, ne[l]), o[c] = a & 32767, ++a;
          }
          i = fe(n, i, 0) - 1;
        }
        return n.l = (i + 7) / 8 | 0, n.l;
      }
      return function (e, t) {
        return e.length < 8 ? i(e, t) : a(e, t);
      };
    }();
    function xe(e) {
      var t = Z(50 + Math.floor(e.length * 1.1)),
        n = be(e, t);
      return t.slice(0, n);
    }
    var Se = H ? new Uint16Array(32768) : he(32768),
      Ce = H ? new Uint16Array(32768) : he(32768),
      we = H ? new Uint16Array(128) : he(128),
      Te = 1,
      Ee = 1;
    function De(e, t) {
      var n = se(e, t) + 257;
      t += 5;
      var r = se(e, t) + 1;
      t += 5;
      var i = oe(e, t) + 4;
      t += 4;
      for (var a = 0, o = H ? new Uint8Array(19) : he(19), s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], c = 1, l = H ? new Uint8Array(8) : he(8), u = H ? new Uint8Array(8) : he(8), d = o.length, f = 0; f < i; ++f) o[ee[f]] = a = ae(e, t), c < a && (c = a), l[a]++, t += 3;
      var p = 0;
      for (l[0] = 0, f = 1; f <= c; ++f) u[f] = p = p + l[f - 1] << 1;
      for (f = 0; f < d; ++f) (p = o[f]) != 0 && (s[f] = u[p]++);
      var m = 0;
      for (f = 0; f < d; ++f) if (m = o[f], m != 0) {
        p = ne[s[f]] >> 8 - m;
        for (var h = (1 << 7 - m) - 1; h >= 0; --h) we[p | h << m] = m & 7 | f << 3;
      }
      var g = [];
      for (c = 1; g.length < n + r;) switch (p = we[ce(e, t)], t += p & 7, p >>>= 3) {
        case 16:
          for (a = 3 + U(e, t), t += 2, p = g[g.length - 1]; a-- > 0;) g.push(p);
          break;
        case 17:
          for (a = 3 + ae(e, t), t += 3; a-- > 0;) g.push(0);
          break;
        case 18:
          for (a = 11 + ce(e, t), t += 7; a-- > 0;) g.push(0);
          break;
        default:
          g.push(p), c < p && (c = p);
      }
      var _ = g.slice(0, n),
        v = g.slice(n);
      for (f = n; f < 286; ++f) _[f] = 0;
      for (f = r; f < 30; ++f) v[f] = 0;
      return Te = ge(_, Se, 286), Ee = ge(v, Ce, 30), t;
    }
    function Oe(e, t) {
      if (e[0] == 3 && !(e[1] & 3)) return [ZA(t), 2];
      for (var n = 0, r = 0, i = QA(t || 1 << 18), a = 0, o = i.length >>> 0, s = 0, c = 0; !(r & 1);) {
        if (r = ae(e, n), n += 3, r >>> 1) r >> 1 == 1 ? (s = 9, c = 5) : (n = De(e, n), s = Te, c = Ee);else {
          n & 7 && (n += 8 - (n & 7));
          var l = e[n >>> 3] | e[(n >>> 3) + 1] << 8;
          if (n += 32, l > 0) for (!t && o < a + l && (i = me(i, a + l), o = i.length); l-- > 0;) i[a++] = e[n >>> 3], n += 8;
          continue;
        }
        for (;;) {
          !t && o < a + 32767 && (i = me(i, a + 32767), o = i.length);
          var u = le(e, n, s),
            d = r >>> 1 == 1 ? _e[u] : Se[u];
          if (n += d & 15, d >>>= 4, !(d >>> 8 & 255)) i[a++] = d;else if (d == 256) break;else {
            d -= 257;
            var f = d < 8 ? 0 : d - 4 >> 2;
            f > 5 && (f = 0);
            var p = a + te[d];
            f > 0 && (p += le(e, n, f), n += f), u = le(e, n, c), d = r >>> 1 == 1 ? ve[u] : Ce[u], n += d & 15, d >>>= 4;
            var m = d < 4 ? 0 : d - 2 >> 1,
              h = B[d];
            for (m > 0 && (h += le(e, n, m), n += m), !t && o < p && (i = me(i, p + 100), o = i.length); a < p;) i[a] = i[a - h], ++a;
          }
        }
      }
      return t ? [i, n + 7 >>> 3] : [i.slice(0, a), n + 7 >>> 3];
    }
    function ke(e, t) {
      var n = Oe(e.slice(e.l || 0), t);
      return e.l += n[1], n[0];
    }
    function Ae(e, t) {
      if (e) typeof console < `u` && console.error(t);else throw Error(t);
    }
    function je(e, t) {
      var n = e;
      FP(n, 0);
      var r = {
        FileIndex: [],
        FullPaths: []
      };
      S(r, {
        root: t.root
      });
      for (var i = n.length - 4; (n[i] != 80 || n[i + 1] != 75 || n[i + 2] != 5 || n[i + 3] != 6) && i >= 0;) --i;
      n.l = i + 4, n.l += 4;
      var a = n.read_shift(2);
      for (n.l += 6, n.l = n.read_shift(4), i = 0; i < a; ++i) {
        n.l += 20;
        var s = n.read_shift(4),
          c = n.read_shift(4),
          l = n.read_shift(2),
          u = n.read_shift(2),
          d = n.read_shift(2);
        n.l += 8;
        var f = n.read_shift(4),
          p = o(n.slice(n.l + l, n.l + l + u));
        n.l += l + u + d;
        var m = n.l;
        n.l = f + 4, Me(n, s, c, r, p), n.l = m;
      }
      return r;
    }
    function Me(e, t, n, r, i) {
      e.l += 2;
      var s = e.read_shift(2),
        c = e.read_shift(2),
        l = a(e);
      if (s & 8257) throw Error(`Unsupported ZIP encryption`);
      for (var u = e.read_shift(4), d = e.read_shift(4), f = e.read_shift(4), p = e.read_shift(2), m = e.read_shift(2), h = ``, g = 0; g < p; ++g) h += String.fromCharCode(e[e.l++]);
      if (m) {
        var _ = o(e.slice(e.l, e.l + m));
        (_[21589] || {}).mt && (l = _[21589].mt), ((i || {})[21589] || {}).mt && (l = i[21589].mt);
      }
      e.l += m;
      var v = e.slice(e.l, e.l + d);
      switch (c) {
        case 8:
          v = R(e, f);
          break;
        case 0:
          break;
        default:
          throw Error(`Unsupported ZIP Compression method ` + c);
      }
      var y = !1;
      s & 8 && (u = e.read_shift(4), u == 134695760 && (u = e.read_shift(4), y = !0), d = e.read_shift(4), f = e.read_shift(4)), d != t && Ae(y, `Bad compressed size: ` + t + ` != ` + d), f != n && Ae(y, `Bad uncompressed size: ` + n + ` != ` + f), Ue(r, h, v, {
        unsafe: !0,
        mt: l
      });
    }
    function Ne(e, t) {
      var n = t || {},
        r = [],
        a = [],
        o = Z(1),
        s = n.compression ? 8 : 0,
        c = 0,
        l = 0,
        u = 0,
        d = 0,
        f = 0,
        p = e.FullPaths[0],
        m = p,
        h = e.FileIndex[0],
        g = [],
        _ = 0;
      for (l = 1; l < e.FullPaths.length; ++l) if (m = e.FullPaths[l].slice(p.length), h = e.FileIndex[l], h.size && h.content && m != `Sh33tJ5`) {
        var v = d,
          y = Z(m.length);
        for (u = 0; u < m.length; ++u) y.write_shift(1, m.charCodeAt(u) & 127);
        y = y.slice(0, y.l), g[f] = xM.buf(h.content, 0);
        var b = h.content;
        s == 8 && (b = z(b)), o = Z(30), o.write_shift(4, 67324752), o.write_shift(2, 20), o.write_shift(2, c), o.write_shift(2, s), h.mt ? i(o, h.mt) : o.write_shift(4, 0), o.write_shift(-4, c & 8 ? 0 : g[f]), o.write_shift(4, c & 8 ? 0 : b.length), o.write_shift(4, c & 8 ? 0 : h.content.length), o.write_shift(2, y.length), o.write_shift(2, 0), d += o.length, r.push(o), d += y.length, r.push(y), d += b.length, r.push(b), c & 8 && (o = Z(12), o.write_shift(-4, g[f]), o.write_shift(4, b.length), o.write_shift(4, h.content.length), d += o.l, r.push(o)), o = Z(46), o.write_shift(4, 33639248), o.write_shift(2, 0), o.write_shift(2, 20), o.write_shift(2, c), o.write_shift(2, s), o.write_shift(4, 0), o.write_shift(-4, g[f]), o.write_shift(4, b.length), o.write_shift(4, h.content.length), o.write_shift(2, y.length), o.write_shift(2, 0), o.write_shift(2, 0), o.write_shift(2, 0), o.write_shift(2, 0), o.write_shift(4, 0), o.write_shift(4, v), _ += o.l, a.push(o), _ += y.length, a.push(y), ++f;
      }
      return o = Z(22), o.write_shift(4, 101010256), o.write_shift(2, 0), o.write_shift(2, 0), o.write_shift(2, f), o.write_shift(2, f), o.write_shift(4, _), o.write_shift(4, d), o.write_shift(2, 0), ij([ij(r), ij(a), o]);
    }
    var Pe = {
      htm: `text/html`,
      xml: `text/xml`,
      gif: `image/gif`,
      jpg: `image/jpeg`,
      png: `image/png`,
      mso: `application/x-mso`,
      thmx: `application/vnd.ms-officetheme`,
      sh33tj5: `application/octet-stream`
    };
    function Fe(e, t) {
      if (e.ctype) return e.ctype;
      var n = e.name || ``,
        r = n.match(/\.([^\.]+)$/);
      return r && Pe[r[1]] || t && (r = (n = t).match(/[\.\\]([^\.\\])+$/), r && Pe[r[1]]) ? Pe[r[1]] : `application/octet-stream`;
    }
    function Ie(e) {
      for (var t = qA(e), n = [], r = 0; r < t.length; r += 76) n.push(t.slice(r, r + 76));
      return n.join(`\r
`) + `\r
`;
    }
    function Le(e) {
      var t = e.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function (e) {
        var t = e.charCodeAt(0).toString(16).toUpperCase();
        return `=` + (t.length == 1 ? `0` + t : t);
      });
      t = t.replace(/ $/gm, `=20`).replace(/\t$/gm, `=09`), t.charAt(0) == `
` && (t = `=0D` + t.slice(1)), t = t.replace(/\r(?!\n)/gm, `=0D`).replace(/\n\n/gm, `
=0A`).replace(/([^\r\n])\n/gm, `$1=0A`);
      for (var n = [], r = t.split(`\r
`), i = 0; i < r.length; ++i) {
        var a = r[i];
        if (a.length == 0) {
          n.push(``);
          continue;
        }
        for (var o = 0; o < a.length;) {
          var s = 76,
            c = a.slice(o, o + s);
          c.charAt(s - 1) == `=` ? s-- : c.charAt(s - 2) == `=` ? s -= 2 : c.charAt(s - 3) == `=` && (s -= 3), c = a.slice(o, o + s), o += s, o < a.length && (c += `=`), n.push(c);
        }
      }
      return n.join(`\r
`);
    }
    function Re(e) {
      for (var t = [], n = 0; n < e.length; ++n) {
        for (var r = e[n]; n <= e.length && r.charAt(r.length - 1) == `=`;) r = r.slice(0, r.length - 1) + e[++n];
        t.push(r);
      }
      for (var i = 0; i < t.length; ++i) t[i] = t[i].replace(/[=][0-9A-Fa-f]{2}/g, function (e) {
        return String.fromCharCode(parseInt(e.slice(1), 16));
      });
      return $A(t.join(`\r
`));
    }
    function ze(e, t, n) {
      for (var r = ``, i = ``, a = ``, o, s = 0; s < 10; ++s) {
        var c = t[s];
        if (!c || c.match(/^\s*$/)) break;
        var l = c.match(/^(.*?):\s*([^\s].*)$/);
        if (l) switch (l[1].toLowerCase()) {
          case `content-location`:
            r = l[2].trim();
            break;
          case `content-type`:
            a = l[2].trim();
            break;
          case `content-transfer-encoding`:
            i = l[2].trim();
        }
      }
      switch (++s, i.toLowerCase()) {
        case `base64`:
          o = $A(JA(t.slice(s).join(``)));
          break;
        case `quoted-printable`:
          o = Re(t.slice(s));
          break;
        default:
          throw Error(`Unsupported Content-Transfer-Encoding ` + i);
      }
      var u = Ue(e, r.slice(n.length), o, {
        unsafe: !0
      });
      a && (u.ctype = a);
    }
    function Be(e, t) {
      if (P(e.slice(0, 13)).toLowerCase() != `mime-version:`) throw Error(`Unsupported MAD header`);
      var n = t && t.root || ``,
        r = (YA && Buffer.isBuffer(e) ? e.toString(`binary`) : P(e)).split(`\r
`),
        i = 0,
        a = ``;
      for (i = 0; i < r.length; ++i) if (a = r[i], /^Content-Location:/i.test(a) && (a = a.slice(a.indexOf(`file`)), n ||= a.slice(0, a.lastIndexOf(`/`) + 1), a.slice(0, n.length) != n)) for (; n.length > 0 && (n = n.slice(0, n.length - 1), n = n.slice(0, n.lastIndexOf(`/`) + 1), a.slice(0, n.length) != n););
      var o = (r[1] || ``).match(/boundary="(.*?)"/);
      if (!o) throw Error(`MAD cannot find boundary`);
      var s = `--` + (o[1] || ``),
        c = {
          FileIndex: [],
          FullPaths: []
        };
      S(c);
      var l,
        u = 0;
      for (i = 0; i < r.length; ++i) {
        var d = r[i];
        (d === s || d === s + `--`) && (u++ && ze(c, r.slice(l, i), n), l = i);
      }
      return c;
    }
    function Ve(e, t) {
      var n = t || {},
        r = n.boundary || `SheetJS`;
      r = `------=` + r;
      for (var i = [`MIME-Version: 1.0`, `Content-Type: multipart/related; boundary="` + r.slice(2) + `"`, ``, ``, ``], a = e.FullPaths[0], o = a, s = e.FileIndex[0], c = 1; c < e.FullPaths.length; ++c) if (o = e.FullPaths[c].slice(a.length), s = e.FileIndex[c], s.size && s.content && o != `Sh33tJ5`) {
        o = o.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function (e) {
          return `_x` + e.charCodeAt(0).toString(16) + `_`;
        }).replace(/[\u0080-\uFFFF]/g, function (e) {
          return `_u` + e.charCodeAt(0).toString(16) + `_`;
        });
        for (var l = s.content, u = YA && Buffer.isBuffer(l) ? l.toString(`binary`) : P(l), d = 0, f = Math.min(1024, u.length), p = 0, m = 0; m <= f; ++m) (p = u.charCodeAt(m)) >= 32 && p < 128 && ++d;
        var h = d >= f * 4 / 5;
        i.push(r), i.push(`Content-Location: ` + (n.root || `file:///C:/SheetJS/`) + o), i.push(`Content-Transfer-Encoding: ` + (h ? `quoted-printable` : `base64`)), i.push(`Content-Type: ` + Fe(s, o)), i.push(``), i.push(h ? Le(u) : Ie(u));
      }
      return i.push(r + `--\r
`), i.join(`\r
`);
    }
    function He(e) {
      var t = {};
      return S(t, e), t;
    }
    function Ue(e, t, n, i) {
      var a = i && i.unsafe;
      a || S(e);
      var o = !a && SM.find(e, t);
      if (!o) {
        var s = e.FullPaths[0];
        t.slice(0, s.length) == s ? s = t : (s.slice(-1) != `/` && (s += `/`), s = (s + t).replace(`//`, `/`)), o = {
          name: r(t),
          type: 2
        }, e.FileIndex.push(o), e.FullPaths.push(s), a || SM.utils.cfb_gc(e);
      }
      return o.content = n, o.size = n ? n.length : 0, i && (i.CLSID && (o.clsid = i.CLSID), i.mt && (o.mt = i.mt), i.ct && (o.ct = i.ct)), o;
    }
    function We(e, t) {
      S(e);
      var n = SM.find(e, t);
      if (n) {
        for (var r = 0; r < e.FileIndex.length; ++r) if (e.FileIndex[r] == n) return e.FileIndex.splice(r, 1), e.FullPaths.splice(r, 1), !0;
      }
      return !1;
    }
    function Ge(e, t, n) {
      S(e);
      var i = SM.find(e, t);
      if (i) {
        for (var a = 0; a < e.FileIndex.length; ++a) if (e.FileIndex[a] == i) return e.FileIndex[a].name = r(n), e.FullPaths[a] = n, !0;
      }
      return !1;
    }
    function Ke(e) {
      w(e, !0);
    }
    return e.find = E, e.read = x, e.parse = l, e.write = F, e.writeFile = N, e.utils = {
      cfb_new: He,
      cfb_add: Ue,
      cfb_del: We,
      cfb_mov: Ge,
      cfb_gc: Ke,
      ReadShift: kP,
      CheckField: PP,
      prep_blob: FP,
      bconcat: ij,
      use_zlib: L,
      _deflateRaw: xe,
      _inflateRaw: ke,
      consts: M
    }, e;
  }(),
  CM = void 0;
function wM(e) {
  CM = e;
}
function TM(e) {
  return typeof e == `string` ? ej(e) : Array.isArray(e) ? nj(e) : e;
}
function EM(e, t, n) {
  if (CM !== void 0 && CM.writeFileSync) return n ? CM.writeFileSync(e, t, n) : CM.writeFileSync(e, t);
  if (typeof Deno < `u`) {
    if (n && typeof t == `string`) switch (n) {
      case `utf8`:
        t = new TextEncoder(n).encode(t);
        break;
      case `binary`:
        t = ej(t);
        break;
      default:
        throw Error(`Unsupported encoding ` + n);
    }
    return Deno.writeFileSync(e, t);
  }
  var r = n == `utf8` ? IN(t) : t;
  if (typeof IE_SaveFile < `u`) return IE_SaveFile(r, e);
  if (typeof Blob < `u`) {
    var i = new Blob([TM(r)], {
      type: `application/octet-stream`
    });
    if (typeof navigator < `u` && navigator.msSaveBlob) return navigator.msSaveBlob(i, e);
    if (typeof saveAs < `u`) return saveAs(i, e);
    if (typeof URL < `u` && typeof document < `u` && document.createElement && URL.createObjectURL) {
      var a = URL.createObjectURL(i);
      if (typeof chrome == `object` && typeof (chrome.downloads || {}).download == `function`) return URL.revokeObjectURL && typeof setTimeout < `u` && setTimeout(function () {
        URL.revokeObjectURL(a);
      }, 6e4), chrome.downloads.download({
        url: a,
        filename: e,
        saveAs: !0
      });
      var o = document.createElement(`a`);
      if (o.download != null) return o.download = e, o.href = a, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL && typeof setTimeout < `u` && setTimeout(function () {
        URL.revokeObjectURL(a);
      }, 6e4), a;
    }
  }
  if (typeof $ < `u` && typeof File < `u` && typeof Folder < `u`) try {
    var s = File(e);
    return s.open(`w`), s.encoding = `binary`, Array.isArray(t) && (t = tj(t)), s.write(t), s.close(), t;
  } catch (e) {
    if (!e.message || !e.message.match(/onstruct/)) throw e;
  }
  throw Error(`cannot save file ` + e);
}
function DM(e) {
  if (CM !== void 0) return CM.readFileSync(e);
  if (typeof Deno < `u`) return Deno.readFileSync(e);
  if (typeof $ < `u` && typeof File < `u` && typeof Folder < `u`) try {
    var t = File(e);
    t.open(`r`), t.encoding = `binary`;
    var n = t.read();
    return t.close(), n;
  } catch (e) {
    if (!e.message || !e.message.match(/onstruct/)) throw e;
  }
  throw Error(`Cannot access file ` + e);
}
function OM(e) {
  for (var t = Object.keys(e), n = [], r = 0; r < t.length; ++r) Object.prototype.hasOwnProperty.call(e, t[r]) && n.push(t[r]);
  return n;
}
function kM(e, t) {
  for (var n = [], r = OM(e), i = 0; i !== r.length; ++i) n[e[r[i]][t]] ?? (n[e[r[i]][t]] = r[i]);
  return n;
}
function AM(e) {
  for (var t = [], n = OM(e), r = 0; r !== n.length; ++r) t[e[n[r]]] = n[r];
  return t;
}
function jM(e) {
  for (var t = [], n = OM(e), r = 0; r !== n.length; ++r) t[e[n[r]]] = parseInt(n[r], 10);
  return t;
}
function MM(e) {
  for (var t = [], n = OM(e), r = 0; r !== n.length; ++r) t[e[n[r]]] ?? (t[e[n[r]]] = []), t[e[n[r]]].push(n[r]);
  return t;
}
var NM = new Date(1899, 11, 30, 0, 0, 0);
function PM(e, t) {
  var n = e.getTime();
  t && (n -= 1263168e5);
  var r = NM.getTime() + (e.getTimezoneOffset() - NM.getTimezoneOffset()) * 6e4;
  return (n - r) / 864e5;
}
var FM = new Date(),
  IM = NM.getTime() + (FM.getTimezoneOffset() - NM.getTimezoneOffset()) * 6e4,
  LM = FM.getTimezoneOffset();
function RM(e) {
  var t = new Date();
  return t.setTime(e * 24 * 60 * 60 * 1e3 + IM), t.getTimezoneOffset() !== LM && t.setTime(t.getTime() + (t.getTimezoneOffset() - LM) * 6e4), t;
}
function zM(e) {
  var t = 0,
    n = 0,
    r = !1,
    i = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!i) throw Error(`|` + e + `| is not an ISO8601 Duration`);
  for (var a = 1; a != i.length; ++a) if (i[a]) {
    switch (n = 1, a > 3 && (r = !0), i[a].slice(i[a].length - 1)) {
      case `Y`:
        throw Error(`Unsupported ISO Duration Field: ` + i[a].slice(i[a].length - 1));
      case `D`:
        n *= 24;
      case `H`:
        n *= 60;
      case `M`:
        if (r) n *= 60;else throw Error(`Unsupported ISO Duration Field: M`);
    }
    t += n * parseInt(i[a], 10);
  }
  return t;
}
var BM = new Date(`2017-02-19T19:06:09.000Z`),
  VM = isNaN(BM.getFullYear()) ? new Date(`2/19/17`) : BM,
  HM = VM.getFullYear() == 2017;
function UM(e, t) {
  var n = new Date(e);
  if (HM) return t > 0 ? n.setTime(n.getTime() + n.getTimezoneOffset() * 60 * 1e3) : t < 0 && n.setTime(n.getTime() - n.getTimezoneOffset() * 60 * 1e3), n;
  if (e instanceof Date) return e;
  if (VM.getFullYear() == 1917 && !isNaN(n.getFullYear())) {
    var r = n.getFullYear();
    return e.indexOf(`` + r) > -1 || n.setFullYear(n.getFullYear() + 100), n;
  }
  var i = e.match(/\d+/g) || [`2017`, `2`, `19`, `0`, `0`, `0`],
    a = new Date(+i[0], i[1] - 1, +i[2], +i[3] || 0, +i[4] || 0, +i[5] || 0);
  return e.indexOf(`Z`) > -1 && (a = new Date(a.getTime() - a.getTimezoneOffset() * 60 * 1e3)), a;
}
function WM(e, t) {
  if (YA && Buffer.isBuffer(e)) {
    if (t) {
      if (e[0] == 255 && e[1] == 254) return IN(e.slice(2).toString(`utf16le`));
      if (e[1] == 254 && e[2] == 255) return IN(RA(e.slice(2).toString(`binary`)));
    }
    return e.toString(`binary`);
  }
  if (typeof TextDecoder < `u`) try {
    if (t) {
      if (e[0] == 255 && e[1] == 254) return IN(new TextDecoder(`utf-16le`).decode(e.slice(2)));
      if (e[0] == 254 && e[1] == 255) return IN(new TextDecoder(`utf-16be`).decode(e.slice(2)));
    }
    var n = {
      "€": ``,
      "‚": ``,
      ƒ: ``,
      "„": ``,
      "…": ``,
      "†": ``,
      "‡": ``,
      ˆ: ``,
      "‰": ``,
      Š: ``,
      "‹": ``,
      Œ: ``,
      Ž: ``,
      "‘": ``,
      "’": ``,
      "“": ``,
      "”": ``,
      "•": ``,
      "–": ``,
      "—": ``,
      "˜": ``,
      "™": ``,
      š: ``,
      "›": ``,
      œ: ``,
      ž: ``,
      Ÿ: ``
    };
    return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder(`latin1`).decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function (e) {
      return n[e] || e;
    });
  } catch {}
  for (var r = [], i = 0; i != e.length; ++i) r.push(String.fromCharCode(e[i]));
  return r.join(``);
}
function GM(e) {
  if (typeof JSON < `u` && !Array.isArray(e)) return JSON.parse(JSON.stringify(e));
  if (typeof e != `object` || !e) return e;
  if (e instanceof Date) return new Date(e.getTime());
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = GM(e[n]));
  return t;
}
function KM(e, t) {
  for (var n = ``; n.length < t;) n += e;
  return n;
}
function qM(e) {
  var t = Number(e);
  if (!isNaN(t)) return isFinite(t) ? t : NaN;
  if (!/\d/.test(e)) return t;
  var n = 1,
    r = e.replace(/([\d]),([\d])/g, `$1$2`).replace(/[$]/g, ``).replace(/[%]/g, function () {
      return n *= 100, ``;
    });
  return !isNaN(t = Number(r)) || (r = r.replace(/[(](.*)[)]/, function (e, t) {
    return n = -n, t;
  }), !isNaN(t = Number(r))) ? t / n : t;
}
var JM = [`january`, `february`, `march`, `april`, `may`, `june`, `july`, `august`, `september`, `october`, `november`, `december`];
function YM(e) {
  var t = new Date(e),
    n = new Date(NaN),
    r = t.getYear(),
    i = t.getMonth(),
    a = t.getDate();
  if (isNaN(a)) return n;
  var o = e.toLowerCase();
  if (o.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (o = o.replace(/[^a-z]/g, ``).replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ``), o.length > 3 && JM.indexOf(o) == -1) return n;
  } else if (o.match(/[a-z]/)) return n;
  return r < 0 || r > 8099 ? n : (i > 0 || a > 1) && r != 101 ? t : e.match(/[^-0-9:,\/\\]/) ? n : t;
}
var XM = function () {
  var e = `abacaba`.split(/(:?b)/i).length == 5;
  return function (t, n, r) {
    if (e || typeof n == `string`) return t.split(n);
    for (var i = t.split(n), a = [i[0]], o = 1; o < i.length; ++o) a.push(r), a.push(i[o]);
    return a;
  };
}();
function ZM(e) {
  return e ? e.content && e.type ? WM(e.content, !0) : e.data ? zA(e.data) : e.asNodeBuffer && YA ? zA(e.asNodeBuffer().toString(`binary`)) : e.asBinary ? zA(e.asBinary()) : e._data && e._data.getContent ? zA(WM(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
}
function QM(e) {
  if (!e) return null;
  if (e.data) return IA(e.data);
  if (e.asNodeBuffer && YA) return e.asNodeBuffer();
  if (e._data && e._data.getContent) {
    var t = e._data.getContent();
    return typeof t == `string` ? IA(t) : Array.prototype.slice.call(t);
  }
  return e.content && e.type ? e.content : null;
}
function $M(e) {
  return e && e.name.slice(-4) === `.bin` ? QM(e) : ZM(e);
}
function eN(e, t) {
  for (var n = e.FullPaths || OM(e.files), r = t.toLowerCase().replace(/[\/]/g, `\\`), i = r.replace(/\\/g, `/`), a = 0; a < n.length; ++a) {
    var o = n[a].replace(/^Root Entry[\/]/, ``).toLowerCase();
    if (r == o || i == o) return e.files ? e.files[n[a]] : e.FileIndex[a];
  }
  return null;
}
function tN(e, t) {
  var n = eN(e, t);
  if (n == null) throw Error(`Cannot find file ` + t + ` in zip`);
  return n;
}
function nN(e, t, n) {
  if (!n) return $M(tN(e, t));
  if (!t) return null;
  try {
    return nN(e, t);
  } catch {
    return null;
  }
}
function rN(e, t, n) {
  if (!n) return ZM(tN(e, t));
  if (!t) return null;
  try {
    return rN(e, t);
  } catch {
    return null;
  }
}
function iN(e, t, n) {
  if (!n) return QM(tN(e, t));
  if (!t) return null;
  try {
    return iN(e, t);
  } catch {
    return null;
  }
}
function aN(e) {
  for (var t = e.FullPaths || OM(e.files), n = [], r = 0; r < t.length; ++r) t[r].slice(-1) != `/` && n.push(t[r].replace(/^Root Entry[\/]/, ``));
  return n.sort();
}
function oN(e, t, n) {
  if (e.FullPaths) {
    if (typeof n == `string`) {
      var r = YA ? XA(n) : aj(n);
      return SM.utils.cfb_add(e, t, r);
    }
    SM.utils.cfb_add(e, t, n);
  } else e.file(t, n);
}
function sN() {
  return SM.utils.cfb_new();
}
function cN(e, t) {
  switch (t.type) {
    case `base64`:
      return SM.read(e, {
        type: `base64`
      });
    case `binary`:
      return SM.read(e, {
        type: `binary`
      });
    case `buffer`:
    case `array`:
      return SM.read(e, {
        type: `buffer`
      });
  }
  throw Error(`Unrecognized type ` + t.type);
}
function lN(e, t) {
  if (e.charAt(0) == `/`) return e.slice(1);
  var n = t.split(`/`);
  t.slice(-1) != `/` && n.pop();
  for (var r = e.split(`/`); r.length !== 0;) {
    var i = r.shift();
    i === `..` ? n.pop() : i !== `.` && n.push(i);
  }
  return n.join(`/`);
}
var uN = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`,
  dN = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g,
  fN = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm,
  pN = uN.match(fN) ? fN : /<[^>]*>/g,
  mN = /<\w*:/,
  hN = /<(\/?)\w+:/;
function gN(e, t, n) {
  for (var r = {}, i = 0, a = 0; i !== e.length && (a = e.charCodeAt(i)) !== 32 && a !== 10 && a !== 13; ++i);
  if (t || (r[0] = e.slice(0, i)), i === e.length) return r;
  var o = e.match(dN),
    s = 0,
    c = ``,
    l = 0,
    u = ``,
    d = ``,
    f = 1;
  if (o) for (l = 0; l != o.length; ++l) {
    for (d = o[l], a = 0; a != d.length && d.charCodeAt(a) !== 61; ++a);
    for (u = d.slice(0, a).trim(); d.charCodeAt(a + 1) == 32;) ++a;
    for (f = +((i = d.charCodeAt(a + 1)) == 34 || i == 39), c = d.slice(a + 1 + f, d.length - f), s = 0; s != u.length && u.charCodeAt(s) !== 58; ++s);
    if (s === u.length) u.indexOf(`_`) > 0 && (u = u.slice(0, u.indexOf(`_`))), r[u] = c, n || (r[u.toLowerCase()] = c);else {
      var p = (s === 5 && u.slice(0, 5) === `xmlns` ? `xmlns` : ``) + u.slice(s + 1);
      if (r[p] && u.slice(s - 3, s) == `ext`) continue;
      r[p] = c, n || (r[p.toLowerCase()] = c);
    }
  }
  return r;
}
function _N(e) {
  return e.replace(hN, `<$1`);
}
var vN = {
    "&quot;": `"`,
    "&apos;": `'`,
    "&gt;": `>`,
    "&lt;": `<`,
    "&amp;": `&`
  },
  yN = AM(vN),
  bN = function () {
    var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi,
      t = /_x([\da-fA-F]{4})_/gi;
    return function n(r) {
      var i = r + ``,
        a = i.indexOf(`<![CDATA[`);
      if (a == -1) return i.replace(e, function (e, t) {
        return vN[e] || String.fromCharCode(parseInt(t, e.indexOf(`x`) > -1 ? 16 : 10)) || e;
      }).replace(t, function (e, t) {
        return String.fromCharCode(parseInt(t, 16));
      });
      var o = i.indexOf(`]]>`);
      return n(i.slice(0, a)) + i.slice(a + 9, o) + n(i.slice(o + 3));
    };
  }(),
  xN = /[&<>'"]/g,
  SN = /[\u0000-\u0008\u000b-\u001f]/g;
function CN(e) {
  return (e + ``).replace(xN, function (e) {
    return yN[e];
  }).replace(SN, function (e) {
    return `_x` + (`000` + e.charCodeAt(0).toString(16)).slice(-4) + `_`;
  });
}
function wN(e) {
  return CN(e).replace(/ /g, `_x0020_`);
}
var TN = /[\u0000-\u001f]/g;
function EN(e) {
  return (e + ``).replace(xN, function (e) {
    return yN[e];
  }).replace(/\n/g, `<br/>`).replace(TN, function (e) {
    return `&#x` + (`000` + e.charCodeAt(0).toString(16)).slice(-4) + `;`;
  });
}
function DN(e) {
  return (e + ``).replace(xN, function (e) {
    return yN[e];
  }).replace(TN, function (e) {
    return `&#x` + e.charCodeAt(0).toString(16).toUpperCase() + `;`;
  });
}
var ON = function () {
  var e = /&#(\d+);/g;
  function t(e, t) {
    return String.fromCharCode(parseInt(t, 10));
  }
  return function (n) {
    return n.replace(e, t);
  };
}();
function kN(e) {
  return e.replace(/(\r\n|[\r\n])/g, `&#10;`);
}
function AN(e) {
  switch (e) {
    case 1:
    case !0:
    case `1`:
    case `true`:
    case `TRUE`:
      return !0;
    default:
      return !1;
  }
}
function jN(e) {
  for (var t = ``, n = 0, r = 0, i = 0, a = 0, o = 0, s = 0; n < e.length;) {
    if (r = e.charCodeAt(n++), r < 128) {
      t += String.fromCharCode(r);
      continue;
    }
    if (i = e.charCodeAt(n++), r > 191 && r < 224) {
      o = (r & 31) << 6, o |= i & 63, t += String.fromCharCode(o);
      continue;
    }
    if (a = e.charCodeAt(n++), r < 240) {
      t += String.fromCharCode((r & 15) << 12 | (i & 63) << 6 | a & 63);
      continue;
    }
    o = e.charCodeAt(n++), s = ((r & 7) << 18 | (i & 63) << 12 | (a & 63) << 6 | o & 63) - 65536, t += String.fromCharCode(55296 + (s >>> 10 & 1023)), t += String.fromCharCode(56320 + (s & 1023));
  }
  return t;
}
function MN(e) {
  var t = ZA(2 * e.length),
    n,
    r,
    i = 1,
    a = 0,
    o = 0,
    s;
  for (r = 0; r < e.length; r += i) i = 1, (s = e.charCodeAt(r)) < 128 ? n = s : s < 224 ? (n = (s & 31) * 64 + (e.charCodeAt(r + 1) & 63), i = 2) : s < 240 ? (n = (s & 15) * 4096 + (e.charCodeAt(r + 1) & 63) * 64 + (e.charCodeAt(r + 2) & 63), i = 3) : (i = 4, n = (s & 7) * 262144 + (e.charCodeAt(r + 1) & 63) * 4096 + (e.charCodeAt(r + 2) & 63) * 64 + (e.charCodeAt(r + 3) & 63), n -= 65536, o = 55296 + (n >>> 10 & 1023), n = 56320 + (n & 1023)), o !== 0 && (t[a++] = o & 255, t[a++] = o >>> 8, o = 0), t[a++] = n % 256, t[a++] = n >>> 8;
  return t.slice(0, a).toString(`ucs2`);
}
function NN(e) {
  return XA(e, `binary`).toString(`utf8`);
}
var PN = `foo bar bazâð£`,
  FN = YA && (NN(PN) == jN(PN) && NN || MN(PN) == jN(PN) && MN) || jN,
  IN = YA ? function (e) {
    return XA(e, `utf8`).toString(`binary`);
  } : function (e) {
    for (var t = [], n = 0, r = 0, i = 0; n < e.length;) switch (r = e.charCodeAt(n++), !0) {
      case r < 128:
        t.push(String.fromCharCode(r));
        break;
      case r < 2048:
        t.push(String.fromCharCode(192 + (r >> 6))), t.push(String.fromCharCode(128 + (r & 63)));
        break;
      case r >= 55296 && r < 57344:
        r -= 55296, i = e.charCodeAt(n++) - 56320 + (r << 10), t.push(String.fromCharCode(240 + (i >> 18 & 7))), t.push(String.fromCharCode(144 + (i >> 12 & 63))), t.push(String.fromCharCode(128 + (i >> 6 & 63))), t.push(String.fromCharCode(128 + (i & 63)));
        break;
      default:
        t.push(String.fromCharCode(224 + (r >> 12))), t.push(String.fromCharCode(128 + (r >> 6 & 63))), t.push(String.fromCharCode(128 + (r & 63)));
    }
    return t.join(``);
  },
  LN = function () {
    var e = {};
    return function (t, n) {
      var r = t + `|` + (n || ``);
      return e[r] ? e[r] : e[r] = RegExp(`<(?:\\w+:)?` + t + `(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?` + t + `>`, n || ``);
    };
  }(),
  RN = function () {
    var e = [[`nbsp`, ` `], [`middot`, `·`], [`quot`, `"`], [`apos`, `'`], [`gt`, `>`], [`lt`, `<`], [`amp`, `&`]].map(function (e) {
      return [RegExp(`&` + e[0] + `;`, `ig`), e[1]];
    });
    return function (t) {
      for (var n = t.replace(/^[\t\n\r ]+/, ``).replace(/[\t\n\r ]+$/, ``).replace(/>\s+/g, `>`).replace(/\s+</g, `<`).replace(/[\t\n\r ]+/g, ` `).replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ``), r = 0; r < e.length; ++r) n = n.replace(e[r][0], e[r][1]);
      return n;
    };
  }(),
  zN = function () {
    var e = {};
    return function (t) {
      return e[t] === void 0 ? e[t] = RegExp(`<(?:vt:)?` + t + `>([\\s\\S]*?)</(?:vt:)?` + t + `>`, `g`) : e[t];
    };
  }(),
  BN = /<\/?(?:vt:)?variant>/g,
  VN = /<(?:vt:)([^>]*)>([\s\S]*)</;
function HN(e, t) {
  var n = gN(e),
    r = e.match(zN(n.baseType)) || [],
    i = [];
  if (r.length != n.size) {
    if (t.WTF) throw Error(`unexpected vector length ` + r.length + ` != ` + n.size);
    return i;
  }
  return r.forEach(function (e) {
    var t = e.replace(BN, ``).match(VN);
    t && i.push({
      v: FN(t[2]),
      t: t[1]
    });
  }), i;
}
var UN = /(^\s|\s$|\n)/;
function WN(e, t) {
  return `<` + e + (t.match(UN) ? ` xml:space="preserve"` : ``) + `>` + t + `</` + e + `>`;
}
function GN(e) {
  return OM(e).map(function (t) {
    return ` ` + t + `="` + e[t] + `"`;
  }).join(``);
}
function X(e, t, n) {
  return `<` + e + (n == null ? `` : GN(n)) + (t == null ? `/` : (t.match(UN) ? ` xml:space="preserve"` : ``) + `>` + t + `</` + e) + `>`;
}
function KN(e, t) {
  try {
    return e.toISOString().replace(/\.\d*/, ``);
  } catch (e) {
    if (t) throw e;
  }
  return ``;
}
function qN(e, t) {
  switch (typeof e) {
    case `string`:
      var n = X(`vt:lpwstr`, CN(e));
      return t && (n = n.replace(/&quot;/g, `_x0022_`)), n;
    case `number`:
      return X((e | 0) == e ? `vt:i4` : `vt:r8`, CN(String(e)));
    case `boolean`:
      return X(`vt:bool`, e ? `true` : `false`);
  }
  if (e instanceof Date) return X(`vt:filetime`, KN(e));
  throw Error(`Unable to serialize ` + e);
}
function JN(e) {
  if (YA && Buffer.isBuffer(e)) return e.toString(`utf8`);
  if (typeof e == `string`) return e;
  if (typeof Uint8Array < `u` && e instanceof Uint8Array) return FN(tj(rj(e)));
  throw Error(`Bad input format: expected Buffer or string`);
}
var YN = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/gm,
  XN = {
    CORE_PROPS: `http://schemas.openxmlformats.org/package/2006/metadata/core-properties`,
    CUST_PROPS: `http://schemas.openxmlformats.org/officeDocument/2006/custom-properties`,
    EXT_PROPS: `http://schemas.openxmlformats.org/officeDocument/2006/extended-properties`,
    CT: `http://schemas.openxmlformats.org/package/2006/content-types`,
    RELS: `http://schemas.openxmlformats.org/package/2006/relationships`,
    TCMNT: `http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments`,
    dc: `http://purl.org/dc/elements/1.1/`,
    dcterms: `http://purl.org/dc/terms/`,
    dcmitype: `http://purl.org/dc/dcmitype/`,
    mx: `http://schemas.microsoft.com/office/mac/excel/2008/main`,
    r: `http://schemas.openxmlformats.org/officeDocument/2006/relationships`,
    sjs: `http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties`,
    vt: `http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes`,
    xsi: `http://www.w3.org/2001/XMLSchema-instance`,
    xsd: `http://www.w3.org/2001/XMLSchema`
  },
  ZN = [`http://schemas.openxmlformats.org/spreadsheetml/2006/main`, `http://purl.oclc.org/ooxml/spreadsheetml/main`, `http://schemas.microsoft.com/office/excel/2006/main`, `http://schemas.microsoft.com/office/excel/2006/2`],
  QN = {
    o: `urn:schemas-microsoft-com:office:office`,
    x: `urn:schemas-microsoft-com:office:excel`,
    ss: `urn:schemas-microsoft-com:office:spreadsheet`,
    dt: `uuid:C2F41010-65B3-11d1-A29F-00AA00C14882`,
    mv: `http://macVmlSchemaUri`,
    v: `urn:schemas-microsoft-com:vml`,
    html: `http://www.w3.org/TR/REC-html40`
  };
function $N(e, t) {
  for (var n = 1 - 2 * (e[t + 7] >>> 7), r = ((e[t + 7] & 127) << 4) + (e[t + 6] >>> 4 & 15), i = e[t + 6] & 15, a = 5; a >= 0; --a) i = i * 256 + e[t + a];
  return r == 2047 ? i == 0 ? n * (1 / 0) : NaN : (r == 0 ? r = -1022 : (r -= 1023, i += 2 ** 52), n * 2 ** (r - 52) * i);
}
function eP(e, t, n) {
  var r = (t < 0 || 1 / t == -1 / 0) << 7,
    i = 0,
    a = 0,
    o = r ? -t : t;
  isFinite(o) ? o == 0 ? i = a = 0 : (i = Math.floor(Math.log(o) / Math.LN2), a = o * 2 ** (52 - i), i <= -1023 && (!isFinite(a) || a < 2 ** 52) ? i = -1022 : (a -= 2 ** 52, i += 1023)) : (i = 2047, a = isNaN(t) ? 26985 : 0);
  for (var s = 0; s <= 5; ++s, a /= 256) e[n + s] = a & 255;
  e[n + 6] = (i & 15) << 4 | a & 15, e[n + 7] = i >> 4 | r;
}
var tP = function (e) {
    for (var t = [], n = 10240, r = 0; r < e[0].length; ++r) if (e[0][r]) for (var i = 0, a = e[0][r].length; i < a; i += n) t.push.apply(t, e[0][r].slice(i, i + n));
    return t;
  },
  nP = YA ? function (e) {
    return e[0].length > 0 && Buffer.isBuffer(e[0][0]) ? Buffer.concat(e[0].map(function (e) {
      return Buffer.isBuffer(e) ? e : XA(e);
    })) : tP(e);
  } : tP,
  rP = function (e, t, n) {
    for (var r = [], i = t; i < n; i += 2) r.push(String.fromCharCode(wP(e, i)));
    return r.join(``).replace(oj, ``);
  },
  iP = YA ? function (e, t, n) {
    return Buffer.isBuffer(e) ? e.toString(`utf16le`, t, n).replace(oj, ``) : rP(e, t, n);
  } : rP,
  aP = function (e, t, n) {
    for (var r = [], i = t; i < t + n; ++i) r.push((`0` + e[i].toString(16)).slice(-2));
    return r.join(``);
  },
  oP = YA ? function (e, t, n) {
    return Buffer.isBuffer(e) ? e.toString(`hex`, t, t + n) : aP(e, t, n);
  } : aP,
  sP = function (e, t, n) {
    for (var r = [], i = t; i < n; i++) r.push(String.fromCharCode(CP(e, i)));
    return r.join(``);
  },
  cP = YA ? function (e, t, n) {
    return Buffer.isBuffer(e) ? e.toString(`utf8`, t, n) : sP(e, t, n);
  } : sP,
  lP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? cP(e, t + 4, t + 4 + n - 1) : ``;
  },
  uP = lP,
  dP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? cP(e, t + 4, t + 4 + n - 1) : ``;
  },
  fP = dP,
  pP = function (e, t) {
    var n = 2 * EP(e, t);
    return n > 0 ? cP(e, t + 4, t + 4 + n - 1) : ``;
  },
  mP = pP,
  hP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? iP(e, t + 4, t + 4 + n) : ``;
  },
  gP = hP,
  _P = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? cP(e, t + 4, t + 4 + n) : ``;
  },
  vP = _P,
  yP = function (e, t) {
    return $N(e, t);
  },
  bP = yP,
  xP = function (e) {
    return Array.isArray(e) || typeof Uint8Array < `u` && e instanceof Uint8Array;
  };
YA && (uP = function (e, t) {
  if (!Buffer.isBuffer(e)) return lP(e, t);
  var n = e.readUInt32LE(t);
  return n > 0 ? e.toString(`utf8`, t + 4, t + 4 + n - 1) : ``;
}, fP = function (e, t) {
  if (!Buffer.isBuffer(e)) return dP(e, t);
  var n = e.readUInt32LE(t);
  return n > 0 ? e.toString(`utf8`, t + 4, t + 4 + n - 1) : ``;
}, mP = function (e, t) {
  if (!Buffer.isBuffer(e)) return pP(e, t);
  var n = 2 * e.readUInt32LE(t);
  return e.toString(`utf16le`, t + 4, t + 4 + n - 1);
}, gP = function (e, t) {
  if (!Buffer.isBuffer(e)) return hP(e, t);
  var n = e.readUInt32LE(t);
  return e.toString(`utf16le`, t + 4, t + 4 + n);
}, vP = function (e, t) {
  if (!Buffer.isBuffer(e)) return _P(e, t);
  var n = e.readUInt32LE(t);
  return e.toString(`utf8`, t + 4, t + 4 + n);
}, bP = function (e, t) {
  return Buffer.isBuffer(e) ? e.readDoubleLE(t) : yP(e, t);
}, xP = function (e) {
  return Buffer.isBuffer(e) || Array.isArray(e) || typeof Uint8Array < `u` && e instanceof Uint8Array;
});
function SP() {
  iP = function (e, t, n) {
    return HA.utils.decode(1200, e.slice(t, n)).replace(oj, ``);
  }, cP = function (e, t, n) {
    return HA.utils.decode(65001, e.slice(t, n));
  }, uP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? HA.utils.decode(kA, e.slice(t + 4, t + 4 + n - 1)) : ``;
  }, fP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? HA.utils.decode(OA, e.slice(t + 4, t + 4 + n - 1)) : ``;
  }, mP = function (e, t) {
    var n = 2 * EP(e, t);
    return n > 0 ? HA.utils.decode(1200, e.slice(t + 4, t + 4 + n - 1)) : ``;
  }, gP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? HA.utils.decode(1200, e.slice(t + 4, t + 4 + n)) : ``;
  }, vP = function (e, t) {
    var n = EP(e, t);
    return n > 0 ? HA.utils.decode(65001, e.slice(t + 4, t + 4 + n)) : ``;
  };
}
HA !== void 0 && SP();
var CP = function (e, t) {
    return e[t];
  },
  wP = function (e, t) {
    return e[t + 1] * 256 + e[t];
  },
  TP = function (e, t) {
    var n = e[t + 1] * 256 + e[t];
    return n < 32768 ? n : (65535 - n + 1) * -1;
  },
  EP = function (e, t) {
    return e[t + 3] * (1 << 24) + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
  },
  DP = function (e, t) {
    return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
  },
  OP = function (e, t) {
    return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
  };
function kP(e, t) {
  var n = ``,
    r,
    i,
    a = [],
    o,
    s,
    c,
    l;
  switch (t) {
    case `dbcs`:
      if (l = this.l, YA && Buffer.isBuffer(this)) n = this.slice(this.l, this.l + 2 * e).toString(`utf16le`);else for (c = 0; c < e; ++c) n += String.fromCharCode(wP(this, l)), l += 2;
      e *= 2;
      break;
    case `utf8`:
      n = cP(this, this.l, this.l + e);
      break;
    case `utf16le`:
      e *= 2, n = iP(this, this.l, this.l + e);
      break;
    case `wstr`:
      if (HA !== void 0) n = HA.utils.decode(OA, this.slice(this.l, this.l + 2 * e));else return kP.call(this, e, `dbcs`);
      e = 2 * e;
      break;
    case `lpstr-ansi`:
      n = uP(this, this.l), e = 4 + EP(this, this.l);
      break;
    case `lpstr-cp`:
      n = fP(this, this.l), e = 4 + EP(this, this.l);
      break;
    case `lpwstr`:
      n = mP(this, this.l), e = 4 + 2 * EP(this, this.l);
      break;
    case `lpp4`:
      e = 4 + EP(this, this.l), n = gP(this, this.l), e & 2 && (e += 2);
      break;
    case `8lpp4`:
      e = 4 + EP(this, this.l), n = vP(this, this.l), e & 3 && (e += 4 - (e & 3));
      break;
    case `cstr`:
      for (e = 0, n = ``; (o = CP(this, this.l + e++)) !== 0;) a.push(BA(o));
      n = a.join(``);
      break;
    case `_wstr`:
      for (e = 0, n = ``; (o = wP(this, this.l + e)) !== 0;) a.push(BA(o)), e += 2;
      e += 2, n = a.join(``);
      break;
    case `dbcs-cont`:
      for (n = ``, l = this.l, c = 0; c < e; ++c) {
        if (this.lens && this.lens.indexOf(l) !== -1) return o = CP(this, l), this.l = l + 1, s = kP.call(this, e - c, o ? `dbcs-cont` : `sbcs-cont`), a.join(``) + s;
        a.push(BA(wP(this, l))), l += 2;
      }
      n = a.join(``), e *= 2;
      break;
    case `cpstr`:
      if (HA !== void 0) {
        n = HA.utils.decode(OA, this.slice(this.l, this.l + e));
        break;
      }
    case `sbcs-cont`:
      for (n = ``, l = this.l, c = 0; c != e; ++c) {
        if (this.lens && this.lens.indexOf(l) !== -1) return o = CP(this, l), this.l = l + 1, s = kP.call(this, e - c, o ? `dbcs-cont` : `sbcs-cont`), a.join(``) + s;
        a.push(BA(CP(this, l))), l += 1;
      }
      n = a.join(``);
      break;
    default:
      switch (e) {
        case 1:
          return r = CP(this, this.l), this.l++, r;
        case 2:
          return r = (t === `i` ? TP : wP)(this, this.l), this.l += 2, r;
        case 4:
        case -4:
          return t === `i` || !(this[this.l + 3] & 128) ? (r = (e > 0 ? DP : OP)(this, this.l), this.l += 4, r) : (i = EP(this, this.l), this.l += 4, i);
        case 8:
        case -8:
          if (t === `f`) return i = e == 8 ? bP(this, this.l) : bP([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, i;
          e = 8;
        case 16:
          n = oP(this, this.l, e);
      }
  }
  return this.l += e, n;
}
var AP = function (e, t, n) {
    e[n] = t & 255, e[n + 1] = t >>> 8 & 255, e[n + 2] = t >>> 16 & 255, e[n + 3] = t >>> 24 & 255;
  },
  jP = function (e, t, n) {
    e[n] = t & 255, e[n + 1] = t >> 8 & 255, e[n + 2] = t >> 16 & 255, e[n + 3] = t >> 24 & 255;
  },
  MP = function (e, t, n) {
    e[n] = t & 255, e[n + 1] = t >>> 8 & 255;
  };
function NP(e, t, n) {
  var r = 0,
    i = 0;
  if (n === `dbcs`) {
    for (i = 0; i != t.length; ++i) MP(this, t.charCodeAt(i), this.l + 2 * i);
    r = 2 * t.length;
  } else if (n === `sbcs`) {
    if (HA !== void 0 && kA == 874) for (i = 0; i != t.length; ++i) {
      var a = HA.utils.encode(kA, t.charAt(i));
      this[this.l + i] = a[0];
    } else for (t = t.replace(/[^\x00-\x7F]/g, `_`), i = 0; i != t.length; ++i) this[this.l + i] = t.charCodeAt(i) & 255;
    r = t.length;
  } else if (n === `hex`) {
    for (; i < e; ++i) this[this.l++] = parseInt(t.slice(2 * i, 2 * i + 2), 16) || 0;
    return this;
  } else if (n === `utf16le`) {
    var o = Math.min(this.l + e, this.length);
    for (i = 0; i < Math.min(t.length, e); ++i) {
      var s = t.charCodeAt(i);
      this[this.l++] = s & 255, this[this.l++] = s >> 8;
    }
    for (; this.l < o;) this[this.l++] = 0;
    return this;
  } else switch (e) {
    case 1:
      r = 1, this[this.l] = t & 255;
      break;
    case 2:
      r = 2, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255;
      break;
    case 3:
      r = 3, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255, t >>>= 8, this[this.l + 2] = t & 255;
      break;
    case 4:
      r = 4, AP(this, t, this.l);
      break;
    case 8:
      if (r = 8, n === `f`) {
        eP(this, t, this.l);
        break;
      }
    case 16:
      break;
    case -4:
      r = 4, jP(this, t, this.l);
  }
  return this.l += r, this;
}
function PP(e, t) {
  var n = oP(this, this.l, e.length >> 1);
  if (n !== e) throw Error(t + `Expected ` + e + ` saw ` + n);
  this.l += e.length >> 1;
}
function FP(e, t) {
  e.l = t, e.read_shift = kP, e.chk = PP, e.write_shift = NP;
}
function IP(e, t) {
  e.l += t;
}
function Z(e) {
  var t = ZA(e);
  return FP(t, 0), t;
}
function LP(e, t, n) {
  if (e) {
    var r, i, a;
    FP(e, e.l || 0);
    for (var o = e.length, s = 0, c = 0; e.l < o;) {
      s = e.read_shift(1), s & 128 && (s = (s & 127) + ((e.read_shift(1) & 127) << 7));
      var l = EJ[s] || EJ[65535];
      for (r = e.read_shift(1), a = r & 127, i = 1; i < 4 && r & 128; ++i) a += ((r = e.read_shift(1)) & 127) << 7 * i;
      c = e.l + a;
      var u = l.f && l.f(e, a, n);
      if (e.l = c, t(u, l, s)) return;
    }
  }
}
function RP() {
  var e = [],
    t = YA ? 256 : 2048,
    n = function (e) {
      var t = Z(e);
      return FP(t, 0), t;
    },
    r = n(t),
    i = function () {
      r &&= (r.length > r.l && (r = r.slice(0, r.l), r.l = r.length), r.length > 0 && e.push(r), null);
    },
    a = function (e) {
      return r && e < r.length - r.l ? r : (i(), r = n(Math.max(e + 1, t)));
    };
  return {
    next: a,
    push: function (e) {
      i(), r = e, r.l ?? (r.l = r.length), a(t);
    },
    end: function () {
      return i(), ij(e);
    },
    _bufs: e
  };
}
function Q(e, t, n, r) {
  var i = +t,
    a;
  if (!isNaN(i)) {
    r ||= EJ[i].p || (n || []).length || 0, a = 1 + +(i >= 128) + 1, r >= 128 && ++a, r >= 16384 && ++a, r >= 2097152 && ++a;
    var o = e.next(a);
    i <= 127 ? o.write_shift(1, i) : (o.write_shift(1, (i & 127) + 128), o.write_shift(1, i >> 7));
    for (var s = 0; s != 4; ++s) if (r >= 128) o.write_shift(1, (r & 127) + 128), r >>= 7;else {
      o.write_shift(1, r);
      break;
    }
    r > 0 && xP(n) && e.push(n);
  }
}
function zP(e, t, n) {
  var r = GM(e);
  if (t.s ? (r.cRel && (r.c += t.s.c), r.rRel && (r.r += t.s.r)) : (r.cRel && (r.c += t.c), r.rRel && (r.r += t.r)), !n || n.biff < 12) {
    for (; r.c >= 256;) r.c -= 256;
    for (; r.r >= 65536;) r.r -= 65536;
  }
  return r;
}
function BP(e, t, n) {
  var r = GM(e);
  return r.s = zP(r.s, t.s, n), r.e = zP(r.e, t.s, n), r;
}
function VP(e, t) {
  if (e.cRel && e.c < 0) for (e = GM(e); e.c < 0;) e.c += t > 8 ? 16384 : 256;
  if (e.rRel && e.r < 0) for (e = GM(e); e.r < 0;) e.r += t > 8 ? 1048576 : t > 5 ? 65536 : 16384;
  var n = $P(e);
  return !e.cRel && e.cRel != null && (n = YP(n)), !e.rRel && e.rRel != null && (n = GP(n)), n;
}
function HP(e, t) {
  return e.s.r == 0 && !e.s.rRel && e.e.r == (t.biff >= 12 ? 1048575 : t.biff >= 8 ? 65536 : 16384) && !e.e.rRel ? (e.s.cRel ? `` : `$`) + JP(e.s.c) + `:` + (e.e.cRel ? `` : `$`) + JP(e.e.c) : e.s.c == 0 && !e.s.cRel && e.e.c == (t.biff >= 12 ? 16383 : 255) && !e.e.cRel ? (e.s.rRel ? `` : `$`) + WP(e.s.r) + `:` + (e.e.rRel ? `` : `$`) + WP(e.e.r) : VP(e.s, t.biff) + `:` + VP(e.e, t.biff);
}
function UP(e) {
  return parseInt(KP(e), 10) - 1;
}
function WP(e) {
  return `` + (e + 1);
}
function GP(e) {
  return e.replace(/([A-Z]|^)(\d+)$/, `$1$$$2`);
}
function KP(e) {
  return e.replace(/\$(\d+)$/, `$1`);
}
function qP(e) {
  for (var t = XP(e), n = 0, r = 0; r !== t.length; ++r) n = 26 * n + t.charCodeAt(r) - 64;
  return n - 1;
}
function JP(e) {
  if (e < 0) throw Error(`invalid column ` + e);
  var t = ``;
  for (++e; e; e = Math.floor((e - 1) / 26)) t = String.fromCharCode((e - 1) % 26 + 65) + t;
  return t;
}
function YP(e) {
  return e.replace(/^([A-Z])/, `$$$1`);
}
function XP(e) {
  return e.replace(/^\$([A-Z])/, `$1`);
}
function ZP(e) {
  return e.replace(/(\$?[A-Z]*)(\$?\d*)/, `$1,$2`).split(`,`);
}
function QP(e) {
  for (var t = 0, n = 0, r = 0; r < e.length; ++r) {
    var i = e.charCodeAt(r);
    i >= 48 && i <= 57 ? t = 10 * t + (i - 48) : i >= 65 && i <= 90 && (n = 26 * n + (i - 64));
  }
  return {
    c: n - 1,
    r: t - 1
  };
}
function $P(e) {
  for (var t = e.c + 1, n = ``; t; t = (t - 1) / 26 | 0) n = String.fromCharCode((t - 1) % 26 + 65) + n;
  return n + (e.r + 1);
}
function eF(e) {
  var t = e.indexOf(`:`);
  return t == -1 ? {
    s: QP(e),
    e: QP(e)
  } : {
    s: QP(e.slice(0, t)),
    e: QP(e.slice(t + 1))
  };
}
function tF(e, t) {
  return t === void 0 || typeof t == `number` ? tF(e.s, e.e) : (typeof e != `string` && (e = $P(e)), typeof t != `string` && (t = $P(t)), e == t ? e : e + `:` + t);
}
function nF(e) {
  var t = {
      s: {
        c: 0,
        r: 0
      },
      e: {
        c: 0,
        r: 0
      }
    },
    n = 0,
    r = 0,
    i = 0,
    a = e.length;
  for (n = 0; r < a && !((i = e.charCodeAt(r) - 64) < 1 || i > 26); ++r) n = 26 * n + i;
  for (t.s.c = --n, n = 0; r < a && !((i = e.charCodeAt(r) - 48) < 0 || i > 9); ++r) n = 10 * n + i;
  if (t.s.r = --n, r === a || i != 10) return t.e.c = t.s.c, t.e.r = t.s.r, t;
  for (++r, n = 0; r != a && !((i = e.charCodeAt(r) - 64) < 1 || i > 26); ++r) n = 26 * n + i;
  for (t.e.c = --n, n = 0; r != a && !((i = e.charCodeAt(r) - 48) < 0 || i > 9); ++r) n = 10 * n + i;
  return t.e.r = --n, t;
}
function rF(e, t) {
  var n = e.t == `d` && t instanceof Date;
  if (e.z != null) try {
    return e.w = fM(e.z, n ? PM(t) : t);
  } catch {}
  try {
    return e.w = fM((e.XF || {}).numFmtId || (n ? 14 : 0), n ? PM(t) : t);
  } catch {
    return `` + t;
  }
}
function iF(e, t, n) {
  return e == null || e.t == null || e.t == `z` ? `` : e.w === void 0 ? (e.t == `d` && !e.z && n && n.dateNF && (e.z = n.dateNF), e.t == `e` ? lI[e.v] || e.v : t == null ? rF(e, e.v) : rF(e, t)) : e.w;
}
function aF(e, t) {
  var n = t && t.sheet ? t.sheet : `Sheet1`,
    r = {};
  return r[n] = e, {
    SheetNames: [n],
    Sheets: r
  };
}
function oF(e, t, n) {
  var r = n || {},
    i = e ? Array.isArray(e) : r.dense;
  WA != null && i == null && (i = WA);
  var a = e || (i ? [] : {}),
    o = 0,
    s = 0;
  if (a && r.origin != null) {
    if (typeof r.origin == `number`) o = r.origin;else {
      var c = typeof r.origin == `string` ? QP(r.origin) : r.origin;
      o = c.r, s = c.c;
    }
    a[`!ref`] ||= `A1:A1`;
  }
  var l = {
    s: {
      c: 1e7,
      r: 1e7
    },
    e: {
      c: 0,
      r: 0
    }
  };
  if (a[`!ref`]) {
    var u = nF(a[`!ref`]);
    l.s.c = u.s.c, l.s.r = u.s.r, l.e.c = Math.max(l.e.c, u.e.c), l.e.r = Math.max(l.e.r, u.e.r), o == -1 && (l.e.r = o = u.e.r + 1);
  }
  for (var d = 0; d != t.length; ++d) if (t[d]) {
    if (!Array.isArray(t[d])) throw Error(`aoa_to_sheet expects an array of arrays`);
    for (var f = 0; f != t[d].length; ++f) if (t[d][f] !== void 0) {
      var p = {
          v: t[d][f]
        },
        m = o + d,
        h = s + f;
      if (l.s.r > m && (l.s.r = m), l.s.c > h && (l.s.c = h), l.e.r < m && (l.e.r = m), l.e.c < h && (l.e.c = h), t[d][f] && typeof t[d][f] == `object` && !Array.isArray(t[d][f]) && !(t[d][f] instanceof Date)) p = t[d][f];else if (Array.isArray(p.v) && (p.f = t[d][f][1], p.v = p.v[0]), p.v === null) {
        if (p.f) p.t = `n`;else if (r.nullError) p.t = `e`, p.v = 0;else if (r.sheetStubs) p.t = `z`;else continue;
      } else typeof p.v == `number` ? p.t = `n` : typeof p.v == `boolean` ? p.t = `b` : p.v instanceof Date ? (p.z = r.dateNF || bj[14], r.cellDates ? (p.t = `d`, p.w = fM(p.z, PM(p.v))) : (p.t = `n`, p.v = PM(p.v), p.w = fM(p.z, p.v))) : p.t = `s`;
      if (i) a[m] || (a[m] = []), a[m][h] && a[m][h].z && (p.z = a[m][h].z), a[m][h] = p;else {
        var g = $P({
          c: h,
          r: m
        });
        a[g] && a[g].z && (p.z = a[g].z), a[g] = p;
      }
    }
  }
  return l.s.c < 1e7 && (a[`!ref`] = tF(l)), a;
}
function sF(e, t) {
  return oF(null, e, t);
}
function cF(e) {
  return e.read_shift(4, `i`);
}
function lF(e, t) {
  return t ||= Z(4), t.write_shift(4, e), t;
}
function uF(e) {
  var t = e.read_shift(4);
  return t === 0 ? `` : e.read_shift(t, `dbcs`);
}
function dF(e, t) {
  var n = !1;
  return t ??= (n = !0, Z(4 + 2 * e.length)), t.write_shift(4, e.length), e.length > 0 && t.write_shift(0, e, `dbcs`), n ? t.slice(0, t.l) : t;
}
function fF(e) {
  return {
    ich: e.read_shift(2),
    ifnt: e.read_shift(2)
  };
}
function pF(e, t) {
  return t ||= Z(4), t.write_shift(2, e.ich || 0), t.write_shift(2, e.ifnt || 0), t;
}
function mF(e, t) {
  var n = e.l,
    r = e.read_shift(1),
    i = uF(e),
    a = [],
    o = {
      t: i,
      h: i
    };
  if (r & 1) {
    for (var s = e.read_shift(4), c = 0; c != s; ++c) a.push(fF(e));
    o.r = a;
  } else o.r = [{
    ich: 0,
    ifnt: 0
  }];
  return e.l = n + t, o;
}
function hF(e, t) {
  var n = !1;
  return t ??= (n = !0, Z(15 + 4 * e.t.length)), t.write_shift(1, 0), dF(e.t, t), n ? t.slice(0, t.l) : t;
}
var gF = mF;
function _F(e, t) {
  var n = !1;
  return t ??= (n = !0, Z(23 + 4 * e.t.length)), t.write_shift(1, 1), dF(e.t, t), t.write_shift(4, 1), pF({
    ich: 0,
    ifnt: 0
  }, t), n ? t.slice(0, t.l) : t;
}
function vF(e) {
  var t = e.read_shift(4),
    n = e.read_shift(2);
  return n += e.read_shift(1) << 16, e.l++, {
    c: t,
    iStyleRef: n
  };
}
function yF(e, t) {
  return t ??= Z(8), t.write_shift(-4, e.c), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
}
function bF(e) {
  var t = e.read_shift(2);
  return t += e.read_shift(1) << 16, e.l++, {
    c: -1,
    iStyleRef: t
  };
}
function xF(e, t) {
  return t ??= Z(4), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
}
var SF = uF,
  CF = dF;
function wF(e) {
  var t = e.read_shift(4);
  return t === 0 || t === 4294967295 ? `` : e.read_shift(t, `dbcs`);
}
function TF(e, t) {
  var n = !1;
  return t ??= (n = !0, Z(127)), t.write_shift(4, e.length > 0 ? e.length : 4294967295), e.length > 0 && t.write_shift(0, e, `dbcs`), n ? t.slice(0, t.l) : t;
}
var EF = uF,
  DF = wF,
  OF = TF;
function kF(e) {
  var t = e.slice(e.l, e.l + 4),
    n = t[0] & 1,
    r = t[0] & 2;
  e.l += 4;
  var i = r === 0 ? bP([0, 0, 0, 0, t[0] & 252, t[1], t[2], t[3]], 0) : DP(t, 0) >> 2;
  return n ? i / 100 : i;
}
function AF(e, t) {
  t ??= Z(4);
  var n = 0,
    r = 0,
    i = e * 100;
  if (e == (e | 0) && e >= -536870912 && e < 1 << 29 ? r = 1 : i == (i | 0) && i >= -536870912 && i < 1 << 29 && (r = 1, n = 1), r) t.write_shift(-4, ((n ? i : e) << 2) + (n + 2));else throw Error(`unsupported RkNumber ` + e);
}
function jF(e) {
  var t = {
    s: {},
    e: {}
  };
  return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
}
function MF(e, t) {
  return t ||= Z(16), t.write_shift(4, e.s.r), t.write_shift(4, e.e.r), t.write_shift(4, e.s.c), t.write_shift(4, e.e.c), t;
}
var NF = jF,
  PF = MF;
function FF(e) {
  if (e.length - e.l < 8) throw `XLS Xnum Buffer underflow`;
  return e.read_shift(8, `f`);
}
function IF(e, t) {
  return (t || Z(8)).write_shift(8, e, `f`);
}
function LF(e) {
  var t = {},
    n = e.read_shift(1) >>> 1,
    r = e.read_shift(1),
    i = e.read_shift(2, `i`),
    a = e.read_shift(1),
    o = e.read_shift(1),
    s = e.read_shift(1);
  switch (e.l++, n) {
    case 0:
      t.auto = 1;
      break;
    case 1:
      t.index = r;
      var c = cI[r];
      c && (t.rgb = FB(c));
      break;
    case 2:
      t.rgb = FB([a, o, s]);
      break;
    case 3:
      t.theme = r;
  }
  return i != 0 && (t.tint = i > 0 ? i / 32767 : i / 32768), t;
}
function RF(e, t) {
  if (t ||= Z(8), !e || e.auto) return t.write_shift(4, 0), t.write_shift(4, 0), t;
  e.index == null ? e.theme == null ? (t.write_shift(1, 5), t.write_shift(1, 0)) : (t.write_shift(1, 6), t.write_shift(1, e.theme)) : (t.write_shift(1, 2), t.write_shift(1, e.index));
  var n = e.tint || 0;
  if (n > 0 ? n *= 32767 : n < 0 && (n *= 32768), t.write_shift(2, n), !e.rgb || e.theme != null) t.write_shift(2, 0), t.write_shift(1, 0), t.write_shift(1, 0);else {
    var r = e.rgb || `FFFFFF`;
    typeof r == `number` && (r = (`000000` + r.toString(16)).slice(-6)), t.write_shift(1, parseInt(r.slice(0, 2), 16)), t.write_shift(1, parseInt(r.slice(2, 4), 16)), t.write_shift(1, parseInt(r.slice(4, 6), 16)), t.write_shift(1, 255);
  }
  return t;
}
function zF(e) {
  var t = e.read_shift(1);
  return e.l++, {
    fBold: t & 1,
    fItalic: t & 2,
    fUnderline: t & 4,
    fStrikeout: t & 8,
    fOutline: t & 16,
    fShadow: t & 32,
    fCondense: t & 64,
    fExtend: t & 128
  };
}
function BF(e, t) {
  t ||= Z(2);
  var n = (e.italic ? 2 : 0) | (e.strike ? 8 : 0) | (e.outline ? 16 : 0) | (e.shadow ? 32 : 0) | (e.condense ? 64 : 0) | (e.extend ? 128 : 0);
  return t.write_shift(1, n), t.write_shift(1, 0), t;
}
function VF(e, t) {
  var n = {
      2: `BITMAP`,
      3: `METAFILEPICT`,
      8: `DIB`,
      14: `ENHMETAFILE`
    },
    r = e.read_shift(4);
  switch (r) {
    case 0:
      return ``;
    case 4294967295:
    case 4294967294:
      return n[e.read_shift(4)] || ``;
  }
  if (r > 400) throw Error(`Unsupported Clipboard: ` + r.toString(16));
  return e.l -= 4, e.read_shift(0, t == 1 ? `lpstr` : `lpwstr`);
}
function HF(e) {
  return VF(e, 1);
}
function UF(e) {
  return VF(e, 2);
}
var WF = 2,
  GF = 3,
  KF = 11,
  qF = 12,
  JF = 19,
  YF = 64,
  XF = 65,
  ZF = 71,
  QF = 4108,
  $F = 4126,
  eI = 80,
  tI = 81,
  nI = [eI, tI],
  rI = {
    1: {
      n: `CodePage`,
      t: WF
    },
    2: {
      n: `Category`,
      t: eI
    },
    3: {
      n: `PresentationFormat`,
      t: eI
    },
    4: {
      n: `ByteCount`,
      t: GF
    },
    5: {
      n: `LineCount`,
      t: GF
    },
    6: {
      n: `ParagraphCount`,
      t: GF
    },
    7: {
      n: `SlideCount`,
      t: GF
    },
    8: {
      n: `NoteCount`,
      t: GF
    },
    9: {
      n: `HiddenCount`,
      t: GF
    },
    10: {
      n: `MultimediaClipCount`,
      t: GF
    },
    11: {
      n: `ScaleCrop`,
      t: KF
    },
    12: {
      n: `HeadingPairs`,
      t: QF
    },
    13: {
      n: `TitlesOfParts`,
      t: $F
    },
    14: {
      n: `Manager`,
      t: eI
    },
    15: {
      n: `Company`,
      t: eI
    },
    16: {
      n: `LinksUpToDate`,
      t: KF
    },
    17: {
      n: `CharacterCount`,
      t: GF
    },
    19: {
      n: `SharedDoc`,
      t: KF
    },
    22: {
      n: `HyperlinksChanged`,
      t: KF
    },
    23: {
      n: `AppVersion`,
      t: GF,
      p: `version`
    },
    24: {
      n: `DigSig`,
      t: XF
    },
    26: {
      n: `ContentType`,
      t: eI
    },
    27: {
      n: `ContentStatus`,
      t: eI
    },
    28: {
      n: `Language`,
      t: eI
    },
    29: {
      n: `Version`,
      t: eI
    },
    255: {},
    2147483648: {
      n: `Locale`,
      t: JF
    },
    2147483651: {
      n: `Behavior`,
      t: JF
    },
    1919054434: {}
  },
  iI = {
    1: {
      n: `CodePage`,
      t: WF
    },
    2: {
      n: `Title`,
      t: eI
    },
    3: {
      n: `Subject`,
      t: eI
    },
    4: {
      n: `Author`,
      t: eI
    },
    5: {
      n: `Keywords`,
      t: eI
    },
    6: {
      n: `Comments`,
      t: eI
    },
    7: {
      n: `Template`,
      t: eI
    },
    8: {
      n: `LastAuthor`,
      t: eI
    },
    9: {
      n: `RevNumber`,
      t: eI
    },
    10: {
      n: `EditTime`,
      t: YF
    },
    11: {
      n: `LastPrinted`,
      t: YF
    },
    12: {
      n: `CreatedDate`,
      t: YF
    },
    13: {
      n: `ModifiedDate`,
      t: YF
    },
    14: {
      n: `PageCount`,
      t: GF
    },
    15: {
      n: `WordCount`,
      t: GF
    },
    16: {
      n: `CharCount`,
      t: GF
    },
    17: {
      n: `Thumbnail`,
      t: ZF
    },
    18: {
      n: `Application`,
      t: eI
    },
    19: {
      n: `DocSecurity`,
      t: GF
    },
    255: {},
    2147483648: {
      n: `Locale`,
      t: JF
    },
    2147483651: {
      n: `Behavior`,
      t: JF
    },
    1919054434: {}
  },
  aI = {
    1: `US`,
    2: `CA`,
    3: ``,
    7: `RU`,
    20: `EG`,
    30: `GR`,
    31: `NL`,
    32: `BE`,
    33: `FR`,
    34: `ES`,
    36: `HU`,
    39: `IT`,
    41: `CH`,
    43: `AT`,
    44: `GB`,
    45: `DK`,
    46: `SE`,
    47: `NO`,
    48: `PL`,
    49: `DE`,
    52: `MX`,
    55: `BR`,
    61: `AU`,
    64: `NZ`,
    66: `TH`,
    81: `JP`,
    82: `KR`,
    84: `VN`,
    86: `CN`,
    90: `TR`,
    105: `JS`,
    213: `DZ`,
    216: `MA`,
    218: `LY`,
    351: `PT`,
    354: `IS`,
    358: `FI`,
    420: `CZ`,
    886: `TW`,
    961: `LB`,
    962: `JO`,
    963: `SY`,
    964: `IQ`,
    965: `KW`,
    966: `SA`,
    971: `AE`,
    972: `IL`,
    974: `QA`,
    981: `IR`,
    65535: `US`
  },
  oI = [null, `solid`, `mediumGray`, `darkGray`, `lightGray`, `darkHorizontal`, `darkVertical`, `darkDown`, `darkUp`, `darkGrid`, `darkTrellis`, `lightHorizontal`, `lightVertical`, `lightDown`, `lightUp`, `lightGrid`, `lightTrellis`, `gray125`, `gray0625`];
function sI(e) {
  return e.map(function (e) {
    return [e >> 16 & 255, e >> 8 & 255, e & 255];
  });
}
var cI = GM(sI([0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 8388608, 32768, 128, 8421376, 8388736, 32896, 12632256, 8421504, 10066431, 10040166, 16777164, 13434879, 6684774, 16744576, 26316, 13421823, 128, 16711935, 16776960, 65535, 8388736, 8388608, 32896, 255, 52479, 13434879, 13434828, 16777113, 10079487, 16751052, 13408767, 16764057, 3368703, 3394764, 10079232, 16763904, 16750848, 16737792, 6710937, 9868950, 13158, 3381606, 13056, 3355392, 10040064, 10040166, 3355545, 3355443, 16777215, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
  lI = {
    0: `#NULL!`,
    7: `#DIV/0!`,
    15: `#VALUE!`,
    23: `#REF!`,
    29: `#NAME?`,
    36: `#NUM!`,
    42: `#N/A`,
    43: `#GETTING_DATA`,
    255: `#WTF?`
  },
  uI = {
    "#NULL!": 0,
    "#DIV/0!": 7,
    "#VALUE!": 15,
    "#REF!": 23,
    "#NAME?": 29,
    "#NUM!": 36,
    "#N/A": 42,
    "#GETTING_DATA": 43,
    "#WTF?": 255
  },
  dI = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": `workbooks`,
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": `workbooks`,
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": `workbooks`,
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": `workbooks`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": `workbooks`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": `sheets`,
    "application/vnd.ms-excel.worksheet": `sheets`,
    "application/vnd.ms-excel.binIndexWs": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": `charts`,
    "application/vnd.ms-excel.chartsheet": `charts`,
    "application/vnd.ms-excel.macrosheet+xml": `macros`,
    "application/vnd.ms-excel.macrosheet": `macros`,
    "application/vnd.ms-excel.intlmacrosheet": `TODO`,
    "application/vnd.ms-excel.binIndexMs": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": `dialogs`,
    "application/vnd.ms-excel.dialogsheet": `dialogs`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": `strs`,
    "application/vnd.ms-excel.sharedStrings": `strs`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": `styles`,
    "application/vnd.ms-excel.styles": `styles`,
    "application/vnd.openxmlformats-package.core-properties+xml": `coreprops`,
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": `custprops`,
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": `extprops`,
    "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": `comments`,
    "application/vnd.ms-excel.comments": `comments`,
    "application/vnd.ms-excel.threadedcomments+xml": `threadedcomments`,
    "application/vnd.ms-excel.person+xml": `people`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": `metadata`,
    "application/vnd.ms-excel.sheetMetadata": `metadata`,
    "application/vnd.ms-excel.pivotTable": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": `TODO`,
    "application/vnd.ms-office.chartcolorstyle+xml": `TODO`,
    "application/vnd.ms-office.chartstyle+xml": `TODO`,
    "application/vnd.ms-office.chartex+xml": `TODO`,
    "application/vnd.ms-excel.calcChain": `calcchains`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": `calcchains`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": `TODO`,
    "application/vnd.ms-office.activeX": `TODO`,
    "application/vnd.ms-office.activeX+xml": `TODO`,
    "application/vnd.ms-excel.attachedToolbars": `TODO`,
    "application/vnd.ms-excel.connections": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": `TODO`,
    "application/vnd.ms-excel.externalLink": `links`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": `links`,
    "application/vnd.ms-excel.pivotCacheDefinition": `TODO`,
    "application/vnd.ms-excel.pivotCacheRecords": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": `TODO`,
    "application/vnd.ms-excel.queryTable": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": `TODO`,
    "application/vnd.ms-excel.userNames": `TODO`,
    "application/vnd.ms-excel.revisionHeaders": `TODO`,
    "application/vnd.ms-excel.revisionLog": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": `TODO`,
    "application/vnd.ms-excel.tableSingleCells": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": `TODO`,
    "application/vnd.ms-excel.slicer": `TODO`,
    "application/vnd.ms-excel.slicerCache": `TODO`,
    "application/vnd.ms-excel.slicer+xml": `TODO`,
    "application/vnd.ms-excel.slicerCache+xml": `TODO`,
    "application/vnd.ms-excel.wsSortMap": `TODO`,
    "application/vnd.ms-excel.table": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.theme+xml": `themes`,
    "application/vnd.openxmlformats-officedocument.themeOverride+xml": `TODO`,
    "application/vnd.ms-excel.Timeline+xml": `TODO`,
    "application/vnd.ms-excel.TimelineCache+xml": `TODO`,
    "application/vnd.ms-office.vbaProject": `vba`,
    "application/vnd.ms-office.vbaProjectSignature": `TODO`,
    "application/vnd.ms-office.volatileDependencies": `TODO`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": `TODO`,
    "application/vnd.ms-excel.controlproperties+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.model+data": `TODO`,
    "application/vnd.ms-excel.Survey+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.drawing+xml": `drawings`,
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": `TODO`,
    "application/vnd.openxmlformats-officedocument.vmlDrawing": `TODO`,
    "application/vnd.openxmlformats-package.relationships+xml": `rels`,
    "application/vnd.openxmlformats-officedocument.oleObject": `TODO`,
    "image/png": `TODO`,
    sheet: `js`
  },
  fI = {
    workbooks: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml`,
      xlsm: `application/vnd.ms-excel.sheet.macroEnabled.main+xml`,
      xlsb: `application/vnd.ms-excel.sheet.binary.macroEnabled.main`,
      xlam: `application/vnd.ms-excel.addin.macroEnabled.main+xml`,
      xltx: `application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml`
    },
    strs: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml`,
      xlsb: `application/vnd.ms-excel.sharedStrings`
    },
    comments: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml`,
      xlsb: `application/vnd.ms-excel.comments`
    },
    sheets: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml`,
      xlsb: `application/vnd.ms-excel.worksheet`
    },
    charts: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml`,
      xlsb: `application/vnd.ms-excel.chartsheet`
    },
    dialogs: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml`,
      xlsb: `application/vnd.ms-excel.dialogsheet`
    },
    macros: {
      xlsx: `application/vnd.ms-excel.macrosheet+xml`,
      xlsb: `application/vnd.ms-excel.macrosheet`
    },
    metadata: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml`,
      xlsb: `application/vnd.ms-excel.sheetMetadata`
    },
    styles: {
      xlsx: `application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml`,
      xlsb: `application/vnd.ms-excel.styles`
    }
  };
function pI() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ``
  };
}
function mI(e) {
  var t = pI();
  if (!e || !e.match) return t;
  var n = {};
  if ((e.match(pN) || []).forEach(function (e) {
    var r = gN(e);
    switch (r[0].replace(mN, `<`)) {
      case `<?xml`:
        break;
      case `<Types`:
        t.xmlns = r[`xmlns` + (r[0].match(/<(\w+):/) || [``, ``])[1]];
        break;
      case `<Default`:
        n[r.Extension] = r.ContentType;
        break;
      case `<Override`:
        t[dI[r.ContentType]] !== void 0 && t[dI[r.ContentType]].push(r.PartName);
    }
  }), t.xmlns !== XN.CT) throw Error(`Unknown Namespace: ` + t.xmlns);
  return t.calcchain = t.calcchains.length > 0 ? t.calcchains[0] : ``, t.sst = t.strs.length > 0 ? t.strs[0] : ``, t.style = t.styles.length > 0 ? t.styles[0] : ``, t.defaults = n, delete t.calcchains, t;
}
function hI(e, t) {
  var n = MM(dI),
    r = [],
    i;
  r[r.length] = uN, r[r.length] = X(`Types`, null, {
    xmlns: XN.CT,
    "xmlns:xsd": XN.xsd,
    "xmlns:xsi": XN.xsi
  }), r = r.concat([[`xml`, `application/xml`], [`bin`, `application/vnd.ms-excel.sheet.binary.macroEnabled.main`], [`vml`, `application/vnd.openxmlformats-officedocument.vmlDrawing`], [`data`, `application/vnd.openxmlformats-officedocument.model+data`], [`bmp`, `image/bmp`], [`png`, `image/png`], [`gif`, `image/gif`], [`emf`, `image/x-emf`], [`wmf`, `image/x-wmf`], [`jpg`, `image/jpeg`], [`jpeg`, `image/jpeg`], [`tif`, `image/tiff`], [`tiff`, `image/tiff`], [`pdf`, `application/pdf`], [`rels`, `application/vnd.openxmlformats-package.relationships+xml`]].map(function (e) {
    return X(`Default`, null, {
      Extension: e[0],
      ContentType: e[1]
    });
  }));
  var a = function (n) {
      e[n] && e[n].length > 0 && (i = e[n][0], r[r.length] = X(`Override`, null, {
        PartName: (i[0] == `/` ? `` : `/`) + i,
        ContentType: fI[n][t.bookType] || fI[n].xlsx
      }));
    },
    o = function (n) {
      (e[n] || []).forEach(function (e) {
        r[r.length] = X(`Override`, null, {
          PartName: (e[0] == `/` ? `` : `/`) + e,
          ContentType: fI[n][t.bookType] || fI[n].xlsx
        });
      });
    },
    s = function (t) {
      (e[t] || []).forEach(function (e) {
        r[r.length] = X(`Override`, null, {
          PartName: (e[0] == `/` ? `` : `/`) + e,
          ContentType: n[t][0]
        });
      });
    };
  return a(`workbooks`), o(`sheets`), o(`charts`), s(`themes`), [`strs`, `styles`].forEach(a), [`coreprops`, `extprops`, `custprops`].forEach(s), s(`vba`), s(`comments`), s(`threadedcomments`), s(`drawings`), o(`metadata`), s(`people`), r.length > 2 && (r[r.length] = `</Types>`, r[1] = r[1].replace(`/>`, `>`)), r.join(``);
}
var gI = {
  WB: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument`,
  SHEET: `http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument`,
  HLINK: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink`,
  VML: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing`,
  XPATH: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath`,
  XMISS: `http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing`,
  XLINK: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink`,
  CXML: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml`,
  CXMLP: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps`,
  CMNT: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments`,
  CORE_PROPS: `http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties`,
  EXT_PROPS: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties`,
  CUST_PROPS: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties`,
  SST: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings`,
  STY: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles`,
  THEME: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme`,
  CHART: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart`,
  CHARTEX: `http://schemas.microsoft.com/office/2014/relationships/chartEx`,
  CS: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet`,
  WS: [`http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet`, `http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet`],
  DS: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet`,
  MS: `http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet`,
  IMG: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/image`,
  DRAW: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing`,
  XLMETA: `http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata`,
  TCMNT: `http://schemas.microsoft.com/office/2017/10/relationships/threadedComment`,
  PEOPLE: `http://schemas.microsoft.com/office/2017/10/relationships/person`,
  VBA: `http://schemas.microsoft.com/office/2006/relationships/vbaProject`
};
function _I(e) {
  var t = e.lastIndexOf(`/`);
  return e.slice(0, t + 1) + `_rels/` + e.slice(t + 1) + `.rels`;
}
function vI(e, t) {
  var n = {
    "!id": {}
  };
  if (!e) return n;
  t.charAt(0) !== `/` && (t = `/` + t);
  var r = {};
  return (e.match(pN) || []).forEach(function (e) {
    var i = gN(e);
    if (i[0] === `<Relationship`) {
      var a = {};
      a.Type = i.Type, a.Target = i.Target, a.Id = i.Id, i.TargetMode && (a.TargetMode = i.TargetMode);
      var o = i.TargetMode === `External` ? i.Target : lN(i.Target, t);
      n[o] = a, r[i.Id] = a;
    }
  }), n[`!id`] = r, n;
}
function yI(e) {
  var t = [uN, X(`Relationships`, null, {
    xmlns: XN.RELS
  })];
  return OM(e[`!id`]).forEach(function (n) {
    t[t.length] = X(`Relationship`, null, e[`!id`][n]);
  }), t.length > 2 && (t[t.length] = `</Relationships>`, t[1] = t[1].replace(`/>`, `>`)), t.join(``);
}
function bI(e, t, n, r, i, a) {
  if (i ||= {}, e[`!id`] ||= {}, e[`!idx`] ||= 1, t < 0) for (t = e[`!idx`]; e[`!id`][`rId` + t]; ++t);
  if (e[`!idx`] = t + 1, i.Id = `rId` + t, i.Type = r, i.Target = n, a ? i.TargetMode = a : [gI.HLINK, gI.XPATH, gI.XMISS].indexOf(i.Type) > -1 && (i.TargetMode = `External`), e[`!id`][i.Id]) throw Error(`Cannot rewrite rId ` + t);
  return e[`!id`][i.Id] = i, e[(`/` + i.Target).replace(`//`, `/`)] = i, t;
}
var xI = `application/vnd.oasis.opendocument.spreadsheet`;
function SI(e, t) {
  for (var n = JN(e), r, i; r = YN.exec(n);) switch (r[3]) {
    case `manifest`:
      break;
    case `file-entry`:
      if (i = gN(r[0], !1), i.path == `/` && i.type !== xI) throw Error(`This OpenDocument is not a spreadsheet`);
      break;
    case `encryption-data`:
    case `algorithm`:
    case `start-key-generation`:
    case `key-derivation`:
      throw Error(`Unsupported ODS Encryption`);
    default:
      if (t && t.WTF) throw r;
  }
}
function CI(e) {
  var t = [uN];
  t.push(`<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">
`), t.push(`  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>
`);
  for (var n = 0; n < e.length; ++n) t.push(`  <manifest:file-entry manifest:full-path="` + e[n][0] + `" manifest:media-type="` + e[n][1] + `"/>
`);
  return t.push(`</manifest:manifest>`), t.join(``);
}
function wI(e, t, n) {
  return [`  <rdf:Description rdf:about="` + e + `">
`, `    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/` + (n || `odf`) + `#` + t + `"/>
`, `  </rdf:Description>
`].join(``);
}
function TI(e, t) {
  return [`  <rdf:Description rdf:about="` + e + `">
`, `    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="` + t + `"/>
`, `  </rdf:Description>
`].join(``);
}
function EI(e) {
  var t = [uN];
  t.push(`<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
`);
  for (var n = 0; n != e.length; ++n) t.push(wI(e[n][0], e[n][1])), t.push(TI(``, e[n][0]));
  return t.push(wI(``, `Document`, `pkg`)), t.push(`</rdf:RDF>`), t.join(``);
}
function DI() {
  return `<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ` + DA.version + `</meta:generator></office:meta></office:document-meta>`;
}
var OI = [[`cp:category`, `Category`], [`cp:contentStatus`, `ContentStatus`], [`cp:keywords`, `Keywords`], [`cp:lastModifiedBy`, `LastAuthor`], [`cp:lastPrinted`, `LastPrinted`], [`cp:revision`, `RevNumber`], [`cp:version`, `Version`], [`dc:creator`, `Author`], [`dc:description`, `Comments`], [`dc:identifier`, `Identifier`], [`dc:language`, `Language`], [`dc:subject`, `Subject`], [`dc:title`, `Title`], [`dcterms:created`, `CreatedDate`, `date`], [`dcterms:modified`, `ModifiedDate`, `date`]],
  kI = function () {
    for (var e = Array(OI.length), t = 0; t < OI.length; ++t) {
      var n = OI[t],
        r = `(?:` + n[0].slice(0, n[0].indexOf(`:`)) + `:)` + n[0].slice(n[0].indexOf(`:`) + 1);
      e[t] = RegExp(`<` + r + `[^>]*>([\\s\\S]*?)</` + r + `>`);
    }
    return e;
  }();
function AI(e) {
  var t = {};
  e = FN(e);
  for (var n = 0; n < OI.length; ++n) {
    var r = OI[n],
      i = e.match(kI[n]);
    i != null && i.length > 0 && (t[r[1]] = bN(i[1])), r[2] === `date` && t[r[1]] && (t[r[1]] = UM(t[r[1]]));
  }
  return t;
}
function jI(e, t, n, r, i) {
  i[e] == null && t != null && t !== `` && (i[e] = t, t = CN(t), r[r.length] = n ? X(e, t, n) : WN(e, t));
}
function MI(e, t) {
  var n = t || {},
    r = [uN, X(`cp:coreProperties`, null, {
      "xmlns:cp": XN.CORE_PROPS,
      "xmlns:dc": XN.dc,
      "xmlns:dcterms": XN.dcterms,
      "xmlns:dcmitype": XN.dcmitype,
      "xmlns:xsi": XN.xsi
    })],
    i = {};
  if (!e && !n.Props) return r.join(``);
  e && (e.CreatedDate != null && jI(`dcterms:created`, typeof e.CreatedDate == `string` ? e.CreatedDate : KN(e.CreatedDate, n.WTF), {
    "xsi:type": `dcterms:W3CDTF`
  }, r, i), e.ModifiedDate != null && jI(`dcterms:modified`, typeof e.ModifiedDate == `string` ? e.ModifiedDate : KN(e.ModifiedDate, n.WTF), {
    "xsi:type": `dcterms:W3CDTF`
  }, r, i));
  for (var a = 0; a != OI.length; ++a) {
    var o = OI[a],
      s = n.Props && n.Props[o[1]] != null ? n.Props[o[1]] : e ? e[o[1]] : null;
    s === !0 ? s = `1` : s === !1 ? s = `0` : typeof s == `number` && (s = String(s)), s != null && jI(o[0], s, null, r, i);
  }
  return r.length > 2 && (r[r.length] = `</cp:coreProperties>`, r[1] = r[1].replace(`/>`, `>`)), r.join(``);
}
var NI = [[`Application`, `Application`, `string`], [`AppVersion`, `AppVersion`, `string`], [`Company`, `Company`, `string`], [`DocSecurity`, `DocSecurity`, `string`], [`Manager`, `Manager`, `string`], [`HyperlinksChanged`, `HyperlinksChanged`, `bool`], [`SharedDoc`, `SharedDoc`, `bool`], [`LinksUpToDate`, `LinksUpToDate`, `bool`], [`ScaleCrop`, `ScaleCrop`, `bool`], [`HeadingPairs`, `HeadingPairs`, `raw`], [`TitlesOfParts`, `TitlesOfParts`, `raw`]],
  PI = [`Worksheets`, `SheetNames`, `NamedRanges`, `DefinedNames`, `Chartsheets`, `ChartNames`];
function FI(e, t, n, r) {
  var i = [];
  if (typeof e == `string`) i = HN(e, r);else for (var a = 0; a < e.length; ++a) i = i.concat(e[a].map(function (e) {
    return {
      v: e
    };
  }));
  var o = typeof t == `string` ? HN(t, r).map(function (e) {
      return e.v;
    }) : t,
    s = 0,
    c = 0;
  if (o.length > 0) for (var l = 0; l !== i.length; l += 2) {
    switch (c = +i[l + 1].v, i[l].v) {
      case `Worksheets`:
      case `工作表`:
      case `Листы`:
      case `أوراق العمل`:
      case `ワークシート`:
      case `גליונות עבודה`:
      case `Arbeitsblätter`:
      case `Çalışma Sayfaları`:
      case `Feuilles de calcul`:
      case `Fogli di lavoro`:
      case `Folhas de cálculo`:
      case `Planilhas`:
      case `Regneark`:
      case `Hojas de cálculo`:
      case `Werkbladen`:
        n.Worksheets = c, n.SheetNames = o.slice(s, s + c);
        break;
      case `Named Ranges`:
      case `Rangos con nombre`:
      case `名前付き一覧`:
      case `Benannte Bereiche`:
      case `Navngivne områder`:
        n.NamedRanges = c, n.DefinedNames = o.slice(s, s + c);
        break;
      case `Charts`:
      case `Diagramme`:
        n.Chartsheets = c, n.ChartNames = o.slice(s, s + c);
    }
    s += c;
  }
}
function II(e, t, n) {
  var r = {};
  return t ||= {}, e = FN(e), NI.forEach(function (n) {
    var i = (e.match(LN(n[0])) || [])[1];
    switch (n[2]) {
      case `string`:
        i && (t[n[1]] = bN(i));
        break;
      case `bool`:
        t[n[1]] = i === `true`;
        break;
      case `raw`:
        var a = e.match(RegExp(`<` + n[0] + `[^>]*>([\\s\\S]*?)</` + n[0] + `>`));
        a && a.length > 0 && (r[n[1]] = a[1]);
    }
  }), r.HeadingPairs && r.TitlesOfParts && FI(r.HeadingPairs, r.TitlesOfParts, t, n), t;
}
function LI(e) {
  var t = [],
    n = X;
  return e ||= {}, e.Application = `SheetJS`, t[t.length] = uN, t[t.length] = X(`Properties`, null, {
    xmlns: XN.EXT_PROPS,
    "xmlns:vt": XN.vt
  }), NI.forEach(function (r) {
    if (e[r[1]] !== void 0) {
      var i;
      switch (r[2]) {
        case `string`:
          i = CN(String(e[r[1]]));
          break;
        case `bool`:
          i = e[r[1]] ? `true` : `false`;
      }
      i !== void 0 && (t[t.length] = n(r[0], i));
    }
  }), t[t.length] = n(`HeadingPairs`, n(`vt:vector`, n(`vt:variant`, `<vt:lpstr>Worksheets</vt:lpstr>`) + n(`vt:variant`, n(`vt:i4`, String(e.Worksheets))), {
    size: 2,
    baseType: `variant`
  })), t[t.length] = n(`TitlesOfParts`, n(`vt:vector`, e.SheetNames.map(function (e) {
    return `<vt:lpstr>` + CN(e) + `</vt:lpstr>`;
  }).join(``), {
    size: e.Worksheets,
    baseType: `lpstr`
  })), t.length > 2 && (t[t.length] = `</Properties>`, t[1] = t[1].replace(`/>`, `>`)), t.join(``);
}
var RI = /<[^>]+>[^<]*/g;
function zI(e, t) {
  var n = {},
    r = ``,
    i = e.match(RI);
  if (i) for (var a = 0; a != i.length; ++a) {
    var o = i[a],
      s = gN(o);
    switch (s[0]) {
      case `<?xml`:
        break;
      case `<Properties`:
        break;
      case `<property`:
        r = bN(s.name);
        break;
      case `</property>`:
        r = null;
        break;
      default:
        if (o.indexOf(`<vt:`) === 0) {
          var c = o.split(`>`),
            l = c[0].slice(4),
            u = c[1];
          switch (l) {
            case `lpstr`:
            case `bstr`:
            case `lpwstr`:
              n[r] = bN(u);
              break;
            case `bool`:
              n[r] = AN(u);
              break;
            case `i1`:
            case `i2`:
            case `i4`:
            case `i8`:
            case `int`:
            case `uint`:
              n[r] = parseInt(u, 10);
              break;
            case `r4`:
            case `r8`:
            case `decimal`:
              n[r] = parseFloat(u);
              break;
            case `filetime`:
            case `date`:
              n[r] = UM(u);
              break;
            case `cy`:
            case `error`:
              n[r] = bN(u);
              break;
            default:
              if (l.slice(-1) == `/`) break;
              t.WTF && typeof console < `u` && console.warn(`Unexpected`, o, l, c);
          }
        } else if (o.slice(0, 2) !== `</` && t.WTF) throw Error(o);
    }
  }
  return n;
}
function BI(e) {
  var t = [uN, X(`Properties`, null, {
    xmlns: XN.CUST_PROPS,
    "xmlns:vt": XN.vt
  })];
  if (!e) return t.join(``);
  var n = 1;
  return OM(e).forEach(function (r) {
    ++n, t[t.length] = X(`property`, qN(e[r], !0), {
      fmtid: `{D5CDD505-2E9C-101B-9397-08002B2CF9AE}`,
      pid: n,
      name: CN(r)
    });
  }), t.length > 2 && (t[t.length] = `</Properties>`, t[1] = t[1].replace(`/>`, `>`)), t.join(``);
}
var VI = {
    Title: `Title`,
    Subject: `Subject`,
    Author: `Author`,
    Keywords: `Keywords`,
    Comments: `Description`,
    LastAuthor: `LastAuthor`,
    RevNumber: `Revision`,
    Application: `AppName`,
    LastPrinted: `LastPrinted`,
    CreatedDate: `Created`,
    ModifiedDate: `LastSaved`,
    Category: `Category`,
    Manager: `Manager`,
    Company: `Company`,
    AppVersion: `Version`,
    ContentStatus: `ContentStatus`,
    Identifier: `Identifier`,
    Language: `Language`
  },
  HI;
function UI(e, t, n) {
  HI ||= AM(VI), t = HI[t] || t, e[t] = n;
}
function WI(e, t) {
  var n = [];
  return OM(VI).map(function (e) {
    for (var t = 0; t < OI.length; ++t) if (OI[t][1] == e) return OI[t];
    for (t = 0; t < NI.length; ++t) if (NI[t][1] == e) return NI[t];
    throw e;
  }).forEach(function (r) {
    if (e[r[1]] != null) {
      var i = t && t.Props && t.Props[r[1]] != null ? t.Props[r[1]] : e[r[1]];
      r[2] === `date` && (i = new Date(i).toISOString().replace(/\.\d*Z/, `Z`)), typeof i == `number` ? i = String(i) : i === !0 || i === !1 ? i = i ? `1` : `0` : i instanceof Date && (i = new Date(i).toISOString().replace(/\.\d*Z/, ``)), n.push(WN(VI[r[1]] || r[1], i));
    }
  }), X(`DocumentProperties`, n.join(``), {
    xmlns: QN.o
  });
}
function GI(e, t) {
  var n = [`Worksheets`, `SheetNames`],
    r = `CustomDocumentProperties`,
    i = [];
  return e && OM(e).forEach(function (t) {
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      for (var r = 0; r < OI.length; ++r) if (t == OI[r][1]) return;
      for (r = 0; r < NI.length; ++r) if (t == NI[r][1]) return;
      for (r = 0; r < n.length; ++r) if (t == n[r]) return;
      var a = e[t],
        o = `string`;
      typeof a == `number` ? (o = `float`, a = String(a)) : a === !0 || a === !1 ? (o = `boolean`, a = a ? `1` : `0`) : a = String(a), i.push(X(wN(t), a, {
        "dt:dt": o
      }));
    }
  }), t && OM(t).forEach(function (n) {
    if (Object.prototype.hasOwnProperty.call(t, n) && !(e && Object.prototype.hasOwnProperty.call(e, n))) {
      var r = t[n],
        a = `string`;
      typeof r == `number` ? (a = `float`, r = String(r)) : r === !0 || r === !1 ? (a = `boolean`, r = r ? `1` : `0`) : r instanceof Date ? (a = `dateTime.tz`, r = r.toISOString()) : r = String(r), i.push(X(wN(n), r, {
        "dt:dt": a
      }));
    }
  }), `<` + r + ` xmlns="` + QN.o + `">` + i.join(``) + `</` + r + `>`;
}
function KI(e) {
  var t = e.read_shift(4),
    n = e.read_shift(4);
  return new Date((n / 1e7 * 2 ** 32 + t / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, ``);
}
function qI(e) {
  var t = (typeof e == `string` ? new Date(Date.parse(e)) : e).getTime() / 1e3 + 11644473600,
    n = t % 2 ** 32,
    r = (t - n) / 2 ** 32;
  n *= 1e7, r *= 1e7;
  var i = n / 2 ** 32 | 0;
  i > 0 && (n %= 2 ** 32, r += i);
  var a = Z(8);
  return a.write_shift(4, n), a.write_shift(4, r), a;
}
function JI(e, t, n) {
  var r = e.l,
    i = e.read_shift(0, `lpstr-cp`);
  if (n) for (; e.l - r & 3;) ++e.l;
  return i;
}
function YI(e, t, n) {
  var r = e.read_shift(0, `lpwstr`);
  return n && (e.l += 4 - (r.length + 1 & 3) & 3), r;
}
function XI(e, t, n) {
  return t === 31 ? YI(e) : JI(e, t, n);
}
function ZI(e, t, n) {
  return XI(e, t, n === !1 ? 0 : 4);
}
function QI(e, t) {
  if (!t) throw Error(`VtUnalignedString must have positive length`);
  return XI(e, t, 0);
}
function $I(e) {
  for (var t = e.read_shift(4), n = [], r = 0; r != t; ++r) {
    var i = e.l;
    n[r] = e.read_shift(0, `lpwstr`).replace(oj, ``), e.l - i & 2 && (e.l += 2);
  }
  return n;
}
function eL(e) {
  for (var t = e.read_shift(4), n = [], r = 0; r != t; ++r) n[r] = e.read_shift(0, `lpstr-cp`).replace(oj, ``);
  return n;
}
function tL(e) {
  var t = e.l,
    n = oL(e, tI);
  return e[e.l] == 0 && e[e.l + 1] == 0 && e.l - t & 2 && (e.l += 2), [n, oL(e, GF)];
}
function nL(e) {
  for (var t = e.read_shift(4), n = [], r = 0; r < t / 2; ++r) n.push(tL(e));
  return n;
}
function rL(e, t) {
  for (var n = e.read_shift(4), r = {}, i = 0; i != n; ++i) {
    var a = e.read_shift(4),
      o = e.read_shift(4);
    r[a] = e.read_shift(o, t === 1200 ? `utf16le` : `utf8`).replace(oj, ``).replace(sj, `!`), t === 1200 && o % 2 && (e.l += 2);
  }
  return e.l & 3 && (e.l = e.l >> 3 << 2), r;
}
function iL(e) {
  var t = e.read_shift(4),
    n = e.slice(e.l, e.l + t);
  return e.l += t, (t & 3) > 0 && (e.l += 4 - (t & 3) & 3), n;
}
function aL(e) {
  var t = {};
  return t.Size = e.read_shift(4), e.l += t.Size + 3 - (t.Size - 1) % 4, t;
}
function oL(e, t, n) {
  var r = e.read_shift(2),
    i,
    a = n || {};
  if (e.l += 2, t !== qF && r !== t && nI.indexOf(t) === -1 && ((t & 65534) != 4126 || (r & 65534) != 4126)) throw Error(`Expected type ` + t + ` saw ` + r);
  switch (t === qF ? r : t) {
    case 2:
      return i = e.read_shift(2, `i`), a.raw || (e.l += 2), i;
    case 3:
      return i = e.read_shift(4, `i`), i;
    case 11:
      return e.read_shift(4) !== 0;
    case 19:
      return i = e.read_shift(4), i;
    case 30:
      return JI(e, r, 4).replace(oj, ``);
    case 31:
      return YI(e);
    case 64:
      return KI(e);
    case 65:
      return iL(e);
    case 71:
      return aL(e);
    case 80:
      return ZI(e, r, !a.raw).replace(oj, ``);
    case 81:
      return QI(e, r).replace(oj, ``);
    case 4108:
      return nL(e);
    case 4126:
    case 4127:
      return r == 4127 ? $I(e) : eL(e);
    default:
      throw Error(`TypedPropertyValue unrecognized type ` + t + ` ` + r);
  }
}
function sL(e, t) {
  var n = Z(4),
    r = Z(4);
  switch (n.write_shift(4, e == 80 ? 31 : e), e) {
    case 3:
      r.write_shift(-4, t);
      break;
    case 5:
      r = Z(8), r.write_shift(8, t, `f`);
      break;
    case 11:
      r.write_shift(4, +!!t);
      break;
    case 64:
      r = qI(t);
      break;
    case 31:
    case 80:
      for (r = Z(4 + 2 * (t.length + 1) + (t.length % 2 ? 0 : 2)), r.write_shift(4, t.length + 1), r.write_shift(0, t, `dbcs`); r.l != r.length;) r.write_shift(1, 0);
      break;
    default:
      throw Error(`TypedPropertyValue unrecognized type ` + e + ` ` + t);
  }
  return ij([n, r]);
}
function cL(e, t) {
  var n = e.l,
    r = e.read_shift(4),
    i = e.read_shift(4),
    a = [],
    o = 0,
    s = 0,
    c = -1,
    l = {};
  for (o = 0; o != i; ++o) {
    var u = e.read_shift(4),
      d = e.read_shift(4);
    a[o] = [u, d + n];
  }
  a.sort(function (e, t) {
    return e[1] - t[1];
  });
  var f = {};
  for (o = 0; o != i; ++o) {
    if (e.l !== a[o][1]) {
      var p = !0;
      if (o > 0 && t) switch (t[a[o - 1][0]].t) {
        case 2:
          e.l + 2 === a[o][1] && (e.l += 2, p = !1);
          break;
        case 80:
          e.l <= a[o][1] && (e.l = a[o][1], p = !1);
          break;
        case 4108:
          e.l <= a[o][1] && (e.l = a[o][1], p = !1);
      }
      if ((!t || o == 0) && e.l <= a[o][1] && (p = !1, e.l = a[o][1]), p) throw Error(`Read Error: Expected address ` + a[o][1] + ` at ` + e.l + ` :` + o);
    }
    if (t) {
      var m = t[a[o][0]];
      if (f[m.n] = oL(e, m.t, {
        raw: !0
      }), m.p === `version` && (f[m.n] = String(f[m.n] >> 16) + `.` + (`0000` + String(f[m.n] & 65535)).slice(-4)), m.n == `CodePage`) switch (f[m.n]) {
        case 0:
          f[m.n] = 1252;
        case 874:
        case 932:
        case 936:
        case 949:
        case 950:
        case 1250:
        case 1251:
        case 1253:
        case 1254:
        case 1255:
        case 1256:
        case 1257:
        case 1258:
        case 1e4:
        case 1200:
        case 1201:
        case 1252:
        case 65e3:
        case -536:
        case 65001:
        case -535:
          PA(s = f[m.n] >>> 0 & 65535);
          break;
        default:
          throw Error(`Unsupported CodePage: ` + f[m.n]);
      }
    } else if (a[o][0] === 1) {
      if (s = f.CodePage = oL(e, WF), PA(s), c !== -1) {
        var h = e.l;
        e.l = a[c][1], l = rL(e, s), e.l = h;
      }
    } else if (a[o][0] === 0) {
      if (s === 0) {
        c = o, e.l = a[o + 1][1];
        continue;
      }
      l = rL(e, s);
    } else {
      var g = l[a[o][0]],
        _;
      switch (e[e.l]) {
        case 65:
          e.l += 4, _ = iL(e);
          break;
        case 30:
          e.l += 4, _ = ZI(e, e[e.l - 4]).replace(/\u0000+$/, ``);
          break;
        case 31:
          e.l += 4, _ = ZI(e, e[e.l - 4]).replace(/\u0000+$/, ``);
          break;
        case 3:
          e.l += 4, _ = e.read_shift(4, `i`);
          break;
        case 19:
          e.l += 4, _ = e.read_shift(4);
          break;
        case 5:
          e.l += 4, _ = e.read_shift(8, `f`);
          break;
        case 11:
          e.l += 4, _ = _L(e, 4);
          break;
        case 64:
          e.l += 4, _ = UM(KI(e));
          break;
        default:
          throw Error(`unparsed value: ` + e[e.l]);
      }
      f[g] = _;
    }
  }
  return e.l = n + r, f;
}
var lL = [`CodePage`, `Thumbnail`, `_PID_LINKBASE`, `_PID_HLINKS`, `SystemIdentifier`, `FMTID`];
function uL(e) {
  switch (typeof e) {
    case `boolean`:
      return 11;
    case `number`:
      return (e | 0) == e ? 3 : 5;
    case `string`:
      return 31;
    case `object`:
      if (e instanceof Date) return 64;
  }
  return -1;
}
function dL(e, t, n) {
  var r = Z(8),
    i = [],
    a = [],
    o = 8,
    s = 0,
    c = Z(8),
    l = Z(8);
  if (c.write_shift(4, 2), c.write_shift(4, 1200), l.write_shift(4, 1), a.push(c), i.push(l), o += 8 + c.length, !t) {
    l = Z(8), l.write_shift(4, 0), i.unshift(l);
    var u = [Z(4)];
    for (u[0].write_shift(4, e.length), s = 0; s < e.length; ++s) {
      var d = e[s][0];
      for (c = Z(8 + 2 * (d.length + 1) + (d.length % 2 ? 0 : 2)), c.write_shift(4, s + 2), c.write_shift(4, d.length + 1), c.write_shift(0, d, `dbcs`); c.l != c.length;) c.write_shift(1, 0);
      u.push(c);
    }
    c = ij(u), a.unshift(c), o += 8 + c.length;
  }
  for (s = 0; s < e.length; ++s) if ((!t || t[e[s][0]]) && !(lL.indexOf(e[s][0]) > -1 || PI.indexOf(e[s][0]) > -1) && e[s][1] != null) {
    var f = e[s][1],
      p = 0;
    if (t) {
      p = +t[e[s][0]];
      var m = n[p];
      if (m.p == `version` && typeof f == `string`) {
        var h = f.split(`.`);
        f = (h[0] << 16) + (+h[1] || 0);
      }
      c = sL(m.t, f);
    } else {
      var g = uL(f);
      g == -1 && (g = 31, f = String(f)), c = sL(g, f);
    }
    a.push(c), l = Z(8), l.write_shift(4, t ? p : 2 + s), i.push(l), o += 8 + c.length;
  }
  var _ = 8 * (a.length + 1);
  for (s = 0; s < a.length; ++s) i[s].write_shift(4, _), _ += a[s].length;
  return r.write_shift(4, o), r.write_shift(4, a.length), ij([r].concat(i, a));
}
function fL(e, t, n) {
  var r = e.content;
  if (!r) return {};
  FP(r, 0);
  var i,
    a,
    o,
    s,
    c = 0;
  r.chk(`feff`, `Byte Order: `), r.read_shift(2);
  var l = r.read_shift(4),
    u = r.read_shift(16);
  if (u !== SM.utils.consts.HEADER_CLSID && u !== n) throw Error(`Bad PropertySet CLSID ` + u);
  if (i = r.read_shift(4), i !== 1 && i !== 2) throw Error(`Unrecognized #Sets: ` + i);
  if (a = r.read_shift(16), s = r.read_shift(4), i === 1 && s !== r.l) throw Error(`Length mismatch: ` + s + ` !== ` + r.l);
  i === 2 && (o = r.read_shift(16), c = r.read_shift(4));
  var d = cL(r, t),
    f = {
      SystemIdentifier: l
    };
  for (var p in d) f[p] = d[p];
  if (f.FMTID = a, i === 1) return f;
  if (c - r.l == 2 && (r.l += 2), r.l !== c) throw Error(`Length mismatch 2: ` + r.l + ` !== ` + c);
  var m;
  try {
    m = cL(r, null);
  } catch {}
  for (p in m) f[p] = m[p];
  return f.FMTID = [a, o], f;
}
function pL(e, t, n, r, i, a) {
  var o = Z(i ? 68 : 48),
    s = [o];
  o.write_shift(2, 65534), o.write_shift(2, 0), o.write_shift(4, 842412599), o.write_shift(16, SM.utils.consts.HEADER_CLSID, `hex`), o.write_shift(4, i ? 2 : 1), o.write_shift(16, t, `hex`), o.write_shift(4, i ? 68 : 48);
  var c = dL(e, n, r);
  if (s.push(c), i) {
    var l = dL(i, null, null);
    o.write_shift(16, a, `hex`), o.write_shift(4, 68 + c.length), s.push(l);
  }
  return ij(s);
}
function mL(e, t) {
  return e.read_shift(t), null;
}
function hL(e, t) {
  t ||= Z(e);
  for (var n = 0; n < e; ++n) t.write_shift(1, 0);
  return t;
}
function gL(e, t, n) {
  for (var r = [], i = e.l + t; e.l < i;) r.push(n(e, i - e.l));
  if (i !== e.l) throw Error(`Slurp error`);
  return r;
}
function _L(e, t) {
  return e.read_shift(t) === 1;
}
function vL(e, t) {
  return t ||= Z(2), t.write_shift(2, +!!e), t;
}
function yL(e) {
  return e.read_shift(2, `u`);
}
function bL(e, t) {
  return t ||= Z(2), t.write_shift(2, e), t;
}
function xL(e, t) {
  return gL(e, t, yL);
}
function SL(e) {
  var t = e.read_shift(1);
  return e.read_shift(1) === 1 ? t : t === 1;
}
function CL(e, t, n) {
  return n ||= Z(2), n.write_shift(1, t == `e` ? +e : +!!e), n.write_shift(1, +(t == `e`)), n;
}
function wL(e, t, n) {
  var r = e.read_shift(n && n.biff >= 12 ? 2 : 1),
    i = `sbcs-cont`,
    a = OA;
  n && n.biff >= 8 && (OA = 1200), !n || n.biff == 8 ? e.read_shift(1) && (i = `dbcs-cont`) : n.biff == 12 && (i = `wstr`), n.biff >= 2 && n.biff <= 5 && (i = `cpstr`);
  var o = r ? e.read_shift(r, i) : ``;
  return OA = a, o;
}
function TL(e) {
  var t = OA;
  OA = 1200;
  var n = e.read_shift(2),
    r = e.read_shift(1),
    i = r & 4,
    a = r & 8,
    o = 1 + (r & 1),
    s = 0,
    c,
    l = {};
  a && (s = e.read_shift(2)), i && (c = e.read_shift(4));
  var u = o == 2 ? `dbcs-cont` : `sbcs-cont`,
    d = n === 0 ? `` : e.read_shift(n, u);
  return a && (e.l += 4 * s), i && (e.l += c), l.t = d, a || (l.raw = `<t>` + l.t + `</t>`, l.r = l.t), OA = t, l;
}
function EL(e) {
  var t = e.t || ``,
    n = 1,
    r = Z(3 + (n > 1 ? 2 : 0));
  r.write_shift(2, t.length), r.write_shift(1, (n > 1 ? 8 : 0) | 1), n > 1 && r.write_shift(2, n);
  var i = Z(2 * t.length);
  return i.write_shift(2 * t.length, t, `utf16le`), ij([r, i]);
}
function DL(e, t, n) {
  var r;
  if (n) {
    if (n.biff >= 2 && n.biff <= 5) return e.read_shift(t, `cpstr`);
    if (n.biff >= 12) return e.read_shift(t, `dbcs-cont`);
  }
  return r = e.read_shift(1) === 0 ? e.read_shift(t, `sbcs-cont`) : e.read_shift(t, `dbcs-cont`), r;
}
function OL(e, t, n) {
  var r = e.read_shift(n && n.biff == 2 ? 1 : 2);
  return r === 0 ? (e.l++, ``) : DL(e, r, n);
}
function kL(e, t, n) {
  if (n.biff > 5) return OL(e, t, n);
  var r = e.read_shift(1);
  return r === 0 ? (e.l++, ``) : e.read_shift(r, n.biff <= 4 || !e.lens ? `cpstr` : `sbcs-cont`);
}
function AL(e, t, n) {
  return n ||= Z(3 + 2 * e.length), n.write_shift(2, e.length), n.write_shift(1, 1), n.write_shift(31, e, `utf16le`), n;
}
function jL(e) {
  var t = e.read_shift(1);
  e.l++;
  var n = e.read_shift(2);
  return e.l += 2, [t, n];
}
function ML(e) {
  var t = e.read_shift(4),
    n = e.l,
    r = !1;
  t > 24 && (e.l += t - 24, e.read_shift(16) === `795881f43b1d7f48af2c825dc4852763` && (r = !0), e.l = n);
  var i = e.read_shift((r ? t - 24 : t) >> 1, `utf16le`).replace(oj, ``);
  return r && (e.l += 24), i;
}
function NL(e) {
  for (var t = e.read_shift(2), n = ``; t-- > 0;) n += `../`;
  var r = e.read_shift(0, `lpstr-ansi`);
  if (e.l += 2, e.read_shift(2) != 57005) throw Error(`Bad FileMoniker`);
  if (e.read_shift(4) === 0) return n + r.replace(/\\/g, `/`);
  var i = e.read_shift(4);
  if (e.read_shift(2) != 3) throw Error(`Bad FileMoniker`);
  var a = e.read_shift(i >> 1, `utf16le`).replace(oj, ``);
  return n + a;
}
function PL(e, t) {
  var n = e.read_shift(16);
  switch (t -= 16, n) {
    case `e0c9ea79f9bace118c8200aa004ba90b`:
      return ML(e, t);
    case `0303000000000000c000000000000046`:
      return NL(e, t);
    default:
      throw Error(`Unsupported Moniker ` + n);
  }
}
function FL(e) {
  var t = e.read_shift(4);
  return t > 0 ? e.read_shift(t, `utf16le`).replace(oj, ``) : ``;
}
function IL(e, t) {
  t ||= Z(6 + e.length * 2), t.write_shift(4, 1 + e.length);
  for (var n = 0; n < e.length; ++n) t.write_shift(2, e.charCodeAt(n));
  return t.write_shift(2, 0), t;
}
function LL(e, t) {
  var n = e.l + t,
    r = e.read_shift(4);
  if (r !== 2) throw Error(`Unrecognized streamVersion: ` + r);
  var i = e.read_shift(2);
  e.l += 2;
  var a,
    o,
    s,
    c,
    l = ``,
    u,
    d;
  i & 16 && (a = FL(e, n - e.l)), i & 128 && (o = FL(e, n - e.l)), (i & 257) == 257 && (s = FL(e, n - e.l)), (i & 257) == 1 && (c = PL(e, n - e.l)), i & 8 && (l = FL(e, n - e.l)), i & 32 && (u = e.read_shift(16)), i & 64 && (d = KI(e)), e.l = n;
  var f = o || s || c || ``;
  f && l && (f += `#` + l), f ||= `#` + l, i & 2 && f.charAt(0) == `/` && f.charAt(1) != `/` && (f = `file://` + f);
  var p = {
    Target: f
  };
  return u && (p.guid = u), d && (p.time = d), a && (p.Tooltip = a), p;
}
function RL(e) {
  var t = Z(512),
    n = 0,
    r = e.Target;
  r.slice(0, 7) == `file://` && (r = r.slice(7));
  var i = r.indexOf(`#`),
    a = i > -1 ? 31 : 23;
  switch (r.charAt(0)) {
    case `#`:
      a = 28;
      break;
    case `.`:
      a &= -3;
  }
  t.write_shift(4, 2), t.write_shift(4, a);
  var o = [8, 6815827, 6619237, 4849780, 83];
  for (n = 0; n < o.length; ++n) t.write_shift(4, o[n]);
  if (a == 28) r = r.slice(1), IL(r, t);else if (a & 2) {
    for (o = `e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b`.split(` `), n = 0; n < o.length; ++n) t.write_shift(1, parseInt(o[n], 16));
    var s = i > -1 ? r.slice(0, i) : r;
    for (t.write_shift(4, 2 * (s.length + 1)), n = 0; n < s.length; ++n) t.write_shift(2, s.charCodeAt(n));
    t.write_shift(2, 0), a & 8 && IL(i > -1 ? r.slice(i + 1) : ``, t);
  } else {
    for (o = `03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46`.split(` `), n = 0; n < o.length; ++n) t.write_shift(1, parseInt(o[n], 16));
    for (var c = 0; r.slice(c * 3, c * 3 + 3) == `../` || r.slice(c * 3, c * 3 + 3) == `..\\`;) ++c;
    for (t.write_shift(2, c), t.write_shift(4, r.length - 3 * c + 1), n = 0; n < r.length - 3 * c; ++n) t.write_shift(1, r.charCodeAt(n + 3 * c) & 255);
    for (t.write_shift(1, 0), t.write_shift(2, 65535), t.write_shift(2, 57005), n = 0; n < 6; ++n) t.write_shift(4, 0);
  }
  return t.slice(0, t.l);
}
function zL(e) {
  return [e.read_shift(1), e.read_shift(1), e.read_shift(1), e.read_shift(1)];
}
function BL(e, t) {
  var n = zL(e, t);
  return n[3] = 0, n;
}
function VL(e) {
  return {
    r: e.read_shift(2),
    c: e.read_shift(2),
    ixfe: e.read_shift(2)
  };
}
function HL(e, t, n, r) {
  return r ||= Z(6), r.write_shift(2, e), r.write_shift(2, t), r.write_shift(2, n || 0), r;
}
function UL(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2);
  return e.l += 8, {
    type: t,
    flags: n
  };
}
function WL(e, t, n) {
  return t === 0 ? `` : kL(e, t, n);
}
function GL(e, t, n) {
  var r = n.biff > 8 ? 4 : 2;
  return [e.read_shift(r), e.read_shift(r, `i`), e.read_shift(r, `i`)];
}
function KL(e) {
  return [e.read_shift(2), kF(e)];
}
function qL(e, t, n) {
  e.l += 4, t -= 4;
  var r = e.l + t,
    i = wL(e, t, n),
    a = e.read_shift(2);
  if (r -= e.l, a !== r) throw Error(`Malformed AddinUdf: padding = ` + r + ` != ` + a);
  return e.l += a, i;
}
function JL(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = e.read_shift(2),
    i = e.read_shift(2);
  return {
    s: {
      c: r,
      r: t
    },
    e: {
      c: i,
      r: n
    }
  };
}
function YL(e, t) {
  return t ||= Z(8), t.write_shift(2, e.s.r), t.write_shift(2, e.e.r), t.write_shift(2, e.s.c), t.write_shift(2, e.e.c), t;
}
function XL(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = e.read_shift(1),
    i = e.read_shift(1);
  return {
    s: {
      c: r,
      r: t
    },
    e: {
      c: i,
      r: n
    }
  };
}
var ZL = XL;
function QL(e) {
  e.l += 4;
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = e.read_shift(2);
  return e.l += 12, [n, t, r];
}
function $L(e) {
  var t = {};
  return e.l += 4, e.l += 16, t.fSharedNote = e.read_shift(2), e.l += 4, t;
}
function eR(e) {
  return e.l += 4, e.cf = e.read_shift(2), {};
}
function tR(e) {
  e.l += 2, e.l += e.read_shift(2);
}
var nR = {
  0: tR,
  4: tR,
  5: tR,
  6: tR,
  7: eR,
  8: tR,
  9: tR,
  10: tR,
  11: tR,
  12: tR,
  13: $L,
  14: tR,
  15: tR,
  16: tR,
  17: tR,
  18: tR,
  19: tR,
  20: tR,
  21: QL
};
function rR(e, t) {
  for (var n = e.l + t, r = []; e.l < n;) {
    var i = e.read_shift(2);
    e.l -= 2;
    try {
      r.push(nR[i](e, n - e.l));
    } catch {
      return e.l = n, r;
    }
  }
  return e.l != n && (e.l = n), r;
}
function iR(e, t) {
  var n = {
    BIFFVer: 0,
    dt: 0
  };
  switch (n.BIFFVer = e.read_shift(2), t -= 2, t >= 2 && (n.dt = e.read_shift(2), e.l -= 2), n.BIFFVer) {
    case 1536:
    case 1280:
    case 1024:
    case 768:
    case 512:
    case 2:
    case 7:
      break;
    default:
      if (t > 6) throw Error(`Unexpected BIFF Ver ` + n.BIFFVer);
  }
  return e.read_shift(t), n;
}
function aR(e, t, n) {
  var r = 1536,
    i = 16;
  switch (n.bookType) {
    case `biff8`:
      break;
    case `biff5`:
      r = 1280, i = 8;
      break;
    case `biff4`:
      r = 4, i = 6;
      break;
    case `biff3`:
      r = 3, i = 6;
      break;
    case `biff2`:
      r = 2, i = 4;
      break;
    case `xla`:
      break;
    default:
      throw Error(`unsupported BIFF version`);
  }
  var a = Z(i);
  return a.write_shift(2, r), a.write_shift(2, t), i > 4 && a.write_shift(2, 29282), i > 6 && a.write_shift(2, 1997), i > 8 && (a.write_shift(2, 49161), a.write_shift(2, 1), a.write_shift(2, 1798), a.write_shift(2, 0)), a;
}
function oR(e, t) {
  return t === 0 || e.read_shift(2), 1200;
}
function sR(e, t, n) {
  if (n.enc) return e.l += t, ``;
  var r = e.l,
    i = kL(e, 0, n);
  return e.read_shift(t + r - e.l), i;
}
function cR(e, t) {
  var n = !t || t.biff == 8,
    r = Z(n ? 112 : 54);
  for (r.write_shift(t.biff == 8 ? 2 : 1, 7), n && r.write_shift(1, 0), r.write_shift(4, 859007059), r.write_shift(4, 5458548 | (n ? 0 : 536870912)); r.l < r.length;) r.write_shift(1, n ? 0 : 32);
  return r;
}
function lR(e, t, n) {
  var r = n && n.biff == 8 || t == 2 ? e.read_shift(2) : (e.l += t, 0);
  return {
    fDialog: r & 16,
    fBelow: r & 64,
    fRight: r & 128
  };
}
function uR(e, t, n) {
  var r = e.read_shift(4),
    i = e.read_shift(1) & 3,
    a = e.read_shift(1);
  switch (a) {
    case 0:
      a = `Worksheet`;
      break;
    case 1:
      a = `Macrosheet`;
      break;
    case 2:
      a = `Chartsheet`;
      break;
    case 6:
      a = `VBAModule`;
  }
  var o = wL(e, 0, n);
  return o.length === 0 && (o = `Sheet1`), {
    pos: r,
    hs: i,
    dt: a,
    name: o
  };
}
function dR(e, t) {
  var n = !t || t.biff >= 8 ? 2 : 1,
    r = Z(8 + n * e.name.length);
  r.write_shift(4, e.pos), r.write_shift(1, e.hs || 0), r.write_shift(1, e.dt), r.write_shift(1, e.name.length), t.biff >= 8 && r.write_shift(1, 1), r.write_shift(n * e.name.length, e.name, t.biff < 8 ? `sbcs` : `utf16le`);
  var i = r.slice(0, r.l);
  return i.l = r.l, i;
}
function fR(e, t) {
  for (var n = e.l + t, r = e.read_shift(4), i = e.read_shift(4), a = [], o = 0; o != i && e.l < n; ++o) a.push(TL(e));
  return a.Count = r, a.Unique = i, a;
}
function pR(e, t) {
  var n = Z(8);
  n.write_shift(4, e.Count), n.write_shift(4, e.Unique);
  for (var r = [], i = 0; i < e.length; ++i) r[i] = EL(e[i], t);
  var a = ij([n].concat(r));
  return a.parts = [n.length].concat(r.map(function (e) {
    return e.length;
  })), a;
}
function mR(e, t) {
  var n = {};
  return n.dsst = e.read_shift(2), e.l += t - 2, n;
}
function hR(e) {
  var t = {};
  t.r = e.read_shift(2), t.c = e.read_shift(2), t.cnt = e.read_shift(2) - t.c;
  var n = e.read_shift(2);
  e.l += 4;
  var r = e.read_shift(1);
  return e.l += 3, r & 7 && (t.level = r & 7), r & 32 && (t.hidden = !0), r & 64 && (t.hpt = n / 20), t;
}
function gR(e) {
  var t = UL(e);
  if (t.type != 2211) throw Error(`Invalid Future Record ` + t.type);
  return e.read_shift(4) !== 0;
}
function _R(e) {
  return e.read_shift(2), e.read_shift(4);
}
function vR(e, t, n) {
  var r = 0;
  n && n.biff == 2 || (r = e.read_shift(2));
  var i = e.read_shift(2);
  return n && n.biff == 2 && (r = 1 - (i >> 15), i &= 32767), [{
    Unsynced: r & 1,
    DyZero: (r & 2) >> 1,
    ExAsc: (r & 4) >> 2,
    ExDsc: (r & 8) >> 3
  }, i];
}
function yR(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = e.read_shift(2),
    i = e.read_shift(2),
    a = e.read_shift(2),
    o = e.read_shift(2),
    s = e.read_shift(2),
    c = e.read_shift(2),
    l = e.read_shift(2);
  return {
    Pos: [t, n],
    Dim: [r, i],
    Flags: a,
    CurTab: o,
    FirstTab: s,
    Selected: c,
    TabRatio: l
  };
}
function bR() {
  var e = Z(18);
  return e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 29280), e.write_shift(2, 17600), e.write_shift(2, 56), e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 1), e.write_shift(2, 500), e;
}
function xR(e, t, n) {
  return n && n.biff >= 2 && n.biff < 5 ? {} : {
    RTL: e.read_shift(2) & 64
  };
}
function SR(e) {
  var t = Z(18),
    n = 1718;
  return e && e.RTL && (n |= 64), t.write_shift(2, n), t.write_shift(4, 0), t.write_shift(4, 64), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
function CR() {}
function wR(e, t, n) {
  var r = {
    dyHeight: e.read_shift(2),
    fl: e.read_shift(2)
  };
  switch (n && n.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      e.l += 2;
      break;
    default:
      e.l += 10;
  }
  return r.name = wL(e, 0, n), r;
}
function TR(e, t) {
  var n = e.name || `Arial`,
    r = t && t.biff == 5,
    i = Z(r ? 15 + n.length : 16 + 2 * n.length);
  return i.write_shift(2, (e.sz || 12) * 20), i.write_shift(4, 0), i.write_shift(2, 400), i.write_shift(4, 0), i.write_shift(2, 0), i.write_shift(1, n.length), r || i.write_shift(1, 1), i.write_shift((r ? 1 : 2) * n.length, n, r ? `sbcs` : `utf16le`), i;
}
function ER(e) {
  var t = VL(e);
  return t.isst = e.read_shift(4), t;
}
function DR(e, t, n, r) {
  var i = Z(10);
  return HL(e, t, r, i), i.write_shift(4, n), i;
}
function OR(e, t, n) {
  n.biffguess && n.biff == 2 && (n.biff = 5);
  var r = e.l + t,
    i = VL(e, 6);
  return n.biff == 2 && e.l++, i.val = OL(e, r - e.l, n), i;
}
function kR(e, t, n, r, i) {
  var a = !i || i.biff == 8,
    o = Z(8 + +a + (1 + a) * n.length);
  return HL(e, t, r, o), o.write_shift(2, n.length), a && o.write_shift(1, 1), o.write_shift((1 + a) * n.length, n, a ? `utf16le` : `sbcs`), o;
}
function AR(e, t, n) {
  return [e.read_shift(2), kL(e, 0, n)];
}
function jR(e, t, n, r) {
  var i = n && n.biff == 5;
  r ||= Z(i ? 3 + t.length : 5 + 2 * t.length), r.write_shift(2, e), r.write_shift(i ? 1 : 2, t.length), i || r.write_shift(1, 1), r.write_shift((i ? 1 : 2) * t.length, t, i ? `sbcs` : `utf16le`);
  var a = r.length > r.l ? r.slice(0, r.l) : r;
  return a.l ??= a.length, a;
}
var MR = kL;
function NR(e, t, n) {
  var r = e.l + t,
    i = n.biff == 8 || !n.biff ? 4 : 2,
    a = e.read_shift(i),
    o = e.read_shift(i),
    s = e.read_shift(2),
    c = e.read_shift(2);
  return e.l = r, {
    s: {
      r: a,
      c: s
    },
    e: {
      r: o,
      c
    }
  };
}
function PR(e, t) {
  var n = t.biff == 8 || !t.biff ? 4 : 2,
    r = Z(2 * n + 6);
  return r.write_shift(n, e.s.r), r.write_shift(n, e.e.r + 1), r.write_shift(2, e.s.c), r.write_shift(2, e.e.c + 1), r.write_shift(2, 0), r;
}
function FR(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = KL(e);
  return {
    r: t,
    c: n,
    ixfe: r[0],
    rknum: r[1]
  };
}
function IR(e, t) {
  for (var n = e.l + t - 2, r = e.read_shift(2), i = e.read_shift(2), a = []; e.l < n;) a.push(KL(e));
  if (e.l !== n) throw Error(`MulRK read error`);
  var o = e.read_shift(2);
  if (a.length != o - i + 1) throw Error(`MulRK length mismatch`);
  return {
    r,
    c: i,
    C: o,
    rkrec: a
  };
}
function LR(e, t) {
  for (var n = e.l + t - 2, r = e.read_shift(2), i = e.read_shift(2), a = []; e.l < n;) a.push(e.read_shift(2));
  if (e.l !== n) throw Error(`MulBlank read error`);
  var o = e.read_shift(2);
  if (a.length != o - i + 1) throw Error(`MulBlank length mismatch`);
  return {
    r,
    c: i,
    C: o,
    ixfe: a
  };
}
function RR(e, t, n, r) {
  var i = {},
    a = e.read_shift(4),
    o = e.read_shift(4),
    s = e.read_shift(4),
    c = e.read_shift(2);
  return i.patternType = oI[s >> 26], r.cellStyles ? (i.alc = a & 7, i.fWrap = a >> 3 & 1, i.alcV = a >> 4 & 7, i.fJustLast = a >> 7 & 1, i.trot = a >> 8 & 255, i.cIndent = a >> 16 & 15, i.fShrinkToFit = a >> 20 & 1, i.iReadOrder = a >> 22 & 2, i.fAtrNum = a >> 26 & 1, i.fAtrFnt = a >> 27 & 1, i.fAtrAlc = a >> 28 & 1, i.fAtrBdr = a >> 29 & 1, i.fAtrPat = a >> 30 & 1, i.fAtrProt = a >> 31 & 1, i.dgLeft = o & 15, i.dgRight = o >> 4 & 15, i.dgTop = o >> 8 & 15, i.dgBottom = o >> 12 & 15, i.icvLeft = o >> 16 & 127, i.icvRight = o >> 23 & 127, i.grbitDiag = o >> 30 & 3, i.icvTop = s & 127, i.icvBottom = s >> 7 & 127, i.icvDiag = s >> 14 & 127, i.dgDiag = s >> 21 & 15, i.icvFore = c & 127, i.icvBack = c >> 7 & 127, i.fsxButton = c >> 14 & 1, i) : i;
}
function zR(e, t, n) {
  var r = {};
  return r.ifnt = e.read_shift(2), r.numFmtId = e.read_shift(2), r.flags = e.read_shift(2), r.fStyle = r.flags >> 2 & 1, t -= 6, r.data = RR(e, t, r.fStyle, n), r;
}
function BR(e, t, n, r) {
  var i = n && n.biff == 5;
  r ||= Z(i ? 16 : 20), r.write_shift(2, 0), e.style ? (r.write_shift(2, e.numFmtId || 0), r.write_shift(2, 65524)) : (r.write_shift(2, e.numFmtId || 0), r.write_shift(2, t << 4));
  var a = 0;
  return e.numFmtId > 0 && i && (a |= 1024), r.write_shift(4, a), r.write_shift(4, 0), i || r.write_shift(4, 0), r.write_shift(2, 0), r;
}
function VR(e) {
  e.l += 4;
  var t = [e.read_shift(2), e.read_shift(2)];
  if (t[0] !== 0 && t[0]--, t[1] !== 0 && t[1]--, t[0] > 7 || t[1] > 7) throw Error(`Bad Gutters: ` + t.join(`|`));
  return t;
}
function HR(e) {
  var t = Z(8);
  return t.write_shift(4, 0), t.write_shift(2, e[0] ? e[0] + 1 : 0), t.write_shift(2, e[1] ? e[1] + 1 : 0), t;
}
function UR(e, t, n) {
  var r = VL(e, 6);
  (n.biff == 2 || t == 9) && ++e.l;
  var i = SL(e, 2);
  return r.val = i, r.t = i === !0 || i === !1 ? `b` : `e`, r;
}
function WR(e, t, n, r, i, a) {
  var o = Z(8);
  return HL(e, t, r, o), CL(n, a, o), o;
}
function GR(e, t, n) {
  n.biffguess && n.biff == 2 && (n.biff = 5);
  var r = VL(e, 6);
  return r.val = FF(e, 8), r;
}
function KR(e, t, n, r) {
  var i = Z(14);
  return HL(e, t, r, i), IF(n, i), i;
}
var qR = WL;
function JR(e, t, n) {
  var r = e.l + t,
    i = e.read_shift(2),
    a = e.read_shift(2);
  if (n.sbcch = a, a == 1025 || a == 14849) return [a, i];
  if (a < 1 || a > 255) throw Error(`Unexpected SupBook type: ` + a);
  for (var o = DL(e, a), s = []; r > e.l;) s.push(OL(e));
  return [a, i, o, s];
}
function YR(e, t, n) {
  var r = e.read_shift(2),
    i,
    a = {
      fBuiltIn: r & 1,
      fWantAdvise: r >>> 1 & 1,
      fWantPict: r >>> 2 & 1,
      fOle: r >>> 3 & 1,
      fOleLink: r >>> 4 & 1,
      cf: r >>> 5 & 1023,
      fIcon: r >>> 15 & 1
    };
  return n.sbcch === 14849 && (i = qL(e, t - 2, n)), a.body = i || e.read_shift(t - 2), typeof i == `string` && (a.Name = i), a;
}
var XR = [`_xlnm.Consolidate_Area`, `_xlnm.Auto_Open`, `_xlnm.Auto_Close`, `_xlnm.Extract`, `_xlnm.Database`, `_xlnm.Criteria`, `_xlnm.Print_Area`, `_xlnm.Print_Titles`, `_xlnm.Recorder`, `_xlnm.Data_Form`, `_xlnm.Auto_Activate`, `_xlnm.Auto_Deactivate`, `_xlnm.Sheet_Title`, `_xlnm._FilterDatabase`];
function ZR(e, t, n) {
  var r = e.l + t,
    i = e.read_shift(2),
    a = e.read_shift(1),
    o = e.read_shift(1),
    s = e.read_shift(n && n.biff == 2 ? 1 : 2),
    c = 0;
  (!n || n.biff >= 5) && (n.biff != 5 && (e.l += 2), c = e.read_shift(2), n.biff == 5 && (e.l += 2), e.l += 4);
  var l = DL(e, o, n);
  i & 32 && (l = XR[l.charCodeAt(0)]);
  var u = r - e.l;
  n && n.biff == 2 && --u;
  var d = r == e.l || s === 0 || !(u > 0) ? [] : wW(e, u, n, s);
  return {
    chKey: a,
    Name: l,
    itab: c,
    rgce: d
  };
}
function QR(e, t, n) {
  if (n.biff < 8) return $R(e, t, n);
  for (var r = [], i = e.l + t, a = e.read_shift(n.biff > 8 ? 4 : 2); a-- !== 0;) r.push(GL(e, n.biff > 8 ? 12 : 6, n));
  if (e.l != i) throw Error(`Bad ExternSheet: ` + e.l + ` != ` + i);
  return r;
}
function $R(e, t, n) {
  e[e.l + 1] == 3 && e[e.l]++;
  var r = wL(e, t, n);
  return r.charCodeAt(0) == 3 ? r.slice(1) : r;
}
function ez(e, t, n) {
  if (n.biff < 8) {
    e.l += t;
    return;
  }
  var r = e.read_shift(2),
    i = e.read_shift(2);
  return [DL(e, r, n), DL(e, i, n)];
}
function tz(e, t, n) {
  var r = XL(e, 6);
  e.l++;
  var i = e.read_shift(1);
  return t -= 8, [TW(e, t, n), i, r];
}
function nz(e, t, n) {
  var r = ZL(e, 6);
  switch (n.biff) {
    case 2:
      e.l++, t -= 7;
      break;
    case 3:
    case 4:
      e.l += 2, t -= 8;
      break;
    default:
      e.l += 6, t -= 12;
  }
  return [r, SW(e, t, n, r)];
}
function rz(e) {
  return [e.read_shift(4) !== 0, e.read_shift(4) !== 0, e.read_shift(4)];
}
function iz(e, t, n) {
  if (!(n.biff < 8)) {
    var r = e.read_shift(2),
      i = e.read_shift(2),
      a = e.read_shift(2),
      o = e.read_shift(2),
      s = kL(e, 0, n);
    return n.biff < 8 && e.read_shift(1), [{
      r,
      c: i
    }, s, o, a];
  }
}
function az(e, t, n) {
  return iz(e, t, n);
}
function oz(e, t) {
  for (var n = [], r = e.read_shift(2); r--;) n.push(JL(e, t));
  return n;
}
function sz(e) {
  var t = Z(2 + e.length * 8);
  t.write_shift(2, e.length);
  for (var n = 0; n < e.length; ++n) YL(e[n], t);
  return t;
}
function cz(e, t, n) {
  if (n && n.biff < 8) return uz(e, t, n);
  var r = QL(e, 22);
  return {
    cmo: r,
    ft: rR(e, t - 22, r[1])
  };
}
var lz = {
  8: function (e, t) {
    var n = e.l + t;
    e.l += 10;
    var r = e.read_shift(2);
    e.l += 4, e.l += 2, e.l += 2, e.l += 2, e.l += 4;
    var i = e.read_shift(1);
    return e.l += i, e.l = n, {
      fmt: r
    };
  }
};
function uz(e, t, n) {
  e.l += 4;
  var r = e.read_shift(2),
    i = e.read_shift(2),
    a = e.read_shift(2);
  e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 6, t -= 36;
  var o = [];
  return o.push((lz[r] || IP)(e, t, n)), {
    cmo: [i, r, a],
    ft: o
  };
}
function dz(e, t, n) {
  var r = e.l,
    i = ``;
  try {
    e.l += 4;
    var a = (n.lastobj || {
      cmo: [0, 0]
    }).cmo[1];
    [0, 5, 7, 11, 12, 14].indexOf(a) == -1 ? e.l += 6 : jL(e, 6, n);
    var o = e.read_shift(2);
    e.read_shift(2), yL(e, 2);
    var s = e.read_shift(2);
    e.l += s;
    for (var c = 1; c < e.lens.length - 1; ++c) {
      if (e.l - r != e.lens[c]) throw Error(`TxO: bad continue record`);
      var l = e[e.l],
        u = DL(e, e.lens[c + 1] - e.lens[c] - 1);
      if (i += u, i.length >= (l ? o : 2 * o)) break;
    }
    if (i.length !== o && i.length !== o * 2) throw Error(`cchText: ` + o + ` != ` + i.length);
    return e.l = r + t, {
      t: i
    };
  } catch {
    return e.l = r + t, {
      t: i
    };
  }
}
function fz(e, t) {
  var n = JL(e, 8);
  return e.l += 16, [n, LL(e, t - 24)];
}
function pz(e) {
  var t = Z(24),
    n = QP(e[0]);
  t.write_shift(2, n.r), t.write_shift(2, n.r), t.write_shift(2, n.c), t.write_shift(2, n.c);
  for (var r = `d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b`.split(` `), i = 0; i < 16; ++i) t.write_shift(1, parseInt(r[i], 16));
  return ij([t, RL(e[1])]);
}
function mz(e, t) {
  e.read_shift(2);
  var n = JL(e, 8),
    r = e.read_shift((t - 10) / 2, `dbcs-cont`);
  return r = r.replace(oj, ``), [n, r];
}
function hz(e) {
  var t = e[1].Tooltip,
    n = Z(10 + 2 * (t.length + 1));
  n.write_shift(2, 2048);
  var r = QP(e[0]);
  n.write_shift(2, r.r), n.write_shift(2, r.r), n.write_shift(2, r.c), n.write_shift(2, r.c);
  for (var i = 0; i < t.length; ++i) n.write_shift(2, t.charCodeAt(i));
  return n.write_shift(2, 0), n;
}
function gz(e) {
  var t = [0, 0],
    n = e.read_shift(2);
  return t[0] = aI[n] || n, n = e.read_shift(2), t[1] = aI[n] || n, t;
}
function _z(e) {
  return e ||= Z(4), e.write_shift(2, 1), e.write_shift(2, 1), e;
}
function vz(e) {
  for (var t = e.read_shift(2), n = []; t-- > 0;) n.push(BL(e, 8));
  return n;
}
function yz(e) {
  for (var t = e.read_shift(2), n = []; t-- > 0;) n.push(BL(e, 8));
  return n;
}
function bz(e) {
  e.l += 2;
  var t = {
    cxfs: 0,
    crc: 0
  };
  return t.cxfs = e.read_shift(2), t.crc = e.read_shift(4), t;
}
function xz(e, t, n) {
  if (!n.cellStyles) return IP(e, t);
  var r = n && n.biff >= 12 ? 4 : 2,
    i = e.read_shift(r),
    a = e.read_shift(r),
    o = e.read_shift(r),
    s = e.read_shift(r),
    c = e.read_shift(2);
  r == 2 && (e.l += 2);
  var l = {
    s: i,
    e: a,
    w: o,
    ixfe: s,
    flags: c
  };
  return (n.biff >= 5 || !n.biff) && (l.level = c >> 8 & 7), l;
}
function Sz(e, t) {
  var n = Z(12);
  n.write_shift(2, t), n.write_shift(2, t), n.write_shift(2, e.width * 256), n.write_shift(2, 0);
  var r = 0;
  return e.hidden && (r |= 1), n.write_shift(1, r), r = e.level || 0, n.write_shift(1, r), n.write_shift(2, 0), n;
}
function Cz(e, t) {
  var n = {};
  return t < 32 ? n : (e.l += 16, n.header = FF(e, 8), n.footer = FF(e, 8), e.l += 2, n);
}
function wz(e, t, n) {
  var r = {
    area: !1
  };
  if (n.biff != 5) return e.l += t, r;
  var i = e.read_shift(1);
  return e.l += 3, i & 16 && (r.area = !0), r;
}
function Tz(e) {
  for (var t = Z(2 * e), n = 0; n < e; ++n) t.write_shift(2, n + 1);
  return t;
}
var Ez = VL,
  Dz = xL,
  Oz = OL;
function kz(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = e.read_shift(4),
    i = {
      fmt: t,
      env: n,
      len: r,
      data: e.slice(e.l, e.l + r)
    };
  return e.l += r, i;
}
function Az(e, t, n) {
  n.biffguess && n.biff == 5 && (n.biff = 2);
  var r = VL(e, 6);
  ++e.l;
  var i = kL(e, t - 7, n);
  return r.t = `str`, r.val = i, r;
}
function jz(e) {
  var t = VL(e, 6);
  ++e.l;
  var n = FF(e, 8);
  return t.t = `n`, t.val = n, t;
}
function Mz(e, t, n) {
  var r = Z(15);
  return AJ(r, e, t), r.write_shift(8, n, `f`), r;
}
function Nz(e) {
  var t = VL(e, 6);
  ++e.l;
  var n = e.read_shift(2);
  return t.t = `n`, t.val = n, t;
}
function Pz(e, t, n) {
  var r = Z(9);
  return AJ(r, e, t), r.write_shift(2, n), r;
}
function Fz(e) {
  var t = e.read_shift(1);
  return t === 0 ? (e.l++, ``) : e.read_shift(t, `sbcs-cont`);
}
function Iz(e, t) {
  e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += t - 13;
}
function Lz(e, t, n) {
  var r = e.l + t,
    i = VL(e, 6),
    a = DL(e, e.read_shift(2), n);
  return e.l = r, i.t = `str`, i.val = a, i;
}
var Rz = [2, 3, 48, 49, 131, 139, 140, 245],
  zz = function () {
    var e = {
        1: 437,
        2: 850,
        3: 1252,
        4: 1e4,
        100: 852,
        101: 866,
        102: 865,
        103: 861,
        104: 895,
        105: 620,
        106: 737,
        107: 857,
        120: 950,
        121: 949,
        122: 936,
        123: 932,
        124: 874,
        125: 1255,
        126: 1256,
        150: 10007,
        151: 10029,
        152: 10006,
        200: 1250,
        201: 1251,
        202: 1254,
        203: 1253,
        0: 20127,
        8: 865,
        9: 437,
        10: 850,
        11: 437,
        13: 437,
        14: 850,
        15: 437,
        16: 850,
        17: 437,
        18: 850,
        19: 932,
        20: 850,
        21: 437,
        22: 850,
        23: 865,
        24: 437,
        25: 437,
        26: 850,
        27: 437,
        28: 863,
        29: 850,
        31: 852,
        34: 852,
        35: 852,
        36: 860,
        37: 850,
        38: 866,
        55: 850,
        64: 852,
        77: 936,
        78: 949,
        79: 950,
        80: 874,
        87: 1252,
        88: 1252,
        89: 1252,
        108: 863,
        134: 737,
        135: 852,
        136: 857,
        204: 1257,
        255: 16969
      },
      t = AM({
        1: 437,
        2: 850,
        3: 1252,
        4: 1e4,
        100: 852,
        101: 866,
        102: 865,
        103: 861,
        104: 895,
        105: 620,
        106: 737,
        107: 857,
        120: 950,
        121: 949,
        122: 936,
        123: 932,
        124: 874,
        125: 1255,
        126: 1256,
        150: 10007,
        151: 10029,
        152: 10006,
        200: 1250,
        201: 1251,
        202: 1254,
        203: 1253,
        0: 20127
      });
    function n(t, n) {
      var r = [],
        i = ZA(1);
      switch (n.type) {
        case `base64`:
          i = $A(JA(t));
          break;
        case `binary`:
          i = $A(t);
          break;
        case `buffer`:
        case `array`:
          i = t;
      }
      FP(i, 0);
      var a = i.read_shift(1),
        o = !!(a & 136),
        s = !1,
        c = !1;
      switch (a) {
        case 2:
          break;
        case 3:
          break;
        case 48:
          s = !0, o = !0;
          break;
        case 49:
          s = !0, o = !0;
          break;
        case 131:
          break;
        case 139:
          break;
        case 140:
          c = !0;
          break;
        case 245:
          break;
        default:
          throw Error(`DBF Unsupported Version: ` + a.toString(16));
      }
      var l = 0,
        u = 521;
      a == 2 && (l = i.read_shift(2)), i.l += 3, a != 2 && (l = i.read_shift(4)), l > 1048576 && (l = 1e6), a != 2 && (u = i.read_shift(2));
      var d = i.read_shift(2),
        f = n.codepage || 1252;
      a != 2 && (i.l += 16, i.read_shift(1), i[i.l] !== 0 && (f = e[i[i.l]]), i.l += 1, i.l += 2), c && (i.l += 36);
      for (var p = [], m = {}, h = Math.min(i.length, a == 2 ? 521 : u - 10 - (s ? 264 : 0)), g = c ? 32 : 11; i.l < h && i[i.l] != 13;) switch (m = {}, m.name = HA.utils.decode(f, i.slice(i.l, i.l + g)).replace(/[\u0000\r\n].*$/g, ``), i.l += g, m.type = String.fromCharCode(i.read_shift(1)), a != 2 && !c && (m.offset = i.read_shift(4)), m.len = i.read_shift(1), a == 2 && (m.offset = i.read_shift(2)), m.dec = i.read_shift(1), m.name.length && p.push(m), a != 2 && (i.l += c ? 13 : 14), m.type) {
        case `B`:
          (!s || m.len != 8) && n.WTF && console.log(`Skipping ` + m.name + `:` + m.type);
          break;
        case `G`:
        case `P`:
          n.WTF && console.log(`Skipping ` + m.name + `:` + m.type);
          break;
        case `+`:
        case `0`:
        case `@`:
        case `C`:
        case `D`:
        case `F`:
        case `I`:
        case `L`:
        case `M`:
        case `N`:
        case `O`:
        case `T`:
        case `Y`:
          break;
        default:
          throw Error(`Unknown Field Type: ` + m.type);
      }
      if (i[i.l] !== 13 && (i.l = u - 1), i.read_shift(1) !== 13) throw Error(`DBF Terminator not found ` + i.l + ` ` + i[i.l]);
      i.l = u;
      var _ = 0,
        v = 0;
      for (r[0] = [], v = 0; v != p.length; ++v) r[0][v] = p[v].name;
      for (; l-- > 0;) {
        if (i[i.l] === 42) {
          i.l += d;
          continue;
        }
        for (++i.l, r[++_] = [], v = 0, v = 0; v != p.length; ++v) {
          var y = i.slice(i.l, i.l + p[v].len);
          i.l += p[v].len, FP(y, 0);
          var b = HA.utils.decode(f, y);
          switch (p[v].type) {
            case `C`:
              b.trim().length && (r[_][v] = b.replace(/\s+$/, ``));
              break;
            case `D`:
              b.length === 8 ? r[_][v] = new Date(+b.slice(0, 4), b.slice(4, 6) - 1, +b.slice(6, 8)) : r[_][v] = b;
              break;
            case `F`:
              r[_][v] = parseFloat(b.trim());
              break;
            case `+`:
            case `I`:
              r[_][v] = c ? y.read_shift(-4, `i`) ^ 2147483648 : y.read_shift(4, `i`);
              break;
            case `L`:
              switch (b.trim().toUpperCase()) {
                case `Y`:
                case `T`:
                  r[_][v] = !0;
                  break;
                case `N`:
                case `F`:
                  r[_][v] = !1;
                  break;
                case ``:
                case `?`:
                  break;
                default:
                  throw Error(`DBF Unrecognized L:|` + b + `|`);
              }
              break;
            case `M`:
              if (!o) throw Error(`DBF Unexpected MEMO for type ` + a.toString(16));
              r[_][v] = `##MEMO##` + (c ? parseInt(b.trim(), 10) : y.read_shift(4));
              break;
            case `N`:
              b = b.replace(/\u0000/g, ``).trim(), b && b != `.` && (r[_][v] = +b || 0);
              break;
            case `@`:
              r[_][v] = new Date(y.read_shift(-8, `f`) - 621356832e5);
              break;
            case `T`:
              r[_][v] = new Date((y.read_shift(4) - 2440588) * 864e5 + y.read_shift(4));
              break;
            case `Y`:
              r[_][v] = y.read_shift(4, `i`) / 1e4 + y.read_shift(4, `i`) / 1e4 * 2 ** 32;
              break;
            case `O`:
              r[_][v] = -y.read_shift(-8, `f`);
              break;
            case `B`:
              if (s && p[v].len == 8) {
                r[_][v] = y.read_shift(8, `f`);
                break;
              }
            case `G`:
            case `P`:
              y.l += p[v].len;
              break;
            case `0`:
              if (p[v].name === `_NullFlags`) break;
            default:
              throw Error(`DBF Unsupported data type ` + p[v].type);
          }
        }
      }
      if (a != 2 && i.l < i.length && i[i.l++] != 26) throw Error(`DBF EOF Marker missing ` + (i.l - 1) + ` of ` + i.length + ` ` + i[i.l - 1].toString(16));
      return n && n.sheetRows && (r = r.slice(0, n.sheetRows)), n.DBF = p, r;
    }
    function r(e, t) {
      var r = t || {};
      r.dateNF ||= `yyyymmdd`;
      var i = sF(n(e, r), r);
      return i[`!cols`] = r.DBF.map(function (e) {
        return {
          wch: e.len,
          DBF: e
        };
      }), delete r.DBF, i;
    }
    function i(e, t) {
      try {
        return aF(r(e, t), t);
      } catch (e) {
        if (t && t.WTF) throw e;
      }
      return {
        SheetNames: [],
        Sheets: {}
      };
    }
    var a = {
      B: 8,
      C: 250,
      L: 1,
      D: 8,
      "?": 0,
      "": 0
    };
    function o(e, n) {
      var r = n || {};
      if (+r.codepage >= 0 && PA(+r.codepage), r.type == `string`) throw Error(`Cannot write DBF to JS string`);
      var i = RP(),
        o = jX(e, {
          header: 1,
          raw: !0,
          cellDates: !0
        }),
        s = o[0],
        c = o.slice(1),
        l = e[`!cols`] || [],
        u = 0,
        d = 0,
        f = 0,
        p = 1;
      for (u = 0; u < s.length; ++u) {
        if (((l[u] || {}).DBF || {}).name) {
          s[u] = l[u].DBF.name, ++f;
          continue;
        }
        if (s[u] != null) {
          if (++f, typeof s[u] == `number` && (s[u] = s[u].toString(10)), typeof s[u] != `string`) throw Error(`DBF Invalid column name ` + s[u] + ` |` + typeof s[u] + `|`);
          if (s.indexOf(s[u]) !== u) {
            for (d = 0; d < 1024; ++d) if (s.indexOf(s[u] + `_` + d) == -1) {
              s[u] += `_` + d;
              break;
            }
          }
        }
      }
      var m = nF(e[`!ref`]),
        h = [],
        g = [],
        _ = [];
      for (u = 0; u <= m.e.c - m.s.c; ++u) {
        var v = ``,
          y = ``,
          b = 0,
          x = [];
        for (d = 0; d < c.length; ++d) c[d][u] != null && x.push(c[d][u]);
        if (x.length == 0 || s[u] == null) {
          h[u] = `?`;
          continue;
        }
        for (d = 0; d < x.length; ++d) {
          switch (typeof x[d]) {
            case `number`:
              y = `B`;
              break;
            case `string`:
              y = `C`;
              break;
            case `boolean`:
              y = `L`;
              break;
            case `object`:
              y = x[d] instanceof Date ? `D` : `C`;
              break;
            default:
              y = `C`;
          }
          b = Math.max(b, String(x[d]).length), v = v && v != y ? `C` : y;
        }
        b > 250 && (b = 250), y = ((l[u] || {}).DBF || {}).type, y == `C` && l[u].DBF.len > b && (b = l[u].DBF.len), v == `B` && y == `N` && (v = `N`, _[u] = l[u].DBF.dec, b = l[u].DBF.len), g[u] = v == `C` || y == `N` ? b : a[v] || 0, p += g[u], h[u] = v;
      }
      var S = i.next(32);
      for (S.write_shift(4, 318902576), S.write_shift(4, c.length), S.write_shift(2, 296 + 32 * f), S.write_shift(2, p), u = 0; u < 4; ++u) S.write_shift(4, 0);
      for (S.write_shift(4, 0 | (+t[kA] || 3) << 8), u = 0, d = 0; u < s.length; ++u) if (s[u] != null) {
        var C = i.next(32),
          w = (s[u].slice(-10) + `\0\0\0\0\0\0\0\0\0\0\0`).slice(0, 11);
        C.write_shift(1, w, `sbcs`), C.write_shift(1, h[u] == `?` ? `C` : h[u], `sbcs`), C.write_shift(4, d), C.write_shift(1, g[u] || a[h[u]] || 0), C.write_shift(1, _[u] || 0), C.write_shift(1, 2), C.write_shift(4, 0), C.write_shift(1, 0), C.write_shift(4, 0), C.write_shift(4, 0), d += g[u] || a[h[u]] || 0;
      }
      var T = i.next(264);
      for (T.write_shift(4, 13), u = 0; u < 65; ++u) T.write_shift(4, 0);
      for (u = 0; u < c.length; ++u) {
        var E = i.next(p);
        for (E.write_shift(1, 0), d = 0; d < s.length; ++d) if (s[d] != null) switch (h[d]) {
          case `L`:
            E.write_shift(1, c[u][d] == null ? 63 : c[u][d] ? 84 : 70);
            break;
          case `B`:
            E.write_shift(8, c[u][d] || 0, `f`);
            break;
          case `N`:
            var D = `0`;
            for (typeof c[u][d] == `number` && (D = c[u][d].toFixed(_[d] || 0)), f = 0; f < g[d] - D.length; ++f) E.write_shift(1, 32);
            E.write_shift(1, D, `sbcs`);
            break;
          case `D`:
            c[u][d] ? (E.write_shift(4, (`0000` + c[u][d].getFullYear()).slice(-4), `sbcs`), E.write_shift(2, (`00` + (c[u][d].getMonth() + 1)).slice(-2), `sbcs`), E.write_shift(2, (`00` + c[u][d].getDate()).slice(-2), `sbcs`)) : E.write_shift(8, `00000000`, `sbcs`);
            break;
          case `C`:
            var O = String(c[u][d] == null ? `` : c[u][d]).slice(0, g[d]);
            for (E.write_shift(1, O, `sbcs`), f = 0; f < g[d] - O.length; ++f) E.write_shift(1, 32);
        }
      }
      return i.next(1).write_shift(1, 26), i.end();
    }
    return {
      to_workbook: i,
      to_sheet: r,
      from_sheet: o
    };
  }(),
  Bz = function () {
    var e = {
        AA: `À`,
        BA: `Á`,
        CA: `Â`,
        DA: 195,
        HA: `Ä`,
        JA: 197,
        AE: `È`,
        BE: `É`,
        CE: `Ê`,
        HE: `Ë`,
        AI: `Ì`,
        BI: `Í`,
        CI: `Î`,
        HI: `Ï`,
        AO: `Ò`,
        BO: `Ó`,
        CO: `Ô`,
        DO: 213,
        HO: `Ö`,
        AU: `Ù`,
        BU: `Ú`,
        CU: `Û`,
        HU: `Ü`,
        Aa: `à`,
        Ba: `á`,
        Ca: `â`,
        Da: 227,
        Ha: `ä`,
        Ja: 229,
        Ae: `è`,
        Be: `é`,
        Ce: `ê`,
        He: `ë`,
        Ai: `ì`,
        Bi: `í`,
        Ci: `î`,
        Hi: `ï`,
        Ao: `ò`,
        Bo: `ó`,
        Co: `ô`,
        Do: 245,
        Ho: `ö`,
        Au: `ù`,
        Bu: `ú`,
        Cu: `û`,
        Hu: `ü`,
        KC: `Ç`,
        Kc: `ç`,
        q: `æ`,
        z: `œ`,
        a: `Æ`,
        j: `Œ`,
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
      },
      t = RegExp(`\x1BN(` + OM(e).join(`|`).replace(/\|\|\|/, `|\\||`).replace(/([?()+])/g, `\\$1`) + `|\\|)`, `gm`),
      n = function (t, n) {
        var r = e[n];
        return typeof r == `number` ? VA(r) : r;
      },
      r = function (e, t, n) {
        var r = t.charCodeAt(0) - 32 << 4 | n.charCodeAt(0) - 48;
        return r == 59 ? e : VA(r);
      };
    e[`|`] = 254;
    function i(e, t) {
      switch (t.type) {
        case `base64`:
          return a(JA(e), t);
        case `binary`:
          return a(e, t);
        case `buffer`:
          return a(YA && Buffer.isBuffer(e) ? e.toString(`binary`) : tj(e), t);
        case `array`:
          return a(WM(e), t);
      }
      throw Error(`Unrecognized type ` + t.type);
    }
    function a(e, i) {
      var a = e.split(/[\n\r]+/),
        o = -1,
        s = -1,
        c = 0,
        l = 0,
        u = [],
        d = [],
        f = null,
        p = {},
        m = [],
        h = [],
        g = [],
        _ = 0,
        v;
      for (+i.codepage >= 0 && PA(+i.codepage); c !== a.length; ++c) {
        _ = 0;
        var y = a[c].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, r).replace(t, n),
          b = y.replace(/;;/g, `\0`).split(`;`).map(function (e) {
            return e.replace(/\u0000/g, `;`);
          }),
          x = b[0],
          S;
        if (y.length > 0) switch (x) {
          case `ID`:
            break;
          case `E`:
            break;
          case `B`:
            break;
          case `O`:
            break;
          case `W`:
            break;
          case `P`:
            b[1].charAt(0) == `P` && d.push(y.slice(3).replace(/;;/g, `;`));
            break;
          case `C`:
            var C = !1,
              w = !1,
              T = !1,
              E = !1,
              D = -1,
              O = -1;
            for (l = 1; l < b.length; ++l) switch (b[l].charAt(0)) {
              case `A`:
                break;
              case `X`:
                s = parseInt(b[l].slice(1)) - 1, w = !0;
                break;
              case `Y`:
                for (o = parseInt(b[l].slice(1)) - 1, w || (s = 0), v = u.length; v <= o; ++v) u[v] = [];
                break;
              case `K`:
                S = b[l].slice(1), S.charAt(0) === `"` ? S = S.slice(1, S.length - 1) : S === `TRUE` ? S = !0 : S === `FALSE` ? S = !1 : isNaN(qM(S)) ? isNaN(YM(S).getDate()) || (S = UM(S)) : (S = qM(S), f !== null && sM(f) && (S = RM(S))), HA !== void 0 && typeof S == `string` && (i || {}).type != `string` && (i || {}).codepage && (S = HA.utils.decode(i.codepage, S)), C = !0;
                break;
              case `E`:
                E = !0;
                var k = BH(b[l].slice(1), {
                  r: o,
                  c: s
                });
                u[o][s] = [u[o][s], k];
                break;
              case `S`:
                T = !0, u[o][s] = [u[o][s], `S5S`];
                break;
              case `G`:
                break;
              case `R`:
                D = parseInt(b[l].slice(1)) - 1;
                break;
              case `C`:
                O = parseInt(b[l].slice(1)) - 1;
                break;
              default:
                if (i && i.WTF) throw Error(`SYLK bad record ` + y);
            }
            if (C && (u[o][s] && u[o][s].length == 2 ? u[o][s][0] = S : u[o][s] = S, f = null), T) {
              if (E) throw Error(`SYLK shared formula cannot have own formula`);
              var A = D > -1 && u[D][O];
              if (!A || !A[1]) throw Error(`SYLK shared formula cannot find base`);
              u[o][s][1] = UH(A[1], {
                r: o - D,
                c: s - O
              });
            }
            break;
          case `F`:
            var j = 0;
            for (l = 1; l < b.length; ++l) switch (b[l].charAt(0)) {
              case `X`:
                s = parseInt(b[l].slice(1)) - 1, ++j;
                break;
              case `Y`:
                for (o = parseInt(b[l].slice(1)) - 1, v = u.length; v <= o; ++v) u[v] = [];
                break;
              case `M`:
                _ = parseInt(b[l].slice(1)) / 20;
                break;
              case `F`:
                break;
              case `G`:
                break;
              case `P`:
                f = d[parseInt(b[l].slice(1))];
                break;
              case `S`:
                break;
              case `D`:
                break;
              case `N`:
                break;
              case `W`:
                for (g = b[l].slice(1).split(` `), v = parseInt(g[0], 10); v <= parseInt(g[1], 10); ++v) _ = parseInt(g[2], 10), h[v - 1] = _ === 0 ? {
                  hidden: !0
                } : {
                  wch: _
                }, JB(h[v - 1]);
                break;
              case `C`:
                s = parseInt(b[l].slice(1)) - 1, h[s] || (h[s] = {});
                break;
              case `R`:
                o = parseInt(b[l].slice(1)) - 1, m[o] || (m[o] = {}), _ > 0 ? (m[o].hpt = _, m[o].hpx = ZB(_)) : _ === 0 && (m[o].hidden = !0);
                break;
              default:
                if (i && i.WTF) throw Error(`SYLK bad record ` + y);
            }
            j < 1 && (f = null);
            break;
          default:
            if (i && i.WTF) throw Error(`SYLK bad record ` + y);
        }
      }
      return m.length > 0 && (p[`!rows`] = m), h.length > 0 && (p[`!cols`] = h), i && i.sheetRows && (u = u.slice(0, i.sheetRows)), [u, p];
    }
    function o(e, t) {
      var n = i(e, t),
        r = n[0],
        a = n[1],
        o = sF(r, t);
      return OM(a).forEach(function (e) {
        o[e] = a[e];
      }), o;
    }
    function s(e, t) {
      return aF(o(e, t), t);
    }
    function c(e, t, n, r) {
      var i = `C;Y` + (n + 1) + `;X` + (r + 1) + `;K`;
      switch (e.t) {
        case `n`:
          i += e.v || 0, e.f && !e.F && (i += `;E` + HH(e.f, {
            r: n,
            c: r
          }));
          break;
        case `b`:
          i += e.v ? `TRUE` : `FALSE`;
          break;
        case `e`:
          i += e.w || e.v;
          break;
        case `d`:
          i += `"` + (e.w || e.v) + `"`;
          break;
        case `s`:
          i += `"` + e.v.replace(/"/g, ``).replace(/;/g, `;;`) + `"`;
      }
      return i;
    }
    function l(e, t) {
      t.forEach(function (t, n) {
        var r = `F;W` + (n + 1) + ` ` + (n + 1) + ` `;
        t.hidden ? r += `0` : (typeof t.width == `number` && !t.wpx && (t.wpx = UB(t.width)), typeof t.wpx == `number` && !t.wch && (t.wch = WB(t.wpx)), typeof t.wch == `number` && (r += Math.round(t.wch))), r.charAt(r.length - 1) != ` ` && e.push(r);
      });
    }
    function u(e, t) {
      t.forEach(function (t, n) {
        var r = `F;`;
        t.hidden ? r += `M0;` : t.hpt ? r += `M` + 20 * t.hpt + `;` : t.hpx && (r += `M` + 20 * XB(t.hpx) + `;`), r.length > 2 && e.push(r + `R` + (n + 1));
      });
    }
    function d(e, t) {
      var n = [`ID;PWXL;N;E`],
        r = [],
        i = nF(e[`!ref`]),
        a,
        o = Array.isArray(e),
        s = `\r
`;
      n.push(`P;PGeneral`), n.push(`F;P0;DG0G8;M255`), e[`!cols`] && l(n, e[`!cols`]), e[`!rows`] && u(n, e[`!rows`]), n.push(`B;Y` + (i.e.r - i.s.r + 1) + `;X` + (i.e.c - i.s.c + 1) + `;D` + [i.s.c, i.s.r, i.e.c, i.e.r].join(` `));
      for (var d = i.s.r; d <= i.e.r; ++d) for (var f = i.s.c; f <= i.e.c; ++f) {
        var p = $P({
          r: d,
          c: f
        });
        a = o ? (e[d] || [])[f] : e[p], a && (a.v != null || a.f && !a.F) && r.push(c(a, e, d, f, t));
      }
      return n.join(s) + s + r.join(s) + s + `E` + s;
    }
    return {
      to_workbook: s,
      to_sheet: o,
      from_sheet: d
    };
  }(),
  Vz = function () {
    function e(e, n) {
      switch (n.type) {
        case `base64`:
          return t(JA(e), n);
        case `binary`:
          return t(e, n);
        case `buffer`:
          return t(YA && Buffer.isBuffer(e) ? e.toString(`binary`) : tj(e), n);
        case `array`:
          return t(WM(e), n);
      }
      throw Error(`Unrecognized type ` + n.type);
    }
    function t(e, t) {
      for (var n = e.split(`
`), r = -1, i = -1, a = 0, o = []; a !== n.length; ++a) {
        if (n[a].trim() === `BOT`) {
          o[++r] = [], i = 0;
          continue;
        }
        if (!(r < 0)) {
          var s = n[a].trim().split(`,`),
            c = s[0],
            l = s[1];
          ++a;
          for (var u = n[a] || ``; (u.match(/["]/g) || []).length & 1 && a < n.length - 1;) u += `
` + n[++a];
          switch (u = u.trim(), +c) {
            case -1:
              if (u === `BOT`) {
                o[++r] = [], i = 0;
                continue;
              }
              if (u !== `EOD`) throw Error(`Unrecognized DIF special command ` + u);
              break;
            case 0:
              u === `TRUE` ? o[r][i] = !0 : u === `FALSE` ? o[r][i] = !1 : isNaN(qM(l)) ? isNaN(YM(l).getDate()) ? o[r][i] = l : o[r][i] = UM(l) : o[r][i] = qM(l), ++i;
              break;
            case 1:
              u = u.slice(1, u.length - 1), u = u.replace(/""/g, `"`), GA && u && u.match(/^=".*"$/) && (u = u.slice(2, -1)), o[r][i++] = u === `` ? null : u;
          }
          if (u === `EOD`) break;
        }
      }
      return t && t.sheetRows && (o = o.slice(0, t.sheetRows)), o;
    }
    function n(t, n) {
      return sF(e(t, n), n);
    }
    function r(e, t) {
      return aF(n(e, t), t);
    }
    return {
      to_workbook: r,
      to_sheet: n,
      from_sheet: function () {
        var e = function (e, t, n, r, i) {
            e.push(t), e.push(n + `,` + r), e.push(`"` + i.replace(/"/g, `""`) + `"`);
          },
          t = function (e, t, n, r) {
            e.push(t + `,` + n), e.push(t == 1 ? `"` + r.replace(/"/g, `""`) + `"` : r);
          };
        return function (n) {
          var r = [],
            i = nF(n[`!ref`]),
            a,
            o = Array.isArray(n);
          e(r, `TABLE`, 0, 1, `sheetjs`), e(r, `VECTORS`, 0, i.e.r - i.s.r + 1, ``), e(r, `TUPLES`, 0, i.e.c - i.s.c + 1, ``), e(r, `DATA`, 0, 0, ``);
          for (var s = i.s.r; s <= i.e.r; ++s) {
            t(r, -1, 0, `BOT`);
            for (var c = i.s.c; c <= i.e.c; ++c) {
              var l = $P({
                r: s,
                c
              });
              if (a = o ? (n[s] || [])[c] : n[l], !a) {
                t(r, 1, 0, ``);
                continue;
              }
              switch (a.t) {
                case `n`:
                  var u = GA ? a.w : a.v;
                  !u && a.v != null && (u = a.v), u == null ? GA && a.f && !a.F ? t(r, 1, 0, `=` + a.f) : t(r, 1, 0, ``) : t(r, 0, u, `V`);
                  break;
                case `b`:
                  t(r, 0, +!!a.v, a.v ? `TRUE` : `FALSE`);
                  break;
                case `s`:
                  t(r, 1, 0, !GA || isNaN(a.v) ? a.v : `="` + a.v + `"`);
                  break;
                case `d`:
                  a.w || (a.w = fM(a.z || bj[14], PM(UM(a.v)))), GA ? t(r, 0, a.w, `V`) : t(r, 1, 0, a.w);
                  break;
                default:
                  t(r, 1, 0, ``);
              }
            }
          }
          return t(r, -1, 0, `EOD`), r.join(`\r
`);
        };
      }()
    };
  }(),
  Hz = function () {
    function e(e) {
      return e.replace(/\\b/g, `\\`).replace(/\\c/g, `:`).replace(/\\n/g, `
`);
    }
    function t(e) {
      return e.replace(/\\/g, `\\b`).replace(/:/g, `\\c`).replace(/\n/g, `\\n`);
    }
    function n(t, n) {
      for (var r = t.split(`
`), i = -1, a = -1, o = 0, s = []; o !== r.length; ++o) {
        var c = r[o].trim().split(`:`);
        if (c[0] === `cell`) {
          var l = QP(c[1]);
          if (s.length <= l.r) for (i = s.length; i <= l.r; ++i) s[i] || (s[i] = []);
          switch (i = l.r, a = l.c, c[2]) {
            case `t`:
              s[i][a] = e(c[3]);
              break;
            case `v`:
              s[i][a] = +c[3];
              break;
            case `vtf`:
              var u = c[c.length - 1];
            case `vtc`:
              switch (c[3]) {
                case `nl`:
                  s[i][a] = !!+c[4];
                  break;
                default:
                  s[i][a] = +c[4];
              }
              c[2] == `vtf` && (s[i][a] = [s[i][a], u]);
          }
        }
      }
      return n && n.sheetRows && (s = s.slice(0, n.sheetRows)), s;
    }
    function r(e, t) {
      return sF(n(e, t), t);
    }
    function i(e, t) {
      return aF(r(e, t), t);
    }
    var a = [`socialcalc:version:1.5`, `MIME-Version: 1.0`, `Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave`].join(`
`),
      o = [`--SocialCalcSpreadsheetControlSave`, `Content-type: text/plain; charset=UTF-8`].join(`
`) + `
`,
      s = [`# SocialCalc Spreadsheet Control Save`, `part:sheet`].join(`
`),
      c = `--SocialCalcSpreadsheetControlSave--`;
    function l(e) {
      if (!e || !e[`!ref`]) return ``;
      for (var n = [], r = [], i, a = ``, o = eF(e[`!ref`]), s = Array.isArray(e), c = o.s.r; c <= o.e.r; ++c) for (var l = o.s.c; l <= o.e.c; ++l) if (a = $P({
        r: c,
        c: l
      }), i = s ? (e[c] || [])[l] : e[a], i && i.v != null && i.t !== `z`) {
        switch (r = [`cell`, a, `t`], i.t) {
          case `s`:
          case `str`:
            r.push(t(i.v));
            break;
          case `n`:
            i.f ? (r[2] = `vtf`, r[3] = `n`, r[4] = i.v, r[5] = t(i.f)) : (r[2] = `v`, r[3] = i.v);
            break;
          case `b`:
            r[2] = `vt` + (i.f ? `f` : `c`), r[3] = `nl`, r[4] = i.v ? `1` : `0`, r[5] = t(i.f || (i.v ? `TRUE` : `FALSE`));
            break;
          case `d`:
            var u = PM(UM(i.v));
            r[2] = `vtc`, r[3] = `nd`, r[4] = `` + u, r[5] = i.w || fM(i.z || bj[14], u);
            break;
          case `e`:
            continue;
        }
        n.push(r.join(`:`));
      }
      return n.push(`sheet:c:` + (o.e.c - o.s.c + 1) + `:r:` + (o.e.r - o.s.r + 1) + `:tvf:1`), n.push(`valueformat:1:text-wiki`), n.join(`
`);
    }
    function u(e) {
      return [a, o, s, o, l(e), c].join(`
`);
    }
    return {
      to_workbook: i,
      to_sheet: r,
      from_sheet: u
    };
  }(),
  Uz = function () {
    function e(e, t, n, r, i) {
      i.raw ? t[n][r] = e : e === `` || (e === `TRUE` ? t[n][r] = !0 : e === `FALSE` ? t[n][r] = !1 : isNaN(qM(e)) ? isNaN(YM(e).getDate()) ? t[n][r] = e : t[n][r] = UM(e) : t[n][r] = qM(e));
    }
    function t(t, n) {
      var r = n || {},
        i = [];
      if (!t || t.length === 0) return i;
      for (var a = t.split(/[\r\n]/), o = a.length - 1; o >= 0 && a[o].length === 0;) --o;
      for (var s = 10, c = 0, l = 0; l <= o; ++l) c = a[l].indexOf(` `), c == -1 ? c = a[l].length : c++, s = Math.max(s, c);
      for (l = 0; l <= o; ++l) {
        i[l] = [];
        var u = 0;
        for (e(a[l].slice(0, s).trim(), i, l, u, r), u = 1; u <= (a[l].length - s) / 10 + 1; ++u) e(a[l].slice(s + (u - 1) * 10, s + u * 10).trim(), i, l, u, r);
      }
      return r.sheetRows && (i = i.slice(0, r.sheetRows)), i;
    }
    var n = {
        44: `,`,
        9: `	`,
        59: `;`,
        124: `|`
      },
      r = {
        44: 3,
        9: 2,
        59: 1,
        124: 0
      };
    function i(e) {
      for (var t = {}, i = !1, a = 0, o = 0; a < e.length; ++a) (o = e.charCodeAt(a)) == 34 ? i = !i : !i && o in n && (t[o] = (t[o] || 0) + 1);
      for (a in o = [], t) Object.prototype.hasOwnProperty.call(t, a) && o.push([t[a], a]);
      if (!o.length) for (a in t = r, t) Object.prototype.hasOwnProperty.call(t, a) && o.push([t[a], a]);
      return o.sort(function (e, t) {
        return e[0] - t[0] || r[e[1]] - r[t[1]];
      }), n[o.pop()[1]] || 44;
    }
    function a(e, t) {
      var n = t || {},
        r = ``;
      WA != null && n.dense == null && (n.dense = WA);
      var a = n.dense ? [] : {},
        o = {
          s: {
            c: 0,
            r: 0
          },
          e: {
            c: 0,
            r: 0
          }
        };
      e.slice(0, 4) == `sep=` ? e.charCodeAt(5) == 13 && e.charCodeAt(6) == 10 ? (r = e.charAt(4), e = e.slice(7)) : e.charCodeAt(5) == 13 || e.charCodeAt(5) == 10 ? (r = e.charAt(4), e = e.slice(6)) : r = i(e.slice(0, 1024)) : r = n && n.FS ? n.FS : i(e.slice(0, 1024));
      var s = 0,
        c = 0,
        l = 0,
        u = 0,
        d = 0,
        f = r.charCodeAt(0),
        p = !1,
        m = 0,
        h = e.charCodeAt(0);
      e = e.replace(/\r\n/gm, `
`);
      var g = n.dateNF == null ? null : yM(n.dateNF);
      function _() {
        var t = e.slice(u, d),
          r = {};
        if (t.charAt(0) == `"` && t.charAt(t.length - 1) == `"` && (t = t.slice(1, -1).replace(/""/g, `"`)), t.length === 0) r.t = `z`;else if (n.raw) r.t = `s`, r.v = t;else if (t.trim().length === 0) r.t = `s`, r.v = t;else if (t.charCodeAt(0) == 61) t.charCodeAt(1) == 34 && t.charCodeAt(t.length - 1) == 34 ? (r.t = `s`, r.v = t.slice(2, -1).replace(/""/g, `"`)) : GH(t) ? (r.t = `n`, r.f = t.slice(1)) : (r.t = `s`, r.v = t);else if (t == `TRUE`) r.t = `b`, r.v = !0;else if (t == `FALSE`) r.t = `b`, r.v = !1;else if (!isNaN(l = qM(t))) r.t = `n`, n.cellText !== !1 && (r.w = t), r.v = l;else if (!isNaN(YM(t).getDate()) || g && t.match(g)) {
          r.z = n.dateNF || bj[14];
          var i = 0;
          g && t.match(g) && (t = bM(t, n.dateNF, t.match(g) || []), i = 1), n.cellDates ? (r.t = `d`, r.v = UM(t, i)) : (r.t = `n`, r.v = PM(UM(t, i))), n.cellText !== !1 && (r.w = fM(r.z, r.v instanceof Date ? PM(r.v) : r.v)), n.cellNF || delete r.z;
        } else r.t = `s`, r.v = t;
        if (r.t == `z` || (n.dense ? (a[s] || (a[s] = []), a[s][c] = r) : a[$P({
          c,
          r: s
        })] = r), u = d + 1, h = e.charCodeAt(u), o.e.c < c && (o.e.c = c), o.e.r < s && (o.e.r = s), m == f) ++c;else if (c = 0, ++s, n.sheetRows && n.sheetRows <= s) return !0;
      }
      outer: for (; d < e.length; ++d) switch (m = e.charCodeAt(d)) {
        case 34:
          h === 34 && (p = !p);
          break;
        case f:
        case 10:
        case 13:
          if (!p && _()) break outer;
      }
      return d - u > 0 && _(), a[`!ref`] = tF(o), a;
    }
    function o(e, n) {
      return !(n && n.PRN) || n.FS || e.slice(0, 4) == `sep=` || e.indexOf(`	`) >= 0 || e.indexOf(`,`) >= 0 || e.indexOf(`;`) >= 0 ? a(e, n) : sF(t(e, n), n);
    }
    function s(e, t) {
      var n = ``,
        r = t.type == `string` ? [0, 0, 0, 0] : oX(e, t);
      switch (t.type) {
        case `base64`:
          n = JA(e);
          break;
        case `binary`:
          n = e;
          break;
        case `buffer`:
          n = t.codepage == 65001 ? e.toString(`utf8`) : t.codepage && HA !== void 0 ? HA.utils.decode(t.codepage, e) : YA && Buffer.isBuffer(e) ? e.toString(`binary`) : tj(e);
          break;
        case `array`:
          n = WM(e);
          break;
        case `string`:
          n = e;
          break;
        default:
          throw Error(`Unrecognized type ` + t.type);
      }
      return r[0] == 239 && r[1] == 187 && r[2] == 191 ? n = FN(n.slice(3)) : t.type != `string` && t.type != `buffer` && t.codepage == 65001 ? n = FN(n) : t.type == `binary` && HA !== void 0 && t.codepage && (n = HA.utils.decode(t.codepage, HA.utils.encode(28591, n))), n.slice(0, 19) == `socialcalc:version:` ? Hz.to_sheet(t.type == `string` ? n : FN(n), t) : o(n, t);
    }
    function c(e, t) {
      return aF(s(e, t), t);
    }
    function l(e) {
      for (var t = [], n = nF(e[`!ref`]), r, i = Array.isArray(e), a = n.s.r; a <= n.e.r; ++a) {
        for (var o = [], s = n.s.c; s <= n.e.c; ++s) {
          var c = $P({
            r: a,
            c: s
          });
          if (r = i ? (e[a] || [])[s] : e[c], !r || r.v == null) {
            o.push(`          `);
            continue;
          }
          for (var l = (r.w || (iF(r), r.w) || ``).slice(0, 10); l.length < 10;) l += ` `;
          o.push(l + (s === 0 ? ` ` : ``));
        }
        t.push(o.join(``));
      }
      return t.join(`
`);
    }
    return {
      to_workbook: c,
      to_sheet: s,
      from_sheet: l
    };
  }();
function Wz(e, t) {
  var n = t || {},
    r = !!n.WTF;
  n.WTF = !0;
  try {
    var i = Bz.to_workbook(e, n);
    return n.WTF = r, i;
  } catch (i) {
    if (n.WTF = r, !i.message.match(/SYLK bad record ID/) && r) throw i;
    return Uz.to_workbook(e, t);
  }
}
var Gz = function () {
  function e(e, t, n) {
    if (e) {
      FP(e, e.l || 0);
      for (var r = n.Enum || I; e.l < e.length;) {
        var i = e.read_shift(2),
          a = r[i] || r[65535],
          o = e.read_shift(2),
          s = e.l + o,
          c = a.f && a.f(e, o, n);
        if (e.l = s, t(c, a, i)) return;
      }
    }
  }
  function t(e, t) {
    switch (t.type) {
      case `base64`:
        return n($A(JA(e)), t);
      case `binary`:
        return n($A(e), t);
      case `buffer`:
      case `array`:
        return n(e, t);
    }
    throw `Unsupported type ` + t.type;
  }
  function n(t, n) {
    if (!t) return t;
    var r = n || {};
    WA != null && r.dense == null && (r.dense = WA);
    var i = r.dense ? [] : {},
      a = `Sheet1`,
      o = ``,
      s = 0,
      c = {},
      l = [],
      u = [],
      d = {
        s: {
          r: 0,
          c: 0
        },
        e: {
          r: 0,
          c: 0
        }
      },
      f = r.sheetRows || 0;
    if (t[2] == 0 && (t[3] == 8 || t[3] == 9) && t.length >= 16 && t[14] == 5 && t[15] === 108) throw Error(`Unsupported Works 3 for Mac file`);
    if (t[2] == 2) r.Enum = I, e(t, function (e, t, n) {
      switch (n) {
        case 0:
          r.vers = e, e >= 4096 && (r.qpro = !0);
          break;
        case 6:
          d = e;
          break;
        case 204:
          e && (o = e);
          break;
        case 222:
          o = e;
          break;
        case 15:
        case 51:
          r.qpro || (e[1].v = e[1].v.slice(1));
        case 13:
        case 14:
        case 16:
          n == 14 && (e[2] & 112) == 112 && (e[2] & 15) > 1 && (e[2] & 15) < 15 && (e[1].z = r.dateNF || bj[14], r.cellDates && (e[1].t = `d`, e[1].v = RM(e[1].v))), r.qpro && e[3] > s && (i[`!ref`] = tF(d), c[a] = i, l.push(a), i = r.dense ? [] : {}, d = {
            s: {
              r: 0,
              c: 0
            },
            e: {
              r: 0,
              c: 0
            }
          }, s = e[3], a = o || `Sheet` + (s + 1), o = ``);
          var u = r.dense ? (i[e[0].r] || [])[e[0].c] : i[$P(e[0])];
          if (u) {
            u.t = e[1].t, u.v = e[1].v, e[1].z != null && (u.z = e[1].z), e[1].f != null && (u.f = e[1].f);
            break;
          }
          r.dense ? (i[e[0].r] || (i[e[0].r] = []), i[e[0].r][e[0].c] = e[1]) : i[$P(e[0])] = e[1];
      }
    }, r);else if (t[2] == 26 || t[2] == 14) r.Enum = L, t[2] == 14 && (r.qpro = !0, t.l = 0), e(t, function (e, t, n) {
      switch (n) {
        case 204:
          a = e;
          break;
        case 22:
          e[1].v = e[1].v.slice(1);
        case 23:
        case 24:
        case 25:
        case 37:
        case 39:
        case 40:
          if (e[3] > s && (i[`!ref`] = tF(d), c[a] = i, l.push(a), i = r.dense ? [] : {}, d = {
            s: {
              r: 0,
              c: 0
            },
            e: {
              r: 0,
              c: 0
            }
          }, s = e[3], a = `Sheet` + (s + 1)), f > 0 && e[0].r >= f) break;
          r.dense ? (i[e[0].r] || (i[e[0].r] = []), i[e[0].r][e[0].c] = e[1]) : i[$P(e[0])] = e[1], d.e.c < e[0].c && (d.e.c = e[0].c), d.e.r < e[0].r && (d.e.r = e[0].r);
          break;
        case 27:
          e[14e3] && (u[e[14e3][0]] = e[14e3][1]);
          break;
        case 1537:
          u[e[0]] = e[1], e[0] == s && (a = e[1]);
      }
    }, r);else throw Error(`Unrecognized LOTUS BOF ` + t[2]);
    if (i[`!ref`] = tF(d), c[o || a] = i, l.push(o || a), !u.length) return {
      SheetNames: l,
      Sheets: c
    };
    for (var p = {}, m = [], h = 0; h < u.length; ++h) c[l[h]] ? (m.push(u[h] || l[h]), p[u[h]] = c[u[h]] || c[l[h]]) : (m.push(u[h]), p[u[h]] = {
      "!ref": `A1`
    });
    return {
      SheetNames: m,
      Sheets: p
    };
  }
  function r(e, t) {
    var n = t || {};
    if (+n.codepage >= 0 && PA(+n.codepage), n.type == `string`) throw Error(`Cannot write WK1 to JS string`);
    var r = RP(),
      i = nF(e[`!ref`]),
      o = Array.isArray(e),
      s = [];
    OJ(r, 0, a(1030)), OJ(r, 6, c(i));
    for (var l = Math.min(i.e.r, 8191), u = i.s.r; u <= l; ++u) for (var f = WP(u), m = i.s.c; m <= i.e.c; ++m) {
      u === i.s.r && (s[m] = JP(m));
      var g = s[m] + f,
        _ = o ? (e[u] || [])[m] : e[g];
      if (_ && _.t != `z`) {
        if (_.t == `n`) (_.v | 0) == _.v && _.v >= -32768 && _.v <= 32767 ? OJ(r, 13, p(u, m, _.v)) : OJ(r, 14, h(u, m, _.v));else {
          var v = iF(_);
          OJ(r, 15, d(u, m, v.slice(0, 239)));
        }
      }
    }
    return OJ(r, 1), r.end();
  }
  function i(e, t) {
    var n = t || {};
    if (+n.codepage >= 0 && PA(+n.codepage), n.type == `string`) throw Error(`Cannot write WK3 to JS string`);
    var r = RP();
    OJ(r, 0, o(e));
    for (var i = 0, a = 0; i < e.SheetNames.length; ++i) (e.Sheets[e.SheetNames[i]] || {})[`!ref`] && OJ(r, 27, F(e.SheetNames[i], a++));
    var s = 0;
    for (i = 0; i < e.SheetNames.length; ++i) {
      var c = e.Sheets[e.SheetNames[i]];
      if (c && c[`!ref`]) {
        for (var l = nF(c[`!ref`]), u = Array.isArray(c), d = [], f = Math.min(l.e.r, 8191), p = l.s.r; p <= f; ++p) for (var m = WP(p), h = l.s.c; h <= l.e.c; ++h) {
          p === l.s.r && (d[h] = JP(h));
          var g = d[h] + m,
            _ = u ? (c[p] || [])[h] : c[g];
          if (_ && _.t != `z`) {
            if (_.t == `n`) OJ(r, 23, E(p, h, s, _.v));else {
              var v = iF(_);
              OJ(r, 22, C(p, h, s, v.slice(0, 239)));
            }
          }
        }
        ++s;
      }
    }
    return OJ(r, 1), r.end();
  }
  function a(e) {
    var t = Z(2);
    return t.write_shift(2, e), t;
  }
  function o(e) {
    var t = Z(26);
    t.write_shift(2, 4096), t.write_shift(2, 4), t.write_shift(4, 0);
    for (var n = 0, r = 0, i = 0, a = 0; a < e.SheetNames.length; ++a) {
      var o = e.SheetNames[a],
        s = e.Sheets[o];
      if (s && s[`!ref`]) {
        ++i;
        var c = eF(s[`!ref`]);
        n < c.e.r && (n = c.e.r), r < c.e.c && (r = c.e.c);
      }
    }
    return n > 8191 && (n = 8191), t.write_shift(2, n), t.write_shift(1, i), t.write_shift(1, r), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(1, 1), t.write_shift(1, 2), t.write_shift(4, 0), t.write_shift(4, 0), t;
  }
  function s(e, t, n) {
    var r = {
      s: {
        c: 0,
        r: 0
      },
      e: {
        c: 0,
        r: 0
      }
    };
    return t == 8 && n.qpro ? (r.s.c = e.read_shift(1), e.l++, r.s.r = e.read_shift(2), r.e.c = e.read_shift(1), e.l++, r.e.r = e.read_shift(2), r) : (r.s.c = e.read_shift(2), r.s.r = e.read_shift(2), t == 12 && n.qpro && (e.l += 2), r.e.c = e.read_shift(2), r.e.r = e.read_shift(2), t == 12 && n.qpro && (e.l += 2), r.s.c == 65535 && (r.s.c = r.e.c = r.s.r = r.e.r = 0), r);
  }
  function c(e) {
    var t = Z(8);
    return t.write_shift(2, e.s.c), t.write_shift(2, e.s.r), t.write_shift(2, e.e.c), t.write_shift(2, e.e.r), t;
  }
  function l(e, t, n) {
    var r = [{
      c: 0,
      r: 0
    }, {
      t: `n`,
      v: 0
    }, 0, 0];
    return n.qpro && n.vers != 20768 ? (r[0].c = e.read_shift(1), r[3] = e.read_shift(1), r[0].r = e.read_shift(2), e.l += 2) : (r[2] = e.read_shift(1), r[0].c = e.read_shift(2), r[0].r = e.read_shift(2)), r;
  }
  function u(e, t, n) {
    var r = e.l + t,
      i = l(e, t, n);
    if (i[1].t = `s`, n.vers == 20768) {
      e.l++;
      var a = e.read_shift(1);
      return i[1].v = e.read_shift(a, `utf8`), i;
    }
    return n.qpro && e.l++, i[1].v = e.read_shift(r - e.l, `cstr`), i;
  }
  function d(e, t, n) {
    var r = Z(7 + n.length);
    r.write_shift(1, 255), r.write_shift(2, t), r.write_shift(2, e), r.write_shift(1, 39);
    for (var i = 0; i < r.length; ++i) {
      var a = n.charCodeAt(i);
      r.write_shift(1, a >= 128 ? 95 : a);
    }
    return r.write_shift(1, 0), r;
  }
  function f(e, t, n) {
    var r = l(e, t, n);
    return r[1].v = e.read_shift(2, `i`), r;
  }
  function p(e, t, n) {
    var r = Z(7);
    return r.write_shift(1, 255), r.write_shift(2, t), r.write_shift(2, e), r.write_shift(2, n, `i`), r;
  }
  function m(e, t, n) {
    var r = l(e, t, n);
    return r[1].v = e.read_shift(8, `f`), r;
  }
  function h(e, t, n) {
    var r = Z(13);
    return r.write_shift(1, 255), r.write_shift(2, t), r.write_shift(2, e), r.write_shift(8, n, `f`), r;
  }
  function g(e, t, n) {
    var r = e.l + t,
      i = l(e, t, n);
    if (i[1].v = e.read_shift(8, `f`), n.qpro) e.l = r;else {
      var a = e.read_shift(2);
      b(e.slice(e.l, e.l + a), i), e.l += a;
    }
    return i;
  }
  function _(e, t, n) {
    var r = t & 32768;
    return t &= -32769, t = (r ? e : 0) + (t >= 8192 ? t - 16384 : t), (r ? `` : `$`) + (n ? JP(t) : WP(t));
  }
  var v = {
      51: [`FALSE`, 0],
      52: [`TRUE`, 0],
      70: [`LEN`, 1],
      80: [`SUM`, 69],
      81: [`AVERAGEA`, 69],
      82: [`COUNTA`, 69],
      83: [`MINA`, 69],
      84: [`MAXA`, 69],
      111: [`T`, 1]
    },
    y = `.........+.-.*./.^.=.<>.<=.>=.<.>.....&.......`.split(`.`);
  function b(e, t) {
    FP(e, 0);
    for (var n = [], r = 0, i = ``, a = ``, o = ``, s = ``; e.l < e.length;) {
      var c = e[e.l++];
      switch (c) {
        case 0:
          n.push(e.read_shift(8, `f`));
          break;
        case 1:
          a = _(t[0].c, e.read_shift(2), !0), i = _(t[0].r, e.read_shift(2), !1), n.push(a + i);
          break;
        case 2:
          var l = _(t[0].c, e.read_shift(2), !0),
            u = _(t[0].r, e.read_shift(2), !1);
          a = _(t[0].c, e.read_shift(2), !0), i = _(t[0].r, e.read_shift(2), !1), n.push(l + u + `:` + a + i);
          break;
        case 3:
          if (e.l < e.length) {
            console.error(`WK1 premature formula end`);
            return;
          }
          break;
        case 4:
          n.push(`(` + n.pop() + `)`);
          break;
        case 5:
          n.push(e.read_shift(2));
          break;
        case 6:
          for (var d = ``; c = e[e.l++];) d += String.fromCharCode(c);
          n.push(`"` + d.replace(/"/g, `""`) + `"`);
          break;
        case 8:
          n.push(`-` + n.pop());
          break;
        case 23:
          n.push(`+` + n.pop());
          break;
        case 22:
          n.push(`NOT(` + n.pop() + `)`);
          break;
        case 20:
        case 21:
          s = n.pop(), o = n.pop(), n.push([`AND`, `OR`][c - 20] + `(` + o + `,` + s + `)`);
          break;
        default:
          if (c < 32 && y[c]) s = n.pop(), o = n.pop(), n.push(o + y[c] + s);else if (v[c]) {
            if (r = v[c][1], r == 69 && (r = e[e.l++]), r > n.length) {
              console.error(`WK1 bad formula parse 0x` + c.toString(16) + `:|` + n.join(`|`) + `|`);
              return;
            }
            var f = n.slice(-r);
            n.length -= r, n.push(v[c][0] + `(` + f.join(`,`) + `)`);
          } else if (c <= 7) return console.error(`WK1 invalid opcode ` + c.toString(16));else if (c <= 24) return console.error(`WK1 unsupported op ` + c.toString(16));else if (c <= 30) return console.error(`WK1 invalid opcode ` + c.toString(16));else if (c <= 115) return console.error(`WK1 unsupported function opcode ` + c.toString(16));else return console.error(`WK1 unrecognized opcode ` + c.toString(16));
      }
    }
    n.length == 1 ? t[1].f = `` + n[0] : console.error(`WK1 bad formula parse |` + n.join(`|`) + `|`);
  }
  function x(e) {
    var t = [{
      c: 0,
      r: 0
    }, {
      t: `n`,
      v: 0
    }, 0];
    return t[0].r = e.read_shift(2), t[3] = e[e.l++], t[0].c = e[e.l++], t;
  }
  function S(e, t) {
    var n = x(e, t);
    return n[1].t = `s`, n[1].v = e.read_shift(t - 4, `cstr`), n;
  }
  function C(e, t, n, r) {
    var i = Z(6 + r.length);
    i.write_shift(2, e), i.write_shift(1, n), i.write_shift(1, t), i.write_shift(1, 39);
    for (var a = 0; a < r.length; ++a) {
      var o = r.charCodeAt(a);
      i.write_shift(1, o >= 128 ? 95 : o);
    }
    return i.write_shift(1, 0), i;
  }
  function w(e, t) {
    var n = x(e, t);
    n[1].v = e.read_shift(2);
    var r = n[1].v >> 1;
    if (n[1].v & 1) switch (r & 7) {
      case 0:
        r = (r >> 3) * 5e3;
        break;
      case 1:
        r = (r >> 3) * 500;
        break;
      case 2:
        r = (r >> 3) / 20;
        break;
      case 3:
        r = (r >> 3) / 200;
        break;
      case 4:
        r = (r >> 3) / 2e3;
        break;
      case 5:
        r = (r >> 3) / 2e4;
        break;
      case 6:
        r = (r >> 3) / 16;
        break;
      case 7:
        r = (r >> 3) / 64;
    }
    return n[1].v = r, n;
  }
  function T(e, t) {
    var n = x(e, t),
      r = e.read_shift(4),
      i = e.read_shift(4),
      a = e.read_shift(2);
    if (a == 65535) return r === 0 && i === 3221225472 ? (n[1].t = `e`, n[1].v = 15) : r === 0 && i === 3489660928 ? (n[1].t = `e`, n[1].v = 42) : n[1].v = 0, n;
    var o = a & 32768;
    return a = (a & 32767) - 16446, n[1].v = (1 - o * 2) * (i * 2 ** (a + 32) + r * 2 ** a), n;
  }
  function E(e, t, n, r) {
    var i = Z(14);
    if (i.write_shift(2, e), i.write_shift(1, n), i.write_shift(1, t), r == 0) return i.write_shift(4, 0), i.write_shift(4, 0), i.write_shift(2, 65535), i;
    var a = 0,
      o = 0,
      s = 0,
      c = 0;
    return r < 0 && (a = 1, r = -r), o = Math.log2(r) | 0, r /= 2 ** (o - 31), c = r >>> 0, c & 2147483648 || (r /= 2, ++o, c = r >>> 0), r -= c, c |= 2147483648, c >>>= 0, r *= 2 ** 32, s = r >>> 0, i.write_shift(4, s), i.write_shift(4, c), o += 16383 + (a ? 32768 : 0), i.write_shift(2, o), i;
  }
  function D(e, t) {
    var n = T(e, 14);
    return e.l += t - 14, n;
  }
  function O(e, t) {
    var n = x(e, t),
      r = e.read_shift(4);
    return n[1].v = r >> 6, n;
  }
  function k(e, t) {
    var n = x(e, t),
      r = e.read_shift(8, `f`);
    return n[1].v = r, n;
  }
  function A(e, t) {
    var n = k(e, 14);
    return e.l += t - 10, n;
  }
  function j(e, t) {
    return e[e.l + t - 1] == 0 ? e.read_shift(t, `cstr`) : ``;
  }
  function M(e, t) {
    var n = e[e.l++];
    n > t - 1 && (n = t - 1);
    for (var r = ``; r.length < n;) r += String.fromCharCode(e[e.l++]);
    return r;
  }
  function N(e, t, n) {
    if (!(!n.qpro || t < 21)) {
      var r = e.read_shift(1);
      return e.l += 17, e.l += 1, e.l += 2, [r, e.read_shift(t - 21, `cstr`)];
    }
  }
  function P(e, t) {
    for (var n = {}, r = e.l + t; e.l < r;) {
      var i = e.read_shift(2);
      if (i == 14e3) {
        for (n[i] = [0, ``], n[i][0] = e.read_shift(2); e[e.l];) n[i][1] += String.fromCharCode(e[e.l]), e.l++;
        e.l++;
      }
    }
    return n;
  }
  function F(e, t) {
    var n = Z(5 + e.length);
    n.write_shift(2, 14e3), n.write_shift(2, t);
    for (var r = 0; r < e.length; ++r) {
      var i = e.charCodeAt(r);
      n[n.l++] = i > 127 ? 95 : i;
    }
    return n[n.l++] = 0, n;
  }
  var I = {
      0: {
        n: `BOF`,
        f: yL
      },
      1: {
        n: `EOF`
      },
      2: {
        n: `CALCMODE`
      },
      3: {
        n: `CALCORDER`
      },
      4: {
        n: `SPLIT`
      },
      5: {
        n: `SYNC`
      },
      6: {
        n: `RANGE`,
        f: s
      },
      7: {
        n: `WINDOW1`
      },
      8: {
        n: `COLW1`
      },
      9: {
        n: `WINTWO`
      },
      10: {
        n: `COLW2`
      },
      11: {
        n: `NAME`
      },
      12: {
        n: `BLANK`
      },
      13: {
        n: `INTEGER`,
        f
      },
      14: {
        n: `NUMBER`,
        f: m
      },
      15: {
        n: `LABEL`,
        f: u
      },
      16: {
        n: `FORMULA`,
        f: g
      },
      24: {
        n: `TABLE`
      },
      25: {
        n: `ORANGE`
      },
      26: {
        n: `PRANGE`
      },
      27: {
        n: `SRANGE`
      },
      28: {
        n: `FRANGE`
      },
      29: {
        n: `KRANGE1`
      },
      32: {
        n: `HRANGE`
      },
      35: {
        n: `KRANGE2`
      },
      36: {
        n: `PROTEC`
      },
      37: {
        n: `FOOTER`
      },
      38: {
        n: `HEADER`
      },
      39: {
        n: `SETUP`
      },
      40: {
        n: `MARGINS`
      },
      41: {
        n: `LABELFMT`
      },
      42: {
        n: `TITLES`
      },
      43: {
        n: `SHEETJS`
      },
      45: {
        n: `GRAPH`
      },
      46: {
        n: `NGRAPH`
      },
      47: {
        n: `CALCCOUNT`
      },
      48: {
        n: `UNFORMATTED`
      },
      49: {
        n: `CURSORW12`
      },
      50: {
        n: `WINDOW`
      },
      51: {
        n: `STRING`,
        f: u
      },
      55: {
        n: `PASSWORD`
      },
      56: {
        n: `LOCKED`
      },
      60: {
        n: `QUERY`
      },
      61: {
        n: `QUERYNAME`
      },
      62: {
        n: `PRINT`
      },
      63: {
        n: `PRINTNAME`
      },
      64: {
        n: `GRAPH2`
      },
      65: {
        n: `GRAPHNAME`
      },
      66: {
        n: `ZOOM`
      },
      67: {
        n: `SYMSPLIT`
      },
      68: {
        n: `NSROWS`
      },
      69: {
        n: `NSCOLS`
      },
      70: {
        n: `RULER`
      },
      71: {
        n: `NNAME`
      },
      72: {
        n: `ACOMM`
      },
      73: {
        n: `AMACRO`
      },
      74: {
        n: `PARSE`
      },
      102: {
        n: `PRANGES??`
      },
      103: {
        n: `RRANGES??`
      },
      104: {
        n: `FNAME??`
      },
      105: {
        n: `MRANGES??`
      },
      204: {
        n: `SHEETNAMECS`,
        f: j
      },
      222: {
        n: `SHEETNAMELP`,
        f: M
      },
      65535: {
        n: ``
      }
    },
    L = {
      0: {
        n: `BOF`
      },
      1: {
        n: `EOF`
      },
      2: {
        n: `PASSWORD`
      },
      3: {
        n: `CALCSET`
      },
      4: {
        n: `WINDOWSET`
      },
      5: {
        n: `SHEETCELLPTR`
      },
      6: {
        n: `SHEETLAYOUT`
      },
      7: {
        n: `COLUMNWIDTH`
      },
      8: {
        n: `HIDDENCOLUMN`
      },
      9: {
        n: `USERRANGE`
      },
      10: {
        n: `SYSTEMRANGE`
      },
      11: {
        n: `ZEROFORCE`
      },
      12: {
        n: `SORTKEYDIR`
      },
      13: {
        n: `FILESEAL`
      },
      14: {
        n: `DATAFILLNUMS`
      },
      15: {
        n: `PRINTMAIN`
      },
      16: {
        n: `PRINTSTRING`
      },
      17: {
        n: `GRAPHMAIN`
      },
      18: {
        n: `GRAPHSTRING`
      },
      19: {
        n: `??`
      },
      20: {
        n: `ERRCELL`
      },
      21: {
        n: `NACELL`
      },
      22: {
        n: `LABEL16`,
        f: S
      },
      23: {
        n: `NUMBER17`,
        f: T
      },
      24: {
        n: `NUMBER18`,
        f: w
      },
      25: {
        n: `FORMULA19`,
        f: D
      },
      26: {
        n: `FORMULA1A`
      },
      27: {
        n: `XFORMAT`,
        f: P
      },
      28: {
        n: `DTLABELMISC`
      },
      29: {
        n: `DTLABELCELL`
      },
      30: {
        n: `GRAPHWINDOW`
      },
      31: {
        n: `CPA`
      },
      32: {
        n: `LPLAUTO`
      },
      33: {
        n: `QUERY`
      },
      34: {
        n: `HIDDENSHEET`
      },
      35: {
        n: `??`
      },
      37: {
        n: `NUMBER25`,
        f: O
      },
      38: {
        n: `??`
      },
      39: {
        n: `NUMBER27`,
        f: k
      },
      40: {
        n: `FORMULA28`,
        f: A
      },
      142: {
        n: `??`
      },
      147: {
        n: `??`
      },
      150: {
        n: `??`
      },
      151: {
        n: `??`
      },
      152: {
        n: `??`
      },
      153: {
        n: `??`
      },
      154: {
        n: `??`
      },
      155: {
        n: `??`
      },
      156: {
        n: `??`
      },
      163: {
        n: `??`
      },
      174: {
        n: `??`
      },
      175: {
        n: `??`
      },
      176: {
        n: `??`
      },
      177: {
        n: `??`
      },
      184: {
        n: `??`
      },
      185: {
        n: `??`
      },
      186: {
        n: `??`
      },
      187: {
        n: `??`
      },
      188: {
        n: `??`
      },
      195: {
        n: `??`
      },
      201: {
        n: `??`
      },
      204: {
        n: `SHEETNAMECS`,
        f: j
      },
      205: {
        n: `??`
      },
      206: {
        n: `??`
      },
      207: {
        n: `??`
      },
      208: {
        n: `??`
      },
      256: {
        n: `??`
      },
      259: {
        n: `??`
      },
      260: {
        n: `??`
      },
      261: {
        n: `??`
      },
      262: {
        n: `??`
      },
      263: {
        n: `??`
      },
      265: {
        n: `??`
      },
      266: {
        n: `??`
      },
      267: {
        n: `??`
      },
      268: {
        n: `??`
      },
      270: {
        n: `??`
      },
      271: {
        n: `??`
      },
      384: {
        n: `??`
      },
      389: {
        n: `??`
      },
      390: {
        n: `??`
      },
      393: {
        n: `??`
      },
      396: {
        n: `??`
      },
      512: {
        n: `??`
      },
      514: {
        n: `??`
      },
      513: {
        n: `??`
      },
      516: {
        n: `??`
      },
      517: {
        n: `??`
      },
      640: {
        n: `??`
      },
      641: {
        n: `??`
      },
      642: {
        n: `??`
      },
      643: {
        n: `??`
      },
      644: {
        n: `??`
      },
      645: {
        n: `??`
      },
      646: {
        n: `??`
      },
      647: {
        n: `??`
      },
      648: {
        n: `??`
      },
      658: {
        n: `??`
      },
      659: {
        n: `??`
      },
      660: {
        n: `??`
      },
      661: {
        n: `??`
      },
      662: {
        n: `??`
      },
      665: {
        n: `??`
      },
      666: {
        n: `??`
      },
      768: {
        n: `??`
      },
      772: {
        n: `??`
      },
      1537: {
        n: `SHEETINFOQP`,
        f: N
      },
      1600: {
        n: `??`
      },
      1602: {
        n: `??`
      },
      1793: {
        n: `??`
      },
      1794: {
        n: `??`
      },
      1795: {
        n: `??`
      },
      1796: {
        n: `??`
      },
      1920: {
        n: `??`
      },
      2048: {
        n: `??`
      },
      2049: {
        n: `??`
      },
      2052: {
        n: `??`
      },
      2688: {
        n: `??`
      },
      10998: {
        n: `??`
      },
      12849: {
        n: `??`
      },
      28233: {
        n: `??`
      },
      28484: {
        n: `??`
      },
      65535: {
        n: ``
      }
    };
  return {
    sheet_to_wk1: r,
    book_to_wk3: i,
    to_workbook: t
  };
}();
function Kz(e) {
  var t = {},
    n = e.match(pN),
    r = 0,
    i = !1;
  if (n) for (; r != n.length; ++r) {
    var a = gN(n[r]);
    switch (a[0].replace(/\w*:/g, ``)) {
      case `<condense`:
        break;
      case `<extend`:
        break;
      case `<shadow`:
        if (!a.val) break;
      case `<shadow>`:
      case `<shadow/>`:
        t.shadow = 1;
        break;
      case `</shadow>`:
        break;
      case `<charset`:
        if (a.val == `1`) break;
        t.cp = jA[parseInt(a.val, 10)];
        break;
      case `<outline`:
        if (!a.val) break;
      case `<outline>`:
      case `<outline/>`:
        t.outline = 1;
        break;
      case `</outline>`:
        break;
      case `<rFont`:
        t.name = a.val;
        break;
      case `<sz`:
        t.sz = a.val;
        break;
      case `<strike`:
        if (!a.val) break;
      case `<strike>`:
      case `<strike/>`:
        t.strike = 1;
        break;
      case `</strike>`:
        break;
      case `<u`:
        if (!a.val) break;
        switch (a.val) {
          case `double`:
            t.uval = `double`;
            break;
          case `singleAccounting`:
            t.uval = `single-accounting`;
            break;
          case `doubleAccounting`:
            t.uval = `double-accounting`;
        }
      case `<u>`:
      case `<u/>`:
        t.u = 1;
        break;
      case `</u>`:
        break;
      case `<b`:
        if (a.val == `0`) break;
      case `<b>`:
      case `<b/>`:
        t.b = 1;
        break;
      case `</b>`:
        break;
      case `<i`:
        if (a.val == `0`) break;
      case `<i>`:
      case `<i/>`:
        t.i = 1;
        break;
      case `</i>`:
        break;
      case `<color`:
        a.rgb && (t.color = a.rgb.slice(2, 8));
        break;
      case `<color>`:
      case `<color/>`:
      case `</color>`:
        break;
      case `<family`:
        t.family = a.val;
        break;
      case `<family>`:
      case `<family/>`:
      case `</family>`:
        break;
      case `<vertAlign`:
        t.valign = a.val;
        break;
      case `<vertAlign>`:
      case `<vertAlign/>`:
      case `</vertAlign>`:
        break;
      case `<scheme`:
        break;
      case `<scheme>`:
      case `<scheme/>`:
      case `</scheme>`:
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
        break;
      case `<ext`:
        i = !0;
        break;
      case `</ext>`:
        i = !1;
        break;
      default:
        if (a[0].charCodeAt(1) !== 47 && !i) throw Error(`Unrecognized rich format ` + a[0]);
    }
  }
  return t;
}
var qz = function () {
    var e = LN(`t`),
      t = LN(`rPr`);
    function n(n) {
      var r = n.match(e);
      if (!r) return {
        t: `s`,
        v: ``
      };
      var i = {
          t: `s`,
          v: bN(r[1])
        },
        a = n.match(t);
      return a && (i.s = Kz(a[1])), i;
    }
    var r = /<(?:\w+:)?r>/g,
      i = /<\/(?:\w+:)?r>/;
    return function (e) {
      return e.replace(r, ``).split(i).map(n).filter(function (e) {
        return e.v;
      });
    };
  }(),
  Jz = function () {
    var e = /(\r\n|\n)/g;
    function t(e, t, n) {
      var r = [];
      e.u && r.push(`text-decoration: underline;`), e.uval && r.push(`text-underline-style:` + e.uval + `;`), e.sz && r.push(`font-size:` + e.sz + `pt;`), e.outline && r.push(`text-effect: outline;`), e.shadow && r.push(`text-shadow: auto;`), t.push(`<span style="` + r.join(``) + `">`), e.b && (t.push(`<b>`), n.push(`</b>`)), e.i && (t.push(`<i>`), n.push(`</i>`)), e.strike && (t.push(`<s>`), n.push(`</s>`));
      var i = e.valign || ``;
      return i == `superscript` || i == `super` ? i = `sup` : i == `subscript` && (i = `sub`), i != `` && (t.push(`<` + i + `>`), n.push(`</` + i + `>`)), n.push(`</span>`), e;
    }
    function n(n) {
      var r = [[], n.v, []];
      return n.v ? (n.s && t(n.s, r[0], r[2]), r[0].join(``) + r[1].replace(e, `<br/>`) + r[2].join(``)) : ``;
    }
    return function (e) {
      return e.map(n).join(``);
    };
  }(),
  Yz = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,
  Xz = /<(?:\w+:)?r>/,
  Zz = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function Qz(e, t) {
  var n = !t || t.cellHTML,
    r = {};
  return e ? (e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (r.t = bN(FN(e.slice(e.indexOf(`>`) + 1).split(/<\/(?:\w+:)?t>/)[0] || ``)), r.r = FN(e), n && (r.h = EN(r.t))) : e.match(Xz) && (r.r = FN(e), r.t = bN(FN((e.replace(Zz, ``).match(Yz) || []).join(``).replace(pN, ``))), n && (r.h = Jz(qz(r.r)))), r) : {
    t: ``
  };
}
var $z = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/,
  eB = /<(?:\w+:)?(?:si|sstItem)>/g,
  tB = /<\/(?:\w+:)?(?:si|sstItem)>/;
function nB(e, t) {
  var n = [],
    r = ``;
  if (!e) return n;
  var i = e.match($z);
  if (i) {
    r = i[2].replace(eB, ``).split(tB);
    for (var a = 0; a != r.length; ++a) {
      var o = Qz(r[a].trim(), t);
      o != null && (n[n.length] = o);
    }
    i = gN(i[1]), n.Count = i.count, n.Unique = i.uniqueCount;
  }
  return n;
}
var rB = /^\s|\s$|[\t\n\r]/;
function iB(e, t) {
  if (!t.bookSST) return ``;
  var n = [uN];
  n[n.length] = X(`sst`, null, {
    xmlns: ZN[0],
    count: e.Count,
    uniqueCount: e.Unique
  });
  for (var r = 0; r != e.length; ++r) if (e[r] != null) {
    var i = e[r],
      a = `<si>`;
    i.r ? a += i.r : (a += `<t`, i.t ||= ``, i.t.match(rB) && (a += ` xml:space="preserve"`), a += `>` + CN(i.t) + `</t>`), a += `</si>`, n[n.length] = a;
  }
  return n.length > 2 && (n[n.length] = `</sst>`, n[1] = n[1].replace(`/>`, `>`)), n.join(``);
}
function aB(e) {
  return [e.read_shift(4), e.read_shift(4)];
}
function oB(e, t) {
  var n = [],
    r = !1;
  return LP(e, function (e, i, a) {
    switch (a) {
      case 159:
        n.Count = e[0], n.Unique = e[1];
        break;
      case 19:
        n.push(e);
        break;
      case 160:
        return !0;
      case 35:
        r = !0;
        break;
      case 36:
        r = !1;
        break;
      default:
        if (i.T, !r || t.WTF) throw Error(`Unexpected record 0x` + a.toString(16));
    }
  }), n;
}
function sB(e, t) {
  return t ||= Z(8), t.write_shift(4, e.Count), t.write_shift(4, e.Unique), t;
}
var cB = hF;
function lB(e) {
  var t = RP();
  Q(t, 159, sB(e));
  for (var n = 0; n < e.length; ++n) Q(t, 19, cB(e[n]));
  return Q(t, 160), t.end();
}
function uB(e) {
  if (HA !== void 0) return HA.utils.encode(kA, e);
  for (var t = [], n = e.split(``), r = 0; r < n.length; ++r) t[r] = n[r].charCodeAt(0);
  return t;
}
function dB(e, t) {
  var n = {};
  return n.Major = e.read_shift(2), n.Minor = e.read_shift(2), t >= 4 && (e.l += t - 4), n;
}
function fB(e) {
  var t = {};
  return t.id = e.read_shift(0, `lpp4`), t.R = dB(e, 4), t.U = dB(e, 4), t.W = dB(e, 4), t;
}
function pB(e) {
  for (var t = e.read_shift(4), n = e.l + t - 4, r = {}, i = e.read_shift(4), a = []; i-- > 0;) a.push({
    t: e.read_shift(4),
    v: e.read_shift(0, `lpp4`)
  });
  if (r.name = e.read_shift(0, `lpp4`), r.comps = a, e.l != n) throw Error(`Bad DataSpaceMapEntry: ` + e.l + ` != ` + n);
  return r;
}
function mB(e) {
  var t = [];
  e.l += 4;
  for (var n = e.read_shift(4); n-- > 0;) t.push(pB(e));
  return t;
}
function hB(e) {
  var t = [];
  e.l += 4;
  for (var n = e.read_shift(4); n-- > 0;) t.push(e.read_shift(0, `lpp4`));
  return t;
}
function gB(e) {
  var t = {};
  return e.read_shift(4), e.l += 4, t.id = e.read_shift(0, `lpp4`), t.name = e.read_shift(0, `lpp4`), t.R = dB(e, 4), t.U = dB(e, 4), t.W = dB(e, 4), t;
}
function _B(e) {
  var t = gB(e);
  if (t.ename = e.read_shift(0, `8lpp4`), t.blksz = e.read_shift(4), t.cmode = e.read_shift(4), e.read_shift(4) != 4) throw Error(`Bad !Primary record`);
  return t;
}
function vB(e, t) {
  var n = e.l + t,
    r = {};
  r.Flags = e.read_shift(4) & 63, e.l += 4, r.AlgID = e.read_shift(4);
  var i = !1;
  switch (r.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      i = r.Flags == 36;
      break;
    case 26625:
      i = r.Flags == 4;
      break;
    case 0:
      i = r.Flags == 16 || r.Flags == 4 || r.Flags == 36;
      break;
    default:
      throw `Unrecognized encryption algorithm: ` + r.AlgID;
  }
  if (!i) throw Error(`Encryption Flags/AlgID mismatch`);
  return r.AlgIDHash = e.read_shift(4), r.KeySize = e.read_shift(4), r.ProviderType = e.read_shift(4), e.l += 8, r.CSPName = e.read_shift(n - e.l >> 1, `utf16le`), e.l = n, r;
}
function yB(e, t) {
  var n = {},
    r = e.l + t;
  return e.l += 4, n.Salt = e.slice(e.l, e.l + 16), e.l += 16, n.Verifier = e.slice(e.l, e.l + 16), e.l += 16, e.read_shift(4), n.VerifierHash = e.slice(e.l, r), e.l = r, n;
}
function bB(e) {
  var t = dB(e);
  switch (t.Minor) {
    case 2:
      return [t.Minor, xB(e, t)];
    case 3:
      return [t.Minor, SB(e, t)];
    case 4:
      return [t.Minor, CB(e, t)];
  }
  throw Error(`ECMA-376 Encrypted file unrecognized Version: ` + t.Minor);
}
function xB(e) {
  if ((e.read_shift(4) & 63) != 36) throw Error(`EncryptionInfo mismatch`);
  return {
    t: `Std`,
    h: vB(e, e.read_shift(4)),
    v: yB(e, e.length - e.l)
  };
}
function SB() {
  throw Error(`File is password-protected: ECMA-376 Extensible`);
}
function CB(e) {
  var t = [`saltSize`, `blockSize`, `keyBits`, `hashSize`, `cipherAlgorithm`, `cipherChaining`, `hashAlgorithm`, `saltValue`];
  e.l += 4;
  var n = e.read_shift(e.length - e.l, `utf8`),
    r = {};
  return n.replace(pN, function (e) {
    var n = gN(e);
    switch (_N(n[0])) {
      case `<?xml`:
        break;
      case `<encryption`:
      case `</encryption>`:
        break;
      case `<keyData`:
        t.forEach(function (e) {
          r[e] = n[e];
        });
        break;
      case `<dataIntegrity`:
        r.encryptedHmacKey = n.encryptedHmacKey, r.encryptedHmacValue = n.encryptedHmacValue;
        break;
      case `<keyEncryptors>`:
      case `<keyEncryptors`:
        r.encs = [];
        break;
      case `</keyEncryptors>`:
        break;
      case `<keyEncryptor`:
        r.uri = n.uri;
        break;
      case `</keyEncryptor>`:
        break;
      case `<encryptedKey`:
        r.encs.push(n);
        break;
      default:
        throw n[0];
    }
  }), r;
}
function wB(e, t) {
  var n = {},
    r = n.EncryptionVersionInfo = dB(e, 4);
  if (t -= 4, r.Minor != 2) throw Error(`unrecognized minor version code: ` + r.Minor);
  if (r.Major > 4 || r.Major < 2) throw Error(`unrecognized major version code: ` + r.Major);
  n.Flags = e.read_shift(4), t -= 4;
  var i = e.read_shift(4);
  return t -= 4, n.EncryptionHeader = vB(e, i), t -= i, n.EncryptionVerifier = yB(e, t), n;
}
function TB(e) {
  var t = {},
    n = t.EncryptionVersionInfo = dB(e, 4);
  if (n.Major != 1 || n.Minor != 1) throw `unrecognized version code ` + n.Major + ` : ` + n.Minor;
  return t.Salt = e.read_shift(16), t.EncryptedVerifier = e.read_shift(16), t.EncryptedVerifierHash = e.read_shift(16), t;
}
function EB(e) {
  var t = 0,
    n,
    r = uB(e),
    i = r.length + 1,
    a,
    o,
    s,
    c,
    l;
  for (n = ZA(i), n[0] = r.length, a = 1; a != i; ++a) n[a] = r[a - 1];
  for (a = i - 1; a >= 0; --a) o = n[a], s = t & 16384 ? 1 : 0, c = t << 1 & 32767, l = s | c, t = l ^ o;
  return t ^ 52811;
}
var DB = function () {
    var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0],
      t = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163],
      n = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628],
      r = function (e) {
        return (e / 2 | e * 128) & 255;
      },
      i = function (e, t) {
        return r(e ^ t);
      },
      a = function (e) {
        for (var r = t[e.length - 1], i = 104, a = e.length - 1; a >= 0; --a) for (var o = e[a], s = 0; s != 7; ++s) o & 64 && (r ^= n[i]), o *= 2, --i;
        return r;
      };
    return function (t) {
      for (var n = uB(t), r = a(n), o = n.length, s = ZA(16), c = 0; c != 16; ++c) s[c] = 0;
      var l, u, d;
      for ((o & 1) == 1 && (l = r >> 8, s[o] = i(e[0], l), --o, l = r & 255, u = n[n.length - 1], s[o] = i(u, l)); o > 0;) --o, l = r >> 8, s[o] = i(n[o], l), --o, l = r & 255, s[o] = i(n[o], l);
      for (o = 15, d = 15 - n.length; d > 0;) l = r >> 8, s[o] = i(e[d], l), --o, --d, l = r & 255, s[o] = i(n[o], l), --o, --d;
      return s;
    };
  }(),
  OB = function (e, t, n, r, i) {
    i ||= t, r ||= DB(e);
    for (var a = 0, o; a != t.length; ++a) o = t[a], o ^= r[n], o = (o >> 5 | o << 3) & 255, i[a] = o, ++n;
    return [i, n, r];
  },
  kB = function (e) {
    var t = 0,
      n = DB(e);
    return function (e) {
      var r = OB(``, e, t, n);
      return t = r[1], r[0];
    };
  };
function AB(e, t, n, r) {
  var i = {
    key: yL(e),
    verificationBytes: yL(e)
  };
  return n.password && (i.verifier = EB(n.password)), r.valid = i.verificationBytes === i.verifier, r.valid && (r.insitu = kB(n.password)), i;
}
function jB(e, t, n) {
  var r = n || {};
  return r.Info = e.read_shift(2), e.l -= 2, r.Data = r.Info === 1 ? TB(e, t) : wB(e, t), r;
}
function MB(e, t, n) {
  var r = {
    Type: n.biff >= 8 ? e.read_shift(2) : 0
  };
  return r.Type ? jB(e, t - 2, r) : AB(e, n.biff >= 8 ? t : t - 2, n, r), r;
}
var NB = function () {
  function e(e, n) {
    switch (n.type) {
      case `base64`:
        return t(JA(e), n);
      case `binary`:
        return t(e, n);
      case `buffer`:
        return t(YA && Buffer.isBuffer(e) ? e.toString(`binary`) : tj(e), n);
      case `array`:
        return t(WM(e), n);
    }
    throw Error(`Unrecognized type ` + n.type);
  }
  function t(e, t) {
    var n = (t || {}).dense ? [] : {},
      r = e.match(/\\trowd.*?\\row\b/g);
    if (!r.length) throw Error(`RTF missing table`);
    var i = {
      s: {
        c: 0,
        r: 0
      },
      e: {
        c: 0,
        r: r.length - 1
      }
    };
    return r.forEach(function (e, t) {
      Array.isArray(n) && (n[t] = []);
      for (var r = /\\\w+\b/g, a = 0, o, s = -1; o = r.exec(e);) {
        if (o[0] === `\\cell`) {
          var c = e.slice(a, r.lastIndex - o[0].length);
          if (c[0] == ` ` && (c = c.slice(1)), ++s, c.length) {
            var l = {
              v: c,
              t: `s`
            };
            Array.isArray(n) ? n[t][s] = l : n[$P({
              r: t,
              c: s
            })] = l;
          }
        }
        a = r.lastIndex;
      }
      s > i.e.c && (i.e.c = s);
    }), n[`!ref`] = tF(i), n;
  }
  function n(t, n) {
    return aF(e(t, n), n);
  }
  function r(e) {
    for (var t = [`{\\rtf1\\ansi`], n = nF(e[`!ref`]), r, i = Array.isArray(e), a = n.s.r; a <= n.e.r; ++a) {
      t.push(`\\trowd\\trautofit1`);
      for (var o = n.s.c; o <= n.e.c; ++o) t.push(`\\cellx` + (o + 1));
      for (t.push(`\\pard\\intbl`), o = n.s.c; o <= n.e.c; ++o) {
        var s = $P({
          r: a,
          c: o
        });
        r = i ? (e[a] || [])[o] : e[s], r && (r.v != null || r.f && !r.F) && (t.push(` ` + (r.w || (iF(r), r.w))), t.push(`\\cell`));
      }
      t.push(`\\pard\\intbl\\row`);
    }
    return t.join(``) + `}`;
  }
  return {
    to_workbook: n,
    to_sheet: e,
    from_sheet: r
  };
}();
function PB(e) {
  var t = e.slice(+(e[0] === `#`)).slice(0, 6);
  return [parseInt(t.slice(0, 2), 16), parseInt(t.slice(2, 4), 16), parseInt(t.slice(4, 6), 16)];
}
function FB(e) {
  for (var t = 0, n = 1; t != 3; ++t) n = n * 256 + (e[t] > 255 ? 255 : e[t] < 0 ? 0 : e[t]);
  return n.toString(16).toUpperCase().slice(1);
}
function IB(e) {
  var t = e[0] / 255,
    n = e[1] / 255,
    r = e[2] / 255,
    i = Math.max(t, n, r),
    a = Math.min(t, n, r),
    o = i - a;
  if (o === 0) return [0, 0, t];
  var s = 0,
    c = 0,
    l = i + a;
  switch (c = o / (l > 1 ? 2 - l : l), i) {
    case t:
      s = ((n - r) / o + 6) % 6;
      break;
    case n:
      s = (r - t) / o + 2;
      break;
    case r:
      s = (t - n) / o + 4;
  }
  return [s / 6, c, l / 2];
}
function LB(e) {
  var t = e[0],
    n = e[1],
    r = e[2],
    i = n * 2 * (r < .5 ? r : 1 - r),
    a = r - i / 2,
    o = [a, a, a],
    s = 6 * t,
    c;
  if (n !== 0) switch (s | 0) {
    case 0:
    case 6:
      c = i * s, o[0] += i, o[1] += c;
      break;
    case 1:
      c = i * (2 - s), o[0] += c, o[1] += i;
      break;
    case 2:
      c = i * (s - 2), o[1] += i, o[2] += c;
      break;
    case 3:
      c = i * (4 - s), o[1] += c, o[2] += i;
      break;
    case 4:
      c = i * (s - 4), o[2] += i, o[0] += c;
      break;
    case 5:
      c = i * (6 - s), o[2] += c, o[0] += i;
  }
  for (var l = 0; l != 3; ++l) o[l] = Math.round(o[l] * 255);
  return o;
}
function RB(e, t) {
  if (t === 0) return e;
  var n = IB(PB(e));
  return t < 0 ? n[2] *= 1 + t : n[2] = 1 - (1 - n[2]) * (1 - t), FB(LB(n));
}
var zB = 6,
  BB = 15,
  VB = 1,
  HB = zB;
function UB(e) {
  return Math.floor((e + Math.round(128 / HB) / 256) * HB);
}
function WB(e) {
  return Math.floor((e - 5) / HB * 100 + .5) / 100;
}
function GB(e) {
  return Math.round((e * HB + 5) / HB * 256) / 256;
}
function KB(e) {
  return GB(WB(UB(e)));
}
function qB(e) {
  var t = Math.abs(e - KB(e)),
    n = HB;
  if (t > .005) for (HB = VB; HB < BB; ++HB) Math.abs(e - KB(e)) <= t && (t = Math.abs(e - KB(e)), n = HB);
  HB = n;
}
function JB(e) {
  e.width ? (e.wpx = UB(e.width), e.wch = WB(e.wpx), e.MDW = HB) : e.wpx ? (e.wch = WB(e.wpx), e.width = GB(e.wch), e.MDW = HB) : typeof e.wch == `number` && (e.width = GB(e.wch), e.wpx = UB(e.width), e.MDW = HB), e.customWidth && delete e.customWidth;
}
var YB = 96;
function XB(e) {
  return e * 96 / YB;
}
function ZB(e) {
  return e * YB / 96;
}
var QB = {
  None: `none`,
  Solid: `solid`,
  Gray50: `mediumGray`,
  Gray75: `darkGray`,
  Gray25: `lightGray`,
  HorzStripe: `darkHorizontal`,
  VertStripe: `darkVertical`,
  ReverseDiagStripe: `darkDown`,
  DiagStripe: `darkUp`,
  DiagCross: `darkGrid`,
  ThickDiagCross: `darkTrellis`,
  ThinHorzStripe: `lightHorizontal`,
  ThinVertStripe: `lightVertical`,
  ThinReverseDiagStripe: `lightDown`,
  ThinHorzCross: `lightGrid`
};
function $B(e, t, n, r) {
  t.Borders = [];
  var i = {},
    a = !1;
  (e[0].match(pN) || []).forEach(function (e) {
    var n = gN(e);
    switch (_N(n[0])) {
      case `<borders`:
      case `<borders>`:
      case `</borders>`:
        break;
      case `<border`:
      case `<border>`:
      case `<border/>`:
        i = {}, n.diagonalUp && (i.diagonalUp = AN(n.diagonalUp)), n.diagonalDown && (i.diagonalDown = AN(n.diagonalDown)), t.Borders.push(i);
        break;
      case `</border>`:
        break;
      case `<left/>`:
        break;
      case `<left`:
      case `<left>`:
        break;
      case `</left>`:
        break;
      case `<right/>`:
        break;
      case `<right`:
      case `<right>`:
        break;
      case `</right>`:
        break;
      case `<top/>`:
        break;
      case `<top`:
      case `<top>`:
        break;
      case `</top>`:
        break;
      case `<bottom/>`:
        break;
      case `<bottom`:
      case `<bottom>`:
        break;
      case `</bottom>`:
        break;
      case `<diagonal`:
      case `<diagonal>`:
      case `<diagonal/>`:
        break;
      case `</diagonal>`:
        break;
      case `<horizontal`:
      case `<horizontal>`:
      case `<horizontal/>`:
        break;
      case `</horizontal>`:
        break;
      case `<vertical`:
      case `<vertical>`:
      case `<vertical/>`:
        break;
      case `</vertical>`:
        break;
      case `<start`:
      case `<start>`:
      case `<start/>`:
        break;
      case `</start>`:
        break;
      case `<end`:
      case `<end>`:
      case `<end/>`:
        break;
      case `</end>`:
        break;
      case `<color`:
      case `<color>`:
        break;
      case `<color/>`:
      case `</color>`:
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
        break;
      case `<ext`:
        a = !0;
        break;
      case `</ext>`:
        a = !1;
        break;
      default:
        if (r && r.WTF && !a) throw Error(`unrecognized ` + n[0] + ` in borders`);
    }
  });
}
function eV(e, t, n, r) {
  t.Fills = [];
  var i = {},
    a = !1;
  (e[0].match(pN) || []).forEach(function (e) {
    var n = gN(e);
    switch (_N(n[0])) {
      case `<fills`:
      case `<fills>`:
      case `</fills>`:
        break;
      case `<fill>`:
      case `<fill`:
      case `<fill/>`:
        i = {}, t.Fills.push(i);
        break;
      case `</fill>`:
        break;
      case `<gradientFill>`:
        break;
      case `<gradientFill`:
      case `</gradientFill>`:
        t.Fills.push(i), i = {};
        break;
      case `<patternFill`:
      case `<patternFill>`:
        n.patternType && (i.patternType = n.patternType);
        break;
      case `<patternFill/>`:
      case `</patternFill>`:
        break;
      case `<bgColor`:
        i.bgColor || (i.bgColor = {}), n.indexed && (i.bgColor.indexed = parseInt(n.indexed, 10)), n.theme && (i.bgColor.theme = parseInt(n.theme, 10)), n.tint && (i.bgColor.tint = parseFloat(n.tint)), n.rgb && (i.bgColor.rgb = n.rgb.slice(-6));
        break;
      case `<bgColor/>`:
      case `</bgColor>`:
        break;
      case `<fgColor`:
        i.fgColor || (i.fgColor = {}), n.theme && (i.fgColor.theme = parseInt(n.theme, 10)), n.tint && (i.fgColor.tint = parseFloat(n.tint)), n.rgb != null && (i.fgColor.rgb = n.rgb.slice(-6));
        break;
      case `<fgColor/>`:
      case `</fgColor>`:
        break;
      case `<stop`:
      case `<stop/>`:
        break;
      case `</stop>`:
        break;
      case `<color`:
      case `<color/>`:
        break;
      case `</color>`:
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
        break;
      case `<ext`:
        a = !0;
        break;
      case `</ext>`:
        a = !1;
        break;
      default:
        if (r && r.WTF && !a) throw Error(`unrecognized ` + n[0] + ` in fills`);
    }
  });
}
function tV(e, t, n, r) {
  t.Fonts = [];
  var i = {},
    a = !1;
  (e[0].match(pN) || []).forEach(function (e) {
    var o = gN(e);
    switch (_N(o[0])) {
      case `<fonts`:
      case `<fonts>`:
      case `</fonts>`:
        break;
      case `<font`:
      case `<font>`:
        break;
      case `</font>`:
      case `<font/>`:
        t.Fonts.push(i), i = {};
        break;
      case `<name`:
        o.val && (i.name = FN(o.val));
        break;
      case `<name/>`:
      case `</name>`:
        break;
      case `<b`:
        i.bold = o.val ? AN(o.val) : 1;
        break;
      case `<b/>`:
        i.bold = 1;
        break;
      case `<i`:
        i.italic = o.val ? AN(o.val) : 1;
        break;
      case `<i/>`:
        i.italic = 1;
        break;
      case `<u`:
        switch (o.val) {
          case `none`:
            i.underline = 0;
            break;
          case `single`:
            i.underline = 1;
            break;
          case `double`:
            i.underline = 2;
            break;
          case `singleAccounting`:
            i.underline = 33;
            break;
          case `doubleAccounting`:
            i.underline = 34;
        }
        break;
      case `<u/>`:
        i.underline = 1;
        break;
      case `<strike`:
        i.strike = o.val ? AN(o.val) : 1;
        break;
      case `<strike/>`:
        i.strike = 1;
        break;
      case `<outline`:
        i.outline = o.val ? AN(o.val) : 1;
        break;
      case `<outline/>`:
        i.outline = 1;
        break;
      case `<shadow`:
        i.shadow = o.val ? AN(o.val) : 1;
        break;
      case `<shadow/>`:
        i.shadow = 1;
        break;
      case `<condense`:
        i.condense = o.val ? AN(o.val) : 1;
        break;
      case `<condense/>`:
        i.condense = 1;
        break;
      case `<extend`:
        i.extend = o.val ? AN(o.val) : 1;
        break;
      case `<extend/>`:
        i.extend = 1;
        break;
      case `<sz`:
        o.val && (i.sz = +o.val);
        break;
      case `<sz/>`:
      case `</sz>`:
        break;
      case `<vertAlign`:
        o.val && (i.vertAlign = o.val);
        break;
      case `<vertAlign/>`:
      case `</vertAlign>`:
        break;
      case `<family`:
        o.val && (i.family = parseInt(o.val, 10));
        break;
      case `<family/>`:
      case `</family>`:
        break;
      case `<scheme`:
        o.val && (i.scheme = o.val);
        break;
      case `<scheme/>`:
      case `</scheme>`:
        break;
      case `<charset`:
        if (o.val == `1`) break;
        o.codepage = jA[parseInt(o.val, 10)];
        break;
      case `<color`:
        if (i.color || (i.color = {}), o.auto && (i.color.auto = AN(o.auto)), o.rgb) i.color.rgb = o.rgb.slice(-6);else if (o.indexed) {
          i.color.index = parseInt(o.indexed, 10);
          var s = cI[i.color.index];
          i.color.index == 81 && (s = cI[1]), s ||= cI[1], i.color.rgb = s[0].toString(16) + s[1].toString(16) + s[2].toString(16);
        } else o.theme && (i.color.theme = parseInt(o.theme, 10), o.tint && (i.color.tint = parseFloat(o.tint)), o.theme && n.themeElements && n.themeElements.clrScheme && (i.color.rgb = RB(n.themeElements.clrScheme[i.color.theme].rgb, i.color.tint || 0)));
        break;
      case `<color/>`:
      case `</color>`:
        break;
      case `<AlternateContent`:
        a = !0;
        break;
      case `</AlternateContent>`:
        a = !1;
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
        break;
      case `<ext`:
        a = !0;
        break;
      case `</ext>`:
        a = !1;
        break;
      default:
        if (r && r.WTF && !a) throw Error(`unrecognized ` + o[0] + ` in fonts`);
    }
  });
}
function nV(e, t, n) {
  t.NumberFmt = [];
  for (var r = OM(bj), i = 0; i < r.length; ++i) t.NumberFmt[r[i]] = bj[r[i]];
  var a = e[0].match(pN);
  if (a) for (i = 0; i < a.length; ++i) {
    var o = gN(a[i]);
    switch (_N(o[0])) {
      case `<numFmts`:
      case `</numFmts>`:
      case `<numFmts/>`:
      case `<numFmts>`:
        break;
      case `<numFmt`:
        var s = bN(FN(o.formatCode)),
          c = parseInt(o.numFmtId, 10);
        if (t.NumberFmt[c] = s, c > 0) {
          if (c > 392) {
            for (c = 392; c > 60 && t.NumberFmt[c] != null; --c);
            t.NumberFmt[c] = s;
          }
          pM(s, c);
        }
        break;
      case `</numFmt>`:
        break;
      default:
        if (n.WTF) throw Error(`unrecognized ` + o[0] + ` in numFmts`);
    }
  }
}
function rV(e) {
  var t = [`<numFmts>`];
  return [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (n) {
    for (var r = n[0]; r <= n[1]; ++r) e[r] != null && (t[t.length] = X(`numFmt`, null, {
      numFmtId: r,
      formatCode: CN(e[r])
    }));
  }), t.length === 1 ? `` : (t[t.length] = `</numFmts>`, t[0] = X(`numFmts`, null, {
    count: t.length - 2
  }).replace(`/>`, `>`), t.join(``));
}
var iV = [`numFmtId`, `fillId`, `fontId`, `borderId`, `xfId`],
  aV = [`applyAlignment`, `applyBorder`, `applyFill`, `applyFont`, `applyNumberFormat`, `applyProtection`, `pivotButton`, `quotePrefix`];
function oV(e, t, n) {
  t.CellXf = [];
  var r,
    i = !1;
  (e[0].match(pN) || []).forEach(function (e) {
    var a = gN(e),
      o = 0;
    switch (_N(a[0])) {
      case `<cellXfs`:
      case `<cellXfs>`:
      case `<cellXfs/>`:
      case `</cellXfs>`:
        break;
      case `<xf`:
      case `<xf/>`:
        for (r = a, delete r[0], o = 0; o < iV.length; ++o) r[iV[o]] && (r[iV[o]] = parseInt(r[iV[o]], 10));
        for (o = 0; o < aV.length; ++o) r[aV[o]] && (r[aV[o]] = AN(r[aV[o]]));
        if (t.NumberFmt && r.numFmtId > 392) {
          for (o = 392; o > 60; --o) if (t.NumberFmt[r.numFmtId] == t.NumberFmt[o]) {
            r.numFmtId = o;
            break;
          }
        }
        t.CellXf.push(r);
        break;
      case `</xf>`:
        break;
      case `<alignment`:
      case `<alignment/>`:
        var s = {};
        a.vertical && (s.vertical = a.vertical), a.horizontal && (s.horizontal = a.horizontal), a.textRotation != null && (s.textRotation = a.textRotation), a.indent && (s.indent = a.indent), a.wrapText && (s.wrapText = AN(a.wrapText)), r.alignment = s;
        break;
      case `</alignment>`:
        break;
      case `<protection`:
        break;
      case `</protection>`:
      case `<protection/>`:
        break;
      case `<AlternateContent`:
        i = !0;
        break;
      case `</AlternateContent>`:
        i = !1;
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
        break;
      case `<ext`:
        i = !0;
        break;
      case `</ext>`:
        i = !1;
        break;
      default:
        if (n && n.WTF && !i) throw Error(`unrecognized ` + a[0] + ` in cellXfs`);
    }
  });
}
function sV(e) {
  var t = [];
  return t[t.length] = X(`cellXfs`, null), e.forEach(function (e) {
    t[t.length] = X(`xf`, null, e);
  }), t[t.length] = `</cellXfs>`, t.length === 2 ? `` : (t[0] = X(`cellXfs`, null, {
    count: t.length - 2
  }).replace(`/>`, `>`), t.join(``));
}
var cV = function () {
  var e = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/,
    t = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/,
    n = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/,
    r = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/,
    i = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function (a, o, s) {
    var c = {};
    if (!a) return c;
    a = a.replace(/<!--([\s\S]*?)-->/gm, ``).replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ``);
    var l;
    return (l = a.match(e)) && nV(l, c, s), (l = a.match(r)) && tV(l, c, o, s), (l = a.match(n)) && eV(l, c, o, s), (l = a.match(i)) && $B(l, c, o, s), (l = a.match(t)) && oV(l, c, s), c;
  };
}();
function lV(e, t) {
  var n = [uN, X(`styleSheet`, null, {
      xmlns: ZN[0],
      "xmlns:vt": XN.vt
    })],
    r;
  return e.SSF && (r = rV(e.SSF)) != null && (n[n.length] = r), n[n.length] = `<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>`, n[n.length] = `<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>`, n[n.length] = `<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>`, n[n.length] = `<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>`, (r = sV(t.cellXfs)) && (n[n.length] = r), n[n.length] = `<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>`, n[n.length] = `<dxfs count="0"/>`, n[n.length] = `<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>`, n.length > 2 && (n[n.length] = `</styleSheet>`, n[1] = n[1].replace(`/>`, `>`)), n.join(``);
}
function uV(e, t) {
  return [e.read_shift(2), uF(e, t - 2)];
}
function dV(e, t, n) {
  n ||= Z(6 + 4 * t.length), n.write_shift(2, e), dF(t, n);
  var r = n.length > n.l ? n.slice(0, n.l) : n;
  return n.l ?? (n.l = n.length), r;
}
function fV(e, t, n) {
  var r = {};
  r.sz = e.read_shift(2) / 20;
  var i = zF(e, 2, n);
  switch (i.fItalic && (r.italic = 1), i.fCondense && (r.condense = 1), i.fExtend && (r.extend = 1), i.fShadow && (r.shadow = 1), i.fOutline && (r.outline = 1), i.fStrikeout && (r.strike = 1), e.read_shift(2) === 700 && (r.bold = 1), e.read_shift(2)) {
    case 1:
      r.vertAlign = `superscript`;
      break;
    case 2:
      r.vertAlign = `subscript`;
  }
  var a = e.read_shift(1);
  a != 0 && (r.underline = a);
  var o = e.read_shift(1);
  o > 0 && (r.family = o);
  var s = e.read_shift(1);
  switch (s > 0 && (r.charset = s), e.l++, r.color = LF(e, 8), e.read_shift(1)) {
    case 1:
      r.scheme = `major`;
      break;
    case 2:
      r.scheme = `minor`;
  }
  return r.name = uF(e, t - 21), r;
}
function pV(e, t) {
  t ||= Z(153), t.write_shift(2, e.sz * 20), BF(e, t), t.write_shift(2, e.bold ? 700 : 400);
  var n = 0;
  e.vertAlign == `superscript` ? n = 1 : e.vertAlign == `subscript` && (n = 2), t.write_shift(2, n), t.write_shift(1, e.underline || 0), t.write_shift(1, e.family || 0), t.write_shift(1, e.charset || 0), t.write_shift(1, 0), RF(e.color, t);
  var r = 0;
  return e.scheme == `major` && (r = 1), e.scheme == `minor` && (r = 2), t.write_shift(1, r), dF(e.name, t), t.length > t.l ? t.slice(0, t.l) : t;
}
var mV = [`none`, `solid`, `mediumGray`, `darkGray`, `lightGray`, `darkHorizontal`, `darkVertical`, `darkDown`, `darkUp`, `darkGrid`, `darkTrellis`, `lightHorizontal`, `lightVertical`, `lightDown`, `lightUp`, `lightGrid`, `lightTrellis`, `gray125`, `gray0625`],
  hV,
  gV = IP;
function _V(e, t) {
  t ||= Z(84), hV ||= AM(mV);
  var n = hV[e.patternType];
  n ??= 40, t.write_shift(4, n);
  var r = 0;
  if (n != 40) for (RF({
    auto: 1
  }, t), RF({
    auto: 1
  }, t); r < 12; ++r) t.write_shift(4, 0);else {
    for (; r < 4; ++r) t.write_shift(4, 0);
    for (; r < 12; ++r) t.write_shift(4, 0);
  }
  return t.length > t.l ? t.slice(0, t.l) : t;
}
function vV(e, t) {
  var n = e.l + t,
    r = e.read_shift(2),
    i = e.read_shift(2);
  return e.l = n, {
    ixfe: r,
    numFmtId: i
  };
}
function yV(e, t, n) {
  return n ||= Z(16), n.write_shift(2, t || 0), n.write_shift(2, e.numFmtId || 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(1, 0), n;
}
function bV(e, t) {
  return t ||= Z(10), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
var xV = IP;
function SV(e, t) {
  return t ||= Z(51), t.write_shift(1, 0), bV(null, t), bV(null, t), bV(null, t), bV(null, t), bV(null, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function CV(e, t) {
  return t ||= Z(52), t.write_shift(4, e.xfId), t.write_shift(2, 1), t.write_shift(1, +e.builtinId), t.write_shift(1, 0), TF(e.name || ``, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function wV(e, t, n) {
  var r = Z(2052);
  return r.write_shift(4, e), TF(t, r), TF(n, r), r.length > r.l ? r.slice(0, r.l) : r;
}
function TV(e, t, n) {
  var r = {};
  for (var i in r.NumberFmt = [], bj) r.NumberFmt[i] = bj[i];
  r.CellXf = [], r.Fonts = [];
  var a = [],
    o = !1;
  return LP(e, function (e, i, s) {
    switch (s) {
      case 44:
        r.NumberFmt[e[0]] = e[1], pM(e[1], e[0]);
        break;
      case 43:
        r.Fonts.push(e), e.color.theme != null && t && t.themeElements && t.themeElements.clrScheme && (e.color.rgb = RB(t.themeElements.clrScheme[e.color.theme].rgb, e.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        a[a.length - 1] == 617 && r.CellXf.push(e);
        break;
      case 48:
      case 507:
      case 572:
      case 475:
        break;
      case 1171:
      case 2102:
      case 1130:
      case 512:
      case 2095:
      case 3072:
        break;
      case 35:
        o = !0;
        break;
      case 36:
        o = !1;
        break;
      case 37:
        a.push(s), o = !0;
        break;
      case 38:
        a.pop(), o = !1;
        break;
      default:
        if (i.T > 0) a.push(s);else if (i.T < 0) a.pop();else if (!o || n.WTF && a[a.length - 1] != 37) throw Error(`Unexpected record 0x` + s.toString(16));
    }
  }), r;
}
function EV(e, t) {
  if (t) {
    var n = 0;
    [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (e) {
      for (var r = e[0]; r <= e[1]; ++r) t[r] != null && ++n;
    }), n != 0 && (Q(e, 615, lF(n)), [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (n) {
      for (var r = n[0]; r <= n[1]; ++r) t[r] != null && Q(e, 44, dV(r, t[r]));
    }), Q(e, 616));
  }
}
function DV(e) {
  var t = 1;
  t != 0 && (Q(e, 611, lF(t)), Q(e, 43, pV({
    sz: 12,
    color: {
      theme: 1
    },
    name: `Calibri`,
    family: 2,
    scheme: `minor`
  })), Q(e, 612));
}
function OV(e) {
  var t = 2;
  t != 0 && (Q(e, 603, lF(t)), Q(e, 45, _V({
    patternType: `none`
  })), Q(e, 45, _V({
    patternType: `gray125`
  })), Q(e, 604));
}
function kV(e) {
  var t = 1;
  t != 0 && (Q(e, 613, lF(t)), Q(e, 46, SV({})), Q(e, 614));
}
function AV(e) {
  Q(e, 626, lF(1)), Q(e, 47, yV({
    numFmtId: 0,
    fontId: 0,
    fillId: 0,
    borderId: 0
  }, 65535)), Q(e, 627);
}
function jV(e, t) {
  Q(e, 617, lF(t.length)), t.forEach(function (t) {
    Q(e, 47, yV(t, 0));
  }), Q(e, 618);
}
function MV(e) {
  Q(e, 619, lF(1)), Q(e, 48, CV({
    xfId: 0,
    builtinId: 0,
    name: `Normal`
  })), Q(e, 620);
}
function NV(e) {
  Q(e, 505, lF(0)), Q(e, 506);
}
function PV(e) {
  Q(e, 508, wV(0, `TableStyleMedium9`, `PivotStyleMedium4`)), Q(e, 509);
}
function FV(e, t) {
  var n = RP();
  return Q(n, 278), EV(n, e.SSF), DV(n, e), OV(n, e), kV(n, e), AV(n, e), jV(n, t.cellXfs), MV(n, e), NV(n, e), PV(n, e), Q(n, 279), n.end();
}
var IV = [`</a:lt1>`, `</a:dk1>`, `</a:lt2>`, `</a:dk2>`, `</a:accent1>`, `</a:accent2>`, `</a:accent3>`, `</a:accent4>`, `</a:accent5>`, `</a:accent6>`, `</a:hlink>`, `</a:folHlink>`];
function LV(e, t, n) {
  t.themeElements.clrScheme = [];
  var r = {};
  (e[0].match(pN) || []).forEach(function (e) {
    var i = gN(e);
    switch (i[0]) {
      case `<a:clrScheme`:
      case `</a:clrScheme>`:
        break;
      case `<a:srgbClr`:
        r.rgb = i.val;
        break;
      case `<a:sysClr`:
        r.rgb = i.lastClr;
        break;
      case `<a:dk1>`:
      case `</a:dk1>`:
      case `<a:lt1>`:
      case `</a:lt1>`:
      case `<a:dk2>`:
      case `</a:dk2>`:
      case `<a:lt2>`:
      case `</a:lt2>`:
      case `<a:accent1>`:
      case `</a:accent1>`:
      case `<a:accent2>`:
      case `</a:accent2>`:
      case `<a:accent3>`:
      case `</a:accent3>`:
      case `<a:accent4>`:
      case `</a:accent4>`:
      case `<a:accent5>`:
      case `</a:accent5>`:
      case `<a:accent6>`:
      case `</a:accent6>`:
      case `<a:hlink>`:
      case `</a:hlink>`:
      case `<a:folHlink>`:
      case `</a:folHlink>`:
        i[0].charAt(1) === `/` ? (t.themeElements.clrScheme[IV.indexOf(i[0])] = r, r = {}) : r.name = i[0].slice(3, i[0].length - 1);
        break;
      default:
        if (n && n.WTF) throw Error(`Unrecognized ` + i[0] + ` in clrScheme`);
    }
  });
}
function RV() {}
function zV() {}
var BV = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/,
  VV = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/,
  HV = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function UV(e, t, n) {
  t.themeElements = {};
  var r;
  [[`clrScheme`, BV, LV], [`fontScheme`, VV, RV], [`fmtScheme`, HV, zV]].forEach(function (i) {
    if (!(r = e.match(i[1]))) throw Error(i[0] + ` not found in themeElements`);
    i[2](r, t, n);
  });
}
var WV = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function GV(e, t) {
  (!e || e.length === 0) && (e = KV());
  var n,
    r = {};
  if (!(n = e.match(WV))) throw Error(`themeElements not found in theme`);
  return UV(n[0], r, t), r.raw = e, r;
}
function KV(e, t) {
  if (t && t.themeXLSX) return t.themeXLSX;
  if (e && typeof e.raw == `string`) return e.raw;
  var n = [uN];
  return n[n.length] = `<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">`, n[n.length] = `<a:themeElements>`, n[n.length] = `<a:clrScheme name="Office">`, n[n.length] = `<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>`, n[n.length] = `<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>`, n[n.length] = `<a:dk2><a:srgbClr val="1F497D"/></a:dk2>`, n[n.length] = `<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>`, n[n.length] = `<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>`, n[n.length] = `<a:accent2><a:srgbClr val="C0504D"/></a:accent2>`, n[n.length] = `<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>`, n[n.length] = `<a:accent4><a:srgbClr val="8064A2"/></a:accent4>`, n[n.length] = `<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>`, n[n.length] = `<a:accent6><a:srgbClr val="F79646"/></a:accent6>`, n[n.length] = `<a:hlink><a:srgbClr val="0000FF"/></a:hlink>`, n[n.length] = `<a:folHlink><a:srgbClr val="800080"/></a:folHlink>`, n[n.length] = `</a:clrScheme>`, n[n.length] = `<a:fontScheme name="Office">`, n[n.length] = `<a:majorFont>`, n[n.length] = `<a:latin typeface="Cambria"/>`, n[n.length] = `<a:ea typeface=""/>`, n[n.length] = `<a:cs typeface=""/>`, n[n.length] = `<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>`, n[n.length] = `<a:font script="Hang" typeface="맑은 고딕"/>`, n[n.length] = `<a:font script="Hans" typeface="宋体"/>`, n[n.length] = `<a:font script="Hant" typeface="新細明體"/>`, n[n.length] = `<a:font script="Arab" typeface="Times New Roman"/>`, n[n.length] = `<a:font script="Hebr" typeface="Times New Roman"/>`, n[n.length] = `<a:font script="Thai" typeface="Tahoma"/>`, n[n.length] = `<a:font script="Ethi" typeface="Nyala"/>`, n[n.length] = `<a:font script="Beng" typeface="Vrinda"/>`, n[n.length] = `<a:font script="Gujr" typeface="Shruti"/>`, n[n.length] = `<a:font script="Khmr" typeface="MoolBoran"/>`, n[n.length] = `<a:font script="Knda" typeface="Tunga"/>`, n[n.length] = `<a:font script="Guru" typeface="Raavi"/>`, n[n.length] = `<a:font script="Cans" typeface="Euphemia"/>`, n[n.length] = `<a:font script="Cher" typeface="Plantagenet Cherokee"/>`, n[n.length] = `<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>`, n[n.length] = `<a:font script="Tibt" typeface="Microsoft Himalaya"/>`, n[n.length] = `<a:font script="Thaa" typeface="MV Boli"/>`, n[n.length] = `<a:font script="Deva" typeface="Mangal"/>`, n[n.length] = `<a:font script="Telu" typeface="Gautami"/>`, n[n.length] = `<a:font script="Taml" typeface="Latha"/>`, n[n.length] = `<a:font script="Syrc" typeface="Estrangelo Edessa"/>`, n[n.length] = `<a:font script="Orya" typeface="Kalinga"/>`, n[n.length] = `<a:font script="Mlym" typeface="Kartika"/>`, n[n.length] = `<a:font script="Laoo" typeface="DokChampa"/>`, n[n.length] = `<a:font script="Sinh" typeface="Iskoola Pota"/>`, n[n.length] = `<a:font script="Mong" typeface="Mongolian Baiti"/>`, n[n.length] = `<a:font script="Viet" typeface="Times New Roman"/>`, n[n.length] = `<a:font script="Uigh" typeface="Microsoft Uighur"/>`, n[n.length] = `<a:font script="Geor" typeface="Sylfaen"/>`, n[n.length] = `</a:majorFont>`, n[n.length] = `<a:minorFont>`, n[n.length] = `<a:latin typeface="Calibri"/>`, n[n.length] = `<a:ea typeface=""/>`, n[n.length] = `<a:cs typeface=""/>`, n[n.length] = `<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>`, n[n.length] = `<a:font script="Hang" typeface="맑은 고딕"/>`, n[n.length] = `<a:font script="Hans" typeface="宋体"/>`, n[n.length] = `<a:font script="Hant" typeface="新細明體"/>`, n[n.length] = `<a:font script="Arab" typeface="Arial"/>`, n[n.length] = `<a:font script="Hebr" typeface="Arial"/>`, n[n.length] = `<a:font script="Thai" typeface="Tahoma"/>`, n[n.length] = `<a:font script="Ethi" typeface="Nyala"/>`, n[n.length] = `<a:font script="Beng" typeface="Vrinda"/>`, n[n.length] = `<a:font script="Gujr" typeface="Shruti"/>`, n[n.length] = `<a:font script="Khmr" typeface="DaunPenh"/>`, n[n.length] = `<a:font script="Knda" typeface="Tunga"/>`, n[n.length] = `<a:font script="Guru" typeface="Raavi"/>`, n[n.length] = `<a:font script="Cans" typeface="Euphemia"/>`, n[n.length] = `<a:font script="Cher" typeface="Plantagenet Cherokee"/>`, n[n.length] = `<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>`, n[n.length] = `<a:font script="Tibt" typeface="Microsoft Himalaya"/>`, n[n.length] = `<a:font script="Thaa" typeface="MV Boli"/>`, n[n.length] = `<a:font script="Deva" typeface="Mangal"/>`, n[n.length] = `<a:font script="Telu" typeface="Gautami"/>`, n[n.length] = `<a:font script="Taml" typeface="Latha"/>`, n[n.length] = `<a:font script="Syrc" typeface="Estrangelo Edessa"/>`, n[n.length] = `<a:font script="Orya" typeface="Kalinga"/>`, n[n.length] = `<a:font script="Mlym" typeface="Kartika"/>`, n[n.length] = `<a:font script="Laoo" typeface="DokChampa"/>`, n[n.length] = `<a:font script="Sinh" typeface="Iskoola Pota"/>`, n[n.length] = `<a:font script="Mong" typeface="Mongolian Baiti"/>`, n[n.length] = `<a:font script="Viet" typeface="Arial"/>`, n[n.length] = `<a:font script="Uigh" typeface="Microsoft Uighur"/>`, n[n.length] = `<a:font script="Geor" typeface="Sylfaen"/>`, n[n.length] = `</a:minorFont>`, n[n.length] = `</a:fontScheme>`, n[n.length] = `<a:fmtScheme name="Office">`, n[n.length] = `<a:fillStyleLst>`, n[n.length] = `<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>`, n[n.length] = `<a:gradFill rotWithShape="1">`, n[n.length] = `<a:gsLst>`, n[n.length] = `<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>`, n[n.length] = `<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>`, n[n.length] = `<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>`, n[n.length] = `</a:gsLst>`, n[n.length] = `<a:lin ang="16200000" scaled="1"/>`, n[n.length] = `</a:gradFill>`, n[n.length] = `<a:gradFill rotWithShape="1">`, n[n.length] = `<a:gsLst>`, n[n.length] = `<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>`, n[n.length] = `<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>`, n[n.length] = `</a:gsLst>`, n[n.length] = `<a:lin ang="16200000" scaled="0"/>`, n[n.length] = `</a:gradFill>`, n[n.length] = `</a:fillStyleLst>`, n[n.length] = `<a:lnStyleLst>`, n[n.length] = `<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>`, n[n.length] = `<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>`, n[n.length] = `<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>`, n[n.length] = `</a:lnStyleLst>`, n[n.length] = `<a:effectStyleLst>`, n[n.length] = `<a:effectStyle>`, n[n.length] = `<a:effectLst>`, n[n.length] = `<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>`, n[n.length] = `</a:effectLst>`, n[n.length] = `</a:effectStyle>`, n[n.length] = `<a:effectStyle>`, n[n.length] = `<a:effectLst>`, n[n.length] = `<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>`, n[n.length] = `</a:effectLst>`, n[n.length] = `</a:effectStyle>`, n[n.length] = `<a:effectStyle>`, n[n.length] = `<a:effectLst>`, n[n.length] = `<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>`, n[n.length] = `</a:effectLst>`, n[n.length] = `<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>`, n[n.length] = `<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>`, n[n.length] = `</a:effectStyle>`, n[n.length] = `</a:effectStyleLst>`, n[n.length] = `<a:bgFillStyleLst>`, n[n.length] = `<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>`, n[n.length] = `<a:gradFill rotWithShape="1">`, n[n.length] = `<a:gsLst>`, n[n.length] = `<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>`, n[n.length] = `<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>`, n[n.length] = `<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>`, n[n.length] = `</a:gsLst>`, n[n.length] = `<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>`, n[n.length] = `</a:gradFill>`, n[n.length] = `<a:gradFill rotWithShape="1">`, n[n.length] = `<a:gsLst>`, n[n.length] = `<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>`, n[n.length] = `<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>`, n[n.length] = `</a:gsLst>`, n[n.length] = `<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>`, n[n.length] = `</a:gradFill>`, n[n.length] = `</a:bgFillStyleLst>`, n[n.length] = `</a:fmtScheme>`, n[n.length] = `</a:themeElements>`, n[n.length] = `<a:objectDefaults>`, n[n.length] = `<a:spDef>`, n[n.length] = `<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>`, n[n.length] = `</a:spDef>`, n[n.length] = `<a:lnDef>`, n[n.length] = `<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>`, n[n.length] = `</a:lnDef>`, n[n.length] = `</a:objectDefaults>`, n[n.length] = `<a:extraClrSchemeLst/>`, n[n.length] = `</a:theme>`, n.join(``);
}
function qV(e, t, n) {
  var r = e.l + t;
  if (e.read_shift(4) !== 124226) {
    if (!n.cellStyles) {
      e.l = r;
      return;
    }
    var i = e.slice(e.l);
    e.l = r;
    var a;
    try {
      a = cN(i, {
        type: `array`
      });
    } catch {
      return;
    }
    var o = rN(a, `theme/theme/theme1.xml`, !0);
    if (o) return GV(o, n);
  }
}
function JV(e) {
  return e.read_shift(4);
}
function YV(e) {
  var t = {};
  switch (t.xclrType = e.read_shift(2), t.nTintShade = e.read_shift(2), t.xclrType) {
    case 0:
      e.l += 4;
      break;
    case 1:
      t.xclrValue = XV(e, 4);
      break;
    case 2:
      t.xclrValue = zL(e, 4);
      break;
    case 3:
      t.xclrValue = JV(e, 4);
      break;
    case 4:
      e.l += 4;
  }
  return e.l += 8, t;
}
function XV(e, t) {
  return IP(e, t);
}
function ZV(e, t) {
  return IP(e, t);
}
function QV(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2) - 4,
    r = [t];
  switch (t) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      r[1] = YV(e, n);
      break;
    case 6:
      r[1] = ZV(e, n);
      break;
    case 14:
    case 15:
      r[1] = e.read_shift(n === 1 ? 1 : 2);
      break;
    default:
      throw Error(`Unrecognized ExtProp type: ` + t + ` ` + n);
  }
  return r;
}
function $V(e, t) {
  var n = e.l + t;
  e.l += 2;
  var r = e.read_shift(2);
  e.l += 2;
  for (var i = e.read_shift(2), a = []; i-- > 0;) a.push(QV(e, n - e.l));
  return {
    ixfe: r,
    ext: a
  };
}
function eH(e, t) {
  t.forEach(function (e) {
    e[0];
  });
}
function tH(e, t) {
  return {
    flags: e.read_shift(4),
    version: e.read_shift(4),
    name: uF(e, t - 8)
  };
}
function nH(e) {
  var t = Z(12 + 2 * e.name.length);
  return t.write_shift(4, e.flags), t.write_shift(4, e.version), dF(e.name, t), t.slice(0, t.l);
}
function rH(e) {
  for (var t = [], n = e.read_shift(4); n-- > 0;) t.push([e.read_shift(4), e.read_shift(4)]);
  return t;
}
function iH(e) {
  var t = Z(4 + 8 * e.length);
  t.write_shift(4, e.length);
  for (var n = 0; n < e.length; ++n) t.write_shift(4, e[n][0]), t.write_shift(4, e[n][1]);
  return t;
}
function aH(e, t) {
  var n = Z(8 + 2 * t.length);
  return n.write_shift(4, e), dF(t, n), n.slice(0, n.l);
}
function oH(e) {
  return e.l += 4, e.read_shift(4) != 0;
}
function sH(e, t) {
  var n = Z(8);
  return n.write_shift(4, e), n.write_shift(4, +!!t), n;
}
function cH(e, t, n) {
  var r = {
      Types: [],
      Cell: [],
      Value: []
    },
    i = n || {},
    a = [],
    o = !1,
    s = 2;
  return LP(e, function (e, t, n) {
    switch (n) {
      case 335:
        r.Types.push({
          name: e.name
        });
        break;
      case 51:
        e.forEach(function (e) {
          s == 1 ? r.Cell.push({
            type: r.Types[e[0] - 1].name,
            index: e[1]
          }) : s == 0 && r.Value.push({
            type: r.Types[e[0] - 1].name,
            index: e[1]
          });
        });
        break;
      case 337:
        s = +!!e;
        break;
      case 338:
        s = 2;
        break;
      case 35:
        a.push(n), o = !0;
        break;
      case 36:
        a.pop(), o = !1;
        break;
      default:
        if (!t.T && (!o || i.WTF && a[a.length - 1] != 35)) throw Error(`Unexpected record 0x` + n.toString(16));
    }
  }), r;
}
function lH() {
  var e = RP();
  return Q(e, 332), Q(e, 334, lF(1)), Q(e, 335, nH({
    name: `XLDAPR`,
    version: 12e4,
    flags: 3496657072
  })), Q(e, 336), Q(e, 339, aH(1, `XLDAPR`)), Q(e, 52), Q(e, 35, lF(514)), Q(e, 4096, lF(0)), Q(e, 4097, bL(1)), Q(e, 36), Q(e, 53), Q(e, 340), Q(e, 337, sH(1, !0)), Q(e, 51, iH([[1, 0]])), Q(e, 338), Q(e, 333), e.end();
}
function uH(e, t, n) {
  var r = {
    Types: [],
    Cell: [],
    Value: []
  };
  if (!e) return r;
  var i = !1,
    a = 2,
    o;
  return e.replace(pN, function (e) {
    var t = gN(e);
    switch (_N(t[0])) {
      case `<?xml`:
        break;
      case `<metadata`:
      case `</metadata>`:
        break;
      case `<metadataTypes`:
      case `</metadataTypes>`:
        break;
      case `<metadataType`:
        r.Types.push({
          name: t.name
        });
        break;
      case `</metadataType>`:
        break;
      case `<futureMetadata`:
        for (var s = 0; s < r.Types.length; ++s) r.Types[s].name == t.name && (o = r.Types[s]);
        break;
      case `</futureMetadata>`:
        break;
      case `<bk>`:
        break;
      case `</bk>`:
        break;
      case `<rc`:
        a == 1 ? r.Cell.push({
          type: r.Types[t.t - 1].name,
          index: +t.v
        }) : a == 0 && r.Value.push({
          type: r.Types[t.t - 1].name,
          index: +t.v
        });
        break;
      case `</rc>`:
        break;
      case `<cellMetadata`:
        a = 1;
        break;
      case `</cellMetadata>`:
        a = 2;
        break;
      case `<valueMetadata`:
        a = 0;
        break;
      case `</valueMetadata>`:
        a = 2;
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
      case `<extLst/>`:
        break;
      case `<ext`:
        i = !0;
        break;
      case `</ext>`:
        i = !1;
        break;
      case `<rvb`:
        if (!o) break;
        o.offsets || (o.offsets = []), o.offsets.push(+t.i);
        break;
      default:
        if (!i && n.WTF) throw Error(`unrecognized ` + t[0] + ` in metadata`);
    }
    return e;
  }), r;
}
function dH() {
  var e = [uN];
  return e.push(`<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">
  <metadataTypes count="1">
    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>
  </metadataTypes>
  <futureMetadata name="XLDAPR" count="1">
    <bk>
      <extLst>
        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">
          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>
        </ext>
      </extLst>
    </bk>
  </futureMetadata>
  <cellMetadata count="1">
    <bk>
      <rc t="1" v="0"/>
    </bk>
  </cellMetadata>
</metadata>`), e.join(``);
}
function fH(e) {
  var t = [];
  if (!e) return t;
  var n = 1;
  return (e.match(pN) || []).forEach(function (e) {
    var r = gN(e);
    switch (r[0]) {
      case `<?xml`:
        break;
      case `<calcChain`:
      case `<calcChain>`:
      case `</calcChain>`:
        break;
      case `<c`:
        delete r[0], r.i ? n = r.i : r.i = n, t.push(r);
    }
  }), t;
}
function pH(e) {
  var t = {};
  t.i = e.read_shift(4);
  var n = {};
  n.r = e.read_shift(4), n.c = e.read_shift(4), t.r = $P(n);
  var r = e.read_shift(1);
  return r & 2 && (t.l = `1`), r & 8 && (t.a = `1`), t;
}
function mH(e, t, n) {
  var r = [];
  return LP(e, function (e, t, n) {
    switch (n) {
      case 63:
        r.push(e);
        break;
      default:
        if (!t.T) throw Error(`Unexpected record 0x` + n.toString(16));
    }
  }), r;
}
function hH(e, t, n, r) {
  if (!e) return e;
  var i = r || {},
    a = !1;
  LP(e, function (e, t, n) {
    switch (n) {
      case 359:
      case 363:
      case 364:
      case 366:
      case 367:
      case 368:
      case 369:
      case 370:
      case 371:
      case 472:
      case 577:
      case 578:
      case 579:
      case 580:
      case 581:
      case 582:
      case 583:
      case 584:
      case 585:
      case 586:
      case 587:
        break;
      case 35:
        a = !0;
        break;
      case 36:
        a = !1;
        break;
      default:
        if (!t.T && (!a || i.WTF)) throw Error(`Unexpected record 0x` + n.toString(16));
    }
  }, i);
}
function gH(e, t) {
  if (!e) return `??`;
  var n = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || [``, ``])[1];
  return t[`!id`][n].Target;
}
var _H = 1024;
function vH(e, t) {
  for (var n = [21600, 21600], r = [`m0,0l0`, n[1], n[0], n[1], n[0], `0xe`].join(`,`), i = [X(`xml`, null, {
      "xmlns:v": QN.v,
      "xmlns:o": QN.o,
      "xmlns:x": QN.x,
      "xmlns:mv": QN.mv
    }).replace(/\/>/, `>`), X(`o:shapelayout`, X(`o:idmap`, null, {
      "v:ext": `edit`,
      data: e
    }), {
      "v:ext": `edit`
    }), X(`v:shapetype`, [X(`v:stroke`, null, {
      joinstyle: `miter`
    }), X(`v:path`, null, {
      gradientshapeok: `t`,
      "o:connecttype": `rect`
    })].join(``), {
      id: `_x0000_t202`,
      "o:spt": 202,
      coordsize: n.join(`,`),
      path: r
    })]; _H < e * 1e3;) _H += 1e3;
  return t.forEach(function (e) {
    var t = QP(e[0]),
      n = {
        color2: `#BEFF82`,
        type: `gradient`
      };
    n.type == `gradient` && (n.angle = `-180`);
    var r = X(`v:fill`, n.type == `gradient` ? X(`o:fill`, null, {
      type: `gradientUnscaled`,
      "v:ext": `view`
    }) : null, n);
    ++_H, i = i.concat([`<v:shape` + GN({
      id: `_x0000_s` + _H,
      type: `#_x0000_t202`,
      style: `position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10` + (e[1].hidden ? `;visibility:hidden` : ``),
      fillcolor: `#ECFAD4`,
      strokecolor: `#edeaa1`
    }) + `>`, r, X(`v:shadow`, null, {
      on: `t`,
      obscured: `t`
    }), X(`v:path`, null, {
      "o:connecttype": `none`
    }), `<v:textbox><div style="text-align:left"></div></v:textbox>`, `<x:ClientData ObjectType="Note">`, `<x:MoveWithCells/>`, `<x:SizeWithCells/>`, WN(`x:Anchor`, [t.c + 1, 0, t.r + 1, 0, t.c + 3, 20, t.r + 5, 20].join(`,`)), WN(`x:AutoFill`, `False`), WN(`x:Row`, String(t.r)), WN(`x:Column`, String(t.c)), e[1].hidden ? `` : `<x:Visible/>`, `</x:ClientData>`, `</v:shape>`]);
  }), i.push(`</xml>`), i.join(``);
}
function yH(e, t, n, r) {
  var i = Array.isArray(e),
    a;
  t.forEach(function (t) {
    var o = QP(t.ref);
    if (i ? (e[o.r] || (e[o.r] = []), a = e[o.r][o.c]) : a = e[t.ref], !a) {
      a = {
        t: `z`
      }, i ? e[o.r][o.c] = a : e[t.ref] = a;
      var s = nF(e[`!ref`] || `BDWGO1000001:A1`);
      s.s.r > o.r && (s.s.r = o.r), s.e.r < o.r && (s.e.r = o.r), s.s.c > o.c && (s.s.c = o.c), s.e.c < o.c && (s.e.c = o.c);
      var c = tF(s);
      c !== e[`!ref`] && (e[`!ref`] = c);
    }
    a.c || (a.c = []);
    var l = {
      a: t.author,
      t: t.t,
      r: t.r,
      T: n
    };
    t.h && (l.h = t.h);
    for (var u = a.c.length - 1; u >= 0; --u) {
      if (!n && a.c[u].T) return;
      n && !a.c[u].T && a.c.splice(u, 1);
    }
    if (n && r) {
      for (u = 0; u < r.length; ++u) if (l.a == r[u].id) {
        l.a = r[u].name || l.a;
        break;
      }
    }
    a.c.push(l);
  });
}
function bH(e, t) {
  if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
  var n = [],
    r = [],
    i = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  i && i[1] && i[1].split(/<\/\w*:?author>/).forEach(function (e) {
    if (e !== `` && e.trim() !== ``) {
      var t = e.match(/<(?:\w+:)?author[^>]*>(.*)/);
      t && n.push(t[1]);
    }
  });
  var a = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return a && a[1] && a[1].split(/<\/\w*:?comment>/).forEach(function (e) {
    if (e !== `` && e.trim() !== ``) {
      var i = e.match(/<(?:\w+:)?comment[^>]*>/);
      if (i) {
        var a = gN(i[0]),
          o = {
            author: a.authorId && n[a.authorId] || `sheetjsghost`,
            ref: a.ref,
            guid: a.guid
          },
          s = QP(a.ref);
        if (!(t.sheetRows && t.sheetRows <= s.r)) {
          var c = e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/),
            l = !!c && !!c[1] && Qz(c[1]) || {
              r: ``,
              t: ``,
              h: ``
            };
          o.r = l.r, l.r == `<t></t>` && (l.t = l.h = ``), o.t = (l.t || ``).replace(/\r\n/g, `
`).replace(/\r/g, `
`), t.cellHTML && (o.h = l.h), r.push(o);
        }
      }
    }
  }), r;
}
function xH(e) {
  var t = [uN, X(`comments`, null, {
      xmlns: ZN[0]
    })],
    n = [];
  return t.push(`<authors>`), e.forEach(function (e) {
    e[1].forEach(function (e) {
      var r = CN(e.a);
      n.indexOf(r) == -1 && (n.push(r), t.push(`<author>` + r + `</author>`)), e.T && e.ID && n.indexOf(`tc=` + e.ID) == -1 && (n.push(`tc=` + e.ID), t.push(`<author>tc=` + e.ID + `</author>`));
    });
  }), n.length == 0 && (n.push(`SheetJ5`), t.push(`<author>SheetJ5</author>`)), t.push(`</authors>`), t.push(`<commentList>`), e.forEach(function (e) {
    var r = 0,
      i = [];
    if (e[1][0] && e[1][0].T && e[1][0].ID ? r = n.indexOf(`tc=` + e[1][0].ID) : e[1].forEach(function (e) {
      e.a && (r = n.indexOf(CN(e.a))), i.push(e.t || ``);
    }), t.push(`<comment ref="` + e[0] + `" authorId="` + r + `"><text>`), i.length <= 1) t.push(WN(`t`, CN(i[0] || ``)));else {
      for (var a = `Comment:
    ` + i[0] + `
`, o = 1; o < i.length; ++o) a += `Reply:
    ` + i[o] + `
`;
      t.push(WN(`t`, CN(a)));
    }
    t.push(`</text></comment>`);
  }), t.push(`</commentList>`), t.length > 2 && (t[t.length] = `</comments>`, t[1] = t[1].replace(`/>`, `>`)), t.join(``);
}
function SH(e, t) {
  var n = [],
    r = !1,
    i = {},
    a = 0;
  return e.replace(pN, function (o, s) {
    var c = gN(o);
    switch (_N(c[0])) {
      case `<?xml`:
        break;
      case `<ThreadedComments`:
        break;
      case `</ThreadedComments>`:
        break;
      case `<threadedComment`:
        i = {
          author: c.personId,
          guid: c.id,
          ref: c.ref,
          T: 1
        };
        break;
      case `</threadedComment>`:
        i.t != null && n.push(i);
        break;
      case `<text>`:
      case `<text`:
        a = s + o.length;
        break;
      case `</text>`:
        i.t = e.slice(a, s).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      case `<mentions`:
      case `<mentions>`:
        r = !0;
        break;
      case `</mentions>`:
        r = !1;
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
      case `<extLst/>`:
        break;
      case `<ext`:
        r = !0;
        break;
      case `</ext>`:
        r = !1;
        break;
      default:
        if (!r && t.WTF) throw Error(`unrecognized ` + c[0] + ` in threaded comments`);
    }
    return o;
  }), n;
}
function CH(e, t, n) {
  var r = [uN, X(`ThreadedComments`, null, {
    xmlns: XN.TCMNT
  }).replace(/[\/]>/, `>`)];
  return e.forEach(function (e) {
    var i = ``;
    (e[1] || []).forEach(function (a, o) {
      if (!a.T) {
        delete a.ID;
        return;
      }
      a.a && t.indexOf(a.a) == -1 && t.push(a.a);
      var s = {
        ref: e[0],
        id: `{54EE7951-7262-4200-6969-` + (`000000000000` + n.tcid++).slice(-12) + `}`
      };
      o == 0 ? i = s.id : s.parentId = i, a.ID = s.id, a.a && (s.personId = `{54EE7950-7262-4200-6969-` + (`000000000000` + t.indexOf(a.a)).slice(-12) + `}`), r.push(X(`threadedComment`, WN(`text`, a.t || ``), s));
    });
  }), r.push(`</ThreadedComments>`), r.join(``);
}
function wH(e, t) {
  var n = [],
    r = !1;
  return e.replace(pN, function (e) {
    var i = gN(e);
    switch (_N(i[0])) {
      case `<?xml`:
        break;
      case `<personList`:
        break;
      case `</personList>`:
        break;
      case `<person`:
        n.push({
          name: i.displayname,
          id: i.id
        });
        break;
      case `</person>`:
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
      case `<extLst/>`:
        break;
      case `<ext`:
        r = !0;
        break;
      case `</ext>`:
        r = !1;
        break;
      default:
        if (!r && t.WTF) throw Error(`unrecognized ` + i[0] + ` in threaded comments`);
    }
    return e;
  }), n;
}
function TH(e) {
  var t = [uN, X(`personList`, null, {
    xmlns: XN.TCMNT,
    "xmlns:x": ZN[0]
  }).replace(/[\/]>/, `>`)];
  return e.forEach(function (e, n) {
    t.push(X(`person`, null, {
      displayName: e,
      id: `{54EE7950-7262-4200-6969-` + (`000000000000` + n).slice(-12) + `}`,
      userId: e,
      providerId: `None`
    }));
  }), t.push(`</personList>`), t.join(``);
}
function EH(e) {
  var t = {};
  t.iauthor = e.read_shift(4);
  var n = NF(e, 16);
  return t.rfx = n.s, t.ref = $P(n.s), e.l += 16, t;
}
function DH(e, t) {
  return t ??= Z(36), t.write_shift(4, e[1].iauthor), PF(e[0], t), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
var OH = uF;
function kH(e) {
  return dF(e.slice(0, 54));
}
function AH(e, t) {
  var n = [],
    r = [],
    i = {},
    a = !1;
  return LP(e, function (e, o, s) {
    switch (s) {
      case 632:
        r.push(e);
        break;
      case 635:
        i = e;
        break;
      case 637:
        i.t = e.t, i.h = e.h, i.r = e.r;
        break;
      case 636:
        if (i.author = r[i.iauthor], delete i.iauthor, t.sheetRows && i.rfx && t.sheetRows <= i.rfx.r) break;
        i.t || (i.t = ``), delete i.rfx, n.push(i);
        break;
      case 3072:
        break;
      case 35:
        a = !0;
        break;
      case 36:
        a = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!o.T && (!a || t.WTF)) throw Error(`Unexpected record 0x` + s.toString(16));
    }
  }), n;
}
function jH(e) {
  var t = RP(),
    n = [];
  return Q(t, 628), Q(t, 630), e.forEach(function (e) {
    e[1].forEach(function (e) {
      n.indexOf(e.a) > -1 || (n.push(e.a.slice(0, 54)), Q(t, 632, kH(e.a)));
    });
  }), Q(t, 631), Q(t, 633), e.forEach(function (e) {
    e[1].forEach(function (r) {
      r.iauthor = n.indexOf(r.a), Q(t, 635, DH([{
        s: QP(e[0]),
        e: QP(e[0])
      }, r])), r.t && r.t.length > 0 && Q(t, 637, _F(r)), Q(t, 636), delete r.iauthor;
    });
  }), Q(t, 634), Q(t, 629), t.end();
}
var MH = `application/vnd.ms-office.vbaProject`;
function NH(e) {
  var t = SM.utils.cfb_new({
    root: `R`
  });
  return e.FullPaths.forEach(function (n, r) {
    if (n.slice(-1) !== `/` && n.match(/_VBA_PROJECT_CUR/)) {
      var i = n.replace(/^[^\/]*/, `R`).replace(/\/_VBA_PROJECT_CUR\u0000*/, ``);
      SM.utils.cfb_add(t, i, e.FileIndex[r].content);
    }
  }), SM.write(t);
}
function PH(e, t) {
  t.FullPaths.forEach(function (n, r) {
    if (r != 0) {
      var i = n.replace(/[^\/]*[\/]/, `/_VBA_PROJECT_CUR/`);
      i.slice(-1) !== `/` && SM.utils.cfb_add(e, i, t.FileIndex[r].content);
    }
  });
}
var FH = [`xlsb`, `xlsm`, `xlam`, `biff8`, `xla`];
function IH() {
  return {
    "!type": `dialog`
  };
}
function LH() {
  return {
    "!type": `dialog`
  };
}
function RH() {
  return {
    "!type": `macro`
  };
}
function zH() {
  return {
    "!type": `macro`
  };
}
var BH = function () {
    var e = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g,
      t = {
        r: 0,
        c: 0
      };
    function n(e, n, r, i) {
      var a = !1,
        o = !1;
      r.length == 0 ? o = !0 : r.charAt(0) == `[` && (o = !0, r = r.slice(1, -1)), i.length == 0 ? a = !0 : i.charAt(0) == `[` && (a = !0, i = i.slice(1, -1));
      var s = r.length > 0 ? parseInt(r, 10) | 0 : 0,
        c = i.length > 0 ? parseInt(i, 10) | 0 : 0;
      return a ? c += t.c : --c, o ? s += t.r : --s, n + (a ? `` : `$`) + JP(c) + (o ? `` : `$`) + WP(s);
    }
    return function (r, i) {
      return t = i, r.replace(e, n);
    };
  }(),
  VH = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g,
  HH = function () {
    return function (e, t) {
      return e.replace(VH, function (e, n, r, i, a, o) {
        var s = qP(i) - (r ? 0 : t.c),
          c = UP(o) - (a ? 0 : t.r),
          l = c == 0 ? `` : a ? c + 1 : `[` + c + `]`,
          u = s == 0 ? `` : r ? s + 1 : `[` + s + `]`;
        return n + `R` + l + `C` + u;
      });
    };
  }();
function UH(e, t) {
  return e.replace(VH, function (e, n, r, i, a, o) {
    return n + (r == `$` ? r + i : JP(qP(i) + t.c)) + (a == `$` ? a + o : WP(UP(o) + t.r));
  });
}
function WH(e, t, n) {
  var r = eF(t).s,
    i = QP(n);
  return UH(e, {
    r: i.r - r.r,
    c: i.c - r.c
  });
}
function GH(e) {
  return e.length != 1;
}
function KH(e) {
  return e.replace(/_xlfn\./g, ``);
}
function qH(e) {
  e.l += 1;
}
function JH(e, t) {
  var n = e.read_shift(t == 1 ? 1 : 2);
  return [n & 16383, n >> 14 & 1, n >> 15 & 1];
}
function YH(e, t, n) {
  var r = 2;
  if (n) {
    if (n.biff >= 2 && n.biff <= 5) return XH(e, t, n);
    n.biff == 12 && (r = 4);
  }
  var i = e.read_shift(r),
    a = e.read_shift(r),
    o = JH(e, 2),
    s = JH(e, 2);
  return {
    s: {
      r: i,
      c: o[0],
      cRel: o[1],
      rRel: o[2]
    },
    e: {
      r: a,
      c: s[0],
      cRel: s[1],
      rRel: s[2]
    }
  };
}
function XH(e) {
  var t = JH(e, 2),
    n = JH(e, 2),
    r = e.read_shift(1),
    i = e.read_shift(1);
  return {
    s: {
      r: t[0],
      c: r,
      cRel: t[1],
      rRel: t[2]
    },
    e: {
      r: n[0],
      c: i,
      cRel: n[1],
      rRel: n[2]
    }
  };
}
function ZH(e, t, n) {
  if (n.biff < 8) return XH(e, t, n);
  var r = e.read_shift(n.biff == 12 ? 4 : 2),
    i = e.read_shift(n.biff == 12 ? 4 : 2),
    a = JH(e, 2),
    o = JH(e, 2);
  return {
    s: {
      r,
      c: a[0],
      cRel: a[1],
      rRel: a[2]
    },
    e: {
      r: i,
      c: o[0],
      cRel: o[1],
      rRel: o[2]
    }
  };
}
function QH(e, t, n) {
  if (n && n.biff >= 2 && n.biff <= 5) return $H(e, t, n);
  var r = e.read_shift(n && n.biff == 12 ? 4 : 2),
    i = JH(e, 2);
  return {
    r,
    c: i[0],
    cRel: i[1],
    rRel: i[2]
  };
}
function $H(e) {
  var t = JH(e, 2),
    n = e.read_shift(1);
  return {
    r: t[0],
    c: n,
    cRel: t[1],
    rRel: t[2]
  };
}
function eU(e) {
  var t = e.read_shift(2),
    n = e.read_shift(2);
  return {
    r: t,
    c: n & 255,
    fQuoted: !!(n & 16384),
    cRel: n >> 15,
    rRel: n >> 15
  };
}
function tU(e, t, n) {
  var r = n && n.biff ? n.biff : 8;
  if (r >= 2 && r <= 5) return nU(e, t, n);
  var i = e.read_shift(r >= 12 ? 4 : 2),
    a = e.read_shift(2),
    o = (a & 16384) >> 14,
    s = (a & 32768) >> 15;
  if (a &= 16383, s == 1) for (; i > 524287;) i -= 1048576;
  if (o == 1) for (; a > 8191;) a -= 16384;
  return {
    r: i,
    c: a,
    cRel: o,
    rRel: s
  };
}
function nU(e) {
  var t = e.read_shift(2),
    n = e.read_shift(1),
    r = (t & 32768) >> 15,
    i = (t & 16384) >> 14;
  return t &= 16383, r == 1 && t >= 8192 && (t -= 16384), i == 1 && n >= 128 && (n -= 256), {
    r: t,
    c: n,
    cRel: i,
    rRel: r
  };
}
function rU(e, t, n) {
  return [(e[e.l++] & 96) >> 5, YH(e, n.biff >= 2 && n.biff <= 5 ? 6 : 8, n)];
}
function iU(e, t, n) {
  var r = (e[e.l++] & 96) >> 5,
    i = e.read_shift(2, `i`),
    a = 8;
  if (n) switch (n.biff) {
    case 5:
      e.l += 12, a = 6;
      break;
    case 12:
      a = 12;
  }
  return [r, i, YH(e, a, n)];
}
function aU(e, t, n) {
  var r = (e[e.l++] & 96) >> 5;
  return e.l += n && n.biff > 8 ? 12 : n.biff < 8 ? 6 : 8, [r];
}
function oU(e, t, n) {
  var r = (e[e.l++] & 96) >> 5,
    i = e.read_shift(2),
    a = 8;
  if (n) switch (n.biff) {
    case 5:
      e.l += 12, a = 6;
      break;
    case 12:
      a = 12;
  }
  return e.l += a, [r, i];
}
function sU(e, t, n) {
  return [(e[e.l++] & 96) >> 5, ZH(e, t - 1, n)];
}
function cU(e, t, n) {
  var r = (e[e.l++] & 96) >> 5;
  return e.l += n.biff == 2 ? 6 : n.biff == 12 ? 14 : 7, [r];
}
function lU(e) {
  var t = e[e.l + 1] & 1;
  return e.l += 4, [t, 1];
}
function uU(e, t, n) {
  e.l += 2;
  for (var r = e.read_shift(n && n.biff == 2 ? 1 : 2), i = [], a = 0; a <= r; ++a) i.push(e.read_shift(n && n.biff == 2 ? 1 : 2));
  return i;
}
function dU(e, t, n) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [r, e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function fU(e, t, n) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [r, e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function pU(e) {
  var t = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [t, e.read_shift(2)];
}
function mU(e, t, n) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += n && n.biff == 2 ? 3 : 4, [r];
}
function hU(e) {
  return [e.read_shift(1), e.read_shift(1)];
}
function gU(e) {
  return e.read_shift(2), hU(e, 2);
}
function _U(e) {
  return e.read_shift(2), hU(e, 2);
}
function vU(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  return e.l += 1, [r, QH(e, 0, n)];
}
function yU(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  return e.l += 1, [r, tU(e, 0, n)];
}
function bU(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  e.l += 1;
  var i = e.read_shift(2);
  return n && n.biff == 5 && (e.l += 12), [r, i, QH(e, 0, n)];
}
function xU(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  e.l += 1;
  var i = e.read_shift(n && n.biff <= 3 ? 1 : 2);
  return [LW[i], IW[i], r];
}
function SU(e, t, n) {
  var r = e[e.l++],
    i = e.read_shift(1),
    a = n && n.biff <= 3 ? [r == 88 ? -1 : 0, e.read_shift(1)] : CU(e);
  return [i, (a[0] === 0 ? IW : FW)[a[1]]];
}
function CU(e) {
  return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
}
function wU(e, t, n) {
  e.l += n && n.biff == 2 ? 3 : 4;
}
function TU(e, t, n) {
  return e.l++, n && n.biff == 12 ? [e.read_shift(4, `i`), 0] : [e.read_shift(2), e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function EU(e) {
  return e.l++, lI[e.read_shift(1)];
}
function DU(e) {
  return e.l++, e.read_shift(2);
}
function OU(e) {
  return e.l++, e.read_shift(1) !== 0;
}
function kU(e) {
  return e.l++, FF(e, 8);
}
function AU(e, t, n) {
  return e.l++, wL(e, t - 1, n);
}
function jU(e, t) {
  var n = [e.read_shift(1)];
  if (t == 12) switch (n[0]) {
    case 2:
      n[0] = 4;
      break;
    case 4:
      n[0] = 16;
      break;
    case 0:
      n[0] = 1;
      break;
    case 1:
      n[0] = 2;
  }
  switch (n[0]) {
    case 4:
      n[1] = _L(e, 1) ? `TRUE` : `FALSE`, t != 12 && (e.l += 7);
      break;
    case 37:
    case 16:
      n[1] = lI[e[e.l]], e.l += t == 12 ? 4 : 8;
      break;
    case 0:
      e.l += 8;
      break;
    case 1:
      n[1] = FF(e, 8);
      break;
    case 2:
      n[1] = kL(e, 0, {
        biff: t > 0 && t < 8 ? 2 : t
      });
      break;
    default:
      throw Error(`Bad SerAr: ` + n[0]);
  }
  return n;
}
function MU(e, t, n) {
  for (var r = e.read_shift(n.biff == 12 ? 4 : 2), i = [], a = 0; a != r; ++a) i.push((n.biff == 12 ? NF : JL)(e, 8));
  return i;
}
function NU(e, t, n) {
  var r = 0,
    i = 0;
  n.biff == 12 ? (r = e.read_shift(4), i = e.read_shift(4)) : (i = 1 + e.read_shift(1), r = 1 + e.read_shift(2)), n.biff >= 2 && n.biff < 8 && (--r, --i == 0 && (i = 256));
  for (var a = 0, o = []; a != r && (o[a] = []); ++a) for (var s = 0; s != i; ++s) o[a][s] = jU(e, n.biff);
  return o;
}
function PU(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3,
    i = !n || n.biff >= 8 ? 4 : 2,
    a = e.read_shift(i);
  switch (n.biff) {
    case 2:
      e.l += 5;
      break;
    case 3:
    case 4:
      e.l += 8;
      break;
    case 5:
      e.l += 12;
  }
  return [r, 0, a];
}
function FU(e, t, n) {
  return n.biff == 5 ? IU(e, t, n) : [e.read_shift(1) >>> 5 & 3, e.read_shift(2), e.read_shift(4)];
}
function IU(e) {
  var t = e.read_shift(1) >>> 5 & 3,
    n = e.read_shift(2, `i`);
  e.l += 8;
  var r = e.read_shift(2);
  return e.l += 12, [t, n, r];
}
function LU(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3;
  return e.l += n && n.biff == 2 ? 3 : 4, [r, e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function RU(e, t, n) {
  return [e.read_shift(1) >>> 5 & 3, e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function zU(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3;
  return e.l += 4, n.biff < 8 && e.l--, n.biff == 12 && (e.l += 2), [r];
}
function BU(e, t, n) {
  var r = (e[e.l++] & 96) >> 5,
    i = e.read_shift(2),
    a = 4;
  if (n) switch (n.biff) {
    case 5:
      a = 15;
      break;
    case 12:
      a = 6;
  }
  return e.l += a, [r, i];
}
var VU = IP,
  HU = IP,
  UU = IP;
function WU(e, t, n) {
  return e.l += 2, [eU(e, 4, n)];
}
function GU(e) {
  return e.l += 6, [];
}
var KU = WU,
  qU = GU,
  JU = GU,
  YU = WU;
function XU(e) {
  return e.l += 2, [yL(e), e.read_shift(2) & 1];
}
var ZU = WU,
  QU = XU,
  $U = GU,
  eW = WU,
  tW = WU,
  nW = [`Data`, `All`, `Headers`, `??`, `?Data2`, `??`, `?DataHeaders`, `??`, `Totals`, `??`, `??`, `??`, `?DataTotals`, `??`, `??`, `??`, `?Current`];
function rW(e) {
  e.l += 2;
  var t = e.read_shift(2),
    n = e.read_shift(2),
    r = e.read_shift(4),
    i = e.read_shift(2),
    a = e.read_shift(2),
    o = nW[n >> 2 & 31];
  return {
    ixti: t,
    coltype: n & 3,
    rt: o,
    idx: r,
    c: i,
    C: a
  };
}
function iW(e) {
  return e.l += 2, [e.read_shift(4)];
}
function aW(e, t, n) {
  return e.l += 5, e.l += 2, e.l += n.biff == 2 ? 1 : 4, [`PTGSHEET`];
}
function oW(e, t, n) {
  return e.l += n.biff == 2 ? 4 : 5, [`PTGENDSHEET`];
}
function sW(e) {
  return [e.read_shift(1) >>> 5 & 3, e.read_shift(2)];
}
function cW(e) {
  return [e.read_shift(1) >>> 5 & 3, e.read_shift(2)];
}
function lW(e) {
  return e.l += 4, [0, 0];
}
var uW = {
    1: {
      n: `PtgExp`,
      f: TU
    },
    2: {
      n: `PtgTbl`,
      f: UU
    },
    3: {
      n: `PtgAdd`,
      f: qH
    },
    4: {
      n: `PtgSub`,
      f: qH
    },
    5: {
      n: `PtgMul`,
      f: qH
    },
    6: {
      n: `PtgDiv`,
      f: qH
    },
    7: {
      n: `PtgPower`,
      f: qH
    },
    8: {
      n: `PtgConcat`,
      f: qH
    },
    9: {
      n: `PtgLt`,
      f: qH
    },
    10: {
      n: `PtgLe`,
      f: qH
    },
    11: {
      n: `PtgEq`,
      f: qH
    },
    12: {
      n: `PtgGe`,
      f: qH
    },
    13: {
      n: `PtgGt`,
      f: qH
    },
    14: {
      n: `PtgNe`,
      f: qH
    },
    15: {
      n: `PtgIsect`,
      f: qH
    },
    16: {
      n: `PtgUnion`,
      f: qH
    },
    17: {
      n: `PtgRange`,
      f: qH
    },
    18: {
      n: `PtgUplus`,
      f: qH
    },
    19: {
      n: `PtgUminus`,
      f: qH
    },
    20: {
      n: `PtgPercent`,
      f: qH
    },
    21: {
      n: `PtgParen`,
      f: qH
    },
    22: {
      n: `PtgMissArg`,
      f: qH
    },
    23: {
      n: `PtgStr`,
      f: AU
    },
    26: {
      n: `PtgSheet`,
      f: aW
    },
    27: {
      n: `PtgEndSheet`,
      f: oW
    },
    28: {
      n: `PtgErr`,
      f: EU
    },
    29: {
      n: `PtgBool`,
      f: OU
    },
    30: {
      n: `PtgInt`,
      f: DU
    },
    31: {
      n: `PtgNum`,
      f: kU
    },
    32: {
      n: `PtgArray`,
      f: cU
    },
    33: {
      n: `PtgFunc`,
      f: xU
    },
    34: {
      n: `PtgFuncVar`,
      f: SU
    },
    35: {
      n: `PtgName`,
      f: PU
    },
    36: {
      n: `PtgRef`,
      f: vU
    },
    37: {
      n: `PtgArea`,
      f: rU
    },
    38: {
      n: `PtgMemArea`,
      f: LU
    },
    39: {
      n: `PtgMemErr`,
      f: VU
    },
    40: {
      n: `PtgMemNoMem`,
      f: HU
    },
    41: {
      n: `PtgMemFunc`,
      f: RU
    },
    42: {
      n: `PtgRefErr`,
      f: zU
    },
    43: {
      n: `PtgAreaErr`,
      f: aU
    },
    44: {
      n: `PtgRefN`,
      f: yU
    },
    45: {
      n: `PtgAreaN`,
      f: sU
    },
    46: {
      n: `PtgMemAreaN`,
      f: sW
    },
    47: {
      n: `PtgMemNoMemN`,
      f: cW
    },
    57: {
      n: `PtgNameX`,
      f: FU
    },
    58: {
      n: `PtgRef3d`,
      f: bU
    },
    59: {
      n: `PtgArea3d`,
      f: iU
    },
    60: {
      n: `PtgRefErr3d`,
      f: BU
    },
    61: {
      n: `PtgAreaErr3d`,
      f: oU
    },
    255: {}
  },
  dW = {
    64: 32,
    96: 32,
    65: 33,
    97: 33,
    66: 34,
    98: 34,
    67: 35,
    99: 35,
    68: 36,
    100: 36,
    69: 37,
    101: 37,
    70: 38,
    102: 38,
    71: 39,
    103: 39,
    72: 40,
    104: 40,
    73: 41,
    105: 41,
    74: 42,
    106: 42,
    75: 43,
    107: 43,
    76: 44,
    108: 44,
    77: 45,
    109: 45,
    78: 46,
    110: 46,
    79: 47,
    111: 47,
    88: 34,
    120: 34,
    89: 57,
    121: 57,
    90: 58,
    122: 58,
    91: 59,
    123: 59,
    92: 60,
    124: 60,
    93: 61,
    125: 61
  },
  fW = {
    1: {
      n: `PtgElfLel`,
      f: XU
    },
    2: {
      n: `PtgElfRw`,
      f: eW
    },
    3: {
      n: `PtgElfCol`,
      f: KU
    },
    6: {
      n: `PtgElfRwV`,
      f: tW
    },
    7: {
      n: `PtgElfColV`,
      f: YU
    },
    10: {
      n: `PtgElfRadical`,
      f: ZU
    },
    11: {
      n: `PtgElfRadicalS`,
      f: $U
    },
    13: {
      n: `PtgElfColS`,
      f: qU
    },
    15: {
      n: `PtgElfColSV`,
      f: JU
    },
    16: {
      n: `PtgElfRadicalLel`,
      f: QU
    },
    25: {
      n: `PtgList`,
      f: rW
    },
    29: {
      n: `PtgSxName`,
      f: iW
    },
    255: {}
  },
  pW = {
    0: {
      n: `PtgAttrNoop`,
      f: lW
    },
    1: {
      n: `PtgAttrSemi`,
      f: mU
    },
    2: {
      n: `PtgAttrIf`,
      f: fU
    },
    4: {
      n: `PtgAttrChoose`,
      f: uU
    },
    8: {
      n: `PtgAttrGoto`,
      f: dU
    },
    16: {
      n: `PtgAttrSum`,
      f: wU
    },
    32: {
      n: `PtgAttrBaxcel`,
      f: lU
    },
    33: {
      n: `PtgAttrBaxcel`,
      f: lU
    },
    64: {
      n: `PtgAttrSpace`,
      f: gU
    },
    65: {
      n: `PtgAttrSpaceSemi`,
      f: _U
    },
    128: {
      n: `PtgAttrIfError`,
      f: pU
    },
    255: {}
  };
function mW(e, t, n, r) {
  if (r.biff < 8) return IP(e, t);
  for (var i = e.l + t, a = [], o = 0; o !== n.length; ++o) switch (n[o][0]) {
    case `PtgArray`:
      n[o][1] = NU(e, 0, r), a.push(n[o][1]);
      break;
    case `PtgMemArea`:
      n[o][2] = MU(e, n[o][1], r), a.push(n[o][2]);
      break;
    case `PtgExp`:
      r && r.biff == 12 && (n[o][1][1] = e.read_shift(4), a.push(n[o][1]));
      break;
    case `PtgList`:
    case `PtgElfRadicalS`:
    case `PtgElfColS`:
    case `PtgElfColSV`:
      throw `Unsupported ` + n[o][0];
  }
  return t = i - e.l, t !== 0 && a.push(IP(e, t)), a;
}
function hW(e, t, n) {
  for (var r = e.l + t, i, a, o = []; r != e.l;) t = r - e.l, a = e[e.l], i = uW[a] || uW[dW[a]], (a === 24 || a === 25) && (i = (a === 24 ? fW : pW)[e[e.l + 1]]), !i || !i.f ? IP(e, t) : o.push([i.n, i.f(e, t, n)]);
  return o;
}
function gW(e) {
  for (var t = [], n = 0; n < e.length; ++n) {
    for (var r = e[n], i = [], a = 0; a < r.length; ++a) {
      var o = r[a];
      if (o) switch (o[0]) {
        case 2:
          i.push(`"` + o[1].replace(/"/g, `""`) + `"`);
          break;
        default:
          i.push(o[1]);
      } else i.push(``);
    }
    t.push(i.join(`,`));
  }
  return t.join(`;`);
}
var _W = {
  PtgAdd: `+`,
  PtgConcat: `&`,
  PtgDiv: `/`,
  PtgEq: `=`,
  PtgGe: `>=`,
  PtgGt: `>`,
  PtgLe: `<=`,
  PtgLt: `<`,
  PtgMul: `*`,
  PtgNe: `<>`,
  PtgPower: `^`,
  PtgSub: `-`
};
function vW(e, t) {
  if (!e && !(t && t.biff <= 5 && t.biff >= 2)) throw Error(`empty sheet name`);
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? `'` + e + `'` : e;
}
function yW(e, t, n) {
  if (!e) return `SH33TJSERR0`;
  if (n.biff > 8 && (!e.XTI || !e.XTI[t])) return e.SheetNames[t];
  if (!e.XTI) return `SH33TJSERR6`;
  var r = e.XTI[t];
  if (n.biff < 8) return t > 1e4 && (t -= 65536), t < 0 && (t = -t), t == 0 ? `` : e.XTI[t - 1];
  if (!r) return `SH33TJSERR1`;
  var i = ``;
  if (n.biff > 8) switch (e[r[0]][0]) {
    case 357:
      return i = r[1] == -1 ? `#REF` : e.SheetNames[r[1]], r[1] == r[2] ? i : i + `:` + e.SheetNames[r[2]];
    case 358:
      return n.SID == null ? `SH33TJSSAME` + e[r[0]][0] : e.SheetNames[n.SID];
    default:
      return `SH33TJSSRC` + e[r[0]][0];
  }
  switch (e[r[0]][0][0]) {
    case 1025:
      return i = r[1] == -1 ? `#REF` : e.SheetNames[r[1]] || `SH33TJSERR3`, r[1] == r[2] ? i : i + `:` + e.SheetNames[r[2]];
    case 14849:
      return e[r[0]].slice(1).map(function (e) {
        return e.Name;
      }).join(`;;`);
    default:
      return e[r[0]][0][3] ? (i = r[1] == -1 ? `#REF` : e[r[0]][0][3][r[1]] || `SH33TJSERR4`, r[1] == r[2] ? i : i + `:` + e[r[0]][0][3][r[2]]) : `SH33TJSERR2`;
  }
}
function bW(e, t, n) {
  var r = yW(e, t, n);
  return r == `#REF` ? r : vW(r, n);
}
function xW(e, t, n, r, i) {
  var a = i && i.biff || 8,
    o = {
      s: {
        c: 0,
        r: 0
      },
      e: {
        c: 0,
        r: 0
      }
    },
    s = [],
    c,
    l,
    u,
    d = 0,
    f = 0,
    p,
    m = ``;
  if (!e[0] || !e[0][0]) return ``;
  for (var h = -1, g = ``, _ = 0, v = e[0].length; _ < v; ++_) {
    var y = e[0][_];
    switch (y[0]) {
      case `PtgUminus`:
        s.push(`-` + s.pop());
        break;
      case `PtgUplus`:
        s.push(`+` + s.pop());
        break;
      case `PtgPercent`:
        s.push(s.pop() + `%`);
        break;
      case `PtgAdd`:
      case `PtgConcat`:
      case `PtgDiv`:
      case `PtgEq`:
      case `PtgGe`:
      case `PtgGt`:
      case `PtgLe`:
      case `PtgLt`:
      case `PtgMul`:
      case `PtgNe`:
      case `PtgPower`:
      case `PtgSub`:
        if (c = s.pop(), l = s.pop(), h >= 0) {
          switch (e[0][h][1][0]) {
            case 0:
              g = KM(` `, e[0][h][1][1]);
              break;
            case 1:
              g = KM(`\r`, e[0][h][1][1]);
              break;
            default:
              if (g = ``, i.WTF) throw Error(`Unexpected PtgAttrSpaceType ` + e[0][h][1][0]);
          }
          l += g, h = -1;
        }
        s.push(l + _W[y[0]] + c);
        break;
      case `PtgIsect`:
        c = s.pop(), l = s.pop(), s.push(l + ` ` + c);
        break;
      case `PtgUnion`:
        c = s.pop(), l = s.pop(), s.push(l + `,` + c);
        break;
      case `PtgRange`:
        c = s.pop(), l = s.pop(), s.push(l + `:` + c);
        break;
      case `PtgAttrChoose`:
        break;
      case `PtgAttrGoto`:
        break;
      case `PtgAttrIf`:
        break;
      case `PtgAttrIfError`:
        break;
      case `PtgRef`:
        u = zP(y[1][1], o, i), s.push(VP(u, a));
        break;
      case `PtgRefN`:
        u = n ? zP(y[1][1], n, i) : y[1][1], s.push(VP(u, a));
        break;
      case `PtgRef3d`:
        d = y[1][1], u = zP(y[1][2], o, i), m = bW(r, d, i), s.push(m + `!` + VP(u, a));
        break;
      case `PtgFunc`:
      case `PtgFuncVar`:
        var b = y[1][0],
          x = y[1][1];
        b ||= 0, b &= 127;
        var S = b == 0 ? [] : s.slice(-b);
        s.length -= b, x === `User` && (x = S.shift()), s.push(x + `(` + S.join(`,`) + `)`);
        break;
      case `PtgBool`:
        s.push(y[1] ? `TRUE` : `FALSE`);
        break;
      case `PtgInt`:
        s.push(y[1]);
        break;
      case `PtgNum`:
        s.push(String(y[1]));
        break;
      case `PtgStr`:
        s.push(`"` + y[1].replace(/"/g, `""`) + `"`);
        break;
      case `PtgErr`:
        s.push(y[1]);
        break;
      case `PtgAreaN`:
        p = BP(y[1][1], n ? {
          s: n
        } : o, i), s.push(HP(p, i));
        break;
      case `PtgArea`:
        p = BP(y[1][1], o, i), s.push(HP(p, i));
        break;
      case `PtgArea3d`:
        d = y[1][1], p = y[1][2], m = bW(r, d, i), s.push(m + `!` + HP(p, i));
        break;
      case `PtgAttrSum`:
        s.push(`SUM(` + s.pop() + `)`);
        break;
      case `PtgAttrBaxcel`:
      case `PtgAttrSemi`:
        break;
      case `PtgName`:
        f = y[1][2];
        var C = (r.names || [])[f - 1] || (r[0] || [])[f],
          w = C ? C.Name : `SH33TJSNAME` + String(f);
        w && w.slice(0, 6) == `_xlfn.` && !i.xlfn && (w = w.slice(6)), s.push(w);
        break;
      case `PtgNameX`:
        var T = y[1][1];
        f = y[1][2];
        var E;
        if (i.biff <= 5) T < 0 && (T = -T), r[T] && (E = r[T][f]);else {
          var D = ``;
          if (((r[T] || [])[0] || [])[0] == 14849 || (((r[T] || [])[0] || [])[0] == 1025 ? r[T][f] && r[T][f].itab > 0 && (D = r.SheetNames[r[T][f].itab - 1] + `!`) : D = r.SheetNames[f - 1] + `!`), r[T] && r[T][f]) D += r[T][f].Name;else if (r[0] && r[0][f]) D += r[0][f].Name;else {
            var O = (yW(r, T, i) || ``).split(`;;`);
            O[f - 1] ? D = O[f - 1] : D += `SH33TJSERRX`;
          }
          s.push(D);
          break;
        }
        E ||= {
          Name: `SH33TJSERRY`
        }, s.push(E.Name);
        break;
      case `PtgParen`:
        var k = `(`,
          A = `)`;
        if (h >= 0) {
          switch (g = ``, e[0][h][1][0]) {
            case 2:
              k = KM(` `, e[0][h][1][1]) + k;
              break;
            case 3:
              k = KM(`\r`, e[0][h][1][1]) + k;
              break;
            case 4:
              A = KM(` `, e[0][h][1][1]) + A;
              break;
            case 5:
              A = KM(`\r`, e[0][h][1][1]) + A;
              break;
            default:
              if (i.WTF) throw Error(`Unexpected PtgAttrSpaceType ` + e[0][h][1][0]);
          }
          h = -1;
        }
        s.push(k + s.pop() + A);
        break;
      case `PtgRefErr`:
        s.push(`#REF!`);
        break;
      case `PtgRefErr3d`:
        s.push(`#REF!`);
        break;
      case `PtgExp`:
        u = {
          c: y[1][1],
          r: y[1][0]
        };
        var j = {
          c: n.c,
          r: n.r
        };
        if (r.sharedf[$P(u)]) {
          var M = r.sharedf[$P(u)];
          s.push(xW(M, o, j, r, i));
        } else {
          var N = !1;
          for (c = 0; c != r.arrayf.length; ++c) if (l = r.arrayf[c], !(u.c < l[0].s.c || u.c > l[0].e.c) && !(u.r < l[0].s.r || u.r > l[0].e.r)) {
            s.push(xW(l[1], o, j, r, i)), N = !0;
            break;
          }
          N || s.push(y[1]);
        }
        break;
      case `PtgArray`:
        s.push(`{` + gW(y[1]) + `}`);
        break;
      case `PtgMemArea`:
        break;
      case `PtgAttrSpace`:
      case `PtgAttrSpaceSemi`:
        h = _;
        break;
      case `PtgTbl`:
        break;
      case `PtgMemErr`:
        break;
      case `PtgMissArg`:
        s.push(``);
        break;
      case `PtgAreaErr`:
        s.push(`#REF!`);
        break;
      case `PtgAreaErr3d`:
        s.push(`#REF!`);
        break;
      case `PtgList`:
        s.push(`Table` + y[1].idx + `[#` + y[1].rt + `]`);
        break;
      case `PtgMemAreaN`:
      case `PtgMemNoMemN`:
      case `PtgAttrNoop`:
      case `PtgSheet`:
      case `PtgEndSheet`:
        break;
      case `PtgMemFunc`:
        break;
      case `PtgMemNoMem`:
        break;
      case `PtgElfCol`:
      case `PtgElfColS`:
      case `PtgElfColSV`:
      case `PtgElfColV`:
      case `PtgElfLel`:
      case `PtgElfRadical`:
      case `PtgElfRadicalLel`:
      case `PtgElfRadicalS`:
      case `PtgElfRw`:
      case `PtgElfRwV`:
        throw Error(`Unsupported ELFs`);
      case `PtgSxName`:
        throw Error(`Unrecognized Formula Token: ` + String(y));
      default:
        throw Error(`Unrecognized Formula Token: ` + String(y));
    }
    if (i.biff != 3 && h >= 0 && [`PtgAttrSpace`, `PtgAttrSpaceSemi`, `PtgAttrGoto`].indexOf(e[0][_][0]) == -1) {
      y = e[0][h];
      var P = !0;
      switch (y[1][0]) {
        case 4:
          P = !1;
        case 0:
          g = KM(` `, y[1][1]);
          break;
        case 5:
          P = !1;
        case 1:
          g = KM(`\r`, y[1][1]);
          break;
        default:
          if (g = ``, i.WTF) throw Error(`Unexpected PtgAttrSpaceType ` + y[1][0]);
      }
      s.push((P ? g : ``) + s.pop() + (P ? `` : g)), h = -1;
    }
  }
  if (s.length > 1 && i.WTF) throw Error(`bad formula stack`);
  return s[0];
}
function SW(e, t, n) {
  var r = e.l + t,
    i = n.biff == 2 ? 1 : 2,
    a,
    o = e.read_shift(i);
  if (o == 65535) return [[], IP(e, t - 2)];
  var s = hW(e, o, n);
  return t !== o + i && (a = mW(e, t - o - i, s, n)), e.l = r, [s, a];
}
function CW(e, t, n) {
  var r = e.l + t,
    i = n.biff == 2 ? 1 : 2,
    a,
    o = e.read_shift(i);
  if (o == 65535) return [[], IP(e, t - 2)];
  var s = hW(e, o, n);
  return t !== o + i && (a = mW(e, t - o - i, s, n)), e.l = r, [s, a];
}
function wW(e, t, n, r) {
  var i = e.l + t,
    a = hW(e, r, n),
    o;
  return i !== e.l && (o = mW(e, i - e.l, a, n)), [a, o];
}
function TW(e, t, n) {
  var r = e.l + t,
    i,
    a = e.read_shift(2),
    o = hW(e, a, n);
  return a == 65535 ? [[], IP(e, t - 2)] : (t !== a + 2 && (i = mW(e, r - a - 2, o, n)), [o, i]);
}
function EW(e) {
  var t;
  if (wP(e, e.l + 6) !== 65535) return [FF(e), `n`];
  switch (e[e.l]) {
    case 0:
      return e.l += 8, [`String`, `s`];
    case 1:
      return t = e[e.l + 2] === 1, e.l += 8, [t, `b`];
    case 2:
      return t = e[e.l + 2], e.l += 8, [t, `e`];
    case 3:
      return e.l += 8, [``, `s`];
  }
  return [];
}
function DW(e) {
  if (e == null) {
    var t = Z(8);
    return t.write_shift(1, 3), t.write_shift(1, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 65535), t;
  }
  return IF(typeof e == `number` ? e : 0);
}
function OW(e, t, n) {
  var r = e.l + t,
    i = VL(e, 6);
  n.biff == 2 && ++e.l;
  var a = EW(e, 8),
    o = e.read_shift(1);
  n.biff != 2 && (e.read_shift(1), n.biff >= 5 && e.read_shift(4));
  var s = CW(e, r - e.l, n);
  return {
    cell: i,
    val: a[0],
    formula: s,
    shared: o >> 3 & 1,
    tt: a[1]
  };
}
function kW(e, t, n, r, i) {
  var a = HL(t, n, i),
    o = DW(e.v),
    s = Z(6);
  s.write_shift(2, 33), s.write_shift(4, 0);
  for (var c = Z(e.bf.length), l = 0; l < e.bf.length; ++l) c[l] = e.bf[l];
  return ij([a, o, s, c]);
}
function AW(e, t, n) {
  var r = hW(e, e.read_shift(4), n),
    i = e.read_shift(4);
  return [r, i > 0 ? mW(e, i, r, n) : null];
}
var jW = AW,
  MW = AW,
  NW = AW,
  PW = AW,
  FW = {
    0: `BEEP`,
    1: `OPEN`,
    2: `OPEN.LINKS`,
    3: `CLOSE.ALL`,
    4: `SAVE`,
    5: `SAVE.AS`,
    6: `FILE.DELETE`,
    7: `PAGE.SETUP`,
    8: `PRINT`,
    9: `PRINTER.SETUP`,
    10: `QUIT`,
    11: `NEW.WINDOW`,
    12: `ARRANGE.ALL`,
    13: `WINDOW.SIZE`,
    14: `WINDOW.MOVE`,
    15: `FULL`,
    16: `CLOSE`,
    17: `RUN`,
    22: `SET.PRINT.AREA`,
    23: `SET.PRINT.TITLES`,
    24: `SET.PAGE.BREAK`,
    25: `REMOVE.PAGE.BREAK`,
    26: `FONT`,
    27: `DISPLAY`,
    28: `PROTECT.DOCUMENT`,
    29: `PRECISION`,
    30: `A1.R1C1`,
    31: `CALCULATE.NOW`,
    32: `CALCULATION`,
    34: `DATA.FIND`,
    35: `EXTRACT`,
    36: `DATA.DELETE`,
    37: `SET.DATABASE`,
    38: `SET.CRITERIA`,
    39: `SORT`,
    40: `DATA.SERIES`,
    41: `TABLE`,
    42: `FORMAT.NUMBER`,
    43: `ALIGNMENT`,
    44: `STYLE`,
    45: `BORDER`,
    46: `CELL.PROTECTION`,
    47: `COLUMN.WIDTH`,
    48: `UNDO`,
    49: `CUT`,
    50: `COPY`,
    51: `PASTE`,
    52: `CLEAR`,
    53: `PASTE.SPECIAL`,
    54: `EDIT.DELETE`,
    55: `INSERT`,
    56: `FILL.RIGHT`,
    57: `FILL.DOWN`,
    61: `DEFINE.NAME`,
    62: `CREATE.NAMES`,
    63: `FORMULA.GOTO`,
    64: `FORMULA.FIND`,
    65: `SELECT.LAST.CELL`,
    66: `SHOW.ACTIVE.CELL`,
    67: `GALLERY.AREA`,
    68: `GALLERY.BAR`,
    69: `GALLERY.COLUMN`,
    70: `GALLERY.LINE`,
    71: `GALLERY.PIE`,
    72: `GALLERY.SCATTER`,
    73: `COMBINATION`,
    74: `PREFERRED`,
    75: `ADD.OVERLAY`,
    76: `GRIDLINES`,
    77: `SET.PREFERRED`,
    78: `AXES`,
    79: `LEGEND`,
    80: `ATTACH.TEXT`,
    81: `ADD.ARROW`,
    82: `SELECT.CHART`,
    83: `SELECT.PLOT.AREA`,
    84: `PATTERNS`,
    85: `MAIN.CHART`,
    86: `OVERLAY`,
    87: `SCALE`,
    88: `FORMAT.LEGEND`,
    89: `FORMAT.TEXT`,
    90: `EDIT.REPEAT`,
    91: `PARSE`,
    92: `JUSTIFY`,
    93: `HIDE`,
    94: `UNHIDE`,
    95: `WORKSPACE`,
    96: `FORMULA`,
    97: `FORMULA.FILL`,
    98: `FORMULA.ARRAY`,
    99: `DATA.FIND.NEXT`,
    100: `DATA.FIND.PREV`,
    101: `FORMULA.FIND.NEXT`,
    102: `FORMULA.FIND.PREV`,
    103: `ACTIVATE`,
    104: `ACTIVATE.NEXT`,
    105: `ACTIVATE.PREV`,
    106: `UNLOCKED.NEXT`,
    107: `UNLOCKED.PREV`,
    108: `COPY.PICTURE`,
    109: `SELECT`,
    110: `DELETE.NAME`,
    111: `DELETE.FORMAT`,
    112: `VLINE`,
    113: `HLINE`,
    114: `VPAGE`,
    115: `HPAGE`,
    116: `VSCROLL`,
    117: `HSCROLL`,
    118: `ALERT`,
    119: `NEW`,
    120: `CANCEL.COPY`,
    121: `SHOW.CLIPBOARD`,
    122: `MESSAGE`,
    124: `PASTE.LINK`,
    125: `APP.ACTIVATE`,
    126: `DELETE.ARROW`,
    127: `ROW.HEIGHT`,
    128: `FORMAT.MOVE`,
    129: `FORMAT.SIZE`,
    130: `FORMULA.REPLACE`,
    131: `SEND.KEYS`,
    132: `SELECT.SPECIAL`,
    133: `APPLY.NAMES`,
    134: `REPLACE.FONT`,
    135: `FREEZE.PANES`,
    136: `SHOW.INFO`,
    137: `SPLIT`,
    138: `ON.WINDOW`,
    139: `ON.DATA`,
    140: `DISABLE.INPUT`,
    142: `OUTLINE`,
    143: `LIST.NAMES`,
    144: `FILE.CLOSE`,
    145: `SAVE.WORKBOOK`,
    146: `DATA.FORM`,
    147: `COPY.CHART`,
    148: `ON.TIME`,
    149: `WAIT`,
    150: `FORMAT.FONT`,
    151: `FILL.UP`,
    152: `FILL.LEFT`,
    153: `DELETE.OVERLAY`,
    155: `SHORT.MENUS`,
    159: `SET.UPDATE.STATUS`,
    161: `COLOR.PALETTE`,
    162: `DELETE.STYLE`,
    163: `WINDOW.RESTORE`,
    164: `WINDOW.MAXIMIZE`,
    166: `CHANGE.LINK`,
    167: `CALCULATE.DOCUMENT`,
    168: `ON.KEY`,
    169: `APP.RESTORE`,
    170: `APP.MOVE`,
    171: `APP.SIZE`,
    172: `APP.MINIMIZE`,
    173: `APP.MAXIMIZE`,
    174: `BRING.TO.FRONT`,
    175: `SEND.TO.BACK`,
    185: `MAIN.CHART.TYPE`,
    186: `OVERLAY.CHART.TYPE`,
    187: `SELECT.END`,
    188: `OPEN.MAIL`,
    189: `SEND.MAIL`,
    190: `STANDARD.FONT`,
    191: `CONSOLIDATE`,
    192: `SORT.SPECIAL`,
    193: `GALLERY.3D.AREA`,
    194: `GALLERY.3D.COLUMN`,
    195: `GALLERY.3D.LINE`,
    196: `GALLERY.3D.PIE`,
    197: `VIEW.3D`,
    198: `GOAL.SEEK`,
    199: `WORKGROUP`,
    200: `FILL.GROUP`,
    201: `UPDATE.LINK`,
    202: `PROMOTE`,
    203: `DEMOTE`,
    204: `SHOW.DETAIL`,
    206: `UNGROUP`,
    207: `OBJECT.PROPERTIES`,
    208: `SAVE.NEW.OBJECT`,
    209: `SHARE`,
    210: `SHARE.NAME`,
    211: `DUPLICATE`,
    212: `APPLY.STYLE`,
    213: `ASSIGN.TO.OBJECT`,
    214: `OBJECT.PROTECTION`,
    215: `HIDE.OBJECT`,
    216: `SET.EXTRACT`,
    217: `CREATE.PUBLISHER`,
    218: `SUBSCRIBE.TO`,
    219: `ATTRIBUTES`,
    220: `SHOW.TOOLBAR`,
    222: `PRINT.PREVIEW`,
    223: `EDIT.COLOR`,
    224: `SHOW.LEVELS`,
    225: `FORMAT.MAIN`,
    226: `FORMAT.OVERLAY`,
    227: `ON.RECALC`,
    228: `EDIT.SERIES`,
    229: `DEFINE.STYLE`,
    240: `LINE.PRINT`,
    243: `ENTER.DATA`,
    249: `GALLERY.RADAR`,
    250: `MERGE.STYLES`,
    251: `EDITION.OPTIONS`,
    252: `PASTE.PICTURE`,
    253: `PASTE.PICTURE.LINK`,
    254: `SPELLING`,
    256: `ZOOM`,
    259: `INSERT.OBJECT`,
    260: `WINDOW.MINIMIZE`,
    265: `SOUND.NOTE`,
    266: `SOUND.PLAY`,
    267: `FORMAT.SHAPE`,
    268: `EXTEND.POLYGON`,
    269: `FORMAT.AUTO`,
    272: `GALLERY.3D.BAR`,
    273: `GALLERY.3D.SURFACE`,
    274: `FILL.AUTO`,
    276: `CUSTOMIZE.TOOLBAR`,
    277: `ADD.TOOL`,
    278: `EDIT.OBJECT`,
    279: `ON.DOUBLECLICK`,
    280: `ON.ENTRY`,
    281: `WORKBOOK.ADD`,
    282: `WORKBOOK.MOVE`,
    283: `WORKBOOK.COPY`,
    284: `WORKBOOK.OPTIONS`,
    285: `SAVE.WORKSPACE`,
    288: `CHART.WIZARD`,
    289: `DELETE.TOOL`,
    290: `MOVE.TOOL`,
    291: `WORKBOOK.SELECT`,
    292: `WORKBOOK.ACTIVATE`,
    293: `ASSIGN.TO.TOOL`,
    295: `COPY.TOOL`,
    296: `RESET.TOOL`,
    297: `CONSTRAIN.NUMERIC`,
    298: `PASTE.TOOL`,
    302: `WORKBOOK.NEW`,
    305: `SCENARIO.CELLS`,
    306: `SCENARIO.DELETE`,
    307: `SCENARIO.ADD`,
    308: `SCENARIO.EDIT`,
    309: `SCENARIO.SHOW`,
    310: `SCENARIO.SHOW.NEXT`,
    311: `SCENARIO.SUMMARY`,
    312: `PIVOT.TABLE.WIZARD`,
    313: `PIVOT.FIELD.PROPERTIES`,
    314: `PIVOT.FIELD`,
    315: `PIVOT.ITEM`,
    316: `PIVOT.ADD.FIELDS`,
    318: `OPTIONS.CALCULATION`,
    319: `OPTIONS.EDIT`,
    320: `OPTIONS.VIEW`,
    321: `ADDIN.MANAGER`,
    322: `MENU.EDITOR`,
    323: `ATTACH.TOOLBARS`,
    324: `VBAActivate`,
    325: `OPTIONS.CHART`,
    328: `VBA.INSERT.FILE`,
    330: `VBA.PROCEDURE.DEFINITION`,
    336: `ROUTING.SLIP`,
    338: `ROUTE.DOCUMENT`,
    339: `MAIL.LOGON`,
    342: `INSERT.PICTURE`,
    343: `EDIT.TOOL`,
    344: `GALLERY.DOUGHNUT`,
    350: `CHART.TREND`,
    352: `PIVOT.ITEM.PROPERTIES`,
    354: `WORKBOOK.INSERT`,
    355: `OPTIONS.TRANSITION`,
    356: `OPTIONS.GENERAL`,
    370: `FILTER.ADVANCED`,
    373: `MAIL.ADD.MAILER`,
    374: `MAIL.DELETE.MAILER`,
    375: `MAIL.REPLY`,
    376: `MAIL.REPLY.ALL`,
    377: `MAIL.FORWARD`,
    378: `MAIL.NEXT.LETTER`,
    379: `DATA.LABEL`,
    380: `INSERT.TITLE`,
    381: `FONT.PROPERTIES`,
    382: `MACRO.OPTIONS`,
    383: `WORKBOOK.HIDE`,
    384: `WORKBOOK.UNHIDE`,
    385: `WORKBOOK.DELETE`,
    386: `WORKBOOK.NAME`,
    388: `GALLERY.CUSTOM`,
    390: `ADD.CHART.AUTOFORMAT`,
    391: `DELETE.CHART.AUTOFORMAT`,
    392: `CHART.ADD.DATA`,
    393: `AUTO.OUTLINE`,
    394: `TAB.ORDER`,
    395: `SHOW.DIALOG`,
    396: `SELECT.ALL`,
    397: `UNGROUP.SHEETS`,
    398: `SUBTOTAL.CREATE`,
    399: `SUBTOTAL.REMOVE`,
    400: `RENAME.OBJECT`,
    412: `WORKBOOK.SCROLL`,
    413: `WORKBOOK.NEXT`,
    414: `WORKBOOK.PREV`,
    415: `WORKBOOK.TAB.SPLIT`,
    416: `FULL.SCREEN`,
    417: `WORKBOOK.PROTECT`,
    420: `SCROLLBAR.PROPERTIES`,
    421: `PIVOT.SHOW.PAGES`,
    422: `TEXT.TO.COLUMNS`,
    423: `FORMAT.CHARTTYPE`,
    424: `LINK.FORMAT`,
    425: `TRACER.DISPLAY`,
    430: `TRACER.NAVIGATE`,
    431: `TRACER.CLEAR`,
    432: `TRACER.ERROR`,
    433: `PIVOT.FIELD.GROUP`,
    434: `PIVOT.FIELD.UNGROUP`,
    435: `CHECKBOX.PROPERTIES`,
    436: `LABEL.PROPERTIES`,
    437: `LISTBOX.PROPERTIES`,
    438: `EDITBOX.PROPERTIES`,
    439: `PIVOT.REFRESH`,
    440: `LINK.COMBO`,
    441: `OPEN.TEXT`,
    442: `HIDE.DIALOG`,
    443: `SET.DIALOG.FOCUS`,
    444: `ENABLE.OBJECT`,
    445: `PUSHBUTTON.PROPERTIES`,
    446: `SET.DIALOG.DEFAULT`,
    447: `FILTER`,
    448: `FILTER.SHOW.ALL`,
    449: `CLEAR.OUTLINE`,
    450: `FUNCTION.WIZARD`,
    451: `ADD.LIST.ITEM`,
    452: `SET.LIST.ITEM`,
    453: `REMOVE.LIST.ITEM`,
    454: `SELECT.LIST.ITEM`,
    455: `SET.CONTROL.VALUE`,
    456: `SAVE.COPY.AS`,
    458: `OPTIONS.LISTS.ADD`,
    459: `OPTIONS.LISTS.DELETE`,
    460: `SERIES.AXES`,
    461: `SERIES.X`,
    462: `SERIES.Y`,
    463: `ERRORBAR.X`,
    464: `ERRORBAR.Y`,
    465: `FORMAT.CHART`,
    466: `SERIES.ORDER`,
    467: `MAIL.LOGOFF`,
    468: `CLEAR.ROUTING.SLIP`,
    469: `APP.ACTIVATE.MICROSOFT`,
    470: `MAIL.EDIT.MAILER`,
    471: `ON.SHEET`,
    472: `STANDARD.WIDTH`,
    473: `SCENARIO.MERGE`,
    474: `SUMMARY.INFO`,
    475: `FIND.FILE`,
    476: `ACTIVE.CELL.FONT`,
    477: `ENABLE.TIPWIZARD`,
    478: `VBA.MAKE.ADDIN`,
    480: `INSERTDATATABLE`,
    481: `WORKGROUP.OPTIONS`,
    482: `MAIL.SEND.MAILER`,
    485: `AUTOCORRECT`,
    489: `POST.DOCUMENT`,
    491: `PICKLIST`,
    493: `VIEW.SHOW`,
    494: `VIEW.DEFINE`,
    495: `VIEW.DELETE`,
    509: `SHEET.BACKGROUND`,
    510: `INSERT.MAP.OBJECT`,
    511: `OPTIONS.MENONO`,
    517: `MSOCHECKS`,
    518: `NORMAL`,
    519: `LAYOUT`,
    520: `RM.PRINT.AREA`,
    521: `CLEAR.PRINT.AREA`,
    522: `ADD.PRINT.AREA`,
    523: `MOVE.BRK`,
    545: `HIDECURR.NOTE`,
    546: `HIDEALL.NOTES`,
    547: `DELETE.NOTE`,
    548: `TRAVERSE.NOTES`,
    549: `ACTIVATE.NOTES`,
    620: `PROTECT.REVISIONS`,
    621: `UNPROTECT.REVISIONS`,
    647: `OPTIONS.ME`,
    653: `WEB.PUBLISH`,
    667: `NEWWEBQUERY`,
    673: `PIVOT.TABLE.CHART`,
    753: `OPTIONS.SAVE`,
    755: `OPTIONS.SPELL`,
    808: `HIDEALL.INKANNOTS`
  },
  IW = {
    0: `COUNT`,
    1: `IF`,
    2: `ISNA`,
    3: `ISERROR`,
    4: `SUM`,
    5: `AVERAGE`,
    6: `MIN`,
    7: `MAX`,
    8: `ROW`,
    9: `COLUMN`,
    10: `NA`,
    11: `NPV`,
    12: `STDEV`,
    13: `DOLLAR`,
    14: `FIXED`,
    15: `SIN`,
    16: `COS`,
    17: `TAN`,
    18: `ATAN`,
    19: `PI`,
    20: `SQRT`,
    21: `EXP`,
    22: `LN`,
    23: `LOG10`,
    24: `ABS`,
    25: `INT`,
    26: `SIGN`,
    27: `ROUND`,
    28: `LOOKUP`,
    29: `INDEX`,
    30: `REPT`,
    31: `MID`,
    32: `LEN`,
    33: `VALUE`,
    34: `TRUE`,
    35: `FALSE`,
    36: `AND`,
    37: `OR`,
    38: `NOT`,
    39: `MOD`,
    40: `DCOUNT`,
    41: `DSUM`,
    42: `DAVERAGE`,
    43: `DMIN`,
    44: `DMAX`,
    45: `DSTDEV`,
    46: `VAR`,
    47: `DVAR`,
    48: `TEXT`,
    49: `LINEST`,
    50: `TREND`,
    51: `LOGEST`,
    52: `GROWTH`,
    53: `GOTO`,
    54: `HALT`,
    55: `RETURN`,
    56: `PV`,
    57: `FV`,
    58: `NPER`,
    59: `PMT`,
    60: `RATE`,
    61: `MIRR`,
    62: `IRR`,
    63: `RAND`,
    64: `MATCH`,
    65: `DATE`,
    66: `TIME`,
    67: `DAY`,
    68: `MONTH`,
    69: `YEAR`,
    70: `WEEKDAY`,
    71: `HOUR`,
    72: `MINUTE`,
    73: `SECOND`,
    74: `NOW`,
    75: `AREAS`,
    76: `ROWS`,
    77: `COLUMNS`,
    78: `OFFSET`,
    79: `ABSREF`,
    80: `RELREF`,
    81: `ARGUMENT`,
    82: `SEARCH`,
    83: `TRANSPOSE`,
    84: `ERROR`,
    85: `STEP`,
    86: `TYPE`,
    87: `ECHO`,
    88: `SET.NAME`,
    89: `CALLER`,
    90: `DEREF`,
    91: `WINDOWS`,
    92: `SERIES`,
    93: `DOCUMENTS`,
    94: `ACTIVE.CELL`,
    95: `SELECTION`,
    96: `RESULT`,
    97: `ATAN2`,
    98: `ASIN`,
    99: `ACOS`,
    100: `CHOOSE`,
    101: `HLOOKUP`,
    102: `VLOOKUP`,
    103: `LINKS`,
    104: `INPUT`,
    105: `ISREF`,
    106: `GET.FORMULA`,
    107: `GET.NAME`,
    108: `SET.VALUE`,
    109: `LOG`,
    110: `EXEC`,
    111: `CHAR`,
    112: `LOWER`,
    113: `UPPER`,
    114: `PROPER`,
    115: `LEFT`,
    116: `RIGHT`,
    117: `EXACT`,
    118: `TRIM`,
    119: `REPLACE`,
    120: `SUBSTITUTE`,
    121: `CODE`,
    122: `NAMES`,
    123: `DIRECTORY`,
    124: `FIND`,
    125: `CELL`,
    126: `ISERR`,
    127: `ISTEXT`,
    128: `ISNUMBER`,
    129: `ISBLANK`,
    130: `T`,
    131: `N`,
    132: `FOPEN`,
    133: `FCLOSE`,
    134: `FSIZE`,
    135: `FREADLN`,
    136: `FREAD`,
    137: `FWRITELN`,
    138: `FWRITE`,
    139: `FPOS`,
    140: `DATEVALUE`,
    141: `TIMEVALUE`,
    142: `SLN`,
    143: `SYD`,
    144: `DDB`,
    145: `GET.DEF`,
    146: `REFTEXT`,
    147: `TEXTREF`,
    148: `INDIRECT`,
    149: `REGISTER`,
    150: `CALL`,
    151: `ADD.BAR`,
    152: `ADD.MENU`,
    153: `ADD.COMMAND`,
    154: `ENABLE.COMMAND`,
    155: `CHECK.COMMAND`,
    156: `RENAME.COMMAND`,
    157: `SHOW.BAR`,
    158: `DELETE.MENU`,
    159: `DELETE.COMMAND`,
    160: `GET.CHART.ITEM`,
    161: `DIALOG.BOX`,
    162: `CLEAN`,
    163: `MDETERM`,
    164: `MINVERSE`,
    165: `MMULT`,
    166: `FILES`,
    167: `IPMT`,
    168: `PPMT`,
    169: `COUNTA`,
    170: `CANCEL.KEY`,
    171: `FOR`,
    172: `WHILE`,
    173: `BREAK`,
    174: `NEXT`,
    175: `INITIATE`,
    176: `REQUEST`,
    177: `POKE`,
    178: `EXECUTE`,
    179: `TERMINATE`,
    180: `RESTART`,
    181: `HELP`,
    182: `GET.BAR`,
    183: `PRODUCT`,
    184: `FACT`,
    185: `GET.CELL`,
    186: `GET.WORKSPACE`,
    187: `GET.WINDOW`,
    188: `GET.DOCUMENT`,
    189: `DPRODUCT`,
    190: `ISNONTEXT`,
    191: `GET.NOTE`,
    192: `NOTE`,
    193: `STDEVP`,
    194: `VARP`,
    195: `DSTDEVP`,
    196: `DVARP`,
    197: `TRUNC`,
    198: `ISLOGICAL`,
    199: `DCOUNTA`,
    200: `DELETE.BAR`,
    201: `UNREGISTER`,
    204: `USDOLLAR`,
    205: `FINDB`,
    206: `SEARCHB`,
    207: `REPLACEB`,
    208: `LEFTB`,
    209: `RIGHTB`,
    210: `MIDB`,
    211: `LENB`,
    212: `ROUNDUP`,
    213: `ROUNDDOWN`,
    214: `ASC`,
    215: `DBCS`,
    216: `RANK`,
    219: `ADDRESS`,
    220: `DAYS360`,
    221: `TODAY`,
    222: `VDB`,
    223: `ELSE`,
    224: `ELSE.IF`,
    225: `END.IF`,
    226: `FOR.CELL`,
    227: `MEDIAN`,
    228: `SUMPRODUCT`,
    229: `SINH`,
    230: `COSH`,
    231: `TANH`,
    232: `ASINH`,
    233: `ACOSH`,
    234: `ATANH`,
    235: `DGET`,
    236: `CREATE.OBJECT`,
    237: `VOLATILE`,
    238: `LAST.ERROR`,
    239: `CUSTOM.UNDO`,
    240: `CUSTOM.REPEAT`,
    241: `FORMULA.CONVERT`,
    242: `GET.LINK.INFO`,
    243: `TEXT.BOX`,
    244: `INFO`,
    245: `GROUP`,
    246: `GET.OBJECT`,
    247: `DB`,
    248: `PAUSE`,
    251: `RESUME`,
    252: `FREQUENCY`,
    253: `ADD.TOOLBAR`,
    254: `DELETE.TOOLBAR`,
    255: `User`,
    256: `RESET.TOOLBAR`,
    257: `EVALUATE`,
    258: `GET.TOOLBAR`,
    259: `GET.TOOL`,
    260: `SPELLING.CHECK`,
    261: `ERROR.TYPE`,
    262: `APP.TITLE`,
    263: `WINDOW.TITLE`,
    264: `SAVE.TOOLBAR`,
    265: `ENABLE.TOOL`,
    266: `PRESS.TOOL`,
    267: `REGISTER.ID`,
    268: `GET.WORKBOOK`,
    269: `AVEDEV`,
    270: `BETADIST`,
    271: `GAMMALN`,
    272: `BETAINV`,
    273: `BINOMDIST`,
    274: `CHIDIST`,
    275: `CHIINV`,
    276: `COMBIN`,
    277: `CONFIDENCE`,
    278: `CRITBINOM`,
    279: `EVEN`,
    280: `EXPONDIST`,
    281: `FDIST`,
    282: `FINV`,
    283: `FISHER`,
    284: `FISHERINV`,
    285: `FLOOR`,
    286: `GAMMADIST`,
    287: `GAMMAINV`,
    288: `CEILING`,
    289: `HYPGEOMDIST`,
    290: `LOGNORMDIST`,
    291: `LOGINV`,
    292: `NEGBINOMDIST`,
    293: `NORMDIST`,
    294: `NORMSDIST`,
    295: `NORMINV`,
    296: `NORMSINV`,
    297: `STANDARDIZE`,
    298: `ODD`,
    299: `PERMUT`,
    300: `POISSON`,
    301: `TDIST`,
    302: `WEIBULL`,
    303: `SUMXMY2`,
    304: `SUMX2MY2`,
    305: `SUMX2PY2`,
    306: `CHITEST`,
    307: `CORREL`,
    308: `COVAR`,
    309: `FORECAST`,
    310: `FTEST`,
    311: `INTERCEPT`,
    312: `PEARSON`,
    313: `RSQ`,
    314: `STEYX`,
    315: `SLOPE`,
    316: `TTEST`,
    317: `PROB`,
    318: `DEVSQ`,
    319: `GEOMEAN`,
    320: `HARMEAN`,
    321: `SUMSQ`,
    322: `KURT`,
    323: `SKEW`,
    324: `ZTEST`,
    325: `LARGE`,
    326: `SMALL`,
    327: `QUARTILE`,
    328: `PERCENTILE`,
    329: `PERCENTRANK`,
    330: `MODE`,
    331: `TRIMMEAN`,
    332: `TINV`,
    334: `MOVIE.COMMAND`,
    335: `GET.MOVIE`,
    336: `CONCATENATE`,
    337: `POWER`,
    338: `PIVOT.ADD.DATA`,
    339: `GET.PIVOT.TABLE`,
    340: `GET.PIVOT.FIELD`,
    341: `GET.PIVOT.ITEM`,
    342: `RADIANS`,
    343: `DEGREES`,
    344: `SUBTOTAL`,
    345: `SUMIF`,
    346: `COUNTIF`,
    347: `COUNTBLANK`,
    348: `SCENARIO.GET`,
    349: `OPTIONS.LISTS.GET`,
    350: `ISPMT`,
    351: `DATEDIF`,
    352: `DATESTRING`,
    353: `NUMBERSTRING`,
    354: `ROMAN`,
    355: `OPEN.DIALOG`,
    356: `SAVE.DIALOG`,
    357: `VIEW.GET`,
    358: `GETPIVOTDATA`,
    359: `HYPERLINK`,
    360: `PHONETIC`,
    361: `AVERAGEA`,
    362: `MAXA`,
    363: `MINA`,
    364: `STDEVPA`,
    365: `VARPA`,
    366: `STDEVA`,
    367: `VARA`,
    368: `BAHTTEXT`,
    369: `THAIDAYOFWEEK`,
    370: `THAIDIGIT`,
    371: `THAIMONTHOFYEAR`,
    372: `THAINUMSOUND`,
    373: `THAINUMSTRING`,
    374: `THAISTRINGLENGTH`,
    375: `ISTHAIDIGIT`,
    376: `ROUNDBAHTDOWN`,
    377: `ROUNDBAHTUP`,
    378: `THAIYEAR`,
    379: `RTD`,
    380: `CUBEVALUE`,
    381: `CUBEMEMBER`,
    382: `CUBEMEMBERPROPERTY`,
    383: `CUBERANKEDMEMBER`,
    384: `HEX2BIN`,
    385: `HEX2DEC`,
    386: `HEX2OCT`,
    387: `DEC2BIN`,
    388: `DEC2HEX`,
    389: `DEC2OCT`,
    390: `OCT2BIN`,
    391: `OCT2HEX`,
    392: `OCT2DEC`,
    393: `BIN2DEC`,
    394: `BIN2OCT`,
    395: `BIN2HEX`,
    396: `IMSUB`,
    397: `IMDIV`,
    398: `IMPOWER`,
    399: `IMABS`,
    400: `IMSQRT`,
    401: `IMLN`,
    402: `IMLOG2`,
    403: `IMLOG10`,
    404: `IMSIN`,
    405: `IMCOS`,
    406: `IMEXP`,
    407: `IMARGUMENT`,
    408: `IMCONJUGATE`,
    409: `IMAGINARY`,
    410: `IMREAL`,
    411: `COMPLEX`,
    412: `IMSUM`,
    413: `IMPRODUCT`,
    414: `SERIESSUM`,
    415: `FACTDOUBLE`,
    416: `SQRTPI`,
    417: `QUOTIENT`,
    418: `DELTA`,
    419: `GESTEP`,
    420: `ISEVEN`,
    421: `ISODD`,
    422: `MROUND`,
    423: `ERF`,
    424: `ERFC`,
    425: `BESSELJ`,
    426: `BESSELK`,
    427: `BESSELY`,
    428: `BESSELI`,
    429: `XIRR`,
    430: `XNPV`,
    431: `PRICEMAT`,
    432: `YIELDMAT`,
    433: `INTRATE`,
    434: `RECEIVED`,
    435: `DISC`,
    436: `PRICEDISC`,
    437: `YIELDDISC`,
    438: `TBILLEQ`,
    439: `TBILLPRICE`,
    440: `TBILLYIELD`,
    441: `PRICE`,
    442: `YIELD`,
    443: `DOLLARDE`,
    444: `DOLLARFR`,
    445: `NOMINAL`,
    446: `EFFECT`,
    447: `CUMPRINC`,
    448: `CUMIPMT`,
    449: `EDATE`,
    450: `EOMONTH`,
    451: `YEARFRAC`,
    452: `COUPDAYBS`,
    453: `COUPDAYS`,
    454: `COUPDAYSNC`,
    455: `COUPNCD`,
    456: `COUPNUM`,
    457: `COUPPCD`,
    458: `DURATION`,
    459: `MDURATION`,
    460: `ODDLPRICE`,
    461: `ODDLYIELD`,
    462: `ODDFPRICE`,
    463: `ODDFYIELD`,
    464: `RANDBETWEEN`,
    465: `WEEKNUM`,
    466: `AMORDEGRC`,
    467: `AMORLINC`,
    468: `CONVERT`,
    724: `SHEETJS`,
    469: `ACCRINT`,
    470: `ACCRINTM`,
    471: `WORKDAY`,
    472: `NETWORKDAYS`,
    473: `GCD`,
    474: `MULTINOMIAL`,
    475: `LCM`,
    476: `FVSCHEDULE`,
    477: `CUBEKPIMEMBER`,
    478: `CUBESET`,
    479: `CUBESETCOUNT`,
    480: `IFERROR`,
    481: `COUNTIFS`,
    482: `SUMIFS`,
    483: `AVERAGEIF`,
    484: `AVERAGEIFS`
  },
  LW = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
  };
function RW(e) {
  return e.slice(0, 3) == `of:` && (e = e.slice(3)), e.charCodeAt(0) == 61 && (e = e.slice(1), e.charCodeAt(0) == 61 && (e = e.slice(1))), e = e.replace(/COM\.MICROSOFT\./g, ``), e = e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function (e, t) {
    return t.replace(/\./g, ``);
  }), e = e.replace(/\[.(#[A-Z]*[?!])\]/g, `$1`), e.replace(/[;~]/g, `,`).replace(/\|/g, `;`);
}
function zW(e) {
  return (`of:=` + e.replace(VH, `$1[.$2$3$4$5]`).replace(/\]:\[/g, `:`)).replace(/;/g, `|`).replace(/,/g, `;`);
}
function BW(e) {
  var t = e.split(`:`);
  return [t[0].split(`.`)[0], t[0].split(`.`)[1] + (t.length > 1 ? `:` + (t[1].split(`.`)[1] || t[1].split(`.`)[0]) : ``)];
}
function VW(e) {
  return e.replace(/\./, `!`);
}
var HW = {},
  UW = {},
  WW = typeof Map < `u`;
function GW(e, t, n) {
  var r = 0,
    i = e.length;
  if (n) {
    if (WW ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t)) {
      for (var a = WW ? n.get(t) : n[t]; r < a.length; ++r) if (e[a[r]].t === t) return e.Count++, a[r];
    }
  } else for (; r < i; ++r) if (e[r].t === t) return e.Count++, r;
  return e[i] = {
    t
  }, e.Count++, e.Unique++, n && (WW ? (n.has(t) || n.set(t, []), n.get(t).push(i)) : (Object.prototype.hasOwnProperty.call(n, t) || (n[t] = []), n[t].push(i))), i;
}
function KW(e, t) {
  var n = {
      min: e + 1,
      max: e + 1
    },
    r = -1;
  return t.MDW && (HB = t.MDW), t.width == null ? t.wpx == null ? t.wch != null && (r = t.wch) : r = WB(t.wpx) : n.customWidth = 1, r > -1 ? (n.width = GB(r), n.customWidth = 1) : t.width != null && (n.width = t.width), t.hidden && (n.hidden = !0), t.level != null && (n.outlineLevel = n.level = t.level), n;
}
function qW(e, t) {
  if (e) {
    var n = [.7, .7, .75, .75, .3, .3];
    t == `xlml` && (n = [1, 1, 1, 1, .5, .5]), e.left ??= n[0], e.right ??= n[1], e.top ??= n[2], e.bottom ??= n[3], e.header ??= n[4], e.footer ??= n[5];
  }
}
function JW(e, t, n) {
  var r = n.revssf[t.z == null ? `General` : t.z],
    i = 60,
    a = e.length;
  if (r == null && n.ssf) {
    for (; i < 392; ++i) if (n.ssf[i] == null) {
      pM(t.z, i), n.ssf[i] = t.z, n.revssf[t.z] = r = i;
      break;
    }
  }
  for (i = 0; i != a; ++i) if (e[i].numFmtId === r) return i;
  return e[a] = {
    numFmtId: r,
    fontId: 0,
    fillId: 0,
    borderId: 0,
    xfId: 0,
    applyNumberFormat: 1
  }, a;
}
function YW(e, t, n, r, i, a) {
  try {
    r.cellNF && (e.z = bj[t]);
  } catch (e) {
    if (r.WTF) throw e;
  }
  if (e.t !== `z` || r.cellStyles) {
    if (e.t === `d` && typeof e.v == `string` && (e.v = UM(e.v)), (!r || r.cellText !== !1) && e.t !== `z`) try {
      if (bj[t] ?? pM(_M[t] || `General`, t), e.t === `e`) e.w = e.w || lI[e.v];else if (t === 0) {
        if (e.t === `n`) e.w = (e.v | 0) === e.v ? e.v.toString(10) : Nj(e.v);else if (e.t === `d`) {
          var o = PM(e.v);
          e.w = (o | 0) === o ? o.toString(10) : Nj(o);
        } else if (e.v === void 0) return ``;else e.w = Pj(e.v, UW);
      } else e.w = e.t === `d` ? fM(t, PM(e.v), UW) : fM(t, e.v, UW);
    } catch (e) {
      if (r.WTF) throw e;
    }
    if (r.cellStyles && n != null) try {
      e.s = a.Fills[n], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = RB(i.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), r.WTF && (e.s.fgColor.raw_rgb = i.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = RB(i.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), r.WTF && (e.s.bgColor.raw_rgb = i.themeElements.clrScheme[e.s.bgColor.theme].rgb));
    } catch (e) {
      if (r.WTF && a.Fills) throw e;
    }
  }
}
function XW(e, t, n) {
  if (e && e[`!ref`]) {
    var r = nF(e[`!ref`]);
    if (r.e.c < r.s.c || r.e.r < r.s.r) throw Error(`Bad range (` + n + `): ` + e[`!ref`]);
  }
}
function ZW(e, t) {
  var n = nF(t);
  n.s.r <= n.e.r && n.s.c <= n.e.c && n.s.r >= 0 && n.s.c >= 0 && (e[`!ref`] = tF(n));
}
var QW = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g,
  $W = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/,
  eG = /<(?:\w:)?hyperlink [^>]*>/gm,
  tG = /"(\w*:\w*)"/,
  nG = /<(?:\w:)?col\b[^>]*[\/]?>/g,
  rG = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g,
  iG = /<(?:\w:)?pageMargins[^>]*\/>/g,
  aG = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/,
  oG = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/,
  sG = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function cG(e, t, n, r, i, a, o) {
  if (!e) return e;
  r ||= {
    "!id": {}
  }, WA != null && t.dense == null && (t.dense = WA);
  var s = t.dense ? [] : {},
    c = {
      s: {
        r: 2e6,
        c: 2e6
      },
      e: {
        r: 0,
        c: 0
      }
    },
    l = ``,
    u = ``,
    d = e.match($W);
  d ? (l = e.slice(0, d.index), u = e.slice(d.index + d[0].length)) : l = u = e;
  var f = l.match(aG);
  f ? uG(f[0], s, i, n) : (f = l.match(oG)) && dG(f[0], f[1] || ``, s, i, n, o, a);
  var p = (l.match(/<(?:\w*:)?dimension/) || {
    index: -1
  }).index;
  if (p > 0) {
    var m = l.slice(p, p + 50).match(tG);
    m && ZW(s, m[1]);
  }
  var h = l.match(sG);
  h && h[1] && wG(h[1], i);
  var g = [];
  if (t.cellStyles) {
    var _ = l.match(nG);
    _ && yG(g, _);
  }
  d && DG(d[1], s, t, c, a, o);
  var v = u.match(rG);
  v && (s[`!autofilter`] = xG(v[0]));
  var y = [],
    b = u.match(QW);
  if (b) for (p = 0; p != b.length; ++p) y[p] = nF(b[p].slice(b[p].indexOf(`"`) + 1));
  var x = u.match(eG);
  x && gG(s, x, r);
  var S = u.match(iG);
  if (S && (s[`!margins`] = _G(gN(S[0]))), !s[`!ref`] && c.e.c >= c.s.c && c.e.r >= c.s.r && (s[`!ref`] = tF(c)), t.sheetRows > 0 && s[`!ref`]) {
    var C = nF(s[`!ref`]);
    t.sheetRows <= +C.e.r && (C.e.r = t.sheetRows - 1, C.e.r > c.e.r && (C.e.r = c.e.r), C.e.r < C.s.r && (C.s.r = C.e.r), C.e.c > c.e.c && (C.e.c = c.e.c), C.e.c < C.s.c && (C.s.c = C.e.c), s[`!fullref`] = s[`!ref`], s[`!ref`] = tF(C));
  }
  return g.length > 0 && (s[`!cols`] = g), y.length > 0 && (s[`!merges`] = y), s;
}
function lG(e) {
  if (e.length === 0) return ``;
  for (var t = `<mergeCells count="` + e.length + `">`, n = 0; n != e.length; ++n) t += `<mergeCell ref="` + tF(e[n]) + `"/>`;
  return t + `</mergeCells>`;
}
function uG(e, t, n, r) {
  var i = gN(e);
  n.Sheets[r] || (n.Sheets[r] = {}), i.codeName && (n.Sheets[r].CodeName = bN(FN(i.codeName)));
}
function dG(e, t, n, r, i) {
  uG(e.slice(0, e.indexOf(`>`)), n, r, i);
}
function fG(e, t, n, r, i) {
  var a = !1,
    o = {},
    s = null;
  if (r.bookType !== `xlsx` && t.vbaraw) {
    var c = t.SheetNames[n];
    try {
      t.Workbook && (c = t.Workbook.Sheets[n].CodeName || c);
    } catch {}
    a = !0, o.codeName = IN(CN(c));
  }
  if (e && e[`!outline`]) {
    var l = {
      summaryBelow: 1,
      summaryRight: 1
    };
    e[`!outline`].above && (l.summaryBelow = 0), e[`!outline`].left && (l.summaryRight = 0), s = (s || ``) + X(`outlinePr`, null, l);
  }
  (a || s) && (i[i.length] = X(`sheetPr`, s, o));
}
var pG = [`objects`, `scenarios`, `selectLockedCells`, `selectUnlockedCells`],
  mG = [`formatColumns`, `formatRows`, `formatCells`, `insertColumns`, `insertRows`, `insertHyperlinks`, `deleteColumns`, `deleteRows`, `sort`, `autoFilter`, `pivotTables`];
function hG(e) {
  var t = {
    sheet: 1
  };
  return pG.forEach(function (n) {
    e[n] != null && e[n] && (t[n] = `1`);
  }), mG.forEach(function (n) {
    e[n] != null && !e[n] && (t[n] = `0`);
  }), e.password && (t.password = EB(e.password).toString(16).toUpperCase()), X(`sheetProtection`, null, t);
}
function gG(e, t, n) {
  for (var r = Array.isArray(e), i = 0; i != t.length; ++i) {
    var a = gN(FN(t[i]), !0);
    if (!a.ref) return;
    var o = ((n || {})[`!id`] || [])[a.id];
    o ? (a.Target = o.Target, a.location && (a.Target += `#` + bN(a.location))) : (a.Target = `#` + bN(a.location), o = {
      Target: a.Target,
      TargetMode: `Internal`
    }), a.Rel = o, a.tooltip && (a.Tooltip = a.tooltip, delete a.tooltip);
    for (var s = nF(a.ref), c = s.s.r; c <= s.e.r; ++c) for (var l = s.s.c; l <= s.e.c; ++l) {
      var u = $P({
        c: l,
        r: c
      });
      r ? (e[c] || (e[c] = []), e[c][l] || (e[c][l] = {
        t: `z`,
        v: void 0
      }), e[c][l].l = a) : (e[u] || (e[u] = {
        t: `z`,
        v: void 0
      }), e[u].l = a);
    }
  }
}
function _G(e) {
  var t = {};
  return [`left`, `right`, `top`, `bottom`, `header`, `footer`].forEach(function (n) {
    e[n] && (t[n] = parseFloat(e[n]));
  }), t;
}
function vG(e) {
  return qW(e), X(`pageMargins`, null, e);
}
function yG(e, t) {
  for (var n = !1, r = 0; r != t.length; ++r) {
    var i = gN(t[r], !0);
    i.hidden &&= AN(i.hidden);
    var a = parseInt(i.min, 10) - 1,
      o = parseInt(i.max, 10) - 1;
    for (i.outlineLevel && (i.level = +i.outlineLevel || 0), delete i.min, delete i.max, i.width = +i.width, !n && i.width && (n = !0, qB(i.width)), JB(i); a <= o;) e[a++] = GM(i);
  }
}
function bG(e, t) {
  for (var n = [`<cols>`], r, i = 0; i != t.length; ++i) (r = t[i]) && (n[n.length] = X(`col`, null, KW(i, r)));
  return n[n.length] = `</cols>`, n.join(``);
}
function xG(e) {
  return {
    ref: (e.match(/ref="([^"]*)"/) || [])[1]
  };
}
function SG(e, t, n, r) {
  var i = typeof e.ref == `string` ? e.ref : tF(e.ref);
  n.Workbook ||= {
    Sheets: []
  }, n.Workbook.Names || (n.Workbook.Names = []);
  var a = n.Workbook.Names,
    o = eF(i);
  o.s.r == o.e.r && (o.e.r = eF(t[`!ref`]).e.r, i = tF(o));
  for (var s = 0; s < a.length; ++s) {
    var c = a[s];
    if (c.Name == `_xlnm._FilterDatabase` && c.Sheet == r) {
      c.Ref = `'` + n.SheetNames[r] + `'!` + i;
      break;
    }
  }
  return s == a.length && a.push({
    Name: `_xlnm._FilterDatabase`,
    Sheet: r,
    Ref: `'` + n.SheetNames[r] + `'!` + i
  }), X(`autoFilter`, null, {
    ref: i
  });
}
var CG = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function wG(e, t) {
  t.Views ||= [{}], (e.match(CG) || []).forEach(function (e, n) {
    var r = gN(e);
    t.Views[n] || (t.Views[n] = {}), +r.zoomScale && (t.Views[n].zoom = +r.zoomScale), AN(r.rightToLeft) && (t.Views[n].RTL = !0);
  });
}
function TG(e, t, n, r) {
  var i = {
    workbookViewId: `0`
  };
  return (((r || {}).Workbook || {}).Views || [])[0] && (i.rightToLeft = r.Workbook.Views[0].RTL ? `1` : `0`), X(`sheetViews`, X(`sheetView`, null, i), {});
}
function EG(e, t, n, r) {
  if (e.c && n[`!comments`].push([t, e.c]), e.v === void 0 && typeof e.f != `string` || e.t === `z` && !e.f) return ``;
  var i = ``,
    a = e.t,
    o = e.v;
  if (e.t !== `z`) switch (e.t) {
    case `b`:
      i = e.v ? `1` : `0`;
      break;
    case `n`:
      i = `` + e.v;
      break;
    case `e`:
      i = lI[e.v];
      break;
    case `d`:
      r && r.cellDates ? i = UM(e.v, -1).toISOString() : (e = GM(e), e.t = `n`, i = `` + (e.v = PM(UM(e.v)))), e.z === void 0 && (e.z = bj[14]);
      break;
    default:
      i = e.v;
  }
  var s = WN(`v`, CN(i)),
    c = {
      r: t
    },
    l = JW(r.cellXfs, e, r);
  switch (l !== 0 && (c.s = l), e.t) {
    case `n`:
      break;
    case `d`:
      c.t = `d`;
      break;
    case `b`:
      c.t = `b`;
      break;
    case `e`:
      c.t = `e`;
      break;
    case `z`:
      break;
    default:
      if (e.v == null) {
        delete e.t;
        break;
      }
      if (e.v.length > 32767) throw Error(`Text length must not exceed 32767 characters`);
      if (r && r.bookSST) {
        s = WN(`v`, `` + GW(r.Strings, e.v, r.revStrings)), c.t = `s`;
        break;
      }
      c.t = `str`;
  }
  if (e.t != a && (e.t = a, e.v = o), typeof e.f == `string` && e.f) {
    var u = e.F && e.F.slice(0, t.length) == t ? {
      t: `array`,
      ref: e.F
    } : null;
    s = X(`f`, CN(e.f), u) + (e.v == null ? `` : s);
  }
  return e.l && n[`!links`].push([t, e.l]), e.D && (c.cm = 1), X(`c`, s, c);
}
var DG = function () {
  var e = /<(?:\w+:)?c[ \/>]/,
    t = /<\/(?:\w+:)?row>/,
    n = /r=["']([^"']*)["']/,
    r = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/,
    i = /ref=["']([^"']*)["']/,
    a = LN(`v`),
    o = LN(`f`);
  return function (s, c, l, u, d, f) {
    for (var p = 0, m = ``, h = [], g = [], _ = 0, v = 0, y = 0, b = ``, x, S, C = 0, w = 0, T, E, D = 0, O = 0, k = Array.isArray(f.CellXf), A, j = [], M = [], N = Array.isArray(c), P = [], F = {}, I = !1, L = !!l.sheetStubs, R = s.split(t), z = 0, ee = R.length; z != ee; ++z) {
      m = R[z].trim();
      var te = m.length;
      if (te !== 0) {
        var B = 0;
        outa: for (p = 0; p < te; ++p) switch (m[p]) {
          case `>`:
            if (m[p - 1] != `/`) {
              ++p;
              break outa;
            }
            if (l && l.cellStyles) {
              if (S = gN(m.slice(B, p), !0), C = S.r == null ? C + 1 : parseInt(S.r, 10), w = -1, l.sheetRows && l.sheetRows < C) continue;
              F = {}, I = !1, S.ht && (I = !0, F.hpt = parseFloat(S.ht), F.hpx = ZB(F.hpt)), S.hidden == `1` && (I = !0, F.hidden = !0), S.outlineLevel != null && (I = !0, F.level = +S.outlineLevel), I && (P[C - 1] = F);
            }
            break;
          case `<`:
            B = p;
        }
        if (B >= p) break;
        if (S = gN(m.slice(B, p), !0), C = S.r == null ? C + 1 : parseInt(S.r, 10), w = -1, !(l.sheetRows && l.sheetRows < C)) {
          u.s.r > C - 1 && (u.s.r = C - 1), u.e.r < C - 1 && (u.e.r = C - 1), l && l.cellStyles && (F = {}, I = !1, S.ht && (I = !0, F.hpt = parseFloat(S.ht), F.hpx = ZB(F.hpt)), S.hidden == `1` && (I = !0, F.hidden = !0), S.outlineLevel != null && (I = !0, F.level = +S.outlineLevel), I && (P[C - 1] = F)), h = m.slice(p).split(e);
          for (var V = 0; V != h.length && h[V].trim().charAt(0) == `<`; ++V);
          for (h = h.slice(V), p = 0; p != h.length; ++p) if (m = h[p].trim(), m.length !== 0) {
            if (g = m.match(n), _ = p, v = 0, y = 0, m = `<c ` + (m.slice(0, 1) == `<` ? `>` : ``) + m, g != null && g.length === 2) {
              for (_ = 0, b = g[1], v = 0; v != b.length && !((y = b.charCodeAt(v) - 64) < 1 || y > 26); ++v) _ = 26 * _ + y;
              --_, w = _;
            } else ++w;
            for (v = 0; v != m.length && m.charCodeAt(v) !== 62; ++v);
            if (++v, S = gN(m.slice(0, v), !0), S.r || (S.r = $P({
              r: C - 1,
              c: w
            })), b = m.slice(v), x = {
              t: ``
            }, (g = b.match(a)) != null && g[1] !== `` && (x.v = bN(g[1])), l.cellFormula) {
              if ((g = b.match(o)) != null && g[1] !== ``) {
                if (x.f = bN(FN(g[1])).replace(/\r\n/g, `
`), l.xlfn || (x.f = KH(x.f)), g[0].indexOf(`t="array"`) > -1) x.F = (b.match(i) || [])[1], x.F.indexOf(`:`) > -1 && j.push([nF(x.F), x.F]);else if (g[0].indexOf(`t="shared"`) > -1) {
                  E = gN(g[0]);
                  var H = bN(FN(g[1]));
                  l.xlfn || (H = KH(H)), M[parseInt(E.si, 10)] = [E, H, S.r];
                }
              } else (g = b.match(/<f[^>]*\/>/)) && (E = gN(g[0]), M[E.si] && (x.f = WH(M[E.si][1], M[E.si][2], S.r)));
              var ne = QP(S.r);
              for (v = 0; v < j.length; ++v) ne.r >= j[v][0].s.r && ne.r <= j[v][0].e.r && ne.c >= j[v][0].s.c && ne.c <= j[v][0].e.c && (x.F = j[v][1]);
            }
            if (S.t == null && x.v === void 0) {
              if (x.f || x.F) x.v = 0, x.t = `n`;else if (L) x.t = `z`;else continue;
            } else x.t = S.t || `n`;
            switch (u.s.c > w && (u.s.c = w), u.e.c < w && (u.e.c = w), x.t) {
              case `n`:
                if (x.v == `` || x.v == null) {
                  if (!L) continue;
                  x.t = `z`;
                } else x.v = parseFloat(x.v);
                break;
              case `s`:
                if (x.v === void 0) {
                  if (!L) continue;
                  x.t = `z`;
                } else T = HW[parseInt(x.v, 10)], x.v = T.t, x.r = T.r, l.cellHTML && (x.h = T.h);
                break;
              case `str`:
                x.t = `s`, x.v = x.v == null ? `` : FN(x.v), l.cellHTML && (x.h = EN(x.v));
                break;
              case `inlineStr`:
                g = b.match(r), x.t = `s`, g != null && (T = Qz(g[1])) ? (x.v = T.t, l.cellHTML && (x.h = T.h)) : x.v = ``;
                break;
              case `b`:
                x.v = AN(x.v);
                break;
              case `d`:
                l.cellDates ? x.v = UM(x.v, 1) : (x.v = PM(UM(x.v, 1)), x.t = `n`);
                break;
              case `e`:
                (!l || l.cellText !== !1) && (x.w = x.v), x.v = uI[x.v];
            }
            if (D = O = 0, A = null, k && S.s !== void 0 && (A = f.CellXf[S.s], A != null && (A.numFmtId != null && (D = A.numFmtId), l.cellStyles && A.fillId != null && (O = A.fillId))), YW(x, D, O, l, d, f), l.cellDates && k && x.t == `n` && sM(bj[D]) && (x.t = `d`, x.v = RM(x.v)), S.cm && l.xlmeta) {
              var re = (l.xlmeta.Cell || [])[S.cm - 1];
              re && re.type == `XLDAPR` && (x.D = !0);
            }
            if (N) {
              var ie = QP(S.r);
              c[ie.r] || (c[ie.r] = []), c[ie.r][ie.c] = x;
            } else c[S.r] = x;
          }
        }
      }
    }
    P.length > 0 && (c[`!rows`] = P);
  };
}();
function OG(e, t, n, r) {
  var i = [],
    a = [],
    o = nF(e[`!ref`]),
    s = ``,
    c,
    l = ``,
    u = [],
    d = 0,
    f = 0,
    p = e[`!rows`],
    m = Array.isArray(e),
    h = {
      r: l
    },
    g,
    _ = -1;
  for (f = o.s.c; f <= o.e.c; ++f) u[f] = JP(f);
  for (d = o.s.r; d <= o.e.r; ++d) {
    for (a = [], l = WP(d), f = o.s.c; f <= o.e.c; ++f) {
      c = u[f] + l;
      var v = m ? (e[d] || [])[f] : e[c];
      v !== void 0 && (s = EG(v, c, e, t, n, r)) != null && a.push(s);
    }
    (a.length > 0 || p && p[d]) && (h = {
      r: l
    }, p && p[d] && (g = p[d], g.hidden && (h.hidden = 1), _ = -1, g.hpx ? _ = XB(g.hpx) : g.hpt && (_ = g.hpt), _ > -1 && (h.ht = _, h.customHeight = 1), g.level && (h.outlineLevel = g.level)), i[i.length] = X(`row`, a.join(``), h));
  }
  if (p) for (; d < p.length; ++d) p && p[d] && (h = {
    r: d + 1
  }, g = p[d], g.hidden && (h.hidden = 1), _ = -1, g.hpx ? _ = XB(g.hpx) : g.hpt && (_ = g.hpt), _ > -1 && (h.ht = _, h.customHeight = 1), g.level && (h.outlineLevel = g.level), i[i.length] = X(`row`, ``, h));
  return i.join(``);
}
function kG(e, t, n, r) {
  var i = [uN, X(`worksheet`, null, {
      xmlns: ZN[0],
      "xmlns:r": XN.r
    })],
    a = n.SheetNames[e],
    o = 0,
    s = ``,
    c = n.Sheets[a];
  c ??= {};
  var l = c[`!ref`] || `A1`,
    u = nF(l);
  if (u.e.c > 16383 || u.e.r > 1048575) {
    if (t.WTF) throw Error(`Range ` + l + ` exceeds format limit A1:XFD1048576`);
    u.e.c = Math.min(u.e.c, 16383), u.e.r = Math.min(u.e.c, 1048575), l = tF(u);
  }
  r ||= {}, c[`!comments`] = [];
  var d = [];
  fG(c, n, e, t, i), i[i.length] = X(`dimension`, null, {
    ref: l
  }), i[i.length] = TG(c, t, e, n), t.sheetFormat && (i[i.length] = X(`sheetFormatPr`, null, {
    defaultRowHeight: t.sheetFormat.defaultRowHeight || `16`,
    baseColWidth: t.sheetFormat.baseColWidth || `10`,
    outlineLevelRow: t.sheetFormat.outlineLevelRow || `7`
  })), c[`!cols`] != null && c[`!cols`].length > 0 && (i[i.length] = bG(c, c[`!cols`])), i[o = i.length] = `<sheetData/>`, c[`!links`] = [], c[`!ref`] != null && (s = OG(c, t, e, n, r), s.length > 0 && (i[i.length] = s)), i.length > o + 1 && (i[i.length] = `</sheetData>`, i[o] = i[o].replace(`/>`, `>`)), c[`!protect`] && (i[i.length] = hG(c[`!protect`])), c[`!autofilter`] != null && (i[i.length] = SG(c[`!autofilter`], c, n, e)), c[`!merges`] != null && c[`!merges`].length > 0 && (i[i.length] = lG(c[`!merges`]));
  var f = -1,
    p,
    m = -1;
  return c[`!links`].length > 0 && (i[i.length] = `<hyperlinks>`, c[`!links`].forEach(function (e) {
    e[1].Target && (p = {
      ref: e[0]
    }, e[1].Target.charAt(0) != `#` && (m = bI(r, -1, CN(e[1].Target).replace(/#.*$/, ``), gI.HLINK), p[`r:id`] = `rId` + m), (f = e[1].Target.indexOf(`#`)) > -1 && (p.location = CN(e[1].Target.slice(f + 1))), e[1].Tooltip && (p.tooltip = CN(e[1].Tooltip)), i[i.length] = X(`hyperlink`, null, p));
  }), i[i.length] = `</hyperlinks>`), delete c[`!links`], c[`!margins`] != null && (i[i.length] = vG(c[`!margins`])), (!t || t.ignoreEC || t.ignoreEC == null) && (i[i.length] = WN(`ignoredErrors`, X(`ignoredError`, null, {
    numberStoredAsText: 1,
    sqref: l
  }))), d.length > 0 && (m = bI(r, -1, `../drawings/drawing` + (e + 1) + `.xml`, gI.DRAW), i[i.length] = X(`drawing`, null, {
    "r:id": `rId` + m
  }), c[`!drawing`] = d), c[`!comments`].length > 0 && (m = bI(r, -1, `../drawings/vmlDrawing` + (e + 1) + `.vml`, gI.VML), i[i.length] = X(`legacyDrawing`, null, {
    "r:id": `rId` + m
  }), c[`!legacy`] = m), i.length > 1 && (i[i.length] = `</worksheet>`, i[1] = i[1].replace(`/>`, `>`)), i.join(``);
}
function AG(e, t) {
  var n = {},
    r = e.l + t;
  n.r = e.read_shift(4), e.l += 4;
  var i = e.read_shift(2);
  e.l += 1;
  var a = e.read_shift(1);
  return e.l = r, a & 7 && (n.level = a & 7), a & 16 && (n.hidden = !0), a & 32 && (n.hpt = i / 20), n;
}
function jG(e, t, n) {
  var r = Z(145),
    i = (n[`!rows`] || [])[e] || {};
  r.write_shift(4, e), r.write_shift(4, 0);
  var a = 320;
  i.hpx ? a = XB(i.hpx) * 20 : i.hpt && (a = i.hpt * 20), r.write_shift(2, a), r.write_shift(1, 0);
  var o = 0;
  i.level && (o |= i.level), i.hidden && (o |= 16), (i.hpx || i.hpt) && (o |= 32), r.write_shift(1, o), r.write_shift(1, 0);
  var s = 0,
    c = r.l;
  r.l += 4;
  for (var l = {
      r: e,
      c: 0
    }, u = 0; u < 16; ++u) if (!(t.s.c > u + 1 << 10 || t.e.c < u << 10)) {
    for (var d = -1, f = -1, p = u << 10; p < u + 1 << 10; ++p) l.c = p, (Array.isArray(n) ? (n[l.r] || [])[l.c] : n[$P(l)]) && (d < 0 && (d = p), f = p);
    d < 0 || (++s, r.write_shift(4, d), r.write_shift(4, f));
  }
  var m = r.l;
  return r.l = c, r.write_shift(4, s), r.l = m, r.length > r.l ? r.slice(0, r.l) : r;
}
function MG(e, t, n, r) {
  var i = jG(r, n, t);
  (i.length > 17 || (t[`!rows`] || [])[r]) && Q(e, 0, i);
}
var NG = NF,
  PG = PF;
function FG() {}
function IG(e, t) {
  var n = {},
    r = e[e.l];
  return ++e.l, n.above = !(r & 64), n.left = !(r & 128), e.l += 18, n.name = SF(e, t - 19), n;
}
function LG(e, t, n) {
  n ??= Z(84 + 4 * e.length);
  var r = 192;
  t && (t.above && (r &= -65), t.left && (r &= -129)), n.write_shift(1, r);
  for (var i = 1; i < 3; ++i) n.write_shift(1, 0);
  return RF({
    auto: 1
  }, n), n.write_shift(-4, -1), n.write_shift(-4, -1), CF(e, n), n.slice(0, n.l);
}
function RG(e) {
  return [vF(e)];
}
function zG(e, t, n) {
  return n ??= Z(8), yF(t, n);
}
function BG(e) {
  return [bF(e)];
}
function VG(e, t, n) {
  return n ??= Z(4), xF(t, n);
}
function HG(e) {
  return [vF(e), e.read_shift(1), `b`];
}
function UG(e, t, n) {
  return n ??= Z(9), yF(t, n), n.write_shift(1, +!!e.v), n;
}
function WG(e) {
  return [bF(e), e.read_shift(1), `b`];
}
function GG(e, t, n) {
  return n ??= Z(5), xF(t, n), n.write_shift(1, +!!e.v), n;
}
function KG(e) {
  return [vF(e), e.read_shift(1), `e`];
}
function qG(e, t, n) {
  return n ??= Z(9), yF(t, n), n.write_shift(1, e.v), n;
}
function JG(e) {
  return [bF(e), e.read_shift(1), `e`];
}
function YG(e, t, n) {
  return n ??= Z(8), xF(t, n), n.write_shift(1, e.v), n.write_shift(2, 0), n.write_shift(1, 0), n;
}
function XG(e) {
  return [vF(e), e.read_shift(4), `s`];
}
function ZG(e, t, n) {
  return n ??= Z(12), yF(t, n), n.write_shift(4, t.v), n;
}
function QG(e) {
  return [bF(e), e.read_shift(4), `s`];
}
function $G(e, t, n) {
  return n ??= Z(8), xF(t, n), n.write_shift(4, t.v), n;
}
function eK(e) {
  return [vF(e), FF(e), `n`];
}
function tK(e, t, n) {
  return n ??= Z(16), yF(t, n), IF(e.v, n), n;
}
function nK(e) {
  return [bF(e), FF(e), `n`];
}
function rK(e, t, n) {
  return n ??= Z(12), xF(t, n), IF(e.v, n), n;
}
function iK(e) {
  return [vF(e), kF(e), `n`];
}
function aK(e, t, n) {
  return n ??= Z(12), yF(t, n), AF(e.v, n), n;
}
function oK(e) {
  return [bF(e), kF(e), `n`];
}
function sK(e, t, n) {
  return n ??= Z(8), xF(t, n), AF(e.v, n), n;
}
function cK(e) {
  return [vF(e), mF(e), `is`];
}
function lK(e) {
  return [vF(e), uF(e), `str`];
}
function uK(e, t, n) {
  return n ??= Z(12 + 4 * e.v.length), yF(t, n), dF(e.v, n), n.length > n.l ? n.slice(0, n.l) : n;
}
function dK(e) {
  return [bF(e), uF(e), `str`];
}
function fK(e, t, n) {
  return n ??= Z(8 + 4 * e.v.length), xF(t, n), dF(e.v, n), n.length > n.l ? n.slice(0, n.l) : n;
}
function pK(e, t, n) {
  var r = e.l + t,
    i = vF(e);
  i.r = n[`!row`];
  var a = [i, e.read_shift(1), `b`];
  return n.cellFormula ? (e.l += 2, a[3] = xW(MW(e, r - e.l, n), null, i, n.supbooks, n)) : e.l = r, a;
}
function mK(e, t, n) {
  var r = e.l + t,
    i = vF(e);
  i.r = n[`!row`];
  var a = [i, e.read_shift(1), `e`];
  return n.cellFormula ? (e.l += 2, a[3] = xW(MW(e, r - e.l, n), null, i, n.supbooks, n)) : e.l = r, a;
}
function hK(e, t, n) {
  var r = e.l + t,
    i = vF(e);
  i.r = n[`!row`];
  var a = [i, FF(e), `n`];
  return n.cellFormula ? (e.l += 2, a[3] = xW(MW(e, r - e.l, n), null, i, n.supbooks, n)) : e.l = r, a;
}
function gK(e, t, n) {
  var r = e.l + t,
    i = vF(e);
  i.r = n[`!row`];
  var a = [i, uF(e), `str`];
  return n.cellFormula ? (e.l += 2, a[3] = xW(MW(e, r - e.l, n), null, i, n.supbooks, n)) : e.l = r, a;
}
var _K = NF,
  vK = PF;
function yK(e, t) {
  return t ??= Z(4), t.write_shift(4, e), t;
}
function bK(e, t) {
  var n = e.l + t,
    r = NF(e, 16),
    i = wF(e),
    a = uF(e),
    o = uF(e),
    s = uF(e);
  e.l = n;
  var c = {
    rfx: r,
    relId: i,
    loc: a,
    display: s
  };
  return o && (c.Tooltip = o), c;
}
function xK(e, t) {
  var n = Z(50 + 4 * (e[1].Target.length + (e[1].Tooltip || ``).length));
  PF({
    s: QP(e[0]),
    e: QP(e[0])
  }, n), OF(`rId` + t, n);
  var r = e[1].Target.indexOf(`#`);
  return dF((r == -1 ? `` : e[1].Target.slice(r + 1)) || ``, n), dF(e[1].Tooltip || ``, n), dF(``, n), n.slice(0, n.l);
}
function SK() {}
function CK(e, t, n) {
  var r = e.l + t,
    i = jF(e, 16),
    a = e.read_shift(1),
    o = [i];
  return o[2] = a, n.cellFormula ? o[1] = jW(e, r - e.l, n) : e.l = r, o;
}
function wK(e, t, n) {
  var r = e.l + t,
    i = [NF(e, 16)];
  return n.cellFormula && (i[1] = PW(e, r - e.l, n)), e.l = r, i;
}
function TK(e, t, n) {
  n ??= Z(18);
  var r = KW(e, t);
  n.write_shift(-4, e), n.write_shift(-4, e), n.write_shift(4, (r.width || 10) * 256), n.write_shift(4, 0);
  var i = 0;
  return t.hidden && (i |= 1), typeof r.width == `number` && (i |= 2), t.level && (i |= t.level << 8), n.write_shift(2, i), n;
}
var EK = [`left`, `right`, `top`, `bottom`, `header`, `footer`];
function DK(e) {
  var t = {};
  return EK.forEach(function (n) {
    t[n] = FF(e, 8);
  }), t;
}
function OK(e, t) {
  return t ??= Z(48), qW(e), EK.forEach(function (n) {
    IF(e[n], t);
  }), t;
}
function kK(e) {
  var t = e.read_shift(2);
  return e.l += 28, {
    RTL: t & 32
  };
}
function AK(e, t, n) {
  n ??= Z(30);
  var r = 924;
  return (((t || {}).Views || [])[0] || {}).RTL && (r |= 32), n.write_shift(2, r), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(2, 0), n.write_shift(2, 100), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(4, 0), n;
}
function jK(e) {
  var t = Z(24);
  return t.write_shift(4, 4), t.write_shift(4, 1), PF(e, t), t;
}
function MK(e, t) {
  return t ??= Z(66), t.write_shift(2, e.password ? EB(e.password) : 0), t.write_shift(4, 1), [[`objects`, !1], [`scenarios`, !1], [`formatCells`, !0], [`formatColumns`, !0], [`formatRows`, !0], [`insertColumns`, !0], [`insertRows`, !0], [`insertHyperlinks`, !0], [`deleteColumns`, !0], [`deleteRows`, !0], [`selectLockedCells`, !1], [`sort`, !0], [`autoFilter`, !0], [`pivotTables`, !0], [`selectUnlockedCells`, !1]].forEach(function (n) {
    n[1] ? t.write_shift(4, +(e[n[0]] != null && !e[n[0]])) : t.write_shift(4, e[n[0]] != null && e[n[0]] ? 0 : 1);
  }), t;
}
function NK() {}
function PK() {}
function FK(e, t, n, r, i, a, o) {
  if (!e) return e;
  var s = t || {};
  r ||= {
    "!id": {}
  }, WA != null && s.dense == null && (s.dense = WA);
  var c = s.dense ? [] : {},
    l,
    u = {
      s: {
        r: 2e6,
        c: 2e6
      },
      e: {
        r: 0,
        c: 0
      }
    },
    d = [],
    f = !1,
    p = !1,
    m,
    h,
    g,
    _,
    v,
    y,
    b,
    x,
    S,
    C = [];
  s.biff = 12, s[`!row`] = 0;
  var w = 0,
    T = !1,
    E = [],
    D = {},
    O = s.supbooks || i.supbooks || [[]];
  if (O.sharedf = D, O.arrayf = E, O.SheetNames = i.SheetNames || i.Sheets.map(function (e) {
    return e.name;
  }), !s.supbooks && (s.supbooks = O, i.Names)) for (var k = 0; k < i.Names.length; ++k) O[0][k + 1] = i.Names[k];
  var A = [],
    j = [],
    M = !1;
  EJ[16] = {
    n: `BrtShortReal`,
    f: nK
  };
  var N, P;
  if (LP(e, function (e, t, k) {
    if (!p) switch (k) {
      case 148:
        l = e;
        break;
      case 0:
        m = e, s.sheetRows && s.sheetRows <= m.r && (p = !0), x = WP(_ = m.r), s[`!row`] = m.r, (e.hidden || e.hpt || e.level != null) && (e.hpt && (e.hpx = ZB(e.hpt)), j[e.r] = e);
        break;
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
      case 62:
        switch (h = {
          t: e[2]
        }, e[2]) {
          case `n`:
            h.v = e[1];
            break;
          case `s`:
            b = HW[e[1]], h.v = b.t, h.r = b.r;
            break;
          case `b`:
            h.v = !!e[1];
            break;
          case `e`:
            h.v = e[1], s.cellText !== !1 && (h.w = lI[h.v]);
            break;
          case `str`:
            h.t = `s`, h.v = e[1];
            break;
          case `is`:
            h.t = `s`, h.v = e[1].t;
        }
        if ((g = o.CellXf[e[0].iStyleRef]) && YW(h, g.numFmtId, null, s, a, o), v = e[0].c == -1 ? v + 1 : e[0].c, s.dense ? (c[_] || (c[_] = []), c[_][v] = h) : c[JP(v) + x] = h, s.cellFormula) {
          for (T = !1, w = 0; w < E.length; ++w) {
            var F = E[w];
            m.r >= F[0].s.r && m.r <= F[0].e.r && v >= F[0].s.c && v <= F[0].e.c && (h.F = tF(F[0]), T = !0);
          }
          !T && e.length > 3 && (h.f = e[3]);
        }
        if (u.s.r > m.r && (u.s.r = m.r), u.s.c > v && (u.s.c = v), u.e.r < m.r && (u.e.r = m.r), u.e.c < v && (u.e.c = v), s.cellDates && g && h.t == `n` && sM(bj[g.numFmtId])) {
          var I = wj(h.v);
          I && (h.t = `d`, h.v = new Date(I.y, I.m - 1, I.d, I.H, I.M, I.S, I.u));
        }
        N &&= (N.type == `XLDAPR` && (h.D = !0), void 0), P &&= void 0;
        break;
      case 1:
      case 12:
        if (!s.sheetStubs || f) break;
        h = {
          t: `z`,
          v: void 0
        }, v = e[0].c == -1 ? v + 1 : e[0].c, s.dense ? (c[_] || (c[_] = []), c[_][v] = h) : c[JP(v) + x] = h, u.s.r > m.r && (u.s.r = m.r), u.s.c > v && (u.s.c = v), u.e.r < m.r && (u.e.r = m.r), u.e.c < v && (u.e.c = v), N &&= (N.type == `XLDAPR` && (h.D = !0), void 0), P &&= void 0;
        break;
      case 176:
        C.push(e);
        break;
      case 49:
        N = ((s.xlmeta || {}).Cell || [])[e - 1];
        break;
      case 494:
        var L = r[`!id`][e.relId];
        for (L ? (e.Target = L.Target, e.loc && (e.Target += `#` + e.loc), e.Rel = L) : e.relId == `` && (e.Target = `#` + e.loc), _ = e.rfx.s.r; _ <= e.rfx.e.r; ++_) for (v = e.rfx.s.c; v <= e.rfx.e.c; ++v) s.dense ? (c[_] || (c[_] = []), c[_][v] || (c[_][v] = {
          t: `z`,
          v: void 0
        }), c[_][v].l = e) : (y = $P({
          c: v,
          r: _
        }), c[y] || (c[y] = {
          t: `z`,
          v: void 0
        }), c[y].l = e);
        break;
      case 426:
        if (!s.cellFormula) break;
        E.push(e), S = s.dense ? c[_][v] : c[JP(v) + x], S.f = xW(e[1], u, {
          r: m.r,
          c: v
        }, O, s), S.F = tF(e[0]);
        break;
      case 427:
        if (!s.cellFormula) break;
        D[$P(e[0].s)] = e[1], S = s.dense ? c[_][v] : c[JP(v) + x], S.f = xW(e[1], u, {
          r: m.r,
          c: v
        }, O, s);
        break;
      case 60:
        if (!s.cellStyles) break;
        for (; e.e >= e.s;) A[e.e--] = {
          width: e.w / 256,
          hidden: !!(e.flags & 1),
          level: e.level
        }, M || (M = !0, qB(e.w / 256)), JB(A[e.e + 1]);
        break;
      case 161:
        c[`!autofilter`] = {
          ref: tF(e)
        };
        break;
      case 476:
        c[`!margins`] = e;
        break;
      case 147:
        i.Sheets[n] || (i.Sheets[n] = {}), e.name && (i.Sheets[n].CodeName = e.name), (e.above || e.left) && (c[`!outline`] = {
          above: e.above,
          left: e.left
        });
        break;
      case 137:
        i.Views ||= [{}], i.Views[0] || (i.Views[0] = {}), e.RTL && (i.Views[0].RTL = !0);
        break;
      case 485:
        break;
      case 64:
      case 1053:
        break;
      case 151:
        break;
      case 152:
      case 175:
      case 644:
      case 625:
      case 562:
      case 396:
      case 1112:
      case 1146:
      case 471:
      case 1050:
      case 649:
      case 1105:
      case 589:
      case 607:
      case 564:
      case 1055:
      case 168:
      case 174:
      case 1180:
      case 499:
      case 507:
      case 550:
      case 171:
      case 167:
      case 1177:
      case 169:
      case 1181:
      case 551:
      case 552:
      case 661:
      case 639:
      case 478:
      case 537:
      case 477:
      case 536:
      case 1103:
      case 680:
      case 1104:
      case 1024:
      case 663:
      case 535:
      case 678:
      case 504:
      case 1043:
      case 428:
      case 170:
      case 3072:
      case 50:
      case 2070:
      case 1045:
        break;
      case 35:
        f = !0;
        break;
      case 36:
        f = !1;
        break;
      case 37:
        d.push(k), f = !0;
        break;
      case 38:
        d.pop(), f = !1;
        break;
      default:
        if (!t.T && (!f || s.WTF)) throw Error(`Unexpected record 0x` + k.toString(16));
    }
  }, s), delete s.supbooks, delete s[`!row`], !c[`!ref`] && (u.s.r < 2e6 || l && (l.e.r > 0 || l.e.c > 0 || l.s.r > 0 || l.s.c > 0)) && (c[`!ref`] = tF(l || u)), s.sheetRows && c[`!ref`]) {
    var F = nF(c[`!ref`]);
    s.sheetRows <= +F.e.r && (F.e.r = s.sheetRows - 1, F.e.r > u.e.r && (F.e.r = u.e.r), F.e.r < F.s.r && (F.s.r = F.e.r), F.e.c > u.e.c && (F.e.c = u.e.c), F.e.c < F.s.c && (F.s.c = F.e.c), c[`!fullref`] = c[`!ref`], c[`!ref`] = tF(F));
  }
  return C.length > 0 && (c[`!merges`] = C), A.length > 0 && (c[`!cols`] = A), j.length > 0 && (c[`!rows`] = j), c;
}
function IK(e, t, n, r, i, a, o) {
  if (t.v === void 0) return !1;
  var s = ``;
  switch (t.t) {
    case `b`:
      s = t.v ? `1` : `0`;
      break;
    case `d`:
      t = GM(t), t.z = t.z || bj[14], t.v = PM(UM(t.v)), t.t = `n`;
      break;
    case `n`:
    case `e`:
      s = `` + t.v;
      break;
    default:
      s = t.v;
  }
  var c = {
    r: n,
    c: r
  };
  switch (c.s = JW(i.cellXfs, t, i), t.l && a[`!links`].push([$P(c), t.l]), t.c && a[`!comments`].push([$P(c), t.c]), t.t) {
    case `s`:
    case `str`:
      return i.bookSST ? (s = GW(i.Strings, t.v, i.revStrings), c.t = `s`, c.v = s, o ? Q(e, 18, $G(t, c)) : Q(e, 7, ZG(t, c))) : (c.t = `str`, o ? Q(e, 17, fK(t, c)) : Q(e, 6, uK(t, c))), !0;
    case `n`:
      return t.v == (t.v | 0) && t.v > -1e3 && t.v < 1e3 ? o ? Q(e, 13, sK(t, c)) : Q(e, 2, aK(t, c)) : o ? Q(e, 16, rK(t, c)) : Q(e, 5, tK(t, c)), !0;
    case `b`:
      return c.t = `b`, o ? Q(e, 15, GG(t, c)) : Q(e, 4, UG(t, c)), !0;
    case `e`:
      return c.t = `e`, o ? Q(e, 14, YG(t, c)) : Q(e, 3, qG(t, c)), !0;
  }
  return o ? Q(e, 12, VG(t, c)) : Q(e, 1, zG(t, c)), !0;
}
function LK(e, t, n, r) {
  var i = nF(t[`!ref`] || `A1`),
    a,
    o = ``,
    s = [];
  Q(e, 145);
  var c = Array.isArray(t),
    l = i.e.r;
  t[`!rows`] && (l = Math.max(i.e.r, t[`!rows`].length - 1));
  for (var u = i.s.r; u <= l; ++u) {
    o = WP(u), MG(e, t, i, u);
    var d = !1;
    if (u <= i.e.r) for (var f = i.s.c; f <= i.e.c; ++f) {
      u === i.s.r && (s[f] = JP(f)), a = s[f] + o;
      var p = c ? (t[u] || [])[f] : t[a];
      if (!p) {
        d = !1;
        continue;
      }
      d = IK(e, p, u, f, r, t, d);
    }
  }
  Q(e, 146);
}
function RK(e, t) {
  t && t[`!merges`] && (Q(e, 177, yK(t[`!merges`].length)), t[`!merges`].forEach(function (t) {
    Q(e, 176, vK(t));
  }), Q(e, 178));
}
function zK(e, t) {
  t && t[`!cols`] && (Q(e, 390), t[`!cols`].forEach(function (t, n) {
    t && Q(e, 60, TK(n, t));
  }), Q(e, 391));
}
function BK(e, t) {
  t && t[`!ref`] && (Q(e, 648), Q(e, 649, jK(nF(t[`!ref`]))), Q(e, 650));
}
function VK(e, t, n) {
  t[`!links`].forEach(function (t) {
    t[1].Target && Q(e, 494, xK(t, bI(n, -1, t[1].Target.replace(/#.*$/, ``), gI.HLINK)));
  }), delete t[`!links`];
}
function HK(e, t, n, r) {
  if (t[`!comments`].length > 0) {
    var i = bI(r, -1, `../drawings/vmlDrawing` + (n + 1) + `.vml`, gI.VML);
    Q(e, 551, OF(`rId` + i)), t[`!legacy`] = i;
  }
}
function UK(e, t, n, r) {
  if (t[`!autofilter`]) {
    var i = t[`!autofilter`],
      a = typeof i.ref == `string` ? i.ref : tF(i.ref);
    n.Workbook ||= {
      Sheets: []
    }, n.Workbook.Names || (n.Workbook.Names = []);
    var o = n.Workbook.Names,
      s = eF(a);
    s.s.r == s.e.r && (s.e.r = eF(t[`!ref`]).e.r, a = tF(s));
    for (var c = 0; c < o.length; ++c) {
      var l = o[c];
      if (l.Name == `_xlnm._FilterDatabase` && l.Sheet == r) {
        l.Ref = `'` + n.SheetNames[r] + `'!` + a;
        break;
      }
    }
    c == o.length && o.push({
      Name: `_xlnm._FilterDatabase`,
      Sheet: r,
      Ref: `'` + n.SheetNames[r] + `'!` + a
    }), Q(e, 161, PF(nF(a))), Q(e, 162);
  }
}
function WK(e, t, n) {
  Q(e, 133), Q(e, 137, AK(t, n)), Q(e, 138), Q(e, 134);
}
function GK(e, t) {
  t[`!protect`] && Q(e, 535, MK(t[`!protect`]));
}
function KK(e, t, n, r) {
  var i = RP(),
    a = n.SheetNames[e],
    o = n.Sheets[a] || {},
    s = a;
  try {
    n && n.Workbook && (s = n.Workbook.Sheets[e].CodeName || s);
  } catch {}
  var c = nF(o[`!ref`] || `A1`);
  if (c.e.c > 16383 || c.e.r > 1048575) {
    if (t.WTF) throw Error(`Range ` + (o[`!ref`] || `A1`) + ` exceeds format limit A1:XFD1048576`);
    c.e.c = Math.min(c.e.c, 16383), c.e.r = Math.min(c.e.c, 1048575);
  }
  return o[`!links`] = [], o[`!comments`] = [], Q(i, 129), (n.vbaraw || o[`!outline`]) && Q(i, 147, LG(s, o[`!outline`])), Q(i, 148, PG(c)), WK(i, o, n.Workbook), zK(i, o, e, t, n), LK(i, o, e, t, n), GK(i, o), UK(i, o, n, e), RK(i, o), VK(i, o, r), o[`!margins`] && Q(i, 476, OK(o[`!margins`])), (!t || t.ignoreEC || t.ignoreEC == null) && BK(i, o), HK(i, o, e, r), Q(i, 130), i.end();
}
function qK(e) {
  var t = [],
    n = e.match(/^<c:numCache>/),
    r;
  (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm) || []).forEach(function (e) {
    var r = e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    r && (t[+r[1]] = n ? +r[2] : r[2]);
  });
  var i = bN((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [``, `General`])[1]);
  return (e.match(/<c:f>(.*?)<\/c:f>/gm) || []).forEach(function (e) {
    r = e.replace(/<.*?>/g, ``);
  }), [t, i, r];
}
function JK(e, t, n, r, i, a) {
  var o = a || {
    "!type": `chart`
  };
  if (!e) return a;
  var s = 0,
    c = 0,
    l = `A`,
    u = {
      s: {
        r: 2e6,
        c: 2e6
      },
      e: {
        r: 0,
        c: 0
      }
    };
  return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function (e) {
    var t = qK(e);
    u.s.r = u.s.c = 0, u.e.c = s, l = JP(s), t[0].forEach(function (e, n) {
      o[l + WP(n)] = {
        t: `n`,
        v: e,
        z: t[1]
      }, c = n;
    }), u.e.r < c && (u.e.r = c), ++s;
  }), s > 0 && (o[`!ref`] = tF(u)), o;
}
function YK(e, t, n, r, i) {
  if (!e) return e;
  r ||= {
    "!id": {}
  };
  var a = {
      "!type": `chart`,
      "!drawel": null,
      "!rel": ``
    },
    o,
    s = e.match(aG);
  return s && uG(s[0], a, i, n), (o = e.match(/drawing r:id="(.*?)"/)) && (a[`!rel`] = o[1]), r[`!id`][a[`!rel`]] && (a[`!drawel`] = r[`!id`][a[`!rel`]]), a;
}
function XK(e, t) {
  return e.l += 10, {
    name: uF(e, t - 10)
  };
}
function ZK(e, t, n, r, i) {
  if (!e) return e;
  r ||= {
    "!id": {}
  };
  var a = {
      "!type": `chart`,
      "!drawel": null,
      "!rel": ``
    },
    o = [],
    s = !1;
  return LP(e, function (e, r, c) {
    switch (c) {
      case 550:
        a[`!rel`] = e;
        break;
      case 651:
        i.Sheets[n] || (i.Sheets[n] = {}), e.name && (i.Sheets[n].CodeName = e.name);
        break;
      case 562:
      case 652:
      case 669:
      case 679:
      case 551:
      case 552:
      case 476:
      case 3072:
        break;
      case 35:
        s = !0;
        break;
      case 36:
        s = !1;
        break;
      case 37:
        o.push(c);
        break;
      case 38:
        o.pop();
        break;
      default:
        if (r.T > 0) o.push(c);else if (r.T < 0) o.pop();else if (!s || t.WTF) throw Error(`Unexpected record 0x` + c.toString(16));
    }
  }, t), r[`!id`][a[`!rel`]] && (a[`!drawel`] = r[`!id`][a[`!rel`]]), a;
}
var QK = [[`allowRefreshQuery`, !1, `bool`], [`autoCompressPictures`, !0, `bool`], [`backupFile`, !1, `bool`], [`checkCompatibility`, !1, `bool`], [`CodeName`, ``], [`date1904`, !1, `bool`], [`defaultThemeVersion`, 0, `int`], [`filterPrivacy`, !1, `bool`], [`hidePivotFieldList`, !1, `bool`], [`promptedSolutions`, !1, `bool`], [`publishItems`, !1, `bool`], [`refreshAllConnections`, !1, `bool`], [`saveExternalLinkValues`, !0, `bool`], [`showBorderUnselectedTables`, !0, `bool`], [`showInkAnnotation`, !0, `bool`], [`showObjects`, `all`], [`showPivotChartFilter`, !1, `bool`], [`updateLinks`, `userSet`]],
  $K = [[`activeTab`, 0, `int`], [`autoFilterDateGrouping`, !0, `bool`], [`firstSheet`, 0, `int`], [`minimized`, !1, `bool`], [`showHorizontalScroll`, !0, `bool`], [`showSheetTabs`, !0, `bool`], [`showVerticalScroll`, !0, `bool`], [`tabRatio`, 600, `int`], [`visibility`, `visible`]],
  eq = [],
  tq = [[`calcCompleted`, `true`], [`calcMode`, `auto`], [`calcOnSave`, `true`], [`concurrentCalc`, `true`], [`fullCalcOnLoad`, `false`], [`fullPrecision`, `true`], [`iterate`, `false`], [`iterateCount`, `100`], [`iterateDelta`, `0.001`], [`refMode`, `A1`]];
function nq(e, t) {
  for (var n = 0; n != e.length; ++n) for (var r = e[n], i = 0; i != t.length; ++i) {
    var a = t[i];
    if (r[a[0]] == null) r[a[0]] = a[1];else switch (a[2]) {
      case `bool`:
        typeof r[a[0]] == `string` && (r[a[0]] = AN(r[a[0]]));
        break;
      case `int`:
        typeof r[a[0]] == `string` && (r[a[0]] = parseInt(r[a[0]], 10));
    }
  }
}
function rq(e, t) {
  for (var n = 0; n != t.length; ++n) {
    var r = t[n];
    if (e[r[0]] == null) e[r[0]] = r[1];else switch (r[2]) {
      case `bool`:
        typeof e[r[0]] == `string` && (e[r[0]] = AN(e[r[0]]));
        break;
      case `int`:
        typeof e[r[0]] == `string` && (e[r[0]] = parseInt(e[r[0]], 10));
    }
  }
}
function iq(e) {
  rq(e.WBProps, QK), rq(e.CalcPr, tq), nq(e.WBView, $K), nq(e.Sheets, eq), UW.date1904 = AN(e.WBProps.date1904);
}
function aq(e) {
  return !e.Workbook || !e.Workbook.WBProps ? `false` : AN(e.Workbook.WBProps.date1904) ? `true` : `false`;
}
var oq = `][*?/\\`.split(``);
function sq(e, t) {
  if (e.length > 31) {
    if (t) return !1;
    throw Error(`Sheet names cannot exceed 31 chars`);
  }
  var n = !0;
  return oq.forEach(function (r) {
    if (e.indexOf(r) != -1) {
      if (!t) throw Error(`Sheet name cannot contain : \\ / ? * [ ]`);
      n = !1;
    }
  }), n;
}
function cq(e, t, n) {
  e.forEach(function (r, i) {
    sq(r);
    for (var a = 0; a < i; ++a) if (r == e[a]) throw Error(`Duplicate Sheet Name: ` + r);
    if (n) {
      var o = t && t[i] && t[i].CodeName || r;
      if (o.charCodeAt(0) == 95 && o.length > 22) throw Error(`Bad Code Name: Worksheet` + o);
    }
  });
}
function lq(e) {
  if (!e || !e.SheetNames || !e.Sheets) throw Error(`Invalid Workbook`);
  if (!e.SheetNames.length) throw Error(`Workbook is empty`);
  var t = e.Workbook && e.Workbook.Sheets || [];
  cq(e.SheetNames, t, !!e.vbaraw);
  for (var n = 0; n < e.SheetNames.length; ++n) XW(e.Sheets[e.SheetNames[n]], e.SheetNames[n], n);
}
var uq = /<\w+:workbook/;
function dq(e, t) {
  if (!e) throw Error(`Could not find file`);
  var n = {
      AppVersion: {},
      WBProps: {},
      WBView: [],
      Sheets: [],
      CalcPr: {},
      Names: [],
      xmlns: ``
    },
    r = !1,
    i = `xmlns`,
    a = {},
    o = 0;
  if (e.replace(pN, function (s, c) {
    var l = gN(s);
    switch (_N(l[0])) {
      case `<?xml`:
        break;
      case `<workbook`:
        s.match(uq) && (i = `xmlns` + s.match(/<(\w+):/)[1]), n.xmlns = l[i];
        break;
      case `</workbook>`:
        break;
      case `<fileVersion`:
        delete l[0], n.AppVersion = l;
        break;
      case `<fileVersion/>`:
      case `</fileVersion>`:
        break;
      case `<fileSharing`:
        break;
      case `<fileSharing/>`:
        break;
      case `<workbookPr`:
      case `<workbookPr/>`:
        QK.forEach(function (e) {
          if (l[e[0]] != null) switch (e[2]) {
            case `bool`:
              n.WBProps[e[0]] = AN(l[e[0]]);
              break;
            case `int`:
              n.WBProps[e[0]] = parseInt(l[e[0]], 10);
              break;
            default:
              n.WBProps[e[0]] = l[e[0]];
          }
        }), l.codeName && (n.WBProps.CodeName = FN(l.codeName));
        break;
      case `</workbookPr>`:
        break;
      case `<workbookProtection`:
        break;
      case `<workbookProtection/>`:
        break;
      case `<bookViews`:
      case `<bookViews>`:
      case `</bookViews>`:
        break;
      case `<workbookView`:
      case `<workbookView/>`:
        delete l[0], n.WBView.push(l);
        break;
      case `</workbookView>`:
        break;
      case `<sheets`:
      case `<sheets>`:
      case `</sheets>`:
        break;
      case `<sheet`:
        switch (l.state) {
          case `hidden`:
            l.Hidden = 1;
            break;
          case `veryHidden`:
            l.Hidden = 2;
            break;
          default:
            l.Hidden = 0;
        }
        delete l.state, l.name = bN(FN(l.name)), delete l[0], n.Sheets.push(l);
        break;
      case `</sheet>`:
        break;
      case `<functionGroups`:
      case `<functionGroups/>`:
        break;
      case `<functionGroup`:
        break;
      case `<externalReferences`:
      case `</externalReferences>`:
      case `<externalReferences>`:
        break;
      case `<externalReference`:
        break;
      case `<definedNames/>`:
        break;
      case `<definedNames>`:
      case `<definedNames`:
        r = !0;
        break;
      case `</definedNames>`:
        r = !1;
        break;
      case `<definedName`:
        a = {}, a.Name = FN(l.name), l.comment && (a.Comment = l.comment), l.localSheetId && (a.Sheet = +l.localSheetId), AN(l.hidden || `0`) && (a.Hidden = !0), o = c + s.length;
        break;
      case `</definedName>`:
        a.Ref = bN(FN(e.slice(o, c))), n.Names.push(a);
        break;
      case `<definedName/>`:
        break;
      case `<calcPr`:
        delete l[0], n.CalcPr = l;
        break;
      case `<calcPr/>`:
        delete l[0], n.CalcPr = l;
        break;
      case `</calcPr>`:
        break;
      case `<oleSize`:
        break;
      case `<customWorkbookViews>`:
      case `</customWorkbookViews>`:
      case `<customWorkbookViews`:
        break;
      case `<customWorkbookView`:
      case `</customWorkbookView>`:
        break;
      case `<pivotCaches>`:
      case `</pivotCaches>`:
      case `<pivotCaches`:
        break;
      case `<pivotCache`:
        break;
      case `<smartTagPr`:
      case `<smartTagPr/>`:
        break;
      case `<smartTagTypes`:
      case `<smartTagTypes>`:
      case `</smartTagTypes>`:
        break;
      case `<smartTagType`:
        break;
      case `<webPublishing`:
      case `<webPublishing/>`:
        break;
      case `<fileRecoveryPr`:
      case `<fileRecoveryPr/>`:
        break;
      case `<webPublishObjects>`:
      case `<webPublishObjects`:
      case `</webPublishObjects>`:
        break;
      case `<webPublishObject`:
        break;
      case `<extLst`:
      case `<extLst>`:
      case `</extLst>`:
      case `<extLst/>`:
        break;
      case `<ext`:
        r = !0;
        break;
      case `</ext>`:
        r = !1;
        break;
      case `<ArchID`:
        break;
      case `<AlternateContent`:
      case `<AlternateContent>`:
        r = !0;
        break;
      case `</AlternateContent>`:
        r = !1;
        break;
      case `<revisionPtr`:
        break;
      default:
        if (!r && t.WTF) throw Error(`unrecognized ` + l[0] + ` in workbook`);
    }
    return s;
  }), ZN.indexOf(n.xmlns) === -1) throw Error(`Unknown Namespace: ` + n.xmlns);
  return iq(n), n;
}
function fq(e) {
  var t = [uN];
  t[t.length] = X(`workbook`, null, {
    xmlns: ZN[0],
    "xmlns:r": XN.r
  });
  var n = e.Workbook && (e.Workbook.Names || []).length > 0,
    r = {
      codeName: `ThisWorkbook`
    };
  e.Workbook && e.Workbook.WBProps && (QK.forEach(function (t) {
    e.Workbook.WBProps[t[0]] != null && e.Workbook.WBProps[t[0]] != t[1] && (r[t[0]] = e.Workbook.WBProps[t[0]]);
  }), e.Workbook.WBProps.CodeName && (r.codeName = e.Workbook.WBProps.CodeName, delete r.CodeName)), t[t.length] = X(`workbookPr`, null, r);
  var i = e.Workbook && e.Workbook.Sheets || [],
    a = 0;
  if (i && i[0] && i[0].Hidden) {
    for (t[t.length] = `<bookViews>`, a = 0; a != e.SheetNames.length && i[a] && i[a].Hidden; ++a);
    a == e.SheetNames.length && (a = 0), t[t.length] = `<workbookView firstSheet="` + a + `" activeTab="` + a + `"/>`, t[t.length] = `</bookViews>`;
  }
  for (t[t.length] = `<sheets>`, a = 0; a != e.SheetNames.length; ++a) {
    var o = {
      name: CN(e.SheetNames[a].slice(0, 31))
    };
    if (o.sheetId = `` + (a + 1), o[`r:id`] = `rId` + (a + 1), i[a]) switch (i[a].Hidden) {
      case 1:
        o.state = `hidden`;
        break;
      case 2:
        o.state = `veryHidden`;
    }
    t[t.length] = X(`sheet`, null, o);
  }
  return t[t.length] = `</sheets>`, n && (t[t.length] = `<definedNames>`, e.Workbook && e.Workbook.Names && e.Workbook.Names.forEach(function (e) {
    var n = {
      name: e.Name
    };
    e.Comment && (n.comment = e.Comment), e.Sheet != null && (n.localSheetId = `` + e.Sheet), e.Hidden && (n.hidden = `1`), e.Ref && (t[t.length] = X(`definedName`, CN(e.Ref), n));
  }), t[t.length] = `</definedNames>`), t.length > 2 && (t[t.length] = `</workbook>`, t[1] = t[1].replace(`/>`, `>`)), t.join(``);
}
function pq(e, t) {
  var n = {};
  return n.Hidden = e.read_shift(4), n.iTabID = e.read_shift(4), n.strRelID = DF(e, t - 8), n.name = uF(e), n;
}
function mq(e, t) {
  return t ||= Z(127), t.write_shift(4, e.Hidden), t.write_shift(4, e.iTabID), OF(e.strRelID, t), dF(e.name.slice(0, 31), t), t.length > t.l ? t.slice(0, t.l) : t;
}
function hq(e, t) {
  var n = {},
    r = e.read_shift(4);
  n.defaultThemeVersion = e.read_shift(4);
  var i = t > 8 ? uF(e) : ``;
  return i.length > 0 && (n.CodeName = i), n.autoCompressPictures = !!(r & 65536), n.backupFile = !!(r & 64), n.checkCompatibility = !!(r & 4096), n.date1904 = !!(r & 1), n.filterPrivacy = !!(r & 8), n.hidePivotFieldList = !!(r & 1024), n.promptedSolutions = !!(r & 16), n.publishItems = !!(r & 2048), n.refreshAllConnections = !!(r & 262144), n.saveExternalLinkValues = !!(r & 128), n.showBorderUnselectedTables = !!(r & 4), n.showInkAnnotation = !!(r & 32), n.showObjects = [`all`, `placeholders`, `none`][r >> 13 & 3], n.showPivotChartFilter = !!(r & 32768), n.updateLinks = [`userSet`, `never`, `always`][r >> 8 & 3], n;
}
function gq(e, t) {
  t ||= Z(72);
  var n = 0;
  return e && e.filterPrivacy && (n |= 8), t.write_shift(4, n), t.write_shift(4, 0), CF(e && e.CodeName || `ThisWorkbook`, t), t.slice(0, t.l);
}
function _q(e, t) {
  var n = {};
  return e.read_shift(4), n.ArchID = e.read_shift(4), e.l += t - 8, n;
}
function vq(e, t, n) {
  var r = e.l + t;
  e.l += 4, e.l += 1;
  var i = e.read_shift(4),
    a = EF(e),
    o = NW(e, 0, n),
    s = wF(e);
  e.l = r;
  var c = {
    Name: a,
    Ptg: o
  };
  return i < 268435455 && (c.Sheet = i), s && (c.Comment = s), c;
}
function yq(e, t) {
  var n = {
      AppVersion: {},
      WBProps: {},
      WBView: [],
      Sheets: [],
      CalcPr: {},
      xmlns: ``
    },
    r = [],
    i = !1;
  t ||= {}, t.biff = 12;
  var a = [],
    o = [[]];
  return o.SheetNames = [], o.XTI = [], EJ[16] = {
    n: `BrtFRTArchID$`,
    f: _q
  }, LP(e, function (e, s, c) {
    switch (c) {
      case 156:
        o.SheetNames.push(e.name), n.Sheets.push(e);
        break;
      case 153:
        n.WBProps = e;
        break;
      case 39:
        e.Sheet != null && (t.SID = e.Sheet), e.Ref = xW(e.Ptg, null, null, o, t), delete t.SID, delete e.Ptg, a.push(e);
        break;
      case 1036:
        break;
      case 357:
      case 358:
      case 355:
      case 667:
        o[0].length ? o.push([c, e]) : o[0] = [c, e], o[o.length - 1].XTI = [];
        break;
      case 362:
        o.length === 0 && (o[0] = [], o[0].XTI = []), o[o.length - 1].XTI = o[o.length - 1].XTI.concat(e), o.XTI = o.XTI.concat(e);
        break;
      case 361:
        break;
      case 2071:
      case 158:
      case 143:
      case 664:
      case 353:
        break;
      case 3072:
      case 3073:
      case 534:
      case 677:
      case 157:
      case 610:
      case 2050:
      case 155:
      case 548:
      case 676:
      case 128:
      case 665:
      case 2128:
      case 2125:
      case 549:
      case 2053:
      case 596:
      case 2076:
      case 2075:
      case 2082:
      case 397:
      case 154:
      case 1117:
      case 553:
      case 2091:
        break;
      case 35:
        r.push(c), i = !0;
        break;
      case 36:
        r.pop(), i = !1;
        break;
      case 37:
        r.push(c), i = !0;
        break;
      case 38:
        r.pop(), i = !1;
        break;
      case 16:
        break;
      default:
        if (!s.T && (!i || t.WTF && r[r.length - 1] != 37 && r[r.length - 1] != 35)) throw Error(`Unexpected record 0x` + c.toString(16));
    }
  }, t), iq(n), n.Names = a, n.supbooks = o, n;
}
function bq(e, t) {
  Q(e, 143);
  for (var n = 0; n != t.SheetNames.length; ++n) Q(e, 156, mq({
    Hidden: t.Workbook && t.Workbook.Sheets && t.Workbook.Sheets[n] && t.Workbook.Sheets[n].Hidden || 0,
    iTabID: n + 1,
    strRelID: `rId` + (n + 1),
    name: t.SheetNames[n]
  }));
  Q(e, 144);
}
function xq(e, t) {
  t ||= Z(127);
  for (var n = 0; n != 4; ++n) t.write_shift(4, 0);
  return dF(`SheetJS`, t), dF(DA.version, t), dF(DA.version, t), dF(`7262`, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function Sq(e, t) {
  return t ||= Z(29), t.write_shift(-4, 0), t.write_shift(-4, 460), t.write_shift(4, 28800), t.write_shift(4, 17600), t.write_shift(4, 500), t.write_shift(4, e), t.write_shift(4, e), t.write_shift(1, 120), t.length > t.l ? t.slice(0, t.l) : t;
}
function Cq(e, t) {
  if (t.Workbook && t.Workbook.Sheets) {
    for (var n = t.Workbook.Sheets, r = 0, i = -1, a = -1; r < n.length; ++r) !n[r] || !n[r].Hidden && i == -1 ? i = r : n[r].Hidden == 1 && a == -1 && (a = r);
    a > i || (Q(e, 135), Q(e, 158, Sq(i)), Q(e, 136));
  }
}
function wq(e, t) {
  var n = RP();
  return Q(n, 131), Q(n, 128, xq()), Q(n, 153, gq(e.Workbook && e.Workbook.WBProps || null)), Cq(n, e, t), bq(n, e, t), Q(n, 132), n.end();
}
function Tq(e, t, n) {
  return t.slice(-4) === `.bin` ? yq(e, n) : dq(e, n);
}
function Eq(e, t, n, r, i, a, o, s) {
  return t.slice(-4) === `.bin` ? FK(e, r, n, i, a, o, s) : cG(e, r, n, i, a, o, s);
}
function Dq(e, t, n, r, i, a, o, s) {
  return t.slice(-4) === `.bin` ? ZK(e, r, n, i, a, o, s) : YK(e, r, n, i, a, o, s);
}
function Oq(e, t, n, r, i, a, o, s) {
  return t.slice(-4) === `.bin` ? RH(e, r, n, i, a, o, s) : zH(e, r, n, i, a, o, s);
}
function kq(e, t, n, r, i, a, o, s) {
  return t.slice(-4) === `.bin` ? IH(e, r, n, i, a, o, s) : LH(e, r, n, i, a, o, s);
}
function Aq(e, t, n, r) {
  return t.slice(-4) === `.bin` ? TV(e, n, r) : cV(e, n, r);
}
function jq(e, t, n) {
  return GV(e, n);
}
function Mq(e, t, n) {
  return t.slice(-4) === `.bin` ? oB(e, n) : nB(e, n);
}
function Nq(e, t, n) {
  return t.slice(-4) === `.bin` ? AH(e, n) : bH(e, n);
}
function Pq(e, t, n) {
  return t.slice(-4) === `.bin` ? mH(e, t, n) : fH(e, t, n);
}
function Fq(e, t, n, r) {
  if (n.slice(-4) === `.bin`) return hH(e, t, n, r);
}
function Iq(e, t, n) {
  return t.slice(-4) === `.bin` ? cH(e, t, n) : uH(e, t, n);
}
function Lq(e, t, n) {
  return (t.slice(-4) === `.bin` ? wq : fq)(e, n);
}
function Rq(e, t, n, r, i) {
  return (t.slice(-4) === `.bin` ? KK : kG)(e, n, r, i);
}
function zq(e, t, n) {
  return (t.slice(-4) === `.bin` ? FV : lV)(e, n);
}
function Bq(e, t, n) {
  return (t.slice(-4) === `.bin` ? lB : iB)(e, n);
}
function Vq(e, t, n) {
  return (t.slice(-4) === `.bin` ? jH : xH)(e, n);
}
function Hq(e) {
  return (e.slice(-4) === `.bin` ? lH : dH)();
}
var Uq = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g,
  Wq = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function Gq(e, t) {
  var n = e.split(/\s+/),
    r = [];
  if (t || (r[0] = n[0]), n.length === 1) return r;
  var i = e.match(Uq),
    a,
    o,
    s,
    c;
  if (i) for (c = 0; c != i.length; ++c) a = i[c].match(Wq), (o = a[1].indexOf(`:`)) === -1 ? r[a[1]] = a[2].slice(1, a[2].length - 1) : (s = a[1].slice(0, 6) === `xmlns:` ? `xmlns` + a[1].slice(6) : a[1].slice(o + 1), r[s] = a[2].slice(1, a[2].length - 1));
  return r;
}
function Kq(e) {
  var t = e.split(/\s+/),
    n = {};
  if (t.length === 1) return n;
  var r = e.match(Uq),
    i,
    a,
    o,
    s;
  if (r) for (s = 0; s != r.length; ++s) i = r[s].match(Wq), (a = i[1].indexOf(`:`)) === -1 ? n[i[1]] = i[2].slice(1, i[2].length - 1) : (o = i[1].slice(0, 6) === `xmlns:` ? `xmlns` + i[1].slice(6) : i[1].slice(a + 1), n[o] = i[2].slice(1, i[2].length - 1));
  return n;
}
var qq;
function Jq(e, t) {
  var n = qq[e] || bN(e);
  return n === `General` ? Pj(t) : fM(n, t);
}
function Yq(e, t, n, r) {
  var i = r;
  switch ((n[0].match(/dt:dt="([\w.]+)"/) || [``, ``])[1]) {
    case `boolean`:
      i = AN(r);
      break;
    case `i2`:
    case `int`:
      i = parseInt(r, 10);
      break;
    case `r4`:
    case `float`:
      i = parseFloat(r);
      break;
    case `date`:
    case `dateTime.tz`:
      i = UM(r);
      break;
    case `i8`:
    case `string`:
    case `fixed`:
    case `uuid`:
    case `bin.base64`:
      break;
    default:
      throw Error(`bad custprop:` + n[0]);
  }
  e[bN(t)] = i;
}
function Xq(e, t, n) {
  if (e.t !== `z`) {
    if (!n || n.cellText !== !1) try {
      e.w = e.t === `e` ? e.w || lI[e.v] : t === `General` ? e.t === `n` ? (e.v | 0) === e.v ? e.v.toString(10) : Nj(e.v) : Pj(e.v) : Jq(t || `General`, e.v);
    } catch (e) {
      if (n.WTF) throw e;
    }
    try {
      var r = qq[t] || t || `General`;
      if (n.cellNF && (e.z = r), n.cellDates && e.t == `n` && sM(r)) {
        var i = wj(e.v);
        i && (e.t = `d`, e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u));
      }
    } catch (e) {
      if (n.WTF) throw e;
    }
  }
}
function Zq(e, t, n) {
  if (n.cellStyles && t.Interior) {
    var r = t.Interior;
    r.Pattern && (r.patternType = QB[r.Pattern] || r.Pattern);
  }
  e[t.ID] = t;
}
function Qq(e, t, n, r, i, a, o, s, c, l) {
  var u = `General`,
    d = r.StyleID,
    f = {};
  l ||= {};
  var p = [],
    m = 0;
  for (d === void 0 && s && (d = s.StyleID), d === void 0 && o && (d = o.StyleID); a[d] !== void 0 && (a[d].nf && (u = a[d].nf), a[d].Interior && p.push(a[d].Interior), a[d].Parent);) d = a[d].Parent;
  switch (n.Type) {
    case `Boolean`:
      r.t = `b`, r.v = AN(e);
      break;
    case `String`:
      r.t = `s`, r.r = ON(bN(e)), r.v = e.indexOf(`<`) > -1 ? bN(t || e).replace(/<.*?>/g, ``) : r.r;
      break;
    case `DateTime`:
      e.slice(-1) != `Z` && (e += `Z`), r.v = (UM(e) - new Date(Date.UTC(1899, 11, 30))) / 864e5, r.v === r.v ? r.v < 60 && --r.v : r.v = bN(e), (!u || u == `General`) && (u = `yyyy-mm-dd`);
    case `Number`:
      r.v === void 0 && (r.v = +e), r.t ||= `n`;
      break;
    case `Error`:
      r.t = `e`, r.v = uI[e], l.cellText !== !1 && (r.w = e);
      break;
    default:
      e == `` && t == `` ? r.t = `z` : (r.t = `s`, r.v = ON(t || e));
  }
  if (Xq(r, u, l), l.cellFormula !== !1) {
    if (r.Formula) {
      var h = bN(r.Formula);
      h.charCodeAt(0) == 61 && (h = h.slice(1)), r.f = BH(h, i), delete r.Formula, r.ArrayRange == `RC` ? r.F = BH(`RC:RC`, i) : r.ArrayRange && (r.F = BH(r.ArrayRange, i), c.push([nF(r.F), r.F]));
    } else for (m = 0; m < c.length; ++m) i.r >= c[m][0].s.r && i.r <= c[m][0].e.r && i.c >= c[m][0].s.c && i.c <= c[m][0].e.c && (r.F = c[m][1]);
  }
  l.cellStyles && (p.forEach(function (e) {
    !f.patternType && e.patternType && (f.patternType = e.patternType);
  }), r.s = f), r.StyleID !== void 0 && (r.ixfe = r.StyleID);
}
function $q(e) {
  e.t = e.v || ``, e.t = e.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), e.v = e.w = e.ixfe = void 0;
}
function eJ(e, t) {
  var n = t || {};
  hM();
  var r = zA(JN(e));
  (n.type == `binary` || n.type == `array` || n.type == `base64`) && (r = HA === void 0 ? FN(r) : HA.utils.decode(65001, IA(r)));
  var i = r.slice(0, 1024).toLowerCase(),
    a = !1;
  if (i = i.replace(/".*?"/g, ``), (i.indexOf(`>`) & 1023) > Math.min(i.indexOf(`,`) & 1023, i.indexOf(`;`) & 1023)) {
    var o = GM(n);
    return o.type = `string`, Uz.to_workbook(r, o);
  }
  if (i.indexOf(`<?xml`) == -1 && [`html`, `table`, `head`, `meta`, `script`, `style`, `div`].forEach(function (e) {
    i.indexOf(`<` + e) >= 0 && (a = !0);
  }), a) return ZJ(r, n);
  qq = {
    "General Number": `General`,
    "General Date": bj[22],
    "Long Date": `dddd, mmmm dd, yyyy`,
    "Medium Date": bj[15],
    "Short Date": bj[14],
    "Long Time": bj[19],
    "Medium Time": bj[18],
    "Short Time": bj[20],
    Currency: `"$"#,##0.00_);[Red]\\("$"#,##0.00\\)`,
    Fixed: bj[2],
    Standard: bj[4],
    Percent: bj[10],
    Scientific: bj[11],
    "Yes/No": `"Yes";"Yes";"No";@`,
    "True/False": `"True";"True";"False";@`,
    "On/Off": `"Yes";"Yes";"No";@`
  };
  var s,
    c = [],
    l;
  WA != null && n.dense == null && (n.dense = WA);
  var u = {},
    d = [],
    f = n.dense ? [] : {},
    p = ``,
    m = {},
    h = {},
    g = Gq(`<Data ss:Type="String">`),
    _ = 0,
    v = 0,
    y = 0,
    b = {
      s: {
        r: 2e6,
        c: 2e6
      },
      e: {
        r: 0,
        c: 0
      }
    },
    x = {},
    S = {},
    C = ``,
    w = 0,
    T = [],
    E = {},
    D = {},
    O = 0,
    k = [],
    A = [],
    j = {},
    M = [],
    N,
    P = !1,
    F = [],
    I = [],
    L = {},
    R = 0,
    z = 0,
    ee = {
      Sheets: [],
      WBProps: {
        date1904: !1
      }
    },
    te = {};
  YN.lastIndex = 0, r = r.replace(/<!--([\s\S]*?)-->/gm, ``);
  for (var B = ``; s = YN.exec(r);) switch (s[3] = (B = s[3]).toLowerCase()) {
    case `data`:
      if (B == `data`) {
        if (s[1] === `/`) {
          if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
        } else s[0].charAt(s[0].length - 2) !== `/` && c.push([s[3], !0]);
        break;
      }
      if (c[c.length - 1][1]) break;
      s[1] === `/` ? Qq(r.slice(_, s.index), C, g, c[c.length - 1][0] == `comment` ? j : m, {
        c: v,
        r: y
      }, x, M[v], h, F, n) : (C = ``, g = Gq(s[0]), _ = s.index + s[0].length);
      break;
    case `cell`:
      if (s[1] === `/`) {
        if (A.length > 0 && (m.c = A), (!n.sheetRows || n.sheetRows > y) && m.v !== void 0 && (n.dense ? (f[y] || (f[y] = []), f[y][v] = m) : f[JP(v) + WP(y)] = m), m.HRef && (m.l = {
          Target: bN(m.HRef)
        }, m.HRefScreenTip && (m.l.Tooltip = m.HRefScreenTip), delete m.HRef, delete m.HRefScreenTip), (m.MergeAcross || m.MergeDown) && (R = v + (parseInt(m.MergeAcross, 10) | 0), z = y + (parseInt(m.MergeDown, 10) | 0), T.push({
          s: {
            c: v,
            r: y
          },
          e: {
            c: R,
            r: z
          }
        })), !n.sheetStubs) m.MergeAcross ? v = R + 1 : ++v;else if (m.MergeAcross || m.MergeDown) {
          for (var V = v; V <= R; ++V) for (var H = y; H <= z; ++H) (V > v || H > y) && (n.dense ? (f[H] || (f[H] = []), f[H][V] = {
            t: `z`
          }) : f[JP(V) + WP(H)] = {
            t: `z`
          });
          v = R + 1;
        } else ++v;
      } else m = Kq(s[0]), m.Index && (v = m.Index - 1), v < b.s.c && (b.s.c = v), v > b.e.c && (b.e.c = v), s[0].slice(-2) === `/>` && ++v, A = [];
      break;
    case `row`:
      s[1] === `/` || s[0].slice(-2) === `/>` ? (y < b.s.r && (b.s.r = y), y > b.e.r && (b.e.r = y), s[0].slice(-2) === `/>` && (h = Gq(s[0]), h.Index && (y = h.Index - 1)), v = 0, ++y) : (h = Gq(s[0]), h.Index && (y = h.Index - 1), L = {}, (h.AutoFitHeight == `0` || h.Height) && (L.hpx = parseInt(h.Height, 10), L.hpt = XB(L.hpx), I[y] = L), h.Hidden == `1` && (L.hidden = !0, I[y] = L));
      break;
    case `worksheet`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
        d.push(p), b.s.r <= b.e.r && b.s.c <= b.e.c && (f[`!ref`] = tF(b), n.sheetRows && n.sheetRows <= b.e.r && (f[`!fullref`] = f[`!ref`], b.e.r = n.sheetRows - 1, f[`!ref`] = tF(b))), T.length && (f[`!merges`] = T), M.length > 0 && (f[`!cols`] = M), I.length > 0 && (f[`!rows`] = I), u[p] = f;
      } else b = {
        s: {
          r: 2e6,
          c: 2e6
        },
        e: {
          r: 0,
          c: 0
        }
      }, y = v = 0, c.push([s[3], !1]), l = Gq(s[0]), p = bN(l.Name), f = n.dense ? [] : {}, T = [], F = [], I = [], te = {
        name: p,
        Hidden: 0
      }, ee.Sheets.push(te);
      break;
    case `table`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
      } else if (s[0].slice(-2) == `/>`) break;else c.push([s[3], !1]), M = [], P = !1;
      break;
    case `style`:
      s[1] === `/` ? Zq(x, S, n) : S = Gq(s[0]);
      break;
    case `numberformat`:
      S.nf = bN(Gq(s[0]).Format || `General`), qq[S.nf] && (S.nf = qq[S.nf]);
      for (var ne = 0; ne != 392 && bj[ne] != S.nf; ++ne);
      if (ne == 392) {
        for (ne = 57; ne != 392; ++ne) if (bj[ne] == null) {
          pM(S.nf, ne);
          break;
        }
      }
      break;
    case `column`:
      if (c[c.length - 1][0] !== `table`) break;
      if (N = Gq(s[0]), N.Hidden && (N.hidden = !0, delete N.Hidden), N.Width && (N.wpx = parseInt(N.Width, 10)), !P && N.wpx > 10) {
        P = !0, HB = zB;
        for (var re = 0; re < M.length; ++re) M[re] && JB(M[re]);
      }
      P && JB(N), M[N.Index - 1 || M.length] = N;
      for (var ie = 0; ie < +N.Span; ++ie) M[M.length] = GM(N);
      break;
    case `namedrange`:
      if (s[1] === `/`) break;
      ee.Names ||= [];
      var U = gN(s[0]),
        ae = {
          Name: U.Name,
          Ref: BH(U.RefersTo.slice(1), {
            r: 0,
            c: 0
          })
        };
      ee.Sheets.length > 0 && (ae.Sheet = ee.Sheets.length - 1), ee.Names.push(ae);
      break;
    case `namedcell`:
      break;
    case `b`:
      break;
    case `i`:
      break;
    case `u`:
      break;
    case `s`:
      break;
    case `em`:
      break;
    case `h2`:
      break;
    case `h3`:
      break;
    case `sub`:
      break;
    case `sup`:
      break;
    case `span`:
      break;
    case `alignment`:
      break;
    case `borders`:
      break;
    case `border`:
      break;
    case `font`:
      if (s[0].slice(-2) === `/>`) break;
      s[1] === `/` ? C += r.slice(w, s.index) : w = s.index + s[0].length;
      break;
    case `interior`:
      if (!n.cellStyles) break;
      S.Interior = Gq(s[0]);
      break;
    case `protection`:
      break;
    case `author`:
    case `title`:
    case `description`:
    case `created`:
    case `keywords`:
    case `subject`:
    case `category`:
    case `company`:
    case `lastauthor`:
    case `lastsaved`:
    case `lastprinted`:
    case `version`:
    case `revision`:
    case `totaltime`:
    case `hyperlinkbase`:
    case `manager`:
    case `contentstatus`:
    case `identifier`:
    case `language`:
    case `appname`:
      if (s[0].slice(-2) === `/>`) break;
      s[1] === `/` ? UI(E, B, r.slice(O, s.index)) : O = s.index + s[0].length;
      break;
    case `paragraphs`:
      break;
    case `styles`:
    case `workbook`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
      } else c.push([s[3], !1]);
      break;
    case `comment`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
        $q(j), A.push(j);
      } else c.push([s[3], !1]), l = Gq(s[0]), j = {
        a: l.Author
      };
      break;
    case `autofilter`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
      } else if (s[0].charAt(s[0].length - 2) !== `/`) {
        var oe = Gq(s[0]);
        f[`!autofilter`] = {
          ref: BH(oe.Range).replace(/\$/g, ``)
        }, c.push([s[3], !0]);
      }
      break;
    case `name`:
      break;
    case `datavalidation`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
      } else s[0].charAt(s[0].length - 2) !== `/` && c.push([s[3], !0]);
      break;
    case `pixelsperinch`:
      break;
    case `componentoptions`:
    case `documentproperties`:
    case `customdocumentproperties`:
    case `officedocumentsettings`:
    case `pivottable`:
    case `pivotcache`:
    case `names`:
    case `mapinfo`:
    case `pagebreaks`:
    case `querytable`:
    case `sorting`:
    case `schema`:
    case `conditionalformatting`:
    case `smarttagtype`:
    case `smarttags`:
    case `excelworkbook`:
    case `workbookoptions`:
    case `worksheetoptions`:
      if (s[1] === `/`) {
        if ((l = c.pop())[0] !== s[3]) throw Error(`Bad state: ` + l.join(`|`));
      } else s[0].charAt(s[0].length - 2) !== `/` && c.push([s[3], !0]);
      break;
    case `null`:
      break;
    default:
      if (c.length == 0 && s[3] == `document` || c.length == 0 && s[3] == `uof`) return lY(r, n);
      var se = !0;
      switch (c[c.length - 1][0]) {
        case `officedocumentsettings`:
          switch (s[3]) {
            case `allowpng`:
              break;
            case `removepersonalinformation`:
              break;
            case `downloadcomponents`:
              break;
            case `locationofcomponents`:
              break;
            case `colors`:
              break;
            case `color`:
              break;
            case `index`:
              break;
            case `rgb`:
              break;
            case `targetscreensize`:
              break;
            case `readonlyrecommended`:
              break;
            default:
              se = !1;
          }
          break;
        case `componentoptions`:
          switch (s[3]) {
            case `toolbar`:
              break;
            case `hideofficelogo`:
              break;
            case `spreadsheetautofit`:
              break;
            case `label`:
              break;
            case `caption`:
              break;
            case `maxheight`:
              break;
            case `maxwidth`:
              break;
            case `nextsheetnumber`:
              break;
            default:
              se = !1;
          }
          break;
        case `excelworkbook`:
          switch (s[3]) {
            case `date1904`:
              ee.WBProps.date1904 = !0;
              break;
            case `windowheight`:
              break;
            case `windowwidth`:
              break;
            case `windowtopx`:
              break;
            case `windowtopy`:
              break;
            case `tabratio`:
              break;
            case `protectstructure`:
              break;
            case `protectwindow`:
              break;
            case `protectwindows`:
              break;
            case `activesheet`:
              break;
            case `displayinknotes`:
              break;
            case `firstvisiblesheet`:
              break;
            case `supbook`:
              break;
            case `sheetname`:
              break;
            case `sheetindex`:
              break;
            case `sheetindexfirst`:
              break;
            case `sheetindexlast`:
              break;
            case `dll`:
              break;
            case `acceptlabelsinformulas`:
              break;
            case `donotsavelinkvalues`:
              break;
            case `iteration`:
              break;
            case `maxiterations`:
              break;
            case `maxchange`:
              break;
            case `path`:
              break;
            case `xct`:
              break;
            case `count`:
              break;
            case `selectedsheets`:
              break;
            case `calculation`:
              break;
            case `uncalced`:
              break;
            case `startupprompt`:
              break;
            case `crn`:
              break;
            case `externname`:
              break;
            case `formula`:
              break;
            case `colfirst`:
              break;
            case `collast`:
              break;
            case `wantadvise`:
              break;
            case `boolean`:
              break;
            case `error`:
              break;
            case `text`:
              break;
            case `ole`:
              break;
            case `noautorecover`:
              break;
            case `publishobjects`:
              break;
            case `donotcalculatebeforesave`:
              break;
            case `number`:
              break;
            case `refmoder1c1`:
              break;
            case `embedsavesmarttags`:
              break;
            default:
              se = !1;
          }
          break;
        case `workbookoptions`:
          switch (s[3]) {
            case `owcversion`:
              break;
            case `height`:
              break;
            case `width`:
              break;
            default:
              se = !1;
          }
          break;
        case `worksheetoptions`:
          switch (s[3]) {
            case `visible`:
              if (s[0].slice(-2) !== `/>`) {
                if (s[1] === `/`) switch (r.slice(O, s.index)) {
                  case `SheetHidden`:
                    te.Hidden = 1;
                    break;
                  case `SheetVeryHidden`:
                    te.Hidden = 2;
                } else O = s.index + s[0].length;
              }
              break;
            case `header`:
              f[`!margins`] || qW(f[`!margins`] = {}, `xlml`), isNaN(+gN(s[0]).Margin) || (f[`!margins`].header = +gN(s[0]).Margin);
              break;
            case `footer`:
              f[`!margins`] || qW(f[`!margins`] = {}, `xlml`), isNaN(+gN(s[0]).Margin) || (f[`!margins`].footer = +gN(s[0]).Margin);
              break;
            case `pagemargins`:
              var ce = gN(s[0]);
              f[`!margins`] || qW(f[`!margins`] = {}, `xlml`), isNaN(+ce.Top) || (f[`!margins`].top = +ce.Top), isNaN(+ce.Left) || (f[`!margins`].left = +ce.Left), isNaN(+ce.Right) || (f[`!margins`].right = +ce.Right), isNaN(+ce.Bottom) || (f[`!margins`].bottom = +ce.Bottom);
              break;
            case `displayrighttoleft`:
              ee.Views ||= [], ee.Views[0] || (ee.Views[0] = {}), ee.Views[0].RTL = !0;
              break;
            case `freezepanes`:
              break;
            case `frozennosplit`:
              break;
            case `splithorizontal`:
            case `splitvertical`:
              break;
            case `donotdisplaygridlines`:
              break;
            case `activerow`:
              break;
            case `activecol`:
              break;
            case `toprowbottompane`:
              break;
            case `leftcolumnrightpane`:
              break;
            case `unsynced`:
              break;
            case `print`:
              break;
            case `printerrors`:
              break;
            case `panes`:
              break;
            case `scale`:
              break;
            case `pane`:
              break;
            case `number`:
              break;
            case `layout`:
              break;
            case `pagesetup`:
              break;
            case `selected`:
              break;
            case `protectobjects`:
              break;
            case `enableselection`:
              break;
            case `protectscenarios`:
              break;
            case `validprinterinfo`:
              break;
            case `horizontalresolution`:
              break;
            case `verticalresolution`:
              break;
            case `numberofcopies`:
              break;
            case `activepane`:
              break;
            case `toprowvisible`:
              break;
            case `leftcolumnvisible`:
              break;
            case `fittopage`:
              break;
            case `rangeselection`:
              break;
            case `papersizeindex`:
              break;
            case `pagelayoutzoom`:
              break;
            case `pagebreakzoom`:
              break;
            case `filteron`:
              break;
            case `fitwidth`:
              break;
            case `fitheight`:
              break;
            case `commentslayout`:
              break;
            case `zoom`:
              break;
            case `lefttoright`:
              break;
            case `gridlines`:
              break;
            case `allowsort`:
              break;
            case `allowfilter`:
              break;
            case `allowinsertrows`:
              break;
            case `allowdeleterows`:
              break;
            case `allowinsertcols`:
              break;
            case `allowdeletecols`:
              break;
            case `allowinserthyperlinks`:
              break;
            case `allowformatcells`:
              break;
            case `allowsizecols`:
              break;
            case `allowsizerows`:
              break;
            case `nosummaryrowsbelowdetail`:
              f[`!outline`] || (f[`!outline`] = {}), f[`!outline`].above = !0;
              break;
            case `tabcolorindex`:
              break;
            case `donotdisplayheadings`:
              break;
            case `showpagelayoutzoom`:
              break;
            case `nosummarycolumnsrightdetail`:
              f[`!outline`] || (f[`!outline`] = {}), f[`!outline`].left = !0;
              break;
            case `blackandwhite`:
              break;
            case `donotdisplayzeros`:
              break;
            case `displaypagebreak`:
              break;
            case `rowcolheadings`:
              break;
            case `donotdisplayoutline`:
              break;
            case `noorientation`:
              break;
            case `allowusepivottables`:
              break;
            case `zeroheight`:
              break;
            case `viewablerange`:
              break;
            case `selection`:
              break;
            case `protectcontents`:
              break;
            default:
              se = !1;
          }
          break;
        case `pivottable`:
        case `pivotcache`:
          switch (s[3]) {
            case `immediateitemsondrop`:
              break;
            case `showpagemultipleitemlabel`:
              break;
            case `compactrowindent`:
              break;
            case `location`:
              break;
            case `pivotfield`:
              break;
            case `orientation`:
              break;
            case `layoutform`:
              break;
            case `layoutsubtotallocation`:
              break;
            case `layoutcompactrow`:
              break;
            case `position`:
              break;
            case `pivotitem`:
              break;
            case `datatype`:
              break;
            case `datafield`:
              break;
            case `sourcename`:
              break;
            case `parentfield`:
              break;
            case `ptlineitems`:
              break;
            case `ptlineitem`:
              break;
            case `countofsameitems`:
              break;
            case `item`:
              break;
            case `itemtype`:
              break;
            case `ptsource`:
              break;
            case `cacheindex`:
              break;
            case `consolidationreference`:
              break;
            case `filename`:
              break;
            case `reference`:
              break;
            case `nocolumngrand`:
              break;
            case `norowgrand`:
              break;
            case `blanklineafteritems`:
              break;
            case `hidden`:
              break;
            case `subtotal`:
              break;
            case `basefield`:
              break;
            case `mapchilditems`:
              break;
            case `function`:
              break;
            case `refreshonfileopen`:
              break;
            case `printsettitles`:
              break;
            case `mergelabels`:
              break;
            case `defaultversion`:
              break;
            case `refreshname`:
              break;
            case `refreshdate`:
              break;
            case `refreshdatecopy`:
              break;
            case `versionlastrefresh`:
              break;
            case `versionlastupdate`:
              break;
            case `versionupdateablemin`:
              break;
            case `versionrefreshablemin`:
              break;
            case `calculation`:
              break;
            default:
              se = !1;
          }
          break;
        case `pagebreaks`:
          switch (s[3]) {
            case `colbreaks`:
              break;
            case `colbreak`:
              break;
            case `rowbreaks`:
              break;
            case `rowbreak`:
              break;
            case `colstart`:
              break;
            case `colend`:
              break;
            case `rowend`:
              break;
            default:
              se = !1;
          }
          break;
        case `autofilter`:
          switch (s[3]) {
            case `autofiltercolumn`:
              break;
            case `autofiltercondition`:
              break;
            case `autofilterand`:
              break;
            case `autofilteror`:
              break;
            default:
              se = !1;
          }
          break;
        case `querytable`:
          switch (s[3]) {
            case `id`:
              break;
            case `autoformatfont`:
              break;
            case `autoformatpattern`:
              break;
            case `querysource`:
              break;
            case `querytype`:
              break;
            case `enableredirections`:
              break;
            case `refreshedinxl9`:
              break;
            case `urlstring`:
              break;
            case `htmltables`:
              break;
            case `connection`:
              break;
            case `commandtext`:
              break;
            case `refreshinfo`:
              break;
            case `notitles`:
              break;
            case `nextid`:
              break;
            case `columninfo`:
              break;
            case `overwritecells`:
              break;
            case `donotpromptforfile`:
              break;
            case `textwizardsettings`:
              break;
            case `source`:
              break;
            case `number`:
              break;
            case `decimal`:
              break;
            case `thousandseparator`:
              break;
            case `trailingminusnumbers`:
              break;
            case `formatsettings`:
              break;
            case `fieldtype`:
              break;
            case `delimiters`:
              break;
            case `tab`:
              break;
            case `comma`:
              break;
            case `autoformatname`:
              break;
            case `versionlastedit`:
              break;
            case `versionlastrefresh`:
              break;
            default:
              se = !1;
          }
          break;
        case `datavalidation`:
          switch (s[3]) {
            case `range`:
              break;
            case `type`:
              break;
            case `min`:
              break;
            case `max`:
              break;
            case `sort`:
              break;
            case `descending`:
              break;
            case `order`:
              break;
            case `casesensitive`:
              break;
            case `value`:
              break;
            case `errorstyle`:
              break;
            case `errormessage`:
              break;
            case `errortitle`:
              break;
            case `inputmessage`:
              break;
            case `inputtitle`:
              break;
            case `combohide`:
              break;
            case `inputhide`:
              break;
            case `condition`:
              break;
            case `qualifier`:
              break;
            case `useblank`:
              break;
            case `value1`:
              break;
            case `value2`:
              break;
            case `format`:
              break;
            case `cellrangelist`:
              break;
            default:
              se = !1;
          }
          break;
        case `sorting`:
        case `conditionalformatting`:
          switch (s[3]) {
            case `range`:
              break;
            case `type`:
              break;
            case `min`:
              break;
            case `max`:
              break;
            case `sort`:
              break;
            case `descending`:
              break;
            case `order`:
              break;
            case `casesensitive`:
              break;
            case `value`:
              break;
            case `errorstyle`:
              break;
            case `errormessage`:
              break;
            case `errortitle`:
              break;
            case `cellrangelist`:
              break;
            case `inputmessage`:
              break;
            case `inputtitle`:
              break;
            case `combohide`:
              break;
            case `inputhide`:
              break;
            case `condition`:
              break;
            case `qualifier`:
              break;
            case `useblank`:
              break;
            case `value1`:
              break;
            case `value2`:
              break;
            case `format`:
              break;
            default:
              se = !1;
          }
          break;
        case `mapinfo`:
        case `schema`:
        case `data`:
          switch (s[3]) {
            case `map`:
              break;
            case `entry`:
              break;
            case `range`:
              break;
            case `xpath`:
              break;
            case `field`:
              break;
            case `xsdtype`:
              break;
            case `filteron`:
              break;
            case `aggregate`:
              break;
            case `elementtype`:
              break;
            case `attributetype`:
              break;
            case `schema`:
            case `element`:
            case `complextype`:
            case `datatype`:
            case `all`:
            case `attribute`:
            case `extends`:
              break;
            case `row`:
              break;
            default:
              se = !1;
          }
          break;
        case `smarttags`:
          break;
        default:
          se = !1;
      }
      if (se || s[3].match(/!\[CDATA/)) break;
      if (!c[c.length - 1][1]) throw `Unrecognized tag: ` + s[3] + `|` + c.join(`|`);
      if (c[c.length - 1][0] === `customdocumentproperties`) {
        if (s[0].slice(-2) === `/>`) break;
        s[1] === `/` ? Yq(D, B, k, r.slice(O, s.index)) : (k = s, O = s.index + s[0].length);
        break;
      }
      if (n.WTF) throw `Unrecognized tag: ` + s[3] + `|` + c.join(`|`);
  }
  var le = {};
  return !n.bookSheets && !n.bookProps && (le.Sheets = u), le.SheetNames = d, le.Workbook = ee, le.SSF = GM(bj), le.Props = E, le.Custprops = D, le;
}
function tJ(e, t) {
  switch (YY(t ||= {}), t.type || `base64`) {
    case `base64`:
      return eJ(JA(e), t);
    case `binary`:
    case `buffer`:
    case `file`:
      return eJ(e, t);
    case `array`:
      return eJ(tj(e), t);
  }
}
function nJ(e, t) {
  var n = [];
  return e.Props && n.push(WI(e.Props, t)), e.Custprops && n.push(GI(e.Props, e.Custprops, t)), n.join(``);
}
function rJ() {
  return ``;
}
function iJ(e, t) {
  var n = [`<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>`];
  return t.cellXfs.forEach(function (e, t) {
    var r = [];
    r.push(X(`NumberFormat`, null, {
      "ss:Format": CN(bj[e.numFmtId])
    }));
    var i = {
      "ss:ID": `s` + (21 + t)
    };
    n.push(X(`Style`, r.join(``), i));
  }), X(`Styles`, n.join(``));
}
function aJ(e) {
  return X(`NamedRange`, null, {
    "ss:Name": e.Name,
    "ss:RefersTo": `=` + HH(e.Ref, {
      r: 0,
      c: 0
    })
  });
}
function oJ(e) {
  if (!((e || {}).Workbook || {}).Names) return ``;
  for (var t = e.Workbook.Names, n = [], r = 0; r < t.length; ++r) {
    var i = t[r];
    i.Sheet ?? (i.Name.match(/^_xlfn\./) || n.push(aJ(i)));
  }
  return X(`Names`, n.join(``));
}
function sJ(e, t, n, r) {
  if (!e || !((r || {}).Workbook || {}).Names) return ``;
  for (var i = r.Workbook.Names, a = [], o = 0; o < i.length; ++o) {
    var s = i[o];
    s.Sheet == n && (s.Name.match(/^_xlfn\./) || a.push(aJ(s)));
  }
  return a.join(``);
}
function cJ(e, t, n, r) {
  if (!e) return ``;
  var i = [];
  if (e[`!margins`] && (i.push(`<PageSetup>`), e[`!margins`].header && i.push(X(`Header`, null, {
    "x:Margin": e[`!margins`].header
  })), e[`!margins`].footer && i.push(X(`Footer`, null, {
    "x:Margin": e[`!margins`].footer
  })), i.push(X(`PageMargins`, null, {
    "x:Bottom": e[`!margins`].bottom || `0.75`,
    "x:Left": e[`!margins`].left || `0.7`,
    "x:Right": e[`!margins`].right || `0.7`,
    "x:Top": e[`!margins`].top || `0.75`
  })), i.push(`</PageSetup>`)), r && r.Workbook && r.Workbook.Sheets && r.Workbook.Sheets[n]) {
    if (r.Workbook.Sheets[n].Hidden) i.push(X(`Visible`, r.Workbook.Sheets[n].Hidden == 1 ? `SheetHidden` : `SheetVeryHidden`, {}));else {
      for (var a = 0; a < n && (!r.Workbook.Sheets[a] || r.Workbook.Sheets[a].Hidden); ++a);
      a == n && i.push(`<Selected/>`);
    }
  }
  return ((((r || {}).Workbook || {}).Views || [])[0] || {}).RTL && i.push(`<DisplayRightToLeft/>`), e[`!protect`] && (i.push(WN(`ProtectContents`, `True`)), e[`!protect`].objects && i.push(WN(`ProtectObjects`, `True`)), e[`!protect`].scenarios && i.push(WN(`ProtectScenarios`, `True`)), e[`!protect`].selectLockedCells != null && !e[`!protect`].selectLockedCells ? i.push(WN(`EnableSelection`, `NoSelection`)) : e[`!protect`].selectUnlockedCells != null && !e[`!protect`].selectUnlockedCells && i.push(WN(`EnableSelection`, `UnlockedCells`)), [[`formatCells`, `AllowFormatCells`], [`formatColumns`, `AllowSizeCols`], [`formatRows`, `AllowSizeRows`], [`insertColumns`, `AllowInsertCols`], [`insertRows`, `AllowInsertRows`], [`insertHyperlinks`, `AllowInsertHyperlinks`], [`deleteColumns`, `AllowDeleteCols`], [`deleteRows`, `AllowDeleteRows`], [`sort`, `AllowSort`], [`autoFilter`, `AllowFilter`], [`pivotTables`, `AllowUsePivotTables`]].forEach(function (t) {
    e[`!protect`][t[0]] && i.push(`<` + t[1] + `/>`);
  })), i.length == 0 ? `` : X(`WorksheetOptions`, i.join(``), {
    xmlns: QN.x
  });
}
function lJ(e) {
  return e.map(function (e) {
    return X(`Comment`, X(`ss:Data`, kN(e.t || ``), {
      xmlns: `http://www.w3.org/TR/REC-html40`
    }), {
      "ss:Author": e.a
    });
  }).join(``);
}
function uJ(e, t, n, r, i, a, o) {
  if (!e || e.v == null && e.f == null) return ``;
  var s = {};
  if (e.f && (s[`ss:Formula`] = `=` + CN(HH(e.f, o))), e.F && e.F.slice(0, t.length) == t) {
    var c = QP(e.F.slice(t.length + 1));
    s[`ss:ArrayRange`] = `RC:R` + (c.r == o.r ? `` : `[` + (c.r - o.r) + `]`) + `C` + (c.c == o.c ? `` : `[` + (c.c - o.c) + `]`);
  }
  if (e.l && e.l.Target && (s[`ss:HRef`] = CN(e.l.Target), e.l.Tooltip && (s[`x:HRefScreenTip`] = CN(e.l.Tooltip))), n[`!merges`]) for (var l = n[`!merges`], u = 0; u != l.length; ++u) l[u].s.c == o.c && l[u].s.r == o.r && (l[u].e.c > l[u].s.c && (s[`ss:MergeAcross`] = l[u].e.c - l[u].s.c), l[u].e.r > l[u].s.r && (s[`ss:MergeDown`] = l[u].e.r - l[u].s.r));
  var d = ``,
    f = ``;
  switch (e.t) {
    case `z`:
      if (!r.sheetStubs) return ``;
      break;
    case `n`:
      d = `Number`, f = String(e.v);
      break;
    case `b`:
      d = `Boolean`, f = e.v ? `1` : `0`;
      break;
    case `e`:
      d = `Error`, f = lI[e.v];
      break;
    case `d`:
      d = `DateTime`, f = new Date(e.v).toISOString(), e.z ??= e.z || bj[14];
      break;
    case `s`:
      d = `String`, f = DN(e.v || ``);
  }
  s[`ss:StyleID`] = `s` + (21 + JW(r.cellXfs, e, r)), s[`ss:Index`] = o.c + 1;
  var p = e.v == null ? `` : f,
    m = e.t == `z` ? `` : `<Data ss:Type="` + d + `">` + p + `</Data>`;
  return (e.c || []).length > 0 && (m += lJ(e.c)), X(`Cell`, m, s);
}
function dJ(e, t) {
  var n = `<Row ss:Index="` + (e + 1) + `"`;
  return t && (t.hpt && !t.hpx && (t.hpx = ZB(t.hpt)), t.hpx && (n += ` ss:AutoFitHeight="0" ss:Height="` + t.hpx + `"`), t.hidden && (n += ` ss:Hidden="1"`)), n + `>`;
}
function fJ(e, t, n, r) {
  if (!e[`!ref`]) return ``;
  var i = nF(e[`!ref`]),
    a = e[`!merges`] || [],
    o = 0,
    s = [];
  e[`!cols`] && e[`!cols`].forEach(function (e, t) {
    JB(e);
    var n = !!e.width,
      r = KW(t, e),
      i = {
        "ss:Index": t + 1
      };
    n && (i[`ss:Width`] = UB(r.width)), e.hidden && (i[`ss:Hidden`] = `1`), s.push(X(`Column`, null, i));
  });
  for (var c = Array.isArray(e), l = i.s.r; l <= i.e.r; ++l) {
    for (var u = [dJ(l, (e[`!rows`] || [])[l])], d = i.s.c; d <= i.e.c; ++d) {
      var f = !1;
      for (o = 0; o != a.length; ++o) if (!(a[o].s.c > d) && !(a[o].s.r > l) && !(a[o].e.c < d) && !(a[o].e.r < l)) {
        (a[o].s.c != d || a[o].s.r != l) && (f = !0);
        break;
      }
      if (!f) {
        var p = {
            r: l,
            c: d
          },
          m = $P(p),
          h = c ? (e[l] || [])[d] : e[m];
        u.push(uJ(h, m, e, t, n, r, p));
      }
    }
    u.push(`</Row>`), u.length > 2 && s.push(u.join(``));
  }
  return s.join(``);
}
function pJ(e, t, n) {
  var r = [],
    i = n.SheetNames[e],
    a = n.Sheets[i],
    o = a ? sJ(a, t, e, n) : ``;
  return o.length > 0 && r.push(`<Names>` + o + `</Names>`), o = a ? fJ(a, t, e, n) : ``, o.length > 0 && r.push(`<Table>` + o + `</Table>`), r.push(cJ(a, t, e, n)), r.join(``);
}
function mJ(e, t) {
  t ||= {}, e.SSF ||= GM(bj), e.SSF && (hM(), mM(e.SSF), t.revssf = jM(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF, t.cellXfs = [], JW(t.cellXfs, {}, {
    revssf: {
      General: 0
    }
  }));
  var n = [];
  n.push(nJ(e, t)), n.push(rJ(e, t)), n.push(``), n.push(``);
  for (var r = 0; r < e.SheetNames.length; ++r) n.push(X(`Worksheet`, pJ(r, t, e), {
    "ss:Name": CN(e.SheetNames[r])
  }));
  return n[2] = iJ(e, t), n[3] = oJ(e, t), uN + X(`Workbook`, n.join(``), {
    xmlns: QN.ss,
    "xmlns:o": QN.o,
    "xmlns:x": QN.x,
    "xmlns:ss": QN.ss,
    "xmlns:dt": QN.dt,
    "xmlns:html": QN.html
  });
}
function hJ(e) {
  var t = {},
    n = e.content;
  if (n.l = 28, t.AnsiUserType = n.read_shift(0, `lpstr-ansi`), t.AnsiClipboardFormat = HF(n), n.length - n.l <= 4) return t;
  var r = n.read_shift(4);
  if (r == 0 || r > 40 || (n.l -= 4, t.Reserved1 = n.read_shift(0, `lpstr-ansi`), n.length - n.l <= 4) || (r = n.read_shift(4), r !== 1907505652) || (t.UnicodeClipboardFormat = UF(n), r = n.read_shift(4), r == 0 || r > 40)) return t;
  n.l -= 4, t.Reserved2 = n.read_shift(0, `lpwstr`);
}
var gJ = [60, 1084, 2066, 2165, 2175];
function _J(e, t, n, r, i) {
  var a = r,
    o = [],
    s = n.slice(n.l, n.l + a);
  if (i && i.enc && i.enc.insitu && s.length > 0) switch (e) {
    case 9:
    case 521:
    case 1033:
    case 2057:
    case 47:
    case 405:
    case 225:
    case 406:
    case 312:
    case 404:
    case 10:
      break;
    case 133:
      break;
    default:
      i.enc.insitu(s);
  }
  o.push(s), n.l += a;
  for (var c = wP(n, n.l), l = DJ[c], u = 0; l != null && gJ.indexOf(c) > -1;) a = wP(n, n.l + 2), u = n.l + 4, c == 2066 ? u += 4 : (c == 2165 || c == 2175) && (u += 12), s = n.slice(u, n.l + 4 + a), o.push(s), n.l += 4 + a, l = DJ[c = wP(n, n.l)];
  var d = ij(o);
  FP(d, 0);
  var f = 0;
  d.lens = [];
  for (var p = 0; p < o.length; ++p) d.lens.push(f), f += o[p].length;
  if (d.length < r) throw `XLS Record 0x` + e.toString(16) + ` Truncated: ` + d.length + ` < ` + r;
  return t.f(d, d.length, i);
}
function vJ(e, t, n) {
  if (e.t !== `z` && e.XF) {
    var r = 0;
    try {
      r = e.z || e.XF.numFmtId || 0, t.cellNF && (e.z = bj[r]);
    } catch (e) {
      if (t.WTF) throw e;
    }
    if (!t || t.cellText !== !1) try {
      e.w = e.t === `e` ? e.w || lI[e.v] : r === 0 || r == `General` ? e.t === `n` ? (e.v | 0) === e.v ? e.v.toString(10) : Nj(e.v) : Pj(e.v) : fM(r, e.v, {
        date1904: !!n,
        dateNF: t && t.dateNF
      });
    } catch (e) {
      if (t.WTF) throw e;
    }
    if (t.cellDates && r && e.t == `n` && sM(bj[r] || String(r))) {
      var i = wj(e.v);
      i && (e.t = `d`, e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u));
    }
  }
}
function yJ(e, t, n) {
  return {
    v: e,
    ixfe: t,
    t: n
  };
}
function bJ(e, t) {
  var n = {
      opts: {}
    },
    r = {};
  WA != null && t.dense == null && (t.dense = WA);
  var i = t.dense ? [] : {},
    a = {},
    o = {},
    s = null,
    c = [],
    l = ``,
    u = {},
    d,
    f = ``,
    p,
    m,
    h,
    g,
    _ = {},
    v = [],
    y,
    b,
    x = [],
    S = [],
    C = {
      Sheets: [],
      WBProps: {
        date1904: !1
      },
      Views: [{}]
    },
    w = {},
    T = function (e) {
      return e < 8 ? cI[e] : e < 64 && S[e - 8] || cI[e];
    },
    E = function (e, t, n) {
      var r = t.XF.data;
      if (r && r.patternType && n && n.cellStyles) {
        t.s = {}, t.s.patternType = r.patternType;
        var i;
        (i = FB(T(r.icvFore))) && (t.s.fgColor = {
          rgb: i
        }), (i = FB(T(r.icvBack))) && (t.s.bgColor = {
          rgb: i
        });
      }
    },
    D = function (e, t, n) {
      if (!(L > 1) && !(n.sheetRows && e.r >= n.sheetRows)) {
        if (n.cellStyles && t.XF && t.XF.data && E(e, t, n), delete t.ixfe, delete t.XF, d = e, f = $P(e), (!o || !o.s || !o.e) && (o = {
          s: {
            r: 0,
            c: 0
          },
          e: {
            r: 0,
            c: 0
          }
        }), e.r < o.s.r && (o.s.r = e.r), e.c < o.s.c && (o.s.c = e.c), e.r + 1 > o.e.r && (o.e.r = e.r + 1), e.c + 1 > o.e.c && (o.e.c = e.c + 1), n.cellFormula && t.f) {
          for (var r = 0; r < v.length; ++r) if (!(v[r][0].s.c > e.c || v[r][0].s.r > e.r) && !(v[r][0].e.c < e.c || v[r][0].e.r < e.r)) {
            t.F = tF(v[r][0]), (v[r][0].s.c != e.c || v[r][0].s.r != e.r) && delete t.f, t.f &&= `` + xW(v[r][1], o, e, F, O);
            break;
          }
        }
        n.dense ? (i[e.r] || (i[e.r] = []), i[e.r][e.c] = t) : i[f] = t;
      }
    },
    O = {
      enc: !1,
      sbcch: 0,
      snames: [],
      sharedf: _,
      arrayf: v,
      rrtabid: [],
      lastuser: ``,
      biff: 8,
      codepage: 0,
      winlocked: 0,
      cellStyles: !!t && !!t.cellStyles,
      WTF: !!t && !!t.wtf
    };
  t.password && (O.password = t.password);
  var k,
    A = [],
    j = [],
    M = [],
    N = [],
    P = !1,
    F = [];
  F.SheetNames = O.snames, F.sharedf = O.sharedf, F.arrayf = O.arrayf, F.names = [], F.XTI = [];
  var I = 0,
    L = 0,
    R = 0,
    z = [],
    ee = [],
    te;
  O.codepage = 1200, PA(1200);
  for (var B = !1; e.l < e.length - 1;) {
    var V = e.l,
      H = e.read_shift(2);
    if (H === 0 && I === 10) break;
    var ne = e.l === e.length ? 0 : e.read_shift(2),
      re = DJ[H];
    if (re && re.f) {
      if (t.bookSheets && I === 133 && H !== 133) break;
      if (I = H, re.r === 2 || re.r == 12) {
        var ie = e.read_shift(2);
        if (ne -= 2, !O.enc && ie !== H && ((ie & 255) << 8 | ie >> 8) !== H) throw Error(`rt mismatch: ` + ie + `!=` + H);
        re.r == 12 && (e.l += 10, ne -= 10);
      }
      var U = {};
      if (U = H === 10 ? re.f(e, ne, O) : _J(H, re, e, ne, O), L == 0 && [9, 521, 1033, 2057].indexOf(I) === -1) continue;
      switch (H) {
        case 34:
          n.opts.Date1904 = C.WBProps.date1904 = U;
          break;
        case 134:
          n.opts.WriteProtect = !0;
          break;
        case 47:
          if (O.enc || (e.l = 0), O.enc = U, !t.password) throw Error(`File is password-protected`);
          if (U.valid == null) throw Error(`Encryption scheme unsupported`);
          if (!U.valid) throw Error(`Password is incorrect`);
          break;
        case 92:
          O.lastuser = U;
          break;
        case 66:
          var ae = Number(U);
          switch (ae) {
            case 21010:
              ae = 1200;
              break;
            case 32768:
              ae = 1e4;
              break;
            case 32769:
              ae = 1252;
          }
          PA(O.codepage = ae), B = !0;
          break;
        case 317:
          O.rrtabid = U;
          break;
        case 25:
          O.winlocked = U;
          break;
        case 439:
          n.opts.RefreshAll = U;
          break;
        case 12:
          n.opts.CalcCount = U;
          break;
        case 16:
          n.opts.CalcDelta = U;
          break;
        case 17:
          n.opts.CalcIter = U;
          break;
        case 13:
          n.opts.CalcMode = U;
          break;
        case 14:
          n.opts.CalcPrecision = U;
          break;
        case 95:
          n.opts.CalcSaveRecalc = U;
          break;
        case 15:
          O.CalcRefMode = U;
          break;
        case 2211:
          n.opts.FullCalc = U;
          break;
        case 129:
          U.fDialog && (i[`!type`] = `dialog`), U.fBelow || ((i[`!outline`] || (i[`!outline`] = {})).above = !0), U.fRight || ((i[`!outline`] || (i[`!outline`] = {})).left = !0);
          break;
        case 224:
          x.push(U);
          break;
        case 430:
          F.push([U]), F[F.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          F[F.length - 1].push(U);
          break;
        case 24:
        case 536:
          te = {
            Name: U.Name,
            Ref: xW(U.rgce, o, null, F, O)
          }, U.itab > 0 && (te.Sheet = U.itab - 1), F.names.push(te), F[0] || (F[0] = [], F[0].XTI = []), F[F.length - 1].push(U), U.Name == `_xlnm._FilterDatabase` && U.itab > 0 && U.rgce && U.rgce[0] && U.rgce[0][0] && U.rgce[0][0][0] == `PtgArea3d` && (ee[U.itab - 1] = {
            ref: tF(U.rgce[0][0][1][2])
          });
          break;
        case 22:
          O.ExternCount = U;
          break;
        case 23:
          F.length == 0 && (F[0] = [], F[0].XTI = []), F[F.length - 1].XTI = F[F.length - 1].XTI.concat(U), F.XTI = F.XTI.concat(U);
          break;
        case 2196:
          if (O.biff < 8) break;
          te != null && (te.Comment = U[1]);
          break;
        case 18:
          i[`!protect`] = U;
          break;
        case 19:
          U !== 0 && O.WTF && console.error(`Password verifier: ` + U);
          break;
        case 133:
          a[U.pos] = U, O.snames.push(U.name);
          break;
        case 10:
          if (--L) break;
          if (o.e) {
            if (o.e.r > 0 && o.e.c > 0) {
              if (o.e.r--, o.e.c--, i[`!ref`] = tF(o), t.sheetRows && t.sheetRows <= o.e.r) {
                var oe = o.e.r;
                o.e.r = t.sheetRows - 1, i[`!fullref`] = i[`!ref`], i[`!ref`] = tF(o), o.e.r = oe;
              }
              o.e.r++, o.e.c++;
            }
            A.length > 0 && (i[`!merges`] = A), j.length > 0 && (i[`!objects`] = j), M.length > 0 && (i[`!cols`] = M), N.length > 0 && (i[`!rows`] = N), C.Sheets.push(w);
          }
          l === `` ? u = i : r[l] = i, i = t.dense ? [] : {};
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          if (O.biff === 8 && (O.biff = {
            9: 2,
            521: 3,
            1033: 4
          }[H] || {
            512: 2,
            768: 3,
            1024: 4,
            1280: 5,
            1536: 8,
            2: 2,
            7: 2
          }[U.BIFFVer] || 8), O.biffguess = U.BIFFVer == 0, U.BIFFVer == 0 && U.dt == 4096 && (O.biff = 5, B = !0, PA(O.codepage = 28591)), O.biff == 8 && U.BIFFVer == 0 && U.dt == 16 && (O.biff = 2), L++) break;
          if (i = t.dense ? [] : {}, O.biff < 8 && !B && (B = !0, PA(O.codepage = t.codepage || 1252)), O.biff < 5 || U.BIFFVer == 0 && U.dt == 4096) {
            l === `` && (l = `Sheet1`), o = {
              s: {
                r: 0,
                c: 0
              },
              e: {
                r: 0,
                c: 0
              }
            };
            var se = {
              pos: e.l - ne,
              name: l
            };
            a[se.pos] = se, O.snames.push(l);
          } else l = (a[V] || {
            name: ``
          }).name;
          U.dt == 32 && (i[`!type`] = `chart`), U.dt == 64 && (i[`!type`] = `macro`), A = [], j = [], O.arrayf = v = [], M = [], N = [], P = !1, w = {
            Hidden: (a[V] || {
              hs: 0
            }).hs,
            name: l
          };
          break;
        case 515:
        case 3:
        case 2:
          i[`!type`] == `chart` && (t.dense ? (i[U.r] || [])[U.c] : i[$P({
            c: U.c,
            r: U.r
          })]) && ++U.c, y = {
            ixfe: U.ixfe,
            XF: x[U.ixfe] || {},
            v: U.val,
            t: `n`
          }, R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
            c: U.c,
            r: U.r
          }, y, t);
          break;
        case 5:
        case 517:
          y = {
            ixfe: U.ixfe,
            XF: x[U.ixfe],
            v: U.val,
            t: U.t
          }, R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
            c: U.c,
            r: U.r
          }, y, t);
          break;
        case 638:
          y = {
            ixfe: U.ixfe,
            XF: x[U.ixfe],
            v: U.rknum,
            t: `n`
          }, R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
            c: U.c,
            r: U.r
          }, y, t);
          break;
        case 189:
          for (var ce = U.c; ce <= U.C; ++ce) {
            var le = U.rkrec[ce - U.c][0];
            y = {
              ixfe: le,
              XF: x[le],
              v: U.rkrec[ce - U.c][1],
              t: `n`
            }, R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
              c: ce,
              r: U.r
            }, y, t);
          }
          break;
        case 6:
        case 518:
        case 1030:
          if (U.val == `String`) {
            s = U;
            break;
          }
          if (y = yJ(U.val, U.cell.ixfe, U.tt), y.XF = x[y.ixfe], t.cellFormula) {
            var ue = U.formula;
            if (ue && ue[0] && ue[0][0] && ue[0][0][0] == `PtgExp`) {
              var de = ue[0][0][1][0],
                fe = ue[0][0][1][1],
                pe = $P({
                  r: de,
                  c: fe
                });
              _[pe] ? y.f = `` + xW(U.formula, o, U.cell, F, O) : y.F = ((t.dense ? (i[de] || [])[fe] : i[pe]) || {}).F;
            } else y.f = `` + xW(U.formula, o, U.cell, F, O);
          }
          R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D(U.cell, y, t), s = U;
          break;
        case 7:
        case 519:
          if (s) s.val = U, y = yJ(U, s.cell.ixfe, `s`), y.XF = x[y.ixfe], t.cellFormula && (y.f = `` + xW(s.formula, o, s.cell, F, O)), R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D(s.cell, y, t), s = null;else throw Error(`String record expects Formula`);
          break;
        case 33:
        case 545:
          v.push(U);
          var me = $P(U[0].s);
          if (p = t.dense ? (i[U[0].s.r] || [])[U[0].s.c] : i[me], t.cellFormula && p) {
            if (!s || !me || !p) break;
            p.f = `` + xW(U[1], o, U[0], F, O), p.F = tF(U[0]);
          }
          break;
        case 1212:
          if (!t.cellFormula) break;
          if (f) {
            if (!s) break;
            _[$P(s.cell)] = U[0], p = t.dense ? (i[s.cell.r] || [])[s.cell.c] : i[$P(s.cell)], (p || {}).f = `` + xW(U[0], o, d, F, O);
          }
          break;
        case 253:
          y = yJ(c[U.isst].t, U.ixfe, `s`), c[U.isst].h && (y.h = c[U.isst].h), y.XF = x[y.ixfe], R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
            c: U.c,
            r: U.r
          }, y, t);
          break;
        case 513:
          t.sheetStubs && (y = {
            ixfe: U.ixfe,
            XF: x[U.ixfe],
            t: `z`
          }, R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
            c: U.c,
            r: U.r
          }, y, t));
          break;
        case 190:
          if (t.sheetStubs) for (var he = U.c; he <= U.C; ++he) {
            var ge = U.ixfe[he - U.c];
            y = {
              ixfe: ge,
              XF: x[ge],
              t: `z`
            }, R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
              c: he,
              r: U.r
            }, y, t);
          }
          break;
        case 214:
        case 516:
        case 4:
          y = yJ(U.val, U.ixfe, `s`), y.XF = x[y.ixfe], R > 0 && (y.z = z[y.ixfe >> 8 & 63]), vJ(y, t, n.opts.Date1904), D({
            c: U.c,
            r: U.r
          }, y, t);
          break;
        case 0:
        case 512:
          L === 1 && (o = U);
          break;
        case 252:
          c = U;
          break;
        case 1054:
          if (O.biff == 4) {
            z[R++] = U[1];
            for (var _e = 0; _e < R + 163 && bj[_e] != U[1]; ++_e);
            _e >= 163 && pM(U[1], R + 163);
          } else pM(U[1], U[0]);
          break;
        case 30:
          z[R++] = U;
          for (var ve = 0; ve < R + 163 && bj[ve] != U; ++ve);
          ve >= 163 && pM(U, R + 163);
          break;
        case 229:
          A = A.concat(U);
          break;
        case 93:
          j[U.cmo[0]] = O.lastobj = U;
          break;
        case 438:
          O.lastobj.TxO = U;
          break;
        case 127:
          O.lastobj.ImData = U;
          break;
        case 440:
          for (g = U[0].s.r; g <= U[0].e.r; ++g) for (h = U[0].s.c; h <= U[0].e.c; ++h) p = t.dense ? (i[g] || [])[h] : i[$P({
            c: h,
            r: g
          })], p && (p.l = U[1]);
          break;
        case 2048:
          for (g = U[0].s.r; g <= U[0].e.r; ++g) for (h = U[0].s.c; h <= U[0].e.c; ++h) p = t.dense ? (i[g] || [])[h] : i[$P({
            c: h,
            r: g
          })], p && p.l && (p.l.Tooltip = U[1]);
          break;
        case 28:
          if (O.biff <= 5 && O.biff >= 2) break;
          p = t.dense ? (i[U[0].r] || [])[U[0].c] : i[$P(U[0])];
          var ye = j[U[2]];
          p || (t.dense ? (i[U[0].r] || (i[U[0].r] = []), p = i[U[0].r][U[0].c] = {
            t: `z`
          }) : p = i[$P(U[0])] = {
            t: `z`
          }, o.e.r = Math.max(o.e.r, U[0].r), o.s.r = Math.min(o.s.r, U[0].r), o.e.c = Math.max(o.e.c, U[0].c), o.s.c = Math.min(o.s.c, U[0].c)), p.c || (p.c = []), m = {
            a: U[1],
            t: ye.TxO.t
          }, p.c.push(m);
          break;
        case 2173:
          eH(x[U.ixfe], U.ext);
          break;
        case 125:
          if (!O.cellStyles) break;
          for (; U.e >= U.s;) M[U.e--] = {
            width: U.w / 256,
            level: U.level || 0,
            hidden: !!(U.flags & 1)
          }, P || (P = !0, qB(U.w / 256)), JB(M[U.e + 1]);
          break;
        case 520:
          var be = {};
          U.level != null && (N[U.r] = be, be.level = U.level), U.hidden && (N[U.r] = be, be.hidden = !0), U.hpt && (N[U.r] = be, be.hpt = U.hpt, be.hpx = ZB(U.hpt));
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          i[`!margins`] || qW(i[`!margins`] = {}), i[`!margins`][{
            38: `left`,
            39: `right`,
            40: `top`,
            41: `bottom`
          }[H]] = U;
          break;
        case 161:
          i[`!margins`] || qW(i[`!margins`] = {}), i[`!margins`].header = U.header, i[`!margins`].footer = U.footer;
          break;
        case 574:
          U.RTL && (C.Views[0].RTL = !0);
          break;
        case 146:
          S = U;
          break;
        case 2198:
          k = U;
          break;
        case 140:
          b = U;
          break;
        case 442:
          l ? w.CodeName = U || w.name : C.WBProps.CodeName = U || `ThisWorkbook`;
      }
    } else re || console.error(`Missing Info for XLS Record 0x` + H.toString(16)), e.l += ne;
  }
  return n.SheetNames = OM(a).sort(function (e, t) {
    return Number(e) - Number(t);
  }).map(function (e) {
    return a[e].name;
  }), t.bookSheets || (n.Sheets = r), !n.SheetNames.length && u[`!ref`] ? (n.SheetNames.push(`Sheet1`), n.Sheets && (n.Sheets.Sheet1 = u)) : n.Preamble = u, n.Sheets && ee.forEach(function (e, t) {
    n.Sheets[n.SheetNames[t]][`!autofilter`] = e;
  }), n.Strings = c, n.SSF = GM(bj), O.enc && (n.Encryption = O.enc), k && (n.Themes = k), n.Metadata = {}, b !== void 0 && (n.Metadata.Country = b), F.names.length > 0 && (C.Names = F.names), n.Workbook = C, n;
}
var xJ = {
  SI: `e0859ff2f94f6810ab9108002b27b3d9`,
  DSI: `02d5cdd59c2e1b10939708002b2cf9ae`,
  UDI: `05d5cdd59c2e1b10939708002b2cf9ae`
};
function SJ(e, t, n) {
  var r = SM.find(e, `/!DocumentSummaryInformation`);
  if (r && r.size > 0) try {
    var i = fL(r, rI, xJ.DSI);
    for (var a in i) t[a] = i[a];
  } catch (e) {
    if (n.WTF) throw e;
  }
  var o = SM.find(e, `/!SummaryInformation`);
  if (o && o.size > 0) try {
    var s = fL(o, iI, xJ.SI);
    for (var c in s) t[c] ?? (t[c] = s[c]);
  } catch (e) {
    if (n.WTF) throw e;
  }
  t.HeadingPairs && t.TitlesOfParts && (FI(t.HeadingPairs, t.TitlesOfParts, t, n), delete t.HeadingPairs, delete t.TitlesOfParts);
}
function CJ(e, t) {
  var n = [],
    r = [],
    i = [],
    a = 0,
    o,
    s = kM(rI, `n`),
    c = kM(iI, `n`);
  if (e.Props) for (o = OM(e.Props), a = 0; a < o.length; ++a) (Object.prototype.hasOwnProperty.call(s, o[a]) ? n : Object.prototype.hasOwnProperty.call(c, o[a]) ? r : i).push([o[a], e.Props[o[a]]]);
  if (e.Custprops) for (o = OM(e.Custprops), a = 0; a < o.length; ++a) Object.prototype.hasOwnProperty.call(e.Props || {}, o[a]) || (Object.prototype.hasOwnProperty.call(s, o[a]) ? n : Object.prototype.hasOwnProperty.call(c, o[a]) ? r : i).push([o[a], e.Custprops[o[a]]]);
  var l = [];
  for (a = 0; a < i.length; ++a) lL.indexOf(i[a][0]) > -1 || PI.indexOf(i[a][0]) > -1 || i[a][1] != null && l.push(i[a]);
  r.length && SM.utils.cfb_add(t, `/SummaryInformation`, pL(r, xJ.SI, c, iI)), (n.length || l.length) && SM.utils.cfb_add(t, `/DocumentSummaryInformation`, pL(n, xJ.DSI, s, rI, l.length ? l : null, xJ.UDI));
}
function wJ(e, t) {
  t ||= {}, YY(t), FA(), t.codepage && MA(t.codepage);
  var n, r;
  if (e.FullPaths) {
    if (SM.find(e, `/encryption`)) throw Error(`File is password-protected`);
    n = SM.find(e, `!CompObj`), r = SM.find(e, `/Workbook`) || SM.find(e, `/Book`);
  } else {
    switch (t.type) {
      case `base64`:
        e = $A(JA(e));
        break;
      case `binary`:
        e = $A(e);
        break;
      case `buffer`:
        break;
      case `array`:
        Array.isArray(e) || (e = Array.prototype.slice.call(e));
    }
    FP(e, 0), r = {
      content: e
    };
  }
  var i, a;
  if (n && hJ(n), t.bookProps && !t.bookSheets) i = {};else {
    var o = YA ? `buffer` : `array`;
    if (r && r.content) i = bJ(r.content, t);else if ((a = SM.find(e, `PerfectOffice_MAIN`)) && a.content) i = Gz.to_workbook(a.content, (t.type = o, t));else if ((a = SM.find(e, `NativeContent_MAIN`)) && a.content) i = Gz.to_workbook(a.content, (t.type = o, t));else if ((a = SM.find(e, `MN0`)) && a.content) throw Error(`Unsupported Works 4 for Mac file`);else throw Error(`Cannot find Workbook stream`);
    t.bookVBA && e.FullPaths && SM.find(e, `/_VBA_PROJECT_CUR/VBA/dir`) && (i.vbaraw = NH(e));
  }
  var s = {};
  return e.FullPaths && SJ(e, s, t), i.Props = i.Custprops = s, t.bookFiles && (i.cfb = e), i;
}
function TJ(e, t) {
  var n = t || {},
    r = SM.utils.cfb_new({
      root: `R`
    }),
    i = `/Workbook`;
  switch (n.bookType || `xls`) {
    case `xls`:
      n.bookType = `biff8`;
    case `xla`:
      n.bookType ||= `xla`;
    case `biff8`:
      i = `/Workbook`, n.biff = 8;
      break;
    case `biff5`:
      i = `/Book`, n.biff = 5;
      break;
    default:
      throw Error(`invalid type ` + n.bookType + ` for XLS CFB`);
  }
  return SM.utils.cfb_add(r, i, KJ(e, n)), n.biff == 8 && (e.Props || e.Custprops) && CJ(e, r), n.biff == 8 && e.vbaraw && PH(r, SM.read(e.vbaraw, {
    type: typeof e.vbaraw == `string` ? `binary` : `buffer`
  })), r;
}
var EJ = {
    0: {
      f: AG
    },
    1: {
      f: RG
    },
    2: {
      f: iK
    },
    3: {
      f: KG
    },
    4: {
      f: HG
    },
    5: {
      f: eK
    },
    6: {
      f: lK
    },
    7: {
      f: XG
    },
    8: {
      f: gK
    },
    9: {
      f: hK
    },
    10: {
      f: pK
    },
    11: {
      f: mK
    },
    12: {
      f: BG
    },
    13: {
      f: oK
    },
    14: {
      f: JG
    },
    15: {
      f: WG
    },
    16: {
      f: nK
    },
    17: {
      f: dK
    },
    18: {
      f: QG
    },
    19: {
      f: mF
    },
    20: {},
    21: {},
    22: {},
    23: {},
    24: {},
    25: {},
    26: {},
    27: {},
    28: {},
    29: {},
    30: {},
    31: {},
    32: {},
    33: {},
    34: {},
    35: {
      T: 1
    },
    36: {
      T: -1
    },
    37: {
      T: 1
    },
    38: {
      T: -1
    },
    39: {
      f: vq
    },
    40: {},
    42: {},
    43: {
      f: fV
    },
    44: {
      f: uV
    },
    45: {
      f: gV
    },
    46: {
      f: xV
    },
    47: {
      f: vV
    },
    48: {},
    49: {
      f: cF
    },
    50: {},
    51: {
      f: rH
    },
    52: {
      T: 1
    },
    53: {
      T: -1
    },
    54: {
      T: 1
    },
    55: {
      T: -1
    },
    56: {
      T: 1
    },
    57: {
      T: -1
    },
    58: {},
    59: {},
    60: {
      f: xz
    },
    62: {
      f: cK
    },
    63: {
      f: pH
    },
    64: {
      f: NK
    },
    65: {},
    66: {},
    67: {},
    68: {},
    69: {},
    70: {},
    128: {},
    129: {
      T: 1
    },
    130: {
      T: -1
    },
    131: {
      T: 1,
      f: IP,
      p: 0
    },
    132: {
      T: -1
    },
    133: {
      T: 1
    },
    134: {
      T: -1
    },
    135: {
      T: 1
    },
    136: {
      T: -1
    },
    137: {
      T: 1,
      f: kK
    },
    138: {
      T: -1
    },
    139: {
      T: 1
    },
    140: {
      T: -1
    },
    141: {
      T: 1
    },
    142: {
      T: -1
    },
    143: {
      T: 1
    },
    144: {
      T: -1
    },
    145: {
      T: 1
    },
    146: {
      T: -1
    },
    147: {
      f: IG
    },
    148: {
      f: NG,
      p: 16
    },
    151: {
      f: SK
    },
    152: {},
    153: {
      f: hq
    },
    154: {},
    155: {},
    156: {
      f: pq
    },
    157: {},
    158: {},
    159: {
      T: 1,
      f: aB
    },
    160: {
      T: -1
    },
    161: {
      T: 1,
      f: NF
    },
    162: {
      T: -1
    },
    163: {
      T: 1
    },
    164: {
      T: -1
    },
    165: {
      T: 1
    },
    166: {
      T: -1
    },
    167: {},
    168: {},
    169: {},
    170: {},
    171: {},
    172: {
      T: 1
    },
    173: {
      T: -1
    },
    174: {},
    175: {},
    176: {
      f: _K
    },
    177: {
      T: 1
    },
    178: {
      T: -1
    },
    179: {
      T: 1
    },
    180: {
      T: -1
    },
    181: {
      T: 1
    },
    182: {
      T: -1
    },
    183: {
      T: 1
    },
    184: {
      T: -1
    },
    185: {
      T: 1
    },
    186: {
      T: -1
    },
    187: {
      T: 1
    },
    188: {
      T: -1
    },
    189: {
      T: 1
    },
    190: {
      T: -1
    },
    191: {
      T: 1
    },
    192: {
      T: -1
    },
    193: {
      T: 1
    },
    194: {
      T: -1
    },
    195: {
      T: 1
    },
    196: {
      T: -1
    },
    197: {
      T: 1
    },
    198: {
      T: -1
    },
    199: {
      T: 1
    },
    200: {
      T: -1
    },
    201: {
      T: 1
    },
    202: {
      T: -1
    },
    203: {
      T: 1
    },
    204: {
      T: -1
    },
    205: {
      T: 1
    },
    206: {
      T: -1
    },
    207: {
      T: 1
    },
    208: {
      T: -1
    },
    209: {
      T: 1
    },
    210: {
      T: -1
    },
    211: {
      T: 1
    },
    212: {
      T: -1
    },
    213: {
      T: 1
    },
    214: {
      T: -1
    },
    215: {
      T: 1
    },
    216: {
      T: -1
    },
    217: {
      T: 1
    },
    218: {
      T: -1
    },
    219: {
      T: 1
    },
    220: {
      T: -1
    },
    221: {
      T: 1
    },
    222: {
      T: -1
    },
    223: {
      T: 1
    },
    224: {
      T: -1
    },
    225: {
      T: 1
    },
    226: {
      T: -1
    },
    227: {
      T: 1
    },
    228: {
      T: -1
    },
    229: {
      T: 1
    },
    230: {
      T: -1
    },
    231: {
      T: 1
    },
    232: {
      T: -1
    },
    233: {
      T: 1
    },
    234: {
      T: -1
    },
    235: {
      T: 1
    },
    236: {
      T: -1
    },
    237: {
      T: 1
    },
    238: {
      T: -1
    },
    239: {
      T: 1
    },
    240: {
      T: -1
    },
    241: {
      T: 1
    },
    242: {
      T: -1
    },
    243: {
      T: 1
    },
    244: {
      T: -1
    },
    245: {
      T: 1
    },
    246: {
      T: -1
    },
    247: {
      T: 1
    },
    248: {
      T: -1
    },
    249: {
      T: 1
    },
    250: {
      T: -1
    },
    251: {
      T: 1
    },
    252: {
      T: -1
    },
    253: {
      T: 1
    },
    254: {
      T: -1
    },
    255: {
      T: 1
    },
    256: {
      T: -1
    },
    257: {
      T: 1
    },
    258: {
      T: -1
    },
    259: {
      T: 1
    },
    260: {
      T: -1
    },
    261: {
      T: 1
    },
    262: {
      T: -1
    },
    263: {
      T: 1
    },
    264: {
      T: -1
    },
    265: {
      T: 1
    },
    266: {
      T: -1
    },
    267: {
      T: 1
    },
    268: {
      T: -1
    },
    269: {
      T: 1
    },
    270: {
      T: -1
    },
    271: {
      T: 1
    },
    272: {
      T: -1
    },
    273: {
      T: 1
    },
    274: {
      T: -1
    },
    275: {
      T: 1
    },
    276: {
      T: -1
    },
    277: {},
    278: {
      T: 1
    },
    279: {
      T: -1
    },
    280: {
      T: 1
    },
    281: {
      T: -1
    },
    282: {
      T: 1
    },
    283: {
      T: 1
    },
    284: {
      T: -1
    },
    285: {
      T: 1
    },
    286: {
      T: -1
    },
    287: {
      T: 1
    },
    288: {
      T: -1
    },
    289: {
      T: 1
    },
    290: {
      T: -1
    },
    291: {
      T: 1
    },
    292: {
      T: -1
    },
    293: {
      T: 1
    },
    294: {
      T: -1
    },
    295: {
      T: 1
    },
    296: {
      T: -1
    },
    297: {
      T: 1
    },
    298: {
      T: -1
    },
    299: {
      T: 1
    },
    300: {
      T: -1
    },
    301: {
      T: 1
    },
    302: {
      T: -1
    },
    303: {
      T: 1
    },
    304: {
      T: -1
    },
    305: {
      T: 1
    },
    306: {
      T: -1
    },
    307: {
      T: 1
    },
    308: {
      T: -1
    },
    309: {
      T: 1
    },
    310: {
      T: -1
    },
    311: {
      T: 1
    },
    312: {
      T: -1
    },
    313: {
      T: -1
    },
    314: {
      T: 1
    },
    315: {
      T: -1
    },
    316: {
      T: 1
    },
    317: {
      T: -1
    },
    318: {
      T: 1
    },
    319: {
      T: -1
    },
    320: {
      T: 1
    },
    321: {
      T: -1
    },
    322: {
      T: 1
    },
    323: {
      T: -1
    },
    324: {
      T: 1
    },
    325: {
      T: -1
    },
    326: {
      T: 1
    },
    327: {
      T: -1
    },
    328: {
      T: 1
    },
    329: {
      T: -1
    },
    330: {
      T: 1
    },
    331: {
      T: -1
    },
    332: {
      T: 1
    },
    333: {
      T: -1
    },
    334: {
      T: 1
    },
    335: {
      f: tH
    },
    336: {
      T: -1
    },
    337: {
      f: oH,
      T: 1
    },
    338: {
      T: -1
    },
    339: {
      T: 1
    },
    340: {
      T: -1
    },
    341: {
      T: 1
    },
    342: {
      T: -1
    },
    343: {
      T: 1
    },
    344: {
      T: -1
    },
    345: {
      T: 1
    },
    346: {
      T: -1
    },
    347: {
      T: 1
    },
    348: {
      T: -1
    },
    349: {
      T: 1
    },
    350: {
      T: -1
    },
    351: {},
    352: {},
    353: {
      T: 1
    },
    354: {
      T: -1
    },
    355: {
      f: DF
    },
    357: {},
    358: {},
    359: {},
    360: {
      T: 1
    },
    361: {},
    362: {
      f: QR
    },
    363: {},
    364: {},
    366: {},
    367: {},
    368: {},
    369: {},
    370: {},
    371: {},
    372: {
      T: 1
    },
    373: {
      T: -1
    },
    374: {
      T: 1
    },
    375: {
      T: -1
    },
    376: {
      T: 1
    },
    377: {
      T: -1
    },
    378: {
      T: 1
    },
    379: {
      T: -1
    },
    380: {
      T: 1
    },
    381: {
      T: -1
    },
    382: {
      T: 1
    },
    383: {
      T: -1
    },
    384: {
      T: 1
    },
    385: {
      T: -1
    },
    386: {
      T: 1
    },
    387: {
      T: -1
    },
    388: {
      T: 1
    },
    389: {
      T: -1
    },
    390: {
      T: 1
    },
    391: {
      T: -1
    },
    392: {
      T: 1
    },
    393: {
      T: -1
    },
    394: {
      T: 1
    },
    395: {
      T: -1
    },
    396: {},
    397: {},
    398: {},
    399: {},
    400: {},
    401: {
      T: 1
    },
    403: {},
    404: {},
    405: {},
    406: {},
    407: {},
    408: {},
    409: {},
    410: {},
    411: {},
    412: {},
    413: {},
    414: {},
    415: {},
    416: {},
    417: {},
    418: {},
    419: {},
    420: {},
    421: {},
    422: {
      T: 1
    },
    423: {
      T: 1
    },
    424: {
      T: -1
    },
    425: {
      T: -1
    },
    426: {
      f: CK
    },
    427: {
      f: wK
    },
    428: {},
    429: {
      T: 1
    },
    430: {
      T: -1
    },
    431: {
      T: 1
    },
    432: {
      T: -1
    },
    433: {
      T: 1
    },
    434: {
      T: -1
    },
    435: {
      T: 1
    },
    436: {
      T: -1
    },
    437: {
      T: 1
    },
    438: {
      T: -1
    },
    439: {
      T: 1
    },
    440: {
      T: -1
    },
    441: {
      T: 1
    },
    442: {
      T: -1
    },
    443: {
      T: 1
    },
    444: {
      T: -1
    },
    445: {
      T: 1
    },
    446: {
      T: -1
    },
    447: {
      T: 1
    },
    448: {
      T: -1
    },
    449: {
      T: 1
    },
    450: {
      T: -1
    },
    451: {
      T: 1
    },
    452: {
      T: -1
    },
    453: {
      T: 1
    },
    454: {
      T: -1
    },
    455: {
      T: 1
    },
    456: {
      T: -1
    },
    457: {
      T: 1
    },
    458: {
      T: -1
    },
    459: {
      T: 1
    },
    460: {
      T: -1
    },
    461: {
      T: 1
    },
    462: {
      T: -1
    },
    463: {
      T: 1
    },
    464: {
      T: -1
    },
    465: {
      T: 1
    },
    466: {
      T: -1
    },
    467: {
      T: 1
    },
    468: {
      T: -1
    },
    469: {
      T: 1
    },
    470: {
      T: -1
    },
    471: {},
    472: {},
    473: {
      T: 1
    },
    474: {
      T: -1
    },
    475: {},
    476: {
      f: DK
    },
    477: {},
    478: {},
    479: {
      T: 1
    },
    480: {
      T: -1
    },
    481: {
      T: 1
    },
    482: {
      T: -1
    },
    483: {
      T: 1
    },
    484: {
      T: -1
    },
    485: {
      f: FG
    },
    486: {
      T: 1
    },
    487: {
      T: -1
    },
    488: {
      T: 1
    },
    489: {
      T: -1
    },
    490: {
      T: 1
    },
    491: {
      T: -1
    },
    492: {
      T: 1
    },
    493: {
      T: -1
    },
    494: {
      f: bK
    },
    495: {
      T: 1
    },
    496: {
      T: -1
    },
    497: {
      T: 1
    },
    498: {
      T: -1
    },
    499: {},
    500: {
      T: 1
    },
    501: {
      T: -1
    },
    502: {
      T: 1
    },
    503: {
      T: -1
    },
    504: {},
    505: {
      T: 1
    },
    506: {
      T: -1
    },
    507: {},
    508: {
      T: 1
    },
    509: {
      T: -1
    },
    510: {
      T: 1
    },
    511: {
      T: -1
    },
    512: {},
    513: {},
    514: {
      T: 1
    },
    515: {
      T: -1
    },
    516: {
      T: 1
    },
    517: {
      T: -1
    },
    518: {
      T: 1
    },
    519: {
      T: -1
    },
    520: {
      T: 1
    },
    521: {
      T: -1
    },
    522: {},
    523: {},
    524: {},
    525: {},
    526: {},
    527: {},
    528: {
      T: 1
    },
    529: {
      T: -1
    },
    530: {
      T: 1
    },
    531: {
      T: -1
    },
    532: {
      T: 1
    },
    533: {
      T: -1
    },
    534: {},
    535: {},
    536: {},
    537: {},
    538: {
      T: 1
    },
    539: {
      T: -1
    },
    540: {
      T: 1
    },
    541: {
      T: -1
    },
    542: {
      T: 1
    },
    548: {},
    549: {},
    550: {
      f: DF
    },
    551: {},
    552: {},
    553: {},
    554: {
      T: 1
    },
    555: {
      T: -1
    },
    556: {
      T: 1
    },
    557: {
      T: -1
    },
    558: {
      T: 1
    },
    559: {
      T: -1
    },
    560: {
      T: 1
    },
    561: {
      T: -1
    },
    562: {},
    564: {},
    565: {
      T: 1
    },
    566: {
      T: -1
    },
    569: {
      T: 1
    },
    570: {
      T: -1
    },
    572: {},
    573: {
      T: 1
    },
    574: {
      T: -1
    },
    577: {},
    578: {},
    579: {},
    580: {},
    581: {},
    582: {},
    583: {},
    584: {},
    585: {},
    586: {},
    587: {},
    588: {
      T: -1
    },
    589: {},
    590: {
      T: 1
    },
    591: {
      T: -1
    },
    592: {
      T: 1
    },
    593: {
      T: -1
    },
    594: {
      T: 1
    },
    595: {
      T: -1
    },
    596: {},
    597: {
      T: 1
    },
    598: {
      T: -1
    },
    599: {
      T: 1
    },
    600: {
      T: -1
    },
    601: {
      T: 1
    },
    602: {
      T: -1
    },
    603: {
      T: 1
    },
    604: {
      T: -1
    },
    605: {
      T: 1
    },
    606: {
      T: -1
    },
    607: {},
    608: {
      T: 1
    },
    609: {
      T: -1
    },
    610: {},
    611: {
      T: 1
    },
    612: {
      T: -1
    },
    613: {
      T: 1
    },
    614: {
      T: -1
    },
    615: {
      T: 1
    },
    616: {
      T: -1
    },
    617: {
      T: 1
    },
    618: {
      T: -1
    },
    619: {
      T: 1
    },
    620: {
      T: -1
    },
    625: {},
    626: {
      T: 1
    },
    627: {
      T: -1
    },
    628: {
      T: 1
    },
    629: {
      T: -1
    },
    630: {
      T: 1
    },
    631: {
      T: -1
    },
    632: {
      f: OH
    },
    633: {
      T: 1
    },
    634: {
      T: -1
    },
    635: {
      T: 1,
      f: EH
    },
    636: {
      T: -1
    },
    637: {
      f: gF
    },
    638: {
      T: 1
    },
    639: {},
    640: {
      T: -1
    },
    641: {
      T: 1
    },
    642: {
      T: -1
    },
    643: {
      T: 1
    },
    644: {},
    645: {
      T: -1
    },
    646: {
      T: 1
    },
    648: {
      T: 1
    },
    649: {},
    650: {
      T: -1
    },
    651: {
      f: XK
    },
    652: {},
    653: {
      T: 1
    },
    654: {
      T: -1
    },
    655: {
      T: 1
    },
    656: {
      T: -1
    },
    657: {
      T: 1
    },
    658: {
      T: -1
    },
    659: {},
    660: {
      T: 1
    },
    661: {},
    662: {
      T: -1
    },
    663: {},
    664: {
      T: 1
    },
    665: {},
    666: {
      T: -1
    },
    667: {},
    668: {},
    669: {},
    671: {
      T: 1
    },
    672: {
      T: -1
    },
    673: {
      T: 1
    },
    674: {
      T: -1
    },
    675: {},
    676: {},
    677: {},
    678: {},
    679: {},
    680: {},
    681: {},
    1024: {},
    1025: {},
    1026: {
      T: 1
    },
    1027: {
      T: -1
    },
    1028: {
      T: 1
    },
    1029: {
      T: -1
    },
    1030: {},
    1031: {
      T: 1
    },
    1032: {
      T: -1
    },
    1033: {
      T: 1
    },
    1034: {
      T: -1
    },
    1035: {},
    1036: {},
    1037: {},
    1038: {
      T: 1
    },
    1039: {
      T: -1
    },
    1040: {},
    1041: {
      T: 1
    },
    1042: {
      T: -1
    },
    1043: {},
    1044: {},
    1045: {},
    1046: {
      T: 1
    },
    1047: {
      T: -1
    },
    1048: {
      T: 1
    },
    1049: {
      T: -1
    },
    1050: {},
    1051: {
      T: 1
    },
    1052: {
      T: 1
    },
    1053: {
      f: PK
    },
    1054: {
      T: 1
    },
    1055: {},
    1056: {
      T: 1
    },
    1057: {
      T: -1
    },
    1058: {
      T: 1
    },
    1059: {
      T: -1
    },
    1061: {},
    1062: {
      T: 1
    },
    1063: {
      T: -1
    },
    1064: {
      T: 1
    },
    1065: {
      T: -1
    },
    1066: {
      T: 1
    },
    1067: {
      T: -1
    },
    1068: {
      T: 1
    },
    1069: {
      T: -1
    },
    1070: {
      T: 1
    },
    1071: {
      T: -1
    },
    1072: {
      T: 1
    },
    1073: {
      T: -1
    },
    1075: {
      T: 1
    },
    1076: {
      T: -1
    },
    1077: {
      T: 1
    },
    1078: {
      T: -1
    },
    1079: {
      T: 1
    },
    1080: {
      T: -1
    },
    1081: {
      T: 1
    },
    1082: {
      T: -1
    },
    1083: {
      T: 1
    },
    1084: {
      T: -1
    },
    1085: {},
    1086: {
      T: 1
    },
    1087: {
      T: -1
    },
    1088: {
      T: 1
    },
    1089: {
      T: -1
    },
    1090: {
      T: 1
    },
    1091: {
      T: -1
    },
    1092: {
      T: 1
    },
    1093: {
      T: -1
    },
    1094: {
      T: 1
    },
    1095: {
      T: -1
    },
    1096: {},
    1097: {
      T: 1
    },
    1098: {},
    1099: {
      T: -1
    },
    1100: {
      T: 1
    },
    1101: {
      T: -1
    },
    1102: {},
    1103: {},
    1104: {},
    1105: {},
    1111: {},
    1112: {},
    1113: {
      T: 1
    },
    1114: {
      T: -1
    },
    1115: {
      T: 1
    },
    1116: {
      T: -1
    },
    1117: {},
    1118: {
      T: 1
    },
    1119: {
      T: -1
    },
    1120: {
      T: 1
    },
    1121: {
      T: -1
    },
    1122: {
      T: 1
    },
    1123: {
      T: -1
    },
    1124: {
      T: 1
    },
    1125: {
      T: -1
    },
    1126: {},
    1128: {
      T: 1
    },
    1129: {
      T: -1
    },
    1130: {},
    1131: {
      T: 1
    },
    1132: {
      T: -1
    },
    1133: {
      T: 1
    },
    1134: {
      T: -1
    },
    1135: {
      T: 1
    },
    1136: {
      T: -1
    },
    1137: {
      T: 1
    },
    1138: {
      T: -1
    },
    1139: {
      T: 1
    },
    1140: {
      T: -1
    },
    1141: {},
    1142: {
      T: 1
    },
    1143: {
      T: -1
    },
    1144: {
      T: 1
    },
    1145: {
      T: -1
    },
    1146: {},
    1147: {
      T: 1
    },
    1148: {
      T: -1
    },
    1149: {
      T: 1
    },
    1150: {
      T: -1
    },
    1152: {
      T: 1
    },
    1153: {
      T: -1
    },
    1154: {
      T: -1
    },
    1155: {
      T: -1
    },
    1156: {
      T: -1
    },
    1157: {
      T: 1
    },
    1158: {
      T: -1
    },
    1159: {
      T: 1
    },
    1160: {
      T: -1
    },
    1161: {
      T: 1
    },
    1162: {
      T: -1
    },
    1163: {
      T: 1
    },
    1164: {
      T: -1
    },
    1165: {
      T: 1
    },
    1166: {
      T: -1
    },
    1167: {
      T: 1
    },
    1168: {
      T: -1
    },
    1169: {
      T: 1
    },
    1170: {
      T: -1
    },
    1171: {},
    1172: {
      T: 1
    },
    1173: {
      T: -1
    },
    1177: {},
    1178: {
      T: 1
    },
    1180: {},
    1181: {},
    1182: {},
    2048: {
      T: 1
    },
    2049: {
      T: -1
    },
    2050: {},
    2051: {
      T: 1
    },
    2052: {
      T: -1
    },
    2053: {},
    2054: {},
    2055: {
      T: 1
    },
    2056: {
      T: -1
    },
    2057: {
      T: 1
    },
    2058: {
      T: -1
    },
    2060: {},
    2067: {},
    2068: {
      T: 1
    },
    2069: {
      T: -1
    },
    2070: {},
    2071: {},
    2072: {
      T: 1
    },
    2073: {
      T: -1
    },
    2075: {},
    2076: {},
    2077: {
      T: 1
    },
    2078: {
      T: -1
    },
    2079: {},
    2080: {
      T: 1
    },
    2081: {
      T: -1
    },
    2082: {},
    2083: {
      T: 1
    },
    2084: {
      T: -1
    },
    2085: {
      T: 1
    },
    2086: {
      T: -1
    },
    2087: {
      T: 1
    },
    2088: {
      T: -1
    },
    2089: {
      T: 1
    },
    2090: {
      T: -1
    },
    2091: {},
    2092: {},
    2093: {
      T: 1
    },
    2094: {
      T: -1
    },
    2095: {},
    2096: {
      T: 1
    },
    2097: {
      T: -1
    },
    2098: {
      T: 1
    },
    2099: {
      T: -1
    },
    2100: {
      T: 1
    },
    2101: {
      T: -1
    },
    2102: {},
    2103: {
      T: 1
    },
    2104: {
      T: -1
    },
    2105: {},
    2106: {
      T: 1
    },
    2107: {
      T: -1
    },
    2108: {},
    2109: {
      T: 1
    },
    2110: {
      T: -1
    },
    2111: {
      T: 1
    },
    2112: {
      T: -1
    },
    2113: {
      T: 1
    },
    2114: {
      T: -1
    },
    2115: {},
    2116: {},
    2117: {},
    2118: {
      T: 1
    },
    2119: {
      T: -1
    },
    2120: {},
    2121: {
      T: 1
    },
    2122: {
      T: -1
    },
    2123: {
      T: 1
    },
    2124: {
      T: -1
    },
    2125: {},
    2126: {
      T: 1
    },
    2127: {
      T: -1
    },
    2128: {},
    2129: {
      T: 1
    },
    2130: {
      T: -1
    },
    2131: {
      T: 1
    },
    2132: {
      T: -1
    },
    2133: {
      T: 1
    },
    2134: {},
    2135: {},
    2136: {},
    2137: {
      T: 1
    },
    2138: {
      T: -1
    },
    2139: {
      T: 1
    },
    2140: {
      T: -1
    },
    2141: {},
    3072: {},
    3073: {},
    4096: {
      T: 1
    },
    4097: {
      T: -1
    },
    5002: {
      T: 1
    },
    5003: {
      T: -1
    },
    5081: {
      T: 1
    },
    5082: {
      T: -1
    },
    5083: {},
    5084: {
      T: 1
    },
    5085: {
      T: -1
    },
    5086: {
      T: 1
    },
    5087: {
      T: -1
    },
    5088: {},
    5089: {},
    5090: {},
    5092: {
      T: 1
    },
    5093: {
      T: -1
    },
    5094: {},
    5095: {
      T: 1
    },
    5096: {
      T: -1
    },
    5097: {},
    5099: {},
    65535: {
      n: ``
    }
  },
  DJ = {
    6: {
      f: OW
    },
    10: {
      f: mL
    },
    12: {
      f: yL
    },
    13: {
      f: yL
    },
    14: {
      f: _L
    },
    15: {
      f: _L
    },
    16: {
      f: FF
    },
    17: {
      f: _L
    },
    18: {
      f: _L
    },
    19: {
      f: yL
    },
    20: {
      f: qR
    },
    21: {
      f: qR
    },
    23: {
      f: QR
    },
    24: {
      f: ZR
    },
    25: {
      f: _L
    },
    26: {},
    27: {},
    28: {
      f: az
    },
    29: {},
    34: {
      f: _L
    },
    35: {
      f: YR
    },
    38: {
      f: FF
    },
    39: {
      f: FF
    },
    40: {
      f: FF
    },
    41: {
      f: FF
    },
    42: {
      f: _L
    },
    43: {
      f: _L
    },
    47: {
      f: MB
    },
    49: {
      f: wR
    },
    51: {
      f: yL
    },
    60: {},
    61: {
      f: yR
    },
    64: {
      f: _L
    },
    65: {
      f: CR
    },
    66: {
      f: yL
    },
    77: {},
    80: {},
    81: {},
    82: {},
    85: {
      f: yL
    },
    89: {},
    90: {},
    91: {},
    92: {
      f: sR
    },
    93: {
      f: cz
    },
    94: {},
    95: {
      f: _L
    },
    96: {},
    97: {},
    99: {
      f: _L
    },
    125: {
      f: xz
    },
    128: {
      f: VR
    },
    129: {
      f: lR
    },
    130: {
      f: yL
    },
    131: {
      f: _L
    },
    132: {
      f: _L
    },
    133: {
      f: uR
    },
    134: {},
    140: {
      f: gz
    },
    141: {
      f: yL
    },
    144: {},
    146: {
      f: yz
    },
    151: {},
    152: {},
    153: {},
    154: {},
    155: {},
    156: {
      f: yL
    },
    157: {},
    158: {},
    160: {
      f: Dz
    },
    161: {
      f: Cz
    },
    174: {},
    175: {},
    176: {},
    177: {},
    178: {},
    180: {},
    181: {},
    182: {},
    184: {},
    185: {},
    189: {
      f: IR
    },
    190: {
      f: LR
    },
    193: {
      f: mL
    },
    197: {},
    198: {},
    199: {},
    200: {},
    201: {},
    202: {
      f: _L
    },
    203: {},
    204: {},
    205: {},
    206: {},
    207: {},
    208: {},
    209: {},
    210: {},
    211: {},
    213: {},
    215: {},
    216: {},
    217: {},
    218: {
      f: yL
    },
    220: {},
    221: {
      f: _L
    },
    222: {},
    224: {
      f: zR
    },
    225: {
      f: oR
    },
    226: {
      f: mL
    },
    227: {},
    229: {
      f: oz
    },
    233: {},
    235: {},
    236: {},
    237: {},
    239: {},
    240: {},
    241: {},
    242: {},
    244: {},
    245: {},
    246: {},
    247: {},
    248: {},
    249: {},
    251: {},
    252: {
      f: fR
    },
    253: {
      f: ER
    },
    255: {
      f: mR
    },
    256: {},
    259: {},
    290: {},
    311: {},
    312: {},
    315: {},
    317: {
      f: xL
    },
    318: {},
    319: {},
    320: {},
    330: {},
    331: {},
    333: {},
    334: {},
    335: {},
    336: {},
    337: {},
    338: {},
    339: {},
    340: {},
    351: {},
    352: {
      f: _L
    },
    353: {
      f: mL
    },
    401: {},
    402: {},
    403: {},
    404: {},
    405: {},
    406: {},
    407: {},
    408: {},
    425: {},
    426: {},
    427: {},
    428: {},
    429: {},
    430: {
      f: JR
    },
    431: {
      f: _L
    },
    432: {},
    433: {},
    434: {},
    437: {},
    438: {
      f: dz
    },
    439: {
      f: _L
    },
    440: {
      f: fz
    },
    441: {},
    442: {
      f: OL
    },
    443: {},
    444: {
      f: yL
    },
    445: {},
    446: {},
    448: {
      f: mL
    },
    449: {
      f: _R,
      r: 2
    },
    450: {
      f: mL
    },
    512: {
      f: NR
    },
    513: {
      f: Ez
    },
    515: {
      f: GR
    },
    516: {
      f: OR
    },
    517: {
      f: UR
    },
    519: {
      f: Oz
    },
    520: {
      f: hR
    },
    523: {},
    545: {
      f: nz
    },
    549: {
      f: vR
    },
    566: {},
    574: {
      f: xR
    },
    638: {
      f: FR
    },
    659: {},
    1048: {},
    1054: {
      f: AR
    },
    1084: {},
    1212: {
      f: tz
    },
    2048: {
      f: mz
    },
    2049: {},
    2050: {},
    2051: {},
    2052: {},
    2053: {},
    2054: {},
    2055: {},
    2056: {},
    2057: {
      f: iR
    },
    2058: {},
    2059: {},
    2060: {},
    2061: {},
    2062: {},
    2063: {},
    2064: {},
    2066: {},
    2067: {},
    2128: {},
    2129: {},
    2130: {},
    2131: {},
    2132: {},
    2133: {},
    2134: {},
    2135: {},
    2136: {},
    2137: {},
    2138: {},
    2146: {},
    2147: {
      r: 12
    },
    2148: {},
    2149: {},
    2150: {},
    2151: {
      f: mL
    },
    2152: {},
    2154: {},
    2155: {},
    2156: {},
    2161: {},
    2162: {},
    2164: {},
    2165: {},
    2166: {},
    2167: {},
    2168: {},
    2169: {},
    2170: {},
    2171: {},
    2172: {
      f: bz,
      r: 12
    },
    2173: {
      f: $V,
      r: 12
    },
    2174: {},
    2175: {},
    2180: {},
    2181: {},
    2182: {},
    2183: {},
    2184: {},
    2185: {},
    2186: {},
    2187: {},
    2188: {
      f: _L,
      r: 12
    },
    2189: {},
    2190: {
      r: 12
    },
    2191: {},
    2192: {},
    2194: {},
    2195: {},
    2196: {
      f: ez,
      r: 12
    },
    2197: {},
    2198: {
      f: qV,
      r: 12
    },
    2199: {},
    2200: {},
    2201: {},
    2202: {
      f: rz,
      r: 12
    },
    2203: {
      f: mL
    },
    2204: {},
    2205: {},
    2206: {},
    2207: {},
    2211: {
      f: gR
    },
    2212: {},
    2213: {},
    2214: {},
    2215: {},
    4097: {},
    4098: {},
    4099: {},
    4102: {},
    4103: {},
    4105: {},
    4106: {},
    4107: {},
    4108: {},
    4109: {},
    4116: {},
    4117: {},
    4118: {},
    4119: {},
    4120: {},
    4121: {},
    4122: {},
    4123: {},
    4124: {},
    4125: {},
    4126: {},
    4127: {},
    4128: {},
    4129: {},
    4130: {},
    4132: {},
    4133: {},
    4134: {
      f: yL
    },
    4135: {},
    4146: {},
    4147: {},
    4148: {},
    4149: {},
    4154: {},
    4156: {},
    4157: {},
    4158: {},
    4159: {},
    4160: {},
    4161: {},
    4163: {},
    4164: {
      f: wz
    },
    4165: {},
    4166: {},
    4168: {},
    4170: {},
    4171: {},
    4174: {},
    4175: {},
    4176: {},
    4177: {},
    4187: {},
    4188: {
      f: vz
    },
    4189: {},
    4191: {},
    4192: {},
    4193: {},
    4194: {},
    4195: {},
    4196: {},
    4197: {},
    4198: {},
    4199: {},
    4200: {},
    0: {
      f: NR
    },
    1: {},
    2: {
      f: Nz
    },
    3: {
      f: jz
    },
    4: {
      f: Az
    },
    5: {
      f: UR
    },
    7: {
      f: Fz
    },
    8: {},
    9: {
      f: iR
    },
    11: {},
    22: {
      f: yL
    },
    30: {
      f: MR
    },
    31: {},
    32: {},
    33: {
      f: nz
    },
    36: {},
    37: {
      f: vR
    },
    50: {
      f: Iz
    },
    62: {},
    52: {},
    67: {},
    68: {
      f: yL
    },
    69: {},
    86: {},
    126: {},
    127: {
      f: kz
    },
    135: {},
    136: {},
    137: {},
    145: {},
    148: {},
    149: {},
    150: {},
    169: {},
    171: {},
    188: {},
    191: {},
    192: {},
    194: {},
    195: {},
    214: {
      f: Lz
    },
    223: {},
    234: {},
    354: {},
    421: {},
    518: {
      f: OW
    },
    521: {
      f: iR
    },
    536: {
      f: ZR
    },
    547: {
      f: YR
    },
    561: {},
    579: {},
    1030: {
      f: OW
    },
    1033: {
      f: iR
    },
    1091: {},
    2157: {},
    2163: {},
    2177: {},
    2240: {},
    2241: {},
    2242: {},
    2243: {},
    2244: {},
    2245: {},
    2246: {},
    2247: {},
    2248: {},
    2249: {},
    2250: {},
    2251: {},
    2262: {
      r: 12
    },
    29282: {}
  };
function OJ(e, t, n, r) {
  var i = t;
  if (!isNaN(i)) {
    var a = r || (n || []).length || 0,
      o = e.next(4);
    o.write_shift(2, i), o.write_shift(2, a), a > 0 && xP(n) && e.push(n);
  }
}
function kJ(e, t, n, r) {
  var i = r || (n || []).length || 0;
  if (i <= 8224) return OJ(e, t, n, i);
  var a = t;
  if (!isNaN(a)) {
    for (var o = n.parts || [], s = 0, c = 0, l = 0; l + (o[s] || 8224) <= 8224;) l += o[s] || 8224, s++;
    var u = e.next(4);
    for (u.write_shift(2, a), u.write_shift(2, l), e.push(n.slice(c, c + l)), c += l; c < i;) {
      for (u = e.next(4), u.write_shift(2, 60), l = 0; l + (o[s] || 8224) <= 8224;) l += o[s] || 8224, s++;
      u.write_shift(2, l), e.push(n.slice(c, c + l)), c += l;
    }
  }
}
function AJ(e, t, n) {
  return e ||= Z(7), e.write_shift(2, t), e.write_shift(2, n), e.write_shift(2, 0), e.write_shift(1, 0), e;
}
function jJ(e, t, n, r) {
  var i = Z(9);
  return AJ(i, e, t), CL(n, r || `b`, i), i;
}
function MJ(e, t, n) {
  var r = Z(8 + 2 * n.length);
  return AJ(r, e, t), r.write_shift(1, n.length), r.write_shift(n.length, n, `sbcs`), r.l < r.length ? r.slice(0, r.l) : r;
}
function NJ(e, t, n, r) {
  if (t.v != null) switch (t.t) {
    case `d`:
    case `n`:
      var i = t.t == `d` ? PM(UM(t.v)) : t.v;
      i == (i | 0) && i >= 0 && i < 65536 ? OJ(e, 2, Pz(n, r, i)) : OJ(e, 3, Mz(n, r, i));
      return;
    case `b`:
    case `e`:
      OJ(e, 5, jJ(n, r, t.v, t.t));
      return;
    case `s`:
    case `str`:
      OJ(e, 4, MJ(n, r, (t.v || ``).slice(0, 255)));
      return;
  }
  OJ(e, 1, AJ(null, n, r));
}
function PJ(e, t, n, r) {
  var i = Array.isArray(t),
    a = nF(t[`!ref`] || `A1`),
    o,
    s = ``,
    c = [];
  if (a.e.c > 255 || a.e.r > 16383) {
    if (r.WTF) throw Error(`Range ` + (t[`!ref`] || `A1`) + ` exceeds format limit A1:IV16384`);
    a.e.c = Math.min(a.e.c, 255), a.e.r = Math.min(a.e.c, 16383), o = tF(a);
  }
  for (var l = a.s.r; l <= a.e.r; ++l) {
    s = WP(l);
    for (var u = a.s.c; u <= a.e.c; ++u) {
      l === a.s.r && (c[u] = JP(u)), o = c[u] + s;
      var d = i ? (t[l] || [])[u] : t[o];
      d && NJ(e, d, l, u, r);
    }
  }
}
function FJ(e, t) {
  var n = t || {};
  WA != null && n.dense == null && (n.dense = WA);
  for (var r = RP(), i = 0, a = 0; a < e.SheetNames.length; ++a) e.SheetNames[a] == n.sheet && (i = a);
  if (i == 0 && n.sheet && e.SheetNames[0] != n.sheet) throw Error(`Sheet not found: ` + n.sheet);
  return OJ(r, n.biff == 4 ? 1033 : n.biff == 3 ? 521 : 9, aR(e, 16, n)), PJ(r, e.Sheets[e.SheetNames[i]], i, n, e), OJ(r, 10), r.end();
}
function IJ(e, t, n) {
  OJ(e, 49, TR({
    sz: 12,
    color: {
      theme: 1
    },
    name: `Arial`,
    family: 2,
    scheme: `minor`
  }, n));
}
function LJ(e, t, n) {
  t && [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (r) {
    for (var i = r[0]; i <= r[1]; ++i) t[i] != null && OJ(e, 1054, jR(i, t[i], n));
  });
}
function RJ(e, t) {
  var n = Z(19);
  n.write_shift(4, 2151), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(2, 3), n.write_shift(1, 1), n.write_shift(4, 0), OJ(e, 2151, n), n = Z(39), n.write_shift(4, 2152), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(2, 3), n.write_shift(1, 0), n.write_shift(4, 0), n.write_shift(2, 1), n.write_shift(4, 4), n.write_shift(2, 0), YL(nF(t[`!ref`] || `A1`), n), n.write_shift(4, 4), OJ(e, 2152, n);
}
function zJ(e, t) {
  for (var n = 0; n < 16; ++n) OJ(e, 224, BR({
    numFmtId: 0,
    style: !0
  }, 0, t));
  t.cellXfs.forEach(function (n) {
    OJ(e, 224, BR(n, 0, t));
  });
}
function BJ(e, t) {
  for (var n = 0; n < t[`!links`].length; ++n) {
    var r = t[`!links`][n];
    OJ(e, 440, pz(r)), r[1].Tooltip && OJ(e, 2048, hz(r));
  }
  delete t[`!links`];
}
function VJ(e, t) {
  if (t) {
    var n = 0;
    t.forEach(function (t, r) {
      ++n <= 256 && t && OJ(e, 125, Sz(KW(r, t), r));
    });
  }
}
function HJ(e, t, n, r, i) {
  var a = 16 + JW(i.cellXfs, t, i);
  if (t.v == null && !t.bf) {
    OJ(e, 513, HL(n, r, a));
    return;
  }
  if (t.bf) OJ(e, 6, kW(t, n, r, i, a));else switch (t.t) {
    case `d`:
    case `n`:
      OJ(e, 515, KR(n, r, t.t == `d` ? PM(UM(t.v)) : t.v, a, i));
      break;
    case `b`:
    case `e`:
      OJ(e, 517, WR(n, r, t.v, a, i, t.t));
      break;
    case `s`:
    case `str`:
      i.bookSST ? OJ(e, 253, DR(n, r, GW(i.Strings, t.v, i.revStrings), a, i)) : OJ(e, 516, kR(n, r, (t.v || ``).slice(0, 255), a, i));
      break;
    default:
      OJ(e, 513, HL(n, r, a));
  }
}
function UJ(e, t, n) {
  var r = RP(),
    i = n.SheetNames[e],
    a = n.Sheets[i] || {},
    o = (n || {}).Workbook || {},
    s = (o.Sheets || [])[e] || {},
    c = Array.isArray(a),
    l = t.biff == 8,
    u,
    d = ``,
    f = [],
    p = nF(a[`!ref`] || `A1`),
    m = l ? 65536 : 16384;
  if (p.e.c > 255 || p.e.r >= m) {
    if (t.WTF) throw Error(`Range ` + (a[`!ref`] || `A1`) + ` exceeds format limit A1:IV16384`);
    p.e.c = Math.min(p.e.c, 255), p.e.r = Math.min(p.e.c, m - 1);
  }
  OJ(r, 2057, aR(n, 16, t)), OJ(r, 13, bL(1)), OJ(r, 12, bL(100)), OJ(r, 15, vL(!0)), OJ(r, 17, vL(!1)), OJ(r, 16, IF(.001)), OJ(r, 95, vL(!0)), OJ(r, 42, vL(!1)), OJ(r, 43, vL(!1)), OJ(r, 130, bL(1)), OJ(r, 128, HR([0, 0])), OJ(r, 131, vL(!1)), OJ(r, 132, vL(!1)), l && VJ(r, a[`!cols`]), OJ(r, 512, PR(p, t)), l && (a[`!links`] = []);
  for (var h = p.s.r; h <= p.e.r; ++h) {
    d = WP(h);
    for (var g = p.s.c; g <= p.e.c; ++g) {
      h === p.s.r && (f[g] = JP(g)), u = f[g] + d;
      var _ = c ? (a[h] || [])[g] : a[u];
      _ && (HJ(r, _, h, g, t), l && _.l && a[`!links`].push([u, _.l]));
    }
  }
  var v = s.CodeName || s.name || i;
  return l && OJ(r, 574, SR((o.Views || [])[0])), l && (a[`!merges`] || []).length && OJ(r, 229, sz(a[`!merges`])), l && BJ(r, a), OJ(r, 442, AL(v, t)), l && RJ(r, a), OJ(r, 10), r.end();
}
function WJ(e, t, n) {
  var r = RP(),
    i = (e || {}).Workbook || {},
    a = i.Sheets || [],
    o = i.WBProps || {},
    s = n.biff == 8,
    c = n.biff == 5;
  OJ(r, 2057, aR(e, 5, n)), n.bookType == `xla` && OJ(r, 135), OJ(r, 225, s ? bL(1200) : null), OJ(r, 193, hL(2)), c && OJ(r, 191), c && OJ(r, 192), OJ(r, 226), OJ(r, 92, cR(`SheetJS`, n)), OJ(r, 66, bL(s ? 1200 : 1252)), s && OJ(r, 353, bL(0)), s && OJ(r, 448), OJ(r, 317, Tz(e.SheetNames.length)), s && e.vbaraw && OJ(r, 211), s && e.vbaraw && OJ(r, 442, AL(o.CodeName || `ThisWorkbook`, n)), OJ(r, 156, bL(17)), OJ(r, 25, vL(!1)), OJ(r, 18, vL(!1)), OJ(r, 19, bL(0)), s && OJ(r, 431, vL(!1)), s && OJ(r, 444, bL(0)), OJ(r, 61, bR(n)), OJ(r, 64, vL(!1)), OJ(r, 141, bL(0)), OJ(r, 34, vL(aq(e) == `true`)), OJ(r, 14, vL(!0)), s && OJ(r, 439, vL(!1)), OJ(r, 218, bL(0)), IJ(r, e, n), LJ(r, e.SSF, n), zJ(r, n), s && OJ(r, 352, vL(!1));
  var l = r.end(),
    u = RP();
  s && OJ(u, 140, _z()), s && n.Strings && kJ(u, 252, pR(n.Strings, n)), OJ(u, 10);
  var d = u.end(),
    f = RP(),
    p = 0,
    m = 0;
  for (m = 0; m < e.SheetNames.length; ++m) p += (s ? 12 : 11) + (s ? 2 : 1) * e.SheetNames[m].length;
  var h = l.length + p + d.length;
  for (m = 0; m < e.SheetNames.length; ++m) {
    var g = a[m] || {};
    OJ(f, 133, dR({
      pos: h,
      hs: g.Hidden || 0,
      dt: 0,
      name: e.SheetNames[m]
    }, n)), h += t[m].length;
  }
  var _ = f.end();
  if (p != _.length) throw Error(`BS8 ` + p + ` != ` + _.length);
  var v = [];
  return l.length && v.push(l), _.length && v.push(_), d.length && v.push(d), ij(v);
}
function GJ(e, t) {
  var n = t || {},
    r = [];
  e && !e.SSF && (e.SSF = GM(bj)), e && e.SSF && (hM(), mM(e.SSF), n.revssf = jM(e.SSF), n.revssf[e.SSF[65535]] = 0, n.ssf = e.SSF), n.Strings = [], n.Strings.Count = 0, n.Strings.Unique = 0, XY(n), n.cellXfs = [], JW(n.cellXfs, {}, {
    revssf: {
      General: 0
    }
  }), e.Props ||= {};
  for (var i = 0; i < e.SheetNames.length; ++i) r[r.length] = UJ(i, n, e);
  return r.unshift(WJ(e, r, n)), ij(r);
}
function KJ(e, t) {
  for (var n = 0; n <= e.SheetNames.length; ++n) {
    var r = e.Sheets[e.SheetNames[n]];
    r && r[`!ref`] && eF(r[`!ref`]).e.c > 255 && typeof console < `u` && console.error && console.error(`Worksheet '` + e.SheetNames[n] + `' extends beyond column IV (255).  Data may be lost.`);
  }
  var i = t || {};
  switch (i.biff || 2) {
    case 8:
    case 5:
      return GJ(e, t);
    case 4:
    case 3:
    case 2:
      return FJ(e, t);
  }
  throw Error(`invalid type ` + i.bookType + ` for BIFF`);
}
function qJ(e, t) {
  var n = t || {};
  WA != null && n.dense == null && (n.dense = WA);
  var r = n.dense ? [] : {};
  e = e.replace(/<!--.*?-->/g, ``);
  var i = e.match(/<table/i);
  if (!i) throw Error(`Invalid HTML: could not find <table>`);
  var a = e.match(/<\/table/i),
    o = i.index,
    s = a && a.index || e.length,
    c = XM(e.slice(o, s), /(:?<tr[^>]*>)/i, `<tr>`),
    l = -1,
    u = 0,
    d = 0,
    f = 0,
    p = {
      s: {
        r: 1e7,
        c: 1e7
      },
      e: {
        r: 0,
        c: 0
      }
    },
    m = [];
  for (o = 0; o < c.length; ++o) {
    var h = c[o].trim(),
      g = h.slice(0, 3).toLowerCase();
    if (g == `<tr`) {
      if (++l, n.sheetRows && n.sheetRows <= l) {
        --l;
        break;
      }
      u = 0;
      continue;
    }
    if (g == `<td` || g == `<th`) {
      var _ = h.split(/<\/t[dh]>/i);
      for (s = 0; s < _.length; ++s) {
        var v = _[s].trim();
        if (v.match(/<t[dh]/i)) {
          for (var y = v, b = 0; y.charAt(0) == `<` && (b = y.indexOf(`>`)) > -1;) y = y.slice(b + 1);
          for (var x = 0; x < m.length; ++x) {
            var S = m[x];
            S.s.c == u && S.s.r < l && l <= S.e.r && (u = S.e.c + 1, x = -1);
          }
          var C = gN(v.slice(0, v.indexOf(`>`)));
          f = C.colspan ? +C.colspan : 1, ((d = +C.rowspan) > 1 || f > 1) && m.push({
            s: {
              r: l,
              c: u
            },
            e: {
              r: l + (d || 1) - 1,
              c: u + f - 1
            }
          });
          var w = C.t || C[`data-t`] || ``;
          if (!y.length) {
            u += f;
            continue;
          }
          if (y = RN(y), p.s.r > l && (p.s.r = l), p.e.r < l && (p.e.r = l), p.s.c > u && (p.s.c = u), p.e.c < u && (p.e.c = u), !y.length) {
            u += f;
            continue;
          }
          var T = {
            t: `s`,
            v: y
          };
          n.raw || !y.trim().length || w == `s` || (y === `TRUE` ? T = {
            t: `b`,
            v: !0
          } : y === `FALSE` ? T = {
            t: `b`,
            v: !1
          } : isNaN(qM(y)) ? isNaN(YM(y).getDate()) || (T = {
            t: `d`,
            v: UM(y)
          }, n.cellDates || (T = {
            t: `n`,
            v: PM(T.v)
          }), T.z = n.dateNF || bj[14]) : T = {
            t: `n`,
            v: qM(y)
          }), n.dense ? (r[l] || (r[l] = []), r[l][u] = T) : r[$P({
            r: l,
            c: u
          })] = T, u += f;
        }
      }
    }
  }
  return r[`!ref`] = tF(p), m.length && (r[`!merges`] = m), r;
}
function JJ(e, t, n, r) {
  for (var i = e[`!merges`] || [], a = [], o = t.s.c; o <= t.e.c; ++o) {
    for (var s = 0, c = 0, l = 0; l < i.length; ++l) if (!(i[l].s.r > n || i[l].s.c > o) && !(i[l].e.r < n || i[l].e.c < o)) {
      if (i[l].s.r < n || i[l].s.c < o) {
        s = -1;
        break;
      }
      s = i[l].e.r - i[l].s.r + 1, c = i[l].e.c - i[l].s.c + 1;
      break;
    }
    if (!(s < 0)) {
      var u = $P({
          r: n,
          c: o
        }),
        d = r.dense ? (e[n] || [])[o] : e[u],
        f = d && d.v != null && (d.h || EN(d.w || (iF(d), d.w) || ``)) || ``,
        p = {};
      s > 1 && (p.rowspan = s), c > 1 && (p.colspan = c), r.editable ? f = `<span contenteditable="true">` + f + `</span>` : d && (p[`data-t`] = d && d.t || `z`, d.v != null && (p[`data-v`] = d.v), d.z != null && (p[`data-z`] = d.z), d.l && (d.l.Target || `#`).charAt(0) != `#` && (f = `<a href="` + d.l.Target + `">` + f + `</a>`)), p.id = (r.id || `sjs`) + `-` + u, a.push(X(`td`, f, p));
    }
  }
  return `<tr>` + a.join(``) + `</tr>`;
}
var YJ = `<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>`,
  XJ = `</body></html>`;
function ZJ(e, t) {
  var n = e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!n || n.length == 0) throw Error(`Invalid HTML: could not find <table>`);
  if (n.length == 1) return aF(qJ(n[0], t), t);
  var r = VX();
  return n.forEach(function (e, n) {
    HX(r, qJ(e, t), `Sheet` + (n + 1));
  }), r;
}
function QJ(e, t, n) {
  return [].join(``) + `<table` + (n && n.id ? ` id="` + n.id + `"` : ``) + `>`;
}
function $J(e, t) {
  var n = t || {},
    r = n.header == null ? YJ : n.header,
    i = n.footer == null ? XJ : n.footer,
    a = [r],
    o = eF(e[`!ref`]);
  n.dense = Array.isArray(e), a.push(QJ(e, o, n));
  for (var s = o.s.r; s <= o.e.r; ++s) a.push(JJ(e, o, s, n));
  return a.push(`</table>` + i), a.join(``);
}
function eY(e, t, n) {
  var r = n || {};
  WA != null && (r.dense = WA);
  var i = 0,
    a = 0;
  if (r.origin != null) {
    if (typeof r.origin == `number`) i = r.origin;else {
      var o = typeof r.origin == `string` ? QP(r.origin) : r.origin;
      i = o.r, a = o.c;
    }
  }
  var s = t.getElementsByTagName(`tr`),
    c = Math.min(r.sheetRows || 1e7, s.length),
    l = {
      s: {
        r: 0,
        c: 0
      },
      e: {
        r: i,
        c: a
      }
    };
  if (e[`!ref`]) {
    var u = eF(e[`!ref`]);
    l.s.r = Math.min(l.s.r, u.s.r), l.s.c = Math.min(l.s.c, u.s.c), l.e.r = Math.max(l.e.r, u.e.r), l.e.c = Math.max(l.e.c, u.e.c), i == -1 && (l.e.r = i = u.e.r + 1);
  }
  var d = [],
    f = 0,
    p = e[`!rows`] ||= [],
    m = 0,
    h = 0,
    g = 0,
    _ = 0,
    v = 0,
    y = 0;
  for (e[`!cols`] ||= []; m < s.length && h < c; ++m) {
    var b = s[m];
    if (rY(b)) {
      if (r.display) continue;
      p[h] = {
        hidden: !0
      };
    }
    var x = b.children;
    for (g = _ = 0; g < x.length; ++g) {
      var S = x[g];
      if (!(r.display && rY(S))) {
        var C = S.hasAttribute(`data-v`) ? S.getAttribute(`data-v`) : S.hasAttribute(`v`) ? S.getAttribute(`v`) : RN(S.innerHTML),
          w = S.getAttribute(`data-z`) || S.getAttribute(`z`);
        for (f = 0; f < d.length; ++f) {
          var T = d[f];
          T.s.c == _ + a && T.s.r < h + i && h + i <= T.e.r && (_ = T.e.c + 1 - a, f = -1);
        }
        y = +S.getAttribute(`colspan`) || 1, ((v = +S.getAttribute(`rowspan`) || 1) > 1 || y > 1) && d.push({
          s: {
            r: h + i,
            c: _ + a
          },
          e: {
            r: h + i + (v || 1) - 1,
            c: _ + a + (y || 1) - 1
          }
        });
        var E = {
            t: `s`,
            v: C
          },
          D = S.getAttribute(`data-t`) || S.getAttribute(`t`) || ``;
        C != null && (C.length == 0 ? E.t = D || `z` : r.raw || C.trim().length == 0 || D == `s` || (C === `TRUE` ? E = {
          t: `b`,
          v: !0
        } : C === `FALSE` ? E = {
          t: `b`,
          v: !1
        } : isNaN(qM(C)) ? isNaN(YM(C).getDate()) || (E = {
          t: `d`,
          v: UM(C)
        }, r.cellDates || (E = {
          t: `n`,
          v: PM(E.v)
        }), E.z = r.dateNF || bj[14]) : E = {
          t: `n`,
          v: qM(C)
        })), E.z === void 0 && w != null && (E.z = w);
        var O = ``,
          k = S.getElementsByTagName(`A`);
        if (k && k.length) for (var A = 0; A < k.length && !(k[A].hasAttribute(`href`) && (O = k[A].getAttribute(`href`), O.charAt(0) != `#`)); ++A);
        O && O.charAt(0) != `#` && (E.l = {
          Target: O
        }), r.dense ? (e[h + i] || (e[h + i] = []), e[h + i][_ + a] = E) : e[$P({
          c: _ + a,
          r: h + i
        })] = E, l.e.c < _ + a && (l.e.c = _ + a), _ += y;
      }
    }
    ++h;
  }
  return d.length && (e[`!merges`] = (e[`!merges`] || []).concat(d)), l.e.r = Math.max(l.e.r, h - 1 + i), e[`!ref`] = tF(l), h >= c && (e[`!fullref`] = tF((l.e.r = s.length - m + h - 1 + i, l))), e;
}
function tY(e, t) {
  return eY((t || {}).dense ? [] : {}, e, t);
}
function nY(e, t) {
  return aF(tY(e, t), t);
}
function rY(e) {
  var t = ``,
    n = iY(e);
  return n && (t = n(e).getPropertyValue(`display`)), t ||= e.style && e.style.display, t === `none`;
}
function iY(e) {
  return e.ownerDocument.defaultView && typeof e.ownerDocument.defaultView.getComputedStyle == `function` ? e.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == `function` ? getComputedStyle : null;
}
function aY(e) {
  return [bN(e.replace(/[\t\r\n]/g, ` `).trim().replace(/ +/g, ` `).replace(/<text:s\/>/g, ` `).replace(/<text:s text:c="(\d+)"\/>/g, function (e, t) {
    return Array(parseInt(t, 10) + 1).join(` `);
  }).replace(/<text:tab[^>]*\/>/g, `	`).replace(/<text:line-break\/>/g, `
`).replace(/<[^>]*>/g, ``))];
}
var oY = {
  day: [`d`, `dd`],
  month: [`m`, `mm`],
  year: [`y`, `yy`],
  hours: [`h`, `hh`],
  minutes: [`m`, `mm`],
  seconds: [`s`, `ss`],
  "am-pm": [`A/P`, `AM/PM`],
  "day-of-week": [`ddd`, `dddd`],
  era: [`e`, `ee`],
  quarter: [`\\Qm`, `m\\"th quarter"`]
};
function sY(e, t) {
  var n = t || {};
  WA != null && n.dense == null && (n.dense = WA);
  var r = JN(e),
    i = [],
    a,
    o,
    s = {
      name: ``
    },
    c = ``,
    l = 0,
    u,
    d,
    f = {},
    p = [],
    m = n.dense ? [] : {},
    h,
    g,
    _ = {
      value: ``
    },
    v = ``,
    y = 0,
    b,
    x = [],
    S = -1,
    C = -1,
    w = {
      s: {
        r: 1e6,
        c: 1e7
      },
      e: {
        r: 0,
        c: 0
      }
    },
    T = 0,
    E = {},
    D = [],
    O = {},
    k = 0,
    A = 0,
    j = [],
    M = 1,
    N = 1,
    P = [],
    F = {
      Names: []
    },
    I = {},
    L = [``, ``],
    R = [],
    z = {},
    ee = ``,
    te = 0,
    B = !1,
    V = !1,
    H = 0;
  for (YN.lastIndex = 0, r = r.replace(/<!--([\s\S]*?)-->/gm, ``).replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ``); h = YN.exec(r);) switch (h[3] = h[3].replace(/_.*$/, ``)) {
    case `table`:
    case `工作表`:
      h[1] === `/` ? (w.e.c >= w.s.c && w.e.r >= w.s.r ? m[`!ref`] = tF(w) : m[`!ref`] = `A1:A1`, n.sheetRows > 0 && n.sheetRows <= w.e.r && (m[`!fullref`] = m[`!ref`], w.e.r = n.sheetRows - 1, m[`!ref`] = tF(w)), D.length && (m[`!merges`] = D), j.length && (m[`!rows`] = j), u.name = u.名称 || u.name, typeof JSON < `u` && JSON.stringify(u), p.push(u.name), f[u.name] = m, V = !1) : h[0].charAt(h[0].length - 2) !== `/` && (u = gN(h[0], !1), S = C = -1, w.s.r = w.s.c = 1e7, w.e.r = w.e.c = 0, m = n.dense ? [] : {}, D = [], j = [], V = !0);
      break;
    case `table-row-group`:
      h[1] === `/` ? --T : ++T;
      break;
    case `table-row`:
    case `行`:
      if (h[1] === `/`) {
        S += M, M = 1;
        break;
      }
      if (d = gN(h[0], !1), d.行号 ? S = d.行号 - 1 : S == -1 && (S = 0), M = +d[`number-rows-repeated`] || 1, M < 10) for (H = 0; H < M; ++H) T > 0 && (j[S + H] = {
        level: T
      });
      C = -1;
      break;
    case `covered-table-cell`:
      h[1] !== `/` && ++C, n.sheetStubs && (n.dense ? (m[S] || (m[S] = []), m[S][C] = {
        t: `z`
      }) : m[$P({
        r: S,
        c: C
      })] = {
        t: `z`
      }), v = ``, x = [];
      break;
    case `table-cell`:
    case `数据`:
      if (h[0].charAt(h[0].length - 2) === `/`) ++C, _ = gN(h[0], !1), N = parseInt(_[`number-columns-repeated`] || `1`, 10), g = {
        t: `z`,
        v: null
      }, _.formula && n.cellFormula != 0 && (g.f = RW(bN(_.formula))), (_.数据类型 || _[`value-type`]) == `string` && (g.t = `s`, g.v = bN(_[`string-value`] || ``), n.dense ? (m[S] || (m[S] = []), m[S][C] = g) : m[$P({
        r: S,
        c: C
      })] = g), C += N - 1;else if (h[1] !== `/`) {
        ++C, v = ``, y = 0, x = [], N = 1;
        var ne = M ? S + M - 1 : S;
        if (C > w.e.c && (w.e.c = C), C < w.s.c && (w.s.c = C), S < w.s.r && (w.s.r = S), ne > w.e.r && (w.e.r = ne), _ = gN(h[0], !1), R = [], z = {}, g = {
          t: _.数据类型 || _[`value-type`],
          v: null
        }, n.cellFormula) {
          if (_.formula && (_.formula = bN(_.formula)), _[`number-matrix-columns-spanned`] && _[`number-matrix-rows-spanned`] && (k = parseInt(_[`number-matrix-rows-spanned`], 10) || 0, A = parseInt(_[`number-matrix-columns-spanned`], 10) || 0, O = {
            s: {
              r: S,
              c: C
            },
            e: {
              r: S + k - 1,
              c: C + A - 1
            }
          }, g.F = tF(O), P.push([O, g.F])), _.formula) g.f = RW(_.formula);else for (H = 0; H < P.length; ++H) S >= P[H][0].s.r && S <= P[H][0].e.r && C >= P[H][0].s.c && C <= P[H][0].e.c && (g.F = P[H][1]);
        }
        switch ((_[`number-columns-spanned`] || _[`number-rows-spanned`]) && (k = parseInt(_[`number-rows-spanned`], 10) || 0, A = parseInt(_[`number-columns-spanned`], 10) || 0, O = {
          s: {
            r: S,
            c: C
          },
          e: {
            r: S + k - 1,
            c: C + A - 1
          }
        }, D.push(O)), _[`number-columns-repeated`] && (N = parseInt(_[`number-columns-repeated`], 10)), g.t) {
          case `boolean`:
            g.t = `b`, g.v = AN(_[`boolean-value`]);
            break;
          case `float`:
            g.t = `n`, g.v = parseFloat(_.value);
            break;
          case `percentage`:
            g.t = `n`, g.v = parseFloat(_.value);
            break;
          case `currency`:
            g.t = `n`, g.v = parseFloat(_.value);
            break;
          case `date`:
            g.t = `d`, g.v = UM(_[`date-value`]), n.cellDates || (g.t = `n`, g.v = PM(g.v)), g.z = `m/d/yy`;
            break;
          case `time`:
            g.t = `n`, g.v = zM(_[`time-value`]) / 86400, n.cellDates && (g.t = `d`, g.v = RM(g.v)), g.z = `HH:MM:SS`;
            break;
          case `number`:
            g.t = `n`, g.v = parseFloat(_.数据数值);
            break;
          default:
            if (g.t === `string` || g.t === `text` || !g.t) g.t = `s`, _[`string-value`] != null && (v = bN(_[`string-value`]), x = []);else throw Error(`Unsupported value type ` + g.t);
        }
      } else {
        if (B = !1, g.t === `s` && (g.v = v || ``, x.length && (g.R = x), B = y == 0), I.Target && (g.l = I), R.length > 0 && (g.c = R, R = []), v && n.cellText !== !1 && (g.w = v), B && (g.t = `z`, delete g.v), (!B || n.sheetStubs) && !(n.sheetRows && n.sheetRows <= S)) for (var re = 0; re < M; ++re) {
          if (N = parseInt(_[`number-columns-repeated`] || `1`, 10), n.dense) for (m[S + re] || (m[S + re] = []), m[S + re][C] = re == 0 ? g : GM(g); --N > 0;) m[S + re][C + N] = GM(g);else for (m[$P({
            r: S + re,
            c: C
          })] = g; --N > 0;) m[$P({
            r: S + re,
            c: C + N
          })] = GM(g);
          w.e.c <= C && (w.e.c = C);
        }
        N = parseInt(_[`number-columns-repeated`] || `1`, 10), C += N - 1, N = 0, g = {}, v = ``, x = [];
      }
      I = {};
      break;
    case `document`:
    case `document-content`:
    case `电子表格文档`:
    case `spreadsheet`:
    case `主体`:
    case `scripts`:
    case `styles`:
    case `font-face-decls`:
    case `master-styles`:
      if (h[1] === `/`) {
        if ((a = i.pop())[0] !== h[3]) throw `Bad state: ` + a;
      } else h[0].charAt(h[0].length - 2) !== `/` && i.push([h[3], !0]);
      break;
    case `annotation`:
      if (h[1] === `/`) {
        if ((a = i.pop())[0] !== h[3]) throw `Bad state: ` + a;
        z.t = v, x.length && (z.R = x), z.a = ee, R.push(z);
      } else h[0].charAt(h[0].length - 2) !== `/` && i.push([h[3], !1]);
      ee = ``, te = 0, v = ``, y = 0, x = [];
      break;
    case `creator`:
      h[1] === `/` ? ee = r.slice(te, h.index) : te = h.index + h[0].length;
      break;
    case `meta`:
    case `元数据`:
    case `settings`:
    case `config-item-set`:
    case `config-item-map-indexed`:
    case `config-item-map-entry`:
    case `config-item-map-named`:
    case `shapes`:
    case `frame`:
    case `text-box`:
    case `image`:
    case `data-pilot-tables`:
    case `list-style`:
    case `form`:
    case `dde-links`:
    case `event-listeners`:
    case `chart`:
      if (h[1] === `/`) {
        if ((a = i.pop())[0] !== h[3]) throw `Bad state: ` + a;
      } else h[0].charAt(h[0].length - 2) !== `/` && i.push([h[3], !1]);
      v = ``, y = 0, x = [];
      break;
    case `scientific-number`:
      break;
    case `currency-symbol`:
      break;
    case `currency-style`:
      break;
    case `number-style`:
    case `percentage-style`:
    case `date-style`:
    case `time-style`:
      if (h[1] === `/`) {
        if (E[s.name] = c, (a = i.pop())[0] !== h[3]) throw `Bad state: ` + a;
      } else h[0].charAt(h[0].length - 2) !== `/` && (c = ``, s = gN(h[0], !1), i.push([h[3], !0]));
      break;
    case `script`:
      break;
    case `libraries`:
      break;
    case `automatic-styles`:
      break;
    case `default-style`:
    case `page-layout`:
      break;
    case `style`:
      break;
    case `map`:
      break;
    case `font-face`:
      break;
    case `paragraph-properties`:
      break;
    case `table-properties`:
      break;
    case `table-column-properties`:
      break;
    case `table-row-properties`:
      break;
    case `table-cell-properties`:
      break;
    case `number`:
      switch (i[i.length - 1][0]) {
        case `time-style`:
        case `date-style`:
          o = gN(h[0], !1), c += oY[h[3]][+(o.style === `long`)];
      }
      break;
    case `fraction`:
      break;
    case `day`:
    case `month`:
    case `year`:
    case `era`:
    case `day-of-week`:
    case `week-of-year`:
    case `quarter`:
    case `hours`:
    case `minutes`:
    case `seconds`:
    case `am-pm`:
      switch (i[i.length - 1][0]) {
        case `time-style`:
        case `date-style`:
          o = gN(h[0], !1), c += oY[h[3]][+(o.style === `long`)];
      }
      break;
    case `boolean-style`:
      break;
    case `boolean`:
      break;
    case `text-style`:
      break;
    case `text`:
      if (h[0].slice(-2) === `/>`) break;
      if (h[1] === `/`) switch (i[i.length - 1][0]) {
        case `number-style`:
        case `date-style`:
        case `time-style`:
          c += r.slice(l, h.index);
      } else l = h.index + h[0].length;
      break;
    case `named-range`:
      o = gN(h[0], !1), L = BW(o[`cell-range-address`]);
      var ie = {
        Name: o.name,
        Ref: L[0] + `!` + L[1]
      };
      V && (ie.Sheet = p.length), F.Names.push(ie);
      break;
    case `text-content`:
      break;
    case `text-properties`:
      break;
    case `embedded-text`:
      break;
    case `body`:
    case `电子表格`:
      break;
    case `forms`:
      break;
    case `table-column`:
      break;
    case `table-header-rows`:
      break;
    case `table-rows`:
      break;
    case `table-column-group`:
      break;
    case `table-header-columns`:
      break;
    case `table-columns`:
      break;
    case `null-date`:
      break;
    case `graphic-properties`:
      break;
    case `calculation-settings`:
      break;
    case `named-expressions`:
      break;
    case `label-range`:
      break;
    case `label-ranges`:
      break;
    case `named-expression`:
      break;
    case `sort`:
      break;
    case `sort-by`:
      break;
    case `sort-groups`:
      break;
    case `tab`:
      break;
    case `line-break`:
      break;
    case `span`:
      break;
    case `p`:
    case `文本串`:
      if ([`master-styles`].indexOf(i[i.length - 1][0]) > -1) break;
      if (h[1] === `/` && (!_ || !_[`string-value`])) {
        var U = aY(r.slice(y, h.index), b);
        v = (v.length > 0 ? v + `
` : ``) + U[0];
      } else b = gN(h[0], !1), y = h.index + h[0].length;
      break;
    case `s`:
      break;
    case `database-range`:
      if (h[1] === `/`) break;
      try {
        L = BW(gN(h[0])[`target-range-address`]), f[L[0]][`!autofilter`] = {
          ref: L[1]
        };
      } catch {}
      break;
    case `date`:
      break;
    case `object`:
      break;
    case `title`:
    case `标题`:
      break;
    case `desc`:
      break;
    case `binary-data`:
      break;
    case `table-source`:
      break;
    case `scenario`:
      break;
    case `iteration`:
      break;
    case `content-validations`:
      break;
    case `content-validation`:
      break;
    case `help-message`:
      break;
    case `error-message`:
      break;
    case `database-ranges`:
      break;
    case `filter`:
      break;
    case `filter-and`:
      break;
    case `filter-or`:
      break;
    case `filter-condition`:
      break;
    case `list-level-style-bullet`:
      break;
    case `list-level-style-number`:
      break;
    case `list-level-properties`:
      break;
    case `sender-firstname`:
    case `sender-lastname`:
    case `sender-initials`:
    case `sender-title`:
    case `sender-position`:
    case `sender-email`:
    case `sender-phone-private`:
    case `sender-fax`:
    case `sender-company`:
    case `sender-phone-work`:
    case `sender-street`:
    case `sender-city`:
    case `sender-postal-code`:
    case `sender-country`:
    case `sender-state-or-province`:
    case `author-name`:
    case `author-initials`:
    case `chapter`:
    case `file-name`:
    case `template-name`:
    case `sheet-name`:
      break;
    case `event-listener`:
      break;
    case `initial-creator`:
    case `creation-date`:
    case `print-date`:
    case `generator`:
    case `document-statistic`:
    case `user-defined`:
    case `editing-duration`:
    case `editing-cycles`:
      break;
    case `config-item`:
      break;
    case `page-number`:
      break;
    case `page-count`:
      break;
    case `time`:
      break;
    case `cell-range-source`:
      break;
    case `detective`:
      break;
    case `operation`:
      break;
    case `highlighted-range`:
      break;
    case `data-pilot-table`:
    case `source-cell-range`:
    case `source-service`:
    case `data-pilot-field`:
    case `data-pilot-level`:
    case `data-pilot-subtotals`:
    case `data-pilot-subtotal`:
    case `data-pilot-members`:
    case `data-pilot-member`:
    case `data-pilot-display-info`:
    case `data-pilot-sort-info`:
    case `data-pilot-layout-info`:
    case `data-pilot-field-reference`:
    case `data-pilot-groups`:
    case `data-pilot-group`:
    case `data-pilot-group-member`:
      break;
    case `rect`:
      break;
    case `dde-connection-decls`:
    case `dde-connection-decl`:
    case `dde-link`:
    case `dde-source`:
      break;
    case `properties`:
      break;
    case `property`:
      break;
    case `a`:
      if (h[1] !== `/`) {
        if (I = gN(h[0], !1), !I.href) break;
        I.Target = bN(I.href), delete I.href, I.Target.charAt(0) == `#` && I.Target.indexOf(`.`) > -1 ? (L = BW(I.Target.slice(1)), I.Target = `#` + L[0] + `!` + L[1]) : I.Target.match(/^\.\.[\\\/]/) && (I.Target = I.Target.slice(3));
      }
      break;
    case `table-protection`:
      break;
    case `data-pilot-grand-total`:
      break;
    case `office-document-common-attrs`:
      break;
    default:
      switch (h[2]) {
        case `dc:`:
        case `calcext:`:
        case `loext:`:
        case `ooo:`:
        case `chartooo:`:
        case `draw:`:
        case `style:`:
        case `chart:`:
        case `form:`:
        case `uof:`:
        case `表:`:
        case `字:`:
          break;
        default:
          if (n.WTF) throw Error(h);
      }
  }
  var ae = {
    Sheets: f,
    SheetNames: p,
    Workbook: F
  };
  return n.bookSheets && delete ae.Sheets, ae;
}
function cY(e, t) {
  t ||= {}, eN(e, `META-INF/manifest.xml`) && SI(nN(e, `META-INF/manifest.xml`), t);
  var n = rN(e, `content.xml`);
  if (!n) throw Error(`Missing content.xml in ODS / UOF file`);
  var r = sY(FN(n), t);
  return eN(e, `meta.xml`) && (r.Props = AI(nN(e, `meta.xml`))), r;
}
function lY(e, t) {
  return sY(e, t);
}
var uY = function () {
    var e = [`<office:master-styles>`, `<style:master-page style:name="mp1" style:page-layout-name="mp1">`, `<style:header/>`, `<style:header-left style:display="false"/>`, `<style:footer/>`, `<style:footer-left style:display="false"/>`, `</style:master-page>`, `</office:master-styles>`].join(``),
      t = `<office:document-styles ` + GN({
        "xmlns:office": `urn:oasis:names:tc:opendocument:xmlns:office:1.0`,
        "xmlns:table": `urn:oasis:names:tc:opendocument:xmlns:table:1.0`,
        "xmlns:style": `urn:oasis:names:tc:opendocument:xmlns:style:1.0`,
        "xmlns:text": `urn:oasis:names:tc:opendocument:xmlns:text:1.0`,
        "xmlns:draw": `urn:oasis:names:tc:opendocument:xmlns:drawing:1.0`,
        "xmlns:fo": `urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0`,
        "xmlns:xlink": `http://www.w3.org/1999/xlink`,
        "xmlns:dc": `http://purl.org/dc/elements/1.1/`,
        "xmlns:number": `urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0`,
        "xmlns:svg": `urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0`,
        "xmlns:of": `urn:oasis:names:tc:opendocument:xmlns:of:1.2`,
        "office:version": `1.2`
      }) + `>` + e + `</office:document-styles>`;
    return function () {
      return uN + t;
    };
  }(),
  dY = function () {
    var e = function (e) {
        return CN(e).replace(/  +/g, function (e) {
          return `<text:s text:c="` + e.length + `"/>`;
        }).replace(/\t/g, `<text:tab/>`).replace(/\n/g, `</text:p><text:p>`).replace(/^ /, `<text:s/>`).replace(/ $/, `<text:s/>`);
      },
      t = `          <table:table-cell />
`,
      n = `          <table:covered-table-cell/>
`,
      r = function (r, i, a) {
        var o = [];
        o.push(`      <table:table table:name="` + CN(i.SheetNames[a]) + `" table:style-name="ta1">
`);
        var s = 0,
          c = 0,
          l = eF(r[`!ref`] || `A1`),
          u = r[`!merges`] || [],
          d = 0,
          f = Array.isArray(r);
        if (r[`!cols`]) for (c = 0; c <= l.e.c; ++c) o.push(`        <table:table-column` + (r[`!cols`][c] ? ` table:style-name="co` + r[`!cols`][c].ods + `"` : ``) + `></table:table-column>
`);
        var p = ``,
          m = r[`!rows`] || [];
        for (s = 0; s < l.s.r; ++s) p = m[s] ? ` table:style-name="ro` + m[s].ods + `"` : ``, o.push(`        <table:table-row` + p + `></table:table-row>
`);
        for (; s <= l.e.r; ++s) {
          for (p = m[s] ? ` table:style-name="ro` + m[s].ods + `"` : ``, o.push(`        <table:table-row` + p + `>
`), c = 0; c < l.s.c; ++c) o.push(t);
          for (; c <= l.e.c; ++c) {
            var h = !1,
              g = {},
              _ = ``;
            for (d = 0; d != u.length; ++d) if (!(u[d].s.c > c) && !(u[d].s.r > s) && !(u[d].e.c < c) && !(u[d].e.r < s)) {
              (u[d].s.c != c || u[d].s.r != s) && (h = !0), g[`table:number-columns-spanned`] = u[d].e.c - u[d].s.c + 1, g[`table:number-rows-spanned`] = u[d].e.r - u[d].s.r + 1;
              break;
            }
            if (h) {
              o.push(n);
              continue;
            }
            var v = $P({
                r: s,
                c
              }),
              y = f ? (r[s] || [])[c] : r[v];
            if (y && y.f && (g[`table:formula`] = CN(zW(y.f)), y.F && y.F.slice(0, v.length) == v)) {
              var b = eF(y.F);
              g[`table:number-matrix-columns-spanned`] = b.e.c - b.s.c + 1, g[`table:number-matrix-rows-spanned`] = b.e.r - b.s.r + 1;
            }
            if (!y) {
              o.push(t);
              continue;
            }
            switch (y.t) {
              case `b`:
                _ = y.v ? `TRUE` : `FALSE`, g[`office:value-type`] = `boolean`, g[`office:boolean-value`] = y.v ? `true` : `false`;
                break;
              case `n`:
                _ = y.w || String(y.v || 0), g[`office:value-type`] = `float`, g[`office:value`] = y.v || 0;
                break;
              case `s`:
              case `str`:
                _ = y.v == null ? `` : y.v, g[`office:value-type`] = `string`;
                break;
              case `d`:
                _ = y.w || UM(y.v).toISOString(), g[`office:value-type`] = `date`, g[`office:date-value`] = UM(y.v).toISOString(), g[`table:style-name`] = `ce1`;
                break;
              default:
                o.push(t);
                continue;
            }
            var x = e(_);
            if (y.l && y.l.Target) {
              var S = y.l.Target;
              S = S.charAt(0) == `#` ? `#` + VW(S.slice(1)) : S, S.charAt(0) != `#` && !S.match(/^\w+:/) && (S = `../` + S), x = X(`text:a`, x, {
                "xlink:href": S.replace(/&/g, `&amp;`)
              });
            }
            o.push(`          ` + X(`table:table-cell`, X(`text:p`, x, {}), g) + `
`);
          }
          o.push(`        </table:table-row>
`);
        }
        return o.push(`      </table:table>
`), o.join(``);
      },
      i = function (e, t) {
        e.push(` <office:automatic-styles>
`), e.push(`  <number:date-style style:name="N37" number:automatic-order="true">
`), e.push(`   <number:month number:style="long"/>
`), e.push(`   <number:text>/</number:text>
`), e.push(`   <number:day number:style="long"/>
`), e.push(`   <number:text>/</number:text>
`), e.push(`   <number:year/>
`), e.push(`  </number:date-style>
`);
        var n = 0;
        t.SheetNames.map(function (e) {
          return t.Sheets[e];
        }).forEach(function (t) {
          if (t && t[`!cols`]) {
            for (var r = 0; r < t[`!cols`].length; ++r) if (t[`!cols`][r]) {
              var i = t[`!cols`][r];
              if (i.width == null && i.wpx == null && i.wch == null) continue;
              JB(i), i.ods = n;
              var a = t[`!cols`][r].wpx + `px`;
              e.push(`  <style:style style:name="co` + n + `" style:family="table-column">
`), e.push(`   <style:table-column-properties fo:break-before="auto" style:column-width="` + a + `"/>
`), e.push(`  </style:style>
`), ++n;
            }
          }
        });
        var r = 0;
        t.SheetNames.map(function (e) {
          return t.Sheets[e];
        }).forEach(function (t) {
          if (t && t[`!rows`]) {
            for (var n = 0; n < t[`!rows`].length; ++n) if (t[`!rows`][n]) {
              t[`!rows`][n].ods = r;
              var i = t[`!rows`][n].hpx + `px`;
              e.push(`  <style:style style:name="ro` + r + `" style:family="table-row">
`), e.push(`   <style:table-row-properties fo:break-before="auto" style:row-height="` + i + `"/>
`), e.push(`  </style:style>
`), ++r;
            }
          }
        }), e.push(`  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">
`), e.push(`   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>
`), e.push(`  </style:style>
`), e.push(`  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>
`), e.push(` </office:automatic-styles>
`);
      };
    return function (e, t) {
      var n = [uN],
        a = GN({
          "xmlns:office": `urn:oasis:names:tc:opendocument:xmlns:office:1.0`,
          "xmlns:table": `urn:oasis:names:tc:opendocument:xmlns:table:1.0`,
          "xmlns:style": `urn:oasis:names:tc:opendocument:xmlns:style:1.0`,
          "xmlns:text": `urn:oasis:names:tc:opendocument:xmlns:text:1.0`,
          "xmlns:draw": `urn:oasis:names:tc:opendocument:xmlns:drawing:1.0`,
          "xmlns:fo": `urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0`,
          "xmlns:xlink": `http://www.w3.org/1999/xlink`,
          "xmlns:dc": `http://purl.org/dc/elements/1.1/`,
          "xmlns:meta": `urn:oasis:names:tc:opendocument:xmlns:meta:1.0`,
          "xmlns:number": `urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0`,
          "xmlns:presentation": `urn:oasis:names:tc:opendocument:xmlns:presentation:1.0`,
          "xmlns:svg": `urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0`,
          "xmlns:chart": `urn:oasis:names:tc:opendocument:xmlns:chart:1.0`,
          "xmlns:dr3d": `urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0`,
          "xmlns:math": `http://www.w3.org/1998/Math/MathML`,
          "xmlns:form": `urn:oasis:names:tc:opendocument:xmlns:form:1.0`,
          "xmlns:script": `urn:oasis:names:tc:opendocument:xmlns:script:1.0`,
          "xmlns:ooo": `http://openoffice.org/2004/office`,
          "xmlns:ooow": `http://openoffice.org/2004/writer`,
          "xmlns:oooc": `http://openoffice.org/2004/calc`,
          "xmlns:dom": `http://www.w3.org/2001/xml-events`,
          "xmlns:xforms": `http://www.w3.org/2002/xforms`,
          "xmlns:xsd": `http://www.w3.org/2001/XMLSchema`,
          "xmlns:xsi": `http://www.w3.org/2001/XMLSchema-instance`,
          "xmlns:sheet": `urn:oasis:names:tc:opendocument:sh33tjs:1.0`,
          "xmlns:rpt": `http://openoffice.org/2005/report`,
          "xmlns:of": `urn:oasis:names:tc:opendocument:xmlns:of:1.2`,
          "xmlns:xhtml": `http://www.w3.org/1999/xhtml`,
          "xmlns:grddl": `http://www.w3.org/2003/g/data-view#`,
          "xmlns:tableooo": `http://openoffice.org/2009/table`,
          "xmlns:drawooo": `http://openoffice.org/2010/draw`,
          "xmlns:calcext": `urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0`,
          "xmlns:loext": `urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0`,
          "xmlns:field": `urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0`,
          "xmlns:formx": `urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0`,
          "xmlns:css3t": `http://www.w3.org/TR/css3-text/`,
          "office:version": `1.2`
        }),
        o = GN({
          "xmlns:config": `urn:oasis:names:tc:opendocument:xmlns:config:1.0`,
          "office:mimetype": `application/vnd.oasis.opendocument.spreadsheet`
        });
      t.bookType == `fods` ? (n.push(`<office:document` + a + o + `>
`), n.push(DI().replace(/office:document-meta/g, `office:meta`))) : n.push(`<office:document-content` + a + `>
`), i(n, e), n.push(`  <office:body>
`), n.push(`    <office:spreadsheet>
`);
      for (var s = 0; s != e.SheetNames.length; ++s) n.push(r(e.Sheets[e.SheetNames[s]], e, s, t));
      return n.push(`    </office:spreadsheet>
`), n.push(`  </office:body>
`), t.bookType == `fods` ? n.push(`</office:document>`) : n.push(`</office:document-content>`), n.join(``);
    };
  }();
function fY(e, t) {
  if (t.bookType == `fods`) return dY(e, t);
  var n = sN(),
    r = ``,
    i = [],
    a = [];
  return r = `mimetype`, oN(n, r, `application/vnd.oasis.opendocument.spreadsheet`), r = `content.xml`, oN(n, r, dY(e, t)), i.push([r, `text/xml`]), a.push([r, `ContentFile`]), r = `styles.xml`, oN(n, r, uY(e, t)), i.push([r, `text/xml`]), a.push([r, `StylesFile`]), r = `meta.xml`, oN(n, r, uN + DI()), i.push([r, `text/xml`]), a.push([r, `MetadataFile`]), r = `manifest.rdf`, oN(n, r, EI(a)), i.push([r, `application/rdf+xml`]), r = `META-INF/manifest.xml`, oN(n, r, CI(i)), n;
}
function pY(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function mY(e) {
  return typeof TextDecoder < `u` ? new TextDecoder().decode(e) : FN(tj(e));
}
function hY(e) {
  return typeof TextEncoder < `u` ? new TextEncoder().encode(e) : $A(IN(e));
}
function gY(e, t) {
  outer: for (var n = 0; n <= e.length - t.length; ++n) {
    for (var r = 0; r < t.length; ++r) if (e[n + r] != t[r]) continue outer;
    return !0;
  }
  return !1;
}
function _Y(e) {
  var t = e.reduce(function (e, t) {
      return e + t.length;
    }, 0),
    n = new Uint8Array(t),
    r = 0;
  return e.forEach(function (e) {
    n.set(e, r), r += e.length;
  }), n;
}
function vY(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), (e + (e >> 4) & 252645135) * 16843009 >>> 24;
}
function yY(e, t) {
  for (var n = (e[t + 15] & 127) << 7 | e[t + 14] >> 1, r = e[t + 14] & 1, i = t + 13; i >= t; --i) r = r * 256 + e[i];
  return (e[t + 15] & 128 ? -r : r) * 10 ** (n - 6176);
}
function bY(e, t, n) {
  var r = Math.floor(n == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(n))) + 6176 - 20,
    i = n / 10 ** (r - 6176);
  e[t + 15] |= r >> 7, e[t + 14] |= (r & 127) << 1;
  for (var a = 0; i >= 1; ++a, i /= 256) e[t + a] = i & 255;
  e[t + 15] |= n >= 0 ? 0 : 128;
}
function xY(e, t) {
  var n = t ? t[0] : 0,
    r = e[n] & 127;
  varint: if (e[n++] >= 128 && (r |= (e[n] & 127) << 7, e[n++] < 128 || (r |= (e[n] & 127) << 14, e[n++] < 128) || (r |= (e[n] & 127) << 21, e[n++] < 128) || (r += (e[n] & 127) * 2 ** 28, ++n, e[n++] < 128) || (r += (e[n] & 127) * 2 ** 35, ++n, e[n++] < 128) || (r += (e[n] & 127) * 2 ** 42, ++n, e[n++] < 128))) break varint;
  return t && (t[0] = n), r;
}
function SY(e) {
  var t = new Uint8Array(7);
  t[0] = e & 127;
  var n = 1;
  sz: if (e > 127) {
    if (t[n - 1] |= 128, t[n] = e >> 7 & 127, ++n, e <= 16383 || (t[n - 1] |= 128, t[n] = e >> 14 & 127, ++n, e <= 2097151) || (t[n - 1] |= 128, t[n] = e >> 21 & 127, ++n, e <= 268435455) || (t[n - 1] |= 128, t[n] = e / 256 >>> 21 & 127, ++n, e <= 34359738367) || (t[n - 1] |= 128, t[n] = e / 65536 >>> 21 & 127, ++n, e <= 4398046511103)) break sz;
    t[n - 1] |= 128, t[n] = e / 16777216 >>> 21 & 127, ++n;
  }
  return t.slice(0, n);
}
function CY(e) {
  var t = 0,
    n = e[t] & 127;
  varint: if (e[t++] >= 128) {
    if (n |= (e[t] & 127) << 7, e[t++] < 128 || (n |= (e[t] & 127) << 14, e[t++] < 128) || (n |= (e[t] & 127) << 21, e[t++] < 128)) break varint;
    n |= (e[t] & 127) << 28;
  }
  return n;
}
function wY(e) {
  for (var t = [], n = [0]; n[0] < e.length;) {
    var r = n[0],
      i = xY(e, n),
      a = i & 7;
    i = Math.floor(i / 8);
    var o = 0,
      s;
    if (i == 0) break;
    switch (a) {
      case 0:
        for (var c = n[0]; e[n[0]++] >= 128;);
        s = e.slice(c, n[0]);
        break;
      case 5:
        o = 4, s = e.slice(n[0], n[0] + o), n[0] += o;
        break;
      case 1:
        o = 8, s = e.slice(n[0], n[0] + o), n[0] += o;
        break;
      case 2:
        o = xY(e, n), s = e.slice(n[0], n[0] + o), n[0] += o;
        break;
      default:
        throw Error(`PB Type ${a} for Field ${i} at offset ${r}`);
    }
    var l = {
      data: s,
      type: a
    };
    t[i] == null ? t[i] = [l] : t[i].push(l);
  }
  return t;
}
function TY(e) {
  var t = [];
  return e.forEach(function (e, n) {
    e.forEach(function (e) {
      e.data && (t.push(SY(n * 8 + e.type)), e.type == 2 && t.push(SY(e.data.length)), t.push(e.data));
    });
  }), _Y(t);
}
function EY(e, t) {
  return e?.map(function (e) {
    return t(e.data);
  }) || [];
}
function DY(e) {
  for (var t = [], n = [0]; n[0] < e.length;) {
    var r = xY(e, n),
      i = wY(e.slice(n[0], n[0] + r));
    n[0] += r;
    var a = {
      id: CY(i[1][0].data),
      messages: []
    };
    i[2].forEach(function (t) {
      var r = wY(t.data),
        i = CY(r[3][0].data);
      a.messages.push({
        meta: r,
        data: e.slice(n[0], n[0] + i)
      }), n[0] += i;
    }), i[3]?.[0] && (a.merge = CY(i[3][0].data) >>> 0 > 0), t.push(a);
  }
  return t;
}
function OY(e) {
  var t = [];
  return e.forEach(function (e) {
    var n = [];
    n[1] = [{
      data: SY(e.id),
      type: 0
    }], n[2] = [], e.merge != null && (n[3] = [{
      data: SY(+!!e.merge),
      type: 0
    }]);
    var r = [];
    e.messages.forEach(function (e) {
      r.push(e.data), e.meta[3] = [{
        type: 0,
        data: SY(e.data.length)
      }], n[2].push({
        data: TY(e.meta),
        type: 2
      });
    });
    var i = TY(n);
    t.push(SY(i.length)), t.push(i), r.forEach(function (e) {
      return t.push(e);
    });
  }), _Y(t);
}
function kY(e, t) {
  if (e != 0) throw Error(`Unexpected Snappy chunk type ${e}`);
  for (var n = [0], r = xY(t, n), i = []; n[0] < t.length;) {
    var a = t[n[0]] & 3;
    if (a == 0) {
      var o = t[n[0]++] >> 2;
      if (o < 60) ++o;else {
        var s = o - 59;
        o = t[n[0]], s > 1 && (o |= t[n[0] + 1] << 8), s > 2 && (o |= t[n[0] + 2] << 16), s > 3 && (o |= t[n[0] + 3] << 24), o >>>= 0, o++, n[0] += s;
      }
      i.push(t.slice(n[0], n[0] + o)), n[0] += o;
      continue;
    }
    var c = 0,
      l = 0;
    if (a == 1 ? (l = (t[n[0]] >> 2 & 7) + 4, c = (t[n[0]++] & 224) << 3, c |= t[n[0]++]) : (l = (t[n[0]++] >> 2) + 1, a == 2 ? (c = t[n[0]] | t[n[0] + 1] << 8, n[0] += 2) : (c = (t[n[0]] | t[n[0] + 1] << 8 | t[n[0] + 2] << 16 | t[n[0] + 3] << 24) >>> 0, n[0] += 4)), i = [_Y(i)], c == 0) throw Error(`Invalid offset 0`);
    if (c > i[0].length) throw Error(`Invalid offset beyond length`);
    if (l >= c) for (i.push(i[0].slice(-c)), l -= c; l >= i[i.length - 1].length;) i.push(i[i.length - 1]), l -= i[i.length - 1].length;
    i.push(i[0].slice(-c, -c + l));
  }
  var u = _Y(i);
  if (u.length != r) throw Error(`Unexpected length: ${u.length} != ${r}`);
  return u;
}
function AY(e) {
  for (var t = [], n = 0; n < e.length;) {
    var r = e[n++],
      i = e[n] | e[n + 1] << 8 | e[n + 2] << 16;
    n += 3, t.push(kY(r, e.slice(n, n + i))), n += i;
  }
  if (n !== e.length) throw Error(`data is not a valid framed stream!`);
  return _Y(t);
}
function jY(e) {
  for (var t = [], n = 0; n < e.length;) {
    var r = Math.min(e.length - n, 268435455),
      i = new Uint8Array(4);
    t.push(i);
    var a = SY(r),
      o = a.length;
    t.push(a), r <= 60 ? (o++, t.push(new Uint8Array([r - 1 << 2]))) : r <= 256 ? (o += 2, t.push(new Uint8Array([240, r - 1 & 255]))) : r <= 65536 ? (o += 3, t.push(new Uint8Array([244, r - 1 & 255, r - 1 >> 8 & 255]))) : r <= 16777216 ? (o += 4, t.push(new Uint8Array([248, r - 1 & 255, r - 1 >> 8 & 255, r - 1 >> 16 & 255]))) : r <= 4294967296 && (o += 5, t.push(new Uint8Array([252, r - 1 & 255, r - 1 >> 8 & 255, r - 1 >> 16 & 255, r - 1 >>> 24 & 255]))), t.push(e.slice(n, n + r)), o += r, i[0] = 0, i[1] = o & 255, i[2] = o >> 8 & 255, i[3] = o >> 16 & 255, n += r;
  }
  return _Y(t);
}
function MY(e, t, n, r) {
  var i = pY(e),
    a = i.getUint32(4, !0),
    o = (r > 1 ? 12 : 8) + vY(a & (r > 1 ? 3470 : 398)) * 4,
    s = -1,
    c = -1,
    l = NaN,
    u = new Date(2001, 0, 1);
  a & 512 && (s = i.getUint32(o, !0), o += 4), o += vY(a & (r > 1 ? 12288 : 4096)) * 4, a & 16 && (c = i.getUint32(o, !0), o += 4), a & 32 && (l = i.getFloat64(o, !0), o += 8), a & 64 && (u.setTime(u.getTime() + i.getFloat64(o, !0) * 1e3), o += 8);
  var d;
  switch (e[2]) {
    case 0:
      break;
    case 2:
      d = {
        t: `n`,
        v: l
      };
      break;
    case 3:
      d = {
        t: `s`,
        v: t[c]
      };
      break;
    case 5:
      d = {
        t: `d`,
        v: u
      };
      break;
    case 6:
      d = {
        t: `b`,
        v: l > 0
      };
      break;
    case 7:
      d = {
        t: `n`,
        v: l / 86400
      };
      break;
    case 8:
      d = {
        t: `e`,
        v: 0
      };
      break;
    case 9:
      if (s > -1) d = {
        t: `s`,
        v: n[s]
      };else if (c > -1) d = {
        t: `s`,
        v: t[c]
      };else if (!isNaN(l)) d = {
        t: `n`,
        v: l
      };else throw Error(`Unsupported cell type ${e.slice(0, 4)}`);
      break;
    default:
      throw Error(`Unsupported cell type ${e.slice(0, 4)}`);
  }
  return d;
}
function NY(e, t, n) {
  var r = pY(e),
    i = r.getUint32(8, !0),
    a = 12,
    o = -1,
    s = -1,
    c = NaN,
    l = NaN,
    u = new Date(2001, 0, 1);
  i & 1 && (c = yY(e, a), a += 16), i & 2 && (l = r.getFloat64(a, !0), a += 8), i & 4 && (u.setTime(u.getTime() + r.getFloat64(a, !0) * 1e3), a += 8), i & 8 && (s = r.getUint32(a, !0), a += 4), i & 16 && (o = r.getUint32(a, !0), a += 4);
  var d;
  switch (e[1]) {
    case 0:
      break;
    case 2:
      d = {
        t: `n`,
        v: c
      };
      break;
    case 3:
      d = {
        t: `s`,
        v: t[s]
      };
      break;
    case 5:
      d = {
        t: `d`,
        v: u
      };
      break;
    case 6:
      d = {
        t: `b`,
        v: l > 0
      };
      break;
    case 7:
      d = {
        t: `n`,
        v: l / 86400
      };
      break;
    case 8:
      d = {
        t: `e`,
        v: 0
      };
      break;
    case 9:
      if (o > -1) d = {
        t: `s`,
        v: n[o]
      };else throw Error(`Unsupported cell type ${e[1]} : ${i & 31} : ${e.slice(0, 4)}`);
      break;
    case 10:
      d = {
        t: `n`,
        v: c
      };
      break;
    default:
      throw Error(`Unsupported cell type ${e[1]} : ${i & 31} : ${e.slice(0, 4)}`);
  }
  return d;
}
function PY(e, t) {
  var n = new Uint8Array(32),
    r = pY(n),
    i = 12,
    a = 0;
  switch (n[0] = 5, e.t) {
    case `n`:
      n[1] = 2, bY(n, i, e.v), a |= 1, i += 16;
      break;
    case `b`:
      n[1] = 6, r.setFloat64(i, +!!e.v, !0), a |= 2, i += 8;
      break;
    case `s`:
      if (t.indexOf(e.v) == -1) throw Error(`Value ${e.v} missing from SST!`);
      n[1] = 3, r.setUint32(i, t.indexOf(e.v), !0), a |= 8, i += 4;
      break;
    default:
      throw `unsupported cell type ` + e.t;
  }
  return r.setUint32(8, a, !0), n.slice(0, i);
}
function FY(e, t) {
  var n = new Uint8Array(32),
    r = pY(n),
    i = 12,
    a = 0;
  switch (n[0] = 3, e.t) {
    case `n`:
      n[2] = 2, r.setFloat64(i, e.v, !0), a |= 32, i += 8;
      break;
    case `b`:
      n[2] = 6, r.setFloat64(i, +!!e.v, !0), a |= 32, i += 8;
      break;
    case `s`:
      if (t.indexOf(e.v) == -1) throw Error(`Value ${e.v} missing from SST!`);
      n[2] = 3, r.setUint32(i, t.indexOf(e.v), !0), a |= 16, i += 4;
      break;
    default:
      throw `unsupported cell type ` + e.t;
  }
  return r.setUint32(4, a, !0), n.slice(0, i);
}
function IY(e, t, n) {
  switch (e[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return MY(e, t, n, e[0]);
    case 5:
      return NY(e, t, n);
    default:
      throw Error(`Unsupported payload version ${e[0]}`);
  }
}
function LY(e) {
  return xY(wY(e)[1][0].data);
}
function RY(e, t) {
  var n = wY(t.data),
    r = CY(n[1][0].data),
    i = n[3],
    a = [];
  return (i || []).forEach(function (t) {
    var n = wY(t.data),
      i = CY(n[1][0].data) >>> 0;
    switch (r) {
      case 1:
        a[i] = mY(n[3][0].data);
        break;
      case 8:
        var o = e[LY(n[9][0].data)][0],
          s = e[LY(wY(o.data)[1][0].data)][0],
          c = CY(s.meta[1][0].data);
        if (c != 2001) throw Error(`2000 unexpected reference to ${c}`);
        a[i] = wY(s.data)[3].map(function (e) {
          return mY(e.data);
        }).join(``);
    }
  }), a;
}
function zY(e, t) {
  var n = wY(e),
    r = CY(n[1][0].data) >>> 0,
    i = CY(n[2][0].data) >>> 0,
    a = n[8]?.[0]?.data && CY(n[8][0].data) > 0 || !1,
    o,
    s;
  if (n[7]?.[0]?.data && t != 0) o = n[7]?.[0]?.data, s = n[6]?.[0]?.data;else if (n[4]?.[0]?.data && t != 1) o = n[4]?.[0]?.data, s = n[3]?.[0]?.data;else throw `NUMBERS Tile missing ${t} cell storage`;
  for (var c = a ? 4 : 1, l = pY(o), u = [], d = 0; d < o.length / 2; ++d) {
    var f = l.getUint16(d * 2, !0);
    f < 65535 && u.push([d, f]);
  }
  if (u.length != i) throw `Expected ${i} cells, found ${u.length}`;
  var p = [];
  for (d = 0; d < u.length - 1; ++d) p[u[d][0]] = s.subarray(u[d][1] * c, u[d + 1][1] * c);
  return u.length >= 1 && (p[u[u.length - 1][0]] = s.subarray(u[u.length - 1][1] * c)), {
    R: r,
    cells: p
  };
}
function BY(e, t) {
  var n = wY(t.data),
    r = n?.[7]?.[0] ? +(CY(n[7][0].data) >>> 0 > 0) : -1,
    i = EY(n[5], function (e) {
      return zY(e, r);
    });
  return {
    nrows: CY(n[4][0].data) >>> 0,
    data: i.reduce(function (e, t) {
      return e[t.R] || (e[t.R] = []), t.cells.forEach(function (n, r) {
        if (e[t.R][r]) throw Error(`Duplicate cell r=${t.R} c=${r}`);
        e[t.R][r] = n;
      }), e;
    }, [])
  };
}
function VY(e, t, n) {
  var r = wY(t.data),
    i = {
      s: {
        r: 0,
        c: 0
      },
      e: {
        r: 0,
        c: 0
      }
    };
  if (i.e.r = (CY(r[6][0].data) >>> 0) - 1, i.e.r < 0) throw Error(`Invalid row varint ${r[6][0].data}`);
  if (i.e.c = (CY(r[7][0].data) >>> 0) - 1, i.e.c < 0) throw Error(`Invalid col varint ${r[7][0].data}`);
  n[`!ref`] = tF(i);
  var a = wY(r[4][0].data),
    o = RY(e, e[LY(a[4][0].data)][0]),
    s = a[17]?.[0] ? RY(e, e[LY(a[17][0].data)][0]) : [],
    c = wY(a[3][0].data),
    l = 0;
  c[1].forEach(function (t) {
    var r = e[LY(wY(t.data)[2][0].data)][0],
      i = CY(r.meta[1][0].data);
    if (i != 6002) throw Error(`6001 unexpected reference to ${i}`);
    var a = BY(e, r);
    a.data.forEach(function (e, t) {
      e.forEach(function (e, r) {
        var i = $P({
            r: l + t,
            c: r
          }),
          a = IY(e, o, s);
        a && (n[i] = a);
      });
    }), l += a.nrows;
  });
}
function HY(e, t) {
  var n = wY(t.data),
    r = {
      "!ref": `A1`
    },
    i = e[LY(n[2][0].data)],
    a = CY(i[0].meta[1][0].data);
  if (a != 6001) throw Error(`6000 unexpected reference to ${a}`);
  return VY(e, i[0], r), r;
}
function UY(e, t) {
  var n = wY(t.data),
    r = {
      name: n[1]?.[0] ? mY(n[1][0].data) : ``,
      sheets: []
    };
  return EY(n[2], LY).forEach(function (t) {
    e[t].forEach(function (t) {
      CY(t.meta[1][0].data) == 6e3 && r.sheets.push(HY(e, t));
    });
  }), r;
}
function WY(e, t) {
  var n = VX();
  if (EY(wY(t.data)[1], LY).forEach(function (t) {
    e[t].forEach(function (t) {
      if (CY(t.meta[1][0].data) == 2) {
        var r = UY(e, t);
        r.sheets.forEach(function (e, t) {
          HX(n, e, t == 0 ? r.name : r.name + `_` + t, !0);
        });
      }
    });
  }), n.SheetNames.length == 0) throw Error(`Empty NUMBERS file`);
  return n;
}
function GY(e) {
  var t = {},
    n = [];
  if (e.FullPaths.forEach(function (e) {
    if (e.match(/\.iwpv2/)) throw Error(`Unsupported password protection`);
  }), e.FileIndex.forEach(function (e) {
    if (e.name.match(/\.iwa$/)) {
      var r;
      try {
        r = AY(e.content);
      } catch (t) {
        return console.log(`?? ` + e.content.length + ` ` + (t.message || t));
      }
      var i;
      try {
        i = DY(r);
      } catch (e) {
        return console.log(`## ` + (e.message || e));
      }
      i.forEach(function (e) {
        t[e.id] = e.messages, n.push(e.id);
      });
    }
  }), !n.length) throw Error(`File has no messages`);
  var r = t?.[1]?.[0]?.meta?.[1]?.[0].data && CY(t[1][0].meta[1][0].data) == 1 && t[1][0];
  if (r || n.forEach(function (e) {
    t[e].forEach(function (e) {
      if (CY(e.meta[1][0].data) >>> 0 == 1) {
        if (!r) r = e;else throw Error(`Document has multiple roots`);
      }
    });
  }), !r) throw Error(`Cannot find Document root`);
  return WY(t, r);
}
function KY(e, t, n) {
  if (!e[6]?.[0] || !e[7]?.[0]) throw `Mutation only works on post-BNC storages!`;
  if (e[8]?.[0]?.data && CY(e[8][0].data) > 0) throw `Math only works with normal offsets`;
  for (var r = 0, i = pY(e[7][0].data), a = 0, o = [], s = pY(e[4][0].data), c = 0, l = [], u = 0; u < t.length; ++u) {
    if (t[u] == null) {
      i.setUint16(u * 2, 65535, !0), s.setUint16(u * 2, 65535);
      continue;
    }
    i.setUint16(u * 2, a, !0), s.setUint16(u * 2, c, !0);
    var d, f;
    switch (typeof t[u]) {
      case `string`:
        d = PY({
          t: `s`,
          v: t[u]
        }, n), f = FY({
          t: `s`,
          v: t[u]
        }, n);
        break;
      case `number`:
        d = PY({
          t: `n`,
          v: t[u]
        }, n), f = FY({
          t: `n`,
          v: t[u]
        }, n);
        break;
      case `boolean`:
        d = PY({
          t: `b`,
          v: t[u]
        }, n), f = FY({
          t: `b`,
          v: t[u]
        }, n);
        break;
      default:
        throw Error(`Unsupported value ` + t[u]);
    }
    o.push(d), a += d.length, l.push(f), c += f.length, ++r;
  }
  for (e[2][0].data = SY(r); u < e[7][0].data.length / 2; ++u) i.setUint16(u * 2, 65535, !0), s.setUint16(u * 2, 65535, !0);
  return e[6][0].data = _Y(o), e[3][0].data = _Y(l), r;
}
function qY(e, t) {
  if (!t || !t.numbers) throw Error("Must pass a `numbers` option -- check the README");
  var n = e.Sheets[e.SheetNames[0]];
  e.SheetNames.length > 1 && console.error(`The Numbers writer currently writes only the first table`);
  var r = eF(n[`!ref`]);
  r.s.r = r.s.c = 0;
  var i = !1;
  r.e.c > 9 && (i = !0, r.e.c = 9), r.e.r > 49 && (i = !0, r.e.r = 49), i && console.error(`The Numbers writer is currently limited to ${tF(r)}`);
  var a = jX(n, {
      range: r,
      header: 1
    }),
    o = [`~Sh33tJ5~`];
  a.forEach(function (e) {
    return e.forEach(function (e) {
      typeof e == `string` && o.push(e);
    });
  });
  var s = {},
    c = [],
    l = SM.read(t.numbers, {
      type: `base64`
    });
  l.FileIndex.map(function (e, t) {
    return [e, l.FullPaths[t]];
  }).forEach(function (e) {
    var t = e[0],
      n = e[1];
    if (t.type == 2 && t.name.match(/\.iwa/)) {
      var r = t.content;
      DY(AY(r)).forEach(function (e) {
        c.push(e.id), s[e.id] = {
          deps: [],
          location: n,
          type: CY(e.messages[0].meta[1][0].data)
        };
      });
    }
  }), c.sort(function (e, t) {
    return e - t;
  });
  var u = c.filter(function (e) {
    return e > 1;
  }).map(function (e) {
    return [e, SY(e)];
  });
  l.FileIndex.map(function (e, t) {
    return [e, l.FullPaths[t]];
  }).forEach(function (e) {
    var t = e[0];
    e[1], t.name.match(/\.iwa/) && DY(AY(t.content)).forEach(function (e) {
      e.messages.forEach(function (t) {
        u.forEach(function (t) {
          e.messages.some(function (e) {
            return CY(e.meta[1][0].data) != 11006 && gY(e.data, t[1]);
          }) && s[t[0]].deps.push(e.id);
        });
      });
    });
  });
  for (var d = SM.find(l, s[1].location), f = DY(AY(d.content)), p, m = 0; m < f.length; ++m) {
    var h = f[m];
    h.id == 1 && (p = h);
  }
  var g = LY(wY(p.messages[0].data)[1][0].data);
  for (d = SM.find(l, s[g].location), f = DY(AY(d.content)), m = 0; m < f.length; ++m) h = f[m], h.id == g && (p = h);
  for (g = LY(wY(p.messages[0].data)[2][0].data), d = SM.find(l, s[g].location), f = DY(AY(d.content)), m = 0; m < f.length; ++m) h = f[m], h.id == g && (p = h);
  for (g = LY(wY(p.messages[0].data)[2][0].data), d = SM.find(l, s[g].location), f = DY(AY(d.content)), m = 0; m < f.length; ++m) h = f[m], h.id == g && (p = h);
  var _ = wY(p.messages[0].data);
  _[6][0].data = SY(r.e.r + 1), _[7][0].data = SY(r.e.c + 1);
  for (var v = LY(_[46][0].data), y = SM.find(l, s[v].location), b = DY(AY(y.content)), x = 0; x < b.length && b[x].id != v; ++x);
  if (b[x].id != v) throw `Bad ColumnRowUIDMapArchive`;
  var S = wY(b[x].messages[0].data);
  S[1] = [], S[2] = [], S[3] = [];
  for (var C = 0; C <= r.e.c; ++C) {
    var w = [];
    w[1] = w[2] = [{
      type: 0,
      data: SY(C + 420690)
    }], S[1].push({
      type: 2,
      data: TY(w)
    }), S[2].push({
      type: 0,
      data: SY(C)
    }), S[3].push({
      type: 0,
      data: SY(C)
    });
  }
  S[4] = [], S[5] = [], S[6] = [];
  for (var T = 0; T <= r.e.r; ++T) w = [], w[1] = w[2] = [{
    type: 0,
    data: SY(T + 726270)
  }], S[4].push({
    type: 2,
    data: TY(w)
  }), S[5].push({
    type: 0,
    data: SY(T)
  }), S[6].push({
    type: 0,
    data: SY(T)
  });
  b[x].messages[0].data = TY(S), y.content = jY(OY(b)), y.size = y.content.length, delete _[46];
  var E = wY(_[4][0].data);
  E[7][0].data = SY(r.e.r + 1);
  var D = LY(wY(E[1][0].data)[2][0].data);
  if (y = SM.find(l, s[D].location), b = DY(AY(y.content)), b[0].id != D) throw `Bad HeaderStorageBucket`;
  var O = wY(b[0].messages[0].data);
  for (T = 0; T < a.length; ++T) {
    var k = wY(O[2][0].data);
    k[1][0].data = SY(T), k[4][0].data = SY(a[T].length), O[2][T] = {
      type: O[2][0].type,
      data: TY(k)
    };
  }
  b[0].messages[0].data = TY(O), y.content = jY(OY(b)), y.size = y.content.length;
  var A = LY(E[2][0].data);
  if (y = SM.find(l, s[A].location), b = DY(AY(y.content)), b[0].id != A) throw `Bad HeaderStorageBucket`;
  for (O = wY(b[0].messages[0].data), C = 0; C <= r.e.c; ++C) k = wY(O[2][0].data), k[1][0].data = SY(C), k[4][0].data = SY(r.e.r + 1), O[2][C] = {
    type: O[2][0].type,
    data: TY(k)
  };
  b[0].messages[0].data = TY(O), y.content = jY(OY(b)), y.size = y.content.length;
  var j = LY(E[4][0].data);
  (function () {
    for (var e = SM.find(l, s[j].location), t = DY(AY(e.content)), n, r = 0; r < t.length; ++r) {
      var i = t[r];
      i.id == j && (n = i);
    }
    var a = wY(n.messages[0].data);
    a[3] = [];
    var c = [];
    o.forEach(function (e, t) {
      c[1] = [{
        type: 0,
        data: SY(t)
      }], c[2] = [{
        type: 0,
        data: SY(1)
      }], c[3] = [{
        type: 2,
        data: hY(e)
      }], a[3].push({
        type: 2,
        data: TY(c)
      });
    }), n.messages[0].data = TY(a), e.content = jY(OY(t)), e.size = e.content.length;
  })();
  var M = wY(E[3][0].data),
    N = M[1][0];
  delete M[2];
  var P = wY(N.data),
    F = LY(P[2][0].data);
  (function () {
    for (var e = SM.find(l, s[F].location), t = DY(AY(e.content)), n, i = 0; i < t.length; ++i) {
      var c = t[i];
      c.id == F && (n = c);
    }
    var u = wY(n.messages[0].data);
    delete u[6], delete M[7];
    var d = new Uint8Array(u[5][0].data);
    u[5] = [];
    for (var f = 0, p = 0; p <= r.e.r; ++p) {
      var m = wY(d);
      f += KY(m, a[p], o), m[1][0].data = SY(p), u[5].push({
        data: TY(m),
        type: 2
      });
    }
    u[1] = [{
      type: 0,
      data: SY(r.e.c + 1)
    }], u[2] = [{
      type: 0,
      data: SY(r.e.r + 1)
    }], u[3] = [{
      type: 0,
      data: SY(f)
    }], u[4] = [{
      type: 0,
      data: SY(r.e.r + 1)
    }], n.messages[0].data = TY(u), e.content = jY(OY(t)), e.size = e.content.length;
  })(), N.data = TY(P), E[3][0].data = TY(M), _[4][0].data = TY(E), p.messages[0].data = TY(_);
  var I = jY(OY(f));
  return d.content = I, d.size = d.content.length, l;
}
function JY(e) {
  return function (t) {
    for (var n = 0; n != e.length; ++n) {
      var r = e[n];
      t[r[0]] === void 0 && (t[r[0]] = r[1]), r[2] === `n` && (t[r[0]] = Number(t[r[0]]));
    }
  };
}
function YY(e) {
  JY([[`cellNF`, !1], [`cellHTML`, !0], [`cellFormula`, !0], [`cellStyles`, !1], [`cellText`, !0], [`cellDates`, !1], [`sheetStubs`, !1], [`sheetRows`, 0, `n`], [`bookDeps`, !1], [`bookSheets`, !1], [`bookProps`, !1], [`bookFiles`, !1], [`bookVBA`, !1], [`password`, ``], [`WTF`, !1]])(e);
}
function XY(e) {
  JY([[`cellDates`, !1], [`bookSST`, !1], [`bookType`, `xlsx`], [`compression`, !1], [`WTF`, !1]])(e);
}
function ZY(e) {
  return gI.WS.indexOf(e) > -1 ? `sheet` : gI.CS && e == gI.CS ? `chart` : gI.DS && e == gI.DS ? `dialog` : gI.MS && e == gI.MS ? `macro` : e && e.length ? e : `sheet`;
}
function QY(e, t) {
  if (!e) return 0;
  try {
    e = t.map(function (t) {
      return t.id ||= t.strRelID, [t.name, e[`!id`][t.id].Target, ZY(e[`!id`][t.id].Type)];
    });
  } catch {
    return null;
  }
  return !e || e.length === 0 ? null : e;
}
function $Y(e, t, n, r, i, a, o, s, c, l, u, d) {
  try {
    a[r] = vI(rN(e, n, !0), t);
    var f = nN(e, t),
      p;
    switch (s) {
      case `sheet`:
        p = Eq(f, t, i, c, a[r], l, u, d);
        break;
      case `chart`:
        if (p = Dq(f, t, i, c, a[r], l, u, d), !p || !p[`!drawel`]) break;
        var m = lN(p[`!drawel`].Target, t),
          h = _I(m),
          g = lN(gH(rN(e, m, !0), vI(rN(e, h, !0), m)), m),
          _ = _I(g);
        p = JK(rN(e, g, !0), g, c, vI(rN(e, _, !0), g), l, p);
        break;
      case `macro`:
        p = Oq(f, t, i, c, a[r], l, u, d);
        break;
      case `dialog`:
        p = kq(f, t, i, c, a[r], l, u, d);
        break;
      default:
        throw Error(`Unrecognized sheet type ` + s);
    }
    o[r] = p;
    var v = [];
    a && a[r] && OM(a[r]).forEach(function (n) {
      var i = ``;
      if (a[r][n].Type == gI.CMNT) {
        i = lN(a[r][n].Target, t);
        var o = Nq(nN(e, i, !0), i, c);
        if (!o || !o.length) return;
        yH(p, o, !1);
      }
      a[r][n].Type == gI.TCMNT && (i = lN(a[r][n].Target, t), v = v.concat(SH(nN(e, i, !0), c)));
    }), v && v.length && yH(p, v, !0, c.people || []);
  } catch (e) {
    if (c.WTF) throw e;
  }
}
function eX(e) {
  return e.charAt(0) == `/` ? e.slice(1) : e;
}
function tX(e, t) {
  if (hM(), t ||= {}, YY(t), eN(e, `META-INF/manifest.xml`) || eN(e, `objectdata.xml`)) return cY(e, t);
  if (eN(e, `Index/Document.iwa`)) {
    if (typeof Uint8Array > `u`) throw Error(`NUMBERS file parsing requires Uint8Array support`);
    if (GY !== void 0) {
      if (e.FileIndex) return GY(e);
      var n = SM.utils.cfb_new();
      return aN(e).forEach(function (t) {
        oN(n, t, iN(e, t));
      }), GY(n);
    }
    throw Error(`Unsupported NUMBERS file`);
  }
  if (!eN(e, `[Content_Types].xml`)) throw eN(e, `index.xml.gz`) ? Error(`Unsupported NUMBERS 08 file`) : eN(e, `index.xml`) ? Error(`Unsupported NUMBERS 09 file`) : Error(`Unsupported ZIP file`);
  var r = aN(e),
    i = mI(rN(e, `[Content_Types].xml`)),
    a = !1,
    o,
    s;
  if (i.workbooks.length === 0 && (s = `xl/workbook.xml`, nN(e, s, !0) && i.workbooks.push(s)), i.workbooks.length === 0) {
    if (s = `xl/workbook.bin`, !nN(e, s, !0)) throw Error(`Could not find workbook`);
    i.workbooks.push(s), a = !0;
  }
  i.workbooks[0].slice(-3) == `bin` && (a = !0);
  var c = {},
    l = {};
  if (!t.bookSheets && !t.bookProps) {
    if (HW = [], i.sst) try {
      HW = Mq(nN(e, eX(i.sst)), i.sst, t);
    } catch (e) {
      if (t.WTF) throw e;
    }
    t.cellStyles && i.themes.length && (c = jq(rN(e, i.themes[0].replace(/^\//, ``), !0) || ``, i.themes[0], t)), i.style && (l = Aq(nN(e, eX(i.style)), i.style, c, t));
  }
  i.links.map(function (n) {
    try {
      var r = vI(rN(e, _I(eX(n))), n);
      return Fq(nN(e, eX(n)), r, n, t);
    } catch {}
  });
  var u = Tq(nN(e, eX(i.workbooks[0])), i.workbooks[0], t),
    d = {},
    f = ``;
  i.coreprops.length && (f = nN(e, eX(i.coreprops[0]), !0), f && (d = AI(f)), i.extprops.length !== 0 && (f = nN(e, eX(i.extprops[0]), !0), f && II(f, d, t)));
  var p = {};
  (!t.bookSheets || t.bookProps) && i.custprops.length !== 0 && (f = rN(e, eX(i.custprops[0]), !0), f && (p = zI(f, t)));
  var m = {};
  if ((t.bookSheets || t.bookProps) && (u.Sheets ? o = u.Sheets.map(function (e) {
    return e.name;
  }) : d.Worksheets && d.SheetNames.length > 0 && (o = d.SheetNames), t.bookProps && (m.Props = d, m.Custprops = p), t.bookSheets && o !== void 0 && (m.SheetNames = o), t.bookSheets ? m.SheetNames : t.bookProps)) return m;
  o = {};
  var h = {};
  t.bookDeps && i.calcchain && (h = Pq(nN(e, eX(i.calcchain)), i.calcchain, t));
  var g = 0,
    _ = {},
    v,
    y,
    b = u.Sheets;
  d.Worksheets = b.length, d.SheetNames = [];
  for (var x = 0; x != b.length; ++x) d.SheetNames[x] = b[x].name;
  var S = a ? `bin` : `xml`,
    C = i.workbooks[0].lastIndexOf(`/`),
    w = (i.workbooks[0].slice(0, C + 1) + `_rels/` + i.workbooks[0].slice(C + 1) + `.rels`).replace(/^\//, ``);
  eN(e, w) || (w = `xl/_rels/workbook.` + S + `.rels`);
  var T = vI(rN(e, w, !0), w.replace(/_rels.*/, `s5s`));
  (i.metadata || []).length >= 1 && (t.xlmeta = Iq(nN(e, eX(i.metadata[0])), i.metadata[0], t)), (i.people || []).length >= 1 && (t.people = wH(nN(e, eX(i.people[0])), t)), T &&= QY(T, u.Sheets);
  var E = +!!nN(e, `xl/worksheets/sheet.xml`, !0);
  wsloop: for (g = 0; g != d.Worksheets; ++g) {
    var D = `sheet`;
    if (T && T[g] ? (v = `xl/` + T[g][1].replace(/[\/]?xl\//, ``), eN(e, v) || (v = T[g][1]), eN(e, v) || (v = w.replace(/_rels\/.*$/, ``) + T[g][1]), D = T[g][2]) : (v = `xl/worksheets/sheet` + (g + 1 - E) + `.` + S, v = v.replace(/sheet0\./, `sheet.`)), y = v.replace(/^(.*)(\/)([^\/]*)$/, `$1/_rels/$3.rels`), t && t.sheets != null) switch (typeof t.sheets) {
      case `number`:
        if (g != t.sheets) continue wsloop;
        break;
      case `string`:
        if (d.SheetNames[g].toLowerCase() != t.sheets.toLowerCase()) continue wsloop;
        break;
      default:
        if (Array.isArray && Array.isArray(t.sheets)) {
          for (var O = !1, k = 0; k != t.sheets.length; ++k) typeof t.sheets[k] == `number` && t.sheets[k] == g && (O = 1), typeof t.sheets[k] == `string` && t.sheets[k].toLowerCase() == d.SheetNames[g].toLowerCase() && (O = 1);
          if (!O) continue wsloop;
        }
    }
    $Y(e, v, y, d.SheetNames[g], g, _, o, D, t, u, c, l);
  }
  return m = {
    Directory: i,
    Workbook: u,
    Props: d,
    Custprops: p,
    Deps: h,
    Sheets: o,
    SheetNames: d.SheetNames,
    Strings: HW,
    Styles: l,
    Themes: c,
    SSF: GM(bj)
  }, t && t.bookFiles && (e.files ? (m.keys = r, m.files = e.files) : (m.keys = [], m.files = {}, e.FullPaths.forEach(function (t, n) {
    t = t.replace(/^Root Entry[\/]/, ``), m.keys.push(t), m.files[t] = e.FileIndex[n];
  }))), t && t.bookVBA && (i.vba.length > 0 ? m.vbaraw = nN(e, eX(i.vba[0]), !0) : i.defaults && i.defaults.bin === MH && (m.vbaraw = nN(e, `xl/vbaProject.bin`, !0))), m;
}
function nX(e, t) {
  var n = t || {},
    r = `Workbook`,
    i = SM.find(e, r);
  try {
    if (r = `/!DataSpaces/Version`, i = SM.find(e, r), !i || !i.content || (fB(i.content), r = `/!DataSpaces/DataSpaceMap`, i = SM.find(e, r), !i || !i.content)) throw Error(`ECMA-376 Encrypted file missing ` + r);
    var a = mB(i.content);
    if (a.length !== 1 || a[0].comps.length !== 1 || a[0].comps[0].t !== 0 || a[0].name !== `StrongEncryptionDataSpace` || a[0].comps[0].v !== `EncryptedPackage`) throw Error(`ECMA-376 Encrypted file bad ` + r);
    if (r = `/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace`, i = SM.find(e, r), !i || !i.content) throw Error(`ECMA-376 Encrypted file missing ` + r);
    var o = hB(i.content);
    if (o.length != 1 || o[0] != `StrongEncryptionTransform`) throw Error(`ECMA-376 Encrypted file bad ` + r);
    if (r = `/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary`, i = SM.find(e, r), !i || !i.content) throw Error(`ECMA-376 Encrypted file missing ` + r);
    _B(i.content);
  } catch {}
  if (r = `/EncryptionInfo`, i = SM.find(e, r), !i || !i.content) throw Error(`ECMA-376 Encrypted file missing ` + r);
  var s = bB(i.content);
  if (r = `/EncryptedPackage`, i = SM.find(e, r), !i || !i.content) throw Error(`ECMA-376 Encrypted file missing ` + r);
  if (s[0] == 4 && typeof decrypt_agile < `u`) return decrypt_agile(s[1], i.content, n.password || ``, n);
  if (s[0] == 2 && typeof decrypt_std76 < `u`) return decrypt_std76(s[1], i.content, n.password || ``, n);
  throw Error(`File is password-protected`);
}
function rX(e, t) {
  return t.bookType == `ods` ? fY(e, t) : t.bookType == `numbers` ? qY(e, t) : t.bookType == `xlsb` ? iX(e, t) : aX(e, t);
}
function iX(e, t) {
  _H = 1024, e && !e.SSF && (e.SSF = GM(bj)), e && e.SSF && (hM(), mM(e.SSF), t.revssf = jM(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = [], t.Strings.Count = 0, t.Strings.Unique = 0, WW ? t.revStrings = new Map() : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
  var n = t.bookType == `xlsb` ? `bin` : `xml`,
    r = FH.indexOf(t.bookType) > -1,
    i = pI();
  XY(t ||= {});
  var a = sN(),
    o = ``,
    s = 0;
  if (t.cellXfs = [], JW(t.cellXfs, {}, {
    revssf: {
      General: 0
    }
  }), e.Props ||= {}, o = `docProps/core.xml`, oN(a, o, MI(e.Props, t)), i.coreprops.push(o), bI(t.rels, 2, o, gI.CORE_PROPS), o = `docProps/app.xml`, !(e.Props && e.Props.SheetNames)) {
    if (!e.Workbook || !e.Workbook.Sheets) e.Props.SheetNames = e.SheetNames;else {
      for (var c = [], l = 0; l < e.SheetNames.length; ++l) (e.Workbook.Sheets[l] || {}).Hidden != 2 && c.push(e.SheetNames[l]);
      e.Props.SheetNames = c;
    }
  }
  for (e.Props.Worksheets = e.Props.SheetNames.length, oN(a, o, LI(e.Props, t)), i.extprops.push(o), bI(t.rels, 3, o, gI.EXT_PROPS), e.Custprops !== e.Props && OM(e.Custprops || {}).length > 0 && (o = `docProps/custom.xml`, oN(a, o, BI(e.Custprops, t)), i.custprops.push(o), bI(t.rels, 4, o, gI.CUST_PROPS)), s = 1; s <= e.SheetNames.length; ++s) {
    var u = {
        "!id": {}
      },
      d = e.Sheets[e.SheetNames[s - 1]];
    if ((d || {})[`!type`], o = `xl/worksheets/sheet` + s + `.` + n, oN(a, o, Rq(s - 1, o, t, e, u)), i.sheets.push(o), bI(t.wbrels, -1, `worksheets/sheet` + s + `.` + n, gI.WS[0]), d) {
      var f = d[`!comments`],
        p = !1,
        m = ``;
      f && f.length > 0 && (m = `xl/comments` + s + `.` + n, oN(a, m, Vq(f, m, t)), i.comments.push(m), bI(u, -1, `../comments` + s + `.` + n, gI.CMNT), p = !0), d[`!legacy`] && p && oN(a, `xl/drawings/vmlDrawing` + s + `.vml`, vH(s, d[`!comments`])), delete d[`!comments`], delete d[`!legacy`];
    }
    u[`!id`].rId1 && oN(a, _I(o), yI(u));
  }
  return t.Strings != null && t.Strings.length > 0 && (o = `xl/sharedStrings.` + n, oN(a, o, Bq(t.Strings, o, t)), i.strs.push(o), bI(t.wbrels, -1, `sharedStrings.` + n, gI.SST)), o = `xl/workbook.` + n, oN(a, o, Lq(e, o, t)), i.workbooks.push(o), bI(t.rels, 1, o, gI.WB), o = `xl/theme/theme1.xml`, oN(a, o, KV(e.Themes, t)), i.themes.push(o), bI(t.wbrels, -1, `theme/theme1.xml`, gI.THEME), o = `xl/styles.` + n, oN(a, o, zq(e, o, t)), i.styles.push(o), bI(t.wbrels, -1, `styles.` + n, gI.STY), e.vbaraw && r && (o = `xl/vbaProject.bin`, oN(a, o, e.vbaraw), i.vba.push(o), bI(t.wbrels, -1, `vbaProject.bin`, gI.VBA)), o = `xl/metadata.` + n, oN(a, o, Hq(o)), i.metadata.push(o), bI(t.wbrels, -1, `metadata.` + n, gI.XLMETA), oN(a, `[Content_Types].xml`, hI(i, t)), oN(a, `_rels/.rels`, yI(t.rels)), oN(a, `xl/_rels/workbook.` + n + `.rels`, yI(t.wbrels)), delete t.revssf, delete t.ssf, a;
}
function aX(e, t) {
  _H = 1024, e && !e.SSF && (e.SSF = GM(bj)), e && e.SSF && (hM(), mM(e.SSF), t.revssf = jM(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = [], t.Strings.Count = 0, t.Strings.Unique = 0, WW ? t.revStrings = new Map() : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
  var n = `xml`,
    r = FH.indexOf(t.bookType) > -1,
    i = pI();
  XY(t ||= {});
  var a = sN(),
    o = ``,
    s = 0;
  if (t.cellXfs = [], JW(t.cellXfs, {}, {
    revssf: {
      General: 0
    }
  }), e.Props ||= {}, o = `docProps/core.xml`, oN(a, o, MI(e.Props, t)), i.coreprops.push(o), bI(t.rels, 2, o, gI.CORE_PROPS), o = `docProps/app.xml`, !(e.Props && e.Props.SheetNames)) {
    if (!e.Workbook || !e.Workbook.Sheets) e.Props.SheetNames = e.SheetNames;else {
      for (var c = [], l = 0; l < e.SheetNames.length; ++l) (e.Workbook.Sheets[l] || {}).Hidden != 2 && c.push(e.SheetNames[l]);
      e.Props.SheetNames = c;
    }
  }
  e.Props.Worksheets = e.Props.SheetNames.length, oN(a, o, LI(e.Props, t)), i.extprops.push(o), bI(t.rels, 3, o, gI.EXT_PROPS), e.Custprops !== e.Props && OM(e.Custprops || {}).length > 0 && (o = `docProps/custom.xml`, oN(a, o, BI(e.Custprops, t)), i.custprops.push(o), bI(t.rels, 4, o, gI.CUST_PROPS));
  var u = [`SheetJ5`];
  for (t.tcid = 0, s = 1; s <= e.SheetNames.length; ++s) {
    var d = {
        "!id": {}
      },
      f = e.Sheets[e.SheetNames[s - 1]];
    if ((f || {})[`!type`], o = `xl/worksheets/sheet` + s + `.` + n, oN(a, o, kG(s - 1, t, e, d)), i.sheets.push(o), bI(t.wbrels, -1, `worksheets/sheet` + s + `.` + n, gI.WS[0]), f) {
      var p = f[`!comments`],
        m = !1,
        h = ``;
      if (p && p.length > 0) {
        var g = !1;
        p.forEach(function (e) {
          e[1].forEach(function (e) {
            e.T == 1 && (g = !0);
          });
        }), g && (h = `xl/threadedComments/threadedComment` + s + `.` + n, oN(a, h, CH(p, u, t)), i.threadedcomments.push(h), bI(d, -1, `../threadedComments/threadedComment` + s + `.` + n, gI.TCMNT)), h = `xl/comments` + s + `.` + n, oN(a, h, xH(p, t)), i.comments.push(h), bI(d, -1, `../comments` + s + `.` + n, gI.CMNT), m = !0;
      }
      f[`!legacy`] && m && oN(a, `xl/drawings/vmlDrawing` + s + `.vml`, vH(s, f[`!comments`])), delete f[`!comments`], delete f[`!legacy`];
    }
    d[`!id`].rId1 && oN(a, _I(o), yI(d));
  }
  return t.Strings != null && t.Strings.length > 0 && (o = `xl/sharedStrings.` + n, oN(a, o, iB(t.Strings, t)), i.strs.push(o), bI(t.wbrels, -1, `sharedStrings.` + n, gI.SST)), o = `xl/workbook.` + n, oN(a, o, fq(e, t)), i.workbooks.push(o), bI(t.rels, 1, o, gI.WB), o = `xl/theme/theme1.xml`, oN(a, o, KV(e.Themes, t)), i.themes.push(o), bI(t.wbrels, -1, `theme/theme1.xml`, gI.THEME), o = `xl/styles.` + n, oN(a, o, lV(e, t)), i.styles.push(o), bI(t.wbrels, -1, `styles.` + n, gI.STY), e.vbaraw && r && (o = `xl/vbaProject.bin`, oN(a, o, e.vbaraw), i.vba.push(o), bI(t.wbrels, -1, `vbaProject.bin`, gI.VBA)), o = `xl/metadata.` + n, oN(a, o, dH()), i.metadata.push(o), bI(t.wbrels, -1, `metadata.` + n, gI.XLMETA), u.length > 1 && (o = `xl/persons/person.xml`, oN(a, o, TH(u, t)), i.people.push(o), bI(t.wbrels, -1, `persons/person.xml`, gI.PEOPLE)), oN(a, `[Content_Types].xml`, hI(i, t)), oN(a, `_rels/.rels`, yI(t.rels)), oN(a, `xl/_rels/workbook.` + n + `.rels`, yI(t.wbrels)), delete t.revssf, delete t.ssf, a;
}
function oX(e, t) {
  var n = ``;
  switch ((t || {}).type || `base64`) {
    case `buffer`:
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    case `base64`:
      n = JA(e.slice(0, 12));
      break;
    case `binary`:
      n = e;
      break;
    case `array`:
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    default:
      throw Error(`Unrecognized type ` + (t && t.type || `undefined`));
  }
  return [n.charCodeAt(0), n.charCodeAt(1), n.charCodeAt(2), n.charCodeAt(3), n.charCodeAt(4), n.charCodeAt(5), n.charCodeAt(6), n.charCodeAt(7)];
}
function sX(e, t) {
  return SM.find(e, `EncryptedPackage`) ? nX(e, t) : wJ(e, t);
}
function cX(e, t) {
  var n,
    r = e,
    i = t || {};
  return i.type ||= YA && Buffer.isBuffer(e) ? `buffer` : `base64`, n = cN(r, i), tX(n, i);
}
function lX(e, t) {
  var n = 0;
  main: for (; n < e.length;) switch (e.charCodeAt(n)) {
    case 10:
    case 13:
    case 32:
      ++n;
      break;
    case 60:
      return tJ(e.slice(n), t);
    default:
      break main;
  }
  return Uz.to_workbook(e, t);
}
function uX(e, t) {
  var n = ``,
    r = oX(e, t);
  switch (t.type) {
    case `base64`:
      n = JA(e);
      break;
    case `binary`:
      n = e;
      break;
    case `buffer`:
      n = e.toString(`binary`);
      break;
    case `array`:
      n = WM(e);
      break;
    default:
      throw Error(`Unrecognized type ` + t.type);
  }
  return r[0] == 239 && r[1] == 187 && r[2] == 191 && (n = FN(n)), t.type = `binary`, lX(n, t);
}
function dX(e, t) {
  var n = e;
  return t.type == `base64` && (n = JA(n)), n = HA.utils.decode(1200, n.slice(2), `str`), t.type = `binary`, lX(n, t);
}
function fX(e) {
  return e.match(/[^\x00-\x7F]/) ? IN(e) : e;
}
function pX(e, t, n, r) {
  return r ? (n.type = `string`, Uz.to_workbook(e, n)) : Uz.to_workbook(t, n);
}
function mX(e, t) {
  FA();
  var n = t || {};
  if (typeof ArrayBuffer < `u` && e instanceof ArrayBuffer) return mX(new Uint8Array(e), (n = GM(n), n.type = `array`, n));
  typeof Uint8Array < `u` && e instanceof Uint8Array && !n.type && (n.type = typeof Deno < `u` ? `buffer` : `array`);
  var r = e,
    i = [0, 0, 0, 0],
    a = !1;
  if (n.cellStyles && (n.cellNF = !0, n.sheetStubs = !0), UW = {}, n.dateNF && (UW.dateNF = n.dateNF), n.type || (n.type = YA && Buffer.isBuffer(e) ? `buffer` : `base64`), n.type == `file` && (n.type = YA ? `buffer` : `binary`, r = DM(e), typeof Uint8Array < `u` && !YA && (n.type = `array`)), n.type == `string` && (a = !0, n.type = `binary`, n.codepage = 65001, r = fX(e)), n.type == `array` && typeof Uint8Array < `u` && e instanceof Uint8Array && typeof ArrayBuffer < `u`) {
    var o = new Uint8Array(new ArrayBuffer(3));
    if (o.foo = `bar`, !o.foo) return n = GM(n), n.type = `array`, mX(rj(r), n);
  }
  switch ((i = oX(r, n))[0]) {
    case 208:
      if (i[1] === 207 && i[2] === 17 && i[3] === 224 && i[4] === 161 && i[5] === 177 && i[6] === 26 && i[7] === 225) return sX(SM.read(r, n), n);
      break;
    case 9:
      if (i[1] <= 8) return wJ(r, n);
      break;
    case 60:
      return tJ(r, n);
    case 73:
      if (i[1] === 73 && i[2] === 42 && i[3] === 0) throw Error(`TIFF Image File is not a spreadsheet`);
      if (i[1] === 68) return Wz(r, n);
      break;
    case 84:
      if (i[1] === 65 && i[2] === 66 && i[3] === 76) return Vz.to_workbook(r, n);
      break;
    case 80:
      return i[1] === 75 && i[2] < 9 && i[3] < 9 ? cX(r, n) : pX(e, r, n, a);
    case 239:
      return i[3] === 60 ? tJ(r, n) : pX(e, r, n, a);
    case 255:
      if (i[1] === 254) return dX(r, n);
      if (i[1] === 0 && i[2] === 2 && i[3] === 0) return Gz.to_workbook(r, n);
      break;
    case 0:
      if (i[1] === 0 && (i[2] >= 2 && i[3] === 0 || i[2] === 0 && (i[3] === 8 || i[3] === 9))) return Gz.to_workbook(r, n);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return zz.to_workbook(r, n);
    case 123:
      if (i[1] === 92 && i[2] === 114 && i[3] === 116) return NB.to_workbook(r, n);
      break;
    case 10:
    case 13:
    case 32:
      return uX(r, n);
    case 137:
      if (i[1] === 80 && i[2] === 78 && i[3] === 71) throw Error(`PNG Image File is not a spreadsheet`);
  }
  return Rz.indexOf(i[0]) > -1 && i[2] <= 12 && i[3] <= 31 ? zz.to_workbook(r, n) : pX(e, r, n, a);
}
function hX(e, t) {
  var n = t || {};
  return n.type = `file`, mX(e, n);
}
function gX(e, t) {
  switch (t.type) {
    case `base64`:
    case `binary`:
      break;
    case `buffer`:
    case `array`:
      t.type = ``;
      break;
    case `file`:
      return EM(t.file, SM.write(e, {
        type: YA ? `buffer` : ``
      }));
    case `string`:
      throw Error(`'string' output type invalid for '` + t.bookType + `' files`);
    default:
      throw Error(`Unrecognized type ` + t.type);
  }
  return SM.write(e, t);
}
function _X(e, t) {
  var n = GM(t || {});
  return yX(rX(e, n), n);
}
function vX(e, t) {
  var n = GM(t || {});
  return yX(aX(e, n), n);
}
function yX(e, t) {
  var n = {},
    r = YA ? `nodebuffer` : typeof Uint8Array < `u` ? `array` : `string`;
  if (t.compression && (n.compression = `DEFLATE`), t.password) n.type = r;else switch (t.type) {
    case `base64`:
      n.type = `base64`;
      break;
    case `binary`:
      n.type = `string`;
      break;
    case `string`:
      throw Error(`'string' output type invalid for '` + t.bookType + `' files`);
    case `buffer`:
    case `file`:
      n.type = r;
      break;
    default:
      throw Error(`Unrecognized type ` + t.type);
  }
  var i = e.FullPaths ? SM.write(e, {
    fileType: `zip`,
    type: {
      nodebuffer: `buffer`,
      string: `binary`
    }[n.type] || n.type,
    compression: !!t.compression
  }) : e.generate(n);
  if (typeof Deno < `u` && typeof i == `string`) {
    if (t.type == `binary` || t.type == `base64`) return i;
    i = new Uint8Array(ej(i));
  }
  return t.password && typeof encrypt_agile < `u` ? gX(encrypt_agile(i, t.password), t) : t.type === `file` ? EM(t.file, i) : t.type == `string` ? FN(i) : i;
}
function bX(e, t) {
  var n = t || {};
  return gX(TJ(e, n), n);
}
function xX(e, t, n) {
  n ||= ``;
  var r = n + e;
  switch (t.type) {
    case `base64`:
      return qA(IN(r));
    case `binary`:
      return IN(r);
    case `string`:
      return e;
    case `file`:
      return EM(t.file, r, `utf8`);
    case `buffer`:
      return YA ? XA(r, `utf8`) : typeof TextEncoder < `u` ? new TextEncoder().encode(r) : xX(r, {
        type: `binary`
      }).split(``).map(function (e) {
        return e.charCodeAt(0);
      });
  }
  throw Error(`Unrecognized type ` + t.type);
}
function SX(e, t) {
  switch (t.type) {
    case `base64`:
      return qA(e);
    case `binary`:
      return e;
    case `string`:
      return e;
    case `file`:
      return EM(t.file, e, `binary`);
    case `buffer`:
      return YA ? XA(e, `binary`) : e.split(``).map(function (e) {
        return e.charCodeAt(0);
      });
  }
  throw Error(`Unrecognized type ` + t.type);
}
function CX(e, t) {
  switch (t.type) {
    case `string`:
    case `base64`:
    case `binary`:
      for (var n = ``, r = 0; r < e.length; ++r) n += String.fromCharCode(e[r]);
      return t.type == `base64` ? qA(n) : t.type == `string` ? FN(n) : n;
    case `file`:
      return EM(t.file, e);
    case `buffer`:
      return e;
    default:
      throw Error(`Unrecognized type ` + t.type);
  }
}
function wX(e, t) {
  FA(), lq(e);
  var n = GM(t || {});
  if (n.cellStyles && (n.cellNF = !0, n.sheetStubs = !0), n.type == `array`) {
    n.type = `binary`;
    var r = wX(e, n);
    return n.type = `array`, ej(r);
  }
  return vX(e, n);
}
function TX(e, t) {
  FA(), lq(e);
  var n = GM(t || {});
  if (n.cellStyles && (n.cellNF = !0, n.sheetStubs = !0), n.type == `array`) {
    n.type = `binary`;
    var r = TX(e, n);
    return n.type = `array`, ej(r);
  }
  var i = 0;
  if (n.sheet && (i = typeof n.sheet == `number` ? n.sheet : e.SheetNames.indexOf(n.sheet), !e.SheetNames[i])) throw Error(`Sheet not found: ` + n.sheet + ` : ` + typeof n.sheet);
  switch (n.bookType || `xlsb`) {
    case `xml`:
    case `xlml`:
      return xX(mJ(e, n), n);
    case `slk`:
    case `sylk`:
      return xX(Bz.from_sheet(e.Sheets[e.SheetNames[i]], n), n);
    case `htm`:
    case `html`:
      return xX($J(e.Sheets[e.SheetNames[i]], n), n);
    case `txt`:
      return SX(FX(e.Sheets[e.SheetNames[i]], n), n);
    case `csv`:
      return xX(PX(e.Sheets[e.SheetNames[i]], n), n, `﻿`);
    case `dif`:
      return xX(Vz.from_sheet(e.Sheets[e.SheetNames[i]], n), n);
    case `dbf`:
      return CX(zz.from_sheet(e.Sheets[e.SheetNames[i]], n), n);
    case `prn`:
      return xX(Uz.from_sheet(e.Sheets[e.SheetNames[i]], n), n);
    case `rtf`:
      return xX(NB.from_sheet(e.Sheets[e.SheetNames[i]], n), n);
    case `eth`:
      return xX(Hz.from_sheet(e.Sheets[e.SheetNames[i]], n), n);
    case `fods`:
      return xX(fY(e, n), n);
    case `wk1`:
      return CX(Gz.sheet_to_wk1(e.Sheets[e.SheetNames[i]], n), n);
    case `wk3`:
      return CX(Gz.book_to_wk3(e, n), n);
    case `biff2`:
      n.biff ||= 2;
    case `biff3`:
      n.biff ||= 3;
    case `biff4`:
      return n.biff ||= 4, CX(KJ(e, n), n);
    case `biff5`:
      n.biff ||= 5;
    case `biff8`:
    case `xla`:
    case `xls`:
      return n.biff ||= 8, bX(e, n);
    case `xlsx`:
    case `xlsm`:
    case `xlam`:
    case `xlsb`:
    case `numbers`:
    case `ods`:
      return _X(e, n);
    default:
      throw Error(`Unrecognized bookType |` + n.bookType + `|`);
  }
}
function EX(e) {
  if (!e.bookType) {
    var t = {
        xls: `biff8`,
        htm: `html`,
        slk: `sylk`,
        socialcalc: `eth`,
        Sh33tJS: `WTF`
      },
      n = e.file.slice(e.file.lastIndexOf(`.`)).toLowerCase();
    n.match(/^\.[a-z]+$/) && (e.bookType = n.slice(1)), e.bookType = t[e.bookType] || e.bookType;
  }
}
function DX(e, t, n) {
  var r = n || {};
  return r.type = `file`, r.file = t, EX(r), TX(e, r);
}
function OX(e, t, n) {
  var r = n || {};
  return r.type = `file`, r.file = t, EX(r), wX(e, r);
}
function kX(e, t, n, r) {
  var i = n || {};
  i.type = `file`, i.file = e, EX(i), i.type = `buffer`;
  var a = r;
  return a instanceof Function || (a = n), CM.writeFile(e, TX(t, i), a);
}
function AX(e, t, n, r, i, a, o, s) {
  var c = WP(n),
    l = s.defval,
    u = s.raw || !Object.prototype.hasOwnProperty.call(s, `raw`),
    d = !0,
    f = i === 1 ? [] : {};
  if (i !== 1) {
    if (Object.defineProperty) try {
      Object.defineProperty(f, "__rowNum__", {
        value: n,
        enumerable: !1
      });
    } catch {
      f.__rowNum__ = n;
    } else f.__rowNum__ = n;
  }
  if (!o || e[n]) for (var p = t.s.c; p <= t.e.c; ++p) {
    var m = o ? e[n][p] : e[r[p] + c];
    if (m === void 0 || m.t === void 0) {
      if (l === void 0) continue;
      a[p] != null && (f[a[p]] = l);
      continue;
    }
    var h = m.v;
    switch (m.t) {
      case `z`:
        if (h == null) break;
        continue;
      case `e`:
        h = h == 0 ? null : void 0;
        break;
      case `s`:
      case `d`:
      case `b`:
      case `n`:
        break;
      default:
        throw Error(`unrecognized type ` + m.t);
    }
    if (a[p] != null) {
      if (h == null) {
        if (m.t == `e` && h === null) f[a[p]] = null;else if (l !== void 0) f[a[p]] = l;else if (u && h === null) f[a[p]] = null;else continue;
      } else f[a[p]] = u && (m.t !== `n` || m.t === `n` && s.rawNumbers !== !1) ? h : iF(m, h, s);
      h != null && (d = !1);
    }
  }
  return {
    row: f,
    isempty: d
  };
}
function jX(e, t) {
  if (e == null || e[`!ref`] == null) return [];
  var n = {
      t: `n`,
      v: 0
    },
    r = 0,
    i = 1,
    a = [],
    o = 0,
    s = ``,
    c = {
      s: {
        r: 0,
        c: 0
      },
      e: {
        r: 0,
        c: 0
      }
    },
    l = t || {},
    u = l.range == null ? e[`!ref`] : l.range;
  switch (l.header === 1 ? r = 1 : l.header === `A` ? r = 2 : Array.isArray(l.header) ? r = 3 : l.header ?? (r = 0), typeof u) {
    case `string`:
      c = nF(u);
      break;
    case `number`:
      c = nF(e[`!ref`]), c.s.r = u;
      break;
    default:
      c = u;
  }
  r > 0 && (i = 0);
  var d = WP(c.s.r),
    f = [],
    p = [],
    m = 0,
    h = 0,
    g = Array.isArray(e),
    _ = c.s.r,
    v = 0,
    y = {};
  g && !e[_] && (e[_] = []);
  var b = l.skipHidden && e[`!cols`] || [],
    x = l.skipHidden && e[`!rows`] || [];
  for (v = c.s.c; v <= c.e.c; ++v) if (!(b[v] || {}).hidden) switch (f[v] = JP(v), n = g ? e[_][v] : e[f[v] + d], r) {
    case 1:
      a[v] = v - c.s.c;
      break;
    case 2:
      a[v] = f[v];
      break;
    case 3:
      a[v] = l.header[v - c.s.c];
      break;
    default:
      if (n ??= {
        w: `__EMPTY`,
        t: `s`
      }, s = o = iF(n, null, l), h = y[o] || 0, !h) y[o] = 1;else {
        do s = o + `_` + h++; while (y[s]);
        y[o] = h, y[s] = 1;
      }
      a[v] = s;
  }
  for (_ = c.s.r + i; _ <= c.e.r; ++_) if (!(x[_] || {}).hidden) {
    var S = AX(e, c, _, f, r, a, g, l);
    (S.isempty === !1 || (r === 1 ? l.blankrows !== !1 : l.blankrows)) && (p[m++] = S.row);
  }
  return p.length = m, p;
}
var MX = /"/g;
function NX(e, t, n, r, i, a, o, s) {
  for (var c = !0, l = [], u = ``, d = WP(n), f = t.s.c; f <= t.e.c; ++f) if (r[f]) {
    var p = s.dense ? (e[n] || [])[f] : e[r[f] + d];
    if (p == null) u = ``;else if (p.v != null) {
      c = !1, u = `` + (s.rawNumbers && p.t == `n` ? p.v : iF(p, null, s));
      for (var m = 0, h = 0; m !== u.length; ++m) if ((h = u.charCodeAt(m)) === i || h === a || h === 34 || s.forceQuotes) {
        u = `"` + u.replace(MX, `""`) + `"`;
        break;
      }
      u == `ID` && (u = `"ID"`);
    } else p.f != null && !p.F ? (c = !1, u = `=` + p.f, u.indexOf(`,`) >= 0 && (u = `"` + u.replace(MX, `""`) + `"`)) : u = ``;
    l.push(u);
  }
  return s.blankrows === !1 && c ? null : l.join(o);
}
function PX(e, t) {
  var n = [],
    r = t ?? {};
  if (e == null || e[`!ref`] == null) return ``;
  var i = nF(e[`!ref`]),
    a = r.FS === void 0 ? `,` : r.FS,
    o = a.charCodeAt(0),
    s = r.RS === void 0 ? `
` : r.RS,
    c = s.charCodeAt(0),
    l = RegExp((a == `|` ? `\\|` : a) + `+$`),
    u = ``,
    d = [];
  r.dense = Array.isArray(e);
  for (var f = r.skipHidden && e[`!cols`] || [], p = r.skipHidden && e[`!rows`] || [], m = i.s.c; m <= i.e.c; ++m) (f[m] || {}).hidden || (d[m] = JP(m));
  for (var h = 0, g = i.s.r; g <= i.e.r; ++g) (p[g] || {}).hidden || (u = NX(e, i, g, d, o, c, a, r), u != null && (r.strip && (u = u.replace(l, ``)), (u || r.blankrows !== !1) && n.push((h++ ? s : ``) + u)));
  return delete r.dense, n.join(``);
}
function FX(e, t) {
  t ||= {}, t.FS = `	`, t.RS = `
`;
  var n = PX(e, t);
  return HA === void 0 || t.type == `string` ? n : `ÿþ` + HA.utils.encode(1200, n, `str`);
}
function IX(e) {
  var t = ``,
    n,
    r = ``;
  if (e == null || e[`!ref`] == null) return [];
  var i = nF(e[`!ref`]),
    a = ``,
    o = [],
    s,
    c = [],
    l = Array.isArray(e);
  for (s = i.s.c; s <= i.e.c; ++s) o[s] = JP(s);
  for (var u = i.s.r; u <= i.e.r; ++u) for (a = WP(u), s = i.s.c; s <= i.e.c; ++s) if (t = o[s] + a, n = l ? (e[u] || [])[s] : e[t], r = ``, n !== void 0) {
    if (n.F != null) {
      if (t = n.F, !n.f) continue;
      r = n.f, t.indexOf(`:`) == -1 && (t = t + `:` + t);
    }
    if (n.f != null) r = n.f;else if (n.t == `z`) continue;else if (n.t == `n` && n.v != null) r = `` + n.v;else if (n.t == `b`) r = n.v ? `TRUE` : `FALSE`;else if (n.w !== void 0) r = `'` + n.w;else if (n.v === void 0) continue;else r = n.t == `s` ? `'` + n.v : `` + n.v;
    c[c.length] = t + `=` + r;
  }
  return c;
}
function LX(e, t, n) {
  var r = n || {},
    i = +!r.skipHeader,
    a = e || {},
    o = 0,
    s = 0;
  if (a && r.origin != null) {
    if (typeof r.origin == `number`) o = r.origin;else {
      var c = typeof r.origin == `string` ? QP(r.origin) : r.origin;
      o = c.r, s = c.c;
    }
  }
  var l,
    u = {
      s: {
        c: 0,
        r: 0
      },
      e: {
        c: s,
        r: o + t.length - 1 + i
      }
    };
  if (a[`!ref`]) {
    var d = nF(a[`!ref`]);
    u.e.c = Math.max(u.e.c, d.e.c), u.e.r = Math.max(u.e.r, d.e.r), o == -1 && (o = d.e.r + 1, u.e.r = o + t.length - 1 + i);
  } else o == -1 && (o = 0, u.e.r = t.length - 1 + i);
  var f = r.header || [],
    p = 0;
  t.forEach(function (e, t) {
    OM(e).forEach(function (n) {
      (p = f.indexOf(n)) == -1 && (f[p = f.length] = n);
      var c = e[n],
        u = `z`,
        d = ``,
        m = $P({
          c: s + p,
          r: o + t + i
        });
      l = zX(a, m), c && typeof c == `object` && !(c instanceof Date) ? a[m] = c : (typeof c == `number` ? u = `n` : typeof c == `boolean` ? u = `b` : typeof c == `string` ? u = `s` : c instanceof Date ? (u = `d`, r.cellDates || (u = `n`, c = PM(c)), d = r.dateNF || bj[14]) : c === null && r.nullError && (u = `e`, c = 0), l ? (l.t = u, l.v = c, delete l.w, delete l.R, d && (l.z = d)) : a[m] = l = {
        t: u,
        v: c
      }, d && (l.z = d));
    });
  }), u.e.c = Math.max(u.e.c, s + f.length - 1);
  var m = WP(o);
  if (i) for (p = 0; p < f.length; ++p) a[JP(p + s) + m] = {
    t: `s`,
    v: f[p]
  };
  return a[`!ref`] = tF(u), a;
}
function RX(e, t) {
  return LX(null, e, t);
}
function zX(e, t, n) {
  if (typeof t == `string`) {
    if (Array.isArray(e)) {
      var r = QP(t);
      return e[r.r] || (e[r.r] = []), e[r.r][r.c] || (e[r.r][r.c] = {
        t: `z`
      });
    }
    return e[t] || (e[t] = {
      t: `z`
    });
  }
  return typeof t == `number` ? zX(e, $P({
    r: t,
    c: n || 0
  })) : zX(e, $P(t));
}
function BX(e, t) {
  if (typeof t == `number`) {
    if (t >= 0 && e.SheetNames.length > t) return t;
    throw Error(`Cannot find sheet # ` + t);
  }
  if (typeof t == `string`) {
    var n = e.SheetNames.indexOf(t);
    if (n > -1) return n;
    throw Error(`Cannot find sheet name |` + t + `|`);
  }
  throw Error(`Cannot find sheet |` + t + `|`);
}
function VX() {
  return {
    SheetNames: [],
    Sheets: {}
  };
}
function HX(e, t, n, r) {
  var i = 1;
  if (!n) for (; i <= 65535 && e.SheetNames.indexOf(n = `Sheet` + i) != -1; ++i, n = void 0);
  if (!n || e.SheetNames.length >= 65535) throw Error(`Too many worksheets`);
  if (r && e.SheetNames.indexOf(n) >= 0) {
    var a = n.match(/(^.*?)(\d+)$/);
    i = a && +a[2] || 0;
    var o = a && a[1] || n;
    for (++i; i <= 65535 && e.SheetNames.indexOf(n = o + i) != -1; ++i);
  }
  if (sq(n), e.SheetNames.indexOf(n) >= 0) throw Error(`Worksheet with name |` + n + `| already exists!`);
  return e.SheetNames.push(n), e.Sheets[n] = t, n;
}
function UX(e, t, n) {
  e.Workbook ||= {}, e.Workbook.Sheets || (e.Workbook.Sheets = []);
  var r = BX(e, t);
  switch (e.Workbook.Sheets[r] || (e.Workbook.Sheets[r] = {}), n) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw Error(`Bad sheet visibility setting ` + n);
  }
  e.Workbook.Sheets[r].Hidden = n;
}
function WX(e, t) {
  return e.z = t, e;
}
function GX(e, t, n) {
  return t ? (e.l = {
    Target: t
  }, n && (e.l.Tooltip = n)) : delete e.l, e;
}
function KX(e, t, n) {
  return GX(e, `#` + t, n);
}
function qX(e, t, n) {
  e.c ||= [], e.c.push({
    t,
    a: n || `SheetJS`
  });
}
function JX(e, t, n, r) {
  for (var i = typeof t == `string` ? nF(t) : t, a = typeof t == `string` ? t : tF(t), o = i.s.r; o <= i.e.r; ++o) for (var s = i.s.c; s <= i.e.c; ++s) {
    var c = zX(e, o, s);
    c.t = `n`, c.F = a, delete c.v, o == i.s.r && s == i.s.c && (c.f = n, r && (c.D = !0));
  }
  return e;
}
var YX = {
    encode_col: JP,
    encode_row: WP,
    encode_cell: $P,
    encode_range: tF,
    decode_col: qP,
    decode_row: UP,
    split_cell: ZP,
    decode_cell: QP,
    decode_range: eF,
    format_cell: iF,
    sheet_add_aoa: oF,
    sheet_add_json: LX,
    sheet_add_dom: eY,
    aoa_to_sheet: sF,
    json_to_sheet: RX,
    table_to_sheet: tY,
    table_to_book: nY,
    sheet_to_csv: PX,
    sheet_to_txt: FX,
    sheet_to_json: jX,
    sheet_to_html: $J,
    sheet_to_formulae: IX,
    sheet_to_row_object_array: jX,
    sheet_get_cell: zX,
    book_new: VX,
    book_append_sheet: HX,
    book_set_sheet_visibility: UX,
    cell_set_number_format: WX,
    cell_set_hyperlink: GX,
    cell_set_internal_link: KX,
    cell_add_comment: qX,
    sheet_set_array_formula: JX,
    consts: {
      SHEET_VISIBLE: 0,
      SHEET_HIDDEN: 1,
      SHEET_VERY_HIDDEN: 2
    }
  },
  XX;
function ZX(e) {
  XX = e;
}
function QX(e, t) {
  var n = XX(),
    r = t ?? {};
  if (e == null || e[`!ref`] == null) return n.push(null), n;
  var i = nF(e[`!ref`]),
    a = r.FS === void 0 ? `,` : r.FS,
    o = a.charCodeAt(0),
    s = r.RS === void 0 ? `
` : r.RS,
    c = s.charCodeAt(0),
    l = RegExp((a == `|` ? `\\|` : a) + `+$`),
    u = ``,
    d = [];
  r.dense = Array.isArray(e);
  for (var f = r.skipHidden && e[`!cols`] || [], p = r.skipHidden && e[`!rows`] || [], m = i.s.c; m <= i.e.c; ++m) (f[m] || {}).hidden || (d[m] = JP(m));
  var h = i.s.r,
    g = !1,
    _ = 0;
  return n._read = function () {
    if (!g) return g = !0, n.push(`﻿`);
    for (; h <= i.e.r;) if (++h, !(p[h - 1] || {}).hidden && (u = NX(e, i, h - 1, d, o, c, a, r), u != null && (r.strip && (u = u.replace(l, ``)), u || r.blankrows !== !1))) return n.push((_++ ? s : ``) + u);
    return n.push(null);
  }, n;
}
function $X(e, t) {
  var n = XX(),
    r = t || {},
    i = r.header == null ? YJ : r.header,
    a = r.footer == null ? XJ : r.footer;
  n.push(i);
  var o = eF(e[`!ref`]);
  r.dense = Array.isArray(e), n.push(QJ(e, o, r));
  var s = o.s.r,
    c = !1;
  return n._read = function () {
    if (s > o.e.r) return c || (c = !0, n.push(`</table>` + a)), n.push(null);
    for (; s <= o.e.r;) {
      n.push(JJ(e, o, s, r)), ++s;
      break;
    }
  }, n;
}
function eZ(e, t) {
  var n = XX({
    objectMode: !0
  });
  if (e == null || e[`!ref`] == null) return n.push(null), n;
  var r = {
      t: `n`,
      v: 0
    },
    i = 0,
    a = 1,
    o = [],
    s = 0,
    c = ``,
    l = {
      s: {
        r: 0,
        c: 0
      },
      e: {
        r: 0,
        c: 0
      }
    },
    u = t || {},
    d = u.range == null ? e[`!ref`] : u.range;
  switch (u.header === 1 ? i = 1 : u.header === `A` ? i = 2 : Array.isArray(u.header) && (i = 3), typeof d) {
    case `string`:
      l = nF(d);
      break;
    case `number`:
      l = nF(e[`!ref`]), l.s.r = d;
      break;
    default:
      l = d;
  }
  i > 0 && (a = 0);
  var f = WP(l.s.r),
    p = [],
    m = 0,
    h = Array.isArray(e),
    g = l.s.r,
    _ = 0,
    v = {};
  h && !e[g] && (e[g] = []);
  var y = u.skipHidden && e[`!cols`] || [],
    b = u.skipHidden && e[`!rows`] || [];
  for (_ = l.s.c; _ <= l.e.c; ++_) if (!(y[_] || {}).hidden) switch (p[_] = JP(_), r = h ? e[g][_] : e[p[_] + f], i) {
    case 1:
      o[_] = _ - l.s.c;
      break;
    case 2:
      o[_] = p[_];
      break;
    case 3:
      o[_] = u.header[_ - l.s.c];
      break;
    default:
      if (r ??= {
        w: `__EMPTY`,
        t: `s`
      }, c = s = iF(r, null, u), m = v[s] || 0, !m) v[s] = 1;else {
        do c = s + `_` + m++; while (v[c]);
        v[s] = m, v[c] = 1;
      }
      o[_] = c;
  }
  return g = l.s.r + a, n._read = function () {
    for (; g <= l.e.r;) if (!(b[g - 1] || {}).hidden) {
      var t = AX(e, l, g, p, i, o, h, u);
      if (++g, t.isempty === !1 || (i === 1 ? u.blankrows !== !1 : u.blankrows)) {
        n.push(t.row);
        return;
      }
    }
    return n.push(null);
  }, n;
}
var tZ = {
    to_json: eZ,
    to_html: $X,
    to_csv: QX,
    set_readable: ZX
  },
  nZ = DA.version,
  rZ = [{
    id: `pedidos`,
    label: `Pedidos`
  }, {
    id: `accesos`,
    label: `Accesos`
  }, {
    id: `configuracion`,
    label: `Configuración`
  }],
  iZ = `__todas__`;
function aZ() {
  return new Date().toISOString().slice(0, 10);
}
function oZ(e) {
  let t = new Date();
  return t.setDate(t.getDate() - e), t.toISOString().slice(0, 10);
}
function sZ(e) {
  if (!e) return `—`;
  let [t, n, r] = String(e).slice(0, 10).split(`-`);
  return `${r}/${n}/${t}`;
}
function cZ(e) {
  if (!e) return `todavía no`;
  let t = String(e).replace(`T`, ` `);
  return `${sZ(t.slice(0, 10))} ${t.slice(11, 16)}`;
}
var SZ = n((e, t) => {
    t.exports = function () {
      return typeof Promise == `function` && Promise.prototype && Promise.prototype.then;
    };
  }),
  CZ = n(e => {
    var t,
      n = [0, 26, 44, 70, 100, 134, 172, 196, 242, 292, 346, 404, 466, 532, 581, 655, 733, 815, 901, 991, 1085, 1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185, 2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706];
    e.getSymbolSize = function (e) {
      if (!e) throw Error(`"version" cannot be null or undefined`);
      if (e < 1 || e > 40) throw Error(`"version" should be in range from 1 to 40`);
      return e * 4 + 17;
    }, e.getSymbolTotalCodewords = function (e) {
      return n[e];
    }, e.getBCHDigit = function (e) {
      let t = 0;
      for (; e !== 0;) t++, e >>>= 1;
      return t;
    }, e.setToSJISFunction = function (e) {
      if (typeof e != `function`) throw Error(`"toSJISFunc" is not a valid function.`);
      t = e;
    }, e.isKanjiModeEnabled = function () {
      return t !== void 0;
    }, e.toSJIS = function (e) {
      return t(e);
    };
  }),
  wZ = n(e => {
    e.L = {
      bit: 1
    }, e.M = {
      bit: 0
    }, e.Q = {
      bit: 3
    }, e.H = {
      bit: 2
    };
    function t(t) {
      if (typeof t != `string`) throw Error(`Param is not a string`);
      switch (t.toLowerCase()) {
        case `l`:
        case `low`:
          return e.L;
        case `m`:
        case `medium`:
          return e.M;
        case `q`:
        case `quartile`:
          return e.Q;
        case `h`:
        case `high`:
          return e.H;
        default:
          throw Error(`Unknown EC Level: ` + t);
      }
    }
    e.isValid = function (e) {
      return e && e.bit !== void 0 && e.bit >= 0 && e.bit < 4;
    }, e.from = function (n, r) {
      if (e.isValid(n)) return n;
      try {
        return t(n);
      } catch {
        return r;
      }
    };
  }),
  TZ = n((e, t) => {
    function n() {
      this.buffer = [], this.length = 0;
    }
    n.prototype = {
      get: function (e) {
        let t = Math.floor(e / 8);
        return (this.buffer[t] >>> 7 - e % 8 & 1) == 1;
      },
      put: function (e, t) {
        for (let n = 0; n < t; n++) this.putBit((e >>> t - n - 1 & 1) == 1);
      },
      getLengthInBits: function () {
        return this.length;
      },
      putBit: function (e) {
        let t = Math.floor(this.length / 8);
        this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
      }
    }, t.exports = n;
  }),
  EZ = n((e, t) => {
    function n(e) {
      if (!e || e < 1) throw Error(`BitMatrix size must be defined and greater than 0`);
      this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
    }
    n.prototype.set = function (e, t, n, r) {
      let i = e * this.size + t;
      this.data[i] = n, r && (this.reservedBit[i] = !0);
    }, n.prototype.get = function (e, t) {
      return this.data[e * this.size + t];
    }, n.prototype.xor = function (e, t, n) {
      this.data[e * this.size + t] ^= n;
    }, n.prototype.isReserved = function (e, t) {
      return this.reservedBit[e * this.size + t];
    }, t.exports = n;
  }),
  DZ = n(e => {
    var t = CZ().getSymbolSize;
    e.getRowColCoords = function (e) {
      if (e === 1) return [];
      let n = Math.floor(e / 7) + 2,
        r = t(e),
        i = r === 145 ? 26 : Math.ceil((r - 13) / (2 * n - 2)) * 2,
        a = [r - 7];
      for (let e = 1; e < n - 1; e++) a[e] = a[e - 1] - i;
      return a.push(6), a.reverse();
    }, e.getPositions = function (t) {
      let n = [],
        r = e.getRowColCoords(t),
        i = r.length;
      for (let e = 0; e < i; e++) for (let t = 0; t < i; t++) e === 0 && t === 0 || e === 0 && t === i - 1 || e === i - 1 && t === 0 || n.push([r[e], r[t]]);
      return n;
    };
  }),
  OZ = n(e => {
    var t = CZ().getSymbolSize,
      n = 7;
    e.getPositions = function (e) {
      let r = t(e);
      return [[0, 0], [r - n, 0], [0, r - n]];
    };
  }),
  kZ = n(e => {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    var t = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function (e) {
      return e != null && e !== `` && !isNaN(e) && e >= 0 && e <= 7;
    }, e.from = function (t) {
      return e.isValid(t) ? parseInt(t, 10) : void 0;
    }, e.getPenaltyN1 = function (e) {
      let n = e.size,
        r = 0,
        i = 0,
        a = 0,
        o = null,
        s = null;
      for (let c = 0; c < n; c++) {
        i = a = 0, o = s = null;
        for (let l = 0; l < n; l++) {
          let n = e.get(c, l);
          n === o ? i++ : (i >= 5 && (r += t.N1 + (i - 5)), o = n, i = 1), n = e.get(l, c), n === s ? a++ : (a >= 5 && (r += t.N1 + (a - 5)), s = n, a = 1);
        }
        i >= 5 && (r += t.N1 + (i - 5)), a >= 5 && (r += t.N1 + (a - 5));
      }
      return r;
    }, e.getPenaltyN2 = function (e) {
      let n = e.size,
        r = 0;
      for (let t = 0; t < n - 1; t++) for (let i = 0; i < n - 1; i++) {
        let n = e.get(t, i) + e.get(t, i + 1) + e.get(t + 1, i) + e.get(t + 1, i + 1);
        (n === 4 || n === 0) && r++;
      }
      return r * t.N2;
    }, e.getPenaltyN3 = function (e) {
      let n = e.size,
        r = 0,
        i = 0,
        a = 0;
      for (let t = 0; t < n; t++) {
        i = a = 0;
        for (let o = 0; o < n; o++) i = i << 1 & 2047 | e.get(t, o), o >= 10 && (i === 1488 || i === 93) && r++, a = a << 1 & 2047 | e.get(o, t), o >= 10 && (a === 1488 || a === 93) && r++;
      }
      return r * t.N3;
    }, e.getPenaltyN4 = function (e) {
      let n = 0,
        r = e.data.length;
      for (let t = 0; t < r; t++) n += e.data[t];
      return Math.abs(Math.ceil(n * 100 / r / 5) - 10) * t.N4;
    };
    function n(t, n, r) {
      switch (t) {
        case e.Patterns.PATTERN000:
          return (n + r) % 2 == 0;
        case e.Patterns.PATTERN001:
          return n % 2 == 0;
        case e.Patterns.PATTERN010:
          return r % 3 == 0;
        case e.Patterns.PATTERN011:
          return (n + r) % 3 == 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(n / 2) + Math.floor(r / 3)) % 2 == 0;
        case e.Patterns.PATTERN101:
          return n * r % 2 + n * r % 3 == 0;
        case e.Patterns.PATTERN110:
          return (n * r % 2 + n * r % 3) % 2 == 0;
        case e.Patterns.PATTERN111:
          return (n * r % 3 + (n + r) % 2) % 2 == 0;
        default:
          throw Error(`bad maskPattern:` + t);
      }
    }
    e.applyMask = function (e, t) {
      let r = t.size;
      for (let i = 0; i < r; i++) for (let a = 0; a < r; a++) t.isReserved(a, i) || t.xor(a, i, n(e, a, i));
    }, e.getBestMask = function (t, n) {
      let r = Object.keys(e.Patterns).length,
        i = 0,
        a = 1 / 0;
      for (let o = 0; o < r; o++) {
        n(o), e.applyMask(o, t);
        let r = e.getPenaltyN1(t) + e.getPenaltyN2(t) + e.getPenaltyN3(t) + e.getPenaltyN4(t);
        e.applyMask(o, t), r < a && (a = r, i = o);
      }
      return i;
    };
  }),
  AZ = n(e => {
    var t = wZ(),
      n = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 2, 2, 4, 1, 2, 4, 4, 2, 4, 4, 4, 2, 4, 6, 5, 2, 4, 6, 6, 2, 5, 8, 8, 4, 5, 8, 8, 4, 5, 8, 11, 4, 8, 10, 11, 4, 9, 12, 16, 4, 9, 16, 16, 6, 10, 12, 18, 6, 10, 17, 16, 6, 11, 16, 19, 6, 13, 18, 21, 7, 14, 21, 25, 8, 16, 20, 25, 8, 17, 23, 25, 9, 17, 23, 34, 9, 18, 25, 30, 10, 20, 27, 32, 12, 21, 29, 35, 12, 23, 34, 37, 12, 25, 34, 40, 13, 26, 35, 42, 14, 28, 38, 45, 15, 29, 40, 48, 16, 31, 43, 51, 17, 33, 45, 54, 18, 35, 48, 57, 19, 37, 51, 60, 19, 38, 53, 63, 20, 40, 56, 66, 21, 43, 59, 70, 22, 45, 62, 74, 24, 47, 65, 77, 25, 49, 68, 81],
      r = [7, 10, 13, 17, 10, 16, 22, 28, 15, 26, 36, 44, 20, 36, 52, 64, 26, 48, 72, 88, 36, 64, 96, 112, 40, 72, 108, 130, 48, 88, 132, 156, 60, 110, 160, 192, 72, 130, 192, 224, 80, 150, 224, 264, 96, 176, 260, 308, 104, 198, 288, 352, 120, 216, 320, 384, 132, 240, 360, 432, 144, 280, 408, 480, 168, 308, 448, 532, 180, 338, 504, 588, 196, 364, 546, 650, 224, 416, 600, 700, 224, 442, 644, 750, 252, 476, 690, 816, 270, 504, 750, 900, 300, 560, 810, 960, 312, 588, 870, 1050, 336, 644, 952, 1110, 360, 700, 1020, 1200, 390, 728, 1050, 1260, 420, 784, 1140, 1350, 450, 812, 1200, 1440, 480, 868, 1290, 1530, 510, 924, 1350, 1620, 540, 980, 1440, 1710, 570, 1036, 1530, 1800, 570, 1064, 1590, 1890, 600, 1120, 1680, 1980, 630, 1204, 1770, 2100, 660, 1260, 1860, 2220, 720, 1316, 1950, 2310, 750, 1372, 2040, 2430];
    e.getBlocksCount = function (e, r) {
      switch (r) {
        case t.L:
          return n[(e - 1) * 4 + 0];
        case t.M:
          return n[(e - 1) * 4 + 1];
        case t.Q:
          return n[(e - 1) * 4 + 2];
        case t.H:
          return n[(e - 1) * 4 + 3];
        default:
          return;
      }
    }, e.getTotalCodewordsCount = function (e, n) {
      switch (n) {
        case t.L:
          return r[(e - 1) * 4 + 0];
        case t.M:
          return r[(e - 1) * 4 + 1];
        case t.Q:
          return r[(e - 1) * 4 + 2];
        case t.H:
          return r[(e - 1) * 4 + 3];
        default:
          return;
      }
    };
  }),
  jZ = n(e => {
    var t = new Uint8Array(512),
      n = new Uint8Array(256);
    (function () {
      let e = 1;
      for (let r = 0; r < 255; r++) t[r] = e, n[e] = r, e <<= 1, e & 256 && (e ^= 285);
      for (let e = 255; e < 512; e++) t[e] = t[e - 255];
    })(), e.log = function (e) {
      if (e < 1) throw Error(`log(` + e + `)`);
      return n[e];
    }, e.exp = function (e) {
      return t[e];
    }, e.mul = function (e, r) {
      return e === 0 || r === 0 ? 0 : t[n[e] + n[r]];
    };
  }),
  MZ = n(e => {
    var t = jZ();
    e.mul = function (e, n) {
      let r = new Uint8Array(e.length + n.length - 1);
      for (let i = 0; i < e.length; i++) for (let a = 0; a < n.length; a++) r[i + a] ^= t.mul(e[i], n[a]);
      return r;
    }, e.mod = function (e, n) {
      let r = new Uint8Array(e);
      for (; r.length - n.length >= 0;) {
        let e = r[0];
        for (let i = 0; i < n.length; i++) r[i] ^= t.mul(n[i], e);
        let i = 0;
        for (; i < r.length && r[i] === 0;) i++;
        r = r.slice(i);
      }
      return r;
    }, e.generateECPolynomial = function (n) {
      let r = new Uint8Array([1]);
      for (let i = 0; i < n; i++) r = e.mul(r, new Uint8Array([1, t.exp(i)]));
      return r;
    };
  }),
  NZ = n((e, t) => {
    var n = MZ();
    function r(e) {
      this.genPoly = void 0, this.degree = e, this.degree && this.initialize(this.degree);
    }
    r.prototype.initialize = function (e) {
      this.degree = e, this.genPoly = n.generateECPolynomial(this.degree);
    }, r.prototype.encode = function (e) {
      if (!this.genPoly) throw Error(`Encoder not initialized`);
      let t = new Uint8Array(e.length + this.degree);
      t.set(e);
      let r = n.mod(t, this.genPoly),
        i = this.degree - r.length;
      if (i > 0) {
        let e = new Uint8Array(this.degree);
        return e.set(r, i), e;
      }
      return r;
    }, t.exports = r;
  }),
  PZ = n(e => {
    e.isValid = function (e) {
      return !isNaN(e) && e >= 1 && e <= 40;
    };
  }),
  FZ = n(e => {
    var t = `[0-9]+`,
      n = `[A-Z $%*+\\-./:]+`,
      r = `(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+`;
    r = r.replace(/u/g, `\\u`);
    var i = `(?:(?![A-Z0-9 $%*+\\-./:]|` + r + `)(?:.|[\r
]))+`;
    e.KANJI = new RegExp(r, `g`), e.BYTE_KANJI = RegExp(`[^A-Z0-9 $%*+\\-./:]+`, `g`), e.BYTE = new RegExp(i, `g`), e.NUMERIC = new RegExp(t, `g`), e.ALPHANUMERIC = new RegExp(n, `g`);
    var a = RegExp(`^` + r + `$`),
      o = RegExp(`^[0-9]+$`),
      s = RegExp(`^[A-Z0-9 $%*+\\-./:]+$`);
    e.testKanji = function (e) {
      return a.test(e);
    }, e.testNumeric = function (e) {
      return o.test(e);
    }, e.testAlphanumeric = function (e) {
      return s.test(e);
    };
  }),
  IZ = n(e => {
    var t = PZ(),
      n = FZ();
    e.NUMERIC = {
      id: `Numeric`,
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: `Alphanumeric`,
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: `Byte`,
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: `Kanji`,
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function (e, n) {
      if (!e.ccBits) throw Error(`Invalid mode: ` + e);
      if (!t.isValid(n)) throw Error(`Invalid version: ` + n);
      return n >= 1 && n < 10 ? e.ccBits[0] : n < 27 ? e.ccBits[1] : e.ccBits[2];
    }, e.getBestModeForData = function (t) {
      return n.testNumeric(t) ? e.NUMERIC : n.testAlphanumeric(t) ? e.ALPHANUMERIC : n.testKanji(t) ? e.KANJI : e.BYTE;
    }, e.toString = function (e) {
      if (e && e.id) return e.id;
      throw Error(`Invalid mode`);
    }, e.isValid = function (e) {
      return e && e.bit && e.ccBits;
    };
    function r(t) {
      if (typeof t != `string`) throw Error(`Param is not a string`);
      switch (t.toLowerCase()) {
        case `numeric`:
          return e.NUMERIC;
        case `alphanumeric`:
          return e.ALPHANUMERIC;
        case `kanji`:
          return e.KANJI;
        case `byte`:
          return e.BYTE;
        default:
          throw Error(`Unknown mode: ` + t);
      }
    }
    e.from = function (t, n) {
      if (e.isValid(t)) return t;
      try {
        return r(t);
      } catch {
        return n;
      }
    };
  }),
  LZ = n(e => {
    var t = CZ(),
      n = AZ(),
      r = wZ(),
      i = IZ(),
      a = PZ(),
      o = 7973,
      s = t.getBCHDigit(o);
    function c(t, n, r) {
      for (let i = 1; i <= 40; i++) if (n <= e.getCapacity(i, r, t)) return i;
    }
    function l(e, t) {
      return i.getCharCountIndicator(e, t) + 4;
    }
    function u(e, t) {
      let n = 0;
      return e.forEach(function (e) {
        let r = l(e.mode, t);
        n += r + e.getBitsLength();
      }), n;
    }
    function d(t, n) {
      for (let r = 1; r <= 40; r++) if (u(t, r) <= e.getCapacity(r, n, i.MIXED)) return r;
    }
    e.from = function (e, t) {
      return a.isValid(e) ? parseInt(e, 10) : t;
    }, e.getCapacity = function (e, r, o) {
      if (!a.isValid(e)) throw Error(`Invalid QR Code version`);
      o === void 0 && (o = i.BYTE);
      let s = (t.getSymbolTotalCodewords(e) - n.getTotalCodewordsCount(e, r)) * 8;
      if (o === i.MIXED) return s;
      let c = s - l(o, e);
      switch (o) {
        case i.NUMERIC:
          return Math.floor(c / 10 * 3);
        case i.ALPHANUMERIC:
          return Math.floor(c / 11 * 2);
        case i.KANJI:
          return Math.floor(c / 13);
        case i.BYTE:
        default:
          return Math.floor(c / 8);
      }
    }, e.getBestVersionForData = function (e, t) {
      let n,
        i = r.from(t, r.M);
      if (Array.isArray(e)) {
        if (e.length > 1) return d(e, i);
        if (e.length === 0) return 1;
        n = e[0];
      } else n = e;
      return c(n.mode, n.getLength(), i);
    }, e.getEncodedBits = function (e) {
      if (!a.isValid(e) || e < 7) throw Error(`Invalid QR Code version`);
      let n = e << 12;
      for (; t.getBCHDigit(n) - s >= 0;) n ^= o << t.getBCHDigit(n) - s;
      return e << 12 | n;
    };
  }),
  RZ = n(e => {
    var t = CZ(),
      n = 1335,
      r = 21522,
      i = t.getBCHDigit(n);
    e.getEncodedBits = function (e, a) {
      let o = e.bit << 3 | a,
        s = o << 10;
      for (; t.getBCHDigit(s) - i >= 0;) s ^= n << t.getBCHDigit(s) - i;
      return (o << 10 | s) ^ r;
    };
  }),
  zZ = n((e, t) => {
    var n = IZ();
    function r(e) {
      this.mode = n.NUMERIC, this.data = e.toString();
    }
    r.getBitsLength = function (e) {
      return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
    }, r.prototype.getLength = function () {
      return this.data.length;
    }, r.prototype.getBitsLength = function () {
      return r.getBitsLength(this.data.length);
    }, r.prototype.write = function (e) {
      let t, n, r;
      for (t = 0; t + 3 <= this.data.length; t += 3) n = this.data.substr(t, 3), r = parseInt(n, 10), e.put(r, 10);
      let i = this.data.length - t;
      i > 0 && (n = this.data.substr(t), r = parseInt(n, 10), e.put(r, i * 3 + 1));
    }, t.exports = r;
  }),
  BZ = n((e, t) => {
    var n = IZ(),
      r = `0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:`.split(``);
    function i(e) {
      this.mode = n.ALPHANUMERIC, this.data = e;
    }
    i.getBitsLength = function (e) {
      return 11 * Math.floor(e / 2) + e % 2 * 6;
    }, i.prototype.getLength = function () {
      return this.data.length;
    }, i.prototype.getBitsLength = function () {
      return i.getBitsLength(this.data.length);
    }, i.prototype.write = function (e) {
      let t = 0;
      for (; t + 2 <= this.data.length; t += 2) {
        let n = r.indexOf(this.data[t]) * 45;
        n += r.indexOf(this.data[t + 1]), e.put(n, 11);
      }
      this.data.length % 2 && e.put(r.indexOf(this.data[t]), 6);
    }, t.exports = i;
  }),
  VZ = n((e, t) => {
    var n = IZ();
    function r(e) {
      this.mode = n.BYTE, this.data = typeof e == `string` ? new TextEncoder().encode(e) : new Uint8Array(e);
    }
    r.getBitsLength = function (e) {
      return e * 8;
    }, r.prototype.getLength = function () {
      return this.data.length;
    }, r.prototype.getBitsLength = function () {
      return r.getBitsLength(this.data.length);
    }, r.prototype.write = function (e) {
      for (let t = 0, n = this.data.length; t < n; t++) e.put(this.data[t], 8);
    }, t.exports = r;
  }),
  HZ = n((e, t) => {
    var n = IZ(),
      r = CZ();
    function i(e) {
      this.mode = n.KANJI, this.data = e;
    }
    i.getBitsLength = function (e) {
      return e * 13;
    }, i.prototype.getLength = function () {
      return this.data.length;
    }, i.prototype.getBitsLength = function () {
      return i.getBitsLength(this.data.length);
    }, i.prototype.write = function (e) {
      let t = 0;
      for (; t < this.data.length; t++) {
        let n = r.toSJIS(this.data[t]);
        if (n >= 33088 && n <= 40956) n -= 33088;else if (n >= 57408 && n <= 60351) n -= 49472;else throw Error(`Invalid SJIS character: ` + this.data[t] + `
Make sure your charset is UTF-8`);
        n = (n >>> 8 & 255) * 192 + (n & 255), e.put(n, 13);
      }
    }, t.exports = i;
  }),
  UZ = n((e, t) => {
    var n = {
      single_source_shortest_paths: function (e, t, r) {
        var i = {},
          a = {};
        a[t] = 0;
        var o = n.PriorityQueue.make();
        o.push(t, 0);
        for (var s, c, l, u, d, f, p, m, h; !o.empty();) for (l in s = o.pop(), c = s.value, u = s.cost, d = e[c] || {}, d) d.hasOwnProperty(l) && (f = d[l], p = u + f, m = a[l], h = a[l] === void 0, (h || m > p) && (a[l] = p, o.push(l, p), i[l] = c));
        if (r !== void 0 && a[r] === void 0) {
          var g = [`Could not find a path from `, t, ` to `, r, `.`].join(``);
          throw Error(g);
        }
        return i;
      },
      extract_shortest_path_from_predecessor_list: function (e, t) {
        for (var n = [], r = t; r;) n.push(r), e[r], r = e[r];
        return n.reverse(), n;
      },
      find_path: function (e, t, r) {
        var i = n.single_source_shortest_paths(e, t, r);
        return n.extract_shortest_path_from_predecessor_list(i, r);
      },
      PriorityQueue: {
        make: function (e) {
          var t = n.PriorityQueue,
            r = {},
            i;
          for (i in e ||= {}, t) t.hasOwnProperty(i) && (r[i] = t[i]);
          return r.queue = [], r.sorter = e.sorter || t.default_sorter, r;
        },
        default_sorter: function (e, t) {
          return e.cost - t.cost;
        },
        push: function (e, t) {
          var n = {
            value: e,
            cost: t
          };
          this.queue.push(n), this.queue.sort(this.sorter);
        },
        pop: function () {
          return this.queue.shift();
        },
        empty: function () {
          return this.queue.length === 0;
        }
      }
    };
    t !== void 0 && (t.exports = n);
  }),
  WZ = n(e => {
    var t = IZ(),
      n = zZ(),
      r = BZ(),
      i = VZ(),
      a = HZ(),
      o = FZ(),
      s = CZ(),
      c = UZ();
    function l(e) {
      return unescape(encodeURIComponent(e)).length;
    }
    function u(e, t, n) {
      let r = [],
        i;
      for (; (i = e.exec(n)) !== null;) r.push({
        data: i[0],
        index: i.index,
        mode: t,
        length: i[0].length
      });
      return r;
    }
    function d(e) {
      let n = u(o.NUMERIC, t.NUMERIC, e),
        r = u(o.ALPHANUMERIC, t.ALPHANUMERIC, e),
        i,
        a;
      return s.isKanjiModeEnabled() ? (i = u(o.BYTE, t.BYTE, e), a = u(o.KANJI, t.KANJI, e)) : (i = u(o.BYTE_KANJI, t.BYTE, e), a = []), n.concat(r, i, a).sort(function (e, t) {
        return e.index - t.index;
      }).map(function (e) {
        return {
          data: e.data,
          mode: e.mode,
          length: e.length
        };
      });
    }
    function f(e, o) {
      switch (o) {
        case t.NUMERIC:
          return n.getBitsLength(e);
        case t.ALPHANUMERIC:
          return r.getBitsLength(e);
        case t.KANJI:
          return a.getBitsLength(e);
        case t.BYTE:
          return i.getBitsLength(e);
      }
    }
    function p(e) {
      return e.reduce(function (e, t) {
        let n = e.length - 1 >= 0 ? e[e.length - 1] : null;
        return n && n.mode === t.mode ? (e[e.length - 1].data += t.data, e) : (e.push(t), e);
      }, []);
    }
    function m(e) {
      let n = [];
      for (let r = 0; r < e.length; r++) {
        let i = e[r];
        switch (i.mode) {
          case t.NUMERIC:
            n.push([i, {
              data: i.data,
              mode: t.ALPHANUMERIC,
              length: i.length
            }, {
              data: i.data,
              mode: t.BYTE,
              length: i.length
            }]);
            break;
          case t.ALPHANUMERIC:
            n.push([i, {
              data: i.data,
              mode: t.BYTE,
              length: i.length
            }]);
            break;
          case t.KANJI:
            n.push([i, {
              data: i.data,
              mode: t.BYTE,
              length: l(i.data)
            }]);
            break;
          case t.BYTE:
            n.push([{
              data: i.data,
              mode: t.BYTE,
              length: l(i.data)
            }]);
        }
      }
      return n;
    }
    function h(e, n) {
      let r = {},
        i = {
          start: {}
        },
        a = [`start`];
      for (let o = 0; o < e.length; o++) {
        let s = e[o],
          c = [];
        for (let e = 0; e < s.length; e++) {
          let l = s[e],
            u = `` + o + e;
          c.push(u), r[u] = {
            node: l,
            lastCount: 0
          }, i[u] = {};
          for (let e = 0; e < a.length; e++) {
            let o = a[e];
            r[o] && r[o].node.mode === l.mode ? (i[o][u] = f(r[o].lastCount + l.length, l.mode) - f(r[o].lastCount, l.mode), r[o].lastCount += l.length) : (r[o] && (r[o].lastCount = l.length), i[o][u] = f(l.length, l.mode) + 4 + t.getCharCountIndicator(l.mode, n));
          }
        }
        a = c;
      }
      for (let e = 0; e < a.length; e++) i[a[e]].end = 0;
      return {
        map: i,
        table: r
      };
    }
    function g(e, o) {
      let c,
        l = t.getBestModeForData(e);
      if (c = t.from(o, l), c !== t.BYTE && c.bit < l.bit) throw Error(`"` + e + `" cannot be encoded with mode ` + t.toString(c) + `.
 Suggested mode is: ` + t.toString(l));
      switch (c === t.KANJI && !s.isKanjiModeEnabled() && (c = t.BYTE), c) {
        case t.NUMERIC:
          return new n(e);
        case t.ALPHANUMERIC:
          return new r(e);
        case t.KANJI:
          return new a(e);
        case t.BYTE:
          return new i(e);
      }
    }
    e.fromArray = function (e) {
      return e.reduce(function (e, t) {
        return typeof t == `string` ? e.push(g(t, null)) : t.data && e.push(g(t.data, t.mode)), e;
      }, []);
    }, e.fromString = function (t, n) {
      let r = h(m(d(t, s.isKanjiModeEnabled())), n),
        i = c.find_path(r.map, `start`, `end`),
        a = [];
      for (let e = 1; e < i.length - 1; e++) a.push(r.table[i[e]].node);
      return e.fromArray(p(a));
    }, e.rawSplit = function (t) {
      return e.fromArray(d(t, s.isKanjiModeEnabled()));
    };
  }),
  GZ = n(e => {
    var t = CZ(),
      n = wZ(),
      r = TZ(),
      i = EZ(),
      a = DZ(),
      o = OZ(),
      s = kZ(),
      c = AZ(),
      l = NZ(),
      u = LZ(),
      d = RZ(),
      f = IZ(),
      p = WZ();
    function m(e, t) {
      let n = e.size,
        r = o.getPositions(t);
      for (let t = 0; t < r.length; t++) {
        let i = r[t][0],
          a = r[t][1];
        for (let t = -1; t <= 7; t++) if (!(i + t <= -1 || n <= i + t)) for (let r = -1; r <= 7; r++) a + r <= -1 || n <= a + r || (t >= 0 && t <= 6 && (r === 0 || r === 6) || r >= 0 && r <= 6 && (t === 0 || t === 6) || t >= 2 && t <= 4 && r >= 2 && r <= 4 ? e.set(i + t, a + r, !0, !0) : e.set(i + t, a + r, !1, !0));
      }
    }
    function h(e) {
      let t = e.size;
      for (let n = 8; n < t - 8; n++) {
        let t = n % 2 == 0;
        e.set(n, 6, t, !0), e.set(6, n, t, !0);
      }
    }
    function g(e, t) {
      let n = a.getPositions(t);
      for (let t = 0; t < n.length; t++) {
        let r = n[t][0],
          i = n[t][1];
        for (let t = -2; t <= 2; t++) for (let n = -2; n <= 2; n++) t === -2 || t === 2 || n === -2 || n === 2 || t === 0 && n === 0 ? e.set(r + t, i + n, !0, !0) : e.set(r + t, i + n, !1, !0);
      }
    }
    function _(e, t) {
      let n = e.size,
        r = u.getEncodedBits(t),
        i,
        a,
        o;
      for (let t = 0; t < 18; t++) i = Math.floor(t / 3), a = t % 3 + n - 8 - 3, o = (r >> t & 1) == 1, e.set(i, a, o, !0), e.set(a, i, o, !0);
    }
    function v(e, t, n) {
      let r = e.size,
        i = d.getEncodedBits(t, n),
        a,
        o;
      for (a = 0; a < 15; a++) o = (i >> a & 1) == 1, a < 6 ? e.set(a, 8, o, !0) : a < 8 ? e.set(a + 1, 8, o, !0) : e.set(r - 15 + a, 8, o, !0), a < 8 ? e.set(8, r - a - 1, o, !0) : a < 9 ? e.set(8, 15 - a - 1 + 1, o, !0) : e.set(8, 15 - a - 1, o, !0);
      e.set(r - 8, 8, 1, !0);
    }
    function y(e, t) {
      let n = e.size,
        r = -1,
        i = n - 1,
        a = 7,
        o = 0;
      for (let s = n - 1; s > 0; s -= 2) for (s === 6 && s--;;) {
        for (let n = 0; n < 2; n++) if (!e.isReserved(i, s - n)) {
          let r = !1;
          o < t.length && (r = (t[o] >>> a & 1) == 1), e.set(i, s - n, r), a--, a === -1 && (o++, a = 7);
        }
        if (i += r, i < 0 || n <= i) {
          i -= r, r = -r;
          break;
        }
      }
    }
    function b(e, n, i) {
      let a = new r();
      i.forEach(function (t) {
        a.put(t.mode.bit, 4), a.put(t.getLength(), f.getCharCountIndicator(t.mode, e)), t.write(a);
      });
      let o = (t.getSymbolTotalCodewords(e) - c.getTotalCodewordsCount(e, n)) * 8;
      for (a.getLengthInBits() + 4 <= o && a.put(0, 4); a.getLengthInBits() % 8 != 0;) a.putBit(0);
      let s = (o - a.getLengthInBits()) / 8;
      for (let e = 0; e < s; e++) a.put(e % 2 ? 17 : 236, 8);
      return x(a, e, n);
    }
    function x(e, n, r) {
      let i = t.getSymbolTotalCodewords(n),
        a = i - c.getTotalCodewordsCount(n, r),
        o = c.getBlocksCount(n, r),
        s = o - i % o,
        u = Math.floor(i / o),
        d = Math.floor(a / o),
        f = d + 1,
        p = u - d,
        m = new l(p),
        h = 0,
        g = Array(o),
        _ = Array(o),
        v = 0,
        y = new Uint8Array(e.buffer);
      for (let e = 0; e < o; e++) {
        let t = e < s ? d : f;
        g[e] = y.slice(h, h + t), _[e] = m.encode(g[e]), h += t, v = Math.max(v, t);
      }
      let b = new Uint8Array(i),
        x = 0,
        S,
        C;
      for (S = 0; S < v; S++) for (C = 0; C < o; C++) S < g[C].length && (b[x++] = g[C][S]);
      for (S = 0; S < p; S++) for (C = 0; C < o; C++) b[x++] = _[C][S];
      return b;
    }
    function S(e, n, r, a) {
      let o;
      if (Array.isArray(e)) o = p.fromArray(e);else if (typeof e == `string`) {
        let t = n;
        if (!t) {
          let n = p.rawSplit(e);
          t = u.getBestVersionForData(n, r);
        }
        o = p.fromString(e, t || 40);
      } else throw Error(`Invalid data`);
      let c = u.getBestVersionForData(o, r);
      if (!c) throw Error(`The amount of data is too big to be stored in a QR Code`);
      if (!n) n = c;else if (n < c) throw Error(`
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + c + `.
`);
      let l = b(n, r, o),
        d = new i(t.getSymbolSize(n));
      return m(d, n), h(d), g(d, n), v(d, r, 0), n >= 7 && _(d, n), y(d, l), isNaN(a) && (a = s.getBestMask(d, v.bind(null, d, r))), s.applyMask(a, d), v(d, r, a), {
        modules: d,
        version: n,
        errorCorrectionLevel: r,
        maskPattern: a,
        segments: o
      };
    }
    e.create = function (e, r) {
      if (e === void 0 || e === ``) throw Error(`No input text`);
      let i = n.M,
        a,
        o;
      return r !== void 0 && (i = n.from(r.errorCorrectionLevel, n.M), a = u.from(r.version), o = s.from(r.maskPattern), r.toSJISFunc && t.setToSJISFunction(r.toSJISFunc)), S(e, a, i, o);
    };
  }),
  KZ = n(e => {
    function t(e) {
      if (typeof e == `number` && (e = e.toString()), typeof e != `string`) throw Error(`Color should be defined as hex string`);
      let t = e.slice().replace(`#`, ``).split(``);
      if (t.length < 3 || t.length === 5 || t.length > 8) throw Error(`Invalid hex color: ` + e);
      (t.length === 3 || t.length === 4) && (t = Array.prototype.concat.apply([], t.map(function (e) {
        return [e, e];
      }))), t.length === 6 && t.push(`F`, `F`);
      let n = parseInt(t.join(``), 16);
      return {
        r: n >> 24 & 255,
        g: n >> 16 & 255,
        b: n >> 8 & 255,
        a: n & 255,
        hex: `#` + t.slice(0, 6).join(``)
      };
    }
    e.getOptions = function (e) {
      e ||= {}, e.color || (e.color = {});
      let n = e.margin === void 0 || e.margin === null || e.margin < 0 ? 4 : e.margin,
        r = e.width && e.width >= 21 ? e.width : void 0,
        i = e.scale || 4;
      return {
        width: r,
        scale: r ? 4 : i,
        margin: n,
        color: {
          dark: t(e.color.dark || `#000000ff`),
          light: t(e.color.light || `#ffffffff`)
        },
        type: e.type,
        rendererOpts: e.rendererOpts || {}
      };
    }, e.getScale = function (e, t) {
      return t.width && t.width >= e + t.margin * 2 ? t.width / (e + t.margin * 2) : t.scale;
    }, e.getImageWidth = function (t, n) {
      let r = e.getScale(t, n);
      return Math.floor((t + n.margin * 2) * r);
    }, e.qrToImageData = function (t, n, r) {
      let i = n.modules.size,
        a = n.modules.data,
        o = e.getScale(i, r),
        s = Math.floor((i + r.margin * 2) * o),
        c = r.margin * o,
        l = [r.color.light, r.color.dark];
      for (let e = 0; e < s; e++) for (let n = 0; n < s; n++) {
        let u = (e * s + n) * 4,
          d = r.color.light;
        if (e >= c && n >= c && e < s - c && n < s - c) {
          let t = Math.floor((e - c) / o),
            r = Math.floor((n - c) / o);
          d = l[+!!a[t * i + r]];
        }
        t[u++] = d.r, t[u++] = d.g, t[u++] = d.b, t[u] = d.a;
      }
    };
  }),
  qZ = n(e => {
    var t = KZ();
    function n(e, t, n) {
      e.clearRect(0, 0, t.width, t.height), t.style ||= {}, t.height = n, t.width = n, t.style.height = n + `px`, t.style.width = n + `px`;
    }
    function r() {
      try {
        return document.createElement(`canvas`);
      } catch {
        throw Error(`You need to specify a canvas element`);
      }
    }
    e.render = function (e, i, a) {
      let o = a,
        s = i;
      o === void 0 && (!i || !i.getContext) && (o = i, i = void 0), i || (s = r()), o = t.getOptions(o);
      let c = t.getImageWidth(e.modules.size, o),
        l = s.getContext(`2d`),
        u = l.createImageData(c, c);
      return t.qrToImageData(u.data, e, o), n(l, s, c), l.putImageData(u, 0, 0), s;
    }, e.renderToDataURL = function (t, n, r) {
      let i = r;
      i === void 0 && (!n || !n.getContext) && (i = n, n = void 0), i ||= {};
      let a = e.render(t, n, i),
        o = i.type || `image/png`,
        s = i.rendererOpts || {};
      return a.toDataURL(o, s.quality);
    };
  }),
  JZ = n(e => {
    var t = KZ();
    function n(e, t) {
      let n = e.a / 255,
        r = t + `="` + e.hex + `"`;
      return n < 1 ? r + ` ` + t + `-opacity="` + n.toFixed(2).slice(1) + `"` : r;
    }
    function r(e, t, n) {
      let r = e + t;
      return n !== void 0 && (r += ` ` + n), r;
    }
    function i(e, t, n) {
      let i = ``,
        a = 0,
        o = !1,
        s = 0;
      for (let c = 0; c < e.length; c++) {
        let l = Math.floor(c % t),
          u = Math.floor(c / t);
        !l && !o && (o = !0), e[c] ? (s++, c > 0 && l > 0 && e[c - 1] || (i += o ? r(`M`, l + n, .5 + u + n) : r(`m`, a, 0), a = 0, o = !1), l + 1 < t && e[c + 1] || (i += r(`h`, s), s = 0)) : a++;
      }
      return i;
    }
    e.render = function (e, r, a) {
      let o = t.getOptions(r),
        s = e.modules.size,
        c = e.modules.data,
        l = s + o.margin * 2,
        u = o.color.light.a ? `<path ` + n(o.color.light, `fill`) + ` d="M0 0h` + l + `v` + l + `H0z"/>` : ``,
        d = `<path ` + n(o.color.dark, `stroke`) + ` d="` + i(c, s, o.margin) + `"/>`,
        f = `viewBox="0 0 ` + l + ` ` + l + `"`,
        p = `<svg xmlns="http://www.w3.org/2000/svg" ` + (o.width ? `width="` + o.width + `" height="` + o.width + `" ` : ``) + f + ` shape-rendering="crispEdges">` + u + d + `</svg>
`;
      return typeof a == `function` && a(null, p), p;
    };
  }),
  YZ = e(n(e => {
    var t = SZ(),
      n = GZ(),
      r = qZ(),
      i = JZ();
    function a(e, r, i, a, o) {
      let s = [].slice.call(arguments, 1),
        c = s.length,
        l = typeof s[c - 1] == `function`;
      if (!l && !t()) throw Error(`Callback required as last argument`);
      if (l) {
        if (c < 2) throw Error(`Too few arguments provided`);
        c === 2 ? (o = i, i = r, r = a = void 0) : c === 3 && (r.getContext && o === void 0 ? (o = a, a = void 0) : (o = a, a = i, i = r, r = void 0));
      } else {
        if (c < 1) throw Error(`Too few arguments provided`);
        return c === 1 ? (i = r, r = a = void 0) : c === 2 && !r.getContext && (a = i, i = r, r = void 0), new Promise(function (t, o) {
          try {
            t(e(n.create(i, a), r, a));
          } catch (e) {
            o(e);
          }
        });
      }
      try {
        let t = n.create(i, a);
        o(null, e(t, r, a));
      } catch (e) {
        o(e);
      }
    }
    e.create = n.create, e.toCanvas = a.bind(null, r.render), e.toDataURL = a.bind(null, r.renderToDataURL), e.toString = a.bind(null, function (e, t, n) {
      return i.render(e, n);
    });
  })(), 1);
var ZZ = 2e3,
  QZ = 1e4;
function $Z(e) {
  return (e ?? []).some(e => e.qr || e.codigo || e.codigoPendiente || e.desvinculacionPendiente || e.estado === `esperando-qr`) ? ZZ : QZ;
}
function tQ(e) {
  if (e.estado === `sin-datos`) return {
    texto: `Sin poner en marcha`,
    tono: `neutro`
  };
  if (!e.enLinea) return {
    texto: `Sin señal`,
    tono: `error`
  };
  switch (e.estado) {
    case `conectado`:
      return {
        texto: `Conectado`,
        tono: `success`
      };
    case `esperando-qr`:
      return {
        texto: `Falta vincular`,
        tono: `warning`
      };
    case `sesion-cerrada`:
      return {
        texto: `Desvinculado`,
        tono: `error`
      };
    default:
      return {
        texto: `Conectando…`,
        tono: `info`
      };
  }
}
var nQ = {
  success: `bg-(--success-bg) text-(--success-texto)`,
  warning: `bg-(--warning-bg) text-(--warning-texto)`,
  error: `bg-(--error-bg) text-(--error-texto)`,
  info: `bg-(--info-bg) text-(--info-texto)`,
  neutro: `bg-(--panel) text-(--text)`
};
function rQ(e) {
  if (!e) return null;
  let t = String(e);
  return /^51\d{9}$/.test(t) ? `+51 ${t.slice(2, 5)} ${t.slice(5, 8)} ${t.slice(8)}` : `+${t}`;
}
var fQ = 3e5,
  pQ = 3e4;
function hQ() {}
function gQ() {}
function _Q() {}
function vQ() {}
function yQ(e) {
  return {
    imagen: `📷 Foto`,
    audio: `🎤 Audio`,
    video: `🎬 Video`,
    documento: `📄 Documento`,
    sticker: `Sticker`,
    ubicacion: `📍 Ubicación`,
    contacto: `👤 Contacto`
  }[e] ?? ``;
}
var EQ = [{
    id: `atender`,
    label: `Por atender`
  }, {
    id: `ordenes`,
    label: `Órdenes`
  }, {
    id: `reportes`,
    label: `Reportes`
  }, {
    id: `tarifario`,
    label: `Tarifario`
  }, {
    id: `flota`,
    label: `Flota`
  }],
  DQ = `__todos__`,
  OQ = {
    PROGRAMADA: `Programada`,
    REALIZADA: `Realizada`,
    CANCELADA: `Cancelada`,
    RECHAZADA: `No salió nadie`
  };
function kQ() {
  return new Date().toISOString().slice(0, 10);
}
function AQ(e) {
  let t = new Date();
  return t.setDate(t.getDate() - e), t.toISOString().slice(0, 10);
}
function jQ(e) {
  if (!e) return `—`;
  let [t, n, r] = String(e).slice(0, 10).split(`-`);
  return `${r}/${n}/${t}`;
}
function MQ(e) {
  return e == null ? `—` : `S/ ${Number(e).toFixed(2)}`;
}
var PQ = [{
  id: `salida`,
  etiqueta: `Salida`,
  campo: e => e.salida
}, {
  id: `destino`,
  etiqueta: `Destino`,
  campo: e => e.destino
}, {
  id: `sede`,
  etiqueta: `Sede`,
  campo: e => e.sede
}, {
  id: `area`,
  etiqueta: `Área`,
  campo: e => e.area
}, {
  id: `solicitante`,
  etiqueta: `Lo pidió`,
  campo: e => e.solicitante
}];
function IQ(e) {
  return !e;
}
function HQ(e, t) {
  return e + (t.personas ?? 0);
}
function UQ(e) {
  return e.confirmacion === `RECHAZADO`;
}
function WQ(e) {
  return e.confirmacion === `LISTO`;
}
function GQ(e) {
  return e.confirmacion;
}
function YQ(e) {
  return e.confirmacion === `RECHAZADO`;
}
function XQ(e) {
  return e.confirmacion === `LISTO`;
}
function ZQ(e) {
  return e.confirmacion;
}
var $Q = [{
  id: `gastos`,
  label: `Gastos por área`
}, {
  id: `uso`,
  label: `Uso`
}];
function e$() {
  let e = new Date();
  return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, `0`)}-01`;
}
async function t$(e, {
  desde: t,
  hasta: n,
  avisos: r
}) {
  if (!e || e.ordenes === 0) {
    r.info(`No hay nada para llevar a Excel en ese período`);
    return;
  }
  let i = await b(() => Promise.resolve().then(() => EA), void 0),
    a = i.utils.book_new(),
    o = (e, t) => {
      t.length !== 0 && i.utils.book_append_sheet(a, i.utils.json_to_sheet(t), e);
    };
  o(`Gastos por area`, (e.areas ?? []).map(e => ({
    Área: e.area,
    Órdenes: e.ordenes,
    Personas: e.personas,
    "No viajaron": e.noViajaron,
    Servicio: Number(e.costo ?? 0),
    Penalidad: Number(e.penalidad ?? 0),
    Total: Number(e.total ?? 0),
    Porcentaje: Number(e.porcentaje ?? 0)
  }))), o(`Resumen`, [{
    Desde: t,
    Hasta: n,
    Órdenes: e.ordenes,
    "Se hicieron": e.realizadas,
    "Se cancelaron": e.canceladas,
    "No salió nadie": e.rechazadas,
    "Sin cerrar": e.programadas,
    Servicio: Number(e.costo ?? 0),
    Penalidades: Number(e.penalidad ?? 0),
    Total: Number(e.total ?? 0),
    "Pedidos preguntados": e.pedidos,
    Confirmaron: e.confirmaron,
    "Se bajaron": e.seBajaron,
    "No contestaron": e.sinContestar,
    "Personas que no viajaron": e.personasQueNoViajaron,
    Encuestados: e.encuestados,
    "Contestaron la encuesta": e.contestaron,
    Calificación: e.calificacion == null ? `` : Number(e.calificacion),
    "Llegó tarde": e.llegoTarde,
    "No llegó": e.noLlego,
    "No viajaron (encuesta)": e.noViajaron
  }]);
  let s = e => (e ?? []).map(e => ({
    Nombre: e.etiqueta,
    Detalle: e.detalle ?? ``,
    Veces: e.veces,
    Personas: e.personas,
    Monto: Number(e.monto ?? 0),
    Penalidad: Number(e.penalidad ?? 0)
  }));
  o(`Rutas`, s(e.rutas)), o(`Proveedores`, s(e.proveedores)), o(`Areas que se bajan`, s(e.areasQueSeBajan)), o(`Quienes se bajan`, s(e.personasQueSeBajan));
  let c = e => (e ?? []).map(e => ({
    Nombre: e.etiqueta,
    Respuestas: e.veces,
    Nota: Number(e.monto ?? 0)
  }));
  o(`Rutas peor calificadas`, c(e.rutasPeorCalificadas)), o(`Proveedores peor calificados`, c(e.proveedoresPeorCalificados)), i.writeFile(a, `transporte-${t}-a-${n}.xlsx`), r.ok(`Archivo descargado`);
}
function a$(e) {
  return Number(e.total ?? 0);
}
function c$(e) {
  return e.veces;
}
var d$ = 200;
function y$(e) {
  if (!e) return `—`;
  let t = new Date(e);
  return Number.isNaN(t.getTime()) ? `—` : t.toLocaleString(`es-PE`, {
    day: `2-digit`,
    month: `2-digit`,
    hour: `2-digit`,
    minute: `2-digit`
  });
}
function b$(e, t) {
  if (!e.dependeDe) return !0;
  let n = t[e.dependeDe];
  return Array.isArray(n) ? n.includes(e.dependeValor) : n === e.dependeValor;
}
function x$(e) {
  return e == null ? !0 : Array.isArray(e) ? e.length === 0 : String(e).trim() === ``;
}
function S$(e, t) {
  let n = [],
    r = new Map();
  for (let i of e) {
    if (!b$(i, t)) continue;
    let e = r.get(i.categoria);
    e || (e = {
      nombre: i.categoria,
      campos: [],
      fija: !1,
      marcadas: 0
    }, r.set(i.categoria, e), n.push(e)), e.campos.push(i), (i.obligatorio || i.dependeDe) && (e.fija = !0);
    let a = t[i.id];
    x$(a) || (e.marcadas += Array.isArray(a) ? a.length : 1);
  }
  return n;
}
function C$(e) {
  let t = new Map();
  for (let n of e) {
    let e = t.get(n.categoria) ?? {
      alternativa: !0
    };
    (n.obligatorio || n.dependeDe) && (e.alternativa = !1), t.set(n.categoria, e);
  }
  return new Set([...t].filter(([, e]) => e.alternativa).map(([e]) => e));
}
function w$(e, t, n) {
  let r = C$(e),
    i = {
      ...t
    };
  for (let t of e) r.has(t.categoria) && t.categoria !== n && delete i[t.id];
  return i;
}
function T$(e, t) {
  let n = C$(e),
    r = e.find(e => n.has(e.categoria) && !x$(t[e.id]));
  return r ? r.categoria : null;
}
function E$(e, t) {
  return C$(e).size > 1 && T$(e, t) == null;
}
function D$(e, t, n = new Set()) {
  let r = [];
  for (let i of e) if (r.push(i), x$(t[i.id]) && !n.has(i.id)) break;
  return r;
}
function O$(e, t) {
  return e.filter(e => e.obligatorio && b$(e, t) && x$(t[e.id])).map(e => e.etiqueta);
}
var k$ = {
  REPORTADA: `Se reportó`,
  TOMADA: `La tomaron`,
  ASIGNADA: `Se designó a`,
  RESUELTA: `Se resolvió`,
  DERIVADA: `Pasó a otra área`,
  ANULADA: `Se anuló`,
  CRITICIDAD_CAMBIADA: `Cambió la gravedad`,
  REABIERTA: `Se reabrió`
};
var F$ = [`var(--accent)`, `var(--success)`, `var(--warning)`, `var(--info)`, `var(--error)`],
  I$ = Array.from({
    length: 28
  }, (e, t) => {
    let n = t / 28 * 2 * Math.PI,
      r = 90 + t * 37 % 70;
    return {
      "--x": `${Math.round(Math.cos(n) * r)}px`,
      "--y": `${Math.round(Math.sin(n) * r - 30)}px`,
      "--r": `${(t % 2 ? 1 : -1) * (180 + t * 47 % 360)}deg`,
      "--d": `${t % 5 * 30}ms`,
      "--c": F$[t % F$.length]
    };
  });
async function z$(e) {
  if (!e || ![`image/jpeg`, `image/png`, `image/webp`].includes(e.type)) throw Error(`Selecciona una foto JPG, PNG o WebP.`);
  if (e.size > 20971520) throw Error(`La foto no puede superar 20 MB.`);
  let t = URL.createObjectURL(e);
  try {
    let e = await new Promise((e, n) => {
        let r = new Image();
        r.onload = () => e(r), r.onerror = () => n(Error(`No se pudo abrir la foto. Elige otra.`)), r.src = t;
      }),
      n = Math.min(1, 1800 / Math.max(e.width, e.height)),
      r = document.createElement(`canvas`);
    r.width = Math.round(e.width * n), r.height = Math.round(e.height * n), r.getContext(`2d`).drawImage(e, 0, 0, r.width, r.height);
    let i = await new Promise(e => r.toBlob(e, `image/jpeg`, .85));
    if (!i) throw Error(`No se pudo preparar la foto.`);
    return new File([i], `evidencia.jpg`, {
      type: `image/jpeg`
    });
  } finally {
    URL.revokeObjectURL(t);
  }
}
var B$ = {
    REPORTADA: `Esperando`,
    EN_PROCESO: `En eso están`,
    RESUELTA: `Resuelta`,
    DERIVADA: `Pasó a otra área`,
    ANULADA: `Anulada`
  },
  V$ = {
    toilet: `🚻`,
    utensils: `🍽️`,
    soup: `🥘`,
    sparkles: `🧹`
  };
function H$(e) {
  return V$[e?.icono] ?? `🚨`;
}
var U$ = [[/instalac/i, `🔧`], [/insumo/i, `🧻`], [/espera|tiempo/i, `⏱️`], [/cuerpo/i, `🔎`], [/derrame/i, `💧`], [/temperatura/i, `🌡️`], [/limpie/i, `🧽`], [/general/i, `📋`]];
function W$(e) {
  return U$.find(([t]) => t.test(e ?? ``))?.[1] ?? `✳️`;
}
var G$ = `gth_incidencia_fundo`;
function K$() {
  try {
    return Number(localStorage.getItem(G$)) || null;
  } catch {
    return null;
  }
}
function q$(e) {
  try {
    e && localStorage.setItem(G$, String(e));
  } catch {}
}
function $$(e) {
  return e.estado !== `RESUELTA` && e.estado !== `ANULADA`;
}
function e1(e) {
  return e.estado === `RESUELTA` || e.estado === `ANULADA`;
}
var n1 = [`Qué`, `Dónde`, `Detalle`, `Foto`],
  r1 = {
    1: {
      emoji: `📍`,
      titulo: `¿Dónde fue?`,
      ayuda: `Así el área sabe a dónde ir.`
    },
    2: {
      emoji: `🔍`,
      titulo: `Contanos qué pasó`,
      ayuda: `Tocá lo que viste. Nada de escribir de más.`
    },
    3: {
      emoji: `📸`,
      titulo: `Una foto y listo`,
      ayuda: `Con la foto, el área sabe qué llevar antes de ir.`
    }
  };
function c1(e) {
  let t = [];
  for (let n of e ?? []) {
    let e = n.seccion || `Revisión`,
      r = t[t.length - 1];
    r && r.nombre === e ? r.items.push(n) : t.push({
      nombre: e,
      items: [n]
    });
  }
  return t.flatMap(e => {
    let t = Math.ceil(e.items.length / 8);
    return Array.from({
      length: t
    }, (n, r) => ({
      nombre: t > 1 ? `${e.nombre} · ${r + 1}/${t}` : e.nombre,
      items: e.items.slice(r * 8, (r + 1) * 8)
    }));
  });
}
var l1 = e => String(e).padStart(2, `0`);
function u1(e = new Date()) {
  return `${e.getFullYear()}-${l1(e.getMonth() + 1)}-${l1(e.getDate())}`;
}
function d1(e = new Date()) {
  return `${l1(e.getHours())}:${l1(e.getMinutes())}`;
}
function f1(e, t, n = new Date()) {
  let r = {
      ...(t?.cabecera ?? {})
    },
    i = !1;
  for (let t of e ?? []) {
    let e = r[t.id];
    (e == null || String(e).trim() === ``) && (t.tipo === `FECHA` ? (r[t.id] = u1(n), i = !0) : t.tipo === `HORA` && (r[t.id] = d1(n), i = !0));
  }
  return i ? {
    datos: {
      ...t,
      cabecera: r
    },
    cambio: i
  } : {
    datos: t,
    cambio: i
  };
}
// Llena la cabecera con lo que se eligió al iniciar el acta: el fundo
// («ubicacion») y, en las actas de cocina, la concesionaria (2026-10-07).
function p1(e, t, n, k) {
  let cabecera = { ...(t?.cabecera ?? {}) },
    cambio = !1;
  for (let [id, valor] of [[`ubicacion`, n], [`concesionaria`, k]]) {
    let campo = (e ?? []).find(e => e.id === id),
      actual = cabecera[id];
    valor && campo && (actual == null || String(actual).trim() === ``) && (cabecera[id] = valor, cambio = !0);
  }
  return cambio ? { datos: { ...t, cabecera }, cambio } : { datos: t, cambio };
}
function m1(e, t) {
  return e?.hallazgo ? Array.isArray(t) && t.some(t => !e.sinHallazgo?.includes(t)) : !!e?.negativos?.includes(t);
}
// La fecha de levantamiento es opcional: si queda vacía, el plazo sale de la criticidad (2026-10-08).
var h1 = [`observacion`, `accion`, `responsable`];
function g1(e, t) {
  let n = [];
  for (let r of e ?? []) {
    let e = t?.items?.[r.id] ?? {};
    if (!m1(r, e.valor)) continue;
    let i = h1.filter(t => e[t] == null || String(e[t]).trim() === ``);
    i.length && n.push({
      id: r.id,
      etiqueta: r.etiqueta,
      faltan: i
    });
  }
  return n;
}
function _1(e, t) {
  return (e ?? []).filter(e => {
    let n = t?.items?.[e.id]?.valor;
    return Array.isArray(n) ? n.length > 0 : n != null && n !== ``;
  }).length;
}
var v1 = [[/epp|higiene/i, `🦺`], [/cocina/i, `🍳`], [/almac/i, `📦`], [/document|vigencia/i, `📄`], [/inocuidad|manipula/i, `🧼`], [/plaga|residuo/i, `🪤`], [/infraestructura|equipamiento/i, `🏗️`], [/servicio|atenci/i, `🍽️`], [/ss\.?hh|baño/i, `🚻`], [/limpieza/i, `🧽`], [/estado/i, `🚦`]];
function y1(e) {
  return v1.find(([t]) => t.test(e ?? ``))?.[1] ?? `📋`;
}
function b1(e) {
  return e >= 100 ? `¡Todo contestado! Sólo falta firmar ✨` : e >= 75 ? `Ya casi 🏁` : e >= 50 ? `Pasaste la mitad 💪` : e > 0 ? `Vas bien, seguí así 👍` : `¡Arrancamos! Tocá Cumple o No cumple en cada punto 👇`;
}
var x1 = e => `gth_acta_borrador_${e}`;
function S1(e, t, n) {
  try {
    localStorage.setItem(x1(e), JSON.stringify({
      revision: t,
      datos: n,
      en: Date.now()
    }));
  } catch {}
}
function C1(e, t) {
  try {
    let n = JSON.parse(localStorage.getItem(x1(e)) ?? `null`);
    return n && n.revision === t ? n.datos : null;
  } catch {
    return null;
  }
}
function w1(e) {
  try {
    localStorage.removeItem(x1(e));
  } catch {}
}
function T1(e, t = {}) {
  let n = {
    ...t
  };
  for (let t of e) {
    if (t.tipo !== `UNICA` || !t.negativos?.length) continue;
    let e = n[t.id]?.valor;
    if (e != null && e !== ``) continue;
    let r = t.opciones.find(e => !t.negativos.includes(e) && e !== `N.A.`);
    r && (n[t.id] = {
      ...n[t.id],
      valor: r
    });
  }
  return n;
}
var E1 = 5,
  D1 = e => String(e).padStart(2, `0`);
function k1(e) {
  return !e;
}
function A1(e, t) {
  return D1(t * E1);
}
function j1(e, t) {
  return D1(t);
}
var F1 = `min-h-11 w-full min-w-0 rounded-xl border border-(--border) bg-(--bg) px-3 py-2 text-base text-(--text-h) outline-none focus:ring-2 focus:ring-(--accent-border)`,
  I1 = `rounded-xl border border-(--border) bg-(--panel) p-3 sm:p-4`,
  L1 = `min-h-11 min-w-0 rounded-lg border px-2 py-2 text-center text-xs sm:text-sm transition active:scale-[0.97] focus-visible:ring-2 focus-visible:ring-(--accent-border)`,
  R1 = `text-sm font-medium text-(--text-h) !m-0`;
function z1(e, t) {
  return e.hallazgo ? Array.isArray(t) && t.some(t => !e.sinHallazgo?.includes(t)) : e.negativos?.includes(t);
}
function q1(e) {
  return {
    value: e.id,
    label: e.nombre
  };
}
var J1 = {
  datos: `Revisá que la fecha, la hora y el lugar sean los de ahora: se completan solos.`,
  seccion: `Tocá Cumple o No cumple en cada punto. Si todo está en regla, «Todo cumple» marca el resto de una.`,
  evidencia: `Una foto general de cómo encontraste el lugar, y un repaso de lo que marcaste.`,
  firmas: `Firma quien inspecciona y el encargado de la concesionaria. Después el acta ya no se cambia.`
};
function t0(e) {
  return e.fotos.length;
}
function i0(e) {
  return e.campo === `foto:general`;
}
var a0 = {
  INCIDENCIA: `Reportada`,
  OBSERVACION: `De inspección`
};
function o0(e, t = new Date()) {
  if (!e) return `Sin plazo`;
  let n = new Date(e);
  if (Number.isNaN(n.getTime())) return `Sin plazo`;
  let r = Math.round((n.getTime() - t.getTime()) / 6e4),
    i = r < 0,
    a = Math.abs(r),
    o;
  if (a < 60) o = `${a} min`;else if (a < 1440) {
    let e = Math.round(a / 60);
    o = `${e} ${e === 1 ? `hora` : `horas`}`;
  } else {
    let e = Math.round(a / 1440);
    o = `${e} ${e === 1 ? `día` : `días`}`;
  }
  return i ? `Hace ${o}` : `En ${o}`;
}
function s0(e, t = new Date()) {
  if (e?.vencida) return !0;
  if (!e?.vence) return !1;
  let n = new Date(e.vence);
  return !Number.isNaN(n.getTime()) && n < t;
}
function c0(e, t = new Date()) {
  let n = e ?? [];
  return {
    pendientes: n.length,
    vencidas: n.filter(e => s0(e, t)).length
  };
}
var l0 = [{
  id: ``,
  label: `Todo`
}, {
  id: `INCIDENCIA`,
  label: `Reportadas`
}, {
  id: `OBSERVACION`,
  label: `De inspección`
}];
function m0(e, t) {
  let n = (0, ReactCompiler.c)(8),
    r;
  n[0] === t ? r = n[1] : (r = t === void 0 ? {} : t, n[0] = t, n[1] = r);
  let {
      activo: i,
      abajo: a,
      minimo: o
    } = r,
    s = i === void 0 || i,
    c = a === void 0 ? 56 : a,
    l = o === void 0 ? 360 : o,
    [u, f] = (0, React.useState)(null),
    p,
    m;
  return n[2] !== c || n[3] !== s || n[4] !== l || n[5] !== e ? (p = () => {
    if (!s) return;
    let t = () => {
      let t = e.current;
      if (!t) return;
      let n = t.closest(`main`),
        r = t.getBoundingClientRect().top + (n?.scrollTop ?? 0);
      f(Math.max(l, window.innerHeight - r - c));
    };
    return t(), window.addEventListener(`resize`, t), () => window.removeEventListener(`resize`, t);
  }, m = [e, s, c, l], n[2] = c, n[3] = s, n[4] = l, n[5] = e, n[6] = p, n[7] = m) : (p = n[6], m = n[7]), (0, React.useLayoutEffect)(p, m), u;
}
function h0(e, t) {
  if (t.texto) return t.texto(e) ?? ``;
  let n = e?.[t.clave];
  return n == null ? `` : String(n);
}
function g0(e, t) {
  if (t.valores) {
    let n = t.valores(e) ?? [];
    return n.length ? n.map(String) : [``];
  }
  return [h0(e, t)];
}
var _0 = new Intl.Collator(`es`, {
  numeric: !0,
  sensitivity: `base`
});
function v0(e, t) {
  let n = t.orden ? t.orden(e) : e?.[t.clave];
  return n == null || n === `` ? null : n;
}
function y0(e, t, n) {
  if (!t) return e;
  let r = n.find(e => e.clave === t.clave);
  if (!r) return e;
  let i = t.dir === `desc` ? -1 : 1;
  return [...e].sort((e, t) => {
    let n = v0(e, r),
      a = v0(t, r);
    return n === null && a === null ? 0 : n === null ? 1 : a === null ? -1 : (typeof n == `number` && typeof a == `number` ? n - a : _0.compare(String(n), String(a))) * i;
  });
}
function b0(e, t, n) {
  let r = Object.entries(t ?? {}).filter(([, e]) => e);
  if (!r.length) return e;
  let i = Object.fromEntries(n.map(e => [e.clave, e]));
  return e.filter(e => r.every(([t, n]) => {
    let r = i[t];
    return !r || g0(e, r).some(e => n.has(e));
  }));
}
function x0(e, t, n, r) {
  let i = r.find(e => e.clave === t);
  if (!i) return [];
  let a = {
    ...n
  };
  delete a[t];
  let o = new Set();
  for (let t of b0(e, a, r)) for (let e of g0(t, i)) o.add(e);
  return [...o].sort((e, t) => e === `` ? 1 : t === `` ? -1 : _0.compare(e, t));
}
function S0({
  r: e,
  c: t
}, n, {
  filas: r,
  columnas: i,
  pagina: a = 15,
  ctrl: o = !1,
  shift: s = !1
}) {
  let c = Math.max(0, r - 1),
    l = Math.max(0, i - 1),
    u = (e, t) => ({
      r: Math.min(c, Math.max(0, e)),
      c: Math.min(l, Math.max(0, t))
    });
  switch (n) {
    case `ArrowUp`:
      return u(o ? 0 : e - 1, t);
    case `ArrowDown`:
      return u(o ? c : e + 1, t);
    case `ArrowLeft`:
      return u(e, o ? 0 : t - 1);
    case `ArrowRight`:
      return u(e, o ? l : t + 1);
    case `Tab`:
      return u(e, s ? t - 1 : t + 1);
    case `Enter`:
      return u(s ? e - 1 : e + 1, t);
    case `Home`:
      return u(o ? 0 : e, 0);
    case `End`:
      return u(o ? c : e, l);
    case `PageDown`:
      return u(e + a, t);
    case `PageUp`:
      return u(e - a, t);
    default:
      return null;
  }
}
function C0(e) {
  let t = e + 1,
    n = ``;
  for (; t > 0;) {
    let e = (t - 1) % 26;
    n = String.fromCharCode(65 + e) + n, t = Math.floor((t - 1) / 26);
  }
  return n;
}
var w0 = 32,
  T0 = 56,
  E0 = 10;
function O0({
  crear: e,
  col: t,
  fila: n,
  onTerminar: r
}) {
  return e?.(t, n, {
    terminar: e => r(e, `Enter`),
    cancelar: () => r(void 0)
  }) ?? null;
}
var M0 = {
    MANUAL: `manual`,
    NISIRA: `nisira`,
    CALCULO: `calculo`
  },
  N0 = [{
    id: M0.MANUAL,
    label: `Se escribe acá`
  }, {
    id: M0.NISIRA,
    label: `Viene de NISIRA`
  }, {
    id: M0.CALCULO,
    label: `Se calcula`
  }],
  P0 = e => ({
    fecha: !0,
    texto: t => Y0(t?.[e]),
    orden: t => t?.[e] ?? null
  }),
  F0 = [{
    clave: `apenom`,
    titulo: `Apellidos y nombres`,
    origen: M0.NISIRA,
    fija: !0,
    ancho: 260,
    texto: e => e?.apenom ?? (e?.dni ? `` : `VACANTE`)
  }, {
    clave: `dni`,
    titulo: `DNI`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 96
  }, {
    clave: `sexo`,
    titulo: `Sexo`,
    origen: M0.NISIRA,
    ancho: 84
  }, {
    clave: `tipoPlanilla`,
    titulo: `Tipo de planilla`,
    origen: M0.CALCULO,
    ancho: 150
  }, {
    clave: `regimen`,
    titulo: `Régimen`,
    origen: M0.NISIRA,
    ancho: 170
  }, {
    clave: `planilla`,
    titulo: `Planilla`,
    origen: M0.NISIRA,
    ancho: 280
  }, {
    clave: `tipoPuesto`,
    titulo: `Tipo de puesto`,
    origen: M0.CALCULO,
    ancho: 160
  }, {
    clave: `cultivo`,
    titulo: `Cultivo`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 120
  }, {
    clave: `fechaNacimiento`,
    titulo: `Fecha de nacimiento`,
    origen: M0.NISIRA,
    ancho: 180,
    ...P0(`fechaNacimiento`)
  }, {
    clave: `edad`,
    titulo: `Edad`,
    origen: M0.CALCULO,
    ancho: 84
  }, {
    clave: `fechaIngreso`,
    titulo: `Fecha de ingreso`,
    origen: M0.NISIRA,
    ancho: 150,
    ...P0(`fechaIngreso`)
  }, {
    clave: `aniosCumplidos`,
    titulo: `Años cumplidos`,
    origen: M0.CALCULO,
    ancho: 140
  }, {
    clave: `rangoPermanencia`,
    titulo: `Rango de permanencia`,
    origen: M0.CALCULO,
    ancho: 180
  }, {
    clave: `temporalidad`,
    titulo: `Temporalidad`,
    origen: M0.CALCULO,
    ancho: 130
  }, {
    clave: `nivelJerarquico`,
    titulo: `Nivel jerárquico`,
    origen: M0.CALCULO,
    ancho: 150,
    orden: e => e?.nivelJerarquico ? Number(String(e.nivelJerarquico).replace(/\D/g, ``)) : null
  }, {
    clave: `cargoCorrecto`,
    titulo: `Cargo correcto`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 300
  }, {
    clave: `cargoNisira`,
    titulo: `Cargo NISIRA`,
    origen: M0.NISIRA,
    ancho: 300
  }, {
    clave: `estadoCargo`,
    titulo: `Estado del cargo`,
    origen: M0.CALCULO,
    ancho: 150
  }, {
    clave: `gerenciaCorporativa`,
    titulo: `Gerencia corporativa`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 300
  }, {
    clave: `gerenciaLinea`,
    titulo: `Gerencia de línea`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 300
  }, {
    clave: `area`,
    titulo: `Área`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 280
  }, {
    clave: `seccion`,
    titulo: `Sección`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 220
  }, {
    clave: `tipoContrato`,
    titulo: `Tipo de contrato`,
    origen: M0.NISIRA,
    ancho: 300
  }, {
    clave: `subgrupoTrabajo`,
    titulo: `Subgrupo de trabajo`,
    origen: M0.MANUAL,
    editar: `subgrupo`,
    ancho: 200
  }, {
    clave: `dniJefe`,
    titulo: `Jefe inmediato`,
    origen: M0.MANUAL,
    editar: `jefe`,
    ancho: 260,
    texto: e => e?.nombreJefe === `VACANTE` && e?.cargoJefe ? `VACANTE · ${e.cargoJefe}` : e?.nombreJefe ?? e?.dniJefe ?? ``
  }, {
    clave: `cargoJefe`,
    titulo: `Cargo del jefe`,
    origen: M0.CALCULO,
    ancho: 280
  }, {
    clave: `empresaNisira`,
    titulo: `Empresa`,
    origen: M0.NISIRA,
    ancho: 120
  }, {
    clave: `sede`,
    titulo: `Sede`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 130
  }, {
    clave: `subgrupoPlanilla`,
    titulo: `Subgrupo de planilla`,
    origen: M0.NISIRA,
    ancho: 180
  }, {
    clave: `cese`,
    titulo: `Cese`,
    origen: M0.NISIRA,
    ancho: 110,
    ...P0(`cese`)
  }, {
    clave: `perfiles`,
    titulo: `Perfiles`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 110
  }, {
    clave: `control`,
    titulo: `Control`,
    origen: M0.MANUAL,
    editar: `texto`,
    ancho: 130
  }, {
    clave: `alertas`,
    titulo: `Por revisar`,
    origen: M0.CALCULO,
    ancho: 280,
    texto: e => (e?.alertas ?? []).map(e => U0[e] ?? e).join(` · `),
    valores: e => (e?.alertas ?? []).map(e => U0[e] ?? e)
  }],
  I0 = [`dni`, `cultivo`, `cargoCorrecto`, `gerenciaCorporativa`, `gerenciaLinea`, `area`, `seccion`, `subgrupoTrabajo`, `dniJefe`, `sede`, `perfiles`, `control`, `puestoJefe`];
function L0(e) {
  let t = {};
  for (let n of I0) t[n] = e?.[n] ?? null;
  return t;
}
var R0 = `puesto:`;
function z0(e) {
  return e?.puestoJefe ? `${R0}${e.puestoJefe}` : e?.dniJefe ?? ``;
}
function B0(e, t) {
  let n = String(t ?? ``);
  return n.startsWith(R0) ? {
    ...e,
    dniJefe: null,
    puestoJefe: Number(n.slice(7))
  } : {
    ...e,
    dniJefe: n || null,
    puestoJefe: null
  };
}
function V0(e) {
  let t = e.filter(e => e.activo);
  return [...t.filter(e => e.dni).map(e => ({
    value: e.dni,
    label: `${e.apenom ?? e.dni}${e.cargoCorrecto ? ` · ${e.cargoCorrecto}` : ``}`
  })), ...t.filter(e => !e.dni).map(e => ({
    value: `${R0}${e.id}`,
    label: `VACANTE · ${e.cargoCorrecto ?? `sin cargo`}${e.area ? ` · ${e.area}` : ``}`,
    puestoId: e.id
  }))];
}
function H0(e) {
  let t = String(e ?? ``).replace(/\s+/g, ``);
  return /^\d{7,9}$/.test(t) ? {
    value: t,
    label: `Usar el DNI ${t} (no está en el organigrama)`
  } : null;
}
var U0 = {
    CARGO_DISTINTO: `El cargo no coincide con NISIRA`,
    NO_ESTA_EN_NISIRA: `Este DNI no está en NISIRA`,
    CESADO: `Cesado en NISIRA`,
    CESE_PROGRAMADO: `Tiene fecha de cese`,
    JEFE_FUERA: `El jefe no está en el organigrama`,
    SIN_NIVEL: `El subgrupo no tiene nivel`,
    DNI_REPETIDO: `El DNI está en otro puesto`
  },
  W0 = [{
    value: ``,
    label: `Todos`
  }, {
    value: `CON_ALERTA`,
    label: `Con algo por revisar`
  }, {
    value: `VACANTE`,
    label: `Vacantes`
  }, ...Object.entries(U0).map(([e, t]) => ({
    value: e,
    label: t
  }))];
function G0(e) {
  return String(e ?? ``).normalize(`NFD`).replace(/\p{M}/gu, ``).toUpperCase();
}
function K0(e, {
  texto: t = ``,
  gerencia: n = ``,
  area: r = ``,
  alerta: i = ``,
  inactivos: a = !1
} = {}) {
  let o = G0(t.trim());
  return e.filter(e => !a && !e.activo || n && e.gerenciaLinea !== n || r && e.area !== r || i === `CON_ALERTA` && !e.alertas?.length || i === `VACANTE` && !e.vacante || i && i !== `CON_ALERTA` && i !== `VACANTE` && !e.alertas?.includes(i) ? !1 : !o || [e.apenom, e.dni, e.cargoCorrecto, e.cargoNisira, e.area, e.seccion, e.nombreJefe].some(e => e && G0(e).includes(o)));
}
function q0(e) {
  let t = e.filter(e => e.activo);
  return {
    puestos: t.length,
    vacantes: t.filter(e => e.vacante).length,
    porRevisar: t.filter(e => e.alertas?.length).length,
    cargoDistinto: t.filter(e => e.alertas?.includes(`CARGO_DISTINTO`)).length
  };
}
function J0(e, t) {
  if (!e || !t) return null;
  let n = new Date(e).getTime();
  return Number.isNaN(n) ? null : Math.floor((t - n) / 864e5);
}
function Y0(e) {
  if (!e) return ``;
  let [t, n, r] = String(e).slice(0, 10).split(`-`);
  return r && n && t ? `${r}/${n}/${t}` : ``;
}
var X0 = {
    DNI: `dni`,
    CULTIVO: `cultivo`,
    "CARGO CORRECTO": `cargoCorrecto`,
    "GERENCIA CORPORATIVA": `gerenciaCorporativa`,
    "GERENCIA DE LINEA": `gerenciaLinea`,
    AREA: `area`,
    SECCION: `seccion`,
    "SUBGRUPO DE TRABAJO": `subgrupoTrabajo`,
    "DNI JEFE INMEDIATO": `dniJefe`,
    SEDE: `sede`,
    PERFILES: `perfiles`,
    CONTROL: `control`
  },
  Z0 = new Set([`SIN DATA`, `VACANTE`, `#N/A`, `NO SE ENCONTRO`, `#REF!`, `#VALUE!`, `P.VACANTE`, `POR DEFINIR`, `PORDEFINIR`]);
function Q0(e) {
  let t = e.findIndex(e => {
    let t = (e ?? []).map(G0).map(e => e.trim());
    return t.includes(`DNI`) && t.includes(`CARGO CORRECTO`);
  });
  if (t < 0) return {
    puestos: [],
    salteadas: 0,
    encontrada: !1
  };
  let n = {};
  e[t].forEach((e, t) => {
    let r = X0[G0(e).trim()];
    r && n[r] === void 0 && (n[r] = t);
  });
  let r = [],
    i = 0;
  for (let a of e.slice(t + 1)) {
    if (!a || a.every(e => e == null || String(e).trim() === ``)) continue;
    let e = String(a[n.dni] ?? ``).trim();
    if (!/^\d{6,12}$/.test(e) && G0(e) !== `VACANTE`) {
      i++;
      continue;
    }
    let t = {};
    for (let [e, r] of Object.entries(n)) {
      let n = a[r],
        i = n == null ? `` : String(n).trim();
      t[e] = i && !Z0.has(G0(i)) ? i : null;
    }
    t.dni = G0(e) === `VACANTE` ? null : e, r.push(t);
  }
  return {
    puestos: r,
    salteadas: i,
    encontrada: !0
  };
}
var $0 = {
  ancho: 300,
  alto: 104,
  separacionX: 24,
  separacionY: 56,
  separacionPila: 12,
  apilarDesde: 4,
  filasPorColumna: 6
};
function e2(e) {
  let t = Number(String(e?.nivelJerarquico ?? ``).replace(/\D/g, ``));
  return Number.isFinite(t) && String(e?.nivelJerarquico ?? ``).match(/\d/) ? t : 99;
}
var t2 = new Intl.Collator(`es`, {
  sensitivity: `base`
});
function n2(e, t) {
  return e2(e.fila) - e2(t.fila) || Number(!!e.fila.vacante) - Number(!!t.fila.vacante) || t2.compare(e.fila.apenom ?? ``, t.fila.apenom ?? ``);
}
var r2 = [`seccion`, `area`, `gerenciaLinea`, `gerenciaCorporativa`],
  i2 = .25,
  a2 = new Set([`DE`, `DEL`, `LA`, `LAS`, `LOS`, `EL`, `Y`, `E`, `EN`, `A`, `AL`, `CON`, `PARA`, `POR`]),
  o2 = new Set(`GERENTE.SUBGERENTE.JEFE.JEFA.COORDINADOR.COORDINADORA.SUPERVISOR.SUPERVISORA.ANALISTA.ASISTENTE.AUXILIAR.ESPECIALISTA.PRACTICANTE.TECNICO.OPERARIO.GESTOR.ENCARGADO.ENCARGADA.LIDER.DIRECTOR.DIRECTORA.SENIOR.JUNIOR.CORPORATIVO.CORPORATIVA.GENERAL`.split(`.`));
function s2(e) {
  let t = String(e ?? ``).normalize(`NFD`).replace(/\p{M}/gu, ``).toUpperCase().split(/[^A-Z0-9]+/).filter(e => e.length > 2 && !a2.has(e) && !o2.has(e));
  return new Set(t.map(e => e.slice(0, 5)));
}
var c2 = e => !!e && /\d/.test(e);
function l2(e) {
  let t = e.filter(e => e.activo !== !1),
    n = new Map(t.map(e => [e.id, e])),
    r = new Map();
  for (let e of t) e.dni && !r.has(e.dni) && r.set(e.dni, e);
  let i = new Set();
  for (let e of t) e.puestoJefe ? i.add(e.puestoJefe) : c2(e.dniJefe) && r.has(e.dniJefe) && i.add(r.get(e.dniJefe).id);
  let a = new Map();
  for (let e of t) {
    if (!e.dni) continue;
    let t = a.get(e2(e)) ?? {
      ocupados: 0,
      conGente: 0
    };
    t.ocupados++, i.has(e.id) && t.conGente++, a.set(e2(e), t);
  }
  let o = e => e < 99 && (a.get(e)?.conGente ?? 0) >= i2 * (a.get(e)?.ocupados ?? 0) && (a.get(e)?.conGente ?? 0) > 0,
    s = e => i.has(e.id) || o(e2(e)),
    c = Object.fromEntries(r2.map(e => {
      let n = new Map();
      for (let r of t) r[e] && s(r) && (n.get(r[e]) ?? n.set(r[e], []).get(r[e])).push(r);
      return [e, n];
    })),
    l = new Map();
  for (let e of t) {
    let t = e.puestoJefe ? n.get(e.puestoJefe) ?? null : c2(e.dniJefe) ? r.get(e.dniJefe) ?? null : null;
    t === e && (t = null);
    let i = !e.puestoJefe && !t && c2(e.dniJefe) && e.dniJefe !== e.dni ? e.dniJefe : null,
      a = e2(e),
      o = t ? e2(t) : -1,
      s = null;
    if (a < 99) {
      let n = s2(e.cargoCorrecto);
      for (let [r, i] of (t ? r2.slice(0, 3) : r2).entries()) {
        let t = r2.slice(0, r),
          l = n => t.every(t => !n[t] || n[t] === n[i] || n[t] === e[t]),
          u = (c[i].get(e[i]) ?? []).filter(t => t !== e && e2(t) < a && e2(t) > o && l(t));
        if (!u.length) continue;
        let d = [...new Set(u.map(e2))].sort((e, t) => t - e);
        for (let e of d) {
          let t = u.filter(t => e2(t) === e);
          if (t.length === 1) {
            s = t[0];
            break;
          }
          let r = t.map(e => [...s2(e.cargoCorrecto)].filter(e => n.has(e)).length),
            i = Math.max(...r);
          if (i === 0) continue;
          let a = t.filter((e, t) => r[t] === i);
          if (a.length === 1) {
            s = a[0];
            break;
          }
          let o = a.filter(e => e.dni);
          if (o.length === 1) {
            s = o[0];
            break;
          }
        }
        if (s) break;
      }
    }
    let u = s ?? t;
    l.set(e.id, u ? {
      id: u.id
    } : i ? {
      dni: i
    } : null);
  }
  return l;
}
var u2 = [`gerenciaCorporativa`, `gerenciaLinea`, `area`, `seccion`],
  d2 = `GERENCIA GENERAL`;
function f2(e) {
  return String(e ?? ``).normalize(`NFD`).replace(/\p{M}/gu, ``).toUpperCase().split(/[^A-Z0-9]+/).filter(e => e && !a2.has(e)).join(` `);
}
function p2(e, t) {
  let n = f2(e).replace(/ /g, ``),
    r = f2(t).split(` `).filter(Boolean);
  if (!n || r.length < 2 || n.length >= r.join(``).length) return !1;
  let i = (e, t) => {
    if (e === n.length) return !0;
    for (let a = t; a < r.length; a++) {
      let t = r[a];
      for (let r = Math.min(t.length, n.length - e); r >= 1; r--) if (n.slice(e, e + r) === t.slice(0, r) && i(e + r, a + 1)) return !0;
      if (a === 0) return !1;
    }
    return !1;
  };
  return i(0, 0);
}
function m2(e, t) {
  let n = f2(e),
    r = f2(t);
  return n === r || !!n && !!r && (p2(n, r) || p2(r, n));
}
var h2 = {
  GERENTE: 0,
  SUBGERENTE: 1,
  JEFE: 2,
  JEFA: 2,
  COORDINADOR: 3,
  COORDINADORA: 3,
  SUPERVISOR: 4,
  SUPERVISORA: 4
};
function g2(e) {
  return h2[f2(e?.cargoCorrecto).split(` `)[0]] ?? 9;
}
function _2(e) {
  return e?.referencia ? [99, 9] : [e2(e), g2(e)];
}
function v2(e, t) {
  let [n, r] = _2(e),
    [i, a] = _2(t);
  return n - i || r - a;
}
function y2(e, t) {
  let n = new Map();
  for (let e of t) e.dni && !n.has(e.dni) && n.set(e.dni, e);
  let r = C2(t),
    i = (e, t) => {
      t.padre = e, e.hijos.push(t);
    },
    a = e => [...e].sort((e, t) => v2(e.fila, t.fila))[0];
  function o(e, t, s, c) {
    if (t === u2.length) return w2(e, r, i);
    let l = u2[t],
      u = new Map();
    for (let t of e) {
      let e = f2(t[l]);
      u.has(e) || u.set(e, {
        nombre: t[l],
        filas: []
      }), u.get(e).filas.push(t);
    }
    let d = u.has(f2(s)) ? f2(s) : [...u.keys()].find(e => e && m2(e, s)) ?? f2(s),
      f = [...(u.get(d)?.filas ?? []), ...(u.get(``)?.filas ?? [])];
    u.delete(d), u.delete(``);
    let p = [...u.entries()].map(([e, n]) => ({
        nombre: n.nombre,
        raices: o(n.filas, t + 1, n.nombre, [...c, e])
      })),
      m = f.length ? o(f, t + 1, s, [...c, d]) : [],
      h = [],
      g = e => {
        h.push(e), e.hijos.forEach(g);
      };
    m.forEach(g);
    for (let e of p) {
      let t = e.raices.length === 1 && e.raices[0].fila.referencia === `unidad`;
      if (e.raices.length === 1 && !t) continue;
      let n = h.find(t => !t.fila.referencia && x2(t.fila.cargoCorrecto, e.nombre));
      if (!n) continue;
      let r = t ? e.raices[0].hijos : e.raices;
      for (let e of r) e.padre = null, i(n, e);
      e.raices = [];
    }
    let _ = p.map(e => a(e.raices)).filter(Boolean),
      v = e => _.every(t => t === e || v2(e.fila, t.fila) < 0),
      y = null,
      b = m.length ? a(m) : null;
    if (b && m.every(e => e === b || v2(b.fila, e.fila) < 0) && (b.fila.referencia || (e => _.every(t => v2(e.fila, t.fila) <= 0))(b)) && (y = b), !y && !m.length && _.length > 1) {
      let e = a(_),
        t = s2(`X ${s}`),
        n = [...s2(e.fila.cargoCorrecto)].some(e => t.has(e)),
        r = p.find(t => t.raices.includes(e)).raices.every(t => t === e || v2(e.fila, t.fila) < 0);
      !e.fila.referencia && v(e) && n && r && (y = e);
    }
    let x = [...m, ...p.flatMap(e => e.raices)].filter(e => e !== y);
    if (!y) {
      if (p.length + +!!m.length <= 1 || t === 0) return x;
      y = {
        fila: S2(s, c, x, n),
        hijos: [],
        padre: null
      };
    }
    for (let e of x) i(y, e);
    return [y];
  }
  return o(e, 0, d2, []);
}
var b2 = {
  GERENTE: `GER`,
  GERENCIA: `GER`,
  SUBGERENTE: `SUBGER`,
  SUBGERENCIA: `SUBGER`,
  JEFE: `JEF`,
  JEFA: `JEF`,
  JEFATURA: `JEF`,
  COORDINADOR: `COORD`,
  COORDINADORA: `COORD`,
  COORDINACION: `COORD`
};
function x2(e, t) {
  let n = b2[f2(e).split(` `)[0]],
    r = b2[f2(t).split(` `)[0]];
  if (!n || n !== r) return !1;
  let i = s2(e),
    a = s2(f2(t).split(` `).slice(1).join(` `));
  return i.size > 0 && [...i].every(e => a.has(e)) && i.size >= Math.max(1, a.size - 1);
}
function S2(e, t, n, r) {
  let i = new Set(n.map(e => e.fila.dniJefe).filter(c2)),
    a = n.find(e => e.fila.nombreJefe)?.fila;
  if (i.size === 1 && n.every(e => c2(e.fila.dniJefe)) && !r.has([...i][0])) {
    let t = [...i][0],
      r = n.find(e => e.fila.dniJefe === t && e.fila.nombreJefe)?.fila ?? a;
    return {
      id: `jefe:${t}`,
      activo: !0,
      dni: t,
      referencia: `sinPuesto`,
      apenom: r?.nombreJefe ?? null,
      cargoCorrecto: r?.cargoJefe ?? null,
      unidad: e,
      alertas: []
    };
  }
  return {
    id: `unidad:${t.join(`›`)}`,
    activo: !0,
    referencia: `unidad`,
    unidad: e,
    apenom: null,
    cargoCorrecto: null,
    alertas: []
  };
}
function C2(e) {
  let t = e.filter(e => e.activo !== !1),
    n = new Map(t.map(e => [e.id, e])),
    r = new Map();
  for (let e of t) e.dni && !r.has(e.dni) && r.set(e.dni, e);
  let i = new Set();
  for (let e of t) e.puestoJefe && n.has(e.puestoJefe) ? i.add(e.puestoJefe) : c2(e.dniJefe) && r.has(e.dniJefe) && i.add(r.get(e.dniJefe).id);
  let a = new Map();
  for (let e of t) {
    if (!e.dni) continue;
    let t = a.get(e2(e)) ?? {
      ocupados: 0,
      conGente: 0
    };
    t.ocupados++, i.has(e.id) && t.conGente++, a.set(e2(e), t);
  }
  let o = e => {
    let t = a.get(e);
    return e < 99 && !!t && t.conGente > 0 && t.conGente >= i2 * t.ocupados;
  };
  return e => o(e2(e));
}
function w2(e, t, n) {
  let r = new Map(e.map(e => [e.id, {
      fila: e,
      hijos: [],
      padre: null
    }])),
    i = [...e].sort((e, t) => v2(e, t) || Number(!!e.vacante) - Number(!!t.vacante)),
    [a, o] = _2(i[0]),
    s = i.filter(e => _2(e)[0] === a && _2(e)[1] === o),
    c = new Map(e.filter(e => e.dni).map(e => [e.dni, e])),
    l = new Map(e.map(e => [e.id, e])),
    u = [];
  for (let a of i) {
    if (s.includes(a)) continue;
    let i = a.puestoJefe ? l.get(a.puestoJefe) : c2(a.dniJefe) ? c.get(a.dniJefe) : null,
      o = e => v2(e, a) < 0,
      d = i && o(i) ? i : null,
      f = e.filter(e => e !== a && o(e) && t(e) && (!d || v2(d, e) < 0)),
      p = null,
      m = s2(a.cargoCorrecto),
      h = [...new Set(f.map(e => _2(e).join(`.`)))].sort((e, t) => t.localeCompare(e, void 0, {
        numeric: !0
      }));
    for (let e of h) {
      let t = f.filter(t => _2(t).join(`.`) === e);
      if (t.length === 1) {
        p = t[0];
        break;
      }
      let n = t.map(e => [...s2(e.cargoCorrecto)].filter(e => m.has(e)).length),
        r = Math.max(...n);
      if (r === 0) continue;
      let i = t.filter((e, t) => n[t] === r);
      if (i.length === 1) {
        p = i[0];
        break;
      }
      let a = i.filter(e => e.dni);
      if (a.length === 1) {
        p = a[0];
        break;
      }
    }
    let g = p ?? d ?? (s.length === 1 ? s[0] : null);
    g ? n(r.get(g.id), r.get(a.id)) : u.push(a);
  }
  return [...s, ...u].map(e => r.get(e.id));
}
function T2(e, t = e) {
  let n = e.filter(e => e.activo !== !1),
    r = t.filter(e => e.activo !== !1),
    i = r.filter(e => e.gerenciaCorporativa);
  if (!i.length) return E2(D2(n, t));
  let a = y2(i, r),
    o = new Set(n.map(e => e.id)),
    s = e => e.fila.referencia ? e.hijos.flatMap(s) : [e.fila.id, ...e.hijos.flatMap(s)],
    c = new Map(),
    l = e => {
      if (!c.has(e)) {
        let t = e.fila.referencia ? s(e) : null;
        c.set(e, e.fila.referencia ? t.length > 0 && t.every(e => o.has(e)) : o.has(e.fila.id));
      }
      return c.get(e);
    },
    u = new Map(),
    d = e => (u.has(e.fila.id) || u.set(e.fila.id, {
      fila: e.fila,
      hijos: [],
      padre: null
    }), u.get(e.fila.id)),
    f = (e, t) => {
      let n = null;
      if (l(e)) {
        let r = d(e);
        if (t) r.padre = t, t.hijos.push(r);else if (e.padre && !l(e.padre)) {
          let t = e.padre.fila.referencia ? e.padre.fila : {
            ...e.padre.fila,
            referencia: `fuera`
          };
          u.has(t.id) || u.set(t.id, {
            fila: t,
            hijos: [],
            padre: null
          });
          let n = u.get(t.id);
          r.padre = n, n.hijos.push(r);
        }
        n = r;
      }
      for (let t of e.hijos) f(t, n);
    };
  a.forEach(e => f(e, null));
  let p = n.filter(e => !e.gerenciaCorporativa);
  if (p.length) for (let [e, n] of D2(p, t)) u.has(e) || u.set(e, n);
  return E2(u);
}
function E2(e) {
  let t = [...e.values()].filter(e => !e.padre),
    n = new Set(),
    r = e => {
      n.has(e) || (n.add(e), e.hijos.forEach(r));
    };
  t.forEach(r);
  for (let i of e.values()) n.has(i) || (i.padre && (i.padre.hijos = i.padre.hijos.filter(e => e !== i)), i.padre = null, t.push(i), r(i));
  let i = e => {
    e.sort(n2), e.forEach(e => i(e.hijos));
  };
  i(t);
  let a = new Map(t.map(e => [e, O2(e)]));
  return t.sort((e, t) => a.get(t) - a.get(e) || n2(e, t)), {
    raices: t,
    porId: new Map([...e.values()].map(e => [e.fila.id, e]))
  };
}
function D2(e, t = e) {
  let n = e.filter(e => e.activo !== !1),
    r = l2(t),
    i = new Map(n.map(e => [e.id, {
      fila: e,
      hijos: [],
      padre: null
    }])),
    a = new Map(t.filter(e => e.activo !== !1).map(e => [e.id, e])),
    o = new Map();
  function s(e, t) {
    let n = e.id ?? `jefe:${e.dni}`;
    if (i.has(n)) return i.get(n);
    let r;
    if (e.id) {
      let t = a.get(e.id);
      if (!t) return null;
      r = {
        ...t,
        referencia: `fuera`
      };
    } else r = {
      id: n,
      activo: !0,
      dni: e.dni,
      referencia: `sinPuesto`,
      apenom: null,
      cargoCorrecto: null,
      alertas: []
    };
    let s = {
      fila: r,
      hijos: [],
      padre: null
    };
    return i.set(n, s), o.set(n, s), r.referencia === `sinPuesto` && (r.apenom = t.nombreJefe ?? null, r.cargoCorrecto = t.cargoJefe ?? null), s;
  }
  for (let e of n) {
    let t = i.get(e.id),
      n = r.get(e.id);
    if (!n) continue;
    let a = n.id && i.has(n.id) ? i.get(n.id) : s(n, e);
    a && a !== t && (a.fila.referencia === `sinPuesto` && (!a.fila.apenom && e.nombreJefe && (a.fila.apenom = e.nombreJefe), !a.fila.cargoCorrecto && e.cargoJefe && (a.fila.cargoCorrecto = e.cargoJefe)), t.padre = a, a.hijos.push(t));
  }
  return i;
}
function O2(e) {
  return e.hijos.reduce((e, t) => e + 1 + O2(t), 0);
}
var k2 = [{
  clave: `gerenciaCorporativa`,
  titulo: `Gerencia corporativa`
}, {
  clave: `gerenciaLinea`,
  titulo: `Gerencia de línea`
}, {
  clave: `area`,
  titulo: `Área`
}, {
  clave: `seccion`,
  titulo: `Sección`
}];
function A2(e, t) {
  return e.filter(e => k2.every(({
    clave: n
  }) => !t?.[n] || e[n] === t[n]));
}
function j2(e, t) {
  let n = {},
    r = e;
  for (let {
    clave: e
  } of k2) n[e] = [...new Set(r.map(t => t[e]).filter(Boolean))].sort((e, t) => t2.compare(e, t)), t?.[e] && (r = r.filter(n => n[e] === t[e]));
  return n;
}
function M2(e, t, n) {
  let r = k2.findIndex(e => e.clave === t),
    i = {
      ...e,
      [t]: n || ``
    };
  for (let e of k2.slice(r + 1)) i[e.clave] = ``;
  return i;
}
function N2(e, t) {
  return t.has(e.fila.id) ? [] : e.hijos;
}
function P2(e, t) {
  let n = new Map(),
    r = e => {
      if (n.has(e)) return n.get(e);
      let i = e2(e.fila),
        a = -1 / 0;
      if (i !== 99) a = i;else {
        let n = N2(e, t).map(r).filter(Number.isFinite);
        n.length && (a = Math.min(...n) - 1);
      }
      return n.set(e, a), a;
    },
    i = new Map(),
    a = (e, n) => {
      let o = r(e),
        s = Math.max(Number.isFinite(o) ? o : n, n);
      i.set(e, s);
      for (let n of N2(e, t)) a(n, s + 1);
    };
  for (let t of e) {
    let e = r(t);
    a(t, Number.isFinite(e) ? e : 0);
  }
  return i;
}
function F2(e, t, n) {
  let r = N2(e, t);
  return r.length >= n.apilarDesde && r.every(e => N2(e, t).length === 0);
}
function I2(e, t, n) {
  let r = [];
  for (let n of e) {
    let e = t.get(n),
      i = r.find(t => t.fila === e);
    i || r.push(i = {
      fila: e,
      hijos: []
    }), i.hijos.push(n);
  }
  r.sort((e, t) => e.fila - t.fila);
  let i = 0;
  for (let e of r) e.desde = i, i += Math.ceil(e.hijos.length / n.filasPorColumna);
  return {
    grupos: r,
    columnas: i
  };
}
function L2(e, t, n, r, i) {
  let a = N2(e, t),
    o;
  if (!a.length) o = n.ancho;else if (F2(e, t, n)) {
    a.forEach(e => L2(e, t, n, r, i));
    let {
      columnas: e
    } = I2(a, i, n);
    o = Math.max(n.ancho, e * n.ancho + (e - 1) * n.separacionX + 20);
  } else {
    let e = a.map(e => L2(e, t, n, r, i));
    o = Math.max(n.ancho, e.reduce((e, t) => e + t.ancho, 0) + (a.length - 1) * n.separacionX);
  }
  let s = {
    ancho: o
  };
  return r.set(e, s), s;
}
function R2(e, t = new Set(), n = $0) {
  let r = new Map(),
    i = P2(e, t),
    a = n.alto + n.separacionY,
    o = e.map(e => L2(e, t, n, r, i));
  function s(e, o, c, l, u) {
    let {
        nodos: d,
        lineas: f
      } = u,
      {
        ancho: p
      } = r.get(e),
      m = o + (p - n.ancho) / 2,
      h = c + (i.get(e) - l) * a,
      g = N2(e, t);
    if (d.push({
      id: e.fila.id,
      fila: e.fila,
      x: m,
      y: h,
      aCargo: e.hijos.length,
      debajo: O2(e),
      colapsado: t.has(e.fila.id) && e.hijos.length > 0
    }), !g.length) return;
    let _ = m + n.ancho / 2,
      v = h + n.alto,
      y = v + n.separacionY / 2,
      b = e => c + (i.get(e) - l) * a;
    if (F2(e, t, n)) {
      let {
          grupos: e,
          columnas: t
        } = I2(g, i, n),
        d = o + (p - (t * n.ancho + (t - 1) * n.separacionX)) / 2 + 10,
        m = [];
      for (let t of e) {
        let e = c + (t.fila - l) * a;
        t.hijos.forEach((i, a) => {
          let o = t.desde + Math.floor(a / n.filasPorColumna),
            p = a % n.filasPorColumna,
            h = d + o * (n.ancho + n.separacionX),
            g = e + p * (n.alto + n.separacionPila),
            _ = h - 10;
          m[o] = {
            x: _,
            hasta: g + n.alto / 2
          }, f.push(`M${_},${g + n.alto / 2}H${h}`), s(i, h - (r.get(i).ancho - n.ancho) / 2, c + (g - e), l, u);
        });
      }
      f.push(`M${_},${v}V${y}`), f.push(`M${Math.min(_, m[0].x)},${y}H${Math.max(_, m.at(-1).x)}`);
      for (let e of m) f.push(`M${e.x},${y}V${e.hasta}`);
      return;
    }
    let x = g.map(e => r.get(e)),
      S = o + (p - (x.reduce((e, t) => e + t.ancho, 0) + (g.length - 1) * n.separacionX)) / 2,
      C = [];
    g.forEach((e, t) => {
      C.push({
        x: S + x[t].ancho / 2,
        y: b(e)
      }), s(e, S, c, l, u), S += x[t].ancho + n.separacionX;
    }), f.push(`M${_},${v}V${y}`), C.length > 1 ? f.push(`M${C[0].x},${y}H${C.at(-1).x}`) : f.push(`M${_},${y}H${C[0].x}`);
    for (let e of C) f.push(`M${e.x},${y}V${e.y}`);
  }
  let c = e.map(e => {
      let t = {
        nodos: [],
        lineas: []
      };
      return s(e, 0, 0, i.get(e), t), Math.max(...t.nodos.map(e => e.y)) + n.alto;
    }),
    l = n.separacionX * 3,
    u = o.reduce((e, t, r) => e + (t.ancho + l) * (c[r] + n.separacionY * 2), 0),
    d = Math.max(...o.map(e => e.ancho), Math.sqrt(u * 1.8)),
    f = [],
    p = 0;
  e.forEach((e, t) => {
    let n = o[t];
    (!f.length || p > 0 && p + n.ancho > d) && (f.push([]), p = 0), f.at(-1).push({
      r: e,
      x: p,
      alto: c[t]
    }), p += n.ancho + l;
  });
  let m = {
      nodos: [],
      lineas: []
    },
    h = 0,
    g = 0;
  for (let e of f) {
    let t = Math.min(...e.map(e => i.get(e.r))),
      o = 0;
    for (let n of e) s(n.r, n.x, h, t, m), o = Math.max(o, (i.get(n.r) - t) * a + n.alto), g = Math.max(g, n.x + r.get(n.r).ancho);
    h += o + n.separacionY * 2;
  }
  return {
    nodos: m.nodos,
    lineas: m.lineas,
    ancho: Math.max(n.ancho, g),
    alto: Math.max(n.alto, h - n.separacionY * 2)
  };
}
function z2(e, t) {
  let n = new Set(),
    r = (e, i) => {
      i >= t && e.hijos.length && n.add(e.fila.id), e.hijos.forEach(e => r(e, i + 1));
    };
  return e.forEach(e => r(e, 0)), n;
}
function B2(e, t, n) {
  let r = t.get(n),
    i = new Set(e);
  i.delete(n);
  let a = r?.padre ? r.padre.hijos : [];
  for (let e of a) e.fila.id !== n && e.hijos.length && i.add(e.fila.id);
  return i;
}
function V2(e, t, n, {
  minimo: r = .4,
  legibleAlto: i = .75,
  margen: a = 48,
  m: o = $0
} = {}) {
  let s = e.filter(e => t.includes(e.id));
  if (!s.length || !n) return null;
  let c = Math.min(...s.map(e => e.x)),
    l = Math.min(...s.map(e => e.y)),
    u = Math.max(...s.map(e => e.x + o.ancho)),
    d = Math.max(...s.map(e => e.y + o.alto)),
    f = Math.max(i, (n.alto - a * 2) / (d - l)),
    p = Math.max(r, Math.min(1, (n.ancho - a * 2) / (u - c), f)),
    m = s[0],
    h = (u - c) * p <= n.ancho - a * 2 ? (c + u) / 2 : m.x + o.ancho / 2;
  return {
    escala: p,
    x: n.ancho / 2 - h * p,
    y: a - l * p
  };
}
function H2(e, t) {
  let n = [],
    r = e.get(t)?.padre;
  for (; r && !n.includes(r.fila.id);) n.push(r.fila.id), r = r.padre;
  return n;
}
var U2 = [{
  clave: `uva`,
  nombre: `Uva`,
  color: `var(--cultivo-uva)`,
  fondo: `var(--cultivo-uva-bg)`
}, {
  clave: `arandano`,
  nombre: `Arándano`,
  color: `var(--cultivo-arandano)`,
  fondo: `var(--cultivo-arandano-bg)`
}, {
  clave: `transversal`,
  nombre: `Transversal`,
  color: `var(--cultivo-transversal)`,
  fondo: `var(--cultivo-transversal-bg)`
}];
function W2(e) {
  let t = String(e?.cultivo ?? ``).normalize(`NFD`).replace(/\p{M}/gu, ``).trim().toLowerCase();
  return U2.find(e => e.clave === t) ?? null;
}
var G2 = new Set([`de`, `del`, `la`, `las`, `los`, `y`, `e`, `en`, `a`, `al`, `o`, `u`, `por`, `para`, `con`]);
function K2(e) {
  return String(e ?? ``).split(/(\s+)/).map((e, t) => {
    if (/^\s+$/.test(e) || !e) return e;
    let n = e.toLowerCase();
    return e.length >= 2 && e.length <= 5 && !G2.has(n) && !/[AEIOUÁÉÍÓÚaeiouáéíóú]/.test(e) && /[A-ZÑ]/.test(e) ? e : t > 0 && G2.has(n) ? n : n.charAt(0).toUpperCase() + n.slice(1);
  }).join(``);
}
function q2(e) {
  if (e?.referencia === `unidad`) return K2(e.unidad);
  if (!e?.apenom) return e?.dni ? `DNI ${e.dni}` : `Vacante`;
  let [t, n] = e.apenom.split(`,`).map(e => e.trim());
  return K2(n ? `${n} ${t}` : t);
}
function J2(e) {
  return K2(e?.cargoCorrecto ?? ``);
}
function Y2(e) {
  if (!e?.apenom) return ``;
  let [t, n] = e.apenom.split(`,`).map(e => e.trim());
  return `${(n ?? ``).charAt(0)}${(t ?? ``).charAt(0)}`.toUpperCase();
}
var X2 = new Map();
function Z2(e, t) {
  return `${e}:${t}`;
}
function Q2(e, t) {
  let n = Z2(e, t);
  return X2.has(n) || X2.set(n, Qa(`/organigrama/${e}/foto`).catch(e => {
    throw X2.delete(n), e;
  })), X2.get(n);
}
function $2(e, t, n) {
  let r = (0, ReactCompiler.c)(9),
    i = n === void 0 || n,
    [a, o] = (0, React.useState)(null),
    s;
  r[0] !== e || r[1] !== t ? (s = Z2(e, t), r[0] = e, r[1] = t, r[2] = s) : s = r[2];
  let c = s,
    l,
    u;
  return r[3] !== i || r[4] !== e || r[5] !== c || r[6] !== t ? (l = () => {
    if (!t || !i) return;
    let n = !0;
    return Q2(e, t).then(e => {
      n && o({
        k: c,
        url: e
      });
    }).catch(e4), () => {
      n = !1;
    };
  }, u = [e, t, i, c], r[3] = i, r[4] = e, r[5] = c, r[6] = t, r[7] = l, r[8] = u) : (l = r[7], u = r[8]), (0, React.useEffect)(l, u), t && i && a?.k === c ? a.url : null;
}
function e4() {}
var t4 = {
  fuera: `Fuera de este filtro`,
  sinPuesto: `Sin puesto en el organigrama`,
  unidad: `Sin puesto a cargo`
};
function s4(e) {
  return e.fila.id;
}
function c4(e) {
  return e.hijos.length;
}
function d4(e) {
  return {
    value: e,
    label: e
  };
}
function f4(e) {
  return {
    value: e.id,
    label: `${q2(e)} · ${J2(e)}`
  };
}
function p4(e) {
  return e.dni;
}
function m4(e, t) {
  let n = (e, r, i) => {
    t(e.fila, r, i?.fila ?? null);
    for (let t of e.hijos) n(t, r + 1, e);
  };
  e.forEach(e => n(e, 1, null));
}
var h4 = e => e?.referencia === `unidad`;
function g4(e) {
  let t = [];
  return m4(e, (e, n, r) => {
    let i = {
      Escalón: n,
      "Reporta a": r ? q2(r) : ``,
      "Cargo de a quien reporta": r ? J2(r) ?? `` : ``
    };
    for (let t of F0) {
      let n = t.texto ? t.texto(e) : e[t.clave];
      h4(e) && t.clave === `apenom` && (n = q2(e)), h4(e) && t.clave === `cargoCorrecto` && (n = `SIN PUESTO A CARGO`), i[t.titulo] = n ?? ``;
    }
    t.push(i);
  }), t;
}
var _4 = [{
  titulo: `Escalón`,
  ancho: 9,
  valor: (e, t) => t
}, {
  titulo: `Puesto`,
  ancho: 38,
  valor: e => h4(e) ? q2(e) : e.vacante ? `VACANTE` : e.apenom ?? ``
}, {
  titulo: `DNI`,
  ancho: 12,
  valor: e => e.dni ?? ``
}, {
  titulo: `Cargo`,
  ancho: 40,
  valor: e => h4(e) ? `SIN PUESTO A CARGO` : e.cargoCorrecto ?? ``
}, {
  titulo: `Nivel`,
  ancho: 11,
  valor: e => e.nivelJerarquico ?? ``
}, {
  titulo: `Cultivo`,
  ancho: 13,
  valor: e => e.cultivo ?? ``
}, {
  titulo: `Reporta a`,
  ancho: 32,
  valor: (e, t, n) => n ? q2(n) : ``
}, {
  titulo: `Cargo de a quien reporta`,
  ancho: 36,
  valor: (e, t, n) => n ? J2(n) ?? `` : ``
}, {
  titulo: `Gerencia de línea`,
  ancho: 34,
  valor: e => e.gerenciaLinea ?? ``
}, {
  titulo: `Área`,
  ancho: 30,
  valor: e => e.area ?? ``
}, {
  titulo: `Sección`,
  ancho: 26,
  valor: e => e.seccion ?? ``
}, {
  titulo: `Sede`,
  ancho: 14,
  valor: e => e.sede ?? ``
}, {
  titulo: `Estado`,
  ancho: 12,
  valor: e => h4(e) ? `UNIDAD` : e.vacante ? `VACANTE` : `OCUPADO`
}];
function v4(e) {
  let t = [];
  return m4(e, (e, n, r) => {
    t.push({
      valores: _4.map(t => t.valor(e, n, r)),
      escalon: n,
      vacante: !!e.vacante,
      unidad: h4(e),
      referencia: !!e.referencia && !h4(e),
      cultivo: W2(e)?.clave ?? null
    });
  }), t;
}
function y4(e) {
  let t = String(e ?? ``).trim(),
    n = t.match(/^#([0-9a-f]{3})$/i);
  if (n) return n[1].split(``).map(e => parseInt(e + e, 16));
  if (n = t.match(/^#([0-9a-f]{6})/i), n) return [0, 2, 4].map(e => parseInt(n[1].slice(e, e + 2), 16));
  if (n = t.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)(?:[\s,/]+([\d.]+)(%?))?/i), n) {
    let e = n[4] == null ? 1 : Number(n[4]) / (n[5] ? 100 : 1);
    return [n[1], n[2], n[3]].map(t => Math.round(255 - (255 - Number(t)) * e));
  }
  return null;
}
function b4(e, t = 0, n = `FF3C4651`) {
  let r = y4(e);
  return r ? `FF` + r.map(e => Math.round(e + (255 - e) * t).toString(16).padStart(2, `0`)).join(``).toUpperCase() : n;
}
function x4() {
  let e = document.documentElement,
    t = e.classList.contains(`dark`);
  t && e.classList.remove(`dark`);
  try {
    let t = getComputedStyle(e),
      n = e => t.getPropertyValue(e).trim();
    return {
      titulo: {
        fondo: b4(n(`--sidebar-bg`)),
        texto: b4(n(`--sidebar-fg`), 0, `FFFFFFFF`)
      },
      encabezado: {
        fondo: b4(n(`--accent`)),
        texto: b4(n(`--accent-fg`), 0, `FFFFFFFF`)
      },
      cebra: b4(n(`--accent`), .92, `FFF4F7F9`),
      texto: b4(n(`--text-h`)),
      tenue: b4(n(`--text`), 0, `FF6B7280`),
      borde: b4(n(`--border`), 0, `FFD9DEE3`),
      cultivos: Object.fromEntries(U2.map(e => [e.clave, {
        texto: b4(n(`--cultivo-${e.clave}`)),
        fondo: b4(n(`--cultivo-${e.clave}`), .82, `FFF2F2F2`)
      }]))
    };
  } finally {
    t && e.classList.add(`dark`);
  }
}
function S4(e, t, n = 16e3) {
  return Math.max(.1, Math.min(2, n / e, n / t));
}
var C4 = 32;
function w4(e) {
  return {
    ancho: Math.ceil(e.ancho + 64),
    alto: Math.ceil(e.alto + 64 + $0.separacionY)
  };
}
async function T4(e, {
  x: t,
  ancho: n,
  alto: r,
  pixelRatio: i
}) {
  let {
    toPng: a
  } = await b(async () => {
    let {
      toPng: e
    } = await import(`./es-D4THWdz3.js`);
    return {
      toPng: e
    };
  }, []);
  return a(e, {
    width: n,
    height: r,
    pixelRatio: i,
    backgroundColor: `#ffffff`,
    style: {
      transform: `translate(${C4 - t}px, ${C4}px)`,
      transition: `none`
    },
    filter: e => !(e instanceof HTMLElement && e.dataset?.soloPantalla != null)
  });
}
async function E4(e, t) {
  let {
    ancho: n,
    alto: r
  } = w4(t);
  return {
    url: await T4(e, {
      x: 0,
      ancho: n,
      alto: r,
      pixelRatio: S4(n, r)
    }),
    ancho: n,
    alto: r
  };
}
async function D4(e, t, {
  tramo: n = 6400
} = {}) {
  let r = w4(t),
    i = Math.ceil(r.ancho / 100) * 100,
    a = Math.ceil(r.alto / 20) * 20,
    o = O4(Math.min(n, i), a),
    s = [];
  for (let t = 0; t < i; t += n) {
    let r = Math.min(n, i - t);
    s.push({
      url: await T4(e, {
        x: t,
        ancho: r,
        alto: a,
        pixelRatio: o
      }),
      x: t,
      ancho: r,
      alto: a
    });
  }
  return {
    tramos: s,
    ancho: i,
    alto: a
  };
}
function O4(e, t, {
  tope: n = 16e3,
  area: r = 12e7
} = {}) {
  return Math.max(.1, Math.min(2, n / e, n / t, Math.sqrt(r / (e * t))));
}
var k4 = 13.57,
  A4 = 15,
  j4 = () => new Date().toISOString().slice(0, 10);
function M4(e, t) {
  let n = document.createElement(`a`);
  n.href = e, n.download = t, document.body.appendChild(n), n.click(), n.remove();
}
function N4(e) {
  return String(e ?? ``).normalize(`NFD`).replace(/\p{M}/gu, ``).toLowerCase().replace(/[^a-z0-9]+/g, `-`).replace(/^-|-$/g, ``).slice(0, 60) || `organigrama`;
}
async function P4(e, t, n) {
  let {
    url: r
  } = await E4(e, t);
  M4(r, `organigrama-${N4(n)}-${j4()}.png`);
}
function F4(e) {
  let t = {
    style: `thin`,
    color: {
      argb: e.borde
    }
  };
  return {
    top: t,
    left: t,
    bottom: t,
    right: t
  };
}
function I4(e, t, {
  empresa: n,
  titulo: r,
  subtitulo: i
}, a) {
  [[n, 16, !0], [r, 12, !0], [i, 10, !1]].forEach(([n, r, i], o) => {
    let s = o + 1;
    e.mergeCells(s, 1, s, t);
    let c = e.getCell(s, 1);
    c.value = n, c.font = {
      name: `Calibri`,
      size: r,
      bold: i,
      color: {
        argb: a.titulo.texto
      }
    }, c.fill = {
      type: `pattern`,
      pattern: `solid`,
      fgColor: {
        argb: a.titulo.fondo
      }
    }, c.alignment = {
      vertical: `middle`,
      indent: 1
    }, e.getRow(s).height = o === 0 ? 28 : 20;
  });
}
function L4(e, t, n, r) {
  let i = e.getRow(t);
  n.forEach((e, t) => {
    let n = i.getCell(t + 1);
    n.value = e, n.font = {
      name: `Calibri`,
      size: 10,
      bold: !0,
      color: {
        argb: r.encabezado.texto
      }
    }, n.fill = {
      type: `pattern`,
      pattern: `solid`,
      fgColor: {
        argb: r.encabezado.fondo
      }
    }, n.alignment = {
      vertical: `middle`,
      wrapText: !0
    }, n.border = F4(r);
  }), i.height = 30;
}
async function R4({
  raices: t,
  imagen: n,
  titulo: r,
  empresa: i,
  colores: a,
  fecha: o = new Date()
}) {
  let {
      default: s
    } = await b(async () => {
      let {
        default: t
      } = await import(`./exceljs.min-DgbhWywh.js`).then(t => e(t.default, 1));
      return {
        default: t
      };
    }, __vite__mapDeps([4, 1])),
    c = new s.Workbook();
  c.creator = i, c.created = o;
  let l = v4(t),
    u = l.filter(e => !e.unidad && !e.referencia),
    d = u.filter(e => e.vacante).length,
    f = o.toLocaleDateString(`es-PE`, {
      day: `2-digit`,
      month: `long`,
      year: `numeric`
    }),
    p = {
      empresa: i || `Organigrama`,
      titulo: `Informe de puestos — ${r}`,
      subtitulo: `Al ${f} · ${u.length} puestos · ${u.length - d} ocupados · ${d} vacantes`
    },
    m = c.addWorksheet(`Puestos`, {
      views: [{
        state: `frozen`,
        ySplit: 5,
        xSplit: 2
      }],
      pageSetup: {
        orientation: `landscape`,
        fitToPage: !0,
        fitToWidth: 1,
        fitToHeight: 0,
        paperSize: 9
      }
    }),
    h = _4.length;
  m.columns = _4.map(e => ({
    width: e.ancho
  })), I4(m, h, p, a), L4(m, 5, _4.map(e => e.titulo), a);
  let g = _4.findIndex(e => e.titulo === `Puesto`) + 1,
    _ = _4.findIndex(e => e.titulo === `Cultivo`) + 1;
  l.forEach((e, t) => {
    let n = m.getRow(6 + t);
    n.values = e.valores, n.eachCell({
      includeEmpty: !0
    }, (n, r) => {
      r > h || (n.border = F4(a), n.alignment = {
        vertical: `middle`
      }, n.font = {
        name: `Calibri`,
        size: 10,
        italic: e.vacante || e.unidad || e.referencia,
        color: {
          argb: e.vacante || e.unidad || e.referencia ? a.tenue : a.texto
        }
      }, t % 2 == 1 && (n.fill = {
        type: `pattern`,
        pattern: `solid`,
        fgColor: {
          argb: a.cebra
        }
      }));
    }), n.getCell(g).alignment = {
      vertical: `middle`,
      indent: Math.min(e.escalon - 1, 15)
    }, n.getCell(g).font = {
      ...n.getCell(g).font,
      bold: e.escalon <= 2 && !e.vacante
    };
    let r = e.cultivo && a.cultivos[e.cultivo];
    if (r) {
      let e = n.getCell(_);
      e.fill = {
        type: `pattern`,
        pattern: `solid`,
        fgColor: {
          argb: r.fondo
        }
      }, e.font = {
        ...e.font,
        bold: !0,
        italic: !1,
        color: {
          argb: r.texto
        }
      }, e.alignment = {
        vertical: `middle`,
        horizontal: `center`
      };
    }
  }), m.autoFilter = {
    from: {
      row: 5,
      column: 1
    },
    to: {
      row: 5 + l.length,
      column: h
    }
  };
  let v = c.addWorksheet(`Organigrama`, {
      views: [{
        showGridLines: !1
      }]
    }),
    y = Math.max(12, Math.ceil((n?.ancho ?? 0) / 100));
  if (v.columns = Array.from({
    length: y
  }, () => ({
    width: k4
  })), I4(v, 12, {
    ...p,
    titulo: `Organigrama — ${r}`
  }, a), n?.tramos?.length) {
    let e = Math.ceil(n.alto / 20);
    for (let t = 5; t <= 4 + e; t++) v.getRow(t).height = A4;
    for (let t of n.tramos) {
      let n = c.addImage({
        base64: t.url,
        extension: `png`
      });
      v.addImage(n, {
        tl: {
          nativeCol: Math.round(t.x / 100),
          nativeRow: 4
        },
        br: {
          nativeCol: Math.round((t.x + t.ancho) / 100),
          nativeRow: 4 + e
        },
        editAs: `oneCell`
      });
    }
  } else v.getCell(5, 1).value = `No se pudo armar el dibujo. Descárgalo aparte desde la telaraña.`;
  let x = c.addWorksheet(`Detalle`, {
      views: [{
        state: `frozen`,
        ySplit: 1
      }]
    }),
    S = g4(t),
    C = Object.keys(S[0] ?? {});
  return x.columns = C.map(e => ({
    width: Math.max(10, Math.min(40, e.length + 4))
  })), L4(x, 1, C, a), S.forEach((e, t) => {
    let n = x.getRow(2 + t);
    n.values = C.map(t => e[t]), n.eachCell(e => {
      e.font = {
        name: `Calibri`,
        size: 10
      };
    });
  }), S.length && (x.autoFilter = {
    from: {
      row: 1,
      column: 1
    },
    to: {
      row: 1 + S.length,
      column: C.length
    }
  }), c.xlsx.writeBuffer();
}
async function z4({
  raices: e,
  imagen: t,
  titulo: n,
  empresa: r
}) {
  let i = await R4({
      raices: e,
      imagen: t,
      titulo: n,
      empresa: r,
      colores: x4()
    }),
    a = URL.createObjectURL(new Blob([i], {
      type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`
    }));
  try {
    M4(a, `organigrama-${N4(n)}-${j4()}.xlsx`);
  } finally {
    setTimeout(() => URL.revokeObjectURL(a), 1e4);
  }
}
var B4 = .1,
  V4 = 2,
  H4 = 40,
  U4 = .4,
  W4 = e => Math.min(V4, Math.max(B4, e));
function G4(e, t) {
  let n = W4(Math.min(1, (e.ancho - 80) / t.ancho, (e.alto - 80) / t.alto));
  return {
    escala: n,
    x: (e.ancho - t.ancho * n) / 2,
    y: H4
  };
}
function K4(e, t, n) {
  let r = e.get(n);
  return [n, ...(r && !t.has(n) ? r.hijos.map(e => e.fila.id) : [])];
}
function q4(e, t, n, r, i) {
  let a = G4(e, t);
  return a.escala >= U4 || !n.length ? a : V2(t.nodos, K4(r, i, n[0].fila.id), e, {
    minimo: U4
  }) ?? a;
}
var Y4 = [{
  id: `hoja`,
  label: `Hoja`,
  icono: zi
}, {
  id: `escalera`,
  label: `Escalera`,
  icono: ni
}, {
  id: `telarana`,
  label: `Telaraña`,
  icono: yi
}];
var Z4 = 100,
  Q4 = {
    [M0.MANUAL]: ``,
    [M0.NISIRA]: `bg-(--info-bg)`,
    [M0.CALCULO]: `bg-(--panel-fuerte)`
  },
  $4 = {
    [M0.MANUAL]: void 0,
    [M0.NISIRA]: `var(--info-bg)`,
    [M0.CALCULO]: `var(--panel-fuerte)`
  },
  e3 = F0.map(e => ({
    ...e,
    fondo: Q4[e.origen],
    color: $4[e.origen],
    claseCelda: e.clave === `estadoCargo` ? e => e.estadoCargo === `NO` ? `font-medium text-(--error-texto)` : void 0 : void 0
  })),
  t3 = e => (e ?? 0).toLocaleString(`es-PE`);
var g3 = `gth_instalar_oculto`;
function _3() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
function v3() {
  return window.matchMedia?.(`(display-mode: standalone)`).matches || window.navigator.standalone === !0;
}
function b3() {}
function x3() {
  let e = (0, ReactCompiler.c)(7),
    {
      key: t,
      pathname: n
    } = rt(),
    r = it(),
    i = (0, React.useRef)(null),
    a;
  e[0] !== t || e[1] !== r ? (a = () => {
    let e = i.current;
    if (e) try {
      sessionStorage.setItem(`gth_scroll_${e.key}`, String(e.y()));
    } catch {}
    if (i.current = {
      key: t,
      y: S3
    }, r === `POP`) {
      let e = null;
      try {
        e = sessionStorage.getItem(`gth_scroll_${t}`);
      } catch {
        e = null;
      }
      if (e != null) {
        requestAnimationFrame(() => window.scrollTo(0, Number(e)));
        return;
      }
    }
    window.scrollTo(0, 0);
  }, e[0] = t, e[1] = r, e[2] = a) : a = e[2];
  let o;
  return e[3] !== t || e[4] !== n || e[5] !== r ? (o = [t, n, r], e[3] = t, e[4] = n, e[5] = r, e[6] = o) : o = e[6], (0, React.useEffect)(a, o), null;
}
function S3() {
  return window.scrollY;
}
var w3 = __VERSION_APP__,
  T3 = 9e5,
  E3 = null,
  D3 = !1;
async function O3() {
  try {
    let e = await fetch(`/version.json?t=${Date.now()}`, {
      cache: `no-store`
    });
    return e.ok ? (await e.json())?.version ?? null : null;
  } catch {
    return null;
  }
}
async function k3() {
  if (D3) return;
  let e = await O3();
  e && e !== w3 && (D3 = !0, window.__versionNueva = e, window.dispatchEvent(new CustomEvent(`version-nueva`, {
    detail: {
      version: e
    }
  })));
}
function A3() {
  E3 || (E3 = setInterval(k3, T3), document.addEventListener(`visibilitychange`, () => {
    document.visibilityState === `visible` && k3();
  }), window.addEventListener(`vite:preloadError`, e => {
    e.preventDefault?.(), window.location.reload();
  }), k3());
}
var j3 = `gth_actualizando`;
var paginasPorRuta = {
  "/": MisTareas,
  "/aprobaciones": Aprobaciones,
  "/proyectos": Proyectos,
  "/proyectos/:id": DetalleProyecto,
  "/calendario": Calendario,
  "/calendario/conectar/:proveedor": ConectarCalendario,
  "/notificaciones": Notificaciones,
  "/organizacion": Organizacion,
  "/organizacion/:id": Organizacion,
  "/admin": ResumenAdmin,
  "/admin/maestros": Maestros,
  "/admin/marca": Apariencia,
  "/admin/personal": Personal,
  "/admin/errores": ErroresSistema,
  "/admin/movilidad": MovilidadAdmin,
  "/admin/bots": BotsWhatsApp,
  "/admin/niveles": NivelesJerarquicos,
  "/admin/areas-por-sector": AreasPorSector,
  "/transporte": Transporte,
  "/incidencias": Incidencias,
  "/inspecciones": Inspecciones,
  "/labores": ControlLabores,
  "/observaciones": Observaciones,
  "/organigrama": Organigrama,
  "/gestor": GestorWhatsApp
};
mx(px()), Cs(), po(), `serviceWorker` in navigator && window.addEventListener(`load`, () => {
  (import.meta.env.VITE_ENABLE_SW === "true" ? navigator.serviceWorker.register(`/sw.js`) : Promise.resolve()).catch(() => {});
});
async function iniciarAplicacion() {
  await Ss();
  try {
    await ox();
    let e = await ix.handleRedirectPromise();
    if (e?.idToken) try {
      let t = await api(`/auth/microsoft`, {
          method: `POST`,
          body: JSON.stringify({
            idToken: e.idToken
          }),
          redirigirEn401: !1
        }),
        n = t.token ? t : t.completo ?? t;
      guardarSesion(n.token, n.usuario), Vn(n.tokenConfianza);
    } catch (e) {
      try {
        sessionStorage.setItem(`msal_error`, e?.message || `No se pudo iniciar sesión con Microsoft.`);
      } catch {}
    }
  } catch (e) {
    console.error(`[MSAL] redirect`, e);
  }
  // La primera ruta se decide con los permisos ya leídos (no con el token).
  await refrescarPermisos();
  (0, f.createRoot)(document.getElementById(`root`)).render((0, JSXRuntime.jsx)(React.StrictMode, {
    children: (0, JSXRuntime.jsx)(Do, {
      children: (0, JSXRuntime.jsx)(App, {})
    })
  })), requestAnimationFrame(() => {
    let e = document.getElementById(`arranque`);
    e && (e.style.transition = `opacity .25s ease`, e.style.opacity = `0`, setTimeout(() => e.remove(), 260));
  });
}
export { i as _, dS as a, zo as c, api as d, ii as f, m as g, usuarioIdSesion as h, Fx as i, Bo as l, rr as m, DX as n, Yx as o, Rr as p, Mx as r, EstadoError as s, YX as t, ko as u };
export { accionProyecto as rec_accionProyecto, puedeRutaAdmin as rec_puedeRutaAdmin, refrescarPermisos as rec_refrescarPermisos, permisosSesion as rec_permisosSesion, puedeAccion as rec_puedeAccion, puedePagina as rec_puedePagina, tienePermisoCon as rec_tienePermisoCon, $$ as rec_$$, $0 as rec_$0, $2 as rec_$2, $4 as rec_$4, $A as rec_$A, $B as rec_$B, $E as rec_$E, $F as rec_$F, $G as rec_$G, $H as rec_$H, $I as rec_$I, $J as rec_$J, $K as rec_$K, $L as rec_$L, $M as rec_$M, $N as rec_$N, $P as rec_$P, $Q as rec_$Q, $R as rec_$R, $S as rec_$S, $T as rec_$T, $U as rec_$U, $V as rec_$V, $W as rec_$W, $X as rec_$X, $Y as rec_$Y, $Z as rec_$Z, $_ as rec_$_, $a as rec_$a, $b as rec_$b, $c as rec_$c, $d as rec_$d, $e as rec_$e, $f as rec_$f, $g as rec_$g, $h as rec_$h, $i as rec_$i, $j as rec_$j, $k as rec_$k, $l as rec_$l, $m as rec_$m, $o as rec_$o, $p as rec_$p, $q as rec_$q, $r as rec_$r, $s as rec_$s, $t as rec_$t, $u as rec_$u, $v as rec_$v, $w as rec_$w, $x as rec_$x, $y as rec_$y, $z as rec_$z, A as rec_A, A1 as rec_A1, A2 as rec_A2, A3 as rec_A3, A4 as rec_A4, AA as rec_AA, AB as rec_AB, AC as rec_AC, AD as rec_AD, AE as rec_AE, AF as rec_AF, AG as rec_AG, AH as rec_AH, AI as rec_AI, AJ as rec_AJ, AK as rec_AK, AL as rec_AL, AM as rec_AM, AN as rec_AN, AP as rec_AP, API_BASE as rec_API_BASE, AQ as rec_AQ, AR as rec_AR, AS as rec_AS, AT as rec_AT, AU as rec_AU, AV as rec_AV, AW as rec_AW, AX as rec_AX, AY as rec_AY, AZ as rec_AZ, A_ as rec_A_, Aa as rec_Aa, Ab as rec_Ab, Ac as rec_Ac, AccesoDenegado as rec_AccesoDenegado, AccesosMovilidad as rec_AccesosMovilidad, AccionAsync as rec_AccionAsync, AccionesEstadoTarea as rec_AccionesEstadoTarea, ActividadProyecto as rec_ActividadProyecto, Ad as rec_Ad, Ae as rec_Ae, Af as rec_Af, Ag as rec_Ag, AgendarEnArea as rec_AgendarEnArea, Ah as rec_Ah, Ai as rec_Ai, Aj as rec_Aj, Ak as rec_Ak, Al as rec_Al, Am as rec_Am, An as rec_An, AnaliticaInspecciones as rec_AnaliticaInspecciones, AnaliticaTransporte as rec_AnaliticaTransporte, AnaliticaUso as rec_AnaliticaUso, Ao as rec_Ao, Ap as rec_Ap, Apariencia as rec_Apariencia, App as rec_App, Aprobaciones as rec_Aprobaciones, Aq as rec_Aq, Ar as rec_Ar, ArbolOrganizacion as rec_ArbolOrganizacion, AreasPorSector as rec_AreasPorSector, ArmarOrden as rec_ArmarOrden, As as rec_As, AsignacionesPorArea as rec_AsignacionesPorArea, At as rec_At, Au as rec_Au, AuditoriaProyecto as rec_AuditoriaProyecto, Av as rec_Av, AvanceIncidencia as rec_AvanceIncidencia, AvatarPersona as rec_AvatarPersona, AvisoActualizacion as rec_AvisoActualizacion, Aw as rec_Aw, Ay as rec_Ay, Az as rec_Az, B as rec_B, B$ as rec_B$, B0 as rec_B0, B2 as rec_B2, B4 as rec_B4, BA as rec_BA, BB as rec_BB, BE as rec_BE, BF as rec_BF, BG as rec_BG, BH as rec_BH, BI as rec_BI, BJ as rec_BJ, BK as rec_BK, BL as rec_BL, BM as rec_BM, BN as rec_BN, BP as rec_BP, BR as rec_BR, BT as rec_BT, BU as rec_BU, BV as rec_BV, BW as rec_BW, BX as rec_BX, BY as rec_BY, BZ as rec_BZ, B_ as rec_B_, Ba as rec_Ba, Bb as rec_Bb, Bc as rec_Bc, Bd as rec_Bd, Be as rec_Be, Bf as rec_Bf, Bg as rec_Bg, Bh as rec_Bh, Bi as rec_Bi, Bj as rec_Bj, Bl as rec_Bl, Bm as rec_Bm, Bn as rec_Bn, Bo as rec_Bo, BotsWhatsApp as rec_BotsWhatsApp, Bp as rec_Bp, Bq as rec_Bq, Br as rec_Br, Bs as rec_Bs, Bt as rec_Bt, Bu as rec_Bu, BuscadorPersona as rec_BuscadorPersona, BuscarConversacion as rec_BuscarConversacion, BuscarPersonaOrganigrama as rec_BuscarPersonaOrganigrama, BusquedaGlobal as rec_BusquedaGlobal, Bv as rec_Bv, Bw as rec_Bw, Bx as rec_Bx, By as rec_By, Bz as rec_Bz, C as rec_C, C$ as rec_C$, C0 as rec_C0, C1 as rec_C1, C2 as rec_C2, C4 as rec_C4, CA as rec_CA, CB as rec_CB, CC as rec_CC, CD as rec_CD, CE as rec_CE, CF as rec_CF, CG as rec_CG, CH as rec_CH, CI as rec_CI, CJ as rec_CJ, CK as rec_CK, CL as rec_CL, CM as rec_CM, CN as rec_CN, CP as rec_CP, CR as rec_CR, CS as rec_CS, CT as rec_CT, CU as rec_CU, CV as rec_CV, CW as rec_CW, CX as rec_CX, CY as rec_CY, CZ as rec_CZ, C_ as rec_C_, Ca as rec_Ca, Calendario as rec_Calendario, CalendarioFecha as rec_CalendarioFecha, CambiarContrasena as rec_CambiarContrasena, CambiosPendientes as rec_CambiosPendientes, CandadoGestor as rec_CandadoGestor, CapturarFirma as rec_CapturarFirma, CapturarFoto as rec_CapturarFoto, Cargando as rec_Cargando, CatalogosMovilidad as rec_CatalogosMovilidad, Cb as rec_Cb, Cc as rec_Cc, Cd as rec_Cd, Ce as rec_Ce, CeldaCalendario as rec_CeldaCalendario, CeldaEditable as rec_CeldaEditable, CerrarOrden as rec_CerrarOrden, CerrarProyecto as rec_CerrarProyecto, Cf as rec_Cf, Cg as rec_Cg, Ch as rec_Ch, ChatGestor as rec_ChatGestor, Ci as rec_Ci, Cj as rec_Cj, Ck as rec_Ck, Cl as rec_Cl, Cm as rec_Cm, Cn as rec_Cn, Co as rec_Co, CodigoVinculacion as rec_CodigoVinculacion, ColoresMarca as rec_ColoresMarca, Componente_A0_65_48 as rec_Componente_A0_65_48, Componente_BC_66_67 as rec_Componente_BC_66_67, Componente_BS_66_83 as rec_Componente_BS_66_83, Componente_DO_68_79 as rec_Componente_DO_68_79, Componente_DolarO_36_79 as rec_Componente_DolarO_36_79, Componente_FQ_70_81 as rec_Componente_FQ_70_81, Componente_G1_71_49 as rec_Componente_G1_71_49, Componente_GS_71_83 as rec_Componente_GS_71_83, Componente_Gk_71_107 as rec_Componente_Gk_71_107, Componente_HS_72_83 as rec_Componente_HS_72_83, Componente_IC_73_67 as rec_Componente_IC_73_67, Componente_ID_73_68 as rec_Componente_ID_73_68, Componente_JQ_74_81 as rec_Componente_JQ_74_81, Componente_KD_75_68 as rec_Componente_KD_75_68, Componente_LC_76_67 as rec_Componente_LC_76_67, Componente_LD_76_68 as rec_Componente_LD_76_68, Componente_LDolar_76_36 as rec_Componente_LDolar_76_36, Componente_LS_76_83 as rec_Componente_LS_76_83, Componente_MD_77_68 as rec_Componente_MD_77_68, Componente_MDolar_77_36 as rec_Componente_MDolar_77_36, Componente_Mk_77_107 as rec_Componente_Mk_77_107, Componente_NDolar_78_36 as rec_Componente_NDolar_78_36, Componente_PD_80_68 as rec_Componente_PD_80_68, Componente_Q1_81_49 as rec_Componente_Q1_81_49, Componente_Qk_81_107 as rec_Componente_Qk_81_107, Componente_RC_82_67 as rec_Componente_RC_82_67, Componente_RDolar_82_36 as rec_Componente_RDolar_82_36, Componente_SQ_83_81 as rec_Componente_SQ_83_81, Componente_TA_84_65 as rec_Componente_TA_84_65, Componente_TS_84_83 as rec_Componente_TS_84_83, Componente_U1_85_49 as rec_Componente_U1_85_49, Componente_VQ_86_81 as rec_Componente_VQ_86_81, Componente_W1_87_49 as rec_Componente_W1_87_49, Componente_XDolar_88_36 as rec_Componente_XDolar_88_36, Componente_ZO_90_79 as rec_Componente_ZO_90_79, Componente_Zk_90_107 as rec_Componente_Zk_90_107, Componente__A_95_65 as rec_Componente__A_95_65, Componente__Dolar_95_36 as rec_Componente__Dolar_95_36, Componente__Z_95_90 as rec_Componente__Z_95_90, Componente_a4_97_52 as rec_Componente_a4_97_52, Componente_aO_97_79 as rec_Componente_aO_97_79, Componente_ak_97_107 as rec_Componente_ak_97_107, Componente_bZ_98_90 as rec_Componente_bZ_98_90, Componente_c3_99_51 as rec_Componente_c3_99_51, Componente_ck_99_107 as rec_Componente_ck_99_107, Componente_dk_100_107 as rec_Componente_dk_100_107, Componente_ek_101_107 as rec_Componente_ek_101_107, Componente_f0_102_48 as rec_Componente_f0_102_48, Componente_gDolar_103_36 as rec_Componente_gDolar_103_36, Componente_hA_104_65 as rec_Componente_hA_104_65, Componente_i3_105_51 as rec_Componente_i3_105_51, Componente_i4_105_52 as rec_Componente_i4_105_52, Componente_ik_105_107 as rec_Componente_ik_105_107, Componente_is_105_115 as rec_Componente_is_105_115, Componente_jDolar_106_36 as rec_Componente_jDolar_106_36, Componente_kk_107_107 as rec_Componente_kk_107_107, Componente_lk_108_107 as rec_Componente_lk_108_107, Componente_nA_110_65 as rec_Componente_nA_110_65, Componente_nk_110_107 as rec_Componente_nk_110_107, Componente_o3_111_51 as rec_Componente_o3_111_51, Componente_oA_111_65 as rec_Componente_oA_111_65, Componente_ok_111_107 as rec_Componente_ok_111_107, Componente_p0_112_48 as rec_Componente_p0_112_48, Componente_qD_113_68 as rec_Componente_qD_113_68, Componente_qQ_113_81 as rec_Componente_qQ_113_81, Componente_r3_114_51 as rec_Componente_r3_114_51, Componente_r4_114_52 as rec_Componente_r4_114_52, Componente_rDolar_114_36 as rec_Componente_rDolar_114_36, Componente_rk_114_107 as rec_Componente_rk_114_107, Componente_s3_115_51 as rec_Componente_s3_115_51, Componente_sDolar_115_36 as rec_Componente_sDolar_115_36, Componente_t1_116_49 as rec_Componente_t1_116_49, Componente_uk_117_107 as rec_Componente_uk_117_107, Componente_vA_118_65 as rec_Componente_vA_118_65, Componente_vDolar_118_36 as rec_Componente_vDolar_118_36, Componente_xC_120_67 as rec_Componente_xC_120_67, Componente_xZ_120_90 as rec_Componente_xZ_120_90, Componente_yZ_121_90 as rec_Componente_yZ_121_90, Componente_zC_122_67 as rec_Componente_zC_122_67, Componente_zO_122_79 as rec_Componente_zO_122_79, Componente_zS_122_83 as rec_Componente_zS_122_83, ConectarCalendario as rec_ConectarCalendario, ConfiguracionProyecto as rec_ConfiguracionProyecto, ConfirmarFechaTerminada as rec_ConfirmarFechaTerminada, ConstruirRuta as rec_ConstruirRuta, ContenidoMensaje as rec_ContenidoMensaje, ConversacionesGestor as rec_ConversacionesGestor, Cp as rec_Cp, Cq as rec_Cq, Cr as rec_Cr, Cs as rec_Cs, Ct as rec_Ct, Cu as rec_Cu, Cv as rec_Cv, Cw as rec_Cw, Cx as rec_Cx, Cy as rec_Cy, Cz as rec_Cz, D as rec_D, D$ as rec_D$, D1 as rec_D1, D2 as rec_D2, D3 as rec_D3, D4 as rec_D4, DA as rec_DA, DB as rec_DB, DC as rec_DC, DD as rec_DD, DE as rec_DE, DF as rec_DF, DG as rec_DG, DH as rec_DH, DI as rec_DI, DJ as rec_DJ, DK as rec_DK, DL as rec_DL, DM as rec_DM, DN as rec_DN, DP as rec_DP, DQ as rec_DQ, DR as rec_DR, DT as rec_DT, DU as rec_DU, DV as rec_DV, DW as rec_DW, DX as rec_DX, DY as rec_DY, DZ as rec_DZ, D_ as rec_D_, Da as rec_Da, Db as rec_Db, Dc as rec_Dc, Dd as rec_Dd, De as rec_De, DesempenoPersonal as rec_DesempenoPersonal, DetalleActa as rec_DetalleActa, DetalleEstrategia as rec_DetalleEstrategia, DetalleHilo as rec_DetalleHilo, DetalleIncidencia as rec_DetalleIncidencia, DetalleProyecto as rec_DetalleProyecto, DetalleReunion as rec_DetalleReunion, DetalleTarea as rec_DetalleTarea, DetalleUnidad as rec_DetalleUnidad, Df as rec_Df, Dg as rec_Dg, Dh as rec_Dh, Di as rec_Di, DialogoConfirmacion as rec_DialogoConfirmacion, DiscusionesProyecto as rec_DiscusionesProyecto, Dj as rec_Dj, Dk as rec_Dk, Dl as rec_Dl, Dm as rec_Dm, Dn as rec_Dn, Do as rec_Do, DocumentoMensaje as rec_DocumentoMensaje, Dp as rec_Dp, Dq as rec_Dq, Dr as rec_Dr, Dt as rec_Dt, Du as rec_Du, Dv as rec_Dv, Dw as rec_Dw, Dy as rec_Dy, Dz as rec_Dz, E as rec_E, E$ as rec_E$, E0 as rec_E0, E1 as rec_E1, E2 as rec_E2, E3 as rec_E3, E4 as rec_E4, EA as rec_EA, EB as rec_EB, EC as rec_EC, ED as rec_ED, EE as rec_EE, EF as rec_EF, EG as rec_EG, EH as rec_EH, EI as rec_EI, EJ as rec_EJ, EK as rec_EK, EL as rec_EL, EM as rec_EM, EN as rec_EN, EO as rec_EO, EP as rec_EP, EQ as rec_EQ, ER as rec_ER, ET as rec_ET, EU as rec_EU, EV as rec_EV, EW as rec_EW, EX as rec_EX, EY as rec_EY, EZ as rec_EZ, E_ as rec_E_, Ea as rec_Ea, Eb as rec_Eb, Ec as rec_Ec, Ed as rec_Ed, EditarNivel as rec_EditarNivel, EditorMenciones as rec_EditorMenciones, Ee as rec_Ee, Ef as rec_Ef, Eg as rec_Eg, Eh as rec_Eh, Ei as rec_Ei, Ej as rec_Ej, Ek as rec_Ek, El as rec_El, Em as rec_Em, En as rec_En, Ep as rec_Ep, Eq as rec_Eq, EquipoProyecto as rec_EquipoProyecto, EquipoUnidad as rec_EquipoUnidad, Er as rec_Er, ErroresSistema as rec_ErroresSistema, Es as rec_Es, EscaleraOrganigrama as rec_EscaleraOrganigrama, EstadoBots as rec_EstadoBots, EstadoError as rec_EstadoError, EstadoOrden as rec_EstadoOrden, EstrategiasUnidad as rec_EstrategiasUnidad, EstructuraPrincipal as rec_EstructuraPrincipal, Et as rec_Et, Eu as rec_Eu, Ev as rec_Ev, Ew as rec_Ew, Ey as rec_Ey, Ez as rec_Ez, F as rec_F, F$ as rec_F$, F0 as rec_F0, F1 as rec_F1, F2 as rec_F2, F4 as rec_F4, FA as rec_FA, FB as rec_FB, FC as rec_FC, FE as rec_FE, FF as rec_FF, FG as rec_FG, FH as rec_FH, FI as rec_FI, FJ as rec_FJ, FK as rec_FK, FL as rec_FL, FM as rec_FM, FN as rec_FN, FO as rec_FO, FP as rec_FP, FR as rec_FR, FS as rec_FS, FT as rec_FT, FU as rec_FU, FV as rec_FV, FW as rec_FW, FX as rec_FX, FY as rec_FY, FZ as rec_FZ, F_ as rec_F_, Fa as rec_Fa, Fb as rec_Fb, Fc as rec_Fc, Fd as rec_Fd, Fe as rec_Fe, Ff as rec_Ff, Fg as rec_Fg, Fh as rec_Fh, Fi as rec_Fi, FiltroColumna as rec_FiltroColumna, FiltrosOrganigrama as rec_FiltrosOrganigrama, Fj as rec_Fj, Fk as rec_Fk, Fl as rec_Fl, Flota as rec_Flota, Fm as rec_Fm, Fn as rec_Fn, Fo as rec_Fo, FormularioActa as rec_FormularioActa, FormularioCatalogoMovilidad as rec_FormularioCatalogoMovilidad, FormularioEstrategia as rec_FormularioEstrategia, FormularioFundo as rec_FormularioFundo, FormularioProveedor as rec_FormularioProveedor, FormularioPuesto as rec_FormularioPuesto, FormularioRol as rec_FormularioRol, FormularioRuta as rec_FormularioRuta, FormularioSolicitante as rec_FormularioSolicitante, FormularioUnidad as rec_FormularioUnidad, FormularioUsuario as rec_FormularioUsuario, FormularioVehiculo as rec_FormularioVehiculo, FotoIncidencia as rec_FotoIncidencia, FotoPuesto as rec_FotoPuesto, FotosActa as rec_FotosActa, Fp as rec_Fp, Fq as rec_Fq, Fr as rec_Fr, Fs as rec_Fs, Ft as rec_Ft, Fu as rec_Fu, Fundos as rec_Fundos, Fv as rec_Fv, Fw as rec_Fw, Fx as rec_Fx, Fy as rec_Fy, Fz as rec_Fz, G as rec_G, G$ as rec_G$, G0 as rec_G0, G2 as rec_G2, G4 as rec_G4, GA as rec_GA, GB as rec_GB, GC as rec_GC, GE as rec_GE, GF as rec_GF, GG as rec_GG, GH as rec_GH, GI as rec_GI, GJ as rec_GJ, GK as rec_GK, GL as rec_GL, GM as rec_GM, GN as rec_GN, GP as rec_GP, GQ as rec_GQ, GR as rec_GR, GT as rec_GT, GU as rec_GU, GV as rec_GV, GW as rec_GW, GX as rec_GX, GY as rec_GY, GZ as rec_GZ, G_ as rec_G_, Ga as rec_Ga, Gb as rec_Gb, Gc as rec_Gc, Gd as rec_Gd, Ge as rec_Ge, GestionNiveles as rec_GestionNiveles, GestionOrganigrama as rec_GestionOrganigrama, GestorWhatsApp as rec_GestorWhatsApp, Gf as rec_Gf, Gg as rec_Gg, Gh as rec_Gh, Gi as rec_Gi, Gj as rec_Gj, Gl as rec_Gl, Gm as rec_Gm, Go as rec_Go, Gp as rec_Gp, Gq as rec_Gq, Gr as rec_Gr, Gs as rec_Gs, Gt as rec_Gt, Gu as rec_Gu, Gv as rec_Gv, Gw as rec_Gw, Gx as rec_Gx, Gy as rec_Gy, Gz as rec_Gz, H as rec_H, H$ as rec_H$, H0 as rec_H0, H2 as rec_H2, H4 as rec_H4, HA as rec_HA, HB as rec_HB, HD as rec_HD, HE as rec_HE, HF as rec_HF, HG as rec_HG, HH as rec_HH, HI as rec_HI, HJ as rec_HJ, HK as rec_HK, HL as rec_HL, HM as rec_HM, HN as rec_HN, HO as rec_HO, HP as rec_HP, HQ as rec_HQ, HR as rec_HR, HT as rec_HT, HU as rec_HU, HV as rec_HV, HW as rec_HW, HX as rec_HX, HY as rec_HY, HZ as rec_HZ, H_ as rec_H_, Ha as rec_Ha, Hb as rec_Hb, Hc as rec_Hc, Hd as rec_Hd, He as rec_He, Hf as rec_Hf, Hg as rec_Hg, Hh as rec_Hh, Hi as rec_Hi, Hj as rec_Hj, Hl as rec_Hl, Hm as rec_Hm, HorarioMovilidad as rec_HorarioMovilidad, Hp as rec_Hp, Hq as rec_Hq, Hr as rec_Hr, Hs as rec_Hs, Ht as rec_Ht, Hu as rec_Hu, Hv as rec_Hv, Hw as rec_Hw, Hx as rec_Hx, Hy as rec_Hy, Hz as rec_Hz, I as rec_I, I$ as rec_I$, I0 as rec_I0, I1 as rec_I1, I2 as rec_I2, I4 as rec_I4, IA as rec_IA, IB as rec_IB, IE as rec_IE, IF as rec_IF, IG as rec_IG, IH as rec_IH, II as rec_II, IJ as rec_IJ, IK as rec_IK, IL as rec_IL, IM as rec_IM, IN as rec_IN, IO as rec_IO, IP as rec_IP, IQ as rec_IQ, IR as rec_IR, IT as rec_IT, IU as rec_IU, IV as rec_IV, IW as rec_IW, IX as rec_IX, IY as rec_IY, IZ as rec_IZ, I_ as rec_I_, Ia as rec_Ia, Ib as rec_Ib, Ic as rec_Ic, IconoMicrosoft as rec_IconoMicrosoft, Id as rec_Id, Ie as rec_Ie, If as rec_If, Ig as rec_Ig, Ih as rec_Ih, Ii as rec_Ii, Ij as rec_Ij, Il as rec_Il, Im as rec_Im, ImagenActa as rec_ImagenActa, ImagenMarca as rec_ImagenMarca, ImagenesMarca as rec_ImagenesMarca, ImportacionNisira as rec_ImportacionNisira, In as rec_In, IncidenciaEnviada as rec_IncidenciaEnviada, Incidencias as rec_Incidencias, IniciarInspeccion as rec_IniciarInspeccion, Inspecciones as rec_Inspecciones, InstalacionYConexion as rec_InstalacionYConexion, Io as rec_Io, Ip as rec_Ip, Iq as rec_Iq, Ir as rec_Ir, Is as rec_Is, It as rec_It, Iu as rec_Iu, Iv as rec_Iv, Iw as rec_Iw, Ix as rec_Ix, Iy as rec_Iy, Iz as rec_Iz, J as rec_J, J0 as rec_J0, J1 as rec_J1, J2 as rec_J2, JA as rec_JA, JB as rec_JB, JD as rec_JD, JE as rec_JE, JF as rec_JF, JG as rec_JG, JH as rec_JH, JI as rec_JI, JJ as rec_JJ, JK as rec_JK, JL as rec_JL, JM as rec_JM, JN as rec_JN, JP as rec_JP, JR as rec_JR, JS as rec_JS, JSXRuntime as rec_JSXRuntime, JT as rec_JT, JU as rec_JU, JV as rec_JV, JW as rec_JW, JX as rec_JX, JY as rec_JY, JZ as rec_JZ, J_ as rec_J_, Ja as rec_Ja, Jb as rec_Jb, Jc as rec_Jc, Jd as rec_Jd, Je as rec_Je, Jf as rec_Jf, Jg as rec_Jg, Jh as rec_Jh, Ji as rec_Ji, Jj as rec_Jj, Jl as rec_Jl, Jm as rec_Jm, Jn as rec_Jn, Jo as rec_Jo, Jp as rec_Jp, Jq as rec_Jq, Jr as rec_Jr, Js as rec_Js, Jt as rec_Jt, Ju as rec_Ju, Jv as rec_Jv, Jw as rec_Jw, Jx as rec_Jx, Jy as rec_Jy, Jz as rec_Jz, K$ as rec_K$, K0 as rec_K0, K2 as rec_K2, K4 as rec_K4, KA as rec_KA, KB as rec_KB, KE as rec_KE, KF as rec_KF, KG as rec_KG, KH as rec_KH, KI as rec_KI, KJ as rec_KJ, KK as rec_KK, KL as rec_KL, KM as rec_KM, KN as rec_KN, KO as rec_KO, KP as rec_KP, KR as rec_KR, KT as rec_KT, KU as rec_KU, KV as rec_KV, KW as rec_KW, KX as rec_KX, KY as rec_KY, KZ as rec_KZ, K_ as rec_K_, Ka as rec_Ka, Kb as rec_Kb, Kc as rec_Kc, Kd as rec_Kd, Ke as rec_Ke, Kf as rec_Kf, Kg as rec_Kg, Kh as rec_Kh, Ki as rec_Ki, Kj as rec_Kj, Kk as rec_Kk, Kl as rec_Kl, Km as rec_Km, Ko as rec_Ko, Kp as rec_Kp, Kq as rec_Kq, Kr as rec_Kr, Ks as rec_Ks, Kt as rec_Kt, Ku as rec_Ku, Kv as rec_Kv, Kw as rec_Kw, Kx as rec_Kx, Ky as rec_Ky, Kz as rec_Kz, L as rec_L, L0 as rec_L0, L1 as rec_L1, L2 as rec_L2, L4 as rec_L4, LA as rec_LA, LB as rec_LB, LE as rec_LE, LF as rec_LF, LG as rec_LG, LH as rec_LH, LI as rec_LI, LJ as rec_LJ, LK as rec_LK, LL as rec_LL, LM as rec_LM, LN as rec_LN, LP as rec_LP, LR as rec_LR, LT as rec_LT, LU as rec_LU, LV as rec_LV, LW as rec_LW, LX as rec_LX, LY as rec_LY, LZ as rec_LZ, L_ as rec_L_, La as rec_La, Lb as rec_Lb, Lc as rec_Lc, Ld as rec_Ld, Le as rec_Le, Lf as rec_Lf, Lg as rec_Lg, Lh as rec_Lh, Li as rec_Li, LienzoOrganigrama as rec_LienzoOrganigrama, ListaAdjuntos as rec_ListaAdjuntos, ListaIncidencias as rec_ListaIncidencias, ListaInspecciones as rec_ListaInspecciones, Lj as rec_Lj, Lk as rec_Lk, Ll as rec_Ll, Lm as rec_Lm, Lo as rec_Lo, Login as rec_Login, LogoMarca as rec_LogoMarca, Lp as rec_Lp, Lq as rec_Lq, Lr as rec_Lr, Ls as rec_Ls, Lt as rec_Lt, Lu as rec_Lu, Lv as rec_Lv, Lw as rec_Lw, Lx as rec_Lx, Ly as rec_Ly, Lz as rec_Lz, M as rec_M, M0 as rec_M0, M2 as rec_M2, M4 as rec_M4, MA as rec_MA, MB as rec_MB, MC as rec_MC, ME as rec_ME, MF as rec_MF, MG as rec_MG, MH as rec_MH, MI as rec_MI, MJ as rec_MJ, MK as rec_MK, ML as rec_ML, MM as rec_MM, MN as rec_MN, MO as rec_MO, MP as rec_MP, MQ as rec_MQ, MR as rec_MR, MT as rec_MT, MU as rec_MU, MV as rec_MV, MW as rec_MW, MX as rec_MX, MY as rec_MY, MZ as rec_MZ, M_ as rec_M_, Ma as rec_Ma, Maestros as rec_Maestros, MarcaCarga as rec_MarcaCarga, Mb as rec_Mb, Mc as rec_Mc, Md as rec_Md, Me as rec_Me, MensajeGestor as rec_MensajeGestor, MenuCrear as rec_MenuCrear, MetasProyecto as rec_MetasProyecto, Mf as rec_Mf, Mg as rec_Mg, Mh as rec_Mh, Mi as rec_Mi, MisTareas as rec_MisTareas, Mj as rec_Mj, Ml as rec_Ml, Mm as rec_Mm, Mn as rec_Mn, Modal as rec_Modal, MovilidadAdmin as rec_MovilidadAdmin, Mp as rec_Mp, Mq as rec_Mq, Mr as rec_Mr, Mt as rec_Mt, Mu as rec_Mu, Mv as rec_Mv, Mw as rec_Mw, Mx as rec_Mx, My as rec_My, Mz as rec_Mz, N as rec_N, N0 as rec_N0, N2 as rec_N2, N4 as rec_N4, NA as rec_NA, NB as rec_NB, NC as rec_NC, ND as rec_ND, NE as rec_NE, NF as rec_NF, NG as rec_NG, NH as rec_NH, NI as rec_NI, NJ as rec_NJ, NK as rec_NK, NL as rec_NL, NM as rec_NM, NN as rec_NN, NO as rec_NO, NP as rec_NP, NR as rec_NR, NS as rec_NS, NT as rec_NT, NU as rec_NU, NV as rec_NV, NW as rec_NW, NX as rec_NX, NY as rec_NY, NZ as rec_NZ, N_ as rec_N_, Na as rec_Na, Nb as rec_Nb, Nc as rec_Nc, Nd as rec_Nd, Ne as rec_Ne, Nf as rec_Nf, Ng as rec_Ng, Nh as rec_Nh, Ni as rec_Ni, NivelesJerarquicos as rec_NivelesJerarquicos, Nj as rec_Nj, Nk as rec_Nk, Nl as rec_Nl, Nm as rec_Nm, Nn as rec_Nn, No as rec_No, NombreMarca as rec_NombreMarca, Notificaciones as rec_Notificaciones, Np as rec_Np, Nq as rec_Nq, Nr as rec_Nr, Ns as rec_Ns, Nt as rec_Nt, Nu as rec_Nu, NuevaEtiqueta as rec_NuevaEtiqueta, NuevaLista as rec_NuevaLista, NuevaMeta as rec_NuevaMeta, NuevaReunion as rec_NuevaReunion, TarjetaKanban as rec_TarjetaKanban, NuevoAccesoMovilidad as rec_NuevoAccesoMovilidad, NuevoHilo as rec_NuevoHilo, NuevoProyecto as rec_NuevoProyecto, Nv as rec_Nv, Nw as rec_Nw, Nx as rec_Nx, Ny as rec_Ny, Nz as rec_Nz, O as rec_O, O$ as rec_O$, O0 as rec_O0, O2 as rec_O2, O3 as rec_O3, O4 as rec_O4, OA as rec_OA, OB as rec_OB, OC as rec_OC, OD as rec_OD, OE as rec_OE, OF as rec_OF, OG as rec_OG, OH as rec_OH, OI as rec_OI, OJ as rec_OJ, OK as rec_OK, OL as rec_OL, OM as rec_OM, ON as rec_ON, OO as rec_OO, OP as rec_OP, OQ as rec_OQ, OR as rec_OR, OS as rec_OS, OT as rec_OT, OU as rec_OU, OV as rec_OV, OW as rec_OW, OX as rec_OX, OY as rec_OY, OZ as rec_OZ, O_ as rec_O_, Oa as rec_Oa, Ob as rec_Ob, Observaciones as rec_Observaciones, Oc as rec_Oc, Od as rec_Od, Oe as rec_Oe, Of as rec_Of, Og as rec_Og, Oh as rec_Oh, Oi as rec_Oi, Oj as rec_Oj, Ok as rec_Ok, Ol as rec_Ol, Om as rec_Om, On as rec_On, Oo as rec_Oo, Op as rec_Op, Oq as rec_Oq, Or as rec_Or, OrdenesTransporte as rec_OrdenesTransporte, Organigrama as rec_Organigrama, Organizacion as rec_Organizacion, Ot as rec_Ot, Ou as rec_Ou, Ov as rec_Ov, Ow as rec_Ow, Ox as rec_Ox, Oy as rec_Oy, Oz as rec_Oz, P as rec_P, P0 as rec_P0, P2 as rec_P2, P4 as rec_P4, PA as rec_PA, PB as rec_PB, PE as rec_PE, PF as rec_PF, PG as rec_PG, PH as rec_PH, PI as rec_PI, PJ as rec_PJ, PK as rec_PK, PL as rec_PL, PM as rec_PM, PN as rec_PN, PO as rec_PO, PP as rec_PP, PQ as rec_PQ, PR as rec_PR, PS as rec_PS, PT as rec_PT, PU as rec_PU, PV as rec_PV, PW as rec_PW, PX as rec_PX, PY as rec_PY, PZ as rec_PZ, P_ as rec_P_, Pa as rec_Pa, PaginaNoEncontrada as rec_PaginaNoEncontrada, Paginacion as rec_Paginacion, PanelNotificaciones as rec_PanelNotificaciones, PantallaActualizando as rec_PantallaActualizando, Pb as rec_Pb, Pc as rec_Pc, Pd as rec_Pd, Pe as rec_Pe, PedidosMovilidadAdmin as rec_PedidosMovilidadAdmin, PedidosTransporte as rec_PedidosTransporte, PendientesPorLevantar as rec_PendientesPorLevantar, PermisoRequerido as rec_PermisoRequerido, Personal as rec_Personal, Pf as rec_Pf, Pg as rec_Pg, Ph as rec_Ph, Pi as rec_Pi, Pj as rec_Pj, Pk as rec_Pk, Pl as rec_Pl, Pm as rec_Pm, Pn as rec_Pn, Po as rec_Po, Pp as rec_Pp, Pq as rec_Pq, Pr as rec_Pr, PreguntaActa as rec_PreguntaActa, PreguntaIncidencia as rec_PreguntaIncidencia, ProveedorAvisos as rec_ProveedorAvisos, ProveedorDialogos as rec_ProveedorDialogos, Proyectos as rec_Proyectos, Ps as rec_Ps, Pt as rec_Pt, Pu as rec_Pu, PuestoOrganigrama as rec_PuestoOrganigrama, Pv as rec_Pv, Pw as rec_Pw, Px as rec_Px, Py as rec_Py, Pz as rec_Pz, Q as rec_Q, Q0 as rec_Q0, Q2 as rec_Q2, Q4 as rec_Q4, QA as rec_QA, QB as rec_QB, QC as rec_QC, QE as rec_QE, QF as rec_QF, QG as rec_QG, QH as rec_QH, QI as rec_QI, QJ as rec_QJ, QK as rec_QK, QL as rec_QL, QM as rec_QM, QN as rec_QN, QP as rec_QP, QR as rec_QR, QS as rec_QS, QT as rec_QT, QU as rec_QU, QV as rec_QV, QW as rec_QW, QX as rec_QX, QY as rec_QY, QZ as rec_QZ, Q_ as rec_Q_, Qa as rec_Qa, Qb as rec_Qb, Qc as rec_Qc, Qd as rec_Qd, Qe as rec_Qe, Qf as rec_Qf, Qg as rec_Qg, Qh as rec_Qh, Qi as rec_Qi, Qj as rec_Qj, Ql as rec_Ql, Qm as rec_Qm, Qo as rec_Qo, Qp as rec_Qp, Qq as rec_Qq, Qr as rec_Qr, QrVinculacion as rec_QrVinculacion, Qs as rec_Qs, Qt as rec_Qt, Qu as rec_Qu, Qv as rec_Qv, Qw as rec_Qw, Qx as rec_Qx, Qy as rec_Qy, Qz as rec_Qz, R as rec_R, R0 as rec_R0, R1 as rec_R1, R2 as rec_R2, R4 as rec_R4, RA as rec_RA, RB as rec_RB, RD as rec_RD, RE as rec_RE, RF as rec_RF, RG as rec_RG, RH as rec_RH, RI as rec_RI, RJ as rec_RJ, RK as rec_RK, RL as rec_RL, RM as rec_RM, RN as rec_RN, RP as rec_RP, RR as rec_RR, RS as rec_RS, RT as rec_RT, RU as rec_RU, RV as rec_RV, RW as rec_RW, RX as rec_RX, RY as rec_RY, RZ as rec_RZ, R_ as rec_R_, Ra as rec_Ra, Rb as rec_Rb, Rc as rec_Rc, Rd as rec_Rd, Re as rec_Re, React as rec_React, ReactCompiler as rec_ReactCompiler, RedireccionInicio as rec_RedireccionInicio, RepartoPorArea as rec_RepartoPorArea, ReportarIncidencia as rec_ReportarIncidencia, ReportesTransporte as rec_ReportesTransporte, ResolverObservacion as rec_ResolverObservacion, RespuestaActa as rec_RespuestaActa, RespuestaIncidencia as rec_RespuestaIncidencia, ResumenAdmin as rec_ResumenAdmin, ResumenCostos as rec_ResumenCostos, ResumenTarea as rec_ResumenTarea, ReunionesProyecto as rec_ReunionesProyecto, Rf as rec_Rf, Rg as rec_Rg, Rh as rec_Rh, Ri as rec_Ri, Rj as rec_Rj, Rk as rec_Rk, Rl as rec_Rl, Rm as rec_Rm, Ro as rec_Ro, Roles as rec_Roles, Rp as rec_Rp, Rq as rec_Rq, Rr as rec_Rr, Rs as rec_Rs, Rt as rec_Rt, Ru as rec_Ru, RutaConPermiso as rec_RutaConPermiso, RutasAplicacion as rec_RutasAplicacion, RutasTransporte as rec_RutasTransporte, Rv as rec_Rv, Rw as rec_Rw, Rx as rec_Rx, Ry as rec_Ry, Rz as rec_Rz, S as rec_S, S$ as rec_S$, S0 as rec_S0, S1 as rec_S1, S2 as rec_S2, S3 as rec_S3, S4 as rec_S4, SA as rec_SA, SB as rec_SB, SC as rec_SC, SD as rec_SD, SE as rec_SE, SF as rec_SF, SG as rec_SG, SH as rec_SH, SI as rec_SI, SJ as rec_SJ, SK as rec_SK, SL as rec_SL, SM as rec_SM, SN as rec_SN, SO as rec_SO, SP as rec_SP, SR as rec_SR, SS as rec_SS, ST as rec_ST, SU as rec_SU, SV as rec_SV, SW as rec_SW, SX as rec_SX, SY as rec_SY, SZ as rec_SZ, S_ as rec_S_, Sa as rec_Sa, Sb as rec_Sb, Sc as rec_Sc, Sd as rec_Sd, Se as rec_Se, SedesUsuario as rec_SedesUsuario, SeguimientoObservaciones as rec_SeguimientoObservaciones, SeleccionTipoIncidencia as rec_SeleccionTipoIncidencia, SelectorFecha as rec_SelectorFecha, SelectorFechaHora as rec_SelectorFechaHora, SelectorHora as rec_SelectorHora, SelectorMultiple as rec_SelectorMultiple, SesionRequerida as rec_SesionRequerida, SesionesUsuario as rec_SesionesUsuario, Sf as rec_Sf, Sg as rec_Sg, Sh as rec_Sh, Si as rec_Si, SinSecciones as rec_SinSecciones, Sj as rec_Sj, Sl as rec_Sl, Sm as rec_Sm, Sn as rec_Sn, So as rec_So, SolicitantesMovilidad as rec_SolicitantesMovilidad, Sp as rec_Sp, Sq as rec_Sq, Sr as rec_Sr, Ss as rec_Ss, St as rec_St, Su as rec_Su, Sv as rec_Sv, Sw as rec_Sw, Sy as rec_Sy, Sz as rec_Sz, T as rec_T, T$ as rec_T$, T0 as rec_T0, T1 as rec_T1, T2 as rec_T2, T3 as rec_T3, T4 as rec_T4, TB as rec_TB, TC as rec_TC, TD as rec_TD, TE as rec_TE, TF as rec_TF, TG as rec_TG, TH as rec_TH, TI as rec_TI, TJ as rec_TJ, TK as rec_TK, TL as rec_TL, TM as rec_TM, TN as rec_TN, TP as rec_TP, TR as rec_TR, TT as rec_TT, TU as rec_TU, TV as rec_TV, TW as rec_TW, TX as rec_TX, TY as rec_TY, TZ as rec_TZ, T_ as rec_T_, Ta as rec_Ta, TablaFlota as rec_TablaFlota, TablaOrganigrama as rec_TablaOrganigrama, TableroTareas as rec_TableroTareas, TareasUnidad as rec_TareasUnidad, TarjetaBot as rec_TarjetaBot, TarjetaTarea as rec_TarjetaTarea, TarjetaUnidad as rec_TarjetaUnidad, Tb as rec_Tb, Tc as rec_Tc, Td as rec_Td, Te as rec_Te, Tf as rec_Tf, Tg as rec_Tg, Th as rec_Th, Ti as rec_Ti, TipografiaMarca as rec_TipografiaMarca, Tj as rec_Tj, Tk as rec_Tk, Tl as rec_Tl, Tm as rec_Tm, Tn as rec_Tn, To as rec_To, Tp as rec_Tp, Tq as rec_Tq, Tr as rec_Tr, TransferirTrabajo as rec_TransferirTrabajo, TransicionMarca as rec_TransicionMarca, Transporte as rec_Transporte, Ts as rec_Ts, Tt as rec_Tt, Tu as rec_Tu, Tv as rec_Tv, Tw as rec_Tw, Ty as rec_Ty, Tz as rec_Tz, U as rec_U, U$ as rec_U$, U0 as rec_U0, U2 as rec_U2, U4 as rec_U4, UA as rec_UA, UB as rec_UB, UC as rec_UC, UD as rec_UD, UE as rec_UE, UF as rec_UF, UG as rec_UG, UH as rec_UH, UI as rec_UI, UJ as rec_UJ, UK as rec_UK, UL as rec_UL, UM as rec_UM, UN as rec_UN, UO as rec_UO, UP as rec_UP, UQ as rec_UQ, UR as rec_UR, US as rec_US, UT as rec_UT, UU as rec_UU, UV as rec_UV, UW as rec_UW, UX as rec_UX, UY as rec_UY, UZ as rec_UZ, U_ as rec_U_, Ua as rec_Ua, Ub as rec_Ub, Uc as rec_Uc, Ud as rec_Ud, Ue as rec_Ue, Uf as rec_Uf, Ug as rec_Ug, Uh as rec_Uh, Ui as rec_Ui, Uj as rec_Uj, Ul as rec_Ul, Um as rec_Um, Up as rec_Up, Uq as rec_Uq, Ur as rec_Ur, Us as rec_Us, Usuarios as rec_Usuarios, Ut as rec_Ut, Uu as rec_Uu, Uv as rec_Uv, Uw as rec_Uw, Ux as rec_Ux, Uy as rec_Uy, Uz as rec_Uz, V as rec_V, V$ as rec_V$, V0 as rec_V0, V2 as rec_V2, V4 as rec_V4, VA as rec_VA, VB as rec_VB, VD as rec_VD, VE as rec_VE, VF as rec_VF, VG as rec_VG, VH as rec_VH, VI as rec_VI, VJ as rec_VJ, VK as rec_VK, VL as rec_VL, VM as rec_VM, VN as rec_VN, VO as rec_VO, VP as rec_VP, VR as rec_VR, VT as rec_VT, VU as rec_VU, VV as rec_VV, VW as rec_VW, VX as rec_VX, VY as rec_VY, VZ as rec_VZ, V_ as rec_V_, Va as rec_Va, Vb as rec_Vb, Vc as rec_Vc, Vd as rec_Vd, Ve as rec_Ve, Vf as rec_Vf, Vg as rec_Vg, Vh as rec_Vh, Vi as rec_Vi, VincularBot as rec_VincularBot, VincularMiNumero as rec_VincularMiNumero, VincularPorTelefono as rec_VincularPorTelefono, Vj as rec_Vj, Vl as rec_Vl, Vm as rec_Vm, Vn as rec_Vn, Vo as rec_Vo, Vp as rec_Vp, Vq as rec_Vq, Vr as rec_Vr, Vs as rec_Vs, Vt as rec_Vt, Vu as rec_Vu, Vv as rec_Vv, Vw as rec_Vw, Vx as rec_Vx, Vy as rec_Vy, Vz as rec_Vz, W$ as rec_W$, W0 as rec_W0, W2 as rec_W2, W4 as rec_W4, WA as rec_WA, WB as rec_WB, WC as rec_WC, WD as rec_WD, WE as rec_WE, WF as rec_WF, WG as rec_WG, WH as rec_WH, WI as rec_WI, WJ as rec_WJ, WK as rec_WK, WL as rec_WL, WM as rec_WM, WN as rec_WN, WP as rec_WP, WQ as rec_WQ, WR as rec_WR, WS as rec_WS, WT as rec_WT, WU as rec_WU, WV as rec_WV, WW as rec_WW, WX as rec_WX, WY as rec_WY, WZ as rec_WZ, W_ as rec_W_, Wa as rec_Wa, Wb as rec_Wb, Wc as rec_Wc, Wd as rec_Wd, We as rec_We, Wf as rec_Wf, Wg as rec_Wg, Wh as rec_Wh, Wi as rec_Wi, Wj as rec_Wj, Wl as rec_Wl, Wm as rec_Wm, Wn as rec_Wn, Wo as rec_Wo, Wp as rec_Wp, Wq as rec_Wq, Wr as rec_Wr, Ws as rec_Ws, Wt as rec_Wt, Wu as rec_Wu, Wv as rec_Wv, Ww as rec_Ww, Wx as rec_Wx, Wy as rec_Wy, Wz as rec_Wz, X as rec_X, X0 as rec_X0, X2 as rec_X2, XA as rec_XA, XB as rec_XB, XC as rec_XC, XE as rec_XE, XF as rec_XF, XG as rec_XG, XH as rec_XH, XI as rec_XI, XJ as rec_XJ, XK as rec_XK, XL as rec_XL, XM as rec_XM, XN as rec_XN, XP as rec_XP, XQ as rec_XQ, XR as rec_XR, XS as rec_XS, XT as rec_XT, XU as rec_XU, XV as rec_XV, XW as rec_XW, XX as rec_XX, XY as rec_XY, X_ as rec_X_, Xa as rec_Xa, Xb as rec_Xb, Xc as rec_Xc, Xd as rec_Xd, Xe as rec_Xe, Xf as rec_Xf, Xg as rec_Xg, Xh as rec_Xh, Xi as rec_Xi, Xj as rec_Xj, Xl as rec_Xl, Xm as rec_Xm, Xo as rec_Xo, Xp as rec_Xp, Xq as rec_Xq, Xr as rec_Xr, Xs as rec_Xs, Xt as rec_Xt, Xu as rec_Xu, Xv as rec_Xv, Xw as rec_Xw, Xx as rec_Xx, Xy as rec_Xy, Xz as rec_Xz, Y as rec_Y, Y0 as rec_Y0, Y2 as rec_Y2, Y4 as rec_Y4, YA as rec_YA, YB as rec_YB, YC as rec_YC, YE as rec_YE, YF as rec_YF, YG as rec_YG, YH as rec_YH, YI as rec_YI, YJ as rec_YJ, YK as rec_YK, YL as rec_YL, YM as rec_YM, YN as rec_YN, YP as rec_YP, YQ as rec_YQ, YR as rec_YR, YT as rec_YT, YU as rec_YU, YV as rec_YV, YW as rec_YW, YX as rec_YX, YY as rec_YY, YZ as rec_YZ, Y_ as rec_Y_, Ya as rec_Ya, Yb as rec_Yb, Yc as rec_Yc, Yd as rec_Yd, Ye as rec_Ye, Yf as rec_Yf, Yg as rec_Yg, Yh as rec_Yh, Yi as rec_Yi, Yj as rec_Yj, Yk as rec_Yk, Yl as rec_Yl, Ym as rec_Ym, Yo as rec_Yo, Yp as rec_Yp, Yq as rec_Yq, Yr as rec_Yr, Ys as rec_Ys, Yt as rec_Yt, Yu as rec_Yu, Yv as rec_Yv, Yw as rec_Yw, Yx as rec_Yx, Yy as rec_Yy, Yz as rec_Yz, Z as rec_Z, Z0 as rec_Z0, Z2 as rec_Z2, Z4 as rec_Z4, ZA as rec_ZA, ZB as rec_ZB, ZC as rec_ZC, ZE as rec_ZE, ZF as rec_ZF, ZG as rec_ZG, ZH as rec_ZH, ZI as rec_ZI, ZJ as rec_ZJ, ZK as rec_ZK, ZL as rec_ZL, ZM as rec_ZM, ZN as rec_ZN, ZP as rec_ZP, ZQ as rec_ZQ, ZR as rec_ZR, ZS as rec_ZS, ZT as rec_ZT, ZU as rec_ZU, ZV as rec_ZV, ZW as rec_ZW, ZX as rec_ZX, ZY as rec_ZY, ZZ as rec_ZZ, Z_ as rec_Z_, Za as rec_Za, Zb as rec_Zb, Zc as rec_Zc, Zd as rec_Zd, Ze as rec_Ze, Zf as rec_Zf, Zg as rec_Zg, Zh as rec_Zh, Zi as rec_Zi, Zj as rec_Zj, Zl as rec_Zl, Zm as rec_Zm, Zo as rec_Zo, Zp as rec_Zp, Zq as rec_Zq, Zr as rec_Zr, Zs as rec_Zs, Zt as rec_Zt, Zu as rec_Zu, Zv as rec_Zv, Zw as rec_Zw, Zx as rec_Zx, Zy as rec_Zy, Zz as rec_Zz, _ as rec__, _0 as rec__0, _1 as rec__1, _2 as rec__2, _3 as rec__3, _4 as rec__4, _B as rec__B, _C as rec__C, _D as rec__D, _E as rec__E, _F as rec__F, _G as rec__G, _H as rec__H, _I as rec__I, _J as rec__J, _K as rec__K, _L as rec__L, _M as rec__M, _N as rec__N, _O as rec__O, _P as rec__P, _Q as rec__Q, _R as rec__R, _S as rec__S, _T as rec__T, _U as rec__U, _V as rec__V, _W as rec__W, _X as rec__X, _Y as rec__Y, __ as rec___, __vite__mapDeps as rec___vite__mapDeps, _a as rec__a, _b as rec__b, _c as rec__c, _d as rec__d, _e as rec__e, _f as rec__f, _g as rec__g, _h as rec__h, _i as rec__i, _j as rec__j, _k as rec__k, _l as rec__l, _m as rec__m, _n as rec__n, _o as rec__o, _p as rec__p, _q as rec__q, _r as rec__r, _s as rec__s, _t as rec__t, _u as rec__u, _v as rec__v, _w as rec__w, _x as rec__x, _y as rec__y, _z as rec__z, a as rec_a, a$ as rec_a$, a0 as rec_a0, a2 as rec_a2, aB as rec_aB, aC as rec_aC, aD as rec_aD, aE as rec_aE, aF as rec_aF, aG as rec_aG, aH as rec_aH, aI as rec_aI, aJ as rec_aJ, aK as rec_aK, aL as rec_aL, aM as rec_aM, aN as rec_aN, aP as rec_aP, aR as rec_aR, aS as rec_aS, aT as rec_aT, aU as rec_aU, aV as rec_aV, aW as rec_aW, aX as rec_aX, aY as rec_aY, aZ as rec_aZ, a_ as rec_a_, ab as rec_ab, ac as rec_ac, ad as rec_ad, ae as rec_ae, af as rec_af, ag as rec_ag, ah as rec_ah, ai as rec_ai, aj as rec_aj, al as rec_al, am as rec_am, an as rec_an, ao as rec_ao, ap as rec_ap, api as rec_api, aq as rec_aq, ar as rec_ar, as as rec_as, at as rec_at, au as rec_au, av as rec_av, aw as rec_aw, ax as rec_ax, ay as rec_ay, az as rec_az, b as rec_b, b$ as rec_b$, b0 as rec_b0, b1 as rec_b1, b2 as rec_b2, b3 as rec_b3, b4 as rec_b4, bA as rec_bA, bB as rec_bB, bC as rec_bC, bD as rec_bD, bE as rec_bE, bF as rec_bF, bG as rec_bG, bH as rec_bH, bI as rec_bI, bJ as rec_bJ, bK as rec_bK, bL as rec_bL, bM as rec_bM, bN as rec_bN, bO as rec_bO, bP as rec_bP, bR as rec_bR, bS as rec_bS, bT as rec_bT, bU as rec_bU, bV as rec_bV, bW as rec_bW, bX as rec_bX, bY as rec_bY, b_ as rec_b_, ba as rec_ba, bb as rec_bb, bc as rec_bc, bd as rec_bd, be as rec_be, bf as rec_bf, bg as rec_bg, bh as rec_bh, bi as rec_bi, bj as rec_bj, bk as rec_bk, bl as rec_bl, bm as rec_bm, bn as rec_bn, bo as rec_bo, borrarSesion as rec_borrarSesion, bp as rec_bp, bq as rec_bq, br as rec_br, bs as rec_bs, bt as rec_bt, bu as rec_bu, bv as rec_bv, bw as rec_bw, bx as rec_bx, by as rec_by, bz as rec_bz, c as rec_c, c$ as rec_c$, c0 as rec_c0, c1 as rec_c1, c2 as rec_c2, c4 as rec_c4, cA as rec_cA, cB as rec_cB, cC as rec_cC, cD as rec_cD, cE as rec_cE, cF as rec_cF, cG as rec_cG, cH as rec_cH, cI as rec_cI, cJ as rec_cJ, cK as rec_cK, cL as rec_cL, cM as rec_cM, cN as rec_cN, cO as rec_cO, cP as rec_cP, cR as rec_cR, cS as rec_cS, cT as rec_cT, cU as rec_cU, cV as rec_cV, cW as rec_cW, cX as rec_cX, cY as rec_cY, cZ as rec_cZ, c_ as rec_c_, ca as rec_ca, cabeceraSesion as rec_cabeceraSesion, cb as rec_cb, cc as rec_cc, cd as rec_cd, ce as rec_ce, cf as rec_cf, cg as rec_cg, ch as rec_ch, ci as rec_ci, cj as rec_cj, cl as rec_cl, cm as rec_cm, cn as rec_cn, co as rec_co, cp as rec_cp, cq as rec_cq, cr as rec_cr, ct as rec_ct, cu as rec_cu, cv as rec_cv, cw as rec_cw, cx as rec_cx, cy as rec_cy, cz as rec_cz, d$ as rec_d$, d1 as rec_d1, d2 as rec_d2, d4 as rec_d4, dB as rec_dB, dC as rec_dC, dD as rec_dD, dE as rec_dE, dF as rec_dF, dG as rec_dG, dH as rec_dH, dI as rec_dI, dJ as rec_dJ, dK as rec_dK, dL as rec_dL, dM as rec_dM, dN as rec_dN, dO as rec_dO, dP as rec_dP, dR as rec_dR, dS as rec_dS, dT as rec_dT, dU as rec_dU, dV as rec_dV, dW as rec_dW, dX as rec_dX, dY as rec_dY, d_ as rec_d_, da as rec_da, db as rec_db, dc as rec_dc, dd as rec_dd, de as rec_de, df as rec_df, dg as rec_dg, dh as rec_dh, di as rec_di, dj as rec_dj, dl as rec_dl, dm as rec_dm, dn as rec_dn, dp as rec_dp, dq as rec_dq, dr as rec_dr, ds as rec_ds, dt as rec_dt, du as rec_du, dv as rec_dv, dw as rec_dw, dy as rec_dy, dz as rec_dz, e as rec_e, e$ as rec_e$, e1 as rec_e1, e2 as rec_e2, e3 as rec_e3, e4 as rec_e4, eB as rec_eB, eC as rec_eC, eD as rec_eD, eE as rec_eE, eF as rec_eF, eG as rec_eG, eH as rec_eH, eI as rec_eI, eJ as rec_eJ, eK as rec_eK, eL as rec_eL, eM as rec_eM, eN as rec_eN, eP as rec_eP, eR as rec_eR, eS as rec_eS, eT as rec_eT, eU as rec_eU, eV as rec_eV, eW as rec_eW, eX as rec_eX, eY as rec_eY, eZ as rec_eZ, e_ as rec_e_, ea as rec_ea, eb as rec_eb, ec as rec_ec, ed as rec_ed, ee as rec_ee, ef as rec_ef, eg as rec_eg, eh as rec_eh, ei as rec_ei, ej as rec_ej, el as rec_el, em as rec_em, en as rec_en, eo as rec_eo, ep as rec_ep, eq as rec_eq, es as rec_es, esAdministrador as rec_esAdministrador, et as rec_et, eu as rec_eu, ev as rec_ev, ex as rec_ex, ey as rec_ey, ez as rec_ez, f as rec_f, f1 as rec_f1, f2 as rec_f2, f4 as rec_f4, fB as rec_fB, fC as rec_fC, fD as rec_fD, fE as rec_fE, fF as rec_fF, fG as rec_fG, fH as rec_fH, fI as rec_fI, fJ as rec_fJ, fK as rec_fK, fL as rec_fL, fM as rec_fM, fN as rec_fN, fO as rec_fO, fP as rec_fP, fQ as rec_fQ, fR as rec_fR, fS as rec_fS, fT as rec_fT, fU as rec_fU, fV as rec_fV, fW as rec_fW, fX as rec_fX, fY as rec_fY, f_ as rec_f_, fa as rec_fa, fb as rec_fb, fc as rec_fc, fd as rec_fd, fe as rec_fe, ff as rec_ff, fg as rec_fg, fh as rec_fh, fi as rec_fi, fj as rec_fj, fk as rec_fk, fl as rec_fl, fm as rec_fm, fn as rec_fn, fo as rec_fo, fp as rec_fp, fq as rec_fq, fr as rec_fr, fs as rec_fs, ft as rec_ft, fu as rec_fu, fv as rec_fv, fw as rec_fw, fx as rec_fx, fy as rec_fy, fz as rec_fz, g0 as rec_g0, g1 as rec_g1, g2 as rec_g2, g3 as rec_g3, g4 as rec_g4, gB as rec_gB, gC as rec_gC, gD as rec_gD, gE as rec_gE, gF as rec_gF, gG as rec_gG, gH as rec_gH, gI as rec_gI, gJ as rec_gJ, gK as rec_gK, gL as rec_gL, gM as rec_gM, gN as rec_gN, gO as rec_gO, gP as rec_gP, gQ as rec_gQ, gR as rec_gR, gS as rec_gS, gT as rec_gT, gU as rec_gU, gV as rec_gV, gW as rec_gW, gX as rec_gX, gY as rec_gY, g_ as rec_g_, ga as rec_ga, gb as rec_gb, gc as rec_gc, gd as rec_gd, ge as rec_ge, gf as rec_gf, gg as rec_gg, gh as rec_gh, gi as rec_gi, gj as rec_gj, gk as rec_gk, gl as rec_gl, gm as rec_gm, gn as rec_gn, go as rec_go, gp as rec_gp, gq as rec_gq, gr as rec_gr, gs as rec_gs, gt as rec_gt, gu as rec_gu, guardarSesion as rec_guardarSesion, gv as rec_gv, gw as rec_gw, gx as rec_gx, gy as rec_gy, gz as rec_gz, h as rec_h, h0 as rec_h0, h1 as rec_h1, h2 as rec_h2, h4 as rec_h4, hB as rec_hB, hC as rec_hC, hD as rec_hD, hE as rec_hE, hF as rec_hF, hG as rec_hG, hH as rec_hH, hI as rec_hI, hJ as rec_hJ, hK as rec_hK, hL as rec_hL, hM as rec_hM, hN as rec_hN, hO as rec_hO, hP as rec_hP, hQ as rec_hQ, hR as rec_hR, hS as rec_hS, hT as rec_hT, hU as rec_hU, hV as rec_hV, hW as rec_hW, hX as rec_hX, hY as rec_hY, h_ as rec_h_, ha as rec_ha, hb as rec_hb, hc as rec_hc, hd as rec_hd, he as rec_he, hf as rec_hf, hg as rec_hg, hh as rec_hh, hi as rec_hi, hj as rec_hj, hk as rec_hk, hl as rec_hl, hm as rec_hm, hn as rec_hn, ho as rec_ho, hp as rec_hp, hq as rec_hq, hr as rec_hr, hs as rec_hs, ht as rec_ht, hu as rec_hu, hv as rec_hv, hw as rec_hw, hx as rec_hx, hy as rec_hy, hz as rec_hz, i as rec_i, i0 as rec_i0, i2 as rec_i2, iA as rec_iA, iB as rec_iB, iC as rec_iC, iD as rec_iD, iE as rec_iE, iF as rec_iF, iG as rec_iG, iH as rec_iH, iI as rec_iI, iJ as rec_iJ, iK as rec_iK, iL as rec_iL, iM as rec_iM, iN as rec_iN, iP as rec_iP, iR as rec_iR, iS as rec_iS, iT as rec_iT, iU as rec_iU, iV as rec_iV, iW as rec_iW, iX as rec_iX, iY as rec_iY, iZ as rec_iZ, i_ as rec_i_, ib as rec_ib, ic as rec_ic, id as rec_id, ie as rec_ie, ig as rec_ig, ih as rec_ih, ii as rec_ii, ij as rec_ij, il as rec_il, im as rec_im, iniciarAplicacion as rec_iniciarAplicacion, io as rec_io, ip as rec_ip, iq as rec_iq, it as rec_it, iu as rec_iu, iv as rec_iv, iw as rec_iw, ix as rec_ix, iy as rec_iy, iz as rec_iz, j as rec_j, j1 as rec_j1, j2 as rec_j2, j3 as rec_j3, j4 as rec_j4, jA as rec_jA, jB as rec_jB, jC as rec_jC, jE as rec_jE, jF as rec_jF, jG as rec_jG, jH as rec_jH, jI as rec_jI, jJ as rec_jJ, jK as rec_jK, jL as rec_jL, jM as rec_jM, jN as rec_jN, jP as rec_jP, jQ as rec_jQ, jR as rec_jR, jS as rec_jS, jT as rec_jT, jU as rec_jU, jV as rec_jV, jW as rec_jW, jX as rec_jX, jY as rec_jY, jZ as rec_jZ, j_ as rec_j_, ja as rec_ja, jb as rec_jb, jc as rec_jc, jd as rec_jd, je as rec_je, jf as rec_jf, jg as rec_jg, jh as rec_jh, ji as rec_ji, jj as rec_jj, jl as rec_jl, jm as rec_jm, jn as rec_jn, jo as rec_jo, jp as rec_jp, jq as rec_jq, jr as rec_jr, js as rec_js, jt as rec_jt, ju as rec_ju, jv as rec_jv, jw as rec_jw, jx as rec_jx, jy as rec_jy, jz as rec_jz, k as rec_k, k$ as rec_k$, k1 as rec_k1, k2 as rec_k2, k3 as rec_k3, k4 as rec_k4, kA as rec_kA, kB as rec_kB, kC as rec_kC, kD as rec_kD, kE as rec_kE, kF as rec_kF, kG as rec_kG, kH as rec_kH, kI as rec_kI, kJ as rec_kJ, kK as rec_kK, kL as rec_kL, kM as rec_kM, kN as rec_kN, kO as rec_kO, kP as rec_kP, kQ as rec_kQ, kR as rec_kR, kS as rec_kS, kT as rec_kT, kU as rec_kU, kV as rec_kV, kW as rec_kW, kX as rec_kX, kY as rec_kY, kZ as rec_kZ, k_ as rec_k_, ka as rec_ka, kb as rec_kb, kc as rec_kc, kd as rec_kd, ke as rec_ke, kf as rec_kf, kg as rec_kg, kh as rec_kh, ki as rec_ki, kj as rec_kj, kl as rec_kl, km as rec_km, kn as rec_kn, ko as rec_ko, kp as rec_kp, kq as rec_kq, kr as rec_kr, ks as rec_ks, kt as rec_kt, ku as rec_ku, kv as rec_kv, kw as rec_kw, kx as rec_kx, ky as rec_ky, kz as rec_kz, l as rec_l, l0 as rec_l0, l1 as rec_l1, l2 as rec_l2, lA as rec_lA, lB as rec_lB, lC as rec_lC, lD as rec_lD, lE as rec_lE, lF as rec_lF, lG as rec_lG, lH as rec_lH, lI as rec_lI, lJ as rec_lJ, lK as rec_lK, lL as rec_lL, lM as rec_lM, lN as rec_lN, lP as rec_lP, lR as rec_lR, lS as rec_lS, lT as rec_lT, lU as rec_lU, lV as rec_lV, lW as rec_lW, lX as rec_lX, lY as rec_lY, l_ as rec_l_, la as rec_la, lb as rec_lb, lc as rec_lc, ld as rec_ld, le as rec_le, leerClaims as rec_leerClaims, lf as rec_lf, lg as rec_lg, lh as rec_lh, li as rec_li, lj as rec_lj, ll as rec_ll, lm as rec_lm, ln as rec_ln, lo as rec_lo, lp as rec_lp, lq as rec_lq, lr as rec_lr, ls as rec_ls, lt as rec_lt, lu as rec_lu, lv as rec_lv, lw as rec_lw, ly as rec_ly, lz as rec_lz, m as rec_m, m0 as rec_m0, m1 as rec_m1, m2 as rec_m2, m4 as rec_m4, mB as rec_mB, mC as rec_mC, mD as rec_mD, mE as rec_mE, mF as rec_mF, mG as rec_mG, mH as rec_mH, mI as rec_mI, mJ as rec_mJ, mK as rec_mK, mL as rec_mL, mM as rec_mM, mN as rec_mN, mP as rec_mP, mR as rec_mR, mS as rec_mS, mT as rec_mT, mU as rec_mU, mV as rec_mV, mW as rec_mW, mX as rec_mX, mY as rec_mY, m_ as rec_m_, ma as rec_ma, mb as rec_mb, mc as rec_mc, md as rec_md, me as rec_me, mf as rec_mf, mg as rec_mg, mh as rec_mh, mi as rec_mi, mj as rec_mj, ml as rec_ml, mm as rec_mm, mn as rec_mn, mo as rec_mo, mp as rec_mp, mq as rec_mq, mr as rec_mr, ms as rec_ms, mt as rec_mt, mu as rec_mu, mv as rec_mv, mw as rec_mw, mx as rec_mx, my as rec_my, mz as rec_mz, n as rec_n, n1 as rec_n1, n2 as rec_n2, nB as rec_nB, nD as rec_nD, nE as rec_nE, nF as rec_nF, nG as rec_nG, nH as rec_nH, nI as rec_nI, nJ as rec_nJ, nK as rec_nK, nL as rec_nL, nM as rec_nM, nN as rec_nN, nP as rec_nP, nQ as rec_nQ, nR as rec_nR, nS as rec_nS, nT as rec_nT, nU as rec_nU, nV as rec_nV, nW as rec_nW, nX as rec_nX, nY as rec_nY, nZ as rec_nZ, n_ as rec_n_, na as rec_na, nb as rec_nb, nc as rec_nc, nd as rec_nd, ne as rec_ne, nf as rec_nf, ng as rec_ng, nh as rec_nh, ni as rec_ni, nj as rec_nj, nl as rec_nl, nm as rec_nm, nn as rec_nn, no as rec_no, np as rec_np, nq as rec_nq, nr as rec_nr, ns as rec_ns, nt as rec_nt, nu as rec_nu, nv as rec_nv, nw as rec_nw, nx as rec_nx, ny as rec_ny, nz as rec_nz, o as rec_o, o0 as rec_o0, o2 as rec_o2, oB as rec_oB, oC as rec_oC, oD as rec_oD, oE as rec_oE, oF as rec_oF, oG as rec_oG, oH as rec_oH, oI as rec_oI, oJ as rec_oJ, oK as rec_oK, oL as rec_oL, oM as rec_oM, oN as rec_oN, oP as rec_oP, oR as rec_oR, oS as rec_oS, oT as rec_oT, oU as rec_oU, oV as rec_oV, oW as rec_oW, oX as rec_oX, oY as rec_oY, oZ as rec_oZ, o_ as rec_o_, ob as rec_ob, obtenerToken as rec_obtenerToken, obtenerUsuario as rec_obtenerUsuario, oc as rec_oc, od as rec_od, oe as rec_oe, of as rec_of, og as rec_og, oh as rec_oh, oi as rec_oi, oj as rec_oj, ol as rec_ol, om as rec_om, on as rec_on, oo as rec_oo, op as rec_op, oq as rec_oq, or as rec_or, os as rec_os, ot as rec_ot, ou as rec_ou, ov as rec_ov, ow as rec_ow, ox as rec_ox, oy as rec_oy, oz as rec_oz, p as rec_p, p1 as rec_p1, p2 as rec_p2, p4 as rec_p4, pA as rec_pA, pB as rec_pB, pC as rec_pC, pD as rec_pD, pE as rec_pE, pF as rec_pF, pG as rec_pG, pH as rec_pH, pI as rec_pI, pJ as rec_pJ, pK as rec_pK, pL as rec_pL, pM as rec_pM, pN as rec_pN, pP as rec_pP, pQ as rec_pQ, pR as rec_pR, pS as rec_pS, pT as rec_pT, pU as rec_pU, pV as rec_pV, pW as rec_pW, pX as rec_pX, pY as rec_pY, p_ as rec_p_, pa as rec_pa, paginasPorRuta as rec_paginasPorRuta, pb as rec_pb, pc as rec_pc, pd as rec_pd, pe as rec_pe, pf as rec_pf, pg as rec_pg, ph as rec_ph, pi as rec_pi, pj as rec_pj, pk as rec_pk, pl as rec_pl, pm as rec_pm, pn as rec_pn, po as rec_po, pp as rec_pp, pq as rec_pq, pr as rec_pr, ps as rec_ps, pt as rec_pt, pu as rec_pu, puedeIncidencias as rec_puedeIncidencias, puedeInspecciones as rec_puedeInspecciones, puedeMovilidad as rec_puedeMovilidad, puedeOrganigrama as rec_puedeOrganigrama, puedePlanner as rec_puedePlanner, pv as rec_pv, pw as rec_pw, px as rec_px, py as rec_py, pz as rec_pz, q as rec_q, q$ as rec_q$, q0 as rec_q0, q1 as rec_q1, q2 as rec_q2, q4 as rec_q4, qA as rec_qA, qB as rec_qB, qC as rec_qC, qE as rec_qE, qF as rec_qF, qG as rec_qG, qH as rec_qH, qI as rec_qI, qJ as rec_qJ, qK as rec_qK, qL as rec_qL, qM as rec_qM, qN as rec_qN, qO as rec_qO, qP as rec_qP, qR as rec_qR, qT as rec_qT, qU as rec_qU, qV as rec_qV, qW as rec_qW, qX as rec_qX, qY as rec_qY, qZ as rec_qZ, q_ as rec_q_, qa as rec_qa, qb as rec_qb, qc as rec_qc, qd as rec_qd, qe as rec_qe, qf as rec_qf, qg as rec_qg, qh as rec_qh, qi as rec_qi, qj as rec_qj, qk as rec_qk, ql as rec_ql, qm as rec_qm, qo as rec_qo, qp as rec_qp, qq as rec_qq, qr as rec_qr, qs as rec_qs, qt as rec_qt, qu as rec_qu, qv as rec_qv, qw as rec_qw, qx as rec_qx, qy as rec_qy, qz as rec_qz, r as rec_r, r1 as rec_r1, r2 as rec_r2, rB as rec_rB, rD as rec_rD, rE as rec_rE, rF as rec_rF, rG as rec_rG, rH as rec_rH, rI as rec_rI, rJ as rec_rJ, rK as rec_rK, rL as rec_rL, rM as rec_rM, rN as rec_rN, rP as rec_rP, rQ as rec_rQ, rR as rec_rR, rS as rec_rS, rT as rec_rT, rU as rec_rU, rV as rec_rV, rW as rec_rW, rX as rec_rX, rY as rec_rY, rZ as rec_rZ, r_ as rec_r_, ra as rec_ra, rb as rec_rb, rc as rec_rc, rd as rec_rd, re as rec_re, rf as rec_rf, rg as rec_rg, rh as rec_rh, ri as rec_ri, rj as rec_rj, rl as rec_rl, rm as rec_rm, rn as rec_rn, ro as rec_ro, rolesSesion as rec_rolesSesion, rp as rec_rp, rq as rec_rq, rr as rec_rr, rs as rec_rs, rt as rec_rt, ru as rec_ru, rv as rec_rv, rw as rec_rw, rx as rec_rx, ry as rec_ry, rz as rec_rz, s as rec_s, s0 as rec_s0, s2 as rec_s2, s4 as rec_s4, sB as rec_sB, sC as rec_sC, sD as rec_sD, sE as rec_sE, sF as rec_sF, sG as rec_sG, sH as rec_sH, sI as rec_sI, sJ as rec_sJ, sK as rec_sK, sL as rec_sL, sM as rec_sM, sN as rec_sN, sP as rec_sP, sR as rec_sR, sS as rec_sS, sT as rec_sT, sU as rec_sU, sV as rec_sV, sW as rec_sW, sX as rec_sX, sY as rec_sY, sZ as rec_sZ, s_ as rec_s_, sa as rec_sa, sb as rec_sb, sc as rec_sc, sd as rec_sd, se as rec_se, sesionVencida as rec_sesionVencida, sf as rec_sf, sg as rec_sg, sh as rec_sh, si as rec_si, sj as rec_sj, sk as rec_sk, sl as rec_sl, sm as rec_sm, sn as rec_sn, so as rec_so, sp as rec_sp, sq as rec_sq, sr as rec_sr, ss as rec_ss, st as rec_st, su as rec_su, sv as rec_sv, sw as rec_sw, sx as rec_sx, sy as rec_sy, sz as rec_sz, t as rec_t, t$ as rec_t$, t0 as rec_t0, t2 as rec_t2, t3 as rec_t3, t4 as rec_t4, tA as rec_tA, tB as rec_tB, tD as rec_tD, tE as rec_tE, tF as rec_tF, tG as rec_tG, tH as rec_tH, tI as rec_tI, tJ as rec_tJ, tK as rec_tK, tL as rec_tL, tM as rec_tM, tN as rec_tN, tO as rec_tO, tP as rec_tP, tQ as rec_tQ, tR as rec_tR, tS as rec_tS, tT as rec_tT, tU as rec_tU, tV as rec_tV, tW as rec_tW, tX as rec_tX, tY as rec_tY, tZ as rec_tZ, t_ as rec_t_, ta as rec_ta, tb as rec_tb, tc as rec_tc, td as rec_td, te as rec_te, tf as rec_tf, tg as rec_tg, th as rec_th, ti as rec_ti, tj as rec_tj, tk as rec_tk, tl as rec_tl, tm as rec_tm, tn as rec_tn, to as rec_to, tp as rec_tp, tq as rec_tq, ts as rec_ts, tt as rec_tt, tu as rec_tu, tv as rec_tv, tw as rec_tw, tx as rec_tx, ty as rec_ty, tz as rec_tz, u as rec_u, u1 as rec_u1, u2 as rec_u2, uA as rec_uA, uB as rec_uB, uC as rec_uC, uD as rec_uD, uE as rec_uE, uF as rec_uF, uG as rec_uG, uH as rec_uH, uI as rec_uI, uJ as rec_uJ, uK as rec_uK, uL as rec_uL, uM as rec_uM, uN as rec_uN, uO as rec_uO, uP as rec_uP, uR as rec_uR, uS as rec_uS, uT as rec_uT, uU as rec_uU, uV as rec_uV, uW as rec_uW, uX as rec_uX, uY as rec_uY, u_ as rec_u_, ua as rec_ua, ub as rec_ub, uc as rec_uc, ud as rec_ud, ue as rec_ue, uf as rec_uf, ug as rec_ug, uh as rec_uh, ui as rec_ui, uj as rec_uj, ul as rec_ul, um as rec_um, un as rec_un, uo as rec_uo, up as rec_up, uq as rec_uq, ur as rec_ur, us as rec_us, usuarioIdSesion as rec_usuarioIdSesion, ut as rec_ut, uu as rec_uu, uv as rec_uv, uw as rec_uw, uy as rec_uy, uz as rec_uz, v as rec_v, v0 as rec_v0, v1 as rec_v1, v2 as rec_v2, v3 as rec_v3, v4 as rec_v4, vB as rec_vB, vC as rec_vC, vD as rec_vD, vE as rec_vE, vF as rec_vF, vG as rec_vG, vH as rec_vH, vI as rec_vI, vJ as rec_vJ, vK as rec_vK, vL as rec_vL, vM as rec_vM, vN as rec_vN, vO as rec_vO, vP as rec_vP, vQ as rec_vQ, vR as rec_vR, vS as rec_vS, vT as rec_vT, vU as rec_vU, vV as rec_vV, vW as rec_vW, vX as rec_vX, vY as rec_vY, v_ as rec_v_, va as rec_va, vb as rec_vb, vc as rec_vc, vd as rec_vd, ve as rec_ve, vf as rec_vf, vg as rec_vg, vh as rec_vh, vi as rec_vi, vj as rec_vj, vk as rec_vk, vl as rec_vl, vm as rec_vm, vn as rec_vn, vo as rec_vo, vp as rec_vp, vq as rec_vq, vr as rec_vr, vs as rec_vs, vt as rec_vt, vu as rec_vu, vv as rec_vv, vw as rec_vw, vx as rec_vx, vy as rec_vy, vz as rec_vz, w as rec_w, w$ as rec_w$, w0 as rec_w0, w1 as rec_w1, w2 as rec_w2, w3 as rec_w3, w4 as rec_w4, wB as rec_wB, wC as rec_wC, wD as rec_wD, wE as rec_wE, wF as rec_wF, wG as rec_wG, wH as rec_wH, wI as rec_wI, wJ as rec_wJ, wK as rec_wK, wL as rec_wL, wM as rec_wM, wN as rec_wN, wP as rec_wP, wR as rec_wR, wT as rec_wT, wU as rec_wU, wV as rec_wV, wW as rec_wW, wX as rec_wX, wY as rec_wY, wZ as rec_wZ, w_ as rec_w_, wb as rec_wb, wc as rec_wc, wd as rec_wd, we as rec_we, wf as rec_wf, wg as rec_wg, wh as rec_wh, wi as rec_wi, wj as rec_wj, wk as rec_wk, wl as rec_wl, wm as rec_wm, wn as rec_wn, wo as rec_wo, wp as rec_wp, wq as rec_wq, wr as rec_wr, ws as rec_ws, wt as rec_wt, wu as rec_wu, wv as rec_wv, ww as rec_ww, wx as rec_wx, wy as rec_wy, wz as rec_wz, x as rec_x, x$ as rec_x$, x0 as rec_x0, x1 as rec_x1, x2 as rec_x2, x3 as rec_x3, x4 as rec_x4, xB as rec_xB, xD as rec_xD, xE as rec_xE, xF as rec_xF, xG as rec_xG, xH as rec_xH, xI as rec_xI, xJ as rec_xJ, xK as rec_xK, xL as rec_xL, xM as rec_xM, xN as rec_xN, xO as rec_xO, xP as rec_xP, xR as rec_xR, xS as rec_xS, xT as rec_xT, xU as rec_xU, xV as rec_xV, xW as rec_xW, xX as rec_xX, xY as rec_xY, x_ as rec_x_, xa as rec_xa, xb as rec_xb, xc as rec_xc, xd as rec_xd, xe as rec_xe, xf as rec_xf, xg as rec_xg, xh as rec_xh, xi as rec_xi, xj as rec_xj, xk as rec_xk, xl as rec_xl, xm as rec_xm, xn as rec_xn, xo as rec_xo, xp as rec_xp, xq as rec_xq, xr as rec_xr, xs as rec_xs, xt as rec_xt, xu as rec_xu, xv as rec_xv, xw as rec_xw, xx as rec_xx, xy as rec_xy, xz as rec_xz, y as rec_y, y$ as rec_y$, y0 as rec_y0, y1 as rec_y1, y2 as rec_y2, y4 as rec_y4, yA as rec_yA, yB as rec_yB, yD as rec_yD, yE as rec_yE, yF as rec_yF, yG as rec_yG, yH as rec_yH, yI as rec_yI, yJ as rec_yJ, yK as rec_yK, yL as rec_yL, yM as rec_yM, yN as rec_yN, yO as rec_yO, yP as rec_yP, yQ as rec_yQ, yR as rec_yR, yS as rec_yS, yT as rec_yT, yU as rec_yU, yV as rec_yV, yW as rec_yW, yX as rec_yX, yY as rec_yY, y_ as rec_y_, ya as rec_ya, yb as rec_yb, yc as rec_yc, yd as rec_yd, ye as rec_ye, yf as rec_yf, yg as rec_yg, yh as rec_yh, yi as rec_yi, yj as rec_yj, yk as rec_yk, yl as rec_yl, ym as rec_ym, yn as rec_yn, yo as rec_yo, yp as rec_yp, yq as rec_yq, yr as rec_yr, ys as rec_ys, yt as rec_yt, yu as rec_yu, yv as rec_yv, yw as rec_yw, yx as rec_yx, yy as rec_yy, yz as rec_yz, z as rec_z, z$ as rec_z$, z0 as rec_z0, z1 as rec_z1, z2 as rec_z2, z4 as rec_z4, zA as rec_zA, zB as rec_zB, zE as rec_zE, zF as rec_zF, zG as rec_zG, zH as rec_zH, zI as rec_zI, zJ as rec_zJ, zK as rec_zK, zL as rec_zL, zM as rec_zM, zN as rec_zN, zP as rec_zP, zR as rec_zR, zT as rec_zT, zU as rec_zU, zV as rec_zV, zW as rec_zW, zX as rec_zX, zY as rec_zY, zZ as rec_zZ, z_ as rec_z_, za as rec_za, zb as rec_zb, zc as rec_zc, zd as rec_zd, ze as rec_ze, zf as rec_zf, zg as rec_zg, zh as rec_zh, zi as rec_zi, zj as rec_zj, zl as rec_zl, zm as rec_zm, zo as rec_zo, zp as rec_zp, zq as rec_zq, zr as rec_zr, zs as rec_zs, zt as rec_zt, zu as rec_zu, zv as rec_zv, zw as rec_zw, zx as rec_zx, zy as rec_zy, zz as rec_zz };
